var E4 = Object.defineProperty;
var L4 = (t, e, n) => e in t ? E4(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n;
var Ve = (t, e, n) => L4(t, typeof e != "symbol" ? e + "" : e, n);
import { inject as wn, defineComponent as Ce, ref as K, onMounted as st, computed as I, createElementBlock as b, openBlock as h, normalizeClass as re, createCommentVNode as A, createElementVNode as k, unref as O, Fragment as he, renderList as Le, toDisplayString as ne, createStaticVNode as ri, resolveComponent as lt, createBlock as G, withCtx as oe, renderSlot as me, defineAsyncComponent as ve, resolveDynamicComponent as dt, normalizeStyle as bn, reactive as Ma, watch as Qe, withModifiers as da, createVNode as Q, createTextVNode as ze, withDirectives as Tt, vModelRadio as bs, vModelText as Zo, mergeProps as $t, vModelCheckbox as jh, vModelSelect as D4, vShow as va, createSlots as an, useTemplateRef as I4, onUnmounted as Ks, resolveDirective as M4, withKeys as Li, watchEffect as Kb, nextTick as kn, getCurrentInstance as Qb, getCurrentScope as Jb, onScopeDispose as e2, toRef as Ls, readonly as O4, customRef as P4, useSlots as Di, isRef as Sm, normalizeProps as cn, guardReactiveProps as Un, Teleport as B4, Transition as zr, h as xr, render as Am, onBeforeUpdate as R4, mergeModels as Gc, useModel as t2, provide as ba, cloneVNode as Em, toRefs as Vh, useAttrs as N4, onBeforeUnmount as $4, markRaw as Lm } from "vue";
import { useRoute as Yn, useRouter as Qs } from "vue-router";
import { defineStore as F4, mapState as z4, storeToRefs as U4 } from "pinia";
function qe() {
  return wn("theme");
}
const H4 = {
  key: 0,
  class: "title"
}, Y4 = { class: "alphabet-list" }, j4 = ["onClick"], V4 = /* @__PURE__ */ Ce({
  __name: "AlphabeticalBrowseBy",
  props: {
    selectedLetterProp: {
      type: String,
      default: "All"
    },
    displayAll: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["selectedLetter"],
  setup(t, { emit: e }) {
    const n = t, a = e, i = qe(), r = K([
      { letter: "All" },
      ..."ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("").map((u) => ({ letter: u }))
    ]), s = K("");
    st(() => {
      s.value = n.selectedLetterProp;
    });
    const o = I(() => r.value.filter((u) => n.displayAll || u.letter !== "All").map((u) => {
      const f = u.letter === s.value;
      return {
        letter: u.letter,
        class: `letter${f ? " is-selected" : ""}`
      };
    })), l = I(
      () => (i == null ? void 0 : i.value) === "" ? "alphabetical-browse-by" : `alphabetical-browse-by ${i == null ? void 0 : i.value}`
    );
    function c(u) {
      s.value = u.letter, a("selectedLetter", s.value);
    }
    return (u, f) => (h(), b("div", {
      class: re(l.value)
    }, [
      O(i) === "" ? (h(), b("h2", H4, " Browse by Last Name ")) : A("", !0),
      k("ul", Y4, [
        (h(!0), b(he, null, Le(o.value, (m) => (h(), b("li", {
          key: m.letter,
          class: re(m.class),
          onClick: (_) => c(m)
        }, [
          k("a", null, ne(m.letter), 1)
        ], 10, j4))), 128))
      ])
    ], 2));
  }
}), ge = (t, e) => {
  const n = t.__vccOpts || t;
  for (const [a, i] of e)
    n[a] = i;
  return n;
}, vhe = /* @__PURE__ */ ge(V4, [["__scopeId", "data-v-759d3a15"]]);
function Xc(t) {
  "@babel/helpers - typeof";
  return Xc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Xc(t);
}
function jn(t, e) {
  if (e.length < t)
    throw new TypeError(t + " argument" + (t > 1 ? "s" : "") + " required, but only " + e.length + " present");
}
function q4(t) {
  return jn(1, arguments), t instanceof Date || Xc(t) === "object" && Object.prototype.toString.call(t) === "[object Date]";
}
function si(t) {
  jn(1, arguments);
  var e = Object.prototype.toString.call(t);
  return t instanceof Date || Xc(t) === "object" && e === "[object Date]" ? new Date(t.getTime()) : typeof t == "number" || e === "[object Number]" ? new Date(t) : ((typeof t == "string" || e === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function W4(t) {
  if (jn(1, arguments), !q4(t) && typeof t != "number")
    return !1;
  var e = si(t);
  return !isNaN(Number(e));
}
function Pr(t) {
  if (t === null || t === !0 || t === !1)
    return NaN;
  var e = Number(t);
  return isNaN(e) ? e : e < 0 ? Math.ceil(e) : Math.floor(e);
}
function G4(t, e) {
  jn(2, arguments);
  var n = si(t).getTime(), a = Pr(e);
  return new Date(n + a);
}
function X4(t, e) {
  jn(2, arguments);
  var n = Pr(e);
  return G4(t, -n);
}
var Z4 = 864e5;
function K4(t) {
  jn(1, arguments);
  var e = si(t), n = e.getTime();
  e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
  var a = e.getTime(), i = n - a;
  return Math.floor(i / Z4) + 1;
}
function Zc(t) {
  jn(1, arguments);
  var e = 1, n = si(t), a = n.getUTCDay(), i = (a < e ? 7 : 0) + a - e;
  return n.setUTCDate(n.getUTCDate() - i), n.setUTCHours(0, 0, 0, 0), n;
}
function n2(t) {
  jn(1, arguments);
  var e = si(t), n = e.getUTCFullYear(), a = /* @__PURE__ */ new Date(0);
  a.setUTCFullYear(n + 1, 0, 4), a.setUTCHours(0, 0, 0, 0);
  var i = Zc(a), r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(n, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var s = Zc(r);
  return e.getTime() >= i.getTime() ? n + 1 : e.getTime() >= s.getTime() ? n : n - 1;
}
function Q4(t) {
  jn(1, arguments);
  var e = n2(t), n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(e, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var a = Zc(n);
  return a;
}
var J4 = 6048e5;
function e8(t) {
  jn(1, arguments);
  var e = si(t), n = Zc(e).getTime() - Q4(e).getTime();
  return Math.round(n / J4) + 1;
}
var t8 = {};
function zu() {
  return t8;
}
function Kc(t, e) {
  var n, a, i, r, s, o, l, c;
  jn(1, arguments);
  var u = zu(), f = Pr((n = (a = (i = (r = e == null ? void 0 : e.weekStartsOn) !== null && r !== void 0 ? r : e == null || (s = e.locale) === null || s === void 0 || (o = s.options) === null || o === void 0 ? void 0 : o.weekStartsOn) !== null && i !== void 0 ? i : u.weekStartsOn) !== null && a !== void 0 ? a : (l = u.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(f >= 0 && f <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var m = si(t), _ = m.getUTCDay(), T = (_ < f ? 7 : 0) + _ - f;
  return m.setUTCDate(m.getUTCDate() - T), m.setUTCHours(0, 0, 0, 0), m;
}
function a2(t, e) {
  var n, a, i, r, s, o, l, c;
  jn(1, arguments);
  var u = si(t), f = u.getUTCFullYear(), m = zu(), _ = Pr((n = (a = (i = (r = e == null ? void 0 : e.firstWeekContainsDate) !== null && r !== void 0 ? r : e == null || (s = e.locale) === null || s === void 0 || (o = s.options) === null || o === void 0 ? void 0 : o.firstWeekContainsDate) !== null && i !== void 0 ? i : m.firstWeekContainsDate) !== null && a !== void 0 ? a : (l = m.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && n !== void 0 ? n : 1);
  if (!(_ >= 1 && _ <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var T = /* @__PURE__ */ new Date(0);
  T.setUTCFullYear(f + 1, 0, _), T.setUTCHours(0, 0, 0, 0);
  var g = Kc(T, e), x = /* @__PURE__ */ new Date(0);
  x.setUTCFullYear(f, 0, _), x.setUTCHours(0, 0, 0, 0);
  var S = Kc(x, e);
  return u.getTime() >= g.getTime() ? f + 1 : u.getTime() >= S.getTime() ? f : f - 1;
}
function n8(t, e) {
  var n, a, i, r, s, o, l, c;
  jn(1, arguments);
  var u = zu(), f = Pr((n = (a = (i = (r = e == null ? void 0 : e.firstWeekContainsDate) !== null && r !== void 0 ? r : e == null || (s = e.locale) === null || s === void 0 || (o = s.options) === null || o === void 0 ? void 0 : o.firstWeekContainsDate) !== null && i !== void 0 ? i : u.firstWeekContainsDate) !== null && a !== void 0 ? a : (l = u.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && n !== void 0 ? n : 1), m = a2(t, e), _ = /* @__PURE__ */ new Date(0);
  _.setUTCFullYear(m, 0, f), _.setUTCHours(0, 0, 0, 0);
  var T = Kc(_, e);
  return T;
}
var a8 = 6048e5;
function i8(t, e) {
  jn(1, arguments);
  var n = si(t), a = Kc(n, e).getTime() - n8(n, e).getTime();
  return Math.round(a / a8) + 1;
}
function yt(t, e) {
  for (var n = t < 0 ? "-" : "", a = Math.abs(t).toString(); a.length < e; )
    a = "0" + a;
  return n + a;
}
var $i = {
  // Year
  y: function(e, n) {
    var a = e.getUTCFullYear(), i = a > 0 ? a : 1 - a;
    return yt(n === "yy" ? i % 100 : i, n.length);
  },
  // Month
  M: function(e, n) {
    var a = e.getUTCMonth();
    return n === "M" ? String(a + 1) : yt(a + 1, 2);
  },
  // Day of the month
  d: function(e, n) {
    return yt(e.getUTCDate(), n.length);
  },
  // AM or PM
  a: function(e, n) {
    var a = e.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return a.toUpperCase();
      case "aaa":
        return a;
      case "aaaaa":
        return a[0];
      case "aaaa":
      default:
        return a === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(e, n) {
    return yt(e.getUTCHours() % 12 || 12, n.length);
  },
  // Hour [0-23]
  H: function(e, n) {
    return yt(e.getUTCHours(), n.length);
  },
  // Minute
  m: function(e, n) {
    return yt(e.getUTCMinutes(), n.length);
  },
  // Second
  s: function(e, n) {
    return yt(e.getUTCSeconds(), n.length);
  },
  // Fraction of second
  S: function(e, n) {
    var a = n.length, i = e.getUTCMilliseconds(), r = Math.floor(i * Math.pow(10, a - 3));
    return yt(r, n.length);
  }
}, Qr = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, r8 = {
  // Era
  G: function(e, n, a) {
    var i = e.getUTCFullYear() > 0 ? 1 : 0;
    switch (n) {
      case "G":
      case "GG":
      case "GGG":
        return a.era(i, {
          width: "abbreviated"
        });
      case "GGGGG":
        return a.era(i, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return a.era(i, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(e, n, a) {
    if (n === "yo") {
      var i = e.getUTCFullYear(), r = i > 0 ? i : 1 - i;
      return a.ordinalNumber(r, {
        unit: "year"
      });
    }
    return $i.y(e, n);
  },
  // Local week-numbering year
  Y: function(e, n, a, i) {
    var r = a2(e, i), s = r > 0 ? r : 1 - r;
    if (n === "YY") {
      var o = s % 100;
      return yt(o, 2);
    }
    return n === "Yo" ? a.ordinalNumber(s, {
      unit: "year"
    }) : yt(s, n.length);
  },
  // ISO week-numbering year
  R: function(e, n) {
    var a = n2(e);
    return yt(a, n.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, n) {
    var a = e.getUTCFullYear();
    return yt(a, n.length);
  },
  // Quarter
  Q: function(e, n, a) {
    var i = Math.ceil((e.getUTCMonth() + 1) / 3);
    switch (n) {
      case "Q":
        return String(i);
      case "QQ":
        return yt(i, 2);
      case "Qo":
        return a.ordinalNumber(i, {
          unit: "quarter"
        });
      case "QQQ":
        return a.quarter(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return a.quarter(i, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return a.quarter(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, n, a) {
    var i = Math.ceil((e.getUTCMonth() + 1) / 3);
    switch (n) {
      case "q":
        return String(i);
      case "qq":
        return yt(i, 2);
      case "qo":
        return a.ordinalNumber(i, {
          unit: "quarter"
        });
      case "qqq":
        return a.quarter(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return a.quarter(i, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return a.quarter(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, n, a) {
    var i = e.getUTCMonth();
    switch (n) {
      case "M":
      case "MM":
        return $i.M(e, n);
      case "Mo":
        return a.ordinalNumber(i + 1, {
          unit: "month"
        });
      case "MMM":
        return a.month(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return a.month(i, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return a.month(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(e, n, a) {
    var i = e.getUTCMonth();
    switch (n) {
      case "L":
        return String(i + 1);
      case "LL":
        return yt(i + 1, 2);
      case "Lo":
        return a.ordinalNumber(i + 1, {
          unit: "month"
        });
      case "LLL":
        return a.month(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return a.month(i, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return a.month(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(e, n, a, i) {
    var r = i8(e, i);
    return n === "wo" ? a.ordinalNumber(r, {
      unit: "week"
    }) : yt(r, n.length);
  },
  // ISO week of year
  I: function(e, n, a) {
    var i = e8(e);
    return n === "Io" ? a.ordinalNumber(i, {
      unit: "week"
    }) : yt(i, n.length);
  },
  // Day of the month
  d: function(e, n, a) {
    return n === "do" ? a.ordinalNumber(e.getUTCDate(), {
      unit: "date"
    }) : $i.d(e, n);
  },
  // Day of year
  D: function(e, n, a) {
    var i = K4(e);
    return n === "Do" ? a.ordinalNumber(i, {
      unit: "dayOfYear"
    }) : yt(i, n.length);
  },
  // Day of week
  E: function(e, n, a) {
    var i = e.getUTCDay();
    switch (n) {
      case "E":
      case "EE":
      case "EEE":
        return a.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return a.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return a.day(i, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return a.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, n, a, i) {
    var r = e.getUTCDay(), s = (r - i.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "e":
        return String(s);
      case "ee":
        return yt(s, 2);
      case "eo":
        return a.ordinalNumber(s, {
          unit: "day"
        });
      case "eee":
        return a.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return a.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return a.day(r, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return a.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, n, a, i) {
    var r = e.getUTCDay(), s = (r - i.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "c":
        return String(s);
      case "cc":
        return yt(s, n.length);
      case "co":
        return a.ordinalNumber(s, {
          unit: "day"
        });
      case "ccc":
        return a.day(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return a.day(r, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return a.day(r, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return a.day(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, n, a) {
    var i = e.getUTCDay(), r = i === 0 ? 7 : i;
    switch (n) {
      case "i":
        return String(r);
      case "ii":
        return yt(r, n.length);
      case "io":
        return a.ordinalNumber(r, {
          unit: "day"
        });
      case "iii":
        return a.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return a.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return a.day(i, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return a.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, n, a) {
    var i = e.getUTCHours(), r = i / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return a.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return a.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return a.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return a.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, n, a) {
    var i = e.getUTCHours(), r;
    switch (i === 12 ? r = Qr.noon : i === 0 ? r = Qr.midnight : r = i / 12 >= 1 ? "pm" : "am", n) {
      case "b":
      case "bb":
        return a.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return a.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return a.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return a.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, n, a) {
    var i = e.getUTCHours(), r;
    switch (i >= 17 ? r = Qr.evening : i >= 12 ? r = Qr.afternoon : i >= 4 ? r = Qr.morning : r = Qr.night, n) {
      case "B":
      case "BB":
      case "BBB":
        return a.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return a.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return a.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, n, a) {
    if (n === "ho") {
      var i = e.getUTCHours() % 12;
      return i === 0 && (i = 12), a.ordinalNumber(i, {
        unit: "hour"
      });
    }
    return $i.h(e, n);
  },
  // Hour [0-23]
  H: function(e, n, a) {
    return n === "Ho" ? a.ordinalNumber(e.getUTCHours(), {
      unit: "hour"
    }) : $i.H(e, n);
  },
  // Hour [0-11]
  K: function(e, n, a) {
    var i = e.getUTCHours() % 12;
    return n === "Ko" ? a.ordinalNumber(i, {
      unit: "hour"
    }) : yt(i, n.length);
  },
  // Hour [1-24]
  k: function(e, n, a) {
    var i = e.getUTCHours();
    return i === 0 && (i = 24), n === "ko" ? a.ordinalNumber(i, {
      unit: "hour"
    }) : yt(i, n.length);
  },
  // Minute
  m: function(e, n, a) {
    return n === "mo" ? a.ordinalNumber(e.getUTCMinutes(), {
      unit: "minute"
    }) : $i.m(e, n);
  },
  // Second
  s: function(e, n, a) {
    return n === "so" ? a.ordinalNumber(e.getUTCSeconds(), {
      unit: "second"
    }) : $i.s(e, n);
  },
  // Fraction of second
  S: function(e, n) {
    return $i.S(e, n);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, n, a, i) {
    var r = i._originalDate || e, s = r.getTimezoneOffset();
    if (s === 0)
      return "Z";
    switch (n) {
      case "X":
        return Im(s);
      case "XXXX":
      case "XX":
        return gr(s);
      case "XXXXX":
      case "XXX":
      default:
        return gr(s, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, n, a, i) {
    var r = i._originalDate || e, s = r.getTimezoneOffset();
    switch (n) {
      case "x":
        return Im(s);
      case "xxxx":
      case "xx":
        return gr(s);
      case "xxxxx":
      case "xxx":
      default:
        return gr(s, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, n, a, i) {
    var r = i._originalDate || e, s = r.getTimezoneOffset();
    switch (n) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Dm(s, ":");
      case "OOOO":
      default:
        return "GMT" + gr(s, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, n, a, i) {
    var r = i._originalDate || e, s = r.getTimezoneOffset();
    switch (n) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Dm(s, ":");
      case "zzzz":
      default:
        return "GMT" + gr(s, ":");
    }
  },
  // Seconds timestamp
  t: function(e, n, a, i) {
    var r = i._originalDate || e, s = Math.floor(r.getTime() / 1e3);
    return yt(s, n.length);
  },
  // Milliseconds timestamp
  T: function(e, n, a, i) {
    var r = i._originalDate || e, s = r.getTime();
    return yt(s, n.length);
  }
};
function Dm(t, e) {
  var n = t > 0 ? "-" : "+", a = Math.abs(t), i = Math.floor(a / 60), r = a % 60;
  if (r === 0)
    return n + String(i);
  var s = e;
  return n + String(i) + s + yt(r, 2);
}
function Im(t, e) {
  if (t % 60 === 0) {
    var n = t > 0 ? "-" : "+";
    return n + yt(Math.abs(t) / 60, 2);
  }
  return gr(t, e);
}
function gr(t, e) {
  var n = e || "", a = t > 0 ? "-" : "+", i = Math.abs(t), r = yt(Math.floor(i / 60), 2), s = yt(i % 60, 2);
  return a + r + n + s;
}
var Mm = function(e, n) {
  switch (e) {
    case "P":
      return n.date({
        width: "short"
      });
    case "PP":
      return n.date({
        width: "medium"
      });
    case "PPP":
      return n.date({
        width: "long"
      });
    case "PPPP":
    default:
      return n.date({
        width: "full"
      });
  }
}, i2 = function(e, n) {
  switch (e) {
    case "p":
      return n.time({
        width: "short"
      });
    case "pp":
      return n.time({
        width: "medium"
      });
    case "ppp":
      return n.time({
        width: "long"
      });
    case "pppp":
    default:
      return n.time({
        width: "full"
      });
  }
}, s8 = function(e, n) {
  var a = e.match(/(P+)(p+)?/) || [], i = a[1], r = a[2];
  if (!r)
    return Mm(e, n);
  var s;
  switch (i) {
    case "P":
      s = n.dateTime({
        width: "short"
      });
      break;
    case "PP":
      s = n.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      s = n.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      s = n.dateTime({
        width: "full"
      });
      break;
  }
  return s.replace("{{date}}", Mm(i, n)).replace("{{time}}", i2(r, n));
}, o8 = {
  p: i2,
  P: s8
};
function l8(t) {
  var e = new Date(Date.UTC(t.getFullYear(), t.getMonth(), t.getDate(), t.getHours(), t.getMinutes(), t.getSeconds(), t.getMilliseconds()));
  return e.setUTCFullYear(t.getFullYear()), t.getTime() - e.getTime();
}
var c8 = ["D", "DD"], u8 = ["YY", "YYYY"];
function d8(t) {
  return c8.indexOf(t) !== -1;
}
function h8(t) {
  return u8.indexOf(t) !== -1;
}
function Om(t, e, n) {
  if (t === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(e, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(e, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(e, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(e, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var f8 = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, p8 = function(e, n, a) {
  var i, r = f8[e];
  return typeof r == "string" ? i = r : n === 1 ? i = r.one : i = r.other.replace("{{count}}", n.toString()), a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? "in " + i : i + " ago" : i;
};
function Kd(t) {
  return function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = e.width ? String(e.width) : t.defaultWidth, a = t.formats[n] || t.formats[t.defaultWidth];
    return a;
  };
}
var m8 = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, g8 = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, b8 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, v8 = {
  date: Kd({
    formats: m8,
    defaultWidth: "full"
  }),
  time: Kd({
    formats: g8,
    defaultWidth: "full"
  }),
  dateTime: Kd({
    formats: b8,
    defaultWidth: "full"
  })
}, y8 = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, _8 = function(e, n, a, i) {
  return y8[e];
};
function No(t) {
  return function(e, n) {
    var a = n != null && n.context ? String(n.context) : "standalone", i;
    if (a === "formatting" && t.formattingValues) {
      var r = t.defaultFormattingWidth || t.defaultWidth, s = n != null && n.width ? String(n.width) : r;
      i = t.formattingValues[s] || t.formattingValues[r];
    } else {
      var o = t.defaultWidth, l = n != null && n.width ? String(n.width) : t.defaultWidth;
      i = t.values[l] || t.values[o];
    }
    var c = t.argumentCallback ? t.argumentCallback(e) : e;
    return i[c];
  };
}
var T8 = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, x8 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, w8 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, k8 = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, C8 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, S8 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, A8 = function(e, n) {
  var a = Number(e), i = a % 100;
  if (i > 20 || i < 10)
    switch (i % 10) {
      case 1:
        return a + "st";
      case 2:
        return a + "nd";
      case 3:
        return a + "rd";
    }
  return a + "th";
}, E8 = {
  ordinalNumber: A8,
  era: No({
    values: T8,
    defaultWidth: "wide"
  }),
  quarter: No({
    values: x8,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: No({
    values: w8,
    defaultWidth: "wide"
  }),
  day: No({
    values: k8,
    defaultWidth: "wide"
  }),
  dayPeriod: No({
    values: C8,
    defaultWidth: "wide",
    formattingValues: S8,
    defaultFormattingWidth: "wide"
  })
};
function $o(t) {
  return function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = n.width, i = a && t.matchPatterns[a] || t.matchPatterns[t.defaultMatchWidth], r = e.match(i);
    if (!r)
      return null;
    var s = r[0], o = a && t.parsePatterns[a] || t.parsePatterns[t.defaultParseWidth], l = Array.isArray(o) ? D8(o, function(f) {
      return f.test(s);
    }) : L8(o, function(f) {
      return f.test(s);
    }), c;
    c = t.valueCallback ? t.valueCallback(l) : l, c = n.valueCallback ? n.valueCallback(c) : c;
    var u = e.slice(s.length);
    return {
      value: c,
      rest: u
    };
  };
}
function L8(t, e) {
  for (var n in t)
    if (t.hasOwnProperty(n) && e(t[n]))
      return n;
}
function D8(t, e) {
  for (var n = 0; n < t.length; n++)
    if (e(t[n]))
      return n;
}
function I8(t) {
  return function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = e.match(t.matchPattern);
    if (!a) return null;
    var i = a[0], r = e.match(t.parsePattern);
    if (!r) return null;
    var s = t.valueCallback ? t.valueCallback(r[0]) : r[0];
    s = n.valueCallback ? n.valueCallback(s) : s;
    var o = e.slice(i.length);
    return {
      value: s,
      rest: o
    };
  };
}
var M8 = /^(\d+)(th|st|nd|rd)?/i, O8 = /\d+/i, P8 = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, B8 = {
  any: [/^b/i, /^(a|c)/i]
}, R8 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, N8 = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, $8 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, F8 = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, z8 = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, U8 = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, H8 = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Y8 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, j8 = {
  ordinalNumber: I8({
    matchPattern: M8,
    parsePattern: O8,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: $o({
    matchPatterns: P8,
    defaultMatchWidth: "wide",
    parsePatterns: B8,
    defaultParseWidth: "any"
  }),
  quarter: $o({
    matchPatterns: R8,
    defaultMatchWidth: "wide",
    parsePatterns: N8,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: $o({
    matchPatterns: $8,
    defaultMatchWidth: "wide",
    parsePatterns: F8,
    defaultParseWidth: "any"
  }),
  day: $o({
    matchPatterns: z8,
    defaultMatchWidth: "wide",
    parsePatterns: U8,
    defaultParseWidth: "any"
  }),
  dayPeriod: $o({
    matchPatterns: H8,
    defaultMatchWidth: "any",
    parsePatterns: Y8,
    defaultParseWidth: "any"
  })
}, V8 = {
  code: "en-US",
  formatDistance: p8,
  formatLong: v8,
  formatRelative: _8,
  localize: E8,
  match: j8,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, q8 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, W8 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, G8 = /^'([^]*?)'?$/, X8 = /''/g, Z8 = /[a-zA-Z]/;
function Ct(t, e, n) {
  var a, i, r, s, o, l, c, u, f, m, _, T, g, x;
  jn(2, arguments);
  var S = String(e), D = zu(), L = (a = (i = void 0) !== null && i !== void 0 ? i : D.locale) !== null && a !== void 0 ? a : V8, M = Pr((r = (s = (o = (l = void 0) !== null && l !== void 0 ? l : void 0) !== null && o !== void 0 ? o : D.firstWeekContainsDate) !== null && s !== void 0 ? s : (c = D.locale) === null || c === void 0 || (u = c.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && r !== void 0 ? r : 1);
  if (!(M >= 1 && M <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var E = Pr((f = (m = (_ = (T = void 0) !== null && T !== void 0 ? T : void 0) !== null && _ !== void 0 ? _ : D.weekStartsOn) !== null && m !== void 0 ? m : (g = D.locale) === null || g === void 0 || (x = g.options) === null || x === void 0 ? void 0 : x.weekStartsOn) !== null && f !== void 0 ? f : 0);
  if (!(E >= 0 && E <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!L.localize)
    throw new RangeError("locale must contain localize property");
  if (!L.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var P = si(t);
  if (!W4(P))
    throw new RangeError("Invalid time value");
  var B = l8(P), z = X4(P, B), W = {
    firstWeekContainsDate: M,
    weekStartsOn: E,
    locale: L,
    _originalDate: P
  }, V = S.match(W8).map(function(H) {
    var se = H[0];
    if (se === "p" || se === "P") {
      var ie = o8[se];
      return ie(H, L.formatLong);
    }
    return H;
  }).join("").match(q8).map(function(H) {
    if (H === "''")
      return "'";
    var se = H[0];
    if (se === "'")
      return K8(H);
    var ie = r8[se];
    if (ie)
      return h8(H) && Om(H, e, String(t)), d8(H) && Om(H, e, String(t)), ie(z, H, L.localize, W);
    if (se.match(Z8))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + se + "`");
    return H;
  }).join("");
  return V;
}
function K8(t) {
  var e = t.match(G8);
  return e ? e[1].replace(X8, "'") : t;
}
const Q8 = {
  width: "225",
  height: "496",
  viewBox: "0 0 225 496",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function J8(t, e) {
  return h(), b("svg", Q8, e[0] || (e[0] = [
    k("g", null, [
      k("path", {
        opacity: "0.25",
        d: "M71.1732 72.8843L243 0.393311V49.8933L105.538 107.886L48.6001 247.893L105.538 387.9L243 445.893V495.393L71.1732 422.902L0 247.893L71.1732 72.8843Z",
        fill: "#F2F2F2"
      })
    ], -1)
  ]));
}
const r2 = { render: J8 }, ew = {
  width: "900",
  height: "300",
  viewBox: "0 0 900 300",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__graphic-hatch-lines"
};
function tw(t, e) {
  return h(), b("svg", ew, e[0] || (e[0] = [
    ri('<path d="M144.445 318.242L12.7009 0.182617" stroke="#C099FF" stroke-width="1.5" class="svg__stroke--wayfinder"></path><path d="M160.445 318.242L28.7009 0.182617" stroke="#C099FF" stroke-width="1.5" class="svg__stroke--wayfinder"></path><path d="M176.445 318.242L44.7009 0.182617" stroke="#C099FF" stroke-width="1.5" class="svg__stroke--wayfinder"></path><path d="M192.445 318.242L60.7009 0.182617" stroke="#C099FF" stroke-width="1.5" class="svg__stroke--wayfinder"></path><path d="M208.445 318.242L76.7009 0.182617" stroke="#C099FF" stroke-width="2" class="svg__stroke--wayfinder"></path><path d="M224.445 318.242L92.7009 0.182617" stroke="#C099FF" stroke-width="2" class="svg__stroke--wayfinder"></path><path d="M240.445 318.242L108.701 0.182617" stroke="#C099FF" stroke-width="2" class="svg__stroke--wayfinder"></path><path d="M256.445 318.242L124.701 0.182617" stroke="#C099FF" stroke-width="2" class="svg__stroke--wayfinder"></path><path d="M272.445 318.242L140.701 0.182617" stroke="#C099FF" stroke-width="2.5" class="svg__stroke--wayfinder"></path><path d="M288.445 318.242L156.701 0.182617" stroke="#C099FF" stroke-width="2.5" class="svg__stroke--wayfinder"></path><path d="M304.445 318.242L172.701 0.182617" stroke="#C099FF" stroke-width="2.5" class="svg__stroke--wayfinder"></path><path d="M320.445 318.242L188.701 0.182617" stroke="#C099FF" stroke-width="2.5" class="svg__stroke--wayfinder"></path><path d="M336.445 318.242L204.701 0.182617" stroke="#C099FF" stroke-width="3" class="svg__stroke--wayfinder"></path><path d="M352.445 318.242L220.701 0.182617" stroke="#C099FF" stroke-width="3" class="svg__stroke--wayfinder"></path><path d="M368.445 318.242L236.701 0.182617" stroke="#C099FF" stroke-width="3" class="svg__stroke--wayfinder"></path><path d="M384.445 318.242L252.701 0.182617" stroke="#C099FF" stroke-width="3" class="svg__stroke--wayfinder"></path><path d="M400.445 318.242L268.701 0.182617" stroke="#C099FF" stroke-width="3.5" class="svg__stroke--wayfinder"></path><path d="M416.445 318.242L284.701 0.182617" stroke="#C099FF" stroke-width="3.5" class="svg__stroke--wayfinder"></path><path d="M432.445 318.242L300.701 0.182617" stroke="#C099FF" stroke-width="3.5" class="svg__stroke--wayfinder"></path><path d="M448.445 318.242L316.701 0.182617" stroke="#C099FF" stroke-width="3.5" class="svg__stroke--wayfinder"></path><path d="M464.445 318.242L332.701 0.182617" stroke="#C099FF" stroke-width="4" class="svg__stroke--wayfinder"></path><path d="M480.445 318.242L348.701 0.182617" stroke="#C099FF" stroke-width="4" class="svg__stroke--wayfinder"></path><path d="M496.445 318.242L364.701 0.182617" stroke="#C099FF" stroke-width="4" class="svg__stroke--wayfinder"></path><path d="M512.445 318.242L380.701 0.182617" stroke="#C099FF" stroke-width="4" class="svg__stroke--wayfinder"></path><path d="M528.445 318.242L396.701 0.182617" stroke="#C099FF" stroke-width="4.5" class="svg__stroke--wayfinder"></path><path d="M544.445 318.242L412.701 0.182617" stroke="#C099FF" stroke-width="4.5" class="svg__stroke--wayfinder"></path><path d="M560.445 318.242L428.701 0.182617" stroke="#C099FF" stroke-width="4.5" class="svg__stroke--wayfinder"></path><path d="M576.445 318.242L444.701 0.182617" stroke="#C099FF" stroke-width="4.5" class="svg__stroke--wayfinder"></path><path d="M592.445 318.242L460.701 0.182617" stroke="#C099FF" stroke-width="5" class="svg__stroke--wayfinder"></path><path d="M608.445 318.242L476.701 0.182617" stroke="#C099FF" stroke-width="5" class="svg__stroke--wayfinder"></path><path d="M624.445 318.242L492.701 0.182617" stroke="#C099FF" stroke-width="5" class="svg__stroke--wayfinder"></path><path d="M640.445 318.242L508.701 0.182617" stroke="#C099FF" stroke-width="5" class="svg__stroke--wayfinder"></path><path d="M656.445 318.242L524.701 0.182617" stroke="#C099FF" stroke-width="5.5" class="svg__stroke--wayfinder"></path><path d="M672.445 318.242L540.701 0.182617" stroke="#C099FF" stroke-width="5.5" class="svg__stroke--wayfinder"></path><path d="M688.445 318.242L556.701 0.182617" stroke="#C099FF" stroke-width="5.5" class="svg__stroke--wayfinder"></path><path d="M704.445 318.242L572.701 0.182617" stroke="#C099FF" stroke-width="5.5" class="svg__stroke--wayfinder"></path><path d="M720.445 318.242L588.701 0.182617" stroke="#C099FF" stroke-width="5.5" class="svg__stroke--wayfinder"></path><path d="M736.445 318.242L604.701 0.182617" stroke="#C099FF" stroke-width="5.5" class="svg__stroke--wayfinder"></path><path d="M752.445 318.242L620.701 0.182617" stroke="#C099FF" stroke-width="5.5" class="svg__stroke--wayfinder"></path><path d="M768.445 318.242L636.701 0.182617" stroke="#C099FF" stroke-width="5.5" class="svg__stroke--wayfinder"></path><path d="M784.445 318.242L654.701 0.182617" stroke="#C099FF" stroke-width="5.5" class="svg__stroke--wayfinder"></path><path d="M800.445 318.242L670.701 0.182617" stroke="#C099FF" stroke-width="5.5" class="svg__stroke--wayfinder"></path><path d="M816.445 318.242L686.701 0.182617" stroke="#C099FF" stroke-width="5.5" class="svg__stroke--wayfinder"></path><path d="M832.445 318.242L702.701 0.182617" stroke="#C099FF" stroke-width="5.5" class="svg__stroke--wayfinder"></path><path d="M848.445 318.242L718.701 0.182617" stroke="#C099FF" stroke-width="5.5" class="svg__stroke--wayfinder"></path><path d="M864.445 318.242L734.701 0.182617" stroke="#C099FF" stroke-width="5.5" class="svg__stroke--wayfinder"></path><path d="M880.445 318.242L750.701 0.182617" stroke="#C099FF" stroke-width="5.5" class="svg__stroke--wayfinder"></path>', 47)
  ]));
}
const s2 = { render: tw }, nw = {
  width: "42",
  height: "100",
  viewBox: "0 0 42 100",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__graphic-category-slash"
};
function o2(t, e) {
  return h(), b("svg", nw, e[0] || (e[0] = [
    k("path", {
      d: "M40.8666 1L20.4532 51.5248L7.48442 83.6237L1.00001 99.6732",
      stroke: "#0AA5FF",
      "stroke-width": "1.5",
      class: "svg__stroke--default-cyan-03"
    }, null, -1)
  ]));
}
const l2 = { render: o2 }, c2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: l2,
  render: o2
}, Symbol.toStringTag, { value: "Module" }));
function qh(t = "") {
  let e = !1;
  return (t == null || String(t).indexOf("/") === 0 || !t.includes(".") && t.length !== 0) && (e = !0), e;
}
const aw = ["1", "_blank", "blank"], iw = ["", null];
function u2(t = "", e = "") {
  let n = "";
  return aw.includes(t) || iw.includes(t) && !qh(e) ? n = "_blank" : n = "", n;
}
function rw(t = "") {
  let e = !1;
  switch (!0) {
    case String(t).indexOf("/") === 0:
      e = !0;
      break;
  }
  return e;
}
const sw = {
  name: "SmartLink",
  props: {
    to: {
      type: String,
      default: ""
    },
    linkTarget: {
      type: String,
      default: ""
    },
    isDownload: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    parsedTarget() {
      return u2(this.linkTarget, this.to);
    },
    isRelative() {
      return !!rw(this.to);
    },
    parsedTo() {
      return this.isRelative && !this.isDownload && !this.parsedTarget ? this.to !== "/" && !this.to.endsWith("/") && !this.to.includes("q=") && !this.to.includes("&filters=") && !this.to.includes("?view=") ? `${this.to}/` : this.to : this.to;
    }
  }
}, ow = ["href"], lw = ["href", "target"], cw = {
  key: 3,
  class: "smart-link is-link"
};
function uw(t, e, n, a, i, r) {
  const s = lt("router-link");
  return r.isRelative && !n.isDownload && !r.parsedTarget ? (h(), G(s, {
    key: 0,
    class: "smart-link is-router-link",
    to: r.parsedTo
  }, {
    default: oe(() => [
      me(t.$slots, "default", {}, void 0, !0)
    ]),
    _: 3
  }, 8, ["to"])) : n.isDownload ? (h(), b("a", {
    key: 1,
    href: n.to,
    class: "smart-link is-link",
    download: ""
  }, [
    me(t.$slots, "default", {}, void 0, !0)
  ], 8, ow)) : n.to ? (h(), b("a", {
    key: 2,
    href: n.to,
    target: r.parsedTarget,
    class: "smart-link is-link"
  }, [
    me(t.$slots, "default", {}, void 0, !0)
  ], 8, lw)) : (h(), b("button", cw, [
    me(t.$slots, "default", {}, void 0, !0)
  ]));
}
const Xe = /* @__PURE__ */ ge(sw, [["render", uw], ["__scopeId", "data-v-fdc32891"]]), dw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Xe
}, Symbol.toStringTag, { value: "Module" })), hw = { class: "label" }, fw = { class: "hover" }, pw = { class: "label" }, mw = {
  __name: "ButtonLink",
  props: {
    to: {
      type: String,
      default: ""
    },
    /**
     * Determines what text the button should have.
     */
    label: {
      type: String,
      default: ""
    },
    /**
     * Determines what icon should be used in button.
     * Do not include this prop if it is an internal link.
     */
    iconName: {
      type: String,
      default: ""
    },
    isSecondary: {
      type: Boolean,
      default: !1
    },
    isTertiary: {
      type: Boolean,
      default: !1
    },
    isQuaternary: {
      type: Boolean,
      default: !1
    },
    isDownload: {
      type: Boolean,
      default: !1
    },
    linkTarget: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = t, n = ve(
      () => Promise.resolve().then(() => X2)
    ), a = ve(
      () => Promise.resolve().then(() => VM)
    ), i = ve(
      () => import("./icon-download-Dp9VXiET.js")
    ), r = ve(
      () => Promise.resolve().then(() => p2)
    ), s = qe(), o = I(() => [
      "button-link",
      (s == null ? void 0 : s.value) || "",
      e.isSecondary ? "is-secondary" : e.isTertiary ? "is-tertiary" : e.isQuaternary ? "is-quaternary" : ""
    ]), l = I(() => {
      switch (!0) {
        case e.isDownload:
          return i;
        case e.iconName === "none":
          return "";
        case qh(e.to):
          return a;
        case (e.linkTarget === "_blank" || e.iconName === "svg-external-link"):
          return n;
        case e.iconName === "icon-close":
          return r;
        default:
          return n;
      }
    });
    return (c, u) => (h(), G(Xe, {
      to: t.to,
      class: re(o.value),
      "is-download": t.isDownload,
      "link-target": t.linkTarget
    }, {
      default: oe(() => [
        k("span", hw, ne(t.label), 1),
        me(c.$slots, "default", {}, void 0, !0),
        l.value !== "" ? (h(), G(dt(l.value), {
          key: 0,
          class: "arrow",
          "aria-hidden": "true"
        })) : A("", !0),
        k("div", fw, [
          k("span", pw, ne(t.label), 1),
          l.value !== "" ? (h(), G(dt(l.value), {
            key: 0,
            class: "arrow",
            "aria-hidden": "true"
          })) : A("", !0)
        ])
      ]),
      _: 3
    }, 8, ["to", "class", "is-download", "link-target"]));
  }
}, sn = /* @__PURE__ */ ge(mw, [["__scopeId", "data-v-f4120164"]]), Ml = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sn
}, Symbol.toStringTag, { value: "Module" })), gw = {
  name: "IconWithLink",
  components: {
    SmartLink: Xe,
    SvgIconConsultation: ve(
      () => import("./icon-chat-DCvwPwHu.js")
    ),
    SvgIconList: ve(
      () => Promise.resolve().then(() => MT)
    ),
    SvgIconLocation: ve(
      () => import("./icon-location-DNog__Cl.js")
    ),
    SvgIconPhone: ve(
      () => import("./icon-phone-DPv-PoqA.js")
    ),
    SvgIconSearch: ve(
      () => Promise.resolve().then(() => Ole)
    ),
    SvgIconVirtual: ve(
      () => import("./icon-virtual-CwZieS3s.js")
    ),
    SvgIconHeadphones: ve(
      () => import("./icon-headphones-Vk0iXmnu.js")
    ),
    SvgIconVideo: ve(
      () => import("./icon-video-Tda9BGRR.js")
    ),
    SvgIconImageStack: ve(
      () => Promise.resolve().then(() => kQ)
    ),
    SvgIconMoney: ve(
      () => import("./icon-money-BxPRObPA.js")
    ),
    SvgIconMessage: ve(
      () => import("./icon-message-CyHSPUb-.js")
    ),
    SvgIconPlay: ve(
      () => import("./icon-play-BaMxYNFG.js")
    ),
    SvgIconPlayFilled: ve(
      () => import("./icon-play-filled-Dvcf_yQh.js")
    ),
    SvgIconEye: ve(
      () => import("./icon-eye-L7brvvQ3.js")
    ),
    SvgIconCheck: ve(
      () => import("./icon-check-CKGDA7ua.js")
    ),
    SvgIconEmail: ve(
      () => import("./icon-email-d9JGcdKa.js")
    ),
    SvgIconCard: ve(
      () => Promise.resolve().then(() => wde)
    ),
    SvgIconCalendar: ve(
      () => Promise.resolve().then(() => Bp)
    ),
    SvgIconLaptop: ve(
      () => import("./icon-laptop-Bmg8PSn7.js")
    ),
    SvgIconBook: ve(
      () => import("./icon-book-Dhs3bbZ0.js")
    ),
    SvgIconLocker: ve(
      () => import("./icon-locker-BBQPsbYg.js")
    ),
    SvgIconPerson: ve(
      () => import("./icon-person-BPUoRkt6.js")
    ),
    SvgIconAccessible: ve(
      () => import("./icon-accessible-C8Gup1rK.js")
    ),
    SvgIconClock: ve(
      () => import("./icon-clock-CG3EE-5W.js")
    ),
    SvgIconChair: ve(
      () => import("./icon-chair-D8fW8Dnx.js")
    ),
    SvgIconLight: ve(
      () => import("./icon-light-wkkuRssP.js")
    ),
    SvgIconLocationFilled: ve(
      () => import("./icon-location-filled-Cyf_QfPI.js")
    ),
    SvgIconAlert: ve(
      () => Promise.resolve().then(() => R0e)
    ),
    SvgIconShareEmail: ve(
      () => import("./icon-share-email-ds0LMlnf.js")
    ),
    SvgIconSharePrinter: ve(
      () => Promise.resolve().then(() => S2)
    ),
    SvgIconShareFacebook: ve(
      () => import("./icon-share-facebook-jNsnyfWc.js")
    ),
    SvgIconShareInstagram: ve(
      () => import("./icon-share-instagram-CHpDcj4d.js")
    ),
    SvgIconShareLinkedin: ve(
      () => import("./icon-share-linkedin-D_WCf0Fz.js")
    ),
    SvgIconShareTwitter: ve(
      () => import("./icon-share-twitter-CS2kovPG.js")
    ),
    SvgIconShareWhatsapp: ve(
      () => import("./icon-share-whatsapp-B2hhPPEt.js")
    ),
    // FTVA Icons
    SvgIconFtvaAppleinc: ve(
      () => import("./icon-ftva-appleinc-D6O1BYI_.js")
    ),
    SvgIconFtvaDownload: ve(
      () => import("./icon-ftva-download-CfgJu8GR.js")
    ),
    SvgIconFtvaEmail: ve(
      () => import("./icon-ftva-email-BVoSQQla.js")
    ),
    SvgIconFtvaGcal: ve(
      () => import("./icon-ftva-gcal-C7UpU-sa.js")
    ),
    SvgIconFtvaHours: ve(
      () => import("./icon-ftva-hours-C6XjS6oB.js")
    ),
    SvgIconFtvaLocationOutline: ve(
      () => import("./icon-ftva-location-outline--K6kAmAp.js")
    ),
    SvgIconFtvaOutlook: ve(
      () => import("./icon-ftva-outlook-D01ntAYf.js")
    ),
    SvgIconFtvaPhone: ve(
      () => import("./icon-ftva-phone-CwJ6dpNs.js")
    ),
    SvgIconFtvaShare: ve(
      () => Promise.resolve().then(() => CB)
    ),
    SvgIconFtvaSocialConfirm: ve(
      () => Promise.resolve().then(() => AB)
    ),
    SvgIconFtvaSocialEmail: ve(
      () => import("./icon-ftva-social_email-C1L_bljr.js")
    ),
    SvgIconFtvaSocialFacebook: ve(
      () => import("./icon-ftva-social_facebook-BgnF7yg7.js")
    ),
    SvgIconFtvaSocialLink: ve(
      () => import("./icon-ftva-social_link-BZIDORpF.js")
    ),
    SvgIconFtvaSocialX: ve(
      () => import("./icon-ftva-social_x-7x5Xoj9-.js")
    )
  },
  props: {
    text: {
      type: String,
      required: !0
    },
    iconName: {
      type: String,
      required: !0
    },
    to: {
      // URL to link to
      type: String,
      default: ""
    }
  }
}, bw = { class: "icon-with-link" }, vw = ["textContent"], yw = {
  key: 1,
  class: "icon-with-link-container"
}, _w = ["textContent"];
function Tw(t, e, n, a, i, r) {
  const s = lt("SmartLink");
  return h(), b("div", bw, [
    n.to ? (h(), G(s, {
      key: 0,
      to: n.to,
      class: "icon-with-link-container link"
    }, {
      default: oe(() => [
        (h(), G(dt(n.iconName), {
          class: "icon",
          "aria-hidden": "true"
        })),
        k("div", {
          class: "text",
          textContent: ne(n.text)
        }, null, 8, vw)
      ]),
      _: 1
    }, 8, ["to"])) : (h(), b("div", yw, [
      (h(), G(dt(n.iconName), {
        class: "icon",
        "aria-hidden": "true"
      })),
      k("div", {
        class: "text",
        textContent: ne(n.text)
      }, null, 8, _w)
    ]))
  ]);
}
const en = /* @__PURE__ */ ge(gw, [["render", Tw], ["__scopeId", "data-v-569e4c2f"]]), d2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: en
}, Symbol.toStringTag, { value: "Module" }));
function xw(t = "") {
  return t == null ? t : t.includes("https://test-craft.library.ucla.edu") ? t.replaceAll("https://test-craft.library.ucla.edu", "") : t.includes("https://stage-craft.library.ucla.edu") ? t.replaceAll("https://stage-craft.library.ucla.edu", "") : t.replaceAll("https://craft.library.ucla.edu", "");
}
function ww(t = "") {
  if (t == null)
    return t;
  const e = /<a\s+(?:[^>]*?\s+)?target=(["_blank'])(.*?)\1*>(.*?)<\/a>/g;
  return t.replace(e, (n) => `${n.replace("</a>", "")}<span class="visually-hidden">(opens in a new tab)</span></a>`);
}
const kw = ["innerHTML"], Cw = /* @__PURE__ */ Ce({
  __name: "RichText",
  props: {
    richTextContent: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = t, n = qe(), a = I(() => ["rich-text", (n == null ? void 0 : n.value) || ""]), i = I(() => {
      const r = xw(e.richTextContent);
      return ww(r);
    });
    return (r, s) => (h(), b("div", {
      class: re(a.value)
    }, [
      k("div", {
        class: "parsed-content",
        innerHTML: i.value
      }, null, 8, kw),
      me(r.$slots, "default", {}, void 0, !0)
    ], 2));
  }
}), un = /* @__PURE__ */ ge(Cw, [["__scopeId", "data-v-04307b17"]]), h2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: un
}, Symbol.toStringTag, { value: "Module" })), Sw = ["src", "height", "width", "alt", "srcset", "sizes", "object-fit"], Aw = ["innerHTML"], Ew = {
  key: 1,
  class: "toptext"
}, Lw = { class: "image-top-text" }, Dw = {
  key: 2,
  class: "credit"
}, Iw = { class: "credit-text" }, Mw = /* @__PURE__ */ Ce({
  __name: "ResponsiveImage",
  props: {
    media: {
      type: Object,
      default: () => {
      }
    },
    src: {
      type: String,
      default: ""
    },
    height: {
      type: Number,
      default: 0
    },
    width: {
      type: Number,
      default: 0
    },
    alt: {
      type: String,
      default: ""
    },
    srcset: {
      type: String,
      default: ""
    },
    sizes: {
      type: String,
      default: ""
    },
    caption: {
      type: String,
      default: ""
    },
    aspectRatio: {
      type: Number,
      default: 0
    },
    objectFit: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = t, n = K(!1), a = K(!1);
    function i() {
      n.value = !0;
    }
    function r() {
      a.value = !0;
    }
    const s = I(() => {
      let u = "";
      return e.media.focalPoint && e.media.focalPoint.length > 0 && (u = `object-position:${e.media.focalPoint.map((m) => `${m * 100}%`).join(" ")}`), u;
    }), o = I(() => {
      const u = e.media.height || e.height, f = e.media.width || e.width;
      return e.aspectRatio || u / f * 100;
    }), l = I(() => ({
      paddingBottom: `${o.value}%`
    })), c = I(() => [
      "responsive-image",
      `object-fit-${e.objectFit}`,
      { "has-loaded": n },
      { "has-errored": a }
    ]);
    return (u, f) => e.media && e.media.src ? (h(), b("figure", {
      key: 0,
      class: re(c.value)
    }, [
      k("img", {
        src: e.media.src || e.src,
        height: e.media.width || e.width,
        width: e.media.height || e.height,
        alt: e.media.alt || e.alt,
        srcset: e.media.srcset || e.srcset,
        sizes: e.media.sizes || e.sizes,
        "object-fit": e.objectFit,
        style: bn(s.value),
        class: "media",
        onLoad: i,
        onError: r
      }, null, 44, Sw),
      e.media.caption || e.caption ? (h(), b("figcaption", {
        key: 0,
        class: "caption",
        innerHTML: e.media.caption || e.caption
      }, null, 8, Aw)) : A("", !0),
      k("div", {
        class: "sizer",
        style: bn(l.value)
      }, null, 4),
      me(u.$slots, "default", {}, void 0, !0),
      u.$slots.toptext ? (h(), b("div", Ew, [
        k("div", Lw, [
          me(u.$slots, "toptext", {}, void 0, !0)
        ])
      ])) : A("", !0),
      u.$slots.credit ? (h(), b("div", Dw, [
        k("div", Iw, [
          me(u.$slots, "credit", {}, void 0, !0)
        ])
      ])) : A("", !0)
    ], 2)) : A("", !0);
  }
}), dn = /* @__PURE__ */ ge(Mw, [["__scopeId", "data-v-0cc7cdea"]]), Ow = ["src", "alt", "controls", "autoplay", "muted", "loop", "playsinline"], Pw = /* @__PURE__ */ Ce({
  __name: "ResponsiveVideo",
  props: {
    media: {
      type: Object,
      default: () => ({})
    },
    mode: {
      type: String,
      default: "intrinsic-ratio"
    },
    aspectRatio: {
      type: Number,
      default: 0
    },
    objectFit: {
      type: String,
      default: "cover"
    },
    playsinline: {
      type: Boolean,
      default: !0
    },
    autoplay: {
      type: Boolean,
      default: !0
    },
    loop: {
      type: Boolean,
      default: !1
    },
    muted: {
      type: Boolean,
      default: !0
    },
    controls: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["ended", "error", "error-image", "error-video", "loaded", "loaded-image", "loaded-video", "playing"],
  setup(t, { emit: e }) {
    const n = t, a = e, i = K(null), r = Ma({
      video: !1
    }), s = K({
      video: !1
    }), o = I(() => Object.values(s.value).includes(!0)), l = I(() => Object.values(r).every(Boolean)), c = I(() => n.media.src), u = I(() => {
      const B = n.media.height;
      return B && typeof B == "string" ? Number.parseInt(B) : B;
    }), f = I(() => {
      const B = n.media.width;
      return B && typeof B == "string" ? Number.parseInt(B) : B;
    }), m = I(() => {
      let B = "landscape";
      switch (!0) {
        case u.value > f.value:
          B = "portrait";
          break;
        case u.value === f.value:
          B = "square";
          break;
      }
      return B;
    }), _ = I(() => [
      "responsive-video",
      `mode-${n.mode}`,
      { "has-loaded": l.value },
      { "has-error": o.value },
      { "has-video-error": s.value.video },
      `is-orientation-${m.value}`,
      `object-fit-${n.objectFit}`
    ]), T = I(() => {
      let B = n.aspectRatio || u.value / f.value * 100;
      return B || (B = 0), B;
    }), g = I(() => n.media.focalPoint.length > 0 ? {
      x: n.media.focalPoint[0],
      y: n.media.focalPoint[1]
    } : {
      x: "0.5",
      y: "0.5"
    }), x = I(() => n.media.alt), S = I(() => {
      const B = {};
      return n.mode === "intrinsic-ratio" && (B.paddingBottom = `${T.value}%`), B;
    }), D = I(() => {
      const B = {};
      return g.value.x !== "" && g.value.y !== "" && (B.objectPosition = `${g.value.x}% ${g.value.y}%`), B;
    });
    Qe(c, (B) => {
      B && (r.video = !1, s.value.video = !1);
    }), st(() => {
      c.value && (r.video = i.value.readyState >= 3);
    });
    function L(B) {
      r[B] = !0, a("loaded", B), a(`loaded-${B}`);
    }
    function M(B) {
      s.value[B] = !0, a("error", B), a(`error-${B}`);
    }
    function E(B) {
      a("ended", B);
    }
    function P() {
      a("playing");
    }
    return (B, z) => (h(), b("figure", {
      class: re(_.value)
    }, [
      c.value ? (h(), b("video", {
        key: 0,
        ref_key: "videoRef",
        ref: i,
        class: "media media-video",
        src: c.value,
        alt: x.value,
        style: bn(D.value),
        controls: t.controls,
        autoplay: t.autoplay,
        muted: t.muted,
        loop: t.loop,
        playsinline: t.playsinline,
        onLoadeddata: z[0] || (z[0] = (W) => L("video")),
        onError: z[1] || (z[1] = (W) => M("video")),
        onEnded: E,
        onPlaying: P
      }, null, 44, Ow)) : A("", !0),
      k("div", {
        class: "sizer",
        style: bn(S.value)
      }, null, 4),
      z[2] || (z[2] = k("div", { class: "background-color" }, null, -1)),
      me(B.$slots, "default", {}, void 0, !0)
    ], 2));
  }
}), Wh = /* @__PURE__ */ ge(Pw, [["__scopeId", "data-v-b6bc161d"]]), Bw = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-close"
};
function f2(t, e) {
  return h(), b("svg", Bw, e[0] || (e[0] = [
    k("circle", {
      cx: "16",
      cy: "15.8645",
      r: "12",
      fill: "#F2F2F2",
      class: "svg__fill--secondary-grey-01"
    }, null, -1),
    k("path", {
      d: "M22 21.8088 10 9.91943",
      stroke: "#0B6AB7",
      "stroke-width": "1.5",
      "stroke-linejoin": "round",
      class: "svg__stroke--primary-blue-03"
    }, null, -1),
    k("path", {
      d: "m10.0497 21.8645 11.9017-12",
      stroke: "#0B6AB7",
      "stroke-width": "1.5",
      "stroke-linejoin": "round",
      class: "svg__stroke--primary-blue-03"
    }, null, -1)
  ]));
}
const er = { render: f2 }, p2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: er,
  render: f2
}, Symbol.toStringTag, { value: "Module" })), Rw = {
  key: 0,
  class: "success-message"
}, Nw = {
  key: 1,
  id: "app",
  method: "post",
  class: "form"
}, $w = { class: "formTitleWrapper" }, Fw = {
  key: 0,
  class: "form-errors"
}, zw = { key: 1 }, Uw = {
  key: 2,
  class: "input-wrapper input-radio"
}, Hw = { for: "in-person" }, Yw = { for: "online" }, jw = { class: "input-wrapper" }, Vw = { class: "input-container" }, qw = {
  key: 3,
  class: "input-wrapper"
}, Ww = { for: "email" }, Gw = { key: 0 }, Xw = { key: 1 }, Zw = ["required"], Kw = ["for"], Qw = {
  key: 0,
  class: "required"
}, Jw = {
  key: 1,
  class: "textareaWrapper"
}, ek = ["for"], tk = {
  key: 0,
  class: "required"
}, nk = ["onUpdate:modelValue"], ak = {
  key: 2,
  class: "radio-wrapper"
}, ik = ["for"], rk = ["id", "onUpdate:modelValue", "value", "name"], sk = {
  key: 3,
  class: "checkbox-wrapper"
}, ok = ["id", "onUpdate:modelValue", "true-value", "value"], lk = ["for"], ck = ["id", "onUpdate:modelValue", "name"], uk = ["value"], dk = {
  __name: "BlockForm",
  setup(t) {
    const e = ve(() => Promise.resolve().then(() => Ml)), n = wn("eventId"), a = wn("blockFormData"), i = wn("registrationType"), r = wn("libcalWaitlist"), s = wn("libcalEndpoint");
    console.log("BlockForm eventId", n.value), console.log("BlockForm blockFormData", a.value), console.log("BlockForm registrationType", i.value), console.log("BlockForm libcalWaitlist", r.value), console.log("BlockForm libcalEndpoint", s);
    const o = K([]), l = K(""), c = K(""), u = K(""), f = K({}), m = K({}), _ = K(null), T = K(!1), g = K(!1), x = K({}), S = K(!1), D = K(""), L = I(() => a.value.questions ? a.value.questions.map((W) => (W.type === "string" || W.type === "radio" || W.type === "dropdown" ? m.value[W.id] = "" : m.value[W.id] = [], f.value[W.id] = W.required, {
      ...W,
      classes: `input-${W.type}`
    })) : []);
    function M() {
      console.log("registrationTypeInput", D.value, i.value && i === "both");
      const W = {
        form: {
          first_name: l.value,
          last_name: c.value,
          email: u.value,
          questions: []
        },
        registration_type: i && i.value !== "both" && i.value !== "" ? i.value : i.value && i.value === "both" ? D.value : "",
        is_waitlist: r.value && r.value !== "" ? r.value : "0"
      };
      W.form.questions = a.value.questions.map((H) => ({
        id: H.id,
        answer: m.value[H.id]
      })), console.log("data submitting", JSON.stringify(W));
      let V = "";
      console.log("eventId", n), s ? V = `${s}api/1.1/events/${n.value}/register` : V = `${process.env.VUE_APP_CALENDAR_LIBRARY_URL}${n}/register`, fetch(V, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        body: JSON.stringify(W)
      }).then(() => {
        g.value = !0, x.value = {
          code: "success",
          text: "One seat is sent to LibCal to be registered or will be on wait list"
        };
      }).catch((H) => {
        console.error(H), g.value = !0, x.value = {
          code: "error",
          text: H
        };
      });
    }
    function E() {
      let W = !1, V = !1, H = !1;
      l.value && c.value && (W = !0), a.value.emailMethod.status === "required" && u.value && (V = !0), i && i.value === "both" && D.value === "" ? H = !1 : (i && i.value, H = !0), o.value = [], W || o.value.push("Full Name 1 required."), V || o.value.push("Email 2 required."), H || o.value.push("Registration Type 3 required.");
      for (const se of a.value.questions)
        f.value[se.id] && !m.value[se.id] ? se.type === "string" ? o.value.push(
          `${a.value.questions.label} 4a required.`
        ) : o.value.push(`${se.label} 4b required.`) : f.value[se.id] && se.type === "checkbox" && m.value[se.id].length === 0 && o.value.push(`${se.label} 4c required.`);
      o.value.length === 0 ? M() : window.scrollTo(0, 0);
    }
    function P() {
      S.value = !0;
    }
    function B() {
      S.value = !1;
    }
    function z() {
      clearTimeout(_.value), T.value = !1, S.value = !1;
    }
    return Qe(x, () => {
      T.value = !0, _.value = setTimeout(z, 113e3);
    }), (W, V) => S.value ? (h(), b("div", {
      key: 1,
      class: re(["block-form", {
        "form-error": o.value.length,
        "form-success": T.value
      }])
    }, [
      T.value ? (h(), b("div", Rw, [
        V[8] || (V[8] = k("h3", null, "Registration complete", -1)),
        V[9] || (V[9] = k("p", null, "Please check your email to view your booking.", -1)),
        k("button", {
          type: "button",
          class: "notification--remove",
          onClick: V[1] || (V[1] = (H) => z())
        }, [
          Q(O(er), { class: "svg-glyph-close" })
        ])
      ])) : (h(), b("form", Nw, [
        k("div", $w, [
          V[10] || (V[10] = k("h3", { class: "formTitle" }, " Registration ", -1)),
          k("button", {
            type: "button",
            onClick: V[2] || (V[2] = (H) => B())
          }, [
            Q(O(er), { class: "svg-glyph-close" })
          ])
        ]),
        o.value.length ? (h(), b("div", Fw, V[11] || (V[11] = [
          k("p", null, " Please complete the required fields to complete registration ", -1)
        ]))) : A("", !0),
        o.value.length ? (h(), b("br", zw)) : A("", !0),
        V[18] || (V[18] = k("div", { class: "registrationInfo" }, [
          k("p", null, "Registration is required for this event.")
        ], -1)),
        O(i) === "both" ? (h(), b("div", Uw, [
          V[14] || (V[14] = k("legend", null, [
            ze(" Registration Type "),
            k("span", { class: "required" }, "(required)")
          ], -1)),
          k("label", Hw, [
            Tt(k("input", {
              id: "in-person",
              "onUpdate:modelValue": V[3] || (V[3] = (H) => D.value = H),
              type: "radio",
              value: "in-person",
              required: ""
            }, null, 512), [
              [bs, D.value]
            ]),
            V[12] || (V[12] = ze("in-person"))
          ]),
          k("label", Yw, [
            Tt(k("input", {
              id: "online",
              "onUpdate:modelValue": V[4] || (V[4] = (H) => D.value = H),
              type: "radio",
              value: "online"
            }, null, 512), [
              [bs, D.value]
            ]),
            V[13] || (V[13] = ze(" online"))
          ])
        ])) : A("", !0),
        k("div", jw, [
          V[15] || (V[15] = k("label", null, [
            ze("Full Name "),
            k("span", { class: "required" }, "(required)")
          ], -1)),
          k("div", Vw, [
            Tt(k("input", {
              id: "firstName",
              "onUpdate:modelValue": V[5] || (V[5] = (H) => l.value = H),
              type: "text",
              name: "firstName",
              required: "",
              placeholder: "First Name"
            }, null, 512), [
              [Zo, l.value]
            ]),
            Tt(k("input", {
              id: "lastName",
              "onUpdate:modelValue": V[6] || (V[6] = (H) => c.value = H),
              type: "text",
              name: "lastName",
              required: "",
              placeholder: "Last Name"
            }, null, 512), [
              [Zo, c.value]
            ])
          ])
        ]),
        O(a).emailMethod ? (h(), b("div", qw, [
          k("label", Ww, [
            O(a).emailMethod.status === "required" ? (h(), b("span", Gw, V[16] || (V[16] = [
              ze(" Email "),
              k("span", { class: "required" }, "(required)", -1)
            ]))) : (h(), b("span", Xw, "Email"))
          ]),
          Tt(k("input", $t({
            id: "email",
            "onUpdate:modelValue": V[7] || (V[7] = (H) => u.value = H),
            type: "email",
            name: "email",
            required: O(a).emailMethod.status
          }, {}), null, 16, Zw), [
            [Zo, u.value]
          ])
        ])) : A("", !0),
        (h(!0), b(he, null, Le(L.value, (H) => (h(), b("div", {
          key: H.id,
          class: "input-wrapper parsedQuestionsLabelWrapper"
        }, [
          H.type !== "string" ? (h(), b("label", {
            key: 0,
            for: H.id,
            class: re(H.required ? "questionRequired" : "")
          }, [
            ze(ne(H.label) + " ", 1),
            H.required ? (h(), b("span", Qw, " (required) ")) : A("", !0)
          ], 10, Kw)) : A("", !0),
          H.type === "string" ? (h(), b("div", Jw, [
            k("label", {
              for: H.id,
              class: re(H.required ? "questionRequired" : "")
            }, [
              ze(ne(H.label) + " ", 1),
              H.required ? (h(), b("span", tk, "(required)")) : A("", !0)
            ], 10, ek),
            Tt(k("textarea", {
              "onUpdate:modelValue": (se) => m.value[H.id] = se,
              placeholder: "Add multiple lines"
            }, null, 8, nk), [
              [Zo, m.value[H.id]]
            ])
          ])) : A("", !0),
          H.type === "radio" ? (h(), b("div", ak, [
            (h(!0), b(he, null, Le(H.options, (se, ie) => (h(), b("div", {
              key: ie,
              class: "radioWrapper"
            }, [
              k("label", { for: se }, [
                Tt(k("input", {
                  id: se,
                  "onUpdate:modelValue": (Z) => m.value[H.id] = Z,
                  type: "radio",
                  value: se,
                  name: H.id
                }, null, 8, rk), [
                  [bs, m.value[H.id]]
                ]),
                ze(" " + ne(se), 1)
              ], 8, ik)
            ]))), 128))
          ])) : A("", !0),
          H.type === "checkbox" ? (h(), b("div", sk, [
            (h(!0), b(he, null, Le(H.options, (se, ie) => (h(), b("div", {
              key: ie,
              class: "checkboxWrapper"
            }, [
              Tt(k("input", {
                id: se,
                "onUpdate:modelValue": (Z) => m.value[H.id] = Z,
                type: "checkbox",
                "true-value": se,
                value: se
              }, null, 8, ok), [
                [jh, m.value[H.id]]
              ]),
              k("label", { for: se }, ne(se), 9, lk)
            ]))), 128))
          ])) : A("", !0),
          H.type === "dropdown" ? Tt((h(), b("select", {
            key: 4,
            id: H.id,
            "onUpdate:modelValue": (se) => m.value[H.id] = se,
            name: H.id,
            class: re(["input-dropdown", H.classes])
          }, [
            V[17] || (V[17] = k("option", {
              disabled: "",
              value: ""
            }, " Please select one ", -1)),
            (h(!0), b(he, null, Le(H.options, (se, ie) => (h(), b("option", {
              key: ie,
              value: se
            }, ne(se), 9, uk))), 128))
          ], 10, ck)), [
            [D4, m.value[H.id]]
          ]) : A("", !0)
        ]))), 128)),
        Q(O(e), {
          type: "submit",
          label: "Register",
          "icon-name": "none",
          "is-secondary": !0,
          onClick: da(E, ["prevent"])
        })
      ]))
    ], 2)) : (h(), G(O(e), {
      key: 0,
      label: "Register",
      "icon-name": "none",
      "is-secondary": !0,
      class: "register-button",
      onClick: V[0] || (V[0] = da((H) => P(), ["prevent"]))
    }));
  }
}, Gh = /* @__PURE__ */ ge(dk, [["__scopeId", "data-v-a5726d35"]]);
function Zi(t = "", e = "") {
  const n = Ct(new Date(t), "h:mm aaa"), a = Ct(new Date(e), "h:mm aaa");
  let i = `${n} - ${a}`;
  return n === a && (i = Ct(new Date(t), "h:mm aaa")), e || (i = n), i;
}
function ya(t = "", e = "", n = "long") {
  const a = Ct(new Date(t), "MMMM d, Y"), i = Ct(new Date(e), "MMMM d, Y");
  let r = `${a} - ${i}`;
  if (a === i && (r = Ct(new Date(t), "MMMM d, Y")), e || (r = a), n === "short" || n === "shortWithYear") {
    const s = r.slice(0, 3), o = r.split(" ").slice(1).join(" ");
    if (e && e !== t) {
      const l = Ct(new Date(t), "MMM d"), c = Ct(new Date(e), "MMM d");
      if (n === "shortWithYear") {
        const u = Ct(new Date(e), "MMM d, Y");
        return `${l} - ${u}`;
      }
      return `${l} - ${c}`;
    }
    return `${s} ${o}`;
  }
  return r;
}
function pa(t = "") {
  let e = "default";
  if (t == null)
    return e;
  switch (!0) {
    case t.includes("/help/"):
    case t.includes("/projects/"):
      e = "help";
      break;
    case t.includes("/about/"):
    case t.includes("/impact/"):
    case t.includes("/applicants/"):
      e = "about";
      break;
    case t.includes("/visit/"):
    case t.includes("/events-exhibits/"):
    case t.includes("/who-we-are/"):
      e = "visit";
      break;
  }
  return e;
}
function Xh(t = "") {
  return t === null || t.match(/^(http|https):\/\//) || t.startsWith("/") || (t = `/${t}`), t;
}
const hk = { class: "slot" }, fk = {
  key: 0,
  class: "breadcrumb"
}, pk = { class: "text" }, mk = {
  key: 0,
  class: "gradient"
}, gk = { class: "hatch-box" }, bk = { class: "clipped-box" }, vk = ["innerHTML"], yk = { class: "hatch" }, _k = { class: "meta" }, Tk = ["innerHTML"], xk = { key: 1 }, wk = { key: 2 }, kk = ["innerHTML"], Ck = { class: "meta-text" }, Sk = {
  key: 0,
  class: "date-created"
}, Ak = ["innerHTML"], Ek = {
  key: 1,
  class: "byline"
}, Lk = ["innerHTML"], Dk = {
  key: 3,
  class: "schedule"
}, Ik = ["innerHTML"], Mk = ["innerHTML"], Ok = {
  key: 4,
  class: "location-group"
}, Pk = {
  key: 0,
  class: "block-form-container"
}, Bk = /* @__PURE__ */ Ce({
  __name: "BannerFeatured",
  props: {
    media: {
      type: Object,
      default: () => {
      }
    },
    title: {
      type: String,
      required: !0
    },
    description: {
      type: String,
      default: ""
    },
    category: {
      type: String,
      default: ""
    },
    dateCreated: {
      type: String,
      default: ""
    },
    startDate: {
      type: String,
      default: ""
    },
    endDate: {
      type: String,
      default: ""
    },
    locations: {
      type: Array,
      default: () => []
    },
    byline: {
      type: Array,
      default: () => []
    },
    to: {
      // URL to link to, if blank won't link
      type: String,
      default: ""
    },
    breadcrumb: {
      type: String,
      default: ""
    },
    prompt: {
      // text that displays on blue button, e.g. "View exhibit". Links to `props.to`
      type: String,
      default: ""
    },
    alignRight: {
      type: Boolean,
      default: !0
    },
    ratio: {
      type: Number,
      default: 56.25
    },
    registerEvent: {
      type: Boolean,
      default: !1
    },
    titleLink: {
      type: String,
      default: ""
    },
    sectionHandle: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = t, n = I(() => {
      if (e.media && e.media.src) {
        const g = e.media.src.toLowerCase().split(".").pop();
        return g === "mp4" || g === "m4a" || g === "f4v" || g === "m4b" || g === "mov";
      } else
        return !1;
    }), a = I(() => n.value ? Wh : dn), i = I(() => n.value ? null : e.media), r = I(() => {
      if (!n.value)
        return null;
      const T = e.media;
      return {
        src: T.src,
        focalPoint: T.focalPoint,
        sizes: T.sizes,
        height: T.height,
        width: T.width,
        alt: T.alt,
        caption: T.caption,
        poster: T.poster
      };
    }), s = I(() => n.value ? r.value : i.value), o = I(() => e.ratio), l = I(() => e.locations.map((T) => ({
      ...T,
      svg: T.title === "Online" ? "svg-icon-virtual" : "svg-icon-location",
      class: T.title === "Online" ? "location-online" : "location-link",
      to: T.to != null ? Xh(T.to) : ""
    }))), c = I(() => ya(e.startDate, e.endDate)), u = I(() => Ct(new Date(e.dateCreated), "MMMM d, Y")), f = I(() => e.startDate && e.sectionHandle === "event" ? Zi(e.startDate, e.endDate) : ""), m = I(() => pa(e.to)), _ = I(() => [
      "banner-featured",
      { "hatch-left": !e.alignRight },
      `color-${m.value}`
    ]);
    return (T, g) => (h(), b("div", {
      class: re(_.value)
    }, [
      k("div", hk, [
        me(T.$slots, "default", {}, () => [
          t.breadcrumb ? (h(), b("div", fk, [
            Q(O(l2), {
              class: "heading-line",
              "aria-hidden": "true"
            }),
            k("h2", pk, ne(t.breadcrumb), 1)
          ])) : A("", !0)
        ], !0)
      ]),
      (h(), G(dt(a.value), {
        class: "media",
        media: s.value,
        "aspect-ratio": o.value
      }, {
        default: oe(() => [
          n.value ? A("", !0) : (h(), b("div", mk)),
          Q(O(r2), {
            class: "molecule",
            "aria-hidden": "true"
          })
        ]),
        _: 1
      }, 8, ["media", "aspect-ratio"])),
      k("div", gk, [
        k("div", bk, [
          t.category ? (h(), b("h2", {
            key: 0,
            class: "category category-mobile",
            innerHTML: t.category
          }, null, 8, vk)) : A("", !0)
        ]),
        k("div", yk, [
          Q(O(s2), {
            class: "svg",
            "aria-hidden": "true"
          })
        ])
      ]),
      k("div", _k, [
        t.category ? (h(), b("div", {
          key: 0,
          class: "category category-desktop",
          innerHTML: t.category
        }, null, 8, Tk)) : A("", !0),
        t.titleLink.length > 0 ? (h(), b("div", xk, [
          Q(Xe, {
            id: "banner-featured",
            to: t.titleLink,
            class: "title title-linked"
          }, {
            default: oe(() => [
              ze(ne(t.title), 1)
            ]),
            _: 1
          }, 8, ["to"])
        ])) : (h(), b("div", wk, [
          k("h3", {
            id: "banner-featured",
            class: "title",
            innerHTML: t.title
          }, null, 8, kk)
        ])),
        k("div", Ck, [
          t.dateCreated ? (h(), b("div", Sk, [
            t.dateCreated ? (h(), b("time", {
              key: 0,
              class: "date-created",
              innerHTML: u.value
            }, null, 8, Ak)) : A("", !0)
          ])) : A("", !0),
          t.byline.length ? (h(), b("div", Ek, [
            (h(!0), b(he, null, Le(t.byline, (x, S) => (h(), b("div", {
              key: `external-${S}`,
              class: "byline-item",
              innerHTML: x
            }, null, 8, Lk))), 128))
          ])) : A("", !0),
          t.description ? (h(), G(un, {
            key: 2,
            class: "description",
            "rich-text-content": t.description
          }, null, 8, ["rich-text-content"])) : A("", !0),
          t.startDate || t.endDate ? (h(), b("div", Dk, [
            t.startDate ? (h(), b("time", {
              key: 0,
              class: "schedule-item",
              innerHTML: c.value
            }, null, 8, Ik)) : A("", !0),
            f.value ? (h(), b("time", {
              key: 1,
              class: "schedule-item",
              innerHTML: f.value
            }, null, 8, Mk)) : A("", !0)
          ])) : A("", !0),
          t.locations.length ? (h(), b("div", Ok, [
            (h(!0), b(he, null, Le(l.value, (x) => (h(), G(en, {
              key: `location-${x.id}`,
              text: x.title,
              "icon-name": x.svg,
              to: x.to,
              class: re(x.class)
            }, null, 8, ["text", "icon-name", "to", "class"]))), 128))
          ])) : A("", !0)
        ]),
        t.to ? (h(), G(sn, {
          key: 3,
          id: "banner-featured-button",
          label: t.prompt,
          to: t.to,
          "aria-labelledby": "banner-featured-button banner-featured",
          class: "button"
        }, null, 8, ["label", "to"])) : A("", !0)
      ]),
      !t.to && t.registerEvent ? (h(), b("div", Pk, [
        Q(Gh)
      ])) : A("", !0)
    ], 2));
  }
}), Pm = /* @__PURE__ */ ge(Bk, [["__scopeId", "data-v-22c151a4"]]), Rk = {
  key: 0,
  class: "category"
}, Nk = ["innerHTML"], $k = { class: "hatch-box" }, Fk = { class: "hatch" }, zk = { class: "meta" }, Uk = ["innerHTML"], Hk = { class: "meta-text" }, Yk = { class: "meta-block" }, jk = {
  key: 0,
  class: "byline-item"
}, Vk = {
  key: 1,
  class: "subject-areas"
}, qk = ["innerHTML"], Wk = ["innerHTML"], Gk = ["innerHTML"], Xk = {
  key: 0,
  class: "contact-info-group"
}, Zk = {
  key: 1,
  class: "location-group"
}, Kk = {
  key: 1,
  class: "block-form-container"
}, Qk = /* @__PURE__ */ Ce({
  __name: "BannerHeader",
  props: {
    media: {
      type: Object,
      default: () => {
      }
    },
    title: {
      type: String,
      required: !0
    },
    text: {
      type: String,
      default: ""
    },
    byline: {
      type: Array,
      default: () => []
    },
    contributors: {
      type: Array,
      default: () => []
    },
    subjectAreas: {
      type: Array,
      default: () => []
    },
    dateCreated: {
      type: String,
      default: ""
    },
    startDate: {
      type: String,
      default: ""
    },
    endDate: {
      type: String,
      default: ""
    },
    locations: {
      type: Array,
      default: () => []
    },
    to: {
      // URL to link to, if blank won't link
      type: String,
      default: ""
    },
    category: {
      type: String,
      default: ""
    },
    prompt: {
      // text that displays on blue button, e.g. "View exhibit". Links to `props.to`
      type: String,
      default: ""
    },
    alignRight: {
      type: Boolean,
      default: !0
    },
    ratio: {
      type: Number,
      default: 56.25
    },
    // contact info for Location Detail Page
    email: {
      type: String,
      default: ""
    },
    phone: {
      type: String,
      default: ""
    },
    address: {
      type: String,
      default: ""
    },
    addressLink: {
      type: String,
      default: ""
    },
    staffDirectoryLink: {
      type: String,
      default: ""
    },
    isEvent: {
      type: Boolean,
      default: !1
    },
    registerEvent: {
      type: Boolean,
      default: !1
    },
    sectionHandle: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = t, n = ve(() => Promise.resolve().then(() => Ml)), a = ve(() => Promise.resolve().then(() => h2)), i = ve(() => Promise.resolve().then(() => d2)), r = ve(() => Promise.resolve().then(() => c2)), s = I(() => pa(e.to)), o = I(() => [
      "banner-header",
      { "hatch-left": !e.alignRight },
      `color-${s.value}`
    ]), l = I(() => {
      if (e.media && e.media.src) {
        const M = e.media.src.toLowerCase().split(".").pop();
        return M === "mp4" || M === "m4a" || M === "f4v" || M === "m4b" || M === "mov";
      } else
        return !1;
    }), c = I(() => l.value ? Wh : dn), u = I(() => l.value ? null : e.media), f = I(() => {
      if (!l.value)
        return null;
      const L = e.media;
      return {
        src: L.src,
        focalPoint: L.focalPoint,
        sizes: L.sizes,
        height: L.height,
        width: L.width,
        alt: L.alt,
        caption: L.caption,
        poster: L.poster
      };
    }), m = I(() => l.value ? f.value : u.value), _ = I(() => Ct(new Date(e.dateCreated), "MMMM d, Y")), T = I(() => ya(e.startDate, e.endDate)), g = I(() => e.startDate && e.sectionHandle === "event" ? Zi(e.startDate, e.endDate) : ""), x = I(() => e.ratio), S = I(() => e.category ? "gradient" : "gradient-no-category"), D = I(() => e.locations.map((L) => {
      let M = "svg-icon-location";
      return L.title === "Online" && (M = "svg-icon-virtual"), {
        ...L,
        svg: M,
        to: L.to != null ? Xh(L.to) : ""
      };
    }));
    return (L, M) => (h(), b("div", {
      class: re(o.value)
    }, [
      t.category ? (h(), b("div", Rk, [
        Q(O(r), {
          class: "heading-line",
          "aria-hidden": "true"
        }),
        k("div", {
          class: "text",
          innerHTML: t.category
        }, null, 8, Nk)
      ])) : A("", !0),
      (h(), G(dt(c.value), {
        class: "media",
        media: m.value,
        "aspect-ratio": x.value
      }, {
        default: oe(() => [
          l.value ? A("", !0) : (h(), b("div", {
            key: 0,
            class: re(S.value)
          }, null, 2)),
          Q(O(r2), {
            class: "molecule",
            "aria-hidden": "true"
          })
        ]),
        _: 1
      }, 8, ["media", "aspect-ratio"])),
      k("div", $k, [
        M[0] || (M[0] = k("div", { class: "clipped-box" }, null, -1)),
        k("div", Fk, [
          Q(O(s2), {
            class: "svg",
            "aria-hidden": "true"
          })
        ])
      ]),
      k("div", zk, [
        k("h1", {
          class: "title",
          innerHTML: t.title
        }, null, 8, Uk),
        t.text ? (h(), G(O(a), {
          key: 0,
          class: "snippet",
          "rich-text-content": t.text
        }, null, 8, ["rich-text-content"])) : A("", !0),
        Tt(k("div", Hk, [
          Tt(k("div", Yk, [
            t.byline.length ? (h(), b("div", jk, [
              (h(!0), b(he, null, Le(t.byline, (E, P) => (h(), b("div", {
                key: `${E}-${P}`,
                class: "byline-item"
              }, ne(E), 1))), 128))
            ])) : A("", !0),
            t.subjectAreas.length ? (h(), b("div", Vk, [
              (h(!0), b(he, null, Le(t.subjectAreas, (E, P) => (h(), b("div", {
                key: `${E.title}-${P}`
              }, ne(E.title), 1))), 128))
            ])) : A("", !0),
            t.dateCreated ? (h(), b("time", {
              key: 2,
              class: "date-created",
              innerHTML: _.value
            }, null, 8, qk)) : A("", !0),
            t.startDate ? (h(), b("time", {
              key: 3,
              class: "schedule-item",
              innerHTML: T.value
            }, null, 8, Wk)) : A("", !0),
            g.value ? (h(), b("time", {
              key: 4,
              class: "schedule-item",
              innerHTML: g.value
            }, null, 8, Gk)) : A("", !0)
          ], 512), [
            [
              va,
              t.byline.length || t.subjectAreas.length || t.dateCreated || t.startDate
            ]
          ]),
          t.email || t.phone || t.staffDirectoryLink || t.addressLink ? (h(), b("div", Xk, [
            t.email ? (h(), G(O(i), {
              key: 0,
              text: t.email,
              "icon-name": "svg-icon-email",
              to: `mailto:${t.email}`
            }, null, 8, ["text", "to"])) : A("", !0),
            t.phone ? (h(), G(O(i), {
              key: 1,
              text: t.phone,
              "icon-name": "svg-icon-phone",
              to: `tel:${t.phone}`
            }, null, 8, ["text", "to"])) : A("", !0),
            t.staffDirectoryLink ? (h(), G(O(i), {
              key: 2,
              text: "View staff directory",
              "icon-name": "svg-icon-person",
              to: t.staffDirectoryLink
            }, null, 8, ["to"])) : A("", !0),
            t.addressLink ? (h(), G(O(i), {
              key: 3,
              text: t.address,
              "icon-name": "svg-icon-location",
              to: t.addressLink
            }, null, 8, ["text", "to"])) : A("", !0)
          ])) : A("", !0),
          t.locations.length ? (h(), b("div", Zk, [
            (h(!0), b(he, null, Le(D.value, (E) => (h(), G(O(i), {
              key: `location-${E.id}`,
              text: E.title,
              "icon-name": E.svg,
              to: E.to
            }, null, 8, ["text", "icon-name", "to"]))), 128))
          ])) : A("", !0)
        ], 512), [
          [
            va,
            t.byline.length || t.subjectAreas.length || t.dateCreated || t.startDate || t.email || t.phone || t.staffDirectoryLink || t.addressLink
          ]
        ]),
        t.to ? (h(), G(O(n), {
          key: 1,
          label: t.prompt,
          "is-secondary": !0,
          class: "button",
          to: t.to
        }, null, 8, ["label", "to"])) : A("", !0)
      ]),
      !t.to && t.registerEvent ? (h(), b("div", Kk, [
        Q(Gh)
      ])) : A("", !0)
    ], 2));
  }
}), yhe = /* @__PURE__ */ ge(Qk, [["__scopeId", "data-v-3a64bf88"]]), Jk = { class: "banner-text" }, e9 = { class: "banner-text-content-container" }, t9 = {
  key: 0,
  class: "category"
}, n9 = ["innerHTML"], a9 = { class: "content" }, i9 = { class: "title" }, r9 = ["lang", "innerHTML"], s9 = {
  key: 1,
  class: "meta-block"
}, o9 = {
  key: 0,
  class: "byline-item"
}, l9 = {
  key: 1,
  class: "subject-areas"
}, c9 = {
  key: 2,
  class: "contact-info"
}, u9 = {
  key: 3,
  class: "contact-info"
}, d9 = {
  key: 4,
  class: "contact-info"
}, h9 = {
  key: 5,
  class: "contact-info"
}, f9 = {
  key: 6,
  class: "schedule"
}, p9 = ["innerHTML"], m9 = ["innerHTML"], g9 = ["innerHTML"], b9 = {
  key: 3,
  class: "schedule-item"
}, v9 = {
  key: 2,
  class: "location-group"
}, y9 = {
  key: 0,
  class: "block-form-container"
}, _9 = /* @__PURE__ */ Ce({
  __name: "BannerText",
  props: {
    category: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: "",
      required: !0
    },
    alternativeFullName: {
      type: String,
      default: ""
    },
    language: {
      type: String,
      default: ""
    },
    startDate: {
      type: String,
      default: ""
    },
    endDate: {
      type: String,
      default: ""
    },
    dateCreated: {
      type: String,
      default: ""
    },
    locations: {
      type: Array,
      default: () => []
    },
    isOnline: {
      type: Boolean,
      default: !1
    },
    text: {
      type: String,
      default: ""
    },
    buttonText: {
      type: String,
      default: ""
    },
    to: {
      type: String,
      default: ""
    },
    isDarkBlue: {
      type: Boolean,
      default: !1
    },
    // contact info for Location Detail Page
    email: {
      type: String,
      default: ""
    },
    phone: {
      type: String,
      default: ""
    },
    address: {
      type: String,
      default: ""
    },
    addressLink: {
      type: String,
      default: ""
    },
    staffDirectoryLink: {
      type: String,
      default: ""
    },
    articleType: {
      type: String,
      default: ""
    },
    byline: {
      type: Array,
      default: () => []
    },
    subjectAreas: {
      type: Array,
      default: () => []
    },
    registerEvent: {
      type: Boolean,
      default: !1
    },
    sectionHandle: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = t, n = ve(() => Promise.resolve().then(() => Ml)), a = ve(() => Promise.resolve().then(() => h2)), i = ve(() => Promise.resolve().then(() => d2)), r = ve(() => Promise.resolve().then(() => c2)), s = I(() => {
      let _ = ["banner-text-container", "theme-light"];
      return e.isDarkBlue && (_ = ["banner-text-container", "theme-dark"]), _;
    }), o = I(() => pa(e.to)), l = I(() => ["text", `color-${o.value}`]), c = I(() => Ct(new Date(e.dateCreated), "MMMM d, Y")), u = I(() => ya(e.startDate, e.endDate)), f = I(() => e.startDate && e.sectionHandle === "event" ? Zi(e.startDate, e.endDate) : ""), m = I(() => e.locations.map((_) => {
      let T = "svg-icon-location";
      return _.title === "Online" && (T = "svg-icon-virtual"), {
        ..._,
        svg: T,
        to: _.to != null ? Xh(_.to) : ""
      };
    }));
    return (_, T) => (h(), b("div", Jk, [
      k("div", {
        class: re(s.value)
      }, [
        k("div", e9, [
          t.category ? (h(), b("div", t9, [
            Q(O(r), {
              class: "heading-line",
              "aria-hidden": "true"
            }),
            k("div", {
              class: re(l.value),
              innerHTML: t.category
            }, null, 10, n9)
          ])) : A("", !0),
          k("div", a9, [
            k("h1", i9, [
              ze(ne(t.title) + " ", 1),
              t.alternativeFullName ? (h(), b("span", {
                key: 0,
                lang: t.language,
                class: "translation",
                innerHTML: t.alternativeFullName
              }, null, 8, r9)) : A("", !0)
            ]),
            t.text ? (h(), G(O(a), {
              key: 0,
              class: "text",
              "rich-text-content": t.text
            }, null, 8, ["rich-text-content"])) : A("", !0),
            t.byline || t.subjectAreas || t.startDate || t.phone || t.email || t.addressLink || t.staffDirectoryLink ? (h(), b("div", s9, [
              t.byline ? (h(), b("div", o9, [
                (h(!0), b(he, null, Le(t.byline, (g, x) => (h(), b("div", {
                  key: `${g}-${x}`
                }, ne(g), 1))), 128))
              ])) : A("", !0),
              t.subjectAreas ? (h(), b("div", l9, [
                (h(!0), b(he, null, Le(t.subjectAreas, (g, x) => (h(), b("div", {
                  key: `${g.title}-${x}`
                }, ne(g.title), 1))), 128))
              ])) : A("", !0),
              t.email ? (h(), b("div", c9, [
                Q(O(i), {
                  text: t.email,
                  "icon-name": "svg-icon-email",
                  to: `mailto:${t.email}`
                }, null, 8, ["text", "to"])
              ])) : A("", !0),
              t.phone ? (h(), b("div", u9, [
                Q(O(i), {
                  text: t.phone,
                  "icon-name": "svg-icon-phone",
                  to: `tel:${t.phone}`
                }, null, 8, ["text", "to"])
              ])) : A("", !0),
              t.staffDirectoryLink ? (h(), b("div", d9, [
                Q(O(i), {
                  text: "View staff directory",
                  "icon-name": "svg-icon-person",
                  to: t.staffDirectoryLink
                }, null, 8, ["to"])
              ])) : A("", !0),
              t.addressLink ? (h(), b("div", h9, [
                Q(O(i), {
                  text: t.address,
                  "icon-name": "svg-icon-location",
                  to: t.addressLink
                }, null, 8, ["text", "to"])
              ])) : A("", !0),
              t.startDate || t.dateCreated ? (h(), b("div", f9, [
                t.dateCreated ? (h(), b("time", {
                  key: 0,
                  class: "date-created",
                  innerHTML: c.value
                }, null, 8, p9)) : A("", !0),
                t.startDate ? (h(), b("time", {
                  key: 1,
                  class: "schedule-item",
                  innerHTML: u.value
                }, null, 8, m9)) : A("", !0),
                f.value ? (h(), b("time", {
                  key: 2,
                  class: "schedule-item",
                  innerHTML: f.value
                }, null, 8, g9)) : A("", !0),
                t.isOnline ? (h(), b("div", b9, " Online ")) : A("", !0)
              ])) : A("", !0)
            ])) : A("", !0),
            t.locations.length ? (h(), b("div", v9, [
              (h(!0), b(he, null, Le(m.value, (g) => (h(), G(O(i), {
                key: `location-${g.id}`,
                text: g.title,
                "icon-name": g.svg,
                to: g.to
              }, null, 8, ["text", "icon-name", "to"]))), 128))
            ])) : A("", !0),
            t.to && !t.isDarkBlue ? (h(), G(O(n), {
              key: 3,
              label: t.buttonText,
              to: t.to,
              "is-secondary": !0
            }, null, 8, ["label", "to"])) : A("", !0),
            t.to && t.isDarkBlue ? (h(), G(O(n), {
              key: 4,
              label: t.buttonText,
              to: t.to,
              "is-tertiary": !0
            }, null, 8, ["label", "to"])) : A("", !0)
          ])
        ])
      ], 2),
      !t.to && t.registerEvent ? (h(), b("div", y9, [
        Q(Gh)
      ])) : A("", !0)
    ]));
  }
}), _he = /* @__PURE__ */ ge(_9, [["__scopeId", "data-v-2a3390cd"]]), T9 = {
  width: "1000",
  height: "480",
  viewBox: "0 0 1000 480",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__molecule-placeholder"
};
function x9(t, e) {
  return h(), b("svg", T9, e[0] || (e[0] = [
    ri('<g><path d="M0.343468 256.541L86.6725 221.246L86.8143 220.911M0.343468 256.541L-88.3703 221.246M0.343468 256.541L67.1173 201.214M0.343468 256.541L-67.8612 201.214M124.829 131.101L86.6725 44.7721M124.829 131.101L86.8143 220.911M124.829 131.101L0.343468 62.4195M124.829 131.101L67.1173 201.214M86.6725 44.7721L0.343468 4.23083M86.6725 44.7721L0.343468 62.4195M0.343468 4.23083L-88.3703 44.7721M0.343468 4.23083V62.4195M-88.3703 44.7721L-125.096 131.101M-88.3703 44.7721L0.343468 62.4195M-125.096 131.101L-88.3703 221.246M-125.096 131.101L-67.8612 201.214M-125.096 131.101L0.343468 62.4195M-88.3703 221.246L-67.8612 201.214M-67.8612 201.214H67.1173M-67.8612 201.214L0.343468 62.4195M67.1173 201.214L86.8143 220.911M67.1173 201.214L0.343468 62.4195" stroke="#87FBE8" stroke-width="1.15119" class="svg__stroke--help-green-02"></path><path d="M250.268 256.541L336.597 221.246L336.739 220.911M250.268 256.541L161.555 221.246M250.268 256.541L317.042 201.214M250.268 256.541L182.064 201.214M374.754 131.101L336.597 44.7721M374.754 131.101L336.739 220.911M374.754 131.101L250.268 62.4194M374.754 131.101L317.042 201.214M336.597 44.7721L250.268 4.23081M336.597 44.7721L250.268 62.4194M250.268 4.23081L161.555 44.7721M250.268 4.23081V62.4194M161.555 44.7721L124.829 131.101M161.555 44.7721L250.268 62.4194M124.829 131.101L161.555 221.246M124.829 131.101L182.064 201.214M124.829 131.101L250.268 62.4194M161.555 221.246L182.064 201.214M182.064 201.214H317.042M182.064 201.214L250.268 62.4194M317.042 201.214L336.739 220.911M317.042 201.214L250.268 62.4194" stroke="#5CD9FF" stroke-width="1.15119" class="svg__stroke--default-cyan-02"></path><path d="M500.193 256.541L586.522 221.246L586.664 220.911M500.193 256.541L411.48 221.246M500.193 256.541L566.967 201.214M500.193 256.541L431.989 201.214M624.679 131.101L586.522 44.7721M624.679 131.101L586.664 220.911M624.679 131.101L500.193 62.4195M624.679 131.101L566.967 201.214M586.522 44.7721L500.193 4.23083M586.522 44.7721L500.193 62.4195M500.193 4.23083L411.48 44.7721M500.193 4.23083V62.4195M411.48 44.7721L374.754 131.101M411.48 44.7721L500.193 62.4195M374.754 131.101L411.48 221.246M374.754 131.101L431.989 201.214M374.754 131.101L500.193 62.4195M411.48 221.246L431.989 201.214M431.989 201.214H566.967M431.989 201.214L500.193 62.4195M566.967 201.214L586.664 220.911M566.967 201.214L500.193 62.4195" stroke="#87FBE8" stroke-width="1.15119" class="svg__stroke--help-green-02"></path><path d="M750.118 256.541L836.447 221.246L836.589 220.911M750.118 256.541L661.404 221.246M750.118 256.541L816.892 201.214M750.118 256.541L681.914 201.214M874.604 131.101L836.447 44.7721M874.604 131.101L836.589 220.911M874.604 131.101L750.118 62.4195M874.604 131.101L816.892 201.214M836.447 44.7721L750.118 4.23083M836.447 44.7721L750.118 62.4195M750.118 4.23083L661.404 44.7721M750.118 4.23083V62.4195M661.404 44.7721L624.679 131.101M661.404 44.7721L750.118 62.4195M624.679 131.101L661.404 221.246M624.679 131.101L681.914 201.214M624.679 131.101L750.118 62.4195M661.404 221.246L681.914 201.214M681.914 201.214H816.892M681.914 201.214L750.118 62.4195M816.892 201.214L836.589 220.911M816.892 201.214L750.118 62.4195" stroke="#5CD9FF" stroke-width="1.15119" class="svg__stroke--default-cyan-02"></path><path d="M1000.04 256.541L1086.37 221.246L1086.51 220.911M1000.04 256.541L911.329 221.246M1000.04 256.541L1066.82 201.214M1000.04 256.541L931.838 201.214M1124.53 131.101L1086.37 44.7721M1124.53 131.101L1086.51 220.911M1124.53 131.101L1000.04 62.4195M1124.53 131.101L1066.82 201.214M1086.37 44.7721L1000.04 4.23083M1086.37 44.7721L1000.04 62.4195M1000.04 4.23083L911.329 44.7721M1000.04 4.23083V62.4195M911.329 44.7721L874.604 131.101M911.329 44.7721L1000.04 62.4195M874.604 131.101L911.329 221.246M874.604 131.101L931.838 201.214M874.604 131.101L1000.04 62.4195M911.329 221.246L931.838 201.214M931.838 201.214H1066.82M931.838 201.214L1000.04 62.4195M1066.82 201.214L1086.51 220.911M1066.82 201.214L1000.04 62.4195" stroke="#87FBE8" stroke-width="1.15119" class="svg__stroke--help-green-02"></path><path d="M125.439 478.919L211.768 443.625L211.91 443.289M125.439 478.919L36.7256 443.625M125.439 478.919L192.213 423.592M125.439 478.919L57.2347 423.592M249.925 353.48L211.768 267.151M249.925 353.48L211.91 443.289M249.925 353.48L125.439 284.798M249.925 353.48L192.213 423.592M211.768 267.151L125.439 226.61M211.768 267.151L125.439 284.798M125.439 226.61L36.7256 267.151M125.439 226.61V284.798M36.7256 267.151L0 353.48M36.7256 267.151L125.439 284.798M0 353.48L36.7256 443.625M0 353.48L57.2347 423.592M0 353.48L125.439 284.798M36.7256 443.625L57.2347 423.592M57.2347 423.592H192.213M57.2347 423.592L125.439 284.798M192.213 423.592L211.91 443.289M192.213 423.592L125.439 284.798" stroke="#E7DBFF" stroke-width="1.15119" class="svg__stroke--about-purple-02"></path><path d="M375.364 478.919L461.693 443.625L461.835 443.289M375.364 478.919L286.65 443.625M375.364 478.919L442.138 423.592M375.364 478.919L307.16 423.592M499.85 353.48L461.693 267.151M499.85 353.48L461.835 443.289M499.85 353.48L375.364 284.798M499.85 353.48L442.138 423.592M461.693 267.151L375.364 226.61M461.693 267.151L375.364 284.798M375.364 226.61L286.65 267.151M375.364 226.61V284.798M286.65 267.151L249.925 353.48M286.65 267.151L375.364 284.798M249.925 353.48L286.65 443.625M249.925 353.48L307.16 423.592M249.925 353.48L375.364 284.798M286.65 443.625L307.16 423.592M307.16 423.592H442.138M307.16 423.592L375.364 284.798M442.138 423.592L461.835 443.289M442.138 423.592L375.364 284.798" stroke="#FFBDF4" stroke-width="1.15119" class="svg__stroke--visit-fushia-02"></path><path d="M625.289 478.919L711.618 443.625L711.76 443.289M625.289 478.919L536.575 443.625M625.289 478.919L692.063 423.592M625.289 478.919L557.085 423.592M749.775 353.48L711.618 267.151M749.775 353.48L711.76 443.289M749.775 353.48L625.289 284.798M749.775 353.48L692.063 423.592M711.618 267.151L625.289 226.61M711.618 267.151L625.289 284.798M625.289 226.61L536.575 267.151M625.289 226.61V284.798M536.575 267.151L499.85 353.48M536.575 267.151L625.289 284.798M499.85 353.48L536.575 443.625M499.85 353.48L557.085 423.592M499.85 353.48L625.289 284.798M536.575 443.625L557.085 423.592M557.085 423.592H692.063M557.085 423.592L625.289 284.798M692.063 423.592L711.76 443.289M692.063 423.592L625.289 284.798" stroke="#E7DBFF" stroke-width="1.15119" class="svg__stroke--about-purple-02"></path><path d="M875.214 478.919L961.543 443.625L961.685 443.289M875.214 478.919L786.5 443.625M875.214 478.919L941.988 423.592M875.214 478.919L807.009 423.592M999.7 353.48L961.543 267.151M999.7 353.48L961.685 443.289M999.7 353.48L875.214 284.798M999.7 353.48L941.988 423.592M961.543 267.151L875.214 226.61M961.543 267.151L875.214 284.798M875.214 226.61L786.5 267.151M875.214 226.61V284.798M786.5 267.151L749.775 353.48M786.5 267.151L875.214 284.798M749.775 353.48L786.5 443.625M749.775 353.48L807.009 423.592M749.775 353.48L875.214 284.798M786.5 443.625L807.009 423.592M807.009 423.592H941.988M807.009 423.592L875.214 284.798M941.988 423.592L961.685 443.289M941.988 423.592L875.214 284.798" stroke="#FFBDF4" stroke-width="1.15119" class="svg__stroke--visit-fushia-02"></path></g>', 1)
  ]));
}
const Js = { render: x9 }, w9 = {
  key: 0,
  class: "linked-category"
}, k9 = ["innerHTML"], C9 = {
  key: 2,
  class: "custom-title"
}, S9 = ["lang", "innerHTML"], A9 = ["innerHTML"], E9 = {
  key: 5,
  class: "custom-description"
}, L9 = {
  key: 7,
  class: "byline-group"
}, D9 = ["innerHTML"], I9 = ["innerHTML"], M9 = {
  key: 2,
  class: "schedule-item date-created"
}, O9 = {
  key: 8,
  class: "date-time"
}, P9 = {
  key: 0,
  class: "ongoing-item"
}, B9 = ["innerHTML"], R9 = ["innerHTML"], N9 = {
  key: 9,
  class: "location-group"
}, $9 = {
  key: 10,
  class: "block-tags"
}, F9 = { class: "sharebutton-slot" }, z9 = { class: "floating-slot" }, U9 = /* @__PURE__ */ Ce({
  __name: "CardMeta",
  props: {
    to: {
      type: String,
      default: ""
    },
    // the data is often an array that needs to be combined on the page into one string
    category: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    alternativeFullName: {
      type: String,
      default: ""
    },
    language: {
      type: String,
      default: ""
    },
    startDate: {
      type: String,
      default: ""
    },
    endDate: {
      type: String,
      default: ""
    },
    // often used to display date article was published
    // will be styled or formatted differently than startDate & endDate
    dateCreated: {
      type: String,
      required: !1
    },
    // long single date = 'Febuary 1, 2022', short = 'Feb 1, 2022
    // long date range =  'Febuary 1, 2022 - Febuary 2, 2022', short = 'Feb 1 - Feb 2'
    dateFormat: {
      type: String,
      default: "long"
    },
    ongoing: {
      type: Boolean,
      default: !1
    },
    locations: {
      type: Array,
      default: () => []
    },
    text: {
      type: String,
      default: ""
    },
    bylineOne: {
      type: String,
      default: ""
    },
    bylineTwo: {
      type: String,
      default: ""
    },
    sectionHandle: {
      type: String,
      default: ""
    },
    tagLabels: {
      type: Array,
      default: () => []
    },
    introduction: {
      type: String,
      default: ""
    },
    guestSpeaker: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = t, n = ve(() => Promise.resolve().then(() => m2)), a = Yn(), i = qe(), r = I(() => !!(a !== void 0 && a.path.includes("impact"))), s = I(() => r.value ? "_blank" : ""), o = I(() => e.startDate ? e.sectionHandle === "ftvaEvent" ? ya(e.startDate, e.startDate, e.dateFormat) : e.endDate ? ya(e.startDate, e.endDate, e.dateFormat) : ya(e.startDate, e.startDate, e.dateFormat) : ""), l = I(() => e.dateCreated ? Ct(new Date(e.dateCreated), "MMMM d, yyyy") : ""), c = I(() => e.startDate && e.sectionHandle === "event" ? Zi(e.startDate, e.endDate) : e.startDate && e.sectionHandle !== "ftvaEventSeries" && (i == null ? void 0 : i.value) === "ftva" ? e.endDate ? Zi(e.startDate, e.endDate) : Zi(e.startDate, e.startDate) : e.startDate && e.sectionHandle === "ftvaEventSeries" ? Ct(new Date(e.startDate), "h:mm aaa") : ""), u = I(() => e.locations.map((m) => {
      let _ = "svg-icon-location";
      return m.title === "Online" && (_ = "svg-icon-virtual"), {
        ...m,
        svg: _,
        to: m.to != null ? `/${m.to}` : ""
      };
    })), f = I(() => ["card-meta", (i == null ? void 0 : i.value) || "", e.sectionHandle]);
    return (m, _) => (h(), b("div", {
      class: re(f.value)
    }, [
      m.$slots.linkedcategoryslot ? (h(), b("div", w9, [
        me(m.$slots, "linkedcategoryslot", {}, void 0, !0)
      ])) : A("", !0),
      t.category ? (h(), b("div", {
        key: 1,
        class: "category",
        innerHTML: t.category
      }, null, 8, k9)) : A("", !0),
      m.$slots.customTitle && !t.to && !t.title ? (h(), b("h3", C9, [
        me(m.$slots, "customTitle", {}, void 0, !0)
      ])) : t.to && t.title && !m.$slots.customTitle ? (h(), G(Xe, {
        key: 3,
        "link-target": s.value,
        to: t.to,
        class: "title"
      }, {
        default: oe(() => [
          ze(ne(t.title) + " ", 1),
          t.alternativeFullName ? (h(), b("span", {
            key: 0,
            lang: t.language,
            class: "translation",
            innerHTML: t.alternativeFullName
          }, null, 8, S9)) : A("", !0)
        ]),
        _: 1
      }, 8, ["link-target", "to"])) : (h(), b("h3", {
        key: 4,
        class: "title-no-link",
        innerHTML: t.title
      }, null, 8, A9)),
      m.$slots.customDescription ? (h(), b("p", E9, [
        me(m.$slots, "customDescription", {}, void 0, !0)
      ])) : A("", !0),
      t.guestSpeaker ? (h(), G(un, {
        key: 6,
        class: "guestSpeaker",
        "rich-text-content": t.guestSpeaker
      }, null, 8, ["rich-text-content"])) : A("", !0),
      t.bylineOne || t.bylineTwo || t.dateCreated ? (h(), b("div", L9, [
        t.bylineOne ? (h(), b("div", {
          key: 0,
          class: "schedule-item",
          innerHTML: t.bylineOne
        }, null, 8, D9)) : A("", !0),
        t.bylineTwo ? (h(), b("div", {
          key: 1,
          class: "schedule-item",
          innerHTML: t.bylineTwo
        }, null, 8, I9)) : A("", !0),
        t.dateCreated ? (h(), b("div", M9, ne(l.value), 1)) : A("", !0)
      ])) : A("", !0),
      t.startDate || t.ongoing ? (h(), b("div", O9, [
        t.ongoing ? (h(), b("div", P9, " Ongoing ")) : A("", !0),
        t.startDate ? (h(), b("time", {
          key: 1,
          class: "schedule-item start-date",
          innerHTML: o.value
        }, null, 8, B9)) : A("", !0),
        t.startDate && t.sectionHandle !== "ftvaEventSeries" ? (h(), b("time", {
          key: 2,
          class: "schedule-item parsed-time",
          innerHTML: c.value
        }, null, 8, R9)) : A("", !0)
      ])) : A("", !0),
      t.locations.length ? (h(), b("div", N9, [
        (h(!0), b(he, null, Le(u.value, (T, g) => (h(), G(en, {
          key: `location-card-meta${g}`,
          text: T.title,
          "icon-name": T.svg,
          to: T.to
        }, null, 8, ["text", "icon-name", "to"]))), 128))
      ])) : A("", !0),
      t.tagLabels && t.tagLabels.length > 0 ? (h(), b("div", $9, [
        (h(!0), b(he, null, Le(t.tagLabels, (T) => (h(), G(O(n), {
          key: `tag-${T.title}`,
          label: T.title,
          class: "tag-label"
        }, null, 8, ["label"]))), 128))
      ])) : A("", !0),
      t.introduction ? (h(), G(un, {
        key: 11,
        class: "introduction",
        "rich-text-content": t.introduction
      }, null, 8, ["rich-text-content"])) : A("", !0),
      k("div", F9, [
        me(m.$slots, "sharebutton", {}, void 0, !0)
      ]),
      k("div", z9, [
        me(m.$slots, "floatingslot", {}, void 0, !0)
      ]),
      t.text ? (h(), G(un, {
        key: 12,
        class: "text",
        "rich-text-content": t.text
      }, null, 8, ["rich-text-content"])) : A("", !0)
    ], 2));
  }
}), Uu = /* @__PURE__ */ ge(U9, [["__scopeId", "data-v-a3a00691"]]), H9 = { class: "image-container" }, Y9 = {
  key: 1,
  class: "molecule-no-image"
}, j9 = /* @__PURE__ */ Ce({
  __name: "BlockCardWithImage",
  props: {
    image: {
      type: Object,
      default: () => {
      }
    },
    to: {
      type: String,
      default: ""
    },
    category: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    alternativeFullName: {
      type: String,
      default: ""
    },
    language: {
      type: String,
      default: ""
    },
    startDate: {
      type: String,
      default: ""
    },
    endDate: {
      type: String,
      default: ""
    },
    ongoing: {
      type: Boolean,
      default: !1
    },
    isVertical: {
      type: Boolean,
      default: !0
    },
    imageAspectRatio: {
      type: Number,
      default: 0
    },
    locations: {
      type: Array,
      default: () => []
    },
    text: {
      type: String,
      default: ""
    },
    bylineOne: {
      type: String,
      default: ""
    },
    bylineTwo: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: ""
    },
    sectionHandle: {
      type: String,
      default: ""
    },
    cardIsLink: {
      type: Boolean,
      default: !1
      // If this is true, make entire card clickable instead of just title
    },
    dateCreated: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = t, n = Qs();
    function a() {
      e.cardIsLink && e.to && n.push({
        path: e.to
      });
    }
    const i = qe(), r = I(() => [
      "block-highlight",
      // legacy name already used in library-website-nuxt and MEAP styles, do not change
      { "is-vertical": e.isVertical },
      (i == null ? void 0 : i.value) || "",
      e.color
    ]), s = I(() => (i == null ? void 0 : i.value) === "ftva" ? "short" : "long");
    return (o, l) => (h(), b("li", {
      class: re(r.value),
      onClick: a
    }, [
      k("div", H9, [
        t.image ? (h(), G(dn, {
          key: 0,
          media: t.image,
          "aspect-ratio": t.imageAspectRatio,
          class: "image"
        }, an({ _: 2 }, [
          o.$slots.toptext ? {
            name: "toptext",
            fn: oe(() => [
              me(o.$slots, "toptext", {}, void 0, !0)
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["media", "aspect-ratio"])) : (h(), b("div", Y9, [
          Q(O(Js), {
            class: "molecule",
            "aria-hidden": "true"
          })
        ]))
      ]),
      Q(Uu, {
        class: "card-meta-items",
        to: t.to,
        category: t.category,
        title: t.title,
        "start-date": t.startDate,
        "end-date": t.endDate,
        "date-format": s.value,
        ongoing: t.ongoing,
        text: t.text,
        "byline-one": t.bylineOne,
        "byline-two": t.bylineTwo,
        locations: t.locations,
        "alternative-full-name": t.alternativeFullName,
        language: t.language,
        "section-handle": t.sectionHandle,
        "date-created": t.dateCreated
      }, an({ _: 2 }, [
        o.$slots.customTitle ? {
          name: "customTitle",
          fn: oe(() => [
            me(o.$slots, "customTitle", {}, void 0, !0)
          ]),
          key: "0"
        } : void 0,
        o.$slots.customDescription ? {
          name: "customDescription",
          fn: oe(() => [
            me(o.$slots, "customDescription", {}, void 0, !0)
          ]),
          key: "1"
        } : void 0
      ]), 1032, ["to", "category", "title", "start-date", "end-date", "date-format", "ongoing", "text", "byline-one", "byline-two", "locations", "alternative-full-name", "language", "section-handle", "date-created"])
    ], 2));
  }
}), Zh = /* @__PURE__ */ ge(j9, [["__scopeId", "data-v-f993bb7c"]]), V9 = {
  width: "20",
  height: "21",
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-ftva-calendar"
};
function q9(t, e) {
  return h(), b("svg", V9, e[0] || (e[0] = [
    k("path", {
      d: "M7 0.5V2.5H13V0.5H15V2.5H19C19.2652 2.5 19.5196 2.60536 19.7071 2.79289C19.8946 2.98043 20 3.23478 20 3.5V19.5C20 19.7652 19.8946 20.0196 19.7071 20.2071C19.5196 20.3946 19.2652 20.5 19 20.5H1C0.734784 20.5 0.48043 20.3946 0.292893 20.2071C0.105357 20.0196 0 19.7652 0 19.5V3.5C0 3.23478 0.105357 2.98043 0.292893 2.79289C0.48043 2.60536 0.734784 2.5 1 2.5H5V0.5H7ZM18 10.5H2V18.5H18V10.5ZM5 4.5H2V8.5H18V4.5H15V6.5H13V4.5H7V6.5H5V4.5Z",
      fill: "#115DAF",
      class: "svg__fill--accent-blue"
    }, null, -1)
  ]));
}
const zc = { render: q9 }, W9 = {
  width: "16",
  height: "22",
  viewBox: "0 0 16 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-ftva-location"
};
function G9(t, e) {
  return h(), b("svg", W9, e[0] || (e[0] = [
    k("path", {
      d: "M8.00005 10.45C7.2707 10.45 6.57123 10.1603 6.05551 9.64454C5.53978 9.12882 5.25005 8.42935 5.25005 7.7C5.25005 6.97065 5.53978 6.27118 6.05551 5.75546C6.57123 5.23973 7.2707 4.95 8.00005 4.95C8.72939 4.95 9.42887 5.23973 9.94459 5.75546C10.4603 6.27118 10.75 6.97065 10.75 7.7C10.75 8.06114 10.6789 8.41873 10.5407 8.75238C10.4025 9.08603 10.2 9.38918 9.94459 9.64454C9.68923 9.89991 9.38607 10.1025 9.05243 10.2407C8.71878 10.3789 8.36118 10.45 8.00005 10.45ZM8.00005 0C5.95788 0 3.99936 0.811248 2.55533 2.25528C1.1113 3.69931 0.300049 5.65783 0.300049 7.7C0.300049 13.475 8.00005 22 8.00005 22C8.00005 22 15.7 13.475 15.7 7.7C15.7 5.65783 14.8888 3.69931 13.4448 2.25528C12.0007 0.811248 10.0422 0 8.00005 0Z",
      fill: "#115DAF",
      class: "svg__fill--accent-blue"
    }, null, -1)
  ]));
}
const X9 = { render: G9 }, Z9 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-ftva-clock"
};
function K9(t, e) {
  return h(), b("svg", Z9, e[0] || (e[0] = [
    k("path", {
      d: "M10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0ZM10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10C2 12.1217 2.84285 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2ZM10 4C10.2449 4.00003 10.4813 4.08996 10.6644 4.25272C10.8474 4.41547 10.9643 4.63975 10.993 4.883L11 5V9.586L13.707 12.293C13.8863 12.473 13.9905 12.7144 13.9982 12.9684C14.006 13.2223 13.9168 13.4697 13.7488 13.6603C13.5807 13.8508 13.3464 13.9703 13.0935 13.9944C12.8406 14.0185 12.588 13.9454 12.387 13.79L12.293 13.707L9.293 10.707C9.13758 10.5514 9.03776 10.349 9.009 10.131L9 10V5C9 4.73478 9.10536 4.48043 9.29289 4.29289C9.48043 4.10536 9.73478 4 10 4Z",
      fill: "#115DAF",
      class: "svg__fill--accent-blue"
    }, null, -1)
  ]));
}
const Q9 = { render: K9 }, J9 = { class: "event-list date" }, e6 = {
  key: 0,
  class: "event-list time"
}, t6 = {
  key: 1,
  class: "event-list location"
}, n6 = { key: 0 }, a6 = { key: 1 }, i6 = {
  key: 2,
  class: "locations-wrapper"
}, r6 = /* @__PURE__ */ Ce({
  __name: "BlockEventDetail",
  props: {
    startDate: {
      type: String,
      required: !1
    },
    endDate: {
      type: String,
      required: !1
    },
    // Implied this is the start time
    time: {
      type: String,
      required: !1
    },
    ongoing: {
      type: Boolean,
      default: !1
    },
    locations: {
      type: Array,
      default: () => []
    }
  },
  setup(t) {
    const e = qe(), n = I(() => ["block-event-detail", (e == null ? void 0 : e.value) || ""]), a = I(() => {
      switch (e == null ? void 0 : e.value) {
        case "ftva":
          return {
            multiLocationMsgDisplay: !0
          };
        default:
          return {
            multiLocationMsgDisplay: !1
          };
      }
    }), i = I(() => (e == null ? void 0 : e.value) === "ftva" ? "_blank" : ""), r = I(() => t.ongoing ? "Ongoing" : t.endDate ? ya(t.startDate, t.endDate, "shortWithYear") : t.startDate ? ya(t.startDate, t.startDate) : null);
    return (s, o) => {
      var l, c;
      return h(), b("div", {
        class: re(n.value)
      }, [
        k("div", J9, [
          k("span", null, [
            t.startDate ? (h(), G(O(zc), {
              key: 0,
              class: "row-icon"
            })) : A("", !0),
            ze(" " + ne(r.value), 1)
          ])
        ]),
        t.time ? (h(), b("div", e6, [
          k("span", null, [
            Q(O(Q9), { class: "row-icon" }),
            ze(" " + ne(O(Zi)(t.time, t.time)), 1)
          ])
        ])) : A("", !0),
        t.locations && t.locations.length > 0 ? (h(), b("div", t6, [
          k("span", null, [
            Q(O(X9), { class: "row-icon" }),
            (l = a.value) != null && l.multiLocationMsgDisplay && t.locations.length > 1 ? (h(), b("span", n6, " Multiple Locations ")) : (c = a.value) != null && c.multiLocationMsgDisplay && t.locations.length === 1 ? (h(), b("span", a6, [
              Q(Xe, {
                to: t.locations[0].publicUrl,
                "link-target": i.value
              }, {
                default: oe(() => [
                  ze(ne(t.locations[0].title), 1)
                ]),
                _: 1
              }, 8, ["to", "link-target"])
            ])) : (h(), b("span", i6, [
              (h(!0), b(he, null, Le(t.locations, (u, f) => (h(), b("span", {
                key: u.title,
                class: "location-link"
              }, [
                Q(Xe, {
                  to: u.url,
                  "link-target": i.value
                }, {
                  default: oe(() => [
                    ze(ne(u.title), 1)
                  ]),
                  _: 2
                }, 1032, ["to", "link-target"]),
                ze(" " + ne(f < t.locations.length - 1 ? ", " : ""), 1)
              ]))), 128))
            ]))
          ])
        ])) : A("", !0),
        me(s.$slots, "default", {}, void 0, !0)
      ], 2);
    };
  }
}), s6 = /* @__PURE__ */ ge(r6, [["__scopeId", "data-v-fed1c998"]]), o6 = ["innerHTML"], l6 = /* @__PURE__ */ Ce({
  __name: "BlockTag",
  props: {
    label: {
      type: String,
      default: ""
      // Text displayed on the tag or pill.
    },
    iconName: {
      type: String,
      required: !1
    },
    isSecondary: {
      type: Boolean,
      default: !1
    },
    isHighlighted: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    const e = qe(), n = ve(
      () => import("./icon-ftva-guest-BuhDVhJD.js")
    ), a = ve(
      () => import("./icon-ftva-film-DEEfKF7_.js")
    ), i = ve(
      () => import("./icon-ftva-tv-Bij4Z7mQ.js")
    ), r = ve(
      () => import("./icon-ftva-filmreel-D6Tayg6b.js")
    ), s = ve(
      () => import("./icon-ftva-digitalformat-BOpmYHa_.js")
    ), o = ve(
      () => import("./icon-ftva-online-BghTAXGW.js")
    ), l = ve(
      () => import("./icon-ftva-familyfriendly-c2muBjxC.js")
    ), c = {
      SvgIconGuest: n,
      SvgIconFilm: a,
      SvgIconTV: i,
      SvgIconFilmreel: r,
      SvgIconDigital: s,
      SvgIconOnline: o,
      SvgIconFamilyFriendly: l
    }, u = I(() => ["block-tag", (e == null ? void 0 : e.value) || "", t.isSecondary ? "" : "primary", t.isHighlighted ? "highlighted" : ""]);
    return (f, m) => (h(), b("span", {
      class: re(u.value)
    }, [
      t.iconName ? (h(), G(dt(c[t.iconName]), {
        key: 0,
        class: "svg",
        "aria-hidden": "true"
      })) : A("", !0),
      k("div", {
        class: "label",
        innerHTML: t.label
      }, null, 8, o6),
      me(f.$slots, "default", {}, void 0, !0)
    ], 2));
  }
}), eo = /* @__PURE__ */ ge(l6, [["__scopeId", "data-v-19e50dad"]]), m2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: eo
}, Symbol.toStringTag, { value: "Module" })), c6 = { class: "calendar-wrapper" }, u6 = ["onClick"], d6 = { class: "calendar-event-title" }, h6 = { class: "calendar-event-time" }, f6 = {
  key: 0,
  class: "calendar-event-popup-wrapper"
}, p6 = { class: "block-tag-wrapper" }, m6 = {
  key: 1,
  class: "calendar-slot-wrapper"
}, The = /* @__PURE__ */ Ce({
  __name: "BaseCalendar",
  props: {
    defaultEventCalendar: {
      type: Boolean,
      default: !0
      // True: Default calendar with fixed components
      // False: Minimal calendar or with custom components
    },
    events: {
      type: Array,
      default: () => []
    },
    firstEventMonth: {
      type: Array,
      default: () => [/* @__PURE__ */ new Date()]
      // Sets calendar to month of earliest event
      // Default: Calendar opens to month of current date
    }
  },
  setup(t) {
    const e = I4("calendar"), n = K(t.firstEventMonth), a = K({}), i = K({}), r = K(null);
    st(() => {
      s(), window.addEventListener("click", o);
    });
    function s() {
      var x, S;
      const _ = (x = e.value) == null ? void 0 : x.querySelectorAll(".v-calendar-weekly__head-weekday-with-weeknumber"), T = (S = e.value) == null ? void 0 : S.querySelector(".v-calendar-header__today .v-btn__content"), g = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
      _ == null || _.forEach((D, L) => D.innerText = g[L]), T.innerText = "This Month";
    }
    function o() {
      r.value && r.value.classList.remove("selected-event");
    }
    const l = I(() => t.events.length === 0 ? [] : t.events.map((T) => {
      var x, S;
      const g = T.startDateWithTime;
      return {
        // Required object keys for Vuetify calendar
        title: T.title,
        start: new Date(g),
        end: new Date(g),
        time: c(g),
        // All other event data
        id: T.id,
        startDateWithTime: T.startDateWithTime,
        tagLabels: (x = T.ftvaEventScreeningDetails[0]) == null ? void 0 : x.tagLabels,
        image: (S = T.imageCarousel[0]) == null ? void 0 : S.image[0],
        location: T.location,
        to: T.to
      };
    }));
    function c(_) {
      return Ct(new Date(_), "h:mm aaa").toUpperCase();
    }
    function u(_) {
      var g;
      o(), i.value = _;
      const T = a.value[`item-${_.id}`];
      r.value = T, (g = r.value) == null || g.classList.add("selected-event");
    }
    Ks(() => {
      window.removeEventListener("click", o);
    });
    const f = qe(), m = I(() => ["base-calendar", (f == null ? void 0 : f.value) || ""]);
    return (_, T) => {
      const g = lt("v-list-item"), x = lt("v-list"), S = lt("v-card"), D = lt("v-menu"), L = lt("v-calendar"), M = lt("v-sheet"), E = M4("ripple");
      return h(), b("div", {
        ref: "calendar",
        class: re(m.value)
      }, [
        k("div", c6, [
          Q(M, { class: "calendar-body" }, {
            default: oe(() => [
              Q(L, {
                modelValue: n.value,
                "onUpdate:modelValue": T[0] || (T[0] = (P) => n.value = P),
                events: l.value,
                "view-mode": "month"
              }, {
                event: oe((P) => [
                  k("button", {
                    ref: (B) => {
                      a.value[`item-${P.event.id}`] = B;
                    },
                    class: "calendar-event-item",
                    onClick: (B) => u(P.event)
                  }, [
                    k("span", d6, ne(P.event.title), 1),
                    k("span", h6, ne(P.event.time), 1),
                    Q(D, {
                      activator: "parent",
                      "open-on-click": !0,
                      "close-on-content-click": !1,
                      location: "start bottom",
                      origin: "auto",
                      offset: "10",
                      opacity: "0"
                    }, {
                      default: oe(() => [
                        Tt((h(), G(S, {
                          width: "320",
                          style: { overflow: "hidden", "z-index": "initial" },
                          hover: !1,
                          link: !0,
                          to: i.value.to,
                          variant: "text"
                        }, {
                          default: oe(() => [
                            t.defaultEventCalendar ? (h(), b("div", f6, [
                              Q(Zh, {
                                image: i.value.image,
                                title: i.value.title
                              }, null, 8, ["image", "title"]),
                              k("div", p6, [
                                (h(!0), b(he, null, Le(i.value.tagLabels, (B) => (h(), G(eo, {
                                  key: `tag-${B.title}`,
                                  label: B.title,
                                  "is-secondary": !0,
                                  "is-highlighted": B.isHighlighted ? B.isHighlighted : !1,
                                  class: re({ highlighted: B.isHighlighted })
                                }, null, 8, ["label", "is-highlighted", "class"]))), 128))
                              ]),
                              Q(s6, {
                                "start-date": i.value.startDateWithTime,
                                time: i.value.startDateWithTime,
                                locations: i.value.location
                              }, null, 8, ["start-date", "time", "locations"])
                            ])) : _.$slots.calendarSlotComponent ? (h(), b("div", m6, [
                              me(_.$slots, "calendarSlotComponent", { event: i.value })
                            ])) : (h(), G(x, { key: 2 }, {
                              default: oe(() => [
                                Q(g, {
                                  title: i.value.title
                                }, null, 8, ["title"])
                              ]),
                              _: 1
                            }))
                          ]),
                          _: 3
                        }, 8, ["to"])), [
                          [E, !1]
                        ])
                      ]),
                      _: 3
                    })
                  ], 8, u6)
                ]),
                _: 3
              }, 8, ["modelValue", "events"])
            ]),
            _: 3
          })
        ])
      ], 2);
    };
  }
});
var Gi = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ka(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function g6(t) {
  if (t.__esModule) return t;
  var e = t.default;
  if (typeof e == "function") {
    var n = function a() {
      return this instanceof a ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    n.prototype = e.prototype;
  } else n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(t).forEach(function(a) {
    var i = Object.getOwnPropertyDescriptor(t, a);
    Object.defineProperty(n, a, i.get ? i : {
      enumerable: !0,
      get: function() {
        return t[a];
      }
    });
  }), n;
}
var b6 = typeof Gi == "object" && Gi && Gi.Object === Object && Gi, g2 = b6, v6 = g2, y6 = typeof self == "object" && self && self.Object === Object && self, _6 = v6 || y6 || Function("return this")(), oi = _6, T6 = oi, x6 = T6.Symbol, Ol = x6, Bm = Ol, b2 = Object.prototype, w6 = b2.hasOwnProperty, k6 = b2.toString, Fo = Bm ? Bm.toStringTag : void 0;
function C6(t) {
  var e = w6.call(t, Fo), n = t[Fo];
  try {
    t[Fo] = void 0;
    var a = !0;
  } catch {
  }
  var i = k6.call(t);
  return a && (e ? t[Fo] = n : delete t[Fo]), i;
}
var S6 = C6, A6 = Object.prototype, E6 = A6.toString;
function L6(t) {
  return E6.call(t);
}
var D6 = L6, Rm = Ol, I6 = S6, M6 = D6, O6 = "[object Null]", P6 = "[object Undefined]", Nm = Rm ? Rm.toStringTag : void 0;
function B6(t) {
  return t == null ? t === void 0 ? P6 : O6 : Nm && Nm in Object(t) ? I6(t) : M6(t);
}
var Ur = B6;
function R6(t) {
  var e = typeof t;
  return t != null && (e == "object" || e == "function");
}
var Hr = R6, N6 = Ur, $6 = Hr, F6 = "[object AsyncFunction]", z6 = "[object Function]", U6 = "[object GeneratorFunction]", H6 = "[object Proxy]";
function Y6(t) {
  if (!$6(t))
    return !1;
  var e = N6(t);
  return e == z6 || e == U6 || e == F6 || e == H6;
}
var v2 = Y6, j6 = oi, V6 = j6["__core-js_shared__"], q6 = V6, Qd = q6, $m = function() {
  var t = /[^.]+$/.exec(Qd && Qd.keys && Qd.keys.IE_PROTO || "");
  return t ? "Symbol(src)_1." + t : "";
}();
function W6(t) {
  return !!$m && $m in t;
}
var G6 = W6, X6 = Function.prototype, Z6 = X6.toString;
function K6(t) {
  if (t != null) {
    try {
      return Z6.call(t);
    } catch {
    }
    try {
      return t + "";
    } catch {
    }
  }
  return "";
}
var y2 = K6, Q6 = v2, J6 = G6, e7 = Hr, t7 = y2, n7 = /[\\^$.*+?()[\]{}|]/g, a7 = /^\[object .+?Constructor\]$/, i7 = Function.prototype, r7 = Object.prototype, s7 = i7.toString, o7 = r7.hasOwnProperty, l7 = RegExp(
  "^" + s7.call(o7).replace(n7, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function c7(t) {
  if (!e7(t) || J6(t))
    return !1;
  var e = Q6(t) ? l7 : a7;
  return e.test(t7(t));
}
var u7 = c7;
function d7(t, e) {
  return t == null ? void 0 : t[e];
}
var h7 = d7, f7 = u7, p7 = h7;
function m7(t, e) {
  var n = p7(t, e);
  return f7(n) ? n : void 0;
}
var Yr = m7, g7 = Yr, b7 = g7(Object, "create"), Hu = b7, Fm = Hu;
function v7() {
  this.__data__ = Fm ? Fm(null) : {}, this.size = 0;
}
var y7 = v7;
function _7(t) {
  var e = this.has(t) && delete this.__data__[t];
  return this.size -= e ? 1 : 0, e;
}
var T7 = _7, x7 = Hu, w7 = "__lodash_hash_undefined__", k7 = Object.prototype, C7 = k7.hasOwnProperty;
function S7(t) {
  var e = this.__data__;
  if (x7) {
    var n = e[t];
    return n === w7 ? void 0 : n;
  }
  return C7.call(e, t) ? e[t] : void 0;
}
var A7 = S7, E7 = Hu, L7 = Object.prototype, D7 = L7.hasOwnProperty;
function I7(t) {
  var e = this.__data__;
  return E7 ? e[t] !== void 0 : D7.call(e, t);
}
var M7 = I7, O7 = Hu, P7 = "__lodash_hash_undefined__";
function B7(t, e) {
  var n = this.__data__;
  return this.size += this.has(t) ? 0 : 1, n[t] = O7 && e === void 0 ? P7 : e, this;
}
var R7 = B7, N7 = y7, $7 = T7, F7 = A7, z7 = M7, U7 = R7;
function to(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var a = t[e];
    this.set(a[0], a[1]);
  }
}
to.prototype.clear = N7;
to.prototype.delete = $7;
to.prototype.get = F7;
to.prototype.has = z7;
to.prototype.set = U7;
var H7 = to;
function Y7() {
  this.__data__ = [], this.size = 0;
}
var j7 = Y7;
function V7(t, e) {
  return t === e || t !== t && e !== e;
}
var _2 = V7, q7 = _2;
function W7(t, e) {
  for (var n = t.length; n--; )
    if (q7(t[n][0], e))
      return n;
  return -1;
}
var Yu = W7, G7 = Yu, X7 = Array.prototype, Z7 = X7.splice;
function K7(t) {
  var e = this.__data__, n = G7(e, t);
  if (n < 0)
    return !1;
  var a = e.length - 1;
  return n == a ? e.pop() : Z7.call(e, n, 1), --this.size, !0;
}
var Q7 = K7, J7 = Yu;
function eC(t) {
  var e = this.__data__, n = J7(e, t);
  return n < 0 ? void 0 : e[n][1];
}
var tC = eC, nC = Yu;
function aC(t) {
  return nC(this.__data__, t) > -1;
}
var iC = aC, rC = Yu;
function sC(t, e) {
  var n = this.__data__, a = rC(n, t);
  return a < 0 ? (++this.size, n.push([t, e])) : n[a][1] = e, this;
}
var oC = sC, lC = j7, cC = Q7, uC = tC, dC = iC, hC = oC;
function no(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var a = t[e];
    this.set(a[0], a[1]);
  }
}
no.prototype.clear = lC;
no.prototype.delete = cC;
no.prototype.get = uC;
no.prototype.has = dC;
no.prototype.set = hC;
var ju = no, fC = Yr, pC = oi, mC = fC(pC, "Map"), Kh = mC, zm = H7, gC = ju, bC = Kh;
function vC() {
  this.size = 0, this.__data__ = {
    hash: new zm(),
    map: new (bC || gC)(),
    string: new zm()
  };
}
var yC = vC;
function _C(t) {
  var e = typeof t;
  return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? t !== "__proto__" : t === null;
}
var TC = _C, xC = TC;
function wC(t, e) {
  var n = t.__data__;
  return xC(e) ? n[typeof e == "string" ? "string" : "hash"] : n.map;
}
var Vu = wC, kC = Vu;
function CC(t) {
  var e = kC(this, t).delete(t);
  return this.size -= e ? 1 : 0, e;
}
var SC = CC, AC = Vu;
function EC(t) {
  return AC(this, t).get(t);
}
var LC = EC, DC = Vu;
function IC(t) {
  return DC(this, t).has(t);
}
var MC = IC, OC = Vu;
function PC(t, e) {
  var n = OC(this, t), a = n.size;
  return n.set(t, e), this.size += n.size == a ? 0 : 1, this;
}
var BC = PC, RC = yC, NC = SC, $C = LC, FC = MC, zC = BC;
function ao(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var a = t[e];
    this.set(a[0], a[1]);
  }
}
ao.prototype.clear = RC;
ao.prototype.delete = NC;
ao.prototype.get = $C;
ao.prototype.has = FC;
ao.prototype.set = zC;
var Qh = ao, UC = "__lodash_hash_undefined__";
function HC(t) {
  return this.__data__.set(t, UC), this;
}
var YC = HC;
function jC(t) {
  return this.__data__.has(t);
}
var VC = jC, qC = Qh, WC = YC, GC = VC;
function Qc(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.__data__ = new qC(); ++e < n; )
    this.add(t[e]);
}
Qc.prototype.add = Qc.prototype.push = WC;
Qc.prototype.has = GC;
var XC = Qc;
function ZC(t, e, n, a) {
  for (var i = t.length, r = n + (a ? 1 : -1); a ? r-- : ++r < i; )
    if (e(t[r], r, t))
      return r;
  return -1;
}
var KC = ZC;
function QC(t) {
  return t !== t;
}
var JC = QC;
function eS(t, e, n) {
  for (var a = n - 1, i = t.length; ++a < i; )
    if (t[a] === e)
      return a;
  return -1;
}
var tS = eS, nS = KC, aS = JC, iS = tS;
function rS(t, e, n) {
  return e === e ? iS(t, e, n) : nS(t, aS, n);
}
var sS = rS, oS = sS;
function lS(t, e) {
  var n = t == null ? 0 : t.length;
  return !!n && oS(t, e, 0) > -1;
}
var cS = lS;
function uS(t, e, n) {
  for (var a = -1, i = t == null ? 0 : t.length; ++a < i; )
    if (n(e, t[a]))
      return !0;
  return !1;
}
var dS = uS;
function hS(t, e) {
  return t.has(e);
}
var fS = hS, pS = Yr, mS = oi, gS = pS(mS, "Set"), T2 = gS;
function bS() {
}
var vS = bS;
function yS(t) {
  var e = -1, n = Array(t.size);
  return t.forEach(function(a) {
    n[++e] = a;
  }), n;
}
var x2 = yS, Jd = T2, _S = vS, TS = x2, xS = 1 / 0, wS = Jd && 1 / TS(new Jd([, -0]))[1] == xS ? function(t) {
  return new Jd(t);
} : _S, kS = wS, CS = XC, SS = cS, AS = dS, ES = fS, LS = kS, DS = x2, IS = 200;
function MS(t, e, n) {
  var a = -1, i = SS, r = t.length, s = !0, o = [], l = o;
  if (n)
    s = !1, i = AS;
  else if (r >= IS) {
    var c = e ? null : LS(t);
    if (c)
      return DS(c);
    s = !1, i = ES, l = new CS();
  } else
    l = e ? [] : o;
  e:
    for (; ++a < r; ) {
      var u = t[a], f = e ? e(u) : u;
      if (u = n || u !== 0 ? u : 0, s && f === f) {
        for (var m = l.length; m--; )
          if (l[m] === f)
            continue e;
        e && l.push(f), o.push(u);
      } else i(l, f, n) || (l !== o && l.push(f), o.push(u));
    }
  return o;
}
var OS = MS, PS = OS;
function BS(t) {
  return t && t.length ? PS(t) : [];
}
var RS = BS;
const e0 = /* @__PURE__ */ ka(RS), NS = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-checkbox"
};
function $S(t, e) {
  return h(), b("svg", NS, e[0] || (e[0] = [
    k("path", {
      d: "M5 6.5v20c0 .2761.22386.5.5.5h20c.2761 0 .5-.2239.5-.5v-20c0-.27614-.2239-.5-.5-.5h-20c-.27614 0-.5.22386-.5.5Z",
      stroke: "#0B6AB7",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      class: "svg__stroke--primary-blue-03"
    }, null, -1),
    k("path", {
      d: "m9.5 17.5722 3.1522 3.1523L21.3767 12",
      stroke: "#0AA5FF",
      "stroke-width": "1.5",
      "stroke-linecap": "square",
      "stroke-linejoin": "round",
      class: "svg__stroke--default-cyan-03"
    }, null, -1)
  ]));
}
const w2 = { render: $S }, FS = { class: "base-checkbox-group" }, zS = { class: "list" }, US = { class: "label" }, HS = ["value", "checked", "onChange"], YS = /* @__PURE__ */ Ce({
  __name: "BaseCheckboxGroup",
  props: {
    items: {
      type: Array,
      default: () => []
    },
    selected: {
      type: Array,
      default: () => []
    }
  },
  emits: ["update:selected", "input-selected"],
  setup(t, { emit: e }) {
    const n = t, a = e, i = K(e0([...n.selected]));
    Qe(() => n.selected, (s) => {
      i.value = e0([...s]);
    }, { immediate: !0 }), st(() => {
      console.log("BaseCheckboxGroup mounted"), i.value = e0([...n.selected]), console.log("BaseCheckboxGroup parsedSelected", i.value);
    });
    function r(s) {
      const o = i.value.indexOf(s);
      o > -1 ? i.value.splice(o, 1) : i.value.push(s), a("update:selected", i.value), a("input-selected");
    }
    return (s, o) => (h(), b("fieldset", FS, [
      k("ul", zS, [
        (h(!0), b(he, null, Le(t.items, (l, c) => (h(), b("li", {
          key: `BaseCheckboxGroup${c}`,
          class: "list-item"
        }, [
          k("label", US, [
            k("input", {
              type: "checkbox",
              value: l.name,
              checked: i.value.includes(l.name),
              class: "input",
              onChange: (u) => r(l.name)
            }, null, 40, HS),
            Q(O(w2), { class: "svg" }),
            ze(" " + ne(l.name), 1)
          ])
        ]))), 128))
      ])
    ]));
  }
}), Um = /* @__PURE__ */ ge(YS, [["__scopeId", "data-v-f77f7f2f"]]), jS = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-radio-button"
};
function VS(t, e) {
  return h(), b("svg", jS, e[0] || (e[0] = [
    k("path", {
      d: "M15.9998 9.8645L20.1701 11.6219L21.8975 15.8645L20.1701 20.1071L15.9998 21.8645L11.8295 20.1071L10.1021 15.8645L11.8295 11.6219L15.9998 9.8645Z",
      fill: "#0AA5FF",
      class: "svg__fill--default-cyan-03"
    }, null, -1),
    k("path", {
      d: "M10.5626 10.3216L15.9998 8.03037L21.437 10.3216L23.6938 15.8644L21.437 21.4072L15.9998 23.6985L10.5626 21.4072L8.30585 15.8644L10.5626 10.3216Z",
      stroke: "#0B6AB7",
      class: "svg__stroke--primary-blue-03"
    }, null, -1)
  ]));
}
const qS = { render: VS }, WS = { class: "base-radio-group" }, GS = { class: "list" }, XS = { class: "list-item" }, ZS = ["value", "onChange"], KS = /* @__PURE__ */ Ce({
  __name: "BaseRadioGroup",
  props: {
    items: {
      type: Array,
      default: () => []
    },
    selected: {
      type: Array,
      default: () => []
    }
  },
  emits: ["update:selected", "input-selected"],
  setup(t, { emit: e }) {
    const n = e, a = K(t.selected && t.selected.length > 0 ? t.selected[0] : "");
    Qe(() => t.selected, (r) => {
      a.value = r && r.length > 0 ? r[0] : "";
    }, { immediate: !0 });
    function i(r) {
      n("update:selected", [r]), n("input-selected");
    }
    return (r, s) => (h(), b("fieldset", WS, [
      k("ul", GS, [
        k("li", XS, [
          (h(!0), b(he, null, Le(t.items, (o, l) => (h(), b("label", {
            key: `BaseRadioGroup${l}`,
            class: "label"
          }, [
            Tt(k("input", {
              "onUpdate:modelValue": s[0] || (s[0] = (c) => a.value = c),
              type: "radio",
              value: o.name,
              class: "input",
              onChange: (c) => i(o.name)
            }, null, 40, ZS), [
              [bs, a.value]
            ]),
            Q(O(qS), { class: "svg" }),
            ze(" " + ne(o.name), 1)
          ]))), 128))
        ])
      ])
    ]));
  }
}), QS = /* @__PURE__ */ ge(KS, [["__scopeId", "data-v-e5a62c31"]]), JS = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-share-printer"
};
function k2(t, e) {
  return h(), b("svg", JS, e[0] || (e[0] = [
    ri('<circle cx="16" cy="16" r="16" fill="#F2F2F2" class="svg__fill--secondary-grey-01"></circle><path d="M7 21.1984h-.75c0 .4142.33579.75.75.75v-.75Zm0-8.1205v-.75c-.41421 0-.75.3358-.75.75H7Zm18 0h.75c0-.4142-.3358-.75-.75-.75v.75Zm0 8.1205v.75c.4142 0 .75-.3358.75-.75H25Zm-16.29837.75h.75v-1.5h-.75v1.5Zm14.57147-1.5h-.75v1.5h.75v-1.5Zm-15.5231.75v-8.1205h-1.5v8.1205h1.5ZM7 13.8279h18v-1.5H7v1.5Zm17.25-.75v8.1205h1.5v-8.1205h-1.5ZM8.70163 20.4484H7v1.5h1.70163v-1.5Zm16.29837 0h-1.7269v1.5H25v-1.5Z" fill="#0F0F0F" class="svg__fill--black"></path><path d="M11.4482 18.7737v6.5454h9.0013v-6.5454h-9.0013Z" stroke="#0F0F0F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" class="svg__stroke--black"></path><path d="M13.5213 21.0669h4.8821" stroke="#0F0F0F" class="svg__stroke--black"></path><path d="M13.5213 22.812h2.99" stroke="#0F0F0F" class="svg__stroke--black"></path><path d="M10.6306 16.4412h1.6243" stroke="#0F0F0F" stroke-width="1.25" class="svg__stroke--black"></path><path d="M9.86359 8.68115v4.41055H22.5071V8.68115H9.86359Z" stroke="#0F0F0F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="svg__stroke--black"></path>', 7)
  ]));
}
const C2 = { render: k2 }, S2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: C2,
  render: k2
}, Symbol.toStringTag, { value: "Module" })), eA = { class: "block-amenities" }, tA = { class: "amenity-column" }, nA = { class: "amenities-list" }, aA = { class: "amenity-name" }, iA = /* @__PURE__ */ Ce({
  __name: "BlockAmenities",
  props: {
    amenities: {
      type: Array,
      default: () => []
    }
  },
  setup(t) {
    const e = t, n = ve(
      () => import("./icon-clock-CG3EE-5W.js")
    ), a = ve(
      () => import("./icon-accessible-C8Gup1rK.js")
    ), i = ve(
      () => import("./icon-chair-D8fW8Dnx.js")
    ), r = ve(
      () => import("./icon-virtual-CwZieS3s.js")
    ), s = ve(
      () => import("./icon-laptop-Bmg8PSn7.js")
    ), o = ve(
      () => import("./icon-locker-BBQPsbYg.js")
    ), l = ve(
      () => import("./icon-light-wkkuRssP.js")
    ), c = ve(
      () => import("./icon-book-Dhs3bbZ0.js")
    ), u = {
      "icon-clock": {
        icon: n,
        label: "24 Hour Study Space"
      },
      "icon-accessible": {
        icon: a,
        label: "ADA Stations"
      },
      "icon-chair": {
        icon: i,
        label: "Cafe"
      },
      "icon-virtual": {
        icon: r,
        label: "Computer/Laptop Access"
      },
      "icon-laptop": {
        icon: s,
        label: "Laptop Lending"
      },
      "icon-locker": {
        icon: o,
        label: "Locker"
      },
      "icon-light": {
        icon: l,
        label: "Makerspace"
      },
      "icon-share-printer": {
        icon: C2,
        label: "Print, Copy and Scan"
      },
      "icon-book": {
        icon: c,
        label: "Research Help"
      }
    }, f = I(() => e.amenities.map((m) => {
      const _ = u[m];
      return {
        svgIcon: _.icon,
        svgLabel: _.label
      };
    }));
    return (m, _) => (h(), b("div", eA, [
      _[0] || (_[0] = k("h3", { class: "amenities-title" }, " At This Location ", -1)),
      k("div", tA, [
        k("ul", nA, [
          (h(!0), b(he, null, Le(f.value, (T, g) => (h(), b("li", {
            key: `${T.svgLabel}-${g}`,
            class: "amenitiy-row"
          }, [
            T.svgIcon ? (h(), G(dt(T.svgIcon), { key: 0 })) : A("", !0),
            k("span", aA, ne(T.svgLabel), 1)
          ]))), 128))
        ])
      ])
    ]));
  }
}), xhe = /* @__PURE__ */ ge(iA, [["__scopeId", "data-v-41576e56"]]), rA = {
  name: "ModalGeneric",
  components: {
    SvgGlyphClose: er
  },
  emits: ["close"],
  methods: {
    close() {
      this.$emit("close");
    }
  }
}, sA = { class: "content" };
function oA(t, e, n, a, i, r) {
  const s = lt("SvgGlyphClose");
  return h(), b("div", {
    class: "modal",
    onClick: e[1] || (e[1] = (...o) => r.close && r.close(...o))
  }, [
    k("button", {
      class: "svg-glyph-close",
      onClick: e[0] || (e[0] = (...o) => r.close && r.close(...o))
    }, [
      Q(s)
    ]),
    k("div", sA, [
      me(t.$slots, "default", {}, void 0, !0)
    ])
  ]);
}
const lA = /* @__PURE__ */ ge(rA, [["render", oA], ["__scopeId", "data-v-9eea23da"]]), cA = {
  name: "BlockCampusMap",
  components: {
    ModalGeneric: lA,
    RichText: un
  },
  props: {
    campusLocationId: {
      type: String,
      default: ""
    },
    locationName: {
      type: String,
      default: ""
    },
    buildingAccess: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      isModalVisible: !1
    };
  },
  computed: {
    parsedSrc() {
      return `https://map.ucla.edu/?id=${this.campusLocationId}&e=true`;
    }
  },
  methods: {
    showModal() {
      this.isModalVisible = !0;
    },
    closeModal() {
      this.isModalVisible = !1;
    }
  }
}, uA = { class: "block-campus-map" }, dA = { class: "modal-content" }, hA = ["src"], fA = { class: "content" }, pA = { class: "iframe-hover" }, mA = { class: "iframe-container" }, gA = ["src"], bA = {
  key: 0,
  class: "text-grouping"
};
function vA(t, e, n, a, i, r) {
  const s = lt("ModalGeneric"), o = lt("RichText");
  return h(), b("div", uA, [
    Tt(Q(s, {
      class: "modal",
      onClose: r.closeModal
    }, {
      default: oe(() => [
        k("div", dA, [
          k("iframe", {
            src: r.parsedSrc,
            class: "iframe-modal",
            allowfullscreen: ""
          }, null, 8, hA)
        ])
      ]),
      _: 1
    }, 8, ["onClose"]), [
      [va, i.isModalVisible]
    ]),
    k("button", {
      class: "title",
      onClick: e[0] || (e[0] = (...l) => r.showModal && r.showModal(...l))
    }),
    k("div", fA, [
      k("div", pA, [
        k("div", mA, [
          k("iframe", {
            src: r.parsedSrc,
            class: "iframe",
            allowfullscreen: ""
          }, null, 8, gA),
          k("div", {
            class: "iframe-click",
            onClick: e[1] || (e[1] = (...l) => r.showModal && r.showModal(...l))
          })
        ])
      ]),
      n.buildingAccess ? (h(), b("div", bA, [
        e[2] || (e[2] = k("h4", { class: "subheading-small" }, " Building Access ", -1)),
        Q(o, {
          class: "building-access-text",
          "rich-text-content": n.buildingAccess
        }, null, 8, ["rich-text-content"])
      ])) : A("", !0)
    ])
  ]);
}
const whe = /* @__PURE__ */ ge(cA, [["render", vA], ["__scopeId", "data-v-a75f1f8c"]]), yA = [
  {
    id: "843",
    name: "Locations & Hours",
    to: "/locations",
    classes: "",
    target: ""
  },
  {
    id: "844",
    name: "Ask a Librarian",
    to: "/research-teaching-support/research-help",
    classes: null,
    target: ""
  },
  {
    id: "845",
    name: "My Account",
    to: "https://catalog.library.ucla.edu/vwebv/login;jsessionid=9D14C6523970C30728D965F6BD6B914D",
    classes: null,
    target: "1"
  }
], _A = [
  {
    id: "835",
    name: "Get help with...",
    to: null,
    classes: "",
    target: "",
    children: [
      {
        id: "833",
        name: "Borrowing Books and Equipment",
        to: "/help/services-resources/borrowing-books-and-equipment",
        classes: "",
        target: ""
      },
      {
        id: "840",
        name: "All Services & Resources",
        to: "/help/services-resources",
        classes: "",
        target: ""
      }
    ]
  },
  {
    id: "834",
    name: "Visit",
    to: "/events-exhibits",
    classes: null,
    target: "",
    children: [
      {
        id: "841",
        name: "Locations & Hours",
        to: "/visit/locations",
        classes: "",
        target: ""
      },
      {
        id: "837",
        name: "Events & Exhibitions",
        to: "/visit/events-exhibits",
        classes: "",
        target: ""
      }
    ]
  },
  {
    id: "836",
    name: "About",
    to: null,
    classes: null,
    target: "",
    children: [
      {
        id: "842",
        name: "Library News",
        to: "/about/news",
        classes: "",
        target: ""
      },
      {
        id: "838",
        name: "Staff Directory",
        to: "/about/staff",
        classes: "",
        target: ""
      }
    ]
  },
  {
    id: "839",
    name: "Support us",
    to: "https://giving.ucla.edu/Standard/NetDonate.aspx?SiteNum=463",
    classes: null,
    target: "1",
    children: []
  }
], Hm = {
  socialItems: [
    {
      id: "11777",
      name: "Twitter",
      to: "https://twitter.com/",
      classes: null,
      target: "1"
    },
    {
      id: "11778",
      name: "Facebook",
      to: "https://www.facebook.com/",
      classes: null,
      target: "1"
    },
    {
      id: "11779",
      name: "Instagram",
      to: "https://www.instagram.com/",
      classes: null,
      target: "1"
    },
    {
      id: "11780",
      name: "YouTube",
      to: "https://www.youtube.com/",
      classes: null,
      target: "1"
    }
  ],
  pressItems: [
    {
      id: "11781",
      name: "Dress Doom",
      to: "https://test-craft.library.ucla.edu/press-room",
      classes: null,
      target: ""
    },
    {
      id: "11782",
      name: "Careers at USC",
      to: "https://test-craft.library.ucla.edu/careers-at-ucla",
      classes: null,
      target: ""
    }
  ]
}, TA = {
  nodes: [
    {
      id: "1628",
      name: "EEEmergency",
      to: "/emergency",
      classes: null
    },
    {
      id: "1627",
      name: "AAAccessibility",
      to: "https://external.url/accessibility",
      classes: null
    },
    {
      id: "1629",
      name: "PPPrivacy & Terms of Use",
      to: "https://test-craft.library.ucla.edu/privacy-terms-of-use",
      classes: null,
      target: "0"
    },
    {
      id: "9511",
      name: "CCCreative Commons Attribution 4.0",
      to: "https://creativecommons.org/licenses/by/4.0/",
      classes: null,
      target: "1"
    }
  ]
}, xA = {
  funders: [
    {
      id: "28231",
      funderLogo: [
        {
          id: "28636",
          src: "https://static.library.ucla.edu/craftassetstest/logo-arcadia1.svg",
          height: 569,
          width: 2560,
          srcset: "https://static.library.ucla.edu/craftassetstest/_375xAUTO_crop_center-center_none/logo-arcadia1.svg 375w, https://static.library.ucla.edu/craftassetstest/_960xAUTO_crop_center-center_none/logo-arcadia1.svg 960w, https://static.library.ucla.edu/craftassetstest/_1280xAUTO_crop_center-center_none/logo-arcadia1.svg 1280w, https://static.library.ucla.edu/craftassetstest/_1920xAUTO_crop_center-center_none/logo-arcadia1.svg 1920w, https://static.library.ucla.edu/craftassetstest/_2560xAUTO_crop_center-center_none/logo-arcadia1.svg 2560w",
          alt: "Logo arcadia1",
          focalPoint: [0.5, 0.5]
        }
      ],
      funderName: "Arcadiaaaaaa",
      funderUrl: "https://www.hostesscakes.com/produ        colate/"
    },
    {
      id: "28259",
      funderLogo: [
        {
          id: "28637",
          src: "https://static.library.ucla.edu/craftassetstest/logo-library.svg",
          height: 490,
          width: 2560,
          srcset: "https://static.library.ucla.edu/craftassetstest/_375xAUTO_crop_center-center_none/logo-library.svg 375w, https://static.library.ucla.edu/craftassetstest/_960xAUTO_crop_center-center_none/logo-library.svg 960w, https://static.library.ucla.edu/craftassetstest/_1280xAUTO_crop_center-center_none/logo-library.svg 1280w, https://static.library.ucla.edu/craftassetstest/_1920xAUTO_crop_center-center_none/logo-library.svg 1920w, https://static.library.ucla.edu/craftassetstest/_2560xAUTO_crop_center-center_none/logo-library.svg 2560w",
          alt: "Logo library",
          focalPoint: [0.5, 0.5]
        }
      ],
      funderName: "Etch A Sketch",
      funderUrl: "https://en.wikipedia.org/wiki/Etch_A_Sketch"
    }
  ]
}, Cc = {
  // links: [
  //   { title: 'About', links: mockFooterLinks.aboutLinks },
  // ]
  aboutLinks: [
    {
      id: "1623",
      name: "About the Library",
      to: "/about",
      classes: null
    },
    {
      id: "1624",
      name: "Library News",
      to: "/about/news",
      classes: null
    },
    {
      id: "1625",
      name: "Staff Directory",
      to: "/about/staff",
      classes: null
    },
    {
      id: "1626",
      name: "Jobs",
      to: "/about/jobs",
      classes: null
    }
  ],
  contactLinks: [
    {
      id: "1620",
      name: "Contact Us",
      to: "/help",
      classes: null
    },
    {
      id: "1621",
      name: "Ask a Librarian",
      to: "/research-teaching-support/research-help",
      classes: null
    },
    {
      id: "1622",
      name: "Locations & Hours",
      to: "/locations",
      classes: null
    }
  ],
  contributeLinks: [
    {
      id: "1617",
      name: "Support the Library",
      to: "https://giving.ucla.edu/Standard/NetDonate.aspx?SiteNum=463",
      classes: null
    },
    {
      id: "1618",
      name: "Volunteer",
      to: "/about/jobs/volunteer",
      classes: null
    },
    {
      id: "1619",
      name: "Give Feedback",
      to: "/help/feedback",
      classes: null
    }
  ],
  resourcesLinks: [
    {
      id: "1614",
      name: "Services & Resources",
      to: "/help/services-resources",
      classes: null
    },
    {
      id: "1615",
      name: "Research Guides",
      to: "/research-teaching-support/research-guides",
      classes: null
    },
    {
      id: "1616",
      name: "Digital Collections",
      to: "/collections/digital-collections",
      classes: null
    }
  ]
}, io = F4("GlobalStore", {
  state: () => ({
    winHeight: 0,
    winWidth: 824,
    sTop: 0,
    globals: {
      askALibrarian: {
        id: "7322",
        askALibrarianTitle: "Have further questions?",
        askALibrarianText: "<p>We're here to help. Chat with a librarian 24/7, schedule a research consultation or email us your quick questions.</p>",
        buttonUrl: [
          {
            buttonText: "Contact us",
            buttonUrl: "/help/"
          }
        ]
      },
      meapCallToAction: {
        id: "28646",
        name: "MEAP Call to Action",
        titleGeneral: "Get in Touch",
        summary: "<p>Have further questions?</p>",
        button: [
          {
            buttonText: "Contact Us",
            buttonUrl: "mailto:meap@library.ucla.edu"
          }
        ]
      },
      ftvaViewingInformation: {
        title: "View information",
        text: '<p>For more information, or to arrange on-site research viewing, please contact the <a href="https://www.cinema.ucla.edu/archive-research-study-center" target="_blank" rel="noreferrer noopener">Archive Research and Study Center (ARSC)</a></p>'
      }
    },
    header: {
      primary: _A,
      secondary: yA
    },
    footerPrimary: {
      nodes: [
        {
          children: Hm.socialItems
        },
        {
          children: Hm.pressItems
        }
      ]
    },
    footerSock: {
      nodes: TA.nodes
    },
    footerSponsor: {
      funders: xA.funders
    },
    footerLinks: {
      nodes: [
        {
          category: "About",
          children: Cc.aboutLinks
        },
        {
          category: "Contact",
          children: Cc.contactLinks
        },
        {
          category: "Contribute",
          children: Cc.contributeLinks
        },
        {
          category: "Resources",
          children: Cc.resourcesLinks
        }
      ]
    }
  }),
  getters: {}
}), wA = {
  key: 0,
  class: "title"
}, kA = { key: 0 }, CA = /* @__PURE__ */ Ce({
  __name: "BlockCallToAction",
  props: {
    svgName: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    to: {
      type: String,
      default: ""
    },
    isDark: {
      type: Boolean,
      default: !1
    },
    isSmallSize: {
      type: Boolean,
      default: !1
    },
    isCentered: {
      type: Boolean,
      default: !0
    },
    isGlobal: {
      type: Boolean,
      default: !1
    },
    isMeapGlobal: {
      type: Boolean,
      default: !1
    },
    useGlobalData: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    const e = t, n = ve(
      () => import("./call-to-action-chat-wKFtbg67.js")
    ), a = ve(
      () => import("./call-to-action-find-DePPosGW.js")
    ), i = ve(
      () => import("./icon-ftva-question-BgiBGZHU.js")
    ), r = ve(
      () => import("./call-to-action-mail-jFaR-5w7.js")
    ), s = ve(
      () => import("./call-to-action-money-s0xuiara.js")
    ), o = ve(
      () => import("./icon-ftva-external-link-dark-B_Y0Do4N.js")
    ), l = ve(
      () => import("./icon-ftva-info-BFnfBdSM.js")
    ), c = ve(
      () => import("./icon-ftva-pdf-D_o__FZL.js")
    ), u = {
      "svg-call-to-action-chat": {
        icon: n,
        label: "CTA Chat"
      },
      "svg-call-to-action-find": {
        icon: a,
        label: "CTA Find"
      },
      "svg-call-to-action-question": {
        icon: i,
        label: "CTA Question"
      },
      "svg-call-to-action-ftva-external-link-dark": {
        icon: o,
        label: "CTA FTVA External Link"
      },
      "svg-call-to-action-ftva-info": {
        icon: l,
        label: "CTA FTVA Info"
      },
      "svg-call-to-action-ftva-pdf": {
        icon: c,
        label: "CTA FTVA PDF"
      },
      "svg-call-to-action-mail": {
        icon: r,
        label: "CTA Mail"
      },
      "svg-call-to-action-money": {
        icon: s,
        label: "CTA Money"
      }
    }, f = io(), m = I(() => f.globals.askALibrarian), _ = I(() => f.globals.meapCallToAction), T = I(() => f.globals.ftvaViewingInformation), g = qe(), x = I(() => {
      var D;
      return e.isGlobal ? {
        to: m.value.buttonUrl[0].buttonUrl,
        title: m.value.askALibrarianTitle,
        text: m.value.askALibrarianText,
        label: m.value.buttonUrl[0].buttonText,
        svgName: u["svg-call-to-action-chat"].icon
      } : e.isMeapGlobal ? {
        to: _.value.button[0].buttonUrl,
        title: _.value.titleGeneral,
        text: _.value.summary,
        label: _.value.button[0].buttonText,
        svgName: u["svg-call-to-action-chat"].icon
      } : e.useGlobalData && (g == null ? void 0 : g.value) === "ftva" ? {
        title: T.value.title,
        text: T.value.text,
        svgName: u["svg-call-to-action-ftva-info"].icon
      } : {
        to: e.to,
        title: e.title,
        text: e.text,
        label: e.name,
        svgName: e.svgName ? (D = u[e.svgName]) == null ? void 0 : D.icon : void 0
        // Allow undefined
      };
    }), S = I(() => [
      "block-call-to-action",
      { "full-width": !e.isSmallSize },
      { "half-width": e.isSmallSize },
      { "theme-light": !e.isDark },
      { "theme-dark": e.isDark },
      { "slim-left-align": !e.isCentered },
      // For FTVA SlimCTA
      (g == null ? void 0 : g.value) || ""
    ]);
    return (D, L) => (h(), b("div", {
      class: re(S.value)
    }, [
      (h(), G(dt(x.value.svgName), {
        class: "svg",
        "aria-hidden": "true"
      })),
      k("div", null, [
        e.title || x.value.title ? (h(), b("h2", wA, ne(x.value.title), 1)) : A("", !0),
        Q(un, {
          class: re([{ "ftva-global-data": e.useGlobalData && O(g) === "ftva" }, "text"]),
          "rich-text-content": x.value.text
        }, null, 8, ["class", "rich-text-content"])
      ]),
      x.value.to && x.value.label ? (h(), b("div", kA, [
        !e.isDark && O(g) !== "ftva" ? (h(), G(sn, {
          key: 0,
          label: x.value.label,
          to: x.value.to,
          "is-secondary": !0,
          class: "button-link"
        }, null, 8, ["label", "to"])) : A("", !0),
        e.isDark && O(g) !== "ftva" ? (h(), G(sn, {
          key: 1,
          label: x.value.label,
          to: x.value.to,
          "is-tertiary": !0,
          class: "button-link"
        }, null, 8, ["label", "to"])) : A("", !0),
        !e.isDark && O(g) === "ftva" ? (h(), G(sn, {
          key: 2,
          label: x.value.label,
          to: x.value.to,
          "icon-name": "none",
          class: "button-link"
        }, null, 8, ["label", "to"])) : A("", !0),
        e.isDark && O(g) === "ftva" ? (h(), G(sn, {
          key: 3,
          label: x.value.label,
          to: x.value.to,
          "is-tertiary": !0,
          "icon-name": "none",
          class: "button-link"
        }, null, 8, ["label", "to"])) : A("", !0)
      ])) : A("", !0)
    ], 2));
  }
}), Jh = /* @__PURE__ */ ge(CA, [["__scopeId", "data-v-daf47159"]]), SA = { class: "block-call-to-action-two-up" }, AA = /* @__PURE__ */ Ce({
  __name: "BlockCallToActionTwoUp",
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  setup(t) {
    return (e, n) => (h(), b("section", SA, [
      (h(!0), b(he, null, Le(t.items, (a, i) => (h(), G(Jh, {
        key: `BlockCallToActionTwoUpKey${i}`,
        "svg-name": a.svgName,
        title: a.title,
        text: a.text,
        name: a.name,
        to: a.to,
        "is-dark": a.isDark,
        "is-small-size": !0
      }, null, 8, ["svg-name", "title", "text", "name", "to", "is-dark"]))), 128))
    ]));
  }
}), khe = /* @__PURE__ */ ge(AA, [["__scopeId", "data-v-5f23f2ae"]]);
function EA(t = "") {
  return new Date(t).toLocaleDateString("en-us", { weekday: "long" });
}
function A2(t = "") {
  return Ct(new Date(t), "MMM");
}
const LA = { class: "day-month-date" }, DA = ["innerHTML"], IA = { class: "month-date" }, MA = ["innerHTML"], OA = ["innerHTML"], PA = { class: "image-block" }, BA = {
  key: 1,
  class: "molecule-no-image"
}, RA = { class: "meta" }, NA = /* @__PURE__ */ Ce({
  __name: "BlockCardThreeColumn",
  props: {
    image: {
      type: Object,
      default: () => {
      }
    },
    imageAspectRatio: {
      type: Number,
      default: 0
    },
    to: {
      type: String,
      default: ""
    },
    category: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    startDate: {
      type: String,
      default: ""
    },
    endDate: {
      type: String,
      default: ""
    },
    tagLabels: {
      type: Array,
      default: () => []
    }
  },
  setup(t) {
    const e = t, n = qe(), a = I(() => ["block-card-three-column", (n == null ? void 0 : n.value) || ""]), i = I(() => e.startDate ? EA(e.startDate) : ""), r = I(() => e.startDate ? A2(e.startDate) : ""), s = I(() => e.startDate ? Ct(new Date(e.startDate), "d") : ""), o = I(() => (n == null ? void 0 : n.value) === "ftva" ? "short" : "long");
    return (l, c) => (h(), b("li", {
      class: re(a.value)
    }, [
      k("div", LA, [
        t.startDate ? (h(), b("time", {
          key: 0,
          class: "day",
          innerHTML: i.value
        }, null, 8, DA)) : A("", !0),
        k("div", IA, [
          t.startDate ? (h(), b("time", {
            key: 0,
            class: "month",
            innerHTML: r.value
          }, null, 8, MA)) : A("", !0),
          t.startDate ? (h(), b("time", {
            key: 1,
            innerHTML: s.value
          }, null, 8, OA)) : A("", !0)
        ])
      ]),
      k("div", PA, [
        t.image ? (h(), G(dn, {
          key: 0,
          media: t.image,
          class: "image"
        }, null, 8, ["media"])) : (h(), b("div", BA, [
          Q(O(Js), {
            class: "molecule",
            "aria-hidden": "true"
          })
        ]))
      ]),
      k("div", RA, [
        Q(Uu, {
          class: "card-meta-items",
          to: t.to,
          category: t.category,
          title: t.title,
          "start-date": t.startDate,
          "end-date": t.endDate,
          "date-format": o.value
        }, {
          floatingslot: oe(() => [
            (h(!0), b(he, null, Le(t.tagLabels, (u, f) => (h(), b("div", {
              key: `${u.title}-${f}`
            }, [
              Q(eo, {
                label: u.title,
                "is-secondary": !0,
                "is-highlighted": u.isHighlighted
              }, null, 8, ["label", "is-highlighted"])
            ]))), 128))
          ]),
          _: 1
        }, 8, ["to", "category", "title", "start-date", "end-date", "date-format"])
      ])
    ], 2));
  }
}), $A = /* @__PURE__ */ ge(NA, [["__scopeId", "data-v-89248db7"]]), FA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: $A
}, Symbol.toStringTag, { value: "Module" })), zA = {
  width: "200",
  height: "160",
  viewBox: "0 0 200 160",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__illustration-digitized-resources"
};
function UA(t, e) {
  return h(), b("svg", zA, e[0] || (e[0] = [
    ri('<path d="M9.08984 113.223H190.91V131.489C190.91 135.493 187.664 138.739 183.66 138.739H115.956H83.8441H16.3398C12.3358 138.739 9.08984 135.493 9.08984 131.489V113.223Z" stroke="#0B6AB7" stroke-width="1.5" class="svg__stroke--primary-blue-03"></path><path d="M83.791 139.489V155M116.002 139.489V155M116.002 155H135.066M116.002 155H83.791M83.791 155H65.3848" stroke="#0B6AB7" stroke-width="1.5" class="svg__stroke--primary-blue-03"></path><path d="M14.3398 5.75H185.66C188.56 5.75 190.91 8.10051 190.91 11V113.253H9.08984V11C9.08984 8.10051 11.4403 5.75 14.3398 5.75Z" stroke="#0B6AB7" stroke-width="1.5" class="svg__stroke--primary-blue-03"></path><path d="M185.176 19.3555L157.085 30.991L145.45 59.0816L157.085 87.1723L185.176 98.8078" stroke="#FFD600" stroke-width="1.5" class="svg__stroke--secondary-yellow-03"></path><path d="M17.7856 10.9407H182.213C184.008 10.9407 185.463 12.3957 185.463 14.1907V103.971C185.463 105.766 184.008 107.221 182.213 107.221H17.7856C15.9907 107.221 14.5356 105.766 14.5356 103.971V14.1907C14.5356 12.3957 15.9907 10.9407 17.7856 10.9407Z" stroke="#0AA5FF" stroke-width="1.5" class="svg__stroke--default-cyan-03"></path><path d="M99.9953 131.954L104.221 130.204L105.971 125.979L104.221 121.754L99.9953 120.003L95.7701 121.754L94.02 125.979L95.7701 130.204L99.9953 131.954Z" fill="#0AA5FF" class="svg__fill--default-cyan-03"></path><path d="M44.4458 35.502H84.4458" stroke="#00E0E0" stroke-width="1.5" class="svg__stroke--help-green-03"></path><path d="M44.4458 41.502H84.4458" stroke="#00E0E0" stroke-width="1.5" class="svg__stroke--help-green-03"></path><path d="M44.4458 47.502L84.4458 47.5019" stroke="#00E0E0" stroke-width="1.5" class="svg__stroke--help-green-03"></path><path d="M44.4458 53.502L84.4458 53.5019" stroke="#00E0E0" stroke-width="1.5" class="svg__stroke--help-green-03"></path><path d="M44.4458 59.502L75.4405 59.502" stroke="#00E0E0" stroke-width="1.5" class="svg__stroke--help-green-03"></path><path d="M44.4458 71.502L84.4458 71.5019" stroke="#00E0E0" stroke-width="1.5" class="svg__stroke--help-green-03"></path><path d="M44.4458 77.502L84.4458 77.5019" stroke="#00E0E0" stroke-width="1.5" class="svg__stroke--help-green-03"></path><path d="M44.4458 83.502L68.388 83.502" stroke="#00E0E0" stroke-width="1.5" class="svg__stroke--help-green-03"></path><path d="M92.4458 41.502H116.446" stroke="#00E0E0" stroke-width="1.5" class="svg__stroke--help-green-03"></path><path d="M92.4458 35.502H116.446" stroke="#00E0E0" stroke-width="1.5" class="svg__stroke--help-green-03"></path><path d="M92.4458 47.502H105.364" stroke="#00E0E0" stroke-width="1.5" class="svg__stroke--help-green-03"></path><path d="M92.4458 59.502L116.446 59.502" stroke="#00E0E0" stroke-width="1.5" class="svg__stroke--help-green-03"></path><path d="M92.4458 65.502L116.446 65.502" stroke="#00E0E0" stroke-width="1.5" class="svg__stroke--help-green-03"></path><path d="M92.4458 71.502L116.446 71.502" stroke="#00E0E0" stroke-width="1.5" class="svg__stroke--help-green-03"></path><path d="M92.4458 77.502L116.446 77.502" stroke="#00E0E0" stroke-width="1.5" class="svg__stroke--help-green-03"></path><path d="M92.4458 83.502L112.79 83.502" stroke="#00E0E0" stroke-width="1.5" class="svg__stroke--help-green-03"></path>', 22)
  ]));
}
const HA = { render: UA }, YA = {
  width: "200",
  height: "160",
  viewBox: "0 0 200 160",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__illustration-teaching"
};
function jA(t, e) {
  return h(), b("svg", YA, e[0] || (e[0] = [
    ri('<path d="M98.6874 4.74365L99.414 4.55781C99.3291 4.22585 99.03 3.99364 98.6874 3.99365C98.3447 3.99366 98.0457 4.22589 97.9608 4.55785L98.6874 4.74365ZM97.9608 4.92949L132.152 138.616L133.606 138.244L99.414 4.55781L97.9608 4.92949ZM132.158 138.635L136.786 154.948L138.229 154.539L133.601 138.225L132.158 138.635ZM97.9608 4.55785L63.7763 138.244L65.2295 138.616L99.414 4.92945L97.9608 4.55785ZM63.7814 138.225L59.1535 154.539L60.5965 154.948L65.2244 138.635L63.7814 138.225ZM132.879 137.68H64.5029V139.18H132.879V137.68Z" fill="#0B6AB7" class="svg__fill--primary-blue-03"></path><rect x="91.8477" y="16.0012" width="13.6887" height="8.52157" fill="white" class="svg__fill--white"></rect><rect x="15.6284" y="24.1885" width="168.77" height="101.715" rx="1.25" fill="white" stroke="#0B6AB7" stroke-width="1.5" class="svg__fill--white svg__stroke--primary-blue-03"></rect><rect x="15.6284" y="16.5989" width="168.77" height="7.17405" rx="1.25" stroke="#0B6AB7" stroke-width="1.5" class="svg__stroke--primary-blue-03"></rect><rect x="18.8344" y="19.5251" width="162.503" height="1.35532" rx="0.67766" stroke="#0AA5FF" stroke-width="1.35532" class="svg__stroke--default-cyan-03"></rect><path d="M118.251 50.2215H120.732C121.642 50.2215 122.379 50.9586 122.379 51.8678V99.3356C122.379 100.245 121.642 100.982 120.732 100.982H116.912H82.5513C82.5513 100.982 77.6423 100.982 77.6426 95.5711M118.251 50.2215V89.9373C118.251 89.9373 90.4163 89.9373 82.5513 89.9373C82.5513 89.9373 77.6428 90.1604 77.6426 95.5711M118.251 50.2215V46.0938H85.8739C81.3279 46.0938 77.6426 49.779 77.6426 54.3251V95.5711" stroke="#0B6AB7" stroke-width="1.25" class="svg__stroke--primary-blue-03"></path><path d="M98.7616 58.0586L106.301 61.1814L109.424 68.7206L106.301 76.2598L98.7616 79.3826L91.2224 76.2598L88.0996 68.7206L91.2224 61.1814L98.7616 58.0586Z" stroke="#FFD600" stroke-width="1.25" class="svg__stroke--secondary-yellow-03"></path><path d="M84.665 96.2986L106.396 96.2986" stroke="#00E0E0" stroke-width="1.25" class="svg__stroke--help-green-03"></path><path d="M108.205 96.2986L112.156 96.2986" stroke="#00E0E0" stroke-width="1.25" class="svg__stroke--help-green-03"></path><path d="M113.8 96.2986L115.117 96.2986" stroke="#00E0E0" stroke-width="1.25" class="svg__stroke--help-green-03"></path><path d="M94.3551 101.378L98.6348 104.292C98.6591 104.309 98.6921 104.291 98.6921 104.262V95.6572H90.0181V104.262C90.0181 104.291 90.051 104.309 90.0754 104.292L94.3551 101.378Z" fill="#0AA5FF" class="svg__fill--default-cyan-03"></path>', 11)
  ]));
}
const VA = { render: jA };
function qA(t, e) {
  for (var n = -1, a = t == null ? 0 : t.length, i = Array(a); ++n < a; )
    i[n] = e(t[n], n, t);
  return i;
}
var E2 = qA, WA = Array.isArray, rr = WA;
function GA(t) {
  return t != null && typeof t == "object";
}
var sr = GA, XA = Ur, ZA = sr, KA = "[object Symbol]";
function QA(t) {
  return typeof t == "symbol" || ZA(t) && XA(t) == KA;
}
var qu = QA, Ym = Ol, JA = E2, eE = rr, tE = qu, jm = Ym ? Ym.prototype : void 0, Vm = jm ? jm.toString : void 0;
function L2(t) {
  if (typeof t == "string")
    return t;
  if (eE(t))
    return JA(t, L2) + "";
  if (tE(t))
    return Vm ? Vm.call(t) : "";
  var e = t + "";
  return e == "0" && 1 / t == -1 / 0 ? "-0" : e;
}
var D2 = L2;
function nE(t, e, n) {
  var a = -1, i = t.length;
  e < 0 && (e = -e > i ? 0 : i + e), n = n > i ? i : n, n < 0 && (n += i), i = e > n ? 0 : n - e >>> 0, e >>>= 0;
  for (var r = Array(i); ++a < i; )
    r[a] = t[a + e];
  return r;
}
var I2 = nE, aE = I2;
function iE(t, e, n) {
  var a = t.length;
  return n = n === void 0 ? a : n, !e && n >= a ? t : aE(t, e, n);
}
var rE = iE, sE = "\\ud800-\\udfff", oE = "\\u0300-\\u036f", lE = "\\ufe20-\\ufe2f", cE = "\\u20d0-\\u20ff", uE = oE + lE + cE, dE = "\\ufe0e\\ufe0f", hE = "\\u200d", fE = RegExp("[" + hE + sE + uE + dE + "]");
function pE(t) {
  return fE.test(t);
}
var ef = pE, mE = Ur, gE = sr, bE = "[object RegExp]";
function vE(t) {
  return gE(t) && mE(t) == bE;
}
var yE = vE;
function _E(t) {
  return function(e) {
    return t(e);
  };
}
var Wu = _E, Jc = { exports: {} };
Jc.exports;
(function(t, e) {
  var n = g2, a = e && !e.nodeType && e, i = a && !0 && t && !t.nodeType && t, r = i && i.exports === a, s = r && n.process, o = function() {
    try {
      var l = i && i.require && i.require("util").types;
      return l || s && s.binding && s.binding("util");
    } catch {
    }
  }();
  t.exports = o;
})(Jc, Jc.exports);
var Gu = Jc.exports, TE = yE, xE = Wu, qm = Gu, Wm = qm && qm.isRegExp, wE = Wm ? xE(Wm) : TE, kE = wE;
function CE(t) {
  return function(e) {
    return e == null ? void 0 : e[t];
  };
}
var SE = CE, AE = SE, EE = AE("length"), LE = EE, M2 = "\\ud800-\\udfff", DE = "\\u0300-\\u036f", IE = "\\ufe20-\\ufe2f", ME = "\\u20d0-\\u20ff", OE = DE + IE + ME, PE = "\\ufe0e\\ufe0f", BE = "[" + M2 + "]", V0 = "[" + OE + "]", q0 = "\\ud83c[\\udffb-\\udfff]", RE = "(?:" + V0 + "|" + q0 + ")", O2 = "[^" + M2 + "]", P2 = "(?:\\ud83c[\\udde6-\\uddff]){2}", B2 = "[\\ud800-\\udbff][\\udc00-\\udfff]", NE = "\\u200d", R2 = RE + "?", N2 = "[" + PE + "]?", $E = "(?:" + NE + "(?:" + [O2, P2, B2].join("|") + ")" + N2 + R2 + ")*", FE = N2 + R2 + $E, zE = "(?:" + [O2 + V0 + "?", V0, P2, B2, BE].join("|") + ")", Gm = RegExp(q0 + "(?=" + q0 + ")|" + zE + FE, "g");
function UE(t) {
  for (var e = Gm.lastIndex = 0; Gm.test(t); )
    ++e;
  return e;
}
var HE = UE, YE = LE, jE = ef, VE = HE;
function qE(t) {
  return jE(t) ? VE(t) : YE(t);
}
var WE = qE;
function GE(t) {
  return t.split("");
}
var XE = GE, $2 = "\\ud800-\\udfff", ZE = "\\u0300-\\u036f", KE = "\\ufe20-\\ufe2f", QE = "\\u20d0-\\u20ff", JE = ZE + KE + QE, eL = "\\ufe0e\\ufe0f", tL = "[" + $2 + "]", W0 = "[" + JE + "]", G0 = "\\ud83c[\\udffb-\\udfff]", nL = "(?:" + W0 + "|" + G0 + ")", F2 = "[^" + $2 + "]", z2 = "(?:\\ud83c[\\udde6-\\uddff]){2}", U2 = "[\\ud800-\\udbff][\\udc00-\\udfff]", aL = "\\u200d", H2 = nL + "?", Y2 = "[" + eL + "]?", iL = "(?:" + aL + "(?:" + [F2, z2, U2].join("|") + ")" + Y2 + H2 + ")*", rL = Y2 + H2 + iL, sL = "(?:" + [F2 + W0 + "?", W0, z2, U2, tL].join("|") + ")", oL = RegExp(G0 + "(?=" + G0 + ")|" + sL + rL, "g");
function lL(t) {
  return t.match(oL) || [];
}
var cL = lL, uL = XE, dL = ef, hL = cL;
function fL(t) {
  return dL(t) ? hL(t) : uL(t);
}
var pL = fL, mL = /\s/;
function gL(t) {
  for (var e = t.length; e-- && mL.test(t.charAt(e)); )
    ;
  return e;
}
var bL = gL, vL = bL, yL = /^\s+/;
function _L(t) {
  return t && t.slice(0, vL(t) + 1).replace(yL, "");
}
var TL = _L, xL = TL, Xm = Hr, wL = qu, Zm = NaN, kL = /^[-+]0x[0-9a-f]+$/i, CL = /^0b[01]+$/i, SL = /^0o[0-7]+$/i, AL = parseInt;
function EL(t) {
  if (typeof t == "number")
    return t;
  if (wL(t))
    return Zm;
  if (Xm(t)) {
    var e = typeof t.valueOf == "function" ? t.valueOf() : t;
    t = Xm(e) ? e + "" : e;
  }
  if (typeof t != "string")
    return t === 0 ? t : +t;
  t = xL(t);
  var n = CL.test(t);
  return n || SL.test(t) ? AL(t.slice(2), n ? 2 : 8) : kL.test(t) ? Zm : +t;
}
var LL = EL, DL = LL, IL = 1 / 0, ML = 17976931348623157e292;
function OL(t) {
  if (!t)
    return t === 0 ? t : 0;
  if (t = DL(t), t === IL || t === -1 / 0) {
    var e = t < 0 ? -1 : 1;
    return e * ML;
  }
  return t === t ? t : 0;
}
var PL = OL, BL = PL;
function RL(t) {
  var e = BL(t), n = e % 1;
  return e === e ? n ? e - n : e : 0;
}
var NL = RL, $L = D2;
function FL(t) {
  return t == null ? "" : $L(t);
}
var Pl = FL, Km = D2, zL = rE, UL = ef, HL = Hr, YL = kE, jL = WE, VL = pL, qL = NL, Qm = Pl, WL = 30, GL = "...", XL = /\w*$/;
function ZL(t, e) {
  var n = WL, a = GL;
  if (HL(e)) {
    var i = "separator" in e ? e.separator : i;
    n = "length" in e ? qL(e.length) : n, a = "omission" in e ? Km(e.omission) : a;
  }
  t = Qm(t);
  var r = t.length;
  if (UL(t)) {
    var s = VL(t);
    r = s.length;
  }
  if (n >= r)
    return t;
  var o = n - jL(a);
  if (o < 1)
    return a;
  var l = s ? zL(s, 0, o).join("") : t.slice(0, o);
  if (i === void 0)
    return l + a;
  if (s && (o += l.length - o), YL(i)) {
    if (t.slice(o).search(i)) {
      var c, u = l;
      for (i.global || (i = RegExp(i.source, Qm(XL.exec(i)) + "g")), i.lastIndex = 0; c = i.exec(u); )
        var f = c.index;
      l = l.slice(0, f === void 0 ? o : f);
    }
  } else if (t.indexOf(Km(i), o) != o) {
    var m = l.lastIndexOf(i);
    m > -1 && (l = l.slice(0, m));
  }
  return l + a;
}
var KL = ZL;
const QL = /* @__PURE__ */ ka(KL);
function JL(t) {
  return function(e) {
    return t == null ? void 0 : t[e];
  };
}
var j2 = JL, eD = j2, tD = {
  "&amp;": "&",
  "&lt;": "<",
  "&gt;": ">",
  "&quot;": '"',
  "&#39;": "'"
}, nD = eD(tD), aD = nD, iD = Pl, rD = aD, V2 = /&(?:amp|lt|gt|quot|#39);/g, sD = RegExp(V2.source);
function oD(t) {
  return t = iD(t), t && sD.test(t) ? t.replace(V2, rD) : t;
}
var lD = oD;
const cD = /* @__PURE__ */ ka(lD);
function wi(t = "", e = Number.POSITIVE_INFINITY) {
  if (t == null)
    return t;
  const n = cD(
    t.replace(/(<([^>]+)>)/gi, "").replace(/"/gi, "")
  );
  return QL(n, {
    length: e,
    omission: "…",
    separator: /\s/
  });
}
const uD = {
  name: "BlockCardWithIllustration",
  components: {
    SmartLink: Xe,
    IllustrationBookBinding: ve(() => import("./illustration-book-binding-CgZ-Lhg2.js")),
    IllustrationBorrowingBooks: ve(() => import("./illustration-borrowing-books-B8qR2SUi.js")),
    IllustrationDatabases: ve(() => import("./illustration-databases-D85yQ2d_.js")),
    IllustrationDigitizedResources: HA,
    /* : defineAsyncComponent(() =>
      import(
        'ucla-library-design-tokens/assets/svgs/illustration-digitized-resources.svg'
      )), */
    IllustrationFindSpace: ve(() => import("./illustration-find-space-Cp5L5B6y.js")),
    IllustrationRemoteAccess: ve(() => import("./illustration-remote-access-B1gfhv8X.js")),
    IllustrationResearch: ve(() => import("./illustration-research-BET8HhYT.js")),
    IllustrationTeaching: VA
    /* : defineAsyncComponent(() =>
      import(
        'ucla-library-design-tokens/assets/svgs/illustration-teaching.svg'
      )), */
  },
  props: {
    iconName: {
      type: String,
      default: "illustration-remote-access"
    },
    category: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    to: {
      type: String,
      default: ""
    },
    isHorizontal: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    classes() {
      return [
        "block-card-with-illustration",
        `color-${this.sectionName}`,
        { "is-horizontal": this.isHorizontal }
      ];
    },
    sectionName() {
      return pa(this.to);
    },
    parsedSvgName() {
      return `${this.iconName}`;
    },
    isExternalLink() {
      return !!this.to.includes("http");
    },
    parsedTextHorizontal() {
      return this.text ? wi(this.text, 250) : "";
    },
    parsedTextVertical() {
      return this.text ? wi(this.text) : "";
    }
  }
}, dD = { class: "meta" }, hD = ["innerHTML"], fD = ["innerHTML"], pD = {
  key: 2,
  class: "text"
}, mD = {
  key: 3,
  class: "text"
};
function gD(t, e, n, a, i, r) {
  const s = lt("SmartLink");
  return h(), b("li", {
    class: re(r.classes)
  }, [
    (h(), G(dt(r.parsedSvgName), {
      class: "svg",
      "aria-hidden": "true"
    })),
    k("div", dD, [
      n.category ? (h(), b("div", {
        key: 0,
        class: "category",
        innerHTML: n.category
      }, null, 8, hD)) : A("", !0),
      n.to ? (h(), G(s, {
        key: 1,
        to: n.to
      }, {
        default: oe(() => [
          k("h3", {
            class: "title",
            innerHTML: n.title
          }, null, 8, fD)
        ]),
        _: 1
      }, 8, ["to"])) : A("", !0),
      n.isHorizontal ? (h(), b("div", pD, ne(r.parsedTextHorizontal), 1)) : (h(), b("div", mD, ne(r.parsedTextVertical), 1))
    ])
  ], 2);
}
const bD = /* @__PURE__ */ ge(uD, [["render", gD], ["__scopeId", "data-v-73a377ce"]]);
function vD(t = "") {
  return Ct(new Date(t), "dd");
}
const yD = { class: "image-container" }, _D = {
  key: 0,
  class: "floating-highlight"
}, TD = {
  key: 1,
  class: "clipped-date"
}, xD = ["innerHTML"], wD = ["innerHTML"], kD = {
  key: 3,
  class: "molecule-no-image"
}, CD = /* @__PURE__ */ Ce({
  __name: "BlockClippedDate",
  props: {
    image: {
      type: Object,
      default: () => {
      }
    },
    to: {
      type: String,
      default: ""
    },
    category: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    alternativeFullName: {
      type: String,
      default: ""
    },
    language: {
      type: String,
      default: ""
    },
    startDate: {
      type: String,
      default: ""
    },
    endDate: {
      type: String,
      default: ""
    },
    ongoing: {
      type: Boolean,
      default: !1
    },
    imageAspectRatio: {
      type: Number,
      default: 0
    },
    locations: {
      type: Array,
      default: () => []
    },
    text: {
      type: String,
      default: ""
    },
    bylineOne: {
      type: String,
      default: ""
    },
    bylineTwo: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: ""
      // This will be "visit", "about", "help".
    },
    sectionHandle: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = t, n = Yn(), a = I(() => e.color || (n !== void 0 && n.path ? pa(n.path) : "default")), i = I(() => ["block-clipped-date", `color-${a.value}`]), r = I(() => e.startDate ? vD(e.startDate) : ""), s = I(() => e.startDate ? A2(e.startDate) : "");
    return (o, l) => (h(), b("li", {
      class: re(i.value)
    }, [
      k("div", yD, [
        t.startDate ? (h(), b("div", _D)) : A("", !0),
        t.startDate ? (h(), b("div", TD, [
          t.startDate ? (h(), b("time", {
            key: 0,
            class: "month",
            innerHTML: s.value
          }, null, 8, xD)) : A("", !0),
          t.startDate ? (h(), b("time", {
            key: 1,
            class: "day",
            innerHTML: r.value
          }, null, 8, wD)) : A("", !0)
        ])) : A("", !0),
        t.image ? (h(), G(dn, {
          key: 2,
          media: t.image,
          "aspect-ratio": t.imageAspectRatio,
          class: "image"
        }, null, 8, ["media", "aspect-ratio"])) : (h(), b("div", kD, [
          Q(O(Js), {
            class: "molecule",
            "aria-hidden": "true"
          })
        ]))
      ]),
      Q(Uu, {
        to: t.to,
        category: t.category,
        title: t.title,
        "start-date": t.startDate,
        "end-date": t.endDate,
        ongoing: t.ongoing,
        text: t.text,
        "byline-one": t.bylineOne,
        "byline-two": t.bylineTwo,
        locations: t.locations,
        "alternative-full-name": t.alternativeFullName,
        language: t.language,
        "section-handle": t.sectionHandle
      }, null, 8, ["to", "category", "title", "start-date", "end-date", "ongoing", "text", "byline-one", "byline-two", "locations", "alternative-full-name", "language", "section-handle"])
    ], 2));
  }
}), SD = /* @__PURE__ */ ge(CD, [["__scopeId", "data-v-3b7fb1a0"]]), AD = {
  width: "81",
  height: "80",
  viewBox: "0 0 81 80",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__graphic-chevron-right"
};
function ED(t, e) {
  return h(), b("svg", AD, e[0] || (e[0] = [
    k("path", {
      d: "M8.934 79.601 24.819 41.251M24.817 79.601 40.702 41.251M40.702 79.601 56.587 41.251M56.585 79.601 72.471 41.251",
      stroke: "#0AA5FF",
      "stroke-width": "1.5"
    }, null, -1),
    k("path", {
      d: "M24.819 39.35 8.934 1M40.702 39.35 24.817 1M56.587 39.35 40.702 1M72.471 39.35 56.585 1",
      stroke: "#00E0E0",
      "stroke-width": "1.5",
      class: "svg__stroke--wayfinder"
    }, null, -1)
  ]));
}
const Bl = { render: ED }, LD = {
  name: "BlockDate",
  components: {
    SvgArrowDown: Bl
  },
  // TODO See ticket in internal system for notes on this. TLDR: Use JS date objects
  // Then have date-fns format function as computed to show date and day
  props: {
    date: {
      type: String,
      default: ""
    },
    day: {
      type: String,
      default: ""
    }
  }
}, DD = { class: "block-date" }, ID = { class: "date" }, MD = { class: "day" };
function OD(t, e, n, a, i, r) {
  const s = lt("SvgArrowDown");
  return h(), b("div", DD, [
    Q(s, { class: "svg" }),
    k("div", ID, ne(n.date), 1),
    k("div", MD, ne(n.day), 1)
  ]);
}
const Che = /* @__PURE__ */ ge(LD, [["render", OD], ["__scopeId", "data-v-8c66c801"]]), PD = {
  name: "BlockEvent",
  components: { SmartLink: Xe },
  props: {
    title: {
      type: String,
      default: ""
    },
    category: {
      type: String,
      default: ""
    },
    startDate: {
      type: String,
      default: ""
    },
    endDate: {
      type: String,
      default: ""
    },
    prompt: {
      type: String,
      default: "View"
    },
    to: {
      type: String,
      default: ""
    },
    sectionHandle: {
      type: String,
      default: ""
    }
  },
  computed: {
    classes() {
      return ["block-event", `button color-${this.sectionName}`];
    },
    sectionName() {
      return pa(this.to);
    },
    parsedDate() {
      return ya(this.startDate, this.endDate);
    },
    parsedSingledDate() {
      return Ct(new Date(this.startDate), "MMMM d, Y");
    },
    parsedTime() {
      return this.startDate && this.sectionHandle === "event" ? Zi(this.startDate, this.endDate) : "";
    }
  }
}, BD = { class: "text row" }, RD = { class: "category" }, ND = ["textContent"], $D = { class: "date-time" }, FD = ["textContent"], zD = ["textContent"];
function UD(t, e, n, a, i, r) {
  const s = lt("SmartLink");
  return h(), b("div", {
    class: re(r.classes)
  }, [
    e[0] || (e[0] = k("div", { class: "molecule row" }, null, -1)),
    k("div", BD, [
      k("span", RD, ne(n.category), 1),
      k("h2", {
        class: "title",
        textContent: ne(n.title)
      }, null, 8, ND),
      k("div", $D, [
        n.startDate ? (h(), b("time", {
          key: 0,
          class: "dates",
          textContent: ne(r.parsedDate)
        }, null, 8, FD)) : A("", !0),
        r.parsedTime ? (h(), b("time", {
          key: 1,
          class: "time",
          textContent: ne(r.parsedTime)
        }, null, 8, zD)) : A("", !0)
      ]),
      Q(s, {
        class: re(r.classes),
        to: n.to,
        textContent: ne(n.prompt)
      }, null, 8, ["class", "to", "textContent"])
    ]),
    e[1] || (e[1] = k("div", { class: "sizer" }, null, -1))
  ], 2);
}
const HD = /* @__PURE__ */ ge(PD, [["render", UD], ["__scopeId", "data-v-39052f8d"]]), YD = { class: "image-container" }, jD = {
  key: 1,
  class: "molecule-no-image"
}, VD = {
  key: 2,
  class: "clipped"
}, qD = /* @__PURE__ */ Ce({
  __name: "BlockFloatingHighlight",
  props: {
    image: {
      type: Object,
      default: () => {
      }
    },
    to: {
      type: String,
      default: ""
    },
    category: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    alternativeFullName: {
      type: String,
      default: ""
    },
    language: {
      type: String,
      default: ""
    },
    startDate: {
      type: String,
      default: ""
    },
    endDate: {
      type: String,
      default: ""
    },
    ongoing: {
      type: Boolean,
      default: !1
    },
    hasTriangle: {
      type: Boolean,
      default: !0
    },
    isVertical: {
      type: Boolean,
      default: !0
    },
    imageAspectRatio: {
      type: Number,
      default: 0
    },
    locations: {
      type: Array,
      default: () => []
    },
    text: {
      type: String,
      default: ""
    },
    bylineOne: {
      type: String,
      default: ""
    },
    bylineTwo: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: ""
      // This will be "visit", "about", "help".
    },
    sectionHandle: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = t, n = Yn(), a = I(() => e.color || (n !== void 0 && n.path ? pa(n.path) : "default")), i = I(() => [
      "block-floating-highlight",
      { "is-vertical": e.isVertical },
      { "has-triangle": e.hasTriangle },
      `color-${a.value}`
    ]);
    return (r, s) => (h(), b("li", {
      class: re(i.value)
    }, [
      k("div", YD, [
        t.image ? (h(), G(dn, {
          key: 0,
          media: t.image,
          "aspect-ratio": t.imageAspectRatio,
          class: "image"
        }, null, 8, ["media", "aspect-ratio"])) : (h(), b("div", jD, [
          Q(O(Js), {
            class: "molecule",
            "aria-hidden": "true"
          })
        ])),
        t.hasTriangle ? (h(), b("div", VD, s[0] || (s[0] = [
          k("div", { class: "floating-highlight" }, null, -1),
          k("div", { class: "clipped-box" }, null, -1)
        ]))) : A("", !0)
      ]),
      Q(Uu, {
        to: t.to,
        category: t.category,
        title: t.title,
        "start-date": t.startDate,
        "end-date": t.endDate,
        ongoing: t.ongoing,
        text: t.text,
        "byline-one": t.bylineOne,
        "byline-two": t.bylineTwo,
        locations: t.locations,
        "alternative-full-name": t.alternativeFullName,
        language: t.language,
        "section-handle": t.sectionHandle
      }, null, 8, ["to", "category", "title", "start-date", "end-date", "ongoing", "text", "byline-one", "byline-two", "locations", "alternative-full-name", "language", "section-handle"])
    ], 2));
  }
}), q2 = /* @__PURE__ */ ge(qD, [["__scopeId", "data-v-b22f8d83"]]), WD = { class: "block-generic-list" }, GD = {
  key: 0,
  class: "category"
}, XD = ["lang"], ZD = {
  key: 2,
  class: "title-no-link"
}, KD = {
  key: 3,
  class: "byline-group"
}, QD = {
  key: 0,
  class: "schedule-item"
}, JD = {
  key: 0,
  class: "schedule-item"
}, eI = {
  key: 4,
  class: "location-group"
}, tI = {
  key: 5,
  class: "text"
}, nI = /* @__PURE__ */ Ce({
  __name: "BlockGenericList",
  props: {
    title: {
      type: String,
      default: ""
    },
    alternativeFullName: {
      type: String,
      default: ""
    },
    language: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    jobRequisitionNumber: {
      type: String,
      default: ""
    },
    jobPostingURL: {
      type: String,
      default: ""
    },
    departments: {
      type: Array,
      default: () => []
    },
    associatedLocations: {
      type: Array,
      default: () => []
    },
    payRate: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = t, n = I(() => e.text ? wi(e.text, 250) : "");
    return (a, i) => (h(), b("li", WD, [
      t.jobRequisitionNumber ? (h(), b("div", GD, " JOB #" + ne(t.jobRequisitionNumber), 1)) : A("", !0),
      t.jobPostingURL ? (h(), G(Xe, {
        key: 1,
        to: t.jobPostingURL,
        class: "title"
      }, {
        default: oe(() => [
          ze(ne(t.title) + " ", 1),
          t.alternativeFullName ? (h(), b("span", {
            key: 0,
            lang: t.language,
            class: "translation"
          }, ne(t.alternativeFullName), 9, XD)) : A("", !0)
        ]),
        _: 1
      }, 8, ["to"])) : (h(), b("h3", ZD, ne(t.title), 1)),
      t.departments.length || t.payRate ? (h(), b("div", KD, [
        t.departments.length || t.payRate ? (h(), b("div", QD, [
          (h(!0), b(he, null, Le(t.departments, (r, s) => (h(), b("div", {
            key: `block-generic-${r.title}-${s}`,
            class: "schedule-item"
          }, ne(r.title), 1))), 128)),
          t.payRate ? (h(), b("div", JD, ne(t.payRate), 1)) : A("", !0)
        ])) : A("", !0)
      ])) : A("", !0),
      t.associatedLocations.length > 0 ? (h(), b("div", eI, [
        (h(!0), b(he, null, Le(t.associatedLocations, (r, s) => (h(), G(en, {
          key: `block-generic-${r.title}-${s}`,
          text: r.title,
          "icon-name": "svg-icon-location",
          to: r.to
        }, null, 8, ["text", "to"]))), 128))
      ])) : A("", !0),
      t.text ? (h(), b("div", tI, ne(n.value), 1)) : A("", !0)
    ]));
  }
}), aI = /* @__PURE__ */ ge(nI, [["__scopeId", "data-v-36828094"]]), iI = { class: "block-hours" }, rI = { class: "content" }, sI = ["src"], oI = /* @__PURE__ */ Ce({
  __name: "BlockHours",
  props: {
    lid: {
      type: String,
      default: ""
    },
    isClicc: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    const e = t, n = K(null), a = I(() => e.isClicc ? "https://www.library.ucla.edu/blockCliccHours.html?lid=0" : `https://www.library.ucla.edu/blockHours.html?lid=${e.lid}`);
    return st(() => {
      window.addEventListener(
        "message",
        (i) => {
          const r = i.data[0], s = i.data[1];
          r === "setHeight" && n.value && (n.value.style.height = `${s + 20}px`);
        },
        !1
      );
    }), (i, r) => (h(), b("div", iI, [
      r[0] || (r[0] = k("h3", { class: "title" }, " Hours ", -1)),
      k("div", rI, [
        k("iframe", {
          id: "the-iframe",
          ref_key: "iframeRef",
          ref: n,
          title: "Hours for location",
          class: "iframe",
          src: a.value,
          frameBorder: "0",
          width: "100%",
          height: "100%"
        }, null, 8, sI),
        Q(sn, {
          label: "All Library Hours",
          "is-secondary": !0,
          to: "https://calendar.library.ucla.edu/hours",
          class: "btn-lnk"
        })
      ])
    ]));
  }
}), She = /* @__PURE__ */ ge(oI, [["__scopeId", "data-v-7fde24c0"]]), lI = {
  key: 0,
  class: "block-info-top-wrapper"
}, cI = {
  key: 1,
  class: "block-info-mid-wrapper"
}, uI = {
  key: 2,
  class: "block-info-end-wrapper"
}, dI = {
  __name: "BlockInfo",
  props: {
    colorScheme: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = qe(), n = I(() => ["block-info", t.colorScheme, (e == null ? void 0 : e.value) || ""]);
    return (a, i) => (h(), b("div", {
      class: re(n.value)
    }, [
      a.$slots["block-info-top"] ? (h(), b("div", lI, [
        me(a.$slots, "block-info-top", {}, void 0, !0)
      ])) : A("", !0),
      a.$slots["block-info-mid"] ? (h(), b("div", cI, [
        me(a.$slots, "block-info-mid", {}, void 0, !0)
      ])) : A("", !0),
      a.$slots["block-info-end"] ? (h(), b("div", uI, [
        me(a.$slots, "block-info-end", {}, void 0, !0)
      ])) : A("", !0)
    ], 2));
  }
}, hI = /* @__PURE__ */ ge(dI, [["__scopeId", "data-v-84e90e59"]]), fI = { class: "card-container" }, pI = { class: "image-container" }, mI = {
  key: 1,
  class: "molecule-no-image"
}, gI = { class: "library" }, bI = { class: "text" }, vI = {
  key: 0,
  class: "time"
}, yI = { key: 0 }, _I = {
  key: 1,
  class: "hour"
}, TI = {
  key: 2,
  class: "amenities"
}, xI = { class: "tooltiptext" }, wI = /* @__PURE__ */ Ce({
  __name: "BlockLocationListItem",
  props: {
    image: {
      type: Object,
      default: () => {
      }
    },
    title: {
      type: String,
      default: ""
    },
    to: {
      type: String,
      default: ""
    },
    address: {
      type: String,
      default: ""
    },
    addressLink: {
      type: String,
      default: ""
    },
    amenities: {
      type: Array,
      default: () => []
    },
    reserveSeat: {
      type: String,
      default: ""
    },
    isUclaLibrary: {
      type: Boolean,
      default: !0
    },
    affiliateLibraryUrl: {
      type: String,
      default: ""
    },
    locationType: {
      type: String,
      default: ""
    },
    campusMapId: {
      type: String,
      default: ""
    },
    libcalSpacesUrl: {
      type: String,
      default: ""
    },
    libcalLocationIdForHours: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = t, n = ve(
      () => import("./icon-phone-DPv-PoqA.js")
    ), a = ve(
      () => Promise.resolve().then(() => Bp)
    ), i = ve(
      () => import("./icon-location-DNog__Cl.js")
    ), r = ve(
      () => import("./icon-clock-CG3EE-5W.js")
    ), s = ve(
      () => import("./icon-accessible-C8Gup1rK.js")
    ), o = ve(
      () => import("./icon-chair-D8fW8Dnx.js")
    ), l = ve(
      () => import("./icon-virtual-CwZieS3s.js")
    ), c = ve(
      () => import("./icon-laptop-Bmg8PSn7.js")
    ), u = ve(
      () => import("./icon-locker-BBQPsbYg.js")
    ), f = ve(
      () => import("./icon-light-wkkuRssP.js")
    ), m = ve(
      () => Promise.resolve().then(() => S2)
    ), _ = ve(
      () => import("./icon-book-Dhs3bbZ0.js")
    ), T = {
      IconPhone: n,
      IconCalendar: a,
      IconLocation: i,
      IconClock: r,
      IconAccessible: s,
      IconChair: o,
      IconVirtual: l,
      IconLaptop: c,
      IconLocker: u,
      IconLight: f,
      IconShare: m,
      IconBook: _
    }, g = K(null);
    function x() {
      const E = `https://calendar.library.ucla.edu/api_hours_today.php?iid=3244&lid=${e.libcalLocationIdForHours}&format=json&systemTime=0`;
      fetch(E).then((P) => P.json()).then((P) => {
        g.value = {
          ...P.locations[0],
          ...P.locations[0].times
        };
      }).catch((P) => {
        console.error(P);
      });
    }
    const S = I(() => e.isUclaLibrary ? "ucla" : "affiliate"), D = I(() => ["block-location-list-item", `color-${S.value}`]), L = I(() => {
      var E, P, B;
      return ((E = g == null ? void 0 : g.value) == null ? void 0 : E.status) === "open" ? `${g.value.hours[0].from} -  ${g.value.hours[0].to}` : ((P = g == null ? void 0 : g.value) == null ? void 0 : P.status) === "text" ? g.value.text : (B = g == null ? void 0 : g.value) == null ? void 0 : B.status;
    }), M = I(() => !!(e.image && Object.keys(e.image).length !== 0));
    return st(() => {
      x();
    }), (E, P) => (h(), b("div", {
      class: re(D.value)
    }, [
      k("div", fI, [
        k("div", pI, [
          M.value ? (h(), G(dn, {
            key: 0,
            class: "image",
            media: e.image
          }, null, 8, ["media"])) : (h(), b("div", mI, [
            Q(O(Js), {
              class: "molecule",
              "aria-hidden": "true"
            })
          ]))
        ]),
        k("div", gI, [
          k("div", null, [
            e.to ? (h(), G(Xe, {
              key: 0,
              to: e.to,
              class: "title"
            }, {
              default: oe(() => [
                ze(ne(e.title), 1)
              ]),
              _: 1
            }, 8, ["to"])) : (h(), G(Xe, {
              key: 1,
              to: e.affiliateLibraryUrl,
              class: "title"
            }, {
              default: oe(() => [
                ze(ne(e.title), 1)
              ]),
              _: 1
            }, 8, ["to"]))
          ]),
          k("div", bI, [
            g.value && e.isUclaLibrary ? (h(), b("div", vI, [
              Q(O(r)),
              g.value.day ? (h(), b("span", yI, ne("Today"))) : A("", !0),
              g.value.status !== "not-set" ? (h(), b("div", _I, [
                k("span", null, ne(L.value), 1)
              ])) : A("", !0)
            ])) : A("", !0),
            e.reserveSeat ? (h(), G(en, {
              key: 1,
              text: "Reserve a Seat",
              "icon-name": "svg-icon-calendar",
              to: e.reserveSeat,
              class: "reserve"
            }, null, 8, ["to"])) : A("", !0),
            Q(en, {
              text: e.address,
              "icon-name": "svg-icon-location",
              to: e.addressLink,
              class: "location"
            }, null, 8, ["text", "to"]),
            e.amenities ? (h(), b("div", TI, [
              (h(!0), b(he, null, Le(t.amenities, (B) => (h(), b("div", {
                key: `amenity-${B.title}`,
                class: "tooltip"
              }, [
                k("span", xI, ne(B.title), 1),
                (h(), G(dt(T[B.icon]), { class: "svg" }))
              ]))), 128))
            ])) : A("", !0)
          ])
        ])
      ])
    ], 2));
  }
}), kI = /* @__PURE__ */ ge(wI, [["__scopeId", "data-v-fd39eb52"]]), CI = {
  width: "81",
  height: "80",
  viewBox: "0 0 81 80",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__molecule-headphones"
};
function SI(t, e) {
  return h(), b("svg", CI, e[0] || (e[0] = [
    ri('<path d="M40.5 0L68.7843 11.7157L80.5 40L68.7843 68.2843L40.5 80L12.2158 68.2843L0.5 40L12.2158 11.7157L40.5 0Z" fill="#0B6AB7" class="svg__fill--primary-blue-03"></path><rect x="24.5566" y="40.8452" width="5.15" height="16.5937" rx="0.655858" stroke="white" stroke-width="1.25" class="svg__stroke--white"></rect><rect x="-0.625" y="0.625" width="5.14976" height="16.5937" rx="0.655858" transform="matrix(-1 0 0 1 55.8071 40.2202)" stroke="white" stroke-width="1.25" class="svg__stroke--white"></rect><path d="M60 51.25L59.9368 41.3155C59.8688 30.628 51.1858 22 40.4981 22V22C29.8075 22 21.1233 30.6325 21.0593 41.3229L21 51.25" stroke="white" stroke-width="1.25" class="svg__stroke--white"></path><path d="M24 54.9702L24.079 55.5902L24.625 55.5206V54.9702H24ZM21.75 54.5292L21.3181 54.981L21.75 54.5292ZM21.0015 52.5255L21.6218 52.4491L21.0015 52.5255ZM23.375 44.5V54.9702H24.625V44.5H23.375ZM21.625 52.4999V44.5H20.375V52.4999H21.625ZM24 54.9702C23.921 54.3502 23.9211 54.3502 23.9213 54.3502C23.9213 54.3502 23.9214 54.3501 23.9215 54.3501C23.9216 54.3501 23.9217 54.3501 23.9218 54.3501C23.922 54.3501 23.9221 54.3501 23.9221 54.3501C23.9221 54.3501 23.9217 54.3501 23.921 54.3502C23.9195 54.3504 23.9166 54.3507 23.9124 54.3512C23.9039 54.3521 23.8901 54.3536 23.8715 54.3554C23.8342 54.3589 23.7782 54.3636 23.7082 54.3675C23.567 54.3754 23.3743 54.3797 23.166 54.3667C22.7039 54.3377 22.3445 54.2328 22.1819 54.0774L21.3181 54.981C21.8273 55.4676 22.5928 55.5832 23.0878 55.6142C23.358 55.6312 23.6019 55.6254 23.7776 55.6156C23.866 55.6107 23.9386 55.6047 23.9903 55.5997C24.0161 55.5973 24.0369 55.5951 24.0518 55.5934C24.0593 55.5925 24.0654 55.5918 24.0699 55.5913C24.0722 55.591 24.0741 55.5908 24.0756 55.5906C24.0764 55.5905 24.077 55.5904 24.0776 55.5903C24.0779 55.5903 24.0781 55.5903 24.0784 55.5902C24.0785 55.5902 24.0786 55.5902 24.0787 55.5902C24.0788 55.5902 24.079 55.5902 24 54.9702ZM22.1819 54.0774C22.0372 53.9391 21.8896 53.6214 21.7768 53.2149C21.6728 52.8401 21.6288 52.5057 21.6218 52.4491L20.3811 52.6018C20.3917 52.6872 20.4449 53.0899 20.5723 53.5491C20.6909 53.9766 20.9088 54.5897 21.3181 54.981L22.1819 54.0774ZM20.375 52.4999C20.375 52.5295 20.3764 52.5635 20.3811 52.6018L21.6218 52.4491C21.623 52.4588 21.6238 52.4684 21.6244 52.4779C21.6249 52.4872 21.625 52.4948 21.625 52.4999H20.375ZM22.5 43.625C22.9832 43.625 23.375 44.0168 23.375 44.5H24.625C24.625 43.3264 23.6736 42.375 22.5 42.375V43.625ZM22.5 42.375C21.3264 42.375 20.375 43.3264 20.375 44.5H21.625C21.625 44.0168 22.0167 43.625 22.5 43.625V42.375Z" fill="white" class="svg__fill--white"></path><path d="M57 54.9702L56.921 55.5902L56.375 55.5206V54.9702H57ZM59.25 54.5292L58.8181 54.0774L58.8181 54.0774L59.25 54.5292ZM59.9985 52.5255L60.6189 52.6018L59.9985 52.5255ZM57.625 44.5V54.9702H56.375V44.5H57.625ZM59.375 52.4999V44.5H60.625V52.4999H59.375ZM57 54.9702C57.079 54.3502 57.0789 54.3502 57.0787 54.3502C57.0787 54.3502 57.0786 54.3501 57.0785 54.3501C57.0784 54.3501 57.0783 54.3501 57.0782 54.3501C57.078 54.3501 57.0779 54.3501 57.0779 54.3501C57.0779 54.3501 57.0783 54.3501 57.079 54.3502C57.0805 54.3504 57.0834 54.3507 57.0876 54.3512C57.0961 54.3521 57.1099 54.3536 57.1285 54.3554C57.1658 54.3589 57.2218 54.3636 57.2918 54.3675C57.433 54.3754 57.6257 54.3797 57.834 54.3667C58.2961 54.3377 58.6555 54.2328 58.8181 54.0774L59.6819 54.981C59.1727 55.4676 58.4072 55.5832 57.9122 55.6142C57.642 55.6312 57.3981 55.6254 57.2224 55.6156C57.134 55.6107 57.0614 55.6047 57.0097 55.5997C56.9839 55.5973 56.9631 55.5951 56.9482 55.5934C56.9407 55.5925 56.9346 55.5918 56.9301 55.5913C56.9278 55.591 56.9259 55.5908 56.9244 55.5906C56.9236 55.5905 56.923 55.5904 56.9224 55.5903C56.9221 55.5903 56.9219 55.5903 56.9216 55.5902C56.9215 55.5902 56.9214 55.5902 56.9213 55.5902C56.9212 55.5902 56.921 55.5902 57 54.9702ZM58.8181 54.0774C58.9628 53.9391 59.1104 53.6214 59.2232 53.2149C59.3272 52.8401 59.3712 52.5057 59.3782 52.4491L60.6189 52.6018C60.6083 52.6872 60.5551 53.0899 60.4277 53.5491C60.3091 53.9766 60.0912 54.5897 59.6819 54.981L58.8181 54.0774ZM60.625 52.4999C60.625 52.5295 60.6236 52.5635 60.6189 52.6018L59.3782 52.4491C59.377 52.4588 59.3762 52.4684 59.3756 52.4779C59.3751 52.4872 59.375 52.4948 59.375 52.4999H60.625ZM58.5 43.625C58.0168 43.625 57.625 44.0168 57.625 44.5H56.375C56.375 43.3264 57.3264 42.375 58.5 42.375V43.625ZM58.5 42.375C59.6736 42.375 60.625 43.3264 60.625 44.5H59.375C59.375 44.0168 58.9833 43.625 58.5 43.625V42.375Z" fill="white" class="svg__fill--white"></path>', 6)
  ]));
}
const t0 = { render: SI }, AI = { class: "text-grouping" }, EI = ["innerHTML"], LI = { class: "meta-mobile" }, DI = {
  key: 1,
  class: "no-media-mobile"
}, II = { class: "clippy" }, MI = {
  key: 0,
  class: "floating-highlight-mobile"
}, OI = {
  key: 1,
  class: "clipped-play-mobile"
}, PI = ["innerHTML"], BI = { class: "clippy" }, RI = {
  key: 0,
  class: "floating-highlight"
}, NI = {
  key: 1,
  class: "clipped-play"
}, $I = {
  key: 1,
  class: "no-media"
}, FI = /* @__PURE__ */ Ce({
  __name: "BlockMediaWithText",
  props: {
    sectionHeader: {
      type: String,
      default: ""
    },
    shortDescription: {
      type: String,
      default: ""
    },
    buttonText: {
      type: String,
      default: ""
    },
    buttonUrl: {
      type: String,
      default: ""
    },
    embedCode: {
      type: String,
      default: ""
    },
    typeMedia: {
      type: String,
      default: ""
    },
    item: {
      type: Array,
      default: () => []
    },
    coverImage: {
      type: Array,
      default: () => []
    }
  },
  setup(t) {
    const e = t, n = qe(), a = I(() => ["media-with-text", (n == null ? void 0 : n.value) || ""]), i = ve(() => import("./icon-play-filled-Dvcf_yQh.js")), r = ve(() => Promise.resolve().then(() => dw)), s = ve(() => Promise.resolve().then(() => Ml)), o = ve(() => Promise.resolve().then(() => Xre)), l = ve(() => Promise.resolve().then(() => Mse)), c = K(!1), u = I(() => e.typeMedia === "audio" || e.item && e.item[0] && e.item[0].kind === "audio"), f = I(() => e.typeMedia === "video" || e.item && e.item[0] && e.item[0].kind === "video"), m = I(() => [
      {
        item: e.item,
        coverImage: e.coverImage,
        embedCode: e.embedCode,
        captionTitle: e.sectionHeader,
        captionText: e.shortDescription
      }
    ]), _ = I(() => !!(e.buttonUrl && e.typeMedia === "other"));
    return (T, g) => (h(), b("div", {
      class: re(a.value)
    }, [
      k("div", AI, [
        k("h3", {
          class: "section-header",
          innerHTML: t.sectionHeader
        }, null, 8, EI),
        k("div", LI, [
          t.item || t.coverImage ? (h(), G(O(o), {
            key: 0,
            item: t.item,
            "cover-image": t.coverImage,
            "cover-only": !0,
            class: "media-mobile",
            onClick: g[0] || (g[0] = (x) => c.value = !0)
          }, null, 8, ["item", "cover-image"])) : A("", !0),
          t.item || t.coverImage ? A("", !0) : (h(), b("div", DI)),
          k("div", II, [
            f.value || u.value ? (h(), b("div", MI)) : A("", !0),
            f.value || u.value ? (h(), b("div", OI)) : A("", !0),
            f.value || u.value ? (h(), G(O(i), {
              key: 2,
              class: "icon-play-filled-mobile"
            })) : A("", !0)
          ]),
          u.value ? (h(), G(O(t0), {
            key: 2,
            class: "icon-headphones-mobile"
          })) : A("", !0)
        ]),
        t.shortDescription ? (h(), b("div", {
          key: 0,
          class: "short-description",
          innerHTML: t.shortDescription
        }, null, 8, PI)) : A("", !0),
        t.buttonUrl && O(n) !== "ftva" ? (h(), G(O(s), {
          key: 1,
          class: "button",
          to: t.buttonUrl,
          label: t.buttonText,
          "is-secondary": !0,
          "is-download": _.value
        }, null, 8, ["to", "label", "is-download"])) : (h(), G(O(r), {
          key: 2,
          to: t.buttonUrl,
          class: "text-link"
        }, {
          default: oe(() => [
            ze(ne(t.buttonText), 1)
          ]),
          _: 1
        }, 8, ["to"]))
      ]),
      t.item || t.coverImage ? (h(), G(O(o), {
        key: 0,
        item: t.item,
        "cover-image": t.coverImage,
        "cover-only": !0,
        "object-fit": O(n) === "ftva" ? "cover" : "contain",
        class: "meta media",
        onClick: g[1] || (g[1] = (x) => u.value || f.value ? c.value = !0 : c.value = !1)
      }, {
        default: oe(() => [
          k("div", BI, [
            f.value || u.value ? (h(), b("div", RI)) : A("", !0),
            f.value || u.value ? (h(), b("div", NI)) : A("", !0),
            f.value || u.value ? (h(), G(O(i), {
              key: 2,
              class: "icon-play-filled"
            })) : A("", !0)
          ]),
          u.value ? (h(), G(O(t0), {
            key: 0,
            class: "icon-headphones"
          })) : A("", !0),
          u.value ? (h(), G(O(t0), {
            key: 1,
            class: "icon-headphones"
          })) : A("", !0)
        ]),
        _: 1
      }, 8, ["item", "cover-image", "object-fit"])) : A("", !0),
      t.item || t.coverImage ? A("", !0) : (h(), b("div", $I)),
      c.value ? (h(), G(O(l), {
        key: 2,
        items: m.value,
        onCloseModal: g[2] || (g[2] = (x) => c.value = !1),
        onKeydown: g[3] || (g[3] = Li((x) => c.value = !1, ["esc"]))
      }, null, 8, ["items"])) : A("", !0)
    ], 2));
  }
}), zI = /* @__PURE__ */ ge(FI, [["__scopeId", "data-v-b922c7d3"]]), UI = { class: "meta" }, HI = { class: "category" }, YI = { class: "title" }, jI = { class: "author" }, VI = /* @__PURE__ */ Ce({
  __name: "BlockPostSmall",
  props: {
    to: {
      type: String,
      required: !0
    },
    image: {
      type: Object,
      default: () => ({})
    }
  },
  setup(t) {
    const e = qe(), n = I(() => pa(t.to)), a = I(() => (e == null ? void 0 : e.value) === "ftva" ? ["block-post-small", "ftva"] : ["block-post-small", `color-${n.value}`]);
    return (i, r) => (h(), b("div", null, [
      Q(Xe, {
        to: t.to,
        class: re(a.value)
      }, {
        default: oe(() => [
          t.image ? (h(), G(dn, {
            key: 0,
            media: t.image,
            "aspect-ratio": 100,
            class: "image"
          }, null, 8, ["media"])) : A("", !0),
          k("div", UI, [
            k("div", HI, [
              me(i.$slots, "category", {}, void 0, !0)
            ]),
            k("h3", YI, [
              me(i.$slots, "title", {}, void 0, !0)
            ]),
            k("div", jI, [
              me(i.$slots, "author", {}, void 0, !0)
            ])
          ])
        ]),
        _: 3
      }, 8, ["to", "class"])
    ]));
  }
}), qI = /* @__PURE__ */ ge(VI, [["__scopeId", "data-v-08c046f9"]]), WI = {
  __name: "BlockRemoveSearchFilter",
  props: {
    title: {
      type: String,
      default: ""
    },
    iconName: {
      type: String,
      required: !1
    },
    isSelected: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["removeBlockFilter"],
  setup(t, { emit: e }) {
    const n = e, a = ve(
      () => Promise.resolve().then(() => p2)
    ), i = ve(
      () => Promise.resolve().then(() => uU)
    ), r = {
      SvgGlyphClose: a,
      SvgGlyphX: i
    }, s = Yn(), o = qe(), l = I(() => s !== void 0 && s.path ? pa(s.path) : "default"), c = I(() => ["block-remove-search-filter", (o == null ? void 0 : o.value) || "", `color-${l.value}`, t.isSelected && (o != null && o.value) ? "selected" : ""]), u = I(() => {
      switch (o == null ? void 0 : o.value) {
        case "ftva":
          return "SvgGlyphX";
        default:
          return "SvgGlyphClose";
      }
    });
    function f() {
      n("removeBlockFilter");
    }
    return (m, _) => (h(), b("button", {
      type: "button",
      class: re(c.value),
      onClick: f
    }, [
      Q(eo, {
        label: t.title,
        "icon-name": t.iconName,
        theme: O(o),
        "is-secondary": !0
      }, {
        default: oe(() => [
          k("span", {
            class: re(["button-close", { "button-selected": t.isSelected && O(o) === "ftva" }])
          }, [
            (h(), G(dt(r[u.value])))
          ], 2)
        ]),
        _: 1
      }, 8, ["label", "icon-name", "theme"])
    ], 2));
  }
}, GI = /* @__PURE__ */ ge(WI, [["__scopeId", "data-v-29306f32"]]), XI = {
  width: "42",
  height: "48",
  viewBox: "0 0 42 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-ftva-playvideo"
};
function ZI(t, e) {
  return h(), b("svg", XI, e[0] || (e[0] = [
    k("path", {
      d: "M42 24L0.749998 47.8157L0.75 0.1843L42 24Z",
      fill: "white",
      class: "svg__fill--pure-white"
    }, null, -1)
  ]));
}
const KI = { render: ZI }, QI = {
  class: "cover-container",
  onclick: "this.nextElementSibling.style.display='block'; this.style.display='none'"
}, JI = ["src"], eM = {
  key: 0,
  class: "video-container"
}, tM = ["src"], nM = /* @__PURE__ */ Ce({
  __name: "VideoEmbed",
  props: {
    trailer: {
      type: String,
      required: !0
    },
    posterImage: {
      type: Object,
      required: !1
    }
  },
  setup(t) {
    const e = I(() => {
      var i;
      return ["video-embed", ((i = t.posterImage) == null ? void 0 : i.src) ? "has-poster" : "no-poster"];
    }), n = I(() => {
      if (!t.trailer || typeof t.trailer != "string")
        return "";
      const a = t.trailer.match(/src="([^"]+)"/);
      return a ? a[1] : "";
    });
    return (a, i) => {
      var r;
      return t.trailer ? (h(), b("div", {
        key: 0,
        class: re(e.value)
      }, [
        k("div", QI, [
          (r = t.posterImage) != null && r.src ? (h(), b("img", {
            key: 0,
            src: t.posterImage.src,
            class: "cover"
          }, null, 8, JI)) : A("", !0),
          Q(O(KI), { class: "play-button" })
        ]),
        n.value ? (h(), b("div", eM, [
          k("iframe", {
            src: n.value,
            title: "YouTube video player",
            class: "responsive-iframe",
            frameborder: "0",
            allow: "accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
            referrerpolicy: "strict-origin-when-cross-origin",
            allowfullscreen: "",
            loading: "lazy"
          }, null, 8, tM)
        ])) : A("", !0)
      ], 2)) : A("", !0);
    };
  }
}), aM = /* @__PURE__ */ ge(nM, [["__scopeId", "data-v-0ed8f82b"]]), iM = {
  key: 0,
  class: "count"
}, rM = { class: "event-title" }, sM = {
  key: 0,
  class: "title"
}, oM = {
  key: 1,
  class: "alternate-title"
}, lM = ["lang"], cM = { key: 0 }, uM = { key: 1 }, dM = { key: 2 }, hM = { key: 3 }, fM = { key: 4 }, pM = { key: 5 }, mM = { key: 6 }, gM = { key: 7 }, bM = {
  key: 1,
  class: "block-tags"
}, vM = { key: 3 }, yM = /* @__PURE__ */ Ce({
  __name: "BlockScreeningDetail",
  props: {
    screeningCount: {
      type: String,
      default: ""
    },
    count: {
      type: Number,
      default: 0
    },
    title: {
      type: String,
      default: ""
    },
    alternateTitle: {
      type: String,
      default: ""
    },
    language: {
      type: String,
      default: ""
    },
    year: {
      type: String,
      default: ""
    },
    country: {
      type: String,
      default: ""
    },
    languageInfo: {
      type: String,
      default: ""
    },
    runtime: {
      type: String,
      default: ""
    },
    tagLabels: {
      type: Array,
      default: () => []
    },
    text: {
      type: String,
      default: ""
    },
    trailer: {
      type: String,
      default: ""
    },
    image: {
      type: Object,
      default: () => {
      }
    }
  },
  setup(t) {
    const e = ve(() => Promise.resolve().then(() => m2)), n = qe(), a = I(() => ["block-screening-detail", (n == null ? void 0 : n.value) || ""]);
    return (i, r) => (h(), b("div", {
      class: re(a.value)
    }, [
      t.count > 1 ? (h(), b("div", iM, ne(t.screeningCount), 1)) : A("", !0),
      k("div", rM, [
        t.title && t.title !== null ? (h(), b("h3", sM, ne(t.title), 1)) : A("", !0),
        t.alternateTitle && t.alternateTitle !== null ? (h(), b("h4", oM, [
          ze(ne(t.alternateTitle) + " ", 1),
          t.alternateTitle && t.language && t.language !== null ? (h(), b("span", {
            key: 0,
            lang: t.language
          }, null, 8, lM)) : A("", !0)
        ])) : A("", !0)
      ]),
      k("dl", null, [
        t.year && t.year !== null ? (h(), b("dt", cM, " Year ")) : A("", !0),
        t.year && t.year !== null ? (h(), b("dd", uM, ne(t.year), 1)) : A("", !0),
        t.country && t.country !== null ? (h(), b("dt", dM, " Country ")) : A("", !0),
        t.country && t.country !== null ? (h(), b("dd", hM, ne(t.country), 1)) : A("", !0),
        t.languageInfo && t.languageInfo !== null ? (h(), b("dt", fM, " Language ")) : A("", !0),
        t.languageInfo && t.languageInfo !== null ? (h(), b("dd", pM, ne(t.languageInfo), 1)) : A("", !0),
        t.runtime && t.runtime !== null ? (h(), b("dt", mM, " Runtime ")) : A("", !0),
        t.runtime && t.runtime !== null ? (h(), b("dd", gM, ne(t.runtime), 1)) : A("", !0)
      ]),
      t.tagLabels && t.tagLabels.length > 0 ? (h(), b("div", bM, [
        (h(!0), b(he, null, Le(t.tagLabels, (s) => (h(), G(O(e), {
          key: `tag-${s.title}`,
          label: s.title,
          "is-secondary": !0,
          class: "tag-label"
        }, null, 8, ["label"]))), 128))
      ])) : A("", !0),
      t.text && t.text !== null ? (h(), G(un, {
        key: 2,
        class: "text",
        "rich-text-content": t.text
      }, null, 8, ["rich-text-content"])) : A("", !0),
      t.trailer && t.trailer !== null ? (h(), b("div", vM, [
        t.trailer || t.image ? (h(), G(Wh, {
          key: 0,
          "aspect-ratio": 56.9,
          controls: !0
        }, {
          default: oe(() => [
            t.trailer || t.image ? (h(), G(aM, {
              key: 0,
              trailer: t.trailer,
              "poster-image": t.image
            }, null, 8, ["trailer", "poster-image"])) : A("", !0)
          ]),
          _: 1
        })) : A("", !0)
      ])) : A("", !0)
    ], 2));
  }
}), _M = /* @__PURE__ */ ge(yM, [["__scopeId", "data-v-373c8d55"]]), TM = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-collapse"
};
function xM(t, e) {
  return h(), b("svg", TM, e[0] || (e[0] = [
    k("path", {
      d: "M8.00014 16.0314 24 15.9656",
      stroke: "#0B6AB7",
      "stroke-width": "1.5",
      "stroke-linejoin": "round",
      class: "svg__stroke--primary-blue-03"
    }, null, -1)
  ]));
}
const wM = { render: xM }, kM = {
  width: "80",
  height: "80",
  viewBox: "0 0 80 80",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__molecule-stroke"
};
function CM(t, e) {
  return h(), b("svg", kM, e[0] || (e[0] = [
    k("path", {
      d: "M12.2898 12.2897L40 0.811795L67.7103 12.2897L79.1882 40L67.7103 67.7103L40 79.1882L12.2898 67.7103L0.811795 40L12.2898 12.2897Z",
      stroke: "#0AA5FF",
      "stroke-width": "1.5",
      class: "svg__stroke--default-cyan-03"
    }, null, -1)
  ]));
}
const tf = { render: CM }, SM = {
  name: "ButtonHide",
  components: {
    IconCollapse: wM,
    MoleculeStroke: tf
  },
  props: {
    text: {
      type: String,
      default: "See Less"
    }
  }
}, AM = { class: "button-hide" }, EM = {
  class: "icon",
  "aria-hidden": "true"
}, LM = { class: "text" };
function DM(t, e, n, a, i, r) {
  const s = lt("MoleculeStroke"), o = lt("IconCollapse");
  return h(), b("button", AM, [
    k("div", EM, [
      Q(s, { class: "molecule-stroke" }),
      Q(o, { class: "icon-collapse" })
    ]),
    k("div", LM, ne(n.text), 1)
  ]);
}
const IM = /* @__PURE__ */ ge(SM, [["render", DM], ["__scopeId", "data-v-799177e1"]]), MM = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-expand"
};
function OM(t, e) {
  return h(), b("svg", MM, e[0] || (e[0] = [
    k("path", {
      d: "m16.0333 23.0381-.0652-14.07692",
      stroke: "#0B6AB7",
      "stroke-width": "1.5",
      "stroke-linejoin": "round",
      class: "svg__stroke--primary-blue-03"
    }, null, -1),
    k("path", {
      d: "m8.95828 16.0291 14.08422-.0579",
      stroke: "#0B6AB7",
      "stroke-width": "1.5",
      "stroke-linejoin": "round",
      class: "svg__stroke--primary-blue-03"
    }, null, -1)
  ]));
}
const PM = { render: OM }, BM = {
  name: "ButtonShow",
  components: {
    IconExpand: PM,
    MoleculeStroke: tf
  },
  props: {
    text: {
      type: String,
      default: "See More"
    }
  }
}, RM = { class: "button-show" }, NM = {
  class: "icon",
  "aria-hidden": "true"
}, $M = { class: "text" };
function FM(t, e, n, a, i, r) {
  const s = lt("MoleculeStroke"), o = lt("IconExpand");
  return h(), b("button", RM, [
    k("div", NM, [
      Q(s, { class: "molecule-stroke" }),
      Q(o, { class: "icon-expand" })
    ]),
    k("div", $M, ne(n.text), 1)
  ]);
}
const zM = /* @__PURE__ */ ge(BM, [["render", FM], ["__scopeId", "data-v-ae8c2342"]]), UM = {
  name: "BlockShowHide",
  components: { ButtonShow: zM, ButtonHide: IM },
  props: {
    disable: {
      type: Boolean,
      default: !1
    },
    tag: {
      type: String,
      default: "div"
    }
  },
  data() {
    return { shown: !1 };
  },
  computed: {
    classes() {
      return ["block-show-hide", this.shown ? "shown" : "hidden"];
    }
  }
};
function HM(t, e, n, a, i, r) {
  const s = lt("ButtonHide"), o = lt("ButtonShow");
  return h(), G(dt(n.tag), {
    class: re(r.classes)
  }, {
    default: oe(() => [
      me(t.$slots, "default", {}, void 0, !0),
      !n.disable && i.shown ? (h(), G(s, {
        key: 0,
        class: "button-toggle",
        onClick: e[0] || (e[0] = (l) => i.shown = !1)
      })) : n.disable ? A("", !0) : (h(), G(o, {
        key: 1,
        class: "button-toggle",
        onClick: e[1] || (e[1] = (l) => i.shown = !0)
      }))
    ]),
    _: 3
  }, 8, ["class"]);
}
const W2 = /* @__PURE__ */ ge(UM, [["render", HM], ["__scopeId", "data-v-37bd57a5"]]), YM = {
  width: "32",
  height: "33",
  viewBox: "0 0 32 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-external-link"
};
function G2(t, e) {
  return h(), b("svg", YM, e[0] || (e[0] = [
    k("g", { "clip-path": "url(#a)" }, [
      k("path", {
        d: "m11.878 19.5671 9.5414-9.5415",
        stroke: "#0B6AB7",
        "stroke-width": "1.5",
        "stroke-linecap": "square",
        "stroke-linejoin": "round",
        class: "svg__stroke--primary-blue-03"
      }),
      k("path", {
        d: "M22.7092 19.5667v.75h-1.5v-.75h1.5Zm-.75-10.08159v-.75h.75v.75h-.75Zm-10.0815.74999h-.75V8.73511h.75v1.49999Zm9.3315 9.3316V9.48511h1.5V19.5667h-1.5Zm.75-9.3316H11.8777V8.73511h10.0815v1.49999Z",
        fill: "#0B6AB7",
        class: "svg__fill--primary-blue-03"
      }),
      k("path", {
        d: "M7 25.4744h14.2857",
        stroke: "#0AA5FF",
        "stroke-width": "1.5",
        class: "svg__stroke--default-cyan-03"
      })
    ], -1)
  ]));
}
const Xu = { render: G2 }, X2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Xu,
  render: G2
}, Symbol.toStringTag, { value: "Module" })), jM = {
  width: "32",
  height: "33",
  viewBox: "0 0 32 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-arrow-right"
};
function Z2(t, e) {
  return h(), b("svg", jM, e[0] || (e[0] = [
    k("g", {
      stroke: "#0B6AB7",
      "stroke-width": "1.5",
      "stroke-linecap": "square",
      "stroke-linejoin": "round",
      class: "svg__stroke--primary-blue-03"
    }, [
      k("path", { d: "M9 16.729h13.25" }),
      k("path", { d: "m16 23.729 7-7-7-7" })
    ], -1)
  ]));
}
const vi = { render: Z2 }, VM = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: vi,
  render: Z2
}, Symbol.toStringTag, { value: "Module" })), qM = { class: "section" }, WM = { class: "title2" }, GM = {
  key: 0,
  class: "text"
}, XM = {
  class: "svg-meta",
  "aria-hidden": "true"
}, ZM = {
  __name: "BlockSimpleCard",
  props: {
    title: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    to: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = qe(), n = I(() => pa(t.to)), a = I(() => ["block-simple-card", `color-${n.value}`, (e == null ? void 0 : e.value) || ""]), i = I(() => qh(t.to) ? vi : Xu), r = I(() => t.text ? wi(t.text, 250) : "");
    return (s, o) => (h(), b("li", {
      class: re(a.value)
    }, [
      k("span", qM, ne(n.value), 1),
      k("h3", WM, [
        t.title ? (h(), G(O(Xe), {
          key: 0,
          to: t.to,
          class: "title"
        }, {
          default: oe(() => [
            ze(ne(t.title), 1)
          ]),
          _: 1
        }, 8, ["to"])) : A("", !0)
      ]),
      t.text ? (h(), b("div", GM, ne(r.value), 1)) : A("", !0),
      o[0] || (o[0] = k("div", { class: "spacer" }, null, -1)),
      k("div", XM, [
        (h(), G(dt(i.value), { class: "svg" }))
      ])
    ], 2));
  }
}, KM = /* @__PURE__ */ ge(ZM, [["__scopeId", "data-v-e01b3892"]]), QM = {
  name: "BlockSpaces",
  components: {
    SvgHeadingArrow: Bl,
    SmartLink: Xe,
    ButtonLink: sn,
    RichText: un
  },
  props: {
    to: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    isOnline: {
      type: Boolean,
      default: !1
    },
    text: {
      type: String,
      default: ""
    },
    buttonText: {
      type: String,
      default: "Reserve"
    }
  }
}, JM = { class: "block-spaces" }, eO = { class: "arrow-and-title" }, tO = {
  key: 0,
  class: "space-title"
}, nO = ["innerHTML"], aO = { class: "meta" };
function iO(t, e, n, a, i, r) {
  const s = lt("SvgHeadingArrow"), o = lt("SmartLink"), l = lt("RichText"), c = lt("ButtonLink");
  return h(), b("li", JM, [
    (h(), G(dt(n.to ? "SmartLink" : "div"), {
      to: n.to,
      class: "container"
    }, {
      default: oe(() => [
        k("div", eO, [
          Q(s, { class: "heading-arrow" }),
          n.to ? (h(), b("h3", tO, [
            Q(o, { to: n.to }, {
              default: oe(() => [
                ze(ne(n.title), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ])) : (h(), b("h3", {
            key: 1,
            class: "space-title-no-link",
            innerHTML: n.title
          }, null, 8, nO))
        ]),
        k("div", aO, [
          n.text ? (h(), G(l, {
            key: 0,
            class: "text",
            "rich-text-content": n.text
          }, null, 8, ["rich-text-content"])) : A("", !0),
          n.to ? (h(), G(c, {
            key: 1,
            class: "button",
            "button-url": n.to,
            label: n.buttonText,
            "is-secondary": !0,
            to: n.to,
            "link-target": "_blank"
          }, null, 8, ["button-url", "label", "to"])) : A("", !0)
        ])
      ]),
      _: 1
    }, 8, ["to"]))
  ]);
}
const rO = /* @__PURE__ */ ge(QM, [["render", iO], ["__scopeId", "data-v-ceb4a4c3"]]), sO = {
  name: "BlockSponsor",
  components: {
    SmartLink: Xe
  },
  props: {
    funderLogo: {
      type: Array,
      default: () => []
    },
    funderName: {
      type: String,
      default: ""
    },
    funderUrl: {
      type: String,
      default: ""
    }
  },
  computed: {
    parsedFunderLogo() {
      return this.funderLogo[0];
    }
  }
}, oO = ["src", "alt"];
function lO(t, e, n, a, i, r) {
  const s = lt("SmartLink");
  return h(), G(s, {
    to: n.funderUrl,
    "link-target": "_blank"
  }, {
    default: oe(() => [
      k("img", {
        src: r.parsedFunderLogo.src,
        alt: n.funderName,
        class: "block-sponsor"
      }, null, 8, oO)
    ]),
    _: 1
  }, 8, ["to"]);
}
const cO = /* @__PURE__ */ ge(sO, [["render", lO], ["__scopeId", "data-v-7f3e4b64"]]), uO = {
  key: 1,
  class: "molecule-no-image"
}, dO = { class: "meta" }, hO = ["innerHTML"], fO = { key: 1 }, pO = {
  key: 0,
  class: "description-summary-only"
}, mO = {
  key: 2,
  class: "byline"
}, gO = ["innerHTML"], bO = ["innerHTML"], vO = {
  key: 1,
  class: "description"
}, yO = {
  key: 3,
  class: "ftva-description"
}, _O = {
  key: 4,
  class: "ftva-date"
}, TO = /* @__PURE__ */ Ce({
  __name: "BlockStaffArticleList",
  props: {
    image: {
      type: Object,
      default: () => {
      }
    },
    to: {
      type: String,
      default: ""
    },
    category: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    authors: {
      type: Array,
      default: () => []
    },
    date: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    imageAspectRatio: {
      type: Number,
      default: 0
    }
  },
  setup(t) {
    const e = t, n = qe(), a = I(() => ["block-staff-article-item", (n == null ? void 0 : n.value) || ""]), i = I(() => Ct(new Date(e.date), "MMMM d, Y")), r = I(() => !!(e.image && Object.keys(e.image).length !== 0)), s = I(() => e.description ? wi(e.description, 130) : ""), o = I(() => e.description ? wi(e.description, 250) : "");
    return (l, c) => (h(), b("li", {
      class: re(a.value)
    }, [
      r.value ? (h(), G(dn, {
        key: 0,
        media: e.image,
        "aspect-ratio": e.imageAspectRatio,
        "object-fit": "cover",
        class: "image"
      }, null, 8, ["media", "aspect-ratio"])) : (h(), b("div", uO, [
        Q(O(Js), {
          class: "molecule",
          "aria-hidden": "true"
        })
      ])),
      k("div", dO, [
        e.category ? (h(), b("div", {
          key: 0,
          class: "category",
          innerHTML: e.category
        }, null, 8, hO)) : A("", !0),
        Q(Xe, {
          class: "title",
          to: e.to,
          innerHTML: e.title
        }, null, 8, ["to", "innerHTML"]),
        e.authors.length === 0 && e.date === "" && e.description ? (h(), b("div", fO, [
          e.description ? (h(), b("div", pO, ne(o.value), 1)) : A("", !0)
        ])) : A("", !0),
        e.authors && e.authors.length > 0 || e.date !== "" ? (h(), b("div", mO, [
          (h(!0), b(he, null, Le(e.authors, (u) => (h(), b("div", {
            key: u.id,
            class: "author",
            innerHTML: u.title
          }, null, 8, gO))), 128)),
          e.date ? (h(), b("div", {
            key: 0,
            class: "date",
            innerHTML: i.value
          }, null, 8, bO)) : A("", !0),
          e.description ? (h(), b("div", vO, ne(s.value), 1)) : A("", !0)
        ])) : A("", !0),
        l.$slots.customFTVADescription ? (h(), b("div", yO, [
          me(l.$slots, "customFTVADescription", {}, void 0, !0)
        ])) : A("", !0),
        l.$slots.customFTVADate ? (h(), b("div", _O, [
          me(l.$slots, "customFTVADate", {}, void 0, !0)
        ])) : A("", !0)
      ])
    ], 2));
  }
}), xO = /* @__PURE__ */ ge(TO, [["__scopeId", "data-v-aae3d273"]]), wO = /* @__PURE__ */ Ce({
  __name: "DividerWayFinder",
  props: {
    color: {
      type: String,
      default: ""
      // "visit", "about", "help", "ftva"
    }
  },
  setup(t) {
    const e = Yn(), n = qe(), a = K((e == null ? void 0 : e.path) || ""), i = I(() => t.color || (a.value !== "" ? pa(a.value) : "default")), r = I(() => [
      "divider-way-finder",
      `color-${i.value}`,
      (n == null ? void 0 : n.value) || ""
    ]);
    return Kb(() => {
      a.value = (e == null ? void 0 : e.path) || "";
    }), st(() => {
      a.value = (e == null ? void 0 : e.path) || "";
    }), (s, o) => (h(), b("div", {
      class: re(r.value)
    }, o[0] || (o[0] = [
      k("div", { class: "solid" }, null, -1),
      k("div", { class: "dotted" }, null, -1)
    ]), 2));
  }
}), bl = /* @__PURE__ */ ge(wO, [["__scopeId", "data-v-5a6618eb"]]), kO = { class: "block-staff-detail" }, CO = { class: "heading-staff" }, SO = { class: "header" }, AO = { class: "staffName" }, EO = ["lang"], LO = {
  key: 0,
  class: "pronouns"
}, DO = { class: "section-staff-bio" }, IO = { class: "info-container" }, MO = { class: "staff-info" }, OO = ["innerHTML"], PO = {
  key: 0,
  class: "departments"
}, BO = {
  key: 1,
  class: "location-group"
}, RO = { class: "contact-info-list" }, NO = { class: "contact-info" }, $O = {
  key: 0,
  class: "contact-info"
}, FO = {
  key: 1,
  class: "contact-info"
}, zO = { class: "body-bio" }, UO = {
  key: 1,
  class: "ask-me-about"
}, HO = { class: "list topics" }, YO = ["innerHTML"], jO = {
  key: 3,
  class: "biography"
}, VO = /* @__PURE__ */ Ce({
  __name: "BlockStaffDetail",
  props: {
    image: {
      type: Object,
      default: () => {
      }
    },
    to: {
      type: String,
      default: ""
    },
    staffName: {
      type: String,
      default: ""
    },
    nameLast: {
      type: String,
      default: ""
    },
    nameFirst: {
      type: String,
      default: ""
    },
    alternativeName: {
      type: Array,
      default: () => []
    },
    jobTitle: {
      type: String,
      default: ""
    },
    departments: {
      type: Array,
      default: () => []
    },
    // merge this with ask-me-about data and then sort it
    academicDepartments: {
      type: Array,
      default: () => []
    },
    // topics is the ask-me-about data
    topics: {
      // ask-me-about
      type: Array,
      default: () => []
    },
    locations: {
      type: Array,
      default: () => []
    },
    email: {
      type: String,
      default: ""
    },
    phone: {
      type: String,
      default: ""
    },
    consultation: {
      type: String,
      default: ""
    },
    language: {
      type: String,
      default: ""
    },
    pronouns: {
      type: String,
      default: ""
    },
    biography: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = t, n = I(() => `Pronouns: ${e.pronouns}`), a = I(() => `${e.nameFirst} ${e.nameLast}`), i = I(() => e.alternativeName[0].fullName), r = I(() => e.alternativeName[0].languageAltName), s = I(() => e.topics.concat(e.academicDepartments).sort(
      (o, l) => o.title.toUpperCase() > l.title.toUpperCase() ? 1 : l.title.toUpperCase() > o.title.toUpperCase() ? -1 : 0
    ));
    return (o, l) => (h(), b("div", kO, [
      k("div", CO, [
        Q(O(Bl)),
        k("div", SO, [
          k("h1", AO, [
            ze(ne(a.value) + " ", 1),
            t.alternativeName.length ? (h(), b("span", {
              key: 0,
              lang: r.value
            }, ne(i.value), 9, EO)) : A("", !0)
          ]),
          t.pronouns ? (h(), b("div", LO, ne(n.value), 1)) : A("", !0)
        ])
      ]),
      k("div", DO, [
        k("div", {
          class: re(t.image ? "body-contact" : "body-contact no-image")
        }, [
          t.image ? (h(), G(dn, {
            key: 0,
            media: t.image,
            "aspect-ratio": 100,
            class: "image"
          }, null, 8, ["media"])) : A("", !0),
          k("div", IO, [
            k("div", MO, [
              k("div", {
                class: "job-title",
                innerHTML: t.jobTitle
              }, null, 8, OO),
              t.departments.length ? (h(), b("ul", PO, [
                (h(!0), b(he, null, Le(t.departments, (c, u) => (h(), b("li", {
                  key: u,
                  class: "department"
                }, ne(c.title), 1))), 128))
              ])) : A("", !0),
              t.locations.length ? (h(), b("ul", BO, [
                (h(!0), b(he, null, Le(t.locations, (c, u) => (h(), b("li", {
                  key: `location-${u}`,
                  class: "location"
                }, [
                  Q(en, {
                    text: c.title ?? "",
                    "icon-name": "svg-icon-location",
                    to: `/${c.to}`
                  }, null, 8, ["text", "to"])
                ]))), 128))
              ])) : A("", !0)
            ]),
            k("div", RO, [
              k("div", NO, [
                Q(en, {
                  text: t.email,
                  "icon-name": "svg-icon-email",
                  to: `mailto:${t.email}`
                }, null, 8, ["text", "to"])
              ]),
              t.phone ? (h(), b("div", $O, [
                Q(en, {
                  text: t.phone,
                  "icon-name": "svg-icon-phone",
                  to: `tel:${t.phone}`
                }, null, 8, ["text", "to"])
              ])) : A("", !0),
              t.consultation ? (h(), b("div", FO, [
                Q(en, {
                  text: "Book a consultation",
                  "icon-name": "svg-icon-consultation",
                  to: t.consultation
                }, null, 8, ["to"])
              ])) : A("", !0)
            ])
          ])
        ], 2),
        k("div", zO, [
          t.topics.length || t.academicDepartments.length ? (h(), G(bl, {
            key: 0,
            class: "divider divider-first",
            color: "about"
          })) : A("", !0),
          t.topics.length || t.academicDepartments.length ? (h(), b("div", UO, [
            l[0] || (l[0] = k("h2", { class: "section-title" }, " Ask Me About ", -1)),
            Q(un, null, {
              default: oe(() => [
                k("ul", HO, [
                  (h(!0), b(he, null, Le(s.value, (c) => (h(), b("li", {
                    key: c.id,
                    innerHTML: c.title
                  }, null, 8, YO))), 128))
                ])
              ]),
              _: 1
            })
          ])) : A("", !0),
          t.biography ? (h(), G(bl, {
            key: 2,
            class: "divider divider-first",
            color: "about"
          })) : A("", !0),
          t.biography ? (h(), b("div", jO, [
            l[1] || (l[1] = k("h2", { class: "section-title" }, " Biography ", -1)),
            Q(un, { "rich-text-content": t.biography }, null, 8, ["rich-text-content"])
          ])) : A("", !0)
        ])
      ])
    ]));
  }
}), Ahe = /* @__PURE__ */ ge(VO, [["__scopeId", "data-v-e8d5d235"]]), qO = { class: "block-staff-list" }, WO = {
  key: 0,
  class: "no-image"
}, GO = { class: "meta" }, XO = { class: "name-title" }, ZO = { class: "staff-name" }, KO = ["lang"], QO = ["innerHTML"], JO = {
  key: 0,
  class: "departments"
}, eP = { class: "department" }, tP = { class: "contact-info" }, nP = { class: "email" }, aP = {
  key: 0,
  class: "phone"
}, iP = {
  key: 1,
  class: "consultation"
}, rP = {
  key: 2,
  class: "locations"
}, sP = /* @__PURE__ */ Ce({
  __name: "BlockStaffList",
  props: {
    to: {
      type: String,
      default: ""
    },
    image: {
      type: Object,
      default: () => {
      }
    },
    staffName: {
      type: String,
      default: ""
    },
    alternativeFullName: {
      type: String,
      default: ""
    },
    language: {
      type: String,
      default: ""
    },
    jobTitle: {
      type: String,
      default: ""
    },
    email: {
      type: String,
      default: ""
    },
    phone: {
      type: String,
      default: ""
    },
    departments: {
      type: Array,
      default: () => []
    },
    consultation: {
      type: String,
      default: ""
    },
    locations: {
      type: Array,
      default: () => []
    }
  },
  setup(t) {
    const e = t, n = I(() => e.departments[e.departments.length - 1].title);
    return (a, i) => (h(), b("li", qO, [
      Q(dn, {
        media: t.image,
        "aspect-ratio": 100,
        sizes: "300px",
        class: "image"
      }, null, 8, ["media"]),
      t.image ? A("", !0) : (h(), b("div", WO, [
        Q(O(Bl), { class: "icon-heading-arrow" })
      ])),
      k("div", GO, [
        k("div", XO, [
          k("h3", ZO, [
            Q(Xe, { to: t.to }, {
              default: oe(() => [
                ze(ne(t.staffName) + " ", 1),
                t.alternativeFullName ? (h(), b("span", {
                  key: 0,
                  lang: t.language
                }, ne(t.alternativeFullName), 9, KO)) : A("", !0)
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          k("div", {
            class: "job-title",
            innerHTML: t.jobTitle
          }, null, 8, QO),
          t.departments.length ? (h(), b("ul", JO, [
            k("li", eP, ne(n.value), 1)
          ])) : A("", !0)
        ]),
        k("div", tP, [
          k("div", nP, [
            Q(en, {
              text: t.email,
              "icon-name": "svg-icon-email",
              to: `mailto:${t.email}`
            }, null, 8, ["text", "to"])
          ]),
          t.phone ? (h(), b("div", aP, [
            Q(en, {
              text: t.phone,
              "icon-name": "svg-icon-phone",
              to: `tel:${t.phone}`
            }, null, 8, ["text", "to"])
          ])) : A("", !0),
          t.consultation ? (h(), b("div", iP, [
            Q(en, {
              text: "Book a consultation",
              "icon-name": "svg-icon-consultation",
              to: t.consultation
            }, null, 8, ["to"])
          ])) : A("", !0),
          t.locations.length ? (h(), b("div", rP, [
            (h(!0), b(he, null, Le(t.locations, (r, s) => (h(), G(en, {
              key: `${s}`,
              text: r.title ?? "",
              "icon-name": "svg-icon-location",
              to: r.uri
            }, null, 8, ["text", "to"]))), 128))
          ])) : A("", !0)
        ])
      ])
    ]));
  }
}), oP = /* @__PURE__ */ ge(sP, [["__scopeId", "data-v-32f4be86"]]);
/*!
 *  @preserve
 *
 * ++++++++++++++++++++++++++++++++++++++
 * Add to Calendar TimeZones iCal Library
 * ++++++++++++++++++++++++++++++++++++++
 *
 * Version: 1.9.1
 * Creator: Jens Kuerschner (https://jenskuerschner.de)
 * Project: https://github.com/add2cal/timezones-ical-library
 * License: Apache-2.0
 *
 */
const oa = { Zulu: ["Etc/UTC", 0], WET: ["Europe/Lisbon", 1], "W-SU": ["Europe/Moscow", 2], Universal: ["Etc/UTC", 0], UTC: ["Etc/UTC", 0], UCT: ["Etc/UTC", 0], Turkey: ["Europe/Istanbul", 3], Singapore: ["Asia/Singapore", 4], ROK: ["Asia/Seoul", 5], ROC: ["Asia/Taipei", 6], Portugal: ["Europe/Lisbon", 1], Poland: ["Europe/Warsaw", 7], PST8PDT: ["America/Los_Angeles", 8], PRC: ["Asia/Shanghai", 9], Navajo: ["America/Denver", 10], NZ: ["Pacific/Auckland", 11], "NZ-CHAT": ["Pacific/Chatham", 12], MST7MDT: ["America/Denver", 10], MST: ["America/Phoenix", 13], MET: ["Europe/Brussels", 14], Libya: ["Africa/Tripoli", 15], Kwajalein: ["Pacific/Kwajalein", 16], Japan: ["Asia/Tokyo", 17], Jamaica: ["America/Jamaica", 18], Israel: ["Asia/Jerusalem", 19], Iran: ["Asia/Tehran", 20], Iceland: ["Africa/Abidjan", 21], Hongkong: ["Asia/Hong_Kong", 22], HST: ["Pacific/Honolulu", 23], Greenwich: ["Etc/GMT", 24], GMT0: ["Etc/GMT", 24], GMT: ["Etc/GMT", 24], "GMT-0": ["Etc/GMT", 24], "GMT+0": ["Etc/GMT", 24], GB: ["Europe/London", 25], "GB-Eire": ["Europe/London", 25], Eire: ["Europe/Dublin", 26], Egypt: ["Africa/Cairo", 27], EST5EDT: ["America/New_York", 28], EST: ["America/Panama", 29], EET: ["Europe/Athens", 30], Cuba: ["America/Havana", 31], CST6CDT: ["America/Chicago", 32], CET: ["Europe/Brussels", 14], US: { Samoa: ["Pacific/Pago_Pago", 33], Pacific: ["America/Los_Angeles", 8], Mountain: ["America/Denver", 10], Michigan: ["America/Detroit", 34], "Indiana-Starke": ["America/Indiana/Knox", 35], Hawaii: ["Pacific/Honolulu", 23], Eastern: ["America/New_York", 28], "East-Indiana": ["America/Indiana/Indianapolis", 36], Central: ["America/Chicago", 32], Arizona: ["America/Phoenix", 13], Aleutian: ["America/Adak", 37], Alaska: ["America/Anchorage", 38] }, Pacific: { Yap: ["Pacific/Port_Moresby", 39], Wallis: ["Pacific/Tarawa", 40], Wake: ["Pacific/Tarawa", 40], Truk: ["Pacific/Port_Moresby", 39], Tongatapu: ["", 41], Tarawa: ["", 40], Tahiti: ["", 42], Samoa: ["Pacific/Pago_Pago", 33], Saipan: ["Pacific/Guam", 43], Rarotonga: ["", 44], Port_Moresby: ["", 39], Ponape: ["Pacific/Guadalcanal", 45], Pohnpei: ["Pacific/Guadalcanal", 45], Pitcairn: ["", 46], Palau: ["", 47], Pago_Pago: ["", 33], Noumea: ["", 48], Norfolk: ["", 49], Niue: ["", 50], Nauru: ["", 51], Midway: ["Pacific/Pago_Pago", 33], Marquesas: ["", 52], Majuro: ["Pacific/Tarawa", 40], Kwajalein: ["", 16], Kosrae: ["", 53], Kiritimati: ["", 54], Kanton: ["", 55], Johnston: ["Pacific/Honolulu", 23], Honolulu: ["", 23], Guam: ["", 43], Guadalcanal: ["", 45], Gambier: ["", 56], Galapagos: ["", 57], Funafuti: ["Pacific/Tarawa", 40], Fiji: ["", 58], Fakaofo: ["", 59], Enderbury: ["Pacific/Kanton", 55], Efate: ["", 60], Easter: ["", 61], Chuuk: ["Pacific/Port_Moresby", 39], Chatham: ["", 12], Bougainville: ["", 62], Auckland: ["", 11], Apia: ["", 63] }, Mexico: { General: ["America/Mexico_City", 64], BajaSur: ["America/Mazatlan", 65], BajaNorte: ["America/Tijuana", 66] }, Indian: { Reunion: ["Asia/Dubai", 67], Mayotte: ["Africa/Nairobi", 68], Mauritius: ["", 69], Maldives: ["", 70], Mahe: ["Asia/Dubai", 67], Kerguelen: ["Indian/Maldives", 70], Comoro: ["Africa/Nairobi", 68], Cocos: ["Asia/Yangon", 71], Christmas: ["Asia/Bangkok", 72], Chagos: ["", 73], Antananarivo: ["Africa/Nairobi", 68] }, Europe: { Zurich: ["", 74], Zaporozhye: ["Europe/Kyiv", 75], Zagreb: ["Europe/Belgrade", 76], Warsaw: ["", 7], Volgograd: ["", 77], Vilnius: ["", 78], Vienna: ["", 79], Vatican: ["Europe/Rome", 80], Vaduz: ["Europe/Zurich", 74], Uzhgorod: ["Europe/Kyiv", 75], Ulyanovsk: ["", 81], Tiraspol: ["Europe/Chisinau", 82], Tirane: ["", 83], Tallinn: ["", 84], Stockholm: ["Europe/Berlin", 85], Sofia: ["", 86], Skopje: ["Europe/Belgrade", 76], Simferopol: ["", 87], Saratov: ["", 88], Sarajevo: ["Europe/Belgrade", 76], San_Marino: ["Europe/Rome", 80], Samara: ["", 89], Rome: ["", 80], Riga: ["", 90], Prague: ["", 91], Podgorica: ["Europe/Belgrade", 76], Paris: ["", 92], Oslo: ["Europe/Berlin", 85], Nicosia: ["Asia/Nicosia", 93], Moscow: ["", 2], Monaco: ["Europe/Paris", 92], Minsk: ["", 94], Mariehamn: ["Europe/Helsinki", 95], Malta: ["", 96], Madrid: ["", 97], Luxembourg: ["Europe/Brussels", 14], London: ["", 25], Ljubljana: ["Europe/Belgrade", 76], Lisbon: ["", 1], Kyiv: ["", 75], Kirov: ["", 98], Kiev: ["Europe/Kyiv", 75], Kaliningrad: ["", 99], Jersey: ["Europe/London", 25], Istanbul: ["", 3], Isle_of_Man: ["Europe/London", 25], Helsinki: ["", 95], Guernsey: ["Europe/London", 25], Gibraltar: ["", 100], Dublin: ["", 26], Copenhagen: ["Europe/Berlin", 85], Chisinau: ["", 82], Busingen: ["Europe/Zurich", 74], Budapest: ["", 101], Bucharest: ["", 102], Brussels: ["", 14], Bratislava: ["Europe/Prague", 91], Berlin: ["", 85], Belgrade: ["", 76], Belfast: ["Europe/London", 25], Athens: ["", 30], Astrakhan: ["", 103], Andorra: ["", 104], Amsterdam: ["Europe/Brussels", 14] }, Etc: { Zulu: ["Etc/UTC", 0], Universal: ["Etc/UTC", 0], UTC: ["", 0], UCT: ["Etc/UTC", 0], Greenwich: ["Etc/GMT", 24], GMT0: ["Etc/GMT", 24], GMT: ["", 24], "GMT-9": ["", 105], "GMT-8": ["", 106], "GMT-7": ["", 107], "GMT-6": ["", 108], "GMT-5": ["", 109], "GMT-4": ["", 110], "GMT-3": ["", 111], "GMT-2": ["", 112], "GMT-14": ["", 113], "GMT-13": ["", 114], "GMT-12": ["", 115], "GMT-11": ["", 116], "GMT-10": ["", 117], "GMT-1": ["", 118], "GMT-0": ["Etc/GMT", 24], "GMT+9": ["", 119], "GMT+8": ["", 120], "GMT+7": ["", 121], "GMT+6": ["", 122], "GMT+5": ["", 123], "GMT+4": ["", 124], "GMT+3": ["", 125], "GMT+2": ["", 126], "GMT+12": ["", 127], "GMT+11": ["", 128], "GMT+10": ["", 129], "GMT+1": ["", 130], "GMT+0": ["Etc/GMT", 24] }, Chile: { EasterIsland: ["Pacific/Easter", 61], Continental: ["America/Santiago", 131] }, Canada: { Yukon: ["America/Whitehorse", 132], Saskatchewan: ["America/Regina", 133], Pacific: ["America/Vancouver", 134], Newfoundland: ["America/St_Johns", 135], Mountain: ["America/Edmonton", 136], Eastern: ["America/Toronto", 137], Central: ["America/Winnipeg", 138], Atlantic: ["America/Halifax", 139] }, Brazil: { West: ["America/Manaus", 140], East: ["America/Sao_Paulo", 141], DeNoronha: ["America/Noronha", 142], Acre: ["America/Rio_Branco", 143] }, Australia: { Yancowinna: ["Australia/Broken_Hill", 144], West: ["Australia/Perth", 145], Victoria: ["Australia/Melbourne", 146], Tasmania: ["Australia/Hobart", 147], Sydney: ["", 148], South: ["Australia/Adelaide", 149], Queensland: ["Australia/Brisbane", 150], Perth: ["", 145], North: ["Australia/Darwin", 151], NSW: ["Australia/Sydney", 148], Melbourne: ["", 146], Lord_Howe: ["", 152], Lindeman: ["", 153], LHI: ["Australia/Lord_Howe", 152], Hobart: ["", 147], Eucla: ["", 154], Darwin: ["", 151], Currie: ["Australia/Hobart", 147], Canberra: ["Australia/Sydney", 148], Broken_Hill: ["", 144], Brisbane: ["", 150], Adelaide: ["", 149], ACT: ["Australia/Sydney", 148] }, Atlantic: { Stanley: ["", 155], St_Helena: ["Africa/Abidjan", 21], South_Georgia: ["", 156], Reykjavik: ["Africa/Abidjan", 21], Madeira: ["", 157], Jan_Mayen: ["Europe/Berlin", 85], Faroe: ["", 158], Faeroe: ["Atlantic/Faroe", 158], Cape_Verde: ["", 159], Canary: ["", 160], Bermuda: ["", 161], Azores: ["", 162] }, Asia: { Yerevan: ["", 163], Yekaterinburg: ["", 164], Yangon: ["", 71], Yakutsk: ["", 165], Vladivostok: ["", 166], Vientiane: ["Asia/Bangkok", 72], "Ust-Nera": ["", 167], Urumqi: ["", 168], Ulan_Bator: ["Asia/Ulaanbaatar", 169], Ulaanbaatar: ["", 169], Ujung_Pandang: ["Asia/Makassar", 170], Tomsk: ["", 171], Tokyo: ["", 17], Thimphu: ["", 172], Thimbu: ["Asia/Thimphu", 172], Tel_Aviv: ["Asia/Jerusalem", 19], Tehran: ["", 20], Tbilisi: ["", 173], Tashkent: ["", 174], Taipei: ["", 6], Srednekolymsk: ["", 175], Singapore: ["", 4], Shanghai: ["", 9], Seoul: ["", 5], Samarkand: ["", 176], Sakhalin: ["", 177], Saigon: ["Asia/Ho_Chi_Minh", 178], Riyadh: ["", 179], Rangoon: ["Asia/Yangon", 71], Qyzylorda: ["", 180], Qostanay: ["", 181], Qatar: ["", 182], Pyongyang: ["", 183], Pontianak: ["", 184], Phnom_Penh: ["Asia/Bangkok", 72], Oral: ["", 185], Omsk: ["", 186], Novosibirsk: ["", 187], Novokuznetsk: ["", 188], Nicosia: ["", 93], Muscat: ["Asia/Dubai", 67], Manila: ["", 189], Makassar: ["", 170], Magadan: ["", 190], Macau: ["", 191], Macao: ["Asia/Macau", 191], Kuwait: ["Asia/Riyadh", 179], Kuching: ["", 192], Kuala_Lumpur: ["Asia/Singapore", 4], Krasnoyarsk: ["", 193], Kolkata: ["", 194], Khandyga: ["", 195], Katmandu: ["Asia/Kathmandu", 196], Kathmandu: ["", 196], Kashgar: ["Asia/Urumqi", 168], Karachi: ["", 197], Kamchatka: ["", 198], Kabul: ["", 199], Jerusalem: ["", 19], Jayapura: ["", 200], Jakarta: ["", 201], Istanbul: ["Europe/Istanbul", 3], Irkutsk: ["", 202], Hovd: ["", 203], Hong_Kong: ["", 22], Ho_Chi_Minh: ["", 178], Hebron: ["", 204], Harbin: ["Asia/Shanghai", 9], Gaza: ["", 205], Famagusta: ["", 206], Dushanbe: ["", 207], Dubai: ["", 67], Dili: ["", 208], Dhaka: ["", 209], Damascus: ["", 210], Dacca: ["Asia/Dhaka", 209], Colombo: ["", 211], Chungking: ["Asia/Shanghai", 9], Chongqing: ["Asia/Shanghai", 9], Choibalsan: ["Asia/Ulaanbaatar", 169], Chita: ["", 212], Calcutta: ["Asia/Kolkata", 194], Brunei: ["Asia/Kuching", 192], Bishkek: ["", 213], Beirut: ["", 214], Barnaul: ["", 215], Bangkok: ["", 72], Baku: ["", 216], Bahrain: ["Asia/Qatar", 182], Baghdad: ["", 217], Atyrau: ["", 218], Ashkhabad: ["Asia/Ashgabat", 219], Ashgabat: ["", 219], Aqtobe: ["", 220], Aqtau: ["", 221], Anadyr: ["", 222], Amman: ["", 223], Almaty: ["", 224], Aden: ["Asia/Riyadh", 179] }, Arctic: { Longyearbyen: ["Europe/Berlin", 85] }, Antarctica: { Vostok: ["", 225], Troll: ["", 226], Syowa: ["Asia/Riyadh", 179], South_Pole: ["Pacific/Auckland", 11], Rothera: ["", 227], Palmer: ["", 228], McMurdo: ["Pacific/Auckland", 11], Mawson: ["", 229], Macquarie: ["", 230], DumontDUrville: ["Pacific/Port_Moresby", 39], Davis: ["", 231], Casey: ["", 232] }, America: { Yellowknife: ["America/Edmonton", 136], Yakutat: ["", 233], Winnipeg: ["", 138], Whitehorse: ["", 132], Virgin: ["America/Puerto_Rico", 234], Vancouver: ["", 134], Tortola: ["America/Puerto_Rico", 234], Toronto: ["", 137], Tijuana: ["", 66], Thunder_Bay: ["America/Toronto", 137], Thule: ["", 235], Tegucigalpa: ["", 236], Swift_Current: ["", 237], St_Vincent: ["America/Puerto_Rico", 234], St_Thomas: ["America/Puerto_Rico", 234], St_Lucia: ["America/Puerto_Rico", 234], St_Kitts: ["America/Puerto_Rico", 234], St_Johns: ["", 135], St_Barthelemy: ["America/Puerto_Rico", 234], Sitka: ["", 238], Shiprock: ["America/Denver", 10], Scoresbysund: ["", 239], Sao_Paulo: ["", 141], Santo_Domingo: ["", 240], Santiago: ["", 131], Santarem: ["", 241], Santa_Isabel: ["America/Tijuana", 66], Rosario: ["America/Argentina/Cordoba", 242], Rio_Branco: ["", 143], Resolute: ["", 243], Regina: ["", 133], Recife: ["", 244], Rankin_Inlet: ["", 245], Rainy_River: ["America/Winnipeg", 138], Punta_Arenas: ["", 246], Puerto_Rico: ["", 234], Porto_Velho: ["", 247], Porto_Acre: ["America/Rio_Branco", 143], Port_of_Spain: ["America/Puerto_Rico", 234], "Port-au-Prince": ["", 248], Phoenix: ["", 13], Paramaribo: ["", 249], Pangnirtung: ["America/Iqaluit", 250], Panama: ["", 29], Ojinaga: ["", 251], Nuuk: ["", 252], Noronha: ["", 142], Nome: ["", 253], Nipigon: ["America/Toronto", 137], New_York: ["", 28], Nassau: ["America/Toronto", 137], Montserrat: ["America/Puerto_Rico", 234], Montreal: ["America/Toronto", 137], Montevideo: ["", 254], Monterrey: ["", 255], Moncton: ["", 256], Miquelon: ["", 257], Mexico_City: ["", 64], Metlakatla: ["", 258], Merida: ["", 259], Menominee: ["", 260], Mendoza: ["America/Argentina/Mendoza", 261], Mazatlan: ["", 65], Matamoros: ["", 262], Martinique: ["", 263], Marigot: ["America/Puerto_Rico", 234], Manaus: ["", 140], Managua: ["", 264], Maceio: ["", 265], Lower_Princes: ["America/Puerto_Rico", 234], Louisville: ["America/Kentucky/Louisville", 266], Los_Angeles: ["", 8], Lima: ["", 267], La_Paz: ["", 268], Kralendijk: ["America/Puerto_Rico", 234], Knox_IN: ["America/Indiana/Knox", 35], Juneau: ["", 269], Jujuy: ["America/Argentina/Jujuy", 270], Jamaica: ["", 18], Iqaluit: ["", 250], Inuvik: ["", 271], Indianapolis: ["America/Indiana/Indianapolis", 36], Hermosillo: ["", 272], Havana: ["", 31], Halifax: ["", 139], Guyana: ["", 273], Guayaquil: ["", 274], Guatemala: ["", 275], Guadeloupe: ["America/Puerto_Rico", 234], Grenada: ["America/Puerto_Rico", 234], Grand_Turk: ["", 276], Goose_Bay: ["", 277], Godthab: ["America/Nuuk", 252], Glace_Bay: ["", 278], Fortaleza: ["", 279], Fort_Wayne: ["America/Indiana/Indianapolis", 36], Fort_Nelson: ["", 280], Ensenada: ["America/Tijuana", 66], El_Salvador: ["", 281], Eirunepe: ["", 282], Edmonton: ["", 136], Dominica: ["America/Puerto_Rico", 234], Detroit: ["", 34], Denver: ["", 10], Dawson_Creek: ["", 283], Dawson: ["", 284], Danmarkshavn: ["", 285], Curacao: ["America/Puerto_Rico", 234], Cuiaba: ["", 286], Creston: ["America/Phoenix", 13], Costa_Rica: ["", 287], Cordoba: ["America/Argentina/Cordoba", 242], Coral_Harbour: ["America/Panama", 29], Ciudad_Juarez: ["", 288], Chihuahua: ["", 289], Chicago: ["", 32], Cayman: ["America/Panama", 29], Cayenne: ["", 290], Catamarca: ["America/Argentina/Catamarca", 291], Caracas: ["", 292], Cancun: ["", 293], Campo_Grande: ["", 294], Cambridge_Bay: ["", 295], Buenos_Aires: ["America/Argentina/Buenos_Aires", 296], Boise: ["", 297], Bogota: ["", 298], Boa_Vista: ["", 299], "Blanc-Sablon": ["America/Puerto_Rico", 234], Belize: ["", 300], Belem: ["", 301], Barbados: ["", 302], Bahia_Banderas: ["", 303], Bahia: ["", 304], Atka: ["America/Adak", 37], Atikokan: ["America/Panama", 29], Asuncion: ["", 305], Aruba: ["America/Puerto_Rico", 234], Araguaina: ["", 306], Antigua: ["America/Puerto_Rico", 234], Anguilla: ["America/Puerto_Rico", 234], Anchorage: ["", 38], Adak: ["", 37], North_Dakota: { New_Salem: ["", 307], Center: ["", 308], Beulah: ["", 309] }, Kentucky: { Monticello: ["", 310], Louisville: ["", 266] }, Indiana: { Winamac: ["", 311], Vincennes: ["", 312], Vevay: ["", 313], Tell_City: ["", 314], Petersburg: ["", 315], Marengo: ["", 316], Knox: ["", 35], Indianapolis: ["", 36] }, Argentina: { Ushuaia: ["", 317], Tucuman: ["", 318], San_Luis: ["", 319], San_Juan: ["", 320], Salta: ["", 321], Rio_Gallegos: ["", 322], Mendoza: ["", 261], La_Rioja: ["", 323], Jujuy: ["", 270], Cordoba: ["", 242], ComodRivadavia: ["America/Argentina/Catamarca", 291], Catamarca: ["", 291], Buenos_Aires: ["", 296] } }, Africa: { Windhoek: ["", 324], Tunis: ["", 325], Tripoli: ["", 15], Timbuktu: ["Africa/Abidjan", 21], Sao_Tome: ["", 326], "Porto-Novo": ["Africa/Lagos", 327], Ouagadougou: ["Africa/Abidjan", 21], Nouakchott: ["Africa/Abidjan", 21], Niamey: ["Africa/Lagos", 327], Ndjamena: ["", 328], Nairobi: ["", 68], Monrovia: ["", 329], Mogadishu: ["Africa/Nairobi", 68], Mbabane: ["Africa/Johannesburg", 330], Maseru: ["Africa/Johannesburg", 330], Maputo: ["", 331], Malabo: ["Africa/Lagos", 327], Lusaka: ["Africa/Maputo", 331], Lubumbashi: ["Africa/Maputo", 331], Luanda: ["Africa/Lagos", 327], Lome: ["Africa/Abidjan", 21], Libreville: ["Africa/Lagos", 327], Lagos: ["", 327], Kinshasa: ["Africa/Lagos", 327], Kigali: ["Africa/Maputo", 331], Khartoum: ["", 332], Kampala: ["Africa/Nairobi", 68], Juba: ["", 333], Johannesburg: ["", 330], Harare: ["Africa/Maputo", 331], Gaborone: ["Africa/Maputo", 331], Freetown: ["Africa/Abidjan", 21], El_Aaiun: ["", 334], Douala: ["Africa/Lagos", 327], Djibouti: ["Africa/Nairobi", 68], Dar_es_Salaam: ["Africa/Nairobi", 68], Dakar: ["Africa/Abidjan", 21], Conakry: ["Africa/Abidjan", 21], Ceuta: ["", 335], Casablanca: ["", 336], Cairo: ["", 27], Bujumbura: ["Africa/Maputo", 331], Brazzaville: ["Africa/Lagos", 327], Blantyre: ["Africa/Maputo", 331], Bissau: ["", 337], Banjul: ["Africa/Abidjan", 21], Bangui: ["Africa/Lagos", 327], Bamako: ["Africa/Abidjan", 21], Asmera: ["Africa/Nairobi", 68], Asmara: ["Africa/Nairobi", 68], Algiers: ["", 338], Addis_Ababa: ["Africa/Nairobi", 68], Accra: ["Africa/Abidjan", 21], Abidjan: ["", 21] } }, n0 = ["20250101T220159Z<n>X-LIC-LOCATION:Etc/UTC<n><bs><n><tz>UTC<n><of>+0000<n><ot>+0000<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Lisbon<n><bs><n><tz>WET<n><of>+0100<n><ot>+0000<n><s>19701025T020000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n><bd><n><tz>WEST<n><of>+0000<n><ot>+0100<n><s>19700329T010000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Moscow<n><bs><n><tz>MSK<n><of>+0300<n><ot>+0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Istanbul<n><bs><n><tz>%z<n><of>+0300<n><ot>+0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Singapore<n><bs><n><tz>%z<n><of>+0800<n><ot>+0800<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Seoul<n><bs><n><tz>KST<n><of>+0900<n><ot>+0900<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Taipei<n><bs><n><tz>CST<n><of>+0800<n><ot>+0800<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Warsaw<n><bd><n><tz>CEST<n><of>+0100<n><ot>+0200<n><s>19700329T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>CET<n><of>+0200<n><ot>+0100<n><s>19701025T030000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Los_Angeles<n><bd><n><tz>PDT<n><of>-0800<n><ot>-0700<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>PST<n><of>-0700<n><ot>-0800<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Shanghai<n><bs><n><tz>CST<n><of>+0800<n><ot>+0800<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Denver<n><bd><n><tz>MDT<n><of>-0700<n><ot>-0600<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>MST<n><of>-0600<n><ot>-0700<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Pacific/Auckland<n><bd><n><tz>NZDT<n><of>+1200<n><ot>+1300<n><s>19700927T020000<n><r>FREQ=YEARLY;BYMONTH=9;BYDAY=-1SU<n><ed><n><bs><n><tz>NZST<n><of>+1300<n><ot>+1200<n><s>19700405T030000<n><r>FREQ=YEARLY;BYMONTH=4;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Pacific/Chatham<n><bd><n><tz>%z<n><of>+1245<n><ot>+1345<n><s>19700927T024500<n><r>FREQ=YEARLY;BYMONTH=9;BYDAY=-1SU<n><ed><n><bs><n><tz>%z<n><of>+1345<n><ot>+1245<n><s>19700405T034500<n><r>FREQ=YEARLY;BYMONTH=4;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Phoenix<n><bs><n><tz>MST<n><of>-0700<n><ot>-0700<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Brussels<n><bd><n><tz>CEST<n><of>+0100<n><ot>+0200<n><s>19700329T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>CET<n><of>+0200<n><ot>+0100<n><s>19701025T030000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Africa/Tripoli<n><bs><n><tz>EET<n><of>+0200<n><ot>+0200<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Pacific/Kwajalein<n><bs><n><tz>%z<n><of>+1200<n><ot>+1200<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Tokyo<n><bs><n><tz>JST<n><of>+0900<n><ot>+0900<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Jamaica<n><bs><n><tz>EST<n><of>-0500<n><ot>-0500<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Jerusalem<n><bd><n><tz>IDT<n><of>+0200<n><ot>+0300<n><s>19700327T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1FR<n><ed><n><bs><n><tz>IST<n><of>+0300<n><ot>+0200<n><s>19701025T020000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Tehran<n><bs><n><tz>%z<n><of>+0330<n><ot>+0330<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Africa/Abidjan<n><bs><n><tz>GMT<n><of>+0000<n><ot>+0000<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Hong_Kong<n><bs><n><tz>HKT<n><of>+0800<n><ot>+0800<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Pacific/Honolulu<n><bs><n><tz>HST<n><of>-1000<n><ot>-1000<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Etc/GMT<n><bs><n><tz>GMT<n><of>+0000<n><ot>+0000<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/London<n><bd><n><tz>BST<n><of>+0000<n><ot>+0100<n><s>19700329T010000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>GMT<n><of>+0100<n><ot>+0000<n><s>19701025T020000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Dublin<n><bs><n><tz>IST<n><of>+0000<n><ot>+0100<n><s>19700329T010000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><es><n><bd><n><tz>GMT<n><of>+0100<n><ot>+0000<n><s>19701025T020000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><ed><n>", "20250101T220159Z<n>X-LIC-LOCATION:Africa/Cairo<n><bd><n><tz>EEST<n><of>+0200<n><ot>+0300<n><s>19700424T000000<n><r>FREQ=YEARLY;BYMONTH=4;BYDAY=-1FR<n><ed><n><bs><n><tz>EET<n><of>+0300<n><ot>+0200<n><s>19701030T000000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1FR<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/New_York<n><bd><n><tz>EDT<n><of>-0500<n><ot>-0400<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>EST<n><of>-0400<n><ot>-0500<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Panama<n><bs><n><tz>EST<n><of>-0500<n><ot>-0500<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Athens<n><bd><n><tz>EEST<n><of>+0200<n><ot>+0300<n><s>19700329T030000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>EET<n><of>+0300<n><ot>+0200<n><s>19701025T040000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Havana<n><bs><n><tz>CST<n><of>-0400<n><ot>-0500<n><s>19701101T010000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n><bd><n><tz>CDT<n><of>-0500<n><ot>-0400<n><s>19700308T000000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Chicago<n><bd><n><tz>CDT<n><of>-0600<n><ot>-0500<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>CST<n><of>-0500<n><ot>-0600<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Pacific/Pago_Pago<n><bs><n><tz>SST<n><of>-1100<n><ot>-1100<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Detroit<n><bd><n><tz>EDT<n><of>-0500<n><ot>-0400<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>EST<n><of>-0400<n><ot>-0500<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Indiana/Knox<n><bd><n><tz>CDT<n><of>-0600<n><ot>-0500<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>CST<n><of>-0500<n><ot>-0600<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Indiana/Indianapolis<n><bd><n><tz>EDT<n><of>-0500<n><ot>-0400<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>EST<n><of>-0400<n><ot>-0500<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Adak<n><bd><n><tz>HDT<n><of>-1000<n><ot>-0900<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>HST<n><of>-0900<n><ot>-1000<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Anchorage<n><bd><n><tz>AKDT<n><of>-0900<n><ot>-0800<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>AKST<n><of>-0800<n><ot>-0900<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Pacific/Port_Moresby<n><bs><n><tz>%z<n><of>+1000<n><ot>+1000<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Pacific/Tarawa<n><bs><n><tz>%z<n><of>+1200<n><ot>+1200<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Pacific/Tongatapu<n><bs><n><tz>%z<n><of>+1300<n><ot>+1300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Pacific/Tahiti<n><bs><n><tz>%z<n><of>-1000<n><ot>-1000<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Pacific/Guam<n><bs><n><tz>ChST<n><of>+1000<n><ot>+1000<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Pacific/Rarotonga<n><bs><n><tz>%z<n><of>-1000<n><ot>-1000<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Pacific/Guadalcanal<n><bs><n><tz>%z<n><of>+1100<n><ot>+1100<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Pacific/Pitcairn<n><bs><n><tz>%z<n><of>-0800<n><ot>-0800<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Pacific/Palau<n><bs><n><tz>%z<n><of>+0900<n><ot>+0900<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Pacific/Noumea<n><bs><n><tz>%z<n><of>+1100<n><ot>+1100<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Pacific/Norfolk<n><bd><n><tz>%z<n><of>+1100<n><ot>+1200<n><s>19701004T020000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=1SU<n><ed><n><bs><n><tz>%z<n><of>+1200<n><ot>+1100<n><s>19700405T030000<n><r>FREQ=YEARLY;BYMONTH=4;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Pacific/Niue<n><bs><n><tz>%z<n><of>-1100<n><ot>-1100<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Pacific/Nauru<n><bs><n><tz>%z<n><of>+1200<n><ot>+1200<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Pacific/Marquesas<n><bs><n><tz>%z<n><of>-0930<n><ot>-0930<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Pacific/Kosrae<n><bs><n><tz>%z<n><of>+1100<n><ot>+1100<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Pacific/Kiritimati<n><bs><n><tz>%z<n><of>+1400<n><ot>+1400<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Pacific/Kanton<n><bs><n><tz>%z<n><of>+1300<n><ot>+1300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Pacific/Gambier<n><bs><n><tz>%z<n><of>-0900<n><ot>-0900<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Pacific/Galapagos<n><bs><n><tz>%z<n><of>-0600<n><ot>-0600<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Pacific/Fiji<n><bs><n><tz>%z<n><of>+1200<n><ot>+1200<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Pacific/Fakaofo<n><bs><n><tz>%z<n><of>+1300<n><ot>+1300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Pacific/Efate<n><bs><n><tz>%z<n><of>+1100<n><ot>+1100<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Pacific/Easter<n><bs><n><tz>%z<n><of>-0500<n><ot>-0600<n><s>19700404T220000<n><r>FREQ=YEARLY;BYMONTH=4;BYDAY=1SA<n><es><n><bd><n><tz>%z<n><of>-0600<n><ot>-0500<n><s>19700905T220000<n><r>FREQ=YEARLY;BYMONTH=9;BYDAY=1SA<n><ed><n>", "20250101T220159Z<n>X-LIC-LOCATION:Pacific/Bougainville<n><bs><n><tz>%z<n><of>+1100<n><ot>+1100<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Pacific/Apia<n><bs><n><tz>%z<n><of>+1300<n><ot>+1300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Mexico_City<n><bs><n><tz>CST<n><of>-0600<n><ot>-0600<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Mazatlan<n><bs><n><tz>MST<n><of>-0700<n><ot>-0700<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Tijuana<n><bd><n><tz>PDT<n><of>-0800<n><ot>-0700<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>PST<n><of>-0700<n><ot>-0800<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Dubai<n><bs><n><tz>%z<n><of>+0400<n><ot>+0400<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Africa/Nairobi<n><bs><n><tz>EAT<n><of>+0300<n><ot>+0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Indian/Mauritius<n><bs><n><tz>%z<n><of>+0400<n><ot>+0400<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Indian/Maldives<n><bs><n><tz>%z<n><of>+0500<n><ot>+0500<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Yangon<n><bs><n><tz>%z<n><of>+0630<n><ot>+0630<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Bangkok<n><bs><n><tz>%z<n><of>+0700<n><ot>+0700<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Indian/Chagos<n><bs><n><tz>%z<n><of>+0600<n><ot>+0600<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Zurich<n><bd><n><tz>CEST<n><of>+0100<n><ot>+0200<n><s>19700329T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>CET<n><of>+0200<n><ot>+0100<n><s>19701025T030000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Kyiv<n><bs><n><tz>EET<n><of>+0300<n><ot>+0200<n><s>19701025T040000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n><bd><n><tz>EEST<n><of>+0200<n><ot>+0300<n><s>19700329T030000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Belgrade<n><bd><n><tz>CEST<n><of>+0100<n><ot>+0200<n><s>19700329T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>CET<n><of>+0200<n><ot>+0100<n><s>19701025T030000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Volgograd<n><bs><n><tz>MSK<n><of>+0300<n><ot>+0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Vilnius<n><bd><n><tz>EEST<n><of>+0200<n><ot>+0300<n><s>19700329T030000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>EET<n><of>+0300<n><ot>+0200<n><s>19701025T040000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Vienna<n><bd><n><tz>CEST<n><of>+0100<n><ot>+0200<n><s>19700329T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>CET<n><of>+0200<n><ot>+0100<n><s>19701025T030000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Rome<n><bd><n><tz>CEST<n><of>+0100<n><ot>+0200<n><s>19700329T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>CET<n><of>+0200<n><ot>+0100<n><s>19701025T030000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Ulyanovsk<n><bs><n><tz>%z<n><of>+0400<n><ot>+0400<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Chisinau<n><bd><n><tz>EEST<n><of>+0200<n><ot>+0300<n><s>19700329T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>EET<n><of>+0300<n><ot>+0200<n><s>19701025T030000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Tirane<n><bd><n><tz>CEST<n><of>+0100<n><ot>+0200<n><s>19700329T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>CET<n><of>+0200<n><ot>+0100<n><s>19701025T030000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Tallinn<n><bd><n><tz>EEST<n><of>+0200<n><ot>+0300<n><s>19700329T030000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>EET<n><of>+0300<n><ot>+0200<n><s>19701025T040000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Berlin<n><bd><n><tz>CEST<n><of>+0100<n><ot>+0200<n><s>19700329T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>CET<n><of>+0200<n><ot>+0100<n><s>19701025T030000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Sofia<n><bd><n><tz>EEST<n><of>+0200<n><ot>+0300<n><s>19700329T030000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>EET<n><of>+0300<n><ot>+0200<n><s>19701025T040000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Simferopol<n><bs><n><tz>MSK<n><of>+0300<n><ot>+0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Saratov<n><bs><n><tz>%z<n><of>+0400<n><ot>+0400<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Samara<n><bs><n><tz>%z<n><of>+0400<n><ot>+0400<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Riga<n><bd><n><tz>EEST<n><of>+0200<n><ot>+0300<n><s>19700329T030000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>EET<n><of>+0300<n><ot>+0200<n><s>19701025T040000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Prague<n><bd><n><tz>CEST<n><of>+0100<n><ot>+0200<n><s>19700329T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>CET<n><of>+0200<n><ot>+0100<n><s>19701025T030000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Paris<n><bd><n><tz>CEST<n><of>+0100<n><ot>+0200<n><s>19700329T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>CET<n><of>+0200<n><ot>+0100<n><s>19701025T030000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Nicosia<n><bs><n><tz>EET<n><of>+0300<n><ot>+0200<n><s>19701025T040000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n><bd><n><tz>EEST<n><of>+0200<n><ot>+0300<n><s>19700329T030000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Minsk<n><bs><n><tz>%z<n><of>+0300<n><ot>+0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Helsinki<n><bd><n><tz>EEST<n><of>+0200<n><ot>+0300<n><s>19700329T030000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>EET<n><of>+0300<n><ot>+0200<n><s>19701025T040000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Malta<n><bd><n><tz>CEST<n><of>+0100<n><ot>+0200<n><s>19700329T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>CET<n><of>+0200<n><ot>+0100<n><s>19701025T030000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Madrid<n><bd><n><tz>CEST<n><of>+0100<n><ot>+0200<n><s>19700329T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>CET<n><of>+0200<n><ot>+0100<n><s>19701025T030000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Kirov<n><bs><n><tz>MSK<n><of>+0300<n><ot>+0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Kaliningrad<n><bs><n><tz>EET<n><of>+0200<n><ot>+0200<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Gibraltar<n><bd><n><tz>CEST<n><of>+0100<n><ot>+0200<n><s>19700329T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>CET<n><of>+0200<n><ot>+0100<n><s>19701025T030000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Budapest<n><bd><n><tz>CEST<n><of>+0100<n><ot>+0200<n><s>19700329T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>CET<n><of>+0200<n><ot>+0100<n><s>19701025T030000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Bucharest<n><bd><n><tz>EEST<n><of>+0200<n><ot>+0300<n><s>19700329T030000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>EET<n><of>+0300<n><ot>+0200<n><s>19701025T040000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Astrakhan<n><bs><n><tz>%z<n><of>+0400<n><ot>+0400<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Andorra<n><bd><n><tz>CEST<n><of>+0100<n><ot>+0200<n><s>19700329T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>CET<n><of>+0200<n><ot>+0100<n><s>19701025T030000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Etc/GMT-9<n><bs><n><tz>%z<n><of>+0900<n><ot>+0900<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Etc/GMT-8<n><bs><n><tz>%z<n><of>+0800<n><ot>+0800<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Etc/GMT-7<n><bs><n><tz>%z<n><of>+0700<n><ot>+0700<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Etc/GMT-6<n><bs><n><tz>%z<n><of>+0600<n><ot>+0600<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Etc/GMT-5<n><bs><n><tz>%z<n><of>+0500<n><ot>+0500<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Etc/GMT-4<n><bs><n><tz>%z<n><of>+0400<n><ot>+0400<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Etc/GMT-3<n><bs><n><tz>%z<n><of>+0300<n><ot>+0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Etc/GMT-2<n><bs><n><tz>%z<n><of>+0200<n><ot>+0200<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Etc/GMT-14<n><bs><n><tz>%z<n><of>+1400<n><ot>+1400<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Etc/GMT-13<n><bs><n><tz>%z<n><of>+1300<n><ot>+1300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Etc/GMT-12<n><bs><n><tz>%z<n><of>+1200<n><ot>+1200<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Etc/GMT-11<n><bs><n><tz>%z<n><of>+1100<n><ot>+1100<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Etc/GMT-10<n><bs><n><tz>%z<n><of>+1000<n><ot>+1000<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Etc/GMT-1<n><bs><n><tz>%z<n><of>+0100<n><ot>+0100<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Etc/GMT+9<n><bs><n><tz>%z<n><of>-0900<n><ot>-0900<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Etc/GMT+8<n><bs><n><tz>%z<n><of>-0800<n><ot>-0800<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Etc/GMT+7<n><bs><n><tz>%z<n><of>-0700<n><ot>-0700<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Etc/GMT+6<n><bs><n><tz>%z<n><of>-0600<n><ot>-0600<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Etc/GMT+5<n><bs><n><tz>%z<n><of>-0500<n><ot>-0500<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Etc/GMT+4<n><bs><n><tz>%z<n><of>-0400<n><ot>-0400<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Etc/GMT+3<n><bs><n><tz>%z<n><of>-0300<n><ot>-0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Etc/GMT+2<n><bs><n><tz>%z<n><of>-0200<n><ot>-0200<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Etc/GMT+12<n><bs><n><tz>%z<n><of>-1200<n><ot>-1200<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Etc/GMT+11<n><bs><n><tz>%z<n><of>-1100<n><ot>-1100<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Etc/GMT+10<n><bs><n><tz>%z<n><of>-1000<n><ot>-1000<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Etc/GMT+1<n><bs><n><tz>%z<n><of>-0100<n><ot>-0100<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Santiago<n><bs><n><tz>%z<n><of>-0300<n><ot>-0400<n><s>19700405T000000<n><r>FREQ=YEARLY;BYMONTH=4;BYDAY=1SU<n><es><n><bd><n><tz>%z<n><of>-0400<n><ot>-0300<n><s>19700906T000000<n><r>FREQ=YEARLY;BYMONTH=9;BYDAY=1SU<n><ed><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Whitehorse<n><bs><n><tz>MST<n><of>-0700<n><ot>-0700<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Regina<n><bs><n><tz>CST<n><of>-0600<n><ot>-0600<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Vancouver<n><bd><n><tz>PDT<n><of>-0800<n><ot>-0700<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>PST<n><of>-0700<n><ot>-0800<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/St_Johns<n><bs><n><tz>NST<n><of>-0230<n><ot>-0330<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n><bd><n><tz>NDT<n><of>-0330<n><ot>-0230<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Edmonton<n><bd><n><tz>MDT<n><of>-0700<n><ot>-0600<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>MST<n><of>-0600<n><ot>-0700<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Toronto<n><bd><n><tz>EDT<n><of>-0500<n><ot>-0400<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>EST<n><of>-0400<n><ot>-0500<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Winnipeg<n><bd><n><tz>CDT<n><of>-0600<n><ot>-0500<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>CST<n><of>-0500<n><ot>-0600<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Halifax<n><bd><n><tz>ADT<n><of>-0400<n><ot>-0300<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>AST<n><of>-0300<n><ot>-0400<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Manaus<n><bs><n><tz>%z<n><of>-0400<n><ot>-0400<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Sao_Paulo<n><bs><n><tz>%z<n><of>-0300<n><ot>-0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Noronha<n><bs><n><tz>%z<n><of>-0200<n><ot>-0200<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Rio_Branco<n><bs><n><tz>%z<n><of>-0500<n><ot>-0500<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Australia/Broken_Hill<n><bs><n><tz>ACST<n><of>+1030<n><ot>+0930<n><s>19700405T030000<n><r>FREQ=YEARLY;BYMONTH=4;BYDAY=1SU<n><es><n><bd><n><tz>ACDT<n><of>+0930<n><ot>+1030<n><s>19701004T020000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=1SU<n><ed><n>", "20250101T220159Z<n>X-LIC-LOCATION:Australia/Perth<n><bs><n><tz>AWST<n><of>+0800<n><ot>+0800<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Australia/Melbourne<n><bs><n><tz>AEST<n><of>+1100<n><ot>+1000<n><s>19700405T030000<n><r>FREQ=YEARLY;BYMONTH=4;BYDAY=1SU<n><es><n><bd><n><tz>AEDT<n><of>+1000<n><ot>+1100<n><s>19701004T020000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=1SU<n><ed><n>", "20250101T220159Z<n>X-LIC-LOCATION:Australia/Hobart<n><bd><n><tz>AEDT<n><of>+1000<n><ot>+1100<n><s>19701004T020000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=1SU<n><ed><n><bs><n><tz>AEST<n><of>+1100<n><ot>+1000<n><s>19700405T030000<n><r>FREQ=YEARLY;BYMONTH=4;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Australia/Sydney<n><bs><n><tz>AEST<n><of>+1100<n><ot>+1000<n><s>19700405T030000<n><r>FREQ=YEARLY;BYMONTH=4;BYDAY=1SU<n><es><n><bd><n><tz>AEDT<n><of>+1000<n><ot>+1100<n><s>19701004T020000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=1SU<n><ed><n>", "20250101T220159Z<n>X-LIC-LOCATION:Australia/Adelaide<n><bs><n><tz>ACST<n><of>+1030<n><ot>+0930<n><s>19700405T030000<n><r>FREQ=YEARLY;BYMONTH=4;BYDAY=1SU<n><es><n><bd><n><tz>ACDT<n><of>+0930<n><ot>+1030<n><s>19701004T020000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=1SU<n><ed><n>", "20250101T220159Z<n>X-LIC-LOCATION:Australia/Brisbane<n><bs><n><tz>AEST<n><of>+1000<n><ot>+1000<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Australia/Darwin<n><bs><n><tz>ACST<n><of>+0930<n><ot>+0930<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Australia/Lord_Howe<n><bs><n><tz>%z<n><of>+1100<n><ot>+1030<n><s>19700405T020000<n><r>FREQ=YEARLY;BYMONTH=4;BYDAY=1SU<n><es><n><bd><n><tz>%z<n><of>+1030<n><ot>+1100<n><s>19701004T020000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=1SU<n><ed><n>", "20250101T220159Z<n>X-LIC-LOCATION:Australia/Lindeman<n><bs><n><tz>AEST<n><of>+1000<n><ot>+1000<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Australia/Eucla<n><bs><n><tz>%z<n><of>+0845<n><ot>+0845<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Atlantic/Stanley<n><bs><n><tz>%z<n><of>-0300<n><ot>-0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Atlantic/South_Georgia<n><bs><n><tz>%z<n><of>-0200<n><ot>-0200<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Atlantic/Madeira<n><bd><n><tz>WEST<n><of>+0000<n><ot>+0100<n><s>19700329T010000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>WET<n><of>+0100<n><ot>+0000<n><s>19701025T020000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Atlantic/Faroe<n><bd><n><tz>WEST<n><of>+0000<n><ot>+0100<n><s>19700329T010000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>WET<n><of>+0100<n><ot>+0000<n><s>19701025T020000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Atlantic/Cape_Verde<n><bs><n><tz>%z<n><of>-0100<n><ot>-0100<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Atlantic/Canary<n><bd><n><tz>WEST<n><of>+0000<n><ot>+0100<n><s>19700329T010000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>WET<n><of>+0100<n><ot>+0000<n><s>19701025T020000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Atlantic/Bermuda<n><bd><n><tz>ADT<n><of>-0400<n><ot>-0300<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>AST<n><of>-0300<n><ot>-0400<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Atlantic/Azores<n><bd><n><tz>%z<n><of>-0100<n><ot>+0000<n><s>19700329T000000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>%z<n><of>+0000<n><ot>-0100<n><s>19701025T010000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Yerevan<n><bs><n><tz>%z<n><of>+0400<n><ot>+0400<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Yekaterinburg<n><bs><n><tz>%z<n><of>+0500<n><ot>+0500<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Yakutsk<n><bs><n><tz>%z<n><of>+0900<n><ot>+0900<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Vladivostok<n><bs><n><tz>%z<n><of>+1000<n><ot>+1000<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Ust-Nera<n><bs><n><tz>%z<n><of>+1000<n><ot>+1000<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Urumqi<n><bs><n><tz>%z<n><of>+0600<n><ot>+0600<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Ulaanbaatar<n><bs><n><tz>%z<n><of>+0800<n><ot>+0800<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Makassar<n><bs><n><tz>WITA<n><of>+0800<n><ot>+0800<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Tomsk<n><bs><n><tz>%z<n><of>+0700<n><ot>+0700<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Thimphu<n><bs><n><tz>%z<n><of>+0600<n><ot>+0600<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Tbilisi<n><bs><n><tz>%z<n><of>+0400<n><ot>+0400<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Tashkent<n><bs><n><tz>%z<n><of>+0500<n><ot>+0500<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Srednekolymsk<n><bs><n><tz>%z<n><of>+1100<n><ot>+1100<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Samarkand<n><bs><n><tz>%z<n><of>+0500<n><ot>+0500<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Sakhalin<n><bs><n><tz>%z<n><of>+1100<n><ot>+1100<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Ho_Chi_Minh<n><bs><n><tz>%z<n><of>+0700<n><ot>+0700<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Riyadh<n><bs><n><tz>%z<n><of>+0300<n><ot>+0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Qyzylorda<n><bs><n><tz>%z<n><of>+0500<n><ot>+0500<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Qostanay<n><bs><n><tz>%z<n><of>+0500<n><ot>+0500<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Qatar<n><bs><n><tz>%z<n><of>+0300<n><ot>+0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Pyongyang<n><bs><n><tz>KST<n><of>+0900<n><ot>+0900<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Pontianak<n><bs><n><tz>WIB<n><of>+0700<n><ot>+0700<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Oral<n><bs><n><tz>%z<n><of>+0500<n><ot>+0500<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Omsk<n><bs><n><tz>%z<n><of>+0600<n><ot>+0600<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Novosibirsk<n><bs><n><tz>%z<n><of>+0700<n><ot>+0700<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Novokuznetsk<n><bs><n><tz>%z<n><of>+0700<n><ot>+0700<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Manila<n><bs><n><tz>PST<n><of>+0800<n><ot>+0800<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Magadan<n><bs><n><tz>%z<n><of>+1100<n><ot>+1100<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Macau<n><bs><n><tz>CST<n><of>+0800<n><ot>+0800<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Kuching<n><bs><n><tz>%z<n><of>+0800<n><ot>+0800<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Krasnoyarsk<n><bs><n><tz>%z<n><of>+0700<n><ot>+0700<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Kolkata<n><bs><n><tz>IST<n><of>+0530<n><ot>+0530<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Khandyga<n><bs><n><tz>%z<n><of>+0900<n><ot>+0900<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Kathmandu<n><bs><n><tz>%z<n><of>+0545<n><ot>+0545<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Karachi<n><bs><n><tz>PKT<n><of>+0500<n><ot>+0500<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Kamchatka<n><bs><n><tz>%z<n><of>+1200<n><ot>+1200<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Kabul<n><bs><n><tz>%z<n><of>+0430<n><ot>+0430<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Jayapura<n><bs><n><tz>WIT<n><of>+0900<n><ot>+0900<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Jakarta<n><bs><n><tz>WIB<n><of>+0700<n><ot>+0700<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Irkutsk<n><bs><n><tz>%z<n><of>+0800<n><ot>+0800<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Hovd<n><bs><n><tz>%z<n><of>+0700<n><ot>+0700<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Hebron<n><bd><n><tz>EEST<n><of>+0200<n><ot>+0300<n><s>19700328T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SA<n><ed><n><bs><n><tz>EET<n><of>+0300<n><ot>+0200<n><s>19701024T020000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SA<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Gaza<n><bd><n><tz>EEST<n><of>+0200<n><ot>+0300<n><s>19700328T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SA<n><ed><n><bs><n><tz>EET<n><of>+0300<n><ot>+0200<n><s>19701024T020000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SA<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Famagusta<n><bd><n><tz>EEST<n><of>+0200<n><ot>+0300<n><s>19700329T030000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>EET<n><of>+0300<n><ot>+0200<n><s>19701025T040000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Dushanbe<n><bs><n><tz>%z<n><of>+0500<n><ot>+0500<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Dili<n><bs><n><tz>%z<n><of>+0900<n><ot>+0900<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Dhaka<n><bs><n><tz>%z<n><of>+0600<n><ot>+0600<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Damascus<n><bs><n><tz>%z<n><of>+0300<n><ot>+0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Colombo<n><bs><n><tz>%z<n><of>+0530<n><ot>+0530<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Chita<n><bs><n><tz>%z<n><of>+0900<n><ot>+0900<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Bishkek<n><bs><n><tz>%z<n><of>+0600<n><ot>+0600<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Beirut<n><bd><n><tz>EEST<n><of>+0200<n><ot>+0300<n><s>19700329T000000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>EET<n><of>+0300<n><ot>+0200<n><s>19701025T000000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Barnaul<n><bs><n><tz>%z<n><of>+0700<n><ot>+0700<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Baku<n><bs><n><tz>%z<n><of>+0400<n><ot>+0400<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Baghdad<n><bs><n><tz>%z<n><of>+0300<n><ot>+0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Atyrau<n><bs><n><tz>%z<n><of>+0500<n><ot>+0500<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Ashgabat<n><bs><n><tz>%z<n><of>+0500<n><ot>+0500<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Aqtobe<n><bs><n><tz>%z<n><of>+0500<n><ot>+0500<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Aqtau<n><bs><n><tz>%z<n><of>+0500<n><ot>+0500<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Anadyr<n><bs><n><tz>%z<n><of>+1200<n><ot>+1200<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Amman<n><bs><n><tz>%z<n><of>+0300<n><ot>+0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Almaty<n><bs><n><tz>%z<n><of>+0500<n><ot>+0500<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Antarctica/Vostok<n><bs><n><tz>%z<n><of>+0500<n><ot>+0500<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Antarctica/Troll<n><bd><n><tz>+02<n><of>+0000<n><ot>+0200<n><s>19700329T010000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>+00<n><of>+0200<n><ot>+0000<n><s>19701025T030000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Antarctica/Rothera<n><bs><n><tz>%z<n><of>-0300<n><ot>-0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Antarctica/Palmer<n><bs><n><tz>%z<n><of>-0300<n><ot>-0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Antarctica/Mawson<n><bs><n><tz>%z<n><of>+0500<n><ot>+0500<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Antarctica/Macquarie<n><bs><n><tz>AEST<n><of>+1100<n><ot>+1000<n><s>19700405T030000<n><r>FREQ=YEARLY;BYMONTH=4;BYDAY=1SU<n><es><n><bd><n><tz>AEDT<n><of>+1000<n><ot>+1100<n><s>19701004T020000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=1SU<n><ed><n>", "20250101T220159Z<n>X-LIC-LOCATION:Antarctica/Davis<n><bs><n><tz>%z<n><of>+0700<n><ot>+0700<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Antarctica/Casey<n><bs><n><tz>%z<n><of>+0800<n><ot>+0800<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Yakutat<n><bd><n><tz>AKDT<n><of>-0900<n><ot>-0800<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>AKST<n><of>-0800<n><ot>-0900<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Puerto_Rico<n><bs><n><tz>AST<n><of>-0400<n><ot>-0400<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Thule<n><bd><n><tz>ADT<n><of>-0400<n><ot>-0300<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>AST<n><of>-0300<n><ot>-0400<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Tegucigalpa<n><bs><n><tz>CST<n><of>-0600<n><ot>-0600<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Swift_Current<n><bs><n><tz>CST<n><of>-0600<n><ot>-0600<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Sitka<n><bd><n><tz>AKDT<n><of>-0900<n><ot>-0800<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>AKST<n><of>-0800<n><ot>-0900<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Scoresbysund<n><bs><n><tz>%z<n><of>-0100<n><ot>-0200<n><s>19701025T000000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n><bd><n><tz>%z<n><of>-0200<n><ot>-0100<n><s>19700328T230000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SA<n><ed><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Santo_Domingo<n><bs><n><tz>AST<n><of>-0400<n><ot>-0400<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Santarem<n><bs><n><tz>%z<n><of>-0300<n><ot>-0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Argentina/Cordoba<n><bs><n><tz>%z<n><of>-0300<n><ot>-0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Resolute<n><bs><n><tz>CST<n><of>-0500<n><ot>-0600<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n><bd><n><tz>CDT<n><of>-0600<n><ot>-0500<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Recife<n><bs><n><tz>%z<n><of>-0300<n><ot>-0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Rankin_Inlet<n><bd><n><tz>CDT<n><of>-0600<n><ot>-0500<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>CST<n><of>-0500<n><ot>-0600<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Punta_Arenas<n><bs><n><tz>%z<n><of>-0300<n><ot>-0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Porto_Velho<n><bs><n><tz>%z<n><of>-0400<n><ot>-0400<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Port-au-Prince<n><bd><n><tz>EDT<n><of>-0500<n><ot>-0400<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>EST<n><of>-0400<n><ot>-0500<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Paramaribo<n><bs><n><tz>%z<n><of>-0300<n><ot>-0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Iqaluit<n><bd><n><tz>EDT<n><of>-0500<n><ot>-0400<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>EST<n><of>-0400<n><ot>-0500<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Ojinaga<n><bd><n><tz>CDT<n><of>-0600<n><ot>-0500<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>CST<n><of>-0500<n><ot>-0600<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Nuuk<n><bd><n><tz>%z<n><of>-0200<n><ot>-0100<n><s>19700328T230000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SA<n><ed><n><bs><n><tz>%z<n><of>-0100<n><ot>-0200<n><s>19701025T000000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Nome<n><bd><n><tz>AKDT<n><of>-0900<n><ot>-0800<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>AKST<n><of>-0800<n><ot>-0900<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Montevideo<n><bs><n><tz>%z<n><of>-0300<n><ot>-0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Monterrey<n><bs><n><tz>CST<n><of>-0600<n><ot>-0600<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Moncton<n><bd><n><tz>ADT<n><of>-0400<n><ot>-0300<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>AST<n><of>-0300<n><ot>-0400<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Miquelon<n><bd><n><tz>%z<n><of>-0300<n><ot>-0200<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>%z<n><of>-0200<n><ot>-0300<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Metlakatla<n><bd><n><tz>AKDT<n><of>-0900<n><ot>-0800<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>AKST<n><of>-0800<n><ot>-0900<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Merida<n><bs><n><tz>CST<n><of>-0600<n><ot>-0600<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Menominee<n><bd><n><tz>CDT<n><of>-0600<n><ot>-0500<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>CST<n><of>-0500<n><ot>-0600<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Argentina/Mendoza<n><bs><n><tz>%z<n><of>-0300<n><ot>-0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Matamoros<n><bd><n><tz>CDT<n><of>-0600<n><ot>-0500<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>CST<n><of>-0500<n><ot>-0600<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Martinique<n><bs><n><tz>AST<n><of>-0400<n><ot>-0400<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Managua<n><bs><n><tz>CST<n><of>-0600<n><ot>-0600<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Maceio<n><bs><n><tz>%z<n><of>-0300<n><ot>-0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Kentucky/Louisville<n><bd><n><tz>EDT<n><of>-0500<n><ot>-0400<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>EST<n><of>-0400<n><ot>-0500<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Lima<n><bs><n><tz>%z<n><of>-0500<n><ot>-0500<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/La_Paz<n><bs><n><tz>%z<n><of>-0400<n><ot>-0400<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Juneau<n><bd><n><tz>AKDT<n><of>-0900<n><ot>-0800<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>AKST<n><of>-0800<n><ot>-0900<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Argentina/Jujuy<n><bs><n><tz>%z<n><of>-0300<n><ot>-0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Inuvik<n><bd><n><tz>MDT<n><of>-0700<n><ot>-0600<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>MST<n><of>-0600<n><ot>-0700<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Hermosillo<n><bs><n><tz>MST<n><of>-0700<n><ot>-0700<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Guyana<n><bs><n><tz>%z<n><of>-0400<n><ot>-0400<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Guayaquil<n><bs><n><tz>%z<n><of>-0500<n><ot>-0500<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Guatemala<n><bs><n><tz>CST<n><of>-0600<n><ot>-0600<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Grand_Turk<n><bs><n><tz>EST<n><of>-0400<n><ot>-0500<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n><bd><n><tz>EDT<n><of>-0500<n><ot>-0400<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Goose_Bay<n><bs><n><tz>AST<n><of>-0300<n><ot>-0400<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n><bd><n><tz>ADT<n><of>-0400<n><ot>-0300<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Glace_Bay<n><bd><n><tz>ADT<n><of>-0400<n><ot>-0300<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>AST<n><of>-0300<n><ot>-0400<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Fortaleza<n><bs><n><tz>%z<n><of>-0300<n><ot>-0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Fort_Nelson<n><bs><n><tz>MST<n><of>-0700<n><ot>-0700<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/El_Salvador<n><bs><n><tz>CST<n><of>-0600<n><ot>-0600<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Eirunepe<n><bs><n><tz>%z<n><of>-0500<n><ot>-0500<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Dawson_Creek<n><bs><n><tz>MST<n><of>-0700<n><ot>-0700<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Dawson<n><bs><n><tz>MST<n><of>-0700<n><ot>-0700<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Danmarkshavn<n><bs><n><tz>GMT<n><of>+0000<n><ot>+0000<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Cuiaba<n><bs><n><tz>%z<n><of>-0400<n><ot>-0400<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Costa_Rica<n><bs><n><tz>CST<n><of>-0600<n><ot>-0600<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Ciudad_Juarez<n><bd><n><tz>MDT<n><of>-0700<n><ot>-0600<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>MST<n><of>-0600<n><ot>-0700<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Chihuahua<n><bs><n><tz>CST<n><of>-0600<n><ot>-0600<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Cayenne<n><bs><n><tz>%z<n><of>-0300<n><ot>-0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Argentina/Catamarca<n><bs><n><tz>%z<n><of>-0300<n><ot>-0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Caracas<n><bs><n><tz>%z<n><of>-0400<n><ot>-0400<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Cancun<n><bs><n><tz>EST<n><of>-0500<n><ot>-0500<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Campo_Grande<n><bs><n><tz>%z<n><of>-0400<n><ot>-0400<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Cambridge_Bay<n><bd><n><tz>MDT<n><of>-0700<n><ot>-0600<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>MST<n><of>-0600<n><ot>-0700<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Argentina/Buenos_Aires<n><bs><n><tz>%z<n><of>-0300<n><ot>-0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Boise<n><bd><n><tz>MDT<n><of>-0700<n><ot>-0600<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>MST<n><of>-0600<n><ot>-0700<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Bogota<n><bs><n><tz>%z<n><of>-0500<n><ot>-0500<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Boa_Vista<n><bs><n><tz>%z<n><of>-0400<n><ot>-0400<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Belize<n><bs><n><tz>CST<n><of>-0600<n><ot>-0600<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Belem<n><bs><n><tz>%z<n><of>-0300<n><ot>-0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Barbados<n><bs><n><tz>AST<n><of>-0400<n><ot>-0400<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Bahia_Banderas<n><bs><n><tz>CST<n><of>-0600<n><ot>-0600<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Bahia<n><bs><n><tz>%z<n><of>-0300<n><ot>-0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Asuncion<n><bd><n><tz>%z<n><of>-0400<n><ot>-0300<n><s>19701004T000000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=1SU<n><ed><n><bs><n><tz>%z<n><of>-0300<n><ot>-0400<n><s>19700322T000000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=4SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Araguaina<n><bs><n><tz>%z<n><of>-0300<n><ot>-0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/North_Dakota/New_Salem<n><bd><n><tz>CDT<n><of>-0600<n><ot>-0500<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>CST<n><of>-0500<n><ot>-0600<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/North_Dakota/Center<n><bd><n><tz>CDT<n><of>-0600<n><ot>-0500<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>CST<n><of>-0500<n><ot>-0600<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/North_Dakota/Beulah<n><bd><n><tz>CDT<n><of>-0600<n><ot>-0500<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>CST<n><of>-0500<n><ot>-0600<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Kentucky/Monticello<n><bd><n><tz>EDT<n><of>-0500<n><ot>-0400<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>EST<n><of>-0400<n><ot>-0500<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Indiana/Winamac<n><bs><n><tz>EST<n><of>-0400<n><ot>-0500<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n><bd><n><tz>EDT<n><of>-0500<n><ot>-0400<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Indiana/Vincennes<n><bd><n><tz>EDT<n><of>-0500<n><ot>-0400<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>EST<n><of>-0400<n><ot>-0500<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Indiana/Vevay<n><bd><n><tz>EDT<n><of>-0500<n><ot>-0400<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>EST<n><of>-0400<n><ot>-0500<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Indiana/Tell_City<n><bd><n><tz>CDT<n><of>-0600<n><ot>-0500<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>CST<n><of>-0500<n><ot>-0600<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Indiana/Petersburg<n><bd><n><tz>EDT<n><of>-0500<n><ot>-0400<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>EST<n><of>-0400<n><ot>-0500<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Indiana/Marengo<n><bd><n><tz>EDT<n><of>-0500<n><ot>-0400<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>EST<n><of>-0400<n><ot>-0500<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Argentina/Ushuaia<n><bs><n><tz>%z<n><of>-0300<n><ot>-0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Argentina/Tucuman<n><bs><n><tz>%z<n><of>-0300<n><ot>-0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Argentina/San_Luis<n><bs><n><tz>%z<n><of>-0300<n><ot>-0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Argentina/San_Juan<n><bs><n><tz>%z<n><of>-0300<n><ot>-0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Argentina/Salta<n><bs><n><tz>%z<n><of>-0300<n><ot>-0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Argentina/Rio_Gallegos<n><bs><n><tz>%z<n><of>-0300<n><ot>-0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Argentina/La_Rioja<n><bs><n><tz>%z<n><of>-0300<n><ot>-0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Africa/Windhoek<n><bs><n><tz>CAT<n><of>+0200<n><ot>+0200<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Africa/Tunis<n><bs><n><tz>CET<n><of>+0100<n><ot>+0100<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Africa/Sao_Tome<n><bs><n><tz>GMT<n><of>+0000<n><ot>+0000<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Africa/Lagos<n><bs><n><tz>WAT<n><of>+0100<n><ot>+0100<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Africa/Ndjamena<n><bs><n><tz>WAT<n><of>+0100<n><ot>+0100<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Africa/Monrovia<n><bs><n><tz>GMT<n><of>+0000<n><ot>+0000<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Africa/Johannesburg<n><bs><n><tz>SAST<n><of>+0200<n><ot>+0200<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Africa/Maputo<n><bs><n><tz>CAT<n><of>+0200<n><ot>+0200<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Africa/Khartoum<n><bs><n><tz>CAT<n><of>+0200<n><ot>+0200<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Africa/Juba<n><bs><n><tz>CAT<n><of>+0200<n><ot>+0200<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Africa/El_Aaiun<n><bs><n><tz>%z<n><of>+0100<n><ot>+0100<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Africa/Ceuta<n><bd><n><tz>CEST<n><of>+0100<n><ot>+0200<n><s>19700329T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>CET<n><of>+0200<n><ot>+0100<n><s>19701025T030000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Africa/Casablanca<n><bs><n><tz>%z<n><of>+0100<n><ot>+0100<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Africa/Bissau<n><bs><n><tz>GMT<n><of>+0000<n><ot>+0000<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Africa/Algiers<n><bs><n><tz>CET<n><of>+0100<n><ot>+0100<n><s>19700101T000000<n><es><n>"];
function K2(t) {
  const e = t.split("/");
  return e.length === 3 && (!oa[`${e[0]}`] || !oa[`${e[0]}`][`${e[1]}`] || !oa[`${e[0]}`][`${e[1]}`][`${e[2]}`]) || e.length === 2 && (!oa[`${e[0]}`] || !oa[`${e[0]}`][`${e[1]}`]) || e.length === 1 && !oa[`${e[0]}`] ? (console.error("Given timezone not valid."), "") : e.length === 3 ? [
    oa[`${e[0]}`][`${e[1]}`][`${e[2]}`][0],
    a0(
      n0[oa[`${e[0]}`][`${e[1]}`][`${e[2]}`][1]]
    )
  ] : e.length === 2 ? [
    oa[`${e[0]}`][`${e[1]}`][0],
    a0(n0[oa[`${e[0]}`][`${e[1]}`][1]])
  ] : [
    oa[`${e[0]}`][0],
    a0(n0[oa[`${e[0]}`][1]])
  ];
}
function a0(t) {
  const e = {
    "<br>": "<n>",
    "TZNAME:": "<tz>",
    "TZOFFSETFROM:": "<of>",
    "TZOFFSETTO:": "<ot>",
    "DTSTART:": "<s>",
    "RRULE:": "<r>",
    "BEGIN:DAYLIGHT": "<bd>",
    "END:DAYLIGHT": "<ed>",
    "BEGIN:STANDARD": "<bs>",
    "END:STANDARD": "<es>"
  };
  for (const [n, a] of Object.entries(e))
    t = t.replaceAll(a, n);
  return t;
}
function lP(t, e = !1) {
  const n = K2(t);
  if (n[1] == null || n[1] == "")
    return "";
  const a = function() {
    return n[0] == "" ? t : n[0];
  }(), i = "TZID=" + a, r = [
    `BEGIN:VTIMEZONE\r
TZID:` + a + `\r
X-LIC-LOCATION:` + a + `\r
LAST-MODIFIED:` + n[1].replace(/[^\w_\-:,;=+/<br>]/g, "").replace(/<br>/g, `\r
`) + "END:VTIMEZONE",
    i
  ];
  return e ? JSON.stringify(r) : r;
}
function eu(t, e, n) {
  const a = K2(t);
  if (a[1] == null || a[1] == "")
    return "";
  if (!e.match(/^\d{4}-\d{2}-\d{2}$/))
    return console.error("offset calculation failed: date misspelled [-> YYYY-MM-DD]"), "";
  if (!n.match(/^\d{2}:\d{2}$/))
    return console.error("offset calculation failed: time misspelled [-> hh:mm]"), "";
  if (!a[1].match(/BEGIN:DAYLIGHT/i))
    return a[1].match(/TZOFFSETTO:([+|-]\d{4})/i)[1];
  const i = e + "T" + n + ":00", r = new Date(i), s = r.getFullYear(), o = r.getMonth() + 1, l = r.getDate(), c = r.getHours(), u = a[1].replace(/[^\w_\-:,;=+/<br>]/g, "").split("<br>"), f = { 1: {}, 2: {} };
  let m = 0;
  for (let M = 0; M < u.length; M++)
    if (u[`${M}`].startsWith("TZOFFSETTO") && (m++, f[`${m}`].offset = u[`${M}`].split(":")[1]), u[`${M}`].startsWith("DTSTART") && (f[`${m}`].hour = parseInt(u[`${M}`].substr(17, 2))), u[`${M}`].startsWith("RRULE")) {
      let E = u[`${M}`].split(";"), P = parseInt(E[1].split("=")[1]);
      f[`${m}`].month = parseInt(P), f[`${m}`].day = E[2].split("=")[1];
    }
  if (f[1].month > f[2].month && ([f[1], f[2]] = [f[2], f[1]]), o != f[1].month && o != f[2].month)
    return o < f[1].month || o > f[2].month ? f[2].offset : f[1].offset;
  const _ = function() {
    return Object.keys(f).find((M) => f[`${M}`].month == o);
  }(), T = ["SU", "MO", "TU", "WE", "TH", "FR", "SA"], g = new Date(s, o, 0).getDate();
  let x = new Date(s, o - 1, 1).getDay();
  const S = { SU: {}, MO: {}, TU: {}, WE: {}, TH: {}, FR: {}, SA: {} };
  for (let M = 1; M <= g; M++) {
    const E = Object.keys(S[T[`${x}`]]).length + 1;
    S[T[`${x}`]][`${E}`] = M, x++, x == 7 && (x = 0);
  }
  const D = function() {
    if (f[`${_}`].day[0] == "-") {
      const M = f[`${_}`].day.substr(2, 2), E = Object.keys(S[`${M}`]).length + 1 - parseInt(f[`${_}`].day[1]);
      return S[`${M}`][`${E}`];
    } else {
      const M = f[`${_}`].day.substr(1, 2);
      return S[`${M}`][f[`${_}`].day[0]];
    }
  }();
  if (l > D || l == D && c >= f[`${_}`].hour)
    return f[`${_}`].offset;
  const L = function() {
    return _ == 1 ? 2 : 1;
  }();
  return f[`${L}`].offset;
}
let Sc = [];
function cP(t = !1) {
  return Sc.length == 0 && (Sc = function() {
    let e = [];
    for (const [n, a] of Object.entries(oa))
      if (typeof a == "object" && !Array.isArray(a))
        for (const [i, r] of Object.entries(a))
          if (typeof r == "object" && !Array.isArray(r))
            for (const [s] of Object.entries(r))
              e.push(n + "/" + i + "/" + s);
          else
            e.push(n + "/" + i);
      else
        e.push(n);
    return e;
  }()), t ? JSON.stringify(Sc) : Sc;
}
/*!
 *  @preserve
 *
 *  ++++++++++++++++++++++
 *  Add to Calendar Button
 *  ++++++++++++++++++++++
 *
 *  Version: 2.8.6
 *  Creator: Jens Kuerschner (https://jekuer.com)
 *  Project: https://github.com/add2cal/add-to-calendar-button
 *  License: Elastic License 2.0 (ELv2) (https://github.com/add2cal/add-to-calendar-button/blob/main/LICENSE.txt)
 *  Note:    DO NOT REMOVE THE COPYRIGHT NOTICE ABOVE!
 *
 */
const Q2 = "2.8.6", Jm = {
  default: `:host{width:fit-content;--base-font-size-l:16px;--base-font-size-m:16px;--base-font-size-s:16px;--font:arial,helvetica,"Twemoji Mozilla","Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","EmojiOne Color","Android Emoji",sans-serif;--accent-color:#1e90ff;--wrapper-padding:1px;--buttonslist-gap:5px;--btn-background:#f5f5f5;--btn-hover-background:#fff;--btn-border:#d2d2d2;--btn-border-radius:6px;--btn-padding-x:1em;--btn-padding-y:.65em;--btn-font-weight:600;--btn-text:#333;--btn-hover-text:#000;--btn-shadow:rgba(0 0 0 / 10%) 0 4px 10px -2px,rgba(0 0 0 / 15%) 0 2px 2px -1px;--btn-hover-shadow:rgba(0 0 0 / 25%) 0 5px 12px -2px,rgba(0 0 0 / 25%) 0 3px 5px -2px;--btn-active-shadow:rgba(0 0 0 / 30%) 0 6px 13px -2px,rgba(0 0 0 / 25%) 0 4px 5px -2px;--list-background:#f5f5f5;--list-hover-background:#fff;--list-text:#333;--list-font-weight:400;--list-hover-text:#000;--list-close-background:#e5e5e5;--list-close-text:#777;--list-border-radius:6px;--list-padding:.8em;--list-shadow:rgba(0 0 0 / 20%) 0 4px 13px -2px,rgba(0 0 0 / 23%) 0 2px 4px -1px;--list-modal-shadow:rgba(0 0 0 / 50%) 0 4px 30px -3px,rgba(0 0 0 / 30%) 0 2px 8px -2px;--input-border-radius:6px;--input-background:#fff;--status-active-text:#fff;--form-error:#c5372c;--form-success:#338a36;--modal-text:#000;--modal-text-align:left;--modal-text-align-rtl:right;--modal-background:#f5f5f5;--modal-border-radius:6px;--modal-shadow:drop-shadow(3px 6px 25px rgba(0 0 0 / 65%));--modal-btn-bar:#c6c8cd;--modal-btn-background:#f5f5f5;--modal-btn-secondary-background:#e2e1e6;--modal-btn-hover-background:#fff;--modal-btn-border:#d2d2d2;--modal-btn-font-weight:600;--modal-btn-text:#2e2e2e;--modal-btn-hover-text:#161616;--modal-btn-secondary-text:#666567;--modal-btn-shadow:rgba(0 0 0 / 10%) 0 4px 10px -2px,rgba(0 0 0 / 10%) 0 2px 3px -1px;--modal-btn-hover-shadow:rgba(0 0 0 / 25%) 0 5px 13px -2px,rgba(0 0 0 / 20%) 0 3px 5px -2px;--modal-headline-text-align:center;--modal-headline-text-transform:none;--date-btn-text:#1d1d1e;--date-btn-text-secondary:#3a3a3f;--date-btn-cal-day-text:#fff;--date-btn-cal-month-text:#d3d2d7;--date-btn-cal-background:#313132;--date-btn-background:#eae9ed;--date-btn-hover-background:#fff;--date-btn-headline-line-clamp:1;--date-btn-shadow:rgba(0 0 0 / 10%) 0 4px 10px -2px,rgba(0 0 0 / 15%) 0 2px 3px -1px;--date-btn-hover-shadow:rgba(0 0 0 / 20%) 0 5px 12px -2px,rgba(0 0 0 / 20%) 0 3px 4px -2px;--checkmark-background:drop-shadow(0 0 3px #fff);--overlay-background:rgba(20 20 20 / 25%);--overlay-cursor:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23777' width='16' height='16' viewBox='0 0 122.878 122.88'%3E%3Cpath d='M1.426 8.313a4.87 4.87 0 0 1 0-6.886 4.87 4.87 0 0 1 6.886 0l53.127 53.127 53.127-53.127a4.87 4.87 0 0 1 6.887 0 4.87 4.87 0 0 1 0 6.886L68.324 61.439l53.128 53.128a4.87 4.87 0 0 1-6.887 6.886L61.438 68.326 8.312 121.453a4.87 4.87 0 0 1-6.886 0 4.87 4.87 0 0 1 0-6.886l53.127-53.128L1.426 8.313h0z'/%3E%3C/svg%3E") 16 16,crosshair;--icon-ms365-color:#ea3e23;--icon-yahoo-color:#5f01d1;--icon-filter:none}:host(.atcb-dark){--btn-background:#2e2e2e;--btn-hover-background:#373737;--btn-border:#3d3d3d;--btn-text:#dedede;--btn-hover-text:#f1f1f1;--btn-shadow:rgba(255 255 255 / 5%) -3px -3px 30px -1px,rgba(0 0 0 / 40%) 2px 3px 10px -2px,rgba(0 0 0 / 40%) 1px 2px 3px -1px;--btn-hover-shadow:rgba(0 0 0 / 90%) 2px 5px 20px -4px,rgba(0 0 0 / 50%) 1px 2px 6px -2px;--btn-active-shadow:rgba(0 0 0 / 90%) 2px 5px 20px -4px,rgba(0 0 0 / 50%) 1px 2px 6px -2px;--list-background:#2e2e2e;--list-hover-background:#373737;--list-text:#dedede;--list-hover-text:#f1f1f1;--list-close-background:#282828;--list-shadow:rgba(0 0 0 / 60%) 0 4px 20px -2px,rgba(0 0 0 / 40%) 0 2px 4px -1px;--list-modal-shadow:rgba(0 0 0 / 40%) -1px 3px 30px 2px;--modal-text:#f1f1f1;--modal-background:#242424;--modal-shadow:drop-shadow(3px 6px 25px rgba(0 0 0 / 90%));--modal-btn-bar:#38383a;--modal-btn-background:#181819;--modal-btn-secondary-background:#2e2d30;--modal-btn-hover-background:#434246;--modal-btn-border:#434246;--modal-btn-text:#dbdbdb;--modal-btn-hover-text:#fff;--modal-btn-secondary-text:#b8b8b8;--modal-btn-shadow:rgba(255 255 255 / 5%) -2px -2px 10px,rgba(0 0 0 / 40%) 3px 3px 10px -2px,rgba(0 0 0 / 40%) 1px 2px 5px -1px;--input-background:#434246;--status-active-text:#000;--form-error:#db8680;--form-success:#99de9c;--date-btn-text:#ebebf0;--date-btn-text-secondary:#b5b5bd;--date-btn-cal-day-text:#101010;--date-btn-cal-month-text:#3e3e3f;--date-btn-cal-background:#c7c7cd;--date-btn-background:#363636;--date-btn-hover-background:#474747;--date-btn-shadow:rgba(0 0 0 / 60%) 0 0 20px -2px,rgba(0 0 0 / 30%) 1px 2px 3px -1px;--checkmark-background:drop-shadow(0 0 3px #0a0a0a);--overlay-background:rgba(20 20 20 / 60%);--icon-ms365-color:#ea3e23;--icon-yahoo-color:#bebebe;--icon-filter:grayscale(.2)}.atcb-button-wrapper,.atcb-list,.atcb-modal-box{font-size:var(--base-font-size-l)}@media (width <= 991px){.atcb-button-wrapper,.atcb-list,.atcb-modal-box{font-size:var(--base-font-size-m)}}@media (width <= 575px){.atcb-button-wrapper,.atcb-list,.atcb-modal-box{font-size:var(--base-font-size-s)}}.atcb-initialized.atcb-buttons-list{gap:var(--buttonslist-gap)}.atcb-button-wrapper{display:block;padding:var(--wrapper-padding);position:relative}.atcb-button{align-items:center;background-color:var(--btn-background);border:1px solid var(--btn-border);border-radius:var(--btn-border-radius);box-shadow:var(--btn-shadow);box-sizing:content-box;color:var(--btn-text);cursor:pointer;display:flex;font-family:var(--font);font-size:1em;font-weight:var(--btn-font-weight);justify-content:center;line-height:1.5em;margin:.13em;max-width:300px;padding:var(--btn-padding-y) var(--btn-padding-x);position:relative;text-align:center;touch-action:manipulation;user-select:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent;width:auto;z-index:1}.atcb-button:not(.atcb-no-text,.atcb-modal-style,.atcb-dropoverlay,.atcb-single){min-width:calc(11.6em - 2 * var(--btn-padding-x))}.atcb-button.atcb-no-text{display:flex;place-content:center center;align-items:center;height:3em;width:3em;padding:0}.atcb-rtl .atcb-button{direction:rtl;text-align:right}.atcb-button:focus-visible{outline:2px solid var(--accent-color)}.atcb-button:not([disabled]):focus,.atcb-button:not([disabled]):hover{background-color:var(--btn-hover-background);box-shadow:var(--btn-hover-shadow);color:var(--btn-hover-text);margin:0;padding:calc(var(--btn-padding-y) + .13em) calc(var(--btn-padding-x) + .13em)}.atcb-button.atcb-active:not(.atcb-modal-style,.atcb-dropoverlay){z-index:15000000}.atcb-button.atcb-active:not(.atcb-modal-style,.atcb-dropoverlay),.atcb-button.atcb-single:not([disabled]):focus,.atcb-button.atcb-single:not([disabled]):hover{background-color:var(--btn-hover-background);box-shadow:var(--btn-active-shadow);color:var(--btn-hover-text);margin:0;padding:calc(var(--btn-padding-y) + .13em) calc(var(--btn-padding-x) + .13em)}.atcb-button.atcb-no-text.atcb-active,.atcb-button.atcb-no-text:focus,.atcb-button.atcb-no-text:hover{height:3.26em;width:3.26em;padding:0!important}.atcb-button.atcb-active.atcb-dropoverlay{z-index:14000090}.atcb-icon{flex-grow:0;flex-shrink:0;height:1em;line-height:1em;margin-right:.8em;width:1em}.atcb-rtl .atcb-icon{margin-right:0;margin-left:.8em}.atcb-no-text .atcb-icon{margin-right:0;margin-left:0}.atcb-icon svg{fill:currentcolor;height:100%;width:100%}.atcb-text{overflow-wrap:anywhere}.atcb-dropdown-anchor{bottom:4px;height:1px;width:100%;opacity:0;position:absolute}.atcb-list-wrapper{box-sizing:border-box;font-weight:var(--list-font-weight);padding:0 4px;position:absolute;z-index:14000090}.atcb-list-wrapper.atcb-dropoverlay{z-index:15000000;max-width:max-content}.atcb-list{background-color:var(--list-background);border-radius:0 0 var(--list-border-radius) var(--list-border-radius);box-sizing:border-box;box-shadow:var(--list-shadow);color:var(--list-text);display:block;font-family:var(--font);min-width:100%;position:relative;user-select:none;-webkit-user-select:none;width:fit-content}.atcb-list-item{align-items:center;background-color:var(--list-background);box-sizing:border-box;cursor:pointer;display:flex;font-size:1em;line-height:1.75em;padding:var(--list-padding);text-align:left;touch-action:manipulation;-webkit-tap-highlight-color:transparent}.atcb-rtl .atcb-list-item{direction:rtl;text-align:right}.atcb-list-item:hover{background-color:var(--list-hover-background);color:var(--list-hover-text)}.atcb-list-item:focus-visible{background-color:var(--list-hover-background);color:var(--accent-color);outline:0}.atcb-list-item:last-child{border-radius:0 0 var(--list-border-radius) var(--list-border-radius)}.atcb-dropup .atcb-list-item:last-child{border-radius:0;padding-bottom:calc(var(--list-padding) + .45em)}.atcb-dropoverlay .atcb-list .atcb-list-item:first-child,.atcb-dropup .atcb-list,.atcb-dropup .atcb-list-item:first-child,.atcb-list.atcb-modal .atcb-list-item:first-child{border-radius:var(--list-border-radius) var(--list-border-radius) 0 0}.atcb-dropoverlay .atcb-list .atcb-list-item:only-child,.atcb-list.atcb-modal .atcb-list-item:only-child{border-radius:var(--list-border-radius)}.atcb-list.atcb-generated-button:not(.atcb-modal) .atcb-list-item:first-child{padding-top:calc(var(--list-padding) + .45em)}.atcb-dropoverlay .atcb-list.atcb-generated-button:not(.atcb-modal) .atcb-list-item:first-child,.atcb-dropup .atcb-list.atcb-generated-button:not(.atcb-modal) .atcb-list-item:first-child{padding-top:var(--list-padding)}.atcb-dropoverlay .atcb-list,.atcb-list.atcb-modal{border-radius:var(--list-border-radius)}.atcb-list.atcb-modal{box-shadow:var(--list-modal-shadow)}.atcb-list-item .atcb-icon{margin:0 auto}.atcb-list-item .atcb-icon+.atcb-text{margin-left:.7em;width:100%}.atcb-rtl .atcb-list-item .atcb-icon+.atcb-text{margin-left:0;margin-right:.7em}.atcb-list-item-close{background-color:var(--list-close-background)}.atcb-list-item.atcb-list-item-close:not(:focus-visible){color:var(--list-close-text)}.atcb-list-item-close svg{fill:currentcolor}.atcb-modal{display:block;margin:auto;width:auto;min-width:auto;position:relative;z-index:14000090}.atcb-modal-box{filter:var(--modal-shadow);color:var(--modal-text);cursor:default;box-sizing:border-box;font-family:var(--font);line-height:1.5em;text-align:var(--modal-text-align);user-select:none;-webkit-user-select:none;touch-action:manipulation;width:100%;margin-bottom:20px;-webkit-tap-highlight-color:transparent}@media (width > 575px){.atcb-modal-box{width:32em}}.atcb-modal-box.atcb-rtl{text-align:var(--modal-text-align-rtl);direction:rtl;padding:1.25em 1em 1.25em 2em}.atcb-modal-icon{height:2.5em;width:2.5em;border-radius:100%;background-color:var(--modal-background);padding:1.75em;margin:auto}.atcb-modal-icon svg{fill:currentcolor;height:100%;width:100%}.atcb-modal-headline{background-color:var(--modal-background);border-radius:var(--modal-border-radius) var(--modal-border-radius) 0 0;font-size:1.3em;font-weight:600;line-height:1.5em;padding:1.8em 1.5em 1.3em;text-transform:var(--modal-headline-text-transform);text-align:var(--modal-headline-text-align)}.atcb-modal-icon+.atcb-modal-headline{margin-top:-2.6em;padding-top:2.6em}.atcb-modal-content{background-color:var(--modal-background);font-size:1em;padding:.3em 2em 2.2em}.atcb-modal-content-subevents{margin:auto;width:fit-content}.atcb-modal-icon+.atcb-modal-content{border-radius:var(--modal-border-radius) var(--modal-border-radius) 0 0;margin-top:-2.6em;padding-top:2.6em}@media (width <= 575px){.atcb-modal-headline{padding:1.8em 1em 1em}.atcb-modal-content{padding:.3em 1.5em 1.5em}.atcb-modal-icon+.atcb-modal-content{padding-top:1.8em}}.atcb-modal-buttons{background-color:var(--modal-btn-bar);border-radius:0 0 var(--modal-border-radius) var(--modal-border-radius);box-sizing:border-box;padding:.6em;text-align:center;width:100%;display:flex;justify-content:center;flex-flow:row-reverse wrap;align-items:center}a.atcb-modal-btn,button.atcb-modal-btn{background-color:var(--modal-btn-secondary-background);border:0;border-radius:var(--btn-border-radius);box-shadow:var(--modal-btn-shadow);color:var(--modal-btn-secondary-text);cursor:pointer;display:inline-block;font-family:var(--font);font-size:.9em;font-weight:var(--modal-btn-font-weight);line-height:1em;margin:.625em;padding:1em 1.25em;position:relative;text-align:center;text-decoration:none;touch-action:manipulation;user-select:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent}a.atcb-modal-btn.btn-small,button.atcb-modal-btn.btn-small{padding:.6em .8em}a.atcb-modal-btn.atcb-modal-btn-primary,button.atcb-modal-btn.atcb-modal-btn-primary{background-color:var(--modal-btn-background);color:var(--modal-btn-text)}a.atcb-modal-btn.atcb-modal-btn-border,button.atcb-modal-btn.atcb-modal-btn-border{border:1px solid var(--modal-btn-border)}a.atcb-modal-btn:focus-visible,button.atcb-modal-btn:focus-visible{background-color:var(--modal-btn-hover-background);outline:2px solid var(--accent-color)}a.atcb-modal-btn:disabled,button.atcb-button:disabled,button.atcb-modal-btn:disabled,button.atcb-subevent-btn:disabled{cursor:not-allowed;opacity:.75;filter:brightness(95%);border-style:dashed;box-shadow:none}a.atcb-modal-btn:not([disabled]):hover,button.atcb-modal-btn:not([disabled]):hover{background-color:var(--modal-btn-hover-background);box-shadow:var(--modal-btn-hover-shadow);color:var(--modal-btn-hover-text);text-decoration:none}.atcb-subevent-btn{display:flex;align-items:flex-start;cursor:pointer;font-family:var(--font);font-size:1em;box-shadow:var(--date-btn-shadow);background-color:var(--date-btn-background);border:0;border-radius:7px 4px 4px 7px;padding:0;margin:0;touch-action:manipulation;position:relative;user-select:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent;width:100%}.atcb-subevent-btn:hover{align-items:center}.atcb-subevent-btn:focus,.atcb-subevent-btn:hover{background-color:var(--date-btn-hover-background);box-shadow:var(--date-btn-hover-shadow)}.atcb-subevent-btn:focus-visible{outline:2px solid var(--accent-color)}.atcb-subevent-btn+.atcb-subevent-btn{margin-top:30px}.atcb-date-btn-left{border-radius:4px 0 0 4px;align-self:stretch;background-color:var(--date-btn-cal-background);color:var(--date-btn-hover-background);padding:.7em .8em .8em;width:2.7em;align-items:center;display:flex;flex-direction:column;flex-shrink:0}.atcb-rtl .atcb-date-btn-left{border-radius:0 4px 4px 0}.atcb-subevent-btn:hover .atcb-date-btn-left{opacity:.8}.atcb-date-btn-day{color:var(--date-btn-cal-day-text);font-weight:400;font-size:2em;word-break:keep-all;padding-bottom:.1em}.atcb-initialized[lang=ja] .atcb-date-btn-day,.atcb-initialized[lang=ko] .atcb-date-btn-day,.atcb-initialized[lang=zh] .atcb-date-btn-day{font-size:1.3em}.atcb-date-btn-month{color:var(--date-btn-cal-month-text);font-weight:600;font-size:1em}.atcb-date-btn-right{position:relative;color:var(--date-btn-text);min-width:13.5em;overflow-wrap:anywhere}.atcb-subevent-btn .atcb-date-btn-right{width:100%}.atcb-date-btn-details{opacity:1;padding:.7em .8em;text-align:left}.atcb-rtl .atcb-date-btn-details{text-align:right}.atcb-date-btn-hover{position:absolute;top:0;left:0;width:100%;opacity:0;height:100%;display:flex;align-items:center;justify-content:center;font-weight:600;font-size:1em;padding:.4em .7em;box-sizing:border-box}.atcb-subevent-btn:hover .atcb-date-btn-details{opacity:0}.atcb-subevent-btn:hover .atcb-date-btn-hover{opacity:1}.atcb-date-btn-headline{font-weight:600;font-size:.9em;margin-bottom:.5em;overflow:hidden;display:-webkit-box;-webkit-line-clamp:var(--date-btn-headline-line-clamp);line-clamp:var(--date-btn-headline-line-clamp);-webkit-box-orient:vertical}.atcb-date-btn-content{display:flex;align-items:flex-start;font-size:.8em;color:var(--date-btn-text-secondary)}.atcb-date-btn-content.atcb-date-btn-cancelled{color:var(--form-error);font-weight:700}.atcb-date-btn-content-location{overflow:hidden;display:-webkit-box;-webkit-line-clamp:1;line-clamp:1;-webkit-box-orient:vertical;word-break:break-all}.atcb-date-btn-content-icon{display:inline-block;height:.8em;margin-right:.4em;margin-left:0;width:.9em;flex-shrink:0}.atcb-rtl .atcb-date-btn-content-icon{margin-right:0;margin-left:.4em}.atcb-initialized[lang=ja] .atcb-date-btn-content:not(.atcb-date-btn-content-location) .atcb-date-btn-content-icon,.atcb-initialized[lang=ko] .atcb-date-btn-content:not(.atcb-date-btn-content-location) .atcb-date-btn-content-icon,.atcb-initialized[lang=zh] .atcb-date-btn-content:not(.atcb-date-btn-content-location) .atcb-date-btn-content-icon{margin-top:.15em}.atcb-date-btn-content-icon svg{height:100%;fill:currentcolor;width:100%}.atcb-date-btn-content+.atcb-date-btn-content{margin-top:.3em}.atcb-date-btn-content-text span:not(.atcb-icon-ical){padding-right:.3em;display:inline-block}.atcb-checkmark{display:none}.atcb-saved .atcb-checkmark{box-sizing:content-box;color:var(--btn-text);display:block;position:absolute;top:-.9em;right:-.5em;padding:.5em;border-radius:100%;height:1.2em}.atcb-button.atcb-active:not(.atcb-modal-style,.atcb-dropoverlay) .atcb-checkmark,.atcb-button.atcb-single:focus .atcb-checkmark,.atcb-button.atcb-single:hover .atcb-checkmark{top:-.77em;right:-.37em}.atcb-checkmark svg{height:100%;filter:var(--checkmark-background);width:auto}#atcb-bgoverlay{backdrop-filter:blur(2px);-webkit-backdrop-filter:blur(2px);background-color:var(--overlay-background);border:0;box-sizing:border-box;display:flex;height:calc(100vh + 100px);inset-inline:0;left:0;right:0;top:0;min-height:100%;min-width:100%;overflow-y:auto;padding:20px 20px 130px;position:fixed;width:100vw;z-index:14000000}#atcb-bgoverlay:not(dialog){animation:atcb-bgoverlay-animate .2s ease 0s 1 normal forwards;opacity:0}#atcb-bgoverlay.atcb-no-bg{animation:none;backdrop-filter:none;-webkit-backdrop-filter:none;opacity:1;background-color:transparent}@keyframes atcb-bgoverlay-animate{0%{opacity:0}100%{opacity:1}}#atcb-bgoverlay.atcb-click:hover{cursor:var(--overlay-cursor)}.atcb-icon-outlookcom,.atcb-icon.atcb-icon-ms365{padding-bottom:.05em}.atcb-icon.atcb-icon-apple,.atcb-icon.atcb-icon-ical{padding-bottom:.15em}.atcb-icon.atcb-icon-trigger{padding-bottom:.15em}.atcb-icon.atcb-icon-rsvp{height:1.5em;width:1.5em}.atcb-icon.atcb-icon-apple svg{fill:currentcolor}.atcb-icon.atcb-icon-ical svg{fill:currentcolor}.atcb-icon.atcb-icon-ms365 svg{fill:var(--icon-ms365-color)}.atcb-icon.atcb-icon-yahoo svg{fill:var(--icon-yahoo-color)}.atcb-icon.atcb-icon-google svg,.atcb-icon.atcb-icon-msteams svg,.atcb-icon.atcb-icon-outlookcom svg{filter:var(--icon-filter)}.rsvp-inline-wrapper{filter:none;min-width:100%;margin-bottom:0}.atcb-modal-content.no-headline{border-radius:var(--modal-border-radius) var(--modal-border-radius) 0 0;padding-top:1.8em}.rsvp-inline-wrapper .atcb-modal-content,.rsvp-inline-wrapper .atcb-modal-headline,.rsvp-inline-wrapper.atcb-modal-box{background-color:transparent;border-radius:0;box-sizing:border-box;padding:0;width:100%}.rsvp-inline-wrapper .atcb-modal-headline{padding-bottom:1.5em}.pro{text-align:center}.pro ol,.pro ul{margin:auto;text-align:left;width:fit-content}.pro a:not(.atcb-modal-btn),.pro a:not(.atcb-modal-btn):active,.pro a:not(.atcb-modal-btn):visited{color:var(--modal-btn-text);text-decoration:underline;text-decoration-thickness:2px;text-decoration-color:var(--accent-color)}.pro a:not(.atcb-modal-btn):hover{color:var(--accent-color);text-decoration:none}.pro .pro-share-buttons{display:flex;flex-wrap:wrap;justify-content:center}.pro #rsvp-atcb{display:flex;flex-wrap:wrap;gap:.4em;justify-content:center}.pro-form{text-align:left}.pro-form:not(.no-intro){border-top:1px solid var(--modal-btn-border);margin-top:1.5em;padding-top:1.5em}.pro-form.no-intro:not(.no-headline){padding-top:.5em}.pro-field+.pro-field{padding-top:1.3em}.pro-field-type-label+.pro-field-type-radio{padding-top:0}.pro-field-type-checkbox,.pro-field-type-radio div{align-items:center;display:flex}.pro-field-type-checkbox input,.pro-field-type-radio input{cursor:pointer}.pro-field label{display:block;font-size:.9em;opacity:.7}.pro-field-type-checkbox label,.pro-field-type-radio label{cursor:pointer;opacity:.8;padding-left:.3em}.pro-field input[type=email],.pro-field input[type=number],.pro-field input[type=text]{background-color:var(--input-background);border:1px solid var(--modal-btn-border);border-radius:var(--input-border-radius);box-sizing:border-box;caret-color:var(--accent-color);color:var(--modal-text);font-size:.9em;opacity:.8;padding:.7em;transition:all .1s ease-in-out;width:100%}.pro-field input[type=checkbox],.pro-field input[type=radio]{accent-color:var(--accent-color);height:1.2rem;opacity:.8;transition:all .1s ease-in-out;width:1.2em}.pro-field input:disabled,.pro-field input:disabled+label{cursor:not-allowed;opacity:.75;filter:brightness(95%)}.pro-field input:not([disabled]):hover{opacity:1}.pro-field input[type=email]:focus,.pro-field input[type=number]:focus,.pro-field input[type=text]:focus{border-color:var(--accent-color);outline:1px solid var(--accent-color)}.pro-field input[type=checkbox]:focus,.pro-field input[type=radio]:focus{outline-color:var(--accent-color);outline-width:2px}#submit-error{color:var(--form-error);display:none;font-weight:700;padding-top:1.5em;text-align:center}.pro-form.form-error #submit-error{display:block}.pro-field input.error{accent-color:var(--form-error);border:2px solid var(--form-error)}.pro-field input.error+label,.pro-field:has(input.error) label{color:var(--form-error);opacity:1}#rsvp-status-group{border-bottom:1px solid var(--modal-btn-border);font-weight:700;margin-bottom:1.5em;padding-bottom:2em;text-align:center}#rsvp-status-group .pro-field{align-items:center;display:flex;flex-wrap:wrap;gap:3%;justify-content:center;margin-top:1em}@media (width <= 575px){#rsvp-status-group .pro-field{flex-direction:column;gap:1.2em}#rsvp-status-group .pro-field div{width:80%}}#rsvp-status-group .pro-field div{min-width:28%;position:relative}#rsvp-status-group input{opacity:0;position:absolute;top:0;left:0;height:100%;width:100%;margin:0;cursor:pointer}#rsvp-status-group label{align-items:center;border:1px solid var(--modal-btn-text);border-radius:var(--input-border-radius);box-shadow:var(--btn-shadow);color:var(--modal-btn-text);display:flex;flex-direction:column;font-weight:700;text-transform:uppercase;justify-content:center;opacity:.6;padding:.8em;transition:all .1s ease-in-out;width:100%}#rsvp-status-group label.status-confirmed{border-color:var(--form-success);color:var(--form-success)}#rsvp-status-group label.status-declined{border-color:var(--form-error);color:var(--form-error)}#rsvp-status-group input:checked+label{background-color:var(--modal-text);box-shadow:var(--btn-hover-shadow);color:var(--status-active-text);opacity:1;transform:scale(1.08)}#rsvp-status-group input:focus-visible+label{outline:2px solid var(--accent-color);outline-offset:2px}#rsvp-status-group input:not([disabled])+label:hover,#rsvp-status-group input:not([disabled]):hover+label{box-shadow:var(--btn-hover-shadow);opacity:1;transform:scale(1.08)}#rsvp-status-group input:checked+label.status-confirmed{background-color:var(--form-success)}#rsvp-status-group input:checked+label.status-declined{background-color:var(--form-error)}#rsvp-success-msg,#rsvp-success-msg-demo,#rsvp-success-msg-doi,#rsvp-success-msg-email,#ty-success-msg{display:none;font-weight:700;line-height:1.6em;padding-top:.5em;text-align:center}#rsvp-success-msg,#rsvp-success-msg-demo,#ty-success-msg{padding:1.5em 0}#rsvp-success-msg-demo,#rsvp-success-msg-email{color:var(--form-success)}#rsvp-success-msg-doi{color:var(--form-error);padding-top:1em;font-size:.8em}#pro-form-submit{display:block;margin:auto;min-width:150px}.pro-form-fine{font-size:.8em;margin:.5em auto 1em;opacity:.5;text-align:center}.pro-form.form-error .pro-form-fine{opacity:0}.pro-waiting{background-color:var(--modal-btn-background);border:1px solid var(--modal-btn-border);border-radius:var(--btn-border-radius);box-sizing:border-box;color:var(--modal-btn-text);cursor:wait;display:none;line-height:.5em;margin:auto;min-width:150px;padding:.5em 1.25em 1.2em;text-align:center;user-select:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent;width:fit-content}@media (width > 575px){#pro-form-submit,.pro-waiting{min-width:200px}}.pro-waiting span:not(.atcb-icon-ical){animation-name:blink;animation-duration:1s;animation-iteration-count:infinite;animation-fill-mode:both;font-size:2.5em}.pro-field label span:not(.atcb-icon-ical){color:var(--form-error);font-weight:700;padding-left:2px}.pro-waiting span:not(.atcb-icon-ical):nth-child(2){animation-delay:.15s}.pro-waiting span:not(.atcb-icon-ical):nth-child(3){animation-delay:.3s}@keyframes blink{0%{opacity:.2}20%{opacity:1}100%{opacity:.2}}.pro #rsvp-sent-content{align-items:center;display:flex;flex-direction:column;gap:1.5em}#rsvp-status-group span{color:inherit}.atcb-modal-content .pro p:not(.pro-form-fine){margin:0}.atcb-modal-content .pro p.pro-pt{margin-top:1.5em}.atcb-modal-content .pro .pro-field p{font-size:.9em}.pro .btn-flex{align-items:center;display:flex}.pro .atcb-modal-btn svg{fill:none;height:1.5em;margin-right:.5em;stroke:currentcolor;width:auto}#atcb-reference{box-sizing:border-box;filter:drop-shadow(0 0 3px rgba(255 255 255 / 80%));height:auto;padding:8px 0;text-align:center;transform:translate3d(0,0,0);width:100%;z-index:15000000}#atcb-reference.fixed-ref{position:fixed;bottom:10px;right:40px;width:auto}#atcb-reference.atcb-dropup{position:absolute;margin-top:-1px}.atcb-modal-host-initialized #atcb-reference.atcb-dropup{text-align:left}:host(.atcb-dark) #atcb-reference{filter:drop-shadow(0 0 5px #000)}#atcb-reference a,#atcb-reference a:active,#atcb-reference a:visited{opacity:.4;width:150px;max-width:100%;margin:auto;display:inline-block;text-decoration:none}#atcb-reference.fixed-ref a{opacity:.6}#atcb-reference a:hover{opacity:.9;text-decoration:none}#atcb-reference svg{fill:var(--list-text)}`,
  "3d": `:host{width:fit-content;--base-font-size-l:16px;--base-font-size-m:16px;--base-font-size-s:16px;--font:arial,helvetica,"Twemoji Mozilla","Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","EmojiOne Color","Android Emoji",sans-serif;--accent-color:#1e90ff;--wrapper-padding:0px;--buttonslist-gap:5px;--btn-background:#f5f5f5;--btn-hover-background:#fff;--btn-border:#d2d2d2;--btn-border-radius:6px;--btn-padding-x:1em;--btn-padding-y:.65em;--btn-font-weight:600;--btn-text:#333;--btn-hover-text:#000;--btn-shadow:rgba(0 0 0 / 10%) 0 4px 10px -2px,rgba(0 0 0 / 15%) 0 2px 2px -1px;--btn-hover-shadow:rgba(0 0 0 / 25%) 0 5px 12px -2px,rgba(0 0 0 / 25%) 0 3px 5px -2px;--btn-active-shadow:rgba(0 0 0 / 40%) 0 8px 13px -2px,rgba(0 0 0 / 30%) 0 5px 5px -3px;--btn-active-shadow-up:rgba(0 0 0 / 30%) 0 6px 13px -2px,rgba(0 0 0 / 15%) 0 2px 2px -1px,rgba(0 0 0 / 25%) 0 -3px 10px -1px;--list-background:#f5f5f5;--list-hover-background:#fff;--list-text:#333;--list-hover-text:#000;--list-close-background:#e5e5e5;--list-close-text:#777;--list-border-radius:6px;--list-padding:.8em;--list-shadow:rgba(0 0 0 / 20%) 0 4px 13px -2px,rgba(0 0 0 / 23%) 0 2px 4px -1px;--list-modal-shadow:rgba(0 0 0 / 50%) 0 4px 30px -3px,rgba(0 0 0 / 30%) 0 2px 8px -2px;--modal-text:#000;--modal-text-align:left;--modal-text-align-rtl:right;--modal-background:#f5f5f5;--modal-border-radius:6px;--modal-shadow:drop-shadow(3px 6px 25px rgba(0 0 0 / 65%));--modal-btn-bar:#c6c8cd;--modal-btn-background:#f5f5f5;--modal-btn-secondary-background:#e2e1e6;--modal-btn-hover-background:#fff;--modal-btn-border:#d2d2d2;--modal-btn-font-weight:600;--modal-btn-text:#2e2e2e;--modal-btn-hover-text:#161616;--modal-btn-secondary-text:#666567;--modal-btn-shadow:rgba(0 0 0 / 10%) 0 4px 10px -2px,rgba(0 0 0 / 10%) 0 2px 3px -1px;--modal-btn-hover-shadow:rgba(0 0 0 / 25%) 0 5px 13px -2px,rgba(0 0 0 / 20%) 0 3px 5px -2px;--modal-headline-text-align:center;--modal-headline-text-transform:none;--input-border-radius:6px;--input-background:#fff;--status-active-text:#fff;--form-error:#c5372c;--form-success:#338a36;--date-btn-text:#1d1d1e;--date-btn-text-secondary:#3a3a3f;--date-btn-cal-day-text:#fff;--date-btn-cal-month-text:#d3d2d7;--date-btn-cal-background:#313132;--date-btn-background:#eae9ed;--date-btn-hover-background:#fff;--date-btn-headline-line-clamp:1;--date-btn-shadow:rgba(0 0 0 / 10%) 0 4px 10px -2px,rgba(0 0 0 / 15%) 0 2px 3px -1px;--date-btn-hover-shadow:rgba(0 0 0 / 20%) 0 5px 12px -2px,rgba(0 0 0 / 20%) 0 3px 4px -2px;--checkmark-background:drop-shadow(0 0 3px #fff);--overlay-background:rgba(20 20 20 / 25%);--overlay-cursor:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23777' width='16' height='16' viewBox='0 0 122.878 122.88'%3E%3Cpath d='M1.426 8.313a4.87 4.87 0 0 1 0-6.886 4.87 4.87 0 0 1 6.886 0l53.127 53.127 53.127-53.127a4.87 4.87 0 0 1 6.887 0 4.87 4.87 0 0 1 0 6.886L68.324 61.439l53.128 53.128a4.87 4.87 0 0 1-6.887 6.886L61.438 68.326 8.312 121.453a4.87 4.87 0 0 1-6.886 0 4.87 4.87 0 0 1 0-6.886l53.127-53.128L1.426 8.313h0z'/%3E%3C/svg%3E") 16 16,crosshair;--icon-ms365-color:#ea3e23;--icon-yahoo-color:#5f01d1;--icon-filter:none}:host(.atcb-dark){--btn-background:#2e2e2e;--btn-hover-background:#373737;--btn-border:#4d4d4d;--btn-text:#dedede;--btn-hover-text:#f1f1f1;--btn-shadow:rgba(255 255 255 / 5%) -3px -3px 30px -1px,rgba(0 0 0 / 40%) 2px 3px 10px -2px,rgba(0 0 0 / 40%) 1px 2px 3px -1px;--btn-hover-shadow:rgba(0 0 0 / 90%) 2px 5px 20px -4px,rgba(0 0 0 / 50%) 1px 2px 6px -2px;--btn-active-shadow:rgba(0 0 0 / 90%) 2px 5px 20px -4px,rgba(0 0 0 / 50%) 1px 2px 6px -2px;--btn-active-shadow-up:rgba(0 0 0 / 80%) 2px 4px 20px -4px,rgba(0 0 0 / 30%) 1px 1px 3px -1px,rgba(0 0 0 / 45%) 0 -3px 10px -1px;--list-background:#2e2e2e;--list-hover-background:#373737;--list-text:#dedede;--list-hover-text:#f1f1f1;--list-close-background:#282828;--list-shadow:rgba(0 0 0 / 60%) 0 4px 20px -2px,rgba(0 0 0 / 40%) 0 2px 4px -1px;--list-modal-shadow:rgba(0 0 0 / 40%) -1px 3px 30px 2px;--modal-text:#f1f1f1;--modal-background:#242424;--modal-shadow:drop-shadow(3px 6px 25px rgba(0 0 0 / 90%));--modal-btn-bar:#38383a;--modal-btn-background:#181819;--modal-btn-secondary-background:#2e2d30;--modal-btn-hover-background:#434246;--modal-btn-border:#434246;--modal-btn-text:#dbdbdb;--modal-btn-hover-text:#fff;--modal-btn-secondary-text:#b8b8b8;--modal-btn-shadow:rgba(255 255 255 / 5%) -2px -2px 10px,rgba(0 0 0 / 40%) 3px 3px 10px -2px,rgba(0 0 0 / 40%) 1px 2px 5px -1px;--modal-btn-hover-shadow:none;--input-background:#434246;--status-active-text:#000;--form-error:#db8680;--form-success:#99de9c;--date-btn-text:#ebebf0;--date-btn-text-secondary:#b5b5bd;--date-btn-cal-day-text:#101010;--date-btn-cal-month-text:#3e3e3f;--date-btn-cal-background:#c7c7cd;--date-btn-background:#363636;--date-btn-hover-background:#474747;--date-btn-shadow:rgba(0 0 0 / 60%) 0 0 20px -2px,rgba(0 0 0 / 30%) 1px 2px 3px -1px;--date-btn-hover-shadow:none;--checkmark-background:drop-shadow(0 0 3px #0a0a0a);--overlay-background:rgba(20 20 20 / 60%);--icon-ms365-color:#ea3e23;--icon-yahoo-color:#bebebe;--icon-filter:grayscale(.2)}.atcb-button-wrapper,.atcb-list,.atcb-modal-box{font-size:var(--base-font-size-l)}@media (width <= 991px){.atcb-button-wrapper,.atcb-list,.atcb-modal-box{font-size:var(--base-font-size-m)}}@media (width <= 575px){.atcb-button-wrapper,.atcb-list,.atcb-modal-box{font-size:var(--base-font-size-s)}}.atcb-initialized.atcb-buttons-list{gap:var(--buttonslist-gap)}.atcb-button-wrapper{display:block;padding:var(--wrapper-padding);position:relative}.atcb-button{align-items:center;background-color:var(--btn-background);border:1px solid var(--btn-border);border-radius:var(--btn-border-radius);box-shadow:var(--btn-shadow);box-sizing:content-box;color:var(--btn-text);cursor:pointer;display:flex;font-family:var(--font);font-size:1em;font-weight:var(--btn-font-weight);justify-content:center;line-height:1.5em;margin:0;max-width:300px;padding:var(--btn-padding-y) var(--btn-padding-x);position:relative;text-align:center;touch-action:manipulation;transform:translate3d(0,0,-12px);user-select:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent;width:auto;z-index:1}.atcb-button:not(.atcb-no-text,.atcb-modal-style,.atcb-dropoverlay,.atcb-single){min-width:calc(11.6em - 2 * var(--btn-padding-x))}.atcb-button.atcb-no-text{display:flex;place-content:center center;align-items:center;height:3em;width:3em;padding:0}.atcb-rtl .atcb-button{direction:rtl;text-align:right}.atcb-button:focus-visible{outline:2px solid var(--accent-color)}.atcb-button:not([disabled]):focus,.atcb-button:not([disabled]):hover{background-color:var(--btn-hover-background);box-shadow:var(--btn-hover-shadow);color:var(--btn-hover-text)}.atcb-button.atcb-active:not(.atcb-modal-style,.atcb-dropoverlay){background-color:var(--btn-hover-background);z-index:15000000}.atcb-button.atcb-single:not([disabled]):focus,.atcb-button.atcb-single:not([disabled]):hover{background-color:var(--btn-hover-background);box-shadow:var(--btn-active-shadow);color:var(--btn-hover-text)}.atcb-button.atcb-active:not(.atcb-modal-style,.atcb-dropup,.atcb-dropoverlay){box-shadow:var(--btn-active-shadow);transform:perspective(100px) rotateX(12deg) translate3d(0,0,2px);transition:transform .1s linear}.atcb-button.atcb-active.atcb-dropup:not(.atcb-modal-style,.atcb-dropoverlay){box-shadow:var(--btn-active-shadow-up);transform:perspective(100px) rotateX(348deg) translate3d(0,0,2px);transition:transform .1s linear}.atcb-button.atcb-active.atcb-dropoverlay{transform:translate3d(0,0,0);z-index:14000090}.atcb-icon{flex-grow:0;flex-shrink:0;height:1em;line-height:1em;margin-right:.8em;width:1em}.atcb-rtl .atcb-icon{margin-right:0;margin-left:.8em}.atcb-no-text .atcb-icon{margin-right:0;margin-left:0}.atcb-icon svg{fill:currentcolor;height:100%;width:100%}.atcb-text{overflow-wrap:anywhere}.atcb-dropdown-anchor{bottom:6px;height:1px;width:100%;opacity:0;position:absolute}.atcb-list-wrapper{box-sizing:border-box;padding:0 4px;position:absolute;transform:translate3d(0,0,0);z-index:14000090}.atcb-list{background-color:var(--list-background);border-radius:0 0 var(--list-border-radius) var(--list-border-radius);box-sizing:border-box;box-shadow:var(--list-shadow);color:var(--list-text);display:block;font-family:var(--font);min-width:100%;position:relative;user-select:none;-webkit-user-select:none;width:fit-content}.atcb-list-wrapper.atcb-dropdown:not(.atcb-dropup,.atcb-dropoverlay){animation:atcb-list-slide-down .4s ease 50ms 1 normal both;opacity:0}.atcb-list-wrapper.atcb-dropup:not(.atcb-dropoverlay){animation:atcb-list-slide-up .4s ease 50ms 1 normal both;opacity:0}.atcb-list-wrapper.atcb-dropoverlay{transform:translate3d(0,0,2px);z-index:15000000;animation:atcb-list-slide-center .3s ease 0s 1 normal both;opacity:0}@keyframes atcb-list-slide-down{0%{opacity:0;transform:rotateX(70deg);transform-origin:top}100%{opacity:1;transform:rotateX(0);transform-origin:top}}@keyframes atcb-list-slide-up{0%{opacity:0;transform:rotateX(70deg);transform-origin:bottom}100%{opacity:1;transform:rotateX(0);transform-origin:bottom}}@keyframes atcb-list-slide-center{0%{opacity:0;transform:scaleY(1)}1%{opacity:1;transform:scaleY(0)}100%{opacity:1;transform:scaleY(1)}}.atcb-list-item{align-items:center;background-color:var(--list-background);box-sizing:border-box;cursor:pointer;display:flex;font-size:1em;line-height:1.75em;padding:var(--list-padding);text-align:left;touch-action:manipulation;-webkit-tap-highlight-color:transparent}.atcb-rtl .atcb-list-item{direction:rtl;text-align:right}.atcb-list-item:hover{background-color:var(--list-hover-background);color:var(--list-hover-text)}.atcb-list-item:focus-visible{background-color:var(--list-hover-background);color:var(--accent-color);outline:0}.atcb-list-item:last-child{border-radius:0 0 var(--list-border-radius) var(--list-border-radius)}.atcb-dropup .atcb-list-item:last-child{border-radius:0;padding-bottom:calc(var(--list-padding) + .7em)}.atcb-dropoverlay .atcb-list .atcb-list-item:first-child,.atcb-dropup .atcb-list,.atcb-dropup .atcb-list-item:first-child,.atcb-list.atcb-modal .atcb-list-item:first-child{border-radius:var(--list-border-radius) var(--list-border-radius) 0 0}.atcb-dropoverlay .atcb-list .atcb-list-item:only-child,.atcb-list.atcb-modal .atcb-list-item:only-child{border-radius:var(--list-border-radius)}.atcb-list.atcb-generated-button:not(.atcb-modal) .atcb-list-item:first-child{padding-top:calc(var(--list-padding) + .7em)}.atcb-dropoverlay .atcb-list.atcb-generated-button:not(.atcb-modal) .atcb-list-item:first-child,.atcb-dropup .atcb-list.atcb-generated-button:not(.atcb-modal) .atcb-list-item:first-child{padding-top:var(--list-padding)}.atcb-dropoverlay .atcb-list,.atcb-list.atcb-modal{border-radius:var(--list-border-radius)}.atcb-list.atcb-modal{box-shadow:var(--list-modal-shadow)}.atcb-list-item .atcb-icon{margin:0 auto}.atcb-list-item .atcb-icon+.atcb-text{margin-left:.7em;width:100%}.atcb-rtl .atcb-list-item .atcb-icon+.atcb-text{margin-left:0;margin-right:.7em}.atcb-list-item-close{background-color:var(--list-close-background)}.atcb-list-item.atcb-list-item-close:not(:focus-visible){color:var(--list-close-text)}.atcb-list-item-close svg{fill:currentcolor}.atcb-modal{display:block;margin:auto;width:auto;min-width:auto;position:relative;z-index:14000090}.atcb-modal-box{filter:var(--modal-shadow);color:var(--modal-text);cursor:default;box-sizing:border-box;font-family:var(--font);line-height:1.5em;text-align:var(--modal-text-align);user-select:none;-webkit-user-select:none;touch-action:manipulation;width:100%;margin-bottom:20px;-webkit-tap-highlight-color:transparent}@media (width > 575px){.atcb-modal-box{width:32em}}.atcb-modal-box.atcb-rtl{text-align:var(--modal-text-align-rtl);direction:rtl;padding:1.25em 1em 1.25em 2em}.atcb-modal-icon{height:2.5em;width:2.5em;border-radius:100%;background-color:var(--modal-background);padding:1.75em;margin:auto}.atcb-modal-icon svg{fill:currentcolor;height:100%;width:100%}.atcb-modal-headline{background-color:var(--modal-background);border-radius:var(--modal-border-radius) var(--modal-border-radius) 0 0;font-size:1.3em;font-weight:600;line-height:1.5em;padding:1.8em 1.5em 1.3em;text-transform:var(--modal-headline-text-transform);text-align:var(--modal-headline-text-align)}.atcb-modal-icon+.atcb-modal-headline{margin-top:-2.6em;padding-top:2.6em}.atcb-modal-content{background-color:var(--modal-background);font-size:1em;padding:.3em 2em 2.2em}.atcb-modal-content-subevents{margin:auto;width:fit-content}.atcb-modal-icon+.atcb-modal-content{border-radius:var(--modal-border-radius) var(--modal-border-radius) 0 0;margin-top:-2.6em;padding-top:2.6em}@media (width <= 575px){.atcb-modal-headline{padding:1.8em 1em 1em}.atcb-modal-content{padding:.3em 1.5em 1.5em}.atcb-modal-icon+.atcb-modal-content{padding-top:1.8em}}.atcb-modal-buttons{background-color:var(--modal-btn-bar);border-radius:0 0 var(--modal-border-radius) var(--modal-border-radius);box-sizing:border-box;padding:.6em;text-align:center;width:100%;display:flex;justify-content:center;flex-flow:row-reverse wrap;align-items:center}a.atcb-modal-btn,button.atcb-modal-btn{background-color:var(--modal-btn-secondary-background);border:0;border-radius:var(--btn-border-radius);box-shadow:var(--modal-btn-shadow);color:var(--modal-btn-secondary-text);cursor:pointer;display:inline-block;font-family:var(--font);font-size:.9em;font-weight:var(--modal-btn-font-weight);line-height:1em;margin:.625em;padding:1em 1.25em;position:relative;text-align:center;text-decoration:none;touch-action:manipulation;user-select:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent}a.atcb-modal-btn.btn-small,button.atcb-modal-btn.btn-small{padding:.6em .8em}a.atcb-modal-btn.atcb-modal-btn-primary,button.atcb-modal-btn.atcb-modal-btn-primary{background-color:var(--modal-btn-background);color:var(--modal-btn-text)}a.atcb-modal-btn.atcb-modal-btn-border,button.atcb-modal-btn.atcb-modal-btn-border{border:1px solid var(--modal-btn-border)}a.atcb-modal-btn:focus-visible,button.atcb-modal-btn:focus-visible{background-color:var(--modal-btn-hover-background);outline:2px solid var(--accent-color)}a.atcb-modal-btn:disabled,button.atcb-button:disabled,button.atcb-modal-btn:disabled,button.atcb-subevent-btn:disabled{cursor:not-allowed;opacity:.75;filter:brightness(95%);border-style:dashed;box-shadow:none}a.atcb-modal-btn:not([disabled]):hover,button.atcb-modal-btn:not([disabled]):hover{background-color:var(--modal-btn-hover-background);box-shadow:var(--modal-btn-hover-shadow);color:var(--modal-btn-hover-text);text-decoration:none}.atcb-subevent-btn{display:flex;align-items:flex-start;cursor:pointer;font-family:var(--font);font-size:1em;box-shadow:var(--date-btn-shadow);background-color:var(--date-btn-background);border:0;border-radius:7px 4px 4px 7px;padding:0;margin:0;touch-action:manipulation;position:relative;user-select:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent;width:100%}.atcb-subevent-btn:hover{align-items:center}.atcb-subevent-btn:focus,.atcb-subevent-btn:hover{background-color:var(--date-btn-hover-background);box-shadow:var(--date-btn-hover-shadow)}.atcb-subevent-btn:focus-visible{outline:2px solid var(--accent-color)}.atcb-subevent-btn+.atcb-subevent-btn{margin-top:30px}.atcb-date-btn-left{border-radius:4px 0 0 4px;align-self:stretch;background-color:var(--date-btn-cal-background);color:var(--date-btn-hover-background);padding:.7em .8em .8em;width:2.7em;align-items:center;display:flex;flex-direction:column;flex-shrink:0}.atcb-rtl .atcb-date-btn-left{border-radius:0 4px 4px 0}.atcb-subevent-btn:hover .atcb-date-btn-left{opacity:.8}.atcb-date-btn-day{color:var(--date-btn-cal-day-text);font-weight:400;font-size:2em;word-break:keep-all;padding-bottom:.1em}.atcb-initialized[lang=ja] .atcb-date-btn-day,.atcb-initialized[lang=ko] .atcb-date-btn-day,.atcb-initialized[lang=zh] .atcb-date-btn-day{font-size:1.3em}.atcb-date-btn-month{color:var(--date-btn-cal-month-text);font-weight:600;font-size:1em}.atcb-date-btn-right{position:relative;color:var(--date-btn-text);min-width:13.5em;overflow-wrap:anywhere}.atcb-subevent-btn .atcb-date-btn-right{width:100%}.atcb-date-btn-details{opacity:1;padding:.7em .8em;text-align:left}.atcb-rtl .atcb-date-btn-details{text-align:right}.atcb-date-btn-hover{position:absolute;top:0;left:0;width:100%;opacity:0;height:100%;display:flex;align-items:center;justify-content:center;font-weight:600;font-size:1em;padding:.4em .7em;box-sizing:border-box}.atcb-subevent-btn:hover .atcb-date-btn-details{opacity:0}.atcb-subevent-btn:hover .atcb-date-btn-hover{opacity:1}.atcb-date-btn-headline{font-weight:600;font-size:.9em;margin-bottom:.5em;overflow:hidden;display:-webkit-box;-webkit-line-clamp:var(--date-btn-headline-line-clamp);line-clamp:var(--date-btn-headline-line-clamp);-webkit-box-orient:vertical}.atcb-date-btn-content{display:flex;align-items:flex-start;font-size:.8em;color:var(--date-btn-text-secondary)}.atcb-date-btn-content.atcb-date-btn-cancelled{color:var(--form-error);font-weight:700}.atcb-date-btn-content-location{overflow:hidden;display:-webkit-box;-webkit-line-clamp:1;line-clamp:1;-webkit-box-orient:vertical;word-break:break-all}.atcb-date-btn-content-icon{display:inline-block;height:.8em;margin-right:.4em;margin-left:0;width:.9em;flex-shrink:0}.atcb-rtl .atcb-date-btn-content-icon{margin-right:0;margin-left:.4em}.atcb-initialized[lang=ja] .atcb-date-btn-content:not(.atcb-date-btn-content-location) .atcb-date-btn-content-icon,.atcb-initialized[lang=ko] .atcb-date-btn-content:not(.atcb-date-btn-content-location) .atcb-date-btn-content-icon,.atcb-initialized[lang=zh] .atcb-date-btn-content:not(.atcb-date-btn-content-location) .atcb-date-btn-content-icon{margin-top:.15em}.atcb-date-btn-content-icon svg{height:100%;fill:currentcolor;width:100%}.atcb-date-btn-content+.atcb-date-btn-content{margin-top:.3em}.atcb-date-btn-content-text span:not(.atcb-icon-ical){padding-right:.3em;display:inline-block}.atcb-checkmark{display:none}.atcb-saved .atcb-checkmark{box-sizing:content-box;color:var(--btn-text);display:block;position:absolute;top:-.9em;right:-.5em;padding:.5em;border-radius:100%;height:1.2em}.atcb-checkmark svg{height:100%;filter:var(--checkmark-background);width:auto}#atcb-bgoverlay{backdrop-filter:blur(2px);-webkit-backdrop-filter:blur(2px);background-color:var(--overlay-background);border:0;box-sizing:border-box;display:flex;height:calc(100vh + 100px);inset-inline:0;left:0;right:0;top:0;min-height:100%;min-width:100%;overflow-y:auto;padding:20px 20px 130px;position:fixed;width:100vw;z-index:14000000}#atcb-bgoverlay:not(dialog){animation:atcb-bgoverlay-animate .2s ease 0s 1 normal forwards;opacity:0}#atcb-bgoverlay.atcb-no-bg{animation:none;backdrop-filter:none;-webkit-backdrop-filter:none;opacity:1;background-color:transparent}@keyframes atcb-bgoverlay-animate{0%{opacity:0}100%{opacity:1}}#atcb-bgoverlay.atcb-click:hover{cursor:var(--overlay-cursor)}.atcb-icon-outlookcom,.atcb-icon.atcb-icon-ms365{padding-bottom:.05em}.atcb-icon.atcb-icon-apple,.atcb-icon.atcb-icon-ical{padding-bottom:.15em}.atcb-icon.atcb-icon-trigger{padding-bottom:.15em}.atcb-icon.atcb-icon-rsvp{height:1.5em;width:1.5em}.atcb-icon.atcb-icon-apple svg{fill:currentcolor}.atcb-icon.atcb-icon-ical svg{fill:currentcolor}.atcb-icon.atcb-icon-ms365 svg{fill:var(--icon-ms365-color)}.atcb-icon.atcb-icon-yahoo svg{fill:var(--icon-yahoo-color)}.atcb-icon.atcb-icon-google svg,.atcb-icon.atcb-icon-msteams svg,.atcb-icon.atcb-icon-outlookcom svg{filter:var(--icon-filter)}.rsvp-inline-wrapper{filter:none;min-width:100%;margin-bottom:0}.atcb-modal-content.no-headline{border-radius:var(--modal-border-radius) var(--modal-border-radius) 0 0;padding-top:1.8em}.rsvp-inline-wrapper .atcb-modal-content,.rsvp-inline-wrapper .atcb-modal-headline,.rsvp-inline-wrapper.atcb-modal-box{background-color:transparent;border-radius:0;box-sizing:border-box;padding:0;width:100%}.rsvp-inline-wrapper .atcb-modal-headline{padding-bottom:1.5em}.pro{text-align:center}.pro ol,.pro ul{margin:auto;text-align:left;width:fit-content}.pro a:not(.atcb-modal-btn),.pro a:not(.atcb-modal-btn):active,.pro a:not(.atcb-modal-btn):visited{color:var(--modal-btn-text);text-decoration:underline;text-decoration-thickness:2px;text-decoration-color:var(--accent-color)}.pro a:not(.atcb-modal-btn):hover{color:var(--accent-color);text-decoration:none}.pro .pro-share-buttons{display:flex;flex-wrap:wrap;justify-content:center}.pro #rsvp-atcb{display:flex;flex-wrap:wrap;gap:.4em;justify-content:center}.pro-form{text-align:left}.pro-form:not(.no-intro){border-top:1px solid var(--modal-btn-border);margin-top:1.5em;padding-top:1.5em}.pro-form.no-intro:not(.no-headline){padding-top:.5em}.pro-field+.pro-field{padding-top:1.3em}.pro-field-type-label+.pro-field-type-radio{padding-top:0}.pro-field-type-checkbox,.pro-field-type-radio div{align-items:center;display:flex}.pro-field-type-checkbox input,.pro-field-type-radio input{cursor:pointer}.pro-field label{display:block;font-size:.9em;opacity:.7}.pro-field-type-checkbox label,.pro-field-type-radio label{cursor:pointer;opacity:.8;padding-left:.3em}.pro-field input[type=email],.pro-field input[type=number],.pro-field input[type=text]{background-color:var(--input-background);border:1px solid var(--modal-btn-border);border-radius:var(--input-border-radius);box-sizing:border-box;caret-color:var(--accent-color);color:var(--modal-text);font-size:.9em;opacity:.8;padding:.7em;transition:all .1s ease-in-out;width:100%}.pro-field input[type=checkbox],.pro-field input[type=radio]{accent-color:var(--accent-color);height:1.2rem;opacity:.8;transition:all .1s ease-in-out;width:1.2em}.pro-field input:disabled,.pro-field input:disabled+label{cursor:not-allowed;opacity:.75;filter:brightness(95%)}.pro-field input:not([disabled]):hover{opacity:1}.pro-field input[type=email]:focus,.pro-field input[type=number]:focus,.pro-field input[type=text]:focus{border-color:var(--accent-color);outline:1px solid var(--accent-color)}.pro-field input[type=checkbox]:focus,.pro-field input[type=radio]:focus{outline-color:var(--accent-color);outline-width:2px}#submit-error{color:var(--form-error);display:none;font-weight:700;padding-top:1.5em;text-align:center}.pro-form.form-error #submit-error{display:block}.pro-field input.error{accent-color:var(--form-error);border:2px solid var(--form-error)}.pro-field input.error+label,.pro-field:has(input.error) label{color:var(--form-error);opacity:1}#rsvp-status-group{border-bottom:1px solid var(--modal-btn-border);font-weight:700;margin-bottom:1.5em;padding-bottom:2em;text-align:center}#rsvp-status-group .pro-field{align-items:center;display:flex;flex-wrap:wrap;gap:3%;justify-content:center;margin-top:1em}@media (width <= 575px){#rsvp-status-group .pro-field{flex-direction:column;gap:1.2em}#rsvp-status-group .pro-field div{width:80%}}#rsvp-status-group .pro-field div{min-width:28%;position:relative}#rsvp-status-group input{opacity:0;position:absolute;top:0;left:0;height:100%;width:100%;margin:0;cursor:pointer}#rsvp-status-group label{align-items:center;border:1px solid var(--modal-btn-text);border-radius:var(--input-border-radius);box-shadow:var(--btn-shadow);color:var(--modal-btn-text);display:flex;flex-direction:column;font-weight:700;text-transform:uppercase;justify-content:center;opacity:.6;padding:.8em;transition:all .1s ease-in-out;width:100%}#rsvp-status-group label.status-confirmed{border-color:var(--form-success);color:var(--form-success)}#rsvp-status-group label.status-declined{border-color:var(--form-error);color:var(--form-error)}#rsvp-status-group input:checked+label{background-color:var(--modal-text);box-shadow:var(--btn-hover-shadow);color:var(--status-active-text);opacity:1;transform:scale(1.08)}#rsvp-status-group input:focus-visible+label{outline:2px solid var(--accent-color);outline-offset:2px}#rsvp-status-group input:not([disabled])+label:hover,#rsvp-status-group input:not([disabled]):hover+label{box-shadow:var(--btn-hover-shadow);opacity:1;transform:scale(1.08)}#rsvp-status-group input:checked+label.status-confirmed{background-color:var(--form-success)}#rsvp-status-group input:checked+label.status-declined{background-color:var(--form-error)}#rsvp-success-msg,#rsvp-success-msg-demo,#rsvp-success-msg-doi,#rsvp-success-msg-email,#ty-success-msg{display:none;font-weight:700;line-height:1.6em;padding-top:.5em;text-align:center}#rsvp-success-msg,#rsvp-success-msg-demo,#ty-success-msg{padding:1.5em 0}#rsvp-success-msg-demo,#rsvp-success-msg-email{color:var(--form-success)}#rsvp-success-msg-doi{color:var(--form-error);padding-top:1em;font-size:.8em}#pro-form-submit{display:block;margin:auto;min-width:150px}.pro-form-fine{font-size:.8em;margin:.5em auto 1em;opacity:.5;text-align:center}.pro-form.form-error .pro-form-fine{opacity:0}.pro-waiting{background-color:var(--modal-btn-background);border:1px solid var(--modal-btn-border);border-radius:var(--btn-border-radius);box-sizing:border-box;color:var(--modal-btn-text);cursor:wait;display:none;line-height:.5em;margin:auto;min-width:150px;padding:.5em 1.25em 1.2em;text-align:center;user-select:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent;width:fit-content}@media (width > 575px){#pro-form-submit,.pro-waiting{min-width:200px}}.pro-waiting span:not(.atcb-icon-ical){animation-name:blink;animation-duration:1s;animation-iteration-count:infinite;animation-fill-mode:both;font-size:2.5em}.pro-field label span:not(.atcb-icon-ical){color:var(--form-error);font-weight:700;padding-left:2px}.pro-waiting span:not(.atcb-icon-ical):nth-child(2){animation-delay:.15s}.pro-waiting span:not(.atcb-icon-ical):nth-child(3){animation-delay:.3s}@keyframes blink{0%{opacity:.2}20%{opacity:1}100%{opacity:.2}}.pro #rsvp-sent-content{align-items:center;display:flex;flex-direction:column;gap:1.5em}#rsvp-status-group span{color:inherit}.atcb-modal-content .pro p:not(.pro-form-fine){margin:0}.atcb-modal-content .pro p.pro-pt{margin-top:1.5em}.atcb-modal-content .pro .pro-field p{font-size:.9em}.pro .btn-flex{align-items:center;display:flex}.pro .atcb-modal-btn svg{fill:none;height:1.5em;margin-right:.5em;stroke:currentcolor;width:auto}#atcb-reference{box-sizing:border-box;filter:drop-shadow(0 0 3px rgba(255 255 255 / 80%));height:auto;padding:8px 0;text-align:center;transform:translate3d(0,0,0);width:100%;z-index:15000000}#atcb-reference.fixed-ref{position:fixed;bottom:10px;right:40px;width:auto}#atcb-reference.atcb-dropup{position:absolute;margin-top:-1px}.atcb-modal-host-initialized #atcb-reference.atcb-dropup{text-align:left}:host(.atcb-dark) #atcb-reference{filter:drop-shadow(0 0 5px #000)}#atcb-reference a,#atcb-reference a:active,#atcb-reference a:visited{opacity:.4;width:150px;max-width:100%;margin:auto;display:inline-block;text-decoration:none}#atcb-reference.fixed-ref a{opacity:.6}#atcb-reference a:hover{opacity:.9;text-decoration:none}#atcb-reference svg{fill:var(--list-text)}`,
  flat: `:host{width:fit-content;--base-font-size-l:16px;--base-font-size-m:16px;--base-font-size-s:16px;--font:arial,helvetica,"Twemoji Mozilla","Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","EmojiOne Color","Android Emoji",sans-serif;--accent-color:#1e90ff;--wrapper-padding:0px;--buttonslist-gap:8px;--btn-background:#f5f5f5;--btn-hover-background:#fff;--btn-border:#545454;--btn-padding-x:1.2em;--btn-padding-y:.8em;--btn-shadow:#333;--btn-font-weight:600;--btn-text:#333;--btn-hover-text:#000;--list-background:#f5f5f5;--list-hover-background:#fff;--list-border:#545454;--list-text:#333;--list-font-weight:400;--list-hover-text:#000;--list-close-background:#545454;--list-close-text:#b0b0b0;--list-close-text-hover:#777;--list-padding:.8em;--modal-text:#000;--modal-text-align:left;--modal-text-align-rtl:right;--modal-background:#f5f5f5;--modal-btn-bar:#bababa;--modal-btn-background:#f5f5f5;--modal-btn-secondary-background:#e2e1e6;--modal-btn-hover-background:#fff;--modal-btn-border:#545454;--modal-btn-font-weight:600;--modal-btn-text:#2e2e2e;--modal-btn-hover-text:#161616;--modal-btn-secondary-text:#676767;--modal-headline-text-align:center;--modal-headline-text-transform:uppercase;--input-background:#fff;--status-active-text:#fff;--form-error:#c5372c;--form-success:#338a36;--date-btn-text:#1d1d1e;--date-btn-text-secondary:#414141;--date-btn-cal-day-text:#fff;--date-btn-cal-month-text:#d3d2d7;--date-btn-cal-background:#313132;--date-btn-background:#eae9ed;--date-btn-hover-background:#fff;--date-btn-headline-line-clamp:1;--overlay-background:rgba(20 20 20 / 40%);--overlay-cursor:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23777' width='16' height='16' viewBox='0 0 122.878 122.88'%3E%3Cpath d='M1.426 8.313a4.87 4.87 0 0 1 0-6.886 4.87 4.87 0 0 1 6.886 0l53.127 53.127 53.127-53.127a4.87 4.87 0 0 1 6.887 0 4.87 4.87 0 0 1 0 6.886L68.324 61.439l53.128 53.128a4.87 4.87 0 0 1-6.887 6.886L61.438 68.326 8.312 121.453a4.87 4.87 0 0 1-6.886 0 4.87 4.87 0 0 1 0-6.886l53.127-53.128L1.426 8.313h0z'/%3E%3C/svg%3E") 16 16,crosshair;--icon-ms365-color:#ea3e23;--icon-yahoo-color:#5f01d1;--icon-filter:none}:host(.atcb-dark){--btn-background:#222;--btn-hover-background:#373737;--btn-border:#515151;--btn-shadow:#000;--btn-text:#dedede;--btn-hover-text:#f1f1f1;--list-background:#222;--list-hover-background:#373737;--list-border:#515151;--list-text:#dedede;--list-hover-text:#f1f1f1;--list-close-background:#111;--list-close-text:#777;--list-close-text-hover:#f1f1f1;--modal-text:#f1f1f1;--modal-background:#242424;--modal-btn-bar:#313131;--modal-btn-background:#181819;--modal-btn-secondary-background:#2e2d30;--modal-btn-hover-background:#434246;--modal-btn-border:#434246;--modal-btn-text:#dbdbdb;--modal-btn-hover-text:#fff;--modal-btn-secondary-text:#b8b8b8;--input-background:#434246;--status-active-text:#000;--form-error:#db8680;--form-success:#99de9c;--date-btn-text:#ebebf0;--date-btn-text-secondary:#b5b5bd;--date-btn-cal-day-text:#101010;--date-btn-cal-month-text:#414141;--date-btn-cal-background:#c7c7cd;--date-btn-background:#2d2d2d;--date-btn-hover-background:#474747;--overlay-background:rgba(20 20 20 / 75%);--icon-ms365-color:#ea3e23;--icon-yahoo-color:#bebebe;--icon-filter:grayscale(0.2)}.atcb-button-wrapper,.atcb-list,.atcb-modal-box{font-size:var(--base-font-size-l)}@media (width <= 991px){.atcb-button-wrapper,.atcb-list,.atcb-modal-box{font-size:var(--base-font-size-m)}}@media (width <= 575px){.atcb-button-wrapper,.atcb-list,.atcb-modal-box{font-size:var(--base-font-size-s)}}.atcb-initialized.atcb-buttons-list{gap:var(--buttonslist-gap)}.atcb-button-wrapper{display:block;padding:var(--wrapper-padding);position:relative}.atcb-button{align-items:center;background-color:var(--btn-background);border:.2em solid var(--btn-border);box-sizing:content-box;color:var(--btn-text);cursor:pointer;display:flex;font-family:var(--font);font-size:1em;font-weight:var(--btn-font-weight);justify-content:center;line-height:1.5em;margin:0;max-width:300px;padding:var(--btn-padding-y) var(--btn-padding-x);top:0;left:0;box-shadow:0 0 0 0 var(--btn-shadow);position:relative;text-align:center;touch-action:manipulation;user-select:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent;width:auto;z-index:1}.atcb-button:not(.atcb-no-text,.atcb-modal-style,.atcb-dropoverlay,.atcb-single){min-width:calc(11.6em - 2 * var(--btn-padding-x))}.atcb-button.atcb-no-text{display:flex;place-content:center center;align-items:center;height:3em;width:3em;padding:0}.atcb-button.atcb-click:not([disabled]){top:-3px;left:-3px;box-shadow:3px 3px 0 0 var(--btn-shadow)}.atcb-rtl .atcb-button{direction:rtl;text-align:right}.atcb-button:focus-visible{outline:2px solid var(--accent-color)}.atcb-button:not([disabled]):focus,.atcb-button:not([disabled]):hover{background-color:var(--btn-hover-background);top:0;left:0;box-shadow:0 0 0 0 var(--btn-shadow);color:var(--btn-hover-text)}.atcb-button.atcb-active:not(.atcb-modal-style,.atcb-dropoverlay){z-index:15000000}.atcb-button.atcb-active:not(.atcb-modal-style,.atcb-dropoverlay),.atcb-button.atcb-single:not([disabled]):focus,.atcb-button.atcb-single:not([disabled]):hover{background-color:var(--btn-hover-background);top:-5px;left:-5px;box-shadow:5px 5px 0 0 var(--btn-shadow);color:var(--btn-hover-text)}.atcb-button.atcb-active.atcb-dropoverlay{z-index:14000090}.atcb-icon{flex-grow:0;flex-shrink:0;height:.9em;line-height:1em;margin-right:.8em;width:.9em}.atcb-rtl .atcb-icon{margin-right:0;margin-left:1em}.atcb-no-text .atcb-icon{margin-right:0;margin-left:0}.atcb-icon svg{fill:currentcolor;height:100%;width:100%}.atcb-icon-trigger svg{display:none}.atcb-button .atcb-icon-trigger::after{content:"+";font-family:Arial,Helvetica,sans-serif;font-size:1.5em}.atcb-text{overflow-wrap:anywhere}.atcb-dropdown-anchor{bottom:0;height:0;width:100%;opacity:0;position:absolute}.atcb-list-wrapper{box-sizing:border-box;font-weight:var(--list-font-weight);padding:0 2px 0 6px;position:absolute;z-index:16000090}.atcb-list-wrapper.atcb-no-text.atcb-dropdown{padding:0}.atcb-list-wrapper:not(.atcb-dropup,.atcb-dropoverlay){animation:list-entrance-bottom .2s ease 0s 1 normal forwards}.atcb-list-wrapper.atcb-dropup{animation:list-entrance-top .2s ease 0s 1 normal forwards}.atcb-list-wrapper.atcb-dropoverlay{z-index:15000000}@keyframes list-entrance-bottom{0%{opacity:0;transform:translateY(150px)}100%{opacity:1;transform:translateY(0)}}@keyframes list-entrance-top{0%{opacity:0;transform:translateY(-150px)}100%{opacity:1;transform:translateY(0)}}.atcb-list{background:var(--list-background);box-sizing:border-box;border:.15em solid var(--list-border);color:var(--list-text);display:block;font-family:var(--font);min-width:100%;position:relative;user-select:none;-webkit-user-select:none;width:fit-content}.atcb-list-item{align-items:center;background-color:var(--list-background);box-sizing:border-box;cursor:pointer;display:flex;font-size:1em;line-height:1.75em;padding:var(--list-padding);text-align:left;touch-action:manipulation;-webkit-tap-highlight-color:transparent}.atcb-rtl .atcb-list-item{direction:rtl;text-align:right}.atcb-list-item:hover{background-color:var(--list-hover-background);color:var(--list-hover-text)}.atcb-list-item:focus-visible{background-color:var(--list-hover-background);color:var(--accent-color);outline:0}.atcb-dropup .atcb-list-item:last-child{border-bottom-width:0}.atcb-list.atcb-generated-button:not(.atcb-modal) .atcb-list-item:first-child{border-top-width:0}.atcb-dropoverlay .atcb-list.atcb-generated-button:not(.atcb-modal) .atcb-list-item:first-child,.atcb-dropup .atcb-list.atcb-generated-button:not(.atcb-modal) .atcb-list-item:first-child{border-top-width:.15em}.atcb-list-item .atcb-icon{margin:0 auto;height:1em;width:1em}.atcb-list-item .atcb-icon+.atcb-text{margin-left:.7em;width:100%}.atcb-rtl .atcb-list-item .atcb-icon+.atcb-text{margin-left:0;margin-right:.7em}.atcb-list-item-close{background-color:var(--list-close-background)}.atcb-list-item.atcb-list-item-close:not(:focus-visible){color:var(--list-close-text)}.atcb-list-item.atcb-list-item-close:hover{color:var(--list-close-text-hover)}.atcb-list-item-close svg{fill:currentcolor}.atcb-modal{display:block;margin:auto;width:auto;min-width:auto;position:relative;z-index:14000090}.atcb-modal-box{border:.15em solid var(--btn-border);background-color:var(--modal-background);color:var(--modal-text);cursor:default;box-sizing:border-box;font-family:var(--font);line-height:1.5em;text-align:var(--modal-text-align);user-select:none;-webkit-user-select:none;touch-action:manipulation;width:100%;margin-bottom:20px;-webkit-tap-highlight-color:transparent}@media (width > 575px){.atcb-modal-box{width:32em}}.atcb-modal-box.atcb-rtl{text-align:var(--modal-text-align-rtl);direction:rtl;padding:1.25em 1em 1.25em 2em}.atcb-modal-icon{height:2.5em;width:2.5em;padding:1.75em;margin:auto}.atcb-modal-icon svg{fill:currentcolor;height:100%;width:100%}.atcb-modal-headline{font-size:1.3em;font-weight:600;line-height:1.5em;padding:1.8em 1.5em 1.3em;text-transform:var(--modal-headline-text-transform);text-align:var(--modal-headline-text-align)}.atcb-modal-icon+.atcb-modal-headline{padding-top:0}.atcb-modal-content{font-size:1em;padding:.3em 2em 2.2em}.atcb-modal-content-subevents{margin:auto;width:fit-content}.atcb-modal-icon+.atcb-modal-content{padding-top:0}@media (width <= 575px){.atcb-modal-headline{padding:1.8em 1em 1em}.atcb-modal-content{padding:.3em 1.5em 1.5em}}.atcb-modal-buttons{background-color:var(--modal-btn-bar);box-sizing:border-box;padding:.6em;text-align:center;width:100%;display:flex;justify-content:center;flex-flow:row-reverse wrap;align-items:center}a.atcb-modal-btn,button.atcb-modal-btn{border:.2em solid var(--btn-border);background-color:var(--modal-btn-secondary-background);color:var(--modal-btn-secondary-text);cursor:pointer;display:inline-block;font-family:var(--font);font-size:.9em;font-weight:var(--modal-btn-font-weight);line-height:1em;margin:.625em;padding:1em 1.25em;position:relative;text-align:center;text-decoration:none;touch-action:manipulation;user-select:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent;top:0;left:0;box-shadow:0 0 0 0 var(--btn-shadow)}a.atcb-modal-btn.btn-small,button.atcb-modal-btn.btn-small{padding:.6em .8em}a.atcb-modal-btn.atcb-modal-btn-primary,button.atcb-modal-btn.atcb-modal-btn-primary{background-color:var(--modal-btn-background);color:var(--modal-btn-text)}a.atcb-modal-btn:focus-visible,button.atcb-modal-btn:focus-visible{background-color:var(--modal-btn-hover-background);outline:2px solid var(--accent-color)}a.atcb-modal-btn:disabled,button.atcb-button:disabled,button.atcb-modal-btn:disabled,button.atcb-subevent-btn:disabled{cursor:not-allowed;opacity:.75;filter:brightness(95%);border-style:dashed;box-shadow:none}a.atcb-modal-btn:not([disabled]):hover,button.atcb-modal-btn:not([disabled]):hover{background-color:var(--modal-btn-hover-background);color:var(--modal-btn-hover-text);text-decoration:none;top:-3px;left:-3px;box-shadow:3px 3px 0 0 var(--btn-shadow)}.atcb-subevent-btn{border:.15em solid var(--btn-border);display:flex;align-items:flex-start;cursor:pointer;font-family:var(--font);font-size:1em;background-color:var(--date-btn-background);padding:0;margin:0;touch-action:manipulation;position:relative;user-select:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent;top:0;left:0;box-shadow:0 0 0 0 var(--btn-shadow);width:100%}.atcb-subevent-btn:hover{align-items:center;top:-3px;left:-3px;box-shadow:3px 3px 0 0 var(--btn-shadow)}.atcb-subevent-btn:focus,.atcb-subevent-btn:hover{background-color:var(--date-btn-hover-background)}.atcb-subevent-btn:focus-visible{outline:2px solid var(--accent-color)}.atcb-subevent-btn+.atcb-subevent-btn{margin-top:30px}.atcb-date-btn-left{align-self:stretch;background-color:var(--date-btn-cal-background);color:var(--date-btn-hover-background);padding:.7em .8em .8em;width:2.7em;align-items:center;display:flex;flex-direction:column;flex-shrink:0}.atcb-subevent-btn:hover .atcb-date-btn-left{opacity:.8}.atcb-date-btn-day{color:var(--date-btn-cal-day-text);font-weight:400;font-size:2em;word-break:keep-all;padding-bottom:.1em}.atcb-initialized[lang=ja] .atcb-date-btn-day,.atcb-initialized[lang=ko] .atcb-date-btn-day,.atcb-initialized[lang=zh] .atcb-date-btn-day{font-size:1.3em}.atcb-date-btn-month{color:var(--date-btn-cal-month-text);font-weight:600;font-size:1em}.atcb-date-btn-right{position:relative;color:var(--date-btn-text);min-width:13.5em;overflow-wrap:anywhere}.atcb-subevent-btn .atcb-date-btn-right{width:100%}.atcb-date-btn-details{opacity:1;padding:.7em .8em;text-align:left}.atcb-rtl .atcb-date-btn-details{text-align:right}.atcb-date-btn-hover{position:absolute;top:0;left:0;width:100%;opacity:0;height:100%;display:flex;align-items:center;justify-content:center;font-weight:600;font-size:1em;padding:.4em .7em;box-sizing:border-box}.atcb-subevent-btn:hover .atcb-date-btn-details{opacity:0}.atcb-subevent-btn:hover .atcb-date-btn-hover{opacity:1}.atcb-date-btn-headline{font-weight:600;font-size:.9em;margin-bottom:.5em;overflow:hidden;display:-webkit-box;-webkit-line-clamp:var(--date-btn-headline-line-clamp);line-clamp:var(--date-btn-headline-line-clamp);-webkit-box-orient:vertical}.atcb-date-btn-content{display:flex;align-items:flex-start;font-size:.8em;color:var(--date-btn-text-secondary)}.atcb-date-btn-content.atcb-date-btn-cancelled{color:var(--form-error);font-weight:700}.atcb-date-btn-content-location{overflow:hidden;display:-webkit-box;-webkit-line-clamp:1;line-clamp:1;-webkit-box-orient:vertical;word-break:break-all}.atcb-date-btn-content-icon{display:inline-block;height:.8em;margin-right:.4em;margin-left:0;width:.9em;flex-shrink:0}.atcb-rtl .atcb-date-btn-content-icon{margin-right:0;margin-left:.4em}.atcb-initialized[lang=ja] .atcb-date-btn-content:not(.atcb-date-btn-content-location) .atcb-date-btn-content-icon,.atcb-initialized[lang=ko] .atcb-date-btn-content:not(.atcb-date-btn-content-location) .atcb-date-btn-content-icon,.atcb-initialized[lang=zh] .atcb-date-btn-content:not(.atcb-date-btn-content-location) .atcb-date-btn-content-icon{margin-top:.15em}.atcb-date-btn-content-icon svg{height:100%;fill:currentcolor;width:100%}.atcb-date-btn-content+.atcb-date-btn-content{margin-top:.3em}.atcb-date-btn-content-text span:not(.atcb-icon-ical){padding-right:.3em;display:inline-block}.atcb-checkmark{display:none}.atcb-saved .atcb-checkmark{box-sizing:content-box;color:var(--btn-text);display:block;position:absolute;top:-2.1em;right:-2em;padding:.5em;border-radius:100%;height:1.5em}.atcb-checkmark svg{height:100%;width:auto}#atcb-bgoverlay{backdrop-filter:blur(2px);-webkit-backdrop-filter:blur(2px);background-color:var(--overlay-background);border:0;box-sizing:border-box;display:flex;height:calc(100vh + 100px);inset-inline:0;left:0;right:0;top:0;min-height:100%;min-width:100%;overflow-y:auto;padding:20px 20px 130px;position:fixed;width:100vw;z-index:14000000}#atcb-bgoverlay:not(dialog){animation:atcb-bgoverlay-animate .2s ease 0s 1 normal forwards;opacity:0}#atcb-bgoverlay.atcb-no-bg{animation:none;backdrop-filter:none;-webkit-backdrop-filter:none;opacity:1;background-color:transparent}@keyframes atcb-bgoverlay-animate{0%{opacity:0}100%{opacity:1}}#atcb-bgoverlay.atcb-click:hover{cursor:var(--overlay-cursor)}.atcb-icon-outlookcom,.atcb-icon.atcb-icon-ms365{padding-bottom:.05em}.atcb-icon.atcb-icon-apple,.atcb-icon.atcb-icon-ical{padding-bottom:.15em}.atcb-icon.atcb-icon-rsvp{height:1.5em;width:1.5em}.atcb-icon.atcb-icon-apple svg{fill:currentcolor}.atcb-icon.atcb-icon-ical svg{fill:currentcolor}.atcb-icon.atcb-icon-ms365 svg{fill:var(--icon-ms365-color)}.atcb-icon.atcb-icon-yahoo svg{fill:var(--icon-yahoo-color)}.atcb-icon.atcb-icon-google svg,.atcb-icon.atcb-icon-msteams svg,.atcb-icon.atcb-icon-outlookcom svg{filter:var(--icon-filter)}.rsvp-inline-wrapper{background-color:transparent;border:0;filter:none;min-width:100%;margin-bottom:0}.atcb-modal-content.no-headline{padding-top:1.8em}.rsvp-inline-wrapper .atcb-modal-content,.rsvp-inline-wrapper .atcb-modal-headline,.rsvp-inline-wrapper.atcb-modal-box{background-color:transparent;border-radius:0;box-sizing:border-box;padding:0;width:100%}.rsvp-inline-wrapper .atcb-modal-headline{padding-bottom:1.5em}.pro{text-align:center}.pro ol,.pro ul{margin:auto;text-align:left;width:fit-content}.pro a:not(.atcb-modal-btn),.pro a:not(.atcb-modal-btn):active,.pro a:not(.atcb-modal-btn):visited{color:var(--modal-btn-text);text-decoration:underline;text-decoration-thickness:2px;text-decoration-color:var(--accent-color)}.pro a:not(.atcb-modal-btn):hover{color:var(--accent-color);text-decoration:none}.pro .pro-share-buttons{display:flex;flex-wrap:wrap;justify-content:center}.pro #rsvp-atcb{display:flex;flex-wrap:wrap;gap:.4em;justify-content:center}.pro-form{text-align:left}.pro-form:not(.no-intro){border-top:2px solid var(--modal-btn-border);margin-top:1.5em;padding-top:1.5em}.pro-form.no-intro:not(.no-headline){padding-top:.5em}.pro-field+.pro-field{padding-top:1.3em}.pro-field-type-label+.pro-field-type-radio{padding-top:0}.pro-field-type-checkbox,.pro-field-type-radio div{align-items:center;display:flex}.pro-field-type-checkbox input,.pro-field-type-radio input{cursor:pointer}.pro-field label{display:block;font-size:.9em;opacity:.7}.pro-field-type-checkbox label,.pro-field-type-radio label{cursor:pointer;opacity:.8;padding-left:.3em}.pro-field input[type=email],.pro-field input[type=number],.pro-field input[type=text]{background-color:var(--input-background);border:2px solid var(--modal-btn-border);border-radius:var(--input-border-radius);box-sizing:border-box;caret-color:var(--accent-color);color:var(--modal-text);font-size:.9em;opacity:.8;padding:.7em;transition:all .1s ease-in-out;width:100%}.pro-field input[type=checkbox],.pro-field input[type=radio]{accent-color:var(--accent-color);height:1.2rem;opacity:.8;transition:all .1s ease-in-out;width:1.2em}.pro-field input:disabled,.pro-field input:disabled+label{cursor:not-allowed;opacity:.75;filter:brightness(95%)}.pro-field input:not([disabled]):hover{opacity:1}.pro-field input[type=email]:focus,.pro-field input[type=number]:focus,.pro-field input[type=text]:focus{border-color:var(--accent-color);outline:1px solid var(--accent-color)}.pro-field input[type=checkbox]:focus,.pro-field input[type=radio]:focus{outline-color:var(--accent-color);outline-width:2px}#submit-error{color:var(--form-error);display:none;font-weight:700;padding-top:1.5em;text-align:center}.pro-form.form-error #submit-error{display:block}.pro-field input.error{accent-color:var(--form-error);border:2px solid var(--form-error)}.pro-field input.error+label,.pro-field:has(input.error) label{color:var(--form-error);opacity:1}#rsvp-status-group{border-bottom:2px solid var(--modal-btn-border);font-weight:700;margin-bottom:1.5em;padding-bottom:2em;text-align:center}#rsvp-status-group .pro-field{align-items:center;display:flex;flex-wrap:wrap;gap:3%;justify-content:center;margin-top:1em}@media (width <= 575px){#rsvp-status-group .pro-field{flex-direction:column;gap:1.2em}#rsvp-status-group .pro-field div{width:80%}}#rsvp-status-group .pro-field div{min-width:28%;position:relative}#rsvp-status-group input{opacity:0;position:absolute;top:0;left:0;height:100%;width:100%;margin:0;cursor:pointer}#rsvp-status-group label{align-items:center;border:2px solid var(--modal-btn-text);border-radius:var(--input-border-radius);color:var(--modal-btn-text);display:flex;flex-direction:column;font-weight:700;text-transform:uppercase;justify-content:center;opacity:.6;padding:.8em;transition:all .1s ease-in-out;width:100%}#rsvp-status-group label.status-confirmed{border-color:var(--form-success);color:var(--form-success)}#rsvp-status-group label.status-declined{border-color:var(--form-error);color:var(--form-error)}#rsvp-status-group input:checked+label{background-color:var(--modal-text);color:var(--status-active-text);opacity:1;transform:scale(1.1)}#rsvp-status-group input:focus-visible+label{outline:2px solid var(--accent-color);outline-offset:2px}#rsvp-status-group input:not([disabled])+label:hover,#rsvp-status-group input:not([disabled]):hover+label{opacity:1;transform:scale(1.08)}#rsvp-status-group input:checked+label.status-confirmed{background-color:var(--form-success)}#rsvp-status-group input:checked+label.status-declined{background-color:var(--form-error)}#rsvp-success-msg,#rsvp-success-msg-demo,#rsvp-success-msg-doi,#rsvp-success-msg-email,#ty-success-msg{display:none;font-weight:700;line-height:1.6em;padding-top:.5em;text-align:center}#rsvp-success-msg,#rsvp-success-msg-demo,#ty-success-msg{padding:1.5em 0}#rsvp-success-msg-demo,#rsvp-success-msg-email{color:var(--form-success)}#rsvp-success-msg-doi{color:var(--form-error);font-size:.8em;padding-top:1em}#pro-form-submit{display:block;margin:auto;min-width:150px}.pro-form-fine{font-size:.8em;padding:.5em .5em 1em;opacity:.5;text-align:center}.pro-form.form-error .pro-form-fine{opacity:0}.pro-waiting{background-color:var(--modal-btn-background);border:.2em solid var(--modal-btn-border);border-radius:var(--btn-border-radius);box-sizing:border-box;color:var(--modal-btn-text);cursor:wait;display:none;line-height:.5em;margin:auto;min-width:150px;padding:.5em 1.25em 1.2em;text-align:center;user-select:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent;width:fit-content}@media (width > 575px){#pro-form-submit,.pro-waiting{min-width:200px}}.pro-waiting span:not(.atcb-icon-ical){animation-name:blink;animation-duration:1s;animation-iteration-count:infinite;animation-fill-mode:both;font-size:2.5em}.pro-field label span:not(.atcb-icon-ical){color:var(--form-error);font-weight:700;padding-left:2px}.pro-waiting span:not(.atcb-icon-ical):nth-child(2){animation-delay:.15s}.pro-waiting span:not(.atcb-icon-ical):nth-child(3){animation-delay:.3s}@keyframes blink{0%{opacity:.2}20%{opacity:1}100%{opacity:.2}}.pro #rsvp-sent-content{align-items:center;display:flex;flex-direction:column;gap:1.5em}#rsvp-status-group span{color:inherit}.atcb-modal-content .pro p:not(.pro-form-fine){margin:0}.atcb-modal-content .pro p.pro-pt{margin-top:1.5em}.atcb-modal-content .pro .pro-field p{font-size:.9em}.pro .btn-flex{align-items:center;display:flex}.pro .atcb-modal-btn svg{fill:none;height:1.5em;margin-right:.5em;stroke:currentcolor;width:auto}#atcb-reference{box-sizing:border-box;filter:drop-shadow(0 0 3px rgba(255 255 255 / 80%));height:auto;padding:8px 0;text-align:center;transform:translate3d(0,0,0);width:100%;z-index:15000000}#atcb-reference.fixed-ref{position:fixed;bottom:10px;right:40px;width:auto}#atcb-reference.atcb-dropup{position:absolute;margin-top:-5px}.atcb-modal-host-initialized #atcb-reference.atcb-dropup{text-align:left}:host(.atcb-dark) #atcb-reference{filter:drop-shadow(0 0 5px #000)}#atcb-reference a,#atcb-reference a:active,#atcb-reference a:visited{opacity:.4;width:150px;max-width:100%;margin:auto;display:inline-block;text-decoration:none}#atcb-reference.fixed-ref a{opacity:.6}#atcb-reference a:hover{opacity:.9;text-decoration:none}#atcb-reference svg{fill:var(--list-text)}`,
  round: `:host{width:fit-content;--base-font-size-l:16px;--base-font-size-m:16px;--base-font-size-s:16px;--font:arial,helvetica,"Twemoji Mozilla","Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","EmojiOne Color","Android Emoji",sans-serif;--accent-color:#1e90ff;--wrapper-padding:1px;--buttonslist-gap:5px;--btn-background:#f5f5f5;--btn-hover-background:#fff;--btn-border:#d2d2d2;--btn-border-radius:500px;--btn-padding-x:1.3em;--btn-padding-y:.65em;--btn-font-weight:600;--btn-text:#333;--btn-hover-text:#000;--btn-shadow:rgba(0 0 0 / 15%) 0 4px 10px -2px,rgba(0 0 0 / 20%) 0 2px 3px -1px;--btn-hover-shadow:rgba(0 0 0 / 30%) 0 5px 15px -3px,rgba(0 0 0 / 25%) 0 3px 5px -2px;--btn-active-shadow:rgba(0 0 0 / 35%) 0 6px 15px -3px,rgba(0 0 0 / 25%) 0 4px 6px -2px;--list-background:#f5f5f5;--list-hover-background:#fff;--list-text:#333;--list-font-weight:400;--list-hover-text:#000;--list-close-background:#e5e5e5;--list-close-text:#777;--list-border-radius:11px;--list-padding:.8em 1.2em;--list-min-width:100%;--list-shadow:rgba(0 0 0 / 20%) 0 4px 13px -2px,rgba(0 0 0 / 23%) 0 2px 4px -1px;--list-modal-shadow:rgba(0 0 0 / 50%) 0 4px 30px -3px,rgba(0 0 0 / 30%) 0 2px 8px -2px;--modal-text:#000;--modal-text-align:left;--modal-text-align-rtl:right;--modal-background:#f5f5f5;--modal-border-radius:9px;--modal-shadow:drop-shadow(3px 6px 25px rgba(0 0 0 / 65%));--modal-btn-bar:#c6c8cd;--modal-btn-background:#f5f5f5;--modal-btn-secondary-background:#e2e1e6;--modal-btn-hover-background:#fff;--modal-btn-border:#d2d2d2;--modal-btn-font-weight:600;--modal-btn-text:#2e2e2e;--modal-btn-hover-text:#161616;--modal-btn-secondary-text:#666567;--modal-btn-shadow:rgba(0 0 0 / 10%) 2px 3px 10px -3px,rgba(0 0 0 / 25%) 1px 1px 8px -4px;--modal-btn-hover-shadow:rgba(0 0 0 / 35%) 3px 5px 15px -2px,rgba(0 0 0 / 20%) 2px 4px 25px -6px;--modal-headline-text-align:center;--modal-headline-text-transform:none;--input-border-radius:6px;--input-background:#fff;--status-active-text:#fff;--form-error:#c5372c;--form-success:#338a36;--date-btn-text:#1d1d1e;--date-btn-text-secondary:#3a3a3f;--date-btn-cal-day-text:#fff;--date-btn-cal-month-text:#d3d2d7;--date-btn-cal-background:#313132;--date-btn-background:#eae9ed;--date-btn-hover-background:#fff;--date-btn-headline-line-clamp:1;--date-btn-shadow:rgba(0 0 0 / 10%) 0 4px 10px -2px,rgba(0 0 0 / 15%) 0 2px 3px -1px;--date-btn-hover-shadow:rgba(0 0 0 / 20%) 0 5px 12px -2px,rgba(0 0 0 / 20%) 0 3px 4px -2px;--checkmark-background:drop-shadow(0 0 3px #fff);--overlay-background:rgba(20 20 20 / 25%);--overlay-cursor:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23777' width='16' height='16' viewBox='0 0 122.878 122.88'%3E%3Cpath d='M1.426 8.313a4.87 4.87 0 0 1 0-6.886 4.87 4.87 0 0 1 6.886 0l53.127 53.127 53.127-53.127a4.87 4.87 0 0 1 6.887 0 4.87 4.87 0 0 1 0 6.886L68.324 61.439l53.128 53.128a4.87 4.87 0 0 1-6.887 6.886L61.438 68.326 8.312 121.453a4.87 4.87 0 0 1-6.886 0 4.87 4.87 0 0 1 0-6.886l53.127-53.128L1.426 8.313h0z'/%3E%3C/svg%3E") 16 16,crosshair;--icon-ms365-color:#ea3e23;--icon-yahoo-color:#5f01d1;--icon-filter:none}:host(.atcb-dark){--btn-background:#2e2e2e;--btn-hover-background:#373737;--btn-border:#4d4d4d;--btn-text:#dedede;--btn-hover-text:#f1f1f1;--btn-shadow:rgba(255 255 255 / 5%) -3px -3px 30px -1px,rgba(0 0 0 / 40%) 2px 3px 10px -2px,rgba(0 0 0 / 40%) 1px 2px 3px -1px;--btn-hover-shadow:rgba(0 0 0 / 90%) 2px 5px 20px -4px,rgba(0 0 0 / 50%) 1px 2px 6px -2px;--btn-active-shadow:rgba(0 0 0 / 90%) 2px 5px 20px -4px,rgba(0 0 0 / 50%) 1px 2px 6px -2px;--list-background:#2e2e2e;--list-hover-background:#373737;--list-text:#dedede;--list-hover-text:#f1f1f1;--list-close-background:#282828;--list-shadow:rgba(0 0 0 / 60%) 0 4px 20px -2px,rgba(0 0 0 / 40%) 0 2px 4px -1px;--list-modal-shadow:rgba(0 0 0 / 40%) -1px 3px 30px 2px;--modal-text:#f1f1f1;--modal-background:#242424;--modal-shadow:drop-shadow(3px 6px 25px rgba(0 0 0 / 90%));--modal-btn-bar:#38383a;--modal-btn-background:#181819;--modal-btn-secondary-background:#2e2d30;--modal-btn-hover-background:#434246;--modal-btn-border:#434246;--modal-btn-text:#dbdbdb;--modal-btn-hover-text:#fff;--modal-btn-secondary-text:#b8b8b8;--modal-btn-shadow:rgba(255 255 255 / 5%) -2px -2px 10px,rgba(0 0 0 / 40%) 3px 3px 10px -2px,rgba(0 0 0 / 40%) 1px 2px 5px -1px;--input-background:#434246;--status-active-text:#000;--form-error:#db8680;--form-success:#99de9c;--date-btn-text:#ebebf0;--date-btn-text-secondary:#b5b5bd;--date-btn-cal-day-text:#101010;--date-btn-cal-month-text:#3e3e3f;--date-btn-cal-background:#c7c7cd;--date-btn-background:#363636;--date-btn-hover-background:#474747;--date-btn-shadow:rgba(0 0 0 / 60%) 0 0 20px -2px,rgba(0 0 0 / 30%) 1px 2px 3px -1px;--checkmark-background:drop-shadow(0 0 3px #0a0a0a);--overlay-background:rgba(20 20 20 / 60%);--icon-ms365-color:#ea3e23;--icon-yahoo-color:#bebebe;--icon-filter:grayscale(.2)}.atcb-button-wrapper,.atcb-list,.atcb-modal-box{font-size:var(--base-font-size-l)}@media (width <= 991px){.atcb-button-wrapper,.atcb-list,.atcb-modal-box{font-size:var(--base-font-size-m)}}@media (width <= 575px){.atcb-button-wrapper,.atcb-list,.atcb-modal-box{font-size:var(--base-font-size-s)}}.atcb-initialized.atcb-buttons-list{gap:var(--buttonslist-gap)}.atcb-button-wrapper{display:block;padding:var(--wrapper-padding);position:relative}.atcb-button{align-items:center;background-color:var(--btn-background);border:1px solid var(--btn-border);border-radius:var(--btn-border-radius);box-shadow:var(--btn-shadow);color:var(--btn-text);cursor:pointer;display:flex;font-family:var(--font);font-size:1em;font-weight:var(--btn-font-weight);justify-content:center;line-height:1.5em;margin:.13em;max-width:350px;padding:var(--btn-padding-y) var(--btn-padding-x);position:relative;text-align:center;touch-action:manipulation;user-select:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent;width:auto;z-index:1}.atcb-button.atcb-no-text{min-width:0;border-radius:100%;display:flex;place-content:center center;align-items:center;height:3em;width:3em;padding:0}.atcb-rtl .atcb-button{direction:rtl;text-align:right}.atcb-button:focus-visible{outline:2px solid var(--accent-color)}.atcb-button:not([disabled]):focus,.atcb-button:not([disabled]):hover{background-color:var(--btn-hover-background);box-shadow:var(--btn-hover-shadow);color:var(--btn-hover-text);margin:0;padding:calc(var(--btn-padding-y) + .13em) calc(var(--btn-padding-x) + .13em)}.atcb-button.atcb-no-text.atcb-active,.atcb-button.atcb-no-text:focus,.atcb-button.atcb-no-text:hover{height:3.26em;width:3.26em;padding:0}.atcb-button.atcb-active:not(.atcb-modal-style,.atcb-dropoverlay){z-index:15000000}.atcb-button.atcb-active:not(.atcb-modal-style,.atcb-dropoverlay,.atcb-no-text),.atcb-button.atcb-single:not(.atcb-no-text,[disabled]):focus,.atcb-button.atcb-single:not(.atcb-no-text,[disabled]):hover{background-color:var(--btn-hover-background);box-shadow:var(--btn-active-shadow);color:var(--btn-hover-text);margin:0;padding:calc(var(--btn-padding-y) + .13em) calc(var(--btn-padding-x) + .13em)}.atcb-button.atcb-active.atcb-no-text:not(.atcb-modal-style,.atcb-dropoverlay),.atcb-button.atcb-single.atcb-no-text:not([disabled]):focus,.atcb-button.atcb-single.atcb-no-text:not([disabled]):hover{background-color:var(--btn-hover-background);box-shadow:var(--btn-active-shadow);color:var(--btn-hover-text);margin:0;padding:calc(var(--btn-padding-y) + .28em) calc(var(--btn-padding-x) + .13em)}.atcb-button.atcb-dropup::after,.atcb-button:not(.atcb-modal-style,.atcb-dropoverlay,.atcb-dropup)::before{content:"";width:0;height:0;position:absolute;left:0;right:0;margin:0 auto}.atcb-button:not(.atcb-modal-style,.atcb-dropoverlay,.atcb-dropup)::before{top:100%;border:0 solid transparent;border-bottom:none;border-top-color:var(--btn-border)}.atcb-button.atcb-dropup::after{bottom:100%;border:0 solid transparent;border-top:none;border-bottom-color:var(--btn-border)}.atcb-button.atcb-active.atcb-dropup::after,.atcb-button.atcb-active:not(.atcb-modal-style,.atcb-dropoverlay,.atcb-dropup)::before{border-width:.35em;transition:border-width .1s linear .1s}.atcb-button.atcb-active.atcb-dropoverlay{z-index:14000090}.atcb-icon{flex-grow:0;flex-shrink:0;height:1em;line-height:1em;margin-right:.8em;width:1em}.atcb-rtl .atcb-icon{margin-right:0;margin-left:.8em}.atcb-no-text .atcb-icon{margin-right:0;margin-left:0}.atcb-icon svg{fill:currentcolor;height:100%;width:100%}.atcb-text{overflow-wrap:anywhere}.atcb-dropdown-anchor{bottom:-15px;height:0;width:100%;opacity:0;position:absolute}.atcb-list-wrapper{box-sizing:border-box;font-weight:var(--list-font-weight);position:absolute;z-index:14000090;width:auto}.atcb-list-wrapper:not(.atcb-dropup,.atcb-dropoverlay){animation:list-entrance-bottom .2s ease 0s 1 normal forwards}.atcb-list-wrapper.atcb-dropup{animation:list-entrance-top .2s ease 0s 1 normal forwards}.atcb-list-wrapper.atcb-dropoverlay{animation:list-entrance-center .2s ease 0s 1 normal forwards;z-index:15000000}@keyframes list-entrance-bottom{0%{opacity:0;transform:translateY(250px)}100%{opacity:1;transform:translateY(0)}}@keyframes list-entrance-top{0%{opacity:0;transform:translateY(-250px)}100%{opacity:1;transform:translateY(0)}}@keyframes list-entrance-center{0%{opacity:0;transform:scaleY(1)}1%{opacity:1;transform:scaleY(0)}100%{opacity:1;transform:scaleY(1)}}.atcb-list{background-color:var(--list-background);border-radius:var(--list-border-radius);box-sizing:border-box;box-shadow:var(--list-shadow);color:var(--list-text);display:block;font-family:var(--font);min-width:var(--list-min-width);position:relative;user-select:none;-webkit-user-select:none;width:fit-content}.atcb-list-item{align-items:center;background-color:var(--list-background);box-sizing:border-box;cursor:pointer;display:flex;font-size:1em;line-height:1.75em;padding:var(--list-padding);text-align:left;touch-action:manipulation;-webkit-tap-highlight-color:transparent}.atcb-rtl .atcb-list-item{direction:rtl;text-align:right}.atcb-list-item:hover{background-color:var(--list-hover-background);color:var(--list-hover-text)}.atcb-list-item:focus-visible{background-color:var(--list-hover-background);color:var(--accent-color);outline:0}.atcb-list-item:last-child{border-radius:0 0 var(--list-border-radius) var(--list-border-radius)}.atcb-list-item:first-child{border-radius:var(--list-border-radius) var(--list-border-radius) 0 0}.atcb-list-item:only-child{border-radius:var(--list-border-radius)}.atcb-list.atcb-modal{box-shadow:var(--list-modal-shadow)}.atcb-list-item .atcb-icon{margin:0 auto}.atcb-list-item .atcb-icon+.atcb-text{margin-left:.7em;width:100%}.atcb-rtl .atcb-list-item .atcb-icon+.atcb-text{margin-left:0;margin-right:.7em}.atcb-list-item-close{background-color:var(--list-close-background)}.atcb-list-item.atcb-list-item-close:not(:focus-visible){color:var(--list-close-text)}.atcb-list-item-close svg{fill:currentcolor}.atcb-modal{display:block;margin:auto;width:auto;min-width:auto;position:relative;z-index:14000090}.atcb-modal-box{filter:var(--modal-shadow);color:var(--modal-text);cursor:default;box-sizing:border-box;font-family:var(--font);line-height:1.5em;text-align:var(--modal-text-align);user-select:none;-webkit-user-select:none;touch-action:manipulation;width:100%;margin-bottom:20px;-webkit-tap-highlight-color:transparent}@media (width > 575px){.atcb-modal-box{width:32em}}.atcb-modal-box.atcb-rtl{text-align:var(--modal-text-align-rtl);direction:rtl;padding:1.25em 1em 1.25em 2em}.atcb-modal-icon{height:2.5em;width:2.5em;border-radius:100%;background-color:var(--modal-background);padding:1.75em;margin:auto}.atcb-modal-icon svg{fill:currentcolor;height:100%;width:100%}.atcb-modal-headline{background-color:var(--modal-background);border-radius:var(--modal-border-radius) var(--modal-border-radius) 0 0;font-size:1.3em;font-weight:600;line-height:1.5em;padding:1.8em 1.5em 1.3em;text-transform:var(--modal-headline-text-transform);text-align:var(--modal-headline-text-align)}.atcb-modal-icon+.atcb-modal-headline{margin-top:-2.6em;padding-top:2.6em}.atcb-modal-content{background-color:var(--modal-background);font-size:1em;padding:.3em 2em 2.2em}.atcb-modal-icon+.atcb-modal-content{border-radius:var(--modal-border-radius) var(--modal-border-radius) 0 0;margin-top:-2.6em;padding-top:2.6em}.atcb-modal-content-subevents{margin:auto;width:fit-content}@media (width <= 575px){.atcb-modal-headline{padding:1.8em 1em 1em}.atcb-modal-content{padding:.3em 1.5em 1.5em}.atcb-modal-icon+.atcb-modal-content{padding-top:1.8em}}.atcb-modal-buttons{background-color:var(--modal-btn-bar);border-radius:0 0 var(--modal-border-radius) var(--modal-border-radius);box-sizing:border-box;padding:.6em;text-align:center;width:100%;display:flex;justify-content:center;flex-flow:row-reverse wrap;align-items:center}a.atcb-modal-btn,button.atcb-modal-btn{background-color:var(--modal-btn-secondary-background);border:0;border-radius:var(--btn-border-radius);box-shadow:var(--modal-btn-shadow);color:var(--modal-btn-secondary-text);cursor:pointer;display:inline-block;font-family:var(--font);font-size:.9em;font-weight:var(--modal-btn-font-weight);line-height:1em;margin:.625em;padding:1em 1.25em;position:relative;text-align:center;text-decoration:none;touch-action:manipulation;user-select:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent}a.atcb-modal-btn.btn-small,button.atcb-modal-btn.btn-small{padding:.6em .8em}a.atcb-modal-btn.atcb-modal-btn-primary,button.atcb-modal-btn.atcb-modal-btn-primary{background-color:var(--modal-btn-background);color:var(--modal-btn-text)}a.atcb-modal-btn.atcb-modal-btn-border,button.atcb-modal-btn.atcb-modal-btn-border{border:1px solid var(--modal-btn-border)}a.atcb-modal-btn:focus-visible,button.atcb-modal-btn:focus-visible{background-color:var(--modal-btn-hover-background);outline:2px solid var(--accent-color)}a.atcb-modal-btn:disabled,button.atcb-button:disabled,button.atcb-modal-btn:disabled,button.atcb-subevent-btn:disabled{cursor:not-allowed;opacity:.75;filter:brightness(95%);border-style:dashed;box-shadow:none}a.atcb-modal-btn:not([disabled]):hover,button.atcb-modal-btn:not([disabled]):hover{background-color:var(--modal-btn-hover-background);box-shadow:var(--modal-btn-hover-shadow);color:var(--modal-btn-hover-text);text-decoration:none}.atcb-subevent-btn{display:flex;align-items:flex-start;cursor:pointer;font-family:var(--font);font-size:1em;box-shadow:var(--date-btn-shadow);background-color:var(--date-btn-background);border:0;border-radius:7px 4px 4px 7px;padding:0;margin:0;touch-action:manipulation;position:relative;user-select:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent;width:100%}.atcb-subevent-btn:hover{align-items:center}.atcb-subevent-btn:focus,.atcb-subevent-btn:hover{background-color:var(--date-btn-hover-background);box-shadow:var(--date-btn-hover-shadow)}.atcb-subevent-btn:focus-visible{outline:2px solid var(--accent-color)}.atcb-subevent-btn+.atcb-subevent-btn{margin-top:30px}.atcb-date-btn-left{border-radius:4px 0 0 4px;align-self:stretch;background-color:var(--date-btn-cal-background);color:var(--date-btn-hover-background);padding:.7em .8em .8em;width:2.7em;align-items:center;display:flex;flex-direction:column;flex-shrink:0}.atcb-rtl .atcb-date-btn-left{border-radius:0 4px 4px 0}.atcb-subevent-btn:hover .atcb-date-btn-left{opacity:.8}.atcb-date-btn-day{color:var(--date-btn-cal-day-text);font-weight:400;font-size:2em;word-break:keep-all;padding-bottom:.1em}.atcb-initialized[lang=ja] .atcb-date-btn-day,.atcb-initialized[lang=ko] .atcb-date-btn-day,.atcb-initialized[lang=zh] .atcb-date-btn-day{font-size:1.3em}.atcb-date-btn-month{color:var(--date-btn-cal-month-text);font-weight:600;font-size:1em}.atcb-date-btn-right{position:relative;color:var(--date-btn-text);min-width:13.5em;overflow-wrap:anywhere}.atcb-subevent-btn .atcb-date-btn-right{width:100%}.atcb-date-btn-details{opacity:1;padding:.7em .8em;text-align:left}.atcb-rtl .atcb-date-btn-details{text-align:right}.atcb-date-btn-hover{position:absolute;top:0;left:0;width:100%;opacity:0;height:100%;display:flex;align-items:center;justify-content:center;font-weight:600;font-size:1em;padding:.4em .7em;box-sizing:border-box}.atcb-subevent-btn:hover .atcb-date-btn-details{opacity:0}.atcb-subevent-btn:hover .atcb-date-btn-hover{opacity:1}.atcb-date-btn-headline{font-weight:600;font-size:.9em;margin-bottom:.5em;overflow:hidden;display:-webkit-box;-webkit-line-clamp:var(--date-btn-headline-line-clamp);line-clamp:var(--date-btn-headline-line-clamp);-webkit-box-orient:vertical}.atcb-date-btn-content{display:flex;align-items:flex-start;font-size:.8em;color:var(--date-btn-text-secondary)}.atcb-date-btn-content.atcb-date-btn-cancelled{color:var(--form-error);font-weight:700}.atcb-date-btn-content-location{overflow:hidden;display:-webkit-box;-webkit-line-clamp:1;line-clamp:1;-webkit-box-orient:vertical;word-break:break-all}.atcb-date-btn-content-icon{display:inline-block;height:.8em;margin-right:.4em;margin-left:0;width:.9em;flex-shrink:0}.atcb-rtl .atcb-date-btn-content-icon{margin-right:0;margin-left:.4em}.atcb-initialized[lang=ja] .atcb-date-btn-content:not(.atcb-date-btn-content-location) .atcb-date-btn-content-icon,.atcb-initialized[lang=ko] .atcb-date-btn-content:not(.atcb-date-btn-content-location) .atcb-date-btn-content-icon,.atcb-initialized[lang=zh] .atcb-date-btn-content:not(.atcb-date-btn-content-location) .atcb-date-btn-content-icon{margin-top:.15em}.atcb-date-btn-content-icon svg{height:100%;fill:currentcolor;width:100%}.atcb-date-btn-content+.atcb-date-btn-content{margin-top:.3em}.atcb-date-btn-content-text span:not(.atcb-icon-ical){padding-right:.3em;display:inline-block}.atcb-checkmark{display:none}.atcb-saved .atcb-checkmark{box-sizing:content-box;color:var(--btn-text);display:block;position:absolute;top:-.9em;right:-.5em;padding:.5em;border-radius:100%;height:1.2em}.atcb-button.atcb-active:not(.atcb-modal-style,.atcb-dropoverlay) .atcb-checkmark,.atcb-button:focus .atcb-checkmark,.atcb-button:hover .atcb-checkmark{top:-.77em;right:-.37em}.atcb-checkmark svg{height:100%;filter:var(--checkmark-background);width:auto}#atcb-bgoverlay{backdrop-filter:blur(2px);-webkit-backdrop-filter:blur(2px);background-color:var(--overlay-background);border:0;box-sizing:border-box;display:flex;height:calc(100vh + 100px);inset-inline:0;left:0;right:0;top:0;min-height:100%;min-width:100%;overflow-y:auto;padding:20px 20px 130px;position:fixed;width:100vw;z-index:14000000}#atcb-bgoverlay:not(dialog){animation:atcb-bgoverlay-animate .2s ease 0s 1 normal forwards;opacity:0}#atcb-bgoverlay.atcb-no-bg{animation:none;backdrop-filter:none;-webkit-backdrop-filter:none;opacity:1;background-color:transparent}@keyframes atcb-bgoverlay-animate{0%{opacity:0}100%{opacity:1}}#atcb-bgoverlay.atcb-click:hover{cursor:var(--overlay-cursor)}.atcb-icon-outlookcom,.atcb-icon.atcb-icon-ms365{padding-bottom:.05em}.atcb-icon.atcb-icon-apple,.atcb-icon.atcb-icon-ical{padding-bottom:.15em}.atcb-icon.atcb-icon-trigger{padding-bottom:.15em}.atcb-icon.atcb-icon-rsvp{height:1.5em;width:1.5em}.atcb-icon.atcb-icon-apple svg{fill:currentcolor}.atcb-icon.atcb-icon-ical svg{fill:currentcolor}.atcb-icon.atcb-icon-ms365 svg{fill:var(--icon-ms365-color)}.atcb-icon.atcb-icon-yahoo svg{fill:var(--icon-yahoo-color)}.atcb-icon.atcb-icon-google svg,.atcb-icon.atcb-icon-msteams svg,.atcb-icon.atcb-icon-outlookcom svg{filter:var(--icon-filter)}.rsvp-inline-wrapper{filter:none;min-width:100%;margin-bottom:0}.atcb-modal-content.no-headline{border-radius:var(--modal-border-radius) var(--modal-border-radius) 0 0;padding-top:1.8em}.rsvp-inline-wrapper .atcb-modal-content,.rsvp-inline-wrapper .atcb-modal-headline,.rsvp-inline-wrapper.atcb-modal-box{background-color:transparent;border-radius:0;box-sizing:border-box;padding:0;width:100%}.rsvp-inline-wrapper .atcb-modal-headline{padding-bottom:1.5em}.pro{text-align:center}.pro ol,.pro ul{margin:auto;text-align:left;width:fit-content}.pro a:not(.atcb-modal-btn),.pro a:not(.atcb-modal-btn):active,.pro a:not(.atcb-modal-btn):visited{color:var(--modal-btn-text);text-decoration:underline;text-decoration-thickness:2px;text-decoration-color:var(--accent-color)}.pro a:not(.atcb-modal-btn):hover{color:var(--accent-color);text-decoration:none}.pro .pro-share-buttons{display:flex;flex-wrap:wrap;justify-content:center}.pro #rsvp-atcb{display:flex;flex-wrap:wrap;gap:.4em;justify-content:center}.pro-form{text-align:left}.pro-form:not(.no-intro){border-top:1px solid var(--modal-btn-border);margin-top:1.5em;padding-top:1.5em}.pro-form.no-intro:not(.no-headline){padding-top:.5em}.pro-field+.pro-field{padding-top:1.3em}.pro-field-type-label+.pro-field-type-radio{padding-top:0}.pro-field-type-checkbox,.pro-field-type-radio div{align-items:center;display:flex}.pro-field-type-checkbox input,.pro-field-type-radio input{cursor:pointer}.pro-field label{display:block;font-size:.9em;opacity:.7}.pro-field-type-checkbox label,.pro-field-type-radio label{cursor:pointer;opacity:.8;padding-left:.3em}.pro-field input[type=email],.pro-field input[type=number],.pro-field input[type=text]{background-color:var(--input-background);border:1px solid var(--modal-btn-border);border-radius:var(--input-border-radius);box-sizing:border-box;caret-color:var(--accent-color);color:var(--modal-text);font-size:.9em;opacity:.8;padding:.7em;transition:all .1s ease-in-out;width:100%}.pro-field input[type=checkbox],.pro-field input[type=radio]{accent-color:var(--accent-color);height:1.2rem;opacity:.8;transition:all .1s ease-in-out;width:1.2em}.pro-field input:disabled,.pro-field input:disabled+label{cursor:not-allowed;opacity:.75;filter:brightness(95%)}.pro-field input:not([disabled]):hover{opacity:1}.pro-field input[type=email]:focus,.pro-field input[type=number]:focus,.pro-field input[type=text]:focus{border-color:var(--accent-color);outline:1px solid var(--accent-color)}.pro-field input[type=checkbox]:focus,.pro-field input[type=radio]:focus{outline-color:var(--accent-color);outline-width:2px}#submit-error{color:var(--form-error);display:none;font-weight:700;padding-top:1.5em;text-align:center}.pro-form.form-error #submit-error{display:block}.pro-field input.error{accent-color:var(--form-error);border:2px solid var(--form-error)}.pro-field input.error+label,.pro-field:has(input.error) label{color:var(--form-error);opacity:1}#rsvp-status-group{border-bottom:1px solid var(--modal-btn-border);font-weight:700;margin-bottom:1.5em;padding-bottom:2em;text-align:center}#rsvp-status-group .pro-field{align-items:center;display:flex;flex-wrap:wrap;gap:3%;justify-content:center;margin-top:1em}@media (width <= 575px){#rsvp-status-group .pro-field{flex-direction:column;gap:1.2em}#rsvp-status-group .pro-field div{width:80%}}#rsvp-status-group .pro-field div{min-width:28%;position:relative}#rsvp-status-group input{opacity:0;position:absolute;top:0;left:0;height:100%;width:100%;margin:0;cursor:pointer}#rsvp-status-group label{align-items:center;border:1px solid var(--modal-btn-text);border-radius:var(--input-border-radius);box-shadow:var(--btn-shadow);color:var(--modal-btn-text);display:flex;flex-direction:column;font-weight:700;text-transform:uppercase;justify-content:center;opacity:.6;padding:.8em;transition:all .1s ease-in-out;width:100%}#rsvp-status-group label.status-confirmed{border-color:var(--form-success);color:var(--form-success)}#rsvp-status-group label.status-declined{border-color:var(--form-error);color:var(--form-error)}#rsvp-status-group input:checked+label{background-color:var(--modal-text);box-shadow:var(--btn-hover-shadow);color:var(--status-active-text);opacity:1;transform:scale(1.08)}#rsvp-status-group input:focus-visible+label{outline:2px solid var(--accent-color);outline-offset:2px}#rsvp-status-group input:not([disabled])+label:hover,#rsvp-status-group input:not([disabled]):hover+label{box-shadow:var(--btn-hover-shadow);opacity:1;transform:scale(1.08)}#rsvp-status-group input:checked+label.status-confirmed{background-color:var(--form-success)}#rsvp-status-group input:checked+label.status-declined{background-color:var(--form-error)}#rsvp-success-msg,#rsvp-success-msg-demo,#rsvp-success-msg-doi,#rsvp-success-msg-email,#ty-success-msg{display:none;font-weight:700;line-height:1.6em;padding-top:.5em;text-align:center}#rsvp-success-msg,#rsvp-success-msg-demo,#ty-success-msg{padding:1.5em 0}#rsvp-success-msg-demo,#rsvp-success-msg-email{color:var(--form-success)}#rsvp-success-msg-doi{color:var(--form-error);padding-top:1em;font-size:.8em}#pro-form-submit{display:block;margin:auto;min-width:150px}.pro-form-fine{font-size:.8em;margin:.5em auto 1em;opacity:.5;text-align:center}.pro-form.form-error .pro-form-fine{opacity:0}.pro-waiting{background-color:var(--modal-btn-background);border:1px solid var(--modal-btn-border);border-radius:var(--btn-border-radius);box-sizing:border-box;color:var(--modal-btn-text);cursor:wait;display:none;line-height:.5em;margin:auto;min-width:150px;padding:.5em 1.25em 1.2em;text-align:center;user-select:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent;width:fit-content}@media (width > 575px){#pro-form-submit,.pro-waiting{min-width:200px}}.pro-waiting span:not(.atcb-icon-ical){animation-name:blink;animation-duration:1s;animation-iteration-count:infinite;animation-fill-mode:both;font-size:2.5em}.pro-field label span:not(.atcb-icon-ical){color:var(--form-error);font-weight:700;padding-left:2px}.pro-waiting span:not(.atcb-icon-ical):nth-child(2){animation-delay:.15s}.pro-waiting span:not(.atcb-icon-ical):nth-child(3){animation-delay:.3s}@keyframes blink{0%{opacity:.2}20%{opacity:1}100%{opacity:.2}}.pro #rsvp-sent-content{align-items:center;display:flex;flex-direction:column;gap:1.5em}#rsvp-status-group span{color:inherit}.atcb-modal-content .pro p:not(.pro-form-fine){margin:0}.atcb-modal-content .pro p.pro-pt{margin-top:1.5em}.atcb-modal-content .pro .pro-field p{font-size:.9em}.pro .btn-flex{align-items:center;display:flex}.pro .atcb-modal-btn svg{fill:none;height:1.5em;margin-right:.5em;stroke:currentcolor;width:auto}#atcb-reference{box-sizing:border-box;filter:drop-shadow(0 0 3px rgba(255 255 255 / 80%));height:auto;padding:8px 0;text-align:center;transform:translate3d(0,0,0);width:100%;z-index:15000000}#atcb-reference.fixed-ref{position:fixed;bottom:10px;right:40px;width:auto}#atcb-reference.atcb-dropup{position:absolute;margin-top:-1px}.atcb-modal-host-initialized #atcb-reference.atcb-dropup{text-align:left}:host(.atcb-dark) #atcb-reference{filter:drop-shadow(0 0 5px #000)}#atcb-reference a,#atcb-reference a:active,#atcb-reference a:visited{opacity:.4;width:150px;max-width:100%;margin:auto;display:inline-block;text-decoration:none}#atcb-reference.fixed-ref a{opacity:.6}#atcb-reference a:hover{opacity:.9;text-decoration:none}#atcb-reference svg{fill:var(--list-text)}`,
  neumorphism: `:host{width:fit-content;--base-font-size-l:16px;--base-font-size-m:16px;--base-font-size-s:16px;--font:arial,helvetica,"Twemoji Mozilla","Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","EmojiOne Color","Android Emoji",sans-serif;--accent-color:#1e90ff;--wrapper-padding:0px;--buttonslist-gap:5px;--btn-background:#f5f5f5;--btn-hover-background:#fff;--btn-font-weight:600;--btn-text:#444;--btn-hover-text:#111;--btn-border-radius:15px;--btn-padding-x:1.2em;--btn-padding-y:1em;--btn-shadow:rgba(40 40 40 / 30%) 0.3em 0.3em 0.6em,rgba(255 255 255 / 70%) -0.1em -0.1em 0.3em;--btn-hover-shadow:rgba(40 40 40 / 50%) 0.4em 0.4em 0.8em,rgba(255 255 255 / 90%) -0.2em -0.2em 0.5em;--btn-active-shadow:inset rgba(40 40 40 / 40%) 0.15em 0.15em 0.3em,inset rgba(255 255 255 / 90%) -0.2em -0.2em 0.5em;--list-background:#f5f5f5;--list-hover-background:#fff;--list-text:#444;--list-font-weight:400;--list-hover-text:#111;--list-close-background:#e5e5e5;--list-close-text:#777;--list-border-radius:11px;--list-padding:1em;--list-min-width:100%;--list-shadow:rgba(40 40 40 / 30%) 0.4em 0.4em 0.8em,rgba(255 255 255 / 80%) -0.2em -0.2em 0.5em;--modal-text:#111;--modal-text-align:left;--modal-text-align-rtl:right;--modal-background:#f5f5f5;--modal-border-radius:9px;--modal-shadow:drop-shadow(5px 8px 30px rgba(0 0 0 / 70%));--modal-btn-bar:#c6c8cd;--modal-btn-background:#f5f5f5;--modal-btn-secondary-background:#e2e1e6;--modal-btn-hover-background:#fff;--modal-btn-font-weight:600;--modal-btn-text:#2e2e2e;--modal-btn-hover-text:#222;--modal-btn-secondary-text:#666567;--modal-btn-shadow:rgba(40 40 40 / 15%) 0.2em 0.2em 0.4em,rgba(255 255 255 / 30%) -0.1em -0.1em 0.3em;--modal-btn-hover-shadow:rgba(40 40 40 / 40%) 0.4em 0.4em 0.7em,rgba(255 255 255 / 70%) -0.2em -0.2em 0.5em;--modal-headline-text-align:center;--modal-headline-text-transform:none;--input-border-radius:6px;--input-background:#fff;--status-active-text:#fff;--form-error:#c5372c;--form-success:#338a36;--date-btn-text:#1d1d1e;--date-btn-text-secondary:#3a3a3f;--date-btn-cal-day-text:#fff;--date-btn-cal-month-text:#d3d2d7;--date-btn-cal-background:#313132;--date-btn-background:#e3e5ea;--date-btn-hover-background:#fff;--date-btn-headline-line-clamp:1;--date-btn-shadow:rgba(0 0 0 / 10%) 0 4px 10px -2px,rgba(0 0 0 / 15%) 0 2px 3px -1px;--date-btn-hover-shadow:rgba(0 0 0 / 20%) 0 5px 12px -2px,rgba(0 0 0 / 20%) 0 3px 4px -2px;--checkmark-background:drop-shadow(0 0 3px #fff);--overlay-background:#dcdcdc;--overlay-cursor:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23777' width='16' height='16' viewBox='0 0 122.878 122.88'%3E%3Cpath d='M1.426 8.313a4.87 4.87 0 0 1 0-6.886 4.87 4.87 0 0 1 6.886 0l53.127 53.127 53.127-53.127a4.87 4.87 0 0 1 6.887 0 4.87 4.87 0 0 1 0 6.886L68.324 61.439l53.128 53.128a4.87 4.87 0 0 1-6.887 6.886L61.438 68.326 8.312 121.453a4.87 4.87 0 0 1-6.886 0 4.87 4.87 0 0 1 0-6.886l53.127-53.128L1.426 8.313h0z'/%3E%3C/svg%3E") 16 16,crosshair;--icon-ms365-color:#ea3e23;--icon-yahoo-color:#5f01d1;--icon-filter:none}:host(.atcb-dark){--btn-background:#2e2e2e;--btn-hover-background:#373737;--btn-text:#dedede;--btn-hover-text:#f1f1f1;--btn-shadow:rgba(0 0 0 / 70%) 0.3em 0.3em 0.6em,rgba(230 230 230 / 20%) -0.05em -0.05em 0.4em;--btn-hover-shadow:rgba(0 0 0 / 90%) 0.4em 0.4em 0.9em,rgba(230 230 230 / 25%) -0.08em -0.08em 0.6em -0.1em;--btn-active-shadow:inset rgba(0 0 0 / 80%) 0.15em 0.15em 0.25em,inset rgba(230 230 230 / 10%) -0.2em -0.2em 0.7em -0.1em;--list-background:#2e2e2e;--list-hover-background:#373737;--list-text:#dedede;--list-hover-text:#f1f1f1;--list-close-background:#282828;--list-shadow:rgba(0 0 0) 0.3em 0.3em 1em,rgba(230 230 230 / 40%) -0.08em -0.08em 0.6em;--modal-text:#f1f1f1;--modal-background:#242424;--modal-shadow:drop-shadow(5px 8px 35px rgba(0 0 0 / 90%));--modal-btn-bar:#38383a;--modal-btn-background:#181819;--modal-btn-secondary-background:#2e2d30;--modal-btn-hover-background:#434246;--modal-btn-text:#dbdbdb;--modal-btn-hover-text:#fff;--modal-btn-secondary-text:#b8b8b8;--modal-btn-shadow:rgba(0 0 0 / 60%) 0.2em 0.2em 0.6em,rgba(230 230 230 / 15%) -0.1em -0.1em 0.4em;--modal-btn-hover-shadow:rgba(0 0 0 / 80%) 0.3em 0.3em 0.8em,rgba(230 230 230 / 15%) -0.1em -0.1em 0.6em;--input-background:#434246;--status-active-text:#000;--form-error:#db8680;--form-success:#99de9c;--date-btn-text:#ebebf0;--date-btn-text-secondary:#b5b5bd;--date-btn-cal-day-text:#101010;--date-btn-cal-month-text:#3e3e3f;--date-btn-cal-background:#c7c7cd;--date-btn-background:#363636;--date-btn-hover-background:#474747;--date-btn-shadow:rgba(0 0 0 / 70%) 0.2em 0.2em 0.8em,rgba(230 230 230 / 15%) -0.1em -0.1em 0.5em;--date-btn-hover-shadow:rgba(0 0 0) 0.3em 0.4em 1em,rgba(230 230 230 / 15%) -0.2em -0.2em 0.8em;--checkmark-background:drop-shadow(0 0 3px #0a0a0a);--overlay-background:#141414;--icon-ms365-color:#ea3e23;--icon-yahoo-color:#bebebe;--icon-filter:grayscale(0.2)}.atcb-button-wrapper,.atcb-list,.atcb-modal-box{font-size:var(--base-font-size-l)}@media (width <= 991px){.atcb-button-wrapper,.atcb-list,.atcb-modal-box{font-size:var(--base-font-size-m)}}@media (width <= 575px){.atcb-button-wrapper,.atcb-list,.atcb-modal-box{font-size:var(--base-font-size-s)}}.atcb-initialized.atcb-buttons-list{gap:var(--buttonslist-gap)}.atcb-button-wrapper{display:block;padding:var(--wrapper-padding);position:relative}.atcb-button{align-items:center;background-color:var(--btn-background);border:0;border-radius:var(--btn-border-radius);box-shadow:var(--btn-shadow);color:var(--btn-text);cursor:pointer;display:flex;font-family:var(--font);font-size:1em;font-weight:var(--btn-font-weight);justify-content:center;line-height:1.5em;margin:0;max-width:350px;padding:var(--btn-padding-y) var(--btn-padding-x);position:relative;text-align:center;touch-action:manipulation;user-select:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent;width:auto;transition:box-shadow .1s ease-in-out,background-color .1s ease-in-out;z-index:1}.atcb-button.atcb-no-text{min-width:0;border-radius:100%;display:flex;place-content:center center;align-items:center;height:3em;width:3em;padding:0}.atcb-rtl .atcb-button{direction:rtl;text-align:right}.atcb-button:focus-visible{outline:2px solid var(--accent-color)}.atcb-button:not([disabled]):focus,.atcb-button:not([disabled]):hover{background-color:var(--btn-hover-background);box-shadow:var(--btn-hover-shadow);color:var(--btn-hover-text)}.atcb-button.atcb-active:not(.atcb-modal-style,.atcb-dropoverlay){z-index:15000000}.atcb-button.atcb-active:not(.atcb-modal-style,.atcb-dropoverlay),.atcb-button.atcb-single:not([disabled]):focus,.atcb-button.atcb-single:not([disabled]):hover{background-color:var(--btn-hover-background);box-shadow:var(--btn-active-shadow);color:var(--btn-hover-text)}.atcb-button.atcb-active.atcb-dropoverlay{z-index:14000090}.atcb-icon{flex-grow:0;flex-shrink:0;height:1em;line-height:1em;margin-right:.8em;width:1em}.atcb-rtl .atcb-icon{margin-right:0;margin-left:.8em}.atcb-no-text .atcb-icon{margin-right:0;margin-left:0}.atcb-icon svg{fill:currentcolor;height:100%;width:100%}.atcb-text{overflow-wrap:anywhere}.atcb-dropdown-anchor{bottom:-15px;height:0;width:100%;opacity:0;position:absolute}.atcb-list-wrapper{box-sizing:border-box;font-weight:var(--list-font-weight);position:absolute;width:auto;animation:list-entrance .6s ease 0s 1 normal forwards;z-index:15000000}@keyframes list-entrance{0%{opacity:0}100%{opacity:1}}.atcb-list{background-color:var(--list-background);border-radius:var(--list-border-radius);box-sizing:border-box;box-shadow:var(--list-shadow);color:var(--list-text);display:block;font-family:var(--font);min-width:var(--list-min-width);position:relative;user-select:none;-webkit-user-select:none;width:fit-content}.atcb-list-item{box-shadow:none;align-items:center;background-color:var(--list-background);box-sizing:border-box;cursor:pointer;display:flex;font-size:1em;line-height:1.75em;padding:var(--list-padding);text-align:left;touch-action:manipulation;-webkit-tap-highlight-color:transparent;transition:box-shadow .15s ease-in-out,padding .15s ease-in-out,margin .15s ease-in-out}.atcb-rtl .atcb-list-item{direction:rtl;text-align:right}.atcb-list-item:hover{box-shadow:var(--btn-shadow);background-color:var(--list-hover-background);color:var(--list-hover-text);padding:calc(var(--list-padding) + .2em);margin:-.2em;position:relative;z-index:15000010}.atcb-list-item:focus-visible{box-shadow:var(--btn-shadow);background-color:var(--list-hover-background);color:var(--accent-color);padding:calc(var(--list-padding) + .2em);margin:-.2em;position:relative;z-index:15000010;outline:0}.atcb-list-item:last-child{border-radius:0 0 var(--list-border-radius) var(--list-border-radius)}.atcb-list-item:first-child{border-radius:var(--list-border-radius) var(--list-border-radius) 0 0}.atcb-list-item:only-child{border-radius:var(--list-border-radius)}.atcb-list-item .atcb-icon{margin:0 auto}.atcb-list-item .atcb-icon+.atcb-text{margin-left:.7em;width:100%}.atcb-rtl .atcb-list-item .atcb-icon+.atcb-text{margin-left:0;margin-right:.7em}.atcb-list-item-close{background-color:var(--list-close-background)}.atcb-list-item.atcb-list-item-close:not(:focus-visible){color:var(--list-close-text)}.atcb-list-item-close svg{fill:currentcolor}.atcb-modal{display:block;margin:auto;width:auto;min-width:auto;position:relative;z-index:14000090}.atcb-modal-box{animation:list-entrance .6s ease 0s 1 normal forwards;filter:var(--modal-shadow);color:var(--modal-text);cursor:default;box-sizing:border-box;font-family:var(--font);line-height:1.5em;text-align:var(--modal-text-align);user-select:none;-webkit-user-select:none;touch-action:manipulation;width:100%;margin-bottom:20px;-webkit-tap-highlight-color:transparent}@media (width > 575px){.atcb-modal-box{width:32em}}.atcb-modal-box.atcb-rtl{text-align:var(--modal-text-align-rtl);direction:rtl;padding:1.25em 1em 1.25em 2em}.atcb-modal-icon{height:2.5em;width:2.5em;border-radius:100%;background-color:var(--modal-background);padding:1.75em;margin:auto}.atcb-modal-icon svg{fill:currentcolor;height:100%;width:100%}.atcb-modal-headline{background-color:var(--modal-background);border-radius:var(--modal-border-radius) var(--modal-border-radius) 0 0;font-size:1.3em;font-weight:600;line-height:1.5em;padding:1.8em 1.5em 1.3em;text-transform:var(--modal-headline-text-transform);text-align:var(--modal-headline-text-align)}.atcb-modal-icon+.atcb-modal-headline{margin-top:-2.6em;padding-top:2.6em}.atcb-modal-content{background-color:var(--modal-background);font-size:1em;padding:.3em 2em 2.2em}.atcb-modal-content-subevents{margin:auto;width:fit-content}.atcb-modal-icon+.atcb-modal-content{border-radius:var(--modal-border-radius) var(--modal-border-radius) 0 0;margin-top:-2.6em;padding-top:2.6em}@media (width <= 575px){.atcb-modal-headline{padding:1.8em 1em 1em}.atcb-modal-content{padding:.3em 1.5em 1.5em}.atcb-modal-icon+.atcb-modal-content{padding-top:1.8em}}.atcb-modal-buttons{background-color:var(--modal-btn-bar);border-radius:0 0 var(--modal-border-radius) var(--modal-border-radius);box-sizing:border-box;padding:.6em;text-align:center;width:100%;display:flex;justify-content:center;flex-flow:row-reverse wrap;align-items:center}a.atcb-modal-btn,button.atcb-modal-btn{background-color:var(--modal-btn-secondary-background);border:0;border-radius:var(--btn-border-radius);box-shadow:var(--modal-btn-shadow);color:var(--modal-btn-secondary-text);cursor:pointer;display:inline-block;font-family:var(--font);font-size:.9em;font-weight:var(--modal-btn-font-weight);line-height:1em;margin:.625em;padding:1em 1.25em;position:relative;text-align:center;text-decoration:none;touch-action:manipulation;user-select:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent}a.atcb-modal-btn.btn-small,button.atcb-modal-btn.btn-small{padding:.6em .8em}a.atcb-modal-btn.atcb-modal-btn-primary,button.atcb-modal-btn.atcb-modal-btn-primary{background-color:var(--modal-btn-background);color:var(--modal-btn-text)}a.atcb-modal-btn:focus-visible,button.atcb-modal-btn:focus-visible{background-color:var(--modal-btn-hover-background);outline:2px solid var(--accent-color)}a.atcb-modal-btn:disabled,button.atcb-button:disabled,button.atcb-modal-btn:disabled,button.atcb-subevent-btn:disabled{cursor:not-allowed;opacity:.75;filter:brightness(95%);border-style:dashed;box-shadow:none}a.atcb-modal-btn:not([disabled]):hover,button.atcb-modal-btn:not([disabled]):hover{background-color:var(--modal-btn-hover-background);box-shadow:var(--modal-btn-hover-shadow);color:var(--modal-btn-hover-text);text-decoration:none}.atcb-subevent-btn{display:flex;align-items:flex-start;cursor:pointer;font-family:var(--font);font-size:1em;box-shadow:var(--date-btn-shadow);background-color:var(--date-btn-background);border:0;border-radius:7px 4px 4px 7px;padding:0;margin:0;touch-action:manipulation;position:relative;user-select:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent;width:100%}.atcb-subevent-btn:hover{align-items:center}.atcb-subevent-btn:focus,.atcb-subevent-btn:hover{background-color:var(--date-btn-hover-background);box-shadow:var(--date-btn-hover-shadow)}.atcb-subevent-btn:focus-visible{outline:2px solid var(--accent-color)}.atcb-subevent-btn+.atcb-subevent-btn{margin-top:30px}.atcb-date-btn-left{border-radius:4px 0 0 4px;align-self:stretch;background-color:var(--date-btn-cal-background);color:var(--date-btn-hover-background);padding:.7em .8em .8em;width:2.7em;align-items:center;display:flex;flex-direction:column;flex-shrink:0}.atcb-rtl .atcb-date-btn-left{border-radius:0 4px 4px 0}.atcb-subevent-btn:hover .atcb-date-btn-left{opacity:.8}.atcb-date-btn-day{color:var(--date-btn-cal-day-text);font-weight:400;font-size:2em;word-break:keep-all;padding-bottom:.1em}.atcb-initialized[lang=ja] .atcb-date-btn-day,.atcb-initialized[lang=ko] .atcb-date-btn-day,.atcb-initialized[lang=zh] .atcb-date-btn-day{font-size:1.3em}.atcb-date-btn-month{color:var(--date-btn-cal-month-text);font-weight:600;font-size:1em}.atcb-date-btn-right{position:relative;color:var(--date-btn-text);min-width:13.5em;overflow-wrap:anywhere}.atcb-subevent-btn .atcb-date-btn-right{width:100%}.atcb-date-btn-details{opacity:1;padding:.7em .8em;text-align:left}.atcb-rtl .atcb-date-btn-details{text-align:right}.atcb-date-btn-hover{position:absolute;top:0;left:0;width:100%;opacity:0;height:100%;display:flex;align-items:center;justify-content:center;font-weight:600;font-size:1em;padding:.4em .7em;box-sizing:border-box}.atcb-subevent-btn:hover .atcb-date-btn-details{opacity:0}.atcb-subevent-btn:hover .atcb-date-btn-hover{opacity:1}.atcb-date-btn-headline{font-weight:600;font-size:.9em;margin-bottom:.5em;overflow:hidden;display:-webkit-box;-webkit-line-clamp:var(--date-btn-headline-line-clamp);line-clamp:var(--date-btn-headline-line-clamp);-webkit-box-orient:vertical}.atcb-date-btn-content{display:flex;align-items:flex-start;font-size:.8em;color:var(--date-btn-text-secondary)}.atcb-date-btn-content.atcb-date-btn-cancelled{color:var(--form-error);font-weight:700}.atcb-date-btn-content-location{overflow:hidden;display:-webkit-box;-webkit-line-clamp:1;line-clamp:1;-webkit-box-orient:vertical;word-break:break-all}.atcb-date-btn-content-icon{display:inline-block;height:.8em;margin-right:.4em;margin-left:0;width:.9em;flex-shrink:0}.atcb-rtl .atcb-date-btn-content-icon{margin-right:0;margin-left:.4em}.atcb-initialized[lang=ja] .atcb-date-btn-content:not(.atcb-date-btn-content-location) .atcb-date-btn-content-icon,.atcb-initialized[lang=ko] .atcb-date-btn-content:not(.atcb-date-btn-content-location) .atcb-date-btn-content-icon,.atcb-initialized[lang=zh] .atcb-date-btn-content:not(.atcb-date-btn-content-location) .atcb-date-btn-content-icon{margin-top:.15em}.atcb-date-btn-content-icon svg{height:100%;fill:currentcolor;width:100%}.atcb-date-btn-content+.atcb-date-btn-content{margin-top:.3em}.atcb-date-btn-content-text span:not(.atcb-icon-ical){padding-right:.3em;display:inline-block}.atcb-checkmark{display:none}.atcb-saved .atcb-checkmark{box-sizing:content-box;color:var(--btn-text);display:block;position:absolute;top:-.9em;right:-.5em;padding:.5em;border-radius:100%;height:1.2em}.atcb-button.atcb-active:not(.atcb-modal-style,.atcb-dropoverlay) .atcb-checkmark,.atcb-button.atcb-single:focus .atcb-checkmark,.atcb-button.atcb-single:hover .atcb-checkmark{top:-.77em;right:-.37em}.atcb-checkmark svg{height:100%;filter:var(--checkmark-background);width:auto}#atcb-bgoverlay{background-color:var(--overlay-background);border:0;box-sizing:border-box;display:flex;height:calc(100vh + 100px);inset-inline:0;left:0;right:0;top:0;min-height:100%;min-width:100%;overflow-y:auto;padding:20px 20px 130px;position:fixed;width:100vw;z-index:14000000}#atcb-bgoverlay:not(dialog){animation:atcb-bgoverlay-animate .1s ease 0s 1 normal forwards;opacity:0}#atcb-bgoverlay.atcb-no-bg{animation:none;backdrop-filter:none;-webkit-backdrop-filter:none;opacity:1;background-color:transparent}@keyframes atcb-bgoverlay-animate{0%{opacity:0}100%{opacity:1}}#atcb-bgoverlay.atcb-click:hover{cursor:var(--overlay-cursor)}.atcb-icon-outlookcom,.atcb-icon.atcb-icon-ms365{padding-bottom:.05em}.atcb-icon.atcb-icon-apple,.atcb-icon.atcb-icon-ical{padding-bottom:.15em}.atcb-icon.atcb-icon-trigger{padding-bottom:.15em}.atcb-icon.atcb-icon-rsvp{height:1.5em;width:1.5em}.atcb-icon.atcb-icon-apple svg{fill:currentcolor}.atcb-icon.atcb-icon-ical svg{fill:currentcolor}.atcb-icon.atcb-icon-ms365 svg{fill:var(--icon-ms365-color)}.atcb-icon.atcb-icon-yahoo svg{fill:var(--icon-yahoo-color)}.atcb-icon.atcb-icon-google svg,.atcb-icon.atcb-icon-msteams svg,.atcb-icon.atcb-icon-outlookcom svg{filter:var(--icon-filter)}.rsvp-inline-wrapper{filter:none;min-width:100%;margin-bottom:0}.atcb-modal-content.no-headline{border-radius:var(--modal-border-radius) var(--modal-border-radius) 0 0;padding-top:1.8em}.rsvp-inline-wrapper .atcb-modal-content,.rsvp-inline-wrapper .atcb-modal-headline,.rsvp-inline-wrapper.atcb-modal-box{background-color:transparent;border-radius:0;box-sizing:border-box;padding:0;width:100%}.rsvp-inline-wrapper .atcb-modal-headline{padding-bottom:1.5em}.pro{text-align:center}.pro ol,.pro ul{margin:auto;text-align:left;width:fit-content}.pro a:not(.atcb-modal-btn),.pro a:not(.atcb-modal-btn):active,.pro a:not(.atcb-modal-btn):visited{color:var(--modal-btn-text);text-decoration:underline;text-decoration-thickness:2px;text-decoration-color:var(--accent-color)}.pro a:not(.atcb-modal-btn):hover{color:var(--accent-color);text-decoration:none}.pro .pro-share-buttons{display:flex;flex-wrap:wrap;justify-content:center}.pro #rsvp-atcb{display:flex;flex-wrap:wrap;gap:.4em;justify-content:center}.pro-form{text-align:left}.pro-form:not(.no-intro){border-top:1px solid var(--modal-btn-border);margin-top:1.5em;padding-top:1.5em}.pro-form.no-intro:not(.no-headline){padding-top:.5em}.pro-field+.pro-field{padding-top:1.3em}.pro-field-type-label+.pro-field-type-radio{padding-top:0}.pro-field-type-checkbox,.pro-field-type-radio div{align-items:center;display:flex}.pro-field-type-checkbox input,.pro-field-type-radio input{cursor:pointer}.pro-field label{display:block;font-size:.9em;opacity:.7}.pro-field-type-checkbox label,.pro-field-type-radio label{cursor:pointer;opacity:.8;padding-left:.3em}.pro-field input[type=email],.pro-field input[type=number],.pro-field input[type=text]{background-color:var(--input-background);border:1px solid var(--modal-btn-border);border-radius:var(--input-border-radius);box-sizing:border-box;box-shadow:var(--btn-shadow);caret-color:var(--accent-color);color:var(--modal-text);font-size:.9em;opacity:.8;padding:.7em;transition:all .1s ease-in-out;width:100%}.pro-field input[type=checkbox],.pro-field input[type=radio]{accent-color:var(--accent-color);height:1.2rem;opacity:.8;transition:all .1s ease-in-out;width:1.2em}.pro-field input:disabled,.pro-field input:disabled+label{cursor:not-allowed;opacity:.75;filter:brightness(95%)}.pro-field input:not([disabled]):hover{opacity:1}.pro-field input:not([disabled],[type=checkbox],[type=radio]):hover{box-shadow:var(--btn-active-shadow)}.pro-field input[type=email]:focus,.pro-field input[type=number]:focus,.pro-field input[type=text]:focus{box-shadow:var(--btn-active-shadow)}.pro-field input[type=email]:focus-visible,.pro-field input[type=number]:focus-visible,.pro-field input[type=text]:focus-visible{border-color:var(--accent-color);outline:1px solid var(--accent-color)}.pro-field input[type=checkbox]:focus,.pro-field input[type=radio]:focus{outline-color:var(--accent-color);outline-width:2px}#submit-error{color:var(--form-error);display:none;font-weight:700;padding-top:1.5em;text-align:center}.pro-form.form-error #submit-error{display:block}.pro-field input.error{accent-color:var(--form-error);border:2px solid var(--form-error)}.pro-field input.error+label,.pro-field:has(input.error) label{color:var(--form-error);opacity:1}#rsvp-status-group{border-bottom:1px solid var(--modal-btn-border);font-weight:700;margin-bottom:1.5em;padding-bottom:2em;text-align:center}#rsvp-status-group .pro-field{align-items:center;display:flex;flex-wrap:wrap;gap:3%;justify-content:center;margin-top:1em}@media (width <= 575px){#rsvp-status-group .pro-field{flex-direction:column;gap:1.2em}#rsvp-status-group .pro-field div{width:80%}}#rsvp-status-group .pro-field div{min-width:28%;position:relative}#rsvp-status-group input{opacity:0;position:absolute;top:0;left:0;height:100%;width:100%;margin:0;cursor:pointer}#rsvp-status-group label{align-items:center;background-color:var(--input-background);border-radius:var(--input-border-radius);box-shadow:var(--btn-shadow);color:var(--modal-btn-text);display:flex;flex-direction:column;font-weight:700;text-transform:uppercase;justify-content:center;opacity:.6;padding:.8em;transition:all .1s ease-in-out;width:100%}#rsvp-status-group label.status-confirmed{color:var(--form-success)}#rsvp-status-group label.status-declined{color:var(--form-error)}#rsvp-status-group input:checked+label{background-color:var(--modal-text);box-shadow:var(--btn-hover-shadow);color:var(--status-active-text);opacity:1;transform:scale(1.08)}#rsvp-status-group input:focus-visible+label{outline:2px solid var(--accent-color);outline-offset:2px}#rsvp-status-group input:not([disabled])+label:hover,#rsvp-status-group input:not([disabled]):hover+label{box-shadow:var(--btn-hover-shadow);opacity:1;transform:scale(1.08)}#rsvp-status-group input:checked+label.status-confirmed{background-color:var(--form-success)}#rsvp-status-group input:checked+label.status-declined{background-color:var(--form-error)}#rsvp-success-msg,#rsvp-success-msg-demo,#rsvp-success-msg-doi,#rsvp-success-msg-email,#ty-success-msg{display:none;font-weight:700;line-height:1.6em;padding-top:.5em;text-align:center}#rsvp-success-msg,#rsvp-success-msg-demo,#ty-success-msg{padding:1.5em 0}#rsvp-success-msg-demo,#rsvp-success-msg-email{color:var(--form-success)}#rsvp-success-msg-doi{color:var(--form-error);padding-top:1em;font-size:.8em}#pro-form-submit{background-color:var(--btn-hover-background);display:block;margin:auto;min-width:150px}.pro-form-fine{font-size:.8em;margin:.5em auto 1em;opacity:.5;text-align:center}.pro-form.form-error .pro-form-fine{opacity:0}.pro-waiting{background-color:var(--modal-btn-background);border:1px solid var(--modal-btn-border);border-radius:var(--btn-border-radius);box-sizing:border-box;color:var(--modal-btn-text);cursor:wait;display:none;line-height:.5em;margin:auto;min-width:150px;padding:.5em 1.25em 1.2em;text-align:center;user-select:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent;width:fit-content}@media (width > 575px){#pro-form-submit,.pro-waiting{min-width:200px}}.pro-waiting span:not(.atcb-icon-ical){animation-name:blink;animation-duration:1s;animation-iteration-count:infinite;animation-fill-mode:both;font-size:2.5em}.pro-field label span:not(.atcb-icon-ical){color:var(--form-error);font-weight:700;padding-left:2px}.pro-waiting span:not(.atcb-icon-ical):nth-child(2){animation-delay:.15s}.pro-waiting span:not(.atcb-icon-ical):nth-child(3){animation-delay:.3s}@keyframes blink{0%{opacity:.2}20%{opacity:1}100%{opacity:.2}}.pro #rsvp-sent-content{align-items:center;display:flex;flex-direction:column;gap:1.5em}#rsvp-status-group span{color:inherit}.atcb-modal-content .pro p:not(.pro-form-fine){margin:0}.atcb-modal-content .pro p.pro-pt{margin-top:1.5em}.atcb-modal-content .pro .pro-field p{font-size:.9em}.pro .btn-flex{align-items:center;display:flex}.pro .atcb-modal-btn svg{fill:none;height:1.5em;margin-right:.5em;stroke:currentcolor;width:auto}#atcb-reference{box-sizing:border-box;filter:drop-shadow(0 0 3px rgba(255 255 255 / 80%));height:auto;padding:8px 0;text-align:center;transform:translate3d(0,0,0);width:100%;z-index:15000000}#atcb-reference.fixed-ref{position:fixed;bottom:10px;right:40px;width:auto}#atcb-reference.atcb-dropup{position:absolute;margin-top:-1px}.atcb-modal-host-initialized #atcb-reference.atcb-dropup{text-align:left}:host(.atcb-dark) #atcb-reference{filter:drop-shadow(0 0 5px #000)}#atcb-reference a,#atcb-reference a:active,#atcb-reference a:visited{opacity:.4;width:150px;max-width:100%;margin:auto;display:inline-block;text-decoration:none}#atcb-reference.fixed-ref a{opacity:.6}#atcb-reference a:hover{opacity:.9;text-decoration:none}#atcb-reference svg{fill:var(--list-text)}`,
  text: `:host{width:fit-content;--base-font-size-l:16px;--base-font-size-m:16px;--base-font-size-s:16px;--font:arial,helvetica,"Twemoji Mozilla","Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","EmojiOne Color","Android Emoji",sans-serif;--accent-color:#1e90ff;--wrapper-padding:0px;--buttonslist-gap:5px;--btn-underline:#a9ceff;--btn-border:#a8a8a8;--btn-padding-x:.75em;--btn-padding-y:.75em;--btn-background:#f5f5f5;--btn-hover-background:#fff;--btn-font-weight:600;--btn-text:#333;--btn-hover-text:#000;--btn-hover-shadow:rgba(0 0 0 / 10%) 0 4px 10px -2px,rgba(0 0 0 / 15%) 0 2px 2px -1px;--btn-text-shadow:#fff;--list-background:#f5f5f5;--list-hover-background:#fff;--list-text:#333;--list-font-weight:400;--list-hover-text:#000;--list-close-background:#e5e5e5;--list-close-text:#777;--list-border-radius:11px;--list-padding:.8em 1.2em;--list-min-width:100%;--list-shadow:rgba(0 0 0 / 20%) 0 4px 13px -2px,rgba(0 0 0 / 23%) 0 2px 4px -1px;--list-modal-shadow:rgba(0 0 0 / 50%) 0 4px 30px -3px,rgba(0 0 0 / 30%) 0 2px 8px -2px;--modal-text:#000;--modal-text-align:left;--modal-text-align-rtl:right;--modal-background:#f5f5f5;--modal-btn-bar:#c6c8cd;--modal-btn-background:#f5f5f5;--modal-border-radius:9px;--modal-shadow:drop-shadow(3px 6px 25px rgba(0 0 0 / 65%));--modal-btn-secondary-background:#e2e1e6;--modal-btn-hover-background:#fff;--modal-btn-border:#d2d2d2;--modal-btn-font-weight:600;--modal-btn-text:#2e2e2e;--modal-btn-hover-text:#161616;--modal-btn-secondary-text:#666567;--modal-btn-shadow:rgba(0 0 0 / 10%) 0 4px 10px -2px,rgba(0 0 0 / 15%) 0 2px 3px -1px;--modal-btn-hover-shadow:rgba(0 0 0 / 25%) 0 5px 13px -2px,rgba(0 0 0 / 25%) 0 3px 5px -2px;--modal-headline-text-align:center;--modal-headline-text-transform:none;--input-border-radius:6px;--input-background:#fff;--status-active-text:#fff;--form-error:#c5372c;--form-success:#338a36;--date-btn-text:#1d1d1e;--date-btn-text-secondary:#3a3a3f;--date-btn-cal-day-text:#fff;--date-btn-cal-month-text:#d3d2d7;--date-btn-cal-background:#313132;--date-btn-background:#eae9ed;--date-btn-hover-background:#fff;--date-btn-headline-line-clamp:1;--date-btn-shadow:rgba(0 0 0 / 10%) 0 4px 10px -2px,rgba(0 0 0 / 15%) 0 2px 3px -1px;--date-btn-hover-shadow:rgba(0 0 0 / 20%) 0 5px 12px -2px,rgba(0 0 0 / 20%) 0 3px 4px -2px;--checkmark-background:drop-shadow(0 0 3px #fff);--overlay-background:rgba(200 200 200 / 25%);--overlay-cursor:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23777' width='16' height='16' viewBox='0 0 122.878 122.88'%3E%3Cpath d='M1.426 8.313a4.87 4.87 0 0 1 0-6.886 4.87 4.87 0 0 1 6.886 0l53.127 53.127 53.127-53.127a4.87 4.87 0 0 1 6.887 0 4.87 4.87 0 0 1 0 6.886L68.324 61.439l53.128 53.128a4.87 4.87 0 0 1-6.887 6.886L61.438 68.326 8.312 121.453a4.87 4.87 0 0 1-6.886 0 4.87 4.87 0 0 1 0-6.886l53.127-53.128L1.426 8.313h0z'/%3E%3C/svg%3E") 16 16,crosshair;--icon-ms365-color:#ea3e23;--icon-yahoo-color:#5f01d1;--icon-filter:none}:host(.atcb-dark){--btn-underline:#336db9;--btn-border:#888;--btn-background:#2e2e2e;--btn-hover-background:#373737;--btn-text:#dedede;--btn-hover-text:#fff;--btn-text-shadow:#000;--list-background:#2e2e2e;--list-hover-background:#373737;--list-text:#dedede;--list-hover-text:#fff;--list-close-background:#282828;--list-shadow:rgba(255 255 255 / 5%) -12px -5px 20px -8px,rgba(255 255 255 / 6%) -7px -5px 15px -3px,rgba(0 0 0 / 50%) 2px 5px 18px -1px,rgba(0 0 0 / 40%) 3px 3px 20px -3px;--list-modal-shadow:rgba(255 255 255 / 8%) -12px -5px 30px -8px,rgba(255 255 255 / 8%) -7px -5px 15px -3px,rgba(0 0 0 / 60%) 4px 6px 50px -4px,rgba(0 0 0 / 90%) 8px 12px 40px -2px;--modal-text:#f1f1f1;--modal-background:#242424;--modal-shadow:drop-shadow(3px 6px 25px rgba(0 0 0 / 90%));--modal-btn-bar:#38383a;--modal-btn-background:#181819;--modal-btn-secondary-background:#2e2d30;--modal-btn-hover-background:#434246;--modal-btn-border:#434246;--modal-btn-text:#dbdbdb;--modal-btn-hover-text:#fff;--modal-btn-secondary-text:#b8b8b8;--modal-btn-shadow:rgba(255 255 255 / 5%) -2px -2px 10px,rgba(0 0 0 / 40%) 3px 3px 10px -2px,rgba(0 0 0 / 40%) 1px 2px 5px -1px;--input-background:#434246;--status-active-text:#000;--form-error:#db8680;--form-success:#99de9c;--date-btn-text:#ebebf0;--date-btn-text-secondary:#b5b5bd;--date-btn-cal-day-text:#101010;--date-btn-cal-month-text:#3e3e3f;--date-btn-cal-background:#c7c7cd;--date-btn-background:#363636;--date-btn-hover-background:#474747;--date-btn-shadow:rgba(0 0 0 / 60%) 0 0 20px -2px,rgba(0 0 0 / 30%) 1px 2px 3px -1px;--checkmark-background:drop-shadow(0 0 3px #0a0a0a);--overlay-background:rgba(20 20 20 / 60%);--icon-ms365-color:#ea3e23;--icon-yahoo-color:#bebebe;--icon-filter:grayscale(0.2)}.atcb-button-wrapper,.atcb-list,.atcb-modal-box{font-size:var(--base-font-size-l)}@media (width <= 991px){.atcb-button-wrapper,.atcb-list,.atcb-modal-box{font-size:var(--base-font-size-m)}}@media (width <= 575px){.atcb-button-wrapper,.atcb-list,.atcb-modal-box{font-size:var(--base-font-size-s)}}.atcb-initialized.atcb-buttons-list{gap:var(--buttonslist-gap)}.atcb-button-wrapper{display:block;padding:var(--wrapper-padding);position:relative}.atcb-button{background-image:linear-gradient(120deg,var(--btn-underline) 0,var(--btn-underline) 100%);background-repeat:no-repeat;background-size:100% 8%;background-position:0 100%;background-color:transparent;border:0;border-radius:0;transition:background-size .1s ease-in,border-radius .2s ease-in,box-shadow .1s ease-in;align-items:center;color:var(--btn-text);cursor:pointer;display:flex;font-family:var(--font);font-size:1em;font-weight:var(--btn-font-weight);justify-content:center;line-height:1.2em;margin:0 .2em;padding:var(--btn-padding-y) var(--btn-padding-x);position:relative;text-align:left;touch-action:manipulation;user-select:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent;width:auto;z-index:1}.atcb-button.atcb-no-text{min-width:0;display:flex;place-content:center center;align-items:center;height:3em;width:3em;padding:0}.atcb-rtl .atcb-button{direction:rtl;text-align:right}.atcb-button:focus-visible{outline:2px solid var(--accent-color)}.atcb-button:not([disabled]):focus,.atcb-button:not([disabled]):hover{background-size:100% 100%;box-shadow:var(--btn-hover-shadow);color:var(--btn-hover-text);text-shadow:0 0 .7em var(--btn-text-shadow);border-radius:21px}.atcb-button.atcb-active:not(.atcb-modal-style,.atcb-dropoverlay){background-size:100% 10%;border-radius:3px 3px 11px 11px;background-position:0 0;background-color:var(--btn-background);color:var(--btn-text);text-shadow:none;z-index:15000000}.atcb-button.atcb-single:not([disabled]):focus,.atcb-button.atcb-single:not([disabled]):hover{background-size:100% 10%;background-position:0 100%;border-radius:11px 11px 3px 3px;background-color:var(--btn-background);color:var(--btn-text);text-shadow:none}.atcb-button.atcb-active.atcb-dropup{background-position:0 100%;border-radius:11px 11px 3px 3px}.atcb-button.atcb-dropup::after,.atcb-button:not(.atcb-modal-style,.atcb-dropoverlay,.atcb-dropup)::before{content:"";width:0;height:0;position:absolute;left:0;right:0;margin:0 auto}.atcb-button:not(.atcb-modal-style,.atcb-dropoverlay,.atcb-dropup)::before{top:100%;border:0 solid transparent;border-bottom:none;border-top-color:var(--btn-background)}.atcb-button.atcb-dropup::after{bottom:100%;border:0 solid transparent;border-top:none;border-bottom-color:var(--btn-background)}.atcb-button.atcb-active.atcb-dropup::after,.atcb-button.atcb-active:not(.atcb-modal-style,.atcb-dropoverlay,.atcb-dropup)::before{border-width:.35em;transition:border-width .1s linear .1s}.atcb-button.atcb-active.atcb-dropoverlay{z-index:14000090}.atcb-icon{flex-grow:0;flex-shrink:0;height:1em;line-height:1em;margin-right:.8em;width:.9em}.atcb-rtl .atcb-icon{margin-right:0;margin-left:1em}.atcb-no-text .atcb-icon{margin-right:0;margin-left:0}.atcb-icon svg{fill:currentcolor;height:100%;width:100%}.atcb-icon-trigger svg{display:none}.atcb-button .atcb-icon-trigger::after{content:"+";font-family:Arial,Helvetica,sans-serif;font-size:1.5em}.atcb-text{overflow-wrap:anywhere}.atcb-dropdown-anchor{bottom:-15px;height:0;width:100%;opacity:0;position:absolute}.atcb-list-wrapper{box-sizing:border-box;font-weight:var(--list-font-weight);position:absolute;z-index:14000090;width:auto}.atcb-list-wrapper:not(.atcb-dropup,.atcb-dropoverlay){animation:list-entrance-bottom .2s ease 0s 1 normal forwards}.atcb-list-wrapper.atcb-dropup{animation:list-entrance-top .2s ease 0s 1 normal forwards}.atcb-list-wrapper.atcb-dropoverlay{animation:list-entrance-center .2s ease 0s 1 normal forwards;z-index:15000000}@keyframes list-entrance-bottom{0%{opacity:0;transform:translateY(250px)}100%{opacity:1;transform:translateY(0)}}@keyframes list-entrance-top{0%{opacity:0;transform:translateY(-250px)}100%{opacity:1;transform:translateY(0)}}@keyframes list-entrance-center{0%{opacity:0;transform:scaleY(1)}1%{opacity:1;transform:scaleY(0)}100%{opacity:1;transform:scaleY(1)}}.atcb-list{background-color:var(--list-background);border-radius:var(--list-border-radius);box-sizing:border-box;box-shadow:var(--list-shadow);color:var(--list-text);display:block;font-family:var(--font);min-width:var(--list-min-width);position:relative;user-select:none;-webkit-user-select:none;width:fit-content}.atcb-list-item{align-items:center;background-color:var(--list-background);box-sizing:border-box;cursor:pointer;display:flex;font-size:1em;line-height:1.75em;padding:var(--list-padding);text-align:left;touch-action:manipulation;-webkit-tap-highlight-color:transparent}.atcb-rtl .atcb-list-item{direction:rtl;text-align:right}.atcb-list-item:hover{background-color:var(--list-hover-background);color:var(--list-hover-text)}.atcb-list-item:focus-visible{background-color:var(--list-hover-background);color:var(--accent-color);outline:0}.atcb-list-item:last-child{border-radius:0 0 var(--list-border-radius) var(--list-border-radius)}.atcb-list-item:first-child{border-radius:var(--list-border-radius) var(--list-border-radius) 0 0}.atcb-list-item:only-child{border-radius:var(--list-border-radius)}.atcb-list.atcb-modal{box-shadow:var(--list-modal-shadow)}.atcb-list-item .atcb-icon{margin:0 auto;height:1em;width:1em}.atcb-list-item .atcb-icon+.atcb-text{margin-left:.7em;width:100%}.atcb-rtl .atcb-list-item .atcb-icon+.atcb-text{margin-left:0;margin-right:.7em}.atcb-list-item-close{background-color:var(--list-close-background)}.atcb-list-item.atcb-list-item-close:not(:focus-visible){color:var(--list-close-text)}.atcb-list-item-close svg{fill:currentcolor}.atcb-modal{display:block;margin:auto;width:auto;min-width:auto;position:relative;z-index:14000090}.atcb-modal-box{filter:var(--modal-shadow);color:var(--modal-text);cursor:default;box-sizing:border-box;font-family:var(--font);line-height:1.5em;text-align:var(--modal-text-align);user-select:none;-webkit-user-select:none;touch-action:manipulation;width:100%;margin-bottom:20px;-webkit-tap-highlight-color:transparent}@media (width > 575px){.atcb-modal-box{width:32em}}.atcb-modal-box.atcb-rtl{text-align:var(--modal-text-align-rtl);direction:rtl;padding:1.25em 1em 1.25em 2em}.atcb-modal-icon{height:2.5em;width:2.5em;border-radius:100%;background-color:var(--modal-background);padding:1.75em;margin:auto}.atcb-modal-icon svg{fill:currentcolor;height:100%;width:100%}.atcb-modal-headline{background-color:var(--modal-background);border-radius:var(--modal-border-radius) var(--modal-border-radius) 0 0;font-size:1.3em;font-weight:600;line-height:1.5em;padding:1.8em 1.5em 1.3em;text-transform:var(--modal-headline-text-transform);text-align:var(--modal-headline-text-align)}.atcb-modal-icon+.atcb-modal-headline{margin-top:-2.6em;padding-top:2.6em}.atcb-modal-content{background-color:var(--modal-background);font-size:1em;padding:.3em 2em 2.2em}.atcb-modal-content-subevents{margin:auto;width:fit-content}.atcb-modal-icon+.atcb-modal-content{border-radius:var(--modal-border-radius) var(--modal-border-radius) 0 0;margin-top:-2.6em;padding-top:2.6em}@media (width <= 575px){.atcb-modal-headline{padding:1.8em 1em 1em}.atcb-modal-content{padding:.3em 1.5em 1.5em}.atcb-modal-icon+.atcb-modal-content{padding-top:1.8em}}.atcb-modal-buttons{background-color:var(--modal-btn-bar);border-radius:0 0 var(--modal-border-radius) var(--modal-border-radius);box-sizing:border-box;padding:.6em;text-align:center;width:100%;display:flex;justify-content:center;flex-flow:row-reverse wrap;align-items:center}a.atcb-modal-btn,button.atcb-modal-btn{background-color:var(--modal-btn-secondary-background);border:0;border-radius:21px;box-shadow:var(--modal-btn-shadow);color:var(--modal-btn-secondary-text);cursor:pointer;display:inline-block;font-family:var(--font);font-size:.9em;font-weight:var(--modal-btn-font-weight);line-height:1em;margin:.625em;padding:1em 1.25em;position:relative;text-align:center;text-decoration:none;touch-action:manipulation;user-select:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent}a.atcb-modal-btn.btn-small,button.atcb-modal-btn.btn-small{padding:.6em .8em}a.atcb-modal-btn.atcb-modal-btn-primary,button.atcb-modal-btn.atcb-modal-btn-primary{background-color:var(--modal-btn-background);color:var(--modal-btn-text)}a.atcb-modal-btn.atcb-modal-btn-border,button.atcb-modal-btn.atcb-modal-btn-border{border:1px solid var(--modal-btn-border)}a.atcb-modal-btn:focus-visible,button.atcb-modal-btn:focus-visible{background-color:var(--modal-btn-hover-background);outline:2px solid var(--accent-color)}a.atcb-modal-btn:disabled,button.atcb-button:disabled,button.atcb-modal-btn:disabled,button.atcb-subevent-btn:disabled{cursor:not-allowed;opacity:.75;filter:brightness(95%);border-style:dashed;box-shadow:none}a.atcb-modal-btn:not([disabled]):hover,button.atcb-modal-btn:not([disabled]):hover{background-color:var(--modal-btn-hover-background);box-shadow:var(--modal-btn-hover-shadow);color:var(--modal-btn-hover-text);text-decoration:none}.atcb-subevent-btn{display:flex;align-items:flex-start;cursor:pointer;font-family:var(--font);font-size:1em;box-shadow:var(--date-btn-shadow);background-color:var(--date-btn-background);border:0;border-radius:7px 4px 4px 7px;padding:0;margin:0;touch-action:manipulation;position:relative;user-select:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent;width:100%}.atcb-subevent-btn:hover{align-items:center}.atcb-subevent-btn:focus,.atcb-subevent-btn:hover{background-color:var(--date-btn-hover-background);box-shadow:var(--date-btn-hover-shadow)}.atcb-subevent-btn:focus-visible{outline:2px solid var(--accent-color)}.atcb-subevent-btn+.atcb-subevent-btn{margin-top:30px}.atcb-date-btn-left{border-radius:4px 0 0 4px;align-self:stretch;background-color:var(--date-btn-cal-background);color:var(--date-btn-hover-background);padding:.7em .8em .8em;width:2.7em;align-items:center;display:flex;flex-direction:column;flex-shrink:0}.atcb-rtl .atcb-date-btn-left{border-radius:0 4px 4px 0}.atcb-subevent-btn:hover .atcb-date-btn-left{opacity:.8}.atcb-date-btn-day{color:var(--date-btn-cal-day-text);font-weight:400;font-size:2em;word-break:keep-all;padding-bottom:.1em}.atcb-initialized[lang=ja] .atcb-date-btn-day,.atcb-initialized[lang=ko] .atcb-date-btn-day,.atcb-initialized[lang=zh] .atcb-date-btn-day{font-size:1.3em}.atcb-date-btn-month{color:var(--date-btn-cal-month-text);font-weight:600;font-size:1em}.atcb-date-btn-right{position:relative;color:var(--date-btn-text);min-width:13.5em;overflow-wrap:anywhere}.atcb-subevent-btn .atcb-date-btn-right{width:100%}.atcb-date-btn-details{opacity:1;padding:.7em .8em;text-align:left}.atcb-rtl .atcb-date-btn-details{text-align:right}.atcb-date-btn-hover{position:absolute;top:0;left:0;width:100%;opacity:0;height:100%;display:flex;align-items:center;justify-content:center;font-weight:600;font-size:1em;padding:.4em .7em;box-sizing:border-box}.atcb-subevent-btn:hover .atcb-date-btn-details{opacity:0}.atcb-subevent-btn:hover .atcb-date-btn-hover{opacity:1}.atcb-date-btn-headline{font-weight:600;font-size:.9em;margin-bottom:.5em;overflow:hidden;display:-webkit-box;-webkit-line-clamp:var(--date-btn-headline-line-clamp);line-clamp:var(--date-btn-headline-line-clamp);-webkit-box-orient:vertical}.atcb-date-btn-content{display:flex;align-items:flex-start;font-size:.8em;color:var(--date-btn-text-secondary)}.atcb-date-btn-content.atcb-date-btn-cancelled{color:var(--form-error);font-weight:700}.atcb-date-btn-content-location{overflow:hidden;display:-webkit-box;-webkit-line-clamp:1;line-clamp:1;-webkit-box-orient:vertical;word-break:break-all}.atcb-date-btn-content-icon{display:inline-block;height:.8em;margin-right:.4em;margin-left:0;width:.9em;flex-shrink:0}.atcb-rtl .atcb-date-btn-content-icon{margin-right:0;margin-left:.4em}.atcb-initialized[lang=ja] .atcb-date-btn-content:not(.atcb-date-btn-content-location) .atcb-date-btn-content-icon,.atcb-initialized[lang=ko] .atcb-date-btn-content:not(.atcb-date-btn-content-location) .atcb-date-btn-content-icon,.atcb-initialized[lang=zh] .atcb-date-btn-content:not(.atcb-date-btn-content-location) .atcb-date-btn-content-icon{margin-top:.15em}.atcb-date-btn-content-icon svg{height:100%;fill:currentcolor;width:100%}.atcb-date-btn-content+.atcb-date-btn-content{margin-top:.3em}.atcb-date-btn-content-text span:not(.atcb-icon-ical){padding-right:.3em;display:inline-block}.atcb-checkmark{display:none}.atcb-saved .atcb-checkmark{box-sizing:content-box;color:var(--btn-text);display:block;position:absolute;top:-.9em;right:-.5em;padding:.5em;border-radius:100%;height:1.2em}.atcb-checkmark svg{height:100%;filter:var(--checkmark-background);width:auto}#atcb-bgoverlay{backdrop-filter:blur(2px);-webkit-backdrop-filter:blur(2px);background-color:var(--overlay-background);border:0;box-sizing:border-box;display:flex;height:calc(100vh + 100px);inset-inline:0;left:0;right:0;top:0;min-height:100%;min-width:100%;overflow-y:auto;padding:20px 20px 130px;position:fixed;width:100vw;z-index:14000000}#atcb-bgoverlay:not(dialog){animation:atcb-bgoverlay-animate .2s ease 0s 1 normal forwards;opacity:0}#atcb-bgoverlay.atcb-no-bg{animation:none;backdrop-filter:none;-webkit-backdrop-filter:none;opacity:1;background-color:transparent}@keyframes atcb-bgoverlay-animate{0%{opacity:0}100%{opacity:1}}#atcb-bgoverlay.atcb-click:hover{cursor:var(--overlay-cursor)}.atcb-icon-outlookcom,.atcb-icon.atcb-icon-ms365{padding-bottom:.05em}.atcb-icon.atcb-icon-apple,.atcb-icon.atcb-icon-ical{padding-bottom:.15em}.atcb-icon.atcb-icon-rsvp{height:1.5em;width:1.5em}.atcb-icon.atcb-icon-apple svg{fill:currentcolor}.atcb-icon.atcb-icon-ical svg{fill:currentcolor}.atcb-icon.atcb-icon-ms365 svg{fill:var(--icon-ms365-color)}.atcb-icon.atcb-icon-yahoo svg{fill:var(--icon-yahoo-color)}.atcb-icon.atcb-icon-google svg,.atcb-icon.atcb-icon-msteams svg,.atcb-icon.atcb-icon-outlookcom svg{filter:var(--icon-filter)}.rsvp-inline-wrapper{filter:none;min-width:100%;margin-bottom:0}.atcb-modal-content.no-headline{border-radius:var(--modal-border-radius) var(--modal-border-radius) 0 0;padding-top:1.8em}.rsvp-inline-wrapper .atcb-modal-content,.rsvp-inline-wrapper .atcb-modal-headline,.rsvp-inline-wrapper.atcb-modal-box{background-color:transparent;border-radius:0;box-sizing:border-box;padding:0;width:100%}.rsvp-inline-wrapper .atcb-modal-headline{padding-bottom:1.5em}.pro{text-align:center}.pro ol,.pro ul{margin:auto;text-align:left;width:fit-content}.pro a:not(.atcb-modal-btn),.pro a:not(.atcb-modal-btn):active,.pro a:not(.atcb-modal-btn):visited{color:var(--modal-btn-text);text-decoration:underline;text-decoration-thickness:2px;text-decoration-color:var(--accent-color)}.pro a:not(.atcb-modal-btn):hover{color:var(--accent-color);text-decoration:none}.pro .pro-share-buttons{display:flex;flex-wrap:wrap;justify-content:center}.pro #rsvp-atcb{display:flex;flex-wrap:wrap;gap:.4em;justify-content:center}.pro-form{text-align:left}.pro-form:not(.no-intro){border-top:1px solid var(--modal-btn-border);margin-top:1.5em;padding-top:1.5em}.pro-form.no-intro:not(.no-headline){padding-top:.5em}.pro-field+.pro-field{padding-top:1.3em}.pro-field-type-label+.pro-field-type-radio{padding-top:0}.pro-field-type-checkbox,.pro-field-type-radio div{align-items:center;display:flex}.pro-field-type-checkbox input,.pro-field-type-radio input{cursor:pointer}.pro-field label{display:block;font-size:.9em;opacity:.7}.pro-field-type-checkbox label,.pro-field-type-radio label{cursor:pointer;opacity:.8;padding-left:.3em}.pro-field input[type=email],.pro-field input[type=number],.pro-field input[type=text]{background-color:var(--input-background);border:1px solid var(--modal-btn-border);border-radius:var(--input-border-radius);box-sizing:border-box;caret-color:var(--accent-color);color:var(--modal-text);font-size:.9em;opacity:.8;padding:.7em;transition:all .1s ease-in-out;width:100%}.pro-field input[type=checkbox],.pro-field input[type=radio]{accent-color:var(--accent-color);height:1.2rem;opacity:.8;transition:all .1s ease-in-out;width:1.2em}.pro-field input:disabled,.pro-field input:disabled+label{cursor:not-allowed;opacity:.75;filter:brightness(95%)}.pro-field input:not([disabled]):hover{opacity:1}.pro-field input[type=email]:focus,.pro-field input[type=number]:focus,.pro-field input[type=text]:focus{border-color:var(--accent-color);outline:1px solid var(--accent-color)}.pro-field input[type=checkbox]:focus,.pro-field input[type=radio]:focus{outline-color:var(--accent-color);outline-width:2px}#submit-error{color:var(--form-error);display:none;font-weight:700;padding-top:1.5em;text-align:center}.pro-form.form-error #submit-error{display:block}.pro-field input.error{accent-color:var(--form-error);border:2px solid var(--form-error)}.pro-field input.error+label,.pro-field:has(input.error) label{color:var(--form-error);opacity:1}#rsvp-status-group{border-bottom:1px solid var(--modal-btn-border);font-weight:700;margin-bottom:1.5em;padding-bottom:2em;text-align:center}#rsvp-status-group .pro-field{align-items:center;display:flex;flex-wrap:wrap;gap:3%;justify-content:center;margin-top:1em}@media (width <= 575px){#rsvp-status-group .pro-field{flex-direction:column;gap:1.2em}#rsvp-status-group .pro-field div{width:80%}}#rsvp-status-group .pro-field div{min-width:28%;position:relative}#rsvp-status-group input{opacity:0;position:absolute;top:0;left:0;height:100%;width:100%;margin:0;cursor:pointer}#rsvp-status-group label{align-items:center;border:1px solid var(--modal-btn-text);border-radius:var(--input-border-radius);color:var(--modal-btn-text);display:flex;flex-direction:column;font-weight:700;text-transform:uppercase;justify-content:center;opacity:.6;padding:.8em;transition:all .1s ease-in-out;width:100%}#rsvp-status-group label.status-confirmed{border-color:var(--form-success);color:var(--form-success)}#rsvp-status-group label.status-declined{border-color:var(--form-error);color:var(--form-error)}#rsvp-status-group input:checked+label{background-color:var(--modal-text);box-shadow:var(--btn-hover-shadow);color:var(--status-active-text);opacity:1;transform:scale(1.08)}#rsvp-status-group input:focus-visible+label{outline:2px solid var(--accent-color);outline-offset:2px}#rsvp-status-group input:not([disabled])+label:hover,#rsvp-status-group input:not([disabled]):hover+label{box-shadow:var(--btn-hover-shadow);opacity:1;transform:scale(1.08)}#rsvp-status-group input:checked+label.status-confirmed{background-color:var(--form-success)}#rsvp-status-group input:checked+label.status-declined{background-color:var(--form-error)}#rsvp-success-msg,#rsvp-success-msg-demo,#rsvp-success-msg-doi,#rsvp-success-msg-email,#ty-success-msg{display:none;font-weight:700;line-height:1.6em;padding-top:.5em;text-align:center}#rsvp-success-msg,#rsvp-success-msg-demo,#ty-success-msg{padding:1.5em 0}#rsvp-success-msg-demo,#rsvp-success-msg-email{color:var(--form-success)}#rsvp-success-msg-doi{color:var(--form-error);padding-top:1em;font-size:.8em}#pro-form-submit{display:block;margin:auto;min-width:150px}.pro-form-fine{font-size:.8em;margin:.5em auto 1em;opacity:.5;text-align:center}.pro-form.form-error .pro-form-fine{opacity:0}.pro-waiting{background-color:var(--modal-btn-background);border:1px solid var(--modal-btn-border);border-radius:var(--btn-border-radius);box-sizing:border-box;color:var(--modal-btn-text);cursor:wait;display:none;line-height:.5em;margin:auto;min-width:150px;padding:.5em 1.25em 1.2em;text-align:center;user-select:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent;width:fit-content}@media (width > 575px){#pro-form-submit,.pro-waiting{min-width:200px}}.pro-waiting span:not(.atcb-icon-ical){animation-name:blink;animation-duration:1s;animation-iteration-count:infinite;animation-fill-mode:both;font-size:2.5em}.pro-field label span:not(.atcb-icon-ical){color:var(--form-error);font-weight:700;padding-left:2px}.pro-waiting span:not(.atcb-icon-ical):nth-child(2){animation-delay:.15s}.pro-waiting span:not(.atcb-icon-ical):nth-child(3){animation-delay:.3s}@keyframes blink{0%{opacity:.2}20%{opacity:1}100%{opacity:.2}}.pro #rsvp-sent-content{align-items:center;display:flex;flex-direction:column;gap:1.5em}#rsvp-status-group span{color:inherit}.atcb-modal-content .pro p:not(.pro-form-fine){margin:0}.atcb-modal-content .pro p.pro-pt{margin-top:1.5em}.atcb-modal-content .pro .pro-field p{font-size:.9em}.pro .btn-flex{align-items:center;display:flex}.pro .atcb-modal-btn svg{fill:none;height:1.5em;margin-right:.5em;stroke:currentcolor;width:auto}#atcb-reference{box-sizing:border-box;filter:drop-shadow(0 0 3px rgba(255 255 255 / 80%));height:auto;padding:8px 0;text-align:center;transform:translate3d(0,0,0);width:100%;z-index:15000000}#atcb-reference.fixed-ref{position:fixed;bottom:10px;right:40px;width:auto}#atcb-reference.atcb-dropup{position:absolute;margin-top:-1px}.atcb-modal-host-initialized #atcb-reference.atcb-dropup{text-align:left}:host(.atcb-dark) #atcb-reference{filter:drop-shadow(0 0 5px #000)}#atcb-reference a,#atcb-reference a:active,#atcb-reference a:visited{opacity:.4;width:150px;max-width:100%;margin:auto;display:inline-block;text-decoration:none}#atcb-reference.fixed-ref a{opacity:.6}#atcb-reference a:hover{opacity:.9;text-decoration:none}#atcb-reference svg{fill:var(--list-text)}`,
  date: `:host{width:fit-content;--base-font-size-l:16px;--base-font-size-m:16px;--base-font-size-s:16px;--font:arial,helvetica,"Twemoji Mozilla","Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","EmojiOne Color","Android Emoji",sans-serif;--accent-color:#1e90ff;--wrapper-padding:0px;--buttonslist-gap:5px;--btn-background:#f5f5f5;--btn-hover-background:#fff;--btn-border:#d2d2d2;--btn-border-radius:4px;--btn-text:#333;--btn-hover-text:#000;--btn-shadow:rgba(0 0 0 / 13%) 0 4px 10px -2px,rgba(0 0 0 / 18%) 0 2px 3px -1px;--btn-hover-shadow:rgba(0 0 0 / 25%) 0 5px 12px -2px,rgba(0 0 0 / 25%) 0 3px 5px -2px;--list-background:#f5f5f5;--list-hover-background:#fff;--list-text:#333;--list-font-weight:400;--list-hover-text:#000;--list-close-background:#e5e5e5;--list-close-text:#777;--list-shadow:rgba(0 0 0 / 20%) 0 4px 13px -2px,rgba(0 0 0 / 23%) 0 2px 4px -1px;--list-modal-shadow:rgba(0 0 0 / 50%) 0 4px 30px -3px,rgba(0 0 0 / 30%) 0 2px 8px -2px;--modal-text:#000;--modal-text-align:left;--modal-text-align-rtl:right;--modal-background:#f5f5f5;--modal-shadow:drop-shadow(3px 6px 25px rgba(0 0 0 / 65%));--modal-btn-bar:#c6c8cd;--modal-btn-background:#f5f5f5;--modal-btn-secondary-background:#e2e1e6;--modal-btn-hover-background:#fff;--modal-btn-border:#d2d2d2;--modal-btn-font-weight:600;--modal-btn-text:#2e2e2e;--modal-btn-hover-text:#161616;--modal-btn-secondary-text:#666567;--modal-btn-shadow:rgba(0 0 0 / 10%) 0 4px 10px -2px,rgba(0 0 0 / 10%) 0 2px 3px -1px;--modal-btn-hover-shadow:rgba(0 0 0 / 25%) 0 5px 13px -2px,rgba(0 0 0 / 20%) 0 3px 5px -2px;--modal-headline-text-align:center;--modal-headline-text-transform:none;--input-border-radius:3px;--input-background:#fff;--status-active-text:#fff;--form-error:#c5372c;--form-success:#338a36;--date-btn-text:#1d1d1e;--date-btn-text-secondary:#3a3a3f;--date-btn-cal-day-text:#fff;--date-btn-cal-month-text:#d3d2d7;--date-btn-cal-background:#313132;--date-btn-background:#eae9ed;--date-btn-hover-background:#fff;--date-btn-headline-line-clamp:1;--date-btn-shadow:rgba(0 0 0 / 10%) 0 4px 10px -2px,rgba(0 0 0 / 15%) 0 2px 3px -1px;--date-btn-hover-shadow:rgba(0 0 0 / 20%) 0 5px 12px -2px,rgba(0 0 0 / 20%) 0 3px 4px -2px;--checkmark-background:drop-shadow(0 0 3px #fff);--overlay-background:rgba(20 20 20 / 25%);--overlay-cursor:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23777' width='16' height='16' viewBox='0 0 122.878 122.88'%3E%3Cpath d='M1.426 8.313a4.87 4.87 0 0 1 0-6.886 4.87 4.87 0 0 1 6.886 0l53.127 53.127 53.127-53.127a4.87 4.87 0 0 1 6.887 0 4.87 4.87 0 0 1 0 6.886L68.324 61.439l53.128 53.128a4.87 4.87 0 0 1-6.887 6.886L61.438 68.326 8.312 121.453a4.87 4.87 0 0 1-6.886 0 4.87 4.87 0 0 1 0-6.886l53.127-53.128L1.426 8.313h0z'/%3E%3C/svg%3E") 16 16,crosshair;--icon-ms365-color:#ea3e23;--icon-yahoo-color:#5f01d1;--icon-filter:none}:host(.atcb-dark){--btn-background:#2e2e2e;--btn-hover-background:#474747;--btn-border:#4d4d4d;--btn-text:#dedede;--btn-hover-text:#f1f1f1;--btn-shadow:rgba(0 0 0 / 70%) 0 0 25px -2px,rgba(0 0 0 / 40%) 1px 2px 4px -1px;--btn-hover-shadow:rgba(0 0 0 / 90%) 2px 3px 25px -3px,rgba(0 0 0 / 50%) 1px 4px 6px -2px;--list-background:#2e2e2e;--list-hover-background:#474747;--list-text:#dedede;--list-hover-text:#f1f1f1;--list-close-background:#282828;--list-shadow:rgba(0 0 0 / 60%) 0 4px 20px -2px,rgba(0 0 0 / 40%) 0 2px 4px -1px;--list-modal-shadow:rgba(0 0 0 / 40%) -1px 3px 30px 2px;--modal-text:#f1f1f1;--modal-background:#242424;--modal-shadow:drop-shadow(3px 6px 25px rgba(0 0 0 / 90%));--modal-btn-bar:#38383a;--modal-btn-background:#181819;--modal-btn-secondary-background:#2e2d30;--modal-btn-hover-background:#434246;--modal-btn-border:#434246;--modal-btn-text:#dbdbdb;--modal-btn-hover-text:#fff;--modal-btn-secondary-text:#b8b8b8;--modal-btn-shadow:rgba(255 255 255 / 5%) -2px -2px 10px,rgba(0 0 0 / 40%) 3px 3px 10px -2px,rgba(0 0 0 / 40%) 1px 2px 5px -1px;--input-background:#434246;--status-active-text:#000;--form-error:#db8680;--form-success:#99de9c;--date-btn-text:#ebebf0;--date-btn-text-secondary:#b5b5bd;--date-btn-cal-day-text:#101010;--date-btn-cal-month-text:#3e3e3f;--date-btn-cal-background:#c7c7cd;--date-btn-background:#363636;--date-btn-hover-background:#474747;--date-btn-shadow:rgba(0 0 0 / 60%) 0 0 20px -2px,rgba(0 0 0 / 30%) 1px 2px 3px -1px;--checkmark-background:drop-shadow(0 0 3px #0a0a0a);--overlay-background:rgba(20 20 20 / 60%);--icon-ms365-color:#ea3e23;--icon-yahoo-color:#bebebe;--icon-filter:grayscale(.2)}.atcb-button-wrapper,.atcb-list,.atcb-modal-box{font-size:var(--base-font-size-l)}@media (width <= 991px){.atcb-button-wrapper,.atcb-list,.atcb-modal-box{font-size:var(--base-font-size-m)}}@media (width <= 575px){.atcb-button-wrapper,.atcb-list,.atcb-modal-box{font-size:var(--base-font-size-s)}}.atcb-button-wrapper{display:block;padding:var(--wrapper-padding);position:relative}.atcb-button,.atcb-subevent-btn{display:flex;align-items:flex-start;cursor:pointer;font-family:var(--font);font-size:1em;box-shadow:var(--date-btn-shadow);background-color:var(--date-btn-background);border:0;border-radius:var(--btn-border-radius);padding:0;margin:0;touch-action:manipulation;position:relative;user-select:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent}.atcb-subevent-btn{width:100%}.atcb-button{box-shadow:var(--btn-shadow);min-width:16em;max-width:18em;position:relative;z-index:1}.atcb-rtl .atcb-button{direction:rtl;text-align:right}.atcb-button:focus,.atcb-button:hover{background-color:var(--btn-hover-background);box-shadow:var(--btn-hover-shadow)}.atcb-button:focus-visible,.atcb-subevent-btn:focus-visible{outline:2px solid var(--accent-color)}.atcb-button:not(.atcb-active):hover,.atcb-subevent-btn:hover{align-items:center}.atcb-subevent-btn:focus,.atcb-subevent-btn:hover{background-color:var(--date-btn-hover-background);box-shadow:var(--date-btn-hover-shadow)}.atcb-button.atcb-active:not(.atcb-modal-style,.atcb-dropoverlay){z-index:15000000}.atcb-button.atcb-active.atcb-dropoverlay{z-index:14000090}.atcb-subevent-btn+.atcb-subevent-btn{margin-top:30px}.atcb-date-btn-left{border-radius:var(--btn-border-radius) 0 0 var(--btn-border-radius);align-self:stretch;background-color:var(--date-btn-cal-background);color:var(--date-btn-hover-background);padding:.7em .8em .8em;width:2.7em;align-items:center;display:flex;flex-direction:column;flex-shrink:0}.atcb-rtl .atcb-date-btn-left{border-radius:0 var(--btn-border-radius) var(--btn-border-radius) 0}.atcb-button:hover .atcb-date-btn-left,.atcb-subevent-btn:hover .atcb-date-btn-left{opacity:.8}.atcb-date-btn-day{color:var(--date-btn-cal-day-text);font-weight:400;font-size:2em;word-break:keep-all;padding-bottom:.1em}.atcb-initialized[lang=ja] .atcb-date-btn-day,.atcb-initialized[lang=ko] .atcb-date-btn-day,.atcb-initialized[lang=zh] .atcb-date-btn-day{font-size:1.3em}.atcb-date-btn-month{color:var(--date-btn-cal-month-text);font-weight:600;font-size:1em}.atcb-date-btn-right{position:relative;color:var(--date-btn-text);min-width:13.5em;overflow-wrap:anywhere}.atcb-subevent-btn .atcb-date-btn-right{width:100%}.atcb-date-btn-details{opacity:1;padding:.7em .8em;text-align:left}.atcb-rtl .atcb-date-btn-details{text-align:right}.atcb-date-btn-hover{position:absolute;top:0;left:0;width:100%;opacity:0;height:100%;display:flex;align-items:center;justify-content:center;font-weight:600;font-size:1em;padding:.4em .7em;box-sizing:border-box}.atcb-button:not(.atcb-active):hover .atcb-date-btn-hover,.atcb-subevent-btn:hover .atcb-date-btn-hover{opacity:1}.atcb-button:not(.atcb-active):hover .atcb-date-btn-details,.atcb-subevent-btn:hover .atcb-date-btn-details{opacity:0}.atcb-date-btn-headline{font-weight:600;font-size:.9em;margin-bottom:.5em;overflow:hidden;display:-webkit-box;-webkit-line-clamp:var(--date-btn-headline-line-clamp);line-clamp:var(--date-btn-headline-line-clamp);-webkit-box-orient:vertical}.atcb-date-btn-content{display:flex;align-items:flex-start;font-size:.8em;color:var(--date-btn-text-secondary)}.atcb-date-btn-content.atcb-date-btn-cancelled{color:var(--form-error);font-weight:700}.atcb-date-btn-content-location{overflow:hidden;display:-webkit-box;-webkit-line-clamp:1;line-clamp:1;-webkit-box-orient:vertical;word-break:break-all}.atcb-date-btn-content-icon{display:inline-block;height:.8em;margin-right:.4em;margin-left:0;width:.9em;flex-shrink:0}.atcb-rtl .atcb-date-btn-content-icon{margin-right:0;margin-left:.4em}.atcb-initialized[lang=ja] .atcb-date-btn-content:not(.atcb-date-btn-content-location) .atcb-date-btn-content-icon,.atcb-initialized[lang=ko] .atcb-date-btn-content:not(.atcb-date-btn-content-location) .atcb-date-btn-content-icon,.atcb-initialized[lang=zh] .atcb-date-btn-content:not(.atcb-date-btn-content-location) .atcb-date-btn-content-icon{margin-top:.15em}.atcb-date-btn-content-icon svg{height:100%;fill:currentcolor;width:100%}.atcb-date-btn-content+.atcb-date-btn-content{margin-top:.3em}.atcb-date-btn-content-text span:not(.atcb-icon-ical){padding-right:.3em;display:inline-block}.atcb-icon{flex-grow:0;flex-shrink:0;height:1em;line-height:1em;margin-right:.8em;width:1em}.atcb-rtl .atcb-icon{margin-right:0;margin-left:.8em}.atcb-no-text .atcb-icon{margin-right:0;margin-left:0}.atcb-icon svg{fill:currentcolor;height:100%;width:100%}.atcb-text{overflow-wrap:anywhere}.atcb-dropdown-anchor{bottom:4px;height:1px;width:100%;opacity:0;position:absolute}.atcb-list-wrapper{box-sizing:border-box;font-weight:var(--list-font-weight);padding:0 4px;position:absolute;z-index:14000090}.atcb-list-wrapper.atcb-dropoverlay{z-index:15000000}.atcb-list{border-radius:0 0 var(--btn-border-radius) var(--btn-border-radius);box-sizing:border-box;box-shadow:var(--list-shadow);color:var(--list-text);display:block;font-family:var(--font);min-width:100%;position:relative;user-select:none;-webkit-user-select:none;width:fit-content}.atcb-list-item{align-items:center;background-color:var(--list-background);box-sizing:border-box;cursor:pointer;display:flex;font-size:1em;line-height:1.75em;padding:.8em;text-align:left;touch-action:manipulation;-webkit-tap-highlight-color:transparent}.atcb-rtl .atcb-list-item{direction:rtl;text-align:right}.atcb-list-item:hover{background-color:var(--list-hover-background);color:var(--list-hover-text)}.atcb-list-item:focus-visible{background-color:var(--list-hover-background);color:var(--accent-color);outline:0}.atcb-list-item:last-child{border-radius:0 0 var(--btn-border-radius) var(--btn-border-radius)}.atcb-dropup .atcb-list-item:last-child{border-radius:0;padding-bottom:1.25em}.atcb-dropoverlay .atcb-list .atcb-list-item:first-child,.atcb-dropup .atcb-list-item:first-child,.atcb-list.atcb-modal .atcb-list-item:first-child{border-radius:var(--btn-border-radius) var(--btn-border-radius) 0 0}.atcb-dropoverlay .atcb-list .atcb-list-item:only-child,.atcb-list.atcb-modal .atcb-list-item:only-child{border-radius:var(--btn-border-radius)}.atcb-list.atcb-generated-button:not(.atcb-modal) .atcb-list-item:first-child{padding-top:1.25em}.atcb-dropoverlay .atcb-list.atcb-generated-button:not(.atcb-modal) .atcb-list-item:first-child,.atcb-dropup .atcb-list.atcb-generated-button:not(.atcb-modal) .atcb-list-item:first-child{padding-top:.8em}.atcb-dropoverlay .atcb-list,.atcb-list.atcb-modal{border-radius:var(--btn-border-radius)}.atcb-list.atcb-modal{box-shadow:var(--list-modal-shadow)}.atcb-list-item .atcb-icon{margin:0 auto}.atcb-list-item .atcb-icon+.atcb-text{margin-left:.7em;width:100%}.atcb-rtl .atcb-list-item .atcb-icon+.atcb-text{margin-left:0;margin-right:.7em}.atcb-list-item-close{background-color:var(--list-close-background)}.atcb-list-item.atcb-list-item-close:not(:focus-visible){color:var(--list-close-text)}.atcb-list-item-close svg{fill:currentcolor}.atcb-modal{display:block;margin:auto;width:auto;min-width:auto;position:relative;z-index:14000090}.atcb-modal-box{filter:var(--modal-shadow);color:var(--modal-text);cursor:default;box-sizing:border-box;font-family:var(--font);line-height:1.5em;text-align:var(--modal-text-align);user-select:none;-webkit-user-select:none;touch-action:manipulation;width:100%;margin-bottom:20px;-webkit-tap-highlight-color:transparent}@media (width > 575px){.atcb-modal-box{width:32em}}.atcb-modal-box.atcb-rtl{text-align:var(--modal-text-align-rtl);direction:rtl;padding:1.25em 1em 1.25em 2em}.atcb-modal-icon{height:2.5em;width:2.5em;border-radius:100%;background-color:var(--modal-background);padding:1.75em;margin:auto}.atcb-modal-icon svg{fill:currentcolor;height:100%;width:100%}.atcb-modal-headline{background-color:var(--modal-background);border-radius:var(--btn-border-radius) var(--btn-border-radius) 0 0;font-size:1.3em;font-weight:600;line-height:1.5em;padding:1.8em 1.5em 1.3em;text-transform:var(--modal-headline-text-transform);text-align:var(--modal-headline-text-align)}.atcb-modal-icon+.atcb-modal-headline{margin-top:-2.6em;padding-top:2.6em}.atcb-modal-content{background-color:var(--modal-background);font-size:1em;padding:.3em 2em 2.2em}.atcb-modal-content-subevents{margin:auto;width:fit-content}.atcb-modal-icon+.atcb-modal-content{border-radius:var(--btn-border-radius) var(--btn-border-radius) 0 0;margin-top:-2.6em;padding-top:2.6em}@media (width <= 575px){.atcb-modal-headline{padding:1.8em 1em 1em}.atcb-modal-content{padding:.3em 1.5em 1.5em}.atcb-modal-icon+.atcb-modal-content{padding-top:1.8em}}.atcb-modal-buttons{background-color:var(--modal-btn-bar);border-radius:0 0 var(--btn-border-radius) var(--btn-border-radius);box-sizing:border-box;padding:.6em;text-align:center;width:100%;display:flex;justify-content:center;flex-flow:row-reverse wrap;align-items:center}a.atcb-modal-btn,button.atcb-modal-btn{background-color:var(--modal-btn-secondary-background);border:0;border-radius:var(--btn-border-radius);box-shadow:var(--modal-btn-shadow);color:var(--modal-btn-secondary-text);cursor:pointer;display:inline-block;font-family:var(--font);font-size:.9em;font-weight:var(--modal-btn-font-weight);line-height:1em;margin:.625em;padding:1em 1.25em;position:relative;text-align:center;text-decoration:none;touch-action:manipulation;user-select:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent}a.atcb-modal-btn.btn-small,button.atcb-modal-btn.btn-small{padding:.6em .8em}a.atcb-modal-btn.atcb-modal-btn-primary,button.atcb-modal-btn.atcb-modal-btn-primary{background-color:var(--modal-btn-background);color:var(--modal-btn-text)}a.atcb-modal-btn.atcb-modal-btn-border,button.atcb-modal-btn.atcb-modal-btn-border{border:1px solid var(--modal-btn-border)}a.atcb-modal-btn:focus-visible,button.atcb-modal-btn:focus-visible{background-color:var(--modal-btn-hover-background);outline:2px solid var(--accent-color)}a.atcb-modal-btn:disabled,button.atcb-button:disabled,button.atcb-modal-btn:disabled,button.atcb-subevent-btn:disabled{cursor:not-allowed;opacity:.75;filter:brightness(95%);border-style:dashed;box-shadow:none}a.atcb-modal-btn:not([disabled]):hover,button.atcb-modal-btn:not([disabled]):hover{background-color:var(--modal-btn-hover-background);box-shadow:var(--modal-btn-hover-shadow);color:var(--modal-btn-hover-text);text-decoration:none}.atcb-checkmark{display:none}.atcb-saved .atcb-checkmark{box-sizing:content-box;color:var(--btn-text);display:block;position:absolute;top:-.9em;right:-.5em;padding:.5em;border-radius:100%;height:1.2em}.atcb-checkmark svg{height:100%;filter:var(--checkmark-background);width:auto}#atcb-bgoverlay{backdrop-filter:blur(2px);-webkit-backdrop-filter:blur(2px);background-color:var(--overlay-background);border:0;box-sizing:border-box;display:flex;height:calc(100vh + 100px);inset-inline:0;left:0;right:0;top:0;min-height:100%;min-width:100%;overflow-y:auto;padding:20px 20px 130px;position:fixed;width:100vw;z-index:14000000}#atcb-bgoverlay:not(dialog){animation:atcb-bgoverlay-animate .2s ease 0s 1 normal forwards;opacity:0}#atcb-bgoverlay.atcb-no-bg{animation:none;backdrop-filter:none;-webkit-backdrop-filter:none;opacity:1;background-color:transparent}@keyframes atcb-bgoverlay-animate{0%{opacity:0}100%{opacity:1}}#atcb-bgoverlay.atcb-click:hover{cursor:var(--overlay-cursor)}.atcb-icon-outlookcom,.atcb-icon.atcb-icon-ms365{padding-bottom:.05em}.atcb-icon.atcb-icon-apple,.atcb-icon.atcb-icon-ical{padding-bottom:.15em}.atcb-icon.atcb-icon-apple svg{fill:currentcolor}.atcb-icon.atcb-icon-ical svg{fill:currentcolor}.atcb-icon.atcb-icon-ms365 svg{fill:var(--icon-ms365-color)}.atcb-icon.atcb-icon-yahoo svg{fill:var(--icon-yahoo-color)}.atcb-icon.atcb-icon-google svg,.atcb-icon.atcb-icon-msteams svg,.atcb-icon.atcb-icon-outlookcom svg{filter:var(--icon-filter)}.pro{text-align:center}.pro ol,.pro ul{margin:auto;text-align:left;width:fit-content}.pro a:not(.atcb-modal-btn),.pro a:not(.atcb-modal-btn):active,.pro a:not(.atcb-modal-btn):visited{color:var(--modal-btn-text);text-decoration:underline;text-decoration-thickness:2px;text-decoration-color:var(--accent-color)}.pro a:not(.atcb-modal-btn):hover{color:var(--accent-color);text-decoration:none}.pro .pro-share-buttons{display:flex;flex-wrap:wrap;justify-content:center}.pro-form{border-top:1px solid var(--modal-btn-border);margin-top:1.5em;padding-top:1.5em;text-align:left}.pro-field+.pro-field{padding-top:1.3em}.pro-field-type-label+.pro-field-type-radio{padding-top:0}.pro-field-type-checkbox,.pro-field-type-radio div{align-items:center;display:flex}.pro-field-type-checkbox input,.pro-field-type-radio input{cursor:pointer}.pro-field label{display:block;font-size:.9em;opacity:.7}.pro-field-type-checkbox label,.pro-field-type-radio label{cursor:pointer;opacity:.8;padding-left:.3em}.pro-field input[type=email],.pro-field input[type=number],.pro-field input[type=text]{background-color:var(--input-background);border:1px solid var(--modal-btn-border);border-radius:var(--input-border-radius);box-sizing:border-box;caret-color:var(--accent-color);color:var(--modal-text);font-size:.9em;opacity:.8;padding:.7em;transition:all .1s ease-in-out;width:100%}.pro-field input[type=checkbox],.pro-field input[type=radio]{accent-color:var(--accent-color);height:1.2rem;opacity:.8;transition:all .1s ease-in-out;width:1.2em}.pro-field input:disabled,.pro-field input:disabled+label{cursor:not-allowed;opacity:.75;filter:brightness(95%)}.pro-field input:not([disabled]):hover{opacity:1}.pro-field input[type=email]:focus,.pro-field input[type=number]:focus,.pro-field input[type=text]:focus{border-color:var(--accent-color);outline:1px solid var(--accent-color)}.pro-field input[type=checkbox]:focus,.pro-field input[type=radio]:focus{outline-color:var(--accent-color);outline-width:2px}#submit-error{color:var(--form-error);display:none;font-weight:700;padding-top:1.5em;text-align:center}.pro-form.form-error #submit-error{display:block}.pro-field input.error{accent-color:var(--form-error);border:2px solid var(--form-error)}.pro-field input.error+label,.pro-field:has(input.error) label{color:var(--form-error);opacity:1}#ty-success-msg{display:none;font-weight:700;line-height:1.6em;padding:1.5em 0;text-align:center}#pro-form-submit{display:block;margin:auto;min-width:150px}.pro-form-fine{font-size:.8em;margin:.5em auto 1em;opacity:.5;text-align:center}.pro-form.form-error .pro-form-fine{opacity:0}.pro-waiting{background-color:var(--modal-btn-background);border:1px solid var(--modal-btn-border);border-radius:var(--btn-border-radius);box-sizing:border-box;color:var(--modal-btn-text);cursor:wait;display:none;line-height:.5em;margin:auto;min-width:150px;padding:.5em 1.25em 1.2em;text-align:center;user-select:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent;width:fit-content}@media (width > 575px){#pro-form-submit,.pro-waiting{min-width:200px}}.pro-waiting span:not(.atcb-icon-ical){animation-name:blink;animation-duration:1s;animation-iteration-count:infinite;animation-fill-mode:both;font-size:2.5em}.pro-field label span:not(.atcb-icon-ical){color:var(--form-error);font-weight:700;padding-left:2px}.pro-waiting span:not(.atcb-icon-ical):nth-child(2){animation-delay:.15s}.pro-waiting span:not(.atcb-icon-ical):nth-child(3){animation-delay:.3s}@keyframes blink{0%{opacity:.2}20%{opacity:1}100%{opacity:.2}}.atcb-modal-content .pro p:not(.pro-form-fine){margin:0}.atcb-modal-content .pro p.pro-pt{margin-top:1.5em}.atcb-modal-content .pro .pro-field p{font-size:.9em}.pro .btn-flex{align-items:center;display:flex}.pro .atcb-modal-btn svg{fill:none;height:1.5em;margin-right:.5em;stroke:currentcolor;width:auto}#atcb-reference{box-sizing:border-box;filter:drop-shadow(0 0 3px rgba(255 255 255 / 80%));height:auto;padding:8px 0;text-align:center;transform:translate3d(0,0,0);width:100%;z-index:15000000}#atcb-reference.fixed-ref{position:fixed;bottom:10px;right:40px;width:auto}#atcb-reference.atcb-dropup{position:absolute;margin-top:-1px}.atcb-modal-host-initialized #atcb-reference.atcb-dropup{text-align:left}:host(.atcb-dark) #atcb-reference{filter:drop-shadow(0 0 5px #000)}#atcb-reference a,#atcb-reference a:active,#atcb-reference a:visited{opacity:.4;width:150px;max-width:100%;margin:auto;display:inline-block;text-decoration:none}#atcb-reference.fixed-ref a{opacity:.6}#atcb-reference a:hover{opacity:.9;text-decoration:none}#atcb-reference svg{fill:var(--list-text)}`
}, Ii = () => !(typeof window > "u"), Nn = Ii() ? () => !!(/iPad|iPhone|iPod/i.test(navigator.userAgent) && !/MSStream/i.test(navigator.userAgent)) : () => !1, Ki = Ii() ? () => !!(/android/i.test(navigator.userAgent) && !/MSStream/i.test(navigator.userAgent)) : () => !1, Rl = Ii() ? () => !!/^(?:(?!chrome|android|crios|fxios).)*safari/i.test(navigator.userAgent) : () => !1, Br = () => !!(Ki() || Nn()), X0 = Ii() ? () => !!/; ?wv|(?:iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(navigator.userAgent) : () => !1, uP = Ii() ? () => !!/Instagram/i.test(navigator.userAgent) : () => !1, nf = X0() ? "_system" : "_blank", dP = ["apple", "google", "ical", "ms365", "outlookcom", "msteams", "yahoo"], hP = ["apple", "google", "ical"], fP = ["msteams"], pP = ["ical"], mP = ["apple"], Ft = [], tu = [
  "debug",
  "proOverride",
  "cspnonce",
  "identifier",
  "name",
  "dates",
  "description",
  "startDate",
  "startTime",
  "endDate",
  "endTime",
  "timeZone",
  "useUserTZ",
  "location",
  "status",
  "uid",
  "organizer",
  "attendee",
  "icsFile",
  "images",
  "recurrence",
  "recurrence_until",
  "recurrence_byDay",
  "recurrence_byMonth",
  "recurrence_byMonthDay",
  "recurrence_weekstart",
  "sequence",
  "recurrence_interval",
  "recurrence_count",
  "availability",
  "created",
  "updated",
  "subscribe",
  "options",
  "optionsMobile",
  "optionsIOS",
  "iCalFileName",
  "listStyle",
  "buttonStyle",
  "trigger",
  "hideIconButton",
  "hideIconList",
  "hideIconModal",
  "hideTextLabelButton",
  "hideTextLabelList",
  "buttonsList",
  "hideBackground",
  "hideCheckmark",
  "hideBranding",
  "size",
  "label",
  "inline",
  "inlineRsvp",
  "customLabels",
  "customCss",
  "lightMode",
  "language",
  "hideRichData",
  "bypassWebViewCheck",
  "blockInteraction",
  "styleLight",
  "styleDark",
  "disabled",
  "hidden",
  "hideButton",
  "pastDateHandling",
  "proxy",
  "fakeMobile",
  "fakeIOS",
  "fakeAndroid",
  "forceOverlay",
  "rsvp",
  "ty",
  "customVar",
  "domain",
  "dev"
], Z0 = [
  "debug",
  "proOverride",
  "cspnonce",
  "attendee",
  "images",
  "size",
  "inline",
  "inlineRsvp",
  "customLabels",
  "customCss",
  "lightMode",
  "language",
  "bypassWebViewCheck",
  "blockInteraction",
  "styleLight",
  "styleDark",
  "disabled",
  "hidden",
  "fakeMobile",
  "fakeIOS",
  "fakeAndroid",
  "forceOverlay",
  "customVar",
  "proxy",
  "domain",
  "dev"
], K0 = [
  "debug",
  "proOverride",
  "useUserTZ",
  "hideIconButton",
  "hideIconList",
  "hideIconModal",
  "hideTextLabelButton",
  "hideTextLabelList",
  "subscribe",
  "hideBackground",
  "hideCheckmark",
  "hideBranding",
  "inlineRsvp",
  "hideRichData",
  "buttonsList",
  "inline",
  "bypassWebViewCheck",
  "blockInteraction",
  "disabled",
  "hidden",
  "hideButton",
  "proxy",
  "fakeMobile",
  "fakeIOS",
  "fakeAndroid",
  "forceOverlay",
  "dev"
], gP = ["customLabels", "ty", "rsvp", "customVar"], bP = ["dates"], vP = ["images", "options", "optionsMobile", "optionsIOS"], yP = ["sequence", "recurrence_interval", "recurrence_count"], vs = {
  trigger: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200.016"><path d="M132.829 7.699c0-4.248 4.199-7.699 9.391-7.699s9.391 3.451 9.391 7.699v33.724c0 4.248-4.199 7.699-9.391 7.699s-9.391-3.451-9.391-7.699zm-5.941 123.747c2.979 0 5.404 2.425 5.404 5.404s-2.425 5.404-5.404 5.404l-21.077-.065-.065 21.045c0 2.979-2.425 5.404-5.404 5.404s-5.404-2.425-5.404-5.404l.065-21.061-21.045-.081c-2.979 0-5.404-2.425-5.404-5.404s2.425-5.404 5.404-5.404l21.061.065.065-21.045c0-2.979 2.425-5.404 5.404-5.404s5.404 2.425 5.404 5.404l-.065 21.077 21.061.065zM48.193 7.699C48.193 3.451 52.393 0 57.585 0s9.391 3.451 9.391 7.699v33.724c0 4.248-4.199 7.699-9.391 7.699s-9.391-3.451-9.391-7.699zM10.417 73.763h179.167V34.945c0-1.302-.537-2.49-1.4-3.369-.863-.863-2.051-1.4-3.369-1.4h-17.171c-2.881 0-5.208-2.327-5.208-5.208s2.327-5.208 5.208-5.208h17.171c4.183 0 7.975 1.709 10.726 4.46S200 30.762 200 34.945v44.043 105.843c0 4.183-1.709 7.975-4.46 10.726s-6.543 4.46-10.726 4.46H15.186c-4.183 0-7.975-1.709-10.726-4.46C1.709 192.79 0 188.997 0 184.814V78.988 34.945c0-4.183 1.709-7.975 4.46-10.726s6.543-4.46 10.726-4.46h18.343c2.881 0 5.208 2.327 5.208 5.208s-2.327 5.208-5.208 5.208H15.186c-1.302 0-2.49.537-3.369 1.4-.863.863-1.4 2.051-1.4 3.369zm179.167 10.433H10.417v100.618c0 1.302.537 2.49 1.4 3.369.863.863 2.051 1.4 3.369 1.4h169.629c1.302 0 2.49-.537 3.369-1.4.863-.863 1.4-2.051 1.4-3.369zM82.08 30.176c-2.881 0-5.208-2.327-5.208-5.208s2.327-5.208 5.208-5.208h34.977c2.881 0 5.208 2.327 5.208 5.208s-2.327 5.208-5.208 5.208z"/></svg>',
  apple: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 245.657"><path d="M167.084 130.514c-.308-31.099 25.364-46.022 26.511-46.761-14.429-21.107-36.91-24.008-44.921-24.335-19.13-1.931-37.323 11.27-47.042 11.27-9.692 0-24.67-10.98-40.532-10.689-20.849.308-40.07 12.126-50.818 30.799-21.661 37.581-5.54 93.281 15.572 123.754 10.313 14.923 22.612 31.688 38.764 31.089 15.549-.612 21.433-10.073 40.242-10.073s24.086 10.073 40.546 9.751c16.737-.308 27.34-15.214 37.585-30.187 11.855-17.318 16.714-34.064 17.009-34.925-.372-.168-32.635-12.525-32.962-49.68l.045-.013zm-30.917-91.287C144.735 28.832 150.524 14.402 148.942 0c-12.344.503-27.313 8.228-36.176 18.609-7.956 9.216-14.906 23.904-13.047 38.011 13.786 1.075 27.862-7.004 36.434-17.376z"/></svg>',
  google: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><path d="M152.637 47.363H47.363v105.273h105.273z" fill="#fff"/><path d="M152.637 200L200 152.637h-47.363z" fill="#f72a25"/><path d="M200 47.363h-47.363v105.273H200z" fill="#fbbc04"/><path d="M152.637 152.637H47.363V200h105.273z" fill="#34a853"/><path d="M0 152.637v31.576A15.788 15.788 0 0 0 15.788 200h31.576v-47.363z" fill="#188038"/><path d="M200 47.363V15.788A15.79 15.79 0 0 0 184.212 0h-31.575v47.363z" fill="#1967d2"/><path d="M15.788 0A15.79 15.79 0 0 0 0 15.788v136.849h47.363V47.363h105.274V0z" fill="#4285f4"/><path d="M68.962 129.02c-3.939-2.653-6.657-6.543-8.138-11.67l9.131-3.76c.83 3.158 2.279 5.599 4.346 7.341 2.051 1.742 4.557 2.588 7.471 2.588 2.995 0 5.55-.911 7.699-2.718 2.148-1.823 3.223-4.134 3.223-6.934 0-2.865-1.139-5.208-3.402-7.031s-5.111-2.718-8.496-2.718h-5.273v-9.033h4.736c2.913 0 5.387-.781 7.389-2.376 2.002-1.579 2.995-3.743 2.995-6.494 0-2.441-.895-4.395-2.686-5.859s-4.053-2.197-6.803-2.197c-2.686 0-4.818.716-6.396 2.148s-2.767 3.255-3.451 5.273l-9.033-3.76c1.204-3.402 3.402-6.396 6.624-8.984s7.34-3.89 12.337-3.89c3.695 0 7.031.716 9.977 2.148s5.257 3.418 6.934 5.941c1.676 2.539 2.507 5.387 2.507 8.545 0 3.223-.781 5.941-2.327 8.187-1.546 2.23-3.467 3.955-5.729 5.143v.537a17.39 17.39 0 0 1 7.34 5.729c1.904 2.572 2.865 5.632 2.865 9.212s-.911 6.771-2.718 9.57c-1.823 2.799-4.329 5.013-7.52 6.624s-6.787 2.425-10.775 2.425c-4.622 0-8.887-1.318-12.826-3.988zm56.087-45.312l-10.026 7.243-5.013-7.601 17.985-12.972h6.901v61.198h-9.847z" fill="#1a73e8"/></svg>',
  ical: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200.016"><path d="M132.829 7.699c0-4.248 4.199-7.699 9.391-7.699s9.391 3.451 9.391 7.699v33.724c0 4.248-4.199 7.699-9.391 7.699s-9.391-3.451-9.391-7.699zm-25.228 161.263c-.553 0-.993-2.327-.993-5.208s.439-5.208.993-5.208h25.7c.553 0 .993 2.327.993 5.208s-.439 5.208-.993 5.208zm-81.803-59.766c-.553 0-.993-2.327-.993-5.208s.439-5.208.993-5.208h25.7c.553 0 .993 2.327.993 5.208s-.439 5.208-.993 5.208zm40.902 0c-.553 0-.993-2.327-.993-5.208s.439-5.208.993-5.208h25.7c.553 0 .993 2.327.993 5.208s-.439 5.208-.993 5.208zm40.902 0c-.553 0-.993-2.327-.993-5.208s.439-5.208.993-5.208h25.7c.553 0 .993 2.327.993 5.208s-.439 5.208-.993 5.208zm40.918 0c-.553 0-.993-2.327-.993-5.208s.439-5.208.993-5.208h25.7c.553 0 .993 2.327.993 5.208s-.439 5.208-.993 5.208zM25.798 139.079c-.553 0-.993-2.327-.993-5.208s.439-5.208.993-5.208h25.7c.553 0 .993 2.327.993 5.208s-.439 5.208-.993 5.208zm40.902 0c-.553 0-.993-2.327-.993-5.208s.439-5.208.993-5.208h25.7c.553 0 .993 2.327.993 5.208s-.439 5.208-.993 5.208zm40.902 0c-.553 0-.993-2.327-.993-5.208s.439-5.208.993-5.208h25.7c.553 0 .993 2.327.993 5.208s-.439 5.208-.993 5.208zm40.918 0c-.553 0-.993-2.327-.993-5.208s.439-5.208.993-5.208h25.7c.553 0 .993 2.327.993 5.208s-.439 5.208-.993 5.208zM25.798 168.962c-.553 0-.993-2.327-.993-5.208s.439-5.208.993-5.208h25.7c.553 0 .993 2.327.993 5.208s-.439 5.208-.993 5.208zm40.902 0c-.553 0-.993-2.327-.993-5.208s.439-5.208.993-5.208h25.7c.553 0 .993 2.327.993 5.208s-.439 5.208-.993 5.208zM48.193 7.699C48.193 3.451 52.393 0 57.585 0s9.391 3.451 9.391 7.699v33.724c0 4.248-4.199 7.699-9.391 7.699s-9.391-3.451-9.391-7.699zM10.417 73.763h179.15V34.945c0-1.302-.537-2.49-1.4-3.369-.863-.863-2.051-1.4-3.369-1.4h-17.155c-2.881 0-5.208-2.327-5.208-5.208s2.327-5.208 5.208-5.208h17.171c4.183 0 7.975 1.709 10.726 4.46S200 30.762 200 34.945v44.043 105.843c0 4.183-1.709 7.975-4.46 10.726s-6.543 4.46-10.726 4.46H15.186c-4.183 0-7.975-1.709-10.726-4.46C1.709 192.79 0 188.997 0 184.814V78.971 34.945c0-4.183 1.709-7.975 4.46-10.726s6.543-4.46 10.726-4.46h18.343c2.881 0 5.208 2.327 5.208 5.208s-2.327 5.208-5.208 5.208H15.186c-1.302 0-2.49.537-3.369 1.4-.863.863-1.4 2.051-1.4 3.369zm179.167 10.433H10.417v100.618c0 1.302.537 2.49 1.4 3.369.863.863 2.051 1.4 3.369 1.4h169.629c1.302 0 2.49-.537 3.369-1.4.863-.863 1.4-2.051 1.4-3.369zM82.08 30.176c-2.881 0-5.208-2.327-5.208-5.208s2.327-5.208 5.208-5.208h34.977c2.881 0 5.208 2.327 5.208 5.208s-2.327 5.208-5.208 5.208z"/></svg>',
  msteams: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 200 186.047"><path d="M195.349 39.535a20.93 20.93 0 1 1-41.86 0 20.93 20.93 0 1 1 41.86 0zm-55.847 30.233h51.66A8.84 8.84 0 0 1 200 78.605v47.056c0 17.938-14.541 32.479-32.479 32.479h0-.154c-17.938.003-32.481-14.537-32.484-32.474v-.005-51.274a4.62 4.62 0 0 1 4.619-4.619z" fill="#5059c9"/><path d="M149.614 69.767H64.34c-4.823.119-8.637 4.122-8.526 8.944v53.67c-.673 28.941 22.223 52.957 51.163 53.665 28.94-.708 51.836-24.725 51.163-53.665v-53.67c.112-4.823-3.703-8.825-8.526-8.944zm-10.079-39.535a30.233 30.233 0 0 1-60.465 0 30.233 30.233 0 0 1 60.465 0z" fill="#7b83eb"/><path opacity=".1" d="M111.628 69.767v75.209c-.023 3.449-2.113 6.547-5.302 7.86-1.015.43-2.107.651-3.209.651H59.907l-1.628-4.651c-1.628-5.337-2.459-10.885-2.465-16.465V78.698c-.112-4.815 3.697-8.811 8.512-8.93z"/><path opacity=".2" d="M106.977 69.767v79.86a8.241 8.241 0 0 1-.651 3.209c-1.313 3.189-4.412 5.279-7.86 5.302H62.093l-2.186-4.651a46.13 46.13 0 0 1-1.628-4.651 56.647 56.647 0 0 1-2.465-16.465V78.698c-.112-4.815 3.697-8.811 8.512-8.93z"/><path opacity=".2" d="M102.326 69.767v70.558a8.58 8.58 0 0 1-8.512 8.512H58.279a56.647 56.647 0 0 1-2.465-16.465V78.698c-.112-4.815 3.697-8.811 8.512-8.93z"/><path opacity=".1" d="M111.628 45.721v14.651l-2.326.093c-.791 0-1.535-.046-2.326-.093-1.57-.104-3.127-.353-4.651-.744a30.233 30.233 0 0 1-20.93-17.767 25.845 25.845 0 0 1-1.488-4.651h23.209c4.693.018 8.494 3.818 8.512 8.512z"/><use xlink:href="#B" opacity=".2" transform="scale(.08973306)"/><path d="M106.977 50.372v10c-1.57-.104-3.127-.353-4.651-.744a30.233 30.233 0 0 1-20.93-17.767h17.07c4.693.018 8.494 3.818 8.512 8.512zm0 19.395v70.558a8.58 8.58 0 0 1-8.512 8.512H58.279a56.647 56.647 0 0 1-2.465-16.465V78.698c-.112-4.815 3.697-8.811 8.512-8.93z" opacity=".2"/><path opacity=".2" d="M102.326 50.372v9.256a30.233 30.233 0 0 1-20.93-17.767h12.419c4.693.018 8.494 3.818 8.512 8.512z"/><linearGradient id="A" gradientUnits="userSpaceOnUse" x1="17.776" y1="35.199" x2="84.55" y2="150.848"><stop offset="0" stop-color="#5a62c3"/><stop offset=".5" stop-color="#4d55bd"/><stop offset="1" stop-color="#3940ab"/></linearGradient><path fill="url(#A)" d="M8.526 41.86H93.8a8.53 8.53 0 0 1 8.526 8.526v85.274a8.53 8.53 0 0 1-8.526 8.526H8.526A8.53 8.53 0 0 1 0 135.66V50.386a8.53 8.53 0 0 1 8.526-8.526z"/><path fill="#fff" d="M73.6 74.316H56.553v46.419h-10.86V74.316H28.726v-9.005H73.6z"/><defs><path id="B" d="M1192.167 561.355v111.442c-17.496-1.161-34.848-3.937-51.833-8.293a336.92 336.92 0 0 1-233.25-198.003h190.228c52.304.198 94.656 42.55 94.855 94.854z"/></defs></svg>',
  ms365: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 239.766"><path d="M200 219.785l-.021-.012V20.591L128.615 0 .322 48.172 0 48.234.016 192.257l43.78-17.134V57.943l84.819-20.279-.012 172.285L.088 192.257l128.515 47.456v.053l71.376-19.753v-.227z"/></svg>',
  outlookcom: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 175"><path d="M178.725 0H71.275A8.775 8.775 0 0 0 62.5 8.775v9.975l60.563 18.75L187.5 18.75V8.775A8.775 8.775 0 0 0 178.725 0z" fill="#0364b8"/><path d="M197.813 96.281c.915-2.878 2.187-5.855 2.187-8.781-.002-1.485-.795-2.857-1.491-3.26l-68.434-38.99a9.37 9.37 0 0 0-9.244-.519c-.312.154-.614.325-.906.512l-67.737 38.6-.025.013-.075.044a4.16 4.16 0 0 0-2.088 3.6c.541 2.971 1.272 5.904 2.188 8.781l71.825 52.532z" fill="#0a2767"/><path d="M150 18.75h-43.75L93.619 37.5l12.631 18.75L150 93.75h37.5v-37.5z" fill="#28a8ea"/><path d="M150 18.75h37.5v37.5H150z" fill="#50d9ff"/><path d="M150 93.75l-43.75-37.5H62.5v37.5l43.75 37.5 67.7 11.05z" fill="#0364b8"/><path d="M106.25 56.25v37.5H150v-37.5zM150 93.75v37.5h37.5v-37.5zm-87.5-75h43.75v37.5H62.5z" fill="#0078d4"/><path d="M62.5 93.75h43.75v37.5H62.5z" fill="#064a8c"/><path d="M126.188 145.113l-73.706-53.75 3.094-5.438 68.181 38.825a3.3 3.3 0 0 0 2.625-.075l68.331-38.937 3.1 5.431z" fill="#0a2767" opacity=".5"/><path d="M197.919 91.106l-.088.05-.019.013-67.738 38.588c-2.736 1.764-6.192 1.979-9.125.569l23.588 31.631 51.588 11.257v-.001c2.434-1.761 3.876-4.583 3.875-7.587V87.5c.001 1.488-.793 2.862-2.081 3.606z" fill="#1490df"/><path d="M200 165.625v-4.613l-62.394-35.55-7.531 4.294a9.356 9.356 0 0 1-9.125.569l23.588 31.631 51.588 11.231v.025a9.362 9.362 0 0 0 3.875-7.588z" opacity=".05"/><path d="M199.688 168.019l-68.394-38.956-1.219.688c-2.734 1.766-6.19 1.984-9.125.575l23.588 31.631 51.587 11.256v.001a9.38 9.38 0 0 0 3.562-5.187z" opacity=".1"/><path d="M51.455 90.721c-.733-.467-1.468-1.795-1.455-3.221v78.125c-.007 5.181 4.194 9.382 9.375 9.375h131.25c1.395-.015 2.614-.366 3.813-.813.638-.258 1.252-.652 1.687-.974z" fill="#28a8ea"/><path d="M112.5 141.669V39.581a8.356 8.356 0 0 0-8.331-8.331H62.687v46.6l-10.5 5.987-.031.012-.075.044A4.162 4.162 0 0 0 50 87.5v.031-.031V150h54.169a8.356 8.356 0 0 0 8.331-8.331z" opacity=".1"/><path d="M106.25 147.919V45.831a8.356 8.356 0 0 0-8.331-8.331H62.687v40.35l-10.5 5.987-.031.012-.075.044A4.162 4.162 0 0 0 50 87.5v.031-.031 68.75h47.919a8.356 8.356 0 0 0 8.331-8.331z" opacity=".2"/><path d="M106.25 135.419V45.831a8.356 8.356 0 0 0-8.331-8.331H62.687v40.35l-10.5 5.987-.031.012-.075.044A4.162 4.162 0 0 0 50 87.5v.031-.031 56.25h47.919a8.356 8.356 0 0 0 8.331-8.331z" opacity=".2"/><path d="M100 135.419V45.831a8.356 8.356 0 0 0-8.331-8.331H62.687v40.35l-10.5 5.987-.031.012-.075.044A4.162 4.162 0 0 0 50 87.5v.031-.031 56.25h41.669a8.356 8.356 0 0 0 8.331-8.331z" opacity=".2"/><path d="M8.331 37.5h83.337A8.331 8.331 0 0 1 100 45.831v83.338a8.331 8.331 0 0 1-8.331 8.331H8.331A8.331 8.331 0 0 1 0 129.169V45.831A8.331 8.331 0 0 1 8.331 37.5z" fill="#0078d4"/><path d="M24.169 71.675a26.131 26.131 0 0 1 10.263-11.337 31.031 31.031 0 0 1 16.313-4.087 28.856 28.856 0 0 1 15.081 3.875 25.875 25.875 0 0 1 9.988 10.831 34.981 34.981 0 0 1 3.5 15.938 36.881 36.881 0 0 1-3.606 16.662 26.494 26.494 0 0 1-10.281 11.213 30 30 0 0 1-15.656 3.981 29.556 29.556 0 0 1-15.425-3.919 26.275 26.275 0 0 1-10.112-10.85 34.119 34.119 0 0 1-3.544-15.744 37.844 37.844 0 0 1 3.481-16.563zm10.938 26.613a16.975 16.975 0 0 0 5.769 7.463 15.069 15.069 0 0 0 9.019 2.719 15.831 15.831 0 0 0 9.631-2.806 16.269 16.269 0 0 0 5.606-7.481 28.913 28.913 0 0 0 1.787-10.406 31.644 31.644 0 0 0-1.687-10.538 16.681 16.681 0 0 0-5.413-7.75 14.919 14.919 0 0 0-9.544-2.956 15.581 15.581 0 0 0-9.231 2.744 17.131 17.131 0 0 0-5.9 7.519 29.85 29.85 0 0 0-.044 21.5z" fill="#fff"/></svg>',
  yahoo: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 177.803"><path d="M0 43.284h38.144l22.211 56.822 22.5-56.822h37.135L64.071 177.803H26.694l15.308-35.645L.001 43.284zm163.235 45.403H121.64L158.558 0 200 .002zm-30.699 8.488c12.762 0 23.108 10.346 23.108 23.106s-10.345 23.106-23.108 23.106a23.11 23.11 0 0 1-23.104-23.106 23.11 23.11 0 0 1 23.104-23.106z"/></svg>',
  close: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><path d="M2.321 13.529a7.927 7.927 0 0 1 0-11.208 7.927 7.927 0 0 1 11.208 0l86.471 86.471L186.47 2.321a7.927 7.927 0 0 1 11.209 0 7.927 7.927 0 0 1 0 11.208l-86.474 86.469 86.472 86.473a7.927 7.927 0 0 1-11.209 11.208l-86.471-86.471-86.469 86.471a7.927 7.927 0 0 1-11.208-11.208l86.471-86.473z"/></svg>',
  location: '<svg viewBox="0 0 200 266.42" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="m148.54 230.43c-12.12 13.291-26.234 25.193-42.083 34.82-1.9513 1.431-4.5964 1.6044-6.7645 0.21681-23.416-14.895-43.08-32.782-58.539-52.23-21.334-26.755-34.755-56.414-39.351-84.99-4.6831-28.966-0.30354-56.848 14.114-79.505 5.6805-8.9543 12.944-17.106 21.79-24.153 20.337-16.196 43.557-24.76 66.713-24.586 22.288 0.17345 44.295 8.4773 63.309 25.844 6.6778 6.0707 12.293 13.03 16.89 20.575 15.502 25.54 18.841 58.105 12.033 91.104-6.7212 32.608-23.416 65.737-48.11 92.839zm-48.544-178.91c27.492 0 49.758 22.288 49.758 49.758 0 27.492-22.288 49.758-49.758 49.758-27.492 0-49.758-22.267-49.758-49.758-0.02168-27.492 22.267-49.758 49.758-49.758z" stroke-width="2.1681"/></svg>',
  warning: '<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg"><path d="m100 0c27.613 0 52.613 11.195 70.711 29.293 18.094 18.094 29.289 43.098 29.289 70.707 0 27.613-11.195 52.613-29.289 70.711-18.098 18.094-43.098 29.289-70.711 29.289-27.609 0-52.613-11.195-70.707-29.289-18.098-18.098-29.293-43.098-29.293-70.711 0-27.609 11.195-52.613 29.293-70.707 18.094-18.098 43.098-29.293 70.707-29.293zm57.66 42.34c-14.758-14.754-35.145-23.883-57.66-23.883-22.516 0-42.902 9.1289-57.66 23.883-14.754 14.758-23.883 35.145-23.883 57.66 0 22.516 9.1289 42.902 23.883 57.66 14.758 14.754 35.145 23.883 57.66 23.883 22.516 0 42.902-9.1289 57.66-23.883 14.754-14.758 23.883-35.145 23.883-57.66 0-22.516-9.1289-42.902-23.883-57.66z" fill="#f44336" fill-rule="nonzero" stroke-width=".39062"/><g transform="matrix(3.8384 0 0 3.8384 2277.8 -576.85)" style="shape-inside:url(#rect7396);white-space:pre" aria-label="!"><path d="m-563.8 161.59-0.65341 20.185h-5.8381l-0.65341-20.185zm-3.5796 29.503q-1.5199 0-2.6136-1.0795-1.0796-1.0796-1.0796-2.6136 0-1.5057 1.0796-2.571 1.0938-1.0796 2.6136-1.0796 1.4631 0 2.571 1.0796 1.1222 1.0653 1.1222 2.571 0 1.0227-0.52557 1.8608-0.51137 0.83807-1.3494 1.3352-0.82387 0.49715-1.8182 0.49715z"/></g></svg>',
  checkmark: '<svg version="1.1" viewBox="0 0 87.41 79.72" xmlns="http://www.w3.org/2000/svg"><path d="m2.076 33.666s6.0748-0.59297 17.413 4.2983c9.3883 4.5751 11.891 8.3955 11.891 8.3955 5.38-8.65 11.11-16.6 17.16-23.9 10.412-12.578 24.613-22.448 24.613-22.448l14.257-0.012228s-19.308 19.294-32.483 38.51-22.877 41.21-22.877 41.21-9.3948-18.164-14.53-24.53-10.77-11.59-17.52-16.22z" fill="#45b555"/></svg>',
  rsvp: '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 104.31 122.88"><g><path d="M25.85,63.15c-0.04-0.12-0.08-0.28-0.1-0.42c-0.22-1.89-0.43-3.98-0.62-5.78c-0.26-2.64-0.55-5.69-0.76-7.83 c-0.14-1.45-0.6-2.83-1.27-3.86c-0.45-0.66-0.95-1.15-1.51-1.39c-0.45-0.18-1-0.2-1.57,0.02c-0.78,0.3-1.65,0.93-2.62,2.03 c-0.86,0.98-1.53,2.29-2.09,3.68c-0.79,2.03-1.26,4.19-1.45,5.67c-0.02,0.1-0.02,0.18-0.06,0.26L8.42,86.07 c-0.08,0.4-0.24,0.76-0.48,1.04c-1.81,2.33-2.95,4.33-3.28,5.95c-0.24,1.19,0,2.15,0.79,2.9l19.8,19.8 c1.26,1.21,2.72,1.97,4.47,2.29c1.91,0.36,4.14,0.16,6.7-0.54c0.04,0,0.1-0.02,0.14-0.02c0.97-0.26,2.24-0.57,3.46-0.88 c5.31-1.29,9.94-2.43,14.23-6.33l5.52-5.76c0.05-0.1,0.14-0.18,0.22-0.26s0.62-0.62,1.35-1.31c3.78-3.69,8.45-8.25,5.61-12.24 l-2.21-2.21c-1.07,1.04-2.21,2.05-3.3,3.02c-1,0.88-1.93,1.69-2.78,2.55c-0.91,0.91-2.38,0.91-3.3,0c-0.91-0.92-0.91-2.38,0-3.3 c0.86-0.86,1.91-1.79,3-2.76c3.74-3.3,8.03-7.07,5.73-10.38l-2.19-2.19c-0.12-0.12-0.22-0.26-0.31-0.4c-1.26,1.29-2.64,2.52-4,3.72 c-1,0.88-1.93,1.69-2.78,2.55c-0.91,0.91-2.38,0.91-3.3,0s-0.91-2.38,0-3.3c0.86-0.86,1.91-1.79,3-2.76 c3.74-3.3,8.03-7.07,5.73-10.38l-2.19-2.19c-0.16-0.16-0.28-0.31-0.38-0.5l-6.42,6.42c-0.91,0.91-2.38,0.91-3.3,0s-0.91-2.38,0-3.3 l17.22-17.25c2.88-2.88,3.54-5.88,2.78-8.15c-0.28-0.83-0.74-1.57-1.31-2.14s-1.31-1.03-2.14-1.31c-2.24-0.74-5.23-0.06-8.19,2.9 l-30.2,30.2c-0.91,0.91-2.38,0.91-3.3,0s-0.91-2.38,0-3.3l3.07-3.07L25.85,63.15L25.85,63.15L25.85,63.15z M83.23,24.31 c-1.22,1.3-3.24,1.34-4.52,0.14c-1.3-1.22-1.34-3.24-0.14-4.52l8.82-9.39c1.22-1.3,3.25-1.34,4.52-0.14 c1.3,1.22,1.34,3.24,0.14,4.52L83.23,24.31L83.23,24.31L83.23,24.31L83.23,24.31z M43.96,23.65c1.3,1.22,1.34,3.25,0.14,4.52 c-1.22,1.3-3.25,1.34-4.52,0.14l-9.4-8.82c-1.29-1.23-1.33-3.25-0.14-4.52c1.22-1.3,3.25-1.34,4.52-0.14L43.96,23.65L43.96,23.65 L43.96,23.65z M63.69,15.96c0.05,1.76-1.34,3.24-3.09,3.3s-3.24-1.34-3.3-3.09L56.91,3.3c-0.06-1.75,1.34-3.24,3.09-3.3 c1.76-0.05,3.24,1.34,3.29,3.09L63.69,15.96L63.69,15.96L63.69,15.96z M76.88,63.31c-1.3-1.22-1.34-3.25-0.14-4.52 c1.22-1.3,3.24-1.34,4.52-0.14l9.39,8.82c1.3,1.22,1.34,3.24,0.14,4.52c-1.22,1.3-3.24,1.34-4.52,0.14L76.88,63.31L76.88,63.31 L76.88,63.31z M88.36,44.35c-1.75,0.06-3.24-1.34-3.3-3.09c-0.05-1.75,1.34-3.24,3.09-3.3l12.86-0.43c1.75-0.06,3.24,1.34,3.3,3.09 s-1.34,3.24-3.09,3.3L88.36,44.35L88.36,44.35L88.36,44.35z M60.88,58.97c0.17,0.1,0.34,0.22,0.5,0.38l2.29,2.29 c0.12,0.12,0.24,0.28,0.34,0.42c2.57,3.52,2.17,6.66,0.42,9.52c0.31,0.12,0.62,0.29,0.86,0.54l2.29,2.29 c0.12,0.12,0.24,0.28,0.34,0.42c2.76,3.8,2.07,7.12,0,10.14c0.1,0.05,0.17,0.14,0.28,0.24l2.29,2.29c0.12,0.12,0.24,0.28,0.34,0.42 c5.31,7.26-1.02,13.42-6.1,18.39l-1.31,1.31l-5.67,5.95l-0.18,0.17c-5.19,4.71-10.33,5.97-16.28,7.42c-1,0.24-2,0.5-3.4,0.86 c-0.04,0-0.06,0.02-0.1,0.02c-3.22,0.88-6.14,1.09-8.76,0.62c-2.66-0.48-4.97-1.67-6.9-3.56L2.31,99.29 c-2-1.93-2.69-4.31-2.12-7.14c0.43-2.26,1.75-4.77,3.81-7.47L9.3,54.74v-0.12c0.24-1.71,0.78-4.24,1.71-6.68 c0.71-1.83,1.67-3.62,2.92-5.07c1.51-1.71,3-2.76,4.47-3.32c1.81-0.69,3.54-0.6,5.07,0.06c1.43,0.6,2.64,1.69,3.56,3.08 c1.12,1.67,1.85,3.8,2.05,6.02c0.16,1.83,0.48,4.85,0.78,7.81l0.24,2.47L53,36.07c4.4-4.4,9.16-5.27,12.97-4.02 c1.53,0.5,2.88,1.33,4,2.45s1.95,2.47,2.45,4c1.26,3.8,0.4,8.63-3.92,12.95l-7.59,7.59L60.88,58.97L60.88,58.97L60.88,58.97z"/></g></svg>'
};
async function J2(t) {
  return t = _P(t), t.timeZone = ev(t.timeZone), t = TP(t), t = xP(t), t = wP(t), t.sizes = kP(t.size), t.lightMode = CP(t.lightMode), t = SP(t), t = tv(t), t = AP(t), t = LP(t), t = IP(t), t = await MP(t), t;
}
function _P(t) {
  for (let e = 0; e < K0.length; e++) {
    const n = K0[`${e}`];
    if (t[`${n}`]) {
      if (typeof t[`${n}`] != "boolean") {
        const a = t[`${n}`].toString().trim().toLowerCase() || "";
        t[`${n}`] = a === "" || a === "true";
      }
    } else
      t[`${n}`] = !1;
  }
  return t;
}
function ev(t = null) {
  return !t || t === "" ? "GMT" : t;
}
function TP(t) {
  if (t.recurrence && t.recurrence !== "")
    if (t.recurrence = t.recurrence.replace(/\s+/g, "").toUpperCase(), !/^(?:RRULE:[\w=;,:+\-/\\]+|daily|weekly|monthly|yearly)$/im.test(t.recurrence))
      t.recurrence = "!wrong rrule format!";
    else if (/^RRULE:/i.test(t.recurrence)) {
      t.recurrence_simplyfied = !1;
      const e = t.recurrence.substring(6).split(";"), n = new Object();
      e.forEach(function(a) {
        n[a.split("=")[0]] = a.split("=")[1];
      }), t.recurrence_until = n.UNTIL ? n.UNTIL : "", t.recurrence_count = n.COUNT ? n.COUNT : "", t.recurrence_byDay = n.BYDAY ? n.BYDAY : "", t.recurrence_byMonth = n.BYMONTH ? n.BYMONTH : "", t.recurrence_byMonthDay = n.BYMONTHDAY ? n.BYMONTHDAY : "", t.recurrence_interval = n.INTERVAL ? n.INTERVAL : 1, t.recurrence_frequency = n.FREQ ? n.FREQ : "";
    } else
      t.recurrence_simplyfied = !0, (!t.recurrence_interval || t.recurrence_interval === "") && (t.recurrence_interval = 1), (!t.recurrence_weekstart || t.recurrence_weekstart === "" | t.recurrence_weekstart.length > 2) && (t.recurrence_weekstart = "MO"), t.recurrence_frequency = t.recurrence, t.recurrence = "RRULE:FREQ=" + t.recurrence + ";WKST=" + t.recurrence_weekstart + ";INTERVAL=" + t.recurrence_interval, t.recurrence_until && t.recurrence_until !== "" && (t.endTime && t.endTime !== "" ? t.recurrence = t.recurrence + ";UNTIL=" + t.recurrence_until.replace(/-/g, "").slice(0, 8) + "T" + t.endTime.replace(":", "") + "00" : t.recurrence = t.recurrence + ";UNTIL=" + t.recurrence_until.replace(/-/g, "").slice(0, 8)), t.recurrence_count && t.recurrence_count !== "" && (t.recurrence = t.recurrence + ";COUNT=" + t.recurrence_count), t.recurrence_byDay && t.recurrence_byDay !== "" && (t.recurrence = t.recurrence + ";BYDAY=" + t.recurrence_byDay), t.recurrence_byMonth && t.recurrence_byMonth !== "" && (t.recurrence = t.recurrence + ";BYMONTH=" + t.recurrence_byMonth), t.recurrence_byMonthDay && t.recurrence_byMonthDay !== "" && (t.recurrence = t.recurrence + ";BYMONTHDAY=" + t.recurrence_byMonthDay);
  return t;
}
function xP(t) {
  const e = function() {
    if (Nn() || t.fakeIOS) {
      if (t.optionsIOS && t.optionsIOS.length > 0)
        return t.optionsIOS;
      if (t.optionsMobile && t.optionsMobile.length > 0)
        return t.optionsMobile;
    }
    return (Ki() || t.fakeMobile || t.fakeAndroid) && t.optionsMobile && t.optionsMobile.length > 0 ? t.optionsMobile : t.options || ["ical"];
  }();
  let n = [], a = !1, i = !1;
  for (let r = 0; r < e.length; r++) {
    const o = e[`${r}`].split("|")[0].toLowerCase().replace("microsoft", "ms").replace(/\./, "");
    o === "apple" && (i = !0), o === "ical" && (a = !0), !((Nn() || t.fakeIOS) && pP.includes(o) || (Ki() || t.fakeAndroid) && mP.includes(o) || t.recurrence && t.recurrence !== "" && (!hP.includes(o) || t.recurrence_until && t.recurrence_until !== "" && (o === "apple" || o === "ical") || (Nn() || t.fakeIOS) && o === "google") || t.subscribe && fP.includes(o)) && ((Br() || t.fakeMobile) && t.subscribe && (o === "ms365" || o === "outlookcom") || n.push(o));
  }
  return t.subscribe && t.icsFile && t.icsFile.startsWith("https://calendar.google.com/calendar/") && !t.icsFile.endsWith(".ics") && (n = ["google"]), n.length === 0 && (!Nn() && !t.fakeIOS && n.push("ical"), a = !0), (Nn() || t.fakeIOS) && a && !i && n.push("apple"), (Ki() || t.fakeAndroid) && i && !a && n.push("ical"), t.options = n, t;
}
function wP(t) {
  return t.inlineRSVP && (t.inline = !0), (!t.listStyle || t.listStyle === "") && (t.listStyle = "dropdown"), t.listStyle === "modal" && (t.trigger = "click"), t.buttonStyle && t.buttonStyle !== "" && t.buttonStyle != "default" ? (t.buttonStyle == "round" || t.buttonStyle == "text" || t.buttonStyle == "date" || t.buttonStyle == "neumorphism") && (t.trigger = "click") : t.buttonStyle = "default", (t.buttonStyle == "default" || t.buttonStyle == "3d" || t.buttonStyle == "flat") && !t.hideTextLabelList && t.hideTextLabelButton && (t.listStyle == "dropdown" || t.listStyle == "dropdown-static" || t.listStyle == "dropup-static") && (t.listStyle = "overlay"), t.buttonsList && t.buttonStyle == "date" && (t.buttonsList = !1), t;
}
function kP(t) {
  const e = [];
  if (e.l = e.m = e.s = 16, t && t !== "") {
    const n = t.split("|");
    for (let a = 0; a < n.length; a++)
      n[`${a}`] = parseInt(n[`${a}`]);
    n[0] >= 0 && n[0] < 11 && (e.l = e.m = e.s = 10 + n[0]), n.length > 2 ? (n[1] >= 0 && n[1] < 11 && (e.m = 10 + n[1]), n[2] >= 0 && n[2] < 11 && (e.s = 10 + n[2])) : n.length == 2 && n[1] >= 0 && n[1] < 11 && (e.m = e.s = 10 + n[1]);
  }
  return e;
}
function CP(t = "") {
  return t == "system" && Ii() ? window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light" : t != "bodyScheme" && t != "dark" ? "light" : t;
}
function SP(t) {
  return (!t.language || t.language === "" || !mB.includes(t.language)) && (t.language = "en"), t.language.length > 2 && (t.language = t.language.substring(0, 2)), pB.includes(t.language) ? t.rtl = !0 : t.rtl = !1, t;
}
function tv(t) {
  if (t.dates && t.dates.length > 0)
    for (let n = 0; n < t.dates.length; n++) {
      !t.dates[`${n}`].timeZone && t.timeZone && (t.dates[`${n}`].timeZone = t.timeZone), !t.dates[`${n}`].useUserTZ && t.useUserTZ && (t.dates[`${n}`].useUserTZ = t.useUserTZ);
      const a = e1(t.dates[`${n}`]);
      t.dates[`${n}`].startDate = a.startDate, t.dates[`${n}`].endDate = a.endDate, t.dates[`${n}`].startTime = a.startTime, t.dates[`${n}`].endTime = a.endTime, t.dates[`${n}`].timeZone = a.timeZone, t.dates[`${n}`].timestamp = i0("timestamp", t.dates[`${n}`].startDate, t.dates[`${n}`].startTime, t.dates[`${n}`].timeZone), t.dates[`${n}`].overdue = i0("overdue", t.dates[`${n}`].endDate, t.dates[`${n}`].endTime, t.dates[`${n}`].timeZone);
    }
  else {
    t.dates = [], t.dates[0] = new Object(), t.useUserTZ && (t.dates[0].useUserTZ = t.useUserTZ);
    const n = e1(t);
    t.startDate = t.dates[0].startDate = n.startDate, t.endDate = t.dates[0].endDate = n.endDate, t.startTime = t.dates[0].startTime = n.startTime, t.endTime = t.dates[0].endTime = n.endTime, t.timeZone = t.dates[0].timeZone = n.timeZone, t.recurrence ? t.dates[0].overdue = !1 : t.dates[0].overdue = i0("overdue", t.endDate, t.endTime, t.timeZone);
  }
  const e = /* @__PURE__ */ new Date();
  return (!t.created || t.created === "") && (t.created = la(e, "clean", !0)), (!t.updated || t.updated === "") && (t.updated = la(e, "clean", !0)), t;
}
function AP(t) {
  return (!t.status || t.status === "") && (t.status = "CONFIRMED"), (!t.sequence || t.sequence === "") && (t.sequence = 0), t;
}
function EP(t, e) {
  const n = (i) => i.replace(/(\\r\\n|\\n|\\r|<br(\s*\/?)>)/g, "");
  let a = t.dates[`${e}`].description || t.description || "";
  if (a) {
    if (a = n(a), t.customVar)
      for (const s in t.customVar) {
        const o = "%%" + s.replace(/[^\w\-.]/g, "") + "%%";
        a = a.replace(new RegExp(o, "gi"), t.customVar[`${s}`]);
      }
    const i = _s(a, !0), r = _s(a, !0, !0);
    a = _s(a), t.dates[`${e}`] = { ...t.dates[`${e}`], description: a, descriptionHtmlFree: i, descriptionHtmlFreeICal: r };
  } else
    t.dates[`${e}`].descriptionHtmlFree = t.dates[`${e}`].descriptionHtmlFreeICal = t.dates[`${e}`].description = "";
  return t;
}
function LP(t) {
  for (let e = 0; e < t.dates.length; e++)
    if (t = EP(t, e), (!t.dates[`${e}`].name || t.dates[`${e}`].name === "") && (t.dates[`${e}`].name = t.name), t.dates[`${e}`].status ? t.dates[`${e}`].status = t.dates[`${e}`].status.toUpperCase() : t.dates[`${e}`].status = t.status.toUpperCase(), t.dates[`${e}`].sequence || (t.dates[`${e}`].sequence = t.sequence), !t.dates[`${e}`].organizer && t.organizer && (t.dates[`${e}`].organizer = t.organizer), !t.dates[`${e}`].attendee && t.attendee && (t.dates[`${e}`].attendee = t.attendee), !t.dates[`${e}`].availability && t.availability ? t.dates[`${e}`].availability = t.availability.toLowerCase() : t.dates[`${e}`].availability && (t.dates[`${e}`].availability = t.dates[`${e}`].availability.toLowerCase()), !t.dates[`${e}`].location && t.location && (t.dates[`${e}`].location = t.location), t.dates[`${e}`].location && t.dates[`${e}`].location.startsWith("http") ? t.dates[`${e}`].onlineEvent = !0 : t.dates[`${e}`].onlineEvent = !1, t.dates[`${e}`].uid || (e === 0 && t.uid && t.uid !== "" ? t.dates[0].uid = t.uid : t.uid && t.uid !== "" ? t.dates[`${e}`].uid = t.uid + "-" + (e + 1) : t.dates[`${e}`].uid = hv()), t.customVar)
      for (const n in t.customVar) {
        const a = "%%" + n.replace(/[^\w\-.]/g, "") + "%%";
        t.dates[`${e}`].name = t.dates[`${e}`].name.replace(new RegExp(a, "gi"), t.customVar[`${n}`]), t.dates[`${e}`].location = t.dates[`${e}`].location.replace(new RegExp(a, "gi"), t.customVar[`${n}`]);
      }
  return t.recurrence && t.recurrence !== "" && (t.dates[0].recurrence = t.recurrence), t.dates.length > 1 && t.dates.sort((e, n) => e.timestamp - n.timestamp), t;
}
function e1(t) {
  function e(i) {
    return /^\d\d\d\d-\d\d-\d\d(?:T\d\d:\d\d)?(?::\d\d)?(?:.\d\d\d)?Z?$/i.test(i);
  }
  function n(i) {
    return /^today(?:\+(?:\d|\d\d|\d\d\d|\d\d\d\d))?$/i.test(i);
  }
  if ((!t.endDate || t.endDate === "") && (t.endDate = t.startDate), ["start", "end"].forEach(function(i) {
    const r = t[i + "Date"];
    if (!e(r) && !n(r))
      t[i + "Date"] = "badly-formed";
    else {
      if (n(r) && (t[i + "Date"] = DP(r)), t[i + "Date"]) {
        const s = t[i + "Date"].split("T");
        s[1] && (t[i + "Date"] = s[0], t[i + "Time"] = s[1]);
      }
      t[i + "Time"] && t[i + "Time"].length > 5 && (t[i + "Time"] = t[i + "Time"].substring(0, 5));
    }
  }), t.timeZone === "currentBrowser" || t.useUserTZ) {
    const i = Intl.DateTimeFormat().resolvedOptions().timeZone || "GMT";
    if (t.useUserTZ && t.startTime && t.startTime !== "" && t.endTime && t.endTime !== "") {
      const r = u1(t.startDate, t.startTime, t.timeZone, i), s = u1(t.endDate, t.endTime, t.timeZone, i);
      t.startDate = r[0], t.startTime = r[1], t.endDate = s[0], t.endTime = s[1];
    }
    t.timeZone = i;
  }
  return t;
}
function i0(t, e, n = null, a) {
  try {
    const i = function() {
      if (n) {
        const s = eu(a, e, n);
        return /* @__PURE__ */ new Date(e + " " + n + ":00 GMT" + s);
      }
      return new Date(e);
    }();
    if (t === "timestamp")
      return i.getTime();
    n || i.setDate(i.getDate() + 1);
    const r = (/* @__PURE__ */ new Date()).toISOString();
    return i.getTime() < new Date(r).getTime();
  } catch {
    return !1;
  }
}
function DP(t) {
  const e = /* @__PURE__ */ new Date(), n = e.getUTCFullYear() + "-" + (e.getUTCMonth() + 1) + "-" + e.getUTCDate();
  t = t.replace(/today/gi, n);
  const a = t.split("+"), i = a[0].split("-"), r = new Date(Date.UTC(i[0], i[1] - 1, i[2].substring(0, 2)));
  a[1] && a[1] > 0 && r.setDate(r.getDate() + parseInt(a[1]));
  try {
    return r.toISOString().replace(/T(\d{2}:\d{2}:\d{2}\.\d{3})Z/g, "");
  } catch {
    return !1;
  }
}
function IP(t) {
  return (!t.pastDateHandling || t.pastDateHandling != "disable" && t.pastDateHandling != "hide") && (t.pastDateHandling = "none"), t.allOverdue = function() {
    for (let e = 0; e < t.dates.length; e++)
      if (!t.dates[`${e}`].overdue)
        return !1;
    return !0;
  }(), t.allOverdue && (t.pastDateHandling == "disable" ? t.disabled = !0 : t.pastDateHandling == "hide" && (t.hidden = !0)), t.allCancelled = function() {
    for (let e = 0; e < t.dates.length; e++)
      if (!t.dates[`${e}`].status || t.dates[`${e}`].status.toLowerCase() !== "cancelled")
        return !1;
    return !0;
  }(), (t.disabled || t.hidden) && (t.blockInteraction = !0), t;
}
async function MP(t) {
  if (typeof i1 != "function" || !t.rsvp || !t.proKey || Object.keys(t.rsvp).length === 0) return t;
  if (t.rsvp.expired = function() {
    return !!(t.rsvp && t.rsvp.expires && new Date(t.rsvp.expires) < /* @__PURE__ */ new Date());
  }(), t.rsvp.max) {
    const e = await i1(t.proKey, t.dev);
    t.rsvp.seatsLeft = t.rsvp.max - e, t.rsvp.seatsLeft < 1 && (t.rsvp.bookedOut = !0), (t.rsvp.expired || t.rsvp.bookedOut) && (t.blockInteraction = !0), t.blockInteraction && (t.disabled = !0);
  }
  return t;
}
async function t1(t) {
  if (!t.name || t.name === "")
    throw new Error("Add to Calendar Button generation failed: required name information missing");
  if (t.dates != null && t.dates.length > 0) {
    if (t.subscribe === !0 && t.dates.length > 1)
      throw new Error("Add to Calendar Button generation failed: a subscription calendar cannot be a multi-date setup");
    const e = ["name", "startDate"], n = ["name"];
    return e.every(function(a) {
      for (let i = 0; i < t.dates.length; i++)
        if (!n.includes(`${a}`) && (!t.dates[`${i}`][`${a}`] || t.dates[`${i}`][`${a}`] === "") || n.includes(`${a}`) && (!t.dates[`${i}`][`${a}`] || t.dates[`${i}`][`${a}`] === "") && (!t[`${a}`] || t[`${a}`] === "")) {
          if (!t.subscribe || a !== "startDate")
            throw new Error("Add to Calendar Button generation failed: required setting missing [dates array object #" + (i + 1) + "/" + t.dates.length + "] => [" + a + "]");
          t.dates[`${i}`].startDate = "today";
        }
      return !0;
    });
  } else
    return ["startDate"].every(function(n) {
      if (!t[`${n}`] || t[`${n}`] === "") {
        if (!t.subscribe || n !== "startDate")
          throw new Error("Add to Calendar Button generation failed: required setting missing [" + n + "]");
        t.startDate = "today";
      }
      return !0;
    });
}
async function OP(t) {
  const e = "Add to Calendar Button generation (" + t.identifier + ")";
  try {
    return await nv(t, e), await PP(t, e), await BP(t, e), await RP(t, e), await NP(t, e), await $P(t, e), await FP(t, e), await GP(t, e), t.recurrence_simplyfied && await XP(t, e), !0;
  } catch (n) {
    throw new Error(n.message);
  }
}
async function nv(t, e, n = "", a = "") {
  const i = function() {
    return n !== "" && t.dates[`${n}`].icsFile ? t.dates[`${n}`].icsFile : n === "" && t.icsFile ? t.icsFile : "";
  }();
  if (i !== "" && (!Ds(i, !1) || !t.icsFile.startsWith("https://") && !t.icsFile.startsWith("http://")))
    throw new Error(e + " failed: explicit ics file path not valid" + a);
  return !0;
}
async function PP(t, e) {
  if (!["default", "3d", "flat", "round", "neumorphism", "text", "date", "custom", "none"].includes(t.buttonStyle))
    throw new Error(e + " failed: provided buttonStyle invalid");
  if (t.customCss && t.customCss !== "" && (!Ds(t.customCss, !1) || !/\.css(?:$|\?)/.test(t.customCss)))
    throw new Error(e + " failed: customCss provided, but no valid url");
  if ((!t.customCss || t.customCss === "") && t.buttonStyle === "custom")
    throw new Error(e + ' failed: buttonStyle "custom" selected, but no customCss file provided');
  if (t.rsvp && (t.buttonStyle === "date" || t.buttonStyle === "none"))
    throw new Error(e + " failed: buttonStyle " + t.buttonStyle + " is not compatible with the RSVP functionality");
  return !0;
}
async function BP(t, e) {
  if (t.subscribe === !0 && (!t.icsFile || t.icsFile === ""))
    throw new Error(e + " failed: a subscription calendar requires a valid explicit ics file as well");
  return !0;
}
async function RP(t, e) {
  if (!/^\d{8}T\d{6}Z$/.test(t.created))
    throw new Error(e + " failed: created date format not valid. Needs to be a full ISO-8601 UTC date and time string, formatted YYYYMMDDTHHMMSSZ");
  return !0;
}
async function NP(t, e) {
  if (!/^\d{8}T\d{6}Z$/.test(t.updated))
    throw new Error(e + " failed: updated date format not valid. Needs to be a full ISO-8601 UTC date and time string, formatted YYYYMMDDTHHMMSSZ");
  return !0;
}
async function $P(t, e) {
  return t.options.every((a) => {
    if (!dP.includes(a))
      throw new Error(`${e} failed: invalid option [${a}]`);
    return !0;
  });
}
async function FP(t, e) {
  try {
    for (let n = 0; n < t.dates.length; n++) {
      const a = function() {
        return t.dates.length === 1 ? "" : " [dates array object #" + (n + 1) + "/" + t.dates.length + "] ";
      }();
      await nv(t, e, n, a), await zP(t, e, n, a), await UP(t, e, n, a), await HP(t, e, n, a), await YP(t, e, n, a), await jP(t, e, n, a), await VP(t, e, n, a), await qP(t, e, n, a), await WP(t, e, n, a);
    }
    return !0;
  } catch (n) {
    throw new Error(n.message);
  }
}
async function zP(t, e, n, a) {
  if (!["tentative", "confirmed", "cancelled"].includes(t.dates[`${n}`].status.toLowerCase()))
    throw new Error(e + " failed: event status needs to be TENTATIVE, CONFIRMED, or CANCELLED" + a);
  return !0;
}
async function UP(t, e, n, a) {
  if (t.dates[`${n}`].availability && t.dates[`${n}`].availability !== "" && t.dates[`${n}`].availability !== "free" && t.dates[`${n}`].availability !== "busy")
    throw new Error(e + ' failed: event availability needs to be "free" or "busy"' + a);
  return !0;
}
async function HP(t, e, n, a) {
  if (t.dates[`${n}`].organizer && t.dates[`${n}`].organizer !== "") {
    const i = t.dates[`${n}`].organizer.split("|");
    if (i.length !== 2 || i[0].length > 50 || i[1].length > 100 || !nu(i[1]))
      throw new Error(e + ' failed: organizer needs to match the schema "NAME|EMAIL" with a valid email address' + a);
  }
  return !0;
}
async function YP(t, e, n, a) {
  if (t.dates[`${n}`].attendee && t.dates[`${n}`].attendee !== "") {
    if (!t.dates[`${n}`].organizer || t.dates[`${n}`].organizer === "")
      throw new Error(e + " failed: if an attendee is set, you also need to set the organizer" + a);
    const i = t.dates[`${n}`].attendee.split("|");
    if (i.length === 1 && nu(i[0]))
      return !0;
    if (i.length !== 2 || i[0].length > 50 || i[1].length > 100 || !nu(i[1]))
      throw new Error(e + ' failed: attendee needs to be a valid email address or match the schema "NAME|EMAIL" with EMAIL being a valid email address' + a);
  }
  return !0;
}
async function jP(t, e, n, a) {
  return /^(?:\w|-){1,254}$/.test(t.dates[`${n}`].uid) || (t.debug && console.warn(e + ": UID not valid. May only contain alpha, digits, and dashes; and be less than 255 characters. Falling back to an automated value!" + a), t.dates[`${n}`].uid = hv()), !/^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(t.dates[`${n}`].uid) && t.debug && console.warn(e + ": UID is highly recommended to be a hex-encoded random Universally Unique Identifier (UUID)!" + a), !0;
}
async function VP(t, e, n, a) {
  return t.dates[`${n}`].sequence && (t.dates[`${n}`].sequence < 0 || t.dates[`${n}`].sequence % 1 !== 0) && (t.debug && console.log(e + ": sequence needs to be a full number >= 0. Used the default 0 instead" + a), t.dates[`${n}`].sequence = 0), !0;
}
async function qP(t, e, n, a) {
  if (!cP().includes(t.dates[`${n}`].timeZone))
    throw new Error(e + " failed: invalid time zone given" + a);
  return !0;
}
async function WP(t, e, n, a) {
  const i = t.dates[`${n}`], r = ["startDate", "endDate"], s = {};
  if (r.forEach((l) => {
    const c = i[`${l}`];
    if (c.length !== 10)
      throw new Error(`${e} failed: date misspelled [-> YYYY-MM-DD]${a}`);
    const u = c.split("-");
    if (u.length !== 3)
      throw new Error(`${e} failed: date misspelled [${l}: ${c}]${a}`);
    s[`${l}`] = new Date(u[0], u[1] - 1, u[2]);
  }), ["startTime", "endTime"].forEach((l) => {
    const c = i[`${l}`];
    if (c) {
      if (c.length !== 5)
        throw new Error(`${e} failed: time misspelled [-> HH:MM]${a}`);
      const u = c.split(":");
      if (u.length !== 2 || u[0] > 23 || u[1] > 59)
        throw new Error(`${e} failed: time misspelled [${l}: ${c}]${a}`);
      const f = l === "startTime" ? "startDate" : "endDate";
      s[`${f}`] = new Date(s[`${f}`].getTime() + parseInt(u[0], 10) * 36e5 + parseInt(u[1], 10) * 6e4);
    }
  }), i.startTime && !i.endTime || !i.startTime && i.endTime)
    throw new Error(`${e} failed: if you set a starting or end time, the respective other one also needs to be defined${a}`);
  if (s.endDate < s.startDate)
    throw new Error(`${e} failed: end date before start date${a}`);
  return !0;
}
async function GP(t, e) {
  if (t.recurrence && t.recurrence !== "" && t.dates.length > 1)
    throw new Error(e + " failed: RRULE and multi-date set at the same time");
  if (t.recurrence && t.recurrence !== "" && !/^RRULE:[\w=;,:+\-/\\]+$/i.test(t.recurrence))
    throw new Error(e + " failed: RRULE data misspelled");
  return !0;
}
async function XP(t, e) {
  if (t.recurrence_interval && (t.recurrence_interval < 1 || t.recurrence_interval % 1 !== 0))
    throw new Error(e + " failed: recurrence data (interval) misspelled");
  if (t.recurrence_until && t.recurrence_until !== "" && !/^[\d\-:]+$/.test(t.recurrence_until))
    throw new Error(e + " failed: recurrence data (until) misspelled");
  if (t.recurrence_count && (t.recurrence_count < 1 || t.recurrence_count % 1 !== 0))
    throw new Error(e + " failed: recurrence data (interval) misspelled");
  if (t.recurrence_byMonth && t.recurrence_byMonth !== "" && !/^[\d,]+$/.test(t.recurrence_byMonth))
    throw new Error(e + " failed: recurrence data (byMonth) misspelled");
  if (t.recurrence_byMonthDay && t.recurrence_byMonthDay !== "" && !/^[\d,]+$/.test(t.recurrence_byMonthDay))
    throw new Error(e + " failed: recurrence data (byMonthDay) misspelled");
  if (t.recurrence_byDay && t.recurrence_byDay !== "" && !/^(?:[\d,-]|MO|TU|WE|TH|FR|SA|SU)+$/im.test(t.recurrence_byDay))
    throw new Error(e + " failed: recurrence data (byDay) misspelled");
  if (t.recurrence_weekstart && t.recurrence_weekstart !== "" && !/^(?:MO|TU|WE|TH|FR|SA|SU)$/im.test(t.recurrence_weekstart))
    throw new Error(e + " failed: recurrence data (weekstart) misspelled");
  return !0;
}
function Sn(t, e, n = "", a = null, i = !1, r = !1) {
  e == "open" ? n1(t, n, a, i, r) : e == "close" || a.classList.contains("atcb-active") || t.querySelector(".atcb-active-modal") ? rl(t, i) : n1(t, n, a, i, r);
}
async function n1(t, e, n = null, a = !1, i = !1) {
  if (t.querySelector(".atcb-list") || t.querySelector(".atcb-modal")) return;
  on("openList", e.identifier, e.identifier), Ft.active = e.identifier;
  const r = JP(t, e), s = document.createElement("div");
  s.classList.add("atcb-list-wrapper"), s.setAttribute("part", "atcb-list-wrapper"), e.hideTextLabelList && s.classList.add("atcb-no-text"), n ? (n.classList.add("atcb-active"), n.setAttribute("aria-expanded", !0), e.listStyle === "modal" ? (n.classList.add("atcb-modal-style"), r.classList.add("atcb-modal")) : (s.append(r), s.classList.add("atcb-dropdown"), e.listStyle === "overlay" && s.classList.add("atcb-dropoverlay")), i && r.classList.add("atcb-generated-button")) : r.classList.add("atcb-modal");
  const o = ov(t, e.trigger, e.listStyle === "modal", !e.hideBackground);
  if (e.listStyle === "modal") {
    const c = await Nl(t, e);
    c.querySelector(".atcb-modal-host-initialized").append(o), o.append(r), e.hideBranding || yl(c, !1), Tl(r, e.sizes), af(c), Rr(o);
  } else
    e.forceOverlay && (t = await eB(t, e), n = t.querySelector("button.atcb-button")), t.querySelector(".atcb-initialized").append(s), s.append(r), e.buttonStyle != "default" && s.classList.add("atcb-style-" + e.buttonStyle), e.hideBranding || yl(t), t.append(o), Tl(r, e.sizes), s.style.display = "none", setTimeout(function() {
      s.style.display = "block", e.listStyle === "dropdown-static" ? r0(t, n, s, !0) : e.listStyle === "dropup-static" ? r0(t, n, s, !1, !0) : r0(t, n, s);
    }, 5), Rr(o);
  const l = function() {
    const c = t.querySelector(".atcb-list-item");
    if (c)
      return c;
    const u = document.getElementById(e.identifier + "-modal-host");
    if (u)
      return u.shadowRoot.querySelector(".atcb-list-item");
  }();
  l && (a ? l.focus() : (l.focus({ preventScroll: !0 }), l.blur()));
}
function rl(t, e = !1) {
  const n = document.getElementById(t.host.getAttribute("atcb-button-id") + "-modal-host"), a = function() {
    return !n || n.length === 0 ? [] : n.shadowRoot.querySelectorAll(".atcb-modal[data-modal-nr]");
  }();
  if (a.length > 1) {
    n.shadowRoot.querySelectorAll('.atcb-modal[data-modal-nr="' + a.length + '"]')[0].remove();
    const i = n.shadowRoot.querySelectorAll('.atcb-modal[data-modal-nr="' + (a.length - 1) + '"]')[0];
    i.classList.remove("atcb-hidden");
    let r = i;
    const s = i.getElementsByTagName("button");
    s.length > 0 && (r = s[0]), r.focus(), e || r.blur();
  } else {
    const i = function() {
      const s = t.querySelector(".atcb-active, .atcb-active-modal");
      return s || document.querySelector(".atcb-active, .atcb-active-modal");
    }();
    i && (i.focus({ preventScroll: !0 }), e || i.blur()), Array.from(t.querySelectorAll(".atcb-active")).forEach((s) => {
      s.classList.remove("atcb-active"), s.setAttribute("aria-expanded", !1);
    }), Array.from(t.querySelectorAll(".atcb-active-modal")).forEach((s) => {
      s.classList.remove("atcb-active-modal");
    }), Array.from(document.querySelectorAll(".atcb-active")).forEach((s) => {
      s.classList.remove("atcb-active"), s.setAttribute("aria-expanded", !1);
    }), Array.from(document.querySelectorAll(".atcb-active-modal")).forEach((s) => {
      s.classList.remove("atcb-active-modal");
    }), n && n.remove(), document.body.classList.remove("atcb-modal-no-scroll"), document.documentElement.classList.remove("atcb-modal-no-scroll"), Array.from(t.querySelectorAll(".atcb-list-wrapper")).concat(Array.from(t.querySelectorAll(".atcb-list"))).concat(Array.from(t.querySelectorAll("#atcb-reference"))).concat(Array.from(t.querySelectorAll("#atcb-bgoverlay"))).forEach((s) => s.remove());
    const r = document.querySelector(".atcb-shadow-hide");
    r && (r.shadowRoot.querySelector(".atcb-initialized").style.opacity = "1", r.classList.remove("atcb-shadow-hide"), window.removeEventListener("scroll", au), window.removeEventListener("resize", au)), Ft.active = "";
  }
}
async function a1(t, e) {
  let n = t, a = e;
  t.host || (n = n.shadowRoot, a = await J2(a));
  const i = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1.5"><path stroke-linecap="round" stroke-linejoin="round" d="M8.25 7.5V6.108c0-1.135.845-2.098 1.976-2.192.373-.03.748-.057 1.123-.08M15.75 18H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08M15.75 18.75v-1.875a3.375 3.375 0 00-3.375-3.375h-1.5a1.125 1.125 0 01-1.125-1.125v-1.5A3.375 3.375 0 006.375 7.5H5.25m11.9-3.664A2.251 2.251 0 0015 2.25h-1.5a2.251 2.251 0 00-2.15 1.586m5.8 0c.065.21.1.433.1.664v.75h-6V4.5c0-.231.035-.454.1-.664M6.75 7.5H4.875c-.621 0-1.125.504-1.125 1.125v12c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V16.5a9 9 0 00-9-9z" /></svg>', r = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1.5"><path stroke-linecap="round" stroke-linejoin="round" d="M11.35 3.836c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m8.9-4.414c.376.023.75.05 1.124.08 1.131.094 1.976 1.057 1.976 2.192V16.5A2.25 2.25 0 0118 18.75h-2.25m-7.5-10.5H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V18.75m-7.5-10.5h6.375c.621 0 1.125.504 1.125 1.125v9.375m-8.25-3l1.5 1.5 3-3.75" /></svg>', s = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1.5"><path stroke-linecap="round" stroke-linejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" /></svg>';
  /*!
   *  @preserve
   *  PER LICENSE AGREEMENT, YOU ARE NOT ALLOWED TO REMOVE OR CHANGE THIS FUNCTION!
   */
  if ((!a.proKey || a.proKey === "") && !window.location.hostname.match(/^(localhost|.*\.add-to-calendar-pro.com)$/))
    return;
  const o = await Nl(n, a);
  Rr(o.querySelector(".atcb-modal-host-initialized"));
  const l = a.ty;
  (l.type === "link" || l.type === "form") && (!l.url || l.url === "" || !l.url.startsWith("http")) && (l.type = "text"), (!l.headline || l.headline === "") && (l.headline = $e("thankyou", a) + "!");
  let c = '<div class="pro"><p id="ty-success-msg">' + $e("form.success", a) + '</p><div id="ty-content">';
  l.text && l.text !== "" && (c += _s(l.text)), l.type === "share" && (c += `<p class="pro-pt pro-share-buttons">
    <a href="mailto:?subject=${encodeURIComponent($e("label.share.email.subject", a))}&body=%0A&#10142;%20${encodeURIComponent(l.url)}%0A%0A" target="_blank" rel="noopener" class="atcb-modal-btn atcb-modal-btn-primary atcb-modal-btn-border btn-flex">
      ${s}
      ${$e("label.share.email", a)}
    </a>
    <button id="atcb-ty-share-copy" class="atcb-modal-btn atcb-modal-btn-primary atcb-modal-btn-border btn-flex">
      ${i}
      ${$e("label.share.copy", a)}
    </button>
    </p>`);
  let u = {};
  if (l.type === "form") {
    const f = !l.text || l.text === "" || l.text === void 0, m = function() {
      return l.button_label && l.button_label !== "" ? l.button_label : $e("submit", a);
    }();
    if (c += '<form id="' + a.identifier + '-ty-form" class="pro-form' + (f ? " no-intro" : "") + '">', l.fields && l.fields.length > 0) {
      const _ = l.fields.find((g) => g.name === "header" && g.type === "hidden");
      if (_ && _.default && _.default !== "" && _.default.startsWith("{"))
        try {
          u = JSON.parse(_.default), Object.keys(u).length === 0 && (u.atcb = !0), l.fields = l.fields.filter((g) => g.name !== "header");
        } catch {
        }
      const T = av(l.fields, a.identifier + "-ty");
      l.fields = T.fields, c += T.html;
    }
    c += '<p id="submit-error"></p>', c += '<p class="pro-pt"><button type="submit" id="pro-form-submit" class="atcb-modal-btn atcb-modal-btn-primary atcb-modal-btn-border">' + m + '</button><span id="pro-form-submitting" class="pro-waiting"><span>.</span><span>.</span><span>.</span></span></p>', c += "</form>";
  }
  if (l.type === "link") {
    const f = function() {
      return l.button_label && l.button_label !== "" ? l.button_label : $e("continue", a);
    }();
    c += '<p class="pro-pt"><a href="' + l.url + '" target="_blank" rel="noopener" class="atcb-modal-btn atcb-modal-btn-primary atcb-modal-btn-border">' + f + "</a></p>";
  }
  if (c += "</div></div>", await tr(o, a, "checkmark", l.headline, c), l.type === "share") {
    const f = o.getElementById("atcb-ty-share-copy");
    f.addEventListener("click", function() {
      iu(l.url), f.innerHTML = r + $e("label.share.copied", a) + "!", setTimeout(function() {
        f.innerHTML = i + $e("label.share.copy", a);
      }, 3e3);
    }), f.addEventListener("keyup", function(m) {
      m.key === "Enter" && (m.preventDefault(), f.click());
    });
  }
  if (l.type === "form") {
    const f = o.getElementById(a.identifier + "-ty-form"), m = o.getElementById("submit-error"), _ = o.getElementById("pro-form-submit"), T = o.getElementById("pro-form-submitting");
    _.addEventListener("click", async function(g) {
      g.preventDefault(), T.style.display = "block", _.style.display = "none";
      let x = iv(o, l.fields);
      if (x || (m.textContent = $e("form.error.required", a) + "."), x) {
        const S = [];
        let D = !1;
        if (l.fields.forEach((M) => {
          M.type !== "label" && (M.type === "radio" ? D || (o.querySelectorAll('[name="' + M.name + '"]').forEach(function(P) {
            P.checked && S.push({ name: M.name, value: P.value });
          }), D = !0) : M.type === "checkbox" ? (S.push({ name: M.name, value: o.getElementById(M.fieldId).checked }), D = !1) : (S.push({ name: M.name, value: o.getElementById(M.fieldId).value }), D = !1));
        }), await rv(l.url, S, u) === !0) {
          o.getElementById("ty-success-msg").style.display = "block", o.getElementById("ty-content").style.display = "none";
          return;
        }
        m.textContent = $e("form.error.sending", a) + ".";
      }
      f.classList.add("form-error"), T.style.display = "none", _.style.display = "block";
    }), _.addEventListener("keyup", function(g) {
      g.key === "Enter" && (g.preventDefault(), _.click());
    });
  }
}
async function pi(t, e, n, a = !1) {
  /*!
   *  @preserve
   *  PER LICENSE AGREEMENT, YOU ARE NOT ALLOWED TO REMOVE OR CHANGE THIS FUNCTION!
   */
  var B;
  const i = e.rsvp, r = !i.text || i.text === "" || i.text === void 0, s = !i.headline || i.headline === "" || i.headline === void 0;
  let o = "", l = '<div class="pro">';
  const c = localStorage.getItem(e.proKey + "-rsvp-sent") === "true" || null;
  c && (l += '<div id="rsvp-sent-content">', l += "<p>" + $e("form.success.already", e) + "</p>", e.hideButton || (l += '<div id="rsvp-atcb"></div>'), e.inlineRsvp && (l += '<button id="pro-form-restart" ' + (e.disabled && "disabled") + ' class="atcb-modal-btn atcb-modal-btn btn-small atcb-modal-btn-border">' + $e("label.rsvp.restart", e) + "</button>"), l += "</div>"), l += '<div id="rsvp-success-msg"><p>' + $e("form.success.sent", e) + '</p><p id="rsvp-success-msg-email">' + $e("form.success.email", e) + '</p><p id="rsvp-success-msg-doi">' + $e("form.success.doi", e) + "</p></div>", l += '<div id="rsvp-success-msg-demo">' + $e("form.success.demo", e) + "</div>", l += '<div id="rsvp-content">', i.text && i.text !== "" && (l += _s(i.text)), l += '<form id="' + e.identifier + '-rsvp-form" class="pro-form' + (r ? " no-intro" : "") + (s ? " no-headline" : "") + '">';
  const u = e.proKey || "demo-rsvp";
  i.initial_confirmation === !1 ? (l += '<div id="rsvp-status-group">', l += "<p>" + $e("form.status", e) + "</p>", l += '<div class="pro-field pro-field-type-radio"><div><input type="radio" name="' + u + '-status" id="' + e.identifier + '-rsvp-status-confirmed" aria-label="' + $e("form.status.confirmed", e) + '" checked value="confirmed" ' + (e.disabled && "disabled") + ' /><label for="' + e.identifier + '-rsvp-status-confirmed" class="status-confirmed"><span>' + $e("form.status.confirmed", e) + "</span></label></div>", i.maybe_option === !0 && (l += '<div><input type="radio" name="' + u + '-status" id="' + e.identifier + '-rsvp-status-undecided" aria-label="' + $e("form.status.undecided", e) + '" value="undecided" ' + (e.disabled && "disabled") + ' /><label for="' + e.identifier + '-rsvp-status-undecided" class="status-undecided"><span>' + $e("form.status.undecided", e) + "</span></label></div>"), l += '<div><input type="radio" name="' + u + '-status" id="' + e.identifier + '-rsvp-status-declined" aria-label="' + $e("form.status.declined", e) + '" value="declined" ' + (e.disabled && "disabled") + ' /><label for="' + e.identifier + '-rsvp-status-declined" class="status-declined"><span>' + $e("form.status.declined", e) + "</span></label></div></div>", l += "</div>") : o += '<input type="hidden" name="' + u + '-status" id="' + e.identifier + '-rsvp-status-confirmed" value="confirmed" />';
  const f = i.maxpp || 1;
  f === 1 ? o += '<input type="hidden" name="' + u + '-amount" id="' + e.identifier + '-rsvp-amount" value="1" />' : (l += '<div class="pro-field"><label for="' + e.identifier + '-rsvp-amount">' + $e("form.amount", e) + " (" + $e("form.max", e) + " " + f + ")<span>*</span></label>", l += '<input type="number" name="' + u + '-amount" min="1" max="' + f + '" id="' + e.identifier + '-rsvp-amount" ' + (e.disabled && "disabled") + ' aria-label="' + $e("form.amount", e) + '" value="1" /></div>');
  const m = function() {
    if (e.attendee && e.attendee !== "") {
      const z = e.attendee.split("|");
      return z.length > 1 ? z[1] : z[0];
    }
    return null;
  }(), _ = (B = i.fields) == null ? void 0 : B.find((z) => z.name === "email");
  if (_ ? i.fields = i.fields.map((z) => z.name === "email" ? { ...z, required: !0, type: "email", default: m !== "" ? m : z.default } : z) : m ? o += '<input type="hidden" name="email" id="' + e.identifier + '-rsvp-email" value="' + m + '" />' : (l += '<div class="pro-field"><label for="' + e.identifier + '-rsvp-email">' + $e("form.email", e) + "<span>*</span></label>", l += '<input type="email" name="email" id="' + e.identifier + '-rsvp-email" ' + (e.disabled && "disabled") + ' aria-label="' + $e("form.email", e) + '" value="" /></div>'), i.fields && i.fields.length > 0) {
    const z = av(i.fields, e.identifier + "-rsvp", e.disabled);
    i.fields = z.fields, l += z.html;
  }
  l += o, l += '<p id="submit-error"></p>', l += '<p class="pro-pt"><button type="submit" id="pro-form-submit" ' + (e.disabled && "disabled") + ' class="atcb-modal-btn atcb-modal-btn-primary atcb-modal-btn-border">' + $e("submit", e) + '</button><span id="pro-form-submitting" class="pro-waiting"><span>.</span><span>.</span><span>.</span></span></p>', i.seatsLeft && i.seatsLeft > 0 && (l += '<p class="pro-form-fine">' + $e("form.seatsleft", e) + ": <b>" + i.seatsLeft + "</b></p>"), l += "</form>", l += "</div></div>";
  let T = null;
  if (!e.inlineRsvp)
    T = await Nl(t, e), Rr(T.querySelector(".atcb-modal-host-initialized")), await tr(
      T,
      e,
      void 0,
      i.headline,
      l,
      [
        { type: "none", label: $e("label.rsvp.restart", e), small: !0, primary: !0, id: "pro-form-restart" },
        { type: "close", label: $e("close", e), small: !0, id: "modal-btn-close" },
        { type: "close", label: $e("cancel", e), small: !0, id: "modal-btn-cancel" }
      ],
      [],
      a,
      {},
      !1
    );
  else {
    T = t;
    const z = document.createElement("div");
    if (z.classList.add("atcb-modal-box", "rsvp-inline-wrapper"), z.setAttribute("part", "atcb-modal-box"), e.rtl && z.classList.add("atcb-rtl"), n.append(z), i.headline) {
      const V = document.createElement("div");
      V.classList.add("atcb-modal-headline"), z.append(V), V.innerHTML = i.headline;
    }
    const W = document.createElement("div");
    if (W.classList.add("atcb-modal-content"), z.append(W), !e.hideBranding) {
      const V = yl(T, !1, !0);
      z.append(V);
    }
    if (i.expired) {
      W.innerHTML = '<div class="pro"><p>' + $e("label.rsvp.expired", e) + "</p></div>";
      return;
    } else if (i.bookedOut) {
      W.innerHTML = '<div class="pro"><p>' + $e("label.rsvp.bookedout", e) + "</p></div>";
      return;
    } else
      W.innerHTML = l;
  }
  c && (T.getElementById("rsvp-content").style.display = "none");
  const g = T.getElementById("modal-btn-close"), x = T.getElementById("modal-btn-cancel"), S = T.getElementById("pro-form-restart");
  if (on("openRSVP", e.identifier, e.identifier), e.debug && console.log('RSVP form for "' + e.identifier + '" created'), c) {
    x && (x.style.display = "none");
    const z = T.getElementById("rsvp-atcb");
    if (z && !e.hideButton) {
      const W = JSON.parse(JSON.stringify(e));
      W.hideTextLabelButton = !0, W.hideIconButton = !1, W.buttonsList = !0, sv(t, z, W);
    }
  } else
    g && (g.style.display = "none"), S && (S.style.display = "none");
  const D = T.getElementById(e.identifier + "-rsvp-form"), L = T.getElementById("submit-error"), M = T.getElementById("pro-form-submit"), E = T.getElementById("pro-form-submitting"), P = T.getElementById("pro-form-restart");
  M && (M.addEventListener("click", async function(z) {
    var ie;
    z.preventDefault(), E.style.display = "block", M.style.display = "none";
    const W = [{ type: "number", name: e.proKey + "-amount", fieldId: e.identifier + "-rsvp-amount", required: !0 }];
    _ || W.push({ type: "email", name: "email", fieldId: e.identifier + "-rsvp-email", required: !0 });
    let V = iv(T, [...W, ...i.fields]);
    const H = T.getElementById(e.identifier + "-rsvp-amount"), se = parseInt(H.value) || 1;
    if (i.maxpp && i.maxpp > 0 && se > i.maxpp && (H.classList.add("error"), V = !1), V || (L.textContent = $e("form.error.required", e) + "."), V) {
      if (!e.proKey || e.proKey === "") {
        T.getElementById("rsvp-success-msg-demo").style.display = "block", T.getElementById("rsvp-content").style.display = "none", on("successRSVP", e.identifier, e.identifier), x && (x.style.display = "none"), g && (g.style.display = "block");
        return;
      }
      let Z = JSON.parse(JSON.stringify(i.fields));
      const $ = [];
      $.push({ name: "prokey", value: e.proKey }), $.push({ name: "language", value: e.language });
      const J = T.querySelector('[name="' + e.proKey + '-status"]:checked');
      if ($.push({ name: "status", value: J ? J.value : "confirmed" }), $.push({ name: "amount", value: se }), !_)
        $.push({ name: "email", value: T.getElementById(e.identifier + "-rsvp-email").value });
      else {
        const De = (ie = Z.find((He) => He.name === "email")) == null ? void 0 : ie.fieldId;
        $.push({ name: "email", value: T.getElementById(De).value }), Z = Z.filter((He) => He.fieldId !== De);
      }
      const N = {};
      let ue = !1;
      Z.forEach((De) => {
        De.type !== "label" && (De.type === "radio" ? ue || (T.querySelectorAll('[name="' + De.name + '"]').forEach(function(te) {
          te.checked && (N[De.name] = te.value);
        }), ue = !0) : De.type === "checkbox" ? (N[De.name] = T.getElementById(De.fieldId).checked, ue = !1) : (N[De.name] = T.getElementById(De.fieldId).value, ue = !1));
      }), Object.keys(N).length > 0 && $.push({ name: "payload", value: N });
      const xe = await rv(`https://api${e.dev ? "-dev" : ""}.add-to-calendar-pro.com/24586219-9910-41fe-9b59-df53de9db7af`, $, { rsvp: !0 });
      if (xe === "doi" || xe === !0) {
        T.getElementById("rsvp-success-msg").style.display = "block", xe === "doi" ? T.getElementById("rsvp-success-msg-doi").style.display = "block" : T.getElementById("rsvp-success-msg-email").style.display = "block", T.getElementById("rsvp-content").style.display = "none", x && (x.style.display = "none"), g && (g.style.display = "block"), on("successRSVP", e.identifier, e.identifier), localStorage.setItem(e.proKey + "-rsvp-sent", !0);
        return;
      }
      xe.error && xe.error === 2 ? L.textContent = $e("form.error.email", e) + "." : xe.error && xe.error === 5 ? L.textContent = $e("label.rsvp.expired", e) + "." : xe.error && xe.error === 6 ? se > 1 ? L.textContent = $e("form.error.bookedoutmany", e) + "." : L.textContent = $e("label.rsvp.bookedout", e) + "." : L.textContent = $e("form.error.sending", e) + ".";
    }
    D.classList.add("form-error"), E.style.display = "none", M.style.display = "block";
  }), M.addEventListener("keyup", function(z) {
    z.key === "Enter" && (z.preventDefault(), M.click());
  })), P && (P.addEventListener("click", function(z) {
    z.preventDefault(), T.getElementById("rsvp-sent-content").style.display = "none", T.getElementById("rsvp-content").style.display = "block", g && (g.style.display = "none"), S && (S.style.display = "none"), x && (x.style.display = "block");
  }), P.addEventListener("keyup", function(z) {
    z.key === "Enter" && (z.preventDefault(), P.click());
  }));
}
async function ZP(t, e) {
  const n = t.querySelector(".atcb-initialized"), a = document.createElement("div");
  a.classList.add("atcb-button-wrapper"), e.rtl && a.classList.add("atcb-rtl"), n.append(a), Tl(a, e.sizes);
  const i = document.createElement("button");
  i.classList.add("atcb-button", "atcb-click", "atcb-single"), e.disabled && i.setAttribute("disabled", !0), e.hideTextLabelButton && i.classList.add("atcb-no-text"), i.type = "button", i.setAttribute("aria-expanded", !1), a.append(i);
  const r = function() {
    return e.rsvp.expired ? $e("label.rsvp.expired", e) : e.rsvp.bookedOut ? $e("label.rsvp.bookedout", e) : $e("label.rsvp", e);
  }();
  return vl(t, e, i, "rsvp", !e.hideIconButton, r, !0), e.debug && console.log('Add to Calendar RSVP Button "' + e.identifier + '" created'), !0;
}
async function i1(t, e = !1) {
  try {
    const n = await fetch(`https://api${e ? "-dev" : ""}.add-to-calendar-pro.com/dffb8bbd-ee5e-4a4f-a7ea-503af98ca468?prokey=${t}`, {
      method: "GET"
    });
    if (!n.ok)
      throw new Error("Network response was not ok");
    const a = await n.json();
    return parseInt(a.total);
  } catch (n) {
    console.error("Error:", n);
  }
  return 0;
}
function av(t, e = "", n = !1) {
  /*!
   *  @preserve
   *  PER LICENSE AGREEMENT, YOU ARE NOT ALLOWED TO REMOVE OR CHANGE THIS FUNCTION!
   */
  let a = "", i = "", r = 0, s = "", o = !1;
  for (let l = 1; l <= t.length; l++) {
    o = !1;
    const c = t[l - 1];
    if (c.type !== "label" && (!c.name || c.name === "")) {
      o = !0;
      continue;
    }
    (s === "radio" && c.type !== "radio" || s !== "radio") && (r = l), t[l - 1].fieldId = e + "-" + l;
    const u = c.type === "radio" ? c.placeholder || "" : c.default || "", f = c.label || "", m = c.type === "radio" ? "" : c.placeholder || "";
    let _ = "";
    s !== "hidden" && l === r && l !== 1 && !o && (_ += "</div>"), c.type !== "hidden" && l === r && (_ += '<div class="pro-field pro-field-type-' + c.type + '">'), c.type === "label" ? _ += "<p>" + f + "</p>" : (c.type === "radio" && (_ += "<div>"), c.type === "hidden" ? i += '<input type="hidden" name="' + c.name + '" id="' + c.fieldId + '" value="' + u + '" />' : _ += KP(c.type, c.name, f, c.fieldId, c.required, u, c.default, m, n), c.type === "radio" && (_ += "</div>")), a += _, s = c.type;
  }
  return s !== "hidden" && (a += "</div>"), a += i, { html: a, fields: t };
}
function KP(t, e, n, a, i = !1, r, s = null, o = "", l = !1) {
  let c = "";
  return (t === "text" || t === "email" || t === "number") && n !== "" && (c += '<label for="' + a + '">' + n + (i ? "<span>*</span>" : "") + "</label>"), c += '<input type="' + t + '"' + (t === "number" ? ' min="0"' : "") + ((t === "checkbox" || t === "radio") && s && (s === "true" || s === !0) ? " checked" : "") + ' name="' + e + '" id="' + a + '" placeholder="' + o + '" ' + (l && "disabled") + ' aria-label="' + n + '" value="' + r + '" />', (t === "checkbox" || t === "radio") && (n !== "" || i) && (c += '<label for="' + a + '">' + n + (i ? "<span>*</span>" : "") + "</label>"), c;
}
function iv(t, e) {
  /*!
   *  @preserve
   *  PER LICENSE AGREEMENT, YOU ARE NOT ALLOWED TO REMOVE OR CHANGE THIS FUNCTION!
   */
  let n = !0;
  return e.forEach(function(a) {
    if (a.type !== "label" && a.type !== "radio") {
      const i = t.getElementById(a.fieldId);
      if (a.type !== "checkbox") {
        if (i.value = _l(i.value.trim()), a.type === "number" && (i.value = i.value.replace(/\D/g, "")), a.type === "email" && i.value !== "" && !nu(i.value)) {
          i.classList.add("error"), n = !1;
          return;
        }
        if (a.required && i.value === "") {
          i.classList.add("error"), n = !1;
          return;
        } else
          i.classList.remove("error");
      } else if (a.required && i.checked === !1) {
        i.classList.add("error"), n = !1;
        return;
      } else
        i.classList.remove("error");
    }
    if (a.type === "radio") {
      const i = t.querySelectorAll('[name="' + a.name + '"]');
      let r = !1;
      if (i.forEach(function(s) {
        s.checked && (r = !0);
      }), r === !1) {
        i[0].classList.add("error"), n = !1;
        return;
      } else
        i[0].classList.remove("error");
    }
  }), n;
}
async function rv(t, e, n = {}) {
  /*!
   *  @preserve
   *  PER LICENSE AGREEMENT, YOU ARE NOT ALLOWED TO REMOVE OR CHANGE THIS FUNCTION!
   */
  let a = new FormData(), i = {}, r = {};
  Object.keys(n).length === 0 ? (e.forEach((s) => {
    a.append(s.name, s.value);
  }), r = { method: "POST", body: a }) : (n["Cache-Control"] = "no-cache", n["Content-Type"] = "application/json", n.Accept = "*/*", e.forEach((s) => {
    i[s.name] = s.value;
  }), r = { method: "POST", headers: n, body: JSON.stringify(i) });
  try {
    const s = await fetch(t, r), o = await s.json();
    return s.ok ? o.status && o.status === "doi" ? "doi" : !0 : (console.error("Network response was not ok"), o.error ? o : !1);
  } catch (s) {
    return console.error("Error:", s), !1;
  }
}
function vl(t, e, n, a, i = !1, r = "", s = !1) {
  switch (a) {
    case "trigger":
    case "rsvp":
    default:
      n.id = e.identifier, e.blockInteraction || (n.addEventListener("keyup", function(o) {
        (o.key === "Enter" || o.code == "Space" || o.key === "Alt" && o.key === "Control" && o.code === "Space") && (o.preventDefault(), a === "rsvp" && typeof pi == "function" ? pi(t, e, n, !0) : Sn(t, "auto", e, n, !0, !0));
      }), n.addEventListener(
        "touchend",
        wr((o) => {
          o.preventDefault(), a === "rsvp" && typeof pi == "function" ? pi(t, e, n) : Sn(t, "auto", e, n, !1, !0);
        })
      ), e.trigger === "click" || a === "rsvp" && typeof pi == "function" ? n.addEventListener(
        "mouseup",
        wr((o) => {
          o.preventDefault(), a === "rsvp" && typeof pi == "function" ? pi(t, e, n) : Sn(t, "auto", e, n, !1, !0);
        })
      ) : n.addEventListener("mouseenter", function() {
        Sn(t, "open", e, n, !1, !0);
      }));
      break;
    case "apple":
    case "google":
    case "ical":
    case "msteams":
    case "ms365":
    case "outlookcom":
    case "yahoo":
      n.id = e.identifier + "-" + a, e.blockInteraction || (n.addEventListener(
        "click",
        wr(() => {
          var o;
          s ? ((o = t.querySelector("#" + n.id)) == null || o.blur(), on("openSingletonLink", n.id, e.identifier)) : (Sn(t, "close"), on("openCalendarLink", n.id, e.identifier)), ys(t, a, e);
        })
      ), n.addEventListener("keyup", function(o) {
        var l;
        o.key === "Enter" && (o.preventDefault(), s ? ((l = t.querySelector("#" + n.id)) == null || l.blur(), on("openSingletonLink", n.id, e.identifier)) : (Sn(t, "close"), on("openCalendarLink", n.id, e.identifier)), ys(t, a, e, "all", !0));
      }));
      break;
    case "close":
      n.id = e.identifier + "-close", n.addEventListener(
        "click",
        ds(() => {
          on("closeList", "List Close Button", Ft.active), Sn(t, "close");
        })
      ), n.addEventListener("keyup", function(o) {
        o.key === "Enter" && (o.preventDefault(), on("closeList", "List Close Button", Ft.active), Sn(t, "close", e, "all", !0));
      });
      break;
  }
  QP(e, n, a, i, r, s);
}
function QP(t, e, n, a, i, r) {
  const s = function() {
    if (t.pastDateHandling != "none") {
      let o = !0;
      for (let l = 0; l < t.dates.length; l++)
        if (!t.dates[`${l}`].overdue) {
          o = !1;
          break;
        }
      if (o)
        return $e("expired", t);
    }
    return $e("label.addtocalendar", t);
  }();
  if (i === "" && (t.options.length === 1 || n === "trigger" ? i = s : n === "close" ? i = $e("close", t) : i = $e(n, t)), !(t.buttonStyle === "date" && (n === "trigger" || r))) {
    if (e.setAttribute("aria-label", r ? $e("label.addtocalendar", t) + " (" + $e(n, t) + "): " + t.name : n === "trigger" ? i + ": " + t.name : i), a) {
      const o = document.createElement("div");
      o.classList.add("atcb-icon"), o.setAttribute("part", n === "trigger" ? "atcb-button-icon" : "atcb-list-icon"), o.classList.add(`atcb-icon-${n}`), o.innerHTML = vs[`${n}`], e.append(o);
    }
    if ((n === "trigger" || r) && !t.hideTextLabelButton || !r && n !== "trigger" && !t.hideTextLabelList) {
      const o = document.createElement("span");
      o.classList.add("atcb-text"), o.setAttribute("part", n === "trigger" ? "atcb-button-text" : "atcb-list-text"), o.textContent = i, e.append(o);
    }
  }
}
function sv(t, e, n) {
  const a = function() {
    return !!(n.options.length === 1 || n.buttonsList && n.buttonStyle != "date");
  }();
  (a ? n.options : ["default"]).forEach(function(r, s) {
    const o = document.createElement("div");
    o.classList.add("atcb-button-wrapper"), o.setAttribute("part", "atcb-button-wrapper"), n.rtl && o.classList.add("atcb-rtl"), e.append(o), Tl(o, n.sizes);
    const l = document.createElement("button");
    if (l.classList.add("atcb-button"), l.setAttribute("part", "atcb-button"), n.disabled && l.setAttribute("disabled", !0), n.hideTextLabelButton && l.classList.add("atcb-no-text"), n.trigger === "click" && l.classList.add("atcb-click"), n.listStyle === "overlay" && l.classList.add("atcb-dropoverlay"), l.type = "button", l.setAttribute("aria-expanded", !1), o.append(l), n.buttonStyle === "date" && lv(n, l, "all", a), a) {
      l.classList.add("atcb-single");
      const c = function() {
        return n.buttonsList && n.options.length > 1 ? $e(`${n.options[`${s}`]}`, n) : n.label;
      }();
      vl(t, n, l, r, !n.hideIconButton, c, !0), l.id = n.identifier, n.buttonsList && (l.id = n.identifier + "-" + r);
    } else {
      vl(t, n, l, "trigger", !n.hideIconButton, n.label);
      const c = document.createElement("div");
      c.classList.add("atcb-dropdown-anchor"), l.append(c);
    }
    if (!n.hideCheckmark && !n.hideTextLabelButton && !n.buttonsList && !n.disabled && !n.allCancelled) {
      const c = document.createElement("div");
      c.classList.add("atcb-checkmark"), c.innerHTML = vs.checkmark, l.append(c);
    }
  }), n.debug && console.log('Add to Calendar Button "' + n.identifier + '" created');
}
function JP(t, e) {
  const n = document.createElement("div");
  n.classList.add("atcb-list"), n.setAttribute("part", "atcb-list"), n.role = "list", e.rtl && n.classList.add("atcb-rtl");
  let a = 0;
  if (e.options.forEach(function(i) {
    const r = document.createElement("div");
    r.classList.add("atcb-list-item"), r.setAttribute("part", "atcb-list-item"), r.role = "link", r.tabIndex = 0, a++, r.dataset.optionNumber = a, n.append(r), vl(t, e, r, i, !e.hideIconList);
  }), e.listStyle === "modal") {
    const i = document.createElement("div");
    i.classList.add("atcb-list-item", "atcb-list-item-close"), i.setAttribute("part", "atcb-list-item-close"), i.role = "button", i.tabIndex = 0, a++, i.dataset.optionNumber = a, n.append(i), vl(t, e, i, "close", !e.hideIconList);
  }
  return n;
}
function ov(t, e = "", n = !1, a = !0, i = !0) {
  const r = function() {
    return n ? document.createElement("dialog") : document.createElement("div");
  }();
  if (n && r.setAttribute("open", !0), r.id = "atcb-bgoverlay", a || r.classList.add("atcb-no-bg"), r.role = "button", r.tabIndex = 0, i) {
    r.addEventListener(
      "mouseup",
      wr((o) => {
        o.target === o.currentTarget && (on("closeList", "Background Hit", Ft.active), Sn(t, "close"));
      })
    );
    let s = !1;
    r.addEventListener(
      "touchstart",
      wr(() => s = !1),
      { passive: !0 }
    ), r.addEventListener(
      "touchmove",
      wr(() => s = !0),
      { passive: !0 }
    ), r.addEventListener(
      "touchend",
      ds((o) => {
        s !== !1 || o.target !== o.currentTarget || (on("closeList", "Background Hit", Ft.active), Sn(t, "close"));
      }),
      { passive: !0 }
    ), e !== "click" ? r.addEventListener(
      "mousemove",
      wr((o) => {
        o.target === o.currentTarget && (on("closeList", "Background Hit", Ft.active), Sn(t, "close"));
      })
    ) : r.classList.add("atcb-click");
  }
  return r;
}
/*!
 *  @preserve
 *  PER LICENSE AGREEMENT, YOU ARE NOT ALLOWED TO REMOVE OR CHANGE THIS FUNCTION!
 */
function yl(t, e = !0, n = !1, a = !1) {
  const i = document.createElement("div");
  if (i.id = "atcb-reference", a)
    i.innerHTML = 'Using the <a href="https://add-to-calendar-pro.com" target="_blank" rel="noopener referrer">Add to Calendar Button</a>, licensed under the Elastic License 2.0 (ELv2).', i.style.display = "none !important", i.classList.add("atcb-attribution"), t.append(i);
  else if (setTimeout(() => {
    const r = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52.916 2.8305"><path d="M51.446 1.2565c.0708-.2518.293-.4511.5555-.4783.2211-.042.4641.0128.622.18.2474.2472.3045.6146.2916.9503v.8594h-.8307l-.0027-1.0447c-.0079-.1547-.1075-.343-.2868-.3238-.2049.0128-.3115.2421-.295.4257v.9428h-.823l-.0027-1.0435c-.0076-.1569-.1131-.3412-.2918-.3252-.2069.008-.311.2351-.2939.4188v.9499h-.8307V.8237h.8307v.4019c.0906-.2264.2876-.4188.5368-.449.2878-.0533.6071.0705.7509.3331.0279.0465.0509.0959.0699.1468zm-3.9843.5228c-.0102.1874.107.3914.3024.424.1869.0419.3799-.0941.4215-.2776.0535-.1967-.0023-.4493-.2015-.5411-.1767-.0892-.4107.0032-.483.1865-.0297.0649-.0391.1374-.0392.2082zm-.7691 0c.0037-.2984.1395-.5957.3792-.7774.3035-.2327.7168-.2798 1.0829-.2005.3299.0729.6352.3018.7481.6275.1337.3797.0441.8526-.2795 1.1099-.3184.2561-.7624.3092-1.152.2184-.3379-.0788-.6426-.3312-.7369-.6717a1.092 1.092 0 0 1-.0417-.3063zm-.2351-.3308c-.1638-.0482-.3406-.0889-.5104-.0492s-.2742.2154-.2664.3837c-.0082.1705.0998.3468.2712.3876.1657.0389.3389.0016.4979-.0492l.0769.5499c-.2369.1272-.5165.1434-.7791.1149-.3236-.0401-.6353-.2311-.7805-.529-.1237-.2511-.139-.5539-.0485-.8181.108-.3075.3782-.5432.6902-.6287.2064-.058.4286-.0585.6371-.0119.1027.0253.198.0732.2884.1269l-.0769.523zm-2.6877.9806c-.003-.1221.066-.2371.1643-.3062.1303-.0934.3092-.1186.4572-.0533.132.054.2426.1752.2607.3197s-.0575.2836-.1746.3603c-.1633.1093-.3947.1063-.5517-.0135-.0951-.0715-.1577-.187-.1559-.307zm-3.046-1.0111c-.0091-.4276.1794-.8577.5181-1.1231.3714-.2958.8865-.3488 1.3384-.2477.4065.0946.7695.3811.9242.7731.2302.553.1173 1.2562-.3406 1.6606-.4021.3563-.9997.4264-1.5018.273-.4407-.1312-.7876-.5106-.8926-.9564a1.565 1.565 0 0 1-.0458-.3795zm1.4499.6961c.2631.014.4813-.2093.5326-.4557.0785-.3033.0224-.6834-.2491-.8753-.2182-.159-.5514-.1019-.704.1211-.1692.2437-.1902.5756-.088.8501.0775.2087.2816.3661.5085.3597zm-1.631.6458c-.1978.0602-.4078.0938-.6123.0464-.2697-.0443-.5044-.2371-.6009-.4927-.0701-.1852-.1026-.3819-.154-.5728h-.1846v1.0268h-.8614V.0601l1.3192.0034c.3398.0217.7177.1323.9118.434.152.2456.127.584-.0389.8163-.0979.1284-.2387.2162-.3846.2807.0316.1513.0475.3167.1461.4418.1193.1187.3064.1031.4596.0812v.6422zm-.871-1.8651c.0103-.138-.1243-.231-.25-.2384-.1427-.0193-.2871-.0088-.4307-.0115v.5422c.1905-.0038.3947.0138.5678-.0796a.234.234 0 0 0 .1128-.2126zM35.573.0603l1.1424.0047c.3439.0209.7218.1098.9446.3944.2252.2934.2163.7545-.0512 1.0195-.279.2859-.698.3701-1.0838.362-.0329.0105-.1126-.0258-.102.0281v.8987h-.8499V.0603zm1.0192 1.2345c.1672.0054.3805-.0562.4233-.2409.0425-.1434-.0225-.3102-.1619-.3724-.1328-.0705-.2859-.0537-.4306-.0559v.6615c.0561.0073.1128.0073.1692.0077zm-2.5176.2226h1.0576v.4653h-1.0576zM32.3311.8234h.8307v.4019q.0942-.2384.25-.348.1577-.1115.3615-.1115l.1154.6442q-.375 0-.5519.0808-.175.0788-.175.2538v1.023h-.8307zm-1.2257 1.5791c-.0937.2116-.2986.3716-.5319.3897-.3887.0533-.7844-.1743-.9578-.5217-.2044-.381-.1519-.892.1543-1.2049.2461-.2614.6627-.389.9973-.2285.1574.0799.2779.2236.3381.3886V.7662h.8268v2.0017h-.8268v-.3653zm0-.6345c-.0052-.2449-.2747-.4425-.5088-.3585-.217.0615-.3402.3271-.243.5316.0896.2161.3875.3078.5783.1678.1106-.0747.179-.2073.1735-.3408zM27.7118.7662c.2401-.008.4923.1021.6064.3222.0351.0816.045.0806.0397.0023V.1721l.8307-.1231v2.7189h-.8307v-.3653c-.0907.2158-.3003.3744-.5356.39-.3605.0507-.7279-.1432-.9123-.4525-.2569-.3983-.1992-.9693.1456-1.2985.173-.1702.412-.2772.6563-.2754zm.6461 1.0018c-.0048-.2526-.2909-.4519-.5276-.3518-.2324.0782-.3309.3933-.1843.5898.1239.1938.425.2285.5871.0636.0811-.0768.1287-.1897.1248-.3015zM24.139.8233h.7922v.4019c.1006-.2169.2949-.397.5347-.4408.2696-.0572.58.0085.76.2293.2045.2403.2438.5692.2358.8734v.8802h-.8268l-.0022-1.1213c-.004-.1252-.0677-.2748-.2066-.2939-.2045-.0306-.3739.1457-.4412.3226-.0292.0785-.0098.1646-.0154.2467v.8459h-.8306V.8233zm-1.0416 1.4236c.2011-.0002.3981-.0574.5807-.1384l.0961.5288c-.3198.1421-.6806.1894-1.027.145-.3369-.0473-.6587-.2545-.8007-.5699-.1588-.3469-.1132-.7886.1413-1.0788.2741-.3191.7406-.4335 1.1413-.3308.2768.0734.5008.3019.5751.5779.0429.146.0624.3015.043.453l-1.1806.1538c.0368.134.158.2311.2944.2482.0449.0082.0907.0114.1363.0114zm.1461-.7557c-.0268-.1234-.1257-.237-.2578-.244-.143-.0241-.2868.0725-.325.2111-.0103.0527-.0737.2029.0271.1552l.5558-.1223zm-1.4939 1.1721c-.2463.1208-.5356.1686-.805.1092-.227-.0527-.3993-.2481-.4518-.4712-.0545-.2125-.0296-.4333-.0353-.6502V.1714l.8307-.1231.0011 1.9292c.002.1378.1537.1938.2711.1813.0651.0169.1819-.1.162.0152l.0274.4893zm-2.5115-.2609c-.0937.2116-.2986.3716-.5319.3897-.3887.0533-.7844-.1743-.9578-.5217-.2044-.381-.1519-.892.1543-1.2049.2461-.2614.6627-.389.9973-.2285.1574.0799.2779.2236.3381.3886V.7661h.8268v2.0017h-.8268v-.3653zm0-.6345c-.0052-.2449-.2747-.4425-.5088-.3585-.217.0615-.3402.3271-.243.5316.0896.2161.3875.3078.5783.1678.1106-.0747.179-.2073.1735-.3408zm-2.3726.35c.1696.0054.3334-.0479.4884-.1115l.1077.6249c-.5137.3026-1.2229.2625-1.6732-.1399-.2959-.2444-.4693-.6191-.4819-1.0009-.0323-.4791.181-.9792.5853-1.2496.4565-.3128 1.0898-.3142 1.5659-.0438l-.1038.6115c-.2721-.1029-.5957-.168-.8667-.0274-.2291.1239-.3077.4039-.2984.6481-.0043.2465.1061.5161.3427.6212.1037.0495.2198.0676.3339.0676zm-2.923-.6005h1.0576v.4653h-1.0576zm-1.7829.2619c-.0102.1874.107.3914.3024.424.1869.0419.3799-.0941.4215-.2776.0535-.1967-.0023-.4493-.2015-.5411-.1767-.0892-.4107.0032-.4831.1865-.0297.0649-.0391.1374-.0392.2082zm-.7691 0c.0037-.2984.1395-.5957.3792-.7774.3035-.2327.7168-.2798 1.0829-.2005.33.0729.6352.3018.7481.6275.1337.3797.0441.8526-.2795 1.1099-.3184.2561-.7624.3092-1.152.2184-.3379-.0788-.6426-.3312-.7369-.6717a1.092 1.092 0 0 1-.0417-.3063zm-.1976.8841c-.2463.1208-.5356.1686-.805.1092-.227-.0527-.3993-.2481-.4518-.4712-.0557-.2169-.0286-.4422-.0334-.6635l.0019-.3551h-.25V.7943h.3115l.3653-.7461h.4v.7461h.4538v.4884h-.4538l.0011.6943c.0034.1365.1541.1943.2715.1818.0768.006.1848-.0959.1624.0301l.0265.4744zm-2.7861-1.146h1.0575v.4653H8.4068zM6.5412.7662c.2401-.008.4923.1021.6064.3223.0351.0816.045.0806.0397.0023V.172l.8307-.1231v2.7189h-.8307v-.3653c-.0907.2158-.3003.3744-.5356.39-.3605.0507-.7279-.1432-.9123-.4525-.2569-.3983-.1992-.9693.1456-1.2985.173-.1702.412-.2772.6563-.2754zm.6461 1.0018c-.0048-.2526-.2909-.4519-.5276-.3518-.2324.0782-.3308.3933-.1843.5898.1239.1938.425.2285.5871.0636.0811-.0768.1287-.1897.1248-.3015zM3.7956.7662c.2401-.008.4923.1021.6064.3222.0351.0816.045.0806.0397.0023V.172l.8307-.1231v2.7189h-.8307v-.3653c-.0907.2158-.3003.3744-.5356.39-.3605.0507-.7279-.1432-.9123-.4525-.2569-.3983-.1992-.9693.1456-1.2985.173-.1702.4119-.2772.6563-.2754zm.6461 1.0018c-.0048-.2526-.2909-.4519-.5276-.3518-.2324.0782-.3308.3933-.1843.5898.1239.1938.425.2285.5871.0636.0811-.0768.1287-.1897.1248-.3015zM.7498.0603h1.196l.7845 2.7074h-.9268l-.1038-.5192H.9997l-.1115.5192h-.8883zm.8576 1.7037L1.3497.5795 1.0843 1.764z"/></svg>';
    i.innerHTML = '<a href="https://add-to-calendar-pro.com" target="_blank" rel="noopener">' + r + "</a>";
  }, 500), e)
    t.querySelector(".atcb-initialized .atcb-list-wrapper").append(i);
  else {
    if (n)
      return i;
    (window.innerHeight > 1e3 || window.innerWidth > 1e3) && (t.append(i), i.classList.add("fixed-ref"));
  }
  if (n) return null;
}
async function tr(t, e, n = "", a, i = "", r = [], s = [], o = !1, l = {}, c = !0) {
  Ft.active = e.identifier;
  const u = !a || a === "" || a === void 0, f = await Nl(t, e, !1), m = function() {
    const D = f.getElementById("atcb-bgoverlay");
    if (!D) {
      const L = ov(t, "click", !0, !e.hideBackground, c);
      return f.querySelector(".atcb-modal-host-initialized").append(L), L;
    }
    return D;
  }(), _ = document.createElement("div");
  _.classList.add("atcb-modal"), m.append(_);
  const T = f.querySelectorAll(".atcb-modal").length;
  _.dataset.modalNr = T, _.tabIndex = 0, _.focus({ preventScroll: !0 }), _.blur();
  const g = function() {
    const D = t.getElementById(e.identifier);
    return D || document.getElementById(e.identifier);
  }();
  g && g.classList.add("atcb-active-modal");
  const x = document.createElement("div");
  if (x.classList.add("atcb-modal-box"), x.setAttribute("part", "atcb-modal-box"), e.rtl && x.classList.add("atcb-rtl"), _.append(x), Tl(x, e.sizes), Rr(m), n !== "" && !e.hideIconModal) {
    const D = document.createElement("div");
    D.classList.add("atcb-modal-icon"), D.innerHTML = vs[`${n}`], x.append(D);
  }
  if (!u) {
    const D = document.createElement("div");
    D.classList.add("atcb-modal-headline"), D.textContent = a, x.append(D);
  }
  if (i !== "") {
    const D = document.createElement("div");
    D.classList.add("atcb-modal-content"), u && D.classList.add("no-headline"), D.innerHTML = i, x.append(D);
  }
  if (e.hideBranding || yl(f, !1), s.length > 1) {
    const D = document.createElement("div");
    D.classList.add("atcb-modal-content"), x.append(D);
    const L = document.createElement("div");
    L.classList.add("atcb-modal-content-subevents"), D.append(L);
    for (let M = 1; M < s.length; M++) {
      const E = document.createElement("button");
      E.type = "button", E.id = e.identifier + "-" + s[0] + "-" + M, Ft[`${e.identifier}`][`${s[0]}`][M - 1] > 0 && E.classList.add("atcb-saved"), E.classList.add("atcb-subevent-btn"), L.append(E), lv(e, E, M), !e.dates[M - 1].overdue || e.pastDateHandling === "none" ? (M === 1 && o && E.focus(), E.addEventListener(
        "click",
        ds(() => {
          on("openSubEventLink", E.id, e.identifier), E.blur(), ys(t, s[0], e, s[`${M}`], o, !0);
        })
      )) : E.setAttribute("disabled", !0);
    }
  }
  r.length === 0 && r.push({ type: "close", label: $e("close", e), small: !0 });
  const S = document.createElement("div");
  S.classList.add("atcb-modal-buttons"), x.append(S), r.forEach((D, L) => {
    let M;
    switch (D.href && D.href !== "" ? (M = document.createElement("a"), M.setAttribute("target", nf), M.setAttribute("href", D.href), M.setAttribute("rel", "noopener")) : (M = document.createElement("button"), M.type = "button"), D.id && D.id !== "" && (M.id = D.id), M.classList.add("atcb-modal-btn"), D.primary && M.classList.add("atcb-modal-btn-primary"), D.small && M.classList.add("btn-small"), (!D.label || D.label === "") && (D.label = $e("modal.button.default", e)), M.textContent = D.label, S.append(M), L === 0 && s.length < 2 && o && M.focus(), D.type) {
      default:
      case "close":
        M.addEventListener(
          "click",
          ds(() => {
            on("closeList", "Modal Close Button", Ft.active), rl(t);
          })
        ), M.addEventListener("keyup", function(E) {
          (E.key === "Enter" || E.code == "Space" || E.key === "Alt" && E.key === "Control" && E.code === "Space") && (on("closeList", "Modal Close Button", Ft.active), Sn(t, "close", "", "", !0));
        });
        break;
      case "yahoo2nd":
        M.addEventListener(
          "click",
          ds(() => {
            rl(t), r1(t, e);
          })
        ), M.addEventListener("keyup", function(E) {
          (E.key === "Enter" || E.code == "Space" || E.key === "Alt" && E.key === "Control" && E.code === "Space") && (Sn(t, "close", "", "", !0), r1(t, e, o));
        });
        break;
      case "2timeslink":
        M.addEventListener(
          "click",
          ds(() => {
            rl(t), ys(t, l.type, e, l.id, o, !1, !0);
          })
        ), M.addEventListener("keyup", function(E) {
          (E.key === "Enter" || E.code == "Space" || E.key === "Alt" && E.key === "Control" && E.code === "Space") && (Sn(t, "close", "", "", !0), ys(t, l.type, e, l.id, o, !1, !0));
        });
        break;
      case "none":
        break;
    }
  }), T > 1 && f.querySelector('.atcb-modal[data-modal-nr="' + (T - 1) + '"]').classList.add("atcb-hidden"), af(f, _);
}
function r1(t, e, n) {
  Zu(t, e), ys(t, "yahoo2nd", e, "all", n);
}
function lv(t, e, n = "all", a = !1) {
  n != "all" ? n = parseInt(n) - 1 : t.dates.length == 1 && (n = 0);
  const i = hB(t.dates, t.language, n), r = function() {
    return n !== "all" && t.dates[`${n}`].status.toLowerCase() === "cancelled" || n === "all" && t.allCancelled ? $e("date.status.cancelled", t) + "<br>" + $e("date.status.cancelled.cta", t) : t.pastDateHandling != "none" && (n === "all" && t.allOverdue || n != "all" && t.dates[`${n}`].overdue) ? $e("expired", t) : t.label && t.label != "" ? t.label : "+ " + $e("label.addtocalendar", t);
  }(), s = function() {
    return n !== "all" && t.dates[`${n}`].status.toLowerCase() === "cancelled" || n === "all" && t.allCancelled ? $e("date.status.cancelled", t) : "";
  }(), o = function() {
    return i.length == 0 ? $e("recurring", t) + " &#x27F3;" : "&#x27F3;";
  }();
  let l = !1;
  n === "all" && (n = 0, l = !0);
  const c = new Date(_a(t.dates[`${n}`]).start), u = _a(t.dates[`${n}`]).allday, f = t.dates[`${n}`].timeZone, m = document.createElement("div");
  m.classList.add("atcb-date-btn-left"), e.append(m);
  const _ = document.createElement("div");
  _.classList.add("atcb-date-btn-day"), m.append(_);
  const T = document.createElement("div");
  T.classList.add("atcb-date-btn-month"), _.textContent = c.toLocaleString(t.language, { day: "numeric", timeZone: u ? "UTC" : f }), T.textContent = c.toLocaleString(t.language, { month: "short", timeZone: u ? "UTC" : f }), m.append(T);
  const g = document.createElement("div");
  g.classList.add("atcb-date-btn-right"), e.append(g);
  const x = document.createElement("div");
  x.classList.add("atcb-date-btn-details"), g.append(x);
  const S = document.createElement("div");
  S.classList.add("atcb-date-btn-headline");
  const D = t.dates.length > 1 && l ? t.name : t.dates[`${n}`].name;
  if (S.textContent = D, x.append(S), t.dates[`${n}`].location && t.dates[`${n}`].location !== "" && !t.dates[`${n}`].onlineEvent || s !== "") {
    const E = document.createElement("div");
    if (E.classList.add("atcb-date-btn-content"), x.append(E), s != "")
      E.classList.add("atcb-date-btn-cancelled"), E.textContent = s;
    else {
      const P = document.createElement("span");
      P.classList.add("atcb-date-btn-content-icon"), P.innerHTML = vs.location, E.append(P);
      const B = document.createElement("span");
      B.classList.add("atcb-date-btn-content-location"), B.textContent = t.dates[`${n}`].location, E.append(B);
    }
  } else if (t.dates[`${n}`].description !== "" && i.length === 0 && (!t.recurrence || t.recurrence === "")) {
    const E = document.createElement("div");
    E.classList.add("atcb-date-btn-content"), E.textContent = t.dates[`${n}`].descriptionHtmlFree, E.style.overflow = "hidden", E.style.display = "-webkit-box", E.style.lineClamp = "2", E.style.boxOrient = "vertical", x.append(E);
  } else
    S.style.lineClamp = "2", i.length == 0 && (t.recurrence == null || t.recurrence == "") && (g.style.alignSelf = "center", S.style.textAlign = "center", S.style.lineClamp = "2");
  if (i.length > 0 || t.recurrence != null && t.recurrence != "") {
    const E = document.createElement("div");
    E.classList.add("atcb-date-btn-content"), x.append(E);
    const P = document.createElement("span");
    P.classList.add("atcb-date-btn-content-icon"), P.innerHTML = vs.ical, E.append(P);
    const B = document.createElement("span");
    if (B.classList.add("atcb-date-btn-content-text"), E.append(B), i.forEach(function(z) {
      const W = document.createElement("span");
      W.textContent = z, B.append(W);
    }), t.recurrence != null && t.recurrence != "") {
      const z = document.createElement("span");
      z.innerHTML = o, B.append(z);
    }
  }
  const L = document.createElement("div");
  if (L.classList.add("atcb-date-btn-hover"), L.innerHTML = r, g.append(L), !t.hideCheckmark && t.dates[`${n}`].status.toLowerCase() !== "cancelled") {
    const E = document.createElement("div");
    E.classList.add("atcb-checkmark"), E.innerHTML = vs.checkmark, e.append(E);
  }
  const M = r.replace(/<br>/g, " ").replace(/\+\s/g, "") + (a ? " (" + $e(t.options[0], t) + ")" : "") + ": " + D + (t.dates[`${n}`].location && t.dates[`${n}`].location !== "" ? ", " + t.dates[`${n}`].location : "") + ", " + i.join(" ");
  e.setAttribute("aria-label", M);
}
async function Nl(t, e, n = !0) {
  const a = document.getElementById(e.identifier + "-modal-host");
  if (a) {
    if (!n)
      return a.shadowRoot;
    a.remove();
  }
  let i = document.createElement("div");
  i.id = e.identifier + "-modal-host", t.host.hasAttribute("cspnonce") && i.setAttribute("cspnonce", t.host.getAttribute("cspnonce")), i.setAttribute("atcb-button-id", e.identifier), i.classList.add("add-to-calendar"), i.style.transform = "translate3D(0, 0, 0)", i.style.visibility = "visible", i.style.opacity = "1", i.style.position = "fixed", i.style.top = "0", i.style.left = "0", i.style.width = "100%", i.style.height = "100%", i.style.display = "flex", i.style.zIndex = "13999998", document.body.append(i), i.attachShadow({ mode: "open", delegateFocus: !0 });
  const r = document.createElement("template");
  return r.innerHTML = '<div class="atcb-modal-host-initialized" style="transform:translate3D(0, 0, 0);visibility:visible;opacity:1;position:fixed;top:0;left:0;width:100%;height:100%;display:flex;z-index:13999999;"></div>', i.shadowRoot.append(r.content.cloneNode(!0)), rf(i.shadowRoot, e), await gv(i.shadowRoot, null, e), i.shadowRoot;
}
async function eB(t, e) {
  const n = await Nl(t, e);
  return Rr(n.querySelector(".atcb-modal-host-initialized")), Array.from(t.children).forEach((i) => {
    i.tagName != "STYLE" && n.querySelector(".atcb-modal-host-initialized").append(i.cloneNode(!0));
  }), n.querySelector("button.atcb-button").removeAttribute("id"), t.host.classList.add("atcb-shadow-hide"), t.querySelector(".atcb-initialized").style.opacity = "0", dv(t, n), window.addEventListener("scroll", au), window.addEventListener("resize", au), n.querySelector(".atcb-modal-host-initialized");
}
function tB(t, e) {
  const n = document.createElement("script");
  if (n.id = "atcb-schema-" + t.identifier, e.hasAttribute("cspnonce")) {
    if (/[`'"()[\]{}<>\s]/.test(e.getAttribute("cspnonce")))
      throw new Error("cspnonce input contains forbidden characters.");
    n.setAttribute("nonce", e.getAttribute("cspnonce"));
  }
  n.type = "application/ld+json";
  const a = t.name.replace(/\s/g, ""), i = [];
  if (t.dates.length > 1) {
    const s = [];
    s.push('"@context":"https://schema.org"'), s.push('"@type":"EventSeries"'), s.push('"@id":"' + a + '"'), s.push('"name":"' + t.name + '",'), i.push(`{\r
` + s.join(`,\r
`) + `\r
`);
  }
  const r = [];
  for (let s = 0; s < t.dates.length; s++) {
    const o = [];
    o.push('"@context":"https://schema.org"'), o.push('"@type":"Event"'), t.dates.length > 1 && o.push('"@id":"' + a + "-" + (s + 1) + '"'), t.dates[`${s}`].status.toLowerCase() === "cancelled" ? o.push('"eventStatus":"https://schema.org/EventCancelled"') : o.push('"eventStatus":"https://schema.org/EventScheduled"'), o.push('"name":"' + t.dates[`${s}`].name + '"'), t.dates[`${s}`].descriptionHtmlFree && o.push('"description":"' + t.dates[`${s}`].descriptionHtmlFree + '"');
    const l = _a(t.dates[`${s}`], "delimiters", "general", !0);
    if (o.push('"startDate":"' + l.start + '"'), l.duration && o.push('"duration":"' + l.duration + '"'), o.push(t.dates[`${s}`].onlineEvent ? `"eventAttendanceMode":"https://schema.org/OnlineEventAttendanceMode",\r
"location": {\r
"@type":"VirtualLocation",\r
"url":"` + t.dates[`${s}`].location + `"\r
}` : '"location":"' + t.dates[`${s}`].location + '"'), t.recurrence && t.recurrence !== "" ? o.push(...nB(t, l)) : o.push('"endDate":"' + l.end + '"'), t.dates[`${s}`].organizer && t.dates[`${s}`].organizer !== "") {
      const u = t.dates[`${s}`].organizer.split("|");
      o.push(`"organizer":{\r
"@type":"Person",\r
"name":"` + u[0] + `",\r
"email":"` + u[1] + `"\r
}`);
    }
    const c = [];
    if (t.images && Array.isArray(t.images))
      for (let u = 0; u < t.images.length; u++)
        Ds(t.images[`${u}`], t.debug) && t.images[`${u}`].startsWith("http") && c.push('"' + t.images[`${u}`] + '"');
    c.length > 0 && o.push(`"image":[\r
` + c.join(`,\r
`) + "]"), r.push(`{\r
` + o.join(`,\r
`) + `\r
}`);
  }
  t.dates.length > 1 ? n.textContent = i.join(`,\r
`) + `"subEvents":[\r
` + r.join(`,\r
`) + `\r
]\r
}` : n.textContent = r[0], document.body.insertBefore(n, document.body.firstChild);
}
function nB(t, e) {
  const n = [];
  if (n.push('"eventSchedule": { "@type": "Schedule"'), n.push('"scheduleTimezone":"' + t.dates[0].timeZone + '"'), t.recurrence_interval && t.recurrence_interval !== "" && t.recurrence_frequency && t.recurrence_frequency !== "") {
    const a = "P" + t.recurrence_interval + t.recurrence_frequency.substring(0, 1);
    n.push('"repeatFrequency":"' + a + '"');
  }
  if (t.recurrence_byDay && t.recurrence_byDay !== "") {
    const a = function() {
      if (/\d/.test(t.recurrence_byDay))
        return '"' + t.recurrence_byDay + '"';
      {
        const i = t.recurrence_byDay.split(","), r = {
          MO: "https://schema.org/Monday",
          TU: "https://schema.org/Tuesday",
          WE: "https://schema.org/Wednesday",
          TH: "https://schema.org/Thursday",
          FR: "https://schema.org/Friday",
          SA: "https://schema.org/Saturday",
          SU: "https://schema.org/Sunday"
        }, s = [];
        for (let o = 0; o < i.length; o++)
          s.push('"' + r[i[`${o}`]] + '"');
        return "[" + s.join(",") + "]";
      }
    }();
    n.push('"byDay":' + a);
  }
  if (t.recurrence_byMonth && t.recurrence_byMonth !== "") {
    const a = t.recurrence_byMonth.includes(",") ? "[" + t.recurrence_byMonth + "]" : t.recurrence_byMonth;
    n.push('"byMonth":"' + a + '"');
  }
  if (t.recurrence_byMonthDay && t.recurrence_byMonthDay !== "") {
    const a = t.recurrence_byMonthDay.includes(",") ? "[" + t.recurrence_byMonthDay + "]" : t.recurrence_byMonthDay;
    n.push('"byMonthDay":"' + a + '"');
  }
  return t.recurrence_count && t.recurrence_count !== "" && n.push('"repeatCount":"' + t.recurrence_count + '"'), t.recurrence_until && t.recurrence_until !== "" && n.push('"endDate":"' + t.recurrence_until + '"'), t.startTime && t.startTime !== "" && t.endTime && t.endTime !== "" && (n.push('"startTime":"' + t.startTime + ':00"'), n.push('"endTime":"' + t.endTime + ':00"'), n.push('"duration":"' + e.duration + '"')), n.push('"startDate":"' + t.startDate + '" }'), n;
}
function ys(t, e, n, a = "all", i = !1, r = !1, s = !1) {
  let o = e;
  if (e === "apple" && (o = "ical"), a !== "all" ? a = parseInt(a) - 1 : n.dates.length == 1 && (a = 0), n.subscribe) {
    iB(t, e, o, n, i);
    return;
  }
  if (a !== "all") {
    if (n.dates[`${a}`].status.toLowerCase() === "cancelled" && o !== "ical")
      tr(t, n, "warning", $e("date.status.cancelled", n), $e("date.status.cancelled.cta", n), [], [], i);
    else {
      switch (o) {
        case "ical":
          cv(t, n, e, a, i);
          break;
        case "google":
          sB(n, n.dates[`${a}`], a);
          break;
        case "msteams":
          lB(n, n.dates[`${a}`], a);
          break;
        case "ms365":
          l1(n, n.dates[`${a}`], a);
          break;
        case "outlookcom":
          l1(n, n.dates[`${a}`], a, "outlookcom");
          break;
        case "yahoo":
          oB(n, n.dates[`${a}`], a);
          break;
      }
      const l = document.getElementById(n.identifier + "-modal-host");
      if (l) {
        const u = l.shadowRoot.getElementById(n.identifier + "-" + e + "-" + (a + 1));
        u && u.classList.add("atcb-saved");
      }
      n.dates[`${a}`].status.toLowerCase() !== "cancelled" && Ft[`${n.identifier}`][`${e}`][`${a}`]++, Ft[`${n.identifier}`][`${e}`].filter(function(u) {
        return u < 1;
      }).length == 0 && Zu(t, n, r);
    }
    return;
  }
  aB(t, e, o, n, i, r);
}
function aB(t, e, n, a, i, r) {
  if (n === "ical" && a.dates.every(function(s) {
    return !(s.status.toLowerCase() == "cancelled" || s.organizer != null && s.organizer != "");
  })) {
    cv(t, a, e, "all", i);
    for (let s = 0; s < Ft[`${a.identifier}`][`${e}`].length; s++)
      Ft[`${a.identifier}`][`${e}`][`${s}`]++;
    Zu(t, a, r);
    return;
  }
  if (!r) {
    const s = [e];
    for (let o = 0; o < a.dates.length; o++)
      s.push(o + 1);
    tr(t, a, e, $e("modal.multidate.h", a), $e("modal.multidate.text", a), [], s, i);
  }
}
function iB(t, e, n, a, i) {
  const r = a.icsFile.replace("https://", "webcal://");
  switch (n) {
    case "ical":
      if (Ki() || a.fakeAndroid) {
        s1(a, a.icsFile, e);
        break;
      }
      s1(a, r, e, t, i);
      break;
    case "google":
      rB(a, r);
      break;
    case "ms365":
      o1(a, r, a.name);
      break;
    case "outlookcom":
      o1(a, r, a.name, "outlookcom");
      break;
    case "yahoo":
      if (a.proxy) {
        Oa(a, "yahoo", "", !0);
        return;
      }
      iu(a.icsFile), tr(
        t,
        a,
        "yahoo",
        $e("modal.subscribe.yahoo.h", a),
        $e("modal.clipboard.text", a) + "<br>" + $e("modal.subscribe.yahoo.text", a),
        [
          {
            label: $e("modal.subscribe.yahoo.button", a),
            primary: !0,
            type: "yahoo2nd",
            href: "https://www.yahoo.com/calendar"
          },
          { label: $e("cancel", a) }
        ],
        [],
        i
      );
      return;
    case "yahoo2nd":
      iu(a.icsFile), tr(
        t,
        a,
        "yahoo",
        $e("modal.subscribe.yahoo.h", a),
        $e("modal.clipboard.text", a) + "<br>" + $e("modal.subscribe.yahoo.text", a),
        [
          {
            label: $e("modal.subscribe.yahoo.button", a),
            type: "none",
            href: "https://www.yahoo.com/calendar"
          },
          { label: $e("cancel", a) }
        ],
        [],
        i
      );
      return;
  }
  Zu(t, a);
}
function Zu(t, e, n = !1) {
  const a = t.getElementById(e.identifier);
  a && a.classList.add("atcb-saved"), uB(t, e), n && t.querySelectorAll(".atcb-modal[data-modal-nr]").length < 2 && Sn(t, "close");
}
function s1(t, e, n, a = null, i = !1) {
  if (Nn() && !Rl()) {
    uv(a, e, t, i);
    return;
  }
  Oa(t, n, e, !0);
}
function rB(t, e) {
  const n = "https://calendar.google.com/calendar/u/0/r?cid=", a = "calendar.google.com/calendar?cid=";
  let i = !1;
  const r = function() {
    return /^(?:webcal:\/\/|\/\/)calendar\.google\.com\/.*\?cid=/.test(e) ? (i = !0, e.replace(/^(.)*\?cid=/, "")) : encodeURIComponent(e);
  }();
  if ((Ki() || t.fakeAndroid) && i) {
    Oa(t, "google", "intent://" + a + r + "#Intent;scheme=https;package=com.google.android.calendar;end", !0);
    return;
  }
  if ((Nn() && Rl() || t.fakeIOS) && i) {
    Oa(t, "google", "googlecalendar://" + a + r, !0);
    return;
  }
  Oa(t, "google", n + r, !0);
}
function o1(t, e, n, a = "ms365") {
  const i = [], r = function() {
    return a == "outlookcom" ? "https://outlook.live.com/calendar/0/addfromweb/?" : "https://outlook.office.com/calendar/0/addfromweb/?";
  }();
  i.push("url=" + encodeURIComponent(e)), i.push("name=" + encodeURIComponent(n)), Oa(t, a, r + i.join("&"), !0);
}
function sB(t, e, n = "all") {
  const a = [];
  Br() || t.fakeMobile ? a.push("https://calendar.google.com/calendar/render?action=TEMPLATE&") : a.push("https://calendar.google.com/calendar/r/eventedit?");
  const i = _a(e, "clean", "google");
  a.push("dates=" + encodeURIComponent(i.start) + "%2F" + encodeURIComponent(i.end)), e.timeZone && e.timeZone !== "" && !/GMT[+|-]\d{1,2}|Etc\/U|Etc\/Zulu|CET|CST6CDT|EET|EST|MET|MST|PST8PDT|WET/i.test(e.timeZone) && !i.allday && a.push("ctz=" + e.timeZone), e.name && e.name !== "" && a.push("text=" + encodeURIComponent(e.name));
  const r = [];
  if (e.description && e.description !== "" && r.push(e.description), e.location && e.location !== "" && (a.push("location=" + encodeURIComponent(e.location)), (Nn() || t.fakeIOS) && (r.length > 0 && r.push("<br><br>"), r.push("&#128205;: " + e.location))), r.length > 0 && a.push("details=" + encodeURIComponent(r.join(""))), e.recurrence && e.recurrence !== "" && a.push("recur=" + encodeURIComponent(e.recurrence)), e.availability && e.availability !== "") {
    const o = function() {
      return e.availability == "free" ? "crm=AVAILABLE&trp=false" : "crm=BUSY&trp=true";
    }();
    a.push(o);
  }
  let s = a.join("&");
  Ki() || t.fakeAndroid ? s = "intent://" + s.slice(8) + "#Intent;scheme=https;package=com.google.android.calendar;end" : (Nn() && Rl() || t.fakeIOS) && (s = "googlecalendar://" + s.slice(8)), Oa(t, "google", s, !1, n);
}
function oB(t, e, n = "all") {
  const a = [];
  a.push("https://calendar.yahoo.com/?v=60");
  const i = _a(e, "clean");
  if (i.allday)
    if (i.start === i.end)
      a.push("dur=allday&st=" + encodeURIComponent(i.start));
    else {
      const r = JSON.parse(JSON.stringify(e));
      r.startTime = "00:00", r.endTime = "23:59", r.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const s = _a(r, "clean");
      a.push("st=" + encodeURIComponent(s.start) + "&et=" + encodeURIComponent(s.end));
    }
  else
    a.push("st=" + encodeURIComponent(i.start) + "&et=" + encodeURIComponent(i.end));
  e.name && e.name !== "" && a.push("title=" + encodeURIComponent(e.name)), e.location && e.location !== "" && a.push("in_loc=" + encodeURIComponent(e.location)), e.descriptionHtmlFree && e.descriptionHtmlFree !== "" && a.push("desc=" + encodeURIComponent(e.descriptionHtmlFree)), Oa(t, "yahoo", a.join("&"), !1, n);
}
function l1(t, e, n = "all", a = "ms365") {
  const i = [], r = function() {
    return Br() || t.fakeMobile ? "/calendar/0/deeplink/compose?path=%2Fcalendar%2Faction%2Fcompose&rru=addevent" : "/calendar/action/compose?rru=addevent";
  }(), s = function() {
    return a == "outlookcom" ? "https://outlook.live.com" + r : "https://outlook.office.com" + r;
  }();
  i.push(s);
  const o = _a(e, "delimiters", "microsoft");
  i.push("startdt=" + o.start), i.push("enddt=" + o.end), o.allday && i.push("allday=true"), e.name && e.name !== "" && i.push("subject=" + encodeURIComponent(e.name.replace(/&/g, "&#xFF06;"))), e.location && e.location !== "" && i.push("location=" + encodeURIComponent(e.location)), e.description && e.description !== "" && i.push("body=" + encodeURIComponent(e.description)), Oa(t, a, i.join("&"), !1, n);
}
function lB(t, e, n = "all") {
  const a = [], i = "https://teams.microsoft.com/l/meeting/new?", r = _a(e, "delimiters", "msteams", !0);
  !r.allday || Br() || t.fakeMobile ? (a.push("startTime=" + encodeURIComponent(r.start)), a.push("endTime=" + encodeURIComponent(r.end))) : (a.push("startTime=" + r.start), a.push("endTime=" + r.end)), e.name && e.name !== "" && a.push("subject=" + encodeURIComponent(e.name));
  let s = "";
  e.location && e.location !== "" && (s = e.location, s += " // ", a.push("location=" + encodeURIComponent(s))), e.descriptionHtmlFree && e.descriptionHtmlFree != "" && a.push("content=" + s + encodeURIComponent(e.descriptionHtmlFree)), Oa(t, "msteams", i + a.join("&"), !1, n);
}
function Oa(t, e, n = "", a = !1, i = null, r = "") {
  if (r === "" && (r = nf), t.proxy && t.proKey && t.proKey !== "") {
    const s = a ? "s" : "o", o = function() {
      const c = [];
      return t.attendee && t.attendee !== "" && c.push("attendee=" + encodeURIComponent(t.attendee)), t.customVar && typeof t.customVar == "object" && Object.keys(t.customVar).length > 0 && c.push("customvar=" + encodeURIComponent(JSON.stringify(t.customVar))), t.dates && t.dates.length > 1 && i !== null && i !== "all" && c.push("sub-event=" + i), c.length > 0 ? "?" + c.join("&") : "";
    }();
    if (n = `https://${t.domain ? t.domain : t.dev ? "dev.caldn.net" : "caldn.net"}/${t.proKey}/${s}/${e}${o}`, !Ds(n))
      return;
  }
  if (Ds(n)) {
    const s = window.open(n, r);
    s && s.focus();
  }
}
function cv(t, e, n, a = "all", i = !1) {
  a !== "all" && (a = parseInt(a));
  const r = cB(e, a), s = function() {
    const _ = t.host.getAttribute("attendee") || "", T = t.host.getAttribute("customVar") || "";
    return e.attendee && e.attendee !== "" && _ !== "" || e.customVar && e.customVar !== "" && T !== "" ? "" : a !== "all" && e.dates[`${a}`].icsFile && e.dates[`${a}`].icsFile !== "" ? e.dates[`${a}`].icsFile : e.icsFile && e.icsFile !== "" ? e.icsFile : "";
  }();
  if (e.proxy) {
    Oa(e, n, "", !1, a);
    return;
  }
  if (s !== "" && (!Nn() && !e.fakeIOS || !X0() || e.bypassWebViewCheck)) {
    c1(s, r);
    return;
  }
  const o = /* @__PURE__ */ new Date(), l = ["BEGIN:VCALENDAR", "VERSION:2.0"];
  l.push("PRODID:-// https://add-to-calendar-pro.com // button v" + Q2 + " //EN"), l.push("CALSCALE:GREGORIAN"), a == "all" ? l.push("METHOD:PUBLISH") : e.dates[`${a}`].status && e.dates[`${a}`].status.toLowerCase() === "cancelled" ? l.push("METHOD:CANCEL") : e.dates[`${a}`].organizer && e.dates[`${a}`].organizer != "" ? l.push("METHOD:REQUEST") : l.push("METHOD:PUBLISH");
  const c = [], u = function() {
    return a != "all" ? a : 0;
  }(), f = function() {
    return a != "all" ? a : e.dates.length - 1;
  }();
  for (let _ = u; _ <= f; _++) {
    const T = _a(e.dates[`${_}`], "clean", "ical"), g = function() {
      if (T.allday)
        return ";VALUE=DATE";
      if (e.dates[`${_}`].timeZone && e.dates[`${_}`].timeZone !== "") {
        const x = lP(e.dates[`${_}`].timeZone);
        return c.includes(e.dates[`${_}`].timeZone) || l.push(x[0]), c.push(e.dates[`${_}`].timeZone), ";" + x[1];
      }
    }();
    if (l.push("BEGIN:VEVENT"), e.dates[`${_}`].uid && e.dates[`${_}`].uid !== "" && l.push("UID:" + e.dates[`${_}`].uid), l.push("DTSTAMP:" + la(o, "clean", !0)), l.push("DTSTART" + g + ":" + T.start), l.push("DTEND" + g + ":" + T.end), l.push("SUMMARY:" + Jr(e.dates[`${_}`].name, !0)), e.dates[`${_}`].descriptionHtmlFreeICal && e.dates[`${_}`].descriptionHtmlFreeICal !== "" && l.push("DESCRIPTION:" + Jr(e.dates[`${_}`].descriptionHtmlFreeICal, !0)), e.dates[`${_}`].description && e.dates[`${_}`].description !== "" && l.push(`X-ALT-DESC;FMTTYPE=text/html:\r
 <!DOCTYPE HTML PUBLIC ""-//W3C//DTD HTML 3.2//EN"">\r
 <HTML><BODY>\r
 ` + Jr(e.dates[`${_}`].description, !0) + `\r
 </BODY></HTML>`), e.dates[`${_}`].location && e.dates[`${_}`].location !== "" && l.push("LOCATION:" + Jr(e.dates[`${_}`].location, !0)), e.dates[`${_}`].organizer && e.dates[`${_}`].organizer !== "") {
      const x = e.dates[`${_}`].organizer.split("|");
      l.push("ORGANIZER;CN=" + Jr(x[0], !1, !0) + ":MAILTO:" + x[1]);
    }
    if (e.dates[`${_}`].attendee && e.dates[`${_}`].attendee !== "") {
      const x = e.dates[`${_}`].attendee.split("|");
      x.length === 2 ? l.push("ATTENDEE;CUTYPE=INDIVIDUAL;ROLE=REQ-PARTICIPANT;PARTSTAT=ACCEPTED;CN=" + Jr(x[0], !1, !0) + ";X-NUM-GUESTS=0:mailto:" + x[1]) : l.push("ATTENDEE;CUTYPE=INDIVIDUAL;ROLE=REQ-PARTICIPANT;PARTSTAT=ACCEPTED;CN=" + x[0] + ";X-NUM-GUESTS=0:mailto:" + x[0]);
    }
    if (e.recurrence && e.recurrence !== "" && l.push(e.recurrence), e.dates[`${_}`].availability && e.dates[`${_}`].availability !== "") {
      const x = function() {
        return e.dates[`${_}`].availability == "free" ? "TRANSPARENT" : "OPAQUE";
      }();
      l.push("TRANSP:" + x);
    }
    l.push("SEQUENCE:" + e.dates[`${_}`].sequence), l.push("STATUS:" + e.dates[`${_}`].status), l.push("CREATED:" + e.created), l.push("LAST-MODIFIED:" + e.updated), l.push("END:VEVENT");
  }
  l.push("END:VCALENDAR");
  const m = function() {
    return s != "" ? s : "data:text/calendar;charset=utf-8," + encodeURIComponent(l.join(`\r
`));
  }();
  if (Nn() && !Rl() || X0() && (Nn() || Ki() && uP())) {
    uv(t, m, e, i);
    return;
  }
  c1(m, r);
}
function cB(t, e) {
  const n = function() {
    return e != "all" && e != 0 ? "-" + parseInt(e) + 1 : "";
  }();
  if (t.iCalFileName != null && t.iCalFileName != "")
    return t.iCalFileName + n;
  if (t.icsFile != null && t.icsFile != "") {
    const a = t.icsFile.split("/").pop().split(".")[0];
    if (a != "")
      return a + n;
  }
  return "event-to-save-in-my-calendar" + n;
}
function uv(t, e, n, a) {
  if (iu(e), Nn() && !Rl()) {
    tr(
      t,
      n,
      "warning",
      $e("modal.opensafari.ical.h", n),
      $e("modal.opensafari.ical.text", n) + "<br>" + $e("modal.clipboard.text", n) + "<br>" + $e("modal.opensafari.ical.steps", n),
      [],
      [],
      a
    );
    return;
  }
  tr(t, n, "warning", $e("modal.webview.ical.h", n), $e("modal.webview.ical.text", n) + "<br>" + $e("modal.clipboard.text", n) + "<br>" + $e("modal.webview.ical.steps", n), [], [], a);
}
function uB(t, e) {
  on("success", e.identifier, e.identifier), e.ty && typeof a1 == "function" && setTimeout(() => {
    a1(t, e);
  }, 1e3);
}
function c1(t, e) {
  try {
    const n = document.createElementNS("http://www.w3.org/1999/xhtml", "a");
    n.rel = "noopener", n.href = t, Br() ? n.target = "_self" : n.target = "_blank", n.download = e + ".ics";
    const a = new MouseEvent("click", {
      view: window,
      button: 0,
      bubbles: !0,
      cancelable: !1
    });
    n.dispatchEvent(a), (window.URL || window.webkitURL).revokeObjectURL(n.href);
  } catch (n) {
    console.error(n);
  }
}
function _a(t, e = "delimiters", n = "general", a = !1) {
  if (t.startTime && t.startTime !== "" && t.endTime && t.endTime !== "") {
    const i = /* @__PURE__ */ new Date(t.startDate + "T" + t.startTime + ":00.000+00:00");
    t.endDate || (t.endDate = t.startDate);
    const r = /* @__PURE__ */ new Date(t.endDate + "T" + t.endTime + ":00.000+00:00"), s = r - i, o = Math.floor(s / 1e3 / 60 / 60), l = Math.floor((s - o * 60 * 60 * 1e3) / 1e3 / 60 % 60), c = function() {
      return o < 10 ? "0" + o + ":" + ("0" + l).slice(-2) : o + ":" + ("0" + l).slice(-2);
    }();
    if (n == "ical" || n == "google" && !/GMT[+|-]\d{1,2}|Etc\/U|Etc\/Zulu|CET|CST6CDT|EET|EST|MET|MST|PST8PDT|WET/i.test(t.timeZone))
      return {
        start: la(i, "clean", !0, !0),
        end: la(r, "clean", !0, !0),
        duration: c,
        allday: !1
      };
    const u = eu(t.timeZone, t.startDate, t.startTime), f = eu(t.timeZone, t.endDate, t.endTime);
    if (a) {
      const T = u.slice(0, 3) + ":" + u.slice(3), g = f.slice(0, 3) + ":" + f.slice(3);
      return {
        start: i.toISOString().replace(".000Z", T),
        end: r.toISOString().replace(".000Z", g),
        duration: c,
        allday: !1
      };
    }
    const m = parseInt(u[0] + 1) * -1 * ((parseInt(u.substring(1, 3)) * 60 + parseInt(u.substring(3, 5))) * 60 * 1e3), _ = parseInt(f[0] + 1) * -1 * ((parseInt(f.substring(1, 3)) * 60 + parseInt(f.substring(3, 5))) * 60 * 1e3);
    return i.setTime(i.getTime() + m), r.setTime(r.getTime() + _), {
      start: la(i, e),
      end: la(r, e),
      duration: c,
      allday: !1
    };
  } else {
    const i = t.startDate.split("-"), r = t.endDate ? t.endDate.split("-") : i, s = new Date(Date.UTC(i[0], i[1] - 1, i[2], 12, 0, 0)), o = new Date(Date.UTC(r[0], r[1] - 1, r[2], 12, 0, 0));
    if ((n === "google" || n === "microsoft" && !Br() || n === "msteams" || n === "ical") && o.setDate(o.getDate() + 1), n === "msteams") {
      if (Br()) {
        const l = s.getTimezoneOffset(), c = function() {
          return l < 0 ? "+" + ("0" + Math.abs(l / 60)).slice(-2) + ":" + ("0" + Math.abs(l % 60)).slice(-2) : "-" + ("0" + Math.abs(l / 60)).slice(-2) + ":" + ("0" + Math.abs(l % 60)).slice(-2);
        }();
        return {
          start: la(s, e, !1, !0) + "T00:00:00" + c,
          end: la(o, e, !1, !0) + "T00:00:00" + c,
          allday: !0
        };
      }
      return {
        start: la(s, e, !1, !0) + "+00:00",
        end: la(o, e, !1, !0) + "+00:00",
        allday: !0
      };
    }
    return {
      start: la(s, e, !1),
      end: la(o, e, !1),
      allday: !0
    };
  }
}
function la(t, e = "delimiters", n = !0, a = !1) {
  const i = function() {
    return n ? e == "clean" ? /(-|:|(\.\d{3}))/g : /(\.\d{3})/g : e == "clean" ? /(-|T(\d{2}:\d{2}:\d{2}\.\d{3})Z)/g : /T(\d{2}:\d{2}:\d{2}\.\d{3})Z/g;
  }();
  return a ? t.toISOString().replace(i, "").replace("Z", "") : t.toISOString().replace(i, "");
}
function dB(t) {
  const e = t[0] === "+" ? 1 : -1, n = parseInt(t.substring(1, 3), 10), a = parseInt(t.substring(3, 5), 10);
  return (n * 60 + a) * e * 6e4;
}
function u1(t, e, n, a) {
  const i = /* @__PURE__ */ new Date(`${t}T${e}:00Z`), r = eu(n, t, e), s = new Date(i.getTime() - dB(r));
  return [t, e] = new Intl.DateTimeFormat("en-CA", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    timeZone: a,
    hourCycle: "h23"
  }).format(s).split(", ");
}
function hB(t, e = "en", n = "all", a = !1, i = !1, r = !1, s = !1) {
  if (a) {
    const z = ev();
    t = tv({ dates: t, timeZone: z }).dates;
  }
  let o, l, c, u, f = {}, m = {}, _ = [], T = "", g = "";
  const x = Intl.DateTimeFormat().resolvedOptions().timeZone;
  n === "all" ? (f = _a(t[0]), m = _a(t[t.length - 1]), c = i ? x : t[0].timeZone, u = i ? x : t[t.length - 1].timeZone) : (f = _a(t[`${n}`]), m = f, c = i ? x : t[`${n}`].timeZone, u = c), o = new Date(f.start), l = new Date(m.end), f.allday && (c = "GMT"), m.allday && (u = "GMT");
  const S = ["global", "world-wide", "worldwide", "online"];
  (function() {
    let z = 0, W = t.length - 1;
    for (n != "all" && (z = W = n), z; z <= W; z++)
      if (!function() {
        return !!(t[`${z}`].location && t[`${z}`].location !== "" && S.includes(t[`${z}`].location.toLowerCase()));
      }() && !t[`${z}`].onlineEvent)
        return !1;
    return !0;
  })() ? c = u = x : (!f.allday && x !== c && c !== u && (T = "(" + c + ")"), (!m.allday && x !== u || c !== u) && (g = "(" + u + ")"));
  const L = /* @__PURE__ */ new Date(), M = function() {
    return !r && o.getFullYear() === L.getFullYear();
  }(), E = function() {
    return !r && l.getFullYear() === L.getFullYear();
  }(), P = d1(c, M, e), B = d1(u, E, e);
  if (o.toLocaleDateString(e, B.DateLong) === l.toLocaleDateString(e, B.DateLong))
    if (f.allday)
      M || _.push(o.toLocaleDateString(e, P.DateLong));
    else {
      let z = "";
      M ? z = o.toLocaleString(e, P.Time) : z = o.toLocaleString(e, P.DateTimeLong), e === "en" && (z = z.replace(/:00/, "")), _.push(z), T !== "" && !s && _.push(T), _.push("-"), z = l.toLocaleTimeString(e, B.Time), e === "en" && (z = z.replace(/:00/, "")), _.push(z), g !== "" && !s && _.push(g);
    }
  else {
    if (f.allday)
      _.push(o.toLocaleDateString(e, P.DateLong));
    else {
      let z = "";
      M ? z = o.toLocaleString(e, P.Time) : z = o.toLocaleString(e, P.DateTimeLong), e === "en" && (z = z.replace(/:00/, "")), _.push(z);
    }
    if (T !== "" && !s && _.push(T), _.push("-"), m.allday)
      _.push(l.toLocaleDateString(e, B.DateLong));
    else {
      let z = l.toLocaleString(e, B.DateTimeLong);
      e === "en" && (z = z.replace(/:00/, "")), _.push(z);
    }
    g !== "" && !s && _.push(g);
  }
  return _;
}
function d1(t, e = !1, n = "en") {
  const a = /* @__PURE__ */ function() {
    return n === "en" ? "h12" : "h23";
  }();
  return e ? {
    DateLong: {
      timeZone: t,
      month: "short",
      day: "numeric"
    },
    DateTimeLong: {
      timeZone: t,
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hourCycle: a
    },
    Time: {
      timeZone: t,
      hour: "numeric",
      minute: "2-digit",
      hourCycle: a
    }
  } : {
    DateLong: {
      timeZone: t,
      year: "numeric",
      month: "numeric",
      day: "numeric"
    },
    DateTimeLong: {
      timeZone: t,
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hourCycle: a
    },
    Time: {
      timeZone: t,
      hour: "numeric",
      minute: "2-digit",
      hourCycle: a
    }
  };
}
function _l(t, e = !0) {
  const a = (e ? JSON.stringify(t) : t.toString()).replace(/(<(?!br)([^>]+)>)/gi, "");
  return e ? JSON.parse(a) : a;
}
function Ds(t, e = !0) {
  return t && t.match(/((\.\.\/)|(\.\.\\)|(%2e%2e%2f)|(%252e%252e%252f)|(%2e%2e\/)|(%252e%252e\/)|(\.\.%2f)|(\.\.%252f)|(%2e%2e%5c)|(%252e%252e%255c)|(%2e%2e\\)|(%252e%252e\\)|(\.\.%5c)|(\.\.%255c)|(\.\.%c0%af)|(\.\.%25c0%25af)|(\.\.%c1%9c)|(\.\.%25c1%259c))/gi) ? (e && console.error("Seems like the generated URL includes at least one security issue and got blocked. Please check the calendar button parameters!"), !1) : !0;
}
function nu(t) {
  return !!/^.{0,70}@.{1,30}\.[a-z]{2,9}$/i.test(t);
}
function _s(t, e = !1, n = !1) {
  return e ? (n ? t = t.replace(/(\[br\s?\/?\]|\{br\s?\/?\}|(\[\/p\](?=.))|(\{\/p\}(?=.)))/gi, "\\n") : t = t.replace(/(\[br\s?\/?\]|\{br\s?\/?\}|(\[\/p\](?=.))|(\{\/p\}(?=.)))/gi, " "), t = t.replace(/\[url\](.+?)\[\/url\]/gi, (a, i) => i.split("|")[0]), t = t.replace(/\{url\}(.+?)\{\/url\}/gi, (a, i) => i.split("|")[0]), t = t.replace(/\[\/?(hr|[pbui]|strong|em|li|ul|ol|h\d)\]/gi, ""), t = t.replace(/\{\/?(hr|[pbui]|strong|em|li|ul|ol|h\d)\}/gi, ""), t = t.replace(/&[#a-z0-9]{1,9};/gi, "")) : (t = t.replace(/\[url\]((?:(?!\[\/url\]).)*)\[\/url\]/gi, function(a, i) {
    return h1(i);
  }), t = t.replace(/\{url\}((?:(?!\[\/url\]).)*)\{\/url\}/gi, function(a, i) {
    return h1(i);
  }), t = t.replace(/\[(\/)?(br|hr|[pbui]|strong|em|li|ul|ol|h\d)(\s?\/?)\]/gi, "<$1$2$3>"), t = t.replace(/\{(\/)?(br|hr|[pbui]|strong|em|li|ul|ol|h\d)(\s?\/?)\}/gi, "<$1$2$3>")), t;
}
function h1(t) {
  const e = t.split("|"), n = function() {
    return e.length > 1 && e[1] != "" ? e[1] : e[0];
  }();
  return '<a href="' + e[0] + '" target="' + nf + '" rel="noopener">' + n + "</a>";
}
function Jr(t, e = !0, n = !1) {
  return n ? t = t.replace(/"/g, "") : t = t.replace(/\\/g, "\\\\").replace(/(,|;)/g, "\\$1").replace(/\\\\n/g, "\\n"), e && (t = t.replace(/.{60}/g, `$&\r
 `)), t;
}
function r0(t, e, n, a = !1, i = !1) {
  let r = !1;
  const s = e;
  e.querySelector(".atcb-dropdown-anchor") !== null && (e = e.querySelector(".atcb-dropdown-anchor"), r = !0), n.style.position = "relative", n.style.display = "inline-block";
  let o = e.getBoundingClientRect();
  const l = s.getBoundingClientRect(), c = s.parentNode.getBoundingClientRect(), u = document.documentElement.clientHeight;
  if (r === !0 && !n.classList.contains("atcb-dropoverlay")) {
    let m = n.getBoundingClientRect();
    n.style.width = m.width + "px", n.classList.contains("atcb-dropup") || !a && o.top + m.height > u - 20 && 2 * l.top + l.height - o.top - m.height > 20 || i ? (s.classList.add("atcb-dropup"), n.classList.add("atcb-dropup"), n.style.bottom = c.bottom - l.bottom + (o.top - l.top) + "px") : (n.style.top = l.top - c.top + (o.top - l.top) + "px", s.classList.contains("atcb-dropup") && s.classList.remove("atcb-dropup")), o = e.getBoundingClientRect(), !n.classList.contains("atcb-style-round") && !n.classList.contains("atcb-style-text") && !n.classList.contains("atcb-style-neumorphism") && (n.style.minWidth = o.width + "px", n.classList.contains("atcb-dropdown") && (n.style.maxWidth = o.width + "px")), m = n.getBoundingClientRect(), n.style.left = Math.round(o.left - c.left - (m.width - o.width) / 2) + "px";
  } else {
    n.style.minWidth = l.width + 20 + "px";
    const m = n.getBoundingClientRect();
    n.style.width = m.width + "px";
    const _ = Math.round((l.width - m.width) / 2);
    n.style.margin = -Math.round((m.height + l.height) / 2) + "px " + _ + "px 0 " + _ + "px";
  }
  n.style.position = "absolute", n.style.display = "block";
  const f = t.querySelector("#atcb-reference");
  f && s.classList.contains("atcb-dropup") && (s.parentNode.after(f), f.classList.add("atcb-dropup"));
}
function dv(t, e) {
  const n = t.querySelector(".atcb-initialized ").getBoundingClientRect(), a = e.querySelector(".atcb-initialized");
  let i = n.width;
  n.width < 250 && (i = 250), a.style.width = i + "px", a.style.height = n.height + "px", a.style.top = n.top + "px", a.style.left = n.left + "px";
}
function au() {
  const t = Ft.active;
  if (t !== null && t !== "") {
    const e = document.querySelector("add-to-calendar-button[atcb-button-id=" + t + "]").shadowRoot, n = document.querySelector("div[atcb-button-id=" + t + "]").shadowRoot;
    dv(e, n);
  }
}
function af(t, e = null) {
  const n = function() {
    if (e != null)
      return e;
    {
      const i = t.querySelectorAll(".atcb-modal");
      return i.length === 0 ? null : i[i.length - 1];
    }
  }();
  if (n == null)
    return;
  n.getBoundingClientRect().height + 150 > window.innerHeight ? (document.body.classList.add("atcb-modal-no-scroll"), document.documentElement.classList.add("atcb-modal-no-scroll")) : (document.body.classList.remove("atcb-modal-no-scroll"), document.documentElement.classList.remove("atcb-modal-no-scroll"));
}
function Rr(t) {
  t.style.width = window.innerWidth + "px", t.style.height = window.innerHeight + 100 + "px";
}
function Tl(t, e) {
  t.style.setProperty("--base-font-size-l", e.l + "px"), t.style.setProperty("--base-font-size-m", e.m + "px"), t.style.setProperty("--base-font-size-s", e.s + "px");
}
function hv() {
  return ("10000000-1000-4000-8000" + -1e11).replace(/[018]/g, (e) => (e ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> e / 4).toString(16));
}
function iu(t) {
  const e = document.createElement("input");
  document.body.append(e);
  const n = e.contentEditable, a = e.readOnly;
  if (e.contentEditable = !0, e.readOnly = !1, e.value = t, Nn()) {
    var i = document.createRange();
    i.selectNodeContents(e);
    var r = window.getSelection();
    r.removeAllRanges(), r.addRange(i), e.setSelectionRange(0, 999999);
  } else
    e.select();
  e.contentEditable = n, e.readOnly = a, document.execCommand("copy"), e.remove();
}
function ds(t, e = 200) {
  let n;
  return (...a) => {
    clearTimeout(n), n = setTimeout(() => {
      t.apply(this, a);
    }, e);
  };
}
function wr(t, e = 300) {
  let n;
  return (...a) => {
    n || t.apply(this, a), clearTimeout(n), n = setTimeout(() => {
      n = void 0;
    }, e);
  };
}
function on(t, e, n) {
  const a = function() {
    const i = document.getElementById(n);
    return i || document.querySelector('[atcb-button-id="' + n + '"]');
  }();
  a && a.setAttribute("atcb-last-event", t + ":" + e), Ii() && fB(t, e);
}
function fB(t, e) {
  let n = "";
  switch (t) {
    case "initialization":
      n = "Initialized";
      break;
    case "openList":
      n = "Opened";
      break;
    case "closeList":
      n = "Closed";
      break;
    case "openCalendarLink":
      n = "Opened";
      break;
    case "openSingletonLink":
      n = "Opened";
      break;
    case "openSubEventLink":
      n = "Opened";
      break;
    case "openRSVP":
      n = "Opened";
      break;
    case "success":
      n = "Saved";
      break;
    case "successRSVP":
      n = "Saved";
      break;
  }
  const a = t === "openRSVP" || t === "successRSVP" ? "Add-to-Calendar-RSVP" : "Add-to-Calendar-Button";
  (window.dataLayer = window.dataLayer || []).push({
    eventCategory: a,
    eventAction: n,
    eventLabel: e,
    event: t
  });
}
const pB = ["ar", "fa"], Bt = {
  apple: "Apple",
  google: "Google",
  ms365: "Microsoft 365",
  msteams: "Microsoft Teams",
  outlookcom: "Outlook.com",
  yahoo: "Yahoo"
}, Q0 = {
  en: {
    "label.addtocalendar": "Add to Calendar",
    ical: "iCal File",
    ...Bt,
    "modal.button.default": "Click me",
    "modal.webview.ical.h": "Open your browser",
    "modal.webview.ical.text": "Unfortunately, in-app browsers have problems with the way we generate the calendar file.",
    "modal.clipboard.text": "We automatically copied a magical URL into your clipboard.",
    "modal.webview.ical.steps": "<ol><li><strong>Open another browser</strong> on your phone, ...</li><li><strong>Paste</strong> the clipboard content and go.</li></ol>",
    "modal.opensafari.ical.h": "Open Safari",
    "modal.opensafari.ical.text": "Unfortunately, iOS has some problems generating and opening the calendar file outside of Safari.",
    "modal.opensafari.ical.steps": "<ol><li><strong>Open Safari</strong>, ...</li><li><strong>Paste</strong> the clipboard content and go.</li></ol>",
    "modal.multidate.h": "This is an event series",
    "modal.multidate.text": "Add the individual events one by one:",
    "date.status.cancelled": "This date got cancelled.",
    "date.status.cancelled.cta": "Please update your calendar!",
    "modal.subscribe.yahoo.h": "Add Calendar to Yahoo",
    "modal.subscribe.yahoo.text": '<ol><li>Open now the Yahoo Calendar.</li><li>Click the "Actions" tab.</li><li>Hit "Follow Other Calendars".</li><li>Set a name and paste the clipboard content into the url field.</li></ol>',
    "modal.subscribe.yahoo.button": "Open Yahoo Calendar",
    close: "Close",
    continue: "Continue",
    cancel: "Cancel",
    expired: "Expired",
    recurring: "Recurring",
    thankyou: "Thank you",
    submit: "Submit",
    "label.rsvp": "RSVP",
    "label.share.email": "Share via Email",
    "label.share.copy": "Copy Link",
    "label.share.copied": "Copied",
    "label.share.email.subject": "Save this event",
    "form.error.required": "You did not properly fill all required fields",
    "form.error.sending": "There was a problem sending your response. Please try again later",
    "form.success": "Sent successfully!"
  },
  de: {
    "label.addtocalendar": "Im Kalender speichern",
    ical: "iCal-Datei",
    ...Bt,
    "modal.button.default": "Klick mich",
    "modal.webview.ical.h": "Öffne deinen Browser",
    "modal.webview.ical.text": "Leider haben In-App-Browser Probleme mit der Art, wie wir Kalender-Dateien erzeugen.",
    "modal.clipboard.text": "Wir haben automatisch eine magische URL in deine Zwischenablage kopiert.",
    "modal.webview.ical.steps": "<ol><li><strong>Öffne einen anderen Browser</strong> auf deinem Smartphone, ...</li><li>Nutze die <strong>Einfügen</strong>-Funktion, um fortzufahren.</li></ol>",
    "modal.opensafari.ical.h": "Öffne Safari",
    "modal.opensafari.ical.text": "Leider hat iOS einige Probleme beim Generieren und Öffnen der Kalenderdatei außerhalb von Safari.",
    "modal.opensafari.ical.steps": "<ol><li><strong>Öffne Safari</strong>, ...</li><li>Nutze die <strong>Einfügen</strong>-Funktion, um fortzufahren.</li></ol>",
    "modal.multidate.h": "Dies ist eine Termin-Reihe",
    "modal.multidate.text": "Füge die einzelnen Termine der Reihe nach deinem Kalender hinzu:",
    "date.status.cancelled": "Dieser Termin wurde abgesagt.",
    "date.status.cancelled.cta": "Bitte aktualisiere deinen Kalender!",
    "modal.subscribe.yahoo.h": "Kalender zu Yahoo hinzufügen",
    "modal.subscribe.yahoo.text": '<ol><li>Öffne den Yahoo-Kalender.</li><li>Klicke auf den "Aktionen"-Tab.</li><li>Wähle "Weiteren Kalendern folgen".</li><li>Wähle einen Namen und füge die URL aus deiner Zwischenablage in das URL-Feld ein.</li></ol>',
    "modal.subscribe.yahoo.button": "Yahoo-Kalender öffnen",
    close: "Schließen",
    continue: "Weiter",
    cancel: "Abbrechen",
    expired: "Abgelaufen",
    recurring: "Wiederkehrend",
    thankyou: "Danke",
    submit: "Absenden",
    "label.share.email": "Per E-Mail teilen",
    "label.share.copy": "Link kopieren",
    "label.share.copied": "Kopiert",
    "label.share.email.subject": "Merke dir diesen Termin",
    "form.error.required": "Du hast nicht alle erforderlichen Felder korrekt ausgefüllt",
    "form.error.sending": "Es gab ein Problem beim Senden deiner Antwort. Bitte versuche es später noch einmal",
    "form.success": "Erfolgreich gesendet!"
  },
  es: {
    "label.addtocalendar": "Añadir al Calendario",
    ical: "iCal Ficha",
    ...Bt,
    "modal.button.default": "Haz clic mí",
    "modal.webview.ical.h": "Abra su browser",
    "modal.webview.ical.text": "Lamentablemente, los browsers in-app tienen problemas con la forma en que generamos el archivo del calendario.",
    "modal.clipboard.text": "Hemos copiado automáticamente una URL mágica en su portapapeles.",
    "modal.webview.ical.steps": "<ol><li><strong>Abre otro browser</strong> en tu smartphone, ...</li><li>Utilice la función de <strong>pegar</strong> para continuar.</li></ol>",
    "modal.opensafari.ical.h": "Abrir Safari",
    "modal.opensafari.ical.text": "Desafortunadamente, iOS tiene algunos problemas para generar y abrir el archivo de calendario fuera de Safari.",
    "modal.opensafari.ical.steps": "<ol><li><strong>Abrir Safari</strong>, ...</li><li>Utilice la función de <strong>pegar</strong> para continuar.</li></ol>",
    "modal.multidate.h": "Esta es una serie de fechas",
    "modal.multidate.text": "Añada las fechas individuales a su calendario en orden:",
    "date.status.cancelled": "Esta fecha fue cancelada.",
    "date.status.cancelled.cta": "Actualice su calendario!",
    "modal.subscribe.yahoo.h": "Añadir calendario a Yahoo",
    "modal.subscribe.yahoo.text": '<ol><li>Abra el calendario de Yahoo.</li><li>Haga clic en la pestaña "Acciones".</li><li>Seleccione "Seguir otros calendarios".</li><li>Elige un nombre y pega la URL de tu portapapeles en el campo URL.</li></ol>',
    "modal.subscribe.yahoo.button": "Abrir calendario de Yahoo",
    close: "Ciérralo",
    continue: "Continuar",
    cancel: "Cancelar",
    expired: "Caducada",
    recurring: "Periódica",
    thankyou: "Gracias",
    submit: "Enviar",
    "label.share.email": "Compartir por E-mail",
    "label.share.copy": "Copiar enlace",
    "label.share.copied": "Copiado",
    "label.share.email.subject": "Recuerda esta fecha",
    "form.error.required": "No has completado correctamente todos los campos requeridos",
    "form.error.sending": "Hubo un problema al enviar tu respuesta. Por favor, inténtalo de nuevo más tarde",
    "form.success": "Enviado con éxito!"
  },
  pt: {
    "label.addtocalendar": "Incluir no Calendário",
    ical: "Ficheiro iCal",
    ...Bt,
    "modal.button.default": "Clicar-me",
    "modal.webview.ical.h": "Abra o seu browser",
    "modal.webview.ical.text": "Infelizmente, os navegadores em tampas têm problemas com a forma como geramos o ficheiro de calendário.",
    "modal.clipboard.text": "Copiámos automaticamente um URL mágico para a sua área de transferência.",
    "modal.webview.ical.steps": "<ol><li><strong>Abrir outro browser</strong> en tu smartphone, ...</li><li>Use a função <forte>colar</strong> para continuar.</li></ol>",
    "modal.opensafari.ical.h": "Safari aberto",
    "modal.opensafari.ical.text": "Infelizmente, o iOS tem alguns problemas para gerar e abrir o arquivo de calendário fora do Safari.",
    "modal.opensafari.ical.steps": "<ol><li><strong>Safari aberto</strong>, ...</li><li>Use a função <forte>colar</strong> para continuar.</li></ol>",
    "modal.multidate.h": "Esta é uma série de datas",
    "modal.multidate.text": "Adicione as datas individuais ao seu calendário, por ordem:",
    "date.status.cancelled": "Esta data foi cancelada.",
    "date.status.cancelled.cta": "Actualize o seu calendário!",
    "modal.subscribe.yahoo.h": "Adicionar calendário ao Yahoo",
    "modal.subscribe.yahoo.text": '<ol><li>Abrir o calendário do Yahoo.</li><li>Clique no separador "Acções".</li><li>Seleccione "Seguir outros calendários".</li><li>Escolha um nome e cole o URL da sua área de transferência no campo URL.</li></ol>',
    "modal.subscribe.yahoo.button": "Abra o Calendário do Yahoo",
    close: "Fechar",
    continue: "Continuar",
    cancel: "Cancelar",
    expired: "Expirada",
    recurring: "Recorrente",
    thankyou: "Obrigado",
    submit: "Enviar",
    "label.share.email": "Compartilhar por e-mail",
    "label.share.copy": "Copiar link",
    "label.share.copied": "Copiado",
    "label.share.email.subject": "Lembre-se desta data",
    "form.error.required": "Você não preencheu todos os campos obrigatórios corretamente",
    "form.error.sending": "Houve um problema ao enviar sua resposta. Por favor, tente novamente mais tarde",
    "form.success": "Enviado com sucesso!"
  },
  fr: {
    "label.addtocalendar": "Ajouter à l'Agenda",
    ical: "Fichier iCal",
    ...Bt,
    "modal.button.default": "Cliquez-moi",
    "modal.webview.ical.h": "Ouvrez votre navigateur",
    "modal.webview.ical.text": "Malheureusement, les navigateurs intégrés aux applications ont des problèmes avec la manière dont nous créons les fichiers de calendrier.",
    "modal.clipboard.text": "Nous avons automatiquement copié une URL magique dans votre presse-papier.",
    "modal.webview.ical.steps": "<ol><li><strong>Ouvrez un autre navigateur</strong> sur votre smartphone ;</li><li><strong>Collez</strong> le contenu du presse-papier et continuez.</li></ol>",
    "modal.opensafari.ical.h": "Ouvrir Safari",
    "modal.opensafari.ical.text": "Malheureusement, iOS rencontre des problèmes pour générer et ouvrir le fichier de calendrier en dehors de Safari.",
    "modal.opensafari.ical.steps": "<ol><li><strong>Ouvrez Safari</strong> ;</li><li><strong>Collez</strong> le contenu du presse-papier et continuez.</li></ol>",
    "modal.multidate.h": "Ceci est une liste d’évènements",
    "modal.multidate.text": "Ajouter les évènements un par un :",
    "date.status.cancelled": "Cet évènement est annulé.",
    "date.status.cancelled.cta": "Actualisez votre agenda !",
    "modal.subscribe.yahoo.h": "Ajouter un agenda à Yahoo",
    "modal.subscribe.yahoo.text": "<ol><li>Ouvrez l’Agenda Yahoo ;</li><li>Cliquez sur l’onglet « Actions » ;</li><li>Sélectionnez « Suivre d’autres agendas » ;</li><li>Choisissez un nom et collez le contenu de votre presse-papier dans le champ URL.</li></ol>",
    "modal.subscribe.yahoo.button": "Ouvrir le calendrier Yahoo",
    close: "Fermer",
    continue: "Continuer",
    cancel: "Annuler",
    expired: "Expiré",
    recurring: "Récurrent",
    thankyou: "Merci",
    submit: "Envoyer",
    "label.share.email": "Partager par E-mail",
    "label.share.copy": "Copier le lien",
    "label.share.copied": "Copié",
    "label.share.email.subject": "Retenez cette date",
    "form.error.required": "Tu n'as pas correctement rempli tous les champs requis",
    "form.error.sending": "Il y a eu un problème lors de l'envoi de ta réponse. Veuillez réessayer plus tard",
    "form.success": "Envoyé avec succès!"
  },
  nl: {
    "label.addtocalendar": "Opslaan in Agenda",
    ical: "iCal File",
    ...Bt,
    "modal.button.default": "Klik me",
    "modal.webview.ical.h": "Open uw browser",
    "modal.webview.ical.text": "Helaas hebben in-app browsers problemen met de manier waarop wij kalenderbestanden maken.",
    "modal.clipboard.text": "We hebben automatisch een magische URL naar je klembord gekopieerd.",
    "modal.webview.ical.steps": "<ol><li><strong>Open een andere browser</strong> op uw smartphone, ...</li><li>Gebruik de <strong>insert</strong> functie om verder te gaan.</li></ol>",
    "modal.opensafari.ical.h": "Open Safari",
    "modal.opensafari.ical.text": "Helaas heeft iOS enkele problemen met het genereren en openen van het agendabestand buiten Safari.",
    "modal.opensafari.ical.steps": "<ol><li><strong>Open Safari</strong>, ...</li><li>Gebruik de <strong>insert</strong> functie om verder te gaan.</li></ol>",
    "modal.multidate.h": "Dit is een reeks data",
    "modal.multidate.text": "Voeg de afzonderlijke delen één voor één toe:",
    "date.status.cancelled": "Deze datum is geannuleerd.",
    "date.status.cancelled.cta": "Uw agenda bijwerken!",
    "modal.subscribe.yahoo.h": "Toevoegen aan Yahoo",
    "modal.subscribe.yahoo.text": `<ol><li>Open de Yahoo calendar.</li><li>Klik op de "Acties" tab.</li><li>Selecteer "Volg Andere Agenda's".</li><li>Kies een naam en plak de URL van uw klembord in het URL-veld.</li></ol>`,
    "modal.subscribe.yahoo.button": "Open Yahoo Agenda",
    close: "Sluiten",
    continue: "Doorgaan",
    cancel: "Annuleren",
    expired: "Verlopen",
    recurring: "Terugkerend",
    thankyou: "Bedankt",
    submit: "Versturen",
    "label.share.email": "Delen via E-mail",
    "label.share.copy": "Link kopiëren",
    "label.share.copied": "Gekopieerd",
    "label.share.email.subject": "Onthoud deze datum",
    "form.error.required": "Je hebt niet alle vereiste velden correct ingevuld",
    "form.error.sending": "Er was een probleem met het versturen van je antwoord. Probeer het later opnieuw",
    "form.success": "Succesvol verstuurd!"
  },
  tr: {
    "label.addtocalendar": "Takvime Ekle",
    ical: "iCal Dosyası",
    ...Bt,
    "modal.button.default": "Beni tıklayın",
    "modal.webview.ical.h": "Tarayıcınızı açın",
    "modal.webview.ical.text": "Ne yazık ki, uygulama içi tarayıcılar takvim dosyalarını oluşturma şeklimizle ilgili sorunlar yaşıyor.",
    "modal.clipboard.text": "Panonuza otomatik olarak sihirli bir URL kopyaladık.",
    "modal.webview.ical.steps": "<ol><li><strong>Akıllı telefonunuzda başka bir tarayıcı açın</strong>, ...</li><li>Devam etmek için <strong>insert</strong> fonksiyonunu kullanın.</li></ol>",
    "modal.opensafari.ical.h": "Açık Safari",
    "modal.opensafari.ical.text": "Ne yazık ki iOS, takvim dosyasını Safari dışında oluştururken ve açarken bazı sorunlar yaşıyor.",
    "modal.opensafari.ical.steps": "<ol><li><strong>Açık Safari</strong>, ...</li><li>Devam etmek için <strong>insert</strong> fonksiyonunu kullanın.</li></ol>",
    "modal.multidate.h": "Bu bir etkinlik serisidir",
    "modal.multidate.text": "Parçaları teker teker ekleyin:",
    "date.status.cancelled": "Bu tarih iptal edildi.",
    "date.status.cancelled.cta": "Lütfen takviminizi güncelleyin!",
    "modal.subscribe.yahoo.h": "Yahoo'ya takvim ekleme",
    "modal.subscribe.yahoo.text": `<ol><li>Yahoo takvimini açın.</li><li>"Eylemler" sekmesine tıklayın.</li><li>"Diğer Takvimleri Takip Et" öğesini seçin.</li><li>Bir ad seçin ve URL'yi panonuzdan URL alanına yapıştırın.</li></ol>`,
    "modal.subscribe.yahoo.button": "Yahoo Takvimini aç",
    close: "Kapat",
    continue: "Devam etmek",
    cancel: "İptal",
    expired: "Günü geçmiş",
    recurring: "Yinelenen",
    thankyou: "Teşekkürler",
    submit: "Gönder",
    "label.share.email": "E-posta ile Paylaş",
    "label.share.copy": "Bağlantıyı Kopyala",
    "label.share.copied": "Kopyalandı",
    "label.share.email.subject": "Bu Tarihi Unutma",
    "form.error.required": "Gerekli tüm alanları doğru şekilde doldurmadınız",
    "form.error.sending": "Yanıtınızı gönderirken bir sorun oluştu. Lütfen daha sonra tekrar deneyin",
    "form.success": "Başarıyla gönderildi!"
  },
  zh: {
    "label.addtocalendar": "添加到日历",
    ical: "iCal 文件",
    ...Bt,
    "modal.button.default": "点我",
    "modal.webview.ical.h": "打开浏览器",
    "modal.webview.ical.text": "不幸的是，应用内浏览器在我们生成日历文件的方式上存在问题。",
    "modal.clipboard.text": "我们自动将魔术 URL 复制到您的剪贴板。",
    "modal.webview.ical.steps": "<ol><li>打开手机上的任何其他浏览器, ...</li><li>粘贴剪贴板内容并开始。</li></ol>",
    "modal.opensafari.ical.h": "打开 Safari",
    "modal.opensafari.ical.text": "不幸的是，iOS 在 Safari 之外生成和打开日历文件时遇到一些问题。",
    "modal.opensafari.ical.steps": "<ol><li><strong>打开 Safari</strong>, ...</li><li>粘贴剪贴板内容并开始。</li></ol>",
    "modal.multidate.h": "这是一个活动系列",
    "modal.multidate.text": "逐个添加各个部分:",
    "date.status.cancelled": "此日期已取消。",
    "date.status.cancelled.cta": "请更新您的日历!",
    "modal.subscribe.yahoo.h": "将日历添加到 Yahoo",
    "modal.subscribe.yahoo.text": "<ol><li>打开 Yahoo 日历。</li><li>点击“操作”标签。</li><li>选择“关注其他日历”。</li><li>选择一个名称并将剪贴板中的 URL 粘贴到 URL 字段中。</li></ol>",
    "modal.subscribe.yahoo.button": "打开雅虎日历",
    close: "关",
    continue: "继续",
    cancel: "中止",
    expired: "已到期",
    recurring: "再次发生的",
    thankyou: "谢谢",
    submit: "提交",
    "label.share.email": "通过电子邮件分享",
    "label.share.copy": "复制链接",
    "label.share.copied": "已复制",
    "label.share.email.subject": "记住这个日期",
    "form.error.required": "你没有正确填写所有必填字段",
    "form.error.sending": "发送你的回复时出现问题。请稍后再试",
    "form.success": "成功发送！"
  },
  ar: {
    "label.addtocalendar": "إضافة إلى التقويم",
    ical: "ملف iCal",
    ...Bt,
    "modal.button.default": "انقر فوق لي",
    "modal.webview.ical.h": "افتح المستعرض الخاص بك",
    "modal.webview.ical.text": "لسوء الحظ ، تواجه المتصفحات داخل التطبيق مشاكل في طريقة إنشاء ملف التقويم.",
    "modal.clipboard.text": "قمنا تلقائيًا بنسخ عنوان URL سحري إلى الحافظة الخاصة بك.",
    "modal.webview.ical.steps": "<ol><li>افتح أي متصفح آخر على هاتفك الذكي, ...</li><li>.الصق محتوى الحافظة واذهب</li></ol>",
    "modal.opensafari.ical.h": "افتح Safari",
    "modal.opensafari.ical.text": "لسوء الحظ ، يواجه iOS بعض المشكلات في إنشاء ملف التقويم وفتحه خارج Safari.",
    "modal.opensafari.ical.steps": "<ol><li><strong>افتح Safari</strong>, ...</li><li>الصق محتوى الحافظة واذهب.</li></ol>",
    "modal.multidate.h": "هذه سلسلة أحداث",
    "modal.multidate.text": "أضف الأجزاء الفردية واحدة تلو الأخرى:",
    "date.status.cancelled": "تم إلغاء هذا التاريخ.",
    "date.status.cancelled.cta": "الرجاء تحديث التقويم الخاص بك!",
    "modal.subscribe.yahoo.h": "أضف التقويم إلى Yahoo",
    "modal.subscribe.yahoo.text": '<ol><li>افتح تقويم Yahoo.</li><li>انقر فوق علامة التبويب "الإجراءات".</li><li>حدد "متابعة تقويمات أخرى".</li><li>اختر اسمًا والصق عنوان URL من الحافظة الخاصة بك في حقل URL.</li></ol>',
    "modal.subscribe.yahoo.button": "افتح تقويم ياهو",
    close: "قريب",
    continue: "استمر",
    cancel: "إحباط",
    expired: "منتهي الصلاحية",
    recurring: "يتكرر",
    thankyou: "شكرا",
    submit: "إرسال",
    "label.share.email": "مشاركة عبر البريد الإلكتروني",
    "label.share.copy": "نسخ الرابط",
    "label.share.copied": "تم النسخ",
    "label.share.email.subject": "تذكر هذا الموعد",
    "form.error.required": "لم تقم بملء جميع الحقول المطلوبة بشكل صحيح",
    "form.error.sending": "حدثت مشكلة أثناء إرسال ردك. الرجاء المحاولة لاحقاً",
    "form.success": "تم الإرسال بنجاح!"
  },
  hi: {
    "label.addtocalendar": "कैलेंडर में जोड़ें",
    ical: "iCal फ़ाइल",
    ...Bt,
    "modal.button.default": "मुझे क्लिक करें",
    "modal.webview.ical.h": "अपना ब्राउज़र खोलें",
    "modal.webview.ical.text": "दुर्भाग्य से, इन-ऐप ब्राउज़र में कैलेंडर फ़ाइल बनाने के तरीके में समस्याएँ हैं।",
    "modal.clipboard.text": "हमने आपके क्लिपबोर्ड पर स्वचालित रूप से एक जादुई URL कॉपी कर लिया है।",
    "modal.webview.ical.steps": "<ol><li>अपने फ़ोन पर <strong>दूसरा ब्राउज़र खोलें</strong>, ...</li><li>क्लिपबोर्ड सामग्री <strong>चिपकाएं</strong> और जाएं।</li></ol>",
    "modal.opensafari.ical.h": "सफारी खोलें",
    "modal.opensafari.ical.text": "दुर्भाग्य से, iOS में सफ़ारी के बाहर कैलेंडर फ़ाइल बनाने और खोलने में कुछ समस्याएँ हैं।",
    "modal.opensafari.ical.steps": "<ol><li><strong>सफारी खोलें</strong>, ...</li><li>क्लिपबोर्ड सामग्री <strong>चिपकाएं</strong> और जाएं।</li></ol>",
    "modal.multidate.h": "यह एक इवेंट सीरीज़ है",
    "modal.multidate.text": "अलग-अलग हिस्सों को एक-एक करके जोड़ें:",
    "date.status.cancelled": "यह तिथि रद्द हो गई।",
    "date.status.cancelled.cta": "कृपया अपना कैलेंडर अपडेट करें!",
    "modal.subscribe.yahoo.h": "Yahoo . में कैलेंडर जोड़ें",
    "modal.subscribe.yahoo.text": '<ol><li>Yahoo कैलेंडर खोलें।</li><li>"कृती" टैब पर क्लिक करें।</li><li>"इतर कॅलेंडर्सचे अनुसरण करा" चुनें।</li><li>एक नाम चुनें और अपने क्लिपबोर्ड से URL को URL फ़ील्ड में पेस्ट करें।</li></ol>',
    "modal.subscribe.yahoo.button": "याहू कैलेंडर खोलें",
    close: "बंद करना",
    continue: "जारी रखें",
    cancel: "रद्द करना",
    expired: "खत्म हो चुका",
    recurring: "पुनरावर्ती",
    thankyou: "धन्यवाद",
    submit: "जमा करें",
    "label.share.email": "ईमेल के माध्यम से साझा करें",
    "label.share.copy": "लिंक कॉपी करें",
    "label.share.copied": "कॉपी हो गया",
    "label.share.email.subject": "इस तारीख को याद रखें",
    "form.error.required": "आपने सभी आवश्यक फ़ील्ड सही ढंग से नहीं भरी हैं",
    "form.error.sending": "आपका जवाब भेजते समय एक समस्या हुई। कृपया बाद में पुनः प्रयास करें",
    "form.success": "सफलतापूर्वक भेजा गया!"
  },
  pl: {
    "label.addtocalendar": "Dodaj do kalendarza",
    ical: "Plik iCal",
    ...Bt,
    "modal.button.default": "Kliknij mnie",
    "modal.webview.ical.h": "Otwórz przeglądarkę",
    "modal.webview.ical.text": "Niestety, przeglądarki in-app mają problemy ze sposobem, w jaki generujemy plik kalendarza.",
    "modal.clipboard.text": "Automatycznie skopiowaliśmy magiczny adres URL do schowka.",
    "modal.webview.ical.steps": "<ol><li><strong>Otwórz inną przeglądarkę</strong> w swoim telefonie, ...</li><li><strong>Wklej</strong> zawartość schowka i ruszaj.</li></ol>",
    "modal.opensafari.ical.h": "Otwórz Safari",
    "modal.opensafari.ical.text": "Niestety iOS ma pewne problemy z generowaniem i otwieraniem pliku kalendarza poza Safari.",
    "modal.opensafari.ical.steps": "<ol><li><strong>Otwórz Safari</strong>, ...</li><li><strong>Wklej</strong> zawartość schowka i ruszaj.</li></ol>",
    "modal.multidate.h": "To jest cykl imprez",
    "modal.multidate.text": "Dodawać po kolei poszczególne części:",
    "date.status.cancelled": "Ta data została odwołana.",
    "date.status.cancelled.cta": "Zaktualizuj swój kalendarz!",
    "modal.subscribe.yahoo.h": "Dodaj kalendarz do Yahoo",
    "modal.subscribe.yahoo.text": '<ol><li>Otwórz kalendarz Yahoo.</li><li>Kliknij na zakładkę "Czynności".</li><li>Wybierz "Obserwuj inne kalendarze".</li><li>Wybierz nazwę i wklej adres URL ze schowka w polu URL.</li></ol>',
    "modal.subscribe.yahoo.button": "Otwórz kalendarz Yahoo",
    close: "Zamknij",
    continue: "Kontynuować",
    cancel: "Anuluj",
    expired: "Wygasły",
    recurring: "Powtarzający się",
    thankyou: "Dziękuję",
    submit: "Wyślij",
    "label.share.email": "Udostępnij przez e-mail",
    "label.share.copy": "Kopiuj link",
    "label.share.copied": "Skopiowane",
    "label.share.email.subject": "Zapamiętaj tę datę",
    "form.error.required": "Nie wypełniłeś wszystkich wymaganych pól poprawnie",
    "form.error.sending": "Wystąpił problem z wysłaniem twojej odpowiedzi. Spróbuj ponownie później",
    "form.success": "Wysłano pomyślnie!"
  },
  id: {
    "label.addtocalendar": "Tambahkan ke Kalender",
    ical: "File iCal",
    ...Bt,
    "modal.button.default": "Klik saya",
    "modal.webview.ical.h": "Buka browser Anda",
    "modal.webview.ical.text": "Sayangnya, browser dalam aplikasi memiliki masalah dengan cara kami menghasilkan file kalender.",
    "modal.clipboard.text": "Kami telah secara otomatis menyalin URL ajaib ke clipboard Anda.",
    "modal.webview.ical.steps": "<ol><li><strong>Buka peramban lain</strong> pada ponsel Anda, ...</li><li>Tempelkan konten clipboard dan pergi.</li></ol>",
    "modal.opensafari.ical.h": "Buka Safari",
    "modal.opensafari.ical.text": "Sayangnya, iOS memiliki beberapa masalah dalam membuat dan membuka file kalender di luar Safari.",
    "modal.opensafari.ical.steps": "<ol><li><strong>Buka Safari</strong>, ...</li><li>Tempelkan konten clipboard dan pergi.</li></ol>",
    "modal.multidate.h": "Ini adalah rangkaian acara",
    "modal.multidate.text": "Tambahkan masing-masing bagian satu per satu:",
    "date.status.cancelled": "Tanggal ini dibatalkan.",
    "date.status.cancelled.cta": "Perbarui kalender Anda!",
    "modal.subscribe.yahoo.h": "Tambahkan kalender ke Yahoo",
    "modal.subscribe.yahoo.text": '<ol><li>Buka kalender Yahoo.</li><li>Klik pada tab "Tindakan".</li><li>Pilih "Ikuti Kalender Lain".</li><li>Pilih nama dan tempelkan URL dari clipboard Anda ke bidang URL.</li></ol>',
    "modal.subscribe.yahoo.button": "Buka kalender Yahoo",
    close: "Tutup",
    continue: "Lanjutkan",
    cancel: "Batal",
    expired: "Kedaluwarsa",
    recurring: "Berulang",
    thankyou: "Terima kasih",
    submit: "Kirim",
    "label.share.email": "Bagikan via email",
    "label.share.copy": "Salin tautan",
    "label.share.copied": "Tersalin",
    "label.share.email.subject": "Ingat tanggal ini",
    "form.error.required": "Kamu belum mengisi semua kolom yang diperlukan dengan benar",
    "form.error.sending": "Ada masalah saat mengirim jawabanmu. Coba lagi nanti",
    "form.success": "Berhasil terkirim!"
  },
  no: {
    "label.addtocalendar": "Legg til i kalenderen",
    ical: "iCal-fil",
    ...Bt,
    "modal.button.default": "Klikk på meg",
    "modal.webview.ical.h": "Åpne nettleseren din",
    "modal.webview.ical.text": "Dessverre har nettlesere i appen problemer med måten vi genererer kalenderfilen på.",
    "modal.clipboard.text": "Vi kopierte automatisk en magisk URL til utklippstavlen din.",
    "modal.webview.ical.steps": "<ol><li><strong>Åpne en annen nettleser</strong> på telefonen, ...</li><li><strong>Lim inn</strong> innholdet på utklippstavlen og gå.</li></ol>",
    "modal.opensafari.ical.h": "Åpne Safari",
    "modal.opensafari.ical.text": "Dessverre har iOS noen problemer med å generere og åpne kalenderfilen utenfor Safari.",
    "modal.opensafari.ical.steps": "<ol><li><strong>Åpne Safari</strong>, ...</li><li><strong>Lim inn</strong> innholdet på utklippstavlen og gå.</li></ol>",
    "modal.multidate.h": "Dette er en avtaleserie",
    "modal.multidate.text": "Legg til de enkelte datoene i kalenderen din i rekkefølge:",
    "date.status.cancelled": "Denne datoen ble avlyst.",
    "date.status.cancelled.cta": "Oppdater kalenderen din!",
    "modal.subscribe.yahoo.h": "Legg til kalender til Yahoo",
    "modal.subscribe.yahoo.text": "<ol><li>Åpne Yahoo-kalenderen.</li><li>Klikk på «Handlinger»-fanen.</li><li>Velg «Følg andre kalendere».</li><li>Velg et navn og lim inn URL-en fra utklippstavlen i URL-feltet.</li></ol>",
    "modal.subscribe.yahoo.button": "Åpne Yahoo-kalenderen",
    close: "Lukk",
    continue: "Fortsette",
    cancel: "Avbryt",
    expired: "Utløpt",
    recurring: "Tilbakevendende",
    thankyou: "Takk",
    submit: "Send inn",
    "label.share.email": "Del via e-post",
    "label.share.copy": "Kopier lenke",
    "label.share.copied": "Kopiert",
    "label.share.email.subject": "Husk denne datoen",
    "form.error.required": "Du har ikke fylt ut alle de nødvendige feltene riktig",
    "form.error.sending": "Det oppsto et problem med å sende svaret ditt. Vennligst prøv igjen senere",
    "form.success": "Sendt suksessfullt!"
  },
  fi: {
    "label.addtocalendar": "Lisää kalenteriin",
    ical: "iCal-tiedosto",
    ...Bt,
    "modal.button.default": "Klikkaa minua",
    "modal.webview.ical.h": "Avaa selain",
    "modal.webview.ical.text": "Valitettavasti sovelluksen sisäisillä selaimilla on ongelmia kalenteritiedoston luomisessa.",
    "modal.clipboard.text": "Olemme automaattisesti kopioineet maagisen URL-osoitteen leikepöydällesi.",
    "modal.webview.ical.steps": "<ol><li><strong>Avaa toinen selain</strong> puhelimessasi., ...</li><li><strong>liitä</strong> leikepöydän sisältö ja lähde.</li></ol>",
    "modal.opensafari.ical.h": "Avaa Safari",
    "modal.opensafari.ical.text": "Valitettavasti iOS:llä on ongelmia kalenteritiedoston luomisessa ja avaamisessa Safarin ulkopuolella.",
    "modal.opensafari.ical.steps": "<ol><li><strong>Avaa Safari</strong>, ...</li><li><strong>liitä</strong> leikepöydän sisältö ja lähde.</li></ol>",
    "modal.multidate.h": "Tämä on tapahtumasarja",
    "modal.multidate.text": "Lisää yksittäiset osat yksi kerrallaan:",
    "date.status.cancelled": "Tämä päivämäärä peruttiin.",
    "date.status.cancelled.cta": "Päivitä kalenterisi!",
    "modal.subscribe.yahoo.h": "Lisää kalenteri Yahoo",
    "modal.subscribe.yahoo.text": '<ol><li>Avaa Yahoo-kalenteri.</li><li>Napsauta "Toiminnot"-välilehteä.</li><li>Valitse "Seuraa muiden kalentereita".</li><li>Valitse nimi ja liitä URL-osoite leikepöydältäsi URL-kenttään.</li></ol>',
    "modal.subscribe.yahoo.button": "Avaa Yahoo-kalenteri",
    close: "Sulje",
    continue: "Jatkaa",
    cancel: "Peruuta",
    expired: "Vanhentunut",
    recurring: "Toistuva",
    thankyou: "Kiitos",
    submit: "Lähetä",
    "label.share.email": "Jaa sähköpostitse",
    "label.share.copy": "Kopioi linkki",
    "label.share.copied": "Kopioitu",
    "label.share.email.subject": "Muista tämä päivämäärä",
    "form.error.required": "Et täyttänyt kaikkia vaadittuja kenttiä oikein",
    "form.error.sending": "Vastauksen lähettämisessä ilmeni ongelma. Yritä myöhemmin uudelleen",
    "form.success": "Lähetetty onnistuneesti!"
  },
  sv: {
    "label.addtocalendar": "Lägg till i kalender",
    ical: "iCal-fil",
    ...Bt,
    "modal.button.default": "Klicka på mig",
    "modal.webview.ical.h": "Öppna din webbläsare",
    "modal.webview.ical.text": "Tyvärr har webbläsare i appen problem med hur vi genererar kalenderfilen.",
    "modal.clipboard.text": "Vi har automatiskt kopierat en magisk URL till ditt klippblock.",
    "modal.webview.ical.steps": "<ol><li><strong>Öppna en annan webbläsare</strong> på telefonen, ...</li><li><strong>Insätt</strong> innehållet i klippbordet och kör.</li></ol>",
    "modal.opensafari.ical.h": "Öppna Safari",
    "modal.opensafari.ical.text": "Tyvärr har iOS vissa problem med att generera och öppna kalenderfilen utanför Safari.",
    "modal.opensafari.ical.steps": "<ol><li><strong>Öppna Safari</strong>, ...</li><li><strong>Insätt</strong> innehållet i klippbordet och kör.</li></ol>",
    "modal.multidate.h": "Detta är en evenemangsserie",
    "modal.multidate.text": "Lägg till de enskilda delarna en efter en:",
    "date.status.cancelled": "Detta datum har ställts in.",
    "date.status.cancelled.cta": "Uppdatera din kalender!",
    "modal.subscribe.yahoo.h": "Lägg till kalender i Yahoo",
    "modal.subscribe.yahoo.text": '<ol><li>Öppna Yahoo-kalendern.</li><li>Klicka på fliken "Åtgärder".</li><li>Välj "Följ andra kalendrar".</li><li>Välj ett namn och klistra in URL:en från klippbordet i URL-fältet.</li></ol>',
    "modal.subscribe.yahoo.button": "Öppna Yahoo-kalendern",
    close: "Stäng",
    continue: "Fortsätta",
    cancel: "Avbryt",
    expired: "Utgånget",
    recurring: "Återkommande",
    thankyou: "Tack",
    submit: "Skicka",
    "label.share.email": "Dela via e-post",
    "label.share.copy": "Kopiera länk",
    "label.share.copied": "Kopierat",
    "label.share.email.subject": "Kom ihåg detta datum",
    "form.error.required": "Du har inte fyllt i alla nödvändiga fält korrekt",
    "form.error.sending": "Det uppstod ett problem när ditt svar skickades. Försök igen senare",
    "form.success": "Skickat framgångsrikt!"
  },
  cs: {
    "label.addtocalendar": "Přidat do kalendáře",
    ical: "Soubor iCal",
    ...Bt,
    "modal.button.default": "Klikněte na mě",
    "modal.webview.ical.h": "Otevřete prohlížeč",
    "modal.webview.ical.text": "Prohlížeče v aplikacích mají bohužel problémy se způsobem generování souboru kalendáře.",
    "modal.clipboard.text": "Do schránky jsme automaticky zkopírovali kouzelnou adresu URL.",
    "modal.webview.ical.steps": "<ol><li><strong>Otevření jiného prohlížeče</strong> v telefonu, ...</li><li><strong>Vložte</strong> obsah schránky a přejděte.</li></ol>",
    "modal.opensafari.ical.h": "Otevřít Safari",
    "modal.opensafari.ical.text": "Bohužel má iOS nějaké problémy s generováním a otevíráním souboru kalendáře mimo Safari.",
    "modal.opensafari.ical.steps": "<ol><li><strong>Otevřít Safari</strong>, ...</li><li><strong>Vložte</strong> obsah schránky a přejděte.</li></ol>",
    "modal.multidate.h": "Jedná se o sérii událostí",
    "modal.multidate.text": "Přidávejte jednotlivé díly jeden po druhém:",
    "date.status.cancelled": "Toto datum bylo zrušeno.",
    "date.status.cancelled.cta": "Aktualizujte svůj kalendář!",
    "modal.subscribe.yahoo.h": "Přidat kalendář do Yahoo",
    "modal.subscribe.yahoo.text": '<ol><li>Otevřete kalendář Yahoo.</li><li>Klikněte na kartu "Akce".</li><li>Vyberte možnost "Sledovat další kalendáře".</li><li>Vyberte název a vložte adresu URL ze schránky do pole URL.</li></ol>',
    "modal.subscribe.yahoo.button": "Otevřete kalendář Yahoo",
    close: "Zavřít",
    continue: "Pokračovat",
    cancel: "Storno",
    expired: "Platnost vypršela",
    recurring: "Opakující se",
    thankyou: "Děkuji",
    submit: "Odeslat",
    "label.share.email": "Sdílet e-mailem",
    "label.share.copy": "Kopírovat odkaz",
    "label.share.copied": "Zkopírováno",
    "label.share.email.subject": "Zapamatuj si tento termín",
    "form.error.required": "Nevyplnil jsi správně všechna požadovaná pole",
    "form.error.sending": "Při odesílání tvé odpovědi došlo k problému. Zkus to prosím později znovu",
    "form.success": "Úspěšně odesláno!"
  },
  ja: {
    "label.addtocalendar": "カレンダーに追加",
    ical: "iCalファイル",
    ...Bt,
    "modal.button.default": "クリックしてください",
    "modal.webview.ical.h": "ブラウザを起動する",
    "modal.webview.ical.text": "残念ながら、アプリ内ブラウザは、カレンダーファイルの生成方法に問題があります。",
    "modal.clipboard.text": "魔法のURLを自動的にクリップボードにコピーしています。",
    "modal.webview.ical.steps": "<ol><li>スマートフォンで別のブラウザを起動する, ...</li><li>クリップボードの内容を貼り付けて行く。</li></ol>",
    "modal.opensafari.ical.h": "オープンSafari",
    "modal.opensafari.ical.text": "残念ながら、iOS では、Safari の外でカレンダー ファイルを生成したり開いたりする際にいくつかの問題があります。",
    "modal.opensafari.ical.steps": "<ol><li><strong>オープンSafari</strong>, ...</li><li>クリップボードの内容を貼り付けて行く。</li></ol>",
    "modal.multidate.h": "イベントシリーズです",
    "modal.multidate.text": "個々のパーツを一つずつ追加していく:",
    "date.status.cancelled": "この日はキャンセルになりました。",
    "date.status.cancelled.cta": "カレンダーを更新する!",
    "modal.subscribe.yahoo.h": "Yahooにカレンダーを追加する",
    "modal.subscribe.yahoo.text": "<ol><li>Yahooカレンダーを開く。</li><li>[実行] タブをクリックします。</li><li>[その他のカレンダーのフォロー] を選択します。</li><li>名前を決めて、クリップボードにあるURLをURL欄に貼り付けます。</li></ol>",
    "modal.subscribe.yahoo.button": "Yahooカレンダーを開く",
    close: "閉じる",
    continue: "続ける",
    cancel: "キャンセル",
    expired: "期限切れ",
    recurring: "繰り返し",
    thankyou: "ありがとう",
    submit: "送信",
    "label.share.email": "メールで共有",
    "label.share.copy": "リンクをコピー",
    "label.share.copied": "コピー済み",
    "label.share.email.subject": "この日付を覚えておいて",
    "form.error.required": "必要なフィールドをすべて正しく入力していません",
    "form.error.sending": "あなたの回答を送信する際に問題が発生しました。後で再試行してください",
    "form.success": "正常に送信されました！"
  },
  it: {
    "label.addtocalendar": "Aggiungi al calendario",
    ical: "File iCal",
    ...Bt,
    "modal.button.default": "Clicca su di me",
    "modal.webview.ical.h": "Aprire il browser",
    "modal.webview.ical.text": "Purtroppo i browser in-app hanno problemi con il modo in cui generiamo il file del calendario.",
    "modal.clipboard.text": "Abbiamo copiato automaticamente un URL magico negli appunti.",
    "modal.webview.ical.steps": "<ol><li><strong>Aprire un altro browser</strong> sul cellulare, ...</li><li><strong>Incollare</strong> il contenuto degli appunti e partire.</li></ol>",
    "modal.opensafari.ical.h": "Aprire Safari",
    "modal.opensafari.ical.text": "Sfortunatamente, iOS ha alcuni problemi nella generazione e nell'apertura del file del calendario al di fuori di Safari.",
    "modal.opensafari.ical.steps": "<ol><li><strong>Aprire Safari</strong>, ...</li><li><strong>Incollare</strong> il contenuto degli appunti e partire.</li></ol>",
    "modal.multidate.h": "Questa è una serie di eventi",
    "modal.multidate.text": "Aggiungere le singole parti una per una:",
    "date.status.cancelled": "La data è stata annullata.",
    "date.status.cancelled.cta": "Aggiornare il calendario!",
    "modal.subscribe.yahoo.h": "Aggiungi il calendario a Yahoo",
    "modal.subscribe.yahoo.text": `<ol><li>Aprire il calendario di Yahoo.</li><li>Fare clic sulla scheda "Azioni".</li><li>Selezionare "Segui altri calendari".</li><li>Scegliere un nome e incollare l'URL dagli appunti nel campo URL.</li></ol>`,
    "modal.subscribe.yahoo.button": "Apri il calendario di Yahoo",
    close: "Chiudere",
    continue: "Continuare",
    cancel: "Annulla",
    expired: "Scaduta",
    recurring: "Ricorrente",
    thankyou: "Grazie",
    submit: "Invia",
    "label.share.email": "Condividi via Email",
    "label.share.copy": "Copia il link",
    "label.share.copied": "Copiato",
    "label.share.email.subject": "Ricorda questa data",
    "form.error.required": "Non hai compilato correttamente tutti i campi richiesti",
    "form.error.sending": "C'è stato un problema nell'invio della tua risposta. Prova di nuovo più tardi",
    "form.success": "Inviato con successo!"
  },
  ko: {
    "label.addtocalendar": "캘린더에 추가",
    ical: "iCal 파일",
    ...Bt,
    "modal.button.default": "클릭 해주세요",
    "modal.webview.ical.h": "브라우저 열기",
    "modal.webview.ical.text": "불행히도 인앱 브라우저는 캘린더 파일을 생성하는 방식에 문제가 있습니다.",
    "modal.clipboard.text": "매직 URL을 클립보드에 자동으로 복사했습니다.",
    "modal.webview.ical.steps": "<ol><li>휴대전화에서 다른 브라우저 열기, ...</li><li>클립보드 내용을 붙여넣고 이동합니다.</li></ol>",
    "modal.opensafari.ical.h": "Safari 열기",
    "modal.opensafari.ical.text": "안타깝게도 iOS에는 Safari 외부에서 캘린더 파일을 생성하고 여는 데 몇 가지 문제가 있습니다.",
    "modal.opensafari.ical.steps": "<ol><li><strong>Safari 열기</strong>, ...</li><li>클립보드 내용을 붙여넣고 이동합니다.</li></ol>",
    "modal.multidate.h": "이벤트 시리즈입니다",
    "modal.multidate.text": "개별 부품을 하나씩 추가:",
    "date.status.cancelled": "이 날짜는 취소되었습니다.",
    "date.status.cancelled.cta": "캘린더를 업데이트하세요!",
    "modal.subscribe.yahoo.h": "Yahoo에 캘린더 추가",
    "modal.subscribe.yahoo.text": '<ol><li>Yahoo 캘린더를 엽니다.</li><li>"동작" 탭을 클릭합니다.</li><li>"다른 일정관리 팔로우"를 선택합니다.</li><li>이름을 선택하고 클립보드의 URL을 URL 필드에 붙여넣습니다.</li></ol>',
    "modal.subscribe.yahoo.button": "야후 캘린더 열기",
    close: "닫다",
    continue: "계속하다",
    cancel: "취소",
    expired: "만료됨",
    recurring: "되풀이",
    thankyou: "감사합니다",
    submit: "제출하기",
    "label.share.email": "이메일로 공유하기",
    "label.share.copy": "링크 복사하기",
    "label.share.copied": "복사됨",
    "label.share.email.subject": "이 날짜를 기억하세요",
    "form.error.required": "필수 필드를 모두 올바르게 채우지 않았습니다",
    "form.error.sending": "응답을 보내는 데 문제가 발생했습니다. 나중에 다시 시도해주세요",
    "form.success": "성공적으로 전송됨!"
  },
  vi: {
    "label.addtocalendar": "Thêm vào Lịch",
    ical: "Tệp iCal",
    ...Bt,
    "modal.button.default": "Nhấp vào đây",
    "modal.webview.ical.h": "Mở trình duyệt của bạn",
    "modal.webview.ical.text": "Rất tiếc, các trình duyệt trong ứng dụng gặp sự cố với cách chúng tôi tạo tệp lịch.",
    "modal.clipboard.text": "Chúng tôi đã tự động sao chép một URL ma thuật vào khay nhớ tạm của bạn.",
    "modal.webview.ical.steps": "<ol><li><strong> Mở trình duyệt khác </strong> trên điện thoại của bạn, ...</li><li><strong> Dán </strong> nội dung khay nhớ tạm và bắt đầu.</li></ol>",
    "modal.opensafari.ical.h": "Mở Safari",
    "modal.opensafari.ical.text": "Rất tiếc, iOS gặp một số sự cố khi tạo và mở tệp lịch bên ngoài Safari.",
    "modal.opensafari.ical.steps": "<ol><li><strong>Mở Safari</strong>, ...</li><li><strong> Dán </strong> nội dung khay nhớ tạm và bắt đầu.</li></ol>",
    "modal.multidate.h": "Đây là một chuỗi sự kiện",
    "modal.multidate.text": "Thêm từng phần riêng lẻ một:",
    "date.status.cancelled": "Ngày này đã bị hủy.",
    "date.status.cancelled.cta": "Cập nhật lịch của bạn!",
    "modal.subscribe.yahoo.h": "Thêm lịch vào Yahoo",
    "modal.subscribe.yahoo.text": '<ol><li>Mở Lịch Yahoo.</li><li>Nhấp vào tab "Hành động".</li><li>Chọn "Theo dõi các Lịch khác".</li><li>Chọn tên và dán URL từ khay nhớ tạm của bạn vào trường URL.</li></ol>',
    "modal.subscribe.yahoo.button": "Mở lịch Yahoo",
    close: "Đóng",
    continue: "Tiếp tục",
    cancel: "Hủy bỏ",
    expired: "Hết hạn",
    recurring: "Định kỳ",
    thankyou: "Cảm ơn",
    submit: "Gửi",
    "label.share.email": "Chia sẻ qua Email",
    "label.share.copy": "Sao chép liên kết",
    "label.share.copied": "Đã sao chép",
    "label.share.email.subject": "Ghi nhớ ngày này",
    "form.error.required": "Bạn chưa điền đúng tất cả các trường bắt buộc",
    "form.error.sending": "Có sự cố khi gửi phản hồi của bạn. Vui lòng thử lại sau",
    "form.success": "Gửi thành công!"
  },
  ro: {
    "label.addtocalendar": "Adauga In Calendar",
    ical: "Fisier iCal",
    ...Bt,
    "modal.button.default": "Apasa-ma",
    "modal.webview.ical.h": "Deschide browserul",
    "modal.webview.ical.text": "Din pacate, browserele din aplicatie au probleme cu generarea de fisiere pentru calendar.",
    "modal.clipboard.text": "Ti-am copiat automat un URL magic in clipboard",
    "modal.webview.ical.steps": "<ol><li><strong>Deschide un alt browser</strong> pe telefonul tau, ...</li><li><strong>Lipeste</strong> continutul din clipboard si continua.</li></ol>",
    "modal.opensafari.ical.h": "Deschide Safari",
    "modal.opensafari.ical.text": "Din păcate, iOS are unele probleme la generarea și deschiderea fișierului calendar în afara Safari.",
    "modal.opensafari.ical.steps": "<ol><li><strong>Deschides Safari</strong>, ...</li><li><strong>Lipeste</strong> continutul din clipboard si continua.</li></ol>",
    "modal.multidate.h": "Aceasta este o serie de evenimente",
    "modal.multidate.text": "Adauga evenimentele individuale una cate una:",
    "date.status.cancelled": "Aceasta data a fost anulata.",
    "date.status.cancelled.cta": "Te rugam sa-ti updatezi calendarul!",
    "modal.subscribe.yahoo.h": "Adauga Calendar in Yahoo",
    "modal.subscribe.yahoo.text": '<ol><li>Deschide acum calendarul Yahoo.</li><li>Apasa pe tab-ul de "Actiuni".</li><li>Apasa "Urmareste alte calendare".</li><li>Seteaza un nume si lipeste continutul din clipboard in casuta cu url.</li></ol>',
    "modal.subscribe.yahoo.button": "Deschideți calendarul Yahoo",
    close: "Inchide",
    continue: "Continua",
    cancel: "Anuleaza",
    expired: "Expirat",
    recurring: "Recurente",
    thankyou: "Mulțumesc",
    submit: "Trimite",
    "label.share.email": "Distribuie prin e-mail",
    "label.share.copy": "Copiază linkul",
    "label.share.copied": "Copiat",
    "label.share.email.subject": "Ține minte această dată",
    "form.error.required": "Nu ai completat corect toate câmpurile necesare",
    "form.error.sending": "A apărut o problemă la trimiterea răspunsului tău. Încearcă din nou mai târziu",
    "form.success": "Trimis cu succes!"
  },
  fa: {
    "label.addtocalendar": "افزودن به تقویم",
    ical: "پرونده iCal",
    ...Bt,
    "modal.button.default": "اینجا کلیک کنید",
    "modal.webview.ical.h": "مرورگر خود را باز کنید",
    "modal.webview.ical.text": "متاسفانه، مرورگرهای درون برنامه‌ای با نحوه تولید پرونده تقویم مشکل دارند.",
    "modal.clipboard.text": "ما به طور خودکار یک نشانی اینترنتی جادویی را در کلیپ‌بورد شما کپی کردیم.",
    "modal.webview.ical.steps": "<ol><li><strong>مرورگر دیگری را </strong> در گوشی خود باز کنید، ...</li><li>محتوای کلیپ‌بورد را <strong>Paste</strong> کنید و Go را بزنید که آدرس باز شود.</li></ol>",
    "modal.opensafari.ical.h": "سافاری را باز کنید",
    "modal.opensafari.ical.text": "متأسفانه iOS در تولید و باز کردن فایل تقویم خارج از سافاری مشکلاتی دارد.",
    "modal.opensafari.ical.steps": "<ol><li><strong>سافاری را باز کنید</strong>، ...</li><li>محتوای کلیپ‌بورد را <strong>Paste</strong> کنید و Go را بزنید که آدرس باز شود.</li></ol>",
    "modal.multidate.h": "این یک سری رویداد است",
    "modal.multidate.text": "رویدادهای شخصی را یکی یکی اضافه کنید:",
    "date.status.cancelled": "این تاریخ لغو شد",
    "date.status.cancelled.cta": "لطفا تقویم خود را به‌روز کنید!",
    "modal.subscribe.yahoo.h": "افزودن تقویم به یاهو",
    "modal.subscribe.yahoo.text": "<ol><li>اکنون تقویم یاهو را باز کنید.</li><li>روی زبانه «Actions» کلیک کنید.</li><li>روی «Follow Other Calendars» ضربه بزنید.</li><li>یک نام وارد کنید و محتوای کلیپ‌بورد را در قسمت url قرار دهید.</li></ol>",
    "modal.subscribe.yahoo.button": "تقویم یاهو را باز کنید",
    close: "بستن",
    continue: "ادامه دادن",
    cancel: "لغو",
    expired: "منقضی شده",
    thankyou: "ممنون",
    submit: "ارسال",
    "label.share.email": "اشتراک‌گذاری از طریق ایمیل",
    "label.share.copy": "کپی لینک",
    "label.share.copied": "کپی شد",
    "label.share.email.subject": "این تاریخ را به یاد داشته باشید",
    "form.error.required": "شما همه فیلدهای لازم را به درستی پر نکرده‌اید",
    "form.error.sending": "مشکلی در ارسال پاسخ شما وجود داشت. لطفا بعدا دوباره تلاش کنید",
    "form.success": "با موفقیت ارسال شد!"
  },
  et: {
    "label.addtocalendar": "Lisa kalendrisse",
    ical: "iCal fail",
    ...Bt,
    "modal.button.default": "Kliki siia",
    "modal.webview.ical.h": "Ava oma veebilehitseja",
    "modal.webview.ical.text": "Kahjuks on rakendusesisestel veebilehitsejatel probleeme kalendrifailide loomisega.",
    "modal.clipboard.text": "Kalendri veebi aadress on automaatselt kopeeritud sinu lõikelauale.",
    "modal.webview.ical.steps": "<ol><li><strong>Ava teine veebilehitseja</strong> oma telefonis, ...</li><li><strong>Kleebi</strong> lõikelaua sisu ning mine sellele lehele.</li></ol>",
    "modal.opensafari.ical.h": "Ava Safari",
    "modal.opensafari.ical.text": "Kahjuks on iOS-il probleeme kalendrifaili genereerimise ja avamisega väljaspool Safarit.",
    "modal.opensafari.ical.steps": "<ol><li><strong>Ava Safari</strong>, ...</li><li><strong>Kleebi</strong> lõikelaua sisu ning mine sellele lehele.</li></ol>",
    "modal.multidate.h": "See on sündmuste seeria",
    "modal.multidate.text": "Ava üksikud sündmused ükshaaval:",
    "date.status.cancelled": "See kuupäev on tühistatud.",
    "date.status.cancelled.cta": "Palun uuenda oma kalendrit!",
    "modal.subscribe.yahoo.h": "Lisa kalender Yahoo-sse",
    "modal.subscribe.yahoo.text": '<ol><li>Ava oma Yahoo kalender.</li><li>Kliki "Actions" vahelehte.</li><li>Vajuta "Follow Other Calendars".</li><li>Määra nimi ning lisa lõikelaua sisu URL (veebi aadressi) väljale.</li></ol>',
    "modal.subscribe.yahoo.button": "Avage Yahoo kalender",
    close: "Sulge",
    continue: "Jätkama",
    cancel: "Tühista",
    expired: "Aegunud",
    thankyou: "Aitäh",
    submit: "Saada",
    "label.share.email": "Jaga e-posti teel",
    "label.share.copy": "Kopeeri link",
    "label.share.copied": "Kopeeritud",
    "label.share.email.subject": "Pane see kuupäev kirja",
    "form.error.required": "Sa pole kõiki nõutavaid välju korrektselt täitnud",
    "form.error.sending": "Sinu vastuse saatmisel tekkis probleem. Palun proovi hiljem uuesti",
    "form.success": "Edukalt saadetud!"
  },
  uk: {
    "label.addtocalendar": "Додати до календаря",
    ical: "Файл iCal",
    ...Bt,
    "modal.button.default": "Натисни мене",
    "modal.webview.ical.h": "Відкрийте ваш браузер",
    "modal.webview.ical.text": "На жаль, браузери у додатках мають проблеми з обробкою файлу календаря, який ми створюємо.",
    "modal.clipboard.text": "Ми автоматично скопіювали магічний URL у ваш буфер обміну.",
    "modal.webview.ical.steps": "<ol><li><strong>Відкрийте інший браузер</strong> на своєму телефоні, ...</li><li><strong>Вставте</strong> скопійований вміст і перейдіть.</li></ol>",
    "modal.opensafari.ical.h": "Відкрити Safari",
    "modal.opensafari.ical.text": "На жаль, iOS має проблеми з генерацією та відкриттям файлу календаря поза Safari.",
    "modal.opensafari.ical.steps": "<ol><li><strong>Відкрийте Safari</strong>, ...</li><li><strong>Вставте</strong> скопійований вміст і перейдіть.</li></ol>",
    "modal.multidate.h": "Це серія подій",
    "modal.multidate.text": "Додайте окремі події по одній:",
    "date.status.cancelled": "Цю дату скасовано.",
    "date.status.cancelled.cta": "Оновіть свій календар, будь ласка!",
    "modal.subscribe.yahoo.h": "Додати календар до Yahoo",
    "modal.subscribe.yahoo.text": "<ol><li>Відкрийте зараз календар Yahoo.</li><li>Натисніть вкладку «Дії».</li><li>Натисніть «Підписатися на інші календарі».</li><li>Введіть назву та вставте вміст буфера обміну в поле URL.</li></ol>",
    "modal.subscribe.yahoo.button": "Відкрити Yahoo Календар",
    close: "Закрити",
    continue: "Продовжити",
    cancel: "Скасувати",
    expired: "Термін дії закінчився",
    recurring: "Повторюваний",
    thankyou: "Дякуємо",
    submit: "Відправити",
    "label.rsvp": "RSVP",
    "label.share.email": "Поділитися через Email",
    "label.share.copy": "Скопіювати посилання",
    "label.share.copied": "Скопійовано",
    "label.share.email.subject": "Збережіть цю подію",
    "form.error.required": "Ви не заповнили всі обов'язкові поля",
    "form.error.sending": "Сталася проблема з відправленням вашої відповіді. Спробуйте ще раз пізніше.",
    "form.success": "Успішно відправлено!"
  }
}, mB = Object.keys(Q0);
function $e(t, e) {
  return e.customLabels && e.customLabels[`${t}`] && e.customLabels[`${t}`] !== "" ? _s(e.customLabels[`${t}`]) : fv(t, e.language);
}
function fv(t, e) {
  return e || (e = "en"), Q0[`${e}`][`${t}`] ? Q0[`${e}`][`${t}`] : e !== "en" ? fv(t, "en") : t;
}
let J0 = !1, Ac = 0;
const sl = [], f1 = '<div class="atcb-initialized atcb-hidden"></div>';
if (Ii()) {
  class t extends HTMLElement {
    constructor() {
      super(), this._initialized = new Promise((a) => this._initializedResolver = a);
      const n = document.createElement("template");
      n.innerHTML = f1, this.attachShadow({ mode: "open", delegateFocus: !0 }), this.shadowRoot.append(n.content.cloneNode(!0)), this.state = {
        initializing: !1,
        initialized: !1,
        ready: !1,
        updatePending: !1
      }, this.data = {}, this.error = !1;
    }
    connectedCallback() {
      this.initializing || (this.initializing = !0, setTimeout(() => this.initializeComponent(), 0));
    }
    async initializeComponent() {
      if (this.state.ready)
        return;
      this.state.initializing = !0;
      const n = this.getAttribute("debug");
      if (this.debug = !!(this.hasAttribute("debug") && (!n || n === "true" || n === "")), this.hasAttribute("proOverride") || this.hasAttribute("prooverride")) {
        let a = null;
        this.hasAttribute("proOverride") && this.getAttribute("proOverride") !== "" ? a = this.getAttribute("proOverride") : a = this.getAttribute("prooverride"), this.proOverride = !a || a === "true" || a === "";
      }
      try {
        this.hasAttribute("proKey") && this.getAttribute("proKey") !== "" || this.hasAttribute("prokey") && this.getAttribute("prokey") !== "" ? (this.hasAttribute("proKey") && this.getAttribute("proKey") !== "" ? this.data = await Ec(this.getAttribute("proKey"), this) : this.data = await Ec(this.getAttribute("prokey"), this), this.data.proKey && (this.proKey = this.data.proKey)) : (this.data.proKey = "", this.data = await p1(this, this.debug));
      } catch (a) {
        this.debug && (console.error(a), s0(this.shadowRoot, a)), this.state.initializing = !1, this.state.ready = !0;
        return;
      }
      await this.initButton(), this.state.initializing = !1, this.state.initialized = !0, this.state.ready = !0, this._initializedResolver();
    }
    whenInitialized() {
      return this._initialized;
    }
    disconnectedCallback() {
      m1(this.shadowRoot, this.identifier), this.debug && console.log('Add to Calendar Button "' + this.identifier + '" destroyed'), document.querySelectorAll("add-to-calendar-button").length === 0 && (Ac = 0);
    }
    static get observedAttributes() {
      const n = ["instance", "prokey", "proKey", "prooverride", "proOverride"];
      return this.proKey && this.proKey !== "" ? Z0.map((a) => a.toLowerCase()).concat(n) : tu.map((a) => a.toLowerCase()).concat(n);
    }
    attributeChangedCallback(n, a, i) {
      this.state.ready && (this.debug && this.state.initialized && console.log(`${n}'s value has been changed from ${a} to ${i}`), this.updatePending || (this.updatePending = !0, setTimeout(() => this.updateComponent(), 0)));
    }
    async updateComponent() {
      if (!this.updatePending) return;
      this.data = {}, this.shadowRoot.querySelector(".atcb-initialized").remove();
      const n = document.createElement("template");
      n.innerHTML = f1, this.shadowRoot.append(n.content.cloneNode(!0));
      try {
        this.hasAttribute("proKey") && this.getAttribute("proKey") !== "" ? (this.data = await Ec(this.getAttribute("proKey"), this), this.data.proKey && (this.proKey = this.data.proKey)) : this.hasAttribute("prokey") && this.getAttribute("prokey") !== "" ? (this.data = await Ec(this.getAttribute("prokey"), this), this.data.proKey && (this.proKey = this.data.proKey)) : this.data = await p1(this, this.debug);
      } catch (a) {
        this.debug && (console.error(a), s0(this.shadowRoot, a)), this.updatePending = !1;
        return;
      }
      m1(this.shadowRoot, this.identifier), await this.initButton(), this.updatePending = !1;
    }
    async initButton() {
      if (this.state.initialized || (Ac = Ac + 1), this.identifier && this.identifier !== "")
        this.data.identifier = this.identifier;
      else {
        if (this.data.identifier && this.data.identifier !== "") {
          if (/^[\w-]+$/.test(this.data.identifier))
            this.data.identifier = "atcb-btn-" + this.data.identifier;
          else if (this.data.identifier = "", this.debug) {
            let n = "Add to Calendar Button";
            this.data.rsvp && Object.keys(this.data.rsvp).length > 0 && (n = "RSVP"), console.warn(n + " generation: identifier invalid - using auto numbers instead");
          }
        }
        (this.data.identifier == null || this.data.identifier == "") && (this.data.identifier = "atcb-btn-" + Ac), this.identifier = this.data.identifier;
      }
      this.setAttribute("atcb-button-id", this.data.identifier);
      try {
        return this.style.visibility = "visible", this.style.opacity = "1", this.style.position = "relative", this.style.outline = "none !important", await gB(this.shadowRoot, this.data), !0;
      } catch (n) {
        return this.debug && (console.error(n.message ? n.message : n), s0(this.shadowRoot, n)), !1;
      }
    }
  }
  customElements.get("add-to-calendar-button") || customElements.define("add-to-calendar-button", t);
}
async function p1(t, e = !1) {
  let n;
  try {
    n = pv(t), await t1(n);
  } catch {
    const a = t.innerHTML.trim();
    if (!a)
      throw new Error("Add to Calendar Button generation failed: No data provided.");
    try {
      const i = JSON.parse(_l(a.replace(/(\r\n|\n|\r)/g, ""), !1));
      await t1(i), n = i;
    } catch (i) {
      throw e && console.error(i), new Error("Add to Calendar Button generation failed: no data provided or missing required fields - see console logs for details");
    }
  }
  return n;
}
function pv(t, e = tu) {
  let n = {};
  for (let a = 0; a < e.length; a++) {
    let i = e[`${a}`];
    if (t.hasAttribute(`${i}`)) {
      let r = _l(t.getAttribute(`${i}`).replace(/(\\r\\n|\\n|\\r)/g, ""), !1), s;
      if (K0.includes(i))
        s = !r || r === "" || r.toLowerCase() === "true";
      else if (gP.includes(i)) {
        const o = function() {
          return !r || r === "" ? "{}" : r.substring(0, 1) != "{" ? "{" + r + "}" : r;
        }();
        s = JSON.parse(o);
      } else if (bP.includes(i)) {
        const o = function() {
          return !r || r === "" ? "[]" : r.substring(0, 1) != "[" ? "[" + r + "]" : r;
        }();
        s = JSON.parse(o);
      } else if (vP.includes(i)) {
        const o = function() {
          let l = r;
          return (r.includes('"') || r.includes("'")) && (r.includes("[") ? l = r.substring(2, r.length - 2) : l = r.substring(1, r.length - 1)), r.includes("|") || (l = l.replace(/\s/g, "")), l;
        }();
        o.includes("','") ? s = o.split("','") : s = o.split('","');
      } else yP.includes(i) ? s = parseInt(r) : s = r;
      if (typeof s == "object" && Object.keys(s).length === 0 || Array.isArray(s) && (s.length === 0 || s.length === 1 && s[0] === ""))
        continue;
      n[`${i}`] = s;
    }
  }
  return n;
}
async function gB(t, e) {
  try {
    t.host.classList.add("add-to-calendar"), e = await J2(e), await OP(e);
    const n = t.querySelector(".atcb-initialized");
    return rf(t, e), n.setAttribute("lang", e.language), gv(t, n, e), bB(e), yB(t, e), vB(e.proKey, e.debug), e.hidden || (typeof pi == "function" && e.rsvp && Object.keys(e.rsvp).length > 0 ? e.inlineRsvp ? await pi(t, e, n) : await ZP(t, e) : sv(t, n, e), !e.hideRichData && !e.subscribe && e.name && e.dates[0].location && e.dates[0].startDate && tB(e, t.host)), on("initialization", e.identifier, e.identifier), !e.proKey && e.hideBranding && !document.getElementById("atcb-reference") && yl(document.body, !1, !1, !0), !0;
  } catch (n) {
    throw new Error(n.message);
  }
}
function m1(t, e) {
  rl(t), wB(e);
  const n = document.getElementById("atcb-schema-" + e);
  n && n.remove(), Array.from(t.querySelectorAll(".atcb-debug-error-msg")).concat(Array.from(t.querySelectorAll("style"))).concat(Array.from(t.querySelectorAll("link"))).concat(Array.from(t.querySelectorAll(".atcb-placeholder"))).concat(Array.from(t.querySelectorAll(".atcb-button-wrapper"))).forEach((a) => a.remove()), delete Ft[`${e}`];
}
function rf(t, e) {
  t.host.classList.remove("atcb-dark", "atcb-light", "atcb-bodyScheme");
  const n = function() {
    return e.lightMode == "bodyScheme" ? document.body.classList.contains("atcb-dark") || document.documentElement.classList.contains("atcb-dark") || document.body.classList.contains("atcp-dark") || document.documentElement.classList.contains("atcp-dark") || document.body.classList.contains("dark") || document.documentElement.classList.contains("dark") ? "dark" : "light" : e.lightMode;
  }();
  t.host.classList.add("atcb-" + n);
}
function mv(t) {
  const e = /[`'"()[\]{}<>\s]/;
  if (!t.host.hasAttribute("cspnonce"))
    return null;
  if (e.test(t.host.getAttribute("cspnonce")))
    throw new Error("cspnonce input contains forbidden characters.");
  return t.host.getAttribute("cspnonce");
}
async function gv(t, e = null, n) {
  const a = mv(t);
  if (!document.getElementById("atcb-global-style")) {
    const l = document.createElement("style");
    l.id = "atcb-global-style";
    const c = window.innerWidth - document.documentElement.clientWidth;
    l.innerText = ".atcb-modal-no-scroll{overflow-y:hidden !important;-webkit-overflow-scrolling:touch;} body.atcb-modal-no-scroll{padding-right:" + c + "px;}.atcb-attribution{display:none;}", a && l.setAttribute("nonce", a), document.head.append(l);
  }
  const i = document.createElement("style"), r = n.inlineRsvp && n.rsvp && Object.keys(n.rsvp).length > 0 ? "100%" : "fit-content";
  i.innerText = `.atcb-initialized { display: block; position: relative; width: ${r}; }.atcb-initialized.atcb-inline { display: inline-block; }.atcb-initialized.atcb-buttons-list { display: flex; flex-wrap: wrap; justify-content: center; gap: var(--buttonslist-gap); }.atcb-hidden { display: none; }`, a && i.setAttribute("nonce", a), t.prepend(i);
  const s = function() {
    return n.styleLight ? ":host{" + _l(n.styleLight.replace(/(\\r\\n|\\n|\\r)/g, ""), !1) + "}" : "";
  }(), o = function() {
    return n.styleDark ? ":host(.atcb-dark){" + _l(n.styleDark.replace(/(\\r\\n|\\n|\\r)/g, ""), !1) + "}" : "";
  }();
  if (n.customCss && n.customCss !== "") {
    const l = document.createElement("link");
    if (l.setAttribute("rel", "stylesheet"), l.setAttribute("type", "text/css"), l.setAttribute("href", n.customCss), a && l.setAttribute("nonce", a), !e)
      await g1(l, t, null, a, null, !1, !1, s + o);
    else {
      const c = document.createElement("div");
      c.classList.add("atcb-placeholder"), t.prepend(c);
      const u = document.createElement("style");
      u.innerText = ".atcb-placeholder { background-color: #777; border-radius: 200px; height: 40px; opacity: .3; width: 150px; }", a && u.setAttribute("nonce", a), t.prepend(u), g1(l, t, e, a, c, n.inline, n.buttonsList, s + o);
    }
    return;
  }
  if (n.buttonStyle !== "none" && Jm[`${n.buttonStyle}`]) {
    const l = document.createElement("style");
    a && l.setAttribute("nonce", a), l.innerText = Jm[`${n.buttonStyle}`] + s + o, t.prepend(l);
  }
  e && (n.inline ? (e.style.display = "inline-block", e.classList.add("atcb-inline")) : n.buttonsList && e.classList.add("atcb-buttons-list"), e.classList.remove("atcb-hidden"));
}
async function g1(t, e, n = null, a = null, i = null, r = !1, s = !1, o = "") {
  if (o !== "") {
    const l = document.createElement("style");
    l.innerText = o, a && l.setAttribute("nonce", a), e.prepend(l);
  }
  try {
    e.prepend(t), await new Promise((l) => {
      t.onload = l;
    }), n && (i && i.remove(), r ? (n.style.display = "inline-block", n.classList.add("atcb-inline")) : s && n.classList.add("atcb-buttons-list"), n.classList.remove("atcb-hidden"));
  } catch (l) {
    console.log(l);
  }
}
function s0(t, e) {
  if (t.querySelector(".atcb-debug-error-msg")) return;
  const n = mv(t), a = document.createElement("div");
  a.classList.add("atcb-debug-error-msg");
  const i = document.createElement("style");
  i.innerText = ".atcb-debug-error-msg { color: #bf2e2e; font-size: 12px; font-weight: bold; padding: 12px 15px; border: 2px solid #bf2e2e; max-width: 180px; border-radius: 13px; }", n && i.setAttribute("nonce", n), t.prepend(i), a.textContent = e, t.append(a);
}
function bB(t) {
  const e = [];
  for (let n = 0; n < t.options.length; n++) {
    e[t.options[`${n}`]] = [];
    for (let a = 1; a <= t.dates.length; a++)
      t.dates[a - 1].status.toLowerCase() === "cancelled" ? e[t.options[`${n}`]].push(1) : e[t.options[`${n}`]].push(0);
  }
  Ft[t.identifier] = e;
}
function vB(t = "", e = !1) {
  if (!J0) {
    const n = function() {
      return e ? " (version " + Q2 + ")" : "";
    }();
    t != "" ? console.log("Add to Calendar PRO script initialized" + n + " | https://add-to-calendar-pro.com") : (console.log(`%c
Add to Calendar Button script initialized` + n + `
see https://add-to-calendar-button.com for details.
`, "font-weight: bold;"), console.log("✨ %cPRO version available at https://add-to-calendar-pro.com ← check it out!", "font-weight: bold; line-height: 60px;")), J0 = !0;
  }
}
async function Ec(t, e = null, n = {}) {
  /*!
   *  @preserve
   *  PER LICENSE AGREEMENT, YOU ARE NOT ALLOWED TO REMOVE OR CHANGE THIS FUNCTION!
   */
  if (t && t !== "")
    try {
      const a = e ? e.proOverride : n.proOverride, i = e ? pv(e, a ? tu : Z0) : n, r = await fetch(`https://${i.dev ? "event-dev.caldn.net" : "event.caldn.net"}/${t}/config.json`);
      if (r.ok) {
        const s = await r.json();
        if (a ? tu.forEach((o) => {
          Object.prototype.hasOwnProperty.call(i, o) && ["hideBranding", "hidebranding", "ty", "rsvp"].indexOf(o) === -1 && (s[`${o}`] = i[`${o}`]);
        }) : Z0.forEach((o) => {
          Object.prototype.hasOwnProperty.call(i, o) && (s[`${o}`] = i[`${o}`]);
        }), i.rsvp && Object.prototype.hasOwnProperty.call(i.rsvp, "none") && delete s.rsvp, !s.name || s.name === "")
          throw new Error("Not possible to read proKey config from server...");
        return s.landingpage.domain && s.landingpage.domain !== "" && Ds(s.landingpage.domain) && (s.domain = s.landingpage.domain, delete s.landingpage), s.proKey = t, s.identifier = t, s;
      }
      throw new Error("Not possible to read proKey config from server...");
    } catch {
      throw new Error("Add to Calendar Button proKey invalid or server not responding!");
    }
  return {};
}
function yB(t, e) {
  Ii() && (e.lightMode == "bodyScheme" && (sl[e.identifier] = new MutationObserver(function(n) {
    n.forEach((a) => {
      a.attributeName === "class" && rf(t, e);
    });
  }), sl[e.identifier].observe(document.documentElement, { attributes: !0 }), sl[e.identifier].observe(document.body, { attributes: !0 })), J0 || (document.addEventListener("keyup", _B), document.addEventListener("keydown", TB), window.addEventListener("resize", xB)));
}
function _B(t) {
  const e = function() {
    const n = document.querySelector('[atcb-button-id="' + Ft.active + '"]');
    return n ? n.shadowRoot : null;
  }();
  e && t.key === "Escape" && (on("closeList", "Ecs Hit", Ft.active), Sn(e, "close", "", "", !0));
}
function TB(t) {
  const e = function() {
    const n = document.querySelector('[atcb-button-id="' + Ft.active + '"]'), a = document.getElementById(Ft.active + "-modal-host");
    return a ? a.shadowRoot : n ? n.shadowRoot : null;
  }();
  if (e && e.querySelector(".atcb-list") && (t.key === "ArrowDown" || t.key === "ArrowUp" || t.key === "Tab")) {
    t.preventDefault();
    let n = 0, a = e.activeElement;
    const i = e.querySelectorAll(".atcb-list-item").length;
    if (a && a.classList.contains("atcb-list-item"))
      t.key === "ArrowDown" && a.dataset.optionNumber < i ? n = parseInt(a.dataset.optionNumber) + 1 : t.key === "Tab" ? a.dataset.optionNumber < i ? n = parseInt(a.dataset.optionNumber) + 1 : n = 1 : t.key === "ArrowUp" && a.dataset.optionNumber >= 1 && (n = parseInt(a.dataset.optionNumber) - 1), n > 0 && e.querySelector('.atcb-list-item[data-option-number="' + n + '"]').focus();
    else
      switch (t.key) {
        default:
          e.querySelector('.atcb-list-item[data-option-number="1"]').focus();
          break;
        case "ArrowUp":
          e.querySelector('.atcb-list-item[data-option-number="' + i + '"]').focus();
          break;
      }
  }
}
function xB() {
  const t = function() {
    const e = document.querySelector('[atcb-button-id="' + Ft.active + '"]'), n = document.getElementById(Ft.active + "-modal-host");
    return n ? n.shadowRoot : e ? e.shadowRoot : null;
  }();
  if (t) {
    const e = t.querySelector("#atcb-bgoverlay");
    e && (Rr(e), af(t));
  }
}
function wB(t) {
  typeof sl[`${t}`] < "u" && sl[`${t}`].disconnect();
}
const kB = {
  width: "14",
  height: "17",
  viewBox: "0 0 14 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-ftva-share"
};
function bv(t, e) {
  return h(), b("svg", kB, e[0] || (e[0] = [
    k("path", {
      d: "M6.43456 0.734232C6.58458 0.584253 6.78803 0.5 7.00017 0.5C7.2123 0.5 7.41575 0.584253 7.56577 0.734232L9.9658 3.13426C10.1115 3.28514 10.1922 3.48722 10.1903 3.69698C10.1885 3.90674 10.1044 4.1074 9.95605 4.25572C9.80772 4.40405 9.60707 4.48819 9.39731 4.49001C9.18755 4.49183 8.98547 4.4112 8.83459 4.26547L7.80017 3.23106V10.8999C7.80017 11.1121 7.71589 11.3156 7.56586 11.4656C7.41583 11.6157 7.21234 11.6999 7.00017 11.6999C6.78799 11.6999 6.58451 11.6157 6.43447 11.4656C6.28444 11.3156 6.20016 11.1121 6.20016 10.8999V3.23106L5.16575 4.26547C5.01486 4.4112 4.81278 4.49183 4.60302 4.49001C4.39326 4.48819 4.19261 4.40405 4.04428 4.25572C3.89595 4.1074 3.81182 3.90674 3.80999 3.69698C3.80817 3.48722 3.88881 3.28514 4.03453 3.13426L6.43456 0.734232ZM0.600098 7.69991C0.600098 7.27555 0.76867 6.86858 1.06873 6.56852C1.36879 6.26846 1.77576 6.09989 2.20011 6.09989H3.80013C4.01231 6.09989 4.21579 6.18418 4.36582 6.33421C4.51585 6.48424 4.60014 6.68772 4.60014 6.8999C4.60014 7.11207 4.51585 7.31556 4.36582 7.46559C4.21579 7.61562 4.01231 7.69991 3.80013 7.69991H2.20011V14.9H11.8002V7.69991H10.2002C9.98802 7.69991 9.78454 7.61562 9.63451 7.46559C9.48448 7.31556 9.40019 7.11207 9.40019 6.8999C9.40019 6.68772 9.48448 6.48424 9.63451 6.33421C9.78454 6.18418 9.98802 6.09989 10.2002 6.09989H11.8002C12.2246 6.09989 12.6315 6.26846 12.9316 6.56852C13.2317 6.86858 13.4002 7.27555 13.4002 7.69991V14.9C13.4002 15.3243 13.2317 15.7313 12.9316 16.0314C12.6315 16.3314 12.2246 16.5 11.8002 16.5H2.20011C1.77576 16.5 1.36879 16.3314 1.06873 16.0314C0.76867 15.7313 0.600098 15.3243 0.600098 14.9V7.69991Z",
      fill: "#555555",
      class: "svg__fill--medium-grey"
    }, null, -1)
  ]));
}
const vv = { render: bv }, CB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: vv,
  render: bv
}, Symbol.toStringTag, { value: "Module" })), SB = {
  width: "31",
  height: "31",
  viewBox: "0 0 31 31",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-ftva-social_confirm"
};
function yv(t, e) {
  return h(), b("svg", SB, e[0] || (e[0] = [
    k("rect", {
      y: "3.8147e-06",
      width: "31",
      height: "31",
      rx: "15.5",
      fill: "#115DAF"
    }, null, -1),
    k("path", {
      d: "M9.5 16.7225L12.6849 19.9075L21.5 11.0925",
      stroke: "white",
      "stroke-width": "1.5",
      "stroke-linecap": "square",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const _v = { render: yv }, AB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _v,
  render: yv
}, Symbol.toStringTag, { value: "Module" }));
function Ku(t) {
  return Jb() ? (e2(t), !0) : !1;
}
function Jn(t) {
  return typeof t == "function" ? t() : O(t);
}
const b1 = {
  mounted: "mounted",
  unmounted: "unmounted"
}, sf = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const EB = Object.prototype.toString, Tv = (t) => EB.call(t) === "[object Object]", _i = () => {
}, ru = /* @__PURE__ */ LB();
function LB() {
  var t, e;
  return sf && ((t = window == null ? void 0 : window.navigator) == null ? void 0 : t.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function DB(t) {
  return Qb();
}
function IB(...t) {
  if (t.length !== 1)
    return Ls(...t);
  const e = t[0];
  return typeof e == "function" ? O4(P4(() => ({ get: e, set: _i }))) : K(e);
}
function MB(t, e = !0, n) {
  DB() ? st(t, n) : e ? t() : kn(t);
}
const Qu = sf ? window : void 0;
function Ko(t) {
  var e;
  const n = Jn(t);
  return (e = n == null ? void 0 : n.$el) != null ? e : n;
}
function Uc(...t) {
  let e, n, a, i;
  if (typeof t[0] == "string" || Array.isArray(t[0]) ? ([n, a, i] = t, e = Qu) : [e, n, a, i] = t, !e)
    return _i;
  Array.isArray(n) || (n = [n]), Array.isArray(a) || (a = [a]);
  const r = [], s = () => {
    r.forEach((u) => u()), r.length = 0;
  }, o = (u, f, m, _) => (u.addEventListener(f, m, _), () => u.removeEventListener(f, m, _)), l = Qe(
    () => [Ko(e), Jn(i)],
    ([u, f]) => {
      if (s(), !u)
        return;
      const m = Tv(f) ? { ...f } : f;
      r.push(
        ...n.flatMap((_) => a.map((T) => o(u, _, T, m)))
      );
    },
    { immediate: !0, flush: "post" }
  ), c = () => {
    l(), s();
  };
  return Ku(c), c;
}
let v1 = !1;
function OB(t, e, n = {}) {
  const { window: a = Qu, ignore: i = [], capture: r = !0, detectIframe: s = !1 } = n;
  if (!a)
    return _i;
  ru && !v1 && (v1 = !0, Array.from(a.document.body.children).forEach((g) => g.addEventListener("click", _i)), a.document.documentElement.addEventListener("click", _i));
  let o = !0;
  const l = (g) => Jn(i).some((x) => {
    if (typeof x == "string")
      return Array.from(a.document.querySelectorAll(x)).some((S) => S === g.target || g.composedPath().includes(S));
    {
      const S = Ko(x);
      return S && (g.target === S || g.composedPath().includes(S));
    }
  });
  function c(g) {
    const x = Jn(g);
    return x && x.$.subTree.shapeFlag === 16;
  }
  function u(g, x) {
    const S = Jn(g), D = S.$.subTree && S.$.subTree.children;
    return D == null || !Array.isArray(D) ? !1 : D.some((L) => L.el === x.target || x.composedPath().includes(L.el));
  }
  const f = (g) => {
    const x = Ko(t);
    if (g.target != null && !(!(x instanceof Element) && c(t) && u(t, g)) && !(!x || x === g.target || g.composedPath().includes(x))) {
      if (g.detail === 0 && (o = !l(g)), !o) {
        o = !0;
        return;
      }
      e(g);
    }
  };
  let m = !1;
  const _ = [
    Uc(a, "click", (g) => {
      m || (m = !0, setTimeout(() => {
        m = !1;
      }, 0), f(g));
    }, { passive: !0, capture: r }),
    Uc(a, "pointerdown", (g) => {
      const x = Ko(t);
      o = !l(g) && !!(x && !g.composedPath().includes(x));
    }, { passive: !0 }),
    s && Uc(a, "blur", (g) => {
      setTimeout(() => {
        var x;
        const S = Ko(t);
        ((x = a.document.activeElement) == null ? void 0 : x.tagName) === "IFRAME" && !(S != null && S.contains(a.document.activeElement)) && e(g);
      }, 0);
    })
  ].filter(Boolean);
  return () => _.forEach((g) => g());
}
function PB() {
  const t = K(!1), e = Qb();
  return e && st(() => {
    t.value = !0;
  }, e), t;
}
function BB(t) {
  const e = PB();
  return I(() => (e.value, !!t()));
}
function RB(t, e = {}) {
  const { window: n = Qu } = e, a = BB(() => n && "matchMedia" in n && typeof n.matchMedia == "function");
  let i;
  const r = K(!1), s = (c) => {
    r.value = c.matches;
  }, o = () => {
    i && ("removeEventListener" in i ? i.removeEventListener("change", s) : i.removeListener(s));
  }, l = Kb(() => {
    a.value && (o(), i = n.matchMedia(Jn(t)), "addEventListener" in i ? i.addEventListener("change", s) : i.addListener(s), r.value = i.matches);
  });
  return Ku(() => {
    l(), o(), i = void 0;
  }), r;
}
function li(t = {}) {
  const {
    window: e = Qu,
    initialWidth: n = Number.POSITIVE_INFINITY,
    initialHeight: a = Number.POSITIVE_INFINITY,
    listenOrientation: i = !0,
    includeScrollbar: r = !0,
    type: s = "inner"
  } = t, o = K(n), l = K(a), c = () => {
    e && (s === "outer" ? (o.value = e.outerWidth, l.value = e.outerHeight) : r ? (o.value = e.innerWidth, l.value = e.innerHeight) : (o.value = e.document.documentElement.clientWidth, l.value = e.document.documentElement.clientHeight));
  };
  if (c(), MB(c), Uc("resize", c, { passive: !0 }), i) {
    const u = RB("(orientation: portrait)");
    Qe(u, () => c());
  }
  return { width: o, height: l };
}
const xv = sf ? window : void 0;
function Qo(t) {
  var e;
  const n = Jn(t);
  return (e = n == null ? void 0 : n.$el) != null ? e : n;
}
function Hc(...t) {
  let e, n, a, i;
  if (typeof t[0] == "string" || Array.isArray(t[0]) ? ([n, a, i] = t, e = xv) : [e, n, a, i] = t, !e)
    return _i;
  Array.isArray(n) || (n = [n]), Array.isArray(a) || (a = [a]);
  const r = [], s = () => {
    r.forEach((u) => u()), r.length = 0;
  }, o = (u, f, m, _) => (u.addEventListener(f, m, _), () => u.removeEventListener(f, m, _)), l = Qe(
    () => [Qo(e), Jn(i)],
    ([u, f]) => {
      if (s(), !u)
        return;
      const m = Tv(f) ? { ...f } : f;
      r.push(
        ...n.flatMap((_) => a.map((T) => o(u, _, T, m)))
      );
    },
    { immediate: !0, flush: "post" }
  ), c = () => {
    l(), s();
  };
  return Ku(c), c;
}
let y1 = !1;
function _1(t, e, n = {}) {
  const { window: a = xv, ignore: i = [], capture: r = !0, detectIframe: s = !1 } = n;
  if (!a)
    return _i;
  ru && !y1 && (y1 = !0, Array.from(a.document.body.children).forEach((g) => g.addEventListener("click", _i)), a.document.documentElement.addEventListener("click", _i));
  let o = !0;
  const l = (g) => Jn(i).some((x) => {
    if (typeof x == "string")
      return Array.from(a.document.querySelectorAll(x)).some((S) => S === g.target || g.composedPath().includes(S));
    {
      const S = Qo(x);
      return S && (g.target === S || g.composedPath().includes(S));
    }
  });
  function c(g) {
    const x = Jn(g);
    return x && x.$.subTree.shapeFlag === 16;
  }
  function u(g, x) {
    const S = Jn(g), D = S.$.subTree && S.$.subTree.children;
    return D == null || !Array.isArray(D) ? !1 : D.some((L) => L.el === x.target || x.composedPath().includes(L.el));
  }
  const f = (g) => {
    const x = Qo(t);
    if (g.target != null && !(!(x instanceof Element) && c(t) && u(t, g)) && !(!x || x === g.target || g.composedPath().includes(x))) {
      if (g.detail === 0 && (o = !l(g)), !o) {
        o = !0;
        return;
      }
      e(g);
    }
  };
  let m = !1;
  const _ = [
    Hc(a, "click", (g) => {
      m || (m = !0, setTimeout(() => {
        m = !1;
      }, 0), f(g));
    }, { passive: !0, capture: r }),
    Hc(a, "pointerdown", (g) => {
      const x = Qo(t);
      o = !l(g) && !!(x && !g.composedPath().includes(x));
    }, { passive: !0 }),
    s && Hc(a, "blur", (g) => {
      setTimeout(() => {
        var x;
        const S = Qo(t);
        ((x = a.document.activeElement) == null ? void 0 : x.tagName) === "IFRAME" && !(S != null && S.contains(a.document.activeElement)) && e(g);
      }, 0);
    })
  ].filter(Boolean);
  return () => _.forEach((g) => g());
}
const NB = {
  [b1.mounted](t, e) {
    const n = !e.modifiers.bubble;
    if (typeof e.value == "function")
      t.__onClickOutside_stop = _1(t, e.value, { capture: n });
    else {
      const [a, i] = e.value;
      t.__onClickOutside_stop = _1(t, a, Object.assign({ capture: n }, i));
    }
  },
  [b1.unmounted](t) {
    t.__onClickOutside_stop();
  }
};
function o0(t) {
  return typeof Window < "u" && t instanceof Window ? t.document.documentElement : typeof Document < "u" && t instanceof Document ? t.documentElement : t;
}
function wv(t) {
  const e = window.getComputedStyle(t);
  if (e.overflowX === "scroll" || e.overflowY === "scroll" || e.overflowX === "auto" && t.clientWidth < t.scrollWidth || e.overflowY === "auto" && t.clientHeight < t.scrollHeight)
    return !0;
  {
    const n = t.parentNode;
    return !n || n.tagName === "BODY" ? !1 : wv(n);
  }
}
function $B(t) {
  const e = t || window.event, n = e.target;
  return wv(n) ? !1 : e.touches.length > 1 ? !0 : (e.preventDefault && e.preventDefault(), !1);
}
const l0 = /* @__PURE__ */ new WeakMap();
function FB(t, e = !1) {
  const n = K(e);
  let a = null, i = "";
  Qe(IB(t), (o) => {
    const l = o0(Jn(o));
    if (l) {
      const c = l;
      if (l0.get(c) || l0.set(c, c.style.overflow), c.style.overflow !== "hidden" && (i = c.style.overflow), c.style.overflow === "hidden")
        return n.value = !0;
      if (n.value)
        return c.style.overflow = "hidden";
    }
  }, {
    immediate: !0
  });
  const r = () => {
    const o = o0(Jn(t));
    !o || n.value || (ru && (a = Hc(
      o,
      "touchmove",
      (l) => {
        $B(l);
      },
      { passive: !1 }
    )), o.style.overflow = "hidden", n.value = !0);
  }, s = () => {
    const o = o0(Jn(t));
    !o || !n.value || (ru && (a == null || a()), o.style.overflow = i, l0.delete(o), n.value = !1);
  };
  return Ku(s), I({
    get() {
      return n.value;
    },
    set(o) {
      o ? r() : s();
    }
  });
}
function zB() {
  let t = !1;
  const e = K(!1);
  return (n, a) => {
    if (e.value = a.value, t)
      return;
    t = !0;
    const i = FB(n, a.value);
    Qe(e, (r) => i.value = r);
  };
}
zB();
const UB = {
  width: "10",
  height: "8",
  viewBox: "0 0 10 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-ftva-drop-triangle"
};
function HB(t, e) {
  return h(), b("svg", UB, e[0] || (e[0] = [
    k("path", {
      d: "M5 7.5L0.669873 -8.15666e-07L9.33013 -5.85621e-08L5 7.5Z",
      fill: "#115DAF",
      class: "svg__fill--accent-blue"
    }, null, -1)
  ]));
}
const of = { render: HB }, YB = { class: "dropdown-wrapper" }, jB = { class: "button-inner-wrapper" }, VB = {
  key: 0,
  class: "button-dropdown-modal"
}, qB = /* @__PURE__ */ Ce({
  __name: "MobileDrawer",
  setup(t) {
    const e = K(!1), n = K(!1), a = I(() => [
      { "is-expanded": e.value }
    ]);
    function i() {
      return e.value = !e.value;
    }
    function r() {
      e.value = !1;
    }
    function s() {
      e.value = !1;
    }
    const o = qe(), l = I(() => ["mobile-drawer", (o == null ? void 0 : o.value) || "", { "is-expanded": e.value }]);
    return st(() => {
      const { width: c } = li();
      Qe(c, (u) => {
        n.value = u <= 750;
      }, { immediate: !0 });
    }), (c, u) => (h(), b("div", {
      class: re(l.value)
    }, [
      Tt((h(), b("div", YB, [
        k("div", {
          class: re(["dropdown-overlay", a.value])
        }, null, 2),
        k("button", {
          class: re(["mobile-button", a.value]),
          onClick: i
        }, [
          k("span", jB, [
            me(c.$slots, "buttonLabel", {}, void 0, !0)
          ]),
          k("span", {
            class: re([a.value, "toggle-triangle-icon"])
          }, [
            Q(O(of))
          ], 2)
        ], 2),
        e.value ? (h(), b("div", VB, [
          n.value ? (h(), G(O(er), {
            key: 0,
            class: "svg-glyph-close",
            onClick: s
          })) : A("", !0),
          k("div", {
            class: re(["button-dropdown-modal-wrapper", a.value])
          }, [
            me(c.$slots, "dropdownItems", { removeOverlay: s }, void 0, !0)
          ], 2)
        ])) : A("", !0)
      ])), [
        [O(NB), r]
      ])
    ], 2));
  }
}), Ju = /* @__PURE__ */ ge(qB, [["__scopeId", "data-v-a1a6e280"]]);
function WB(t) {
  return t ? t.replace(/(<([^>]+)>)/ig, "").replace(/[\n]/g, "").replace(/"/ig, "") : "";
}
const GB = { key: 0 }, XB = ["name", "startDate", "startTime", "endTime", "location", "description", "debug"], ZB = {
  key: 0,
  class: "icon-svg"
}, KB = { class: "button-text" }, QB = { key: 0 }, JB = ["href"], eR = { key: 1 }, tR = {
  __name: "ButtonDropdown",
  props: {
    // Event props for Dropdown Calendar
    title: {
      type: String,
      default: ""
    },
    eventDescription: {
      type: String,
      default: ""
    },
    startDateWithTime: {
      type: String,
      default: ""
    },
    endTime: {
      type: String,
      default: ""
    },
    location: {
      type: Array,
      default: () => []
    },
    isEvent: {
      type: Boolean,
      default: !1
    },
    debugModeEnabled: {
      type: Boolean,
      default: !1
    },
    // Dropdown props
    dropdownList: {
      type: Array,
      default: () => []
    },
    buttonTitle: {
      type: String,
      default: ""
    },
    hasIcon: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    const e = Yn(), n = K(!1), a = I(() => [
      { "is-link-copied": n.value }
    ]), i = I(() => typeof window > "u" ? "" : window.location.origin + e.fullPath), r = I(() => {
      var x, S;
      const T = (x = t.location[0]) == null ? void 0 : x.publicUrl, g = (S = t.location[0]) == null ? void 0 : S.title;
      return T || g || "";
    }), s = I(() => {
      if (t.startDateWithTime) {
        const T = Ct(new Date(t.startDateWithTime), "yyyy-MM-dd"), g = Ct(new Date(t.startDateWithTime), "HH:mm");
        return { startDate: T, startTime: g };
      }
      return "";
    }), o = I(() => t.endTime ? f(t.endTime) : s.value.startTime), l = I(() => t.eventDescription ? WB(t.eventDescription) : "");
    function c(T) {
      const g = document.createElement("style");
      g.innerHTML = ".atcb-button.atcb-click.atcb-active { border-bottom-left-radius: 0 !important; border-bottom-right-radius: 0 !important; } .atcb-active .atcb-text::after { transform: rotate(180deg); } #atcb-bgoverlay.atcb-click:hover {  cursor: unset; }", T.target.shadowRoot.appendChild(g);
    }
    function u() {
      navigator.clipboard.writeText(i.value), n.value = !0, setTimeout(() => {
        n.value = !1;
      }, 4e3);
    }
    function f(T) {
      const g = /[0-9][0-9]:[0-9][0-9]/;
      return T.match(g)[0];
    }
    const m = qe(), _ = I(() => ["button-dropdown", (m == null ? void 0 : m.value) || ""]);
    return (T, g) => (h(), b("div", {
      class: re(_.value)
    }, [
      t.isEvent ? (h(), b("div", GB, [
        k("add-to-calendar-button", {
          name: t.title,
          startDate: s.value.startDate,
          startTime: s.value.startTime,
          endTime: o.value,
          timeZone: "America/Los_Angeles",
          location: r.value,
          description: l.value,
          options: "'Google','Apple','Microsoft365','Outlook.com','iCal'",
          trigger: "click",
          hideBranding: "true",
          hideCheckmark: "true",
          hideBackground: "true",
          hideIconButton: "true",
          listStyle: "dropdown-static",
          debug: t.debugModeEnabled,
          onClick: c
        }, null, 8, XB)
      ])) : (h(), G(Ju, { key: 1 }, {
        buttonLabel: oe(() => [
          t.hasIcon ? (h(), b("span", ZB, [
            (h(), G(dt(O(vv)), {
              class: "button-svg",
              "aria-hidden": "true"
            }))
          ])) : A("", !0),
          k("span", KB, ne(t.buttonTitle), 1)
        ]),
        dropdownItems: oe(() => [
          (h(!0), b(he, null, Le(t.dropdownList, (x) => (h(), b("div", {
            key: x.dropdownItemTitle,
            class: "dropdown-modal-item"
          }, [
            x.dropdownItemTitle === "Email" ? (h(), b("span", QB, [
              k("a", {
                href: `mailto:?&body=${i.value}`,
                class: "email-icon"
              }, [
                Q(en, {
                  text: x.dropdownItemTitle,
                  "icon-name": x.iconName,
                  class: "not-smart-link"
                }, null, 8, ["text", "icon-name"])
              ], 8, JB)
            ])) : x.dropdownItemTitle === "Copy Link" ? (h(), b("span", eR, [
              n.value ? (h(), G(en, {
                key: 1,
                text: "Link Copied!",
                class: re(a.value),
                "icon-name": O(_v)
              }, null, 8, ["class", "icon-name"])) : (h(), G(en, {
                key: 0,
                text: x.dropdownItemTitle,
                "icon-name": x.iconName,
                class: "not-smart-link",
                onClick: g[0] || (g[0] = (S) => u())
              }, null, 8, ["text", "icon-name"]))
            ])) : (h(), G(en, {
              key: 2,
              text: x.dropdownItemTitle,
              "icon-name": x.iconName,
              to: `${x.dropdownItemUrl}${i.value}`
            }, null, 8, ["text", "icon-name", "to"]))
          ]))), 128))
        ]),
        _: 1
      }))
    ], 2));
  }
}, Ehe = /* @__PURE__ */ ge(tR, [["__scopeId", "data-v-f0fca622"]]), nR = {
  name: "ButtonMore",
  components: {
    ArrowRight: vi,
    MoleculeStroke: tf,
    SmartLink: Xe
  },
  props: {
    text: {
      type: String,
      default: "See More"
    },
    to: {
      type: String,
      default: ""
    }
  }
}, aR = {
  class: "icon",
  "aria-hidden": "true"
}, iR = { class: "text" };
function rR(t, e, n, a, i, r) {
  const s = lt("MoleculeStroke"), o = lt("ArrowRight"), l = lt("SmartLink");
  return h(), G(l, {
    to: n.to,
    class: "button-more"
  }, {
    default: oe(() => [
      k("div", aR, [
        Q(s, { class: "molecule-stroke" }),
        Q(o, { class: "arrow-right" })
      ]),
      k("div", iR, ne(n.text), 1)
    ]),
    _: 1
  }, 8, ["to"]);
}
const kv = /* @__PURE__ */ ge(nR, [["render", rR], ["__scopeId", "data-v-0bcf47c2"]]);
function We(t) {
  const e = Object.prototype.toString.call(t);
  return t instanceof Date || typeof t == "object" && e === "[object Date]" ? new t.constructor(+t) : typeof t == "number" || e === "[object Number]" || typeof t == "string" || e === "[object String]" ? new Date(t) : /* @__PURE__ */ new Date(NaN);
}
function pt(t, e) {
  return t instanceof Date ? new t.constructor(e) : new Date(e);
}
function Da(t, e) {
  const n = We(t);
  return isNaN(e) ? pt(t, NaN) : (e && n.setDate(n.getDate() + e), n);
}
function Pa(t, e) {
  const n = We(t);
  if (isNaN(e)) return pt(t, NaN);
  if (!e)
    return n;
  const a = n.getDate(), i = pt(t, n.getTime());
  i.setMonth(n.getMonth() + e + 1, 0);
  const r = i.getDate();
  return a >= r ? i : (n.setFullYear(
    i.getFullYear(),
    i.getMonth(),
    a
  ), n);
}
function Cv(t, e) {
  const {
    years: n = 0,
    months: a = 0,
    weeks: i = 0,
    days: r = 0,
    hours: s = 0,
    minutes: o = 0,
    seconds: l = 0
  } = e, c = We(t), u = a || n ? Pa(c, a + n * 12) : c, f = r || i ? Da(u, r + i * 7) : u, m = o + s * 60, T = (l + m * 60) * 1e3;
  return pt(t, f.getTime() + T);
}
function sR(t, e) {
  const n = +We(t);
  return pt(t, n + e);
}
const Sv = 6048e5, oR = 864e5, lR = 6e4, Av = 36e5, cR = 1e3;
function uR(t, e) {
  return sR(t, e * Av);
}
let dR = {};
function jr() {
  return dR;
}
function Na(t, e) {
  var o, l, c, u;
  const n = jr(), a = (e == null ? void 0 : e.weekStartsOn) ?? ((l = (o = e == null ? void 0 : e.locale) == null ? void 0 : o.options) == null ? void 0 : l.weekStartsOn) ?? n.weekStartsOn ?? ((u = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : u.weekStartsOn) ?? 0, i = We(t), r = i.getDay(), s = (r < a ? 7 : 0) + r - a;
  return i.setDate(i.getDate() - s), i.setHours(0, 0, 0, 0), i;
}
function Is(t) {
  return Na(t, { weekStartsOn: 1 });
}
function Ev(t) {
  const e = We(t), n = e.getFullYear(), a = pt(t, 0);
  a.setFullYear(n + 1, 0, 4), a.setHours(0, 0, 0, 0);
  const i = Is(a), r = pt(t, 0);
  r.setFullYear(n, 0, 4), r.setHours(0, 0, 0, 0);
  const s = Is(r);
  return e.getTime() >= i.getTime() ? n + 1 : e.getTime() >= s.getTime() ? n : n - 1;
}
function T1(t) {
  const e = We(t);
  return e.setHours(0, 0, 0, 0), e;
}
function su(t) {
  const e = We(t), n = new Date(
    Date.UTC(
      e.getFullYear(),
      e.getMonth(),
      e.getDate(),
      e.getHours(),
      e.getMinutes(),
      e.getSeconds(),
      e.getMilliseconds()
    )
  );
  return n.setUTCFullYear(e.getFullYear()), +t - +n;
}
function Lv(t, e) {
  const n = T1(t), a = T1(e), i = +n - su(n), r = +a - su(a);
  return Math.round((i - r) / oR);
}
function hR(t) {
  const e = Ev(t), n = pt(t, 0);
  return n.setFullYear(e, 0, 4), n.setHours(0, 0, 0, 0), Is(n);
}
function fR(t, e) {
  const n = e * 3;
  return Pa(t, n);
}
function lf(t, e) {
  return Pa(t, e * 12);
}
function x1(t, e) {
  const n = We(t), a = We(e), i = n.getTime() - a.getTime();
  return i < 0 ? -1 : i > 0 ? 1 : i;
}
function Dv(t) {
  return t instanceof Date || typeof t == "object" && Object.prototype.toString.call(t) === "[object Date]";
}
function ol(t) {
  if (!Dv(t) && typeof t != "number")
    return !1;
  const e = We(t);
  return !isNaN(Number(e));
}
function w1(t) {
  const e = We(t);
  return Math.trunc(e.getMonth() / 3) + 1;
}
function pR(t, e) {
  const n = We(t), a = We(e);
  return n.getFullYear() - a.getFullYear();
}
function mR(t, e) {
  const n = We(t), a = We(e), i = x1(n, a), r = Math.abs(pR(n, a));
  n.setFullYear(1584), a.setFullYear(1584);
  const s = x1(n, a) === -i, o = i * (r - +s);
  return o === 0 ? 0 : o;
}
function Iv(t, e) {
  const n = We(t.start), a = We(t.end);
  let i = +n > +a;
  const r = i ? +n : +a, s = i ? a : n;
  s.setHours(0, 0, 0, 0);
  let o = 1;
  const l = [];
  for (; +s <= r; )
    l.push(We(s)), s.setDate(s.getDate() + o), s.setHours(0, 0, 0, 0);
  return i ? l.reverse() : l;
}
function kr(t) {
  const e = We(t), n = e.getMonth(), a = n - n % 3;
  return e.setMonth(a, 1), e.setHours(0, 0, 0, 0), e;
}
function gR(t, e) {
  const n = We(t.start), a = We(t.end);
  let i = +n > +a;
  const r = i ? +kr(n) : +kr(a);
  let s = kr(i ? a : n), o = 1;
  const l = [];
  for (; +s <= r; )
    l.push(We(s)), s = fR(s, o);
  return i ? l.reverse() : l;
}
function bR(t) {
  const e = We(t);
  return e.setDate(1), e.setHours(0, 0, 0, 0), e;
}
function Mv(t) {
  const e = We(t), n = e.getFullYear();
  return e.setFullYear(n + 1, 0, 0), e.setHours(23, 59, 59, 999), e;
}
function xl(t) {
  const e = We(t), n = pt(t, 0);
  return n.setFullYear(e.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function Ov(t, e) {
  var o, l, c, u;
  const n = jr(), a = (e == null ? void 0 : e.weekStartsOn) ?? ((l = (o = e == null ? void 0 : e.locale) == null ? void 0 : o.options) == null ? void 0 : l.weekStartsOn) ?? n.weekStartsOn ?? ((u = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : u.weekStartsOn) ?? 0, i = We(t), r = i.getDay(), s = (r < a ? -7 : 0) + 6 - (r - a);
  return i.setDate(i.getDate() + s), i.setHours(23, 59, 59, 999), i;
}
function k1(t) {
  const e = We(t), n = e.getMonth(), a = n - n % 3 + 3;
  return e.setMonth(a, 0), e.setHours(23, 59, 59, 999), e;
}
const vR = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, yR = (t, e, n) => {
  let a;
  const i = vR[t];
  return typeof i == "string" ? a = i : e === 1 ? a = i.one : a = i.other.replace("{{count}}", e.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + a : a + " ago" : a;
};
function c0(t) {
  return (e = {}) => {
    const n = e.width ? String(e.width) : t.defaultWidth;
    return t.formats[n] || t.formats[t.defaultWidth];
  };
}
const _R = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, TR = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, xR = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, wR = {
  date: c0({
    formats: _R,
    defaultWidth: "full"
  }),
  time: c0({
    formats: TR,
    defaultWidth: "full"
  }),
  dateTime: c0({
    formats: xR,
    defaultWidth: "full"
  })
}, kR = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, CR = (t, e, n, a) => kR[t];
function zo(t) {
  return (e, n) => {
    const a = n != null && n.context ? String(n.context) : "standalone";
    let i;
    if (a === "formatting" && t.formattingValues) {
      const s = t.defaultFormattingWidth || t.defaultWidth, o = n != null && n.width ? String(n.width) : s;
      i = t.formattingValues[o] || t.formattingValues[s];
    } else {
      const s = t.defaultWidth, o = n != null && n.width ? String(n.width) : t.defaultWidth;
      i = t.values[o] || t.values[s];
    }
    const r = t.argumentCallback ? t.argumentCallback(e) : e;
    return i[r];
  };
}
const SR = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, AR = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, ER = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, LR = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, DR = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, IR = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, MR = (t, e) => {
  const n = Number(t), a = n % 100;
  if (a > 20 || a < 10)
    switch (a % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, OR = {
  ordinalNumber: MR,
  era: zo({
    values: SR,
    defaultWidth: "wide"
  }),
  quarter: zo({
    values: AR,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: zo({
    values: ER,
    defaultWidth: "wide"
  }),
  day: zo({
    values: LR,
    defaultWidth: "wide"
  }),
  dayPeriod: zo({
    values: DR,
    defaultWidth: "wide",
    formattingValues: IR,
    defaultFormattingWidth: "wide"
  })
};
function Uo(t) {
  return (e, n = {}) => {
    const a = n.width, i = a && t.matchPatterns[a] || t.matchPatterns[t.defaultMatchWidth], r = e.match(i);
    if (!r)
      return null;
    const s = r[0], o = a && t.parsePatterns[a] || t.parsePatterns[t.defaultParseWidth], l = Array.isArray(o) ? BR(o, (f) => f.test(s)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      PR(o, (f) => f.test(s))
    );
    let c;
    c = t.valueCallback ? t.valueCallback(l) : l, c = n.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      n.valueCallback(c)
    ) : c;
    const u = e.slice(s.length);
    return { value: c, rest: u };
  };
}
function PR(t, e) {
  for (const n in t)
    if (Object.prototype.hasOwnProperty.call(t, n) && e(t[n]))
      return n;
}
function BR(t, e) {
  for (let n = 0; n < t.length; n++)
    if (e(t[n]))
      return n;
}
function RR(t) {
  return (e, n = {}) => {
    const a = e.match(t.matchPattern);
    if (!a) return null;
    const i = a[0], r = e.match(t.parsePattern);
    if (!r) return null;
    let s = t.valueCallback ? t.valueCallback(r[0]) : r[0];
    s = n.valueCallback ? n.valueCallback(s) : s;
    const o = e.slice(i.length);
    return { value: s, rest: o };
  };
}
const NR = /^(\d+)(th|st|nd|rd)?/i, $R = /\d+/i, FR = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, zR = {
  any: [/^b/i, /^(a|c)/i]
}, UR = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, HR = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, YR = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, jR = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, VR = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, qR = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, WR = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, GR = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, XR = {
  ordinalNumber: RR({
    matchPattern: NR,
    parsePattern: $R,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: Uo({
    matchPatterns: FR,
    defaultMatchWidth: "wide",
    parsePatterns: zR,
    defaultParseWidth: "any"
  }),
  quarter: Uo({
    matchPatterns: UR,
    defaultMatchWidth: "wide",
    parsePatterns: HR,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: Uo({
    matchPatterns: YR,
    defaultMatchWidth: "wide",
    parsePatterns: jR,
    defaultParseWidth: "any"
  }),
  day: Uo({
    matchPatterns: VR,
    defaultMatchWidth: "wide",
    parsePatterns: qR,
    defaultParseWidth: "any"
  }),
  dayPeriod: Uo({
    matchPatterns: WR,
    defaultMatchWidth: "any",
    parsePatterns: GR,
    defaultParseWidth: "any"
  })
}, Pv = {
  code: "en-US",
  formatDistance: yR,
  formatLong: wR,
  formatRelative: CR,
  localize: OR,
  match: XR,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function ZR(t) {
  const e = We(t);
  return Lv(e, xl(e)) + 1;
}
function cf(t) {
  const e = We(t), n = +Is(e) - +hR(e);
  return Math.round(n / Sv) + 1;
}
function uf(t, e) {
  var u, f, m, _;
  const n = We(t), a = n.getFullYear(), i = jr(), r = (e == null ? void 0 : e.firstWeekContainsDate) ?? ((f = (u = e == null ? void 0 : e.locale) == null ? void 0 : u.options) == null ? void 0 : f.firstWeekContainsDate) ?? i.firstWeekContainsDate ?? ((_ = (m = i.locale) == null ? void 0 : m.options) == null ? void 0 : _.firstWeekContainsDate) ?? 1, s = pt(t, 0);
  s.setFullYear(a + 1, 0, r), s.setHours(0, 0, 0, 0);
  const o = Na(s, e), l = pt(t, 0);
  l.setFullYear(a, 0, r), l.setHours(0, 0, 0, 0);
  const c = Na(l, e);
  return n.getTime() >= o.getTime() ? a + 1 : n.getTime() >= c.getTime() ? a : a - 1;
}
function KR(t, e) {
  var o, l, c, u;
  const n = jr(), a = (e == null ? void 0 : e.firstWeekContainsDate) ?? ((l = (o = e == null ? void 0 : e.locale) == null ? void 0 : o.options) == null ? void 0 : l.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((u = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : u.firstWeekContainsDate) ?? 1, i = uf(t, e), r = pt(t, 0);
  return r.setFullYear(i, 0, a), r.setHours(0, 0, 0, 0), Na(r, e);
}
function df(t, e) {
  const n = We(t), a = +Na(n, e) - +KR(n, e);
  return Math.round(a / Sv) + 1;
}
function _t(t, e) {
  const n = t < 0 ? "-" : "", a = Math.abs(t).toString().padStart(e, "0");
  return n + a;
}
const Fi = {
  // Year
  y(t, e) {
    const n = t.getFullYear(), a = n > 0 ? n : 1 - n;
    return _t(e === "yy" ? a % 100 : a, e.length);
  },
  // Month
  M(t, e) {
    const n = t.getMonth();
    return e === "M" ? String(n + 1) : _t(n + 1, 2);
  },
  // Day of the month
  d(t, e) {
    return _t(t.getDate(), e.length);
  },
  // AM or PM
  a(t, e) {
    const n = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(t, e) {
    return _t(t.getHours() % 12 || 12, e.length);
  },
  // Hour [0-23]
  H(t, e) {
    return _t(t.getHours(), e.length);
  },
  // Minute
  m(t, e) {
    return _t(t.getMinutes(), e.length);
  },
  // Second
  s(t, e) {
    return _t(t.getSeconds(), e.length);
  },
  // Fraction of second
  S(t, e) {
    const n = e.length, a = t.getMilliseconds(), i = Math.trunc(
      a * Math.pow(10, n - 3)
    );
    return _t(i, e.length);
  }
}, es = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, C1 = {
  // Era
  G: function(t, e, n) {
    const a = t.getFullYear() > 0 ? 1 : 0;
    switch (e) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(a, { width: "abbreviated" });
      case "GGGGG":
        return n.era(a, { width: "narrow" });
      case "GGGG":
      default:
        return n.era(a, { width: "wide" });
    }
  },
  // Year
  y: function(t, e, n) {
    if (e === "yo") {
      const a = t.getFullYear(), i = a > 0 ? a : 1 - a;
      return n.ordinalNumber(i, { unit: "year" });
    }
    return Fi.y(t, e);
  },
  // Local week-numbering year
  Y: function(t, e, n, a) {
    const i = uf(t, a), r = i > 0 ? i : 1 - i;
    if (e === "YY") {
      const s = r % 100;
      return _t(s, 2);
    }
    return e === "Yo" ? n.ordinalNumber(r, { unit: "year" }) : _t(r, e.length);
  },
  // ISO week-numbering year
  R: function(t, e) {
    const n = Ev(t);
    return _t(n, e.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, e) {
    const n = t.getFullYear();
    return _t(n, e.length);
  },
  // Quarter
  Q: function(t, e, n) {
    const a = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      case "Q":
        return String(a);
      case "QQ":
        return _t(a, 2);
      case "Qo":
        return n.ordinalNumber(a, { unit: "quarter" });
      case "QQQ":
        return n.quarter(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return n.quarter(a, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return n.quarter(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, e, n) {
    const a = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      case "q":
        return String(a);
      case "qq":
        return _t(a, 2);
      case "qo":
        return n.ordinalNumber(a, { unit: "quarter" });
      case "qqq":
        return n.quarter(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return n.quarter(a, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return n.quarter(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, e, n) {
    const a = t.getMonth();
    switch (e) {
      case "M":
      case "MM":
        return Fi.M(t, e);
      case "Mo":
        return n.ordinalNumber(a + 1, { unit: "month" });
      case "MMM":
        return n.month(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return n.month(a, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return n.month(a, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(t, e, n) {
    const a = t.getMonth();
    switch (e) {
      case "L":
        return String(a + 1);
      case "LL":
        return _t(a + 1, 2);
      case "Lo":
        return n.ordinalNumber(a + 1, { unit: "month" });
      case "LLL":
        return n.month(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return n.month(a, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return n.month(a, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(t, e, n, a) {
    const i = df(t, a);
    return e === "wo" ? n.ordinalNumber(i, { unit: "week" }) : _t(i, e.length);
  },
  // ISO week of year
  I: function(t, e, n) {
    const a = cf(t);
    return e === "Io" ? n.ordinalNumber(a, { unit: "week" }) : _t(a, e.length);
  },
  // Day of the month
  d: function(t, e, n) {
    return e === "do" ? n.ordinalNumber(t.getDate(), { unit: "date" }) : Fi.d(t, e);
  },
  // Day of year
  D: function(t, e, n) {
    const a = ZR(t);
    return e === "Do" ? n.ordinalNumber(a, { unit: "dayOfYear" }) : _t(a, e.length);
  },
  // Day of week
  E: function(t, e, n) {
    const a = t.getDay();
    switch (e) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, e, n, a) {
    const i = t.getDay(), r = (i - a.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      case "e":
        return String(r);
      case "ee":
        return _t(r, 2);
      case "eo":
        return n.ordinalNumber(r, { unit: "day" });
      case "eee":
        return n.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return n.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return n.day(i, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return n.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, e, n, a) {
    const i = t.getDay(), r = (i - a.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      case "c":
        return String(r);
      case "cc":
        return _t(r, e.length);
      case "co":
        return n.ordinalNumber(r, { unit: "day" });
      case "ccc":
        return n.day(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return n.day(i, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return n.day(i, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return n.day(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, e, n) {
    const a = t.getDay(), i = a === 0 ? 7 : a;
    switch (e) {
      case "i":
        return String(i);
      case "ii":
        return _t(i, e.length);
      case "io":
        return n.ordinalNumber(i, { unit: "day" });
      case "iii":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, e, n) {
    const i = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, e, n) {
    const a = t.getHours();
    let i;
    switch (a === 12 ? i = es.noon : a === 0 ? i = es.midnight : i = a / 12 >= 1 ? "pm" : "am", e) {
      case "b":
      case "bb":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, e, n) {
    const a = t.getHours();
    let i;
    switch (a >= 17 ? i = es.evening : a >= 12 ? i = es.afternoon : a >= 4 ? i = es.morning : i = es.night, e) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, e, n) {
    if (e === "ho") {
      let a = t.getHours() % 12;
      return a === 0 && (a = 12), n.ordinalNumber(a, { unit: "hour" });
    }
    return Fi.h(t, e);
  },
  // Hour [0-23]
  H: function(t, e, n) {
    return e === "Ho" ? n.ordinalNumber(t.getHours(), { unit: "hour" }) : Fi.H(t, e);
  },
  // Hour [0-11]
  K: function(t, e, n) {
    const a = t.getHours() % 12;
    return e === "Ko" ? n.ordinalNumber(a, { unit: "hour" }) : _t(a, e.length);
  },
  // Hour [1-24]
  k: function(t, e, n) {
    let a = t.getHours();
    return a === 0 && (a = 24), e === "ko" ? n.ordinalNumber(a, { unit: "hour" }) : _t(a, e.length);
  },
  // Minute
  m: function(t, e, n) {
    return e === "mo" ? n.ordinalNumber(t.getMinutes(), { unit: "minute" }) : Fi.m(t, e);
  },
  // Second
  s: function(t, e, n) {
    return e === "so" ? n.ordinalNumber(t.getSeconds(), { unit: "second" }) : Fi.s(t, e);
  },
  // Fraction of second
  S: function(t, e) {
    return Fi.S(t, e);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, e, n) {
    const a = t.getTimezoneOffset();
    if (a === 0)
      return "Z";
    switch (e) {
      case "X":
        return A1(a);
      case "XXXX":
      case "XX":
        return br(a);
      case "XXXXX":
      case "XXX":
      default:
        return br(a, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, e, n) {
    const a = t.getTimezoneOffset();
    switch (e) {
      case "x":
        return A1(a);
      case "xxxx":
      case "xx":
        return br(a);
      case "xxxxx":
      case "xxx":
      default:
        return br(a, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, e, n) {
    const a = t.getTimezoneOffset();
    switch (e) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + S1(a, ":");
      case "OOOO":
      default:
        return "GMT" + br(a, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, e, n) {
    const a = t.getTimezoneOffset();
    switch (e) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + S1(a, ":");
      case "zzzz":
      default:
        return "GMT" + br(a, ":");
    }
  },
  // Seconds timestamp
  t: function(t, e, n) {
    const a = Math.trunc(t.getTime() / 1e3);
    return _t(a, e.length);
  },
  // Milliseconds timestamp
  T: function(t, e, n) {
    const a = t.getTime();
    return _t(a, e.length);
  }
};
function S1(t, e = "") {
  const n = t > 0 ? "-" : "+", a = Math.abs(t), i = Math.trunc(a / 60), r = a % 60;
  return r === 0 ? n + String(i) : n + String(i) + e + _t(r, 2);
}
function A1(t, e) {
  return t % 60 === 0 ? (t > 0 ? "-" : "+") + _t(Math.abs(t) / 60, 2) : br(t, e);
}
function br(t, e = "") {
  const n = t > 0 ? "-" : "+", a = Math.abs(t), i = _t(Math.trunc(a / 60), 2), r = _t(a % 60, 2);
  return n + i + e + r;
}
const E1 = (t, e) => {
  switch (t) {
    case "P":
      return e.date({ width: "short" });
    case "PP":
      return e.date({ width: "medium" });
    case "PPP":
      return e.date({ width: "long" });
    case "PPPP":
    default:
      return e.date({ width: "full" });
  }
}, Bv = (t, e) => {
  switch (t) {
    case "p":
      return e.time({ width: "short" });
    case "pp":
      return e.time({ width: "medium" });
    case "ppp":
      return e.time({ width: "long" });
    case "pppp":
    default:
      return e.time({ width: "full" });
  }
}, QR = (t, e) => {
  const n = t.match(/(P+)(p+)?/) || [], a = n[1], i = n[2];
  if (!i)
    return E1(t, e);
  let r;
  switch (a) {
    case "P":
      r = e.dateTime({ width: "short" });
      break;
    case "PP":
      r = e.dateTime({ width: "medium" });
      break;
    case "PPP":
      r = e.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      r = e.dateTime({ width: "full" });
      break;
  }
  return r.replace("{{date}}", E1(a, e)).replace("{{time}}", Bv(i, e));
}, eh = {
  p: Bv,
  P: QR
}, JR = /^D+$/, eN = /^Y+$/, tN = ["D", "DD", "YY", "YYYY"];
function Rv(t) {
  return JR.test(t);
}
function Nv(t) {
  return eN.test(t);
}
function th(t, e, n) {
  const a = nN(t, e, n);
  if (console.warn(a), tN.includes(t)) throw new RangeError(a);
}
function nN(t, e, n) {
  const a = t[0] === "Y" ? "years" : "days of the month";
  return `Use \`${t.toLowerCase()}\` instead of \`${t}\` (in \`${e}\`) for formatting ${a} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const aN = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, iN = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, rN = /^'([^]*?)'?$/, sN = /''/g, oN = /[a-zA-Z]/;
function Ja(t, e, n) {
  var u, f, m, _, T, g, x, S;
  const a = jr(), i = (n == null ? void 0 : n.locale) ?? a.locale ?? Pv, r = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((f = (u = n == null ? void 0 : n.locale) == null ? void 0 : u.options) == null ? void 0 : f.firstWeekContainsDate) ?? a.firstWeekContainsDate ?? ((_ = (m = a.locale) == null ? void 0 : m.options) == null ? void 0 : _.firstWeekContainsDate) ?? 1, s = (n == null ? void 0 : n.weekStartsOn) ?? ((g = (T = n == null ? void 0 : n.locale) == null ? void 0 : T.options) == null ? void 0 : g.weekStartsOn) ?? a.weekStartsOn ?? ((S = (x = a.locale) == null ? void 0 : x.options) == null ? void 0 : S.weekStartsOn) ?? 0, o = We(t);
  if (!ol(o))
    throw new RangeError("Invalid time value");
  let l = e.match(iN).map((D) => {
    const L = D[0];
    if (L === "p" || L === "P") {
      const M = eh[L];
      return M(D, i.formatLong);
    }
    return D;
  }).join("").match(aN).map((D) => {
    if (D === "''")
      return { isToken: !1, value: "'" };
    const L = D[0];
    if (L === "'")
      return { isToken: !1, value: lN(D) };
    if (C1[L])
      return { isToken: !0, value: D };
    if (L.match(oN))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + L + "`"
      );
    return { isToken: !1, value: D };
  });
  i.localize.preprocessor && (l = i.localize.preprocessor(o, l));
  const c = {
    firstWeekContainsDate: r,
    weekStartsOn: s,
    locale: i
  };
  return l.map((D) => {
    if (!D.isToken) return D.value;
    const L = D.value;
    (!(n != null && n.useAdditionalWeekYearTokens) && Nv(L) || !(n != null && n.useAdditionalDayOfYearTokens) && Rv(L)) && th(L, e, String(t));
    const M = C1[L[0]];
    return M(o, L, i.localize, c);
  }).join("");
}
function lN(t) {
  const e = t.match(rN);
  return e ? e[1].replace(sN, "'") : t;
}
function cN(t) {
  return We(t).getDay();
}
function uN(t) {
  const e = We(t), n = e.getFullYear(), a = e.getMonth(), i = pt(t, 0);
  return i.setFullYear(n, a + 1, 0), i.setHours(0, 0, 0, 0), i.getDate();
}
function dN() {
  return Object.assign({}, jr());
}
function ki(t) {
  return We(t).getHours();
}
function hN(t) {
  let n = We(t).getDay();
  return n === 0 && (n = 7), n;
}
function nr(t) {
  return We(t).getMinutes();
}
function ht(t) {
  return We(t).getMonth();
}
function Ms(t) {
  return We(t).getSeconds();
}
function at(t) {
  return We(t).getFullYear();
}
function Os(t, e) {
  const n = We(t), a = We(e);
  return n.getTime() > a.getTime();
}
function wl(t, e) {
  const n = We(t), a = We(e);
  return +n < +a;
}
function hs(t, e) {
  const n = We(t), a = We(e);
  return +n == +a;
}
function fN(t, e) {
  const n = e instanceof Date ? pt(e, 0) : new e(0);
  return n.setFullYear(
    t.getFullYear(),
    t.getMonth(),
    t.getDate()
  ), n.setHours(
    t.getHours(),
    t.getMinutes(),
    t.getSeconds(),
    t.getMilliseconds()
  ), n;
}
const pN = 10;
class $v {
  constructor() {
    Ve(this, "subPriority", 0);
  }
  validate(e, n) {
    return !0;
  }
}
class mN extends $v {
  constructor(e, n, a, i, r) {
    super(), this.value = e, this.validateValue = n, this.setValue = a, this.priority = i, r && (this.subPriority = r);
  }
  validate(e, n) {
    return this.validateValue(e, this.value, n);
  }
  set(e, n, a) {
    return this.setValue(e, n, this.value, a);
  }
}
class gN extends $v {
  constructor() {
    super(...arguments);
    Ve(this, "priority", pN);
    Ve(this, "subPriority", -1);
  }
  set(n, a) {
    return a.timestampIsSet ? n : pt(n, fN(n, Date));
  }
}
let mt = class {
  run(e, n, a, i) {
    const r = this.parse(e, n, a, i);
    return r ? {
      setter: new mN(
        r.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: r.rest
    } : null;
  }
  validate(e, n, a) {
    return !0;
  }
};
class bN extends mt {
  constructor() {
    super(...arguments);
    Ve(this, "priority", 140);
    Ve(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(n, a, i) {
    switch (a) {
      case "G":
      case "GG":
      case "GGG":
        return i.era(n, { width: "abbreviated" }) || i.era(n, { width: "narrow" });
      case "GGGGG":
        return i.era(n, { width: "narrow" });
      case "GGGG":
      default:
        return i.era(n, { width: "wide" }) || i.era(n, { width: "abbreviated" }) || i.era(n, { width: "narrow" });
    }
  }
  set(n, a, i) {
    return a.era = i, n.setFullYear(i, 0, 1), n.setHours(0, 0, 0, 0), n;
  }
}
const tn = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, qa = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function nn(t, e) {
  return t && {
    value: e(t.value),
    rest: t.rest
  };
}
function Ut(t, e) {
  const n = e.match(t);
  return n ? {
    value: parseInt(n[0], 10),
    rest: e.slice(n[0].length)
  } : null;
}
function Wa(t, e) {
  const n = e.match(t);
  if (!n)
    return null;
  if (n[0] === "Z")
    return {
      value: 0,
      rest: e.slice(1)
    };
  const a = n[1] === "+" ? 1 : -1, i = n[2] ? parseInt(n[2], 10) : 0, r = n[3] ? parseInt(n[3], 10) : 0, s = n[5] ? parseInt(n[5], 10) : 0;
  return {
    value: a * (i * Av + r * lR + s * cR),
    rest: e.slice(n[0].length)
  };
}
function Fv(t) {
  return Ut(tn.anyDigitsSigned, t);
}
function Wt(t, e) {
  switch (t) {
    case 1:
      return Ut(tn.singleDigit, e);
    case 2:
      return Ut(tn.twoDigits, e);
    case 3:
      return Ut(tn.threeDigits, e);
    case 4:
      return Ut(tn.fourDigits, e);
    default:
      return Ut(new RegExp("^\\d{1," + t + "}"), e);
  }
}
function ou(t, e) {
  switch (t) {
    case 1:
      return Ut(tn.singleDigitSigned, e);
    case 2:
      return Ut(tn.twoDigitsSigned, e);
    case 3:
      return Ut(tn.threeDigitsSigned, e);
    case 4:
      return Ut(tn.fourDigitsSigned, e);
    default:
      return Ut(new RegExp("^-?\\d{1," + t + "}"), e);
  }
}
function hf(t) {
  switch (t) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function zv(t, e) {
  const n = e > 0, a = n ? e : 1 - e;
  let i;
  if (a <= 50)
    i = t || 100;
  else {
    const r = a + 50, s = Math.trunc(r / 100) * 100, o = t >= r % 100;
    i = t + s - (o ? 100 : 0);
  }
  return n ? i : 1 - i;
}
function Uv(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
class vN extends mt {
  constructor() {
    super(...arguments);
    Ve(this, "priority", 130);
    Ve(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(n, a, i) {
    const r = (s) => ({
      year: s,
      isTwoDigitYear: a === "yy"
    });
    switch (a) {
      case "y":
        return nn(Wt(4, n), r);
      case "yo":
        return nn(
          i.ordinalNumber(n, {
            unit: "year"
          }),
          r
        );
      default:
        return nn(Wt(a.length, n), r);
    }
  }
  validate(n, a) {
    return a.isTwoDigitYear || a.year > 0;
  }
  set(n, a, i) {
    const r = n.getFullYear();
    if (i.isTwoDigitYear) {
      const o = zv(
        i.year,
        r
      );
      return n.setFullYear(o, 0, 1), n.setHours(0, 0, 0, 0), n;
    }
    const s = !("era" in a) || a.era === 1 ? i.year : 1 - i.year;
    return n.setFullYear(s, 0, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class yN extends mt {
  constructor() {
    super(...arguments);
    Ve(this, "priority", 130);
    Ve(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(n, a, i) {
    const r = (s) => ({
      year: s,
      isTwoDigitYear: a === "YY"
    });
    switch (a) {
      case "Y":
        return nn(Wt(4, n), r);
      case "Yo":
        return nn(
          i.ordinalNumber(n, {
            unit: "year"
          }),
          r
        );
      default:
        return nn(Wt(a.length, n), r);
    }
  }
  validate(n, a) {
    return a.isTwoDigitYear || a.year > 0;
  }
  set(n, a, i, r) {
    const s = uf(n, r);
    if (i.isTwoDigitYear) {
      const l = zv(
        i.year,
        s
      );
      return n.setFullYear(
        l,
        0,
        r.firstWeekContainsDate
      ), n.setHours(0, 0, 0, 0), Na(n, r);
    }
    const o = !("era" in a) || a.era === 1 ? i.year : 1 - i.year;
    return n.setFullYear(o, 0, r.firstWeekContainsDate), n.setHours(0, 0, 0, 0), Na(n, r);
  }
}
class _N extends mt {
  constructor() {
    super(...arguments);
    Ve(this, "priority", 130);
    Ve(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, a) {
    return ou(a === "R" ? 4 : a.length, n);
  }
  set(n, a, i) {
    const r = pt(n, 0);
    return r.setFullYear(i, 0, 4), r.setHours(0, 0, 0, 0), Is(r);
  }
}
class TN extends mt {
  constructor() {
    super(...arguments);
    Ve(this, "priority", 130);
    Ve(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(n, a) {
    return ou(a === "u" ? 4 : a.length, n);
  }
  set(n, a, i) {
    return n.setFullYear(i, 0, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class xN extends mt {
  constructor() {
    super(...arguments);
    Ve(this, "priority", 120);
    Ve(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, a, i) {
    switch (a) {
      case "Q":
      case "QQ":
        return Wt(a.length, n);
      case "Qo":
        return i.ordinalNumber(n, { unit: "quarter" });
      case "QQQ":
        return i.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQQ":
        return i.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return i.quarter(n, {
          width: "wide",
          context: "formatting"
        }) || i.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(n, a) {
    return a >= 1 && a <= 4;
  }
  set(n, a, i) {
    return n.setMonth((i - 1) * 3, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class wN extends mt {
  constructor() {
    super(...arguments);
    Ve(this, "priority", 120);
    Ve(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, a, i) {
    switch (a) {
      case "q":
      case "qq":
        return Wt(a.length, n);
      case "qo":
        return i.ordinalNumber(n, { unit: "quarter" });
      case "qqq":
        return i.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        }) || i.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqqq":
        return i.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return i.quarter(n, {
          width: "wide",
          context: "standalone"
        }) || i.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        }) || i.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(n, a) {
    return a >= 1 && a <= 4;
  }
  set(n, a, i) {
    return n.setMonth((i - 1) * 3, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class kN extends mt {
  constructor() {
    super(...arguments);
    Ve(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
    Ve(this, "priority", 110);
  }
  parse(n, a, i) {
    const r = (s) => s - 1;
    switch (a) {
      case "M":
        return nn(
          Ut(tn.month, n),
          r
        );
      case "MM":
        return nn(Wt(2, n), r);
      case "Mo":
        return nn(
          i.ordinalNumber(n, {
            unit: "month"
          }),
          r
        );
      case "MMM":
        return i.month(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.month(n, { width: "narrow", context: "formatting" });
      case "MMMMM":
        return i.month(n, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return i.month(n, { width: "wide", context: "formatting" }) || i.month(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.month(n, { width: "narrow", context: "formatting" });
    }
  }
  validate(n, a) {
    return a >= 0 && a <= 11;
  }
  set(n, a, i) {
    return n.setMonth(i, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class CN extends mt {
  constructor() {
    super(...arguments);
    Ve(this, "priority", 110);
    Ve(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, a, i) {
    const r = (s) => s - 1;
    switch (a) {
      case "L":
        return nn(
          Ut(tn.month, n),
          r
        );
      case "LL":
        return nn(Wt(2, n), r);
      case "Lo":
        return nn(
          i.ordinalNumber(n, {
            unit: "month"
          }),
          r
        );
      case "LLL":
        return i.month(n, {
          width: "abbreviated",
          context: "standalone"
        }) || i.month(n, { width: "narrow", context: "standalone" });
      case "LLLLL":
        return i.month(n, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return i.month(n, { width: "wide", context: "standalone" }) || i.month(n, {
          width: "abbreviated",
          context: "standalone"
        }) || i.month(n, { width: "narrow", context: "standalone" });
    }
  }
  validate(n, a) {
    return a >= 0 && a <= 11;
  }
  set(n, a, i) {
    return n.setMonth(i, 1), n.setHours(0, 0, 0, 0), n;
  }
}
function SN(t, e, n) {
  const a = We(t), i = df(a, n) - e;
  return a.setDate(a.getDate() - i * 7), a;
}
class AN extends mt {
  constructor() {
    super(...arguments);
    Ve(this, "priority", 100);
    Ve(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(n, a, i) {
    switch (a) {
      case "w":
        return Ut(tn.week, n);
      case "wo":
        return i.ordinalNumber(n, { unit: "week" });
      default:
        return Wt(a.length, n);
    }
  }
  validate(n, a) {
    return a >= 1 && a <= 53;
  }
  set(n, a, i, r) {
    return Na(SN(n, i, r), r);
  }
}
function EN(t, e) {
  const n = We(t), a = cf(n) - e;
  return n.setDate(n.getDate() - a * 7), n;
}
class LN extends mt {
  constructor() {
    super(...arguments);
    Ve(this, "priority", 100);
    Ve(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, a, i) {
    switch (a) {
      case "I":
        return Ut(tn.week, n);
      case "Io":
        return i.ordinalNumber(n, { unit: "week" });
      default:
        return Wt(a.length, n);
    }
  }
  validate(n, a) {
    return a >= 1 && a <= 53;
  }
  set(n, a, i) {
    return Is(EN(n, i));
  }
}
const DN = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], IN = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class MN extends mt {
  constructor() {
    super(...arguments);
    Ve(this, "priority", 90);
    Ve(this, "subPriority", 1);
    Ve(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, a, i) {
    switch (a) {
      case "d":
        return Ut(tn.date, n);
      case "do":
        return i.ordinalNumber(n, { unit: "date" });
      default:
        return Wt(a.length, n);
    }
  }
  validate(n, a) {
    const i = n.getFullYear(), r = Uv(i), s = n.getMonth();
    return r ? a >= 1 && a <= IN[s] : a >= 1 && a <= DN[s];
  }
  set(n, a, i) {
    return n.setDate(i), n.setHours(0, 0, 0, 0), n;
  }
}
class ON extends mt {
  constructor() {
    super(...arguments);
    Ve(this, "priority", 90);
    Ve(this, "subpriority", 1);
    Ve(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, a, i) {
    switch (a) {
      case "D":
      case "DD":
        return Ut(tn.dayOfYear, n);
      case "Do":
        return i.ordinalNumber(n, { unit: "date" });
      default:
        return Wt(a.length, n);
    }
  }
  validate(n, a) {
    const i = n.getFullYear();
    return Uv(i) ? a >= 1 && a <= 366 : a >= 1 && a <= 365;
  }
  set(n, a, i) {
    return n.setMonth(0, i), n.setHours(0, 0, 0, 0), n;
  }
}
function ff(t, e, n) {
  var f, m, _, T;
  const a = jr(), i = (n == null ? void 0 : n.weekStartsOn) ?? ((m = (f = n == null ? void 0 : n.locale) == null ? void 0 : f.options) == null ? void 0 : m.weekStartsOn) ?? a.weekStartsOn ?? ((T = (_ = a.locale) == null ? void 0 : _.options) == null ? void 0 : T.weekStartsOn) ?? 0, r = We(t), s = r.getDay(), l = (e % 7 + 7) % 7, c = 7 - i, u = e < 0 || e > 6 ? e - (s + c) % 7 : (l + c) % 7 - (s + c) % 7;
  return Da(r, u);
}
class PN extends mt {
  constructor() {
    super(...arguments);
    Ve(this, "priority", 90);
    Ve(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(n, a, i) {
    switch (a) {
      case "E":
      case "EE":
      case "EEE":
        return i.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.day(n, { width: "short", context: "formatting" }) || i.day(n, { width: "narrow", context: "formatting" });
      case "EEEEE":
        return i.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return i.day(n, { width: "short", context: "formatting" }) || i.day(n, { width: "narrow", context: "formatting" });
      case "EEEE":
      default:
        return i.day(n, { width: "wide", context: "formatting" }) || i.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.day(n, { width: "short", context: "formatting" }) || i.day(n, { width: "narrow", context: "formatting" });
    }
  }
  validate(n, a) {
    return a >= 0 && a <= 6;
  }
  set(n, a, i, r) {
    return n = ff(n, i, r), n.setHours(0, 0, 0, 0), n;
  }
}
class BN extends mt {
  constructor() {
    super(...arguments);
    Ve(this, "priority", 90);
    Ve(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, a, i, r) {
    const s = (o) => {
      const l = Math.floor((o - 1) / 7) * 7;
      return (o + r.weekStartsOn + 6) % 7 + l;
    };
    switch (a) {
      case "e":
      case "ee":
        return nn(Wt(a.length, n), s);
      case "eo":
        return nn(
          i.ordinalNumber(n, {
            unit: "day"
          }),
          s
        );
      case "eee":
        return i.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.day(n, { width: "short", context: "formatting" }) || i.day(n, { width: "narrow", context: "formatting" });
      case "eeeee":
        return i.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return i.day(n, { width: "short", context: "formatting" }) || i.day(n, { width: "narrow", context: "formatting" });
      case "eeee":
      default:
        return i.day(n, { width: "wide", context: "formatting" }) || i.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.day(n, { width: "short", context: "formatting" }) || i.day(n, { width: "narrow", context: "formatting" });
    }
  }
  validate(n, a) {
    return a >= 0 && a <= 6;
  }
  set(n, a, i, r) {
    return n = ff(n, i, r), n.setHours(0, 0, 0, 0), n;
  }
}
class RN extends mt {
  constructor() {
    super(...arguments);
    Ve(this, "priority", 90);
    Ve(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(n, a, i, r) {
    const s = (o) => {
      const l = Math.floor((o - 1) / 7) * 7;
      return (o + r.weekStartsOn + 6) % 7 + l;
    };
    switch (a) {
      case "c":
      case "cc":
        return nn(Wt(a.length, n), s);
      case "co":
        return nn(
          i.ordinalNumber(n, {
            unit: "day"
          }),
          s
        );
      case "ccc":
        return i.day(n, {
          width: "abbreviated",
          context: "standalone"
        }) || i.day(n, { width: "short", context: "standalone" }) || i.day(n, { width: "narrow", context: "standalone" });
      case "ccccc":
        return i.day(n, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return i.day(n, { width: "short", context: "standalone" }) || i.day(n, { width: "narrow", context: "standalone" });
      case "cccc":
      default:
        return i.day(n, { width: "wide", context: "standalone" }) || i.day(n, {
          width: "abbreviated",
          context: "standalone"
        }) || i.day(n, { width: "short", context: "standalone" }) || i.day(n, { width: "narrow", context: "standalone" });
    }
  }
  validate(n, a) {
    return a >= 0 && a <= 6;
  }
  set(n, a, i, r) {
    return n = ff(n, i, r), n.setHours(0, 0, 0, 0), n;
  }
}
function NN(t, e) {
  const n = We(t), a = hN(n), i = e - a;
  return Da(n, i);
}
class $N extends mt {
  constructor() {
    super(...arguments);
    Ve(this, "priority", 90);
    Ve(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, a, i) {
    const r = (s) => s === 0 ? 7 : s;
    switch (a) {
      case "i":
      case "ii":
        return Wt(a.length, n);
      case "io":
        return i.ordinalNumber(n, { unit: "day" });
      case "iii":
        return nn(
          i.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(n, {
            width: "short",
            context: "formatting"
          }) || i.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          r
        );
      case "iiiii":
        return nn(
          i.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          r
        );
      case "iiiiii":
        return nn(
          i.day(n, {
            width: "short",
            context: "formatting"
          }) || i.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          r
        );
      case "iiii":
      default:
        return nn(
          i.day(n, {
            width: "wide",
            context: "formatting"
          }) || i.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(n, {
            width: "short",
            context: "formatting"
          }) || i.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          r
        );
    }
  }
  validate(n, a) {
    return a >= 1 && a <= 7;
  }
  set(n, a, i) {
    return n = NN(n, i), n.setHours(0, 0, 0, 0), n;
  }
}
class FN extends mt {
  constructor() {
    super(...arguments);
    Ve(this, "priority", 80);
    Ve(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(n, a, i) {
    switch (a) {
      case "a":
      case "aa":
      case "aaa":
        return i.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return i.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return i.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        }) || i.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(n, a, i) {
    return n.setHours(hf(i), 0, 0, 0), n;
  }
}
class zN extends mt {
  constructor() {
    super(...arguments);
    Ve(this, "priority", 80);
    Ve(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(n, a, i) {
    switch (a) {
      case "b":
      case "bb":
      case "bbb":
        return i.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return i.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return i.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        }) || i.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(n, a, i) {
    return n.setHours(hf(i), 0, 0, 0), n;
  }
}
class UN extends mt {
  constructor() {
    super(...arguments);
    Ve(this, "priority", 80);
    Ve(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(n, a, i) {
    switch (a) {
      case "B":
      case "BB":
      case "BBB":
        return i.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return i.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return i.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        }) || i.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(n, a, i) {
    return n.setHours(hf(i), 0, 0, 0), n;
  }
}
class HN extends mt {
  constructor() {
    super(...arguments);
    Ve(this, "priority", 70);
    Ve(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(n, a, i) {
    switch (a) {
      case "h":
        return Ut(tn.hour12h, n);
      case "ho":
        return i.ordinalNumber(n, { unit: "hour" });
      default:
        return Wt(a.length, n);
    }
  }
  validate(n, a) {
    return a >= 1 && a <= 12;
  }
  set(n, a, i) {
    const r = n.getHours() >= 12;
    return r && i < 12 ? n.setHours(i + 12, 0, 0, 0) : !r && i === 12 ? n.setHours(0, 0, 0, 0) : n.setHours(i, 0, 0, 0), n;
  }
}
class YN extends mt {
  constructor() {
    super(...arguments);
    Ve(this, "priority", 70);
    Ve(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(n, a, i) {
    switch (a) {
      case "H":
        return Ut(tn.hour23h, n);
      case "Ho":
        return i.ordinalNumber(n, { unit: "hour" });
      default:
        return Wt(a.length, n);
    }
  }
  validate(n, a) {
    return a >= 0 && a <= 23;
  }
  set(n, a, i) {
    return n.setHours(i, 0, 0, 0), n;
  }
}
class jN extends mt {
  constructor() {
    super(...arguments);
    Ve(this, "priority", 70);
    Ve(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(n, a, i) {
    switch (a) {
      case "K":
        return Ut(tn.hour11h, n);
      case "Ko":
        return i.ordinalNumber(n, { unit: "hour" });
      default:
        return Wt(a.length, n);
    }
  }
  validate(n, a) {
    return a >= 0 && a <= 11;
  }
  set(n, a, i) {
    return n.getHours() >= 12 && i < 12 ? n.setHours(i + 12, 0, 0, 0) : n.setHours(i, 0, 0, 0), n;
  }
}
class VN extends mt {
  constructor() {
    super(...arguments);
    Ve(this, "priority", 70);
    Ve(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(n, a, i) {
    switch (a) {
      case "k":
        return Ut(tn.hour24h, n);
      case "ko":
        return i.ordinalNumber(n, { unit: "hour" });
      default:
        return Wt(a.length, n);
    }
  }
  validate(n, a) {
    return a >= 1 && a <= 24;
  }
  set(n, a, i) {
    const r = i <= 24 ? i % 24 : i;
    return n.setHours(r, 0, 0, 0), n;
  }
}
class qN extends mt {
  constructor() {
    super(...arguments);
    Ve(this, "priority", 60);
    Ve(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(n, a, i) {
    switch (a) {
      case "m":
        return Ut(tn.minute, n);
      case "mo":
        return i.ordinalNumber(n, { unit: "minute" });
      default:
        return Wt(a.length, n);
    }
  }
  validate(n, a) {
    return a >= 0 && a <= 59;
  }
  set(n, a, i) {
    return n.setMinutes(i, 0, 0), n;
  }
}
class WN extends mt {
  constructor() {
    super(...arguments);
    Ve(this, "priority", 50);
    Ve(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(n, a, i) {
    switch (a) {
      case "s":
        return Ut(tn.second, n);
      case "so":
        return i.ordinalNumber(n, { unit: "second" });
      default:
        return Wt(a.length, n);
    }
  }
  validate(n, a) {
    return a >= 0 && a <= 59;
  }
  set(n, a, i) {
    return n.setSeconds(i, 0), n;
  }
}
class GN extends mt {
  constructor() {
    super(...arguments);
    Ve(this, "priority", 30);
    Ve(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(n, a) {
    const i = (r) => Math.trunc(r * Math.pow(10, -a.length + 3));
    return nn(Wt(a.length, n), i);
  }
  set(n, a, i) {
    return n.setMilliseconds(i), n;
  }
}
class XN extends mt {
  constructor() {
    super(...arguments);
    Ve(this, "priority", 10);
    Ve(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(n, a) {
    switch (a) {
      case "X":
        return Wa(
          qa.basicOptionalMinutes,
          n
        );
      case "XX":
        return Wa(qa.basic, n);
      case "XXXX":
        return Wa(
          qa.basicOptionalSeconds,
          n
        );
      case "XXXXX":
        return Wa(
          qa.extendedOptionalSeconds,
          n
        );
      case "XXX":
      default:
        return Wa(qa.extended, n);
    }
  }
  set(n, a, i) {
    return a.timestampIsSet ? n : pt(
      n,
      n.getTime() - su(n) - i
    );
  }
}
class ZN extends mt {
  constructor() {
    super(...arguments);
    Ve(this, "priority", 10);
    Ve(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(n, a) {
    switch (a) {
      case "x":
        return Wa(
          qa.basicOptionalMinutes,
          n
        );
      case "xx":
        return Wa(qa.basic, n);
      case "xxxx":
        return Wa(
          qa.basicOptionalSeconds,
          n
        );
      case "xxxxx":
        return Wa(
          qa.extendedOptionalSeconds,
          n
        );
      case "xxx":
      default:
        return Wa(qa.extended, n);
    }
  }
  set(n, a, i) {
    return a.timestampIsSet ? n : pt(
      n,
      n.getTime() - su(n) - i
    );
  }
}
class KN extends mt {
  constructor() {
    super(...arguments);
    Ve(this, "priority", 40);
    Ve(this, "incompatibleTokens", "*");
  }
  parse(n) {
    return Fv(n);
  }
  set(n, a, i) {
    return [pt(n, i * 1e3), { timestampIsSet: !0 }];
  }
}
class QN extends mt {
  constructor() {
    super(...arguments);
    Ve(this, "priority", 20);
    Ve(this, "incompatibleTokens", "*");
  }
  parse(n) {
    return Fv(n);
  }
  set(n, a, i) {
    return [pt(n, i), { timestampIsSet: !0 }];
  }
}
const JN = {
  G: new bN(),
  y: new vN(),
  Y: new yN(),
  R: new _N(),
  u: new TN(),
  Q: new xN(),
  q: new wN(),
  M: new kN(),
  L: new CN(),
  w: new AN(),
  I: new LN(),
  d: new MN(),
  D: new ON(),
  E: new PN(),
  e: new BN(),
  c: new RN(),
  i: new $N(),
  a: new FN(),
  b: new zN(),
  B: new UN(),
  h: new HN(),
  H: new YN(),
  K: new jN(),
  k: new VN(),
  m: new qN(),
  s: new WN(),
  S: new GN(),
  X: new XN(),
  x: new ZN(),
  t: new KN(),
  T: new QN()
}, e$ = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, t$ = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, n$ = /^'([^]*?)'?$/, a$ = /''/g, i$ = /\S/, r$ = /[a-zA-Z]/;
function nh(t, e, n, a) {
  var g, x, S, D, L, M, E, P;
  const i = dN(), r = (a == null ? void 0 : a.locale) ?? i.locale ?? Pv, s = (a == null ? void 0 : a.firstWeekContainsDate) ?? ((x = (g = a == null ? void 0 : a.locale) == null ? void 0 : g.options) == null ? void 0 : x.firstWeekContainsDate) ?? i.firstWeekContainsDate ?? ((D = (S = i.locale) == null ? void 0 : S.options) == null ? void 0 : D.firstWeekContainsDate) ?? 1, o = (a == null ? void 0 : a.weekStartsOn) ?? ((M = (L = a == null ? void 0 : a.locale) == null ? void 0 : L.options) == null ? void 0 : M.weekStartsOn) ?? i.weekStartsOn ?? ((P = (E = i.locale) == null ? void 0 : E.options) == null ? void 0 : P.weekStartsOn) ?? 0;
  if (e === "")
    return t === "" ? We(n) : pt(n, NaN);
  const l = {
    firstWeekContainsDate: s,
    weekStartsOn: o,
    locale: r
  }, c = [new gN()], u = e.match(t$).map((B) => {
    const z = B[0];
    if (z in eh) {
      const W = eh[z];
      return W(B, r.formatLong);
    }
    return B;
  }).join("").match(e$), f = [];
  for (let B of u) {
    !(a != null && a.useAdditionalWeekYearTokens) && Nv(B) && th(B, e, t), !(a != null && a.useAdditionalDayOfYearTokens) && Rv(B) && th(B, e, t);
    const z = B[0], W = JN[z];
    if (W) {
      const { incompatibleTokens: V } = W;
      if (Array.isArray(V)) {
        const se = f.find(
          (ie) => V.includes(ie.token) || ie.token === z
        );
        if (se)
          throw new RangeError(
            `The format string mustn't contain \`${se.fullToken}\` and \`${B}\` at the same time`
          );
      } else if (W.incompatibleTokens === "*" && f.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${B}\` and any other token at the same time`
        );
      f.push({ token: z, fullToken: B });
      const H = W.run(
        t,
        B,
        r.match,
        l
      );
      if (!H)
        return pt(n, NaN);
      c.push(H.setter), t = H.rest;
    } else {
      if (z.match(r$))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + z + "`"
        );
      if (B === "''" ? B = "'" : z === "'" && (B = s$(B)), t.indexOf(B) === 0)
        t = t.slice(B.length);
      else
        return pt(n, NaN);
    }
  }
  if (t.length > 0 && i$.test(t))
    return pt(n, NaN);
  const m = c.map((B) => B.priority).sort((B, z) => z - B).filter((B, z, W) => W.indexOf(B) === z).map(
    (B) => c.filter((z) => z.priority === B).sort((z, W) => W.subPriority - z.subPriority)
  ).map((B) => B[0]);
  let _ = We(n);
  if (isNaN(_.getTime()))
    return pt(n, NaN);
  const T = {};
  for (const B of m) {
    if (!B.validate(_, l))
      return pt(n, NaN);
    const z = B.set(_, T, l);
    Array.isArray(z) ? (_ = z[0], Object.assign(T, z[1])) : _ = z;
  }
  return pt(n, _);
}
function s$(t) {
  return t.match(n$)[1].replace(a$, "'");
}
function L1(t, e) {
  const n = kr(t), a = kr(e);
  return +n == +a;
}
function o$(t, e) {
  return Da(t, -e);
}
function Hv(t, e) {
  const n = We(t), a = n.getFullYear(), i = n.getDate(), r = pt(t, 0);
  r.setFullYear(a, e, 15), r.setHours(0, 0, 0, 0);
  const s = uN(r);
  return n.setMonth(e, Math.min(i, s)), n;
}
function St(t, e) {
  let n = We(t);
  return isNaN(+n) ? pt(t, NaN) : (e.year != null && n.setFullYear(e.year), e.month != null && (n = Hv(n, e.month)), e.date != null && n.setDate(e.date), e.hours != null && n.setHours(e.hours), e.minutes != null && n.setMinutes(e.minutes), e.seconds != null && n.setSeconds(e.seconds), e.milliseconds != null && n.setMilliseconds(e.milliseconds), n);
}
function l$(t, e) {
  const n = We(t);
  return n.setHours(e), n;
}
function Yv(t, e) {
  const n = We(t);
  return n.setMilliseconds(e), n;
}
function c$(t, e) {
  const n = We(t);
  return n.setMinutes(e), n;
}
function jv(t, e) {
  const n = We(t);
  return n.setSeconds(e), n;
}
function Ga(t, e) {
  const n = We(t);
  return isNaN(+n) ? pt(t, NaN) : (n.setFullYear(e), n);
}
function Ps(t, e) {
  return Pa(t, -e);
}
function u$(t, e) {
  const {
    years: n = 0,
    months: a = 0,
    weeks: i = 0,
    days: r = 0,
    hours: s = 0,
    minutes: o = 0,
    seconds: l = 0
  } = e, c = Ps(t, a + n * 12), u = o$(c, r + i * 7), f = o + s * 60, _ = (l + f * 60) * 1e3;
  return pt(t, u.getTime() - _);
}
function Vv(t, e) {
  return lf(t, -e);
}
function ro() {
  return h(), b(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      k("path", {
        d: "M29.333 8c0-2.208-1.792-4-4-4h-18.667c-2.208 0-4 1.792-4 4v18.667c0 2.208 1.792 4 4 4h18.667c2.208 0 4-1.792 4-4v-18.667zM26.667 8v18.667c0 0.736-0.597 1.333-1.333 1.333 0 0-18.667 0-18.667 0-0.736 0-1.333-0.597-1.333-1.333 0 0 0-18.667 0-18.667 0-0.736 0.597-1.333 1.333-1.333 0 0 18.667 0 18.667 0 0.736 0 1.333 0.597 1.333 1.333z"
      }),
      k("path", {
        d: "M20 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      }),
      k("path", {
        d: "M9.333 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      }),
      k("path", {
        d: "M4 14.667h24c0.736 0 1.333-0.597 1.333-1.333s-0.597-1.333-1.333-1.333h-24c-0.736 0-1.333 0.597-1.333 1.333s0.597 1.333 1.333 1.333z"
      })
    ]
  );
}
ro.compatConfig = {
  MODE: 3
};
function qv() {
  return h(), b(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      k("path", {
        d: "M23.057 7.057l-16 16c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l16-16c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0z"
      }),
      k("path", {
        d: "M7.057 8.943l16 16c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885l-16-16c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
      })
    ]
  );
}
qv.compatConfig = {
  MODE: 3
};
function pf() {
  return h(), b(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      k("path", {
        d: "M20.943 23.057l-7.057-7.057c0 0 7.057-7.057 7.057-7.057 0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-8 8c-0.521 0.521-0.521 1.365 0 1.885l8 8c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
      })
    ]
  );
}
pf.compatConfig = {
  MODE: 3
};
function mf() {
  return h(), b(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      k("path", {
        d: "M12.943 24.943l8-8c0.521-0.521 0.521-1.365 0-1.885l-8-8c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885l7.057 7.057c0 0-7.057 7.057-7.057 7.057-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0z"
      })
    ]
  );
}
mf.compatConfig = {
  MODE: 3
};
function gf() {
  return h(), b(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      k("path", {
        d: "M16 1.333c-8.095 0-14.667 6.572-14.667 14.667s6.572 14.667 14.667 14.667c8.095 0 14.667-6.572 14.667-14.667s-6.572-14.667-14.667-14.667zM16 4c6.623 0 12 5.377 12 12s-5.377 12-12 12c-6.623 0-12-5.377-12-12s5.377-12 12-12z"
      }),
      k("path", {
        d: "M14.667 8v8c0 0.505 0.285 0.967 0.737 1.193l5.333 2.667c0.658 0.329 1.46 0.062 1.789-0.596s0.062-1.46-0.596-1.789l-4.596-2.298c0 0 0-7.176 0-7.176 0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      })
    ]
  );
}
gf.compatConfig = {
  MODE: 3
};
function bf() {
  return h(), b(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      k("path", {
        d: "M24.943 19.057l-8-8c-0.521-0.521-1.365-0.521-1.885 0l-8 8c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l7.057-7.057c0 0 7.057 7.057 7.057 7.057 0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
      })
    ]
  );
}
bf.compatConfig = {
  MODE: 3
};
function vf() {
  return h(), b(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      k("path", {
        d: "M7.057 12.943l8 8c0.521 0.521 1.365 0.521 1.885 0l8-8c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-7.057 7.057c0 0-7.057-7.057-7.057-7.057-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
      })
    ]
  );
}
vf.compatConfig = {
  MODE: 3
};
const ea = (t, e) => e ? new Date(t.toLocaleString("en-US", { timeZone: e })) : new Date(t), yf = (t, e, n) => ah(t, e, n) || Ie(), d$ = (t, e, n) => {
  const a = e.dateInTz ? ea(new Date(t), e.dateInTz) : Ie(t);
  return n ? Hn(a, !0) : a;
}, ah = (t, e, n) => {
  if (!t) return null;
  const a = n ? Hn(Ie(t), !0) : Ie(t);
  return e ? e.exactMatch ? d$(t, e, n) : ea(a, e.timezone) : a;
}, h$ = (t) => {
  if (!t) return 0;
  const e = /* @__PURE__ */ new Date(), n = new Date(e.toLocaleString("en-US", { timeZone: "UTC" })), a = new Date(e.toLocaleString("en-US", { timeZone: t })), i = a.getTimezoneOffset() / 60;
  return (+n - +a) / (1e3 * 60 * 60) - i;
};
var La = /* @__PURE__ */ ((t) => (t.month = "month", t.year = "year", t))(La || {}), vr = /* @__PURE__ */ ((t) => (t.top = "top", t.bottom = "bottom", t))(vr || {}), Ar = /* @__PURE__ */ ((t) => (t.header = "header", t.calendar = "calendar", t.timePicker = "timePicker", t))(Ar || {}), An = /* @__PURE__ */ ((t) => (t.month = "month", t.year = "year", t.calendar = "calendar", t.time = "time", t.minutes = "minutes", t.hours = "hours", t.seconds = "seconds", t))(An || {});
const f$ = ["timestamp", "date", "iso"];
var Bn = /* @__PURE__ */ ((t) => (t.up = "up", t.down = "down", t.left = "left", t.right = "right", t))(Bn || {}), zt = /* @__PURE__ */ ((t) => (t.arrowUp = "ArrowUp", t.arrowDown = "ArrowDown", t.arrowLeft = "ArrowLeft", t.arrowRight = "ArrowRight", t.enter = "Enter", t.space = " ", t.esc = "Escape", t.tab = "Tab", t.home = "Home", t.end = "End", t.pageUp = "PageUp", t.pageDown = "PageDown", t))(zt || {});
function D1(t) {
  return (e) => new Intl.DateTimeFormat(t, { weekday: "short", timeZone: "UTC" }).format(/* @__PURE__ */ new Date(`2017-01-0${e}T00:00:00+00:00`)).slice(0, 2);
}
function p$(t) {
  return (e) => Ja(ea(/* @__PURE__ */ new Date(`2017-01-0${e}T00:00:00+00:00`), "UTC"), "EEEEEE", { locale: t });
}
const m$ = (t, e, n) => {
  const a = [1, 2, 3, 4, 5, 6, 7];
  let i;
  if (t !== null)
    try {
      i = a.map(p$(t));
    } catch {
      i = a.map(D1(e));
    }
  else
    i = a.map(D1(e));
  const r = i.slice(0, n), s = i.slice(n + 1, i.length);
  return [i[n]].concat(...s).concat(...r);
}, _f = (t, e, n) => {
  const a = [];
  for (let i = +t[0]; i <= +t[1]; i++)
    a.push({ value: +i, text: Zv(i, e) });
  return n ? a.reverse() : a;
}, Wv = (t, e, n) => {
  const a = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((r) => {
    const s = r < 10 ? `0${r}` : r;
    return /* @__PURE__ */ new Date(`2017-${s}-01T00:00:00+00:00`);
  });
  if (t !== null)
    try {
      const r = n === "long" ? "LLLL" : "LLL";
      return a.map((s, o) => {
        const l = Ja(ea(s, "UTC"), r, { locale: t });
        return {
          text: l.charAt(0).toUpperCase() + l.substring(1),
          value: o
        };
      });
    } catch {
    }
  const i = new Intl.DateTimeFormat(e, { month: n, timeZone: "UTC" });
  return a.map((r, s) => {
    const o = i.format(r);
    return {
      text: o.charAt(0).toUpperCase() + o.substring(1),
      value: s
    };
  });
}, g$ = (t) => [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11][t], ln = (t) => {
  const e = O(t);
  return e != null && e.$el ? e == null ? void 0 : e.$el : e;
}, b$ = (t) => ({ type: "dot", ...t ?? {} }), Gv = (t) => Array.isArray(t) ? !!t[0] && !!t[1] : !1, Tf = {
  prop: (t) => `"${t}" prop must be enabled!`,
  dateArr: (t) => `You need to use array as "model-value" binding in order to support "${t}"`
}, pn = (t) => t, I1 = (t) => t === 0 ? t : !t || isNaN(+t) ? null : +t, M1 = (t) => t === null, Xv = (t) => {
  if (t)
    return [...t.querySelectorAll("input, button, select, textarea, a[href]")][0];
}, v$ = (t) => {
  const e = [], n = (a) => a.filter((i) => i);
  for (let a = 0; a < t.length; a += 3) {
    const i = [t[a], t[a + 1], t[a + 2]];
    e.push(n(i));
  }
  return e;
}, kl = (t, e, n) => {
  const a = n != null, i = e != null;
  if (!a && !i) return !1;
  const r = +n, s = +e;
  return a && i ? +t > r || +t < s : a ? +t > r : i ? +t < s : !1;
}, Bs = (t, e) => v$(t).map((n) => n.map((a) => {
  const { active: i, disabled: r, isBetween: s, highlighted: o } = e(a);
  return {
    ...a,
    active: i,
    disabled: r,
    className: {
      dp__overlay_cell_active: i,
      dp__overlay_cell: !i,
      dp__overlay_cell_disabled: r,
      dp__overlay_cell_pad: !0,
      dp__overlay_cell_active_disabled: r && i,
      dp__cell_in_between: s,
      "dp--highlighted": o
    }
  };
})), Qi = (t, e, n = !1) => {
  t && e.allowStopPropagation && (n && t.stopImmediatePropagation(), t.stopPropagation());
}, y$ = () => [
  "a[href]",
  "area[href]",
  "input:not([disabled]):not([type='hidden'])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "[tabindex]:not([tabindex='-1'])",
  "[data-datepicker-instance]"
].join(", ");
function _$(t, e) {
  let n = [...document.querySelectorAll(y$())];
  n = n.filter((i) => !t.contains(i) || i.hasAttribute("data-datepicker-instance"));
  const a = n.indexOf(t);
  if (a >= 0 && (e ? a - 1 >= 0 : a + 1 <= n.length))
    return n[a + (e ? -1 : 1)];
}
const T$ = (t, e) => t == null ? void 0 : t.querySelector(`[data-dp-element="${e}"]`), Zv = (t, e) => new Intl.NumberFormat(e, { useGrouping: !1, style: "decimal" }).format(t), xf = (t) => Ja(t, "dd-MM-yyyy"), u0 = (t) => Array.isArray(t), lu = (t, e) => e.get(xf(t)), x$ = (t, e) => t ? e ? e instanceof Map ? !!lu(t, e) : e(Ie(t)) : !1 : !0, Qn = (t, e, n = !1) => {
  if (t.key === zt.enter || t.key === zt.space)
    return n && t.preventDefault(), e();
}, O1 = (t, e, n, a, i, r) => {
  const s = nh(t, e.slice(0, t.length), /* @__PURE__ */ new Date(), { locale: r });
  return ol(s) && Dv(s) ? a || i ? s : St(s, {
    hours: +n.hours,
    minutes: +(n == null ? void 0 : n.minutes),
    seconds: +(n == null ? void 0 : n.seconds),
    milliseconds: 0
  }) : null;
}, w$ = (t, e, n, a, i, r) => {
  const s = Array.isArray(n) ? n[0] : n;
  if (typeof e == "string")
    return O1(t, e, s, a, i, r);
  if (Array.isArray(e)) {
    let o = null;
    for (const l of e)
      if (o = O1(t, l, s, a, i, r), o)
        break;
    return o;
  }
  return typeof e == "function" ? e(t) : null;
}, Ie = (t) => t ? new Date(t) : /* @__PURE__ */ new Date(), k$ = (t, e, n) => {
  if (e) {
    const i = (t.getMonth() + 1).toString().padStart(2, "0"), r = t.getDate().toString().padStart(2, "0"), s = t.getHours().toString().padStart(2, "0"), o = t.getMinutes().toString().padStart(2, "0"), l = n ? t.getSeconds().toString().padStart(2, "0") : "00";
    return `${t.getFullYear()}-${i}-${r}T${s}:${o}:${l}.000Z`;
  }
  const a = Date.UTC(
    t.getUTCFullYear(),
    t.getUTCMonth(),
    t.getUTCDate(),
    t.getUTCHours(),
    t.getUTCMinutes(),
    t.getUTCSeconds()
  );
  return new Date(a).toISOString();
}, Hn = (t, e) => {
  const n = Ie(JSON.parse(JSON.stringify(t))), a = St(n, { hours: 0, minutes: 0, seconds: 0, milliseconds: 0 });
  return e ? bR(a) : a;
}, Ji = (t, e, n, a) => {
  let i = t ? Ie(t) : Ie();
  return (e || e === 0) && (i = l$(i, +e)), (n || n === 0) && (i = c$(i, +n)), (a || a === 0) && (i = jv(i, +a)), Yv(i, 0);
}, Vt = (t, e) => !t || !e ? !1 : wl(Hn(t), Hn(e)), ft = (t, e) => !t || !e ? !1 : hs(Hn(t), Hn(e)), Kt = (t, e) => !t || !e ? !1 : Os(Hn(t), Hn(e)), ed = (t, e, n) => t != null && t[0] && t != null && t[1] ? Kt(n, t[0]) && Vt(n, t[1]) : t != null && t[0] && e ? Kt(n, t[0]) && Vt(n, e) || Vt(n, t[0]) && Kt(n, e) : !1, Ia = (t) => {
  const e = St(new Date(t), { date: 1 });
  return Hn(e);
}, d0 = (t, e, n) => e && (n || n === 0) ? Object.fromEntries(
  ["hours", "minutes", "seconds"].map((a) => a === e ? [a, n] : [a, isNaN(+t[a]) ? void 0 : +t[a]])
) : {
  hours: isNaN(+t.hours) ? void 0 : +t.hours,
  minutes: isNaN(+t.minutes) ? void 0 : +t.minutes,
  seconds: isNaN(+t.seconds) ? void 0 : +t.seconds
}, Er = (t) => ({
  hours: ki(t),
  minutes: nr(t),
  seconds: Ms(t)
}), Kv = (t, e) => {
  if (e) {
    const n = at(Ie(e));
    if (n > t) return 12;
    if (n === t) return ht(Ie(e));
  }
}, Qv = (t, e) => {
  if (e) {
    const n = at(Ie(e));
    return n < t ? -1 : n === t ? ht(Ie(e)) : void 0;
  }
}, Rs = (t) => {
  if (t) return at(Ie(t));
}, Jv = (t, e) => {
  const n = Kt(t, e) ? e : t, a = Kt(e, t) ? e : t;
  return Iv({ start: n, end: a });
}, C$ = (t) => {
  const e = Pa(t, 1);
  return { month: ht(e), year: at(e) };
}, mi = (t, e) => {
  const n = Na(t, { weekStartsOn: +e }), a = Ov(t, { weekStartsOn: +e });
  return [n, a];
}, ey = (t, e) => {
  const n = {
    hours: ki(Ie()),
    minutes: nr(Ie()),
    seconds: e ? Ms(Ie()) : 0
  };
  return Object.assign(n, t);
}, Xi = (t, e, n) => [St(Ie(t), { date: 1 }), St(Ie(), { month: e, year: n, date: 1 })], yi = (t, e, n) => {
  let a = t ? Ie(t) : Ie();
  return (e || e === 0) && (a = Hv(a, e)), n && (a = Ga(a, n)), a;
}, ty = (t, e, n, a, i) => {
  if (!a || i && !e || !i && !n) return !1;
  const r = i ? Pa(t, 1) : Ps(t, 1), s = [ht(r), at(r)];
  return i ? !A$(...s, e) : !S$(...s, n);
}, S$ = (t, e, n) => Vt(...Xi(n, t, e)) || ft(...Xi(n, t, e)), A$ = (t, e, n) => Kt(...Xi(n, t, e)) || ft(...Xi(n, t, e)), ny = (t, e, n, a, i, r, s) => {
  if (typeof e == "function" && !s) return e(t);
  const o = n ? { locale: n } : void 0;
  return Array.isArray(t) ? `${Ja(t[0], r, o)}${i && !t[1] ? "" : a}${t[1] ? Ja(t[1], r, o) : ""}` : Ja(t, r, o);
}, ts = (t) => {
  if (t) return null;
  throw new Error(Tf.prop("partial-range"));
}, Lc = (t, e) => {
  if (e) return t();
  throw new Error(Tf.prop("range"));
}, ih = (t) => Array.isArray(t) ? ol(t[0]) && (t[1] ? ol(t[1]) : !0) : t ? ol(t) : !1, E$ = (t, e) => St(e ?? Ie(), {
  hours: +t.hours || 0,
  minutes: +t.minutes || 0,
  seconds: +t.seconds || 0
}), h0 = (t, e, n, a) => {
  if (!t) return !0;
  if (a) {
    const i = n === "max" ? wl(t, e) : Os(t, e), r = { seconds: 0, milliseconds: 0 };
    return i || hs(St(t, r), St(e, r));
  }
  return n === "max" ? t.getTime() <= e.getTime() : t.getTime() >= e.getTime();
}, f0 = (t, e, n) => t ? E$(t, e) : Ie(n ?? e), P1 = (t, e, n, a, i) => {
  if (Array.isArray(a)) {
    const s = f0(t, a[0], e), o = f0(t, a[1], e);
    return h0(a[0], s, n, !!e) && h0(a[1], o, n, !!e) && i;
  }
  const r = f0(t, a, e);
  return h0(a, r, n, !!e) && i;
}, p0 = (t) => St(Ie(), Er(t)), L$ = (t, e) => t instanceof Map ? Array.from(t.values()).filter((n) => at(Ie(n)) === e).map((n) => ht(n)) : [], ay = (t, e, n) => typeof t == "function" ? t({ month: e, year: n }) : !!t.months.find((a) => a.month === e && a.year === n), wf = (t, e) => typeof t == "function" ? t(e) : t.years.includes(e), iy = (t) => Ja(t, "yyyy-MM-dd"), Ho = Ma({
  menuFocused: !1,
  shiftKeyInMenu: !1
}), ry = () => {
  const t = (n) => {
    Ho.menuFocused = n;
  }, e = (n) => {
    Ho.shiftKeyInMenu !== n && (Ho.shiftKeyInMenu = n);
  };
  return {
    control: I(() => ({ shiftKeyInMenu: Ho.shiftKeyInMenu, menuFocused: Ho.menuFocused })),
    setMenuFocused: t,
    setShiftKey: e
  };
}, Dt = Ma({
  monthYear: [],
  calendar: [],
  time: [],
  actionRow: [],
  selectionGrid: [],
  timePicker: {
    0: [],
    1: []
  },
  monthPicker: []
}), m0 = K(null), Dc = K(!1), g0 = K(!1), b0 = K(!1), v0 = K(!1), Cn = K(0), Xt = K(0), or = () => {
  const t = I(() => Dc.value ? [...Dt.selectionGrid, Dt.actionRow].filter((f) => f.length) : g0.value ? [
    ...Dt.timePicker[0],
    ...Dt.timePicker[1],
    v0.value ? [] : [m0.value],
    Dt.actionRow
  ].filter((f) => f.length) : b0.value ? [...Dt.monthPicker, Dt.actionRow] : [Dt.monthYear, ...Dt.calendar, Dt.time, Dt.actionRow].filter((f) => f.length)), e = (f) => {
    Cn.value = f ? Cn.value + 1 : Cn.value - 1;
    let m = null;
    t.value[Xt.value] && (m = t.value[Xt.value][Cn.value]), !m && t.value[Xt.value + (f ? 1 : -1)] ? (Xt.value = Xt.value + (f ? 1 : -1), Cn.value = f ? 0 : t.value[Xt.value].length - 1) : m || (Cn.value = f ? Cn.value - 1 : Cn.value + 1);
  }, n = (f) => {
    Xt.value === 0 && !f || Xt.value === t.value.length && f || (Xt.value = f ? Xt.value + 1 : Xt.value - 1, t.value[Xt.value] ? t.value[Xt.value] && !t.value[Xt.value][Cn.value] && Cn.value !== 0 && (Cn.value = t.value[Xt.value].length - 1) : Xt.value = f ? Xt.value - 1 : Xt.value + 1);
  }, a = (f) => {
    let m = null;
    t.value[Xt.value] && (m = t.value[Xt.value][Cn.value]), m ? m.focus({ preventScroll: !Dc.value }) : Cn.value = f ? Cn.value - 1 : Cn.value + 1;
  }, i = () => {
    e(!0), a(!0);
  }, r = () => {
    e(!1), a(!1);
  }, s = () => {
    n(!1), a(!0);
  }, o = () => {
    n(!0), a(!0);
  }, l = (f, m) => {
    Dt[m] = f;
  }, c = (f, m) => {
    Dt[m] = f;
  }, u = () => {
    Cn.value = 0, Xt.value = 0;
  };
  return {
    buildMatrix: l,
    buildMultiLevelMatrix: c,
    setTimePickerBackRef: (f) => {
      m0.value = f;
    },
    setSelectionGrid: (f) => {
      Dc.value = f, u(), f || (Dt.selectionGrid = []);
    },
    setTimePicker: (f, m = !1) => {
      g0.value = f, v0.value = m, u(), f || (Dt.timePicker[0] = [], Dt.timePicker[1] = []);
    },
    setTimePickerElements: (f, m = 0) => {
      Dt.timePicker[m] = f;
    },
    arrowRight: i,
    arrowLeft: r,
    arrowUp: s,
    arrowDown: o,
    clearArrowNav: () => {
      Dt.monthYear = [], Dt.calendar = [], Dt.time = [], Dt.actionRow = [], Dt.selectionGrid = [], Dt.timePicker[0] = [], Dt.timePicker[1] = [], Dc.value = !1, g0.value = !1, v0.value = !1, b0.value = !1, u(), m0.value = null;
    },
    setMonthPicker: (f) => {
      b0.value = f, u();
    },
    refSets: Dt
    // exposed for testing
  };
}, B1 = (t) => ({
  menuAppearTop: "dp-menu-appear-top",
  menuAppearBottom: "dp-menu-appear-bottom",
  open: "dp-slide-down",
  close: "dp-slide-up",
  next: "calendar-next",
  previous: "calendar-prev",
  vNext: "dp-slide-up",
  vPrevious: "dp-slide-down",
  ...t ?? {}
}), D$ = (t) => ({
  toggleOverlay: "Toggle overlay",
  menu: "Datepicker menu",
  input: "Datepicker input",
  calendarWrap: "Calendar wrapper",
  calendarDays: "Calendar days",
  openTimePicker: "Open time picker",
  closeTimePicker: "Close time Picker",
  incrementValue: (e) => `Increment ${e}`,
  decrementValue: (e) => `Decrement ${e}`,
  openTpOverlay: (e) => `Open ${e} overlay`,
  amPmButton: "Switch AM/PM mode",
  openYearsOverlay: "Open years overlay",
  openMonthsOverlay: "Open months overlay",
  nextMonth: "Next month",
  prevMonth: "Previous month",
  nextYear: "Next year",
  prevYear: "Previous year",
  day: void 0,
  weekDay: void 0,
  ...t ?? {}
}), R1 = (t) => t ? typeof t == "boolean" ? t ? 2 : 0 : +t >= 2 ? +t : 2 : 0, I$ = (t) => {
  const e = typeof t == "object" && t, n = {
    static: !0,
    solo: !1
  };
  if (!t) return { ...n, count: R1(!1) };
  const a = e ? t : {}, i = e ? a.count ?? !0 : t, r = R1(i);
  return Object.assign(n, a, { count: r });
}, M$ = (t, e, n) => t || (typeof n == "string" ? n : e), O$ = (t) => typeof t == "boolean" ? t ? B1({}) : !1 : B1(t), P$ = (t) => {
  const e = {
    enterSubmit: !0,
    tabSubmit: !0,
    openMenu: !0,
    selectOnFocus: !1,
    rangeSeparator: " - "
  };
  return typeof t == "object" ? { ...e, ...t ?? {}, enabled: !0 } : { ...e, enabled: t };
}, B$ = (t) => ({
  months: [],
  years: [],
  times: { hours: [], minutes: [], seconds: [] },
  ...t ?? {}
}), R$ = (t) => ({
  showSelect: !0,
  showCancel: !0,
  showNow: !1,
  showPreview: !0,
  ...t ?? {}
}), N$ = (t) => {
  const e = { input: !1 };
  return typeof t == "object" ? { ...e, ...t ?? {}, enabled: !0 } : {
    enabled: t,
    ...e
  };
}, $$ = (t) => ({ allowStopPropagation: !0, closeOnScroll: !1, modeHeight: 255, allowPreventDefault: !1, closeOnClearValue: !0, closeOnAutoApply: !0, noSwipe: !1, keepActionRow: !1, onClickOutside: void 0, tabOutClosesMenu: !0, arrowLeft: void 0, keepViewOnOffsetClick: !1, timeArrowHoldThreshold: 0, ...t ?? {} }), F$ = (t) => {
  const e = {
    dates: Array.isArray(t) ? t.map((n) => Ie(n)) : [],
    years: [],
    months: [],
    quarters: [],
    weeks: [],
    weekdays: [],
    options: { highlightDisabled: !1 }
  };
  return typeof t == "function" ? t : { ...e, ...t ?? {} };
}, z$ = (t) => typeof t == "object" ? {
  type: (t == null ? void 0 : t.type) ?? "local",
  hideOnOffsetDates: (t == null ? void 0 : t.hideOnOffsetDates) ?? !1
} : {
  type: t,
  hideOnOffsetDates: !1
}, U$ = (t, e) => typeof t == "object" ? { enabled: !0, ...{
  noDisabledRange: !1,
  showLastInRange: !0,
  minMaxRawRange: !1,
  partialRange: !0,
  disableTimeRangeValidation: !1,
  maxRange: void 0,
  minRange: void 0,
  autoRange: void 0,
  fixedStart: !1,
  fixedEnd: !1
}, ...t } : {
  enabled: t,
  noDisabledRange: e.noDisabledRange,
  showLastInRange: e.showLastInRange,
  minMaxRawRange: e.minMaxRawRange,
  partialRange: e.partialRange,
  disableTimeRangeValidation: e.disableTimeRangeValidation,
  maxRange: e.maxRange,
  minRange: e.minRange,
  autoRange: e.autoRange,
  fixedStart: e.fixedStart,
  fixedEnd: e.fixedEnd
}, H$ = (t, e) => t ? typeof t == "string" ? { timezone: t, exactMatch: !1, dateInTz: void 0, emitTimezone: e, convertModel: !0 } : {
  timezone: t.timezone,
  exactMatch: t.exactMatch ?? !1,
  dateInTz: t.dateInTz ?? void 0,
  emitTimezone: e ?? t.emitTimezone,
  convertModel: t.convertModel ?? !0
} : { timezone: void 0, exactMatch: !1, emitTimezone: e }, y0 = (t, e, n) => new Map(
  t.map((a) => {
    const i = yf(a, e, n);
    return [xf(i), i];
  })
), Y$ = (t, e) => t.length ? new Map(
  t.map((n) => {
    const a = yf(n.date, e);
    return [xf(a), n];
  })
) : null, j$ = (t) => {
  var e;
  return {
    minDate: ah(t.minDate, t.timezone, t.isSpecific),
    maxDate: ah(t.maxDate, t.timezone, t.isSpecific),
    disabledDates: u0(t.disabledDates) ? y0(t.disabledDates, t.timezone, t.isSpecific) : t.disabledDates,
    allowedDates: u0(t.allowedDates) ? y0(t.allowedDates, t.timezone, t.isSpecific) : null,
    highlight: typeof t.highlight == "object" && u0((e = t.highlight) == null ? void 0 : e.dates) ? y0(t.highlight.dates, t.timezone) : t.highlight,
    markers: Y$(t.markers, t.timezone)
  };
}, V$ = (t, e) => typeof t == "boolean" ? { enabled: t, dragSelect: !0, limit: +e } : {
  enabled: !!t,
  limit: t.limit ? +t.limit : null,
  dragSelect: t.dragSelect ?? !0
}, q$ = (t) => ({
  ...Object.fromEntries(
    Object.keys(t).map((e) => {
      const n = e, a = t[n], i = typeof t[n] == "string" ? { [a]: !0 } : Object.fromEntries(a.map((r) => [r, !0]));
      return [e, i];
    })
  )
}), jt = (t) => {
  const e = () => {
    const P = t.enableSeconds ? ":ss" : "", B = t.enableMinutes ? ":mm" : "";
    return t.is24 ? `HH${B}${P}` : `hh${B}${P} aa`;
  }, n = () => {
    var P;
    return t.format ? t.format : t.monthPicker ? "MM/yyyy" : t.timePicker ? e() : t.weekPicker ? `${((P = x.value) == null ? void 0 : P.type) === "iso" ? "RR" : "ww"}-yyyy` : t.yearPicker ? "yyyy" : t.quarterPicker ? "QQQ/yyyy" : t.enableTimePicker ? `MM/dd/yyyy, ${e()}` : "MM/dd/yyyy";
  }, a = (P) => ey(P, t.enableSeconds), i = () => M.value.enabled ? t.startTime && Array.isArray(t.startTime) ? [a(t.startTime[0]), a(t.startTime[1])] : null : t.startTime && !Array.isArray(t.startTime) ? a(t.startTime) : null, r = I(() => I$(t.multiCalendars)), s = I(() => i()), o = I(() => D$(t.ariaLabels)), l = I(() => B$(t.filters)), c = I(() => O$(t.transitions)), u = I(() => R$(t.actionRow)), f = I(
    () => M$(t.previewFormat, t.format, n())
  ), m = I(() => P$(t.textInput)), _ = I(() => N$(t.inline)), T = I(() => $$(t.config)), g = I(() => F$(t.highlight)), x = I(() => z$(t.weekNumbers)), S = I(() => H$(t.timezone, t.emitTimezone)), D = I(() => V$(t.multiDates, t.multiDatesLimit)), L = I(
    () => j$({
      minDate: t.minDate,
      maxDate: t.maxDate,
      disabledDates: t.disabledDates,
      allowedDates: t.allowedDates,
      highlight: g.value,
      markers: t.markers,
      timezone: S.value,
      isSpecific: t.monthPicker || t.yearPicker || t.quarterPicker
    })
  ), M = I(
    () => U$(t.range, {
      minMaxRawRange: !1,
      maxRange: t.maxRange,
      minRange: t.minRange,
      noDisabledRange: t.noDisabledRange,
      showLastInRange: t.showLastInRange,
      partialRange: t.partialRange,
      disableTimeRangeValidation: t.disableTimeRangeValidation,
      autoRange: t.autoRange,
      fixedStart: t.fixedStart,
      fixedEnd: t.fixedEnd
    })
  ), E = I(() => q$(t.ui));
  return {
    defaultedTransitions: c,
    defaultedMultiCalendars: r,
    defaultedStartTime: s,
    defaultedAriaLabels: o,
    defaultedFilters: l,
    defaultedActionRow: u,
    defaultedPreviewFormat: f,
    defaultedTextInput: m,
    defaultedInline: _,
    defaultedConfig: T,
    defaultedHighlight: g,
    defaultedWeekNumbers: x,
    defaultedRange: M,
    propDates: L,
    defaultedTz: S,
    defaultedMultiDates: D,
    defaultedUI: E,
    getDefaultPattern: n,
    getDefaultStartTime: i
  };
}, W$ = (t, e, n) => {
  const a = K(), { defaultedTextInput: i, defaultedRange: r, defaultedTz: s, defaultedMultiDates: o, getDefaultPattern: l } = jt(e), c = K(""), u = Ls(e, "format"), f = Ls(e, "formatLocale");
  Qe(
    a,
    () => {
      typeof e.onInternalModelChange == "function" && t("internal-model-change", a.value, Ne(!0));
    },
    { deep: !0 }
  ), Qe(r, (ee, Ue) => {
    ee.enabled !== Ue.enabled && (a.value = null);
  }), Qe(u, () => {
    ue();
  });
  const m = (ee) => s.value.timezone && s.value.convertModel ? ea(ee, s.value.timezone) : ee, _ = (ee) => {
    if (s.value.timezone && s.value.convertModel) {
      const Ue = h$(s.value.timezone);
      return uR(ee, Ue);
    }
    return ee;
  }, T = (ee, Ue, tt = !1) => ny(
    ee,
    e.format,
    e.formatLocale,
    i.value.rangeSeparator,
    e.modelAuto,
    Ue ?? l(),
    tt
  ), g = (ee) => ee ? e.modelType ? De(ee) : {
    hours: ki(ee),
    minutes: nr(ee),
    seconds: e.enableSeconds ? Ms(ee) : 0
  } : null, x = (ee) => e.modelType ? De(ee) : { month: ht(ee), year: at(ee) }, S = (ee) => Array.isArray(ee) ? o.value.enabled ? ee.map((Ue) => D(Ue, Ga(Ie(), Ue))) : Lc(
    () => [
      Ga(Ie(), ee[0]),
      ee[1] ? Ga(Ie(), ee[1]) : ts(r.value.partialRange)
    ],
    r.value.enabled
  ) : Ga(Ie(), +ee), D = (ee, Ue) => (typeof ee == "string" || typeof ee == "number") && e.modelType ? xe(ee) : Ue, L = (ee) => Array.isArray(ee) ? [
    D(
      ee[0],
      Ji(null, +ee[0].hours, +ee[0].minutes, ee[0].seconds)
    ),
    D(
      ee[1],
      Ji(null, +ee[1].hours, +ee[1].minutes, ee[1].seconds)
    )
  ] : D(ee, Ji(null, ee.hours, ee.minutes, ee.seconds)), M = (ee) => {
    const Ue = St(Ie(), { date: 1 });
    return Array.isArray(ee) ? o.value.enabled ? ee.map((tt) => D(tt, yi(Ue, +tt.month, +tt.year))) : Lc(
      () => [
        D(ee[0], yi(Ue, +ee[0].month, +ee[0].year)),
        D(
          ee[1],
          ee[1] ? yi(Ue, +ee[1].month, +ee[1].year) : ts(r.value.partialRange)
        )
      ],
      r.value.enabled
    ) : D(ee, yi(Ue, +ee.month, +ee.year));
  }, E = (ee) => {
    if (Array.isArray(ee))
      return ee.map((Ue) => xe(Ue));
    throw new Error(Tf.dateArr("multi-dates"));
  }, P = (ee) => {
    if (Array.isArray(ee) && r.value.enabled) {
      const Ue = ee[0], tt = ee[1];
      return [
        Ie(Array.isArray(Ue) ? Ue[0] : null),
        Ie(Array.isArray(tt) ? tt[0] : null)
      ];
    }
    return Ie(ee[0]);
  }, B = (ee) => e.modelAuto ? Array.isArray(ee) ? [xe(ee[0]), xe(ee[1])] : e.autoApply ? [xe(ee)] : [xe(ee), null] : Array.isArray(ee) ? Lc(
    () => ee[1] ? [
      xe(ee[0]),
      ee[1] ? xe(ee[1]) : ts(r.value.partialRange)
    ] : [xe(ee[0])],
    r.value.enabled
  ) : xe(ee), z = () => {
    Array.isArray(a.value) && r.value.enabled && a.value.length === 1 && a.value.push(ts(r.value.partialRange));
  }, W = () => {
    const ee = a.value;
    return [
      De(ee[0]),
      ee[1] ? De(ee[1]) : ts(r.value.partialRange)
    ];
  }, V = () => a.value[1] ? W() : De(pn(a.value[0])), H = () => (a.value || []).map((ee) => De(ee)), se = (ee = !1) => (ee || z(), e.modelAuto ? V() : o.value.enabled ? H() : Array.isArray(a.value) ? Lc(() => W(), r.value.enabled) : De(pn(a.value))), ie = (ee) => !ee || Array.isArray(ee) && !ee.length ? null : e.timePicker ? L(pn(ee)) : e.monthPicker ? M(pn(ee)) : e.yearPicker ? S(pn(ee)) : o.value.enabled ? E(pn(ee)) : e.weekPicker ? P(pn(ee)) : B(pn(ee)), Z = (ee) => {
    const Ue = ie(ee);
    ih(pn(Ue)) ? (a.value = pn(Ue), ue()) : (a.value = null, c.value = "");
  }, $ = () => {
    const ee = (Ue) => Ja(Ue, i.value.format);
    return `${ee(a.value[0])} ${i.value.rangeSeparator} ${a.value[1] ? ee(a.value[1]) : ""}`;
  }, J = () => n.value && a.value ? Array.isArray(a.value) ? $() : Ja(a.value, i.value.format) : T(a.value), N = () => a.value ? o.value.enabled ? a.value.map((ee) => T(ee)).join("; ") : i.value.enabled && typeof i.value.format == "string" ? J() : T(a.value) : "", ue = () => {
    !e.format || typeof e.format == "string" || i.value.enabled && typeof i.value.format == "string" ? c.value = N() : c.value = e.format(a.value);
  }, xe = (ee) => {
    if (e.utc) {
      const Ue = new Date(ee);
      return e.utc === "preserve" ? new Date(Ue.getTime() + Ue.getTimezoneOffset() * 6e4) : Ue;
    }
    return e.modelType ? f$.includes(e.modelType) ? m(new Date(ee)) : e.modelType === "format" && (typeof e.format == "string" || !e.format) ? m(
      nh(ee, l(), /* @__PURE__ */ new Date(), { locale: f.value })
    ) : m(
      nh(ee, e.modelType, /* @__PURE__ */ new Date(), { locale: f.value })
    ) : m(new Date(ee));
  }, De = (ee) => ee ? e.utc ? k$(ee, e.utc === "preserve", e.enableSeconds) : e.modelType ? e.modelType === "timestamp" ? +_(ee) : e.modelType === "iso" ? _(ee).toISOString() : e.modelType === "format" && (typeof e.format == "string" || !e.format) ? T(_(ee)) : T(_(ee), e.modelType, !0) : _(ee) : "", He = (ee, Ue = !1, tt = !1) => {
    if (tt) return ee;
    if (t("update:model-value", ee), s.value.emitTimezone && Ue) {
      const we = Array.isArray(ee) ? ee.map((Je) => ea(pn(Je), s.value.emitTimezone)) : ea(pn(ee), s.value.emitTimezone);
      t("update:model-timezone-value", we);
    }
  }, te = (ee) => Array.isArray(a.value) ? o.value.enabled ? a.value.map((Ue) => ee(Ue)) : [
    ee(a.value[0]),
    a.value[1] ? ee(a.value[1]) : ts(r.value.partialRange)
  ] : ee(pn(a.value)), ke = () => {
    if (Array.isArray(a.value)) {
      const ee = mi(a.value[0], e.weekStart), Ue = a.value[1] ? mi(a.value[1], e.weekStart) : [];
      return [ee.map((tt) => Ie(tt)), Ue.map((tt) => Ie(tt))];
    }
    return mi(a.value, e.weekStart).map((ee) => Ie(ee));
  }, Y = (ee, Ue) => He(pn(te(ee)), !1, Ue), be = (ee) => {
    const Ue = ke();
    return ee ? Ue : t("update:model-value", ke());
  }, Ne = (ee = !1) => (ee || ue(), e.monthPicker ? Y(x, ee) : e.timePicker ? Y(g, ee) : e.yearPicker ? Y(at, ee) : e.weekPicker ? be(ee) : He(se(ee), !0, ee));
  return {
    inputValue: c,
    internalModelValue: a,
    checkBeforeEmit: () => a.value ? r.value.enabled ? r.value.partialRange ? a.value.length >= 1 : a.value.length === 2 : !!a.value : !1,
    parseExternalModelValue: Z,
    formatInputValue: ue,
    emitModelValue: Ne
  };
}, G$ = (t, e) => {
  const { defaultedFilters: n, propDates: a } = jt(t), { validateMonthYearInRange: i } = lr(t), r = (u, f) => {
    let m = u;
    return n.value.months.includes(ht(m)) ? (m = f ? Pa(u, 1) : Ps(u, 1), r(m, f)) : m;
  }, s = (u, f) => {
    let m = u;
    return n.value.years.includes(at(m)) ? (m = f ? lf(u, 1) : Vv(u, 1), s(m, f)) : m;
  }, o = (u, f = !1) => {
    const m = St(Ie(), { month: t.month, year: t.year });
    let _ = u ? Pa(m, 1) : Ps(m, 1);
    t.disableYearSelect && (_ = Ga(_, t.year));
    let T = ht(_), g = at(_);
    n.value.months.includes(T) && (_ = r(_, u), T = ht(_), g = at(_)), n.value.years.includes(g) && (_ = s(_, u), g = at(_)), i(T, g, u, t.preventMinMaxNavigation) && l(T, g, f);
  }, l = (u, f, m) => {
    e("update-month-year", { month: u, year: f, fromNav: m });
  }, c = I(() => (u) => ty(
    St(Ie(), { month: t.month, year: t.year }),
    a.value.maxDate,
    a.value.minDate,
    t.preventMinMaxNavigation,
    u
  ));
  return { handleMonthYearChange: o, isDisabled: c, updateMonthYear: l };
}, td = {
  multiCalendars: { type: [Boolean, Number, String, Object], default: void 0 },
  modelValue: { type: [String, Date, Array, Object, Number], default: null },
  modelType: { type: String, default: null },
  position: { type: String, default: "center" },
  dark: { type: Boolean, default: !1 },
  format: {
    type: [String, Function],
    default: () => null
  },
  autoPosition: { type: Boolean, default: !0 },
  altPosition: { type: Function, default: null },
  transitions: { type: [Boolean, Object], default: !0 },
  formatLocale: { type: Object, default: null },
  utc: { type: [Boolean, String], default: !1 },
  ariaLabels: { type: Object, default: () => ({}) },
  offset: { type: [Number, String], default: 10 },
  hideNavigation: { type: Array, default: () => [] },
  timezone: { type: [String, Object], default: null },
  emitTimezone: { type: String, default: null },
  vertical: { type: Boolean, default: !1 },
  disableMonthYearSelect: { type: Boolean, default: !1 },
  disableYearSelect: { type: Boolean, default: !1 },
  menuClassName: { type: String, default: null },
  dayClass: {
    type: Function,
    default: null
  },
  yearRange: { type: Array, default: () => [1900, 2100] },
  calendarCellClassName: { type: String, default: null },
  enableTimePicker: { type: Boolean, default: !0 },
  autoApply: { type: Boolean, default: !1 },
  disabledDates: { type: [Array, Function], default: () => [] },
  monthNameFormat: { type: String, default: "short" },
  startDate: { type: [Date, String], default: null },
  startTime: { type: [Object, Array], default: null },
  hideOffsetDates: { type: Boolean, default: !1 },
  autoRange: { type: [Number, String], default: null },
  noToday: { type: Boolean, default: !1 },
  disabledWeekDays: { type: Array, default: () => [] },
  allowedDates: { type: Array, default: null },
  nowButtonLabel: { type: String, default: "Now" },
  markers: { type: Array, default: () => [] },
  escClose: { type: Boolean, default: !0 },
  spaceConfirm: { type: Boolean, default: !0 },
  monthChangeOnArrows: { type: Boolean, default: !0 },
  presetDates: { type: Array, default: () => [] },
  flow: { type: Array, default: () => [] },
  partialFlow: { type: Boolean, default: !1 },
  preventMinMaxNavigation: { type: Boolean, default: !1 },
  minRange: { type: [Number, String], default: null },
  maxRange: { type: [Number, String], default: null },
  multiDatesLimit: { type: [Number, String], default: null },
  reverseYears: { type: Boolean, default: !1 },
  weekPicker: { type: Boolean, default: !1 },
  filters: { type: Object, default: () => ({}) },
  arrowNavigation: { type: Boolean, default: !1 },
  disableTimeRangeValidation: { type: Boolean, default: !1 },
  highlight: {
    type: [Function, Object],
    default: null
  },
  teleport: { type: [Boolean, String, Object], default: null },
  teleportCenter: { type: Boolean, default: !1 },
  locale: { type: String, default: "en-Us" },
  weekNumName: { type: String, default: "W" },
  weekStart: { type: [Number, String], default: 1 },
  weekNumbers: {
    type: [String, Function, Object],
    default: null
  },
  calendarClassName: { type: String, default: null },
  monthChangeOnScroll: { type: [Boolean, String], default: !0 },
  dayNames: {
    type: [Function, Array],
    default: null
  },
  monthPicker: { type: Boolean, default: !1 },
  customProps: { type: Object, default: null },
  yearPicker: { type: Boolean, default: !1 },
  modelAuto: { type: Boolean, default: !1 },
  selectText: { type: String, default: "Select" },
  cancelText: { type: String, default: "Cancel" },
  previewFormat: {
    type: [String, Function],
    default: () => ""
  },
  multiDates: { type: [Object, Boolean], default: !1 },
  partialRange: { type: Boolean, default: !0 },
  ignoreTimeValidation: { type: Boolean, default: !1 },
  minDate: { type: [Date, String], default: null },
  maxDate: { type: [Date, String], default: null },
  minTime: { type: Object, default: null },
  maxTime: { type: Object, default: null },
  name: { type: String, default: null },
  placeholder: { type: String, default: "" },
  hideInputIcon: { type: Boolean, default: !1 },
  clearable: { type: Boolean, default: !0 },
  state: { type: Boolean, default: null },
  required: { type: Boolean, default: !1 },
  autocomplete: { type: String, default: "off" },
  inputClassName: { type: String, default: null },
  fixedStart: { type: Boolean, default: !1 },
  fixedEnd: { type: Boolean, default: !1 },
  timePicker: { type: Boolean, default: !1 },
  enableSeconds: { type: Boolean, default: !1 },
  is24: { type: Boolean, default: !0 },
  noHoursOverlay: { type: Boolean, default: !1 },
  noMinutesOverlay: { type: Boolean, default: !1 },
  noSecondsOverlay: { type: Boolean, default: !1 },
  hoursGridIncrement: { type: [String, Number], default: 1 },
  minutesGridIncrement: { type: [String, Number], default: 5 },
  secondsGridIncrement: { type: [String, Number], default: 5 },
  hoursIncrement: { type: [Number, String], default: 1 },
  minutesIncrement: { type: [Number, String], default: 1 },
  secondsIncrement: { type: [Number, String], default: 1 },
  range: { type: [Boolean, Object], default: !1 },
  uid: { type: String, default: null },
  disabled: { type: Boolean, default: !1 },
  readonly: { type: Boolean, default: !1 },
  inline: { type: [Boolean, Object], default: !1 },
  textInput: { type: [Boolean, Object], default: !1 },
  noDisabledRange: { type: Boolean, default: !1 },
  sixWeeks: { type: [Boolean, String], default: !1 },
  actionRow: { type: Object, default: () => ({}) },
  focusStartDate: { type: Boolean, default: !1 },
  disabledTimes: { type: [Function, Array], default: void 0 },
  showLastInRange: { type: Boolean, default: !0 },
  timePickerInline: { type: Boolean, default: !1 },
  calendar: { type: Function, default: null },
  config: { type: Object, default: void 0 },
  quarterPicker: { type: Boolean, default: !1 },
  yearFirst: { type: Boolean, default: !1 },
  loading: { type: Boolean, default: !1 },
  onInternalModelChange: { type: [Function, Object], default: null },
  enableMinutes: { type: Boolean, default: !0 },
  ui: { type: Object, default: () => ({}) }
}, Fa = {
  ...td,
  shadow: { type: Boolean, default: !1 },
  flowStep: { type: Number, default: 0 },
  internalModelValue: { type: [Date, Array], default: null },
  noOverlayFocus: { type: Boolean, default: !1 },
  collapse: { type: Boolean, default: !1 },
  menuWrapRef: { type: Object, default: null },
  getInputRect: { type: Function, default: () => ({}) },
  isTextInputDate: { type: Boolean, default: !1 }
}, X$ = ["title"], Z$ = ["disabled"], K$ = /* @__PURE__ */ Ce({
  compatConfig: {
    MODE: 3
  },
  __name: "ActionRow",
  props: {
    menuMount: { type: Boolean, default: !1 },
    calendarWidth: { type: Number, default: 0 },
    ...Fa
  },
  emits: ["close-picker", "select-date", "select-now", "invalid-select"],
  setup(t, { emit: e }) {
    const n = e, a = t, {
      defaultedActionRow: i,
      defaultedPreviewFormat: r,
      defaultedMultiCalendars: s,
      defaultedTextInput: o,
      defaultedInline: l,
      defaultedRange: c,
      defaultedMultiDates: u,
      getDefaultPattern: f
    } = jt(a), { isTimeValid: m, isMonthValid: _ } = lr(a), { buildMatrix: T } = or(), g = K(null), x = K(null), S = K(!1), D = K({}), L = K(null), M = K(null);
    st(() => {
      a.arrowNavigation && T([ln(g), ln(x)], "actionRow"), E(), window.addEventListener("resize", E);
    }), Ks(() => {
      window.removeEventListener("resize", E);
    });
    const E = () => {
      S.value = !1, setTimeout(() => {
        var $, J;
        const N = ($ = L.value) == null ? void 0 : $.getBoundingClientRect(), ue = (J = M.value) == null ? void 0 : J.getBoundingClientRect();
        N && ue && (D.value.maxWidth = `${ue.width - N.width - 20}px`), S.value = !0;
      }, 0);
    }, P = I(() => c.value.enabled && !c.value.partialRange && a.internalModelValue ? a.internalModelValue.length === 2 : !0), B = I(
      () => !m.value(a.internalModelValue) || !_.value(a.internalModelValue) || !P.value
    ), z = () => {
      const $ = r.value;
      return a.timePicker || a.monthPicker, $(pn(a.internalModelValue));
    }, W = () => {
      const $ = a.internalModelValue;
      return s.value.count > 0 ? `${V($[0])} - ${V($[1])}` : [V($[0]), V($[1])];
    }, V = ($) => ny(
      $,
      r.value,
      a.formatLocale,
      o.value.rangeSeparator,
      a.modelAuto,
      f()
    ), H = I(() => !a.internalModelValue || !a.menuMount ? "" : typeof r.value == "string" ? Array.isArray(a.internalModelValue) ? a.internalModelValue.length === 2 && a.internalModelValue[1] ? W() : u.value.enabled ? a.internalModelValue.map(($) => `${V($)}`) : a.modelAuto ? `${V(a.internalModelValue[0])}` : `${V(a.internalModelValue[0])} -` : V(a.internalModelValue) : z()), se = () => u.value.enabled ? "; " : " - ", ie = I(
      () => Array.isArray(H.value) ? H.value.join(se()) : H.value
    ), Z = () => {
      m.value(a.internalModelValue) && _.value(a.internalModelValue) && P.value ? n("select-date") : n("invalid-select");
    };
    return ($, J) => (h(), b("div", {
      ref_key: "actionRowRef",
      ref: M,
      class: "dp__action_row"
    }, [
      $.$slots["action-row"] ? me($.$slots, "action-row", cn($t({ key: 0 }, {
        internalModelValue: $.internalModelValue,
        disabled: B.value,
        selectDate: () => $.$emit("select-date"),
        closePicker: () => $.$emit("close-picker")
      }))) : (h(), b(he, { key: 1 }, [
        O(i).showPreview ? (h(), b("div", {
          key: 0,
          class: "dp__selection_preview",
          title: ie.value,
          style: bn(D.value)
        }, [
          $.$slots["action-preview"] && S.value ? me($.$slots, "action-preview", {
            key: 0,
            value: $.internalModelValue
          }) : A("", !0),
          !$.$slots["action-preview"] && S.value ? (h(), b(he, { key: 1 }, [
            ze(ne(ie.value), 1)
          ], 64)) : A("", !0)
        ], 12, X$)) : A("", !0),
        k("div", {
          ref_key: "actionBtnContainer",
          ref: L,
          class: "dp__action_buttons",
          "data-dp-element": "action-row"
        }, [
          $.$slots["action-buttons"] ? me($.$slots, "action-buttons", {
            key: 0,
            value: $.internalModelValue
          }) : A("", !0),
          $.$slots["action-buttons"] ? A("", !0) : (h(), b(he, { key: 1 }, [
            !O(l).enabled && O(i).showCancel ? (h(), b("button", {
              key: 0,
              ref_key: "cancelButtonRef",
              ref: g,
              type: "button",
              class: "dp__action_button dp__action_cancel",
              onClick: J[0] || (J[0] = (N) => $.$emit("close-picker")),
              onKeydown: J[1] || (J[1] = (N) => O(Qn)(N, () => $.$emit("close-picker")))
            }, ne($.cancelText), 545)) : A("", !0),
            O(i).showNow ? (h(), b("button", {
              key: 1,
              type: "button",
              class: "dp__action_button dp__action_cancel",
              onClick: J[2] || (J[2] = (N) => $.$emit("select-now")),
              onKeydown: J[3] || (J[3] = (N) => O(Qn)(N, () => $.$emit("select-now")))
            }, ne($.nowButtonLabel), 33)) : A("", !0),
            O(i).showSelect ? (h(), b("button", {
              key: 2,
              ref_key: "selectButtonRef",
              ref: x,
              type: "button",
              class: "dp__action_button dp__action_select",
              disabled: B.value,
              "data-test": "select-button",
              onKeydown: J[4] || (J[4] = (N) => O(Qn)(N, () => Z())),
              onClick: Z
            }, ne($.selectText), 41, Z$)) : A("", !0)
          ], 64))
        ], 512)
      ], 64))
    ], 512));
  }
}), Q$ = { class: "dp__selection_grid_header" }, J$ = ["aria-selected", "aria-disabled", "data-test", "onClick", "onKeydown", "onMouseover"], eF = ["aria-label"], $l = /* @__PURE__ */ Ce({
  __name: "SelectionOverlay",
  props: {
    items: {},
    type: {},
    isLast: { type: Boolean },
    arrowNavigation: { type: Boolean },
    skipButtonRef: { type: Boolean },
    headerRefs: {},
    hideNavigation: {},
    escClose: { type: Boolean },
    useRelative: { type: Boolean },
    height: {},
    textInput: { type: [Boolean, Object] },
    config: {},
    noOverlayFocus: { type: Boolean },
    focusValue: {},
    menuWrapRef: {},
    ariaLabels: {}
  },
  emits: ["selected", "toggle", "reset-flow", "hover-value"],
  setup(t, { expose: e, emit: n }) {
    const { setSelectionGrid: a, buildMultiLevelMatrix: i, setMonthPicker: r } = or(), s = n, o = t, { defaultedAriaLabels: l, defaultedTextInput: c, defaultedConfig: u } = jt(
      o
    ), { hideNavigationButtons: f } = id(), m = K(!1), _ = K(null), T = K(null), g = K([]), x = K(), S = K(null), D = K(0), L = K(null);
    R4(() => {
      _.value = null;
    }), st(() => {
      kn().then(() => H()), o.noOverlayFocus || E(), M(!0);
    }), Ks(() => M(!1));
    const M = (te) => {
      var ke;
      o.arrowNavigation && ((ke = o.headerRefs) != null && ke.length ? r(te) : a(te));
    }, E = () => {
      var te;
      const ke = ln(T);
      ke && (c.value.enabled || (_.value ? (te = _.value) == null || te.focus({ preventScroll: !0 }) : ke.focus({ preventScroll: !0 })), m.value = ke.clientHeight < ke.scrollHeight);
    }, P = I(
      () => ({
        dp__overlay: !0,
        "dp--overlay-absolute": !o.useRelative,
        "dp--overlay-relative": o.useRelative
      })
    ), B = I(
      () => o.useRelative ? { height: `${o.height}px`, width: "260px" } : void 0
    ), z = I(() => ({
      dp__overlay_col: !0
    })), W = I(
      () => ({
        dp__btn: !0,
        dp__button: !0,
        dp__overlay_action: !0,
        dp__over_action_scroll: m.value,
        dp__button_bottom: o.isLast
      })
    ), V = I(() => {
      var te, ke;
      return {
        dp__overlay_container: !0,
        dp__container_flex: ((te = o.items) == null ? void 0 : te.length) <= 6,
        dp__container_block: ((ke = o.items) == null ? void 0 : ke.length) > 6
      };
    });
    Qe(
      () => o.items,
      () => H(!1),
      { deep: !0 }
    );
    const H = (te = !0) => {
      kn().then(() => {
        const ke = ln(_), Y = ln(T), be = ln(S), Ne = ln(L), ee = be ? be.getBoundingClientRect().height : 0;
        Y && (Y.getBoundingClientRect().height ? D.value = Y.getBoundingClientRect().height - ee : D.value = u.value.modeHeight - ee), ke && Ne && te && (Ne.scrollTop = ke.offsetTop - Ne.offsetTop - (D.value / 2 - ke.getBoundingClientRect().height) - ee);
      });
    }, se = (te) => {
      te.disabled || s("selected", te.value);
    }, ie = () => {
      s("toggle"), s("reset-flow");
    }, Z = () => {
      o.escClose && ie();
    }, $ = (te, ke, Y, be) => {
      te && ((ke.active || ke.value === o.focusValue) && (_.value = te), o.arrowNavigation && (Array.isArray(g.value[Y]) ? g.value[Y][be] = te : g.value[Y] = [te], J()));
    }, J = () => {
      var te, ke;
      const Y = (te = o.headerRefs) != null && te.length ? [o.headerRefs].concat(g.value) : g.value.concat([o.skipButtonRef ? [] : [S.value]]);
      i(pn(Y), (ke = o.headerRefs) != null && ke.length ? "monthPicker" : "selectionGrid");
    }, N = (te) => {
      o.arrowNavigation || Qi(te, u.value, !0);
    }, ue = (te) => {
      x.value = te, s("hover-value", te);
    }, xe = () => {
      if (ie(), !o.isLast) {
        const te = T$(o.menuWrapRef ?? null, "action-row");
        if (te) {
          const ke = Xv(te);
          ke == null || ke.focus();
        }
      }
    }, De = (te) => {
      switch (te.key) {
        case zt.esc:
          return Z();
        case zt.arrowLeft:
          return N(te);
        case zt.arrowRight:
          return N(te);
        case zt.arrowUp:
          return N(te);
        case zt.arrowDown:
          return N(te);
        default:
          return;
      }
    }, He = (te) => {
      if (te.key === zt.enter) return ie();
      if (te.key === zt.tab) return xe();
    };
    return e({ focusGrid: E }), (te, ke) => {
      var Y;
      return h(), b("div", {
        ref_key: "gridWrapRef",
        ref: T,
        class: re(P.value),
        style: bn(B.value),
        role: "dialog",
        tabindex: "0",
        onKeydown: De,
        onClick: ke[0] || (ke[0] = da(() => {
        }, ["prevent"]))
      }, [
        k("div", {
          ref_key: "containerRef",
          ref: L,
          class: re(V.value),
          role: "grid",
          style: bn({ "--dp-overlay-height": `${D.value}px` })
        }, [
          k("div", Q$, [
            me(te.$slots, "header")
          ]),
          te.$slots.overlay ? me(te.$slots, "overlay", { key: 0 }) : (h(!0), b(he, { key: 1 }, Le(te.items, (be, Ne) => (h(), b("div", {
            key: Ne,
            class: re(["dp__overlay_row", { dp__flex_row: te.items.length >= 3 }]),
            role: "row"
          }, [
            (h(!0), b(he, null, Le(be, (ee, Ue) => (h(), b("div", {
              key: ee.value,
              ref_for: !0,
              ref: (tt) => $(tt, ee, Ne, Ue),
              role: "gridcell",
              class: re(z.value),
              "aria-selected": ee.active || void 0,
              "aria-disabled": ee.disabled || void 0,
              tabindex: "0",
              "data-test": ee.text,
              onClick: da((tt) => se(ee), ["prevent"]),
              onKeydown: (tt) => O(Qn)(tt, () => se(ee), !0),
              onMouseover: (tt) => ue(ee.value)
            }, [
              k("div", {
                class: re(ee.className)
              }, [
                te.$slots.item ? me(te.$slots, "item", {
                  key: 0,
                  item: ee
                }) : A("", !0),
                te.$slots.item ? A("", !0) : (h(), b(he, { key: 1 }, [
                  ze(ne(ee.text), 1)
                ], 64))
              ], 2)
            ], 42, J$))), 128))
          ], 2))), 128))
        ], 6),
        te.$slots["button-icon"] ? Tt((h(), b("button", {
          key: 0,
          ref_key: "toggleButton",
          ref: S,
          type: "button",
          "aria-label": (Y = O(l)) == null ? void 0 : Y.toggleOverlay,
          class: re(W.value),
          tabindex: "0",
          onClick: ie,
          onKeydown: He
        }, [
          me(te.$slots, "button-icon")
        ], 42, eF)), [
          [va, !O(f)(te.hideNavigation, te.type)]
        ]) : A("", !0)
      ], 38);
    };
  }
}), nd = /* @__PURE__ */ Ce({
  __name: "InstanceWrap",
  props: {
    multiCalendars: {},
    stretch: { type: Boolean },
    collapse: { type: Boolean }
  },
  setup(t) {
    const e = t, n = I(
      () => e.multiCalendars > 0 ? [...Array(e.multiCalendars).keys()] : [0]
    ), a = I(() => ({
      dp__instance_calendar: e.multiCalendars > 0
    }));
    return (i, r) => (h(), b("div", {
      class: re({
        dp__menu_inner: !i.stretch,
        "dp--menu--inner-stretched": i.stretch,
        dp__flex_display: i.multiCalendars > 0,
        "dp--flex-display-collapsed": i.collapse
      })
    }, [
      (h(!0), b(he, null, Le(n.value, (s, o) => (h(), b("div", {
        key: s,
        class: re(a.value)
      }, [
        me(i.$slots, "default", {
          instance: s,
          index: o
        })
      ], 2))), 128))
    ], 2));
  }
}), tF = ["aria-label", "aria-disabled"], ll = /* @__PURE__ */ Ce({
  compatConfig: {
    MODE: 3
  },
  __name: "ArrowBtn",
  props: {
    ariaLabel: {},
    disabled: { type: Boolean }
  },
  emits: ["activate", "set-ref"],
  setup(t, { emit: e }) {
    const n = e, a = K(null);
    return st(() => n("set-ref", a)), (i, r) => (h(), b("button", {
      ref_key: "elRef",
      ref: a,
      type: "button",
      class: "dp__btn dp--arrow-btn-nav",
      tabindex: "0",
      "aria-label": i.ariaLabel,
      "aria-disabled": i.disabled || void 0,
      onClick: r[0] || (r[0] = (s) => i.$emit("activate")),
      onKeydown: r[1] || (r[1] = (s) => O(Qn)(s, () => i.$emit("activate"), !0))
    }, [
      k("span", {
        class: re(["dp__inner_nav", { dp__inner_nav_disabled: i.disabled }])
      }, [
        me(i.$slots, "default")
      ], 2)
    ], 40, tF));
  }
}), nF = { class: "dp--year-mode-picker" }, aF = ["aria-label", "data-test"], sy = /* @__PURE__ */ Ce({
  __name: "YearModePicker",
  props: {
    ...Fa,
    showYearPicker: { type: Boolean, default: !1 },
    items: { type: Array, default: () => [] },
    instance: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    isDisabled: { type: Function, default: () => !1 }
  },
  emits: ["toggle-year-picker", "year-select", "handle-year"],
  setup(t, { emit: e }) {
    const n = e, a = t, { showRightIcon: i, showLeftIcon: r } = id(), { defaultedConfig: s, defaultedMultiCalendars: o, defaultedAriaLabels: l, defaultedTransitions: c, defaultedUI: u } = jt(a), { showTransition: f, transitionName: m } = Fl(c), _ = (x = !1, S) => {
      n("toggle-year-picker", { flow: x, show: S });
    }, T = (x) => {
      n("year-select", x);
    }, g = (x = !1) => {
      n("handle-year", x);
    };
    return (x, S) => {
      var D, L, M, E, P;
      return h(), b("div", nF, [
        O(r)(O(o), t.instance) ? (h(), G(ll, {
          key: 0,
          ref: "mpPrevIconRef",
          "aria-label": (D = O(l)) == null ? void 0 : D.prevYear,
          disabled: t.isDisabled(!1),
          class: re((L = O(u)) == null ? void 0 : L.navBtnPrev),
          onActivate: S[0] || (S[0] = (B) => g(!1))
        }, {
          default: oe(() => [
            x.$slots["arrow-left"] ? me(x.$slots, "arrow-left", { key: 0 }) : A("", !0),
            x.$slots["arrow-left"] ? A("", !0) : (h(), G(O(pf), { key: 1 }))
          ]),
          _: 3
        }, 8, ["aria-label", "disabled", "class"])) : A("", !0),
        k("button", {
          ref: "mpYearButtonRef",
          class: "dp__btn dp--year-select",
          type: "button",
          "aria-label": (M = O(l)) == null ? void 0 : M.openYearsOverlay,
          "data-test": `year-mode-btn-${t.instance}`,
          onClick: S[1] || (S[1] = () => _(!1)),
          onKeydown: S[2] || (S[2] = Li(() => _(!1), ["enter"]))
        }, [
          x.$slots.year ? me(x.$slots, "year", {
            key: 0,
            year: t.year
          }) : A("", !0),
          x.$slots.year ? A("", !0) : (h(), b(he, { key: 1 }, [
            ze(ne(t.year), 1)
          ], 64))
        ], 40, aF),
        O(i)(O(o), t.instance) ? (h(), G(ll, {
          key: 1,
          ref: "mpNextIconRef",
          "aria-label": (E = O(l)) == null ? void 0 : E.nextYear,
          disabled: t.isDisabled(!0),
          class: re((P = O(u)) == null ? void 0 : P.navBtnNext),
          onActivate: S[3] || (S[3] = (B) => g(!0))
        }, {
          default: oe(() => [
            x.$slots["arrow-right"] ? me(x.$slots, "arrow-right", { key: 0 }) : A("", !0),
            x.$slots["arrow-right"] ? A("", !0) : (h(), G(O(mf), { key: 1 }))
          ]),
          _: 3
        }, 8, ["aria-label", "disabled", "class"])) : A("", !0),
        Q(zr, {
          name: O(m)(t.showYearPicker),
          css: O(f)
        }, {
          default: oe(() => [
            t.showYearPicker ? (h(), G($l, {
              key: 0,
              items: t.items,
              "text-input": x.textInput,
              "esc-close": x.escClose,
              config: x.config,
              "is-last": x.autoApply && !O(s).keepActionRow,
              "hide-navigation": x.hideNavigation,
              "aria-labels": x.ariaLabels,
              type: "year",
              onToggle: _,
              onSelected: S[4] || (S[4] = (B) => T(B))
            }, an({
              "button-icon": oe(() => [
                x.$slots["calendar-icon"] ? me(x.$slots, "calendar-icon", { key: 0 }) : A("", !0),
                x.$slots["calendar-icon"] ? A("", !0) : (h(), G(O(ro), { key: 1 }))
              ]),
              _: 2
            }, [
              x.$slots["year-overlay-value"] ? {
                name: "item",
                fn: oe(({ item: B }) => [
                  me(x.$slots, "year-overlay-value", {
                    text: B.text,
                    value: B.value
                  })
                ]),
                key: "0"
              } : void 0
            ]), 1032, ["items", "text-input", "esc-close", "config", "is-last", "hide-navigation", "aria-labels"])) : A("", !0)
          ]),
          _: 3
        }, 8, ["name", "css"])
      ]);
    };
  }
}), kf = (t, e, n) => {
  if (e.value && Array.isArray(e.value))
    if (e.value.some((a) => ft(t, a))) {
      const a = e.value.filter((i) => !ft(i, t));
      e.value = a.length ? a : null;
    } else (n && +n > e.value.length || !n) && e.value.push(t);
  else
    e.value = [t];
}, Cf = (t, e, n) => {
  let a = t.value ? t.value.slice() : [];
  return a.length === 2 && a[1] !== null && (a = []), a.length ? Vt(e, a[0]) ? (a.unshift(e), n("range-start", a[0]), n("range-start", a[1])) : (a[1] = e, n("range-end", e)) : (a = [e], n("range-start", e)), a;
}, ad = (t, e, n, a) => {
  t && (t[0] && t[1] && n && e("auto-apply"), t[0] && !t[1] && a && n && e("auto-apply"));
}, oy = (t) => {
  Array.isArray(t.value) && t.value.length <= 2 && t.range ? t.modelValue.value = t.value.map((e) => ea(Ie(e), t.timezone)) : Array.isArray(t.value) || (t.modelValue.value = ea(Ie(t.value), t.timezone));
}, ly = (t, e, n, a) => Array.isArray(e.value) && (e.value.length === 2 || e.value.length === 1 && a.value.partialRange) ? a.value.fixedStart && (Kt(t, e.value[0]) || ft(t, e.value[0])) ? [e.value[0], t] : a.value.fixedEnd && (Vt(t, e.value[1]) || ft(t, e.value[1])) ? [t, e.value[1]] : (n("invalid-fixed-range", t), e.value) : [], cy = ({
  multiCalendars: t,
  range: e,
  highlight: n,
  propDates: a,
  calendars: i,
  modelValue: r,
  props: s,
  filters: o,
  year: l,
  month: c,
  emit: u
}) => {
  const f = I(() => _f(s.yearRange, s.locale, s.reverseYears)), m = K([!1]), _ = I(() => (V, H) => {
    const se = St(Ia(/* @__PURE__ */ new Date()), {
      month: c.value(V),
      year: l.value(V)
    }), ie = H ? Mv(se) : xl(se);
    return ty(
      ie,
      a.value.maxDate,
      a.value.minDate,
      s.preventMinMaxNavigation,
      H
    );
  }), T = () => Array.isArray(r.value) && t.value.solo && r.value[1], g = () => {
    for (let V = 0; V < t.value.count; V++)
      if (V === 0)
        i.value[V] = i.value[0];
      else if (V === t.value.count - 1 && T())
        i.value[V] = {
          month: ht(r.value[1]),
          year: at(r.value[1])
        };
      else {
        const H = St(Ie(), i.value[V - 1]);
        i.value[V] = { month: ht(H), year: at(lf(H, 1)) };
      }
  }, x = (V) => {
    if (!V) return g();
    const H = St(Ie(), i.value[V]);
    return i.value[0].year = at(Vv(H, t.value.count - 1)), g();
  }, S = (V, H) => {
    const se = mR(H, V);
    return e.value.showLastInRange && se > 1 ? H : V;
  }, D = (V) => s.focusStartDate || t.value.solo ? V[0] : V[1] ? S(V[0], V[1]) : V[0], L = () => {
    if (r.value) {
      const V = Array.isArray(r.value) ? D(r.value) : r.value;
      i.value[0] = { month: ht(V), year: at(V) };
    }
  }, M = () => {
    L(), t.value.count && g();
  };
  Qe(r, (V, H) => {
    s.isTextInputDate && JSON.stringify(V ?? {}) !== JSON.stringify(H ?? {}) && M();
  }), st(() => {
    M();
  });
  const E = (V, H) => {
    i.value[H].year = V, u("update-month-year", { instance: H, year: V, month: i.value[H].month }), t.value.count && !t.value.solo && x(H);
  }, P = I(() => (V) => Bs(f.value, (H) => {
    var se;
    const ie = l.value(V) === H.value, Z = kl(
      H.value,
      Rs(a.value.minDate),
      Rs(a.value.maxDate)
    ) || ((se = o.value.years) == null ? void 0 : se.includes(l.value(V))), $ = wf(n.value, H.value);
    return { active: ie, disabled: Z, highlighted: $ };
  })), B = (V, H) => {
    E(V, H), W(H);
  }, z = (V, H = !1) => {
    if (!_.value(V, H)) {
      const se = H ? l.value(V) + 1 : l.value(V) - 1;
      E(se, V);
    }
  }, W = (V, H = !1, se) => {
    H || u("reset-flow"), se !== void 0 ? m.value[V] = se : m.value[V] = !m.value[V], m.value[V] ? u("overlay-toggle", { open: !0, overlay: An.year }) : (u("overlay-closed"), u("overlay-toggle", { open: !1, overlay: An.year }));
  };
  return {
    isDisabled: _,
    groupedYears: P,
    showYearPicker: m,
    selectYear: E,
    toggleYearPicker: W,
    handleYearSelect: B,
    handleYear: z
  };
}, iF = (t, e) => {
  const {
    defaultedMultiCalendars: n,
    defaultedAriaLabels: a,
    defaultedTransitions: i,
    defaultedConfig: r,
    defaultedRange: s,
    defaultedHighlight: o,
    propDates: l,
    defaultedTz: c,
    defaultedFilters: u,
    defaultedMultiDates: f
  } = jt(t), m = () => {
    t.isTextInputDate && M(at(Ie(t.startDate)), 0);
  }, { modelValue: _, year: T, month: g, calendars: x } = zl(t, e, m), S = I(() => Wv(t.formatLocale, t.locale, t.monthNameFormat)), D = K(null), { checkMinMaxRange: L } = lr(t), {
    selectYear: M,
    groupedYears: E,
    showYearPicker: P,
    toggleYearPicker: B,
    handleYearSelect: z,
    handleYear: W,
    isDisabled: V
  } = cy({
    modelValue: _,
    multiCalendars: n,
    range: s,
    highlight: o,
    calendars: x,
    year: T,
    propDates: l,
    month: g,
    filters: u,
    props: t,
    emit: e
  });
  st(() => {
    t.startDate && (_.value && t.focusStartDate || !_.value) && M(at(Ie(t.startDate)), 0);
  });
  const H = (Y) => Y ? { month: ht(Y), year: at(Y) } : { month: null, year: null }, se = () => _.value ? Array.isArray(_.value) ? _.value.map((Y) => H(Y)) : H(_.value) : H(), ie = (Y, be) => {
    const Ne = x.value[Y], ee = se();
    return Array.isArray(ee) ? ee.some((Ue) => Ue.year === (Ne == null ? void 0 : Ne.year) && Ue.month === be) : (Ne == null ? void 0 : Ne.year) === ee.year && be === ee.month;
  }, Z = (Y, be, Ne) => {
    var ee, Ue;
    const tt = se();
    return Array.isArray(tt) ? T.value(be) === ((ee = tt[Ne]) == null ? void 0 : ee.year) && Y === ((Ue = tt[Ne]) == null ? void 0 : Ue.month) : !1;
  }, $ = (Y, be) => {
    if (s.value.enabled) {
      const Ne = se();
      if (Array.isArray(_.value) && Array.isArray(Ne)) {
        const ee = Z(Y, be, 0) || Z(Y, be, 1), Ue = yi(Ia(Ie()), Y, T.value(be));
        return ed(_.value, D.value, Ue) && !ee;
      }
      return !1;
    }
    return !1;
  }, J = I(() => (Y) => Bs(S.value, (be) => {
    var Ne;
    const ee = ie(Y, be.value), Ue = kl(
      be.value,
      Kv(T.value(Y), l.value.minDate),
      Qv(T.value(Y), l.value.maxDate)
    ) || L$(l.value.disabledDates, T.value(Y)).includes(be.value) || ((Ne = u.value.months) == null ? void 0 : Ne.includes(be.value)), tt = $(be.value, Y), we = ay(o.value, be.value, T.value(Y));
    return { active: ee, disabled: Ue, isBetween: tt, highlighted: we };
  })), N = (Y, be) => yi(Ia(Ie()), Y, T.value(be)), ue = (Y, be) => {
    const Ne = _.value ? _.value : Ia(/* @__PURE__ */ new Date());
    _.value = yi(Ne, Y, T.value(be)), e("auto-apply"), e("update-flow-step");
  }, xe = (Y, be) => {
    const Ne = N(Y, be);
    s.value.fixedEnd || s.value.fixedStart ? _.value = ly(Ne, _, e, s) : _.value ? L(Ne, _.value) && (_.value = Cf(_, N(Y, be), e)) : _.value = [N(Y, be)], kn().then(() => {
      ad(_.value, e, t.autoApply, t.modelAuto);
    });
  }, De = (Y, be) => {
    kf(N(Y, be), _, f.value.limit), e("auto-apply", !0);
  }, He = (Y, be) => (x.value[be].month = Y, ke(be, x.value[be].year, Y), f.value.enabled ? De(Y, be) : s.value.enabled ? xe(Y, be) : ue(Y, be)), te = (Y, be) => {
    M(Y, be), ke(be, Y, null);
  }, ke = (Y, be, Ne) => {
    let ee = Ne;
    if (!ee && ee !== 0) {
      const Ue = se();
      ee = Array.isArray(Ue) ? Ue[Y].month : Ue.month;
    }
    e("update-month-year", { instance: Y, year: be, month: ee });
  };
  return {
    groupedMonths: J,
    groupedYears: E,
    year: T,
    isDisabled: V,
    defaultedMultiCalendars: n,
    defaultedAriaLabels: a,
    defaultedTransitions: i,
    defaultedConfig: r,
    showYearPicker: P,
    modelValue: _,
    presetDate: (Y, be) => {
      oy({
        value: Y,
        modelValue: _,
        range: s.value.enabled,
        timezone: be ? void 0 : c.value.timezone
      }), e("auto-apply");
    },
    setHoverDate: (Y, be) => {
      D.value = N(Y, be);
    },
    selectMonth: He,
    selectYear: te,
    toggleYearPicker: B,
    handleYearSelect: z,
    handleYear: W,
    getModelMonthYear: se
  };
}, rF = /* @__PURE__ */ Ce({
  compatConfig: {
    MODE: 3
  },
  __name: "MonthPicker",
  props: {
    ...Fa
  },
  emits: [
    "update:internal-model-value",
    "overlay-closed",
    "reset-flow",
    "range-start",
    "range-end",
    "auto-apply",
    "update-month-year",
    "update-flow-step",
    "mount",
    "invalid-fixed-range",
    "overlay-toggle"
  ],
  setup(t, { expose: e, emit: n }) {
    const a = n, i = Di(), r = ua(i, "yearMode"), s = t;
    st(() => {
      s.shadow || a("mount", null);
    });
    const {
      groupedMonths: o,
      groupedYears: l,
      year: c,
      isDisabled: u,
      defaultedMultiCalendars: f,
      defaultedConfig: m,
      showYearPicker: _,
      modelValue: T,
      presetDate: g,
      setHoverDate: x,
      selectMonth: S,
      selectYear: D,
      toggleYearPicker: L,
      handleYearSelect: M,
      handleYear: E,
      getModelMonthYear: P
    } = iF(s, a);
    return e({ getSidebarProps: () => ({
      modelValue: T,
      year: c,
      getModelMonthYear: P,
      selectMonth: S,
      selectYear: D,
      handleYear: E
    }), presetDate: g, toggleYearPicker: (B) => L(0, B) }), (B, z) => (h(), G(nd, {
      "multi-calendars": O(f).count,
      collapse: B.collapse,
      stretch: ""
    }, {
      default: oe(({ instance: W }) => [
        B.$slots["top-extra"] ? me(B.$slots, "top-extra", {
          key: 0,
          value: B.internalModelValue
        }) : A("", !0),
        B.$slots["month-year"] ? me(B.$slots, "month-year", cn($t({ key: 1 }, {
          year: O(c),
          months: O(o)(W),
          years: O(l)(W),
          selectMonth: O(S),
          selectYear: O(D),
          instance: W
        }))) : (h(), G($l, {
          key: 2,
          items: O(o)(W),
          "arrow-navigation": B.arrowNavigation,
          "is-last": B.autoApply && !O(m).keepActionRow,
          "esc-close": B.escClose,
          height: O(m).modeHeight,
          config: B.config,
          "no-overlay-focus": !!(B.noOverlayFocus || B.textInput),
          "use-relative": "",
          type: "month",
          onSelected: (V) => O(S)(V, W),
          onHoverValue: (V) => O(x)(V, W)
        }, an({
          header: oe(() => [
            Q(sy, $t(B.$props, {
              items: O(l)(W),
              instance: W,
              "show-year-picker": O(_)[W],
              year: O(c)(W),
              "is-disabled": (V) => O(u)(W, V),
              onHandleYear: (V) => O(E)(W, V),
              onYearSelect: (V) => O(M)(V, W),
              onToggleYearPicker: (V) => O(L)(W, V == null ? void 0 : V.flow, V == null ? void 0 : V.show)
            }), an({ _: 2 }, [
              Le(O(r), (V, H) => ({
                name: V,
                fn: oe((se) => [
                  me(B.$slots, V, cn(Un(se)))
                ])
              }))
            ]), 1040, ["items", "instance", "show-year-picker", "year", "is-disabled", "onHandleYear", "onYearSelect", "onToggleYearPicker"])
          ]),
          _: 2
        }, [
          B.$slots["month-overlay-value"] ? {
            name: "item",
            fn: oe(({ item: V }) => [
              me(B.$slots, "month-overlay-value", {
                text: V.text,
                value: V.value
              })
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["items", "arrow-navigation", "is-last", "esc-close", "height", "config", "no-overlay-focus", "onSelected", "onHoverValue"]))
      ]),
      _: 3
    }, 8, ["multi-calendars", "collapse"]));
  }
}), sF = (t, e) => {
  const n = () => {
    t.isTextInputDate && (u.value = at(Ie(t.startDate)));
  }, { modelValue: a } = zl(t, e, n), i = K(null), { defaultedHighlight: r, defaultedMultiDates: s, defaultedFilters: o, defaultedRange: l, propDates: c } = jt(t), u = K();
  st(() => {
    t.startDate && (a.value && t.focusStartDate || !a.value) && (u.value = at(Ie(t.startDate)));
  });
  const f = (g) => Array.isArray(a.value) ? a.value.some((x) => at(x) === g) : a.value ? at(a.value) === g : !1, m = (g) => l.value.enabled && Array.isArray(a.value) ? ed(a.value, i.value, T(g)) : !1, _ = I(() => Bs(_f(t.yearRange, t.locale, t.reverseYears), (g) => {
    const x = f(g.value), S = kl(
      g.value,
      Rs(c.value.minDate),
      Rs(c.value.maxDate)
    ) || o.value.years.includes(g.value), D = m(g.value) && !x, L = wf(r.value, g.value);
    return { active: x, disabled: S, isBetween: D, highlighted: L };
  })), T = (g) => Ga(Ia(xl(/* @__PURE__ */ new Date())), g);
  return {
    groupedYears: _,
    modelValue: a,
    focusYear: u,
    setHoverValue: (g) => {
      i.value = Ga(Ia(/* @__PURE__ */ new Date()), g);
    },
    selectYear: (g) => {
      var x;
      if (e("update-month-year", { instance: 0, year: g }), s.value.enabled)
        return a.value ? Array.isArray(a.value) && (((x = a.value) == null ? void 0 : x.map((S) => at(S))).includes(g) ? a.value = a.value.filter((S) => at(S) !== g) : a.value.push(Ga(Hn(Ie()), g))) : a.value = [Ga(Hn(xl(Ie())), g)], e("auto-apply", !0);
      l.value.enabled ? (a.value = Cf(a, T(g), e), kn().then(() => {
        ad(a.value, e, t.autoApply, t.modelAuto);
      })) : (a.value = T(g), e("auto-apply"));
    }
  };
}, oF = /* @__PURE__ */ Ce({
  compatConfig: {
    MODE: 3
  },
  __name: "YearPicker",
  props: {
    ...Fa
  },
  emits: [
    "update:internal-model-value",
    "reset-flow",
    "range-start",
    "range-end",
    "auto-apply",
    "update-month-year"
  ],
  setup(t, { expose: e, emit: n }) {
    const a = n, i = t, { groupedYears: r, modelValue: s, focusYear: o, selectYear: l, setHoverValue: c } = sF(i, a), { defaultedConfig: u } = jt(i);
    return e({ getSidebarProps: () => ({
      modelValue: s,
      selectYear: l
    }) }), (f, m) => (h(), b("div", null, [
      f.$slots["top-extra"] ? me(f.$slots, "top-extra", {
        key: 0,
        value: f.internalModelValue
      }) : A("", !0),
      f.$slots["month-year"] ? me(f.$slots, "month-year", cn($t({ key: 1 }, {
        years: O(r),
        selectYear: O(l)
      }))) : (h(), G($l, {
        key: 2,
        items: O(r),
        "is-last": f.autoApply && !O(u).keepActionRow,
        height: O(u).modeHeight,
        config: f.config,
        "no-overlay-focus": !!(f.noOverlayFocus || f.textInput),
        "focus-value": O(o),
        type: "year",
        "use-relative": "",
        onSelected: O(l),
        onHoverValue: O(c)
      }, an({ _: 2 }, [
        f.$slots["year-overlay-value"] ? {
          name: "item",
          fn: oe(({ item: _ }) => [
            me(f.$slots, "year-overlay-value", {
              text: _.text,
              value: _.value
            })
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["items", "is-last", "height", "config", "no-overlay-focus", "focus-value", "onSelected", "onHoverValue"]))
    ]));
  }
}), lF = {
  key: 0,
  class: "dp__time_input"
}, cF = ["data-test", "aria-label", "onKeydown", "onClick", "onMousedown"], uF = /* @__PURE__ */ k("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_l" }, null, -1), dF = /* @__PURE__ */ k("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_r" }, null, -1), hF = ["aria-label", "disabled", "data-test", "onKeydown", "onClick"], fF = ["data-test", "aria-label", "onKeydown", "onClick", "onMousedown"], pF = /* @__PURE__ */ k("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_l" }, null, -1), mF = /* @__PURE__ */ k("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_r" }, null, -1), gF = { key: 0 }, bF = ["aria-label"], vF = /* @__PURE__ */ Ce({
  compatConfig: {
    MODE: 3
  },
  __name: "TimeInput",
  props: {
    hours: { type: Number, default: 0 },
    minutes: { type: Number, default: 0 },
    seconds: { type: Number, default: 0 },
    closeTimePickerBtn: { type: Object, default: null },
    order: { type: Number, default: 0 },
    disabledTimesConfig: { type: Function, default: null },
    validateTime: { type: Function, default: () => !1 },
    ...Fa
  },
  emits: [
    "set-hours",
    "set-minutes",
    "update:hours",
    "update:minutes",
    "update:seconds",
    "reset-flow",
    "mounted",
    "overlay-closed",
    "overlay-opened",
    "am-pm-change"
  ],
  setup(t, { expose: e, emit: n }) {
    const a = n, i = t, { setTimePickerElements: r, setTimePickerBackRef: s } = or(), { defaultedAriaLabels: o, defaultedTransitions: l, defaultedFilters: c, defaultedConfig: u, defaultedRange: f } = jt(i), { transitionName: m, showTransition: _ } = Fl(l), T = Ma({
      hours: !1,
      minutes: !1,
      seconds: !1
    }), g = K("AM"), x = K(null), S = K([]), D = K();
    st(() => {
      a("mounted");
    });
    const L = (X) => St(/* @__PURE__ */ new Date(), {
      hours: X.hours,
      minutes: X.minutes,
      seconds: i.enableSeconds ? X.seconds : 0,
      milliseconds: 0
    }), M = I(
      () => (X) => J(X, i[X]) || P(X, i[X])
    ), E = I(() => ({ hours: i.hours, minutes: i.minutes, seconds: i.seconds })), P = (X, Ae) => f.value.enabled && !f.value.disableTimeRangeValidation ? !i.validateTime(X, Ae) : !1, B = (X, Ae) => {
      if (f.value.enabled && !f.value.disableTimeRangeValidation) {
        const fe = Ae ? +i[`${X}Increment`] : -+i[`${X}Increment`], Ee = i[X] + fe;
        return !i.validateTime(X, Ee);
      }
      return !1;
    }, z = I(() => (X) => !He(+i[X] + +i[`${X}Increment`], X) || B(X, !0)), W = I(() => (X) => !He(+i[X] - +i[`${X}Increment`], X) || B(X, !1)), V = (X, Ae) => Cv(St(Ie(), X), Ae), H = (X, Ae) => u$(St(Ie(), X), Ae), se = I(
      () => ({
        dp__time_col: !0,
        dp__time_col_block: !i.timePickerInline,
        dp__time_col_reg_block: !i.enableSeconds && i.is24 && !i.timePickerInline,
        dp__time_col_reg_inline: !i.enableSeconds && i.is24 && i.timePickerInline,
        dp__time_col_reg_with_button: !i.enableSeconds && !i.is24,
        dp__time_col_sec: i.enableSeconds && i.is24,
        dp__time_col_sec_with_button: i.enableSeconds && !i.is24
      })
    ), ie = I(() => {
      const X = [{ type: "hours" }];
      return i.enableMinutes && X.push({ type: "", separator: !0 }, {
        type: "minutes"
      }), i.enableSeconds && X.push({ type: "", separator: !0 }, {
        type: "seconds"
      }), X;
    }), Z = I(() => ie.value.filter((X) => !X.separator)), $ = I(() => (X) => {
      if (X === "hours") {
        const Ae = ee(+i.hours);
        return { text: Ae < 10 ? `0${Ae}` : `${Ae}`, value: Ae };
      }
      return { text: i[X] < 10 ? `0${i[X]}` : `${i[X]}`, value: i[X] };
    }), J = (X, Ae) => {
      var fe;
      if (!i.disabledTimesConfig) return !1;
      const Ee = i.disabledTimesConfig(i.order, X === "hours" ? Ae : void 0);
      return Ee[X] ? !!((fe = Ee[X]) != null && fe.includes(Ae)) : !0;
    }, N = (X, Ae) => Ae !== "hours" || g.value === "AM" ? X : X + 12, ue = (X) => {
      const Ae = i.is24 ? 24 : 12, fe = X === "hours" ? Ae : 60, Ee = +i[`${X}GridIncrement`], Te = X === "hours" && !i.is24 ? Ee : 0, nt = [];
      for (let le = Te; le < fe; le += Ee)
        nt.push({ value: i.is24 ? le : N(le, X), text: le < 10 ? `0${le}` : `${le}` });
      return X === "hours" && !i.is24 && nt.unshift({ value: g.value === "PM" ? 12 : 0, text: "12" }), Bs(nt, (le) => ({ active: !1, disabled: c.value.times[X].includes(le.value) || !He(le.value, X) || J(X, le.value) || P(X, le.value) }));
    }, xe = (X) => X >= 0 ? X : 59, De = (X) => X >= 0 ? X : 23, He = (X, Ae) => {
      const fe = i.minTime ? L(d0(i.minTime)) : null, Ee = i.maxTime ? L(d0(i.maxTime)) : null, Te = L(
        d0(
          E.value,
          Ae,
          Ae === "minutes" || Ae === "seconds" ? xe(X) : De(X)
        )
      );
      return fe && Ee ? (wl(Te, Ee) || hs(Te, Ee)) && (Os(Te, fe) || hs(Te, fe)) : fe ? Os(Te, fe) || hs(Te, fe) : Ee ? wl(Te, Ee) || hs(Te, Ee) : !0;
    }, te = (X) => i[`no${X[0].toUpperCase() + X.slice(1)}Overlay`], ke = (X) => {
      te(X) || (T[X] = !T[X], T[X] ? a("overlay-opened", X) : a("overlay-closed", X));
    }, Y = (X) => X === "hours" ? ki : X === "minutes" ? nr : Ms, be = () => {
      D.value && clearTimeout(D.value);
    }, Ne = (X, Ae = !0, fe) => {
      const Ee = Ae ? V : H, Te = Ae ? +i[`${X}Increment`] : -+i[`${X}Increment`];
      He(+i[X] + Te, X) && a(
        `update:${X}`,
        Y(X)(Ee({ [X]: +i[X] }, { [X]: +i[`${X}Increment`] }))
      ), !(fe != null && fe.keyboard) && u.value.timeArrowHoldThreshold && (D.value = setTimeout(() => {
        Ne(X, Ae);
      }, u.value.timeArrowHoldThreshold));
    }, ee = (X) => i.is24 ? X : (X >= 12 ? g.value = "PM" : g.value = "AM", g$(X)), Ue = () => {
      g.value === "PM" ? (g.value = "AM", a("update:hours", i.hours - 12)) : (g.value = "PM", a("update:hours", i.hours + 12)), a("am-pm-change", g.value);
    }, tt = (X) => {
      T[X] = !0;
    }, we = (X, Ae, fe) => {
      if (X && i.arrowNavigation) {
        Array.isArray(S.value[Ae]) ? S.value[Ae][fe] = X : S.value[Ae] = [X];
        const Ee = S.value.reduce(
          (Te, nt) => nt.map((le, Oe) => [...Te[Oe] || [], nt[Oe]]),
          []
        );
        s(i.closeTimePickerBtn), x.value && (Ee[1] = Ee[1].concat(x.value)), r(Ee, i.order);
      }
    }, Je = (X, Ae) => (ke(X), a(`update:${X}`, Ae));
    return e({ openChildCmp: tt }), (X, Ae) => {
      var fe;
      return X.disabled ? A("", !0) : (h(), b("div", lF, [
        (h(!0), b(he, null, Le(ie.value, (Ee, Te) => {
          var nt, le, Oe;
          return h(), b("div", {
            key: Te,
            class: re(se.value)
          }, [
            Ee.separator ? (h(), b(he, { key: 0 }, [
              ze(" : ")
            ], 64)) : (h(), b(he, { key: 1 }, [
              k("button", {
                ref_for: !0,
                ref: (Re) => we(Re, Te, 0),
                type: "button",
                class: re({
                  dp__btn: !0,
                  dp__inc_dec_button: !X.timePickerInline,
                  dp__inc_dec_button_inline: X.timePickerInline,
                  dp__tp_inline_btn_top: X.timePickerInline,
                  dp__inc_dec_button_disabled: z.value(Ee.type)
                }),
                "data-test": `${Ee.type}-time-inc-btn-${i.order}`,
                "aria-label": (nt = O(o)) == null ? void 0 : nt.incrementValue(Ee.type),
                tabindex: "0",
                onKeydown: (Re) => O(Qn)(Re, () => Ne(Ee.type, !0, { keyboard: !0 }), !0),
                onClick: (Re) => O(u).timeArrowHoldThreshold ? void 0 : Ne(Ee.type, !0),
                onMousedown: (Re) => O(u).timeArrowHoldThreshold ? Ne(Ee.type, !0) : void 0,
                onMouseup: be
              }, [
                i.timePickerInline ? (h(), b(he, { key: 1 }, [
                  X.$slots["tp-inline-arrow-up"] ? me(X.$slots, "tp-inline-arrow-up", { key: 0 }) : (h(), b(he, { key: 1 }, [
                    uF,
                    dF
                  ], 64))
                ], 64)) : (h(), b(he, { key: 0 }, [
                  X.$slots["arrow-up"] ? me(X.$slots, "arrow-up", { key: 0 }) : A("", !0),
                  X.$slots["arrow-up"] ? A("", !0) : (h(), G(O(bf), { key: 1 }))
                ], 64))
              ], 42, cF),
              k("button", {
                ref_for: !0,
                ref: (Re) => we(Re, Te, 1),
                type: "button",
                "aria-label": (le = O(o)) == null ? void 0 : le.openTpOverlay(Ee.type),
                class: re({
                  dp__time_display: !0,
                  dp__time_display_block: !X.timePickerInline,
                  dp__time_display_inline: X.timePickerInline,
                  "dp--time-invalid": M.value(Ee.type),
                  "dp--time-overlay-btn": !M.value(Ee.type)
                }),
                disabled: te(Ee.type),
                tabindex: "0",
                "data-test": `${Ee.type}-toggle-overlay-btn-${i.order}`,
                onKeydown: (Re) => O(Qn)(Re, () => ke(Ee.type), !0),
                onClick: (Re) => ke(Ee.type)
              }, [
                X.$slots[Ee.type] ? me(X.$slots, Ee.type, {
                  key: 0,
                  text: $.value(Ee.type).text,
                  value: $.value(Ee.type).value
                }) : A("", !0),
                X.$slots[Ee.type] ? A("", !0) : (h(), b(he, { key: 1 }, [
                  ze(ne($.value(Ee.type).text), 1)
                ], 64))
              ], 42, hF),
              k("button", {
                ref_for: !0,
                ref: (Re) => we(Re, Te, 2),
                type: "button",
                class: re({
                  dp__btn: !0,
                  dp__inc_dec_button: !X.timePickerInline,
                  dp__inc_dec_button_inline: X.timePickerInline,
                  dp__tp_inline_btn_bottom: X.timePickerInline,
                  dp__inc_dec_button_disabled: W.value(Ee.type)
                }),
                "data-test": `${Ee.type}-time-dec-btn-${i.order}`,
                "aria-label": (Oe = O(o)) == null ? void 0 : Oe.decrementValue(Ee.type),
                tabindex: "0",
                onKeydown: (Re) => O(Qn)(Re, () => Ne(Ee.type, !1, { keyboard: !0 }), !0),
                onClick: (Re) => O(u).timeArrowHoldThreshold ? void 0 : Ne(Ee.type, !1),
                onMousedown: (Re) => O(u).timeArrowHoldThreshold ? Ne(Ee.type, !1) : void 0,
                onMouseup: be
              }, [
                i.timePickerInline ? (h(), b(he, { key: 1 }, [
                  X.$slots["tp-inline-arrow-down"] ? me(X.$slots, "tp-inline-arrow-down", { key: 0 }) : (h(), b(he, { key: 1 }, [
                    pF,
                    mF
                  ], 64))
                ], 64)) : (h(), b(he, { key: 0 }, [
                  X.$slots["arrow-down"] ? me(X.$slots, "arrow-down", { key: 0 }) : A("", !0),
                  X.$slots["arrow-down"] ? A("", !0) : (h(), G(O(vf), { key: 1 }))
                ], 64))
              ], 42, fF)
            ], 64))
          ], 2);
        }), 128)),
        X.is24 ? A("", !0) : (h(), b("div", gF, [
          X.$slots["am-pm-button"] ? me(X.$slots, "am-pm-button", {
            key: 0,
            toggle: Ue,
            value: g.value
          }) : A("", !0),
          X.$slots["am-pm-button"] ? A("", !0) : (h(), b("button", {
            key: 1,
            ref_key: "amPmButton",
            ref: x,
            type: "button",
            class: "dp__pm_am_button",
            role: "button",
            "aria-label": (fe = O(o)) == null ? void 0 : fe.amPmButton,
            tabindex: "0",
            onClick: Ue,
            onKeydown: Ae[0] || (Ae[0] = (Ee) => O(Qn)(Ee, () => Ue(), !0))
          }, ne(g.value), 41, bF))
        ])),
        (h(!0), b(he, null, Le(Z.value, (Ee, Te) => (h(), G(zr, {
          key: Te,
          name: O(m)(T[Ee.type]),
          css: O(_)
        }, {
          default: oe(() => [
            T[Ee.type] ? (h(), G($l, {
              key: 0,
              items: ue(Ee.type),
              "is-last": X.autoApply && !O(u).keepActionRow,
              "esc-close": X.escClose,
              type: Ee.type,
              "text-input": X.textInput,
              config: X.config,
              "arrow-navigation": X.arrowNavigation,
              "aria-labels": X.ariaLabels,
              onSelected: (nt) => Je(Ee.type, nt),
              onToggle: (nt) => ke(Ee.type),
              onResetFlow: Ae[1] || (Ae[1] = (nt) => X.$emit("reset-flow"))
            }, an({
              "button-icon": oe(() => [
                X.$slots["clock-icon"] ? me(X.$slots, "clock-icon", { key: 0 }) : A("", !0),
                X.$slots["clock-icon"] ? A("", !0) : (h(), G(dt(X.timePickerInline ? O(ro) : O(gf)), { key: 1 }))
              ]),
              _: 2
            }, [
              X.$slots[`${Ee.type}-overlay-value`] ? {
                name: "item",
                fn: oe(({ item: nt }) => [
                  me(X.$slots, `${Ee.type}-overlay-value`, {
                    text: nt.text,
                    value: nt.value
                  })
                ]),
                key: "0"
              } : void 0,
              X.$slots[`${Ee.type}-overlay-header`] ? {
                name: "header",
                fn: oe(() => [
                  me(X.$slots, `${Ee.type}-overlay-header`, {
                    toggle: () => ke(Ee.type)
                  })
                ]),
                key: "1"
              } : void 0
            ]), 1032, ["items", "is-last", "esc-close", "type", "text-input", "config", "arrow-navigation", "aria-labels", "onSelected", "onToggle"])) : A("", !0)
          ]),
          _: 2
        }, 1032, ["name", "css"]))), 128))
      ]));
    };
  }
}), yF = { class: "dp--tp-wrap" }, _F = ["aria-label", "tabindex"], TF = ["tabindex"], xF = ["aria-label"], uy = /* @__PURE__ */ Ce({
  compatConfig: {
    MODE: 3
  },
  __name: "TimePicker",
  props: {
    hours: { type: [Number, Array], default: 0 },
    minutes: { type: [Number, Array], default: 0 },
    seconds: { type: [Number, Array], default: 0 },
    disabledTimesConfig: { type: Function, default: null },
    validateTime: {
      type: Function,
      default: () => !1
    },
    ...Fa
  },
  emits: [
    "update:hours",
    "update:minutes",
    "update:seconds",
    "mount",
    "reset-flow",
    "overlay-opened",
    "overlay-closed",
    "am-pm-change"
  ],
  setup(t, { expose: e, emit: n }) {
    const a = n, i = t, { buildMatrix: r, setTimePicker: s } = or(), o = Di(), { defaultedTransitions: l, defaultedAriaLabels: c, defaultedTextInput: u, defaultedConfig: f, defaultedRange: m } = jt(i), { transitionName: _, showTransition: T } = Fl(l), { hideNavigationButtons: g } = id(), x = K(null), S = K(null), D = K([]), L = K(null);
    st(() => {
      a("mount"), !i.timePicker && i.arrowNavigation ? r([ln(x.value)], "time") : s(!0, i.timePicker);
    });
    const M = I(() => m.value.enabled && i.modelAuto ? Gv(i.internalModelValue) : !0), E = K(!1), P = (N) => ({
      hours: Array.isArray(i.hours) ? i.hours[N] : i.hours,
      minutes: Array.isArray(i.minutes) ? i.minutes[N] : i.minutes,
      seconds: Array.isArray(i.seconds) ? i.seconds[N] : i.seconds
    }), B = I(() => {
      const N = [];
      if (m.value.enabled)
        for (let ue = 0; ue < 2; ue++)
          N.push(P(ue));
      else
        N.push(P(0));
      return N;
    }), z = (N, ue = !1, xe = "") => {
      ue || a("reset-flow"), E.value = N, a(N ? "overlay-opened" : "overlay-closed", An.time), i.arrowNavigation && s(N), kn(() => {
        xe !== "" && D.value[0] && D.value[0].openChildCmp(xe);
      });
    }, W = I(() => ({
      dp__btn: !0,
      dp__button: !0,
      dp__button_bottom: i.autoApply && !f.value.keepActionRow
    })), V = ua(o, "timePicker"), H = (N, ue, xe) => m.value.enabled ? ue === 0 ? [N, B.value[1][xe]] : [B.value[0][xe], N] : N, se = (N) => {
      a("update:hours", N);
    }, ie = (N) => {
      a("update:minutes", N);
    }, Z = (N) => {
      a("update:seconds", N);
    }, $ = () => {
      if (L.value && !u.value.enabled && !i.noOverlayFocus) {
        const N = Xv(L.value);
        N && N.focus({ preventScroll: !0 });
      }
    }, J = (N) => {
      a("overlay-closed", N);
    };
    return e({ toggleTimePicker: z }), (N, ue) => {
      var xe;
      return h(), b("div", yF, [
        !N.timePicker && !N.timePickerInline ? Tt((h(), b("button", {
          key: 0,
          ref_key: "openTimePickerBtn",
          ref: x,
          type: "button",
          class: re(W.value),
          "aria-label": (xe = O(c)) == null ? void 0 : xe.openTimePicker,
          tabindex: N.noOverlayFocus ? void 0 : 0,
          "data-test": "open-time-picker-btn",
          onKeydown: ue[0] || (ue[0] = (De) => O(Qn)(De, () => z(!0))),
          onClick: ue[1] || (ue[1] = (De) => z(!0))
        }, [
          N.$slots["clock-icon"] ? me(N.$slots, "clock-icon", { key: 0 }) : A("", !0),
          N.$slots["clock-icon"] ? A("", !0) : (h(), G(O(gf), { key: 1 }))
        ], 42, _F)), [
          [va, !O(g)(N.hideNavigation, "time")]
        ]) : A("", !0),
        Q(zr, {
          name: O(_)(E.value),
          css: O(T) && !N.timePickerInline
        }, {
          default: oe(() => {
            var De;
            return [
              E.value || N.timePicker || N.timePickerInline ? (h(), b("div", {
                key: 0,
                ref_key: "overlayRef",
                ref: L,
                class: re({
                  dp__overlay: !N.timePickerInline,
                  "dp--overlay-absolute": !i.timePicker && !N.timePickerInline,
                  "dp--overlay-relative": i.timePicker
                }),
                style: bn(N.timePicker ? { height: `${O(f).modeHeight}px` } : void 0),
                tabindex: N.timePickerInline ? void 0 : 0
              }, [
                k("div", {
                  class: re(
                    N.timePickerInline ? "dp__time_picker_inline_container" : "dp__overlay_container dp__container_flex dp__time_picker_overlay_container"
                  ),
                  style: { display: "flex" }
                }, [
                  N.$slots["time-picker-overlay"] ? me(N.$slots, "time-picker-overlay", {
                    key: 0,
                    hours: t.hours,
                    minutes: t.minutes,
                    seconds: t.seconds,
                    setHours: se,
                    setMinutes: ie,
                    setSeconds: Z
                  }) : A("", !0),
                  N.$slots["time-picker-overlay"] ? A("", !0) : (h(), b("div", {
                    key: 1,
                    class: re(N.timePickerInline ? "dp__flex" : "dp__overlay_row dp__flex_row")
                  }, [
                    (h(!0), b(he, null, Le(B.value, (He, te) => Tt((h(), G(vF, $t({
                      key: te,
                      ref_for: !0
                    }, {
                      ...N.$props,
                      order: te,
                      hours: He.hours,
                      minutes: He.minutes,
                      seconds: He.seconds,
                      closeTimePickerBtn: S.value,
                      disabledTimesConfig: t.disabledTimesConfig,
                      disabled: te === 0 ? N.fixedStart : N.fixedEnd
                    }, {
                      ref_for: !0,
                      ref_key: "timeInputRefs",
                      ref: D,
                      "validate-time": (ke, Y) => t.validateTime(ke, H(Y, te, ke)),
                      "onUpdate:hours": (ke) => se(H(ke, te, "hours")),
                      "onUpdate:minutes": (ke) => ie(H(ke, te, "minutes")),
                      "onUpdate:seconds": (ke) => Z(H(ke, te, "seconds")),
                      onMounted: $,
                      onOverlayClosed: J,
                      onOverlayOpened: ue[2] || (ue[2] = (ke) => N.$emit("overlay-opened", ke)),
                      onAmPmChange: ue[3] || (ue[3] = (ke) => N.$emit("am-pm-change", ke))
                    }), an({ _: 2 }, [
                      Le(O(V), (ke, Y) => ({
                        name: ke,
                        fn: oe((be) => [
                          me(N.$slots, ke, $t({ ref_for: !0 }, be))
                        ])
                      }))
                    ]), 1040, ["validate-time", "onUpdate:hours", "onUpdate:minutes", "onUpdate:seconds"])), [
                      [va, te === 0 ? !0 : M.value]
                    ])), 128))
                  ], 2)),
                  !N.timePicker && !N.timePickerInline ? Tt((h(), b("button", {
                    key: 2,
                    ref_key: "closeTimePickerBtn",
                    ref: S,
                    type: "button",
                    class: re(W.value),
                    "aria-label": (De = O(c)) == null ? void 0 : De.closeTimePicker,
                    tabindex: "0",
                    onKeydown: ue[4] || (ue[4] = (He) => O(Qn)(He, () => z(!1))),
                    onClick: ue[5] || (ue[5] = (He) => z(!1))
                  }, [
                    N.$slots["calendar-icon"] ? me(N.$slots, "calendar-icon", { key: 0 }) : A("", !0),
                    N.$slots["calendar-icon"] ? A("", !0) : (h(), G(O(ro), { key: 1 }))
                  ], 42, xF)), [
                    [va, !O(g)(N.hideNavigation, "time")]
                  ]) : A("", !0)
                ], 2)
              ], 14, TF)) : A("", !0)
            ];
          }),
          _: 3
        }, 8, ["name", "css"])
      ]);
    };
  }
}), dy = (t, e, n, a) => {
  const { defaultedRange: i } = jt(t), r = (L, M) => Array.isArray(e[L]) ? e[L][M] : e[L], s = (L) => t.enableSeconds ? Array.isArray(e.seconds) ? e.seconds[L] : e.seconds : 0, o = (L, M) => L ? M !== void 0 ? Ji(L, r("hours", M), r("minutes", M), s(M)) : Ji(L, e.hours, e.minutes, s()) : jv(Ie(), s(M)), l = (L, M) => {
    e[L] = M;
  }, c = I(() => t.modelAuto && i.value.enabled ? Array.isArray(n.value) ? n.value.length > 1 : !1 : i.value.enabled), u = (L, M) => {
    const E = Object.fromEntries(
      Object.keys(e).map((P) => P === L ? [P, M] : [P, e[P]].slice())
    );
    if (c.value && !i.value.disableTimeRangeValidation) {
      const P = (z) => n.value ? Ji(
        n.value[z],
        E.hours[z],
        E.minutes[z],
        E.seconds[z]
      ) : null, B = (z) => Yv(n.value[z], 0);
      return !(ft(P(0), P(1)) && (Os(P(0), B(1)) || wl(P(1), B(0))));
    }
    return !0;
  }, f = (L, M) => {
    u(L, M) && (l(L, M), a && a());
  }, m = (L) => {
    f("hours", L);
  }, _ = (L) => {
    f("minutes", L);
  }, T = (L) => {
    f("seconds", L);
  }, g = (L, M, E, P) => {
    M && m(L), !M && !E && _(L), E && T(L), n.value && P(n.value);
  }, x = (L) => {
    if (L) {
      const M = Array.isArray(L), E = M ? [+L[0].hours, +L[1].hours] : +L.hours, P = M ? [+L[0].minutes, +L[1].minutes] : +L.minutes, B = M ? [+L[0].seconds, +L[1].seconds] : +L.seconds;
      l("hours", E), l("minutes", P), t.enableSeconds && l("seconds", B);
    }
  }, S = (L, M) => {
    const E = {
      hours: Array.isArray(e.hours) ? e.hours[L] : e.hours,
      disabledArr: []
    };
    return (M || M === 0) && (E.hours = M), Array.isArray(t.disabledTimes) && (E.disabledArr = i.value.enabled && Array.isArray(t.disabledTimes[L]) ? t.disabledTimes[L] : t.disabledTimes), E;
  }, D = I(() => (L, M) => {
    var E;
    if (Array.isArray(t.disabledTimes)) {
      const { disabledArr: P, hours: B } = S(L, M), z = P.filter((W) => +W.hours === B);
      return ((E = z[0]) == null ? void 0 : E.minutes) === "*" ? { hours: [B], minutes: void 0, seconds: void 0 } : {
        hours: [],
        minutes: (z == null ? void 0 : z.map((W) => +W.minutes)) ?? [],
        seconds: (z == null ? void 0 : z.map((W) => W.seconds ? +W.seconds : void 0)) ?? []
      };
    }
    return { hours: [], minutes: [], seconds: [] };
  });
  return {
    setTime: l,
    updateHours: m,
    updateMinutes: _,
    updateSeconds: T,
    getSetDateTime: o,
    updateTimeValues: g,
    getSecondsValue: s,
    assignStartTime: x,
    validateTime: u,
    disabledTimesConfig: D
  };
}, wF = (t, e) => {
  const n = () => {
    t.isTextInputDate && M();
  }, { modelValue: a, time: i } = zl(t, e, n), { defaultedStartTime: r, defaultedRange: s, defaultedTz: o } = jt(t), { updateTimeValues: l, getSetDateTime: c, setTime: u, assignStartTime: f, disabledTimesConfig: m, validateTime: _ } = dy(t, i, a, T);
  function T() {
    e("update-flow-step");
  }
  const g = (P) => {
    const { hours: B, minutes: z, seconds: W } = P;
    return { hours: +B, minutes: +z, seconds: W ? +W : 0 };
  }, x = () => {
    if (t.startTime) {
      if (Array.isArray(t.startTime)) {
        const B = g(t.startTime[0]), z = g(t.startTime[1]);
        return [St(Ie(), B), St(Ie(), z)];
      }
      const P = g(t.startTime);
      return St(Ie(), P);
    }
    return s.value.enabled ? [null, null] : null;
  }, S = () => {
    if (s.value.enabled) {
      const [P, B] = x();
      a.value = [
        ea(c(P, 0), o.value.timezone),
        ea(c(B, 1), o.value.timezone)
      ];
    } else
      a.value = ea(c(x()), o.value.timezone);
  }, D = (P) => Array.isArray(P) ? [Er(Ie(P[0])), Er(Ie(P[1]))] : [Er(P ?? Ie())], L = (P, B, z) => {
    u("hours", P), u("minutes", B), u("seconds", t.enableSeconds ? z : 0);
  }, M = () => {
    const [P, B] = D(a.value);
    return s.value.enabled ? L(
      [P.hours, B.hours],
      [P.minutes, B.minutes],
      [P.seconds, B.seconds]
    ) : L(P.hours, P.minutes, P.seconds);
  };
  st(() => {
    if (!t.shadow)
      return f(r.value), a.value ? M() : S();
  });
  const E = () => {
    Array.isArray(a.value) ? a.value = a.value.map((P, B) => P && c(P, B)) : a.value = c(a.value), e("time-update");
  };
  return {
    modelValue: a,
    time: i,
    disabledTimesConfig: m,
    updateTime: (P, B = !0, z = !1) => {
      l(P, B, z, E);
    },
    validateTime: _
  };
}, kF = /* @__PURE__ */ Ce({
  compatConfig: {
    MODE: 3
  },
  __name: "TimePickerSolo",
  props: {
    ...Fa
  },
  emits: [
    "update:internal-model-value",
    "time-update",
    "am-pm-change",
    "mount",
    "reset-flow",
    "update-flow-step",
    "overlay-toggle"
  ],
  setup(t, { expose: e, emit: n }) {
    const a = n, i = t, r = Di(), s = ua(r, "timePicker"), o = K(null), { time: l, modelValue: c, disabledTimesConfig: u, updateTime: f, validateTime: m } = wF(i, a);
    return st(() => {
      i.shadow || a("mount", null);
    }), e({ getSidebarProps: () => ({
      modelValue: c,
      time: l,
      updateTime: f
    }), toggleTimePicker: (_, T = !1, g = "") => {
      var x;
      (x = o.value) == null || x.toggleTimePicker(_, T, g);
    } }), (_, T) => (h(), G(nd, {
      "multi-calendars": 0,
      stretch: ""
    }, {
      default: oe(() => [
        Q(uy, $t({
          ref_key: "tpRef",
          ref: o
        }, _.$props, {
          hours: O(l).hours,
          minutes: O(l).minutes,
          seconds: O(l).seconds,
          "internal-model-value": _.internalModelValue,
          "disabled-times-config": O(u),
          "validate-time": O(m),
          "onUpdate:hours": T[0] || (T[0] = (g) => O(f)(g)),
          "onUpdate:minutes": T[1] || (T[1] = (g) => O(f)(g, !1)),
          "onUpdate:seconds": T[2] || (T[2] = (g) => O(f)(g, !1, !0)),
          onAmPmChange: T[3] || (T[3] = (g) => _.$emit("am-pm-change", g)),
          onResetFlow: T[4] || (T[4] = (g) => _.$emit("reset-flow")),
          onOverlayClosed: T[5] || (T[5] = (g) => _.$emit("overlay-toggle", { open: !1, overlay: g })),
          onOverlayOpened: T[6] || (T[6] = (g) => _.$emit("overlay-toggle", { open: !0, overlay: g }))
        }), an({ _: 2 }, [
          Le(O(s), (g, x) => ({
            name: g,
            fn: oe((S) => [
              me(_.$slots, g, cn(Un(S)))
            ])
          }))
        ]), 1040, ["hours", "minutes", "seconds", "internal-model-value", "disabled-times-config", "validate-time"])
      ]),
      _: 3
    }));
  }
}), CF = { class: "dp--header-wrap" }, SF = {
  key: 0,
  class: "dp__month_year_wrap"
}, AF = { key: 0 }, EF = { class: "dp__month_year_wrap" }, LF = ["aria-label", "data-test", "onClick", "onKeydown"], DF = /* @__PURE__ */ Ce({
  compatConfig: {
    MODE: 3
  },
  __name: "DpHeader",
  props: {
    month: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    instance: { type: Number, default: 0 },
    years: { type: Array, default: () => [] },
    months: { type: Array, default: () => [] },
    ...Fa
  },
  emits: ["update-month-year", "mount", "reset-flow", "overlay-closed", "overlay-opened"],
  setup(t, { expose: e, emit: n }) {
    const a = n, i = t, {
      defaultedTransitions: r,
      defaultedAriaLabels: s,
      defaultedMultiCalendars: o,
      defaultedFilters: l,
      defaultedConfig: c,
      defaultedHighlight: u,
      propDates: f,
      defaultedUI: m
    } = jt(i), { transitionName: _, showTransition: T } = Fl(r), { buildMatrix: g } = or(), { handleMonthYearChange: x, isDisabled: S, updateMonthYear: D } = G$(i, a), { showLeftIcon: L, showRightIcon: M } = id(), E = K(!1), P = K(!1), B = K([null, null, null, null]);
    st(() => {
      a("mount");
    });
    const z = (te) => ({
      get: () => i[te],
      set: (ke) => {
        const Y = te === La.month ? La.year : La.month;
        a("update-month-year", { [te]: ke, [Y]: i[Y] }), te === La.month ? J(!0) : N(!0);
      }
    }), W = I(z(La.month)), V = I(z(La.year)), H = I(() => (te) => ({
      month: i.month,
      year: i.year,
      items: te === La.month ? i.months : i.years,
      instance: i.instance,
      updateMonthYear: D,
      toggle: te === La.month ? J : N
    })), se = I(() => i.months.find((ke) => ke.value === i.month) || { text: "", value: 0 }), ie = I(() => Bs(i.months, (te) => {
      const ke = i.month === te.value, Y = kl(
        te.value,
        Kv(i.year, f.value.minDate),
        Qv(i.year, f.value.maxDate)
      ) || l.value.months.includes(te.value), be = ay(u.value, te.value, i.year);
      return { active: ke, disabled: Y, highlighted: be };
    })), Z = I(() => Bs(i.years, (te) => {
      const ke = i.year === te.value, Y = kl(
        te.value,
        Rs(f.value.minDate),
        Rs(f.value.maxDate)
      ) || l.value.years.includes(te.value), be = wf(u.value, te.value);
      return { active: ke, disabled: Y, highlighted: be };
    })), $ = (te, ke, Y) => {
      Y !== void 0 ? te.value = Y : te.value = !te.value, te.value ? a("overlay-opened", ke) : a("overlay-closed", ke);
    }, J = (te = !1, ke) => {
      ue(te), $(E, An.month, ke);
    }, N = (te = !1, ke) => {
      ue(te), $(P, An.year, ke);
    }, ue = (te) => {
      te || a("reset-flow");
    }, xe = (te, ke) => {
      i.arrowNavigation && (B.value[ke] = ln(te), g(B.value, "monthYear"));
    }, De = I(() => {
      var te, ke;
      return [
        {
          type: La.month,
          index: 1,
          toggle: J,
          modelValue: W.value,
          updateModelValue: (Y) => W.value = Y,
          text: se.value.text,
          showSelectionGrid: E.value,
          items: ie.value,
          ariaLabel: (te = s.value) == null ? void 0 : te.openMonthsOverlay
        },
        {
          type: La.year,
          index: 2,
          toggle: N,
          modelValue: V.value,
          updateModelValue: (Y) => V.value = Y,
          text: Zv(i.year, i.locale),
          showSelectionGrid: P.value,
          items: Z.value,
          ariaLabel: (ke = s.value) == null ? void 0 : ke.openYearsOverlay
        }
      ];
    }), He = I(() => i.disableYearSelect ? [De.value[0]] : i.yearFirst ? [...De.value].reverse() : De.value);
    return e({
      toggleMonthPicker: J,
      toggleYearPicker: N,
      handleMonthYearChange: x
    }), (te, ke) => {
      var Y, be, Ne, ee, Ue, tt;
      return h(), b("div", CF, [
        te.$slots["month-year"] ? (h(), b("div", SF, [
          me(te.$slots, "month-year", cn(Un({ month: t.month, year: t.year, months: t.months, years: t.years, updateMonthYear: O(D), handleMonthYearChange: O(x), instance: t.instance })))
        ])) : (h(), b(he, { key: 1 }, [
          te.$slots["top-extra"] ? (h(), b("div", AF, [
            me(te.$slots, "top-extra", { value: te.internalModelValue })
          ])) : A("", !0),
          k("div", EF, [
            O(L)(O(o), t.instance) && !te.vertical ? (h(), G(ll, {
              key: 0,
              "aria-label": (Y = O(s)) == null ? void 0 : Y.prevMonth,
              disabled: O(S)(!1),
              class: re((be = O(m)) == null ? void 0 : be.navBtnPrev),
              onActivate: ke[0] || (ke[0] = (we) => O(x)(!1, !0)),
              onSetRef: ke[1] || (ke[1] = (we) => xe(we, 0))
            }, {
              default: oe(() => [
                te.$slots["arrow-left"] ? me(te.$slots, "arrow-left", { key: 0 }) : A("", !0),
                te.$slots["arrow-left"] ? A("", !0) : (h(), G(O(pf), { key: 1 }))
              ]),
              _: 3
            }, 8, ["aria-label", "disabled", "class"])) : A("", !0),
            k("div", {
              class: re(["dp__month_year_wrap", {
                dp__year_disable_select: te.disableYearSelect
              }])
            }, [
              (h(!0), b(he, null, Le(He.value, (we, Je) => (h(), b(he, {
                key: we.type
              }, [
                k("button", {
                  ref_for: !0,
                  ref: (X) => xe(X, Je + 1),
                  type: "button",
                  class: "dp__btn dp__month_year_select",
                  tabindex: "0",
                  "aria-label": we.ariaLabel,
                  "data-test": `${we.type}-toggle-overlay-${t.instance}`,
                  onClick: we.toggle,
                  onKeydown: (X) => O(Qn)(X, () => we.toggle(), !0)
                }, [
                  te.$slots[we.type] ? me(te.$slots, we.type, {
                    key: 0,
                    text: we.text,
                    value: i[we.type]
                  }) : A("", !0),
                  te.$slots[we.type] ? A("", !0) : (h(), b(he, { key: 1 }, [
                    ze(ne(we.text), 1)
                  ], 64))
                ], 40, LF),
                Q(zr, {
                  name: O(_)(we.showSelectionGrid),
                  css: O(T)
                }, {
                  default: oe(() => [
                    we.showSelectionGrid ? (h(), G($l, {
                      key: 0,
                      items: we.items,
                      "arrow-navigation": te.arrowNavigation,
                      "hide-navigation": te.hideNavigation,
                      "is-last": te.autoApply && !O(c).keepActionRow,
                      "skip-button-ref": !1,
                      config: te.config,
                      type: we.type,
                      "header-refs": [],
                      "esc-close": te.escClose,
                      "menu-wrap-ref": te.menuWrapRef,
                      "text-input": te.textInput,
                      "aria-labels": te.ariaLabels,
                      onSelected: we.updateModelValue,
                      onToggle: we.toggle
                    }, an({
                      "button-icon": oe(() => [
                        te.$slots["calendar-icon"] ? me(te.$slots, "calendar-icon", { key: 0 }) : A("", !0),
                        te.$slots["calendar-icon"] ? A("", !0) : (h(), G(O(ro), { key: 1 }))
                      ]),
                      _: 2
                    }, [
                      te.$slots[`${we.type}-overlay-value`] ? {
                        name: "item",
                        fn: oe(({ item: X }) => [
                          me(te.$slots, `${we.type}-overlay-value`, {
                            text: X.text,
                            value: X.value
                          })
                        ]),
                        key: "0"
                      } : void 0,
                      te.$slots[`${we.type}-overlay`] ? {
                        name: "overlay",
                        fn: oe(() => [
                          me(te.$slots, `${we.type}-overlay`, $t({ ref_for: !0 }, H.value(we.type)))
                        ]),
                        key: "1"
                      } : void 0,
                      te.$slots[`${we.type}-overlay-header`] ? {
                        name: "header",
                        fn: oe(() => [
                          me(te.$slots, `${we.type}-overlay-header`, {
                            toggle: we.toggle
                          })
                        ]),
                        key: "2"
                      } : void 0
                    ]), 1032, ["items", "arrow-navigation", "hide-navigation", "is-last", "config", "type", "esc-close", "menu-wrap-ref", "text-input", "aria-labels", "onSelected", "onToggle"])) : A("", !0)
                  ]),
                  _: 2
                }, 1032, ["name", "css"])
              ], 64))), 128))
            ], 2),
            O(L)(O(o), t.instance) && te.vertical ? (h(), G(ll, {
              key: 1,
              "aria-label": (Ne = O(s)) == null ? void 0 : Ne.prevMonth,
              disabled: O(S)(!1),
              class: re((ee = O(m)) == null ? void 0 : ee.navBtnPrev),
              onActivate: ke[2] || (ke[2] = (we) => O(x)(!1, !0))
            }, {
              default: oe(() => [
                te.$slots["arrow-up"] ? me(te.$slots, "arrow-up", { key: 0 }) : A("", !0),
                te.$slots["arrow-up"] ? A("", !0) : (h(), G(O(bf), { key: 1 }))
              ]),
              _: 3
            }, 8, ["aria-label", "disabled", "class"])) : A("", !0),
            O(M)(O(o), t.instance) ? (h(), G(ll, {
              key: 2,
              ref: "rightIcon",
              disabled: O(S)(!0),
              "aria-label": (Ue = O(s)) == null ? void 0 : Ue.nextMonth,
              class: re((tt = O(m)) == null ? void 0 : tt.navBtnNext),
              onActivate: ke[3] || (ke[3] = (we) => O(x)(!0, !0)),
              onSetRef: ke[4] || (ke[4] = (we) => xe(we, te.disableYearSelect ? 2 : 3))
            }, {
              default: oe(() => [
                te.$slots[te.vertical ? "arrow-down" : "arrow-right"] ? me(te.$slots, te.vertical ? "arrow-down" : "arrow-right", { key: 0 }) : A("", !0),
                te.$slots[te.vertical ? "arrow-down" : "arrow-right"] ? A("", !0) : (h(), G(dt(te.vertical ? O(vf) : O(mf)), { key: 1 }))
              ]),
              _: 3
            }, 8, ["disabled", "aria-label", "class"])) : A("", !0)
          ])
        ], 64))
      ]);
    };
  }
}), IF = ["aria-label"], MF = {
  class: "dp__calendar_header",
  role: "row"
}, OF = {
  key: 0,
  class: "dp__calendar_header_item",
  role: "gridcell"
}, PF = ["aria-label"], BF = /* @__PURE__ */ k("div", { class: "dp__calendar_header_separator" }, null, -1), RF = ["aria-label"], NF = {
  key: 0,
  role: "gridcell",
  class: "dp__calendar_item dp__week_num"
}, $F = { class: "dp__cell_inner" }, FF = ["id", "aria-selected", "aria-disabled", "aria-label", "data-test", "onClick", "onKeydown", "onMouseenter", "onMouseleave", "onMousedown"], zF = /* @__PURE__ */ Ce({
  compatConfig: {
    MODE: 3
  },
  __name: "DpCalendar",
  props: {
    mappedDates: { type: Array, default: () => [] },
    instance: { type: Number, default: 0 },
    month: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    ...Fa
  },
  emits: [
    "select-date",
    "set-hover-date",
    "handle-scroll",
    "mount",
    "handle-swipe",
    "handle-space",
    "tooltip-open",
    "tooltip-close"
  ],
  setup(t, { expose: e, emit: n }) {
    const a = n, i = t, { buildMultiLevelMatrix: r } = or(), {
      defaultedTransitions: s,
      defaultedConfig: o,
      defaultedAriaLabels: l,
      defaultedMultiCalendars: c,
      defaultedWeekNumbers: u,
      defaultedMultiDates: f,
      defaultedUI: m
    } = jt(i), _ = K(null), T = K({
      bottom: "",
      left: "",
      transform: ""
    }), g = K([]), x = K(null), S = K(!0), D = K(""), L = K({ startX: 0, endX: 0, startY: 0, endY: 0 }), M = K([]), E = K({ left: "50%" }), P = K(!1), B = I(() => i.calendar ? i.calendar(i.mappedDates) : i.mappedDates), z = I(() => i.dayNames ? Array.isArray(i.dayNames) ? i.dayNames : i.dayNames(i.locale, +i.weekStart) : m$(i.formatLocale, i.locale, +i.weekStart));
    st(() => {
      a("mount", { cmp: "calendar", refs: g }), o.value.noSwipe || x.value && (x.value.addEventListener("touchstart", xe, { passive: !1 }), x.value.addEventListener("touchend", De, { passive: !1 }), x.value.addEventListener("touchmove", He, { passive: !1 })), i.monthChangeOnScroll && x.value && x.value.addEventListener("wheel", Y, { passive: !1 });
    });
    const W = (we) => we ? i.vertical ? "vNext" : "next" : i.vertical ? "vPrevious" : "previous", V = (we, Je) => {
      if (i.transitions) {
        const X = Hn(yi(Ie(), i.month, i.year));
        D.value = Kt(Hn(yi(Ie(), we, Je)), X) ? s.value[W(!0)] : s.value[W(!1)], S.value = !1, kn(() => {
          S.value = !0;
        });
      }
    }, H = I(
      () => ({
        [i.calendarClassName]: !!i.calendarClassName,
        ...m.value.calendar ?? {}
      })
    ), se = I(() => (we) => {
      const Je = b$(we);
      return {
        dp__marker_dot: Je.type === "dot",
        dp__marker_line: Je.type === "line"
      };
    }), ie = I(() => (we) => ft(we, _.value)), Z = I(() => ({
      dp__calendar: !0,
      dp__calendar_next: c.value.count > 0 && i.instance !== 0
    })), $ = I(() => (we) => i.hideOffsetDates ? we.current : !0), J = async (we, Je, X) => {
      const Ae = ln(g.value[Je][X]);
      if (Ae) {
        const { width: fe, height: Ee } = Ae.getBoundingClientRect();
        _.value = we.value;
        let Te = { left: `${fe / 2}px` }, nt = -50;
        if (await kn(), M.value[0]) {
          const { left: le, width: Oe } = M.value[0].getBoundingClientRect();
          le < 0 && (Te = { left: "0" }, nt = 0, E.value.left = `${fe / 2}px`), window.innerWidth < le + Oe && (Te = { right: "0" }, nt = 0, E.value.left = `${Oe - fe / 2}px`);
        }
        T.value = {
          bottom: `${Ee}px`,
          ...Te,
          transform: `translateX(${nt}%)`
        }, a("tooltip-open", we.marker);
      }
    }, N = async (we, Je, X) => {
      var Ae, fe;
      if (P.value && f.value.enabled && f.value.dragSelect)
        return a("select-date", we);
      a("set-hover-date", we), (fe = (Ae = we.marker) == null ? void 0 : Ae.tooltip) != null && fe.length && await J(we, Je, X);
    }, ue = (we) => {
      _.value && (_.value = null, T.value = JSON.parse(JSON.stringify({ bottom: "", left: "", transform: "" })), a("tooltip-close", we.marker));
    }, xe = (we) => {
      L.value.startX = we.changedTouches[0].screenX, L.value.startY = we.changedTouches[0].screenY;
    }, De = (we) => {
      L.value.endX = we.changedTouches[0].screenX, L.value.endY = we.changedTouches[0].screenY, te();
    }, He = (we) => {
      i.vertical && !i.inline && we.preventDefault();
    }, te = () => {
      const we = i.vertical ? "Y" : "X";
      Math.abs(L.value[`start${we}`] - L.value[`end${we}`]) > 10 && a("handle-swipe", L.value[`start${we}`] > L.value[`end${we}`] ? "right" : "left");
    }, ke = (we, Je, X) => {
      we && (Array.isArray(g.value[Je]) ? g.value[Je][X] = we : g.value[Je] = [we]), i.arrowNavigation && r(g.value, "calendar");
    }, Y = (we) => {
      i.monthChangeOnScroll && (we.preventDefault(), a("handle-scroll", we));
    }, be = (we) => u.value.type === "local" ? df(we.value, { weekStartsOn: +i.weekStart }) : u.value.type === "iso" ? cf(we.value) : typeof u.value.type == "function" ? u.value.type(we.value) : "", Ne = (we) => {
      const Je = we[0];
      return u.value.hideOnOffsetDates ? we.some((X) => X.current) ? be(Je) : "" : be(Je);
    }, ee = (we, Je) => {
      f.value.enabled || (Qi(we, o.value), a("select-date", Je));
    }, Ue = (we) => {
      Qi(we, o.value);
    }, tt = (we) => {
      f.value.enabled && f.value.dragSelect ? (P.value = !0, a("select-date", we)) : f.value.enabled && a("select-date", we);
    };
    return e({ triggerTransition: V }), (we, Je) => {
      var X;
      return h(), b("div", {
        class: re(Z.value)
      }, [
        k("div", {
          ref_key: "calendarWrapRef",
          ref: x,
          role: "grid",
          class: re(H.value),
          "aria-label": (X = O(l)) == null ? void 0 : X.calendarWrap
        }, [
          k("div", MF, [
            we.weekNumbers ? (h(), b("div", OF, ne(we.weekNumName), 1)) : A("", !0),
            (h(!0), b(he, null, Le(z.value, (Ae, fe) => {
              var Ee, Te;
              return h(), b("div", {
                key: fe,
                class: "dp__calendar_header_item",
                role: "gridcell",
                "data-test": "calendar-header",
                "aria-label": (Te = (Ee = O(l)) == null ? void 0 : Ee.weekDay) == null ? void 0 : Te.call(Ee, fe)
              }, [
                we.$slots["calendar-header"] ? me(we.$slots, "calendar-header", {
                  key: 0,
                  day: Ae,
                  index: fe
                }) : A("", !0),
                we.$slots["calendar-header"] ? A("", !0) : (h(), b(he, { key: 1 }, [
                  ze(ne(Ae), 1)
                ], 64))
              ], 8, PF);
            }), 128))
          ]),
          BF,
          Q(zr, {
            name: D.value,
            css: !!we.transitions
          }, {
            default: oe(() => {
              var Ae;
              return [
                S.value ? (h(), b("div", {
                  key: 0,
                  class: "dp__calendar",
                  role: "rowgroup",
                  "aria-label": ((Ae = O(l)) == null ? void 0 : Ae.calendarDays) || void 0,
                  onMouseleave: Je[1] || (Je[1] = (fe) => P.value = !1)
                }, [
                  (h(!0), b(he, null, Le(B.value, (fe, Ee) => (h(), b("div", {
                    key: Ee,
                    class: "dp__calendar_row",
                    role: "row"
                  }, [
                    we.weekNumbers ? (h(), b("div", NF, [
                      k("div", $F, ne(Ne(fe.days)), 1)
                    ])) : A("", !0),
                    (h(!0), b(he, null, Le(fe.days, (Te, nt) => {
                      var le, Oe, Re;
                      return h(), b("div", {
                        id: O(iy)(Te.value),
                        ref_for: !0,
                        ref: (ct) => ke(ct, Ee, nt),
                        key: nt + Ee,
                        role: "gridcell",
                        class: "dp__calendar_item",
                        "aria-selected": (Te.classData.dp__active_date || Te.classData.dp__range_start || Te.classData.dp__range_start) ?? void 0,
                        "aria-disabled": Te.classData.dp__cell_disabled || void 0,
                        "aria-label": (Oe = (le = O(l)) == null ? void 0 : le.day) == null ? void 0 : Oe.call(le, Te),
                        tabindex: "0",
                        "data-test": Te.value,
                        onClick: da((ct) => ee(ct, Te), ["prevent"]),
                        onKeydown: (ct) => O(Qn)(ct, () => we.$emit("select-date", Te)),
                        onMouseenter: (ct) => N(Te, Ee, nt),
                        onMouseleave: (ct) => ue(Te),
                        onMousedown: (ct) => tt(Te),
                        onMouseup: Je[0] || (Je[0] = (ct) => P.value = !1)
                      }, [
                        k("div", {
                          class: re(["dp__cell_inner", Te.classData])
                        }, [
                          we.$slots.day && $.value(Te) ? me(we.$slots, "day", {
                            key: 0,
                            day: +Te.text,
                            date: Te.value
                          }) : A("", !0),
                          we.$slots.day ? A("", !0) : (h(), b(he, { key: 1 }, [
                            ze(ne(Te.text), 1)
                          ], 64)),
                          Te.marker && $.value(Te) ? (h(), b(he, { key: 2 }, [
                            we.$slots.marker ? me(we.$slots, "marker", {
                              key: 0,
                              marker: Te.marker,
                              day: +Te.text,
                              date: Te.value
                            }) : (h(), b("div", {
                              key: 1,
                              class: re(se.value(Te.marker)),
                              style: bn(Te.marker.color ? { backgroundColor: Te.marker.color } : {})
                            }, null, 6))
                          ], 64)) : A("", !0),
                          ie.value(Te.value) ? (h(), b("div", {
                            key: 3,
                            ref_for: !0,
                            ref_key: "activeTooltip",
                            ref: M,
                            class: "dp__marker_tooltip",
                            style: bn(T.value)
                          }, [
                            (Re = Te.marker) != null && Re.tooltip ? (h(), b("div", {
                              key: 0,
                              class: "dp__tooltip_content",
                              onClick: Ue
                            }, [
                              (h(!0), b(he, null, Le(Te.marker.tooltip, (ct, Ot) => (h(), b("div", {
                                key: Ot,
                                class: "dp__tooltip_text"
                              }, [
                                we.$slots["marker-tooltip"] ? me(we.$slots, "marker-tooltip", {
                                  key: 0,
                                  tooltip: ct,
                                  day: Te.value
                                }) : A("", !0),
                                we.$slots["marker-tooltip"] ? A("", !0) : (h(), b(he, { key: 1 }, [
                                  k("div", {
                                    class: "dp__tooltip_mark",
                                    style: bn(ct.color ? { backgroundColor: ct.color } : {})
                                  }, null, 4),
                                  k("div", null, ne(ct.text), 1)
                                ], 64))
                              ]))), 128)),
                              k("div", {
                                class: "dp__arrow_bottom_tp",
                                style: bn(E.value)
                              }, null, 4)
                            ])) : A("", !0)
                          ], 4)) : A("", !0)
                        ], 2)
                      ], 40, FF);
                    }), 128))
                  ]))), 128))
                ], 40, RF)) : A("", !0)
              ];
            }),
            _: 3
          }, 8, ["name", "css"])
        ], 10, IF)
      ], 2);
    };
  }
}), N1 = (t) => Array.isArray(t), UF = (t, e, n, a) => {
  const i = K([]), r = K(/* @__PURE__ */ new Date()), s = K(), o = () => De(t.isTextInputDate), { modelValue: l, calendars: c, time: u, today: f } = zl(t, e, o), {
    defaultedMultiCalendars: m,
    defaultedStartTime: _,
    defaultedRange: T,
    defaultedConfig: g,
    defaultedTz: x,
    propDates: S,
    defaultedMultiDates: D
  } = jt(t), { validateMonthYearInRange: L, isDisabled: M, isDateRangeAllowed: E, checkMinMaxRange: P } = lr(t), { updateTimeValues: B, getSetDateTime: z, setTime: W, assignStartTime: V, validateTime: H, disabledTimesConfig: se } = dy(t, u, l, a), ie = I(
    () => (de) => c.value[de] ? c.value[de].month : 0
  ), Z = I(
    () => (de) => c.value[de] ? c.value[de].year : 0
  ), $ = (de) => !g.value.keepViewOnOffsetClick || de ? !0 : !s.value, J = (de, Pe, _e, Be = !1) => {
    var Ye, _n;
    $(Be) && (c.value[de] || (c.value[de] = { month: 0, year: 0 }), c.value[de].month = M1(Pe) ? (Ye = c.value[de]) == null ? void 0 : Ye.month : Pe, c.value[de].year = M1(_e) ? (_n = c.value[de]) == null ? void 0 : _n.year : _e);
  }, N = () => {
    t.autoApply && e("select-date");
  };
  st(() => {
    t.shadow || (l.value || (Je(), _.value && V(_.value)), De(!0), t.focusStartDate && t.startDate && Je());
  });
  const ue = I(() => {
    var de;
    return (de = t.flow) != null && de.length && !t.partialFlow ? t.flowStep === t.flow.length : !0;
  }), xe = () => {
    t.autoApply && ue.value && e("auto-apply");
  }, De = (de = !1) => {
    if (l.value)
      return Array.isArray(l.value) ? (i.value = l.value, ee(de)) : ke(l.value, de);
    if (m.value.count && de && !t.startDate)
      return te(Ie(), de);
  }, He = () => Array.isArray(l.value) && T.value.enabled ? ht(l.value[0]) === ht(l.value[1] ?? l.value[0]) : !1, te = (de = /* @__PURE__ */ new Date(), Pe = !1) => {
    if ((!m.value.count || !m.value.static || Pe) && J(0, ht(de), at(de)), m.value.count && (!m.value.solo || !l.value || He()))
      for (let _e = 1; _e < m.value.count; _e++) {
        const Be = St(Ie(), { month: ie.value(_e - 1), year: Z.value(_e - 1) }), Ye = Cv(Be, { months: 1 });
        c.value[_e] = { month: ht(Ye), year: at(Ye) };
      }
  }, ke = (de, Pe) => {
    te(de), W("hours", ki(de)), W("minutes", nr(de)), W("seconds", Ms(de)), m.value.count && Pe && we();
  }, Y = (de) => {
    if (m.value.count) {
      if (m.value.solo) return 0;
      const Pe = ht(de[0]), _e = ht(de[1]);
      return Math.abs(_e - Pe) < m.value.count ? 0 : 1;
    }
    return 1;
  }, be = (de, Pe) => {
    de[1] && T.value.showLastInRange ? te(de[Y(de)], Pe) : te(de[0], Pe);
    const _e = (Be, Ye) => [
      Be(de[0]),
      de[1] ? Be(de[1]) : u[Ye][1]
    ];
    W("hours", _e(ki, "hours")), W("minutes", _e(nr, "minutes")), W("seconds", _e(Ms, "seconds"));
  }, Ne = (de, Pe) => {
    if ((T.value.enabled || t.weekPicker) && !D.value.enabled)
      return be(de, Pe);
    if (D.value.enabled && Pe) {
      const _e = de[de.length - 1];
      return ke(_e, Pe);
    }
  }, ee = (de) => {
    const Pe = l.value;
    Ne(Pe, de), m.value.count && m.value.solo && we();
  }, Ue = (de, Pe) => {
    const _e = St(Ie(), { month: ie.value(Pe), year: Z.value(Pe) }), Be = de < 0 ? Pa(_e, 1) : Ps(_e, 1);
    L(ht(Be), at(Be), de < 0, t.preventMinMaxNavigation) && (J(Pe, ht(Be), at(Be)), e("update-month-year", { instance: Pe, month: ht(Be), year: at(Be) }), m.value.count && !m.value.solo && tt(Pe), n());
  }, tt = (de) => {
    for (let Pe = de - 1; Pe >= 0; Pe--) {
      const _e = Ps(St(Ie(), { month: ie.value(Pe + 1), year: Z.value(Pe + 1) }), 1);
      J(Pe, ht(_e), at(_e));
    }
    for (let Pe = de + 1; Pe <= m.value.count - 1; Pe++) {
      const _e = Pa(St(Ie(), { month: ie.value(Pe - 1), year: Z.value(Pe - 1) }), 1);
      J(Pe, ht(_e), at(_e));
    }
  }, we = () => {
    if (Array.isArray(l.value) && l.value.length === 2) {
      const de = Ie(
        Ie(l.value[1] ? l.value[1] : Pa(l.value[0], 1))
      ), [Pe, _e] = [ht(l.value[0]), at(l.value[0])], [Be, Ye] = [ht(l.value[1]), at(l.value[1])];
      (Pe !== Be || Pe === Be && _e !== Ye) && m.value.solo && J(1, ht(de), at(de));
    } else l.value && !Array.isArray(l.value) && (J(0, ht(l.value), at(l.value)), te(Ie()));
  }, Je = () => {
    t.startDate && (J(0, ht(Ie(t.startDate)), at(Ie(t.startDate))), m.value.count && tt(0));
  }, X = (de, Pe) => {
    if (t.monthChangeOnScroll) {
      const _e = (/* @__PURE__ */ new Date()).getTime() - r.value.getTime(), Be = Math.abs(de.deltaY);
      let Ye = 500;
      Be > 1 && (Ye = 100), Be > 100 && (Ye = 0), _e > Ye && (r.value = /* @__PURE__ */ new Date(), Ue(t.monthChangeOnScroll !== "inverse" ? -de.deltaY : de.deltaY, Pe));
    }
  }, Ae = (de, Pe, _e = !1) => {
    t.monthChangeOnArrows && t.vertical === _e && fe(de, Pe);
  }, fe = (de, Pe) => {
    Ue(de === "right" ? -1 : 1, Pe);
  }, Ee = (de) => {
    if (S.value.markers)
      return lu(de.value, S.value.markers);
  }, Te = (de, Pe) => {
    switch (t.sixWeeks === !0 ? "append" : t.sixWeeks) {
      case "prepend":
        return [!0, !1];
      case "center":
        return [de == 0, !0];
      case "fair":
        return [de == 0 || Pe > de, !0];
      case "append":
        return [!1, !1];
      default:
        return [!1, !1];
    }
  }, nt = (de, Pe, _e, Be) => {
    if (t.sixWeeks && de.length < 6) {
      const Ye = 6 - de.length, _n = (Pe.getDay() + 7 - Be) % 7, qn = 6 - (_e.getDay() + 7 - Be) % 7, [di, Gr] = Te(_n, qn);
      for (let Pi = 1; Pi <= Ye; Pi++)
        if (Gr ? !!(Pi % 2) == di : di) {
          const Ua = de[0].days[0], _o = le(Da(Ua.value, -7), ht(Pe));
          de.unshift({ days: _o });
        } else {
          const Ua = de[de.length - 1], _o = Ua.days[Ua.days.length - 1], Pd = le(Da(_o.value, 1), ht(Pe));
          de.push({ days: Pd });
        }
    }
    return de;
  }, le = (de, Pe) => {
    const _e = Ie(de), Be = [];
    for (let Ye = 0; Ye < 7; Ye++) {
      const _n = Da(_e, Ye), qn = ht(_n) !== Pe;
      Be.push({
        text: t.hideOffsetDates && qn ? "" : _n.getDate(),
        value: _n,
        current: !qn,
        classData: {}
      });
    }
    return Be;
  }, Oe = (de, Pe) => {
    const _e = [], Be = new Date(Pe, de), Ye = new Date(Pe, de + 1, 0), _n = t.weekStart, qn = Na(Be, { weekStartsOn: _n }), di = (Gr) => {
      const Pi = le(Gr, de);
      if (_e.push({ days: Pi }), !_e[_e.length - 1].days.some(
        (Ua) => ft(Hn(Ua.value), Hn(Ye))
      )) {
        const Ua = Da(Gr, 7);
        di(Ua);
      }
    };
    return di(qn), nt(_e, Be, Ye, _n);
  }, Re = (de) => {
    const Pe = Ji(Ie(de.value), u.hours, u.minutes, hn());
    e("date-update", Pe), D.value.enabled ? kf(Pe, l, D.value.limit) : l.value = Pe, a(), kn().then(() => {
      xe();
    });
  }, ct = (de) => T.value.noDisabledRange ? Jv(i.value[0], de).some((Pe) => M(Pe)) : !1, Ot = () => {
    i.value = l.value ? l.value.slice() : [], i.value.length === 2 && !(T.value.fixedStart || T.value.fixedEnd) && (i.value = []);
  }, Ge = (de, Pe) => {
    const _e = [
      Ie(de.value),
      Da(Ie(de.value), +T.value.autoRange)
    ];
    E(_e) ? (Pe && ma(de.value), i.value = _e) : e("invalid-date", de.value);
  }, ma = (de) => {
    const Pe = ht(Ie(de)), _e = at(Ie(de));
    if (J(0, Pe, _e), m.value.count > 0)
      for (let Be = 1; Be < m.value.count; Be++) {
        const Ye = C$(
          St(Ie(de), { year: ie.value(Be - 1), month: Z.value(Be - 1) })
        );
        J(Be, Ye.month, Ye.year);
      }
  }, Vn = (de) => {
    if (ct(de.value) || !P(de.value, l.value, T.value.fixedStart ? 0 : 1))
      return e("invalid-date", de.value);
    i.value = ly(Ie(de.value), l, e, T);
  }, ci = (de, Pe) => {
    if (Ot(), T.value.autoRange) return Ge(de, Pe);
    if (T.value.fixedStart || T.value.fixedEnd) return Vn(de);
    i.value[0] ? P(Ie(de.value), l.value) && !ct(de.value) ? Vt(Ie(de.value), Ie(i.value[0])) ? (i.value.unshift(Ie(de.value)), e("range-end", i.value[0])) : (i.value[1] = Ie(de.value), e("range-end", i.value[1])) : (t.autoApply && e("auto-apply-invalid", de.value), e("invalid-date", de.value)) : (i.value[0] = Ie(de.value), e("range-start", i.value[0]));
  }, hn = (de = !0) => t.enableSeconds ? Array.isArray(u.seconds) ? de ? u.seconds[0] : u.seconds[1] : u.seconds : 0, ui = (de) => {
    i.value[de] = Ji(
      i.value[de],
      u.hours[de],
      u.minutes[de],
      hn(de !== 1)
    );
  }, qr = () => {
    var de, Pe;
    i.value[0] && i.value[1] && +((de = i.value) == null ? void 0 : de[0]) > +((Pe = i.value) == null ? void 0 : Pe[1]) && (i.value.reverse(), e("range-start", i.value[0]), e("range-end", i.value[1]));
  }, dr = () => {
    i.value.length && (i.value[0] && !i.value[1] ? ui(0) : (ui(0), ui(1), a()), qr(), l.value = i.value.slice(), ad(i.value, e, t.autoApply, t.modelAuto));
  }, Wr = (de, Pe = !1) => {
    if (M(de.value) || !de.current && t.hideOffsetDates) return e("invalid-date", de.value);
    if (s.value = JSON.parse(JSON.stringify(de)), !T.value.enabled) return Re(de);
    N1(u.hours) && N1(u.minutes) && !D.value.enabled && (ci(de, Pe), dr());
  }, bt = (de, Pe) => {
    var _e;
    J(de, Pe.month, Pe.year, !0), m.value.count && !m.value.solo && tt(de), e("update-month-year", { instance: de, month: Pe.month, year: Pe.year }), n(m.value.solo ? de : void 0);
    const Be = (_e = t.flow) != null && _e.length ? t.flow[t.flowStep] : void 0;
    !Pe.fromNav && (Be === An.month || Be === An.year) && a();
  }, bo = (de, Pe) => {
    oy({
      value: de,
      modelValue: l,
      range: T.value.enabled,
      timezone: Pe ? void 0 : x.value.timezone
    }), N(), t.multiCalendars && kn().then(() => De(!0));
  }, Oi = () => {
    const de = yf(Ie(), x.value);
    T.value.enabled ? l.value && Array.isArray(l.value) && l.value[0] ? l.value = Vt(de, l.value[0]) ? [de, l.value[0]] : [l.value[0], de] : l.value = [de] : l.value = de, N();
  }, vo = () => {
    if (Array.isArray(l.value))
      if (D.value.enabled) {
        const de = yo();
        l.value[l.value.length - 1] = z(de);
      } else
        l.value = l.value.map((de, Pe) => de && z(de, Pe));
    else
      l.value = z(l.value);
    e("time-update");
  }, yo = () => Array.isArray(l.value) && l.value.length ? l.value[l.value.length - 1] : null;
  return {
    calendars: c,
    modelValue: l,
    month: ie,
    year: Z,
    time: u,
    disabledTimesConfig: se,
    today: f,
    validateTime: H,
    getCalendarDays: Oe,
    getMarker: Ee,
    handleScroll: X,
    handleSwipe: fe,
    handleArrow: Ae,
    selectDate: Wr,
    updateMonthYear: bt,
    presetDate: bo,
    selectCurrentDate: Oi,
    updateTime: (de, Pe = !0, _e = !1) => {
      B(de, Pe, _e, vo);
    },
    assignMonthAndYear: te
  };
}, HF = { key: 0 }, YF = /* @__PURE__ */ Ce({
  __name: "DatePicker",
  props: {
    ...Fa
  },
  emits: [
    "tooltip-open",
    "tooltip-close",
    "mount",
    "update:internal-model-value",
    "update-flow-step",
    "reset-flow",
    "auto-apply",
    "focus-menu",
    "select-date",
    "range-start",
    "range-end",
    "invalid-fixed-range",
    "time-update",
    "am-pm-change",
    "time-picker-open",
    "time-picker-close",
    "recalculate-position",
    "update-month-year",
    "auto-apply-invalid",
    "date-update",
    "invalid-date",
    "overlay-toggle"
  ],
  setup(t, { expose: e, emit: n }) {
    const a = n, i = t, {
      calendars: r,
      month: s,
      year: o,
      modelValue: l,
      time: c,
      disabledTimesConfig: u,
      today: f,
      validateTime: m,
      getCalendarDays: _,
      getMarker: T,
      handleArrow: g,
      handleScroll: x,
      handleSwipe: S,
      selectDate: D,
      updateMonthYear: L,
      presetDate: M,
      selectCurrentDate: E,
      updateTime: P,
      assignMonthAndYear: B
    } = UF(i, a, He, te), z = Di(), { setHoverDate: W, getDayClassData: V, clearHoverDate: H } = rz(l, i), { defaultedMultiCalendars: se } = jt(i), ie = K([]), Z = K([]), $ = K(null), J = ua(z, "calendar"), N = ua(z, "monthYear"), ue = ua(z, "timePicker"), xe = (X) => {
      i.shadow || a("mount", X);
    };
    Qe(
      r,
      () => {
        i.shadow || setTimeout(() => {
          a("recalculate-position");
        }, 0);
      },
      { deep: !0 }
    ), Qe(
      se,
      (X, Ae) => {
        X.count - Ae.count > 0 && B();
      },
      { deep: !0 }
    );
    const De = I(() => (X) => _(s.value(X), o.value(X)).map((Ae) => ({
      ...Ae,
      days: Ae.days.map((fe) => (fe.marker = T(fe), fe.classData = V(fe), fe))
    })));
    function He(X) {
      var Ae;
      X || X === 0 ? (Ae = Z.value[X]) == null || Ae.triggerTransition(s.value(X), o.value(X)) : Z.value.forEach((fe, Ee) => fe.triggerTransition(s.value(Ee), o.value(Ee)));
    }
    function te() {
      a("update-flow-step");
    }
    const ke = (X, Ae = !1) => {
      D(X, Ae), i.spaceConfirm && a("select-date");
    }, Y = (X, Ae, fe = 0) => {
      var Ee;
      (Ee = ie.value[fe]) == null || Ee.toggleMonthPicker(X, Ae);
    }, be = (X, Ae, fe = 0) => {
      var Ee;
      (Ee = ie.value[fe]) == null || Ee.toggleYearPicker(X, Ae);
    }, Ne = (X, Ae, fe) => {
      var Ee;
      (Ee = $.value) == null || Ee.toggleTimePicker(X, Ae, fe);
    }, ee = (X, Ae) => {
      var fe;
      if (!i.range) {
        const Ee = l.value ? l.value : f, Te = Ae ? new Date(Ae) : Ee, nt = X ? Na(Te, { weekStartsOn: 1 }) : Ov(Te, { weekStartsOn: 1 });
        D({
          value: nt,
          current: ht(Te) === s.value(0),
          text: "",
          classData: {}
        }), (fe = document.getElementById(iy(nt))) == null || fe.focus();
      }
    }, Ue = (X) => {
      var Ae;
      (Ae = ie.value[0]) == null || Ae.handleMonthYearChange(X, !0);
    }, tt = (X) => {
      L(0, { month: s.value(0), year: o.value(0) + (X ? 1 : -1), fromNav: !0 });
    }, we = (X, Ae) => {
      X === An.time && a(`time-picker-${Ae ? "open" : "close"}`), a("overlay-toggle", { open: Ae, overlay: X });
    }, Je = (X) => {
      a("overlay-toggle", { open: !1, overlay: X }), a("focus-menu");
    };
    return e({
      clearHoverDate: H,
      presetDate: M,
      selectCurrentDate: E,
      toggleMonthPicker: Y,
      toggleYearPicker: be,
      toggleTimePicker: Ne,
      handleArrow: g,
      updateMonthYear: L,
      getSidebarProps: () => ({
        modelValue: l,
        month: s,
        year: o,
        time: c,
        updateTime: P,
        updateMonthYear: L,
        selectDate: D,
        presetDate: M
      }),
      changeMonth: Ue,
      changeYear: tt,
      selectWeekDate: ee
    }), (X, Ae) => (h(), b(he, null, [
      Q(nd, {
        "multi-calendars": O(se).count,
        collapse: X.collapse
      }, {
        default: oe(({ instance: fe, index: Ee }) => [
          X.disableMonthYearSelect ? A("", !0) : (h(), G(DF, $t({
            key: 0,
            ref: (Te) => {
              Te && (ie.value[Ee] = Te);
            },
            months: O(Wv)(X.formatLocale, X.locale, X.monthNameFormat),
            years: O(_f)(X.yearRange, X.locale, X.reverseYears),
            month: O(s)(fe),
            year: O(o)(fe),
            instance: fe
          }, X.$props, {
            onMount: Ae[0] || (Ae[0] = (Te) => xe(O(Ar).header)),
            onResetFlow: Ae[1] || (Ae[1] = (Te) => X.$emit("reset-flow")),
            onUpdateMonthYear: (Te) => O(L)(fe, Te),
            onOverlayClosed: Je,
            onOverlayOpened: Ae[2] || (Ae[2] = (Te) => X.$emit("overlay-toggle", { open: !0, overlay: Te }))
          }), an({ _: 2 }, [
            Le(O(N), (Te, nt) => ({
              name: Te,
              fn: oe((le) => [
                me(X.$slots, Te, cn(Un(le)))
              ])
            }))
          ]), 1040, ["months", "years", "month", "year", "instance", "onUpdateMonthYear"])),
          Q(zF, $t({
            ref: (Te) => {
              Te && (Z.value[Ee] = Te);
            },
            "mapped-dates": De.value(fe),
            month: O(s)(fe),
            year: O(o)(fe),
            instance: fe
          }, X.$props, {
            onSelectDate: (Te) => O(D)(Te, fe !== 1),
            onHandleSpace: (Te) => ke(Te, fe !== 1),
            onSetHoverDate: Ae[3] || (Ae[3] = (Te) => O(W)(Te)),
            onHandleScroll: (Te) => O(x)(Te, fe),
            onHandleSwipe: (Te) => O(S)(Te, fe),
            onMount: Ae[4] || (Ae[4] = (Te) => xe(O(Ar).calendar)),
            onResetFlow: Ae[5] || (Ae[5] = (Te) => X.$emit("reset-flow")),
            onTooltipOpen: Ae[6] || (Ae[6] = (Te) => X.$emit("tooltip-open", Te)),
            onTooltipClose: Ae[7] || (Ae[7] = (Te) => X.$emit("tooltip-close", Te))
          }), an({ _: 2 }, [
            Le(O(J), (Te, nt) => ({
              name: Te,
              fn: oe((le) => [
                me(X.$slots, Te, cn(Un({ ...le })))
              ])
            }))
          ]), 1040, ["mapped-dates", "month", "year", "instance", "onSelectDate", "onHandleSpace", "onHandleScroll", "onHandleSwipe"])
        ]),
        _: 3
      }, 8, ["multi-calendars", "collapse"]),
      X.enableTimePicker ? (h(), b("div", HF, [
        X.$slots["time-picker"] ? me(X.$slots, "time-picker", cn($t({ key: 0 }, { time: O(c), updateTime: O(P) }))) : (h(), G(uy, $t({
          key: 1,
          ref_key: "timePickerRef",
          ref: $
        }, X.$props, {
          hours: O(c).hours,
          minutes: O(c).minutes,
          seconds: O(c).seconds,
          "internal-model-value": X.internalModelValue,
          "disabled-times-config": O(u),
          "validate-time": O(m),
          onMount: Ae[8] || (Ae[8] = (fe) => xe(O(Ar).timePicker)),
          "onUpdate:hours": Ae[9] || (Ae[9] = (fe) => O(P)(fe)),
          "onUpdate:minutes": Ae[10] || (Ae[10] = (fe) => O(P)(fe, !1)),
          "onUpdate:seconds": Ae[11] || (Ae[11] = (fe) => O(P)(fe, !1, !0)),
          onResetFlow: Ae[12] || (Ae[12] = (fe) => X.$emit("reset-flow")),
          onOverlayClosed: Ae[13] || (Ae[13] = (fe) => we(fe, !1)),
          onOverlayOpened: Ae[14] || (Ae[14] = (fe) => we(fe, !0)),
          onAmPmChange: Ae[15] || (Ae[15] = (fe) => X.$emit("am-pm-change", fe))
        }), an({ _: 2 }, [
          Le(O(ue), (fe, Ee) => ({
            name: fe,
            fn: oe((Te) => [
              me(X.$slots, fe, cn(Un(Te)))
            ])
          }))
        ]), 1040, ["hours", "minutes", "seconds", "internal-model-value", "disabled-times-config", "validate-time"]))
      ])) : A("", !0)
    ], 64));
  }
}), jF = (t, e) => {
  const n = K(), {
    defaultedMultiCalendars: a,
    defaultedConfig: i,
    defaultedHighlight: r,
    defaultedRange: s,
    propDates: o,
    defaultedFilters: l,
    defaultedMultiDates: c
  } = jt(t), { modelValue: u, year: f, month: m, calendars: _ } = zl(t, e), { isDisabled: T } = lr(t), { selectYear: g, groupedYears: x, showYearPicker: S, isDisabled: D, toggleYearPicker: L, handleYearSelect: M, handleYear: E } = cy({
    modelValue: u,
    multiCalendars: a,
    range: s,
    highlight: r,
    calendars: _,
    propDates: o,
    month: m,
    year: f,
    filters: l,
    props: t,
    emit: e
  }), P = ($, J) => [$, J].map((N) => Ja(N, "MMMM", { locale: t.formatLocale })).join("-"), B = I(() => ($) => u.value ? Array.isArray(u.value) ? u.value.some((J) => L1($, J)) : L1(u.value, $) : !1), z = ($) => {
    if (s.value.enabled) {
      if (Array.isArray(u.value)) {
        const J = ft($, u.value[0]) || ft($, u.value[1]);
        return ed(u.value, n.value, $) && !J;
      }
      return !1;
    }
    return !1;
  }, W = ($, J) => $.quarter === w1(J) && $.year === at(J), V = ($) => typeof r.value == "function" ? r.value({ quarter: w1($), year: at($) }) : !!r.value.quarters.find((J) => W(J, $)), H = I(() => ($) => {
    const J = St(/* @__PURE__ */ new Date(), { year: f.value($) });
    return gR({
      start: xl(J),
      end: Mv(J)
    }).map((N) => {
      const ue = kr(N), xe = k1(N), De = T(N), He = z(ue), te = V(ue);
      return {
        text: P(ue, xe),
        value: ue,
        active: B.value(ue),
        highlighted: te,
        disabled: De,
        isBetween: He
      };
    });
  }), se = ($) => {
    kf($, u, c.value.limit), e("auto-apply", !0);
  }, ie = ($) => {
    u.value = Cf(u, $, e), ad(u.value, e, t.autoApply, t.modelAuto);
  }, Z = ($) => {
    u.value = $, e("auto-apply");
  };
  return {
    defaultedConfig: i,
    defaultedMultiCalendars: a,
    groupedYears: x,
    year: f,
    isDisabled: D,
    quarters: H,
    showYearPicker: S,
    modelValue: u,
    setHoverDate: ($) => {
      n.value = $;
    },
    selectYear: g,
    selectQuarter: ($, J, N) => {
      if (!N)
        return _.value[J].month = ht(k1($)), c.value.enabled ? se($) : s.value.enabled ? ie($) : Z($);
    },
    toggleYearPicker: L,
    handleYearSelect: M,
    handleYear: E
  };
}, VF = { class: "dp--quarter-items" }, qF = ["data-test", "disabled", "onClick", "onMouseover"], WF = /* @__PURE__ */ Ce({
  compatConfig: {
    MODE: 3
  },
  __name: "QuarterPicker",
  props: {
    ...Fa
  },
  emits: [
    "update:internal-model-value",
    "reset-flow",
    "overlay-closed",
    "auto-apply",
    "range-start",
    "range-end",
    "overlay-toggle",
    "update-month-year"
  ],
  setup(t, { expose: e, emit: n }) {
    const a = n, i = t, r = Di(), s = ua(r, "yearMode"), {
      defaultedMultiCalendars: o,
      defaultedConfig: l,
      groupedYears: c,
      year: u,
      isDisabled: f,
      quarters: m,
      modelValue: _,
      showYearPicker: T,
      setHoverDate: g,
      selectQuarter: x,
      toggleYearPicker: S,
      handleYearSelect: D,
      handleYear: L
    } = jF(i, a);
    return e({ getSidebarProps: () => ({
      modelValue: _,
      year: u,
      selectQuarter: x,
      handleYearSelect: D,
      handleYear: L
    }) }), (M, E) => (h(), G(nd, {
      "multi-calendars": O(o).count,
      collapse: M.collapse,
      stretch: ""
    }, {
      default: oe(({ instance: P }) => [
        k("div", {
          class: "dp-quarter-picker-wrap",
          style: bn({ minHeight: `${O(l).modeHeight}px` })
        }, [
          M.$slots["top-extra"] ? me(M.$slots, "top-extra", {
            key: 0,
            value: M.internalModelValue
          }) : A("", !0),
          k("div", null, [
            Q(sy, $t(M.$props, {
              items: O(c)(P),
              instance: P,
              "show-year-picker": O(T)[P],
              year: O(u)(P),
              "is-disabled": (B) => O(f)(P, B),
              onHandleYear: (B) => O(L)(P, B),
              onYearSelect: (B) => O(D)(B, P),
              onToggleYearPicker: (B) => O(S)(P, B == null ? void 0 : B.flow, B == null ? void 0 : B.show)
            }), an({ _: 2 }, [
              Le(O(s), (B, z) => ({
                name: B,
                fn: oe((W) => [
                  me(M.$slots, B, cn(Un(W)))
                ])
              }))
            ]), 1040, ["items", "instance", "show-year-picker", "year", "is-disabled", "onHandleYear", "onYearSelect", "onToggleYearPicker"])
          ]),
          k("div", VF, [
            (h(!0), b(he, null, Le(O(m)(P), (B, z) => (h(), b("div", { key: z }, [
              k("button", {
                type: "button",
                class: re(["dp--qr-btn", {
                  "dp--qr-btn-active": B.active,
                  "dp--qr-btn-between": B.isBetween,
                  "dp--qr-btn-disabled": B.disabled,
                  "dp--highlighted": B.highlighted
                }]),
                "data-test": B.value,
                disabled: B.disabled,
                onClick: (W) => O(x)(B.value, P, B.disabled),
                onMouseover: (W) => O(g)(B.value)
              }, [
                M.$slots.quarter ? me(M.$slots, "quarter", {
                  key: 0,
                  value: B.value,
                  text: B.text
                }) : (h(), b(he, { key: 1 }, [
                  ze(ne(B.text), 1)
                ], 64))
              ], 42, qF)
            ]))), 128))
          ])
        ], 4)
      ]),
      _: 3
    }, 8, ["multi-calendars", "collapse"]));
  }
}), GF = ["id", "aria-label"], XF = {
  key: 0,
  class: "dp--menu-load-container"
}, ZF = /* @__PURE__ */ k("span", { class: "dp--menu-loader" }, null, -1), KF = [
  ZF
], QF = {
  key: 0,
  class: "dp__sidebar_left"
}, JF = ["data-test", "onClick", "onKeydown"], ez = {
  key: 2,
  class: "dp__sidebar_right"
}, tz = {
  key: 3,
  class: "dp__action_extra"
}, $1 = /* @__PURE__ */ Ce({
  compatConfig: {
    MODE: 3
  },
  __name: "DatepickerMenu",
  props: {
    ...td,
    shadow: { type: Boolean, default: !1 },
    openOnTop: { type: Boolean, default: !1 },
    internalModelValue: { type: [Date, Array], default: null },
    noOverlayFocus: { type: Boolean, default: !1 },
    collapse: { type: Boolean, default: !1 },
    getInputRect: { type: Function, default: () => ({}) },
    isTextInputDate: { type: Boolean, default: !1 }
  },
  emits: [
    "close-picker",
    "select-date",
    "auto-apply",
    "time-update",
    "flow-step",
    "update-month-year",
    "invalid-select",
    "update:internal-model-value",
    "recalculate-position",
    "invalid-fixed-range",
    "tooltip-open",
    "tooltip-close",
    "time-picker-open",
    "time-picker-close",
    "am-pm-change",
    "range-start",
    "range-end",
    "auto-apply-invalid",
    "date-update",
    "invalid-date",
    "overlay-toggle"
  ],
  setup(t, { expose: e, emit: n }) {
    const a = n, i = t, r = K(null), s = I(() => {
      const { openOnTop: le, ...Oe } = i;
      return {
        ...Oe,
        flowStep: W.value,
        collapse: i.collapse,
        noOverlayFocus: i.noOverlayFocus,
        menuWrapRef: r.value
      };
    }), { setMenuFocused: o, setShiftKey: l, control: c } = ry(), u = Di(), { defaultedTextInput: f, defaultedInline: m, defaultedConfig: _, defaultedUI: T } = jt(i), g = K(null), x = K(0), S = K(null), D = K(!1), L = K(null);
    st(() => {
      if (!i.shadow) {
        D.value = !0, M(), window.addEventListener("resize", M);
        const le = ln(r);
        if (le && !f.value.enabled && !m.value.enabled && (o(!0), J()), le) {
          const Oe = (Re) => {
            _.value.allowPreventDefault && Re.preventDefault(), Qi(Re, _.value, !0);
          };
          le.addEventListener("pointerdown", Oe), le.addEventListener("mousedown", Oe);
        }
      }
    }), Ks(() => {
      window.removeEventListener("resize", M);
    });
    const M = () => {
      const le = ln(S);
      le && (x.value = le.getBoundingClientRect().width);
    }, { arrowRight: E, arrowLeft: P, arrowDown: B, arrowUp: z } = or(), { flowStep: W, updateFlowStep: V, childMount: H, resetFlow: se, handleFlow: ie } = sz(i, a, L), Z = I(() => i.monthPicker ? rF : i.yearPicker ? oF : i.timePicker ? kF : i.quarterPicker ? WF : YF), $ = I(() => {
      var le;
      if (_.value.arrowLeft) return _.value.arrowLeft;
      const Oe = (le = r.value) == null ? void 0 : le.getBoundingClientRect(), Re = i.getInputRect();
      return (Re == null ? void 0 : Re.width) < (x == null ? void 0 : x.value) && (Re == null ? void 0 : Re.left) <= ((Oe == null ? void 0 : Oe.left) ?? 0) ? `${(Re == null ? void 0 : Re.width) / 2}px` : (Re == null ? void 0 : Re.right) >= ((Oe == null ? void 0 : Oe.right) ?? 0) && (Re == null ? void 0 : Re.width) < (x == null ? void 0 : x.value) ? `${(x == null ? void 0 : x.value) - (Re == null ? void 0 : Re.width) / 2}px` : "50%";
    }), J = () => {
      const le = ln(r);
      le && le.focus({ preventScroll: !0 });
    }, N = I(() => {
      var le;
      return ((le = L.value) == null ? void 0 : le.getSidebarProps()) || {};
    }), ue = () => {
      i.openOnTop && a("recalculate-position");
    }, xe = ua(u, "action"), De = I(() => i.monthPicker || i.yearPicker ? ua(u, "monthYear") : i.timePicker ? ua(u, "timePicker") : ua(u, "shared")), He = I(() => i.openOnTop ? "dp__arrow_bottom" : "dp__arrow_top"), te = I(() => ({
      dp__menu_disabled: i.disabled,
      dp__menu_readonly: i.readonly,
      "dp-menu-loading": i.loading
    })), ke = I(
      () => ({
        dp__menu: !0,
        dp__menu_index: !m.value.enabled,
        dp__relative: m.value.enabled,
        [i.menuClassName]: !!i.menuClassName,
        ...T.value.menu ?? {}
      })
    ), Y = (le) => {
      Qi(le, _.value, !0);
    }, be = () => {
      i.escClose && a("close-picker");
    }, Ne = (le) => {
      if (i.arrowNavigation) {
        if (le === Bn.up) return z();
        if (le === Bn.down) return B();
        if (le === Bn.left) return P();
        if (le === Bn.right) return E();
      } else le === Bn.left || le === Bn.up ? Je("handleArrow", Bn.left, 0, le === Bn.up) : Je("handleArrow", Bn.right, 0, le === Bn.down);
    }, ee = (le) => {
      l(le.shiftKey), !i.disableMonthYearSelect && le.code === zt.tab && le.target.classList.contains("dp__menu") && c.value.shiftKeyInMenu && (le.preventDefault(), Qi(le, _.value, !0), a("close-picker"));
    }, Ue = () => {
      J(), a("time-picker-close");
    }, tt = (le) => {
      var Oe, Re, ct;
      (Oe = L.value) == null || Oe.toggleTimePicker(!1, !1), (Re = L.value) == null || Re.toggleMonthPicker(!1, !1, le), (ct = L.value) == null || ct.toggleYearPicker(!1, !1, le);
    }, we = (le, Oe = 0) => {
      var Re, ct, Ot;
      return le === "month" ? (Re = L.value) == null ? void 0 : Re.toggleMonthPicker(!1, !0, Oe) : le === "year" ? (ct = L.value) == null ? void 0 : ct.toggleYearPicker(!1, !0, Oe) : le === "time" ? (Ot = L.value) == null ? void 0 : Ot.toggleTimePicker(!0, !1) : tt(Oe);
    }, Je = (le, ...Oe) => {
      var Re, ct;
      (Re = L.value) != null && Re[le] && ((ct = L.value) == null || ct[le](...Oe));
    }, X = () => {
      Je("selectCurrentDate");
    }, Ae = (le, Oe) => {
      Je("presetDate", le, Oe);
    }, fe = () => {
      Je("clearHoverDate");
    }, Ee = (le, Oe) => {
      Je("updateMonthYear", le, Oe);
    }, Te = (le, Oe) => {
      le.preventDefault(), Ne(Oe);
    }, nt = (le) => {
      var Oe;
      if (ee(le), le.key === zt.home || le.key === zt.end)
        return Je(
          "selectWeekDate",
          le.key === zt.home,
          le.target.getAttribute("id")
        );
      switch ((le.key === zt.pageUp || le.key === zt.pageDown) && (le.shiftKey ? Je("changeYear", le.key === zt.pageUp) : Je("changeMonth", le.key === zt.pageUp), le.target.getAttribute("id") && ((Oe = r.value) == null || Oe.focus({ preventScroll: !0 }))), le.key) {
        case zt.esc:
          return be();
        case zt.arrowLeft:
          return Te(le, Bn.left);
        case zt.arrowRight:
          return Te(le, Bn.right);
        case zt.arrowUp:
          return Te(le, Bn.up);
        case zt.arrowDown:
          return Te(le, Bn.down);
        default:
          return;
      }
    };
    return e({
      updateMonthYear: Ee,
      switchView: we,
      handleFlow: ie
    }), (le, Oe) => {
      var Re, ct, Ot;
      return h(), b("div", {
        id: le.uid ? `dp-menu-${le.uid}` : void 0,
        ref_key: "dpMenuRef",
        ref: r,
        tabindex: "0",
        role: "dialog",
        "aria-label": (Re = le.ariaLabels) == null ? void 0 : Re.menu,
        class: re(ke.value),
        style: bn({ "--dp-arrow-left": $.value }),
        onMouseleave: fe,
        onClick: Y,
        onKeydown: nt
      }, [
        (le.disabled || le.readonly) && O(m).enabled || le.loading ? (h(), b("div", {
          key: 0,
          class: re(te.value)
        }, [
          le.loading ? (h(), b("div", XF, KF)) : A("", !0)
        ], 2)) : A("", !0),
        !O(m).enabled && !le.teleportCenter ? (h(), b("div", {
          key: 1,
          class: re(He.value)
        }, null, 2)) : A("", !0),
        k("div", {
          ref_key: "innerMenuRef",
          ref: S,
          class: re({
            dp__menu_content_wrapper: ((ct = le.presetDates) == null ? void 0 : ct.length) || !!le.$slots["left-sidebar"] || !!le.$slots["right-sidebar"],
            "dp--menu-content-wrapper-collapsed": t.collapse && (((Ot = le.presetDates) == null ? void 0 : Ot.length) || !!le.$slots["left-sidebar"] || !!le.$slots["right-sidebar"])
          }),
          style: bn({ "--dp-menu-width": `${x.value}px` })
        }, [
          le.$slots["left-sidebar"] ? (h(), b("div", QF, [
            me(le.$slots, "left-sidebar", cn(Un(N.value)))
          ])) : A("", !0),
          le.presetDates.length ? (h(), b("div", {
            key: 1,
            class: re({ "dp--preset-dates-collapsed": t.collapse, "dp--preset-dates": !0 })
          }, [
            (h(!0), b(he, null, Le(le.presetDates, (Ge, ma) => (h(), b(he, { key: ma }, [
              Ge.slot ? me(le.$slots, Ge.slot, {
                key: 0,
                presetDate: Ae,
                label: Ge.label,
                value: Ge.value
              }) : (h(), b("button", {
                key: 1,
                type: "button",
                style: bn(Ge.style || {}),
                class: re(["dp__btn dp--preset-range", { "dp--preset-range-collapsed": t.collapse }]),
                "data-test": Ge.testId ?? void 0,
                onClick: da((Vn) => Ae(Ge.value, Ge.noTz), ["prevent"]),
                onKeydown: (Vn) => O(Qn)(Vn, () => Ae(Ge.value, Ge.noTz), !0)
              }, ne(Ge.label), 47, JF))
            ], 64))), 128))
          ], 2)) : A("", !0),
          k("div", {
            ref_key: "calendarWrapperRef",
            ref: g,
            class: "dp__instance_calendar",
            role: "document"
          }, [
            (h(), G(dt(Z.value), $t({
              ref_key: "dynCmpRef",
              ref: L
            }, s.value, {
              "flow-step": O(W),
              onMount: O(H),
              onUpdateFlowStep: O(V),
              onResetFlow: O(se),
              onFocusMenu: J,
              onSelectDate: Oe[0] || (Oe[0] = (Ge) => le.$emit("select-date")),
              onDateUpdate: Oe[1] || (Oe[1] = (Ge) => le.$emit("date-update", Ge)),
              onTooltipOpen: Oe[2] || (Oe[2] = (Ge) => le.$emit("tooltip-open", Ge)),
              onTooltipClose: Oe[3] || (Oe[3] = (Ge) => le.$emit("tooltip-close", Ge)),
              onAutoApply: Oe[4] || (Oe[4] = (Ge) => le.$emit("auto-apply", Ge)),
              onRangeStart: Oe[5] || (Oe[5] = (Ge) => le.$emit("range-start", Ge)),
              onRangeEnd: Oe[6] || (Oe[6] = (Ge) => le.$emit("range-end", Ge)),
              onInvalidFixedRange: Oe[7] || (Oe[7] = (Ge) => le.$emit("invalid-fixed-range", Ge)),
              onTimeUpdate: Oe[8] || (Oe[8] = (Ge) => le.$emit("time-update")),
              onAmPmChange: Oe[9] || (Oe[9] = (Ge) => le.$emit("am-pm-change", Ge)),
              onTimePickerOpen: Oe[10] || (Oe[10] = (Ge) => le.$emit("time-picker-open", Ge)),
              onTimePickerClose: Ue,
              onRecalculatePosition: ue,
              onUpdateMonthYear: Oe[11] || (Oe[11] = (Ge) => le.$emit("update-month-year", Ge)),
              onAutoApplyInvalid: Oe[12] || (Oe[12] = (Ge) => le.$emit("auto-apply-invalid", Ge)),
              onInvalidDate: Oe[13] || (Oe[13] = (Ge) => le.$emit("invalid-date", Ge)),
              onOverlayToggle: Oe[14] || (Oe[14] = (Ge) => le.$emit("overlay-toggle", Ge)),
              "onUpdate:internalModelValue": Oe[15] || (Oe[15] = (Ge) => le.$emit("update:internal-model-value", Ge))
            }), an({ _: 2 }, [
              Le(De.value, (Ge, ma) => ({
                name: Ge,
                fn: oe((Vn) => [
                  me(le.$slots, Ge, cn(Un({ ...Vn })))
                ])
              }))
            ]), 1040, ["flow-step", "onMount", "onUpdateFlowStep", "onResetFlow"]))
          ], 512),
          le.$slots["right-sidebar"] ? (h(), b("div", ez, [
            me(le.$slots, "right-sidebar", cn(Un(N.value)))
          ])) : A("", !0),
          le.$slots["action-extra"] ? (h(), b("div", tz, [
            le.$slots["action-extra"] ? me(le.$slots, "action-extra", {
              key: 0,
              selectCurrentDate: X
            }) : A("", !0)
          ])) : A("", !0)
        ], 6),
        !le.autoApply || O(_).keepActionRow ? (h(), G(K$, $t({
          key: 2,
          "menu-mount": D.value
        }, s.value, {
          "calendar-width": x.value,
          onClosePicker: Oe[16] || (Oe[16] = (Ge) => le.$emit("close-picker")),
          onSelectDate: Oe[17] || (Oe[17] = (Ge) => le.$emit("select-date")),
          onInvalidSelect: Oe[18] || (Oe[18] = (Ge) => le.$emit("invalid-select")),
          onSelectNow: X
        }), an({ _: 2 }, [
          Le(O(xe), (Ge, ma) => ({
            name: Ge,
            fn: oe((Vn) => [
              me(le.$slots, Ge, cn(Un({ ...Vn })))
            ])
          }))
        ]), 1040, ["menu-mount", "calendar-width"])) : A("", !0)
      ], 46, GF);
    };
  }
});
var cs = /* @__PURE__ */ ((t) => (t.center = "center", t.left = "left", t.right = "right", t))(cs || {});
const nz = ({
  menuRef: t,
  menuRefInner: e,
  inputRef: n,
  pickerWrapperRef: a,
  inline: i,
  emit: r,
  props: s,
  slots: o
}) => {
  const l = K({}), c = K(!1), u = K({
    top: "0",
    left: "0"
  }), f = K(!1), m = Ls(s, "teleportCenter");
  Qe(m, () => {
    u.value = JSON.parse(JSON.stringify({})), M();
  });
  const _ = ($) => {
    if (s.teleport) {
      const J = $.getBoundingClientRect();
      return {
        left: J.left + window.scrollX,
        top: J.top + window.scrollY
      };
    }
    return { top: 0, left: 0 };
  }, T = ($, J) => {
    u.value.left = `${$ + J - l.value.width}px`;
  }, g = ($) => {
    u.value.left = `${$}px`;
  }, x = ($, J) => {
    s.position === cs.left && g($), s.position === cs.right && T($, J), s.position === cs.center && (u.value.left = `${$ + J / 2 - l.value.width / 2}px`);
  }, S = ($) => {
    const { width: J, height: N } = $.getBoundingClientRect(), { top: ue, left: xe } = s.altPosition ? s.altPosition($) : _($);
    return { top: +ue, left: +xe, width: J, height: N };
  }, D = () => {
    u.value.left = "50%", u.value.top = "50%", u.value.transform = "translate(-50%, -50%)", u.value.position = "fixed", delete u.value.opacity;
  }, L = () => {
    const $ = ln(n), { top: J, left: N, transform: ue } = s.altPosition($);
    u.value = { top: `${J}px`, left: `${N}px`, transform: ue ?? "" };
  }, M = ($ = !0) => {
    var J;
    if (!i.value.enabled) {
      if (m.value) return D();
      if (s.altPosition !== null) return L();
      if ($) {
        const N = s.teleport ? (J = e.value) == null ? void 0 : J.$el : t.value;
        N && (l.value = N.getBoundingClientRect()), r("recalculate-position");
      }
      return H();
    }
  }, E = ({ inputEl: $, left: J, width: N }) => {
    window.screen.width > 768 && !c.value && x(J, N), z($);
  }, P = ($) => {
    const { top: J, left: N, height: ue, width: xe } = S($);
    u.value.top = `${ue + J + +s.offset}px`, f.value = !1, c.value || (u.value.left = `${N + xe / 2 - l.value.width / 2}px`), E({ inputEl: $, left: N, width: xe });
  }, B = ($) => {
    const { top: J, left: N, width: ue } = S($);
    u.value.top = `${J - +s.offset - l.value.height}px`, f.value = !0, E({ inputEl: $, left: N, width: ue });
  }, z = ($) => {
    if (s.autoPosition) {
      const { left: J, width: N } = S($), { left: ue, right: xe } = l.value;
      if (!c.value) {
        if (Math.abs(ue) !== Math.abs(xe)) {
          if (ue <= 0)
            return c.value = !0, g(J);
          if (xe >= document.documentElement.clientWidth)
            return c.value = !0, T(J, N);
        }
        return x(J, N);
      }
    }
  }, W = () => {
    const $ = ln(n);
    if ($) {
      const { height: J } = l.value, { top: N, height: ue } = $.getBoundingClientRect(), xe = window.innerHeight - N - ue, De = N;
      return J <= xe ? vr.bottom : J > xe && J <= De ? vr.top : xe >= De ? vr.bottom : vr.top;
    }
    return vr.bottom;
  }, V = ($) => W() === vr.bottom ? P($) : B($), H = () => {
    const $ = ln(n);
    if ($)
      return s.autoPosition ? V($) : P($);
  }, se = function($) {
    if ($) {
      const J = $.scrollHeight > $.clientHeight, N = window.getComputedStyle($).overflowY.indexOf("hidden") !== -1;
      return J && !N;
    }
    return !0;
  }, ie = function($) {
    return !$ || $ === document.body || $.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? window : se($) ? $ : ie($.assignedSlot ? $.assignedSlot.parentNode : $.parentNode);
  }, Z = ($) => {
    if ($)
      switch (s.position) {
        case cs.left:
          return { left: 0, transform: "translateX(0)" };
        case cs.right:
          return { left: `${$.width}px`, transform: "translateX(-100%)" };
        default:
          return { left: `${$.width / 2}px`, transform: "translateX(-50%)" };
      }
    return {};
  };
  return {
    openOnTop: f,
    menuStyle: u,
    xCorrect: c,
    setMenuPosition: M,
    getScrollableParent: ie,
    shadowRender: ($, J) => {
      var N, ue, xe;
      const De = document.createElement("div"), He = (N = ln(n)) == null ? void 0 : N.getBoundingClientRect();
      De.setAttribute("id", "dp--temp-container");
      const te = (ue = a.value) != null && ue.clientWidth ? a.value : document.body;
      te.append(De);
      const ke = Z(He), Y = xr(
        $,
        {
          ...J,
          shadow: !0,
          style: { opacity: 0, position: "absolute", ...ke }
        },
        Object.fromEntries(
          Object.keys(o).filter((be) => ["right-sidebar", "left-sidebar", "top-extra", "action-extra"].includes(be)).map((be) => [be, o[be]])
        )
      );
      Am(Y, De), l.value = (xe = Y.el) == null ? void 0 : xe.getBoundingClientRect(), Am(null, De), te.removeChild(De);
    }
  };
}, zi = [
  { name: "clock-icon", use: ["time", "calendar", "shared"] },
  { name: "arrow-left", use: ["month-year", "calendar", "shared", "year-mode"] },
  { name: "arrow-right", use: ["month-year", "calendar", "shared", "year-mode"] },
  { name: "arrow-up", use: ["time", "calendar", "month-year", "shared"] },
  { name: "arrow-down", use: ["time", "calendar", "month-year", "shared"] },
  { name: "calendar-icon", use: ["month-year", "time", "calendar", "shared", "year-mode"] },
  { name: "day", use: ["calendar", "shared"] },
  { name: "month-overlay-value", use: ["calendar", "month-year", "shared"] },
  { name: "year-overlay-value", use: ["calendar", "month-year", "shared", "year-mode"] },
  { name: "year-overlay", use: ["month-year", "shared"] },
  { name: "month-overlay", use: ["month-year", "shared"] },
  { name: "month-overlay-header", use: ["month-year", "shared"] },
  { name: "year-overlay-header", use: ["month-year", "shared"] },
  { name: "hours-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "hours-overlay-header", use: ["calendar", "time", "shared"] },
  { name: "minutes-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "minutes-overlay-header", use: ["calendar", "time", "shared"] },
  { name: "seconds-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "seconds-overlay-header", use: ["calendar", "time", "shared"] },
  { name: "hours", use: ["calendar", "time", "shared"] },
  { name: "minutes", use: ["calendar", "time", "shared"] },
  { name: "month", use: ["calendar", "month-year", "shared"] },
  { name: "year", use: ["calendar", "month-year", "shared", "year-mode"] },
  { name: "action-buttons", use: ["action"] },
  { name: "action-preview", use: ["action"] },
  { name: "calendar-header", use: ["calendar", "shared"] },
  { name: "marker-tooltip", use: ["calendar", "shared"] },
  { name: "action-extra", use: ["menu"] },
  { name: "time-picker-overlay", use: ["calendar", "time", "shared"] },
  { name: "am-pm-button", use: ["calendar", "time", "shared"] },
  { name: "left-sidebar", use: ["menu"] },
  { name: "right-sidebar", use: ["menu"] },
  { name: "month-year", use: ["month-year", "shared"] },
  { name: "time-picker", use: ["menu", "shared"] },
  { name: "action-row", use: ["action"] },
  { name: "marker", use: ["calendar", "shared"] },
  { name: "quarter", use: ["shared"] },
  { name: "top-extra", use: ["shared", "month-year"] },
  { name: "tp-inline-arrow-up", use: ["shared", "time"] },
  { name: "tp-inline-arrow-down", use: ["shared", "time"] }
], az = [{ name: "trigger" }, { name: "input-icon" }, { name: "clear-icon" }, { name: "dp-input" }], iz = {
  all: () => zi,
  monthYear: () => zi.filter((t) => t.use.includes("month-year")),
  input: () => az,
  timePicker: () => zi.filter((t) => t.use.includes("time")),
  action: () => zi.filter((t) => t.use.includes("action")),
  calendar: () => zi.filter((t) => t.use.includes("calendar")),
  menu: () => zi.filter((t) => t.use.includes("menu")),
  shared: () => zi.filter((t) => t.use.includes("shared")),
  yearMode: () => zi.filter((t) => t.use.includes("year-mode"))
}, ua = (t, e, n) => {
  const a = [];
  return iz[e]().forEach((i) => {
    t[i.name] && a.push(i.name);
  }), n != null && n.length && n.forEach((i) => {
    i.slot && a.push(i.slot);
  }), a;
}, Fl = (t) => {
  const e = I(() => (a) => t.value ? a ? t.value.open : t.value.close : ""), n = I(() => (a) => t.value ? a ? t.value.menuAppearTop : t.value.menuAppearBottom : "");
  return { transitionName: e, showTransition: !!t.value, menuTransition: n };
}, zl = (t, e, n) => {
  const { defaultedRange: a, defaultedTz: i } = jt(t), r = Ie(ea(Ie(), i.value.timezone)), s = K([{ month: ht(r), year: at(r) }]), o = (m) => {
    const _ = {
      hours: ki(r),
      minutes: nr(r),
      seconds: 0
    };
    return a.value.enabled ? [_[m], _[m]] : _[m];
  }, l = Ma({
    hours: o("hours"),
    minutes: o("minutes"),
    seconds: o("seconds")
  });
  Qe(
    a,
    (m, _) => {
      m.enabled !== _.enabled && (l.hours = o("hours"), l.minutes = o("minutes"), l.seconds = o("seconds"));
    },
    { deep: !0 }
  );
  const c = I({
    get: () => t.internalModelValue,
    set: (m) => {
      !t.readonly && !t.disabled && e("update:internal-model-value", m);
    }
  }), u = I(
    () => (m) => s.value[m] ? s.value[m].month : 0
  ), f = I(
    () => (m) => s.value[m] ? s.value[m].year : 0
  );
  return Qe(
    c,
    (m, _) => {
      n && JSON.stringify(m ?? {}) !== JSON.stringify(_ ?? {}) && n();
    },
    { deep: !0 }
  ), {
    calendars: s,
    time: l,
    modelValue: c,
    month: u,
    year: f,
    today: r
  };
}, rz = (t, e) => {
  const {
    defaultedMultiCalendars: n,
    defaultedMultiDates: a,
    defaultedUI: i,
    defaultedHighlight: r,
    defaultedTz: s,
    propDates: o,
    defaultedRange: l
  } = jt(e), { isDisabled: c } = lr(e), u = K(null), f = K(ea(/* @__PURE__ */ new Date(), s.value.timezone)), m = (Y) => {
    !Y.current && e.hideOffsetDates || (u.value = Y.value);
  }, _ = () => {
    u.value = null;
  }, T = (Y) => Array.isArray(t.value) && l.value.enabled && t.value[0] && u.value ? Y ? Kt(u.value, t.value[0]) : Vt(u.value, t.value[0]) : !0, g = (Y, be) => {
    const Ne = () => t.value ? be ? t.value[0] || null : t.value[1] : null, ee = t.value && Array.isArray(t.value) ? Ne() : null;
    return ft(Ie(Y.value), ee);
  }, x = (Y) => {
    const be = Array.isArray(t.value) ? t.value[0] : null;
    return Y ? !Vt(u.value ?? null, be) : !0;
  }, S = (Y, be = !0) => (l.value.enabled || e.weekPicker) && Array.isArray(t.value) && t.value.length === 2 ? e.hideOffsetDates && !Y.current ? !1 : ft(Ie(Y.value), t.value[be ? 0 : 1]) : l.value.enabled ? g(Y, be) && x(be) || ft(Y.value, Array.isArray(t.value) ? t.value[0] : null) && T(be) : !1, D = (Y, be) => {
    if (Array.isArray(t.value) && t.value[0] && t.value.length === 1) {
      const Ne = ft(Y.value, u.value);
      return be ? Kt(t.value[0], Y.value) && Ne : Vt(t.value[0], Y.value) && Ne;
    }
    return !1;
  }, L = (Y) => !t.value || e.hideOffsetDates && !Y.current ? !1 : l.value.enabled ? e.modelAuto && Array.isArray(t.value) ? ft(Y.value, t.value[0] ? t.value[0] : f.value) : !1 : a.value.enabled && Array.isArray(t.value) ? t.value.some((be) => ft(be, Y.value)) : ft(Y.value, t.value ? t.value : f.value), M = (Y) => {
    if (l.value.autoRange || e.weekPicker) {
      if (u.value) {
        if (e.hideOffsetDates && !Y.current) return !1;
        const be = Da(u.value, +l.value.autoRange), Ne = mi(Ie(u.value), e.weekStart);
        return e.weekPicker ? ft(Ne[1], Ie(Y.value)) : ft(be, Ie(Y.value));
      }
      return !1;
    }
    return !1;
  }, E = (Y) => {
    if (l.value.autoRange || e.weekPicker) {
      if (u.value) {
        const be = Da(u.value, +l.value.autoRange);
        if (e.hideOffsetDates && !Y.current) return !1;
        const Ne = mi(Ie(u.value), e.weekStart);
        return e.weekPicker ? Kt(Y.value, Ne[0]) && Vt(Y.value, Ne[1]) : Kt(Y.value, u.value) && Vt(Y.value, be);
      }
      return !1;
    }
    return !1;
  }, P = (Y) => {
    if (l.value.autoRange || e.weekPicker) {
      if (u.value) {
        if (e.hideOffsetDates && !Y.current) return !1;
        const be = mi(Ie(u.value), e.weekStart);
        return e.weekPicker ? ft(be[0], Y.value) : ft(u.value, Y.value);
      }
      return !1;
    }
    return !1;
  }, B = (Y) => ed(t.value, u.value, Y.value), z = () => e.modelAuto && Array.isArray(e.internalModelValue) ? !!e.internalModelValue[0] : !1, W = () => e.modelAuto ? Gv(e.internalModelValue) : !0, V = (Y) => {
    if (e.weekPicker) return !1;
    const be = l.value.enabled ? !S(Y) && !S(Y, !1) : !0;
    return !c(Y.value) && !L(Y) && !(!Y.current && e.hideOffsetDates) && be;
  }, H = (Y) => l.value.enabled ? e.modelAuto ? z() && L(Y) : !1 : L(Y), se = (Y) => r.value ? x$(Y.value, o.value.highlight) : !1, ie = (Y) => {
    const be = c(Y.value);
    return be && (typeof r.value == "function" ? !r.value(Y.value, be) : !r.value.options.highlightDisabled);
  }, Z = (Y) => {
    var be;
    return typeof r.value == "function" ? r.value(Y.value) : (be = r.value.weekdays) == null ? void 0 : be.includes(Y.value.getDay());
  }, $ = (Y) => (l.value.enabled || e.weekPicker) && (!(n.value.count > 0) || Y.current) && W() && !(!Y.current && e.hideOffsetDates) && !L(Y) ? B(Y) : !1, J = (Y) => {
    const { isRangeStart: be, isRangeEnd: Ne } = De(Y), ee = l.value.enabled ? be || Ne : !1;
    return {
      dp__cell_offset: !Y.current,
      dp__pointer: !e.disabled && !(!Y.current && e.hideOffsetDates) && !c(Y.value),
      dp__cell_disabled: c(Y.value),
      dp__cell_highlight: !ie(Y) && (se(Y) || Z(Y)) && !H(Y) && !ee && !P(Y) && !($(Y) && e.weekPicker) && !Ne,
      dp__cell_highlight_active: !ie(Y) && (se(Y) || Z(Y)) && H(Y),
      dp__today: !e.noToday && ft(Y.value, f.value) && Y.current,
      "dp--past": Vt(Y.value, f.value),
      "dp--future": Kt(Y.value, f.value)
    };
  }, N = (Y) => ({
    dp__active_date: H(Y),
    dp__date_hover: V(Y)
  }), ue = (Y) => {
    if (t.value && !Array.isArray(t.value)) {
      const be = mi(t.value, e.weekStart);
      return {
        ...te(Y),
        dp__range_start: ft(be[0], Y.value),
        dp__range_end: ft(be[1], Y.value),
        dp__range_between_week: Kt(Y.value, be[0]) && Vt(Y.value, be[1])
      };
    }
    return {
      ...te(Y)
    };
  }, xe = (Y) => {
    if (t.value && Array.isArray(t.value)) {
      const be = mi(t.value[0], e.weekStart), Ne = t.value[1] ? mi(t.value[1], e.weekStart) : [];
      return {
        ...te(Y),
        dp__range_start: ft(be[0], Y.value) || ft(Ne[0], Y.value),
        dp__range_end: ft(be[1], Y.value) || ft(Ne[1], Y.value),
        dp__range_between_week: Kt(Y.value, be[0]) && Vt(Y.value, be[1]) || Kt(Y.value, Ne[0]) && Vt(Y.value, Ne[1]),
        dp__range_between: Kt(Y.value, be[1]) && Vt(Y.value, Ne[0])
      };
    }
    return {
      ...te(Y)
    };
  }, De = (Y) => {
    const be = n.value.count > 0 ? Y.current && S(Y) && W() : S(Y) && W(), Ne = n.value.count > 0 ? Y.current && S(Y, !1) && W() : S(Y, !1) && W();
    return { isRangeStart: be, isRangeEnd: Ne };
  }, He = (Y) => {
    const { isRangeStart: be, isRangeEnd: Ne } = De(Y);
    return {
      dp__range_start: be,
      dp__range_end: Ne,
      dp__range_between: $(Y),
      dp__date_hover: ft(Y.value, u.value) && !be && !Ne && !e.weekPicker,
      dp__date_hover_start: D(Y, !0),
      dp__date_hover_end: D(Y, !1)
    };
  }, te = (Y) => ({
    ...He(Y),
    dp__cell_auto_range: E(Y),
    dp__cell_auto_range_start: P(Y),
    dp__cell_auto_range_end: M(Y)
  }), ke = (Y) => l.value.enabled ? l.value.autoRange ? te(Y) : e.modelAuto ? { ...N(Y), ...He(Y) } : e.weekPicker ? xe(Y) : He(Y) : e.weekPicker ? ue(Y) : N(Y);
  return {
    setHoverDate: m,
    clearHoverDate: _,
    getDayClassData: (Y) => e.hideOffsetDates && !Y.current ? {} : {
      ...J(Y),
      ...ke(Y),
      [e.dayClass ? e.dayClass(Y.value, e.internalModelValue) : ""]: !0,
      [e.calendarCellClassName]: !!e.calendarCellClassName,
      ...i.value.calendarCell ?? {}
    }
  };
}, lr = (t) => {
  const { defaultedFilters: e, defaultedRange: n, propDates: a, defaultedMultiDates: i } = jt(t), r = (Z) => a.value.disabledDates ? typeof a.value.disabledDates == "function" ? a.value.disabledDates(Ie(Z)) : !!lu(Z, a.value.disabledDates) : !1, s = (Z) => a.value.maxDate ? t.yearPicker ? at(Z) > at(a.value.maxDate) : Kt(Z, a.value.maxDate) : !1, o = (Z) => a.value.minDate ? t.yearPicker ? at(Z) < at(a.value.minDate) : Vt(Z, a.value.minDate) : !1, l = (Z) => {
    const $ = s(Z), J = o(Z), N = r(Z), ue = e.value.months.map((ke) => +ke).includes(ht(Z)), xe = t.disabledWeekDays.length ? t.disabledWeekDays.some((ke) => +ke === cN(Z)) : !1, De = _(Z), He = at(Z), te = He < +t.yearRange[0] || He > +t.yearRange[1];
    return !($ || J || N || ue || te || xe || De);
  }, c = (Z, $) => Vt(...Xi(a.value.minDate, Z, $)) || ft(...Xi(a.value.minDate, Z, $)), u = (Z, $) => Kt(...Xi(a.value.maxDate, Z, $)) || ft(...Xi(a.value.maxDate, Z, $)), f = (Z, $, J) => {
    let N = !1;
    return a.value.maxDate && J && u(Z, $) && (N = !0), a.value.minDate && !J && c(Z, $) && (N = !0), N;
  }, m = (Z, $, J, N) => {
    let ue = !1;
    return N ? a.value.minDate && a.value.maxDate ? ue = f(Z, $, J) : (a.value.minDate && c(Z, $) || a.value.maxDate && u(Z, $)) && (ue = !0) : ue = !0, ue;
  }, _ = (Z) => Array.isArray(a.value.allowedDates) && !a.value.allowedDates.length ? !0 : a.value.allowedDates ? !lu(Z, a.value.allowedDates) : !1, T = (Z) => !l(Z), g = (Z) => n.value.noDisabledRange ? !Iv({ start: Z[0], end: Z[1] }).some(($) => T($)) : !0, x = (Z) => {
    if (Z) {
      const $ = at(Z);
      return $ >= +t.yearRange[0] && $ <= t.yearRange[1];
    }
    return !0;
  }, S = (Z, $) => !!(Array.isArray(Z) && Z[$] && (n.value.maxRange || n.value.minRange) && x(Z[$])), D = (Z, $, J = 0) => {
    if (S($, J) && x(Z)) {
      const N = Lv(Z, $[J]), ue = Jv($[J], Z), xe = ue.length === 1 ? 0 : ue.filter((He) => T(He)).length, De = Math.abs(N) - (n.value.minMaxRawRange ? 0 : xe);
      if (n.value.minRange && n.value.maxRange)
        return De >= +n.value.minRange && De <= +n.value.maxRange;
      if (n.value.minRange) return De >= +n.value.minRange;
      if (n.value.maxRange) return De <= +n.value.maxRange;
    }
    return !0;
  }, L = () => !t.enableTimePicker || t.monthPicker || t.yearPicker || t.ignoreTimeValidation, M = (Z) => Array.isArray(Z) ? [Z[0] ? p0(Z[0]) : null, Z[1] ? p0(Z[1]) : null] : p0(Z), E = (Z, $, J) => Z.find(
    (N) => +N.hours === ki($) && N.minutes === "*" ? !0 : +N.minutes === nr($) && +N.hours === ki($)
  ) && J, P = (Z, $, J) => {
    const [N, ue] = Z, [xe, De] = $;
    return !E(N, xe, J) && !E(ue, De, J) && J;
  }, B = (Z, $) => {
    const J = Array.isArray($) ? $ : [$];
    return Array.isArray(t.disabledTimes) ? Array.isArray(t.disabledTimes[0]) ? P(t.disabledTimes, J, Z) : !J.some((N) => E(t.disabledTimes, N, Z)) : Z;
  }, z = (Z, $) => {
    const J = Array.isArray($) ? [Er($[0]), $[1] ? Er($[1]) : void 0] : Er($), N = !t.disabledTimes(J);
    return Z && N;
  }, W = (Z, $) => t.disabledTimes ? Array.isArray(t.disabledTimes) ? B($, Z) : z($, Z) : $, V = (Z) => {
    let $ = !0;
    if (!Z || L()) return !0;
    const J = !a.value.minDate && !a.value.maxDate ? M(Z) : Z;
    return (t.maxTime || a.value.maxDate) && ($ = P1(
      t.maxTime,
      a.value.maxDate,
      "max",
      pn(J),
      $
    )), (t.minTime || a.value.minDate) && ($ = P1(
      t.minTime,
      a.value.minDate,
      "min",
      pn(J),
      $
    )), W(Z, $);
  }, H = (Z) => {
    if (!t.monthPicker) return !0;
    let $ = !0;
    const J = Ie(Ia(Z));
    if (a.value.minDate && a.value.maxDate) {
      const N = Ie(Ia(a.value.minDate)), ue = Ie(Ia(a.value.maxDate));
      return Kt(J, N) && Vt(J, ue) || ft(J, N) || ft(J, ue);
    }
    if (a.value.minDate) {
      const N = Ie(Ia(a.value.minDate));
      $ = Kt(J, N) || ft(J, N);
    }
    if (a.value.maxDate) {
      const N = Ie(Ia(a.value.maxDate));
      $ = Vt(J, N) || ft(J, N);
    }
    return $;
  }, se = I(() => (Z) => !t.enableTimePicker || t.ignoreTimeValidation ? !0 : V(Z)), ie = I(() => (Z) => t.monthPicker ? Array.isArray(Z) && (n.value.enabled || i.value.enabled) ? !Z.filter(($) => !H($)).length : H(Z) : !0);
  return {
    isDisabled: T,
    validateDate: l,
    validateMonthYearInRange: m,
    isDateRangeAllowed: g,
    checkMinMaxRange: D,
    isValidTime: V,
    isTimeValid: se,
    isMonthValid: ie
  };
}, id = () => {
  const t = I(() => (a, i) => a == null ? void 0 : a.includes(i)), e = I(() => (a, i) => a.count ? a.solo ? !0 : i === 0 : !0), n = I(() => (a, i) => a.count ? a.solo ? !0 : i === a.count - 1 : !0);
  return { hideNavigationButtons: t, showLeftIcon: e, showRightIcon: n };
}, sz = (t, e, n) => {
  const a = K(0), i = Ma({
    [Ar.timePicker]: !t.enableTimePicker || t.timePicker || t.monthPicker,
    [Ar.calendar]: !1,
    [Ar.header]: !1
  }), r = I(() => t.monthPicker || t.timePicker), s = (f) => {
    var m;
    if ((m = t.flow) != null && m.length) {
      if (!f && r.value) return u();
      i[f] = !0, Object.keys(i).filter((_) => !i[_]).length || u();
    }
  }, o = () => {
    var f, m;
    (f = t.flow) != null && f.length && a.value !== -1 && (a.value += 1, e("flow-step", a.value), u()), ((m = t.flow) == null ? void 0 : m.length) === a.value && kn().then(() => l());
  }, l = () => {
    a.value = -1;
  }, c = (f, m, ..._) => {
    var T, g;
    t.flow[a.value] === f && n.value && ((g = (T = n.value)[m]) == null || g.call(T, ..._));
  }, u = (f = 0) => {
    f && (a.value += f), c(An.month, "toggleMonthPicker", !0), c(An.year, "toggleYearPicker", !0), c(An.calendar, "toggleTimePicker", !1, !0), c(An.time, "toggleTimePicker", !0, !0);
    const m = t.flow[a.value];
    (m === An.hours || m === An.minutes || m === An.seconds) && c(m, "toggleTimePicker", !0, !0, m);
  };
  return { childMount: s, updateFlowStep: o, resetFlow: l, handleFlow: u, flowStep: a };
}, oz = {
  key: 1,
  class: "dp__input_wrap"
}, lz = ["id", "name", "inputmode", "placeholder", "disabled", "readonly", "required", "value", "autocomplete", "aria-label", "aria-disabled", "aria-invalid"], cz = {
  key: 2,
  class: "dp__clear_icon"
}, uz = /* @__PURE__ */ Ce({
  compatConfig: {
    MODE: 3
  },
  __name: "DatepickerInput",
  props: {
    isMenuOpen: { type: Boolean, default: !1 },
    inputValue: { type: String, default: "" },
    ...td
  },
  emits: [
    "clear",
    "open",
    "update:input-value",
    "set-input-date",
    "close",
    "select-date",
    "set-empty-date",
    "toggle",
    "focus-prev",
    "focus",
    "blur",
    "real-blur"
  ],
  setup(t, { expose: e, emit: n }) {
    const a = n, i = t, {
      defaultedTextInput: r,
      defaultedAriaLabels: s,
      defaultedInline: o,
      defaultedConfig: l,
      defaultedRange: c,
      defaultedMultiDates: u,
      defaultedUI: f,
      getDefaultPattern: m,
      getDefaultStartTime: _
    } = jt(i), { checkMinMaxRange: T } = lr(i), g = K(), x = K(null), S = K(!1), D = K(!1), L = I(
      () => ({
        dp__pointer: !i.disabled && !i.readonly && !r.value.enabled,
        dp__disabled: i.disabled,
        dp__input_readonly: !r.value.enabled,
        dp__input: !0,
        dp__input_icon_pad: !i.hideInputIcon,
        dp__input_valid: !!i.state,
        dp__input_invalid: i.state === !1,
        dp__input_focus: S.value || i.isMenuOpen,
        dp__input_reg: !r.value.enabled,
        [i.inputClassName]: !!i.inputClassName,
        ...f.value.input ?? {}
      })
    ), M = () => {
      a("set-input-date", null), i.clearable && i.autoApply && (a("set-empty-date"), g.value = null);
    }, E = (N) => {
      const ue = _();
      return w$(
        N,
        r.value.format ?? m(),
        ue ?? ey({}, i.enableSeconds),
        i.inputValue,
        D.value,
        i.formatLocale
      );
    }, P = (N) => {
      const { rangeSeparator: ue } = r.value, [xe, De] = N.split(`${ue}`);
      if (xe) {
        const He = E(xe.trim()), te = De ? E(De.trim()) : null;
        if (Os(He, te)) return;
        const ke = He && te ? [He, te] : [He];
        T(te, ke, 0) && (g.value = He ? ke : null);
      }
    }, B = () => {
      D.value = !0;
    }, z = (N) => {
      if (c.value.enabled)
        P(N);
      else if (u.value.enabled) {
        const ue = N.split(";");
        g.value = ue.map((xe) => E(xe.trim())).filter((xe) => xe);
      } else
        g.value = E(N);
    }, W = (N) => {
      var ue;
      const xe = typeof N == "string" ? N : (ue = N.target) == null ? void 0 : ue.value;
      xe !== "" ? (r.value.openMenu && !i.isMenuOpen && a("open"), z(xe), a("set-input-date", g.value)) : M(), D.value = !1, a("update:input-value", xe);
    }, V = (N) => {
      r.value.enabled ? (z(N.target.value), r.value.enterSubmit && ih(g.value) && i.inputValue !== "" ? (a("set-input-date", g.value, !0), g.value = null) : r.value.enterSubmit && i.inputValue === "" && (g.value = null, a("clear"))) : ie(N);
    }, H = (N) => {
      r.value.enabled && r.value.tabSubmit && z(N.target.value), r.value.tabSubmit && ih(g.value) && i.inputValue !== "" ? (a("set-input-date", g.value, !0, !0), g.value = null) : r.value.tabSubmit && i.inputValue === "" && (g.value = null, a("clear", !0));
    }, se = () => {
      S.value = !0, a("focus"), kn().then(() => {
        var N;
        r.value.enabled && r.value.selectOnFocus && ((N = x.value) == null || N.select());
      });
    }, ie = (N) => {
      N.preventDefault(), Qi(N, l.value, !0), r.value.enabled && r.value.openMenu && !o.value.input && !i.isMenuOpen ? a("open") : r.value.enabled || a("toggle");
    }, Z = () => {
      a("real-blur"), S.value = !1, (!i.isMenuOpen || o.value.enabled && o.value.input) && a("blur"), i.autoApply && r.value.enabled && g.value && !i.isMenuOpen && (a("set-input-date", g.value), a("select-date"), g.value = null);
    }, $ = (N) => {
      Qi(N, l.value, !0), a("clear");
    }, J = (N) => {
      if (N.key === "Tab" && H(N), N.key === "Enter" && V(N), !r.value.enabled) {
        if (N.code === "Tab") return;
        N.preventDefault();
      }
    };
    return e({
      focusInput: () => {
        var N;
        (N = x.value) == null || N.focus({ preventScroll: !0 });
      },
      setParsedDate: (N) => {
        g.value = N;
      }
    }), (N, ue) => {
      var xe;
      return h(), b("div", { onClick: ie }, [
        N.$slots.trigger && !N.$slots["dp-input"] && !O(o).enabled ? me(N.$slots, "trigger", { key: 0 }) : A("", !0),
        !N.$slots.trigger && (!O(o).enabled || O(o).input) ? (h(), b("div", oz, [
          N.$slots["dp-input"] && !N.$slots.trigger && (!O(o).enabled || O(o).enabled && O(o).input) ? me(N.$slots, "dp-input", {
            key: 0,
            value: t.inputValue,
            isMenuOpen: t.isMenuOpen,
            onInput: W,
            onEnter: V,
            onTab: H,
            onClear: $,
            onBlur: Z,
            onKeypress: J,
            onPaste: B,
            onFocus: se,
            openMenu: () => N.$emit("open"),
            closeMenu: () => N.$emit("close"),
            toggleMenu: () => N.$emit("toggle")
          }) : A("", !0),
          N.$slots["dp-input"] ? A("", !0) : (h(), b("input", {
            key: 1,
            id: N.uid ? `dp-input-${N.uid}` : void 0,
            ref_key: "inputRef",
            ref: x,
            "data-test": "dp-input",
            name: N.name,
            class: re(L.value),
            inputmode: O(r).enabled ? "text" : "none",
            placeholder: N.placeholder,
            disabled: N.disabled,
            readonly: N.readonly,
            required: N.required,
            value: t.inputValue,
            autocomplete: N.autocomplete,
            "aria-label": (xe = O(s)) == null ? void 0 : xe.input,
            "aria-disabled": N.disabled || void 0,
            "aria-invalid": N.state === !1 ? !0 : void 0,
            onInput: W,
            onBlur: Z,
            onFocus: se,
            onKeypress: J,
            onKeydown: J,
            onPaste: B
          }, null, 42, lz)),
          k("div", {
            onClick: ue[2] || (ue[2] = (De) => a("toggle"))
          }, [
            N.$slots["input-icon"] && !N.hideInputIcon ? (h(), b("span", {
              key: 0,
              class: "dp__input_icon",
              onClick: ue[0] || (ue[0] = (De) => a("toggle"))
            }, [
              me(N.$slots, "input-icon")
            ])) : A("", !0),
            !N.$slots["input-icon"] && !N.hideInputIcon && !N.$slots["dp-input"] ? (h(), G(O(ro), {
              key: 1,
              class: "dp__input_icon dp__input_icons",
              onClick: ue[1] || (ue[1] = (De) => a("toggle"))
            })) : A("", !0)
          ]),
          N.$slots["clear-icon"] && t.inputValue && N.clearable && !N.disabled && !N.readonly ? (h(), b("span", cz, [
            me(N.$slots, "clear-icon", { clear: $ })
          ])) : A("", !0),
          N.clearable && !N.$slots["clear-icon"] && t.inputValue && !N.disabled && !N.readonly ? (h(), G(O(qv), {
            key: 3,
            class: "dp__clear_icon dp__input_icons",
            "data-test": "clear-icon",
            onClick: ue[3] || (ue[3] = da((De) => $(De), ["prevent"]))
          })) : A("", !0)
        ])) : A("", !0)
      ]);
    };
  }
}), dz = typeof window < "u" ? window : void 0, _0 = () => {
}, hz = (t) => Jb() ? (e2(t), !0) : !1, fz = (t, e, n, a) => {
  if (!t) return _0;
  let i = _0;
  const r = Qe(
    () => O(t),
    (o) => {
      i(), o && (o.addEventListener(e, n, a), i = () => {
        o.removeEventListener(e, n, a), i = _0;
      });
    },
    { immediate: !0, flush: "post" }
  ), s = () => {
    r(), i();
  };
  return hz(s), s;
}, pz = (t, e, n, a = {}) => {
  const { window: i = dz, event: r = "pointerdown" } = a;
  return i ? fz(i, r, (s) => {
    const o = ln(t), l = ln(e);
    !o || !l || o === s.target || s.composedPath().includes(o) || s.composedPath().includes(l) || n(s);
  }, { passive: !0 }) : void 0;
}, mz = /* @__PURE__ */ Ce({
  compatConfig: {
    MODE: 3
  },
  __name: "VueDatePicker",
  props: {
    ...td
  },
  emits: [
    "update:model-value",
    "update:model-timezone-value",
    "text-submit",
    "closed",
    "cleared",
    "open",
    "focus",
    "blur",
    "internal-model-change",
    "recalculate-position",
    "flow-step",
    "update-month-year",
    "invalid-select",
    "invalid-fixed-range",
    "tooltip-open",
    "tooltip-close",
    "time-picker-open",
    "time-picker-close",
    "am-pm-change",
    "range-start",
    "range-end",
    "date-update",
    "invalid-date",
    "overlay-toggle"
  ],
  setup(t, { expose: e, emit: n }) {
    const a = n, i = t, r = Di(), s = K(!1), o = Ls(i, "modelValue"), l = Ls(i, "timezone"), c = K(null), u = K(null), f = K(null), m = K(!1), _ = K(null), T = K(!1), g = K(!1), x = K(!1), S = K(!1), { setMenuFocused: D, setShiftKey: L } = ry(), { clearArrowNav: M } = or(), { validateDate: E, isValidTime: P } = lr(i), {
      defaultedTransitions: B,
      defaultedTextInput: z,
      defaultedInline: W,
      defaultedConfig: V,
      defaultedRange: H,
      defaultedMultiDates: se
    } = jt(i), { menuTransition: ie, showTransition: Z } = Fl(B);
    st(() => {
      be(i.modelValue), kn().then(() => {
        if (!W.value.enabled) {
          const _e = He(_.value);
          _e == null || _e.addEventListener("scroll", Ee), window == null || window.addEventListener("resize", Te);
        }
      }), W.value.enabled && (s.value = !0), window == null || window.addEventListener("keyup", nt), window == null || window.addEventListener("keydown", le);
    }), Ks(() => {
      if (!W.value.enabled) {
        const _e = He(_.value);
        _e == null || _e.removeEventListener("scroll", Ee), window == null || window.removeEventListener("resize", Te);
      }
      window == null || window.removeEventListener("keyup", nt), window == null || window.removeEventListener("keydown", le);
    });
    const $ = ua(r, "all", i.presetDates), J = ua(r, "input");
    Qe(
      [o, l],
      () => {
        be(o.value);
      },
      { deep: !0 }
    );
    const { openOnTop: N, menuStyle: ue, xCorrect: xe, setMenuPosition: De, getScrollableParent: He, shadowRender: te } = nz({
      menuRef: c,
      menuRefInner: u,
      inputRef: f,
      pickerWrapperRef: _,
      inline: W,
      emit: a,
      props: i,
      slots: r
    }), {
      inputValue: ke,
      internalModelValue: Y,
      parseExternalModelValue: be,
      emitModelValue: Ne,
      formatInputValue: ee,
      checkBeforeEmit: Ue
    } = W$(a, i, m), tt = I(
      () => ({
        dp__main: !0,
        dp__theme_dark: i.dark,
        dp__theme_light: !i.dark,
        dp__flex_display: W.value.enabled,
        "dp--flex-display-collapsed": x.value,
        dp__flex_display_with_input: W.value.input
      })
    ), we = I(() => i.dark ? "dp__theme_dark" : "dp__theme_light"), Je = I(() => i.teleport ? {
      to: typeof i.teleport == "boolean" ? "body" : i.teleport,
      disabled: !i.teleport || W.value.enabled
    } : {}), X = I(() => ({ class: "dp__outer_menu_wrap" })), Ae = I(() => W.value.enabled && (i.timePicker || i.monthPicker || i.yearPicker || i.quarterPicker)), fe = () => {
      var _e, Be;
      return (Be = (_e = f.value) == null ? void 0 : _e.$el) == null ? void 0 : Be.getBoundingClientRect();
    }, Ee = () => {
      s.value && (V.value.closeOnScroll ? hn() : De());
    }, Te = () => {
      var _e;
      s.value && De();
      const Be = (_e = u.value) == null ? void 0 : _e.$el.getBoundingClientRect().width;
      x.value = document.body.offsetWidth <= Be;
    }, nt = (_e) => {
      _e.key === "Tab" && !W.value.enabled && !i.teleport && V.value.tabOutClosesMenu && (_.value.contains(document.activeElement) || hn()), g.value = _e.shiftKey;
    }, le = (_e) => {
      g.value = _e.shiftKey;
    }, Oe = () => {
      !i.disabled && !i.readonly && (te($1, i), De(!1), s.value = !0, s.value && a("open"), s.value || ci(), be(i.modelValue));
    }, Re = () => {
      var _e;
      ke.value = "", ci(), (_e = f.value) == null || _e.setParsedDate(null), a("update:model-value", null), a("update:model-timezone-value", null), a("cleared"), V.value.closeOnClearValue && hn();
    }, ct = () => {
      const _e = Y.value;
      return !_e || !Array.isArray(_e) && E(_e) ? !0 : Array.isArray(_e) ? se.value.enabled || _e.length === 2 && E(_e[0]) && E(_e[1]) ? !0 : H.value.partialRange && !i.timePicker ? E(_e[0]) : !1 : !1;
    }, Ot = () => {
      Ue() && ct() ? (Ne(), hn()) : a("invalid-select", Y.value);
    }, Ge = (_e) => {
      ma(), Ne(), V.value.closeOnAutoApply && !_e && hn();
    }, ma = () => {
      f.value && z.value.enabled && f.value.setParsedDate(Y.value);
    }, Vn = (_e = !1) => {
      i.autoApply && P(Y.value) && ct() && (H.value.enabled && Array.isArray(Y.value) ? (H.value.partialRange || Y.value.length === 2) && Ge(_e) : Ge(_e));
    }, ci = () => {
      z.value.enabled || (Y.value = null);
    }, hn = () => {
      W.value.enabled || (s.value && (s.value = !1, xe.value = !1, D(!1), L(!1), M(), a("closed"), ke.value && be(o.value)), ci(), a("blur"));
    }, ui = (_e, Be, Ye = !1) => {
      if (!_e) {
        Y.value = null;
        return;
      }
      const _n = Array.isArray(_e) ? !_e.some((di) => !E(di)) : E(_e), qn = P(_e);
      _n && qn && (S.value = !0, Y.value = _e, Be && (T.value = Ye, Ot(), a("text-submit")), kn().then(() => {
        S.value = !1;
      }));
    }, qr = () => {
      i.autoApply && P(Y.value) && Ne(), ma();
    }, dr = () => s.value ? hn() : Oe(), Wr = (_e) => {
      Y.value = _e;
    }, bt = () => {
      z.value.enabled && (m.value = !0, ee()), a("focus");
    }, bo = () => {
      if (z.value.enabled && (m.value = !1, be(i.modelValue), T.value)) {
        const _e = _$(_.value, g.value);
        _e == null || _e.focus();
      }
      a("blur");
    }, Oi = (_e) => {
      u.value && u.value.updateMonthYear(0, {
        month: I1(_e.month),
        year: I1(_e.year)
      });
    }, vo = (_e) => {
      be(_e ?? i.modelValue);
    }, yo = (_e, Be) => {
      var Ye;
      (Ye = u.value) == null || Ye.switchView(_e, Be);
    }, de = (_e) => V.value.onClickOutside ? V.value.onClickOutside(_e) : hn(), Pe = (_e = 0) => {
      var Be;
      (Be = u.value) == null || Be.handleFlow(_e);
    };
    return pz(c, f, () => de(ct)), e({
      closeMenu: hn,
      selectDate: Ot,
      clearValue: Re,
      openMenu: Oe,
      onScroll: Ee,
      formatInputValue: ee,
      // exposed for testing purposes
      updateInternalModelValue: Wr,
      // modify internal modelValue
      setMonthYear: Oi,
      parseModel: vo,
      switchView: yo,
      toggleMenu: dr,
      handleFlow: Pe
    }), (_e, Be) => (h(), b("div", {
      ref_key: "pickerWrapperRef",
      ref: _,
      class: re(tt.value),
      "data-datepicker-instance": ""
    }, [
      Q(uz, $t({
        ref_key: "inputRef",
        ref: f,
        "input-value": O(ke),
        "onUpdate:inputValue": Be[0] || (Be[0] = (Ye) => Sm(ke) ? ke.value = Ye : null),
        "is-menu-open": s.value
      }, _e.$props, {
        onClear: Re,
        onOpen: Oe,
        onSetInputDate: ui,
        onSetEmptyDate: O(Ne),
        onSelectDate: Ot,
        onToggle: dr,
        onClose: hn,
        onFocus: bt,
        onBlur: bo,
        onRealBlur: Be[1] || (Be[1] = (Ye) => m.value = !1)
      }), an({ _: 2 }, [
        Le(O(J), (Ye, _n) => ({
          name: Ye,
          fn: oe((qn) => [
            me(_e.$slots, Ye, cn(Un(qn)))
          ])
        }))
      ]), 1040, ["input-value", "is-menu-open", "onSetEmptyDate"]),
      (h(), G(dt(_e.teleport ? B4 : "div"), cn(Un(Je.value)), {
        default: oe(() => [
          Q(zr, {
            name: O(ie)(O(N)),
            css: O(Z) && !O(W).enabled
          }, {
            default: oe(() => [
              s.value ? (h(), b("div", $t({
                key: 0,
                ref_key: "dpWrapMenuRef",
                ref: c
              }, X.value, {
                class: { "dp--menu-wrapper": !O(W).enabled },
                style: O(W).enabled ? void 0 : O(ue)
              }), [
                Q($1, $t({
                  ref_key: "dpMenuRef",
                  ref: u
                }, _e.$props, {
                  "internal-model-value": O(Y),
                  "onUpdate:internalModelValue": Be[2] || (Be[2] = (Ye) => Sm(Y) ? Y.value = Ye : null),
                  class: { [we.value]: !0, "dp--menu-wrapper": _e.teleport },
                  "open-on-top": O(N),
                  "no-overlay-focus": Ae.value,
                  collapse: x.value,
                  "get-input-rect": fe,
                  "is-text-input-date": S.value,
                  onClosePicker: hn,
                  onSelectDate: Ot,
                  onAutoApply: Vn,
                  onTimeUpdate: qr,
                  onFlowStep: Be[3] || (Be[3] = (Ye) => _e.$emit("flow-step", Ye)),
                  onUpdateMonthYear: Be[4] || (Be[4] = (Ye) => _e.$emit("update-month-year", Ye)),
                  onInvalidSelect: Be[5] || (Be[5] = (Ye) => _e.$emit("invalid-select", O(Y))),
                  onAutoApplyInvalid: Be[6] || (Be[6] = (Ye) => _e.$emit("invalid-select", Ye)),
                  onInvalidFixedRange: Be[7] || (Be[7] = (Ye) => _e.$emit("invalid-fixed-range", Ye)),
                  onRecalculatePosition: O(De),
                  onTooltipOpen: Be[8] || (Be[8] = (Ye) => _e.$emit("tooltip-open", Ye)),
                  onTooltipClose: Be[9] || (Be[9] = (Ye) => _e.$emit("tooltip-close", Ye)),
                  onTimePickerOpen: Be[10] || (Be[10] = (Ye) => _e.$emit("time-picker-open", Ye)),
                  onTimePickerClose: Be[11] || (Be[11] = (Ye) => _e.$emit("time-picker-close", Ye)),
                  onAmPmChange: Be[12] || (Be[12] = (Ye) => _e.$emit("am-pm-change", Ye)),
                  onRangeStart: Be[13] || (Be[13] = (Ye) => _e.$emit("range-start", Ye)),
                  onRangeEnd: Be[14] || (Be[14] = (Ye) => _e.$emit("range-end", Ye)),
                  onDateUpdate: Be[15] || (Be[15] = (Ye) => _e.$emit("date-update", Ye)),
                  onInvalidDate: Be[16] || (Be[16] = (Ye) => _e.$emit("invalid-date", Ye)),
                  onOverlayToggle: Be[17] || (Be[17] = (Ye) => _e.$emit("overlay-toggle", Ye))
                }), an({ _: 2 }, [
                  Le(O($), (Ye, _n) => ({
                    name: Ye,
                    fn: oe((qn) => [
                      me(_e.$slots, Ye, cn(Un({ ...qn })))
                    ])
                  }))
                ]), 1040, ["internal-model-value", "class", "open-on-top", "no-overlay-focus", "collapse", "is-text-input-date", "onRecalculatePosition"])
              ], 16)) : A("", !0)
            ]),
            _: 3
          }, 8, ["name", "css"])
        ]),
        _: 3
      }, 16))
    ], 2));
  }
}), cu = /* @__PURE__ */ (() => {
  const t = mz;
  return t.install = (e) => {
    e.component("Vue3DatePicker", t);
  }, t;
})(), gz = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: cu
}, Symbol.toStringTag, { value: "Module" }));
Object.entries(gz).forEach(([t, e]) => {
  t !== "default" && (cu[t] = e);
});
const bz = {
  width: "32",
  height: "33",
  viewBox: "0 0 32 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-caret-left"
};
function vz(t, e) {
  return h(), b("svg", bz, e[0] || (e[0] = [
    k("path", {
      d: "m18 21-4-4 4-4",
      stroke: "#0B6AB7",
      "stroke-width": "1.5",
      "stroke-linecap": "square",
      "stroke-linejoin": "round",
      class: "svg__stroke--primary-blue-03"
    }, null, -1)
  ]));
}
const rh = { render: vz }, yz = {
  width: "32",
  height: "33",
  viewBox: "0 0 32 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-caret-right"
};
function _z(t, e) {
  return h(), b("svg", yz, e[0] || (e[0] = [
    k("path", {
      d: "m14 13 4 4-4 4",
      stroke: "#0B6AB7",
      "stroke-width": "1.5",
      "stroke-linecap": "square",
      "stroke-linejoin": "round",
      class: "svg__stroke--primary-blue-03"
    }, null, -1)
  ]));
}
const uu = { render: _z }, Tz = { class: "date-filter" }, xz = { class: "custom-header" }, wz = { class: "custom-month-year-component" }, kz = { class: "custom-nav-buttons" }, Cz = ["onClick"], Sz = ["onClick"], Az = { class: "day-header" }, Ez = { class: "day-content" }, Lz = {
  key: 0,
  class: "event-dots"
}, Dz = {
  key: 0,
  class: "dot"
}, Iz = { class: "action-row" }, Mz = { class: "button-text" }, Oz = { class: "custom-header" }, Pz = { class: "custom-month-year-component" }, Bz = { class: "custom-nav-buttons" }, Rz = ["onClick"], Nz = ["onClick"], $z = { class: "day-header" }, Fz = { class: "day-content" }, zz = {
  key: 0,
  class: "event-dots"
}, Uz = {
  key: 0,
  class: "dot"
}, Hz = { class: "action-row" }, Yz = /* @__PURE__ */ Ce({
  __name: "DateFilter",
  props: {
    eventDates: {
      type: Array,
      default: () => []
    },
    initialDates: {
      type: Object,
      default: () => ({ startDate: null, endDate: null })
    },
    // if true, the datepicker will be shown in 'inline' mode all the time, event on desktop
    // this option is not currently used on the ftva site
    // https://vue3datepicker.com/props/modes/#inline
    hideInput: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["input-selected"],
  setup(t, { expose: e, emit: n }) {
    const a = n, i = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], r = {
      closeOnAutoApply: !1,
      keepActionRow: !0
    }, s = K([]), o = K(null), l = K(!1), c = K(!1), u = K(!1), f = K(!1), m = K({
      rangeSeparator: " — "
    }), _ = I(() => s.value && "length" in s.value ? {
      startDate: s.value[0],
      endDate: s.value[1]
    } : s.value ? {
      startDate: s.value,
      endDate: null
    } : {
      startDate: null,
      endDate: null
    });
    t.initialDates.startDate && t.initialDates.endDate ? s.value = [t.initialDates.startDate, t.initialDates.endDate] : t.initialDates.startDate && (s.value = [t.initialDates.startDate, t.initialDates.startDate]);
    function T(ie) {
      const Z = {};
      for (let $ = 0; $ < ie.length; $++)
        Z[ie[$]] === void 0 ? Z[ie[$]] = 1 : Z[ie[$]]++;
      return Z;
    }
    const g = T(t.eventDates);
    function x() {
      var ie, Z;
      f.value === !0 ? ((ie = o.value) == null || ie.updateInternalModelValue(null), f.value = !1, (Z = document == null ? void 0 : document.activeElement) == null || Z.blur()) : (u.value ? s.value = /* @__PURE__ */ new Date() : s.value = [/* @__PURE__ */ new Date(), /* @__PURE__ */ new Date()], f.value = !0);
    }
    function S() {
      var ie, Z, $;
      (ie = o.value) == null || ie.updateInternalModelValue(null), f.value = !1, (Z = o.value) == null || Z.clearValue(), ($ = o.value) == null || $.openMenu(), a("input-selected", _.value);
    }
    function D() {
      var ie;
      a("input-selected", _.value), (ie = o.value) == null || ie.closeMenu();
    }
    function L(ie) {
      ie && "length" in ie && ie.length.valueOf() === 1 ? l.value = !0 : l.value = !1;
    }
    function M() {
      u.value && s.value && "length" in s.value && (s.value = s.value[0]);
    }
    function E() {
      f.value = !1;
    }
    function P() {
      c.value = !c.value;
    }
    function B() {
      var ie;
      (ie = o.value) == null || ie.openMenu();
    }
    function z() {
      var ie;
      (ie = o.value) == null || ie.closeMenu();
    }
    e({
      openDatepicker: B,
      closeDatepicker: z
    });
    const W = I(() => ["vue-date-picker", { "is-selecting": l.value }]), V = I(() => ["toggle-triangle-icon", { "is-open": c.value }]), H = I(() => ["today-button", { "is-active-selection": f.value }]), se = ve(() => Promise.resolve().then(() => Ml));
    return Qe(s, async (ie, Z) => {
      ie !== Z && (ie && "length" in ie && ie[1] === null ? m.value = {
        rangeSeparator: " "
      } : m.value = {
        rangeSeparator: " — "
      });
    }), st(() => {
      const { width: ie } = li();
      Qe(ie, (Z) => {
        u.value = Z <= 750, M();
      }, { immediate: !0 });
    }), (ie, Z) => (h(), b("div", Tz, [
      u.value ? (h(), G(Ju, { key: 1 }, {
        buttonLabel: oe(() => [
          k("span", Mz, [
            Q(O(zc)),
            Z[2] || (Z[2] = ze("Calendar "))
          ])
        ]),
        dropdownItems: oe(({ removeOverlay: $ }) => [
          Q(O(cu), {
            ref_key: "datepicker",
            ref: o,
            modelValue: s.value,
            "onUpdate:modelValue": Z[1] || (Z[1] = (J) => s.value = J),
            config: r,
            range: !u.value,
            "week-start": 0,
            "month-name-format": "long",
            "enable-time-picker": !1,
            "auto-position": !1,
            "auto-apply": !0,
            "text-input": m.value,
            "no-today": "",
            inline: !0,
            class: re(W.value),
            placeholder: u.value ? "Select a date" : "All upcoming",
            onInternalModelChange: L,
            onRangeStart: E,
            onOpen: P,
            onClosed: P
          }, {
            "input-icon": oe(() => [
              Q(O(zc)),
              k("span", {
                class: re(V.value)
              }, [
                Q(O(of))
              ], 2)
            ]),
            "clear-icon": oe(({ clear: J }) => [
              Q(O(er), { onClick: J }, null, 8, ["onClick"])
            ]),
            "month-year": oe(({
              month: J,
              year: N,
              months: ue,
              handleMonthYearChange: xe
            }) => [
              k("div", Oz, [
                k("div", Pz, ne(ue[J].text) + " " + ne(N), 1),
                k("div", Bz, [
                  k("button", {
                    class: "nav-arrow-button",
                    onClick: (De) => {
                      E(), xe(!1);
                    }
                  }, [
                    Q(O(rh))
                  ], 8, Rz),
                  k("button", {
                    class: re(H.value),
                    onClick: x
                  }, " TODAY ", 2),
                  k("button", {
                    class: "nav-arrow-button",
                    onClick: (De) => {
                      E(), xe(!0);
                    }
                  }, [
                    Q(O(uu))
                  ], 8, Nz)
                ])
              ])
            ]),
            "calendar-header": oe(({ index: J }) => [
              k("div", $z, ne(i[J]), 1)
            ]),
            day: oe(({ day: J, date: N }) => [
              k("div", Fz, [
                ze(ne(J) + " ", 1),
                O(g).hasOwnProperty(N.toLocaleDateString()) ? (h(), b("div", zz, [
                  (h(!0), b(he, null, Le(O(g)[N.toLocaleDateString()], (ue) => (h(), b(he, { key: ue }, [
                    ue <= 3 ? (h(), b("span", Uz)) : A("", !0)
                  ], 64))), 128))
                ])) : A("", !0)
              ])
            ]),
            "action-row": oe(({ selectDate: J }) => [
              k("div", Hz, [
                Q(O(se), {
                  class: "action-row-button select-button",
                  label: "Done",
                  "icon-name": "none",
                  onClick: (N) => {
                    J(), D(), $();
                  }
                }, null, 8, ["onClick"]),
                Q(O(se), {
                  class: "action-row-button clear-button",
                  label: "Clear",
                  "icon-name": "icon-close",
                  onClick: S
                })
              ])
            ]),
            _: 2
          }, 1032, ["modelValue", "range", "text-input", "class", "placeholder"])
        ]),
        _: 1
      })) : (h(), G(O(cu), {
        key: 0,
        ref_key: "datepicker",
        ref: o,
        modelValue: s.value,
        "onUpdate:modelValue": Z[0] || (Z[0] = ($) => s.value = $),
        config: r,
        range: !u.value,
        "week-start": 0,
        "month-name-format": "long",
        "enable-time-picker": !1,
        "auto-position": !1,
        "auto-apply": !0,
        "text-input": m.value,
        "no-today": "",
        inline: t.hideInput,
        class: re(W.value),
        placeholder: u.value ? "Select a date" : "All upcoming",
        onInternalModelChange: L,
        onRangeStart: E,
        onOpen: P,
        onClosed: P
      }, {
        "input-icon": oe(() => [
          Q(O(zc))
        ]),
        "clear-icon": oe(({ clear: $ }) => [
          Q(O(er), { onClick: $ }, null, 8, ["onClick"])
        ]),
        "month-year": oe(({
          month: $,
          year: J,
          months: N,
          handleMonthYearChange: ue
        }) => [
          k("div", xz, [
            k("div", wz, ne(N[$].text) + " " + ne(J), 1),
            k("div", kz, [
              k("button", {
                class: "nav-arrow-button",
                onClick: (xe) => {
                  E(), ue(!1);
                }
              }, [
                Q(O(rh))
              ], 8, Cz),
              k("button", {
                class: re(H.value),
                onClick: x
              }, " TODAY ", 2),
              k("button", {
                class: "nav-arrow-button",
                onClick: (xe) => {
                  E(), ue(!0);
                }
              }, [
                Q(O(uu))
              ], 8, Sz)
            ])
          ])
        ]),
        "calendar-header": oe(({ index: $ }) => [
          k("div", Az, ne(i[$]), 1)
        ]),
        day: oe(({ day: $, date: J }) => [
          k("div", Ez, [
            ze(ne($) + " ", 1),
            O(g).hasOwnProperty(J.toLocaleDateString()) ? (h(), b("div", Lz, [
              (h(!0), b(he, null, Le(O(g)[J.toLocaleDateString()], (N) => (h(), b(he, { key: N }, [
                N <= 3 ? (h(), b("span", Dz)) : A("", !0)
              ], 64))), 128))
            ])) : A("", !0)
          ])
        ]),
        "action-row": oe(({ selectDate: $ }) => [
          k("div", Iz, [
            Q(O(se), {
              class: "action-row-button select-button",
              label: "Done",
              "icon-name": "none",
              onClick: (J) => {
                $(), D();
              }
            }, null, 8, ["onClick"]),
            Q(O(se), {
              class: "action-row-button clear-button",
              label: "Clear",
              "icon-name": "icon-close",
              onClick: S
            })
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "range", "text-input", "inline", "class", "placeholder"]))
    ]));
  }
}), Dhe = /* @__PURE__ */ ge(Yz, [["__scopeId", "data-v-a2fcc450"]]), jz = {
  key: 0,
  class: "list-top-wrapper"
}, Vz = { class: "definition-list-wrapper" }, qz = { key: 0 }, Wz = {
  key: 1,
  class: "white-space-wrap"
}, Gz = {
  key: 1,
  class: "list-bottom-wrapper"
}, Xz = /* @__PURE__ */ Ce({
  __name: "DefinitionList",
  props: {
    metaDataObject: {
      type: Object,
      default: () => {
      }
    },
    // switch CSS styling between vertical or horizontal layout
    orientation: {
      type: String,
      default: "vertical"
    }
  },
  setup(t) {
    function e(r) {
      return typeof r == "string" ? r : Array.isArray(r) ? r.map((s) => e(s)).join(", ").replace(/(, ){2,}/g, ", ") : typeof r == "object" ? r == null ? void 0 : Object.keys(r).map((s) => typeof r[s] == "string" ? `${s}: ${r[s]}` : e(r[s])).join(", ").replace(/,\s*$/, "") : r;
    }
    const n = [null, void 0, "", [], {}], a = qe(), i = I(() => ["definition-list", (a == null ? void 0 : a.value) || ""]);
    return (r, s) => (h(), b("div", {
      class: re(i.value)
    }, [
      r.$slots["list-top"] ? (h(), b("div", jz, [
        me(r.$slots, "list-top", {}, void 0, !0)
      ])) : A("", !0),
      k("dl", Vz, [
        (h(!0), b(he, null, Le(t.metaDataObject, (o, l) => (h(), b("div", {
          key: l,
          class: re(["definition-list-item-wrapper", t.orientation])
        }, [
          n.includes(e(o)) ? A("", !0) : (h(), b("dt", qz, [
            me(r.$slots, `term-${l}`, {}, () => [
              ze(ne(l.replace(/([A-Z])/g, " $1").trim()), 1)
            ], !0)
          ])),
          n.includes(e(o)) ? A("", !0) : (h(), b("dd", Wz, [
            me(r.$slots, `definition-${l}`, {}, () => [
              ze(ne(e(o)), 1)
            ], !0)
          ]))
        ], 2))), 128))
      ]),
      r.$slots["list-bottom"] ? (h(), b("div", Gz, [
        me(r.$slots, "list-bottom", {}, void 0, !0)
      ])) : A("", !0)
    ], 2));
  }
}), Ihe = /* @__PURE__ */ ge(Xz, [["__scopeId", "data-v-32d0d7c1"]]), Zz = {
  name: "DividerGeneral",
  // vue component name
  props: {
    isBold: {
      type: Boolean,
      default: !1
    },
    isTertiary: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    classes() {
      return ["divider-general", { "is-bold": this.isBold }, { "is-tertiary": this.isTertiary }];
    }
  }
};
function Kz(t, e, n, a, i, r) {
  return h(), b("div", {
    class: re(r.classes)
  }, null, 2);
}
const sh = /* @__PURE__ */ ge(Zz, [["render", Kz], ["__scopeId", "data-v-d8e8ef90"]]), Qz = {
  width: "17",
  height: "13",
  viewBox: "0 0 17 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-ftva-dropdown_check"
};
function Jz(t, e) {
  return h(), b("svg", Qz, e[0] || (e[0] = [
    k("path", {
      d: "M2.38672 7.78488L5.73438 11.1327L14.9999 1.86719",
      stroke: "#115DAF",
      "stroke-width": "2",
      "stroke-linecap": "square",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const F1 = { render: Jz }, eU = { class: "filter-summary" }, tU = { class: "pills" }, nU = ["value", "disabled", "onChange"], aU = { class: "pill-option" }, iU = { class: "pill-content" }, rU = {
  key: 0,
  class: "pill-label view-all-option"
}, sU = ["disabled", "onChange"], oU = { class: "pill-option" }, lU = /* @__PURE__ */ Ce({
  __name: "DropdownSingleSelect",
  props: /* @__PURE__ */ Gc({
    options: {
      type: Array,
      default: () => []
    },
    fieldName: {
      // name of field which will be used to sort or search on
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    showViewAll: {
      type: Boolean,
      default: !1
    }
  }, {
    selectedFilters: { type: Object, required: !0, default: {} },
    selectedFiltersModifiers: {}
  }),
  emits: /* @__PURE__ */ Gc(["update-display"], ["update:selectedFilters"]),
  setup(t, { emit: e }) {
    const n = t, a = e, i = t2(t, "selectedFilters");
    function r() {
      a("update-display", i.value);
    }
    const s = qe(), o = I(() => ["dropdown-single-select", (s == null ? void 0 : s.value) || ""]), l = K(!1);
    st(() => {
      const { width: u } = li();
      Qe(
        u,
        (f) => {
          l.value = f <= 750;
        },
        { immediate: !0 }
      );
    });
    const c = I(() => {
      const u = n.options.find((f) => f.value === i.value[n.fieldName]);
      return u ? `: ${u.label}` : "(none selected)";
    });
    return (u, f) => (h(), b("div", {
      class: re(o.value)
    }, [
      Q(Ju, null, {
        buttonLabel: oe(() => [
          k("span", eU, [
            ze(ne(t.label) + " ", 1),
            l.value ? A("", !0) : (h(), b(he, { key: 0 }, [
              ze(ne(c.value), 1)
            ], 64))
          ])
        ]),
        dropdownItems: oe(({ removeOverlay: m }) => [
          k("div", tU, [
            (h(!0), b(he, null, Le(t.options, (_) => (h(), b("label", {
              key: _.value,
              class: "pill-label"
            }, [
              Tt(k("input", {
                "onUpdate:modelValue": f[0] || (f[0] = (T) => i.value[n.fieldName] = T),
                type: "radio",
                class: "pill-radio",
                value: _.value,
                disabled: n.disabled,
                onChange: () => {
                  r(), m();
                }
              }, null, 40, nU), [
                [bs, i.value[n.fieldName]]
              ]),
              k("div", aU, [
                k("span", iU, ne(_.label), 1),
                i.value[n.fieldName] === _.value ? (h(), G(O(F1), {
                  key: 0,
                  class: "check-icon"
                })) : A("", !0)
              ])
            ]))), 128)),
            n.showViewAll ? (h(), b("label", rU, [
              Tt(k("input", {
                "onUpdate:modelValue": f[1] || (f[1] = (_) => i.value[n.fieldName] = _),
                type: "radio",
                class: "pill-radio",
                value: "",
                disabled: n.disabled,
                onChange: () => {
                  r(), m();
                }
              }, null, 40, sU), [
                [bs, i.value[n.fieldName]]
              ]),
              k("div", oU, [
                f[2] || (f[2] = k("span", { class: "pill-content" }, "View All", -1)),
                i.value[n.fieldName] === "" ? (h(), G(O(F1), {
                  key: 0,
                  class: "check-icon"
                })) : A("", !0)
              ])
            ])) : A("", !0)
          ])
        ]),
        _: 1
      })
    ], 2));
  }
}), Mhe = /* @__PURE__ */ ge(lU, [["__scopeId", "data-v-9f9dee3e"]]), cU = {
  width: "10",
  height: "10",
  viewBox: "0 0 10 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-ftva-xtag"
};
function hy(t, e) {
  return h(), b("svg", cU, e[0] || (e[0] = [
    k("path", {
      d: "M8.95349 8.2461L8.95349 8.2461L5.7069 5L8.95349 1.7539L8.95349 1.75389C9.0473 1.66009 9.1 1.53286 9.1 1.4002C9.1 1.26754 9.0473 1.14031 8.95349 1.04651C8.85969 0.952699 8.73246 0.9 8.5998 0.9C8.46714 0.9 8.33991 0.9527 8.2461 1.04651L8.2461 1.04651L5 4.2931L1.7539 1.04651L1.75389 1.04651C1.66009 0.952699 1.53286 0.9 1.4002 0.9C1.26754 0.9 1.14031 0.952699 1.04651 1.04651C0.952699 1.14031 0.9 1.26754 0.9 1.4002C0.9 1.53286 0.952699 1.66009 1.04651 1.75389L1.04651 1.7539L4.2931 5L1.04651 8.2461L1.04651 8.2461C0.9527 8.33991 0.9 8.46714 0.9 8.5998C0.9 8.73246 0.952699 8.85969 1.04651 8.95349C1.14031 9.0473 1.26754 9.1 1.4002 9.1C1.53286 9.1 1.66009 9.0473 1.75389 8.95349L1.7539 8.95349L5 5.7069L8.2461 8.95349L8.2461 8.95349C8.29255 8.99994 8.34769 9.03679 8.40838 9.06192C8.46907 9.08706 8.53411 9.1 8.5998 9.1C8.66549 9.1 8.73053 9.08706 8.79122 9.06192C8.8519 9.03679 8.90705 8.99994 8.95349 8.9535L8.88278 8.88278L8.9535 8.95349C8.99994 8.90705 9.03679 8.8519 9.06192 8.79122C9.08706 8.73053 9.1 8.66549 9.1 8.5998C9.1 8.53411 9.08706 8.46907 9.06192 8.40838C9.03679 8.34769 8.99994 8.29255 8.95349 8.2461Z",
      fill: "white",
      stroke: "white",
      "stroke-width": "0.2",
      class: "svg__stroke--pure-white svg__fill--pure-white"
    }, null, -1)
  ]));
}
const fy = { render: hy }, uU = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: fy,
  render: hy
}, Symbol.toStringTag, { value: "Module" })), dU = {
  width: "20",
  height: "21",
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-ftva-filter"
};
function hU(t, e) {
  return h(), b("svg", dU, e[0] || (e[0] = [
    k("path", {
      d: "M6.25 2.33556C5.91848 2.33556 5.60054 2.45844 5.36612 2.67717C5.1317 2.89591 5 3.19257 5 3.50191C5 3.81124 5.1317 4.10791 5.36612 4.32664C5.60054 4.54537 5.91848 4.66825 6.25 4.66825C6.58152 4.66825 6.89946 4.54537 7.13388 4.32664C7.3683 4.10791 7.5 3.81124 7.5 3.50191C7.5 3.19257 7.3683 2.89591 7.13388 2.67717C6.89946 2.45844 6.58152 2.33556 6.25 2.33556ZM2.7125 2.33556C2.97075 1.65262 3.44967 1.06124 4.08325 0.642938C4.71683 0.224634 5.47386 0 6.25 0C7.02614 0 7.78317 0.224634 8.41675 0.642938C9.05033 1.06124 9.52925 1.65262 9.7875 2.33556H18.75C19.0815 2.33556 19.3995 2.45844 19.6339 2.67717C19.8683 2.89591 20 3.19257 20 3.50191C20 3.81124 19.8683 4.10791 19.6339 4.32664C19.3995 4.54537 19.0815 4.66825 18.75 4.66825H9.7875C9.52925 5.35119 9.05033 5.94257 8.41675 6.36087C7.78317 6.77918 7.02614 7.00381 6.25 7.00381C5.47386 7.00381 4.71683 6.77918 4.08325 6.36087C3.44967 5.94257 2.97075 5.35119 2.7125 4.66825H1.25C0.918479 4.66825 0.600537 4.54537 0.366117 4.32664C0.131696 4.10791 0 3.81124 0 3.50191C0 3.19257 0.131696 2.89591 0.366117 2.67717C0.600537 2.45844 0.918479 2.33556 1.25 2.33556H2.7125ZM13.75 9.33365C13.4185 9.33365 13.1005 9.45653 12.8661 9.67527C12.6317 9.894 12.5 10.1907 12.5 10.5C12.5 10.8093 12.6317 11.106 12.8661 11.3247C13.1005 11.5435 13.4185 11.6663 13.75 11.6663C14.0815 11.6663 14.3995 11.5435 14.6339 11.3247C14.8683 11.106 15 10.8093 15 10.5C15 10.1907 14.8683 9.894 14.6339 9.67527C14.3995 9.45653 14.0815 9.33365 13.75 9.33365ZM10.2125 9.33365C10.4708 8.65071 10.9497 8.05934 11.5833 7.64103C12.2168 7.22273 12.9739 6.99809 13.75 6.99809C14.5261 6.99809 15.2832 7.22273 15.9167 7.64103C16.5503 8.05934 17.0292 8.65071 17.2875 9.33365H18.75C19.0815 9.33365 19.3995 9.45653 19.6339 9.67527C19.8683 9.894 20 10.1907 20 10.5C20 10.8093 19.8683 11.106 19.6339 11.3247C19.3995 11.5435 19.0815 11.6663 18.75 11.6663H17.2875C17.0292 12.3493 16.5503 12.9407 15.9167 13.359C15.2832 13.7773 14.5261 14.0019 13.75 14.0019C12.9739 14.0019 12.2168 13.7773 11.5833 13.359C10.9497 12.9407 10.4708 12.3493 10.2125 11.6663H1.25C0.918479 11.6663 0.600537 11.5435 0.366117 11.3247C0.131696 11.106 0 10.8093 0 10.5C0 10.1907 0.131696 9.894 0.366117 9.67527C0.600537 9.45653 0.918479 9.33365 1.25 9.33365H10.2125ZM6.25 16.3317C5.91848 16.3317 5.60054 16.4546 5.36612 16.6734C5.1317 16.8921 5 17.1888 5 17.4981C5 17.8074 5.1317 18.1041 5.36612 18.3228C5.60054 18.5416 5.91848 18.6644 6.25 18.6644C6.58152 18.6644 6.89946 18.5416 7.13388 18.3228C7.3683 18.1041 7.5 17.8074 7.5 17.4981C7.5 17.1888 7.3683 16.8921 7.13388 16.6734C6.89946 16.4546 6.58152 16.3317 6.25 16.3317ZM2.7125 16.3317C2.97075 15.6488 3.44967 15.0574 4.08325 14.6391C4.71683 14.2208 5.47386 13.9962 6.25 13.9962C7.02614 13.9962 7.78317 14.2208 8.41675 14.6391C9.05033 15.0574 9.52925 15.6488 9.7875 16.3317H18.75C19.0815 16.3317 19.3995 16.4546 19.6339 16.6734C19.8683 16.8921 20 17.1888 20 17.4981C20 17.8074 19.8683 18.1041 19.6339 18.3228C19.3995 18.5416 19.0815 18.6644 18.75 18.6644H9.7875C9.52925 19.3474 9.05033 19.9388 8.41675 20.3571C7.78317 20.7754 7.02614 21 6.25 21C5.47386 21 4.71683 20.7754 4.08325 20.3571C3.44967 19.9388 2.97075 19.3474 2.7125 18.6644H1.25C0.918479 18.6644 0.600537 18.5416 0.366117 18.3228C0.131696 18.1041 0 17.8074 0 17.4981C0 17.1888 0.131696 16.8921 0.366117 16.6734C0.600537 16.4546 0.918479 16.3317 1.25 16.3317H2.7125Z",
      fill: "#115DAF",
      class: "svg__fill--accent-blue"
    }, null, -1)
  ]));
}
const fU = { render: hU }, pU = { class: "filter-summary" }, mU = { class: "icon-svg" }, gU = { class: "dropdown-filter" }, bU = { class: "pills" }, vU = ["id", "onUpdate:modelValue", "name", "value"], yU = { class: "action-row" }, _U = /* @__PURE__ */ Ce({
  __name: "FiltersDropdown",
  props: /* @__PURE__ */ Gc({
    filterGroups: {
      type: Array,
      default: () => []
    }
  }, {
    selectedFilters: { type: Object, required: !0, default: {} },
    selectedFiltersModifiers: {}
  }),
  emits: /* @__PURE__ */ Gc(["update-display"], ["update:selectedFilters"]),
  setup(t, { emit: e }) {
    const n = e, a = t2(t, "selectedFilters"), i = I(() => {
      let f = 0;
      for (const m in a.value)
        f += a.value[m].length;
      return f;
    });
    function r(f, m) {
      return Object.keys(a.value).length ? a.value[f].includes(m) : null;
    }
    function s() {
      for (const f of t.filterGroups)
        a.value[f.searchField] = [];
      n("update-display", a.value);
    }
    function o() {
      n("update-display", a.value);
    }
    const l = qe(), c = K(!1), u = I(() => ["filters-dropdown", (l == null ? void 0 : l.value) || ""]);
    return st(() => {
      const { width: f } = li();
      Qe(f, (m) => {
        c.value = m <= 750;
      }, { immediate: !0 });
    }), (f, m) => (h(), b("div", {
      class: re(u.value)
    }, [
      Q(Ju, null, {
        buttonLabel: oe(() => [
          k("div", pU, [
            c.value ? (h(), b(he, { key: 1 }, [
              ze(" Filters ")
            ], 64)) : (h(), b(he, { key: 0 }, [
              ze(" Filters (" + ne(i.value) + " selected ) ", 1)
            ], 64))
          ]),
          k("span", mU, [
            Q(O(fU), { "aria-hidden": "true" })
          ])
        ]),
        dropdownItems: oe(({ removeOverlay: _ }) => [
          k("div", gU, [
            (h(!0), b(he, null, Le(t.filterGroups, (T) => (h(), b("div", {
              key: T.name,
              class: "filter-group"
            }, [
              k("h3", null, ne(T.name), 1),
              k("div", bU, [
                (h(!0), b(he, null, Le(T.options, (g) => (h(), b("label", {
                  key: g,
                  class: "pill-label"
                }, [
                  Tt(k("input", {
                    id: g,
                    "onUpdate:modelValue": (x) => a.value[T.searchField] = x,
                    type: "checkbox",
                    class: "pill-checkbox",
                    name: g,
                    value: g
                  }, null, 8, vU), [
                    [jh, a.value[T.searchField]]
                  ]),
                  Q(eo, {
                    label: g,
                    "is-secondary": !0
                  }, {
                    default: oe(() => [
                      r(T.searchField, g) ? (h(), G(O(fy), {
                        key: 0,
                        class: "close-icon"
                      })) : A("", !0)
                    ]),
                    _: 2
                  }, 1032, ["label"])
                ]))), 128))
              ])
            ]))), 128)),
            k("div", yU, [
              Q(sn, {
                class: "action-row-button select-button",
                label: "Done",
                "icon-name": "none",
                onClick: (T) => {
                  o(), _();
                }
              }, null, 8, ["onClick"]),
              Q(sn, {
                class: "action-row-button clear-button",
                label: "Clear",
                "icon-name": "icon-close",
                onClick: s
              })
            ])
          ])
        ]),
        _: 1
      })
    ], 2));
  }
}), Ohe = /* @__PURE__ */ ge(_U, [["__scopeId", "data-v-72dc34c0"]]);
function TU(t, e, n, a) {
  var i = -1, r = t == null ? 0 : t.length;
  for (a && r && (n = t[++i]); ++i < r; )
    n = e(n, t[i], i, t);
  return n;
}
var xU = TU, wU = j2, kU = {
  // Latin-1 Supplement block.
  À: "A",
  Á: "A",
  Â: "A",
  Ã: "A",
  Ä: "A",
  Å: "A",
  à: "a",
  á: "a",
  â: "a",
  ã: "a",
  ä: "a",
  å: "a",
  Ç: "C",
  ç: "c",
  Ð: "D",
  ð: "d",
  È: "E",
  É: "E",
  Ê: "E",
  Ë: "E",
  è: "e",
  é: "e",
  ê: "e",
  ë: "e",
  Ì: "I",
  Í: "I",
  Î: "I",
  Ï: "I",
  ì: "i",
  í: "i",
  î: "i",
  ï: "i",
  Ñ: "N",
  ñ: "n",
  Ò: "O",
  Ó: "O",
  Ô: "O",
  Õ: "O",
  Ö: "O",
  Ø: "O",
  ò: "o",
  ó: "o",
  ô: "o",
  õ: "o",
  ö: "o",
  ø: "o",
  Ù: "U",
  Ú: "U",
  Û: "U",
  Ü: "U",
  ù: "u",
  ú: "u",
  û: "u",
  ü: "u",
  Ý: "Y",
  ý: "y",
  ÿ: "y",
  Æ: "Ae",
  æ: "ae",
  Þ: "Th",
  þ: "th",
  ß: "ss",
  // Latin Extended-A block.
  Ā: "A",
  Ă: "A",
  Ą: "A",
  ā: "a",
  ă: "a",
  ą: "a",
  Ć: "C",
  Ĉ: "C",
  Ċ: "C",
  Č: "C",
  ć: "c",
  ĉ: "c",
  ċ: "c",
  č: "c",
  Ď: "D",
  Đ: "D",
  ď: "d",
  đ: "d",
  Ē: "E",
  Ĕ: "E",
  Ė: "E",
  Ę: "E",
  Ě: "E",
  ē: "e",
  ĕ: "e",
  ė: "e",
  ę: "e",
  ě: "e",
  Ĝ: "G",
  Ğ: "G",
  Ġ: "G",
  Ģ: "G",
  ĝ: "g",
  ğ: "g",
  ġ: "g",
  ģ: "g",
  Ĥ: "H",
  Ħ: "H",
  ĥ: "h",
  ħ: "h",
  Ĩ: "I",
  Ī: "I",
  Ĭ: "I",
  Į: "I",
  İ: "I",
  ĩ: "i",
  ī: "i",
  ĭ: "i",
  į: "i",
  ı: "i",
  Ĵ: "J",
  ĵ: "j",
  Ķ: "K",
  ķ: "k",
  ĸ: "k",
  Ĺ: "L",
  Ļ: "L",
  Ľ: "L",
  Ŀ: "L",
  Ł: "L",
  ĺ: "l",
  ļ: "l",
  ľ: "l",
  ŀ: "l",
  ł: "l",
  Ń: "N",
  Ņ: "N",
  Ň: "N",
  Ŋ: "N",
  ń: "n",
  ņ: "n",
  ň: "n",
  ŋ: "n",
  Ō: "O",
  Ŏ: "O",
  Ő: "O",
  ō: "o",
  ŏ: "o",
  ő: "o",
  Ŕ: "R",
  Ŗ: "R",
  Ř: "R",
  ŕ: "r",
  ŗ: "r",
  ř: "r",
  Ś: "S",
  Ŝ: "S",
  Ş: "S",
  Š: "S",
  ś: "s",
  ŝ: "s",
  ş: "s",
  š: "s",
  Ţ: "T",
  Ť: "T",
  Ŧ: "T",
  ţ: "t",
  ť: "t",
  ŧ: "t",
  Ũ: "U",
  Ū: "U",
  Ŭ: "U",
  Ů: "U",
  Ű: "U",
  Ų: "U",
  ũ: "u",
  ū: "u",
  ŭ: "u",
  ů: "u",
  ű: "u",
  ų: "u",
  Ŵ: "W",
  ŵ: "w",
  Ŷ: "Y",
  ŷ: "y",
  Ÿ: "Y",
  Ź: "Z",
  Ż: "Z",
  Ž: "Z",
  ź: "z",
  ż: "z",
  ž: "z",
  Ĳ: "IJ",
  ĳ: "ij",
  Œ: "Oe",
  œ: "oe",
  ŉ: "'n",
  ſ: "s"
}, CU = wU(kU), SU = CU, AU = SU, EU = Pl, LU = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, DU = "\\u0300-\\u036f", IU = "\\ufe20-\\ufe2f", MU = "\\u20d0-\\u20ff", OU = DU + IU + MU, PU = "[" + OU + "]", BU = RegExp(PU, "g");
function RU(t) {
  return t = EU(t), t && t.replace(LU, AU).replace(BU, "");
}
var NU = RU, $U = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
function FU(t) {
  return t.match($U) || [];
}
var zU = FU, UU = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
function HU(t) {
  return UU.test(t);
}
var YU = HU, py = "\\ud800-\\udfff", jU = "\\u0300-\\u036f", VU = "\\ufe20-\\ufe2f", qU = "\\u20d0-\\u20ff", WU = jU + VU + qU, my = "\\u2700-\\u27bf", gy = "a-z\\xdf-\\xf6\\xf8-\\xff", GU = "\\xac\\xb1\\xd7\\xf7", XU = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", ZU = "\\u2000-\\u206f", KU = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", by = "A-Z\\xc0-\\xd6\\xd8-\\xde", QU = "\\ufe0e\\ufe0f", vy = GU + XU + ZU + KU, yy = "['’]", z1 = "[" + vy + "]", JU = "[" + WU + "]", _y = "\\d+", eH = "[" + my + "]", Ty = "[" + gy + "]", xy = "[^" + py + vy + _y + my + gy + by + "]", tH = "\\ud83c[\\udffb-\\udfff]", nH = "(?:" + JU + "|" + tH + ")", aH = "[^" + py + "]", wy = "(?:\\ud83c[\\udde6-\\uddff]){2}", ky = "[\\ud800-\\udbff][\\udc00-\\udfff]", us = "[" + by + "]", iH = "\\u200d", U1 = "(?:" + Ty + "|" + xy + ")", rH = "(?:" + us + "|" + xy + ")", H1 = "(?:" + yy + "(?:d|ll|m|re|s|t|ve))?", Y1 = "(?:" + yy + "(?:D|LL|M|RE|S|T|VE))?", Cy = nH + "?", Sy = "[" + QU + "]?", sH = "(?:" + iH + "(?:" + [aH, wy, ky].join("|") + ")" + Sy + Cy + ")*", oH = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", lH = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", cH = Sy + Cy + sH, uH = "(?:" + [eH, wy, ky].join("|") + ")" + cH, dH = RegExp([
  us + "?" + Ty + "+" + H1 + "(?=" + [z1, us, "$"].join("|") + ")",
  rH + "+" + Y1 + "(?=" + [z1, us + U1, "$"].join("|") + ")",
  us + "?" + U1 + "+" + H1,
  us + "+" + Y1,
  lH,
  oH,
  _y,
  uH
].join("|"), "g");
function hH(t) {
  return t.match(dH) || [];
}
var fH = hH, pH = zU, mH = YU, gH = Pl, bH = fH;
function vH(t, e, n) {
  return t = gH(t), e = n ? void 0 : e, e === void 0 ? mH(t) ? bH(t) : pH(t) : t.match(e) || [];
}
var yH = vH, _H = xU, TH = NU, xH = yH, wH = "['’]", kH = RegExp(wH, "g");
function CH(t) {
  return function(e) {
    return _H(xH(TH(e).replace(kH, "")), t, "");
  };
}
var SH = CH, AH = SH, EH = AH(function(t, e, n) {
  return t + (n ? "-" : "") + e.toLowerCase();
}), LH = EH;
const Ay = /* @__PURE__ */ ka(LH), DH = ["data-cy"], IH = {
  key: 0,
  class: "section-header"
}, MH = ["innerHTML"], OH = ["innerHTML"], PH = { class: "cards" }, BH = /* @__PURE__ */ Ce({
  __name: "SectionCardsWithIllustrations",
  props: {
    sectionTitle: {
      type: String,
      default: ""
    },
    sectionSummary: {
      type: String,
      default: ""
    },
    items: {
      type: Array,
      default: () => []
    },
    to: {
      type: String,
      default: ""
    },
    buttonText: {
      type: String,
      default: ""
    },
    isHorizontal: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    const e = t, n = I(() => [
      "section-cards-with-illustrations",
      { "is-horizontal": e.isHorizontal }
    ]), a = I(() => `section-cards-with-illustrations-${Ay(e.sectionTitle) || "untitled"}`);
    return (i, r) => (h(), b("section", {
      class: re(n.value),
      "data-cy": a.value
    }, [
      t.sectionTitle || t.sectionSummary ? (h(), b("div", IH, [
        t.sectionTitle ? (h(), b("h2", {
          key: 0,
          id: "cards-with-illustration-title",
          class: "section-title",
          innerHTML: t.sectionTitle
        }, null, 8, MH)) : A("", !0),
        t.sectionSummary ? (h(), b("div", {
          key: 1,
          class: "section-summary",
          innerHTML: t.sectionSummary
        }, null, 8, OH)) : A("", !0)
      ])) : A("", !0),
      k("ul", PH, [
        (h(!0), b(he, null, Le(t.items, (s) => (h(), G(bD, {
          key: s.to,
          "icon-name": s.iconName,
          to: s.to,
          title: s.title,
          text: s.text,
          category: s.category,
          "is-horizontal": t.isHorizontal
        }, null, 8, ["icon-name", "to", "title", "text", "category", "is-horizontal"]))), 128)),
        t.to ? (h(), G(Xe, {
          key: 0,
          class: "card card-more",
          to: t.to
        }, {
          default: oe(() => [
            Q(kv, {
              id: "card-more-button",
              class: "button",
              text: t.buttonText,
              "aria-labelledby": "card-more-button cards-with-illustration-title"
            }, null, 8, ["text"])
          ]),
          _: 1
        }, 8, ["to"])) : A("", !0)
      ])
    ], 10, DH));
  }
}), RH = /* @__PURE__ */ ge(BH, [["__scopeId", "data-v-06b1ab58"]]);
function $n(t = "") {
  return t === null || t.match(/^(http|https):\/\//) ? t : (t.startsWith("/") || (t = `/${t}`), t.replace("meap/", ""));
}
const NH = /* @__PURE__ */ Ce({
  __name: "AssociatedTopicCards",
  props: {
    block: {
      type: Object,
      default: () => {
      }
    }
  },
  setup(t) {
    const e = I(() => t.block.associatedTopicsFlexiblePageBlock[0].topics.map(
      (n) => ({
        ...n,
        to: n.externalResourceUrl ? n.externalResourceUrl : $n(n.uri)
      })
    ));
    return (n, a) => t.block && t.block.associatedTopicsFlexiblePageBlock ? (h(), G(RH, {
      key: 0,
      items: e.value,
      "section-title": t.block.sectionTitle,
      "section-summary": t.block.sectionSummary,
      "is-horizontal": !1,
      class: "associated-topic-cards"
    }, null, 8, ["items", "section-title", "section-summary"])) : A("", !0);
  }
}), $H = /* @__PURE__ */ ge(NH, [["__scopeId", "data-v-17750fc2"]]), FH = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: $H
}, Symbol.toStringTag, { value: "Module" }));
function j1(t = "") {
  let e = "";
  const n = t.toLowerCase();
  switch (!0) {
    case n.includes("article"):
      e = "Read more";
      break;
    case n.includes("project"):
      e = "View project";
      break;
    case n.includes("event"):
      e = "View event";
      break;
    case n.includes("exhibition"):
      e = "View exhibition";
      break;
    case n.includes("collection"):
      e = "View collection";
      break;
    case n.includes("impactreportstory"):
      e = "Read full story";
      break;
  }
  return e;
}
const zH = { key: 0 }, UH = /* @__PURE__ */ Ce({
  __name: "BannerFeatured",
  props: {
    block: {
      type: Object,
      default: () => {
      }
    }
  },
  setup(t) {
    const e = I(() => {
      let f = {};
      return t.block.content[0].contentLink && t.block.content[0].contentLink.length > 0 && t.block.content[0].contentLink[0].heroImage && t.block.content[0].contentLink[0].heroImage.length > 0 ? f = t.block.content[0].contentLink[0].heroImage[0].image[0] : t.block.content[0].image && (f = t.block.content[0].image[0]), f;
    }), n = I(() => t.block.content[0].alignment === "right"), a = I(() => {
      let f = "";
      return t.block.content[0].contentType ? f = j1(t.block.content[0].contentType) : f = j1(t.block.content[0].contentLink[0].contentType), f;
    }), i = I(() => {
      let f = [];
      if (t.block.content && t.block.content[0].contentLink) {
        const m = t.block.content[0].contentLink[0].contentType.toLowerCase();
        switch (!0) {
          case m.includes("article"):
            f = t.block.content[0].contentLink[0].articleLocations;
            break;
          case m.includes("project"):
            f = t.block.content[0].contentLink[0].projectLocations;
            break;
          case m.includes("event"):
            f = t.block.content[0].contentLink[0].articleLocations;
            break;
        }
      }
      return t.block.content && t.block.content[0].location && f.push(t.block.content[0].location), f;
    }), r = I(() => {
      let f = "";
      if (t.block.content && t.block.content[0].category)
        return t.block.content[0].category;
      if (t.block.content && t.block.content[0].contentLink) {
        const m = t.block.content[0].contentLink[0].contentType, _ = t.block.content[0].contentLink[0].workshopOrEventSeriesType;
        switch (!0) {
          case m.includes("article"):
            f = t.block.content[0].contentLink[0].articleCategory.map((T) => T.title).toString();
            break;
          case m.includes("collection"):
            f = t.block.content[0].contentLink[0].physicalDigital[0];
            break;
          case m.includes("project"):
          case m.includes("event"):
          case m.includes("exhibition"):
          case m.includes("endowment"):
            f = m;
            break;
          case m.includes("impactReportStory"):
            f = "Spotlight";
            break;
          case m.includes("meapProject"):
            f = "Meap Project";
            break;
          case m.includes("meapArticle"):
            f = "Meap Article";
            break;
          case _.includes("help/services-resources"):
            f = "Workshop";
            break;
          case _.includes("visit/events-exhibitions"):
            f = "Event Series";
            break;
        }
      }
      return f;
    }), s = I(() => t.block.sectionTitle ? t.block.sectionTitle : r.value), o = I(() => {
      let f = "";
      return t.block.content && t.block.content[0].contentLink && t.block.content[0].contentLink[0].startDateWithTime ? f = t.block.content[0].contentLink[0].startDateWithTime : t.block.content && t.block.content[0].contentLink && t.block.content[0].contentLink[0].startDate && (f = t.block.content[0].contentLink[0].startDate), f;
    }), l = I(() => {
      let f = "";
      return t.block.content && t.block.content[0].contentLink && t.block.content[0].contentLink[0].endDateWithTime ? f = t.block.content[0].contentLink[0].endDateWithTime : t.block.content && t.block.content[0].contentLink && t.block.content[0].contentLink[0].endDate && (f = t.block.content[0].contentLink[0].endDate), f;
    }), c = I(() => {
      const f = [];
      if (t.block.content && t.block.content[0].contentLink) {
        const m = t.block.content[0].contentLink[0].contentType.toLowerCase(), _ = t.block.content[0].contentLink[0].articleByline1, T = t.block.content[0].contentLink[0].projectByline1, g = Ct(
          new Date(t.block.content[0].contentLink[0].articleByline2),
          "MMMM d, Y"
        );
        switch (!0) {
          case m.includes("article"):
            _ && _.forEach((x) => f.push(x.title)), f.push(g);
            break;
          case m.includes("project"):
            T && f.push(T[0].title);
            break;
        }
      }
      return t.block.content && (t.block.content[0].byline1 || t.block.content[0].byline2) && (f.push(t.block.content[0].byline1), f.push(t.block.content[0].byline2)), f;
    }), u = I(() => {
      let f = "";
      return t.block.content && t.block.content[0].contentLink && t.block.content[0].contentLink[0].contentType === "event" ? f = t.block.content[0].contentLink[0].eventDescription : f = t.block.content[0].contentLink[0].summary, f;
    });
    return (f, m) => t.block && t.block.content ? (h(), b("div", zH, [
      t.block && t.block.content && t.block.content[0].contentLink ? (h(), G(Pm, {
        key: 0,
        class: "flexible-banner-featured",
        media: e.value,
        to: O($n)(t.block.content[0].contentLink[0].to),
        title: t.block.content[0].contentLink[0].title,
        breadcrumb: s.value,
        byline: c.value,
        description: u.value,
        prompt: a.value,
        locations: i.value,
        category: r.value,
        "start-date": o.value,
        "end-date": l.value,
        "section-handle": t.block.content[0].contentLink[0].contentType
      }, null, 8, ["media", "to", "title", "breadcrumb", "byline", "description", "prompt", "locations", "category", "start-date", "end-date", "section-handle"])) : A("", !0),
      t.block && t.block.content && !t.block.content[0].contentLink ? (h(), G(Pm, {
        key: 1,
        class: "flexible-banner-featured",
        media: e.value,
        to: O($n)(t.block.content[0].to),
        title: t.block.content[0].title,
        breadcrumb: s.value,
        byline: c.value,
        description: t.block.content[0].summary,
        prompt: a.value,
        locations: i.value,
        category: r.value,
        "align-right": n.value,
        "section-handle": t.block.content[0].sectionHandle
      }, null, 8, ["media", "to", "title", "breadcrumb", "byline", "description", "prompt", "locations", "category", "align-right", "section-handle"])) : A("", !0)
    ])) : A("", !0);
  }
}), HH = /* @__PURE__ */ ge(UH, [["__scopeId", "data-v-046e78ae"]]), YH = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: HH
}, Symbol.toStringTag, { value: "Module" }));
var jH = ju;
function VH() {
  this.__data__ = new jH(), this.size = 0;
}
var qH = VH;
function WH(t) {
  var e = this.__data__, n = e.delete(t);
  return this.size = e.size, n;
}
var GH = WH;
function XH(t) {
  return this.__data__.get(t);
}
var ZH = XH;
function KH(t) {
  return this.__data__.has(t);
}
var QH = KH, JH = ju, eY = Kh, tY = Qh, nY = 200;
function aY(t, e) {
  var n = this.__data__;
  if (n instanceof JH) {
    var a = n.__data__;
    if (!eY || a.length < nY - 1)
      return a.push([t, e]), this.size = ++n.size, this;
    n = this.__data__ = new tY(a);
  }
  return n.set(t, e), this.size = n.size, this;
}
var iY = aY, rY = ju, sY = qH, oY = GH, lY = ZH, cY = QH, uY = iY;
function so(t) {
  var e = this.__data__ = new rY(t);
  this.size = e.size;
}
so.prototype.clear = sY;
so.prototype.delete = oY;
so.prototype.get = lY;
so.prototype.has = cY;
so.prototype.set = uY;
var dY = so;
function hY(t, e) {
  for (var n = -1, a = t == null ? 0 : t.length; ++n < a && e(t[n], n, t) !== !1; )
    ;
  return t;
}
var fY = hY, pY = Yr, mY = function() {
  try {
    var t = pY(Object, "defineProperty");
    return t({}, "", {}), t;
  } catch {
  }
}(), Ey = mY, V1 = Ey;
function gY(t, e, n) {
  e == "__proto__" && V1 ? V1(t, e, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : t[e] = n;
}
var Ly = gY, bY = Ly, vY = _2, yY = Object.prototype, _Y = yY.hasOwnProperty;
function TY(t, e, n) {
  var a = t[e];
  (!(_Y.call(t, e) && vY(a, n)) || n === void 0 && !(e in t)) && bY(t, e, n);
}
var Dy = TY, xY = Dy, wY = Ly;
function kY(t, e, n, a) {
  var i = !n;
  n || (n = {});
  for (var r = -1, s = e.length; ++r < s; ) {
    var o = e[r], l = a ? a(n[o], t[o], o, n, t) : void 0;
    l === void 0 && (l = t[o]), i ? wY(n, o, l) : xY(n, o, l);
  }
  return n;
}
var Ul = kY;
function CY(t, e) {
  for (var n = -1, a = Array(t); ++n < t; )
    a[n] = e(n);
  return a;
}
var SY = CY, AY = Ur, EY = sr, LY = "[object Arguments]";
function DY(t) {
  return EY(t) && AY(t) == LY;
}
var IY = DY, q1 = IY, MY = sr, Iy = Object.prototype, OY = Iy.hasOwnProperty, PY = Iy.propertyIsEnumerable, BY = q1(/* @__PURE__ */ function() {
  return arguments;
}()) ? q1 : function(t) {
  return MY(t) && OY.call(t, "callee") && !PY.call(t, "callee");
}, Sf = BY, du = { exports: {} };
function RY() {
  return !1;
}
var NY = RY;
du.exports;
(function(t, e) {
  var n = oi, a = NY, i = e && !e.nodeType && e, r = i && !0 && t && !t.nodeType && t, s = r && r.exports === i, o = s ? n.Buffer : void 0, l = o ? o.isBuffer : void 0, c = l || a;
  t.exports = c;
})(du, du.exports);
var Af = du.exports, $Y = 9007199254740991, FY = /^(?:0|[1-9]\d*)$/;
function zY(t, e) {
  var n = typeof t;
  return e = e ?? $Y, !!e && (n == "number" || n != "symbol" && FY.test(t)) && t > -1 && t % 1 == 0 && t < e;
}
var UY = zY, HY = 9007199254740991;
function YY(t) {
  return typeof t == "number" && t > -1 && t % 1 == 0 && t <= HY;
}
var My = YY, jY = Ur, VY = My, qY = sr, WY = "[object Arguments]", GY = "[object Array]", XY = "[object Boolean]", ZY = "[object Date]", KY = "[object Error]", QY = "[object Function]", JY = "[object Map]", ej = "[object Number]", tj = "[object Object]", nj = "[object RegExp]", aj = "[object Set]", ij = "[object String]", rj = "[object WeakMap]", sj = "[object ArrayBuffer]", oj = "[object DataView]", lj = "[object Float32Array]", cj = "[object Float64Array]", uj = "[object Int8Array]", dj = "[object Int16Array]", hj = "[object Int32Array]", fj = "[object Uint8Array]", pj = "[object Uint8ClampedArray]", mj = "[object Uint16Array]", gj = "[object Uint32Array]", It = {};
It[lj] = It[cj] = It[uj] = It[dj] = It[hj] = It[fj] = It[pj] = It[mj] = It[gj] = !0;
It[WY] = It[GY] = It[sj] = It[XY] = It[oj] = It[ZY] = It[KY] = It[QY] = It[JY] = It[ej] = It[tj] = It[nj] = It[aj] = It[ij] = It[rj] = !1;
function bj(t) {
  return qY(t) && VY(t.length) && !!It[jY(t)];
}
var vj = bj, yj = vj, _j = Wu, W1 = Gu, G1 = W1 && W1.isTypedArray, Tj = G1 ? _j(G1) : yj, Oy = Tj, xj = SY, wj = Sf, kj = rr, Cj = Af, Sj = UY, Aj = Oy, Ej = Object.prototype, Lj = Ej.hasOwnProperty;
function Dj(t, e) {
  var n = kj(t), a = !n && wj(t), i = !n && !a && Cj(t), r = !n && !a && !i && Aj(t), s = n || a || i || r, o = s ? xj(t.length, String) : [], l = o.length;
  for (var c in t)
    (e || Lj.call(t, c)) && !(s && // Safari 9 has enumerable `arguments.length` in strict mode.
    (c == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    i && (c == "offset" || c == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    r && (c == "buffer" || c == "byteLength" || c == "byteOffset") || // Skip index properties.
    Sj(c, l))) && o.push(c);
  return o;
}
var Py = Dj, Ij = Object.prototype;
function Mj(t) {
  var e = t && t.constructor, n = typeof e == "function" && e.prototype || Ij;
  return t === n;
}
var rd = Mj;
function Oj(t, e) {
  return function(n) {
    return t(e(n));
  };
}
var By = Oj, Pj = By, Bj = Pj(Object.keys, Object), Rj = Bj, Nj = rd, $j = Rj, Fj = Object.prototype, zj = Fj.hasOwnProperty;
function Uj(t) {
  if (!Nj(t))
    return $j(t);
  var e = [];
  for (var n in Object(t))
    zj.call(t, n) && n != "constructor" && e.push(n);
  return e;
}
var Ry = Uj, Hj = v2, Yj = My;
function jj(t) {
  return t != null && Yj(t.length) && !Hj(t);
}
var Ef = jj, Vj = Py, qj = Ry, Wj = Ef;
function Gj(t) {
  return Wj(t) ? Vj(t) : qj(t);
}
var Lf = Gj, Xj = Ul, Zj = Lf;
function Kj(t, e) {
  return t && Xj(e, Zj(e), t);
}
var Qj = Kj;
function Jj(t) {
  var e = [];
  if (t != null)
    for (var n in Object(t))
      e.push(n);
  return e;
}
var eV = Jj, tV = Hr, nV = rd, aV = eV, iV = Object.prototype, rV = iV.hasOwnProperty;
function sV(t) {
  if (!tV(t))
    return aV(t);
  var e = nV(t), n = [];
  for (var a in t)
    a == "constructor" && (e || !rV.call(t, a)) || n.push(a);
  return n;
}
var oV = sV, lV = Py, cV = oV, uV = Ef;
function dV(t) {
  return uV(t) ? lV(t, !0) : cV(t);
}
var Df = dV, hV = Ul, fV = Df;
function pV(t, e) {
  return t && hV(e, fV(e), t);
}
var mV = pV, hu = { exports: {} };
hu.exports;
(function(t, e) {
  var n = oi, a = e && !e.nodeType && e, i = a && !0 && t && !t.nodeType && t, r = i && i.exports === a, s = r ? n.Buffer : void 0, o = s ? s.allocUnsafe : void 0;
  function l(c, u) {
    if (u)
      return c.slice();
    var f = c.length, m = o ? o(f) : new c.constructor(f);
    return c.copy(m), m;
  }
  t.exports = l;
})(hu, hu.exports);
var gV = hu.exports;
function bV(t, e) {
  var n = -1, a = t.length;
  for (e || (e = Array(a)); ++n < a; )
    e[n] = t[n];
  return e;
}
var vV = bV;
function yV(t, e) {
  for (var n = -1, a = t == null ? 0 : t.length, i = 0, r = []; ++n < a; ) {
    var s = t[n];
    e(s, n, t) && (r[i++] = s);
  }
  return r;
}
var _V = yV;
function TV() {
  return [];
}
var Ny = TV, xV = _V, wV = Ny, kV = Object.prototype, CV = kV.propertyIsEnumerable, X1 = Object.getOwnPropertySymbols, SV = X1 ? function(t) {
  return t == null ? [] : (t = Object(t), xV(X1(t), function(e) {
    return CV.call(t, e);
  }));
} : wV, If = SV, AV = Ul, EV = If;
function LV(t, e) {
  return AV(t, EV(t), e);
}
var DV = LV;
function IV(t, e) {
  for (var n = -1, a = e.length, i = t.length; ++n < a; )
    t[i + n] = e[n];
  return t;
}
var Mf = IV, MV = By, OV = MV(Object.getPrototypeOf, Object), Of = OV, PV = Mf, BV = Of, RV = If, NV = Ny, $V = Object.getOwnPropertySymbols, FV = $V ? function(t) {
  for (var e = []; t; )
    PV(e, RV(t)), t = BV(t);
  return e;
} : NV, $y = FV, zV = Ul, UV = $y;
function HV(t, e) {
  return zV(t, UV(t), e);
}
var YV = HV, jV = Mf, VV = rr;
function qV(t, e, n) {
  var a = e(t);
  return VV(t) ? a : jV(a, n(t));
}
var Fy = qV, WV = Fy, GV = If, XV = Lf;
function ZV(t) {
  return WV(t, XV, GV);
}
var KV = ZV, QV = Fy, JV = $y, eq = Df;
function tq(t) {
  return QV(t, eq, JV);
}
var zy = tq, nq = Yr, aq = oi, iq = nq(aq, "DataView"), rq = iq, sq = Yr, oq = oi, lq = sq(oq, "Promise"), cq = lq, uq = Yr, dq = oi, hq = uq(dq, "WeakMap"), fq = hq, oh = rq, lh = Kh, ch = cq, uh = T2, dh = fq, Uy = Ur, oo = y2, Z1 = "[object Map]", pq = "[object Object]", K1 = "[object Promise]", Q1 = "[object Set]", J1 = "[object WeakMap]", eg = "[object DataView]", mq = oo(oh), gq = oo(lh), bq = oo(ch), vq = oo(uh), yq = oo(dh), yr = Uy;
(oh && yr(new oh(new ArrayBuffer(1))) != eg || lh && yr(new lh()) != Z1 || ch && yr(ch.resolve()) != K1 || uh && yr(new uh()) != Q1 || dh && yr(new dh()) != J1) && (yr = function(t) {
  var e = Uy(t), n = e == pq ? t.constructor : void 0, a = n ? oo(n) : "";
  if (a)
    switch (a) {
      case mq:
        return eg;
      case gq:
        return Z1;
      case bq:
        return K1;
      case vq:
        return Q1;
      case yq:
        return J1;
    }
  return e;
});
var sd = yr, _q = Object.prototype, Tq = _q.hasOwnProperty;
function xq(t) {
  var e = t.length, n = new t.constructor(e);
  return e && typeof t[0] == "string" && Tq.call(t, "index") && (n.index = t.index, n.input = t.input), n;
}
var wq = xq, kq = oi, Cq = kq.Uint8Array, Sq = Cq, tg = Sq;
function Aq(t) {
  var e = new t.constructor(t.byteLength);
  return new tg(e).set(new tg(t)), e;
}
var Pf = Aq, Eq = Pf;
function Lq(t, e) {
  var n = e ? Eq(t.buffer) : t.buffer;
  return new t.constructor(n, t.byteOffset, t.byteLength);
}
var Dq = Lq, Iq = /\w*$/;
function Mq(t) {
  var e = new t.constructor(t.source, Iq.exec(t));
  return e.lastIndex = t.lastIndex, e;
}
var Oq = Mq, ng = Ol, ag = ng ? ng.prototype : void 0, ig = ag ? ag.valueOf : void 0;
function Pq(t) {
  return ig ? Object(ig.call(t)) : {};
}
var Bq = Pq, Rq = Pf;
function Nq(t, e) {
  var n = e ? Rq(t.buffer) : t.buffer;
  return new t.constructor(n, t.byteOffset, t.length);
}
var $q = Nq, Fq = Pf, zq = Dq, Uq = Oq, Hq = Bq, Yq = $q, jq = "[object Boolean]", Vq = "[object Date]", qq = "[object Map]", Wq = "[object Number]", Gq = "[object RegExp]", Xq = "[object Set]", Zq = "[object String]", Kq = "[object Symbol]", Qq = "[object ArrayBuffer]", Jq = "[object DataView]", eW = "[object Float32Array]", tW = "[object Float64Array]", nW = "[object Int8Array]", aW = "[object Int16Array]", iW = "[object Int32Array]", rW = "[object Uint8Array]", sW = "[object Uint8ClampedArray]", oW = "[object Uint16Array]", lW = "[object Uint32Array]";
function cW(t, e, n) {
  var a = t.constructor;
  switch (e) {
    case Qq:
      return Fq(t);
    case jq:
    case Vq:
      return new a(+t);
    case Jq:
      return zq(t, n);
    case eW:
    case tW:
    case nW:
    case aW:
    case iW:
    case rW:
    case sW:
    case oW:
    case lW:
      return Yq(t, n);
    case qq:
      return new a();
    case Wq:
    case Zq:
      return new a(t);
    case Gq:
      return Uq(t);
    case Xq:
      return new a();
    case Kq:
      return Hq(t);
  }
}
var uW = cW, dW = Hr, rg = Object.create, hW = /* @__PURE__ */ function() {
  function t() {
  }
  return function(e) {
    if (!dW(e))
      return {};
    if (rg)
      return rg(e);
    t.prototype = e;
    var n = new t();
    return t.prototype = void 0, n;
  };
}(), fW = hW, pW = fW, mW = Of, gW = rd;
function bW(t) {
  return typeof t.constructor == "function" && !gW(t) ? pW(mW(t)) : {};
}
var vW = bW, yW = sd, _W = sr, TW = "[object Map]";
function xW(t) {
  return _W(t) && yW(t) == TW;
}
var wW = xW, kW = wW, CW = Wu, sg = Gu, og = sg && sg.isMap, SW = og ? CW(og) : kW, AW = SW, EW = sd, LW = sr, DW = "[object Set]";
function IW(t) {
  return LW(t) && EW(t) == DW;
}
var MW = IW, OW = MW, PW = Wu, lg = Gu, cg = lg && lg.isSet, BW = cg ? PW(cg) : OW, RW = BW, NW = dY, $W = fY, FW = Dy, zW = Qj, UW = mV, HW = gV, YW = vV, jW = DV, VW = YV, qW = KV, WW = zy, GW = sd, XW = wq, ZW = uW, KW = vW, QW = rr, JW = Af, eG = AW, tG = Hr, nG = RW, aG = Lf, iG = Df, rG = 1, sG = 2, oG = 4, Hy = "[object Arguments]", lG = "[object Array]", cG = "[object Boolean]", uG = "[object Date]", dG = "[object Error]", Yy = "[object Function]", hG = "[object GeneratorFunction]", fG = "[object Map]", pG = "[object Number]", jy = "[object Object]", mG = "[object RegExp]", gG = "[object Set]", bG = "[object String]", vG = "[object Symbol]", yG = "[object WeakMap]", _G = "[object ArrayBuffer]", TG = "[object DataView]", xG = "[object Float32Array]", wG = "[object Float64Array]", kG = "[object Int8Array]", CG = "[object Int16Array]", SG = "[object Int32Array]", AG = "[object Uint8Array]", EG = "[object Uint8ClampedArray]", LG = "[object Uint16Array]", DG = "[object Uint32Array]", At = {};
At[Hy] = At[lG] = At[_G] = At[TG] = At[cG] = At[uG] = At[xG] = At[wG] = At[kG] = At[CG] = At[SG] = At[fG] = At[pG] = At[jy] = At[mG] = At[gG] = At[bG] = At[vG] = At[AG] = At[EG] = At[LG] = At[DG] = !0;
At[dG] = At[Yy] = At[yG] = !1;
function Yc(t, e, n, a, i, r) {
  var s, o = e & rG, l = e & sG, c = e & oG;
  if (n && (s = i ? n(t, a, i, r) : n(t)), s !== void 0)
    return s;
  if (!tG(t))
    return t;
  var u = QW(t);
  if (u) {
    if (s = XW(t), !o)
      return YW(t, s);
  } else {
    var f = GW(t), m = f == Yy || f == hG;
    if (JW(t))
      return HW(t, o);
    if (f == jy || f == Hy || m && !i) {
      if (s = l || m ? {} : KW(t), !o)
        return l ? VW(t, UW(s, t)) : jW(t, zW(s, t));
    } else {
      if (!At[f])
        return i ? t : {};
      s = ZW(t, f, o);
    }
  }
  r || (r = new NW());
  var _ = r.get(t);
  if (_)
    return _;
  r.set(t, s), nG(t) ? t.forEach(function(x) {
    s.add(Yc(x, e, n, x, t, r));
  }) : eG(t) && t.forEach(function(x, S) {
    s.set(S, Yc(x, e, n, S, t, r));
  });
  var T = c ? l ? WW : qW : l ? iG : aG, g = u ? void 0 : T(t);
  return $W(g || t, function(x, S) {
    g && (S = x, x = t[S]), FW(s, S, Yc(x, e, n, S, t, r));
  }), s;
}
var IG = Yc, MG = rr, OG = qu, PG = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, BG = /^\w*$/;
function RG(t, e) {
  if (MG(t))
    return !1;
  var n = typeof t;
  return n == "number" || n == "symbol" || n == "boolean" || t == null || OG(t) ? !0 : BG.test(t) || !PG.test(t) || e != null && t in Object(e);
}
var NG = RG, Vy = Qh, $G = "Expected a function";
function Bf(t, e) {
  if (typeof t != "function" || e != null && typeof e != "function")
    throw new TypeError($G);
  var n = function() {
    var a = arguments, i = e ? e.apply(this, a) : a[0], r = n.cache;
    if (r.has(i))
      return r.get(i);
    var s = t.apply(this, a);
    return n.cache = r.set(i, s) || r, s;
  };
  return n.cache = new (Bf.Cache || Vy)(), n;
}
Bf.Cache = Vy;
var FG = Bf, zG = FG, UG = 500;
function HG(t) {
  var e = zG(t, function(a) {
    return n.size === UG && n.clear(), a;
  }), n = e.cache;
  return e;
}
var YG = HG, jG = YG, VG = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, qG = /\\(\\)?/g, WG = jG(function(t) {
  var e = [];
  return t.charCodeAt(0) === 46 && e.push(""), t.replace(VG, function(n, a, i, r) {
    e.push(i ? r.replace(qG, "$1") : a || n);
  }), e;
}), GG = WG, XG = rr, ZG = NG, KG = GG, QG = Pl;
function JG(t, e) {
  return XG(t) ? t : ZG(t, e) ? [t] : KG(QG(t));
}
var Rf = JG;
function eX(t) {
  var e = t == null ? 0 : t.length;
  return e ? t[e - 1] : void 0;
}
var tX = eX, nX = qu;
function aX(t) {
  if (typeof t == "string" || nX(t))
    return t;
  var e = t + "";
  return e == "0" && 1 / t == -1 / 0 ? "-0" : e;
}
var qy = aX, iX = Rf, rX = qy;
function sX(t, e) {
  e = iX(e, t);
  for (var n = 0, a = e.length; t != null && n < a; )
    t = t[rX(e[n++])];
  return n && n == a ? t : void 0;
}
var Wy = sX, oX = Wy, lX = I2;
function cX(t, e) {
  return e.length < 2 ? t : oX(t, lX(e, 0, -1));
}
var uX = cX, dX = Rf, hX = tX, fX = uX, pX = qy;
function mX(t, e) {
  return e = dX(e, t), t = fX(t, e), t == null || delete t[pX(hX(e))];
}
var gX = mX, bX = Ur, vX = Of, yX = sr, _X = "[object Object]", TX = Function.prototype, xX = Object.prototype, Gy = TX.toString, wX = xX.hasOwnProperty, kX = Gy.call(Object);
function CX(t) {
  if (!yX(t) || bX(t) != _X)
    return !1;
  var e = vX(t);
  if (e === null)
    return !0;
  var n = wX.call(e, "constructor") && e.constructor;
  return typeof n == "function" && n instanceof n && Gy.call(n) == kX;
}
var SX = CX, AX = SX;
function EX(t) {
  return AX(t) ? void 0 : t;
}
var LX = EX, ug = Ol, DX = Sf, IX = rr, dg = ug ? ug.isConcatSpreadable : void 0;
function MX(t) {
  return IX(t) || DX(t) || !!(dg && t && t[dg]);
}
var OX = MX, PX = Mf, BX = OX;
function Xy(t, e, n, a, i) {
  var r = -1, s = t.length;
  for (n || (n = BX), i || (i = []); ++r < s; ) {
    var o = t[r];
    e > 0 && n(o) ? e > 1 ? Xy(o, e - 1, n, a, i) : PX(i, o) : a || (i[i.length] = o);
  }
  return i;
}
var RX = Xy, NX = RX;
function $X(t) {
  var e = t == null ? 0 : t.length;
  return e ? NX(t, 1) : [];
}
var FX = $X;
function zX(t, e, n) {
  switch (n.length) {
    case 0:
      return t.call(e);
    case 1:
      return t.call(e, n[0]);
    case 2:
      return t.call(e, n[0], n[1]);
    case 3:
      return t.call(e, n[0], n[1], n[2]);
  }
  return t.apply(e, n);
}
var UX = zX, HX = UX, hg = Math.max;
function YX(t, e, n) {
  return e = hg(e === void 0 ? t.length - 1 : e, 0), function() {
    for (var a = arguments, i = -1, r = hg(a.length - e, 0), s = Array(r); ++i < r; )
      s[i] = a[e + i];
    i = -1;
    for (var o = Array(e + 1); ++i < e; )
      o[i] = a[i];
    return o[e] = n(s), HX(t, this, o);
  };
}
var jX = YX;
function VX(t) {
  return function() {
    return t;
  };
}
var qX = VX;
function WX(t) {
  return t;
}
var GX = WX, XX = qX, fg = Ey, ZX = GX, KX = fg ? function(t, e) {
  return fg(t, "toString", {
    configurable: !0,
    enumerable: !1,
    value: XX(e),
    writable: !0
  });
} : ZX, QX = KX, JX = 800, eZ = 16, tZ = Date.now;
function nZ(t) {
  var e = 0, n = 0;
  return function() {
    var a = tZ(), i = eZ - (a - n);
    if (n = a, i > 0) {
      if (++e >= JX)
        return arguments[0];
    } else
      e = 0;
    return t.apply(void 0, arguments);
  };
}
var aZ = nZ, iZ = QX, rZ = aZ, sZ = rZ(iZ), oZ = sZ, lZ = FX, cZ = jX, uZ = oZ;
function dZ(t) {
  return uZ(cZ(t, void 0, lZ), t + "");
}
var hZ = dZ, fZ = E2, pZ = IG, mZ = gX, gZ = Rf, bZ = Ul, vZ = LX, yZ = hZ, _Z = zy, TZ = 1, xZ = 2, wZ = 4, kZ = yZ(function(t, e) {
  var n = {};
  if (t == null)
    return n;
  var a = !1;
  e = fZ(e, function(r) {
    return r = gZ(r, t), a || (a = r.length > 1), r;
  }), bZ(t, _Z(t), n), a && (n = pZ(n, TZ | xZ | wZ, vZ));
  for (var i = e.length; i--; )
    mZ(n, e[i]);
  return n;
}), CZ = kZ;
const SZ = /* @__PURE__ */ ka(CZ), AZ = {
  __name: "SectionHeader",
  props: {
    theme: {
      type: String,
      default: "white"
    },
    level: {
      type: Number,
      default: 0
    }
  },
  setup(t) {
    const e = t, n = wn("sectionLevel", 1), a = I(() => Number(e.level || n)), i = I(() => ["section-header", `section-header${a.value}`]), r = I(() => a.value >= 1 && a.value <= 6 ? `h${a.value}` : "h6");
    return (s, o) => (h(), G(dt(r.value), {
      class: re(i.value)
    }, {
      default: oe(() => [
        me(s.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }, 8, ["class"]));
  }
}, Nf = /* @__PURE__ */ ge(AZ, [["__scopeId", "data-v-543c1eb7"]]);
function EZ(t) {
  return t.replace("&", "").replace(/\s+/g, " ").trim().toLowerCase().replace(/ /g, "-");
}
const LZ = ["id"], DZ = {
  key: 1,
  class: "section-header"
}, IZ = { class: "section-link" }, MZ = /* @__PURE__ */ Ce({
  __name: "SectionWrapper",
  props: {
    sectionTitle: {
      type: String,
      default: ""
    },
    sectionSummary: {
      type: String,
      default: ""
    },
    theme: {
      type: String,
      default: "white"
    },
    level: {
      type: Number,
      default: 0
    },
    noMargins: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    const e = t, n = wn("sectionLevel", 1), a = wn("ancestorSetMargins", !1), i = qe(), r = I(() => Number(e.level || n + 1)), s = I(() => !(e.noMargins || a));
    ba("sectionLevel", r.value), ba("ancestorSetMargins", a || s.value);
    const o = I(() => [
      "section-wrapper",
      `section-wrapper${r.value}`,
      `theme-${e.theme}`,
      { "top-level": s.value },
      (i == null ? void 0 : i.value) || ""
    ]), l = I(() => EZ(e.sectionTitle));
    return (c, u) => (h(), b("section", {
      class: re(o.value)
    }, [
      t.sectionTitle ? (h(), b("a", {
        key: 0,
        id: l.value
      }, null, 8, LZ)) : A("", !0),
      t.sectionTitle ? (h(), b("div", DZ, [
        t.sectionTitle ? (h(), G(Nf, {
          key: 0,
          class: "section-title",
          textContent: ne(t.sectionTitle)
        }, null, 8, ["textContent"])) : A("", !0),
        k("div", IZ, [
          me(c.$slots, "top-right", { class: "" }, void 0, !0)
        ]),
        t.sectionSummary ? (h(), G(un, {
          key: 1,
          class: "section-summary",
          innerHTML: t.sectionSummary
        }, null, 8, ["innerHTML"])) : A("", !0)
      ])) : A("", !0),
      me(c.$slots, "default", {}, void 0, !0)
    ], 2));
  }
}), cl = /* @__PURE__ */ ge(MZ, [["__scopeId", "data-v-9d45978a"]]), OZ = {};
function PZ(t, e) {
  return me(t.$slots, "default");
}
const pg = /* @__PURE__ */ ge(OZ, [["render", PZ]]), BZ = {
  __name: "FlexibleBlocks",
  props: {
    blocks: {
      type: Array,
      default: () => []
    }
  },
  setup(t) {
    const e = t, n = qe(), a = ve(
      () => Promise.resolve().then(() => FH)
    ), i = ve(
      () => Promise.resolve().then(() => YH)
    ), r = ve(
      () => import("./CallToAction-Cb2zpD6U.js")
    ), s = ve(
      () => Promise.resolve().then(() => VZ)
    ), o = ve(
      () => Promise.resolve().then(() => JZ)
    ), l = ve(
      () => Promise.resolve().then(() => gK)
    ), c = ve(
      () => Promise.resolve().then(() => kK)
    ), u = ve(
      () => import("./HorizontalDivider-CtIVLQXd.js")
    ), f = ve(
      () => Promise.resolve().then(() => NK)
    ), m = ve(
      () => Promise.resolve().then(() => pQ)
    ), _ = ve(
      () => Promise.resolve().then(() => yQ)
    ), T = ve(
      () => Promise.resolve().then(() => Yse)
    ), g = ve(
      () => Promise.resolve().then(() => Zse)
    ), x = ve(
      () => Promise.resolve().then(() => noe)
    ), S = ve(
      () => Promise.resolve().then(() => ooe)
    ), D = ve(
      () => import("./SimpleCards-CeA2ajsC.js")
    ), L = ve(
      () => Promise.resolve().then(() => nde)
    ), M = {
      "flexible-associated-topic-cards": a,
      "flexible-banner-featured": i,
      "flexible-call-to-action": r,
      "flexible-card-with-image": s,
      "flexible-form": o,
      "flexible-grid-gallery-cards": l,
      "flexible-highlight": c,
      "flexible-horizontal-divider": u,
      "flexible-impact-number-cards": f,
      "flexible-impact-numbers-carousel": m,
      "flexible-info-block": _,
      "flexible-media-gallery": T,
      "flexible-media-with-text": g,
      "flexible-pull-quote": x,
      "flexible-rich-text": S,
      "flexible-simple-cards": D
      // Add other components here if needed
    }, E = [
      "flexible-associated-topic-cards",
      "flexible-banner-featured",
      "flexible-divider-general",
      "flexible-form",
      "flexible-impact-numbers-carousel",
      "flexible-pull-quote",
      "flexible-simple-cards",
      "flexible-call-to-action",
      "flexible-cta-block2-up",
      "flexible-impact-number-cards",
      "flexible-grid-gallery-cards"
    ], P = I(() => ["flexible-blocks", (n == null ? void 0 : n.value) || ""]), B = I(() => {
      const Z = e.blocks.map(($) => ({
        ...$,
        componentName: z($.typeHandle),
        theme: "white",
        // Default theme to white
        needsDivider: !1
        // Default no divider
      }));
      return Z.forEach(($, J, N) => {
        (n == null ? void 0 : n.value) === "ftva" ? ($.theme = "white", $.needsDivider = !1) : (J > 0 && N[J - 1].theme === "white" && !E.includes($.componentName) && J < N.length - 1 && ($.theme = "gray"), J > 0 && $.theme === "white" && N[J - 1].theme === "white" && ($.needsDivider = !0));
      }), Z.filter(
        ($) => Object.keys(M).includes($.componentName)
      );
    });
    function z(Z) {
      return Ay(`flexible-${Z}`);
    }
    function W(Z) {
      return Z.mediaGalleryStyle !== void 0;
    }
    function V(Z) {
      return W(Z) && Z.mediaGalleryStyle === "halfWidth" ? "" : Z.sectionTitle;
    }
    function H(Z) {
      return Z.mediaGalleryStyle === "halfWidth" ? "" : Z.sectionSummary || Z.richTextSimplified;
    }
    function se(Z) {
      return M[Z];
    }
    function ie(Z) {
      return (n == null ? void 0 : n.value) !== "ftva" ? pg : Z.componentName === "flexible-card-with-image" && Z.cardWithImageType === "horizontalScroll" ? L : pg;
    }
    return (Z, $) => (h(), G(cl, {
      class: re(P.value),
      "no-margins": !0
    }, {
      default: oe(() => [
        Q(Nf, { class: "more-information" }, {
          default: oe(() => $[0] || ($[0] = [
            ze(" More Information ")
          ])),
          _: 1
        }),
        (h(!0), b(he, null, Le(B.value, (J, N) => (h(), b("div", {
          key: `flexibleblocks-${N}`
        }, [
          J.needsDivider ? (h(), G(cl, {
            key: 0,
            theme: "divider"
          }, {
            default: oe(() => [
              Q(bl)
            ]),
            _: 1
          })) : A("", !0),
          Q(cl, {
            theme: J.theme,
            "section-title": V(J),
            "section-summary": H(J),
            class: "flexible-block-section-wrapper"
          }, {
            default: oe(() => [
              (h(), G(dt(ie(J)), null, {
                default: oe(() => [
                  (h(), G(dt(se(J.componentName)), {
                    block: J.mediaGalleryStyle === "halfWidth" ? J : O(SZ)(J, ["sectionTitle", "sectionSummary"]),
                    class: "flexible-block"
                  }, null, 8, ["block"]))
                ]),
                _: 2
              }, 1024))
            ]),
            _: 2
          }, 1032, ["theme", "section-title", "section-summary"])
        ]))), 128))
      ]),
      _: 1
    }, 8, ["class"]));
  }
}, Phe = /* @__PURE__ */ ge(BZ, [["__scopeId", "data-v-386f2b0a"]]), Bhe = /* @__PURE__ */ Ce({
  __name: "CallToAction",
  props: {
    block: {
      type: Object,
      default: () => {
      }
    }
  },
  setup(t) {
    const e = I(() => t.block.callToAction[0]), n = qe(), a = I(() => ["flexible-block-call-to-action", (n == null ? void 0 : n.value) || ""]);
    return (i, r) => (h(), G(Jh, {
      class: re(a.value),
      to: e.value.buttonUrl,
      name: e.value.buttonText,
      title: e.value.titleCta,
      text: e.value.summary,
      "svg-name": e.value.icon,
      "is-dark": e.value.backgroundColor === "true"
    }, null, 8, ["class", "to", "name", "title", "text", "svg-name", "is-dark"]));
  }
});
var RZ = Wy;
function NZ(t, e, n) {
  var a = t == null ? void 0 : RZ(t, e);
  return a === void 0 ? n : a;
}
var $Z = NZ;
const it = /* @__PURE__ */ ka($Z), FZ = { class: "section-header" }, zZ = {
  key: 0,
  class: "section-title"
}, UZ = ["innerHTML"], HZ = { class: "block-group" }, YZ = /* @__PURE__ */ Ce({
  __name: "CardWithImage",
  props: {
    block: {
      type: Object,
      default: () => {
      }
    }
  },
  setup(t) {
    const e = qe(), n = (e == null ? void 0 : e.value) || "", a = t.block.cardWithImageType || "", i = I(() => ["card-with-image", (e == null ? void 0 : e.value) || "", a].filter(Boolean).join(" ").trim());
    function r(u) {
      return u.typeHandle === "externalContent" ? u.to : u.contentType === "article" || u.contentType === "generalContentPage" ? `https://www.library.ucla.edu/${u.uri}` : u.contentType === "ftvaGeneralContentPage" ? u.slug : u.uri;
    }
    function s(u) {
      return n === "ftva" && u.contentType === "ftvaEvent" ? Ct(new Date(u.startDateWithTime), "MMMM d, Y") : u.contentType === "ftvaArticle" ? Ct(new Date(u.postDate), "MMMM d, Y") : "";
    }
    function o(u) {
      return n === "ftva" && (u.contentType === "ftvaEvent" || u.contentType === "ftvaEventSeries" || u.contentType === "ftvaArticle" || u.contentType === "ftvaGeneralContentPage") ? u.imageCarousel && u.imageCarousel[0] && u.imageCarousel[0].image[0] || u.ftvaImage[0] || void 0 : u.contentType === "article" || u.contentType === "generalContentPage" || u.contentType === "collection" ? u.heroImage.length > 0 && u.heroImage[0].image[0] || void 0 : u.typeHandle === "externalContent" && u.image[0] || void 0;
    }
    const l = I(() => {
      const u = [];
      for (const f in t.block.cardWithImage)
        t.block.cardWithImage[f].typeHandle === "internalContent" && t.block.cardWithImage[f].contentLink && t.block.cardWithImage[f].contentLink.length > 0 ? u.push(t.block.cardWithImage[f].contentLink[0]) : t.block.cardWithImage[f].typeHandle !== "internalContent" && u.push(t.block.cardWithImage[f]);
      return u;
    }), c = I(() => l.value.filter((u) => u !== null).map((u) => n === "ftva" ? {
      ...u,
      to: r(u),
      title: u.eventTitle || u.title || u.titleGeneral,
      parsedImage: o(u),
      postDate: u.contentType === "ftvaArticle" ? "obj.postDate" : null,
      // byline2 Formats the date to April 3, 2025
      byline2: s(u)
    } : u.typeHandle !== "externalContent" && u.contentType.includes("article") ? {
      ...u,
      to: $n(u.to),
      parsedImage: it(
        u,
        "heroImage[0].image[0]",
        void 0
      ),
      parsedLocation: it(
        u,
        "associatedLocations",
        []
      ),
      parsedCategory: it(
        u,
        "articleCategory[0].title",
        ""
      ),
      byline1: it(u, "articleByline1[0].title", ""),
      byline2: u.articleByline2 !== null ? ya(
        u.articleByline2,
        u.articleByline2
      ) : ""
    } : u.typeHandle !== "externalContent" && u.contentType.includes("meapProject") ? {
      ...u,
      to: $n(u.to),
      parsedImage: it(
        u,
        "heroImage[0].image[0]",
        void 0
      ),
      parsedLocation: it(u, "projectLocations", []),
      parsedCategory: it(u, "projectCategory", ""),
      byline1: it(u, "projectByline1[0].title", "")
    } : u.typeHandle !== "externalContent" && u.contentType === "event" ? {
      ...u,
      to: $n(u.to),
      parsedImage: it(
        u,
        "heroImage[0].image[0]",
        void 0
      ),
      parsedLocation: it(
        u,
        "associatedLocations",
        []
      ),
      parsedCategory: it(u, "eventType.title", ""),
      startDate: it(u, "startDateWithTime", ""),
      endDate: it(u, "endDateWithTime", ""),
      text: it(u, "eventDescription", "")
    } : u.typeHandle !== "externalContent" && (u.contentType === "exhibition" || !0) ? {
      ...u,
      to: $n(u.to),
      parsedImage: it(
        u,
        "heroImage[0].image[0]",
        void 0
      ),
      parsedLocation: it(
        u,
        "associatedLocations",
        []
      ),
      startDate: it(u, "startDate", ""),
      endDate: it(u, "endDate", "")
    } : u.typeHandle === "externalContent" ? {
      ...u,
      parsedImage: it(u, "image[0]", void 0),
      // parsedLocation:  obj.location !== null ? [obj.location] : [],
      parsedCategory: it(u, "category", "")
    } : {
      ...u,
      parsedImage: it(
        u,
        "heroImage[0].image[0]",
        void 0
      ),
      to: $n(u.to)
    }));
    return (u, f) => t.block.cardWithImage ? (h(), b("div", {
      key: 0,
      class: re(i.value)
    }, [
      k("div", FZ, [
        t.block.sectionTitle ? (h(), b("h2", zZ, ne(t.block.sectionTitle), 1)) : A("", !0),
        t.block.sectionSummary ? (h(), b("div", {
          key: 1,
          class: "section-summary",
          innerHTML: t.block.sectionSummary
        }, null, 8, UZ)) : A("", !0)
      ]),
      k("ul", HZ, [
        (h(!0), b(he, null, Le(c.value, (m, _) => (h(), G(Zh, {
          key: `FlexibleCardWithImage${_}`,
          to: m.to,
          image: m.parsedImage,
          category: m.parsedCategory,
          "byline-one": m.byline1,
          "byline-two": m.byline2,
          title: m.title,
          text: m.text,
          locations: m.parsedLocation,
          "image-aspect-ratio": 60,
          "is-vertical": !0,
          "start-date": m.startDate,
          "end-date": m.endDate,
          "section-handle": m.contentType,
          ongoing: m.ongoing,
          color: O(a),
          class: "block"
        }, null, 8, ["to", "image", "category", "byline-one", "byline-two", "title", "text", "locations", "start-date", "end-date", "section-handle", "ongoing", "color"]))), 128))
      ])
    ], 2)) : A("", !0);
  }
}), jZ = /* @__PURE__ */ ge(YZ, [["__scopeId", "data-v-ec579bc3"]]), VZ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: jZ
}, Symbol.toStringTag, { value: "Module" })), qZ = { class: "section-header" }, WZ = ["innerHTML"], GZ = ["innerHTML"], XZ = { class: "content" }, ZZ = ["srcdoc"], KZ = /* @__PURE__ */ Ce({
  __name: "Form",
  props: {
    block: {
      type: Object,
      default: () => {
      }
    }
  },
  setup(t) {
    const e = I(() => t.block.form), n = qe(), a = I(() => ["form", (n == null ? void 0 : n.value) || ""]);
    return (i, r) => (h(), b("div", {
      class: re(a.value)
    }, [
      k("div", qZ, [
        t.block.sectionTitle ? (h(), b("h2", {
          key: 0,
          class: "section-title",
          innerHTML: t.block.sectionTitle
        }, null, 8, WZ)) : A("", !0),
        t.block.sectionSummary ? (h(), b("div", {
          key: 1,
          class: "section-summary",
          innerHTML: t.block.sectionSummary
        }, null, 8, GZ)) : A("", !0)
      ]),
      k("div", XZ, [
        k("iframe", {
          id: "the-iframe",
          title: "Form",
          refs: "form_iframe",
          class: "iframe",
          srcdoc: e.value,
          frameBorder: "0",
          width: "100%",
          height: "100%",
          onload: "this.width=screen.width;this.height=screen.height;"
        }, null, 8, ZZ)
      ])
    ], 2));
  }
}), QZ = /* @__PURE__ */ ge(KZ, [["__scopeId", "data-v-e5f44e8b"]]), JZ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: QZ
}, Symbol.toStringTag, { value: "Module" })), eK = { class: "grid-gallery" }, tK = { class: "cards" }, nK = {
  key: 0,
  class: "title"
}, aK = ["innerHTML"], iK = {
  key: 2,
  class: "section-text"
}, rK = { class: "text" }, sK = {
  key: 0,
  class: "title"
}, oK = ["innerHTML"], lK = /* @__PURE__ */ Ce({
  __name: "GridGallery",
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  setup(t) {
    const e = I(() => t.items.map((n) => {
      let a = "card ";
      return n.featured && n.snippet ? a = `${a}card-featured` : n.featured && !n.snippet ? a = `${a}card-4up` : a = `${a}card-small`, {
        ...n,
        classes: a
      };
    }));
    return (n, a) => (h(), b("div", eK, [
      k("ul", tK, [
        (h(!0), b(he, null, Le(e.value, (i) => (h(), b("li", {
          key: i.to,
          class: re(i.classes)
        }, [
          Q(dn, {
            media: i.image,
            "aspect-ratio": 60,
            "object-fit": "cover"
          }, null, 8, ["media"]),
          i.headlineText && (i.featured && !i.snippet || !i.featured) ? (h(), b("h5", nK, [
            Q(Xe, {
              to: i.to,
              "link-target": "_blank",
              class: "link"
            }, {
              default: oe(() => [
                ze(ne(i.headlineText), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          ])) : A("", !0),
          !i.featured && i.snippet ? (h(), b("div", {
            key: 1,
            class: "snippet",
            innerHTML: i.snippet
          }, null, 8, aK)) : A("", !0),
          i.featured && i.snippet ? (h(), b("div", iK, [
            k("div", rK, [
              i.headlineText ? (h(), b("h5", sK, [
                Q(Xe, {
                  to: i.to,
                  "link-target": "_blank",
                  class: "link"
                }, {
                  default: oe(() => [
                    ze(ne(i.headlineText), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ])) : A("", !0),
              k("div", {
                class: "snippet",
                innerHTML: i.snippet
              }, null, 8, oK)
            ])
          ])) : A("", !0)
        ], 2))), 128))
      ])
    ]));
  }
}), cK = /* @__PURE__ */ ge(lK, [["__scopeId", "data-v-a055b0cb"]]), uK = { class: "grid-gallery-cards" }, dK = {
  key: 0,
  class: "section-header"
}, hK = ["innerHTML"], fK = ["innerHTML"], pK = /* @__PURE__ */ Ce({
  __name: "GridGalleryCards",
  props: {
    block: {
      type: Object,
      default: () => {
      }
    }
  },
  setup(t) {
    function e(a) {
      const i = [];
      for (const r of a.gridGalleryCards) {
        const s = {};
        s.headlineText = r.contentLink && r.contentLink[0] ? r.contentLink[0].headlineText : r.headlineText, s.snippet = r.contentLink && r.contentLink[0] ? r.contentLink[0].snippet : r.snippet, s.featured = r.featured === "true", s.to = $n(
          r.contentLink && r.contentLink[0] ? r.contentLink[0].to : r.to
        ), s.image = r.contentLink && r.contentLink[0] && r.contentLink[0].heroImage ? r.contentLink[0].heroImage[0].image[0] : r.image ? r.image[0] : {}, i.push(s);
      }
      return i;
    }
    const n = I(() => e(t.block));
    return (a, i) => (h(), b("div", uK, [
      t.block.gridGalleryCards && t.block.gridGalleryCards.length > 0 || t.block.sectionTitle ? (h(), b("div", dK, [
        t.block.sectionTitle ? (h(), b("h2", {
          key: 0,
          class: "section-title",
          innerHTML: t.block.sectionTitle
        }, null, 8, hK)) : A("", !0),
        t.block.sectionSummary ? (h(), b("div", {
          key: 1,
          class: "section-summary",
          innerHTML: t.block.sectionSummary
        }, null, 8, fK)) : A("", !0)
      ])) : A("", !0),
      t.block.gridGalleryCards && t.block.gridGalleryCards.length > 0 ? (h(), G(cK, {
        key: 1,
        class: "section-summary",
        items: n.value
      }, null, 8, ["items"])) : A("", !0)
    ]));
  }
}), mK = /* @__PURE__ */ ge(pK, [["__scopeId", "data-v-13926fda"]]), gK = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: mK
}, Symbol.toStringTag, { value: "Module" })), bK = { class: "section-teaser-highlight" }, vK = { class: "section-header" }, yK = ["innerHTML"], _K = ["innerHTML"], TK = { class: "block-group" }, xK = /* @__PURE__ */ Ce({
  __name: "Highlight",
  props: {
    block: {
      type: Object,
      default: () => {
      }
    }
  },
  setup(t) {
    const e = I(() => {
      const a = [];
      for (const i in t.block.highlight)
        t.block.highlight[i].typeHandle === "internalContent" ? a.push(t.block.highlight[i].contentLink[0]) : a.push(t.block.highlight[i]);
      return a;
    }), n = I(() => e.value.filter((a) => a !== null).map((a) => a.typeHandle !== "externalContent" && a.contentType.includes("article") ? {
      ...a,
      to: $n(a.to),
      parsedImage: it(
        a,
        "heroImage[0].image[0]",
        void 0
      ),
      locations: it(
        a,
        "associatedLocations",
        void 0
      ),
      category: it(
        a,
        "articleCategory[0].title",
        ""
      ),
      byline1: it(a, "articleByline1[0].title", ""),
      byline2: a.articleByline2 != null ? ya(
        a.articleByline2,
        a.articleByline2
      ) : ""
    } : a.typeHandle !== "externalContent" && a.contentType.includes("meapProject") ? {
      ...a,
      to: $n(a.to),
      parsedImage: it(
        a,
        "heroImage[0].image[0]",
        void 0
      ),
      locations: it(a, "projectLocations", void 0),
      category: it(a, "projectCategory", ""),
      byline1: it(a, "projectByline1[0].title", "")
    } : a.typeHandle !== "externalContent" && a.contentType === "event" ? {
      ...a,
      to: $n(a.to),
      parsedImage: it(
        a,
        "heroImage[0].image[0]",
        void 0
      ),
      locations: it(
        a,
        "associatedLocations",
        void 0
      ),
      category: it(a, "eventType.title", ""),
      startDate: it(a, "startDateWithTime", ""),
      endDate: it(a, "endDateWithTime", ""),
      text: it(a, "eventDescription", "")
    } : a.typeHandle !== "externalContent" && (a.contentType === "exhibition" || !0) ? {
      ...a,
      to: $n(a.to),
      parsedImage: it(
        a,
        "heroImage[0].image[0]",
        void 0
      ),
      locations: it(
        a,
        "associatedLocations",
        void 0
      ),
      startDate: it(a, "startDate", ""),
      endDate: it(a, "endDate", "")
    } : a.typeHandle === "externalContent" ? {
      ...a,
      parsedImage: it(a, "image[0]", void 0),
      // TODO: FIX BlockHighlight gql fragment to add locations in nuxt repo
      /* locations:
        obj.locations != null ? [obj.locations] : undefined, */
      category: it(a, "category", "")
    } : {
      ...a,
      parsedImage: it(
        a,
        "heroImage[0].image[0]",
        void 0
      ),
      to: $n(a.to)
    }));
    return (a, i) => (h(), b("section", bK, [
      k("div", vK, [
        t.block.sectionTitle ? (h(), b("h2", {
          key: 0,
          class: "section-title",
          innerHTML: t.block.sectionTitle
        }, null, 8, yK)) : A("", !0),
        t.block.sectionSummary ? (h(), b("div", {
          key: 1,
          class: "section-summary",
          innerHTML: t.block.sectionSummary
        }, null, 8, _K)) : A("", !0)
      ]),
      k("ul", TK, [
        (h(!0), b(he, null, Le(n.value, (r, s) => (h(), G(q2, {
          key: `FlexibleHighlight${s}`,
          to: r.to,
          image: r.parsedImage,
          category: r.category,
          "byline-one": r.byline1,
          "byline-two": r.byline2,
          title: r.title,
          text: r.text,
          locations: r.locations,
          "start-date": r.startDate,
          "end-date": r.endDate,
          "section-handle": r.contentType,
          ongoing: r.ongoing,
          "has-triangle": !0,
          "is-vertical": !0,
          class: "block"
        }, null, 8, ["to", "image", "category", "byline-one", "byline-two", "title", "text", "locations", "start-date", "end-date", "section-handle", "ongoing"]))), 128))
      ])
    ]));
  }
}), wK = /* @__PURE__ */ ge(xK, [["__scopeId", "data-v-fc808ff2"]]), kK = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: wK
}, Symbol.toStringTag, { value: "Module" })), Rhe = /* @__PURE__ */ Ce({
  __name: "HorizontalDivider",
  props: {
    block: {
      type: Object,
      default: () => {
      }
    }
  },
  setup(t) {
    return (e, n) => t.block.horizontalDivider ? (h(), G(bl, { key: 0 })) : A("", !0);
  }
}), CK = { class: "card" }, SK = ["innerHTML"], AK = ["innerHTML"], EK = ["innerHTML"], LK = /* @__PURE__ */ Ce({
  __name: "ImpactNumberCard",
  props: {
    title: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    impactNumber: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = qe(), n = I(() => ["impact-number-card", (e == null ? void 0 : e.value) || ""]);
    return (a, i) => (h(), b("li", {
      class: re(n.value)
    }, [
      k("div", CK, [
        t.impactNumber ? (h(), b("div", {
          key: 0,
          class: "impact-number",
          innerHTML: t.impactNumber
        }, null, 8, SK)) : A("", !0),
        t.title ? (h(), b("div", {
          key: 1,
          class: "title",
          innerHTML: t.title
        }, null, 8, AK)) : A("", !0)
      ]),
      t.text ? (h(), b("div", {
        key: 0,
        class: "text",
        innerHTML: t.text
      }, null, 8, EK)) : A("", !0)
    ], 2));
  }
}), DK = /* @__PURE__ */ ge(LK, [["__scopeId", "data-v-a21f2ee4"]]), IK = { class: "section-header" }, MK = ["innerHTML"], OK = ["innerHTML"], PK = { class: "impact-number-cards-list" }, BK = /* @__PURE__ */ Ce({
  __name: "ImpactNumberCards",
  props: {
    block: {
      type: Object,
      default: () => {
      }
    }
  },
  setup(t) {
    const e = qe(), n = I(() => ["impact-number-cards", (e == null ? void 0 : e.value) || ""]);
    return (a, i) => (h(), b("div", {
      class: re(n.value)
    }, [
      k("div", IK, [
        t.block.sectionTitle ? (h(), b("h3", {
          key: 0,
          class: "section-title",
          innerHTML: t.block.sectionTitle
        }, null, 8, MK)) : A("", !0),
        t.block.sectionSummary ? (h(), b("div", {
          key: 1,
          class: "section-summary",
          innerHTML: t.block.sectionSummary
        }, null, 8, OK)) : A("", !0)
      ]),
      k("ul", PK, [
        (h(!0), b(he, null, Le(t.block.impactNumberCards, (r, s) => (h(), G(DK, {
          key: `impactNumberCards${s}`,
          title: r.title,
          text: r.text,
          "impact-number": r.impactNumber,
          class: "flexible-impact-number-card"
        }, null, 8, ["title", "text", "impact-number"]))), 128))
      ])
    ], 2));
  }
}), RK = /* @__PURE__ */ ge(BK, [["__scopeId", "data-v-a12f6094"]]), NK = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: RK
}, Symbol.toStringTag, { value: "Module" }));
/**
 * Vue 3 Carousel 0.3.4
 * (c) 2024
 * @license MIT
 */
const Tn = {
  itemsToShow: 1,
  itemsToScroll: 1,
  modelValue: 0,
  transition: 300,
  autoplay: 0,
  snapAlign: "center",
  wrapAround: !1,
  throttle: 16,
  pauseAutoplayOnHover: !1,
  mouseDrag: !0,
  touchDrag: !0,
  dir: "ltr",
  breakpoints: void 0,
  i18n: {
    ariaNextSlide: "Navigate to next slide",
    ariaPreviousSlide: "Navigate to previous slide",
    ariaNavigateToSlide: "Navigate to slide {slideNumber}",
    ariaGallery: "Gallery",
    itemXofY: "Item {currentSlide} of {slidesCount}",
    iconArrowUp: "Arrow pointing upwards",
    iconArrowDown: "Arrow pointing downwards",
    iconArrowRight: "Arrow pointing to the right",
    iconArrowLeft: "Arrow pointing to the left"
  }
}, mg = {
  // count of items to showed per view
  itemsToShow: {
    default: Tn.itemsToShow,
    type: Number
  },
  // count of items to be scrolled
  itemsToScroll: {
    default: Tn.itemsToScroll,
    type: Number
  },
  // control infinite scrolling mode
  wrapAround: {
    default: Tn.wrapAround,
    type: Boolean
  },
  // control max drag
  throttle: {
    default: Tn.throttle,
    type: Number
  },
  // control snap position alignment
  snapAlign: {
    default: Tn.snapAlign,
    validator(t) {
      return ["start", "end", "center", "center-even", "center-odd"].includes(t);
    }
  },
  // sliding transition time in ms
  transition: {
    default: Tn.transition,
    type: Number
  },
  // an object to store breakpoints
  breakpoints: {
    default: Tn.breakpoints,
    type: Object
  },
  // time to auto advance slides in ms
  autoplay: {
    default: Tn.autoplay,
    type: Number
  },
  // pause autoplay when mouse hover over the carousel
  pauseAutoplayOnHover: {
    default: Tn.pauseAutoplayOnHover,
    type: Boolean
  },
  // slide number number of initial slide
  modelValue: {
    default: void 0,
    type: Number
  },
  // toggle mouse dragging.
  mouseDrag: {
    default: Tn.mouseDrag,
    type: Boolean
  },
  // toggle mouse dragging.
  touchDrag: {
    default: Tn.touchDrag,
    type: Boolean
  },
  // control snap position alignment
  dir: {
    default: Tn.dir,
    validator(t) {
      return ["rtl", "ltr"].includes(t);
    }
  },
  // aria-labels and additional text labels
  i18n: {
    default: Tn.i18n,
    type: Object
  },
  // an object to pass all settings
  settings: {
    default() {
      return {};
    },
    type: Object
  }
};
function $K({ config: t, slidesCount: e }) {
  const { snapAlign: n, wrapAround: a, itemsToShow: i = 1 } = t;
  if (a)
    return Math.max(e - 1, 0);
  let r;
  switch (n) {
    case "start":
      r = e - i;
      break;
    case "end":
      r = e - 1;
      break;
    case "center":
    case "center-odd":
      r = e - Math.ceil((i - 0.5) / 2);
      break;
    case "center-even":
      r = e - Math.ceil(i / 2);
      break;
    default:
      r = 0;
      break;
  }
  return Math.max(r, 0);
}
function FK({ config: t, slidesCount: e }) {
  const { wrapAround: n, snapAlign: a, itemsToShow: i = 1 } = t;
  let r = 0;
  if (n || i > e)
    return r;
  switch (a) {
    case "start":
      r = 0;
      break;
    case "end":
      r = i - 1;
      break;
    case "center":
    case "center-odd":
      r = Math.floor((i - 1) / 2);
      break;
    case "center-even":
      r = Math.floor((i - 2) / 2);
      break;
    default:
      r = 0;
      break;
  }
  return r;
}
function hh({ val: t, max: e, min: n }) {
  return e < n ? t : Math.min(Math.max(t, n), e);
}
function zK({ config: t, currentSlide: e, slidesCount: n }) {
  const { snapAlign: a, wrapAround: i, itemsToShow: r = 1 } = t;
  let s = e;
  switch (a) {
    case "center":
    case "center-odd":
      s -= (r - 1) / 2;
      break;
    case "center-even":
      s -= (r - 2) / 2;
      break;
    case "end":
      s -= r - 1;
      break;
  }
  return i ? s : hh({
    val: s,
    max: n - r,
    min: 0
  });
}
function Zy(t) {
  return t ? t.reduce((e, n) => {
    var a;
    return n.type === he ? [...e, ...Zy(n.children)] : ((a = n.type) === null || a === void 0 ? void 0 : a.name) === "CarouselSlide" ? [...e, n] : e;
  }, []) : [];
}
function fh({ val: t, max: e, min: n = 0 }) {
  return t > e ? fh({ val: t - (e + 1), max: e, min: n }) : t < n ? fh({ val: t + (e + 1), max: e, min: n }) : t;
}
function UK(t, e) {
  let n;
  return e ? function(...a) {
    const i = this;
    n || (t.apply(i, a), n = !0, setTimeout(() => n = !1, e));
  } : t;
}
function HK(t, e) {
  let n;
  return function(...a) {
    n && clearTimeout(n), n = setTimeout(() => {
      t(...a), n = null;
    }, e);
  };
}
function YK(t = "", e = {}) {
  return Object.entries(e).reduce((n, [a, i]) => n.replace(`{${a}}`, String(i)), t);
}
var jK = Ce({
  name: "ARIA",
  setup() {
    const t = wn("config", Ma(Object.assign({}, Tn))), e = wn("currentSlide", K(0)), n = wn("slidesCount", K(0));
    return () => xr("div", {
      class: ["carousel__liveregion", "carousel__sr-only"],
      "aria-live": "polite",
      "aria-atomic": "true"
    }, YK(t.i18n.itemXofY, {
      currentSlide: e.value + 1,
      slidesCount: n.value
    }));
  }
}), Ky = Ce({
  name: "Carousel",
  props: mg,
  setup(t, { slots: e, emit: n, expose: a }) {
    var i;
    const r = K(null), s = K([]), o = K(0), l = K(0), c = Ma(Object.assign({}, Tn));
    let u = Object.assign({}, Tn), f;
    const m = K((i = t.modelValue) !== null && i !== void 0 ? i : 0), _ = K(0), T = K(0), g = K(0), x = K(0);
    let S, D;
    ba("config", c), ba("slidesCount", l), ba("currentSlide", m), ba("maxSlide", g), ba("minSlide", x), ba("slideWidth", o);
    function L() {
      f = Object.assign({}, t.breakpoints), u = Object.assign(Object.assign(Object.assign({}, u), t), { i18n: Object.assign(Object.assign({}, u.i18n), t.i18n), breakpoints: void 0 }), E(u);
    }
    function M() {
      if (!f || !Object.keys(f).length)
        return;
      const fe = Object.keys(f).map((Te) => Number(Te)).sort((Te, nt) => +nt - +Te);
      let Ee = Object.assign({}, u);
      fe.some((Te) => {
        const nt = window.matchMedia(`(min-width: ${Te}px)`).matches;
        return nt && (Ee = Object.assign(Object.assign({}, Ee), f[Te])), nt;
      }), E(Ee);
    }
    function E(fe) {
      Object.entries(fe).forEach(([Ee, Te]) => c[Ee] = Te);
    }
    const P = HK(() => {
      M(), z(), B();
    }, 16);
    function B() {
      if (!r.value)
        return;
      const fe = r.value.getBoundingClientRect();
      o.value = fe.width / c.itemsToShow;
    }
    function z() {
      l.value <= 0 || (T.value = Math.ceil((l.value - 1) / 2), g.value = $K({ config: c, slidesCount: l.value }), x.value = FK({ config: c, slidesCount: l.value }), c.wrapAround || (m.value = hh({
        val: m.value,
        max: g.value,
        min: x.value
      })));
    }
    st(() => {
      kn(() => B()), setTimeout(() => B(), 1e3), M(), De(), window.addEventListener("resize", P, { passive: !0 }), n("init");
    }), Ks(() => {
      D && clearTimeout(D), S && clearInterval(S), window.removeEventListener("resize", P, {
        passive: !0
      });
    });
    let W = !1;
    const V = { x: 0, y: 0 }, H = { x: 0, y: 0 }, se = Ma({ x: 0, y: 0 }), ie = K(!1), Z = K(!1), $ = () => {
      ie.value = !0;
    }, J = () => {
      ie.value = !1;
    };
    function N(fe) {
      ["INPUT", "TEXTAREA", "SELECT"].includes(fe.target.tagName) || (W = fe.type === "touchstart", W || fe.preventDefault(), !(!W && fe.button !== 0 || te.value) && (V.x = W ? fe.touches[0].clientX : fe.clientX, V.y = W ? fe.touches[0].clientY : fe.clientY, document.addEventListener(W ? "touchmove" : "mousemove", ue, !0), document.addEventListener(W ? "touchend" : "mouseup", xe, !0)));
    }
    const ue = UK((fe) => {
      Z.value = !0, H.x = W ? fe.touches[0].clientX : fe.clientX, H.y = W ? fe.touches[0].clientY : fe.clientY;
      const Ee = H.x - V.x, Te = H.y - V.y;
      se.y = Te, se.x = Ee;
    }, c.throttle);
    function xe() {
      const fe = c.dir === "rtl" ? -1 : 1, Ee = Math.sign(se.x) * 0.4, Te = Math.round(se.x / o.value + Ee) * fe;
      if (Te && !W) {
        const nt = (le) => {
          window.removeEventListener("click", nt, !0);
        };
        window.addEventListener("click", nt, !0);
      }
      ke(m.value - Te), se.x = 0, se.y = 0, Z.value = !1, document.removeEventListener(W ? "touchmove" : "mousemove", ue, !0), document.removeEventListener(W ? "touchend" : "mouseup", xe, !0);
    }
    function De() {
      !c.autoplay || c.autoplay <= 0 || (S = setInterval(() => {
        c.pauseAutoplayOnHover && ie.value || Y();
      }, c.autoplay));
    }
    function He() {
      S && (clearInterval(S), S = null), De();
    }
    const te = K(!1);
    function ke(fe) {
      const Ee = c.wrapAround ? fe : hh({
        val: fe,
        max: g.value,
        min: x.value
      });
      m.value === Ee || te.value || (n("slide-start", {
        slidingToIndex: fe,
        currentSlideIndex: m.value,
        prevSlideIndex: _.value,
        slidesCount: l.value
      }), te.value = !0, _.value = m.value, m.value = Ee, D = setTimeout(() => {
        if (c.wrapAround) {
          const Te = fh({
            val: Ee,
            max: g.value,
            min: 0
          });
          Te !== m.value && (m.value = Te, n("loop", {
            currentSlideIndex: m.value,
            slidingToIndex: fe
          }));
        }
        n("update:modelValue", m.value), n("slide-end", {
          currentSlideIndex: m.value,
          prevSlideIndex: _.value,
          slidesCount: l.value
        }), te.value = !1, He();
      }, c.transition));
    }
    function Y() {
      ke(m.value + c.itemsToScroll);
    }
    function be() {
      ke(m.value - c.itemsToScroll);
    }
    const Ne = { slideTo: ke, next: Y, prev: be };
    ba("nav", Ne), ba("isSliding", te);
    const ee = I(() => zK({
      config: c,
      currentSlide: m.value,
      slidesCount: l.value
    }));
    ba("slidesToScroll", ee);
    const Ue = I(() => {
      const fe = c.dir === "rtl" ? -1 : 1, Ee = ee.value * o.value * fe;
      return {
        transform: `translateX(${se.x - Ee}px)`,
        transition: `${te.value ? c.transition : 0}ms`,
        margin: c.wrapAround ? `0 -${l.value * o.value}px` : "",
        width: "100%"
      };
    });
    function tt() {
      L(), M(), z(), B(), He();
    }
    Object.keys(mg).forEach((fe) => {
      ["modelValue"].includes(fe) || Qe(() => t[fe], tt);
    }), Qe(() => t.modelValue, (fe) => {
      fe !== m.value && ke(Number(fe));
    }), Qe(l, z), n("before-init"), L();
    const we = {
      config: c,
      slidesCount: l,
      slideWidth: o,
      next: Y,
      prev: be,
      slideTo: ke,
      currentSlide: m,
      maxSlide: g,
      minSlide: x,
      middleSlide: T
    };
    a({
      updateBreakpointsConfigs: M,
      updateSlidesData: z,
      updateSlideWidth: B,
      initDefaultConfigs: L,
      restartCarousel: tt,
      slideTo: ke,
      next: Y,
      prev: be,
      nav: Ne,
      data: we
    });
    const Je = e.default || e.slides, X = e.addons, Ae = Ma(we);
    return () => {
      const fe = Zy(Je == null ? void 0 : Je(Ae)), Ee = (X == null ? void 0 : X(Ae)) || [];
      fe.forEach((Oe, Re) => Oe.props.index = Re);
      let Te = fe;
      if (c.wrapAround) {
        const Oe = fe.map((ct, Ot) => Em(ct, {
          index: -fe.length + Ot,
          isClone: !0,
          key: `clone-before-${Ot}`
        })), Re = fe.map((ct, Ot) => Em(ct, {
          index: fe.length + Ot,
          isClone: !0,
          key: `clone-after-${Ot}`
        }));
        Te = [...Oe, ...fe, ...Re];
      }
      s.value = fe, l.value = Math.max(fe.length, 1);
      const nt = xr("ol", {
        class: "carousel__track",
        style: Ue.value,
        onMousedownCapture: c.mouseDrag ? N : null,
        onTouchstartPassiveCapture: c.touchDrag ? N : null
      }, Te), le = xr("div", { class: "carousel__viewport" }, nt);
      return xr("section", {
        ref: r,
        class: {
          carousel: !0,
          "is-sliding": te.value,
          "is-dragging": Z.value,
          "is-hover": ie.value,
          "carousel--rtl": c.dir === "rtl"
        },
        dir: c.dir,
        "aria-label": c.i18n.ariaGallery,
        tabindex: "0",
        onMouseenter: $,
        onMouseleave: J
      }, [le, Ee, xr(jK)]);
    };
  }
}), gg;
(function(t) {
  t.arrowUp = "arrowUp", t.arrowDown = "arrowDown", t.arrowRight = "arrowRight", t.arrowLeft = "arrowLeft";
})(gg || (gg = {}));
var Qy = Ce({
  name: "CarouselSlide",
  props: {
    index: {
      type: Number,
      default: 1
    },
    isClone: {
      type: Boolean,
      default: !1
    }
  },
  setup(t, { slots: e }) {
    const n = wn("config", Ma(Object.assign({}, Tn))), a = wn("currentSlide", K(0)), i = wn("slidesToScroll", K(0)), r = wn("isSliding", K(!1)), s = I(() => t.index === a.value), o = I(() => t.index === a.value - 1), l = I(() => t.index === a.value + 1), c = I(() => {
      const u = Math.floor(i.value), f = Math.ceil(i.value + n.itemsToShow - 1);
      return t.index >= u && t.index <= f;
    });
    return () => {
      var u;
      return xr("li", {
        style: { width: `${100 / n.itemsToShow}%` },
        class: {
          carousel__slide: !0,
          "carousel__slide--clone": t.isClone,
          "carousel__slide--visible": c.value,
          "carousel__slide--active": s.value,
          "carousel__slide--prev": o.value,
          "carousel__slide--next": l.value,
          "carousel__slide--sliding": r.value
        },
        "aria-hidden": !c.value
      }, (u = e.default) === null || u === void 0 ? void 0 : u.call(e, {
        isActive: s.value,
        isClone: t.isClone,
        isPrev: o.value,
        isNext: l.value,
        isSliding: r.value,
        isVisible: c.value
      }));
    };
  }
});
const VK = {
  width: "32",
  height: "33",
  viewBox: "0 0 32 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-arrow-left"
};
function qK(t, e) {
  return h(), b("svg", VK, e[0] || (e[0] = [
    k("g", {
      stroke: "#0B6AB7",
      "stroke-width": "1.5",
      "stroke-linecap": "square",
      "stroke-linejoin": "round",
      class: "svg__stroke--primary-blue-03"
    }, [
      k("path", { d: "M23 16.8645H9.75" }),
      k("path", { d: "m16 23.8645-7-7 7-7" })
    ], -1)
  ]));
}
const WK = { render: qK }, GK = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg_icon-molecule-bullet"
};
function XK(t, e) {
  return h(), b("svg", GK, e[0] || (e[0] = [
    k("path", {
      d: "M15.8977 10L20.068 11.7574L21.7954 16L20.068 20.2426L15.8977 22L11.7274 20.2426L10 16L11.7274 11.7574L15.8977 10Z",
      fill: "#0B6AB7",
      class: "svg__fill--primary-blue-03"
    }, null, -1),
    k("path", {
      d: "M12.1124 12.1377L15.8977 10.5426L19.683 12.1377L21.2556 16L19.683 19.8623L15.8977 21.4574L12.1124 19.8623L10.5399 16L12.1124 12.1377Z",
      stroke: "#0B6AB7",
      class: "svg__stroke--primary-blue-03"
    }, null, -1)
  ]));
}
const Jy = { render: XK }, ZK = { class: "impact-numbers-carousel" }, KK = { class: "slide-indicator" }, QK = { class: "slide-image" }, JK = { class: "impact-numbers-text-container" }, eQ = { class: "impactNumber" }, tQ = { class: "impactText" }, nQ = { class: "small-descriptor" }, aQ = { class: "controls" }, iQ = ["disabled"], rQ = ["disabled"], sQ = /* @__PURE__ */ Ce({
  __name: "ImpactNumbersCarousel",
  props: {
    blocks: {
      type: Array,
      default: () => [],
      required: !0
    }
  },
  setup(t) {
    const e = K(0);
    function n(i) {
      if (i === e.value)
        return "current-slide";
    }
    function a(i) {
      e.value = i;
    }
    return (i, r) => (h(), b("div", ZK, [
      k("div", KK, [
        (h(!0), b(he, null, Le(t.blocks, (s, o) => (h(), G(O(Jy), {
          key: s.largeText,
          class: re(n(o)),
          onClick: (l) => a(o)
        }, null, 8, ["class", "onClick"]))), 128))
      ]),
      Q(O(Ky), {
        modelValue: e.value,
        "onUpdate:modelValue": r[0] || (r[0] = (s) => e.value = s)
      }, {
        default: oe(() => [
          (h(!0), b(he, null, Le(t.blocks, (s) => (h(), G(O(Qy), {
            key: s.largeText
          }, {
            default: oe(() => [
              k("div", QK, [
                Q(dn, {
                  media: s.image[0]
                }, null, 8, ["media"])
              ]),
              k("div", JK, [
                k("span", eQ, ne(s.largeText), 1),
                k("span", tQ, ne(s.mediumText), 1)
              ]),
              k("div", nQ, ne(s.smallDescriptor), 1)
            ]),
            _: 2
          }, 1024))), 128))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      k("div", aQ, [
        k("button", {
          "data-glide-dir": "<",
          disabled: e.value <= 0,
          onClick: r[1] || (r[1] = (s) => e.value -= 1)
        }, [
          Q(O(WK), {
            "aria-label": "Go to previous item",
            class: "prev-control"
          })
        ], 8, iQ),
        k("button", {
          "data-glide-dir": ">",
          disabled: e.value >= t.blocks.length - 1,
          onClick: r[2] || (r[2] = (s) => e.value += 1)
        }, [
          Q(O(vi), { "aria-label": "Go to next item" })
        ], 8, rQ)
      ]),
      r[3] || (r[3] = k("div", {
        role: "tablist",
        class: "dots"
      }, null, -1))
    ]));
  }
}), oQ = /* @__PURE__ */ ge(sQ, [["__scopeId", "data-v-0c60395c"]]), lQ = {
  key: 0,
  class: "impact-numbers-carousel"
}, cQ = { class: "section-header" }, uQ = ["textContent"], dQ = ["innerHTML"], hQ = /* @__PURE__ */ Ce({
  __name: "ImpactNumbersCarousel",
  props: {
    block: {
      type: Object,
      default: () => {
      }
    }
  },
  setup(t) {
    return (e, n) => t.block ? (h(), b("div", lQ, [
      k("div", cQ, [
        t.block.sectionTitle ? (h(), b("h2", {
          key: 0,
          class: "section-title",
          textContent: ne(t.block.sectionTitle)
        }, null, 8, uQ)) : A("", !0),
        t.block.sectionSummary ? (h(), b("div", {
          key: 1,
          class: "section-summary",
          innerHTML: t.block.sectionSummary
        }, null, 8, dQ)) : A("", !0)
      ]),
      Q(oQ, {
        blocks: t.block.blocks
      }, null, 8, ["blocks"])
    ])) : A("", !0);
  }
}), fQ = /* @__PURE__ */ ge(hQ, [["__scopeId", "data-v-257824af"]]), pQ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: fQ
}, Symbol.toStringTag, { value: "Module" })), mQ = { class: "contact-info" }, gQ = { class: "info-address" }, bQ = /* @__PURE__ */ Ce({
  __name: "Info",
  props: {
    block: {
      type: Object,
      default: () => {
      }
    }
  },
  setup(t) {
    const e = I(() => t.block.infoBlock[0]), n = qe(), a = I(() => ["flexible-info", (n == null ? void 0 : n.value) || ""]);
    return (i, r) => (h(), b("div", {
      class: re(a.value)
    }, [
      e.value.typeHandle === "infoBlock" ? (h(), G(Jh, {
        key: 0,
        title: e.value.heading,
        text: e.value.text,
        "svg-name": e.value.icon,
        "is-centered": !1
      }, null, 8, ["title", "text", "svg-name"])) : e.value.typeHandle === "contactInfoBlock" ? (h(), G(hI, {
        key: 1,
        "color-scheme": "paleblue"
      }, {
        "block-info-mid": oe(() => [
          k("ul", mQ, [
            k("li", null, [
              Q(en, {
                text: `${e.value.phone || ""}`,
                "icon-name": "svg-icon-ftva-phone",
                to: `tel:${e.value.phone || ""}`
              }, null, 8, ["text", "to"])
            ]),
            k("li", null, [
              Q(en, {
                text: e.value.email || "",
                "icon-name": "svg-icon-ftva-email",
                to: e.value.email
              }, null, 8, ["text", "to"])
            ]),
            k("li", gQ, [
              Q(en, {
                "icon-name": "svg-icon-ftva-location-outline",
                text: ""
              }),
              Q(un, {
                "rich-text-content": e.value.address
              }, null, 8, ["rich-text-content"])
            ])
          ])
        ]),
        _: 1
      })) : A("", !0)
    ], 2));
  }
}), vQ = /* @__PURE__ */ ge(bQ, [["__scopeId", "data-v-9b6d9b95"]]), yQ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: vQ
}, Symbol.toStringTag, { value: "Module" })), _Q = {
  width: "128",
  height: "128",
  viewBox: "0 0 128 128",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__molecule-image-stack"
};
function TQ(t, e) {
  return h(), b("svg", _Q, e[0] || (e[0] = [
    k("path", {
      d: "m64 0 45.255 18.745L128 64l-18.745 45.255L64 128l-45.255-18.745L0 64l18.745-45.255L64 0Z",
      fill: "#0B6AB7",
      class: "svg__fill--primary-blue-03"
    }, null, -1),
    k("path", {
      d: "M40.97 51.901v-2.93h46.058v30.705h-2.85",
      stroke: "#fff",
      "stroke-width": "1.25",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      class: "svg__stroke--white"
    }, null, -1),
    k("path", {
      d: "M43.943 48.992V46h46.058v30.705h-2.788",
      stroke: "#fff",
      "stroke-width": "1.25",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      class: "svg__stroke--white"
    }, null, -1),
    k("path", {
      d: "M84.057 82.648H38V51.943h46.057v30.705Z",
      stroke: "#fff",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      class: "svg__stroke--white"
    }, null, -1)
  ]));
}
const xQ = { render: TQ }, wQ = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-image-stack"
};
function e5(t, e) {
  return h(), b("svg", wQ, e[0] || (e[0] = [
    k("path", {
      d: "M4.4856 9.95076V8.48584H27.5142V23.8382H26.0894",
      stroke: "#0B6AB7",
      "stroke-width": "0.619048",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      class: "svg__stroke--primary-blue-03"
    }, null, -1),
    k("path", {
      d: "M5.97156 8.49587V7H29.0001V22.3524H27.6063",
      stroke: "#0B6AB7",
      "stroke-width": "0.619048",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      class: "svg__stroke--primary-blue-03"
    }, null, -1),
    k("path", {
      d: "M26.0286 25.3238C18.3524 25.3238 10.6762 25.3238 3 25.3238V9.97144H26.0286V25.3238Z",
      stroke: "#0B6AB7",
      "stroke-width": "0.742857",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      class: "svg__stroke--primary-blue-03"
    }, null, -1),
    k("path", {
      d: "M12.2856 14.3049L17.4856 17.6478L12.2856 20.9906V14.3049Z",
      stroke: "#0AA5FF",
      "stroke-width": "0.619048",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      class: "svg__stroke--default-cyan-03"
    }, null, -1)
  ]));
}
const t5 = { render: e5 }, kQ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: t5,
  render: e5
}, Symbol.toStringTag, { value: "Module" }));
var Jo;
typeof window < "u" ? Jo = window : typeof Gi < "u" ? Jo = Gi : typeof self < "u" ? Jo = self : Jo = {};
var od = Jo;
const j = /* @__PURE__ */ ka(od), CQ = {}, SQ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: CQ
}, Symbol.toStringTag, { value: "Module" })), AQ = /* @__PURE__ */ g6(SQ);
var bg = typeof Gi < "u" ? Gi : typeof window < "u" ? window : {}, EQ = AQ, el;
typeof document < "u" ? el = document : (el = bg["__GLOBAL_DOCUMENT_CACHE@4"], el || (el = bg["__GLOBAL_DOCUMENT_CACHE@4"] = EQ));
var n5 = el;
const Me = /* @__PURE__ */ ka(n5);
var $f = { exports: {} }, a5 = { exports: {} };
(function(t) {
  function e() {
    return t.exports = e = Object.assign ? Object.assign.bind() : function(n) {
      for (var a = 1; a < arguments.length; a++) {
        var i = arguments[a];
        for (var r in i) ({}).hasOwnProperty.call(i, r) && (n[r] = i[r]);
      }
      return n;
    }, t.exports.__esModule = !0, t.exports.default = t.exports, e.apply(null, arguments);
  }
  t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
})(a5);
var LQ = a5.exports, DQ = MQ, IQ = Object.prototype.toString;
function MQ(t) {
  if (!t)
    return !1;
  var e = IQ.call(t);
  return e === "[object Function]" || typeof t == "function" && e !== "[object RegExp]" || typeof window < "u" && // IE8 and below
  (t === window.setTimeout || t === window.alert || t === window.confirm || t === window.prompt);
}
function OQ(t, e) {
  var n = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n) return (n = n.call(t)).next.bind(n);
  if (Array.isArray(t) || (n = PQ(t)) || e) {
    n && (t = n);
    var a = 0;
    return function() {
      return a >= t.length ? { done: !0 } : { done: !1, value: t[a++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function PQ(t, e) {
  if (t) {
    if (typeof t == "string") return vg(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set") return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return vg(t, e);
  }
}
function vg(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, a = new Array(e); n < e; n++)
    a[n] = t[n];
  return a;
}
var BQ = /* @__PURE__ */ function() {
  function t() {
    this.typeToInterceptorsMap_ = /* @__PURE__ */ new Map(), this.enabled_ = !1;
  }
  var e = t.prototype;
  return e.getIsEnabled = function() {
    return this.enabled_;
  }, e.enable = function() {
    this.enabled_ = !0;
  }, e.disable = function() {
    this.enabled_ = !1;
  }, e.reset = function() {
    this.typeToInterceptorsMap_ = /* @__PURE__ */ new Map(), this.enabled_ = !1;
  }, e.addInterceptor = function(a, i) {
    this.typeToInterceptorsMap_.has(a) || this.typeToInterceptorsMap_.set(a, /* @__PURE__ */ new Set());
    var r = this.typeToInterceptorsMap_.get(a);
    return r.has(i) ? !1 : (r.add(i), !0);
  }, e.removeInterceptor = function(a, i) {
    var r = this.typeToInterceptorsMap_.get(a);
    return r && r.has(i) ? (r.delete(i), !0) : !1;
  }, e.clearInterceptorsByType = function(a) {
    var i = this.typeToInterceptorsMap_.get(a);
    return i ? (this.typeToInterceptorsMap_.delete(a), this.typeToInterceptorsMap_.set(a, /* @__PURE__ */ new Set()), !0) : !1;
  }, e.clear = function() {
    return this.typeToInterceptorsMap_.size ? (this.typeToInterceptorsMap_ = /* @__PURE__ */ new Map(), !0) : !1;
  }, e.getForType = function(a) {
    return this.typeToInterceptorsMap_.get(a) || /* @__PURE__ */ new Set();
  }, e.execute = function(a, i) {
    for (var r = this.getForType(a), s = OQ(r), o; !(o = s()).done; ) {
      var l = o.value;
      try {
        i = l(i);
      } catch {
      }
    }
    return i;
  }, t;
}(), RQ = BQ, NQ = /* @__PURE__ */ function() {
  function t() {
    this.maxAttempts_ = 1, this.delayFactor_ = 0.1, this.fuzzFactor_ = 0.1, this.initialDelay_ = 1e3, this.enabled_ = !1;
  }
  var e = t.prototype;
  return e.getIsEnabled = function() {
    return this.enabled_;
  }, e.enable = function() {
    this.enabled_ = !0;
  }, e.disable = function() {
    this.enabled_ = !1;
  }, e.reset = function() {
    this.maxAttempts_ = 1, this.delayFactor_ = 0.1, this.fuzzFactor_ = 0.1, this.initialDelay_ = 1e3, this.enabled_ = !1;
  }, e.getMaxAttempts = function() {
    return this.maxAttempts_;
  }, e.setMaxAttempts = function(a) {
    this.maxAttempts_ = a;
  }, e.getDelayFactor = function() {
    return this.delayFactor_;
  }, e.setDelayFactor = function(a) {
    this.delayFactor_ = a;
  }, e.getFuzzFactor = function() {
    return this.fuzzFactor_;
  }, e.setFuzzFactor = function(a) {
    this.fuzzFactor_ = a;
  }, e.getInitialDelay = function() {
    return this.initialDelay_;
  }, e.setInitialDelay = function(a) {
    this.initialDelay_ = a;
  }, e.createRetry = function(a) {
    var i = a === void 0 ? {} : a, r = i.maxAttempts, s = i.delayFactor, o = i.fuzzFactor, l = i.initialDelay;
    return new $Q({
      maxAttempts: r || this.maxAttempts_,
      delayFactor: s || this.delayFactor_,
      fuzzFactor: o || this.fuzzFactor_,
      initialDelay: l || this.initialDelay_
    });
  }, t;
}(), $Q = /* @__PURE__ */ function() {
  function t(n) {
    this.maxAttempts_ = n.maxAttempts, this.delayFactor_ = n.delayFactor, this.fuzzFactor_ = n.fuzzFactor, this.currentDelay_ = n.initialDelay, this.currentAttempt_ = 1;
  }
  var e = t.prototype;
  return e.moveToNextAttempt = function() {
    this.currentAttempt_++;
    var a = this.currentDelay_ * this.delayFactor_;
    this.currentDelay_ = this.currentDelay_ + a;
  }, e.shouldRetry = function() {
    return this.currentAttempt_ < this.maxAttempts_;
  }, e.getCurrentDelay = function() {
    return this.currentDelay_;
  }, e.getCurrentMinPossibleDelay = function() {
    return (1 - this.fuzzFactor_) * this.currentDelay_;
  }, e.getCurrentMaxPossibleDelay = function() {
    return (1 + this.fuzzFactor_) * this.currentDelay_;
  }, e.getCurrentFuzzedDelay = function() {
    var a = this.getCurrentMinPossibleDelay(), i = this.getCurrentMaxPossibleDelay();
    return a + Math.random() * (i - a);
  }, t;
}(), FQ = NQ, zQ = od, UQ = function(e, n) {
  return n === void 0 && (n = !1), function(a, i, r) {
    if (a) {
      e(a);
      return;
    }
    if (i.statusCode >= 400 && i.statusCode <= 599) {
      var s = r;
      if (n)
        if (zQ.TextDecoder) {
          var o = HQ(i.headers && i.headers["content-type"]);
          try {
            s = new TextDecoder(o).decode(r);
          } catch {
          }
        } else
          s = String.fromCharCode.apply(null, new Uint8Array(r));
      e({
        cause: s
      });
      return;
    }
    e(null, r);
  };
};
function HQ(t) {
  return t === void 0 && (t = ""), t.toLowerCase().split(";").reduce(function(e, n) {
    var a = n.split("="), i = a[0], r = a[1];
    return i.trim() === "charset" ? r.trim() : e;
  }, "utf-8");
}
var YQ = UQ, i5 = od, jQ = LQ, VQ = DQ, r5 = RQ, qQ = FQ;
Zt.httpHandler = YQ;
Zt.requestInterceptorsStorage = new r5();
Zt.responseInterceptorsStorage = new r5();
Zt.retryManager = new qQ();
/**
 * @license
 * slighly modified parse-headers 2.0.2 <https://github.com/kesla/parse-headers/>
 * Copyright (c) 2014 David Björklund
 * Available under the MIT license
 * <https://github.com/kesla/parse-headers/blob/master/LICENCE>
 */
var WQ = function(e) {
  var n = {};
  return e && e.trim().split(`
`).forEach(function(a) {
    var i = a.indexOf(":"), r = a.slice(0, i).trim().toLowerCase(), s = a.slice(i + 1).trim();
    typeof n[r] > "u" ? n[r] = s : Array.isArray(n[r]) ? n[r].push(s) : n[r] = [n[r], s];
  }), n;
};
$f.exports = Zt;
$f.exports.default = Zt;
Zt.XMLHttpRequest = i5.XMLHttpRequest || KQ;
Zt.XDomainRequest = "withCredentials" in new Zt.XMLHttpRequest() ? Zt.XMLHttpRequest : i5.XDomainRequest;
GQ(["get", "put", "post", "patch", "head", "delete"], function(t) {
  Zt[t === "delete" ? "del" : t] = function(e, n, a) {
    return n = s5(e, n, a), n.method = t.toUpperCase(), Ff(n);
  };
});
function GQ(t, e) {
  for (var n = 0; n < t.length; n++)
    e(t[n]);
}
function XQ(t) {
  for (var e in t)
    if (t.hasOwnProperty(e)) return !1;
  return !0;
}
function s5(t, e, n) {
  var a = t;
  return VQ(e) ? (n = e, typeof t == "string" && (a = {
    uri: t
  })) : a = jQ({}, e, {
    uri: t
  }), a.callback = n, a;
}
function Zt(t, e, n) {
  return e = s5(t, e, n), Ff(e);
}
function Ff(t) {
  if (typeof t.callback > "u")
    throw new Error("callback argument missing");
  if (t.requestType && Zt.requestInterceptorsStorage.getIsEnabled()) {
    var e = {
      uri: t.uri || t.url,
      headers: t.headers || {},
      body: t.body,
      metadata: t.metadata || {},
      retry: t.retry,
      timeout: t.timeout
    }, n = Zt.requestInterceptorsStorage.execute(t.requestType, e);
    t.uri = n.uri, t.headers = n.headers, t.body = n.body, t.metadata = n.metadata, t.retry = n.retry, t.timeout = n.timeout;
  }
  var a = !1, i = function(E, P, B) {
    a || (a = !0, t.callback(E, P, B));
  };
  function r() {
    c.readyState === 4 && !Zt.responseInterceptorsStorage.getIsEnabled() && setTimeout(l, 0);
  }
  function s() {
    var M = void 0;
    if (c.response ? M = c.response : M = c.responseText || ZQ(c), S)
      try {
        M = JSON.parse(M);
      } catch {
      }
    return M;
  }
  function o(M) {
    if (clearTimeout(D), clearTimeout(t.retryTimeout), M instanceof Error || (M = new Error("" + (M || "Unknown XMLHttpRequest Error"))), M.statusCode = 0, !f && Zt.retryManager.getIsEnabled() && t.retry && t.retry.shouldRetry()) {
      t.retryTimeout = setTimeout(function() {
        t.retry.moveToNextAttempt(), t.xhr = c, Ff(t);
      }, t.retry.getCurrentFuzzedDelay());
      return;
    }
    if (t.requestType && Zt.responseInterceptorsStorage.getIsEnabled()) {
      var E = {
        headers: L.headers || {},
        body: L.body,
        responseUrl: c.responseURL,
        responseType: c.responseType
      }, P = Zt.responseInterceptorsStorage.execute(t.requestType, E);
      L.body = P.body, L.headers = P.headers;
    }
    return i(M, L);
  }
  function l() {
    if (!f) {
      var M;
      clearTimeout(D), clearTimeout(t.retryTimeout), t.useXDR && c.status === void 0 ? M = 200 : M = c.status === 1223 ? 204 : c.status;
      var E = L, P = null;
      if (M !== 0 ? (E = {
        body: s(),
        statusCode: M,
        method: _,
        headers: {},
        url: m,
        rawRequest: c
      }, c.getAllResponseHeaders && (E.headers = WQ(c.getAllResponseHeaders()))) : P = new Error("Internal XMLHttpRequest Error"), t.requestType && Zt.responseInterceptorsStorage.getIsEnabled()) {
        var B = {
          headers: E.headers || {},
          body: E.body,
          responseUrl: c.responseURL,
          responseType: c.responseType
        }, z = Zt.responseInterceptorsStorage.execute(t.requestType, B);
        E.body = z.body, E.headers = z.headers;
      }
      return i(P, E, E.body);
    }
  }
  var c = t.xhr || null;
  c || (t.cors || t.useXDR ? c = new Zt.XDomainRequest() : c = new Zt.XMLHttpRequest());
  var u, f, m = c.url = t.uri || t.url, _ = c.method = t.method || "GET", T = t.body || t.data, g = c.headers = t.headers || {}, x = !!t.sync, S = !1, D, L = {
    body: void 0,
    headers: {},
    statusCode: 0,
    method: _,
    url: m,
    rawRequest: c
  };
  if ("json" in t && t.json !== !1 && (S = !0, g.accept || g.Accept || (g.Accept = "application/json"), _ !== "GET" && _ !== "HEAD" && (g["content-type"] || g["Content-Type"] || (g["Content-Type"] = "application/json"), T = JSON.stringify(t.json === !0 ? T : t.json))), c.onreadystatechange = r, c.onload = l, c.onerror = o, c.onprogress = function() {
  }, c.onabort = function() {
    f = !0, clearTimeout(t.retryTimeout);
  }, c.ontimeout = o, c.open(_, m, !x, t.username, t.password), x || (c.withCredentials = !!t.withCredentials), !x && t.timeout > 0 && (D = setTimeout(function() {
    if (!f) {
      f = !0, c.abort("timeout");
      var M = new Error("XMLHttpRequest timeout");
      M.code = "ETIMEDOUT", o(M);
    }
  }, t.timeout)), c.setRequestHeader)
    for (u in g)
      g.hasOwnProperty(u) && c.setRequestHeader(u, g[u]);
  else if (t.headers && !XQ(t.headers))
    throw new Error("Headers cannot be set on an XDomainRequest object");
  return "responseType" in t && (c.responseType = t.responseType), "beforeSend" in t && typeof t.beforeSend == "function" && t.beforeSend(c), c.send(T || null), c;
}
function ZQ(t) {
  try {
    if (t.responseType === "document")
      return t.responseXML;
    var e = t.responseXML && t.responseXML.documentElement.nodeName === "parsererror";
    if (t.responseType === "" && !e)
      return t.responseXML;
  } catch {
  }
  return null;
}
function KQ() {
}
var QQ = $f.exports;
const o5 = /* @__PURE__ */ ka(QQ);
var l5 = { exports: {} }, yg = n5, zf = Object.create || /* @__PURE__ */ function() {
  function t() {
  }
  return function(e) {
    if (arguments.length !== 1)
      throw new Error("Object.create shim only accepts one parameter.");
    return t.prototype = e, new t();
  };
}();
function ca(t, e) {
  this.name = "ParsingError", this.code = t.code, this.message = e || t.message;
}
ca.prototype = zf(Error.prototype);
ca.prototype.constructor = ca;
ca.Errors = {
  BadSignature: {
    code: 0,
    message: "Malformed WebVTT signature."
  },
  BadTimeStamp: {
    code: 1,
    message: "Malformed time stamp."
  }
};
function Uf(t) {
  function e(a, i, r, s) {
    return (a | 0) * 3600 + (i | 0) * 60 + (r | 0) + (s | 0) / 1e3;
  }
  var n = t.match(/^(\d+):(\d{1,2})(:\d{1,2})?\.(\d{3})/);
  return n ? n[3] ? e(n[1], n[2], n[3].replace(":", ""), n[4]) : n[1] > 59 ? e(n[1], n[2], 0, n[4]) : e(0, n[1], n[2], n[4]) : null;
}
function ul() {
  this.values = zf(null);
}
ul.prototype = {
  // Only accept the first assignment to any key.
  set: function(t, e) {
    !this.get(t) && e !== "" && (this.values[t] = e);
  },
  // Return the value for a key, or a default value.
  // If 'defaultKey' is passed then 'dflt' is assumed to be an object with
  // a number of possible default values as properties where 'defaultKey' is
  // the key of the property that will be chosen; otherwise it's assumed to be
  // a single value.
  get: function(t, e, n) {
    return n ? this.has(t) ? this.values[t] : e[n] : this.has(t) ? this.values[t] : e;
  },
  // Check whether we have a value for a key.
  has: function(t) {
    return t in this.values;
  },
  // Accept a setting if its one of the given alternatives.
  alt: function(t, e, n) {
    for (var a = 0; a < n.length; ++a)
      if (e === n[a]) {
        this.set(t, e);
        break;
      }
  },
  // Accept a setting if its a valid (signed) integer.
  integer: function(t, e) {
    /^-?\d+$/.test(e) && this.set(t, parseInt(e, 10));
  },
  // Accept a setting if its a valid percentage.
  percent: function(t, e) {
    return e.match(/^([\d]{1,3})(\.[\d]*)?%$/) && (e = parseFloat(e), e >= 0 && e <= 100) ? (this.set(t, e), !0) : !1;
  }
};
function tl(t, e, n, a) {
  var i = a ? t.split(a) : [t];
  for (var r in i)
    if (typeof i[r] == "string") {
      var s = i[r].split(n);
      if (s.length === 2) {
        var o = s[0].trim(), l = s[1].trim();
        e(o, l);
      }
    }
}
function JQ(t, e, n) {
  var a = t;
  function i() {
    var o = Uf(t);
    if (o === null)
      throw new ca(
        ca.Errors.BadTimeStamp,
        "Malformed timestamp: " + a
      );
    return t = t.replace(/^[^\sa-zA-Z-]+/, ""), o;
  }
  function r(o, l) {
    var c = new ul();
    tl(o, function(u, f) {
      switch (u) {
        case "region":
          for (var m = n.length - 1; m >= 0; m--)
            if (n[m].id === f) {
              c.set(u, n[m].region);
              break;
            }
          break;
        case "vertical":
          c.alt(u, f, ["rl", "lr"]);
          break;
        case "line":
          var _ = f.split(","), T = _[0];
          c.integer(u, T), c.percent(u, T) && c.set("snapToLines", !1), c.alt(u, T, ["auto"]), _.length === 2 && c.alt("lineAlign", _[1], ["start", "center", "end"]);
          break;
        case "position":
          _ = f.split(","), c.percent(u, _[0]), _.length === 2 && c.alt("positionAlign", _[1], ["start", "center", "end"]);
          break;
        case "size":
          c.percent(u, f);
          break;
        case "align":
          c.alt(u, f, ["start", "center", "end", "left", "right"]);
          break;
      }
    }, /:/, /\s/), l.region = c.get("region", null), l.vertical = c.get("vertical", "");
    try {
      l.line = c.get("line", "auto");
    } catch {
    }
    l.lineAlign = c.get("lineAlign", "start"), l.snapToLines = c.get("snapToLines", !0), l.size = c.get("size", 100);
    try {
      l.align = c.get("align", "center");
    } catch {
      l.align = c.get("align", "middle");
    }
    try {
      l.position = c.get("position", "auto");
    } catch {
      l.position = c.get("position", {
        start: 0,
        left: 0,
        center: 50,
        middle: 50,
        end: 100,
        right: 100
      }, l.align);
    }
    l.positionAlign = c.get("positionAlign", {
      start: "start",
      left: "start",
      center: "center",
      middle: "center",
      end: "end",
      right: "end"
    }, l.align);
  }
  function s() {
    t = t.replace(/^\s+/, "");
  }
  if (s(), e.startTime = i(), s(), t.substr(0, 3) !== "-->")
    throw new ca(
      ca.Errors.BadTimeStamp,
      "Malformed time stamp (time stamps must be separated by '-->'): " + a
    );
  t = t.substr(3), s(), e.endTime = i(), s(), r(t, e);
}
var T0 = yg.createElement && yg.createElement("textarea"), eJ = {
  c: "span",
  i: "i",
  b: "b",
  u: "u",
  ruby: "ruby",
  rt: "rt",
  v: "span",
  lang: "span"
}, _g = {
  white: "rgba(255,255,255,1)",
  lime: "rgba(0,255,0,1)",
  cyan: "rgba(0,255,255,1)",
  red: "rgba(255,0,0,1)",
  yellow: "rgba(255,255,0,1)",
  magenta: "rgba(255,0,255,1)",
  blue: "rgba(0,0,255,1)",
  black: "rgba(0,0,0,1)"
}, tJ = {
  v: "title",
  lang: "lang"
}, Tg = {
  rt: "ruby"
};
function c5(t, e) {
  function n() {
    if (!e)
      return null;
    function T(x) {
      return e = e.substr(x.length), x;
    }
    var g = e.match(/^([^<]*)(<[^>]*>?)?/);
    return T(g[1] ? g[1] : g[2]);
  }
  function a(T) {
    return T0.innerHTML = T, T = T0.textContent, T0.textContent = "", T;
  }
  function i(T, g) {
    return !Tg[g.localName] || Tg[g.localName] === T.localName;
  }
  function r(T, g) {
    var x = eJ[T];
    if (!x)
      return null;
    var S = t.document.createElement(x), D = tJ[T];
    return D && g && (S[D] = g.trim()), S;
  }
  for (var s = t.document.createElement("div"), o = s, l, c = []; (l = n()) !== null; ) {
    if (l[0] === "<") {
      if (l[1] === "/") {
        c.length && c[c.length - 1] === l.substr(2).replace(">", "") && (c.pop(), o = o.parentNode);
        continue;
      }
      var u = Uf(l.substr(1, l.length - 2)), f;
      if (u) {
        f = t.document.createProcessingInstruction("timestamp", u), o.appendChild(f);
        continue;
      }
      var m = l.match(/^<([^.\s/0-9>]+)(\.[^\s\\>]+)?([^>\\]+)?(\\?)>?$/);
      if (!m || (f = r(m[1], m[3]), !f) || !i(o, f))
        continue;
      if (m[2]) {
        var _ = m[2].split(".");
        _.forEach(function(T) {
          var g = /^bg_/.test(T), x = g ? T.slice(3) : T;
          if (_g.hasOwnProperty(x)) {
            var S = g ? "background-color" : "color", D = _g[x];
            f.style[S] = D;
          }
        }), f.className = _.join(" ");
      }
      c.push(m[1]), o.appendChild(f), o = f;
      continue;
    }
    o.appendChild(t.document.createTextNode(a(l)));
  }
  return s;
}
var xg = [
  [1470, 1470],
  [1472, 1472],
  [1475, 1475],
  [1478, 1478],
  [1488, 1514],
  [1520, 1524],
  [1544, 1544],
  [1547, 1547],
  [1549, 1549],
  [1563, 1563],
  [1566, 1610],
  [1645, 1647],
  [1649, 1749],
  [1765, 1766],
  [1774, 1775],
  [1786, 1805],
  [1807, 1808],
  [1810, 1839],
  [1869, 1957],
  [1969, 1969],
  [1984, 2026],
  [2036, 2037],
  [2042, 2042],
  [2048, 2069],
  [2074, 2074],
  [2084, 2084],
  [2088, 2088],
  [2096, 2110],
  [2112, 2136],
  [2142, 2142],
  [2208, 2208],
  [2210, 2220],
  [8207, 8207],
  [64285, 64285],
  [64287, 64296],
  [64298, 64310],
  [64312, 64316],
  [64318, 64318],
  [64320, 64321],
  [64323, 64324],
  [64326, 64449],
  [64467, 64829],
  [64848, 64911],
  [64914, 64967],
  [65008, 65020],
  [65136, 65140],
  [65142, 65276],
  [67584, 67589],
  [67592, 67592],
  [67594, 67637],
  [67639, 67640],
  [67644, 67644],
  [67647, 67669],
  [67671, 67679],
  [67840, 67867],
  [67872, 67897],
  [67903, 67903],
  [67968, 68023],
  [68030, 68031],
  [68096, 68096],
  [68112, 68115],
  [68117, 68119],
  [68121, 68147],
  [68160, 68167],
  [68176, 68184],
  [68192, 68223],
  [68352, 68405],
  [68416, 68437],
  [68440, 68466],
  [68472, 68479],
  [68608, 68680],
  [126464, 126467],
  [126469, 126495],
  [126497, 126498],
  [126500, 126500],
  [126503, 126503],
  [126505, 126514],
  [126516, 126519],
  [126521, 126521],
  [126523, 126523],
  [126530, 126530],
  [126535, 126535],
  [126537, 126537],
  [126539, 126539],
  [126541, 126543],
  [126545, 126546],
  [126548, 126548],
  [126551, 126551],
  [126553, 126553],
  [126555, 126555],
  [126557, 126557],
  [126559, 126559],
  [126561, 126562],
  [126564, 126564],
  [126567, 126570],
  [126572, 126578],
  [126580, 126583],
  [126585, 126588],
  [126590, 126590],
  [126592, 126601],
  [126603, 126619],
  [126625, 126627],
  [126629, 126633],
  [126635, 126651],
  [1114109, 1114109]
];
function nJ(t) {
  for (var e = 0; e < xg.length; e++) {
    var n = xg[e];
    if (t >= n[0] && t <= n[1])
      return !0;
  }
  return !1;
}
function aJ(t) {
  var e = [], n = "", a;
  if (!t || !t.childNodes)
    return "ltr";
  function i(o, l) {
    for (var c = l.childNodes.length - 1; c >= 0; c--)
      o.push(l.childNodes[c]);
  }
  function r(o) {
    if (!o || !o.length)
      return null;
    var l = o.pop(), c = l.textContent || l.innerText;
    if (c) {
      var u = c.match(/^.*(\n|\r)/);
      return u ? (o.length = 0, u[0]) : c;
    }
    if (l.tagName === "ruby")
      return r(o);
    if (l.childNodes)
      return i(o, l), r(o);
  }
  for (i(e, t); n = r(e); )
    for (var s = 0; s < n.length; s++)
      if (a = n.charCodeAt(s), nJ(a))
        return "rtl";
  return "ltr";
}
function iJ(t) {
  if (typeof t.line == "number" && (t.snapToLines || t.line >= 0 && t.line <= 100))
    return t.line;
  if (!t.track || !t.track.textTrackList || !t.track.textTrackList.mediaElement)
    return -1;
  for (var e = t.track, n = e.textTrackList, a = 0, i = 0; i < n.length && n[i] !== e; i++)
    n[i].mode === "showing" && a++;
  return ++a * -1;
}
function ld() {
}
ld.prototype.applyStyles = function(t, e) {
  e = e || this.div;
  for (var n in t)
    t.hasOwnProperty(n) && (e.style[n] = t[n]);
};
ld.prototype.formatStyle = function(t, e) {
  return t === 0 ? 0 : t + e;
};
function fu(t, e, n) {
  ld.call(this), this.cue = e, this.cueDiv = c5(t, e.text);
  var a = {
    color: "rgba(255, 255, 255, 1)",
    backgroundColor: "rgba(0, 0, 0, 0.8)",
    position: "relative",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    display: "inline",
    writingMode: e.vertical === "" ? "horizontal-tb" : e.vertical === "lr" ? "vertical-lr" : "vertical-rl",
    unicodeBidi: "plaintext"
  };
  this.applyStyles(a, this.cueDiv), this.div = t.document.createElement("div"), a = {
    direction: aJ(this.cueDiv),
    writingMode: e.vertical === "" ? "horizontal-tb" : e.vertical === "lr" ? "vertical-lr" : "vertical-rl",
    unicodeBidi: "plaintext",
    textAlign: e.align === "middle" ? "center" : e.align,
    font: n.font,
    whiteSpace: "pre-line",
    position: "absolute"
  }, this.applyStyles(a), this.div.appendChild(this.cueDiv);
  var i = 0;
  switch (e.positionAlign) {
    case "start":
    case "line-left":
      i = e.position;
      break;
    case "center":
      i = e.position - e.size / 2;
      break;
    case "end":
    case "line-right":
      i = e.position - e.size;
      break;
  }
  e.vertical === "" ? this.applyStyles({
    left: this.formatStyle(i, "%"),
    width: this.formatStyle(e.size, "%")
  }) : this.applyStyles({
    top: this.formatStyle(i, "%"),
    height: this.formatStyle(e.size, "%")
  }), this.move = function(r) {
    this.applyStyles({
      top: this.formatStyle(r.top, "px"),
      bottom: this.formatStyle(r.bottom, "px"),
      left: this.formatStyle(r.left, "px"),
      right: this.formatStyle(r.right, "px"),
      height: this.formatStyle(r.height, "px"),
      width: this.formatStyle(r.width, "px")
    });
  };
}
fu.prototype = zf(ld.prototype);
fu.prototype.constructor = fu;
function Fn(t) {
  var e, n, a, i;
  if (t.div) {
    n = t.div.offsetHeight, a = t.div.offsetWidth, i = t.div.offsetTop;
    var r = (r = t.div.childNodes) && (r = r[0]) && r.getClientRects && r.getClientRects();
    t = t.div.getBoundingClientRect(), e = r ? Math.max(r[0] && r[0].height || 0, t.height / r.length) : 0;
  }
  this.left = t.left, this.right = t.right, this.top = t.top || i, this.height = t.height || n, this.bottom = t.bottom || i + (t.height || n), this.width = t.width || a, this.lineHeight = e !== void 0 ? e : t.lineHeight;
}
Fn.prototype.move = function(t, e) {
  switch (e = e !== void 0 ? e : this.lineHeight, t) {
    case "+x":
      this.left += e, this.right += e;
      break;
    case "-x":
      this.left -= e, this.right -= e;
      break;
    case "+y":
      this.top += e, this.bottom += e;
      break;
    case "-y":
      this.top -= e, this.bottom -= e;
      break;
  }
};
Fn.prototype.overlaps = function(t) {
  return this.left < t.right && this.right > t.left && this.top < t.bottom && this.bottom > t.top;
};
Fn.prototype.overlapsAny = function(t) {
  for (var e = 0; e < t.length; e++)
    if (this.overlaps(t[e]))
      return !0;
  return !1;
};
Fn.prototype.within = function(t) {
  return this.top >= t.top && this.bottom <= t.bottom && this.left >= t.left && this.right <= t.right;
};
Fn.prototype.overlapsOppositeAxis = function(t, e) {
  switch (e) {
    case "+x":
      return this.left < t.left;
    case "-x":
      return this.right > t.right;
    case "+y":
      return this.top < t.top;
    case "-y":
      return this.bottom > t.bottom;
  }
};
Fn.prototype.intersectPercentage = function(t) {
  var e = Math.max(0, Math.min(this.right, t.right) - Math.max(this.left, t.left)), n = Math.max(0, Math.min(this.bottom, t.bottom) - Math.max(this.top, t.top)), a = e * n;
  return a / (this.height * this.width);
};
Fn.prototype.toCSSCompatValues = function(t) {
  return {
    top: this.top - t.top,
    bottom: t.bottom - this.bottom,
    left: this.left - t.left,
    right: t.right - this.right,
    height: this.height,
    width: this.width
  };
};
Fn.getSimpleBoxPosition = function(t) {
  var e = t.div ? t.div.offsetHeight : t.tagName ? t.offsetHeight : 0, n = t.div ? t.div.offsetWidth : t.tagName ? t.offsetWidth : 0, a = t.div ? t.div.offsetTop : t.tagName ? t.offsetTop : 0;
  t = t.div ? t.div.getBoundingClientRect() : t.tagName ? t.getBoundingClientRect() : t;
  var i = {
    left: t.left,
    right: t.right,
    top: t.top || a,
    height: t.height || e,
    bottom: t.bottom || a + (t.height || e),
    width: t.width || n
  };
  return i;
};
function rJ(t, e, n, a) {
  function i(x, S) {
    for (var D, L = new Fn(x), M = 1, E = 0; E < S.length; E++) {
      for (; x.overlapsOppositeAxis(n, S[E]) || x.within(n) && x.overlapsAny(a); )
        x.move(S[E]);
      if (x.within(n))
        return x;
      var P = x.intersectPercentage(n);
      M > P && (D = new Fn(x), M = P), x = new Fn(L);
    }
    return D || L;
  }
  var r = new Fn(e), s = e.cue, o = iJ(s), l = [];
  if (s.snapToLines) {
    var c;
    switch (s.vertical) {
      case "":
        l = ["+y", "-y"], c = "height";
        break;
      case "rl":
        l = ["+x", "-x"], c = "width";
        break;
      case "lr":
        l = ["-x", "+x"], c = "width";
        break;
    }
    var u = r.lineHeight, f = u * Math.round(o), m = n[c] + u, _ = l[0];
    Math.abs(f) > m && (f = f < 0 ? -1 : 1, f *= Math.ceil(m / u) * u), o < 0 && (f += s.vertical === "" ? n.height : n.width, l = l.reverse()), r.move(_, f);
  } else {
    var T = r.lineHeight / n.height * 100;
    switch (s.lineAlign) {
      case "center":
        o -= T / 2;
        break;
      case "end":
        o -= T;
        break;
    }
    switch (s.vertical) {
      case "":
        e.applyStyles({
          top: e.formatStyle(o, "%")
        });
        break;
      case "rl":
        e.applyStyles({
          left: e.formatStyle(o, "%")
        });
        break;
      case "lr":
        e.applyStyles({
          right: e.formatStyle(o, "%")
        });
        break;
    }
    l = ["+y", "-x", "+x", "-y"], r = new Fn(e);
  }
  var g = i(r, l);
  e.move(g.toCSSCompatValues(n));
}
function lo() {
}
lo.StringDecoder = function() {
  return {
    decode: function(t) {
      if (!t)
        return "";
      if (typeof t != "string")
        throw new Error("Error - expected string data.");
      return decodeURIComponent(encodeURIComponent(t));
    }
  };
};
lo.convertCueToDOMTree = function(t, e) {
  return !t || !e ? null : c5(t, e);
};
var sJ = 0.05, oJ = "sans-serif", lJ = "1.5%";
lo.processCues = function(t, e, n) {
  if (!t || !e || !n)
    return null;
  for (; n.firstChild; )
    n.removeChild(n.firstChild);
  var a = t.document.createElement("div");
  a.style.position = "absolute", a.style.left = "0", a.style.right = "0", a.style.top = "0", a.style.bottom = "0", a.style.margin = lJ, n.appendChild(a);
  function i(u) {
    for (var f = 0; f < u.length; f++)
      if (u[f].hasBeenReset || !u[f].displayState)
        return !0;
    return !1;
  }
  if (!i(e)) {
    for (var r = 0; r < e.length; r++)
      a.appendChild(e[r].displayState);
    return;
  }
  var s = [], o = Fn.getSimpleBoxPosition(a), l = Math.round(o.height * sJ * 100) / 100, c = {
    font: l + "px " + oJ
  };
  (function() {
    for (var u, f, m = 0; m < e.length; m++)
      f = e[m], u = new fu(t, f, c), a.appendChild(u.div), rJ(t, u, o, s), f.displayState = u.div, s.push(Fn.getSimpleBoxPosition(u));
  })();
};
lo.Parser = function(t, e, n) {
  n || (n = e, e = {}), e || (e = {}), this.window = t, this.vttjs = e, this.state = "INITIAL", this.buffer = "", this.decoder = n || new TextDecoder("utf8"), this.regionList = [];
};
lo.Parser.prototype = {
  // If the error is a ParsingError then report it to the consumer if
  // possible. If it's not a ParsingError then throw it like normal.
  reportOrThrowError: function(t) {
    if (t instanceof ca)
      this.onparsingerror && this.onparsingerror(t);
    else
      throw t;
  },
  parse: function(t) {
    var e = this;
    t && (e.buffer += e.decoder.decode(t, { stream: !0 }));
    function n() {
      for (var u = e.buffer, f = 0; f < u.length && u[f] !== "\r" && u[f] !== `
`; )
        ++f;
      var m = u.substr(0, f);
      return u[f] === "\r" && ++f, u[f] === `
` && ++f, e.buffer = u.substr(f), m;
    }
    function a(u) {
      var f = new ul();
      if (tl(u, function(_, T) {
        switch (_) {
          case "id":
            f.set(_, T);
            break;
          case "width":
            f.percent(_, T);
            break;
          case "lines":
            f.integer(_, T);
            break;
          case "regionanchor":
          case "viewportanchor":
            var g = T.split(",");
            if (g.length !== 2)
              break;
            var x = new ul();
            if (x.percent("x", g[0]), x.percent("y", g[1]), !x.has("x") || !x.has("y"))
              break;
            f.set(_ + "X", x.get("x")), f.set(_ + "Y", x.get("y"));
            break;
          case "scroll":
            f.alt(_, T, ["up"]);
            break;
        }
      }, /=/, /\s/), f.has("id")) {
        var m = new (e.vttjs.VTTRegion || e.window.VTTRegion)();
        m.width = f.get("width", 100), m.lines = f.get("lines", 3), m.regionAnchorX = f.get("regionanchorX", 0), m.regionAnchorY = f.get("regionanchorY", 100), m.viewportAnchorX = f.get("viewportanchorX", 0), m.viewportAnchorY = f.get("viewportanchorY", 100), m.scroll = f.get("scroll", ""), e.onregion && e.onregion(m), e.regionList.push({
          id: f.get("id"),
          region: m
        });
      }
    }
    function i(u) {
      var f = new ul();
      tl(u, function(m, _) {
        switch (m) {
          case "MPEGT":
            f.integer(m + "S", _);
            break;
          case "LOCA":
            f.set(m + "L", Uf(_));
            break;
        }
      }, /[^\d]:/, /,/), e.ontimestampmap && e.ontimestampmap({
        MPEGTS: f.get("MPEGTS"),
        LOCAL: f.get("LOCAL")
      });
    }
    function r(u) {
      u.match(/X-TIMESTAMP-MAP/) ? tl(u, function(f, m) {
        switch (f) {
          case "X-TIMESTAMP-MAP":
            i(m);
            break;
        }
      }, /=/) : tl(u, function(f, m) {
        switch (f) {
          case "Region":
            a(m);
            break;
        }
      }, /:/);
    }
    try {
      var s;
      if (e.state === "INITIAL") {
        if (!/\r\n|\n/.test(e.buffer))
          return this;
        s = n();
        var o = s.match(/^WEBVTT([ \t].*)?$/);
        if (!o || !o[0])
          throw new ca(ca.Errors.BadSignature);
        e.state = "HEADER";
      }
      for (var l = !1; e.buffer; ) {
        if (!/\r\n|\n/.test(e.buffer))
          return this;
        switch (l ? l = !1 : s = n(), e.state) {
          case "HEADER":
            /:/.test(s) ? r(s) : s || (e.state = "ID");
            continue;
          case "NOTE":
            s || (e.state = "ID");
            continue;
          case "ID":
            if (/^NOTE($|[ \t])/.test(s)) {
              e.state = "NOTE";
              break;
            }
            if (!s)
              continue;
            e.cue = new (e.vttjs.VTTCue || e.window.VTTCue)(0, 0, "");
            try {
              e.cue.align = "center";
            } catch {
              e.cue.align = "middle";
            }
            if (e.state = "CUE", s.indexOf("-->") === -1) {
              e.cue.id = s;
              continue;
            }
          case "CUE":
            try {
              JQ(s, e.cue, e.regionList);
            } catch (u) {
              e.reportOrThrowError(u), e.cue = null, e.state = "BADCUE";
              continue;
            }
            e.state = "CUETEXT";
            continue;
          case "CUETEXT":
            var c = s.indexOf("-->") !== -1;
            if (!s || c && (l = !0)) {
              e.oncue && e.oncue(e.cue), e.cue = null, e.state = "ID";
              continue;
            }
            e.cue.text && (e.cue.text += `
`), e.cue.text += s.replace(/\u2028/g, `
`).replace(/u2029/g, `
`);
            continue;
          case "BADCUE":
            s || (e.state = "ID");
            continue;
        }
      }
    } catch (u) {
      e.reportOrThrowError(u), e.state === "CUETEXT" && e.cue && e.oncue && e.oncue(e.cue), e.cue = null, e.state = e.state === "INITIAL" ? "BADWEBVTT" : "BADCUE";
    }
    return this;
  },
  flush: function() {
    var t = this;
    try {
      if (t.buffer += t.decoder.decode(), (t.cue || t.state === "HEADER") && (t.buffer += `

`, t.parse()), t.state === "INITIAL")
        throw new ca(ca.Errors.BadSignature);
    } catch (e) {
      t.reportOrThrowError(e);
    }
    return t.onflush && t.onflush(), this;
  }
};
var cJ = lo, uJ = "auto", dJ = {
  "": 1,
  lr: 1,
  rl: 1
}, hJ = {
  start: 1,
  center: 1,
  end: 1,
  left: 1,
  right: 1,
  auto: 1,
  "line-left": 1,
  "line-right": 1
};
function fJ(t) {
  if (typeof t != "string")
    return !1;
  var e = dJ[t.toLowerCase()];
  return e ? t.toLowerCase() : !1;
}
function x0(t) {
  if (typeof t != "string")
    return !1;
  var e = hJ[t.toLowerCase()];
  return e ? t.toLowerCase() : !1;
}
function u5(t, e, n) {
  this.hasBeenReset = !1;
  var a = "", i = !1, r = t, s = e, o = n, l = null, c = "", u = !0, f = "auto", m = "start", _ = "auto", T = "auto", g = 100, x = "center";
  Object.defineProperties(this, {
    id: {
      enumerable: !0,
      get: function() {
        return a;
      },
      set: function(S) {
        a = "" + S;
      }
    },
    pauseOnExit: {
      enumerable: !0,
      get: function() {
        return i;
      },
      set: function(S) {
        i = !!S;
      }
    },
    startTime: {
      enumerable: !0,
      get: function() {
        return r;
      },
      set: function(S) {
        if (typeof S != "number")
          throw new TypeError("Start time must be set to a number.");
        r = S, this.hasBeenReset = !0;
      }
    },
    endTime: {
      enumerable: !0,
      get: function() {
        return s;
      },
      set: function(S) {
        if (typeof S != "number")
          throw new TypeError("End time must be set to a number.");
        s = S, this.hasBeenReset = !0;
      }
    },
    text: {
      enumerable: !0,
      get: function() {
        return o;
      },
      set: function(S) {
        o = "" + S, this.hasBeenReset = !0;
      }
    },
    region: {
      enumerable: !0,
      get: function() {
        return l;
      },
      set: function(S) {
        l = S, this.hasBeenReset = !0;
      }
    },
    vertical: {
      enumerable: !0,
      get: function() {
        return c;
      },
      set: function(S) {
        var D = fJ(S);
        if (D === !1)
          throw new SyntaxError("Vertical: an invalid or illegal direction string was specified.");
        c = D, this.hasBeenReset = !0;
      }
    },
    snapToLines: {
      enumerable: !0,
      get: function() {
        return u;
      },
      set: function(S) {
        u = !!S, this.hasBeenReset = !0;
      }
    },
    line: {
      enumerable: !0,
      get: function() {
        return f;
      },
      set: function(S) {
        if (typeof S != "number" && S !== uJ)
          throw new SyntaxError("Line: an invalid number or illegal string was specified.");
        f = S, this.hasBeenReset = !0;
      }
    },
    lineAlign: {
      enumerable: !0,
      get: function() {
        return m;
      },
      set: function(S) {
        var D = x0(S);
        D ? (m = D, this.hasBeenReset = !0) : console.warn("lineAlign: an invalid or illegal string was specified.");
      }
    },
    position: {
      enumerable: !0,
      get: function() {
        return _;
      },
      set: function(S) {
        if (S < 0 || S > 100)
          throw new Error("Position must be between 0 and 100.");
        _ = S, this.hasBeenReset = !0;
      }
    },
    positionAlign: {
      enumerable: !0,
      get: function() {
        return T;
      },
      set: function(S) {
        var D = x0(S);
        D ? (T = D, this.hasBeenReset = !0) : console.warn("positionAlign: an invalid or illegal string was specified.");
      }
    },
    size: {
      enumerable: !0,
      get: function() {
        return g;
      },
      set: function(S) {
        if (S < 0 || S > 100)
          throw new Error("Size must be between 0 and 100.");
        g = S, this.hasBeenReset = !0;
      }
    },
    align: {
      enumerable: !0,
      get: function() {
        return x;
      },
      set: function(S) {
        var D = x0(S);
        if (!D)
          throw new SyntaxError("align: an invalid or illegal alignment string was specified.");
        x = D, this.hasBeenReset = !0;
      }
    }
  }), this.displayState = void 0;
}
u5.prototype.getCueAsHTML = function() {
  return WebVTT.convertCueToDOMTree(window, this.text);
};
var pJ = u5, mJ = {
  "": !0,
  up: !0
};
function gJ(t) {
  if (typeof t != "string")
    return !1;
  var e = mJ[t.toLowerCase()];
  return e ? t.toLowerCase() : !1;
}
function Yo(t) {
  return typeof t == "number" && t >= 0 && t <= 100;
}
function bJ() {
  var t = 100, e = 3, n = 0, a = 100, i = 0, r = 100, s = "";
  Object.defineProperties(this, {
    width: {
      enumerable: !0,
      get: function() {
        return t;
      },
      set: function(o) {
        if (!Yo(o))
          throw new Error("Width must be between 0 and 100.");
        t = o;
      }
    },
    lines: {
      enumerable: !0,
      get: function() {
        return e;
      },
      set: function(o) {
        if (typeof o != "number")
          throw new TypeError("Lines must be set to a number.");
        e = o;
      }
    },
    regionAnchorY: {
      enumerable: !0,
      get: function() {
        return a;
      },
      set: function(o) {
        if (!Yo(o))
          throw new Error("RegionAnchorX must be between 0 and 100.");
        a = o;
      }
    },
    regionAnchorX: {
      enumerable: !0,
      get: function() {
        return n;
      },
      set: function(o) {
        if (!Yo(o))
          throw new Error("RegionAnchorY must be between 0 and 100.");
        n = o;
      }
    },
    viewportAnchorY: {
      enumerable: !0,
      get: function() {
        return r;
      },
      set: function(o) {
        if (!Yo(o))
          throw new Error("ViewportAnchorY must be between 0 and 100.");
        r = o;
      }
    },
    viewportAnchorX: {
      enumerable: !0,
      get: function() {
        return i;
      },
      set: function(o) {
        if (!Yo(o))
          throw new Error("ViewportAnchorX must be between 0 and 100.");
        i = o;
      }
    },
    scroll: {
      enumerable: !0,
      get: function() {
        return s;
      },
      set: function(o) {
        var l = gJ(o);
        l === !1 ? console.warn("Scroll: an invalid or illegal string was specified.") : s = l;
      }
    }
  });
}
var vJ = bJ, Ci = od, Vr = l5.exports = {
  WebVTT: cJ,
  VTTCue: pJ,
  VTTRegion: vJ
};
Ci.vttjs = Vr;
Ci.WebVTT = Vr.WebVTT;
var yJ = Vr.VTTCue, _J = Vr.VTTRegion, TJ = Ci.VTTCue, xJ = Ci.VTTRegion;
Vr.shim = function() {
  Ci.VTTCue = yJ, Ci.VTTRegion = _J;
};
Vr.restore = function() {
  Ci.VTTCue = TJ, Ci.VTTRegion = xJ;
};
Ci.VTTCue || Vr.shim();
var wJ = l5.exports;
const wg = /* @__PURE__ */ ka(wJ);
function Jt() {
  return Jt = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var a in n) ({}).hasOwnProperty.call(n, a) && (t[a] = n[a]);
    }
    return t;
  }, Jt.apply(null, arguments);
}
var kg = "https://example.com", cd = function(e, n) {
  if (/^[a-z]+:/i.test(n))
    return n;
  /^data:/.test(e) && (e = j.location && j.location.href || "");
  var a = /^\/\//.test(e), i = !j.location && !/\/\//i.test(e);
  e = new j.URL(e, j.location || kg);
  var r = new URL(n, e);
  return i ? r.href.slice(kg.length) : a ? r.href.slice(r.protocol.length) : r.href;
}, Hf = /* @__PURE__ */ function() {
  function t() {
    this.listeners = {};
  }
  var e = t.prototype;
  return e.on = function(a, i) {
    this.listeners[a] || (this.listeners[a] = []), this.listeners[a].push(i);
  }, e.off = function(a, i) {
    if (!this.listeners[a])
      return !1;
    var r = this.listeners[a].indexOf(i);
    return this.listeners[a] = this.listeners[a].slice(0), this.listeners[a].splice(r, 1), r > -1;
  }, e.trigger = function(a) {
    var i = this.listeners[a];
    if (i)
      if (arguments.length === 2)
        for (var r = i.length, s = 0; s < r; ++s)
          i[s].call(this, arguments[1]);
      else
        for (var o = Array.prototype.slice.call(arguments, 1), l = i.length, c = 0; c < l; ++c)
          i[c].apply(this, o);
  }, e.dispose = function() {
    this.listeners = {};
  }, e.pipe = function(a) {
    this.on("data", function(i) {
      a.push(i);
    });
  }, t;
}(), kJ = function(e) {
  return j.atob ? j.atob(e) : Buffer.from(e, "base64").toString("binary");
};
function d5(t) {
  for (var e = kJ(t), n = new Uint8Array(e.length), a = 0; a < e.length; a++)
    n[a] = e.charCodeAt(a);
  return n;
}
/*! @name m3u8-parser @version 7.2.0 @license Apache-2.0 */
class CJ extends Hf {
  constructor() {
    super(), this.buffer = "";
  }
  /**
   * Add new data to be parsed.
   *
   * @param {string} data the text to process
   */
  push(e) {
    let n;
    for (this.buffer += e, n = this.buffer.indexOf(`
`); n > -1; n = this.buffer.indexOf(`
`))
      this.trigger("data", this.buffer.substring(0, n)), this.buffer = this.buffer.substring(n + 1);
  }
}
const SJ = "	", w0 = function(t) {
  const e = /([0-9.]*)?@?([0-9.]*)?/.exec(t || ""), n = {};
  return e[1] && (n.length = parseInt(e[1], 10)), e[2] && (n.offset = parseInt(e[2], 10)), n;
}, AJ = function() {
  const n = "(?:" + "[^=]*" + ")=(?:" + '"[^"]*"|[^,]*' + ")";
  return new RegExp("(?:^|,)(" + n + ")");
}, On = function(t) {
  const e = {};
  if (!t)
    return e;
  const n = t.split(AJ());
  let a = n.length, i;
  for (; a--; )
    n[a] !== "" && (i = /([^=]*)=(.*)/.exec(n[a]).slice(1), i[0] = i[0].replace(/^\s+|\s+$/g, ""), i[1] = i[1].replace(/^\s+|\s+$/g, ""), i[1] = i[1].replace(/^['"](.*)['"]$/g, "$1"), e[i[0]] = i[1]);
  return e;
}, Cg = (t) => {
  const e = t.split("x"), n = {};
  return e[0] && (n.width = parseInt(e[0], 10)), e[1] && (n.height = parseInt(e[1], 10)), n;
};
class EJ extends Hf {
  constructor() {
    super(), this.customParsers = [], this.tagMappers = [];
  }
  /**
   * Parses an additional line of input.
   *
   * @param {string} line a single line of an M3U8 file to parse
   */
  push(e) {
    let n, a;
    if (e = e.trim(), e.length === 0)
      return;
    if (e[0] !== "#") {
      this.trigger("data", {
        type: "uri",
        uri: e
      });
      return;
    }
    this.tagMappers.reduce((r, s) => {
      const o = s(e);
      return o === e ? r : r.concat([o]);
    }, [e]).forEach((r) => {
      for (let s = 0; s < this.customParsers.length; s++)
        if (this.customParsers[s].call(this, r))
          return;
      if (r.indexOf("#EXT") !== 0) {
        this.trigger("data", {
          type: "comment",
          text: r.slice(1)
        });
        return;
      }
      if (r = r.replace("\r", ""), n = /^#EXTM3U/.exec(r), n) {
        this.trigger("data", {
          type: "tag",
          tagType: "m3u"
        });
        return;
      }
      if (n = /^#EXTINF:([0-9\.]*)?,?(.*)?$/.exec(r), n) {
        a = {
          type: "tag",
          tagType: "inf"
        }, n[1] && (a.duration = parseFloat(n[1])), n[2] && (a.title = n[2]), this.trigger("data", a);
        return;
      }
      if (n = /^#EXT-X-TARGETDURATION:([0-9.]*)?/.exec(r), n) {
        a = {
          type: "tag",
          tagType: "targetduration"
        }, n[1] && (a.duration = parseInt(n[1], 10)), this.trigger("data", a);
        return;
      }
      if (n = /^#EXT-X-VERSION:([0-9.]*)?/.exec(r), n) {
        a = {
          type: "tag",
          tagType: "version"
        }, n[1] && (a.version = parseInt(n[1], 10)), this.trigger("data", a);
        return;
      }
      if (n = /^#EXT-X-MEDIA-SEQUENCE:(\-?[0-9.]*)?/.exec(r), n) {
        a = {
          type: "tag",
          tagType: "media-sequence"
        }, n[1] && (a.number = parseInt(n[1], 10)), this.trigger("data", a);
        return;
      }
      if (n = /^#EXT-X-DISCONTINUITY-SEQUENCE:(\-?[0-9.]*)?/.exec(r), n) {
        a = {
          type: "tag",
          tagType: "discontinuity-sequence"
        }, n[1] && (a.number = parseInt(n[1], 10)), this.trigger("data", a);
        return;
      }
      if (n = /^#EXT-X-PLAYLIST-TYPE:(.*)?$/.exec(r), n) {
        a = {
          type: "tag",
          tagType: "playlist-type"
        }, n[1] && (a.playlistType = n[1]), this.trigger("data", a);
        return;
      }
      if (n = /^#EXT-X-BYTERANGE:(.*)?$/.exec(r), n) {
        a = Jt(w0(n[1]), {
          type: "tag",
          tagType: "byterange"
        }), this.trigger("data", a);
        return;
      }
      if (n = /^#EXT-X-ALLOW-CACHE:(YES|NO)?/.exec(r), n) {
        a = {
          type: "tag",
          tagType: "allow-cache"
        }, n[1] && (a.allowed = !/NO/.test(n[1])), this.trigger("data", a);
        return;
      }
      if (n = /^#EXT-X-MAP:(.*)$/.exec(r), n) {
        if (a = {
          type: "tag",
          tagType: "map"
        }, n[1]) {
          const s = On(n[1]);
          s.URI && (a.uri = s.URI), s.BYTERANGE && (a.byterange = w0(s.BYTERANGE));
        }
        this.trigger("data", a);
        return;
      }
      if (n = /^#EXT-X-STREAM-INF:(.*)$/.exec(r), n) {
        a = {
          type: "tag",
          tagType: "stream-inf"
        }, n[1] && (a.attributes = On(n[1]), a.attributes.RESOLUTION && (a.attributes.RESOLUTION = Cg(a.attributes.RESOLUTION)), a.attributes.BANDWIDTH && (a.attributes.BANDWIDTH = parseInt(a.attributes.BANDWIDTH, 10)), a.attributes["FRAME-RATE"] && (a.attributes["FRAME-RATE"] = parseFloat(a.attributes["FRAME-RATE"])), a.attributes["PROGRAM-ID"] && (a.attributes["PROGRAM-ID"] = parseInt(a.attributes["PROGRAM-ID"], 10))), this.trigger("data", a);
        return;
      }
      if (n = /^#EXT-X-MEDIA:(.*)$/.exec(r), n) {
        a = {
          type: "tag",
          tagType: "media"
        }, n[1] && (a.attributes = On(n[1])), this.trigger("data", a);
        return;
      }
      if (n = /^#EXT-X-ENDLIST/.exec(r), n) {
        this.trigger("data", {
          type: "tag",
          tagType: "endlist"
        });
        return;
      }
      if (n = /^#EXT-X-DISCONTINUITY/.exec(r), n) {
        this.trigger("data", {
          type: "tag",
          tagType: "discontinuity"
        });
        return;
      }
      if (n = /^#EXT-X-PROGRAM-DATE-TIME:(.*)$/.exec(r), n) {
        a = {
          type: "tag",
          tagType: "program-date-time"
        }, n[1] && (a.dateTimeString = n[1], a.dateTimeObject = new Date(n[1])), this.trigger("data", a);
        return;
      }
      if (n = /^#EXT-X-KEY:(.*)$/.exec(r), n) {
        a = {
          type: "tag",
          tagType: "key"
        }, n[1] && (a.attributes = On(n[1]), a.attributes.IV && (a.attributes.IV.substring(0, 2).toLowerCase() === "0x" && (a.attributes.IV = a.attributes.IV.substring(2)), a.attributes.IV = a.attributes.IV.match(/.{8}/g), a.attributes.IV[0] = parseInt(a.attributes.IV[0], 16), a.attributes.IV[1] = parseInt(a.attributes.IV[1], 16), a.attributes.IV[2] = parseInt(a.attributes.IV[2], 16), a.attributes.IV[3] = parseInt(a.attributes.IV[3], 16), a.attributes.IV = new Uint32Array(a.attributes.IV))), this.trigger("data", a);
        return;
      }
      if (n = /^#EXT-X-START:(.*)$/.exec(r), n) {
        a = {
          type: "tag",
          tagType: "start"
        }, n[1] && (a.attributes = On(n[1]), a.attributes["TIME-OFFSET"] = parseFloat(a.attributes["TIME-OFFSET"]), a.attributes.PRECISE = /YES/.test(a.attributes.PRECISE)), this.trigger("data", a);
        return;
      }
      if (n = /^#EXT-X-CUE-OUT-CONT:(.*)?$/.exec(r), n) {
        a = {
          type: "tag",
          tagType: "cue-out-cont"
        }, n[1] ? a.data = n[1] : a.data = "", this.trigger("data", a);
        return;
      }
      if (n = /^#EXT-X-CUE-OUT:(.*)?$/.exec(r), n) {
        a = {
          type: "tag",
          tagType: "cue-out"
        }, n[1] ? a.data = n[1] : a.data = "", this.trigger("data", a);
        return;
      }
      if (n = /^#EXT-X-CUE-IN:?(.*)?$/.exec(r), n) {
        a = {
          type: "tag",
          tagType: "cue-in"
        }, n[1] ? a.data = n[1] : a.data = "", this.trigger("data", a);
        return;
      }
      if (n = /^#EXT-X-SKIP:(.*)$/.exec(r), n && n[1]) {
        a = {
          type: "tag",
          tagType: "skip"
        }, a.attributes = On(n[1]), a.attributes.hasOwnProperty("SKIPPED-SEGMENTS") && (a.attributes["SKIPPED-SEGMENTS"] = parseInt(a.attributes["SKIPPED-SEGMENTS"], 10)), a.attributes.hasOwnProperty("RECENTLY-REMOVED-DATERANGES") && (a.attributes["RECENTLY-REMOVED-DATERANGES"] = a.attributes["RECENTLY-REMOVED-DATERANGES"].split(SJ)), this.trigger("data", a);
        return;
      }
      if (n = /^#EXT-X-PART:(.*)$/.exec(r), n && n[1]) {
        a = {
          type: "tag",
          tagType: "part"
        }, a.attributes = On(n[1]), ["DURATION"].forEach(function(s) {
          a.attributes.hasOwnProperty(s) && (a.attributes[s] = parseFloat(a.attributes[s]));
        }), ["INDEPENDENT", "GAP"].forEach(function(s) {
          a.attributes.hasOwnProperty(s) && (a.attributes[s] = /YES/.test(a.attributes[s]));
        }), a.attributes.hasOwnProperty("BYTERANGE") && (a.attributes.byterange = w0(a.attributes.BYTERANGE)), this.trigger("data", a);
        return;
      }
      if (n = /^#EXT-X-SERVER-CONTROL:(.*)$/.exec(r), n && n[1]) {
        a = {
          type: "tag",
          tagType: "server-control"
        }, a.attributes = On(n[1]), ["CAN-SKIP-UNTIL", "PART-HOLD-BACK", "HOLD-BACK"].forEach(function(s) {
          a.attributes.hasOwnProperty(s) && (a.attributes[s] = parseFloat(a.attributes[s]));
        }), ["CAN-SKIP-DATERANGES", "CAN-BLOCK-RELOAD"].forEach(function(s) {
          a.attributes.hasOwnProperty(s) && (a.attributes[s] = /YES/.test(a.attributes[s]));
        }), this.trigger("data", a);
        return;
      }
      if (n = /^#EXT-X-PART-INF:(.*)$/.exec(r), n && n[1]) {
        a = {
          type: "tag",
          tagType: "part-inf"
        }, a.attributes = On(n[1]), ["PART-TARGET"].forEach(function(s) {
          a.attributes.hasOwnProperty(s) && (a.attributes[s] = parseFloat(a.attributes[s]));
        }), this.trigger("data", a);
        return;
      }
      if (n = /^#EXT-X-PRELOAD-HINT:(.*)$/.exec(r), n && n[1]) {
        a = {
          type: "tag",
          tagType: "preload-hint"
        }, a.attributes = On(n[1]), ["BYTERANGE-START", "BYTERANGE-LENGTH"].forEach(function(s) {
          if (a.attributes.hasOwnProperty(s)) {
            a.attributes[s] = parseInt(a.attributes[s], 10);
            const o = s === "BYTERANGE-LENGTH" ? "length" : "offset";
            a.attributes.byterange = a.attributes.byterange || {}, a.attributes.byterange[o] = a.attributes[s], delete a.attributes[s];
          }
        }), this.trigger("data", a);
        return;
      }
      if (n = /^#EXT-X-RENDITION-REPORT:(.*)$/.exec(r), n && n[1]) {
        a = {
          type: "tag",
          tagType: "rendition-report"
        }, a.attributes = On(n[1]), ["LAST-MSN", "LAST-PART"].forEach(function(s) {
          a.attributes.hasOwnProperty(s) && (a.attributes[s] = parseInt(a.attributes[s], 10));
        }), this.trigger("data", a);
        return;
      }
      if (n = /^#EXT-X-DATERANGE:(.*)$/.exec(r), n && n[1]) {
        a = {
          type: "tag",
          tagType: "daterange"
        }, a.attributes = On(n[1]), ["ID", "CLASS"].forEach(function(o) {
          a.attributes.hasOwnProperty(o) && (a.attributes[o] = String(a.attributes[o]));
        }), ["START-DATE", "END-DATE"].forEach(function(o) {
          a.attributes.hasOwnProperty(o) && (a.attributes[o] = new Date(a.attributes[o]));
        }), ["DURATION", "PLANNED-DURATION"].forEach(function(o) {
          a.attributes.hasOwnProperty(o) && (a.attributes[o] = parseFloat(a.attributes[o]));
        }), ["END-ON-NEXT"].forEach(function(o) {
          a.attributes.hasOwnProperty(o) && (a.attributes[o] = /YES/i.test(a.attributes[o]));
        }), ["SCTE35-CMD", " SCTE35-OUT", "SCTE35-IN"].forEach(function(o) {
          a.attributes.hasOwnProperty(o) && (a.attributes[o] = a.attributes[o].toString(16));
        });
        const s = /^X-([A-Z]+-)+[A-Z]+$/;
        for (const o in a.attributes) {
          if (!s.test(o))
            continue;
          const l = /[0-9A-Fa-f]{6}/g.test(a.attributes[o]), c = /^\d+(\.\d+)?$/.test(a.attributes[o]);
          a.attributes[o] = l ? a.attributes[o].toString(16) : c ? parseFloat(a.attributes[o]) : String(a.attributes[o]);
        }
        this.trigger("data", a);
        return;
      }
      if (n = /^#EXT-X-INDEPENDENT-SEGMENTS/.exec(r), n) {
        this.trigger("data", {
          type: "tag",
          tagType: "independent-segments"
        });
        return;
      }
      if (n = /^#EXT-X-I-FRAMES-ONLY/.exec(r), n) {
        this.trigger("data", {
          type: "tag",
          tagType: "i-frames-only"
        });
        return;
      }
      if (n = /^#EXT-X-CONTENT-STEERING:(.*)$/.exec(r), n) {
        a = {
          type: "tag",
          tagType: "content-steering"
        }, a.attributes = On(n[1]), this.trigger("data", a);
        return;
      }
      if (n = /^#EXT-X-I-FRAME-STREAM-INF:(.*)$/.exec(r), n) {
        a = {
          type: "tag",
          tagType: "i-frame-playlist"
        }, a.attributes = On(n[1]), a.attributes.URI && (a.uri = a.attributes.URI), a.attributes.BANDWIDTH && (a.attributes.BANDWIDTH = parseInt(a.attributes.BANDWIDTH, 10)), a.attributes.RESOLUTION && (a.attributes.RESOLUTION = Cg(a.attributes.RESOLUTION)), a.attributes["AVERAGE-BANDWIDTH"] && (a.attributes["AVERAGE-BANDWIDTH"] = parseInt(a.attributes["AVERAGE-BANDWIDTH"], 10)), a.attributes["FRAME-RATE"] && (a.attributes["FRAME-RATE"] = parseFloat(a.attributes["FRAME-RATE"])), this.trigger("data", a);
        return;
      }
      if (n = /^#EXT-X-DEFINE:(.*)$/.exec(r), n) {
        a = {
          type: "tag",
          tagType: "define"
        }, a.attributes = On(n[1]), this.trigger("data", a);
        return;
      }
      this.trigger("data", {
        type: "tag",
        data: r.slice(4)
      });
    });
  }
  /**
   * Add a parser for custom headers
   *
   * @param {Object}   options              a map of options for the added parser
   * @param {RegExp}   options.expression   a regular expression to match the custom header
   * @param {string}   options.customType   the custom type to register to the output
   * @param {Function} [options.dataParser] function to parse the line into an object
   * @param {boolean}  [options.segment]    should tag data be attached to the segment object
   */
  addParser({
    expression: e,
    customType: n,
    dataParser: a,
    segment: i
  }) {
    typeof a != "function" && (a = (r) => r), this.customParsers.push((r) => {
      if (e.exec(r))
        return this.trigger("data", {
          type: "custom",
          data: a(r),
          customType: n,
          segment: i
        }), !0;
    });
  }
  /**
   * Add a custom header mapper
   *
   * @param {Object}   options
   * @param {RegExp}   options.expression   a regular expression to match the custom header
   * @param {Function} options.map          function to translate tag into a different tag
   */
  addTagMapper({
    expression: e,
    map: n
  }) {
    const a = (i) => e.test(i) ? n(i) : i;
    this.tagMappers.push(a);
  }
}
const LJ = (t) => t.toLowerCase().replace(/-(\w)/g, (e) => e[1].toUpperCase()), Ui = function(t) {
  const e = {};
  return Object.keys(t).forEach(function(n) {
    e[LJ(n)] = t[n];
  }), e;
}, k0 = function(t) {
  const {
    serverControl: e,
    targetDuration: n,
    partTargetDuration: a
  } = t;
  if (!e)
    return;
  const i = "#EXT-X-SERVER-CONTROL", r = "holdBack", s = "partHoldBack", o = n && n * 3, l = a && a * 2;
  n && !e.hasOwnProperty(r) && (e[r] = o, this.trigger("info", {
    message: `${i} defaulting HOLD-BACK to targetDuration * 3 (${o}).`
  })), o && e[r] < o && (this.trigger("warn", {
    message: `${i} clamping HOLD-BACK (${e[r]}) to targetDuration * 3 (${o})`
  }), e[r] = o), a && !e.hasOwnProperty(s) && (e[s] = a * 3, this.trigger("info", {
    message: `${i} defaulting PART-HOLD-BACK to partTargetDuration * 3 (${e[s]}).`
  })), a && e[s] < l && (this.trigger("warn", {
    message: `${i} clamping PART-HOLD-BACK (${e[s]}) to partTargetDuration * 2 (${l}).`
  }), e[s] = l);
};
class DJ extends Hf {
  constructor(e = {}) {
    super(), this.lineStream = new CJ(), this.parseStream = new EJ(), this.lineStream.pipe(this.parseStream), this.mainDefinitions = e.mainDefinitions || {}, this.params = new URL(e.uri, "https://a.com").searchParams, this.lastProgramDateTime = null;
    const n = this, a = [];
    let i = {}, r, s, o = !1;
    const l = function() {
    }, c = {
      AUDIO: {},
      VIDEO: {},
      "CLOSED-CAPTIONS": {},
      SUBTITLES: {}
    }, u = "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed";
    let f = 0;
    this.manifest = {
      allowCache: !0,
      discontinuityStarts: [],
      dateRanges: [],
      iFramePlaylists: [],
      segments: []
    };
    let m = 0, _ = 0;
    const T = {};
    this.on("end", () => {
      i.uri || !i.parts && !i.preloadHints || (!i.map && r && (i.map = r), !i.key && s && (i.key = s), !i.timeline && typeof f == "number" && (i.timeline = f), this.manifest.preloadSegment = i);
    }), this.parseStream.on("data", function(g) {
      let x, S;
      if (n.manifest.definitions) {
        for (const D in n.manifest.definitions)
          if (g.uri && (g.uri = g.uri.replace(`{$${D}}`, n.manifest.definitions[D])), g.attributes)
            for (const L in g.attributes)
              typeof g.attributes[L] == "string" && (g.attributes[L] = g.attributes[L].replace(`{$${D}}`, n.manifest.definitions[D]));
      }
      ({
        tag() {
          ({
            version() {
              g.version && (this.manifest.version = g.version);
            },
            "allow-cache"() {
              this.manifest.allowCache = g.allowed, "allowed" in g || (this.trigger("info", {
                message: "defaulting allowCache to YES"
              }), this.manifest.allowCache = !0);
            },
            byterange() {
              const D = {};
              "length" in g && (i.byterange = D, D.length = g.length, "offset" in g || (g.offset = m)), "offset" in g && (i.byterange = D, D.offset = g.offset), m = D.offset + D.length;
            },
            endlist() {
              this.manifest.endList = !0;
            },
            inf() {
              "mediaSequence" in this.manifest || (this.manifest.mediaSequence = 0, this.trigger("info", {
                message: "defaulting media sequence to zero"
              })), "discontinuitySequence" in this.manifest || (this.manifest.discontinuitySequence = 0, this.trigger("info", {
                message: "defaulting discontinuity sequence to zero"
              })), g.title && (i.title = g.title), g.duration > 0 && (i.duration = g.duration), g.duration === 0 && (i.duration = 0.01, this.trigger("info", {
                message: "updating zero segment duration to a small value"
              })), this.manifest.segments = a;
            },
            key() {
              if (!g.attributes) {
                this.trigger("warn", {
                  message: "ignoring key declaration without attribute list"
                });
                return;
              }
              if (g.attributes.METHOD === "NONE") {
                s = null;
                return;
              }
              if (!g.attributes.URI) {
                this.trigger("warn", {
                  message: "ignoring key declaration without URI"
                });
                return;
              }
              if (g.attributes.KEYFORMAT === "com.apple.streamingkeydelivery") {
                this.manifest.contentProtection = this.manifest.contentProtection || {}, this.manifest.contentProtection["com.apple.fps.1_0"] = {
                  attributes: g.attributes
                };
                return;
              }
              if (g.attributes.KEYFORMAT === "com.microsoft.playready") {
                this.manifest.contentProtection = this.manifest.contentProtection || {}, this.manifest.contentProtection["com.microsoft.playready"] = {
                  uri: g.attributes.URI
                };
                return;
              }
              if (g.attributes.KEYFORMAT === u) {
                if (["SAMPLE-AES", "SAMPLE-AES-CTR", "SAMPLE-AES-CENC"].indexOf(g.attributes.METHOD) === -1) {
                  this.trigger("warn", {
                    message: "invalid key method provided for Widevine"
                  });
                  return;
                }
                if (g.attributes.METHOD === "SAMPLE-AES-CENC" && this.trigger("warn", {
                  message: "SAMPLE-AES-CENC is deprecated, please use SAMPLE-AES-CTR instead"
                }), g.attributes.URI.substring(0, 23) !== "data:text/plain;base64,") {
                  this.trigger("warn", {
                    message: "invalid key URI provided for Widevine"
                  });
                  return;
                }
                if (!(g.attributes.KEYID && g.attributes.KEYID.substring(0, 2) === "0x")) {
                  this.trigger("warn", {
                    message: "invalid key ID provided for Widevine"
                  });
                  return;
                }
                this.manifest.contentProtection = this.manifest.contentProtection || {}, this.manifest.contentProtection["com.widevine.alpha"] = {
                  attributes: {
                    schemeIdUri: g.attributes.KEYFORMAT,
                    // remove '0x' from the key id string
                    keyId: g.attributes.KEYID.substring(2)
                  },
                  // decode the base64-encoded PSSH box
                  pssh: d5(g.attributes.URI.split(",")[1])
                };
                return;
              }
              g.attributes.METHOD || this.trigger("warn", {
                message: "defaulting key method to AES-128"
              }), s = {
                method: g.attributes.METHOD || "AES-128",
                uri: g.attributes.URI
              }, typeof g.attributes.IV < "u" && (s.iv = g.attributes.IV);
            },
            "media-sequence"() {
              if (!isFinite(g.number)) {
                this.trigger("warn", {
                  message: "ignoring invalid media sequence: " + g.number
                });
                return;
              }
              this.manifest.mediaSequence = g.number;
            },
            "discontinuity-sequence"() {
              if (!isFinite(g.number)) {
                this.trigger("warn", {
                  message: "ignoring invalid discontinuity sequence: " + g.number
                });
                return;
              }
              this.manifest.discontinuitySequence = g.number, f = g.number;
            },
            "playlist-type"() {
              if (!/VOD|EVENT/.test(g.playlistType)) {
                this.trigger("warn", {
                  message: "ignoring unknown playlist type: " + g.playlist
                });
                return;
              }
              this.manifest.playlistType = g.playlistType;
            },
            map() {
              r = {}, g.uri && (r.uri = g.uri), g.byterange && (r.byterange = g.byterange), s && (r.key = s);
            },
            "stream-inf"() {
              if (this.manifest.playlists = a, this.manifest.mediaGroups = this.manifest.mediaGroups || c, !g.attributes) {
                this.trigger("warn", {
                  message: "ignoring empty stream-inf attributes"
                });
                return;
              }
              i.attributes || (i.attributes = {}), Jt(i.attributes, g.attributes);
            },
            media() {
              if (this.manifest.mediaGroups = this.manifest.mediaGroups || c, !(g.attributes && g.attributes.TYPE && g.attributes["GROUP-ID"] && g.attributes.NAME)) {
                this.trigger("warn", {
                  message: "ignoring incomplete or missing media group"
                });
                return;
              }
              const D = this.manifest.mediaGroups[g.attributes.TYPE];
              D[g.attributes["GROUP-ID"]] = D[g.attributes["GROUP-ID"]] || {}, x = D[g.attributes["GROUP-ID"]], S = {
                default: /yes/i.test(g.attributes.DEFAULT)
              }, S.default ? S.autoselect = !0 : S.autoselect = /yes/i.test(g.attributes.AUTOSELECT), g.attributes.LANGUAGE && (S.language = g.attributes.LANGUAGE), g.attributes.URI && (S.uri = g.attributes.URI), g.attributes["INSTREAM-ID"] && (S.instreamId = g.attributes["INSTREAM-ID"]), g.attributes.CHARACTERISTICS && (S.characteristics = g.attributes.CHARACTERISTICS), g.attributes.FORCED && (S.forced = /yes/i.test(g.attributes.FORCED)), x[g.attributes.NAME] = S;
            },
            discontinuity() {
              f += 1, i.discontinuity = !0, this.manifest.discontinuityStarts.push(a.length);
            },
            "program-date-time"() {
              typeof this.manifest.dateTimeString > "u" && (this.manifest.dateTimeString = g.dateTimeString, this.manifest.dateTimeObject = g.dateTimeObject), i.dateTimeString = g.dateTimeString, i.dateTimeObject = g.dateTimeObject;
              const {
                lastProgramDateTime: D
              } = this;
              this.lastProgramDateTime = new Date(g.dateTimeString).getTime(), D === null && this.manifest.segments.reduceRight((L, M) => (M.programDateTime = L - M.duration * 1e3, M.programDateTime), this.lastProgramDateTime);
            },
            targetduration() {
              if (!isFinite(g.duration) || g.duration < 0) {
                this.trigger("warn", {
                  message: "ignoring invalid target duration: " + g.duration
                });
                return;
              }
              this.manifest.targetDuration = g.duration, k0.call(this, this.manifest);
            },
            start() {
              if (!g.attributes || isNaN(g.attributes["TIME-OFFSET"])) {
                this.trigger("warn", {
                  message: "ignoring start declaration without appropriate attribute list"
                });
                return;
              }
              this.manifest.start = {
                timeOffset: g.attributes["TIME-OFFSET"],
                precise: g.attributes.PRECISE
              };
            },
            "cue-out"() {
              i.cueOut = g.data;
            },
            "cue-out-cont"() {
              i.cueOutCont = g.data;
            },
            "cue-in"() {
              i.cueIn = g.data;
            },
            skip() {
              this.manifest.skip = Ui(g.attributes), this.warnOnMissingAttributes_("#EXT-X-SKIP", g.attributes, ["SKIPPED-SEGMENTS"]);
            },
            part() {
              o = !0;
              const D = this.manifest.segments.length, L = Ui(g.attributes);
              i.parts = i.parts || [], i.parts.push(L), L.byterange && (L.byterange.hasOwnProperty("offset") || (L.byterange.offset = _), _ = L.byterange.offset + L.byterange.length);
              const M = i.parts.length - 1;
              this.warnOnMissingAttributes_(`#EXT-X-PART #${M} for segment #${D}`, g.attributes, ["URI", "DURATION"]), this.manifest.renditionReports && this.manifest.renditionReports.forEach((E, P) => {
                E.hasOwnProperty("lastPart") || this.trigger("warn", {
                  message: `#EXT-X-RENDITION-REPORT #${P} lacks required attribute(s): LAST-PART`
                });
              });
            },
            "server-control"() {
              const D = this.manifest.serverControl = Ui(g.attributes);
              D.hasOwnProperty("canBlockReload") || (D.canBlockReload = !1, this.trigger("info", {
                message: "#EXT-X-SERVER-CONTROL defaulting CAN-BLOCK-RELOAD to false"
              })), k0.call(this, this.manifest), D.canSkipDateranges && !D.hasOwnProperty("canSkipUntil") && this.trigger("warn", {
                message: "#EXT-X-SERVER-CONTROL lacks required attribute CAN-SKIP-UNTIL which is required when CAN-SKIP-DATERANGES is set"
              });
            },
            "preload-hint"() {
              const D = this.manifest.segments.length, L = Ui(g.attributes), M = L.type && L.type === "PART";
              i.preloadHints = i.preloadHints || [], i.preloadHints.push(L), L.byterange && (L.byterange.hasOwnProperty("offset") || (L.byterange.offset = M ? _ : 0, M && (_ = L.byterange.offset + L.byterange.length)));
              const E = i.preloadHints.length - 1;
              if (this.warnOnMissingAttributes_(`#EXT-X-PRELOAD-HINT #${E} for segment #${D}`, g.attributes, ["TYPE", "URI"]), !!L.type)
                for (let P = 0; P < i.preloadHints.length - 1; P++) {
                  const B = i.preloadHints[P];
                  B.type && B.type === L.type && this.trigger("warn", {
                    message: `#EXT-X-PRELOAD-HINT #${E} for segment #${D} has the same TYPE ${L.type} as preload hint #${P}`
                  });
                }
            },
            "rendition-report"() {
              const D = Ui(g.attributes);
              this.manifest.renditionReports = this.manifest.renditionReports || [], this.manifest.renditionReports.push(D);
              const L = this.manifest.renditionReports.length - 1, M = ["LAST-MSN", "URI"];
              o && M.push("LAST-PART"), this.warnOnMissingAttributes_(`#EXT-X-RENDITION-REPORT #${L}`, g.attributes, M);
            },
            "part-inf"() {
              this.manifest.partInf = Ui(g.attributes), this.warnOnMissingAttributes_("#EXT-X-PART-INF", g.attributes, ["PART-TARGET"]), this.manifest.partInf.partTarget && (this.manifest.partTargetDuration = this.manifest.partInf.partTarget), k0.call(this, this.manifest);
            },
            daterange() {
              this.manifest.dateRanges.push(Ui(g.attributes));
              const D = this.manifest.dateRanges.length - 1;
              this.warnOnMissingAttributes_(`#EXT-X-DATERANGE #${D}`, g.attributes, ["ID", "START-DATE"]);
              const L = this.manifest.dateRanges[D];
              L.endDate && L.startDate && new Date(L.endDate) < new Date(L.startDate) && this.trigger("warn", {
                message: "EXT-X-DATERANGE END-DATE must be equal to or later than the value of the START-DATE"
              }), L.duration && L.duration < 0 && this.trigger("warn", {
                message: "EXT-X-DATERANGE DURATION must not be negative"
              }), L.plannedDuration && L.plannedDuration < 0 && this.trigger("warn", {
                message: "EXT-X-DATERANGE PLANNED-DURATION must not be negative"
              });
              const M = !!L.endOnNext;
              if (M && !L.class && this.trigger("warn", {
                message: "EXT-X-DATERANGE with an END-ON-NEXT=YES attribute must have a CLASS attribute"
              }), M && (L.duration || L.endDate) && this.trigger("warn", {
                message: "EXT-X-DATERANGE with an END-ON-NEXT=YES attribute must not contain DURATION or END-DATE attributes"
              }), L.duration && L.endDate) {
                const P = L.startDate.getTime() + L.duration * 1e3;
                this.manifest.dateRanges[D].endDate = new Date(P);
              }
              if (!T[L.id])
                T[L.id] = L;
              else {
                for (const P in T[L.id])
                  if (L[P] && JSON.stringify(T[L.id][P]) !== JSON.stringify(L[P])) {
                    this.trigger("warn", {
                      message: "EXT-X-DATERANGE tags with the same ID in a playlist must have the same attributes values"
                    });
                    break;
                  }
                const E = this.manifest.dateRanges.findIndex((P) => P.id === L.id);
                this.manifest.dateRanges[E] = Jt(this.manifest.dateRanges[E], L), T[L.id] = Jt(T[L.id], L), this.manifest.dateRanges.pop();
              }
            },
            "independent-segments"() {
              this.manifest.independentSegments = !0;
            },
            "i-frames-only"() {
              this.manifest.iFramesOnly = !0, this.requiredCompatibilityversion(this.manifest.version, 4);
            },
            "content-steering"() {
              this.manifest.contentSteering = Ui(g.attributes), this.warnOnMissingAttributes_("#EXT-X-CONTENT-STEERING", g.attributes, ["SERVER-URI"]);
            },
            /** @this {Parser} */
            define() {
              this.manifest.definitions = this.manifest.definitions || {};
              const D = (L, M) => {
                if (L in this.manifest.definitions) {
                  this.trigger("error", {
                    message: `EXT-X-DEFINE: Duplicate name ${L}`
                  });
                  return;
                }
                this.manifest.definitions[L] = M;
              };
              if ("QUERYPARAM" in g.attributes) {
                if ("NAME" in g.attributes || "IMPORT" in g.attributes) {
                  this.trigger("error", {
                    message: "EXT-X-DEFINE: Invalid attributes"
                  });
                  return;
                }
                const L = this.params.get(g.attributes.QUERYPARAM);
                if (!L) {
                  this.trigger("error", {
                    message: `EXT-X-DEFINE: No query param ${g.attributes.QUERYPARAM}`
                  });
                  return;
                }
                D(g.attributes.QUERYPARAM, decodeURIComponent(L));
                return;
              }
              if ("NAME" in g.attributes) {
                if ("IMPORT" in g.attributes) {
                  this.trigger("error", {
                    message: "EXT-X-DEFINE: Invalid attributes"
                  });
                  return;
                }
                if (!("VALUE" in g.attributes) || typeof g.attributes.VALUE != "string") {
                  this.trigger("error", {
                    message: `EXT-X-DEFINE: No value for ${g.attributes.NAME}`
                  });
                  return;
                }
                D(g.attributes.NAME, g.attributes.VALUE);
                return;
              }
              if ("IMPORT" in g.attributes) {
                if (!this.mainDefinitions[g.attributes.IMPORT]) {
                  this.trigger("error", {
                    message: `EXT-X-DEFINE: No value ${g.attributes.IMPORT} to import, or IMPORT used on main playlist`
                  });
                  return;
                }
                D(g.attributes.IMPORT, this.mainDefinitions[g.attributes.IMPORT]);
                return;
              }
              this.trigger("error", {
                message: "EXT-X-DEFINE: No attribute"
              });
            },
            "i-frame-playlist"() {
              this.manifest.iFramePlaylists.push({
                attributes: g.attributes,
                uri: g.uri,
                timeline: f
              }), this.warnOnMissingAttributes_("#EXT-X-I-FRAME-STREAM-INF", g.attributes, ["BANDWIDTH", "URI"]);
            }
          }[g.tagType] || l).call(n);
        },
        uri() {
          i.uri = g.uri, a.push(i), this.manifest.targetDuration && !("duration" in i) && (this.trigger("warn", {
            message: "defaulting segment duration to the target duration"
          }), i.duration = this.manifest.targetDuration), s && (i.key = s), i.timeline = f, r && (i.map = r), _ = 0, this.lastProgramDateTime !== null && (i.programDateTime = this.lastProgramDateTime, this.lastProgramDateTime += i.duration * 1e3), i = {};
        },
        comment() {
        },
        custom() {
          g.segment ? (i.custom = i.custom || {}, i.custom[g.customType] = g.data) : (this.manifest.custom = this.manifest.custom || {}, this.manifest.custom[g.customType] = g.data);
        }
      })[g.type].call(n);
    });
  }
  requiredCompatibilityversion(e, n) {
    (e < n || !e) && this.trigger("warn", {
      message: `manifest must be at least version ${n}`
    });
  }
  warnOnMissingAttributes_(e, n, a) {
    const i = [];
    a.forEach(function(r) {
      n.hasOwnProperty(r) || i.push(r);
    }), i.length && this.trigger("warn", {
      message: `${e} lacks required attribute(s): ${i.join(", ")}`
    });
  }
  /**
   * Parse the input string and update the manifest object.
   *
   * @param {string} chunk a potentially incomplete portion of the manifest
   */
  push(e) {
    this.lineStream.push(e);
  }
  /**
   * Flush any remaining input. This can be handy if the last line of an M3U8
   * manifest did not contain a trailing newline but the file has been
   * completely received.
   */
  end() {
    this.lineStream.push(`
`), this.manifest.dateRanges.length && this.lastProgramDateTime === null && this.trigger("warn", {
      message: "A playlist with EXT-X-DATERANGE tag must contain atleast one EXT-X-PROGRAM-DATE-TIME tag"
    }), this.lastProgramDateTime = null, this.trigger("end");
  }
  /**
   * Add an additional parser for non-standard tags
   *
   * @param {Object}   options              a map of options for the added parser
   * @param {RegExp}   options.expression   a regular expression to match the custom header
   * @param {string}   options.customType   the custom type to register to the output
   * @param {Function} [options.dataParser] function to parse the line into an object
   * @param {boolean}  [options.segment]    should tag data be attached to the segment object
   */
  addParser(e) {
    this.parseStream.addParser(e);
  }
  /**
   * Add a custom header mapper
   *
   * @param {Object}   options
   * @param {RegExp}   options.expression   a regular expression to match the custom header
   * @param {Function} options.map          function to translate tag into a different tag
   */
  addTagMapper(e) {
    this.parseStream.addTagMapper(e);
  }
}
var Lr = {
  // to determine mime types
  mp4: /^(av0?1|avc0?[1234]|vp0?9|flac|opus|mp3|mp4a|mp4v|stpp.ttml.im1t)/,
  webm: /^(vp0?[89]|av0?1|opus|vorbis)/,
  ogg: /^(vp0?[89]|theora|flac|opus|vorbis)/,
  // to determine if a codec is audio or video
  video: /^(av0?1|avc0?[1234]|vp0?[89]|hvc1|hev1|theora|mp4v)/,
  audio: /^(mp4a|flac|vorbis|opus|ac-[34]|ec-3|alac|mp3|speex|aac)/,
  text: /^(stpp.ttml.im1t)/,
  // mux.js support regex
  muxerVideo: /^(avc0?1)/,
  muxerAudio: /^(mp4a)/,
  // match nothing as muxer does not support text right now.
  // there cannot never be a character before the start of a string
  // so this matches nothing.
  muxerText: /a^/
}, IJ = ["video", "audio", "text"], Sg = ["Video", "Audio", "Text"], h5 = function(e) {
  return e && e.replace(/avc1\.(\d+)\.(\d+)/i, function(n, a, i) {
    var r = ("00" + Number(a).toString(16)).slice(-2), s = ("00" + Number(i).toString(16)).slice(-2);
    return "avc1." + r + "00" + s;
  });
}, ja = function(e) {
  e === void 0 && (e = "");
  var n = e.split(","), a = [];
  return n.forEach(function(i) {
    i = i.trim();
    var r;
    IJ.forEach(function(s) {
      var o = Lr[s].exec(i.toLowerCase());
      if (!(!o || o.length <= 1)) {
        r = s;
        var l = i.substring(0, o[1].length), c = i.replace(l, "");
        a.push({
          type: l,
          details: c,
          mediaType: s
        });
      }
    }), r || a.push({
      type: i,
      details: "",
      mediaType: "unknown"
    });
  }), a;
}, MJ = function(e, n) {
  if (!e.mediaGroups.AUDIO || !n)
    return null;
  var a = e.mediaGroups.AUDIO[n];
  if (!a)
    return null;
  for (var i in a) {
    var r = a[i];
    if (r.default && r.playlists)
      return ja(r.playlists[0].attributes.CODECS);
  }
  return null;
}, f5 = function(e) {
  return e === void 0 && (e = ""), Lr.audio.test(e.trim().toLowerCase());
}, OJ = function(e) {
  return e === void 0 && (e = ""), Lr.text.test(e.trim().toLowerCase());
}, Ns = function(e) {
  if (!(!e || typeof e != "string")) {
    var n = e.toLowerCase().split(",").map(function(r) {
      return h5(r.trim());
    }), a = "video";
    n.length === 1 && f5(n[0]) ? a = "audio" : n.length === 1 && OJ(n[0]) && (a = "application");
    var i = "mp4";
    return n.every(function(r) {
      return Lr.mp4.test(r);
    }) ? i = "mp4" : n.every(function(r) {
      return Lr.webm.test(r);
    }) ? i = "webm" : n.every(function(r) {
      return Lr.ogg.test(r);
    }) && (i = "ogg"), a + "/" + i + ';codecs="' + e + '"';
  }
}, dl = function(e, n) {
  return e === void 0 && (e = ""), n === void 0 && (n = !1), j.MediaSource && j.MediaSource.isTypeSupported && j.MediaSource.isTypeSupported(Ns(e)) || n && j.ManagedMediaSource && j.ManagedMediaSource.isTypeSupported && j.ManagedMediaSource.isTypeSupported(Ns(e)) || !1;
}, C0 = function(e) {
  return e === void 0 && (e = ""), e.toLowerCase().split(",").every(function(n) {
    n = n.trim();
    for (var a = 0; a < Sg.length; a++) {
      var i = Sg[a];
      if (Lr["muxer" + i].test(n))
        return !0;
    }
    return !1;
  });
}, Ag = "mp4a.40.2", PJ = "avc1.4d400d", BJ = /^(audio|video|application)\/(x-|vnd\.apple\.)?mpegurl/i, RJ = /^application\/dash\+xml/i, p5 = function(e) {
  return BJ.test(e) ? "hls" : RJ.test(e) ? "dash" : e === "application/vnd.videojs.vhs+json" ? "vhs-json" : null;
}, NJ = function(e) {
  return e.toString(2).length;
}, $J = function(e) {
  return Math.ceil(NJ(e) / 8);
}, m5 = function(e) {
  return ArrayBuffer.isView === "function" ? ArrayBuffer.isView(e) : e && e.buffer instanceof ArrayBuffer;
}, FJ = function(e) {
  return m5(e);
}, Ke = function(e) {
  return e instanceof Uint8Array ? e : (!Array.isArray(e) && !FJ(e) && !(e instanceof ArrayBuffer) && (typeof e != "number" || typeof e == "number" && e !== e ? e = 0 : e = [e]), new Uint8Array(e && e.buffer || e, e && e.byteOffset || 0, e && e.byteLength || 0));
}, xn = j.BigInt || Number, ph = [xn("0x1"), xn("0x100"), xn("0x10000"), xn("0x1000000"), xn("0x100000000"), xn("0x10000000000"), xn("0x1000000000000"), xn("0x100000000000000"), xn("0x10000000000000000")];
(function() {
  var t = new Uint16Array([65484]), e = new Uint8Array(t.buffer, t.byteOffset, t.byteLength);
  return e[0] === 255 ? "big" : e[0] === 204 ? "little" : "unknown";
})();
var zJ = function(e, n) {
  var a = n === void 0 ? {} : n, i = a.signed, r = i === void 0 ? !1 : i, s = a.le, o = s === void 0 ? !1 : s;
  e = Ke(e);
  var l = o ? "reduce" : "reduceRight", c = e[l] ? e[l] : Array.prototype[l], u = c.call(e, function(m, _, T) {
    var g = o ? T : Math.abs(T + 1 - e.length);
    return m + xn(_) * ph[g];
  }, xn(0));
  if (r) {
    var f = ph[e.length] / xn(2) - xn(1);
    u = xn(u), u > f && (u -= f, u -= f, u -= xn(2));
  }
  return Number(u);
}, UJ = function(e, n) {
  var a = {}, i = a.le, r = i === void 0 ? !1 : i;
  (typeof e != "bigint" && typeof e != "number" || typeof e == "number" && e !== e) && (e = 0), e = xn(e);
  for (var s = $J(e), o = new Uint8Array(new ArrayBuffer(s)), l = 0; l < s; l++) {
    var c = r ? l : Math.abs(l + 1 - o.length);
    o[c] = Number(e / ph[l] & xn(255)), e < 0 && (o[c] = Math.abs(~o[c]), o[c] -= l === 0 ? 1 : 2);
  }
  return o;
}, g5 = function(e, n) {
  if (typeof e != "string" && e && typeof e.toString == "function" && (e = e.toString()), typeof e != "string")
    return new Uint8Array();
  n || (e = unescape(encodeURIComponent(e)));
  for (var a = new Uint8Array(e.length), i = 0; i < e.length; i++)
    a[i] = e.charCodeAt(i);
  return a;
}, HJ = function() {
  for (var e = arguments.length, n = new Array(e), a = 0; a < e; a++)
    n[a] = arguments[a];
  if (n = n.filter(function(o) {
    return o && (o.byteLength || o.length) && typeof o != "string";
  }), n.length <= 1)
    return Ke(n[0]);
  var i = n.reduce(function(o, l, c) {
    return o + (l.byteLength || l.length);
  }, 0), r = new Uint8Array(i), s = 0;
  return n.forEach(function(o) {
    o = Ke(o), r.set(o, s), s += o.byteLength;
  }), r;
}, Rt = function(e, n, a) {
  var i = a === void 0 ? {} : a, r = i.offset, s = r === void 0 ? 0 : r, o = i.mask, l = o === void 0 ? [] : o;
  e = Ke(e), n = Ke(n);
  var c = n.every ? n.every : Array.prototype.every;
  return n.length && e.length - s >= n.length && // ie 11 doesn't support every on uin8
  c.call(n, function(u, f) {
    var m = l[f] ? l[f] & e[s + f] : e[s + f];
    return u === m;
  });
}, YJ = function(e, n, a) {
  n.forEach(function(i) {
    for (var r in e.mediaGroups[i])
      for (var s in e.mediaGroups[i][r]) {
        var o = e.mediaGroups[i][r][s];
        a(o, i, r, s);
      }
  });
}, cr = {}, Mi = {};
function jJ(t, e, n) {
  if (n === void 0 && (n = Array.prototype), t && typeof n.find == "function")
    return n.find.call(t, e);
  for (var a = 0; a < t.length; a++)
    if (Object.prototype.hasOwnProperty.call(t, a)) {
      var i = t[a];
      if (e.call(void 0, i, a, t))
        return i;
    }
}
function Yf(t, e) {
  return e === void 0 && (e = Object), e && typeof e.freeze == "function" ? e.freeze(t) : t;
}
function VJ(t, e) {
  if (t === null || typeof t != "object")
    throw new TypeError("target is not an object");
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
  return t;
}
var b5 = Yf({
  /**
   * `text/html`, the only mime type that triggers treating an XML document as HTML.
   *
   * @see DOMParser.SupportedType.isHTML
   * @see https://www.iana.org/assignments/media-types/text/html IANA MimeType registration
   * @see https://en.wikipedia.org/wiki/HTML Wikipedia
   * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString MDN
   * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-domparser-parsefromstring WHATWG HTML Spec
   */
  HTML: "text/html",
  /**
   * Helper method to check a mime type if it indicates an HTML document
   *
   * @param {string} [value]
   * @returns {boolean}
   *
   * @see https://www.iana.org/assignments/media-types/text/html IANA MimeType registration
   * @see https://en.wikipedia.org/wiki/HTML Wikipedia
   * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString MDN
   * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-domparser-parsefromstring 	 */
  isHTML: function(t) {
    return t === b5.HTML;
  },
  /**
   * `application/xml`, the standard mime type for XML documents.
   *
   * @see https://www.iana.org/assignments/media-types/application/xml IANA MimeType registration
   * @see https://tools.ietf.org/html/rfc7303#section-9.1 RFC 7303
   * @see https://en.wikipedia.org/wiki/XML_and_MIME Wikipedia
   */
  XML_APPLICATION: "application/xml",
  /**
   * `text/html`, an alias for `application/xml`.
   *
   * @see https://tools.ietf.org/html/rfc7303#section-9.2 RFC 7303
   * @see https://www.iana.org/assignments/media-types/text/xml IANA MimeType registration
   * @see https://en.wikipedia.org/wiki/XML_and_MIME Wikipedia
   */
  XML_TEXT: "text/xml",
  /**
   * `application/xhtml+xml`, indicates an XML document that has the default HTML namespace,
   * but is parsed as an XML document.
   *
   * @see https://www.iana.org/assignments/media-types/application/xhtml+xml IANA MimeType registration
   * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocument WHATWG DOM Spec
   * @see https://en.wikipedia.org/wiki/XHTML Wikipedia
   */
  XML_XHTML_APPLICATION: "application/xhtml+xml",
  /**
   * `image/svg+xml`,
   *
   * @see https://www.iana.org/assignments/media-types/image/svg+xml IANA MimeType registration
   * @see https://www.w3.org/TR/SVG11/ W3C SVG 1.1
   * @see https://en.wikipedia.org/wiki/Scalable_Vector_Graphics Wikipedia
   */
  XML_SVG_IMAGE: "image/svg+xml"
}), v5 = Yf({
  /**
   * The XHTML namespace.
   *
   * @see http://www.w3.org/1999/xhtml
   */
  HTML: "http://www.w3.org/1999/xhtml",
  /**
   * Checks if `uri` equals `NAMESPACE.HTML`.
   *
   * @param {string} [uri]
   *
   * @see NAMESPACE.HTML
   */
  isHTML: function(t) {
    return t === v5.HTML;
  },
  /**
   * The SVG namespace.
   *
   * @see http://www.w3.org/2000/svg
   */
  SVG: "http://www.w3.org/2000/svg",
  /**
   * The `xml:` namespace.
   *
   * @see http://www.w3.org/XML/1998/namespace
   */
  XML: "http://www.w3.org/XML/1998/namespace",
  /**
   * The `xmlns:` namespace
   *
   * @see https://www.w3.org/2000/xmlns/
   */
  XMLNS: "http://www.w3.org/2000/xmlns/"
});
Mi.assign = VJ;
Mi.find = jJ;
Mi.freeze = Yf;
Mi.MIME_TYPE = b5;
Mi.NAMESPACE = v5;
var y5 = Mi, ei = y5.find, Cl = y5.NAMESPACE;
function qJ(t) {
  return t !== "";
}
function WJ(t) {
  return t ? t.split(/[\t\n\f\r ]+/).filter(qJ) : [];
}
function GJ(t, e) {
  return t.hasOwnProperty(e) || (t[e] = !0), t;
}
function Eg(t) {
  if (!t) return [];
  var e = WJ(t);
  return Object.keys(e.reduce(GJ, {}));
}
function XJ(t) {
  return function(e) {
    return t && t.indexOf(e) !== -1;
  };
}
function Hl(t, e) {
  for (var n in t)
    Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
}
function na(t, e) {
  var n = t.prototype;
  if (!(n instanceof e)) {
    let a = function() {
    };
    a.prototype = e.prototype, a = new a(), Hl(n, a), t.prototype = n = a;
  }
  n.constructor != t && (typeof t != "function" && console.error("unknown Class:" + t), n.constructor = t);
}
var aa = {}, Ba = aa.ELEMENT_NODE = 1, $s = aa.ATTRIBUTE_NODE = 2, pu = aa.TEXT_NODE = 3, _5 = aa.CDATA_SECTION_NODE = 4, T5 = aa.ENTITY_REFERENCE_NODE = 5, ZJ = aa.ENTITY_NODE = 6, x5 = aa.PROCESSING_INSTRUCTION_NODE = 7, w5 = aa.COMMENT_NODE = 8, k5 = aa.DOCUMENT_NODE = 9, C5 = aa.DOCUMENT_TYPE_NODE = 10, Si = aa.DOCUMENT_FRAGMENT_NODE = 11, KJ = aa.NOTATION_NODE = 12, In = {}, yn = {};
In.INDEX_SIZE_ERR = (yn[1] = "Index size error", 1);
In.DOMSTRING_SIZE_ERR = (yn[2] = "DOMString size error", 2);
var Xn = In.HIERARCHY_REQUEST_ERR = (yn[3] = "Hierarchy request error", 3);
In.WRONG_DOCUMENT_ERR = (yn[4] = "Wrong document", 4);
In.INVALID_CHARACTER_ERR = (yn[5] = "Invalid character", 5);
In.NO_DATA_ALLOWED_ERR = (yn[6] = "No data allowed", 6);
In.NO_MODIFICATION_ALLOWED_ERR = (yn[7] = "No modification allowed", 7);
var S5 = In.NOT_FOUND_ERR = (yn[8] = "Not found", 8);
In.NOT_SUPPORTED_ERR = (yn[9] = "Not supported", 9);
var Lg = In.INUSE_ATTRIBUTE_ERR = (yn[10] = "Attribute in use", 10);
In.INVALID_STATE_ERR = (yn[11] = "Invalid state", 11);
In.SYNTAX_ERR = (yn[12] = "Syntax error", 12);
In.INVALID_MODIFICATION_ERR = (yn[13] = "Invalid modification", 13);
In.NAMESPACE_ERR = (yn[14] = "Invalid namespace", 14);
In.INVALID_ACCESS_ERR = (yn[15] = "Invalid access", 15);
function Qt(t, e) {
  if (e instanceof Error)
    var n = e;
  else
    n = this, Error.call(this, yn[t]), this.message = yn[t], Error.captureStackTrace && Error.captureStackTrace(this, Qt);
  return n.code = t, e && (this.message = this.message + ": " + e), n;
}
Qt.prototype = Error.prototype;
Hl(In, Qt);
function Ti() {
}
Ti.prototype = {
  /**
   * The number of nodes in the list. The range of valid child node indices is 0 to length-1 inclusive.
   * @standard level1
   */
  length: 0,
  /**
   * Returns the indexth item in the collection. If index is greater than or equal to the number of nodes in the list, this returns null.
   * @standard level1
   * @param index  unsigned long
   *   Index into the collection.
   * @return Node
   * 	The node at the indexth position in the NodeList, or null if that is not a valid index.
   */
  item: function(t) {
    return t >= 0 && t < this.length ? this[t] : null;
  },
  toString: function(t, e) {
    for (var n = [], a = 0; a < this.length; a++)
      fs(this[a], n, t, e);
    return n.join("");
  },
  /**
   * @private
   * @param {function (Node):boolean} predicate
   * @returns {Node[]}
   */
  filter: function(t) {
    return Array.prototype.filter.call(this, t);
  },
  /**
   * @private
   * @param {Node} item
   * @returns {number}
   */
  indexOf: function(t) {
    return Array.prototype.indexOf.call(this, t);
  }
};
function Fs(t, e) {
  this._node = t, this._refresh = e, jf(this);
}
function jf(t) {
  var e = t._node._inc || t._node.ownerDocument._inc;
  if (t._inc !== e) {
    var n = t._refresh(t._node);
    if ($5(t, "length", n.length), !t.$$length || n.length < t.$$length)
      for (var a = n.length; a in t; a++)
        Object.prototype.hasOwnProperty.call(t, a) && delete t[a];
    Hl(n, t), t._inc = e;
  }
}
Fs.prototype.item = function(t) {
  return jf(this), this[t] || null;
};
na(Fs, Ti);
function mu() {
}
function A5(t, e) {
  for (var n = t.length; n--; )
    if (t[n] === e)
      return n;
}
function Dg(t, e, n, a) {
  if (a ? e[A5(e, a)] = n : e[e.length++] = n, t) {
    n.ownerElement = t;
    var i = t.ownerDocument;
    i && (a && D5(i, t, a), QJ(i, t, n));
  }
}
function Ig(t, e, n) {
  var a = A5(e, n);
  if (a >= 0) {
    for (var i = e.length - 1; a < i; )
      e[a] = e[++a];
    if (e.length = i, t) {
      var r = t.ownerDocument;
      r && (D5(r, t, n), n.ownerElement = null);
    }
  } else
    throw new Qt(S5, new Error(t.tagName + "@" + n));
}
mu.prototype = {
  length: 0,
  item: Ti.prototype.item,
  getNamedItem: function(t) {
    for (var e = this.length; e--; ) {
      var n = this[e];
      if (n.nodeName == t)
        return n;
    }
  },
  setNamedItem: function(t) {
    var e = t.ownerElement;
    if (e && e != this._ownerElement)
      throw new Qt(Lg);
    var n = this.getNamedItem(t.nodeName);
    return Dg(this._ownerElement, this, t, n), n;
  },
  /* returns Node */
  setNamedItemNS: function(t) {
    var e = t.ownerElement, n;
    if (e && e != this._ownerElement)
      throw new Qt(Lg);
    return n = this.getNamedItemNS(t.namespaceURI, t.localName), Dg(this._ownerElement, this, t, n), n;
  },
  /* returns Node */
  removeNamedItem: function(t) {
    var e = this.getNamedItem(t);
    return Ig(this._ownerElement, this, e), e;
  },
  // raises: NOT_FOUND_ERR,NO_MODIFICATION_ALLOWED_ERR
  //for level2
  removeNamedItemNS: function(t, e) {
    var n = this.getNamedItemNS(t, e);
    return Ig(this._ownerElement, this, n), n;
  },
  getNamedItemNS: function(t, e) {
    for (var n = this.length; n--; ) {
      var a = this[n];
      if (a.localName == e && a.namespaceURI == t)
        return a;
    }
    return null;
  }
};
function E5() {
}
E5.prototype = {
  /**
   * The DOMImplementation.hasFeature() method returns a Boolean flag indicating if a given feature is supported.
   * The different implementations fairly diverged in what kind of features were reported.
   * The latest version of the spec settled to force this method to always return true, where the functionality was accurate and in use.
   *
   * @deprecated It is deprecated and modern browsers return true in all cases.
   *
   * @param {string} feature
   * @param {string} [version]
   * @returns {boolean} always true
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/hasFeature MDN
   * @see https://www.w3.org/TR/REC-DOM-Level-1/level-one-core.html#ID-5CED94D7 DOM Level 1 Core
   * @see https://dom.spec.whatwg.org/#dom-domimplementation-hasfeature DOM Living Standard
   */
  hasFeature: function(t, e) {
    return !0;
  },
  /**
   * Creates an XML Document object of the specified type with its document element.
   *
   * __It behaves slightly different from the description in the living standard__:
   * - There is no interface/class `XMLDocument`, it returns a `Document` instance.
   * - `contentType`, `encoding`, `mode`, `origin`, `url` fields are currently not declared.
   * - this implementation is not validating names or qualified names
   *   (when parsing XML strings, the SAX parser takes care of that)
   *
   * @param {string|null} namespaceURI
   * @param {string} qualifiedName
   * @param {DocumentType=null} doctype
   * @returns {Document}
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/createDocument MDN
   * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#Level-2-Core-DOM-createDocument DOM Level 2 Core (initial)
   * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocument  DOM Level 2 Core
   *
   * @see https://dom.spec.whatwg.org/#validate-and-extract DOM: Validate and extract
   * @see https://www.w3.org/TR/xml/#NT-NameStartChar XML Spec: Names
   * @see https://www.w3.org/TR/xml-names/#ns-qualnames XML Namespaces: Qualified names
   */
  createDocument: function(t, e, n) {
    var a = new Yl();
    if (a.implementation = this, a.childNodes = new Ti(), a.doctype = n || null, n && a.appendChild(n), e) {
      var i = a.createElementNS(t, e);
      a.appendChild(i);
    }
    return a;
  },
  /**
   * Returns a doctype, with the given `qualifiedName`, `publicId`, and `systemId`.
   *
   * __This behavior is slightly different from the in the specs__:
   * - this implementation is not validating names or qualified names
   *   (when parsing XML strings, the SAX parser takes care of that)
   *
   * @param {string} qualifiedName
   * @param {string} [publicId]
   * @param {string} [systemId]
   * @returns {DocumentType} which can either be used with `DOMImplementation.createDocument` upon document creation
   * 				  or can be put into the document via methods like `Node.insertBefore()` or `Node.replaceChild()`
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/createDocumentType MDN
   * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#Level-2-Core-DOM-createDocType DOM Level 2 Core
   * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocumenttype DOM Living Standard
   *
   * @see https://dom.spec.whatwg.org/#validate-and-extract DOM: Validate and extract
   * @see https://www.w3.org/TR/xml/#NT-NameStartChar XML Spec: Names
   * @see https://www.w3.org/TR/xml-names/#ns-qualnames XML Namespaces: Qualified names
   */
  createDocumentType: function(t, e, n) {
    var a = new ud();
    return a.name = t, a.nodeName = t, a.publicId = e || "", a.systemId = n || "", a;
  }
};
function xt() {
}
xt.prototype = {
  firstChild: null,
  lastChild: null,
  previousSibling: null,
  nextSibling: null,
  attributes: null,
  parentNode: null,
  childNodes: null,
  ownerDocument: null,
  nodeValue: null,
  namespaceURI: null,
  prefix: null,
  localName: null,
  // Modified in DOM Level 2:
  insertBefore: function(t, e) {
    return gu(this, t, e);
  },
  replaceChild: function(t, e) {
    gu(this, t, e, M5), e && this.removeChild(e);
  },
  removeChild: function(t) {
    return I5(this, t);
  },
  appendChild: function(t) {
    return this.insertBefore(t, null);
  },
  hasChildNodes: function() {
    return this.firstChild != null;
  },
  cloneNode: function(t) {
    return mh(this.ownerDocument || this, this, t);
  },
  // Modified in DOM Level 2:
  normalize: function() {
    for (var t = this.firstChild; t; ) {
      var e = t.nextSibling;
      e && e.nodeType == pu && t.nodeType == pu ? (this.removeChild(e), t.appendData(e.data)) : (t.normalize(), t = e);
    }
  },
  // Introduced in DOM Level 2:
  isSupported: function(t, e) {
    return this.ownerDocument.implementation.hasFeature(t, e);
  },
  // Introduced in DOM Level 2:
  hasAttributes: function() {
    return this.attributes.length > 0;
  },
  /**
   * Look up the prefix associated to the given namespace URI, starting from this node.
   * **The default namespace declarations are ignored by this method.**
   * See Namespace Prefix Lookup for details on the algorithm used by this method.
   *
   * _Note: The implementation seems to be incomplete when compared to the algorithm described in the specs._
   *
   * @param {string | null} namespaceURI
   * @returns {string | null}
   * @see https://www.w3.org/TR/DOM-Level-3-Core/core.html#Node3-lookupNamespacePrefix
   * @see https://www.w3.org/TR/DOM-Level-3-Core/namespaces-algorithms.html#lookupNamespacePrefixAlgo
   * @see https://dom.spec.whatwg.org/#dom-node-lookupprefix
   * @see https://github.com/xmldom/xmldom/issues/322
   */
  lookupPrefix: function(t) {
    for (var e = this; e; ) {
      var n = e._nsMap;
      if (n) {
        for (var a in n)
          if (Object.prototype.hasOwnProperty.call(n, a) && n[a] === t)
            return a;
      }
      e = e.nodeType == $s ? e.ownerDocument : e.parentNode;
    }
    return null;
  },
  // Introduced in DOM Level 3:
  lookupNamespaceURI: function(t) {
    for (var e = this; e; ) {
      var n = e._nsMap;
      if (n && Object.prototype.hasOwnProperty.call(n, t))
        return n[t];
      e = e.nodeType == $s ? e.ownerDocument : e.parentNode;
    }
    return null;
  },
  // Introduced in DOM Level 3:
  isDefaultNamespace: function(t) {
    var e = this.lookupPrefix(t);
    return e == null;
  }
};
function L5(t) {
  return t == "<" && "&lt;" || t == ">" && "&gt;" || t == "&" && "&amp;" || t == '"' && "&quot;" || "&#" + t.charCodeAt() + ";";
}
Hl(aa, xt);
Hl(aa, xt.prototype);
function Sl(t, e) {
  if (e(t))
    return !0;
  if (t = t.firstChild)
    do
      if (Sl(t, e))
        return !0;
    while (t = t.nextSibling);
}
function Yl() {
  this.ownerDocument = this;
}
function QJ(t, e, n) {
  t && t._inc++;
  var a = n.namespaceURI;
  a === Cl.XMLNS && (e._nsMap[n.prefix ? n.localName : ""] = n.value);
}
function D5(t, e, n, a) {
  t && t._inc++;
  var i = n.namespaceURI;
  i === Cl.XMLNS && delete e._nsMap[n.prefix ? n.localName : ""];
}
function Vf(t, e, n) {
  if (t && t._inc) {
    t._inc++;
    var a = e.childNodes;
    if (n)
      a[a.length++] = n;
    else {
      for (var i = e.firstChild, r = 0; i; )
        a[r++] = i, i = i.nextSibling;
      a.length = r, delete a[a.length];
    }
  }
}
function I5(t, e) {
  var n = e.previousSibling, a = e.nextSibling;
  return n ? n.nextSibling = a : t.firstChild = a, a ? a.previousSibling = n : t.lastChild = n, e.parentNode = null, e.previousSibling = null, e.nextSibling = null, Vf(t.ownerDocument, t), e;
}
function JJ(t) {
  return t && (t.nodeType === xt.DOCUMENT_NODE || t.nodeType === xt.DOCUMENT_FRAGMENT_NODE || t.nodeType === xt.ELEMENT_NODE);
}
function eee(t) {
  return t && (ti(t) || qf(t) || Ai(t) || t.nodeType === xt.DOCUMENT_FRAGMENT_NODE || t.nodeType === xt.COMMENT_NODE || t.nodeType === xt.PROCESSING_INSTRUCTION_NODE);
}
function Ai(t) {
  return t && t.nodeType === xt.DOCUMENT_TYPE_NODE;
}
function ti(t) {
  return t && t.nodeType === xt.ELEMENT_NODE;
}
function qf(t) {
  return t && t.nodeType === xt.TEXT_NODE;
}
function Mg(t, e) {
  var n = t.childNodes || [];
  if (ei(n, ti) || Ai(e))
    return !1;
  var a = ei(n, Ai);
  return !(e && a && n.indexOf(a) > n.indexOf(e));
}
function Og(t, e) {
  var n = t.childNodes || [];
  function a(r) {
    return ti(r) && r !== e;
  }
  if (ei(n, a))
    return !1;
  var i = ei(n, Ai);
  return !(e && i && n.indexOf(i) > n.indexOf(e));
}
function tee(t, e, n) {
  if (!JJ(t))
    throw new Qt(Xn, "Unexpected parent node type " + t.nodeType);
  if (n && n.parentNode !== t)
    throw new Qt(S5, "child not in parent");
  if (
    // 4. If `node` is not a DocumentFragment, DocumentType, Element, or CharacterData node, then throw a "HierarchyRequestError" DOMException.
    !eee(e) || // 5. If either `node` is a Text node and `parent` is a document,
    // the sax parser currently adds top level text nodes, this will be fixed in 0.9.0
    // || (node.nodeType === Node.TEXT_NODE && parent.nodeType === Node.DOCUMENT_NODE)
    // or `node` is a doctype and `parent` is not a document, then throw a "HierarchyRequestError" DOMException.
    Ai(e) && t.nodeType !== xt.DOCUMENT_NODE
  )
    throw new Qt(
      Xn,
      "Unexpected node type " + e.nodeType + " for parent node type " + t.nodeType
    );
}
function nee(t, e, n) {
  var a = t.childNodes || [], i = e.childNodes || [];
  if (e.nodeType === xt.DOCUMENT_FRAGMENT_NODE) {
    var r = i.filter(ti);
    if (r.length > 1 || ei(i, qf))
      throw new Qt(Xn, "More than one element or text in fragment");
    if (r.length === 1 && !Mg(t, n))
      throw new Qt(Xn, "Element in fragment can not be inserted before doctype");
  }
  if (ti(e) && !Mg(t, n))
    throw new Qt(Xn, "Only one element can be added and only after doctype");
  if (Ai(e)) {
    if (ei(a, Ai))
      throw new Qt(Xn, "Only one doctype is allowed");
    var s = ei(a, ti);
    if (n && a.indexOf(s) < a.indexOf(n))
      throw new Qt(Xn, "Doctype can only be inserted before an element");
    if (!n && s)
      throw new Qt(Xn, "Doctype can not be appended since element is present");
  }
}
function M5(t, e, n) {
  var a = t.childNodes || [], i = e.childNodes || [];
  if (e.nodeType === xt.DOCUMENT_FRAGMENT_NODE) {
    var r = i.filter(ti);
    if (r.length > 1 || ei(i, qf))
      throw new Qt(Xn, "More than one element or text in fragment");
    if (r.length === 1 && !Og(t, n))
      throw new Qt(Xn, "Element in fragment can not be inserted before doctype");
  }
  if (ti(e) && !Og(t, n))
    throw new Qt(Xn, "Only one element can be added and only after doctype");
  if (Ai(e)) {
    if (ei(a, function(l) {
      return Ai(l) && l !== n;
    }))
      throw new Qt(Xn, "Only one doctype is allowed");
    var s = ei(a, ti);
    if (n && a.indexOf(s) < a.indexOf(n))
      throw new Qt(Xn, "Doctype can only be inserted before an element");
  }
}
function gu(t, e, n, a) {
  tee(t, e, n), t.nodeType === xt.DOCUMENT_NODE && (a || nee)(t, e, n);
  var i = e.parentNode;
  if (i && i.removeChild(e), e.nodeType === Si) {
    var r = e.firstChild;
    if (r == null)
      return e;
    var s = e.lastChild;
  } else
    r = s = e;
  var o = n ? n.previousSibling : t.lastChild;
  r.previousSibling = o, s.nextSibling = n, o ? o.nextSibling = r : t.firstChild = r, n == null ? t.lastChild = s : n.previousSibling = s;
  do
    r.parentNode = t;
  while (r !== s && (r = r.nextSibling));
  return Vf(t.ownerDocument || t, t), e.nodeType == Si && (e.firstChild = e.lastChild = null), e;
}
function aee(t, e) {
  return e.parentNode && e.parentNode.removeChild(e), e.parentNode = t, e.previousSibling = t.lastChild, e.nextSibling = null, e.previousSibling ? e.previousSibling.nextSibling = e : t.firstChild = e, t.lastChild = e, Vf(t.ownerDocument, t, e), e;
}
Yl.prototype = {
  //implementation : null,
  nodeName: "#document",
  nodeType: k5,
  /**
   * The DocumentType node of the document.
   *
   * @readonly
   * @type DocumentType
   */
  doctype: null,
  documentElement: null,
  _inc: 1,
  insertBefore: function(t, e) {
    if (t.nodeType == Si) {
      for (var n = t.firstChild; n; ) {
        var a = n.nextSibling;
        this.insertBefore(n, e), n = a;
      }
      return t;
    }
    return gu(this, t, e), t.ownerDocument = this, this.documentElement === null && t.nodeType === Ba && (this.documentElement = t), t;
  },
  removeChild: function(t) {
    return this.documentElement == t && (this.documentElement = null), I5(this, t);
  },
  replaceChild: function(t, e) {
    gu(this, t, e, M5), t.ownerDocument = this, e && this.removeChild(e), ti(t) && (this.documentElement = t);
  },
  // Introduced in DOM Level 2:
  importNode: function(t, e) {
    return N5(this, t, e);
  },
  // Introduced in DOM Level 2:
  getElementById: function(t) {
    var e = null;
    return Sl(this.documentElement, function(n) {
      if (n.nodeType == Ba && n.getAttribute("id") == t)
        return e = n, !0;
    }), e;
  },
  /**
   * The `getElementsByClassName` method of `Document` interface returns an array-like object
   * of all child elements which have **all** of the given class name(s).
   *
   * Returns an empty list if `classeNames` is an empty string or only contains HTML white space characters.
   *
   *
   * Warning: This is a live LiveNodeList.
   * Changes in the DOM will reflect in the array as the changes occur.
   * If an element selected by this array no longer qualifies for the selector,
   * it will automatically be removed. Be aware of this for iteration purposes.
   *
   * @param {string} classNames is a string representing the class name(s) to match; multiple class names are separated by (ASCII-)whitespace
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/Document/getElementsByClassName
   * @see https://dom.spec.whatwg.org/#concept-getelementsbyclassname
   */
  getElementsByClassName: function(t) {
    var e = Eg(t);
    return new Fs(this, function(n) {
      var a = [];
      return e.length > 0 && Sl(n.documentElement, function(i) {
        if (i !== n && i.nodeType === Ba) {
          var r = i.getAttribute("class");
          if (r) {
            var s = t === r;
            if (!s) {
              var o = Eg(r);
              s = e.every(XJ(o));
            }
            s && a.push(i);
          }
        }
      }), a;
    });
  },
  //document factory method:
  createElement: function(t) {
    var e = new Nr();
    e.ownerDocument = this, e.nodeName = t, e.tagName = t, e.localName = t, e.childNodes = new Ti();
    var n = e.attributes = new mu();
    return n._ownerElement = e, e;
  },
  createDocumentFragment: function() {
    var t = new dd();
    return t.ownerDocument = this, t.childNodes = new Ti(), t;
  },
  createTextNode: function(t) {
    var e = new Wf();
    return e.ownerDocument = this, e.appendData(t), e;
  },
  createComment: function(t) {
    var e = new Gf();
    return e.ownerDocument = this, e.appendData(t), e;
  },
  createCDATASection: function(t) {
    var e = new Xf();
    return e.ownerDocument = this, e.appendData(t), e;
  },
  createProcessingInstruction: function(t, e) {
    var n = new Kf();
    return n.ownerDocument = this, n.tagName = n.nodeName = n.target = t, n.nodeValue = n.data = e, n;
  },
  createAttribute: function(t) {
    var e = new bu();
    return e.ownerDocument = this, e.name = t, e.nodeName = t, e.localName = t, e.specified = !0, e;
  },
  createEntityReference: function(t) {
    var e = new Zf();
    return e.ownerDocument = this, e.nodeName = t, e;
  },
  // Introduced in DOM Level 2:
  createElementNS: function(t, e) {
    var n = new Nr(), a = e.split(":"), i = n.attributes = new mu();
    return n.childNodes = new Ti(), n.ownerDocument = this, n.nodeName = e, n.tagName = e, n.namespaceURI = t, a.length == 2 ? (n.prefix = a[0], n.localName = a[1]) : n.localName = e, i._ownerElement = n, n;
  },
  // Introduced in DOM Level 2:
  createAttributeNS: function(t, e) {
    var n = new bu(), a = e.split(":");
    return n.ownerDocument = this, n.nodeName = e, n.name = e, n.namespaceURI = t, n.specified = !0, a.length == 2 ? (n.prefix = a[0], n.localName = a[1]) : n.localName = e, n;
  }
};
na(Yl, xt);
function Nr() {
  this._nsMap = {};
}
Nr.prototype = {
  nodeType: Ba,
  hasAttribute: function(t) {
    return this.getAttributeNode(t) != null;
  },
  getAttribute: function(t) {
    var e = this.getAttributeNode(t);
    return e && e.value || "";
  },
  getAttributeNode: function(t) {
    return this.attributes.getNamedItem(t);
  },
  setAttribute: function(t, e) {
    var n = this.ownerDocument.createAttribute(t);
    n.value = n.nodeValue = "" + e, this.setAttributeNode(n);
  },
  removeAttribute: function(t) {
    var e = this.getAttributeNode(t);
    e && this.removeAttributeNode(e);
  },
  //four real opeartion method
  appendChild: function(t) {
    return t.nodeType === Si ? this.insertBefore(t, null) : aee(this, t);
  },
  setAttributeNode: function(t) {
    return this.attributes.setNamedItem(t);
  },
  setAttributeNodeNS: function(t) {
    return this.attributes.setNamedItemNS(t);
  },
  removeAttributeNode: function(t) {
    return this.attributes.removeNamedItem(t.nodeName);
  },
  //get real attribute name,and remove it by removeAttributeNode
  removeAttributeNS: function(t, e) {
    var n = this.getAttributeNodeNS(t, e);
    n && this.removeAttributeNode(n);
  },
  hasAttributeNS: function(t, e) {
    return this.getAttributeNodeNS(t, e) != null;
  },
  getAttributeNS: function(t, e) {
    var n = this.getAttributeNodeNS(t, e);
    return n && n.value || "";
  },
  setAttributeNS: function(t, e, n) {
    var a = this.ownerDocument.createAttributeNS(t, e);
    a.value = a.nodeValue = "" + n, this.setAttributeNode(a);
  },
  getAttributeNodeNS: function(t, e) {
    return this.attributes.getNamedItemNS(t, e);
  },
  getElementsByTagName: function(t) {
    return new Fs(this, function(e) {
      var n = [];
      return Sl(e, function(a) {
        a !== e && a.nodeType == Ba && (t === "*" || a.tagName == t) && n.push(a);
      }), n;
    });
  },
  getElementsByTagNameNS: function(t, e) {
    return new Fs(this, function(n) {
      var a = [];
      return Sl(n, function(i) {
        i !== n && i.nodeType === Ba && (t === "*" || i.namespaceURI === t) && (e === "*" || i.localName == e) && a.push(i);
      }), a;
    });
  }
};
Yl.prototype.getElementsByTagName = Nr.prototype.getElementsByTagName;
Yl.prototype.getElementsByTagNameNS = Nr.prototype.getElementsByTagNameNS;
na(Nr, xt);
function bu() {
}
bu.prototype.nodeType = $s;
na(bu, xt);
function jl() {
}
jl.prototype = {
  data: "",
  substringData: function(t, e) {
    return this.data.substring(t, t + e);
  },
  appendData: function(t) {
    t = this.data + t, this.nodeValue = this.data = t, this.length = t.length;
  },
  insertData: function(t, e) {
    this.replaceData(t, 0, e);
  },
  appendChild: function(t) {
    throw new Error(yn[Xn]);
  },
  deleteData: function(t, e) {
    this.replaceData(t, e, "");
  },
  replaceData: function(t, e, n) {
    var a = this.data.substring(0, t), i = this.data.substring(t + e);
    n = a + n + i, this.nodeValue = this.data = n, this.length = n.length;
  }
};
na(jl, xt);
function Wf() {
}
Wf.prototype = {
  nodeName: "#text",
  nodeType: pu,
  splitText: function(t) {
    var e = this.data, n = e.substring(t);
    e = e.substring(0, t), this.data = this.nodeValue = e, this.length = e.length;
    var a = this.ownerDocument.createTextNode(n);
    return this.parentNode && this.parentNode.insertBefore(a, this.nextSibling), a;
  }
};
na(Wf, jl);
function Gf() {
}
Gf.prototype = {
  nodeName: "#comment",
  nodeType: w5
};
na(Gf, jl);
function Xf() {
}
Xf.prototype = {
  nodeName: "#cdata-section",
  nodeType: _5
};
na(Xf, jl);
function ud() {
}
ud.prototype.nodeType = C5;
na(ud, xt);
function O5() {
}
O5.prototype.nodeType = KJ;
na(O5, xt);
function P5() {
}
P5.prototype.nodeType = ZJ;
na(P5, xt);
function Zf() {
}
Zf.prototype.nodeType = T5;
na(Zf, xt);
function dd() {
}
dd.prototype.nodeName = "#document-fragment";
dd.prototype.nodeType = Si;
na(dd, xt);
function Kf() {
}
Kf.prototype.nodeType = x5;
na(Kf, xt);
function B5() {
}
B5.prototype.serializeToString = function(t, e, n) {
  return R5.call(t, e, n);
};
xt.prototype.toString = R5;
function R5(t, e) {
  var n = [], a = this.nodeType == 9 && this.documentElement || this, i = a.prefix, r = a.namespaceURI;
  if (r && i == null) {
    var i = a.lookupPrefix(r);
    if (i == null)
      var s = [
        { namespace: r, prefix: null }
        //{namespace:uri,prefix:''}
      ];
  }
  return fs(this, n, t, e, s), n.join("");
}
function Pg(t, e, n) {
  var a = t.prefix || "", i = t.namespaceURI;
  if (!i || a === "xml" && i === Cl.XML || i === Cl.XMLNS)
    return !1;
  for (var r = n.length; r--; ) {
    var s = n[r];
    if (s.prefix === a)
      return s.namespace !== i;
  }
  return !0;
}
function S0(t, e, n) {
  t.push(" ", e, '="', n.replace(/[<>&"\t\n\r]/g, L5), '"');
}
function fs(t, e, n, a, i) {
  if (i || (i = []), a)
    if (t = a(t), t) {
      if (typeof t == "string") {
        e.push(t);
        return;
      }
    } else
      return;
  switch (t.nodeType) {
    case Ba:
      var r = t.attributes, s = r.length, S = t.firstChild, o = t.tagName;
      n = Cl.isHTML(t.namespaceURI) || n;
      var l = o;
      if (!n && !t.prefix && t.namespaceURI) {
        for (var c, u = 0; u < r.length; u++)
          if (r.item(u).name === "xmlns") {
            c = r.item(u).value;
            break;
          }
        if (!c)
          for (var f = i.length - 1; f >= 0; f--) {
            var m = i[f];
            if (m.prefix === "" && m.namespace === t.namespaceURI) {
              c = m.namespace;
              break;
            }
          }
        if (c !== t.namespaceURI)
          for (var f = i.length - 1; f >= 0; f--) {
            var m = i[f];
            if (m.namespace === t.namespaceURI) {
              m.prefix && (l = m.prefix + ":" + o);
              break;
            }
          }
      }
      e.push("<", l);
      for (var _ = 0; _ < s; _++) {
        var T = r.item(_);
        T.prefix == "xmlns" ? i.push({ prefix: T.localName, namespace: T.value }) : T.nodeName == "xmlns" && i.push({ prefix: "", namespace: T.value });
      }
      for (var _ = 0; _ < s; _++) {
        var T = r.item(_);
        if (Pg(T, n, i)) {
          var g = T.prefix || "", x = T.namespaceURI;
          S0(e, g ? "xmlns:" + g : "xmlns", x), i.push({ prefix: g, namespace: x });
        }
        fs(T, e, n, a, i);
      }
      if (o === l && Pg(t, n, i)) {
        var g = t.prefix || "", x = t.namespaceURI;
        S0(e, g ? "xmlns:" + g : "xmlns", x), i.push({ prefix: g, namespace: x });
      }
      if (S || n && !/^(?:meta|link|img|br|hr|input)$/i.test(o)) {
        if (e.push(">"), n && /^script$/i.test(o))
          for (; S; )
            S.data ? e.push(S.data) : fs(S, e, n, a, i.slice()), S = S.nextSibling;
        else
          for (; S; )
            fs(S, e, n, a, i.slice()), S = S.nextSibling;
        e.push("</", l, ">");
      } else
        e.push("/>");
      return;
    case k5:
    case Si:
      for (var S = t.firstChild; S; )
        fs(S, e, n, a, i.slice()), S = S.nextSibling;
      return;
    case $s:
      return S0(e, t.name, t.value);
    case pu:
      return e.push(
        t.data.replace(/[<&>]/g, L5)
      );
    case _5:
      return e.push("<![CDATA[", t.data, "]]>");
    case w5:
      return e.push("<!--", t.data, "-->");
    case C5:
      var D = t.publicId, L = t.systemId;
      if (e.push("<!DOCTYPE ", t.name), D)
        e.push(" PUBLIC ", D), L && L != "." && e.push(" ", L), e.push(">");
      else if (L && L != ".")
        e.push(" SYSTEM ", L, ">");
      else {
        var M = t.internalSubset;
        M && e.push(" [", M, "]"), e.push(">");
      }
      return;
    case x5:
      return e.push("<?", t.target, " ", t.data, "?>");
    case T5:
      return e.push("&", t.nodeName, ";");
    default:
      e.push("??", t.nodeName);
  }
}
function N5(t, e, n) {
  var a;
  switch (e.nodeType) {
    case Ba:
      a = e.cloneNode(!1), a.ownerDocument = t;
    case Si:
      break;
    case $s:
      n = !0;
      break;
  }
  if (a || (a = e.cloneNode(!1)), a.ownerDocument = t, a.parentNode = null, n)
    for (var i = e.firstChild; i; )
      a.appendChild(N5(t, i, n)), i = i.nextSibling;
  return a;
}
function mh(t, e, n) {
  var a = new e.constructor();
  for (var i in e)
    if (Object.prototype.hasOwnProperty.call(e, i)) {
      var r = e[i];
      typeof r != "object" && r != a[i] && (a[i] = r);
    }
  switch (e.childNodes && (a.childNodes = new Ti()), a.ownerDocument = t, a.nodeType) {
    case Ba:
      var s = e.attributes, o = a.attributes = new mu(), l = s.length;
      o._ownerElement = a;
      for (var c = 0; c < l; c++)
        a.setAttributeNode(mh(t, s.item(c), !0));
      break;
    case $s:
      n = !0;
  }
  if (n)
    for (var u = e.firstChild; u; )
      a.appendChild(mh(t, u, n)), u = u.nextSibling;
  return a;
}
function $5(t, e, n) {
  t[e] = n;
}
try {
  if (Object.defineProperty) {
    let t = function(e) {
      switch (e.nodeType) {
        case Ba:
        case Si:
          var n = [];
          for (e = e.firstChild; e; )
            e.nodeType !== 7 && e.nodeType !== 8 && n.push(t(e)), e = e.nextSibling;
          return n.join("");
        default:
          return e.nodeValue;
      }
    };
    Object.defineProperty(Fs.prototype, "length", {
      get: function() {
        return jf(this), this.$$length;
      }
    }), Object.defineProperty(xt.prototype, "textContent", {
      get: function() {
        return t(this);
      },
      set: function(e) {
        switch (this.nodeType) {
          case Ba:
          case Si:
            for (; this.firstChild; )
              this.removeChild(this.firstChild);
            (e || String(e)) && this.appendChild(this.ownerDocument.createTextNode(e));
            break;
          default:
            this.data = e, this.value = e, this.nodeValue = e;
        }
      }
    }), $5 = function(e, n, a) {
      e["$$" + n] = a;
    };
  }
} catch {
}
cr.DocumentType = ud;
cr.DOMException = Qt;
cr.DOMImplementation = E5;
cr.Element = Nr;
cr.Node = xt;
cr.NodeList = Ti;
cr.XMLSerializer = B5;
var hd = {}, F5 = {};
(function(t) {
  var e = Mi.freeze;
  t.XML_ENTITIES = e({
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    quot: '"'
  }), t.HTML_ENTITIES = e({
    Aacute: "Á",
    aacute: "á",
    Abreve: "Ă",
    abreve: "ă",
    ac: "∾",
    acd: "∿",
    acE: "∾̳",
    Acirc: "Â",
    acirc: "â",
    acute: "´",
    Acy: "А",
    acy: "а",
    AElig: "Æ",
    aelig: "æ",
    af: "⁡",
    Afr: "𝔄",
    afr: "𝔞",
    Agrave: "À",
    agrave: "à",
    alefsym: "ℵ",
    aleph: "ℵ",
    Alpha: "Α",
    alpha: "α",
    Amacr: "Ā",
    amacr: "ā",
    amalg: "⨿",
    AMP: "&",
    amp: "&",
    And: "⩓",
    and: "∧",
    andand: "⩕",
    andd: "⩜",
    andslope: "⩘",
    andv: "⩚",
    ang: "∠",
    ange: "⦤",
    angle: "∠",
    angmsd: "∡",
    angmsdaa: "⦨",
    angmsdab: "⦩",
    angmsdac: "⦪",
    angmsdad: "⦫",
    angmsdae: "⦬",
    angmsdaf: "⦭",
    angmsdag: "⦮",
    angmsdah: "⦯",
    angrt: "∟",
    angrtvb: "⊾",
    angrtvbd: "⦝",
    angsph: "∢",
    angst: "Å",
    angzarr: "⍼",
    Aogon: "Ą",
    aogon: "ą",
    Aopf: "𝔸",
    aopf: "𝕒",
    ap: "≈",
    apacir: "⩯",
    apE: "⩰",
    ape: "≊",
    apid: "≋",
    apos: "'",
    ApplyFunction: "⁡",
    approx: "≈",
    approxeq: "≊",
    Aring: "Å",
    aring: "å",
    Ascr: "𝒜",
    ascr: "𝒶",
    Assign: "≔",
    ast: "*",
    asymp: "≈",
    asympeq: "≍",
    Atilde: "Ã",
    atilde: "ã",
    Auml: "Ä",
    auml: "ä",
    awconint: "∳",
    awint: "⨑",
    backcong: "≌",
    backepsilon: "϶",
    backprime: "‵",
    backsim: "∽",
    backsimeq: "⋍",
    Backslash: "∖",
    Barv: "⫧",
    barvee: "⊽",
    Barwed: "⌆",
    barwed: "⌅",
    barwedge: "⌅",
    bbrk: "⎵",
    bbrktbrk: "⎶",
    bcong: "≌",
    Bcy: "Б",
    bcy: "б",
    bdquo: "„",
    becaus: "∵",
    Because: "∵",
    because: "∵",
    bemptyv: "⦰",
    bepsi: "϶",
    bernou: "ℬ",
    Bernoullis: "ℬ",
    Beta: "Β",
    beta: "β",
    beth: "ℶ",
    between: "≬",
    Bfr: "𝔅",
    bfr: "𝔟",
    bigcap: "⋂",
    bigcirc: "◯",
    bigcup: "⋃",
    bigodot: "⨀",
    bigoplus: "⨁",
    bigotimes: "⨂",
    bigsqcup: "⨆",
    bigstar: "★",
    bigtriangledown: "▽",
    bigtriangleup: "△",
    biguplus: "⨄",
    bigvee: "⋁",
    bigwedge: "⋀",
    bkarow: "⤍",
    blacklozenge: "⧫",
    blacksquare: "▪",
    blacktriangle: "▴",
    blacktriangledown: "▾",
    blacktriangleleft: "◂",
    blacktriangleright: "▸",
    blank: "␣",
    blk12: "▒",
    blk14: "░",
    blk34: "▓",
    block: "█",
    bne: "=⃥",
    bnequiv: "≡⃥",
    bNot: "⫭",
    bnot: "⌐",
    Bopf: "𝔹",
    bopf: "𝕓",
    bot: "⊥",
    bottom: "⊥",
    bowtie: "⋈",
    boxbox: "⧉",
    boxDL: "╗",
    boxDl: "╖",
    boxdL: "╕",
    boxdl: "┐",
    boxDR: "╔",
    boxDr: "╓",
    boxdR: "╒",
    boxdr: "┌",
    boxH: "═",
    boxh: "─",
    boxHD: "╦",
    boxHd: "╤",
    boxhD: "╥",
    boxhd: "┬",
    boxHU: "╩",
    boxHu: "╧",
    boxhU: "╨",
    boxhu: "┴",
    boxminus: "⊟",
    boxplus: "⊞",
    boxtimes: "⊠",
    boxUL: "╝",
    boxUl: "╜",
    boxuL: "╛",
    boxul: "┘",
    boxUR: "╚",
    boxUr: "╙",
    boxuR: "╘",
    boxur: "└",
    boxV: "║",
    boxv: "│",
    boxVH: "╬",
    boxVh: "╫",
    boxvH: "╪",
    boxvh: "┼",
    boxVL: "╣",
    boxVl: "╢",
    boxvL: "╡",
    boxvl: "┤",
    boxVR: "╠",
    boxVr: "╟",
    boxvR: "╞",
    boxvr: "├",
    bprime: "‵",
    Breve: "˘",
    breve: "˘",
    brvbar: "¦",
    Bscr: "ℬ",
    bscr: "𝒷",
    bsemi: "⁏",
    bsim: "∽",
    bsime: "⋍",
    bsol: "\\",
    bsolb: "⧅",
    bsolhsub: "⟈",
    bull: "•",
    bullet: "•",
    bump: "≎",
    bumpE: "⪮",
    bumpe: "≏",
    Bumpeq: "≎",
    bumpeq: "≏",
    Cacute: "Ć",
    cacute: "ć",
    Cap: "⋒",
    cap: "∩",
    capand: "⩄",
    capbrcup: "⩉",
    capcap: "⩋",
    capcup: "⩇",
    capdot: "⩀",
    CapitalDifferentialD: "ⅅ",
    caps: "∩︀",
    caret: "⁁",
    caron: "ˇ",
    Cayleys: "ℭ",
    ccaps: "⩍",
    Ccaron: "Č",
    ccaron: "č",
    Ccedil: "Ç",
    ccedil: "ç",
    Ccirc: "Ĉ",
    ccirc: "ĉ",
    Cconint: "∰",
    ccups: "⩌",
    ccupssm: "⩐",
    Cdot: "Ċ",
    cdot: "ċ",
    cedil: "¸",
    Cedilla: "¸",
    cemptyv: "⦲",
    cent: "¢",
    CenterDot: "·",
    centerdot: "·",
    Cfr: "ℭ",
    cfr: "𝔠",
    CHcy: "Ч",
    chcy: "ч",
    check: "✓",
    checkmark: "✓",
    Chi: "Χ",
    chi: "χ",
    cir: "○",
    circ: "ˆ",
    circeq: "≗",
    circlearrowleft: "↺",
    circlearrowright: "↻",
    circledast: "⊛",
    circledcirc: "⊚",
    circleddash: "⊝",
    CircleDot: "⊙",
    circledR: "®",
    circledS: "Ⓢ",
    CircleMinus: "⊖",
    CirclePlus: "⊕",
    CircleTimes: "⊗",
    cirE: "⧃",
    cire: "≗",
    cirfnint: "⨐",
    cirmid: "⫯",
    cirscir: "⧂",
    ClockwiseContourIntegral: "∲",
    CloseCurlyDoubleQuote: "”",
    CloseCurlyQuote: "’",
    clubs: "♣",
    clubsuit: "♣",
    Colon: "∷",
    colon: ":",
    Colone: "⩴",
    colone: "≔",
    coloneq: "≔",
    comma: ",",
    commat: "@",
    comp: "∁",
    compfn: "∘",
    complement: "∁",
    complexes: "ℂ",
    cong: "≅",
    congdot: "⩭",
    Congruent: "≡",
    Conint: "∯",
    conint: "∮",
    ContourIntegral: "∮",
    Copf: "ℂ",
    copf: "𝕔",
    coprod: "∐",
    Coproduct: "∐",
    COPY: "©",
    copy: "©",
    copysr: "℗",
    CounterClockwiseContourIntegral: "∳",
    crarr: "↵",
    Cross: "⨯",
    cross: "✗",
    Cscr: "𝒞",
    cscr: "𝒸",
    csub: "⫏",
    csube: "⫑",
    csup: "⫐",
    csupe: "⫒",
    ctdot: "⋯",
    cudarrl: "⤸",
    cudarrr: "⤵",
    cuepr: "⋞",
    cuesc: "⋟",
    cularr: "↶",
    cularrp: "⤽",
    Cup: "⋓",
    cup: "∪",
    cupbrcap: "⩈",
    CupCap: "≍",
    cupcap: "⩆",
    cupcup: "⩊",
    cupdot: "⊍",
    cupor: "⩅",
    cups: "∪︀",
    curarr: "↷",
    curarrm: "⤼",
    curlyeqprec: "⋞",
    curlyeqsucc: "⋟",
    curlyvee: "⋎",
    curlywedge: "⋏",
    curren: "¤",
    curvearrowleft: "↶",
    curvearrowright: "↷",
    cuvee: "⋎",
    cuwed: "⋏",
    cwconint: "∲",
    cwint: "∱",
    cylcty: "⌭",
    Dagger: "‡",
    dagger: "†",
    daleth: "ℸ",
    Darr: "↡",
    dArr: "⇓",
    darr: "↓",
    dash: "‐",
    Dashv: "⫤",
    dashv: "⊣",
    dbkarow: "⤏",
    dblac: "˝",
    Dcaron: "Ď",
    dcaron: "ď",
    Dcy: "Д",
    dcy: "д",
    DD: "ⅅ",
    dd: "ⅆ",
    ddagger: "‡",
    ddarr: "⇊",
    DDotrahd: "⤑",
    ddotseq: "⩷",
    deg: "°",
    Del: "∇",
    Delta: "Δ",
    delta: "δ",
    demptyv: "⦱",
    dfisht: "⥿",
    Dfr: "𝔇",
    dfr: "𝔡",
    dHar: "⥥",
    dharl: "⇃",
    dharr: "⇂",
    DiacriticalAcute: "´",
    DiacriticalDot: "˙",
    DiacriticalDoubleAcute: "˝",
    DiacriticalGrave: "`",
    DiacriticalTilde: "˜",
    diam: "⋄",
    Diamond: "⋄",
    diamond: "⋄",
    diamondsuit: "♦",
    diams: "♦",
    die: "¨",
    DifferentialD: "ⅆ",
    digamma: "ϝ",
    disin: "⋲",
    div: "÷",
    divide: "÷",
    divideontimes: "⋇",
    divonx: "⋇",
    DJcy: "Ђ",
    djcy: "ђ",
    dlcorn: "⌞",
    dlcrop: "⌍",
    dollar: "$",
    Dopf: "𝔻",
    dopf: "𝕕",
    Dot: "¨",
    dot: "˙",
    DotDot: "⃜",
    doteq: "≐",
    doteqdot: "≑",
    DotEqual: "≐",
    dotminus: "∸",
    dotplus: "∔",
    dotsquare: "⊡",
    doublebarwedge: "⌆",
    DoubleContourIntegral: "∯",
    DoubleDot: "¨",
    DoubleDownArrow: "⇓",
    DoubleLeftArrow: "⇐",
    DoubleLeftRightArrow: "⇔",
    DoubleLeftTee: "⫤",
    DoubleLongLeftArrow: "⟸",
    DoubleLongLeftRightArrow: "⟺",
    DoubleLongRightArrow: "⟹",
    DoubleRightArrow: "⇒",
    DoubleRightTee: "⊨",
    DoubleUpArrow: "⇑",
    DoubleUpDownArrow: "⇕",
    DoubleVerticalBar: "∥",
    DownArrow: "↓",
    Downarrow: "⇓",
    downarrow: "↓",
    DownArrowBar: "⤓",
    DownArrowUpArrow: "⇵",
    DownBreve: "̑",
    downdownarrows: "⇊",
    downharpoonleft: "⇃",
    downharpoonright: "⇂",
    DownLeftRightVector: "⥐",
    DownLeftTeeVector: "⥞",
    DownLeftVector: "↽",
    DownLeftVectorBar: "⥖",
    DownRightTeeVector: "⥟",
    DownRightVector: "⇁",
    DownRightVectorBar: "⥗",
    DownTee: "⊤",
    DownTeeArrow: "↧",
    drbkarow: "⤐",
    drcorn: "⌟",
    drcrop: "⌌",
    Dscr: "𝒟",
    dscr: "𝒹",
    DScy: "Ѕ",
    dscy: "ѕ",
    dsol: "⧶",
    Dstrok: "Đ",
    dstrok: "đ",
    dtdot: "⋱",
    dtri: "▿",
    dtrif: "▾",
    duarr: "⇵",
    duhar: "⥯",
    dwangle: "⦦",
    DZcy: "Џ",
    dzcy: "џ",
    dzigrarr: "⟿",
    Eacute: "É",
    eacute: "é",
    easter: "⩮",
    Ecaron: "Ě",
    ecaron: "ě",
    ecir: "≖",
    Ecirc: "Ê",
    ecirc: "ê",
    ecolon: "≕",
    Ecy: "Э",
    ecy: "э",
    eDDot: "⩷",
    Edot: "Ė",
    eDot: "≑",
    edot: "ė",
    ee: "ⅇ",
    efDot: "≒",
    Efr: "𝔈",
    efr: "𝔢",
    eg: "⪚",
    Egrave: "È",
    egrave: "è",
    egs: "⪖",
    egsdot: "⪘",
    el: "⪙",
    Element: "∈",
    elinters: "⏧",
    ell: "ℓ",
    els: "⪕",
    elsdot: "⪗",
    Emacr: "Ē",
    emacr: "ē",
    empty: "∅",
    emptyset: "∅",
    EmptySmallSquare: "◻",
    emptyv: "∅",
    EmptyVerySmallSquare: "▫",
    emsp: " ",
    emsp13: " ",
    emsp14: " ",
    ENG: "Ŋ",
    eng: "ŋ",
    ensp: " ",
    Eogon: "Ę",
    eogon: "ę",
    Eopf: "𝔼",
    eopf: "𝕖",
    epar: "⋕",
    eparsl: "⧣",
    eplus: "⩱",
    epsi: "ε",
    Epsilon: "Ε",
    epsilon: "ε",
    epsiv: "ϵ",
    eqcirc: "≖",
    eqcolon: "≕",
    eqsim: "≂",
    eqslantgtr: "⪖",
    eqslantless: "⪕",
    Equal: "⩵",
    equals: "=",
    EqualTilde: "≂",
    equest: "≟",
    Equilibrium: "⇌",
    equiv: "≡",
    equivDD: "⩸",
    eqvparsl: "⧥",
    erarr: "⥱",
    erDot: "≓",
    Escr: "ℰ",
    escr: "ℯ",
    esdot: "≐",
    Esim: "⩳",
    esim: "≂",
    Eta: "Η",
    eta: "η",
    ETH: "Ð",
    eth: "ð",
    Euml: "Ë",
    euml: "ë",
    euro: "€",
    excl: "!",
    exist: "∃",
    Exists: "∃",
    expectation: "ℰ",
    ExponentialE: "ⅇ",
    exponentiale: "ⅇ",
    fallingdotseq: "≒",
    Fcy: "Ф",
    fcy: "ф",
    female: "♀",
    ffilig: "ﬃ",
    fflig: "ﬀ",
    ffllig: "ﬄ",
    Ffr: "𝔉",
    ffr: "𝔣",
    filig: "ﬁ",
    FilledSmallSquare: "◼",
    FilledVerySmallSquare: "▪",
    fjlig: "fj",
    flat: "♭",
    fllig: "ﬂ",
    fltns: "▱",
    fnof: "ƒ",
    Fopf: "𝔽",
    fopf: "𝕗",
    ForAll: "∀",
    forall: "∀",
    fork: "⋔",
    forkv: "⫙",
    Fouriertrf: "ℱ",
    fpartint: "⨍",
    frac12: "½",
    frac13: "⅓",
    frac14: "¼",
    frac15: "⅕",
    frac16: "⅙",
    frac18: "⅛",
    frac23: "⅔",
    frac25: "⅖",
    frac34: "¾",
    frac35: "⅗",
    frac38: "⅜",
    frac45: "⅘",
    frac56: "⅚",
    frac58: "⅝",
    frac78: "⅞",
    frasl: "⁄",
    frown: "⌢",
    Fscr: "ℱ",
    fscr: "𝒻",
    gacute: "ǵ",
    Gamma: "Γ",
    gamma: "γ",
    Gammad: "Ϝ",
    gammad: "ϝ",
    gap: "⪆",
    Gbreve: "Ğ",
    gbreve: "ğ",
    Gcedil: "Ģ",
    Gcirc: "Ĝ",
    gcirc: "ĝ",
    Gcy: "Г",
    gcy: "г",
    Gdot: "Ġ",
    gdot: "ġ",
    gE: "≧",
    ge: "≥",
    gEl: "⪌",
    gel: "⋛",
    geq: "≥",
    geqq: "≧",
    geqslant: "⩾",
    ges: "⩾",
    gescc: "⪩",
    gesdot: "⪀",
    gesdoto: "⪂",
    gesdotol: "⪄",
    gesl: "⋛︀",
    gesles: "⪔",
    Gfr: "𝔊",
    gfr: "𝔤",
    Gg: "⋙",
    gg: "≫",
    ggg: "⋙",
    gimel: "ℷ",
    GJcy: "Ѓ",
    gjcy: "ѓ",
    gl: "≷",
    gla: "⪥",
    glE: "⪒",
    glj: "⪤",
    gnap: "⪊",
    gnapprox: "⪊",
    gnE: "≩",
    gne: "⪈",
    gneq: "⪈",
    gneqq: "≩",
    gnsim: "⋧",
    Gopf: "𝔾",
    gopf: "𝕘",
    grave: "`",
    GreaterEqual: "≥",
    GreaterEqualLess: "⋛",
    GreaterFullEqual: "≧",
    GreaterGreater: "⪢",
    GreaterLess: "≷",
    GreaterSlantEqual: "⩾",
    GreaterTilde: "≳",
    Gscr: "𝒢",
    gscr: "ℊ",
    gsim: "≳",
    gsime: "⪎",
    gsiml: "⪐",
    Gt: "≫",
    GT: ">",
    gt: ">",
    gtcc: "⪧",
    gtcir: "⩺",
    gtdot: "⋗",
    gtlPar: "⦕",
    gtquest: "⩼",
    gtrapprox: "⪆",
    gtrarr: "⥸",
    gtrdot: "⋗",
    gtreqless: "⋛",
    gtreqqless: "⪌",
    gtrless: "≷",
    gtrsim: "≳",
    gvertneqq: "≩︀",
    gvnE: "≩︀",
    Hacek: "ˇ",
    hairsp: " ",
    half: "½",
    hamilt: "ℋ",
    HARDcy: "Ъ",
    hardcy: "ъ",
    hArr: "⇔",
    harr: "↔",
    harrcir: "⥈",
    harrw: "↭",
    Hat: "^",
    hbar: "ℏ",
    Hcirc: "Ĥ",
    hcirc: "ĥ",
    hearts: "♥",
    heartsuit: "♥",
    hellip: "…",
    hercon: "⊹",
    Hfr: "ℌ",
    hfr: "𝔥",
    HilbertSpace: "ℋ",
    hksearow: "⤥",
    hkswarow: "⤦",
    hoarr: "⇿",
    homtht: "∻",
    hookleftarrow: "↩",
    hookrightarrow: "↪",
    Hopf: "ℍ",
    hopf: "𝕙",
    horbar: "―",
    HorizontalLine: "─",
    Hscr: "ℋ",
    hscr: "𝒽",
    hslash: "ℏ",
    Hstrok: "Ħ",
    hstrok: "ħ",
    HumpDownHump: "≎",
    HumpEqual: "≏",
    hybull: "⁃",
    hyphen: "‐",
    Iacute: "Í",
    iacute: "í",
    ic: "⁣",
    Icirc: "Î",
    icirc: "î",
    Icy: "И",
    icy: "и",
    Idot: "İ",
    IEcy: "Е",
    iecy: "е",
    iexcl: "¡",
    iff: "⇔",
    Ifr: "ℑ",
    ifr: "𝔦",
    Igrave: "Ì",
    igrave: "ì",
    ii: "ⅈ",
    iiiint: "⨌",
    iiint: "∭",
    iinfin: "⧜",
    iiota: "℩",
    IJlig: "Ĳ",
    ijlig: "ĳ",
    Im: "ℑ",
    Imacr: "Ī",
    imacr: "ī",
    image: "ℑ",
    ImaginaryI: "ⅈ",
    imagline: "ℐ",
    imagpart: "ℑ",
    imath: "ı",
    imof: "⊷",
    imped: "Ƶ",
    Implies: "⇒",
    in: "∈",
    incare: "℅",
    infin: "∞",
    infintie: "⧝",
    inodot: "ı",
    Int: "∬",
    int: "∫",
    intcal: "⊺",
    integers: "ℤ",
    Integral: "∫",
    intercal: "⊺",
    Intersection: "⋂",
    intlarhk: "⨗",
    intprod: "⨼",
    InvisibleComma: "⁣",
    InvisibleTimes: "⁢",
    IOcy: "Ё",
    iocy: "ё",
    Iogon: "Į",
    iogon: "į",
    Iopf: "𝕀",
    iopf: "𝕚",
    Iota: "Ι",
    iota: "ι",
    iprod: "⨼",
    iquest: "¿",
    Iscr: "ℐ",
    iscr: "𝒾",
    isin: "∈",
    isindot: "⋵",
    isinE: "⋹",
    isins: "⋴",
    isinsv: "⋳",
    isinv: "∈",
    it: "⁢",
    Itilde: "Ĩ",
    itilde: "ĩ",
    Iukcy: "І",
    iukcy: "і",
    Iuml: "Ï",
    iuml: "ï",
    Jcirc: "Ĵ",
    jcirc: "ĵ",
    Jcy: "Й",
    jcy: "й",
    Jfr: "𝔍",
    jfr: "𝔧",
    jmath: "ȷ",
    Jopf: "𝕁",
    jopf: "𝕛",
    Jscr: "𝒥",
    jscr: "𝒿",
    Jsercy: "Ј",
    jsercy: "ј",
    Jukcy: "Є",
    jukcy: "є",
    Kappa: "Κ",
    kappa: "κ",
    kappav: "ϰ",
    Kcedil: "Ķ",
    kcedil: "ķ",
    Kcy: "К",
    kcy: "к",
    Kfr: "𝔎",
    kfr: "𝔨",
    kgreen: "ĸ",
    KHcy: "Х",
    khcy: "х",
    KJcy: "Ќ",
    kjcy: "ќ",
    Kopf: "𝕂",
    kopf: "𝕜",
    Kscr: "𝒦",
    kscr: "𝓀",
    lAarr: "⇚",
    Lacute: "Ĺ",
    lacute: "ĺ",
    laemptyv: "⦴",
    lagran: "ℒ",
    Lambda: "Λ",
    lambda: "λ",
    Lang: "⟪",
    lang: "⟨",
    langd: "⦑",
    langle: "⟨",
    lap: "⪅",
    Laplacetrf: "ℒ",
    laquo: "«",
    Larr: "↞",
    lArr: "⇐",
    larr: "←",
    larrb: "⇤",
    larrbfs: "⤟",
    larrfs: "⤝",
    larrhk: "↩",
    larrlp: "↫",
    larrpl: "⤹",
    larrsim: "⥳",
    larrtl: "↢",
    lat: "⪫",
    lAtail: "⤛",
    latail: "⤙",
    late: "⪭",
    lates: "⪭︀",
    lBarr: "⤎",
    lbarr: "⤌",
    lbbrk: "❲",
    lbrace: "{",
    lbrack: "[",
    lbrke: "⦋",
    lbrksld: "⦏",
    lbrkslu: "⦍",
    Lcaron: "Ľ",
    lcaron: "ľ",
    Lcedil: "Ļ",
    lcedil: "ļ",
    lceil: "⌈",
    lcub: "{",
    Lcy: "Л",
    lcy: "л",
    ldca: "⤶",
    ldquo: "“",
    ldquor: "„",
    ldrdhar: "⥧",
    ldrushar: "⥋",
    ldsh: "↲",
    lE: "≦",
    le: "≤",
    LeftAngleBracket: "⟨",
    LeftArrow: "←",
    Leftarrow: "⇐",
    leftarrow: "←",
    LeftArrowBar: "⇤",
    LeftArrowRightArrow: "⇆",
    leftarrowtail: "↢",
    LeftCeiling: "⌈",
    LeftDoubleBracket: "⟦",
    LeftDownTeeVector: "⥡",
    LeftDownVector: "⇃",
    LeftDownVectorBar: "⥙",
    LeftFloor: "⌊",
    leftharpoondown: "↽",
    leftharpoonup: "↼",
    leftleftarrows: "⇇",
    LeftRightArrow: "↔",
    Leftrightarrow: "⇔",
    leftrightarrow: "↔",
    leftrightarrows: "⇆",
    leftrightharpoons: "⇋",
    leftrightsquigarrow: "↭",
    LeftRightVector: "⥎",
    LeftTee: "⊣",
    LeftTeeArrow: "↤",
    LeftTeeVector: "⥚",
    leftthreetimes: "⋋",
    LeftTriangle: "⊲",
    LeftTriangleBar: "⧏",
    LeftTriangleEqual: "⊴",
    LeftUpDownVector: "⥑",
    LeftUpTeeVector: "⥠",
    LeftUpVector: "↿",
    LeftUpVectorBar: "⥘",
    LeftVector: "↼",
    LeftVectorBar: "⥒",
    lEg: "⪋",
    leg: "⋚",
    leq: "≤",
    leqq: "≦",
    leqslant: "⩽",
    les: "⩽",
    lescc: "⪨",
    lesdot: "⩿",
    lesdoto: "⪁",
    lesdotor: "⪃",
    lesg: "⋚︀",
    lesges: "⪓",
    lessapprox: "⪅",
    lessdot: "⋖",
    lesseqgtr: "⋚",
    lesseqqgtr: "⪋",
    LessEqualGreater: "⋚",
    LessFullEqual: "≦",
    LessGreater: "≶",
    lessgtr: "≶",
    LessLess: "⪡",
    lesssim: "≲",
    LessSlantEqual: "⩽",
    LessTilde: "≲",
    lfisht: "⥼",
    lfloor: "⌊",
    Lfr: "𝔏",
    lfr: "𝔩",
    lg: "≶",
    lgE: "⪑",
    lHar: "⥢",
    lhard: "↽",
    lharu: "↼",
    lharul: "⥪",
    lhblk: "▄",
    LJcy: "Љ",
    ljcy: "љ",
    Ll: "⋘",
    ll: "≪",
    llarr: "⇇",
    llcorner: "⌞",
    Lleftarrow: "⇚",
    llhard: "⥫",
    lltri: "◺",
    Lmidot: "Ŀ",
    lmidot: "ŀ",
    lmoust: "⎰",
    lmoustache: "⎰",
    lnap: "⪉",
    lnapprox: "⪉",
    lnE: "≨",
    lne: "⪇",
    lneq: "⪇",
    lneqq: "≨",
    lnsim: "⋦",
    loang: "⟬",
    loarr: "⇽",
    lobrk: "⟦",
    LongLeftArrow: "⟵",
    Longleftarrow: "⟸",
    longleftarrow: "⟵",
    LongLeftRightArrow: "⟷",
    Longleftrightarrow: "⟺",
    longleftrightarrow: "⟷",
    longmapsto: "⟼",
    LongRightArrow: "⟶",
    Longrightarrow: "⟹",
    longrightarrow: "⟶",
    looparrowleft: "↫",
    looparrowright: "↬",
    lopar: "⦅",
    Lopf: "𝕃",
    lopf: "𝕝",
    loplus: "⨭",
    lotimes: "⨴",
    lowast: "∗",
    lowbar: "_",
    LowerLeftArrow: "↙",
    LowerRightArrow: "↘",
    loz: "◊",
    lozenge: "◊",
    lozf: "⧫",
    lpar: "(",
    lparlt: "⦓",
    lrarr: "⇆",
    lrcorner: "⌟",
    lrhar: "⇋",
    lrhard: "⥭",
    lrm: "‎",
    lrtri: "⊿",
    lsaquo: "‹",
    Lscr: "ℒ",
    lscr: "𝓁",
    Lsh: "↰",
    lsh: "↰",
    lsim: "≲",
    lsime: "⪍",
    lsimg: "⪏",
    lsqb: "[",
    lsquo: "‘",
    lsquor: "‚",
    Lstrok: "Ł",
    lstrok: "ł",
    Lt: "≪",
    LT: "<",
    lt: "<",
    ltcc: "⪦",
    ltcir: "⩹",
    ltdot: "⋖",
    lthree: "⋋",
    ltimes: "⋉",
    ltlarr: "⥶",
    ltquest: "⩻",
    ltri: "◃",
    ltrie: "⊴",
    ltrif: "◂",
    ltrPar: "⦖",
    lurdshar: "⥊",
    luruhar: "⥦",
    lvertneqq: "≨︀",
    lvnE: "≨︀",
    macr: "¯",
    male: "♂",
    malt: "✠",
    maltese: "✠",
    Map: "⤅",
    map: "↦",
    mapsto: "↦",
    mapstodown: "↧",
    mapstoleft: "↤",
    mapstoup: "↥",
    marker: "▮",
    mcomma: "⨩",
    Mcy: "М",
    mcy: "м",
    mdash: "—",
    mDDot: "∺",
    measuredangle: "∡",
    MediumSpace: " ",
    Mellintrf: "ℳ",
    Mfr: "𝔐",
    mfr: "𝔪",
    mho: "℧",
    micro: "µ",
    mid: "∣",
    midast: "*",
    midcir: "⫰",
    middot: "·",
    minus: "−",
    minusb: "⊟",
    minusd: "∸",
    minusdu: "⨪",
    MinusPlus: "∓",
    mlcp: "⫛",
    mldr: "…",
    mnplus: "∓",
    models: "⊧",
    Mopf: "𝕄",
    mopf: "𝕞",
    mp: "∓",
    Mscr: "ℳ",
    mscr: "𝓂",
    mstpos: "∾",
    Mu: "Μ",
    mu: "μ",
    multimap: "⊸",
    mumap: "⊸",
    nabla: "∇",
    Nacute: "Ń",
    nacute: "ń",
    nang: "∠⃒",
    nap: "≉",
    napE: "⩰̸",
    napid: "≋̸",
    napos: "ŉ",
    napprox: "≉",
    natur: "♮",
    natural: "♮",
    naturals: "ℕ",
    nbsp: " ",
    nbump: "≎̸",
    nbumpe: "≏̸",
    ncap: "⩃",
    Ncaron: "Ň",
    ncaron: "ň",
    Ncedil: "Ņ",
    ncedil: "ņ",
    ncong: "≇",
    ncongdot: "⩭̸",
    ncup: "⩂",
    Ncy: "Н",
    ncy: "н",
    ndash: "–",
    ne: "≠",
    nearhk: "⤤",
    neArr: "⇗",
    nearr: "↗",
    nearrow: "↗",
    nedot: "≐̸",
    NegativeMediumSpace: "​",
    NegativeThickSpace: "​",
    NegativeThinSpace: "​",
    NegativeVeryThinSpace: "​",
    nequiv: "≢",
    nesear: "⤨",
    nesim: "≂̸",
    NestedGreaterGreater: "≫",
    NestedLessLess: "≪",
    NewLine: `
`,
    nexist: "∄",
    nexists: "∄",
    Nfr: "𝔑",
    nfr: "𝔫",
    ngE: "≧̸",
    nge: "≱",
    ngeq: "≱",
    ngeqq: "≧̸",
    ngeqslant: "⩾̸",
    nges: "⩾̸",
    nGg: "⋙̸",
    ngsim: "≵",
    nGt: "≫⃒",
    ngt: "≯",
    ngtr: "≯",
    nGtv: "≫̸",
    nhArr: "⇎",
    nharr: "↮",
    nhpar: "⫲",
    ni: "∋",
    nis: "⋼",
    nisd: "⋺",
    niv: "∋",
    NJcy: "Њ",
    njcy: "њ",
    nlArr: "⇍",
    nlarr: "↚",
    nldr: "‥",
    nlE: "≦̸",
    nle: "≰",
    nLeftarrow: "⇍",
    nleftarrow: "↚",
    nLeftrightarrow: "⇎",
    nleftrightarrow: "↮",
    nleq: "≰",
    nleqq: "≦̸",
    nleqslant: "⩽̸",
    nles: "⩽̸",
    nless: "≮",
    nLl: "⋘̸",
    nlsim: "≴",
    nLt: "≪⃒",
    nlt: "≮",
    nltri: "⋪",
    nltrie: "⋬",
    nLtv: "≪̸",
    nmid: "∤",
    NoBreak: "⁠",
    NonBreakingSpace: " ",
    Nopf: "ℕ",
    nopf: "𝕟",
    Not: "⫬",
    not: "¬",
    NotCongruent: "≢",
    NotCupCap: "≭",
    NotDoubleVerticalBar: "∦",
    NotElement: "∉",
    NotEqual: "≠",
    NotEqualTilde: "≂̸",
    NotExists: "∄",
    NotGreater: "≯",
    NotGreaterEqual: "≱",
    NotGreaterFullEqual: "≧̸",
    NotGreaterGreater: "≫̸",
    NotGreaterLess: "≹",
    NotGreaterSlantEqual: "⩾̸",
    NotGreaterTilde: "≵",
    NotHumpDownHump: "≎̸",
    NotHumpEqual: "≏̸",
    notin: "∉",
    notindot: "⋵̸",
    notinE: "⋹̸",
    notinva: "∉",
    notinvb: "⋷",
    notinvc: "⋶",
    NotLeftTriangle: "⋪",
    NotLeftTriangleBar: "⧏̸",
    NotLeftTriangleEqual: "⋬",
    NotLess: "≮",
    NotLessEqual: "≰",
    NotLessGreater: "≸",
    NotLessLess: "≪̸",
    NotLessSlantEqual: "⩽̸",
    NotLessTilde: "≴",
    NotNestedGreaterGreater: "⪢̸",
    NotNestedLessLess: "⪡̸",
    notni: "∌",
    notniva: "∌",
    notnivb: "⋾",
    notnivc: "⋽",
    NotPrecedes: "⊀",
    NotPrecedesEqual: "⪯̸",
    NotPrecedesSlantEqual: "⋠",
    NotReverseElement: "∌",
    NotRightTriangle: "⋫",
    NotRightTriangleBar: "⧐̸",
    NotRightTriangleEqual: "⋭",
    NotSquareSubset: "⊏̸",
    NotSquareSubsetEqual: "⋢",
    NotSquareSuperset: "⊐̸",
    NotSquareSupersetEqual: "⋣",
    NotSubset: "⊂⃒",
    NotSubsetEqual: "⊈",
    NotSucceeds: "⊁",
    NotSucceedsEqual: "⪰̸",
    NotSucceedsSlantEqual: "⋡",
    NotSucceedsTilde: "≿̸",
    NotSuperset: "⊃⃒",
    NotSupersetEqual: "⊉",
    NotTilde: "≁",
    NotTildeEqual: "≄",
    NotTildeFullEqual: "≇",
    NotTildeTilde: "≉",
    NotVerticalBar: "∤",
    npar: "∦",
    nparallel: "∦",
    nparsl: "⫽⃥",
    npart: "∂̸",
    npolint: "⨔",
    npr: "⊀",
    nprcue: "⋠",
    npre: "⪯̸",
    nprec: "⊀",
    npreceq: "⪯̸",
    nrArr: "⇏",
    nrarr: "↛",
    nrarrc: "⤳̸",
    nrarrw: "↝̸",
    nRightarrow: "⇏",
    nrightarrow: "↛",
    nrtri: "⋫",
    nrtrie: "⋭",
    nsc: "⊁",
    nsccue: "⋡",
    nsce: "⪰̸",
    Nscr: "𝒩",
    nscr: "𝓃",
    nshortmid: "∤",
    nshortparallel: "∦",
    nsim: "≁",
    nsime: "≄",
    nsimeq: "≄",
    nsmid: "∤",
    nspar: "∦",
    nsqsube: "⋢",
    nsqsupe: "⋣",
    nsub: "⊄",
    nsubE: "⫅̸",
    nsube: "⊈",
    nsubset: "⊂⃒",
    nsubseteq: "⊈",
    nsubseteqq: "⫅̸",
    nsucc: "⊁",
    nsucceq: "⪰̸",
    nsup: "⊅",
    nsupE: "⫆̸",
    nsupe: "⊉",
    nsupset: "⊃⃒",
    nsupseteq: "⊉",
    nsupseteqq: "⫆̸",
    ntgl: "≹",
    Ntilde: "Ñ",
    ntilde: "ñ",
    ntlg: "≸",
    ntriangleleft: "⋪",
    ntrianglelefteq: "⋬",
    ntriangleright: "⋫",
    ntrianglerighteq: "⋭",
    Nu: "Ν",
    nu: "ν",
    num: "#",
    numero: "№",
    numsp: " ",
    nvap: "≍⃒",
    nVDash: "⊯",
    nVdash: "⊮",
    nvDash: "⊭",
    nvdash: "⊬",
    nvge: "≥⃒",
    nvgt: ">⃒",
    nvHarr: "⤄",
    nvinfin: "⧞",
    nvlArr: "⤂",
    nvle: "≤⃒",
    nvlt: "<⃒",
    nvltrie: "⊴⃒",
    nvrArr: "⤃",
    nvrtrie: "⊵⃒",
    nvsim: "∼⃒",
    nwarhk: "⤣",
    nwArr: "⇖",
    nwarr: "↖",
    nwarrow: "↖",
    nwnear: "⤧",
    Oacute: "Ó",
    oacute: "ó",
    oast: "⊛",
    ocir: "⊚",
    Ocirc: "Ô",
    ocirc: "ô",
    Ocy: "О",
    ocy: "о",
    odash: "⊝",
    Odblac: "Ő",
    odblac: "ő",
    odiv: "⨸",
    odot: "⊙",
    odsold: "⦼",
    OElig: "Œ",
    oelig: "œ",
    ofcir: "⦿",
    Ofr: "𝔒",
    ofr: "𝔬",
    ogon: "˛",
    Ograve: "Ò",
    ograve: "ò",
    ogt: "⧁",
    ohbar: "⦵",
    ohm: "Ω",
    oint: "∮",
    olarr: "↺",
    olcir: "⦾",
    olcross: "⦻",
    oline: "‾",
    olt: "⧀",
    Omacr: "Ō",
    omacr: "ō",
    Omega: "Ω",
    omega: "ω",
    Omicron: "Ο",
    omicron: "ο",
    omid: "⦶",
    ominus: "⊖",
    Oopf: "𝕆",
    oopf: "𝕠",
    opar: "⦷",
    OpenCurlyDoubleQuote: "“",
    OpenCurlyQuote: "‘",
    operp: "⦹",
    oplus: "⊕",
    Or: "⩔",
    or: "∨",
    orarr: "↻",
    ord: "⩝",
    order: "ℴ",
    orderof: "ℴ",
    ordf: "ª",
    ordm: "º",
    origof: "⊶",
    oror: "⩖",
    orslope: "⩗",
    orv: "⩛",
    oS: "Ⓢ",
    Oscr: "𝒪",
    oscr: "ℴ",
    Oslash: "Ø",
    oslash: "ø",
    osol: "⊘",
    Otilde: "Õ",
    otilde: "õ",
    Otimes: "⨷",
    otimes: "⊗",
    otimesas: "⨶",
    Ouml: "Ö",
    ouml: "ö",
    ovbar: "⌽",
    OverBar: "‾",
    OverBrace: "⏞",
    OverBracket: "⎴",
    OverParenthesis: "⏜",
    par: "∥",
    para: "¶",
    parallel: "∥",
    parsim: "⫳",
    parsl: "⫽",
    part: "∂",
    PartialD: "∂",
    Pcy: "П",
    pcy: "п",
    percnt: "%",
    period: ".",
    permil: "‰",
    perp: "⊥",
    pertenk: "‱",
    Pfr: "𝔓",
    pfr: "𝔭",
    Phi: "Φ",
    phi: "φ",
    phiv: "ϕ",
    phmmat: "ℳ",
    phone: "☎",
    Pi: "Π",
    pi: "π",
    pitchfork: "⋔",
    piv: "ϖ",
    planck: "ℏ",
    planckh: "ℎ",
    plankv: "ℏ",
    plus: "+",
    plusacir: "⨣",
    plusb: "⊞",
    pluscir: "⨢",
    plusdo: "∔",
    plusdu: "⨥",
    pluse: "⩲",
    PlusMinus: "±",
    plusmn: "±",
    plussim: "⨦",
    plustwo: "⨧",
    pm: "±",
    Poincareplane: "ℌ",
    pointint: "⨕",
    Popf: "ℙ",
    popf: "𝕡",
    pound: "£",
    Pr: "⪻",
    pr: "≺",
    prap: "⪷",
    prcue: "≼",
    prE: "⪳",
    pre: "⪯",
    prec: "≺",
    precapprox: "⪷",
    preccurlyeq: "≼",
    Precedes: "≺",
    PrecedesEqual: "⪯",
    PrecedesSlantEqual: "≼",
    PrecedesTilde: "≾",
    preceq: "⪯",
    precnapprox: "⪹",
    precneqq: "⪵",
    precnsim: "⋨",
    precsim: "≾",
    Prime: "″",
    prime: "′",
    primes: "ℙ",
    prnap: "⪹",
    prnE: "⪵",
    prnsim: "⋨",
    prod: "∏",
    Product: "∏",
    profalar: "⌮",
    profline: "⌒",
    profsurf: "⌓",
    prop: "∝",
    Proportion: "∷",
    Proportional: "∝",
    propto: "∝",
    prsim: "≾",
    prurel: "⊰",
    Pscr: "𝒫",
    pscr: "𝓅",
    Psi: "Ψ",
    psi: "ψ",
    puncsp: " ",
    Qfr: "𝔔",
    qfr: "𝔮",
    qint: "⨌",
    Qopf: "ℚ",
    qopf: "𝕢",
    qprime: "⁗",
    Qscr: "𝒬",
    qscr: "𝓆",
    quaternions: "ℍ",
    quatint: "⨖",
    quest: "?",
    questeq: "≟",
    QUOT: '"',
    quot: '"',
    rAarr: "⇛",
    race: "∽̱",
    Racute: "Ŕ",
    racute: "ŕ",
    radic: "√",
    raemptyv: "⦳",
    Rang: "⟫",
    rang: "⟩",
    rangd: "⦒",
    range: "⦥",
    rangle: "⟩",
    raquo: "»",
    Rarr: "↠",
    rArr: "⇒",
    rarr: "→",
    rarrap: "⥵",
    rarrb: "⇥",
    rarrbfs: "⤠",
    rarrc: "⤳",
    rarrfs: "⤞",
    rarrhk: "↪",
    rarrlp: "↬",
    rarrpl: "⥅",
    rarrsim: "⥴",
    Rarrtl: "⤖",
    rarrtl: "↣",
    rarrw: "↝",
    rAtail: "⤜",
    ratail: "⤚",
    ratio: "∶",
    rationals: "ℚ",
    RBarr: "⤐",
    rBarr: "⤏",
    rbarr: "⤍",
    rbbrk: "❳",
    rbrace: "}",
    rbrack: "]",
    rbrke: "⦌",
    rbrksld: "⦎",
    rbrkslu: "⦐",
    Rcaron: "Ř",
    rcaron: "ř",
    Rcedil: "Ŗ",
    rcedil: "ŗ",
    rceil: "⌉",
    rcub: "}",
    Rcy: "Р",
    rcy: "р",
    rdca: "⤷",
    rdldhar: "⥩",
    rdquo: "”",
    rdquor: "”",
    rdsh: "↳",
    Re: "ℜ",
    real: "ℜ",
    realine: "ℛ",
    realpart: "ℜ",
    reals: "ℝ",
    rect: "▭",
    REG: "®",
    reg: "®",
    ReverseElement: "∋",
    ReverseEquilibrium: "⇋",
    ReverseUpEquilibrium: "⥯",
    rfisht: "⥽",
    rfloor: "⌋",
    Rfr: "ℜ",
    rfr: "𝔯",
    rHar: "⥤",
    rhard: "⇁",
    rharu: "⇀",
    rharul: "⥬",
    Rho: "Ρ",
    rho: "ρ",
    rhov: "ϱ",
    RightAngleBracket: "⟩",
    RightArrow: "→",
    Rightarrow: "⇒",
    rightarrow: "→",
    RightArrowBar: "⇥",
    RightArrowLeftArrow: "⇄",
    rightarrowtail: "↣",
    RightCeiling: "⌉",
    RightDoubleBracket: "⟧",
    RightDownTeeVector: "⥝",
    RightDownVector: "⇂",
    RightDownVectorBar: "⥕",
    RightFloor: "⌋",
    rightharpoondown: "⇁",
    rightharpoonup: "⇀",
    rightleftarrows: "⇄",
    rightleftharpoons: "⇌",
    rightrightarrows: "⇉",
    rightsquigarrow: "↝",
    RightTee: "⊢",
    RightTeeArrow: "↦",
    RightTeeVector: "⥛",
    rightthreetimes: "⋌",
    RightTriangle: "⊳",
    RightTriangleBar: "⧐",
    RightTriangleEqual: "⊵",
    RightUpDownVector: "⥏",
    RightUpTeeVector: "⥜",
    RightUpVector: "↾",
    RightUpVectorBar: "⥔",
    RightVector: "⇀",
    RightVectorBar: "⥓",
    ring: "˚",
    risingdotseq: "≓",
    rlarr: "⇄",
    rlhar: "⇌",
    rlm: "‏",
    rmoust: "⎱",
    rmoustache: "⎱",
    rnmid: "⫮",
    roang: "⟭",
    roarr: "⇾",
    robrk: "⟧",
    ropar: "⦆",
    Ropf: "ℝ",
    ropf: "𝕣",
    roplus: "⨮",
    rotimes: "⨵",
    RoundImplies: "⥰",
    rpar: ")",
    rpargt: "⦔",
    rppolint: "⨒",
    rrarr: "⇉",
    Rrightarrow: "⇛",
    rsaquo: "›",
    Rscr: "ℛ",
    rscr: "𝓇",
    Rsh: "↱",
    rsh: "↱",
    rsqb: "]",
    rsquo: "’",
    rsquor: "’",
    rthree: "⋌",
    rtimes: "⋊",
    rtri: "▹",
    rtrie: "⊵",
    rtrif: "▸",
    rtriltri: "⧎",
    RuleDelayed: "⧴",
    ruluhar: "⥨",
    rx: "℞",
    Sacute: "Ś",
    sacute: "ś",
    sbquo: "‚",
    Sc: "⪼",
    sc: "≻",
    scap: "⪸",
    Scaron: "Š",
    scaron: "š",
    sccue: "≽",
    scE: "⪴",
    sce: "⪰",
    Scedil: "Ş",
    scedil: "ş",
    Scirc: "Ŝ",
    scirc: "ŝ",
    scnap: "⪺",
    scnE: "⪶",
    scnsim: "⋩",
    scpolint: "⨓",
    scsim: "≿",
    Scy: "С",
    scy: "с",
    sdot: "⋅",
    sdotb: "⊡",
    sdote: "⩦",
    searhk: "⤥",
    seArr: "⇘",
    searr: "↘",
    searrow: "↘",
    sect: "§",
    semi: ";",
    seswar: "⤩",
    setminus: "∖",
    setmn: "∖",
    sext: "✶",
    Sfr: "𝔖",
    sfr: "𝔰",
    sfrown: "⌢",
    sharp: "♯",
    SHCHcy: "Щ",
    shchcy: "щ",
    SHcy: "Ш",
    shcy: "ш",
    ShortDownArrow: "↓",
    ShortLeftArrow: "←",
    shortmid: "∣",
    shortparallel: "∥",
    ShortRightArrow: "→",
    ShortUpArrow: "↑",
    shy: "­",
    Sigma: "Σ",
    sigma: "σ",
    sigmaf: "ς",
    sigmav: "ς",
    sim: "∼",
    simdot: "⩪",
    sime: "≃",
    simeq: "≃",
    simg: "⪞",
    simgE: "⪠",
    siml: "⪝",
    simlE: "⪟",
    simne: "≆",
    simplus: "⨤",
    simrarr: "⥲",
    slarr: "←",
    SmallCircle: "∘",
    smallsetminus: "∖",
    smashp: "⨳",
    smeparsl: "⧤",
    smid: "∣",
    smile: "⌣",
    smt: "⪪",
    smte: "⪬",
    smtes: "⪬︀",
    SOFTcy: "Ь",
    softcy: "ь",
    sol: "/",
    solb: "⧄",
    solbar: "⌿",
    Sopf: "𝕊",
    sopf: "𝕤",
    spades: "♠",
    spadesuit: "♠",
    spar: "∥",
    sqcap: "⊓",
    sqcaps: "⊓︀",
    sqcup: "⊔",
    sqcups: "⊔︀",
    Sqrt: "√",
    sqsub: "⊏",
    sqsube: "⊑",
    sqsubset: "⊏",
    sqsubseteq: "⊑",
    sqsup: "⊐",
    sqsupe: "⊒",
    sqsupset: "⊐",
    sqsupseteq: "⊒",
    squ: "□",
    Square: "□",
    square: "□",
    SquareIntersection: "⊓",
    SquareSubset: "⊏",
    SquareSubsetEqual: "⊑",
    SquareSuperset: "⊐",
    SquareSupersetEqual: "⊒",
    SquareUnion: "⊔",
    squarf: "▪",
    squf: "▪",
    srarr: "→",
    Sscr: "𝒮",
    sscr: "𝓈",
    ssetmn: "∖",
    ssmile: "⌣",
    sstarf: "⋆",
    Star: "⋆",
    star: "☆",
    starf: "★",
    straightepsilon: "ϵ",
    straightphi: "ϕ",
    strns: "¯",
    Sub: "⋐",
    sub: "⊂",
    subdot: "⪽",
    subE: "⫅",
    sube: "⊆",
    subedot: "⫃",
    submult: "⫁",
    subnE: "⫋",
    subne: "⊊",
    subplus: "⪿",
    subrarr: "⥹",
    Subset: "⋐",
    subset: "⊂",
    subseteq: "⊆",
    subseteqq: "⫅",
    SubsetEqual: "⊆",
    subsetneq: "⊊",
    subsetneqq: "⫋",
    subsim: "⫇",
    subsub: "⫕",
    subsup: "⫓",
    succ: "≻",
    succapprox: "⪸",
    succcurlyeq: "≽",
    Succeeds: "≻",
    SucceedsEqual: "⪰",
    SucceedsSlantEqual: "≽",
    SucceedsTilde: "≿",
    succeq: "⪰",
    succnapprox: "⪺",
    succneqq: "⪶",
    succnsim: "⋩",
    succsim: "≿",
    SuchThat: "∋",
    Sum: "∑",
    sum: "∑",
    sung: "♪",
    Sup: "⋑",
    sup: "⊃",
    sup1: "¹",
    sup2: "²",
    sup3: "³",
    supdot: "⪾",
    supdsub: "⫘",
    supE: "⫆",
    supe: "⊇",
    supedot: "⫄",
    Superset: "⊃",
    SupersetEqual: "⊇",
    suphsol: "⟉",
    suphsub: "⫗",
    suplarr: "⥻",
    supmult: "⫂",
    supnE: "⫌",
    supne: "⊋",
    supplus: "⫀",
    Supset: "⋑",
    supset: "⊃",
    supseteq: "⊇",
    supseteqq: "⫆",
    supsetneq: "⊋",
    supsetneqq: "⫌",
    supsim: "⫈",
    supsub: "⫔",
    supsup: "⫖",
    swarhk: "⤦",
    swArr: "⇙",
    swarr: "↙",
    swarrow: "↙",
    swnwar: "⤪",
    szlig: "ß",
    Tab: "	",
    target: "⌖",
    Tau: "Τ",
    tau: "τ",
    tbrk: "⎴",
    Tcaron: "Ť",
    tcaron: "ť",
    Tcedil: "Ţ",
    tcedil: "ţ",
    Tcy: "Т",
    tcy: "т",
    tdot: "⃛",
    telrec: "⌕",
    Tfr: "𝔗",
    tfr: "𝔱",
    there4: "∴",
    Therefore: "∴",
    therefore: "∴",
    Theta: "Θ",
    theta: "θ",
    thetasym: "ϑ",
    thetav: "ϑ",
    thickapprox: "≈",
    thicksim: "∼",
    ThickSpace: "  ",
    thinsp: " ",
    ThinSpace: " ",
    thkap: "≈",
    thksim: "∼",
    THORN: "Þ",
    thorn: "þ",
    Tilde: "∼",
    tilde: "˜",
    TildeEqual: "≃",
    TildeFullEqual: "≅",
    TildeTilde: "≈",
    times: "×",
    timesb: "⊠",
    timesbar: "⨱",
    timesd: "⨰",
    tint: "∭",
    toea: "⤨",
    top: "⊤",
    topbot: "⌶",
    topcir: "⫱",
    Topf: "𝕋",
    topf: "𝕥",
    topfork: "⫚",
    tosa: "⤩",
    tprime: "‴",
    TRADE: "™",
    trade: "™",
    triangle: "▵",
    triangledown: "▿",
    triangleleft: "◃",
    trianglelefteq: "⊴",
    triangleq: "≜",
    triangleright: "▹",
    trianglerighteq: "⊵",
    tridot: "◬",
    trie: "≜",
    triminus: "⨺",
    TripleDot: "⃛",
    triplus: "⨹",
    trisb: "⧍",
    tritime: "⨻",
    trpezium: "⏢",
    Tscr: "𝒯",
    tscr: "𝓉",
    TScy: "Ц",
    tscy: "ц",
    TSHcy: "Ћ",
    tshcy: "ћ",
    Tstrok: "Ŧ",
    tstrok: "ŧ",
    twixt: "≬",
    twoheadleftarrow: "↞",
    twoheadrightarrow: "↠",
    Uacute: "Ú",
    uacute: "ú",
    Uarr: "↟",
    uArr: "⇑",
    uarr: "↑",
    Uarrocir: "⥉",
    Ubrcy: "Ў",
    ubrcy: "ў",
    Ubreve: "Ŭ",
    ubreve: "ŭ",
    Ucirc: "Û",
    ucirc: "û",
    Ucy: "У",
    ucy: "у",
    udarr: "⇅",
    Udblac: "Ű",
    udblac: "ű",
    udhar: "⥮",
    ufisht: "⥾",
    Ufr: "𝔘",
    ufr: "𝔲",
    Ugrave: "Ù",
    ugrave: "ù",
    uHar: "⥣",
    uharl: "↿",
    uharr: "↾",
    uhblk: "▀",
    ulcorn: "⌜",
    ulcorner: "⌜",
    ulcrop: "⌏",
    ultri: "◸",
    Umacr: "Ū",
    umacr: "ū",
    uml: "¨",
    UnderBar: "_",
    UnderBrace: "⏟",
    UnderBracket: "⎵",
    UnderParenthesis: "⏝",
    Union: "⋃",
    UnionPlus: "⊎",
    Uogon: "Ų",
    uogon: "ų",
    Uopf: "𝕌",
    uopf: "𝕦",
    UpArrow: "↑",
    Uparrow: "⇑",
    uparrow: "↑",
    UpArrowBar: "⤒",
    UpArrowDownArrow: "⇅",
    UpDownArrow: "↕",
    Updownarrow: "⇕",
    updownarrow: "↕",
    UpEquilibrium: "⥮",
    upharpoonleft: "↿",
    upharpoonright: "↾",
    uplus: "⊎",
    UpperLeftArrow: "↖",
    UpperRightArrow: "↗",
    Upsi: "ϒ",
    upsi: "υ",
    upsih: "ϒ",
    Upsilon: "Υ",
    upsilon: "υ",
    UpTee: "⊥",
    UpTeeArrow: "↥",
    upuparrows: "⇈",
    urcorn: "⌝",
    urcorner: "⌝",
    urcrop: "⌎",
    Uring: "Ů",
    uring: "ů",
    urtri: "◹",
    Uscr: "𝒰",
    uscr: "𝓊",
    utdot: "⋰",
    Utilde: "Ũ",
    utilde: "ũ",
    utri: "▵",
    utrif: "▴",
    uuarr: "⇈",
    Uuml: "Ü",
    uuml: "ü",
    uwangle: "⦧",
    vangrt: "⦜",
    varepsilon: "ϵ",
    varkappa: "ϰ",
    varnothing: "∅",
    varphi: "ϕ",
    varpi: "ϖ",
    varpropto: "∝",
    vArr: "⇕",
    varr: "↕",
    varrho: "ϱ",
    varsigma: "ς",
    varsubsetneq: "⊊︀",
    varsubsetneqq: "⫋︀",
    varsupsetneq: "⊋︀",
    varsupsetneqq: "⫌︀",
    vartheta: "ϑ",
    vartriangleleft: "⊲",
    vartriangleright: "⊳",
    Vbar: "⫫",
    vBar: "⫨",
    vBarv: "⫩",
    Vcy: "В",
    vcy: "в",
    VDash: "⊫",
    Vdash: "⊩",
    vDash: "⊨",
    vdash: "⊢",
    Vdashl: "⫦",
    Vee: "⋁",
    vee: "∨",
    veebar: "⊻",
    veeeq: "≚",
    vellip: "⋮",
    Verbar: "‖",
    verbar: "|",
    Vert: "‖",
    vert: "|",
    VerticalBar: "∣",
    VerticalLine: "|",
    VerticalSeparator: "❘",
    VerticalTilde: "≀",
    VeryThinSpace: " ",
    Vfr: "𝔙",
    vfr: "𝔳",
    vltri: "⊲",
    vnsub: "⊂⃒",
    vnsup: "⊃⃒",
    Vopf: "𝕍",
    vopf: "𝕧",
    vprop: "∝",
    vrtri: "⊳",
    Vscr: "𝒱",
    vscr: "𝓋",
    vsubnE: "⫋︀",
    vsubne: "⊊︀",
    vsupnE: "⫌︀",
    vsupne: "⊋︀",
    Vvdash: "⊪",
    vzigzag: "⦚",
    Wcirc: "Ŵ",
    wcirc: "ŵ",
    wedbar: "⩟",
    Wedge: "⋀",
    wedge: "∧",
    wedgeq: "≙",
    weierp: "℘",
    Wfr: "𝔚",
    wfr: "𝔴",
    Wopf: "𝕎",
    wopf: "𝕨",
    wp: "℘",
    wr: "≀",
    wreath: "≀",
    Wscr: "𝒲",
    wscr: "𝓌",
    xcap: "⋂",
    xcirc: "◯",
    xcup: "⋃",
    xdtri: "▽",
    Xfr: "𝔛",
    xfr: "𝔵",
    xhArr: "⟺",
    xharr: "⟷",
    Xi: "Ξ",
    xi: "ξ",
    xlArr: "⟸",
    xlarr: "⟵",
    xmap: "⟼",
    xnis: "⋻",
    xodot: "⨀",
    Xopf: "𝕏",
    xopf: "𝕩",
    xoplus: "⨁",
    xotime: "⨂",
    xrArr: "⟹",
    xrarr: "⟶",
    Xscr: "𝒳",
    xscr: "𝓍",
    xsqcup: "⨆",
    xuplus: "⨄",
    xutri: "△",
    xvee: "⋁",
    xwedge: "⋀",
    Yacute: "Ý",
    yacute: "ý",
    YAcy: "Я",
    yacy: "я",
    Ycirc: "Ŷ",
    ycirc: "ŷ",
    Ycy: "Ы",
    ycy: "ы",
    yen: "¥",
    Yfr: "𝔜",
    yfr: "𝔶",
    YIcy: "Ї",
    yicy: "ї",
    Yopf: "𝕐",
    yopf: "𝕪",
    Yscr: "𝒴",
    yscr: "𝓎",
    YUcy: "Ю",
    yucy: "ю",
    Yuml: "Ÿ",
    yuml: "ÿ",
    Zacute: "Ź",
    zacute: "ź",
    Zcaron: "Ž",
    zcaron: "ž",
    Zcy: "З",
    zcy: "з",
    Zdot: "Ż",
    zdot: "ż",
    zeetrf: "ℨ",
    ZeroWidthSpace: "​",
    Zeta: "Ζ",
    zeta: "ζ",
    Zfr: "ℨ",
    zfr: "𝔷",
    ZHcy: "Ж",
    zhcy: "ж",
    zigrarr: "⇝",
    Zopf: "ℤ",
    zopf: "𝕫",
    Zscr: "𝒵",
    zscr: "𝓏",
    zwj: "‍",
    zwnj: "‌"
  }), t.entityMap = t.HTML_ENTITIES;
})(F5);
var Qf = {}, Al = Mi.NAMESPACE, gh = /[A-Z_a-z\xC0-\xD6\xD8-\xF6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/, Bg = new RegExp("[\\-\\.0-9" + gh.source.slice(1, -1) + "\\u00B7\\u0300-\\u036F\\u203F-\\u2040]"), Rg = new RegExp("^" + gh.source + Bg.source + "*(?::" + gh.source + Bg.source + "*)?$"), jo = 0, Hi = 1, ns = 2, Vo = 3, as = 4, is = 5, qo = 6, Ic = 7;
function zs(t, e) {
  this.message = t, this.locator = e, Error.captureStackTrace && Error.captureStackTrace(this, zs);
}
zs.prototype = new Error();
zs.prototype.name = zs.name;
function z5() {
}
z5.prototype = {
  parse: function(t, e, n) {
    var a = this.domBuilder;
    a.startDocument(), U5(e, e = {}), iee(
      t,
      e,
      n,
      a,
      this.errorHandler
    ), a.endDocument();
  }
};
function iee(t, e, n, a, i) {
  function r(J) {
    if (J > 65535) {
      J -= 65536;
      var N = 55296 + (J >> 10), ue = 56320 + (J & 1023);
      return String.fromCharCode(N, ue);
    } else
      return String.fromCharCode(J);
  }
  function s(J) {
    var N = J.slice(1, -1);
    return Object.hasOwnProperty.call(n, N) ? n[N] : N.charAt(0) === "#" ? r(parseInt(N.substr(1).replace("x", "0x"))) : (i.error("entity not found:" + J), J);
  }
  function o(J) {
    if (J > g) {
      var N = t.substring(g, J).replace(/&#?\w+;/g, s);
      m && l(g), a.characters(N, 0, J - g), g = J;
    }
  }
  function l(J, N) {
    for (; J >= u && (N = f.exec(t)); )
      c = N.index, u = c + N[0].length, m.lineNumber++;
    m.columnNumber = J - c + 1;
  }
  for (var c = 0, u = 0, f = /.*(?:\r\n?|\n)|.*$/g, m = a.locator, _ = [{ currentNSMap: e }], T = {}, g = 0; ; ) {
    try {
      var x = t.indexOf("<", g);
      if (x < 0) {
        if (!t.substr(g).match(/^\s*$/)) {
          var S = a.doc, D = S.createTextNode(t.substr(g));
          S.appendChild(D), a.currentElement = D;
        }
        return;
      }
      switch (x > g && o(x), t.charAt(x + 1)) {
        case "/":
          var H = t.indexOf(">", x + 3), L = t.substring(x + 2, H).replace(/[ \t\n\r]+$/g, ""), M = _.pop();
          H < 0 ? (L = t.substring(x + 2).replace(/[\s<].*/, ""), i.error("end tag name: " + L + " is not complete:" + M.tagName), H = x + 1 + L.length) : L.match(/\s</) && (L = L.replace(/[\s<].*/, ""), i.error("end tag name: " + L + " maybe not complete"), H = x + 1 + L.length);
          var E = M.localNSMap, P = M.tagName == L, B = P || M.tagName && M.tagName.toLowerCase() == L.toLowerCase();
          if (B) {
            if (a.endElement(M.uri, M.localName, L), E)
              for (var z in E)
                Object.prototype.hasOwnProperty.call(E, z) && a.endPrefixMapping(z);
            P || i.fatalError("end tag name: " + L + " is not match the current start tagName:" + M.tagName);
          } else
            _.push(M);
          H++;
          break;
        case "?":
          m && l(x), H = cee(t, x, a);
          break;
        case "!":
          m && l(x), H = lee(t, x, a, i);
          break;
        default:
          m && l(x);
          var W = new H5(), V = _[_.length - 1].currentNSMap, H = ree(t, x, W, V, s, i), se = W.length;
          if (!W.closed && oee(t, H, W.tagName, T) && (W.closed = !0, n.nbsp || i.warning("unclosed xml attribute")), m && se) {
            for (var ie = Ng(m, {}), Z = 0; Z < se; Z++) {
              var $ = W[Z];
              l($.offset), $.locator = Ng(m, {});
            }
            a.locator = ie, $g(W, a, V) && _.push(W), a.locator = m;
          } else
            $g(W, a, V) && _.push(W);
          Al.isHTML(W.uri) && !W.closed ? H = see(t, H, W.tagName, s, a) : H++;
      }
    } catch (J) {
      if (J instanceof zs)
        throw J;
      i.error("element parse error: " + J), H = -1;
    }
    H > g ? g = H : o(Math.max(x, g) + 1);
  }
}
function Ng(t, e) {
  return e.lineNumber = t.lineNumber, e.columnNumber = t.columnNumber, e;
}
function ree(t, e, n, a, i, r) {
  function s(m, _, T) {
    n.attributeNames.hasOwnProperty(m) && r.fatalError("Attribute " + m + " redefined"), n.addValue(
      m,
      // @see https://www.w3.org/TR/xml/#AVNormalize
      // since the xmldom sax parser does not "interpret" DTD the following is not implemented:
      // - recursive replacement of (DTD) entity references
      // - trimming and collapsing multiple spaces into a single one for attributes that are not of type CDATA
      _.replace(/[\t\n\r]/g, " ").replace(/&#?\w+;/g, i),
      T
    );
  }
  for (var o, l, c = ++e, u = jo; ; ) {
    var f = t.charAt(c);
    switch (f) {
      case "=":
        if (u === Hi)
          o = t.slice(e, c), u = Vo;
        else if (u === ns)
          u = Vo;
        else
          throw new Error("attribute equal must after attrName");
        break;
      case "'":
      case '"':
        if (u === Vo || u === Hi)
          if (u === Hi && (r.warning('attribute value must after "="'), o = t.slice(e, c)), e = c + 1, c = t.indexOf(f, e), c > 0)
            l = t.slice(e, c), s(o, l, e - 1), u = is;
          else
            throw new Error("attribute value no end '" + f + "' match");
        else if (u == as)
          l = t.slice(e, c), s(o, l, e), r.warning('attribute "' + o + '" missed start quot(' + f + ")!!"), e = c + 1, u = is;
        else
          throw new Error('attribute value must after "="');
        break;
      case "/":
        switch (u) {
          case jo:
            n.setTagName(t.slice(e, c));
          case is:
          case qo:
          case Ic:
            u = Ic, n.closed = !0;
          case as:
          case Hi:
            break;
          case ns:
            n.closed = !0;
            break;
          default:
            throw new Error("attribute invalid close char('/')");
        }
        break;
      case "":
        return r.error("unexpected end of input"), u == jo && n.setTagName(t.slice(e, c)), c;
      case ">":
        switch (u) {
          case jo:
            n.setTagName(t.slice(e, c));
          case is:
          case qo:
          case Ic:
            break;
          case as:
          case Hi:
            l = t.slice(e, c), l.slice(-1) === "/" && (n.closed = !0, l = l.slice(0, -1));
          case ns:
            u === ns && (l = o), u == as ? (r.warning('attribute "' + l + '" missed quot(")!'), s(o, l, e)) : ((!Al.isHTML(a[""]) || !l.match(/^(?:disabled|checked|selected)$/i)) && r.warning('attribute "' + l + '" missed value!! "' + l + '" instead!!'), s(l, l, e));
            break;
          case Vo:
            throw new Error("attribute value missed!!");
        }
        return c;
      case "":
        f = " ";
      default:
        if (f <= " ")
          switch (u) {
            case jo:
              n.setTagName(t.slice(e, c)), u = qo;
              break;
            case Hi:
              o = t.slice(e, c), u = ns;
              break;
            case as:
              var l = t.slice(e, c);
              r.warning('attribute "' + l + '" missed quot(")!!'), s(o, l, e);
            case is:
              u = qo;
              break;
          }
        else
          switch (u) {
            case ns:
              n.tagName, (!Al.isHTML(a[""]) || !o.match(/^(?:disabled|checked|selected)$/i)) && r.warning('attribute "' + o + '" missed value!! "' + o + '" instead2!!'), s(o, o, e), e = c, u = Hi;
              break;
            case is:
              r.warning('attribute space is required"' + o + '"!!');
            case qo:
              u = Hi, e = c;
              break;
            case Vo:
              u = as, e = c;
              break;
            case Ic:
              throw new Error("elements closed character '/' and '>' must be connected to");
          }
    }
    c++;
  }
}
function $g(t, e, n) {
  for (var a = t.tagName, i = null, f = t.length; f--; ) {
    var r = t[f], s = r.qName, o = r.value, m = s.indexOf(":");
    if (m > 0)
      var l = r.prefix = s.slice(0, m), c = s.slice(m + 1), u = l === "xmlns" && c;
    else
      c = s, l = null, u = s === "xmlns" && "";
    r.localName = c, u !== !1 && (i == null && (i = {}, U5(n, n = {})), n[u] = i[u] = o, r.uri = Al.XMLNS, e.startPrefixMapping(u, o));
  }
  for (var f = t.length; f--; ) {
    r = t[f];
    var l = r.prefix;
    l && (l === "xml" && (r.uri = Al.XML), l !== "xmlns" && (r.uri = n[l || ""]));
  }
  var m = a.indexOf(":");
  m > 0 ? (l = t.prefix = a.slice(0, m), c = t.localName = a.slice(m + 1)) : (l = null, c = t.localName = a);
  var _ = t.uri = n[l || ""];
  if (e.startElement(_, c, a, t), t.closed) {
    if (e.endElement(_, c, a), i)
      for (l in i)
        Object.prototype.hasOwnProperty.call(i, l) && e.endPrefixMapping(l);
  } else
    return t.currentNSMap = n, t.localNSMap = i, !0;
}
function see(t, e, n, a, i) {
  if (/^(?:script|textarea)$/i.test(n)) {
    var r = t.indexOf("</" + n + ">", e), s = t.substring(e + 1, r);
    if (/[&<]/.test(s))
      return /^script$/i.test(n) ? (i.characters(s, 0, s.length), r) : (s = s.replace(/&#?\w+;/g, a), i.characters(s, 0, s.length), r);
  }
  return e + 1;
}
function oee(t, e, n, a) {
  var i = a[n];
  return i == null && (i = t.lastIndexOf("</" + n + ">"), i < e && (i = t.lastIndexOf("</" + n)), a[n] = i), i < e;
}
function U5(t, e) {
  for (var n in t)
    Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
}
function lee(t, e, n, a) {
  var i = t.charAt(e + 2);
  switch (i) {
    case "-":
      if (t.charAt(e + 3) === "-") {
        var r = t.indexOf("-->", e + 4);
        return r > e ? (n.comment(t, e + 4, r - e - 4), r + 3) : (a.error("Unclosed comment"), -1);
      } else
        return -1;
    default:
      if (t.substr(e + 3, 6) == "CDATA[") {
        var r = t.indexOf("]]>", e + 9);
        return n.startCDATA(), n.characters(t, e + 9, r - e - 9), n.endCDATA(), r + 3;
      }
      var s = uee(t, e), o = s.length;
      if (o > 1 && /!doctype/i.test(s[0][0])) {
        var l = s[1][0], c = !1, u = !1;
        o > 3 && (/^public$/i.test(s[2][0]) ? (c = s[3][0], u = o > 4 && s[4][0]) : /^system$/i.test(s[2][0]) && (u = s[3][0]));
        var f = s[o - 1];
        return n.startDTD(l, c, u), n.endDTD(), f.index + f[0].length;
      }
  }
  return -1;
}
function cee(t, e, n) {
  var a = t.indexOf("?>", e);
  if (a) {
    var i = t.substring(e, a).match(/^<\?(\S*)\s*([\s\S]*?)\s*$/);
    return i ? (i[0].length, n.processingInstruction(i[1], i[2]), a + 2) : -1;
  }
  return -1;
}
function H5() {
  this.attributeNames = {};
}
H5.prototype = {
  setTagName: function(t) {
    if (!Rg.test(t))
      throw new Error("invalid tagName:" + t);
    this.tagName = t;
  },
  addValue: function(t, e, n) {
    if (!Rg.test(t))
      throw new Error("invalid attribute:" + t);
    this.attributeNames[t] = this.length, this[this.length++] = { qName: t, value: e, offset: n };
  },
  length: 0,
  getLocalName: function(t) {
    return this[t].localName;
  },
  getLocator: function(t) {
    return this[t].locator;
  },
  getQName: function(t) {
    return this[t].qName;
  },
  getURI: function(t) {
    return this[t].uri;
  },
  getValue: function(t) {
    return this[t].value;
  }
  //	,getIndex:function(uri, localName)){
  //		if(localName){
  //
  //		}else{
  //			var qName = uri
  //		}
  //	},
  //	getValue:function(){return this.getValue(this.getIndex.apply(this,arguments))},
  //	getType:function(uri,localName){}
  //	getType:function(i){},
};
function uee(t, e) {
  var n, a = [], i = /'[^']+'|"[^"]+"|[^\s<>\/=]+=?|(\/?\s*>|<)/g;
  for (i.lastIndex = e, i.exec(t); n = i.exec(t); )
    if (a.push(n), n[1]) return a;
}
Qf.XMLReader = z5;
Qf.ParseError = zs;
var dee = Mi, hee = cr, Fg = F5, Y5 = Qf, fee = hee.DOMImplementation, zg = dee.NAMESPACE, pee = Y5.ParseError, mee = Y5.XMLReader;
function j5(t) {
  return t.replace(/\r[\n\u0085]/g, `
`).replace(/[\r\u0085\u2028]/g, `
`);
}
function V5(t) {
  this.options = t || { locator: {} };
}
V5.prototype.parseFromString = function(t, e) {
  var n = this.options, a = new mee(), i = n.domBuilder || new Vl(), r = n.errorHandler, s = n.locator, o = n.xmlns || {}, l = /\/x?html?$/.test(e), c = l ? Fg.HTML_ENTITIES : Fg.XML_ENTITIES;
  s && i.setDocumentLocator(s), a.errorHandler = gee(r, i, s), a.domBuilder = n.domBuilder || i, l && (o[""] = zg.HTML), o.xml = o.xml || zg.XML;
  var u = n.normalizeLineEndings || j5;
  return t && typeof t == "string" ? a.parse(
    u(t),
    o,
    c
  ) : a.errorHandler.error("invalid doc source"), i.doc;
};
function gee(t, e, n) {
  if (!t) {
    if (e instanceof Vl)
      return e;
    t = e;
  }
  var a = {}, i = t instanceof Function;
  n = n || {};
  function r(s) {
    var o = t[s];
    !o && i && (o = t.length == 2 ? function(l) {
      t(s, l);
    } : t), a[s] = o && function(l) {
      o("[xmldom " + s + "]	" + l + bh(n));
    } || function() {
    };
  }
  return r("warning"), r("error"), r("fatalError"), a;
}
function Vl() {
  this.cdata = !1;
}
function rs(t, e) {
  e.lineNumber = t.lineNumber, e.columnNumber = t.columnNumber;
}
Vl.prototype = {
  startDocument: function() {
    this.doc = new fee().createDocument(null, null, null), this.locator && (this.doc.documentURI = this.locator.systemId);
  },
  startElement: function(t, e, n, a) {
    var i = this.doc, r = i.createElementNS(t, n || e), s = a.length;
    Mc(this, r), this.currentElement = r, this.locator && rs(this.locator, r);
    for (var o = 0; o < s; o++) {
      var t = a.getURI(o), l = a.getValue(o), n = a.getQName(o), c = i.createAttributeNS(t, n);
      this.locator && rs(a.getLocator(o), c), c.value = c.nodeValue = l, r.setAttributeNode(c);
    }
  },
  endElement: function(t, e, n) {
    var a = this.currentElement;
    a.tagName, this.currentElement = a.parentNode;
  },
  startPrefixMapping: function(t, e) {
  },
  endPrefixMapping: function(t) {
  },
  processingInstruction: function(t, e) {
    var n = this.doc.createProcessingInstruction(t, e);
    this.locator && rs(this.locator, n), Mc(this, n);
  },
  ignorableWhitespace: function(t, e, n) {
  },
  characters: function(t, e, n) {
    if (t = Ug.apply(this, arguments), t) {
      if (this.cdata)
        var a = this.doc.createCDATASection(t);
      else
        var a = this.doc.createTextNode(t);
      this.currentElement ? this.currentElement.appendChild(a) : /^\s*$/.test(t) && this.doc.appendChild(a), this.locator && rs(this.locator, a);
    }
  },
  skippedEntity: function(t) {
  },
  endDocument: function() {
    this.doc.normalize();
  },
  setDocumentLocator: function(t) {
    (this.locator = t) && (t.lineNumber = 0);
  },
  //LexicalHandler
  comment: function(t, e, n) {
    t = Ug.apply(this, arguments);
    var a = this.doc.createComment(t);
    this.locator && rs(this.locator, a), Mc(this, a);
  },
  startCDATA: function() {
    this.cdata = !0;
  },
  endCDATA: function() {
    this.cdata = !1;
  },
  startDTD: function(t, e, n) {
    var a = this.doc.implementation;
    if (a && a.createDocumentType) {
      var i = a.createDocumentType(t, e, n);
      this.locator && rs(this.locator, i), Mc(this, i), this.doc.doctype = i;
    }
  },
  /**
   * @see org.xml.sax.ErrorHandler
   * @link http://www.saxproject.org/apidoc/org/xml/sax/ErrorHandler.html
   */
  warning: function(t) {
    console.warn("[xmldom warning]	" + t, bh(this.locator));
  },
  error: function(t) {
    console.error("[xmldom error]	" + t, bh(this.locator));
  },
  fatalError: function(t) {
    throw new pee(t, this.locator);
  }
};
function bh(t) {
  if (t)
    return `
@` + (t.systemId || "") + "#[line:" + t.lineNumber + ",col:" + t.columnNumber + "]";
}
function Ug(t, e, n) {
  return typeof t == "string" ? t.substr(e, n) : t.length >= e + n || e ? new java.lang.String(t, e, n) + "" : t;
}
"endDTD,startEntity,endEntity,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,resolveEntity,getExternalSubset,notationDecl,unparsedEntityDecl".replace(/\w+/g, function(t) {
  Vl.prototype[t] = function() {
    return null;
  };
});
function Mc(t, e) {
  t.currentElement ? t.currentElement.appendChild(e) : t.doc.appendChild(e);
}
hd.__DOMHandler = Vl;
hd.normalizeLineEndings = j5;
hd.DOMParser = V5;
var bee = hd.DOMParser;
/*! @name mpd-parser @version 1.3.1 @license Apache-2.0 */
const Hg = (t) => !!t && typeof t == "object", gn = (...t) => t.reduce((e, n) => (typeof n != "object" || Object.keys(n).forEach((a) => {
  Array.isArray(e[a]) && Array.isArray(n[a]) ? e[a] = e[a].concat(n[a]) : Hg(e[a]) && Hg(n[a]) ? e[a] = gn(e[a], n[a]) : e[a] = n[a];
}), e), {}), q5 = (t) => Object.keys(t).map((e) => t[e]), vee = (t, e) => {
  const n = [];
  for (let a = t; a < e; a++)
    n.push(a);
  return n;
}, Us = (t) => t.reduce((e, n) => e.concat(n), []), W5 = (t) => {
  if (!t.length)
    return [];
  const e = [];
  for (let n = 0; n < t.length; n++)
    e.push(t[n]);
  return e;
}, yee = (t, e) => t.reduce((n, a, i) => (a[e] && n.push(i), n), []), _ee = (t, e) => q5(t.reduce((n, a) => (a.forEach((i) => {
  n[e(i)] = i;
}), n), {}));
var Hs = {
  INVALID_NUMBER_OF_PERIOD: "INVALID_NUMBER_OF_PERIOD",
  DASH_EMPTY_MANIFEST: "DASH_EMPTY_MANIFEST",
  DASH_INVALID_XML: "DASH_INVALID_XML",
  NO_BASE_URL: "NO_BASE_URL",
  SEGMENT_TIME_UNSPECIFIED: "SEGMENT_TIME_UNSPECIFIED",
  UNSUPPORTED_UTC_TIMING_SCHEME: "UNSUPPORTED_UTC_TIMING_SCHEME"
};
const El = ({
  baseUrl: t = "",
  source: e = "",
  range: n = "",
  indexRange: a = ""
}) => {
  const i = {
    uri: e,
    resolvedUri: cd(t || "", e)
  };
  if (n || a) {
    const s = (n || a).split("-");
    let o = j.BigInt ? j.BigInt(s[0]) : parseInt(s[0], 10), l = j.BigInt ? j.BigInt(s[1]) : parseInt(s[1], 10);
    o < Number.MAX_SAFE_INTEGER && typeof o == "bigint" && (o = Number(o)), l < Number.MAX_SAFE_INTEGER && typeof l == "bigint" && (l = Number(l));
    let c;
    typeof l == "bigint" || typeof o == "bigint" ? c = j.BigInt(l) - j.BigInt(o) + j.BigInt(1) : c = l - o + 1, typeof c == "bigint" && c < Number.MAX_SAFE_INTEGER && (c = Number(c)), i.byterange = {
      length: c,
      offset: o
    };
  }
  return i;
}, Tee = (t) => {
  let e;
  return typeof t.offset == "bigint" || typeof t.length == "bigint" ? e = j.BigInt(t.offset) + j.BigInt(t.length) - j.BigInt(1) : e = t.offset + t.length - 1, `${t.offset}-${e}`;
}, Yg = (t) => (t && typeof t != "number" && (t = parseInt(t, 10)), isNaN(t) ? null : t), xee = {
  /**
   * Returns the entire range of available segments for a static MPD
   *
   * @param {Object} attributes
   *        Inheritied MPD attributes
   * @return {{ start: number, end: number }}
   *         The start and end numbers for available segments
   */
  static(t) {
    const {
      duration: e,
      timescale: n = 1,
      sourceDuration: a,
      periodDuration: i
    } = t, r = Yg(t.endNumber), s = e / n;
    return typeof r == "number" ? {
      start: 0,
      end: r
    } : typeof i == "number" ? {
      start: 0,
      end: i / s
    } : {
      start: 0,
      end: a / s
    };
  },
  /**
   * Returns the current live window range of available segments for a dynamic MPD
   *
   * @param {Object} attributes
   *        Inheritied MPD attributes
   * @return {{ start: number, end: number }}
   *         The start and end numbers for available segments
   */
  dynamic(t) {
    const {
      NOW: e,
      clientOffset: n,
      availabilityStartTime: a,
      timescale: i = 1,
      duration: r,
      periodStart: s = 0,
      minimumUpdatePeriod: o = 0,
      timeShiftBufferDepth: l = 1 / 0
    } = t, c = Yg(t.endNumber), u = (e + n) / 1e3, f = a + s, _ = u + o - f, T = Math.ceil(_ * i / r), g = Math.floor((u - f - l) * i / r), x = Math.floor((u - f) * i / r);
    return {
      start: Math.max(0, g),
      end: typeof c == "number" ? c : Math.min(T, x)
    };
  }
}, wee = (t) => (e) => {
  const {
    duration: n,
    timescale: a = 1,
    periodStart: i,
    startNumber: r = 1
  } = t;
  return {
    number: r + e,
    duration: n / a,
    timeline: i,
    time: e * n
  };
}, Jf = (t) => {
  const {
    type: e,
    duration: n,
    timescale: a = 1,
    periodDuration: i,
    sourceDuration: r
  } = t, {
    start: s,
    end: o
  } = xee[e](t), l = vee(s, o).map(wee(t));
  if (e === "static") {
    const c = l.length - 1, u = typeof i == "number" ? i : r;
    l[c].duration = u - n / a * c;
  }
  return l;
}, G5 = (t) => {
  const {
    baseUrl: e,
    initialization: n = {},
    sourceDuration: a,
    indexRange: i = "",
    periodStart: r,
    presentationTime: s,
    number: o = 0,
    duration: l
  } = t;
  if (!e)
    throw new Error(Hs.NO_BASE_URL);
  const c = El({
    baseUrl: e,
    source: n.sourceURL,
    range: n.range
  }), u = El({
    baseUrl: e,
    source: e,
    indexRange: i
  });
  if (u.map = c, l) {
    const f = Jf(t);
    f.length && (u.duration = f[0].duration, u.timeline = f[0].timeline);
  } else a && (u.duration = a, u.timeline = r);
  return u.presentationTime = s || r, u.number = o, [u];
}, ep = (t, e, n) => {
  const a = t.sidx.map ? t.sidx.map : null, i = t.sidx.duration, r = t.timeline || 0, s = t.sidx.byterange, o = s.offset + s.length, l = e.timescale, c = e.references.filter((x) => x.referenceType !== 1), u = [], f = t.endList ? "static" : "dynamic", m = t.sidx.timeline;
  let _ = m, T = t.mediaSequence || 0, g;
  typeof e.firstOffset == "bigint" ? g = j.BigInt(o) + e.firstOffset : g = o + e.firstOffset;
  for (let x = 0; x < c.length; x++) {
    const S = e.references[x], D = S.referencedSize, L = S.subsegmentDuration;
    let M;
    typeof g == "bigint" ? M = g + j.BigInt(D) - j.BigInt(1) : M = g + D - 1;
    const E = `${g}-${M}`, B = G5({
      baseUrl: n,
      timescale: l,
      timeline: r,
      periodStart: m,
      presentationTime: _,
      number: T,
      duration: L,
      sourceDuration: i,
      indexRange: E,
      type: f
    })[0];
    a && (B.map = a), u.push(B), typeof g == "bigint" ? g += j.BigInt(D) : g += D, _ += L / l, T++;
  }
  return t.segments = u, t;
}, kee = ["AUDIO", "SUBTITLES"], Cee = 1 / 60, X5 = (t) => _ee(t, ({
  timeline: e
}) => e).sort((e, n) => e.timeline > n.timeline ? 1 : -1), See = (t, e) => {
  for (let n = 0; n < t.length; n++)
    if (t[n].attributes.NAME === e)
      return t[n];
  return null;
}, jg = (t) => {
  let e = [];
  return YJ(t, kee, (n, a, i, r) => {
    e = e.concat(n.playlists || []);
  }), e;
}, Vg = ({
  playlist: t,
  mediaSequence: e
}) => {
  t.mediaSequence = e, t.segments.forEach((n, a) => {
    n.number = t.mediaSequence + a;
  });
}, Aee = ({
  oldPlaylists: t,
  newPlaylists: e,
  timelineStarts: n
}) => {
  e.forEach((a) => {
    a.discontinuitySequence = n.findIndex(function({
      timeline: l
    }) {
      return l === a.timeline;
    });
    const i = See(t, a.attributes.NAME);
    if (!i || a.sidx)
      return;
    const r = a.segments[0], s = i.segments.findIndex(function(l) {
      return Math.abs(l.presentationTime - r.presentationTime) < Cee;
    });
    if (s === -1) {
      Vg({
        playlist: a,
        mediaSequence: i.mediaSequence + i.segments.length
      }), a.segments[0].discontinuity = !0, a.discontinuityStarts.unshift(0), (!i.segments.length && a.timeline > i.timeline || i.segments.length && a.timeline > i.segments[i.segments.length - 1].timeline) && a.discontinuitySequence--;
      return;
    }
    i.segments[s].discontinuity && !r.discontinuity && (r.discontinuity = !0, a.discontinuityStarts.unshift(0), a.discontinuitySequence--), Vg({
      playlist: a,
      mediaSequence: i.segments[s].number
    });
  });
}, Eee = ({
  oldManifest: t,
  newManifest: e
}) => {
  const n = t.playlists.concat(jg(t)), a = e.playlists.concat(jg(e));
  return e.timelineStarts = X5([t.timelineStarts, e.timelineStarts]), Aee({
    oldPlaylists: n,
    newPlaylists: a,
    timelineStarts: e.timelineStarts
  }), e;
}, fd = (t) => t && t.uri + "-" + Tee(t.byterange), A0 = (t) => {
  const e = t.reduce(function(a, i) {
    return a[i.attributes.baseUrl] || (a[i.attributes.baseUrl] = []), a[i.attributes.baseUrl].push(i), a;
  }, {});
  let n = [];
  return Object.values(e).forEach((a) => {
    const i = q5(a.reduce((r, s) => {
      const o = s.attributes.id + (s.attributes.lang || "");
      return r[o] ? (s.segments && (s.segments[0] && (s.segments[0].discontinuity = !0), r[o].segments.push(...s.segments)), s.attributes.contentProtection && (r[o].attributes.contentProtection = s.attributes.contentProtection)) : (r[o] = s, r[o].attributes.timelineStarts = []), r[o].attributes.timelineStarts.push({
        // Although they represent the same number, it's important to have both to make it
        // compatible with HLS potentially having a similar attribute.
        start: s.attributes.periodStart,
        timeline: s.attributes.periodStart
      }), r;
    }, {}));
    n = n.concat(i);
  }), n.map((a) => (a.discontinuityStarts = yee(a.segments || [], "discontinuity"), a));
}, tp = (t, e) => {
  const n = fd(t.sidx), a = n && e[n] && e[n].sidx;
  return a && ep(t, a, t.sidx.resolvedUri), t;
}, Lee = (t, e = {}) => {
  if (!Object.keys(e).length)
    return t;
  for (const n in t)
    t[n] = tp(t[n], e);
  return t;
}, Dee = ({
  attributes: t,
  segments: e,
  sidx: n,
  mediaSequence: a,
  discontinuitySequence: i,
  discontinuityStarts: r
}, s) => {
  const o = {
    attributes: {
      NAME: t.id,
      BANDWIDTH: t.bandwidth,
      CODECS: t.codecs,
      "PROGRAM-ID": 1
    },
    uri: "",
    endList: t.type === "static",
    timeline: t.periodStart,
    resolvedUri: t.baseUrl || "",
    targetDuration: t.duration,
    discontinuitySequence: i,
    discontinuityStarts: r,
    timelineStarts: t.timelineStarts,
    mediaSequence: a,
    segments: e
  };
  return t.contentProtection && (o.contentProtection = t.contentProtection), t.serviceLocation && (o.attributes.serviceLocation = t.serviceLocation), n && (o.sidx = n), s && (o.attributes.AUDIO = "audio", o.attributes.SUBTITLES = "subs"), o;
}, Iee = ({
  attributes: t,
  segments: e,
  mediaSequence: n,
  discontinuityStarts: a,
  discontinuitySequence: i
}) => {
  typeof e > "u" && (e = [{
    uri: t.baseUrl,
    timeline: t.periodStart,
    resolvedUri: t.baseUrl || "",
    duration: t.sourceDuration,
    number: 0
  }], t.duration = t.sourceDuration);
  const r = {
    NAME: t.id,
    BANDWIDTH: t.bandwidth,
    "PROGRAM-ID": 1
  };
  t.codecs && (r.CODECS = t.codecs);
  const s = {
    attributes: r,
    uri: "",
    endList: t.type === "static",
    timeline: t.periodStart,
    resolvedUri: t.baseUrl || "",
    targetDuration: t.duration,
    timelineStarts: t.timelineStarts,
    discontinuityStarts: a,
    discontinuitySequence: i,
    mediaSequence: n,
    segments: e
  };
  return t.serviceLocation && (s.attributes.serviceLocation = t.serviceLocation), s;
}, Mee = (t, e = {}, n = !1) => {
  let a;
  const i = t.reduce((r, s) => {
    const o = s.attributes.role && s.attributes.role.value || "", l = s.attributes.lang || "";
    let c = s.attributes.label || "main";
    if (l && !s.attributes.label) {
      const f = o ? ` (${o})` : "";
      c = `${s.attributes.lang}${f}`;
    }
    r[c] || (r[c] = {
      language: l,
      autoselect: !0,
      default: o === "main",
      playlists: [],
      uri: ""
    });
    const u = tp(Dee(s, n), e);
    return r[c].playlists.push(u), typeof a > "u" && o === "main" && (a = s, a.default = !0), r;
  }, {});
  if (!a) {
    const r = Object.keys(i)[0];
    i[r].default = !0;
  }
  return i;
}, Oee = (t, e = {}) => t.reduce((n, a) => {
  const i = a.attributes.label || a.attributes.lang || "text", r = a.attributes.lang || "und";
  return n[i] || (n[i] = {
    language: r,
    default: !1,
    autoselect: !1,
    playlists: [],
    uri: ""
  }), n[i].playlists.push(tp(Iee(a), e)), n;
}, {}), Pee = (t) => t.reduce((e, n) => (n && n.forEach((a) => {
  const {
    channel: i,
    language: r
  } = a;
  e[r] = {
    autoselect: !1,
    default: !1,
    instreamId: i,
    language: r
  }, a.hasOwnProperty("aspectRatio") && (e[r].aspectRatio = a.aspectRatio), a.hasOwnProperty("easyReader") && (e[r].easyReader = a.easyReader), a.hasOwnProperty("3D") && (e[r]["3D"] = a["3D"]);
}), e), {}), Bee = ({
  attributes: t,
  segments: e,
  sidx: n,
  discontinuityStarts: a
}) => {
  const i = {
    attributes: {
      NAME: t.id,
      AUDIO: "audio",
      SUBTITLES: "subs",
      RESOLUTION: {
        width: t.width,
        height: t.height
      },
      CODECS: t.codecs,
      BANDWIDTH: t.bandwidth,
      "PROGRAM-ID": 1
    },
    uri: "",
    endList: t.type === "static",
    timeline: t.periodStart,
    resolvedUri: t.baseUrl || "",
    targetDuration: t.duration,
    discontinuityStarts: a,
    timelineStarts: t.timelineStarts,
    segments: e
  };
  return t.frameRate && (i.attributes["FRAME-RATE"] = t.frameRate), t.contentProtection && (i.contentProtection = t.contentProtection), t.serviceLocation && (i.attributes.serviceLocation = t.serviceLocation), n && (i.sidx = n), i;
}, Ree = ({
  attributes: t
}) => t.mimeType === "video/mp4" || t.mimeType === "video/webm" || t.contentType === "video", Nee = ({
  attributes: t
}) => t.mimeType === "audio/mp4" || t.mimeType === "audio/webm" || t.contentType === "audio", $ee = ({
  attributes: t
}) => t.mimeType === "text/vtt" || t.contentType === "text", Fee = (t, e) => {
  t.forEach((n) => {
    n.mediaSequence = 0, n.discontinuitySequence = e.findIndex(function({
      timeline: a
    }) {
      return a === n.timeline;
    }), n.segments && n.segments.forEach((a, i) => {
      a.number = i;
    });
  });
}, qg = (t) => t ? Object.keys(t).reduce((e, n) => {
  const a = t[n];
  return e.concat(a.playlists);
}, []) : [], zee = ({
  dashPlaylists: t,
  locations: e,
  contentSteering: n,
  sidxMapping: a = {},
  previousManifest: i,
  eventStream: r
}) => {
  if (!t.length)
    return {};
  const {
    sourceDuration: s,
    type: o,
    suggestedPresentationDelay: l,
    minimumUpdatePeriod: c
  } = t[0].attributes, u = A0(t.filter(Ree)).map(Bee), f = A0(t.filter(Nee)), m = A0(t.filter($ee)), _ = t.map((M) => M.attributes.captionServices).filter(Boolean), T = {
    allowCache: !0,
    discontinuityStarts: [],
    segments: [],
    endList: !0,
    mediaGroups: {
      AUDIO: {},
      VIDEO: {},
      "CLOSED-CAPTIONS": {},
      SUBTITLES: {}
    },
    uri: "",
    duration: s,
    playlists: Lee(u, a)
  };
  c >= 0 && (T.minimumUpdatePeriod = c * 1e3), e && (T.locations = e), n && (T.contentSteering = n), o === "dynamic" && (T.suggestedPresentationDelay = l), r && r.length > 0 && (T.eventStream = r);
  const g = T.playlists.length === 0, x = f.length ? Mee(f, a, g) : null, S = m.length ? Oee(m, a) : null, D = u.concat(qg(x), qg(S)), L = D.map(({
    timelineStarts: M
  }) => M);
  return T.timelineStarts = X5(L), Fee(D, T.timelineStarts), x && (T.mediaGroups.AUDIO.audio = x), S && (T.mediaGroups.SUBTITLES.subs = S), _.length && (T.mediaGroups["CLOSED-CAPTIONS"].cc = Pee(_)), i ? Eee({
    oldManifest: i,
    newManifest: T
  }) : T;
}, Uee = (t, e, n) => {
  const {
    NOW: a,
    clientOffset: i,
    availabilityStartTime: r,
    timescale: s = 1,
    periodStart: o = 0,
    minimumUpdatePeriod: l = 0
  } = t, c = (a + i) / 1e3, u = r + o, m = c + l - u;
  return Math.ceil((m * s - e) / n);
}, Z5 = (t, e) => {
  const {
    type: n,
    minimumUpdatePeriod: a = 0,
    media: i = "",
    sourceDuration: r,
    timescale: s = 1,
    startNumber: o = 1,
    periodStart: l
  } = t, c = [];
  let u = -1;
  for (let f = 0; f < e.length; f++) {
    const m = e[f], _ = m.d, T = m.r || 0, g = m.t || 0;
    u < 0 && (u = g), g && g > u && (u = g);
    let x;
    if (T < 0) {
      const L = f + 1;
      L === e.length ? n === "dynamic" && a > 0 && i.indexOf("$Number$") > 0 ? x = Uee(t, u, _) : x = (r * s - u) / _ : x = (e[L].t - u) / _;
    } else
      x = T + 1;
    const S = o + c.length + x;
    let D = o + c.length;
    for (; D < S; )
      c.push({
        number: D,
        duration: _ / s,
        time: u,
        timeline: l
      }), u += _, D++;
  }
  return c;
}, Hee = /\$([A-z]*)(?:(%0)([0-9]+)d)?\$/g, Yee = (t) => (e, n, a, i) => {
  if (e === "$$")
    return "$";
  if (typeof t[n] > "u")
    return e;
  const r = "" + t[n];
  return n === "RepresentationID" || (a ? i = parseInt(i, 10) : i = 1, r.length >= i) ? r : `${new Array(i - r.length + 1).join("0")}${r}`;
}, Wg = (t, e) => t.replace(Hee, Yee(e)), jee = (t, e) => !t.duration && !e ? [{
  number: t.startNumber || 1,
  duration: t.sourceDuration,
  time: 0,
  timeline: t.periodStart
}] : t.duration ? Jf(t) : Z5(t, e), Vee = (t, e) => {
  const n = {
    RepresentationID: t.id,
    Bandwidth: t.bandwidth || 0
  }, {
    initialization: a = {
      sourceURL: "",
      range: ""
    }
  } = t, i = El({
    baseUrl: t.baseUrl,
    source: Wg(a.sourceURL, n),
    range: a.range
  });
  return jee(t, e).map((s) => {
    n.Number = s.number, n.Time = s.time;
    const o = Wg(t.media || "", n), l = t.timescale || 1, c = t.presentationTimeOffset || 0, u = (
      // Even if the @t attribute is not specified for the segment, segment.time is
      // calculated in mpd-parser prior to this, so it's assumed to be available.
      t.periodStart + (s.time - c) / l
    );
    return {
      uri: o,
      timeline: s.timeline,
      duration: s.duration,
      resolvedUri: cd(t.baseUrl || "", o),
      map: i,
      number: s.number,
      presentationTime: u
    };
  });
}, qee = (t, e) => {
  const {
    baseUrl: n,
    initialization: a = {}
  } = t, i = El({
    baseUrl: n,
    source: a.sourceURL,
    range: a.range
  }), r = El({
    baseUrl: n,
    source: e.media,
    range: e.mediaRange
  });
  return r.map = i, r;
}, Wee = (t, e) => {
  const {
    duration: n,
    segmentUrls: a = [],
    periodStart: i
  } = t;
  if (!n && !e || n && e)
    throw new Error(Hs.SEGMENT_TIME_UNSPECIFIED);
  const r = a.map((l) => qee(t, l));
  let s;
  return n && (s = Jf(t)), e && (s = Z5(t, e)), s.map((l, c) => {
    if (r[c]) {
      const u = r[c], f = t.timescale || 1, m = t.presentationTimeOffset || 0;
      return u.timeline = l.timeline, u.duration = l.duration, u.number = l.number, u.presentationTime = i + (l.time - m) / f, u;
    }
  }).filter((l) => l);
}, Gee = ({
  attributes: t,
  segmentInfo: e
}) => {
  let n, a;
  e.template ? (a = Vee, n = gn(t, e.template)) : e.base ? (a = G5, n = gn(t, e.base)) : e.list && (a = Wee, n = gn(t, e.list));
  const i = {
    attributes: t
  };
  if (!a)
    return i;
  const r = a(n, e.segmentTimeline);
  if (n.duration) {
    const {
      duration: s,
      timescale: o = 1
    } = n;
    n.duration = s / o;
  } else r.length ? n.duration = r.reduce((s, o) => Math.max(s, Math.ceil(o.duration)), 0) : n.duration = 0;
  return i.attributes = n, i.segments = r, e.base && n.indexRange && (i.sidx = r[0], i.segments = []), i;
}, Xee = (t) => t.map(Gee), Nt = (t, e) => W5(t.childNodes).filter(({
  tagName: n
}) => n === e), ql = (t) => t.textContent.trim(), Zee = (t) => parseFloat(t.split("/").reduce((e, n) => e / n)), ss = (t) => {
  const o = /P(?:(\d*)Y)?(?:(\d*)M)?(?:(\d*)D)?(?:T(?:(\d*)H)?(?:(\d*)M)?(?:([\d.]*)S)?)?/.exec(t);
  if (!o)
    return 0;
  const [l, c, u, f, m, _] = o.slice(1);
  return parseFloat(l || 0) * 31536e3 + parseFloat(c || 0) * 2592e3 + parseFloat(u || 0) * 86400 + parseFloat(f || 0) * 3600 + parseFloat(m || 0) * 60 + parseFloat(_ || 0);
}, Kee = (t) => (/^\d+-\d+-\d+T\d+:\d+:\d+(\.\d+)?$/.test(t) && (t += "Z"), Date.parse(t)), Gg = {
  /**
   * Specifies the duration of the entire Media Presentation. Format is a duration string
   * as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The duration in seconds
   */
  mediaPresentationDuration(t) {
    return ss(t);
  },
  /**
   * Specifies the Segment availability start time for all Segments referred to in this
   * MPD. For a dynamic manifest, it specifies the anchor for the earliest availability
   * time. Format is a date string as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The date as seconds from unix epoch
   */
  availabilityStartTime(t) {
    return Kee(t) / 1e3;
  },
  /**
   * Specifies the smallest period between potential changes to the MPD. Format is a
   * duration string as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The duration in seconds
   */
  minimumUpdatePeriod(t) {
    return ss(t);
  },
  /**
   * Specifies the suggested presentation delay. Format is a
   * duration string as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The duration in seconds
   */
  suggestedPresentationDelay(t) {
    return ss(t);
  },
  /**
   * specifices the type of mpd. Can be either "static" or "dynamic"
   *
   * @param {string} value
   *        value of attribute as a string
   *
   * @return {string}
   *         The type as a string
   */
  type(t) {
    return t;
  },
  /**
   * Specifies the duration of the smallest time shifting buffer for any Representation
   * in the MPD. Format is a duration string as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The duration in seconds
   */
  timeShiftBufferDepth(t) {
    return ss(t);
  },
  /**
   * Specifies the PeriodStart time of the Period relative to the availabilityStarttime.
   * Format is a duration string as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The duration in seconds
   */
  start(t) {
    return ss(t);
  },
  /**
   * Specifies the width of the visual presentation
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed width
   */
  width(t) {
    return parseInt(t, 10);
  },
  /**
   * Specifies the height of the visual presentation
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed height
   */
  height(t) {
    return parseInt(t, 10);
  },
  /**
   * Specifies the bitrate of the representation
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed bandwidth
   */
  bandwidth(t) {
    return parseInt(t, 10);
  },
  /**
   * Specifies the frame rate of the representation
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed frame rate
   */
  frameRate(t) {
    return Zee(t);
  },
  /**
   * Specifies the number of the first Media Segment in this Representation in the Period
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed number
   */
  startNumber(t) {
    return parseInt(t, 10);
  },
  /**
   * Specifies the timescale in units per seconds
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed timescale
   */
  timescale(t) {
    return parseInt(t, 10);
  },
  /**
   * Specifies the presentationTimeOffset.
   *
   * @param {string} value
   *        value of the attribute as a string
   *
   * @return {number}
   *         The parsed presentationTimeOffset
   */
  presentationTimeOffset(t) {
    return parseInt(t, 10);
  },
  /**
   * Specifies the constant approximate Segment duration
   * NOTE: The <Period> element also contains an @duration attribute. This duration
   *       specifies the duration of the Period. This attribute is currently not
   *       supported by the rest of the parser, however we still check for it to prevent
   *       errors.
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed duration
   */
  duration(t) {
    const e = parseInt(t, 10);
    return isNaN(e) ? ss(t) : e;
  },
  /**
   * Specifies the Segment duration, in units of the value of the @timescale.
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed duration
   */
  d(t) {
    return parseInt(t, 10);
  },
  /**
   * Specifies the MPD start time, in @timescale units, the first Segment in the series
   * starts relative to the beginning of the Period
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed time
   */
  t(t) {
    return parseInt(t, 10);
  },
  /**
   * Specifies the repeat count of the number of following contiguous Segments with the
   * same duration expressed by the value of @d
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed number
   */
  r(t) {
    return parseInt(t, 10);
  },
  /**
   * Specifies the presentationTime.
   *
   * @param {string} value
   *        value of the attribute as a string
   *
   * @return {number}
   *         The parsed presentationTime
   */
  presentationTime(t) {
    return parseInt(t, 10);
  },
  /**
   * Default parser for all other attributes. Acts as a no-op and just returns the value
   * as a string
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {string}
   *         Unparsed value
   */
  DEFAULT(t) {
    return t;
  }
}, rn = (t) => t && t.attributes ? W5(t.attributes).reduce((e, n) => {
  const a = Gg[n.name] || Gg.DEFAULT;
  return e[n.name] = a(n.value), e;
}, {}) : {}, Qee = {
  "urn:uuid:1077efec-c0b2-4d02-ace3-3c1e52e2fb4b": "org.w3.clearkey",
  "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed": "com.widevine.alpha",
  "urn:uuid:9a04f079-9840-4286-ab92-e65be0885f95": "com.microsoft.playready",
  "urn:uuid:f239e769-efa3-4850-9c16-a903c6932efb": "com.adobe.primetime",
  // ISO_IEC 23009-1_2022 5.8.5.2.2 The mp4 Protection Scheme
  "urn:mpeg:dash:mp4protection:2011": "mp4protection"
}, pd = (t, e) => e.length ? Us(t.map(function(n) {
  return e.map(function(a) {
    const i = ql(a), r = cd(n.baseUrl, i), s = gn(rn(a), {
      baseUrl: r
    });
    return r !== i && !s.serviceLocation && n.serviceLocation && (s.serviceLocation = n.serviceLocation), s;
  });
})) : t, np = (t) => {
  const e = Nt(t, "SegmentTemplate")[0], n = Nt(t, "SegmentList")[0], a = n && Nt(n, "SegmentURL").map((f) => gn({
    tag: "SegmentURL"
  }, rn(f))), i = Nt(t, "SegmentBase")[0], r = n || e, s = r && Nt(r, "SegmentTimeline")[0], o = n || i || e, l = o && Nt(o, "Initialization")[0], c = e && rn(e);
  c && l ? c.initialization = l && rn(l) : c && c.initialization && (c.initialization = {
    sourceURL: c.initialization
  });
  const u = {
    template: c,
    segmentTimeline: s && Nt(s, "S").map((f) => rn(f)),
    list: n && gn(rn(n), {
      segmentUrls: a,
      initialization: rn(l)
    }),
    base: i && gn(rn(i), {
      initialization: rn(l)
    })
  };
  return Object.keys(u).forEach((f) => {
    u[f] || delete u[f];
  }), u;
}, Jee = (t, e, n) => (a) => {
  const i = Nt(a, "BaseURL"), r = pd(e, i), s = gn(t, rn(a)), o = np(a);
  return r.map((l) => ({
    segmentInfo: gn(n, o),
    attributes: gn(s, l)
  }));
}, ete = (t) => t.reduce((e, n) => {
  const a = rn(n);
  a.schemeIdUri && (a.schemeIdUri = a.schemeIdUri.toLowerCase());
  const i = Qee[a.schemeIdUri];
  if (i) {
    e[i] = {
      attributes: a
    };
    const r = Nt(n, "cenc:pssh")[0];
    if (r) {
      const s = ql(r);
      e[i].pssh = s && d5(s);
    }
  }
  return e;
}, {}), tte = (t) => {
  if (t.schemeIdUri === "urn:scte:dash:cc:cea-608:2015")
    return (typeof t.value != "string" ? [] : t.value.split(";")).map((n) => {
      let a, i;
      return i = n, /^CC\d=/.test(n) ? [a, i] = n.split("=") : /^CC\d$/.test(n) && (a = n), {
        channel: a,
        language: i
      };
    });
  if (t.schemeIdUri === "urn:scte:dash:cc:cea-708:2015")
    return (typeof t.value != "string" ? [] : t.value.split(";")).map((n) => {
      const a = {
        // service or channel number 1-63
        channel: void 0,
        // language is a 3ALPHA per ISO 639.2/B
        // field is required
        language: void 0,
        // BIT 1/0 or ?
        // default value is 1, meaning 16:9 aspect ratio, 0 is 4:3, ? is unknown
        aspectRatio: 1,
        // BIT 1/0
        // easy reader flag indicated the text is tailed to the needs of beginning readers
        // default 0, or off
        easyReader: 0,
        // BIT 1/0
        // If 3d metadata is present (CEA-708.1) then 1
        // default 0
        "3D": 0
      };
      if (/=/.test(n)) {
        const [i, r = ""] = n.split("=");
        a.channel = i, a.language = n, r.split(",").forEach((s) => {
          const [o, l] = s.split(":");
          o === "lang" ? a.language = l : o === "er" ? a.easyReader = Number(l) : o === "war" ? a.aspectRatio = Number(l) : o === "3D" && (a["3D"] = Number(l));
        });
      } else
        a.language = n;
      return a.channel && (a.channel = "SERVICE" + a.channel), a;
    });
}, nte = (t) => Us(Nt(t.node, "EventStream").map((e) => {
  const n = rn(e), a = n.schemeIdUri;
  return Nt(e, "Event").map((i) => {
    const r = rn(i), s = r.presentationTime || 0, o = n.timescale || 1, l = r.duration || 0, c = s / o + t.attributes.start;
    return {
      schemeIdUri: a,
      value: n.value,
      id: r.id,
      start: c,
      end: c + l / o,
      messageData: ql(i) || r.messageData,
      contentEncoding: n.contentEncoding,
      presentationTimeOffset: n.presentationTimeOffset || 0
    };
  });
})), ate = (t, e, n) => (a) => {
  const i = rn(a), r = pd(e, Nt(a, "BaseURL")), s = Nt(a, "Role")[0], o = {
    role: rn(s)
  };
  let l = gn(t, i, o);
  const c = Nt(a, "Accessibility")[0], u = tte(rn(c));
  u && (l = gn(l, {
    captionServices: u
  }));
  const f = Nt(a, "Label")[0];
  if (f && f.childNodes.length) {
    const x = f.childNodes[0].nodeValue.trim();
    l = gn(l, {
      label: x
    });
  }
  const m = ete(Nt(a, "ContentProtection"));
  Object.keys(m).length && (l = gn(l, {
    contentProtection: m
  }));
  const _ = np(a), T = Nt(a, "Representation"), g = gn(n, _);
  return Us(T.map(Jee(l, r, g)));
}, ite = (t, e) => (n, a) => {
  const i = pd(e, Nt(n.node, "BaseURL")), r = gn(t, {
    periodStart: n.attributes.start
  });
  typeof n.attributes.duration == "number" && (r.periodDuration = n.attributes.duration);
  const s = Nt(n.node, "AdaptationSet"), o = np(n.node);
  return Us(s.map(ate(r, i, o)));
}, rte = (t, e) => {
  if (t.length > 1 && e({
    type: "warn",
    message: "The MPD manifest should contain no more than one ContentSteering tag"
  }), !t.length)
    return null;
  const n = gn({
    serverURL: ql(t[0])
  }, rn(t[0]));
  return n.queryBeforeStart = n.queryBeforeStart === "true", n;
}, ste = ({
  attributes: t,
  priorPeriodAttributes: e,
  mpdType: n
}) => typeof t.start == "number" ? t.start : e && typeof e.start == "number" && typeof e.duration == "number" ? e.start + e.duration : !e && n === "static" ? 0 : null, ote = (t, e = {}) => {
  const {
    manifestUri: n = "",
    NOW: a = Date.now(),
    clientOffset: i = 0,
    // TODO: For now, we are expecting an eventHandler callback function
    // to be passed into the mpd parser as an option.
    // In the future, we should enable stream parsing by using the Stream class from vhs-utils.
    // This will support new features including a standardized event handler.
    // See the m3u8 parser for examples of how stream parsing is currently used for HLS parsing.
    // https://github.com/videojs/vhs-utils/blob/88d6e10c631e57a5af02c5a62bc7376cd456b4f5/src/stream.js#L9
    eventHandler: r = function() {
    }
  } = e, s = Nt(t, "Period");
  if (!s.length)
    throw new Error(Hs.INVALID_NUMBER_OF_PERIOD);
  const o = Nt(t, "Location"), l = rn(t), c = pd([{
    baseUrl: n
  }], Nt(t, "BaseURL")), u = Nt(t, "ContentSteering");
  l.type = l.type || "static", l.sourceDuration = l.mediaPresentationDuration || 0, l.NOW = a, l.clientOffset = i, o.length && (l.locations = o.map(ql));
  const f = [];
  return s.forEach((m, _) => {
    const T = rn(m), g = f[_ - 1];
    T.start = ste({
      attributes: T,
      priorPeriodAttributes: g ? g.attributes : null,
      mpdType: l.type
    }), f.push({
      node: m,
      attributes: T
    });
  }), {
    locations: l.locations,
    contentSteeringInfo: rte(u, r),
    // TODO: There are occurences where this `representationInfo` array contains undesired
    // duplicates. This generally occurs when there are multiple BaseURL nodes that are
    // direct children of the MPD node. When we attempt to resolve URLs from a combination of the
    // parent BaseURL and a child BaseURL, and the value does not resolve,
    // we end up returning the child BaseURL multiple times.
    // We need to determine a way to remove these duplicates in a safe way.
    // See: https://github.com/videojs/mpd-parser/pull/17#discussion_r162750527
    representationInfo: Us(f.map(ite(l, c))),
    eventStream: Us(f.map(nte))
  };
}, K5 = (t) => {
  if (t === "")
    throw new Error(Hs.DASH_EMPTY_MANIFEST);
  const e = new bee();
  let n, a;
  try {
    n = e.parseFromString(t, "application/xml"), a = n && n.documentElement.tagName === "MPD" ? n.documentElement : null;
  } catch {
  }
  if (!a || a && a.getElementsByTagName("parsererror").length > 0)
    throw new Error(Hs.DASH_INVALID_XML);
  return a;
}, lte = (t) => {
  const e = Nt(t, "UTCTiming")[0];
  if (!e)
    return null;
  const n = rn(e);
  switch (n.schemeIdUri) {
    case "urn:mpeg:dash:utc:http-head:2014":
    case "urn:mpeg:dash:utc:http-head:2012":
      n.method = "HEAD";
      break;
    case "urn:mpeg:dash:utc:http-xsdate:2014":
    case "urn:mpeg:dash:utc:http-iso:2014":
    case "urn:mpeg:dash:utc:http-xsdate:2012":
    case "urn:mpeg:dash:utc:http-iso:2012":
      n.method = "GET";
      break;
    case "urn:mpeg:dash:utc:direct:2014":
    case "urn:mpeg:dash:utc:direct:2012":
      n.method = "DIRECT", n.value = Date.parse(n.value);
      break;
    case "urn:mpeg:dash:utc:http-ntp:2014":
    case "urn:mpeg:dash:utc:ntp:2014":
    case "urn:mpeg:dash:utc:sntp:2014":
    default:
      throw new Error(Hs.UNSUPPORTED_UTC_TIMING_SCHEME);
  }
  return n;
}, cte = (t, e = {}) => {
  const n = ote(K5(t), e), a = Xee(n.representationInfo);
  return zee({
    dashPlaylists: a,
    locations: n.locations,
    contentSteering: n.contentSteeringInfo,
    sidxMapping: e.sidxMapping,
    previousManifest: e.previousManifest,
    eventStream: n.eventStream
  });
}, ute = (t) => lte(K5(t));
var dte = Math.pow(2, 32), hte = function(t) {
  var e = new DataView(t.buffer, t.byteOffset, t.byteLength), n;
  return e.getBigUint64 ? (n = e.getBigUint64(0), n < Number.MAX_SAFE_INTEGER ? Number(n) : n) : e.getUint32(0) * dte + e.getUint32(4);
}, fte = {
  getUint64: hte
}, Xg = fte.getUint64, pte = function(t) {
  var e = new DataView(t.buffer, t.byteOffset, t.byteLength), n = {
    version: t[0],
    flags: new Uint8Array(t.subarray(1, 4)),
    references: [],
    referenceId: e.getUint32(4),
    timescale: e.getUint32(8)
  }, a = 12;
  n.version === 0 ? (n.earliestPresentationTime = e.getUint32(a), n.firstOffset = e.getUint32(a + 4), a += 8) : (n.earliestPresentationTime = Xg(t.subarray(a)), n.firstOffset = Xg(t.subarray(a + 8)), a += 16), a += 2;
  var i = e.getUint16(a);
  for (a += 2; i > 0; a += 12, i--)
    n.references.push({
      referenceType: (t[a] & 128) >>> 7,
      referencedSize: e.getUint32(a) & 2147483647,
      subsegmentDuration: e.getUint32(a + 4),
      startsWithSap: !!(t[a + 8] & 128),
      sapType: (t[a + 8] & 112) >>> 4,
      sapDeltaTime: e.getUint32(a + 8) & 268435455
    });
  return n;
}, mte = pte;
const gte = /* @__PURE__ */ ka(mte);
var bte = Ke([73, 68, 51]), vte = function(e, n) {
  n === void 0 && (n = 0), e = Ke(e);
  var a = e[n + 5], i = e[n + 6] << 21 | e[n + 7] << 14 | e[n + 8] << 7 | e[n + 9], r = (a & 16) >> 4;
  return r ? i + 20 : i + 10;
}, nl = function t(e, n) {
  return n === void 0 && (n = 0), e = Ke(e), e.length - n < 10 || !Rt(e, bte, {
    offset: n
  }) ? n : (n += vte(e, n), t(e, n));
}, Zg = function(e) {
  return typeof e == "string" ? g5(e) : e;
}, yte = function(e) {
  return Array.isArray(e) ? e.map(function(n) {
    return Zg(n);
  }) : [Zg(e)];
}, _te = function t(e, n, a) {
  a === void 0 && (a = !1), n = yte(n), e = Ke(e);
  var i = [];
  if (!n.length)
    return i;
  for (var r = 0; r < e.length; ) {
    var s = (e[r] << 24 | e[r + 1] << 16 | e[r + 2] << 8 | e[r + 3]) >>> 0, o = e.subarray(r + 4, r + 8);
    if (s === 0)
      break;
    var l = r + s;
    if (l > e.length) {
      if (a)
        break;
      l = e.length;
    }
    var c = e.subarray(r + 8, l);
    Rt(o, n[0]) && (n.length === 1 ? i.push(c) : i.push.apply(i, t(c, n.slice(1), a))), r = l;
  }
  return i;
}, Oc = {
  EBML: Ke([26, 69, 223, 163]),
  DocType: Ke([66, 130]),
  Segment: Ke([24, 83, 128, 103]),
  SegmentInfo: Ke([21, 73, 169, 102]),
  Tracks: Ke([22, 84, 174, 107]),
  Track: Ke([174]),
  TrackNumber: Ke([215]),
  DefaultDuration: Ke([35, 227, 131]),
  TrackEntry: Ke([174]),
  TrackType: Ke([131]),
  FlagDefault: Ke([136]),
  CodecID: Ke([134]),
  CodecPrivate: Ke([99, 162]),
  VideoTrack: Ke([224]),
  AudioTrack: Ke([225]),
  // Not used yet, but will be used for live webm/mkv
  // see https://www.matroska.org/technical/basics.html#block-structure
  // see https://www.matroska.org/technical/basics.html#simpleblock-structure
  Cluster: Ke([31, 67, 182, 117]),
  Timestamp: Ke([231]),
  TimestampScale: Ke([42, 215, 177]),
  BlockGroup: Ke([160]),
  BlockDuration: Ke([155]),
  Block: Ke([161]),
  SimpleBlock: Ke([163])
}, vh = [128, 64, 32, 16, 8, 4, 2, 1], Tte = function(e) {
  for (var n = 1, a = 0; a < vh.length && !(e & vh[a]); a++)
    n++;
  return n;
}, vu = function(e, n, a, i) {
  a === void 0 && (a = !0), i === void 0 && (i = !1);
  var r = Tte(e[n]), s = e.subarray(n, n + r);
  return a && (s = Array.prototype.slice.call(e, n, n + r), s[0] ^= vh[r - 1]), {
    length: r,
    value: zJ(s, {
      signed: i
    }),
    bytes: s
  };
}, Kg = function t(e) {
  return typeof e == "string" ? e.match(/.{1,2}/g).map(function(n) {
    return t(n);
  }) : typeof e == "number" ? UJ(e) : e;
}, xte = function(e) {
  return Array.isArray(e) ? e.map(function(n) {
    return Kg(n);
  }) : [Kg(e)];
}, wte = function t(e, n, a) {
  if (a >= n.length)
    return n.length;
  var i = vu(n, a, !1);
  if (Rt(e.bytes, i.bytes))
    return a;
  var r = vu(n, a + i.length);
  return t(e, n, a + r.length + r.value + i.length);
}, Qg = function t(e, n) {
  n = xte(n), e = Ke(e);
  var a = [];
  if (!n.length)
    return a;
  for (var i = 0; i < e.length; ) {
    var r = vu(e, i, !1), s = vu(e, i + r.length), o = i + r.length + s.length;
    s.value === 127 && (s.value = wte(r, e, o), s.value !== e.length && (s.value -= o));
    var l = o + s.value > e.length ? e.length : o + s.value, c = e.subarray(o, l);
    Rt(n[0], r.bytes) && (n.length === 1 ? a.push(c) : a = a.concat(t(c, n.slice(1))));
    var u = r.length + s.length + c.length;
    i += u;
  }
  return a;
}, kte = Ke([0, 0, 0, 1]), Cte = Ke([0, 0, 1]), Ste = Ke([0, 0, 3]), Ate = function(e) {
  for (var n = [], a = 1; a < e.length - 2; )
    Rt(e.subarray(a, a + 3), Ste) && (n.push(a + 2), a++), a++;
  if (n.length === 0)
    return e;
  var i = e.length - n.length, r = new Uint8Array(i), s = 0;
  for (a = 0; a < i; s++, a++)
    s === n[0] && (s++, n.shift()), r[a] = e[s];
  return r;
}, Q5 = function(e, n, a, i) {
  e = Ke(e), a = [].concat(a);
  for (var r = 0, s, o = 0; r < e.length && (o < i || s); ) {
    var l = void 0;
    if (Rt(e.subarray(r), kte) ? l = 4 : Rt(e.subarray(r), Cte) && (l = 3), !l) {
      r++;
      continue;
    }
    if (o++, s)
      return Ate(e.subarray(s, r));
    var c = void 0;
    n === "h264" ? c = e[r + l] & 31 : n === "h265" && (c = e[r + l] >> 1 & 63), a.indexOf(c) !== -1 && (s = r + l), r += l + (n === "h264" ? 1 : 2);
  }
  return e.subarray(0, 0);
}, Ete = function(e, n, a) {
  return Q5(e, "h264", n, a);
}, Lte = function(e, n, a) {
  return Q5(e, "h265", n, a);
}, Pn = {
  // "webm" string literal in hex
  webm: Ke([119, 101, 98, 109]),
  // "matroska" string literal in hex
  matroska: Ke([109, 97, 116, 114, 111, 115, 107, 97]),
  // "fLaC" string literal in hex
  flac: Ke([102, 76, 97, 67]),
  // "OggS" string literal in hex
  ogg: Ke([79, 103, 103, 83]),
  // ac-3 sync byte, also works for ec-3 as that is simply a codec
  // of ac-3
  ac3: Ke([11, 119]),
  // "RIFF" string literal in hex used for wav and avi
  riff: Ke([82, 73, 70, 70]),
  // "AVI" string literal in hex
  avi: Ke([65, 86, 73]),
  // "WAVE" string literal in hex
  wav: Ke([87, 65, 86, 69]),
  // "ftyp3g" string literal in hex
  "3gp": Ke([102, 116, 121, 112, 51, 103]),
  // "ftyp" string literal in hex
  mp4: Ke([102, 116, 121, 112]),
  // "styp" string literal in hex
  fmp4: Ke([115, 116, 121, 112]),
  // "ftypqt" string literal in hex
  mov: Ke([102, 116, 121, 112, 113, 116]),
  // moov string literal in hex
  moov: Ke([109, 111, 111, 118]),
  // moof string literal in hex
  moof: Ke([109, 111, 111, 102])
}, Ys = {
  aac: function(e) {
    var n = nl(e);
    return Rt(e, [255, 16], {
      offset: n,
      mask: [255, 22]
    });
  },
  mp3: function(e) {
    var n = nl(e);
    return Rt(e, [255, 2], {
      offset: n,
      mask: [255, 6]
    });
  },
  webm: function(e) {
    var n = Qg(e, [Oc.EBML, Oc.DocType])[0];
    return Rt(n, Pn.webm);
  },
  mkv: function(e) {
    var n = Qg(e, [Oc.EBML, Oc.DocType])[0];
    return Rt(n, Pn.matroska);
  },
  mp4: function(e) {
    if (Ys["3gp"](e) || Ys.mov(e))
      return !1;
    if (Rt(e, Pn.mp4, {
      offset: 4
    }) || Rt(e, Pn.fmp4, {
      offset: 4
    }) || Rt(e, Pn.moof, {
      offset: 4
    }) || Rt(e, Pn.moov, {
      offset: 4
    }))
      return !0;
  },
  mov: function(e) {
    return Rt(e, Pn.mov, {
      offset: 4
    });
  },
  "3gp": function(e) {
    return Rt(e, Pn["3gp"], {
      offset: 4
    });
  },
  ac3: function(e) {
    var n = nl(e);
    return Rt(e, Pn.ac3, {
      offset: n
    });
  },
  ts: function(e) {
    if (e.length < 189 && e.length >= 1)
      return e[0] === 71;
    for (var n = 0; n + 188 < e.length && n < 188; ) {
      if (e[n] === 71 && e[n + 188] === 71)
        return !0;
      n += 1;
    }
    return !1;
  },
  flac: function(e) {
    var n = nl(e);
    return Rt(e, Pn.flac, {
      offset: n
    });
  },
  ogg: function(e) {
    return Rt(e, Pn.ogg);
  },
  avi: function(e) {
    return Rt(e, Pn.riff) && Rt(e, Pn.avi, {
      offset: 8
    });
  },
  wav: function(e) {
    return Rt(e, Pn.riff) && Rt(e, Pn.wav, {
      offset: 8
    });
  },
  h264: function(e) {
    return Ete(e, 7, 3).length;
  },
  h265: function(e) {
    return Lte(e, [32, 33], 3).length;
  }
}, yh = Object.keys(Ys).filter(function(t) {
  return t !== "ts" && t !== "h264" && t !== "h265";
}).concat(["ts", "h264", "h265"]);
yh.forEach(function(t) {
  var e = Ys[t];
  Ys[t] = function(n) {
    return e(Ke(n));
  };
});
var Dte = Ys, ap = function(e) {
  e = Ke(e);
  for (var n = 0; n < yh.length; n++) {
    var a = yh[n];
    if (Dte[a](e))
      return a;
  }
  return "";
}, Ite = function(e) {
  return _te(e, ["moof"]).length > 0;
}, Cr = {};
/**
 * @license
 * Video.js 8.21.0 <http://videojs.com/>
 * Copyright Brightcove, Inc. <https://www.brightcove.com/>
 * Available under Apache License Version 2.0
 * <https://github.com/videojs/video.js/blob/main/LICENSE>
 *
 * Includes vtt.js <https://github.com/mozilla/vtt.js>
 * Available under Apache License Version 2.0
 * <https://github.com/mozilla/vtt.js/blob/main/LICENSE>
 */
var _h = "8.21.0";
const gi = {}, ar = function(t, e) {
  return gi[t] = gi[t] || [], e && (gi[t] = gi[t].concat(e)), gi[t];
}, Mte = function(t, e) {
  ar(t, e);
}, J5 = function(t, e) {
  const n = ar(t).indexOf(e);
  return n <= -1 ? !1 : (gi[t] = gi[t].slice(), gi[t].splice(n, 1), !0);
}, Ote = function(t, e) {
  ar(t, [].concat(e).map((n) => {
    const a = (...i) => (J5(t, a), n(...i));
    return a;
  }));
}, yu = {
  prefixed: !0
}, jc = [
  ["requestFullscreen", "exitFullscreen", "fullscreenElement", "fullscreenEnabled", "fullscreenchange", "fullscreenerror", "fullscreen"],
  // WebKit
  ["webkitRequestFullscreen", "webkitExitFullscreen", "webkitFullscreenElement", "webkitFullscreenEnabled", "webkitfullscreenchange", "webkitfullscreenerror", "-webkit-full-screen"]
], Jg = jc[0];
let al;
for (let t = 0; t < jc.length; t++)
  if (jc[t][1] in Me) {
    al = jc[t];
    break;
  }
if (al) {
  for (let t = 0; t < al.length; t++)
    yu[Jg[t]] = al[t];
  yu.prefixed = al[0] !== Jg[0];
}
let Gn = [];
const Pte = (t, e, n) => (a, i, r) => {
  const s = e.levels[i], o = new RegExp(`^(${s})$`);
  let l = t;
  if (a !== "log" && r.unshift(a.toUpperCase() + ":"), n && (l = `%c${t}`, r.unshift(n)), r.unshift(l + ":"), Gn) {
    Gn.push([].concat(r));
    const u = Gn.length - 1e3;
    Gn.splice(0, u > 0 ? u : 0);
  }
  if (!j.console)
    return;
  let c = j.console[a];
  !c && a === "debug" && (c = j.console.info || j.console.log), !(!c || !s || !o.test(a)) && c[Array.isArray(r) ? "apply" : "call"](j.console, r);
};
function Th(t, e = ":", n = "") {
  let a = "info", i;
  function r(...s) {
    i("log", a, s);
  }
  return i = Pte(t, r, n), r.createLogger = (s, o, l) => {
    const c = o !== void 0 ? o : e, u = l !== void 0 ? l : n, f = `${t} ${c} ${s}`;
    return Th(f, c, u);
  }, r.createNewLogger = (s, o, l) => Th(s, o, l), r.levels = {
    all: "debug|log|warn|error",
    off: "",
    debug: "debug|log|warn|error",
    info: "log|warn|error",
    warn: "warn|error",
    error: "error",
    DEFAULT: a
  }, r.level = (s) => {
    if (typeof s == "string") {
      if (!r.levels.hasOwnProperty(s))
        throw new Error(`"${s}" in not a valid log level`);
      a = s;
    }
    return a;
  }, r.history = () => Gn ? [].concat(Gn) : [], r.history.filter = (s) => (Gn || []).filter((o) => new RegExp(`.*${s}.*`).test(o[0])), r.history.clear = () => {
    Gn && (Gn.length = 0);
  }, r.history.disable = () => {
    Gn !== null && (Gn.length = 0, Gn = null);
  }, r.history.enable = () => {
    Gn === null && (Gn = []);
  }, r.error = (...s) => i("error", a, s), r.warn = (...s) => i("warn", a, s), r.debug = (...s) => i("debug", a, s), r;
}
const ut = Th("VIDEOJS"), e3 = ut.createLogger, Bte = Object.prototype.toString, t3 = function(t) {
  return ni(t) ? Object.keys(t) : [];
};
function Ts(t, e) {
  t3(t).forEach((n) => e(t[n], n));
}
function n3(t, e, n = 0) {
  return t3(t).reduce((a, i) => e(a, t[i], i), n);
}
function ni(t) {
  return !!t && typeof t == "object";
}
function js(t) {
  return ni(t) && Bte.call(t) === "[object Object]" && t.constructor === Object;
}
function wt(...t) {
  const e = {};
  return t.forEach((n) => {
    n && Ts(n, (a, i) => {
      if (!js(a)) {
        e[i] = a;
        return;
      }
      js(e[i]) || (e[i] = {}), e[i] = wt(e[i], a);
    });
  }), e;
}
function a3(t = {}) {
  const e = [];
  for (const n in t)
    if (t.hasOwnProperty(n)) {
      const a = t[n];
      e.push(a);
    }
  return e;
}
function md(t, e, n, a = !0) {
  const i = (s) => Object.defineProperty(t, e, {
    value: s,
    enumerable: !0,
    writable: !0
  }), r = {
    configurable: !0,
    enumerable: !0,
    get() {
      const s = n();
      return i(s), s;
    }
  };
  return a && (r.set = i), Object.defineProperty(t, e, r);
}
var Rte = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  each: Ts,
  reduce: n3,
  isObject: ni,
  isPlain: js,
  merge: wt,
  values: a3,
  defineLazyProperty: md
});
let ip = !1, i3 = null, $a = !1, r3, s3 = !1, xs = !1, ws = !1, ai = !1, rp = null, gd = null;
const Nte = !!(j.cast && j.cast.framework && j.cast.framework.CastReceiverContext);
let o3 = null, _u = !1, bd = !1, Tu = !1, vd = !1, xu = !1, wu = !1, ku = !1;
const Ll = !!(co() && ("ontouchstart" in j || j.navigator.maxTouchPoints || j.DocumentTouch && j.document instanceof j.DocumentTouch)), Yi = j.navigator && j.navigator.userAgentData;
Yi && Yi.platform && Yi.brands && ($a = Yi.platform === "Android", xs = !!Yi.brands.find((t) => t.brand === "Microsoft Edge"), ws = !!Yi.brands.find((t) => t.brand === "Chromium"), ai = !xs && ws, rp = gd = (Yi.brands.find((t) => t.brand === "Chromium") || {}).version || null, bd = Yi.platform === "Windows");
if (!ws) {
  const t = j.navigator && j.navigator.userAgent || "";
  ip = /iPod/i.test(t), i3 = function() {
    const e = t.match(/OS (\d+)_/i);
    return e && e[1] ? e[1] : null;
  }(), $a = /Android/i.test(t), r3 = function() {
    const e = t.match(/Android (\d+)(?:\.(\d+))?(?:\.(\d+))*/i);
    if (!e)
      return null;
    const n = e[1] && parseFloat(e[1]), a = e[2] && parseFloat(e[2]);
    return n && a ? parseFloat(e[1] + "." + e[2]) : n || null;
  }(), s3 = /Firefox/i.test(t), xs = /Edg/i.test(t), ws = /Chrome/i.test(t) || /CriOS/i.test(t), ai = !xs && ws, rp = gd = function() {
    const e = t.match(/(Chrome|CriOS)\/(\d+)/);
    return e && e[2] ? parseFloat(e[2]) : null;
  }(), o3 = function() {
    const e = /MSIE\s(\d+)\.\d/.exec(t);
    let n = e && parseFloat(e[1]);
    return !n && /Trident\/7.0/i.test(t) && /rv:11.0/.test(t) && (n = 11), n;
  }(), xu = /Tizen/i.test(t), wu = /Web0S/i.test(t), ku = xu || wu, _u = /Safari/i.test(t) && !ai && !$a && !xs && !ku, bd = /Windows/i.test(t), Tu = /iPad/i.test(t) || _u && Ll && !/iPhone/i.test(t), vd = /iPhone/i.test(t) && !Tu;
}
const En = vd || Tu || ip, yd = (_u || En) && !ai;
var l3 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  get IS_IPOD() {
    return ip;
  },
  get IOS_VERSION() {
    return i3;
  },
  get IS_ANDROID() {
    return $a;
  },
  get ANDROID_VERSION() {
    return r3;
  },
  get IS_FIREFOX() {
    return s3;
  },
  get IS_EDGE() {
    return xs;
  },
  get IS_CHROMIUM() {
    return ws;
  },
  get IS_CHROME() {
    return ai;
  },
  get CHROMIUM_VERSION() {
    return rp;
  },
  get CHROME_VERSION() {
    return gd;
  },
  IS_CHROMECAST_RECEIVER: Nte,
  get IE_VERSION() {
    return o3;
  },
  get IS_SAFARI() {
    return _u;
  },
  get IS_WINDOWS() {
    return bd;
  },
  get IS_IPAD() {
    return Tu;
  },
  get IS_IPHONE() {
    return vd;
  },
  get IS_TIZEN() {
    return xu;
  },
  get IS_WEBOS() {
    return wu;
  },
  get IS_SMART_TV() {
    return ku;
  },
  TOUCH_ENABLED: Ll,
  IS_IOS: En,
  IS_ANY_SAFARI: yd
});
function eb(t) {
  return typeof t == "string" && !!t.trim();
}
function $te(t) {
  if (t.indexOf(" ") >= 0)
    throw new Error("class has illegal whitespace characters");
}
function co() {
  return Me === j.document;
}
function uo(t) {
  return ni(t) && t.nodeType === 1;
}
function c3() {
  try {
    return j.parent !== j.self;
  } catch {
    return !0;
  }
}
function u3(t) {
  return function(e, n) {
    if (!eb(e))
      return Me[t](null);
    eb(n) && (n = Me.querySelector(n));
    const a = uo(n) ? n : Me;
    return a[t] && a[t](e);
  };
}
function et(t = "div", e = {}, n = {}, a) {
  const i = Me.createElement(t);
  return Object.getOwnPropertyNames(e).forEach(function(r) {
    const s = e[r];
    r === "textContent" ? ur(i, s) : (i[r] !== s || r === "tabIndex") && (i[r] = s);
  }), Object.getOwnPropertyNames(n).forEach(function(r) {
    i.setAttribute(r, n[r]);
  }), a && sp(i, a), i;
}
function ur(t, e) {
  return typeof t.textContent > "u" ? t.innerText = e : t.textContent = e, t;
}
function xh(t, e) {
  e.firstChild ? e.insertBefore(t, e.firstChild) : e.appendChild(t);
}
function hl(t, e) {
  return $te(e), t.classList.contains(e);
}
function Dr(t, ...e) {
  return t.classList.add(...e.reduce((n, a) => n.concat(a.split(/\s+/)), [])), t;
}
function _d(t, ...e) {
  return t ? (t.classList.remove(...e.reduce((n, a) => n.concat(a.split(/\s+/)), [])), t) : (ut.warn("removeClass was called with an element that doesn't exist"), null);
}
function d3(t, e, n) {
  return typeof n == "function" && (n = n(t, e)), typeof n != "boolean" && (n = void 0), e.split(/\s+/).forEach((a) => t.classList.toggle(a, n)), t;
}
function h3(t, e) {
  Object.getOwnPropertyNames(e).forEach(function(n) {
    const a = e[n];
    a === null || typeof a > "u" || a === !1 ? t.removeAttribute(n) : t.setAttribute(n, a === !0 ? "" : a);
  });
}
function qi(t) {
  const e = {}, n = ["autoplay", "controls", "playsinline", "loop", "muted", "default", "defaultMuted"];
  if (t && t.attributes && t.attributes.length > 0) {
    const a = t.attributes;
    for (let i = a.length - 1; i >= 0; i--) {
      const r = a[i].name;
      let s = a[i].value;
      n.includes(r) && (s = s !== null), e[r] = s;
    }
  }
  return e;
}
function f3(t, e) {
  return t.getAttribute(e);
}
function Vs(t, e, n) {
  t.setAttribute(e, n);
}
function Td(t, e) {
  t.removeAttribute(e);
}
function p3() {
  Me.body.focus(), Me.onselectstart = function() {
    return !1;
  };
}
function m3() {
  Me.onselectstart = function() {
    return !0;
  };
}
function qs(t) {
  if (t && t.getBoundingClientRect && t.parentNode) {
    const e = t.getBoundingClientRect(), n = {};
    return ["bottom", "height", "left", "right", "top", "width"].forEach((a) => {
      e[a] !== void 0 && (n[a] = e[a]);
    }), n.height || (n.height = parseFloat(Ws(t, "height"))), n.width || (n.width = parseFloat(Ws(t, "width"))), n;
  }
}
function Dl(t) {
  if (!t || t && !t.offsetParent)
    return {
      left: 0,
      top: 0,
      width: 0,
      height: 0
    };
  const e = t.offsetWidth, n = t.offsetHeight;
  let a = 0, i = 0;
  for (; t.offsetParent && t !== Me[yu.fullscreenElement]; )
    a += t.offsetLeft, i += t.offsetTop, t = t.offsetParent;
  return {
    left: a,
    top: i,
    width: e,
    height: n
  };
}
function xd(t, e) {
  const n = {
    x: 0,
    y: 0
  };
  if (En) {
    let u = t;
    for (; u && u.nodeName.toLowerCase() !== "html"; ) {
      const f = Ws(u, "transform");
      if (/^matrix/.test(f)) {
        const m = f.slice(7, -1).split(/,\s/).map(Number);
        n.x += m[4], n.y += m[5];
      } else if (/^matrix3d/.test(f)) {
        const m = f.slice(9, -1).split(/,\s/).map(Number);
        n.x += m[12], n.y += m[13];
      }
      if (u.assignedSlot && u.assignedSlot.parentElement && j.WebKitCSSMatrix) {
        const m = j.getComputedStyle(u.assignedSlot.parentElement).transform, _ = new j.WebKitCSSMatrix(m);
        n.x += _.m41, n.y += _.m42;
      }
      u = u.parentNode || u.host;
    }
  }
  const a = {}, i = Dl(e.target), r = Dl(t), s = r.width, o = r.height;
  let l = e.offsetY - (r.top - i.top), c = e.offsetX - (r.left - i.left);
  return e.changedTouches && (c = e.changedTouches[0].pageX - r.left, l = e.changedTouches[0].pageY + r.top, En && (c -= n.x, l -= n.y)), a.y = 1 - Math.max(0, Math.min(1, l / o)), a.x = Math.max(0, Math.min(1, c / s)), a;
}
function g3(t) {
  return ni(t) && t.nodeType === 3;
}
function wd(t) {
  for (; t.firstChild; )
    t.removeChild(t.firstChild);
  return t;
}
function b3(t) {
  return typeof t == "function" && (t = t()), (Array.isArray(t) ? t : [t]).map((e) => {
    if (typeof e == "function" && (e = e()), uo(e) || g3(e))
      return e;
    if (typeof e == "string" && /\S/.test(e))
      return Me.createTextNode(e);
  }).filter((e) => e);
}
function sp(t, e) {
  return b3(e).forEach((n) => t.appendChild(n)), t;
}
function v3(t, e) {
  return sp(wd(t), e);
}
function Il(t) {
  return t.button === void 0 && t.buttons === void 0 || t.button === 0 && t.buttons === void 0 || t.type === "mouseup" && t.button === 0 && t.buttons === 0 || t.type === "mousedown" && t.button === 0 && t.buttons === 0 ? !0 : !(t.button !== 0 || t.buttons !== 1);
}
const ir = u3("querySelector"), y3 = u3("querySelectorAll");
function Ws(t, e) {
  if (!t || !e)
    return "";
  if (typeof j.getComputedStyle == "function") {
    let n;
    try {
      n = j.getComputedStyle(t);
    } catch {
      return "";
    }
    return n ? n.getPropertyValue(e) || n[e] : "";
  }
  return "";
}
function _3(t) {
  [...Me.styleSheets].forEach((e) => {
    try {
      const n = [...e.cssRules].map((i) => i.cssText).join(""), a = Me.createElement("style");
      a.textContent = n, t.document.head.appendChild(a);
    } catch {
      const a = Me.createElement("link");
      a.rel = "stylesheet", a.type = e.type, a.media = e.media.mediaText, a.href = e.href, t.document.head.appendChild(a);
    }
  });
}
var T3 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  isReal: co,
  isEl: uo,
  isInFrame: c3,
  createEl: et,
  textContent: ur,
  prependTo: xh,
  hasClass: hl,
  addClass: Dr,
  removeClass: _d,
  toggleClass: d3,
  setAttributes: h3,
  getAttributes: qi,
  getAttribute: f3,
  setAttribute: Vs,
  removeAttribute: Td,
  blockTextSelection: p3,
  unblockTextSelection: m3,
  getBoundingClientRect: qs,
  findPosition: Dl,
  getPointerPosition: xd,
  isTextNode: g3,
  emptyEl: wd,
  normalizeContent: b3,
  appendContent: sp,
  insertContent: v3,
  isSingleLeftClick: Il,
  $: ir,
  $$: y3,
  computedStyle: Ws,
  copyStyleSheetsToWindow: _3
});
let x3 = !1, wh;
const Fte = function() {
  if (wh.options.autoSetup === !1)
    return;
  const t = Array.prototype.slice.call(Me.getElementsByTagName("video")), e = Array.prototype.slice.call(Me.getElementsByTagName("audio")), n = Array.prototype.slice.call(Me.getElementsByTagName("video-js")), a = t.concat(e, n);
  if (a && a.length > 0)
    for (let i = 0, r = a.length; i < r; i++) {
      const s = a[i];
      if (s && s.getAttribute)
        s.player === void 0 && s.getAttribute("data-setup") !== null && wh(s);
      else {
        kh(1);
        break;
      }
    }
  else x3 || kh(1);
};
function kh(t, e) {
  co() && (e && (wh = e), j.setTimeout(Fte, t));
}
function Ch() {
  x3 = !0, j.removeEventListener("load", Ch);
}
co() && (Me.readyState === "complete" ? Ch() : j.addEventListener("load", Ch));
const w3 = function(t) {
  const e = Me.createElement("style");
  return e.className = t, e;
}, k3 = function(t, e) {
  t.styleSheet ? t.styleSheet.cssText = e : t.textContent = e;
};
var zn = /* @__PURE__ */ new WeakMap();
const zte = 3;
let Ute = zte;
function xa() {
  return Ute++;
}
function tb(t, e) {
  if (!zn.has(t))
    return;
  const n = zn.get(t);
  n.handlers[e].length === 0 && (delete n.handlers[e], t.removeEventListener ? t.removeEventListener(e, n.dispatcher, !1) : t.detachEvent && t.detachEvent("on" + e, n.dispatcher)), Object.getOwnPropertyNames(n.handlers).length <= 0 && (delete n.handlers, delete n.dispatcher, delete n.disabled), Object.getOwnPropertyNames(n).length === 0 && zn.delete(t);
}
function op(t, e, n, a) {
  n.forEach(function(i) {
    t(e, i, a);
  });
}
function kd(t) {
  if (t.fixed_)
    return t;
  function e() {
    return !0;
  }
  function n() {
    return !1;
  }
  if (!t || !t.isPropagationStopped || !t.isImmediatePropagationStopped) {
    const a = t || j.event;
    t = {};
    const i = ["layerX", "layerY", "keyLocation", "path", "webkitMovementX", "webkitMovementY", "mozPressure", "mozInputSource"];
    for (const r in a)
      i.includes(r) || r === "returnValue" && a.preventDefault || (t[r] = a[r]);
    if (t.target || (t.target = t.srcElement || Me), t.relatedTarget || (t.relatedTarget = t.fromElement === t.target ? t.toElement : t.fromElement), t.preventDefault = function() {
      a.preventDefault && a.preventDefault(), t.returnValue = !1, a.returnValue = !1, t.defaultPrevented = !0;
    }, t.defaultPrevented = !1, t.stopPropagation = function() {
      a.stopPropagation && a.stopPropagation(), t.cancelBubble = !0, a.cancelBubble = !0, t.isPropagationStopped = e;
    }, t.isPropagationStopped = n, t.stopImmediatePropagation = function() {
      a.stopImmediatePropagation && a.stopImmediatePropagation(), t.isImmediatePropagationStopped = e, t.stopPropagation();
    }, t.isImmediatePropagationStopped = n, t.clientX !== null && t.clientX !== void 0) {
      const r = Me.documentElement, s = Me.body;
      t.pageX = t.clientX + (r && r.scrollLeft || s && s.scrollLeft || 0) - (r && r.clientLeft || s && s.clientLeft || 0), t.pageY = t.clientY + (r && r.scrollTop || s && s.scrollTop || 0) - (r && r.clientTop || s && s.clientTop || 0);
    }
    t.which = t.charCode || t.keyCode, t.button !== null && t.button !== void 0 && (t.button = t.button & 1 ? 0 : t.button & 4 ? 1 : t.button & 2 ? 2 : 0);
  }
  return t.fixed_ = !0, t;
}
let Pc;
const Hte = function() {
  if (typeof Pc != "boolean") {
    Pc = !1;
    try {
      const t = Object.defineProperty({}, "passive", {
        get() {
          Pc = !0;
        }
      });
      j.addEventListener("test", null, t), j.removeEventListener("test", null, t);
    } catch {
    }
  }
  return Pc;
}, Yte = ["touchstart", "touchmove"];
function ha(t, e, n) {
  if (Array.isArray(e))
    return op(ha, t, e, n);
  zn.has(t) || zn.set(t, {});
  const a = zn.get(t);
  if (a.handlers || (a.handlers = {}), a.handlers[e] || (a.handlers[e] = []), n.guid || (n.guid = xa()), a.handlers[e].push(n), a.dispatcher || (a.disabled = !1, a.dispatcher = function(i, r) {
    if (a.disabled)
      return;
    i = kd(i);
    const s = a.handlers[i.type];
    if (s) {
      const o = s.slice(0);
      for (let l = 0, c = o.length; l < c && !i.isImmediatePropagationStopped(); l++)
        try {
          o[l].call(t, i, r);
        } catch (u) {
          ut.error(u);
        }
    }
  }), a.handlers[e].length === 1)
    if (t.addEventListener) {
      let i = !1;
      Hte() && Yte.indexOf(e) > -1 && (i = {
        passive: !0
      }), t.addEventListener(e, a.dispatcher, i);
    } else t.attachEvent && t.attachEvent("on" + e, a.dispatcher);
}
function Ln(t, e, n) {
  if (!zn.has(t))
    return;
  const a = zn.get(t);
  if (!a.handlers)
    return;
  if (Array.isArray(e))
    return op(Ln, t, e, n);
  const i = function(s, o) {
    a.handlers[o] = [], tb(s, o);
  };
  if (e === void 0) {
    for (const s in a.handlers)
      Object.prototype.hasOwnProperty.call(a.handlers || {}, s) && i(t, s);
    return;
  }
  const r = a.handlers[e];
  if (r) {
    if (!n) {
      i(t, e);
      return;
    }
    if (n.guid)
      for (let s = 0; s < r.length; s++)
        r[s].guid === n.guid && r.splice(s--, 1);
    tb(t, e);
  }
}
function ho(t, e, n) {
  const a = zn.has(t) ? zn.get(t) : {}, i = t.parentNode || t.ownerDocument;
  if (typeof e == "string" ? e = {
    type: e,
    target: t
  } : e.target || (e.target = t), e = kd(e), a.dispatcher && a.dispatcher.call(t, e, n), i && !e.isPropagationStopped() && e.bubbles === !0)
    ho.call(null, i, e, n);
  else if (!i && !e.defaultPrevented && e.target && e.target[e.type]) {
    zn.has(e.target) || zn.set(e.target, {});
    const r = zn.get(e.target);
    e.target[e.type] && (r.disabled = !0, typeof e.target[e.type] == "function" && e.target[e.type](), r.disabled = !1);
  }
  return !e.defaultPrevented;
}
function Cd(t, e, n) {
  if (Array.isArray(e))
    return op(Cd, t, e, n);
  const a = function() {
    Ln(t, e, a), n.apply(this, arguments);
  };
  a.guid = n.guid = n.guid || xa(), ha(t, e, a);
}
function lp(t, e, n) {
  const a = function() {
    Ln(t, e, a), n.apply(this, arguments);
  };
  a.guid = n.guid = n.guid || xa(), ha(t, e, a);
}
var jte = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  fixEvent: kd,
  on: ha,
  off: Ln,
  trigger: ho,
  one: Cd,
  any: lp
});
const wa = 30, Et = function(t, e, n) {
  e.guid || (e.guid = xa());
  const a = e.bind(t);
  return a.guid = n ? n + "_" + e.guid : e.guid, a;
}, ii = function(t, e) {
  let n = j.performance.now();
  return function(...i) {
    const r = j.performance.now();
    r - n >= e && (t(...i), n = r);
  };
}, C3 = function(t, e, n, a = j) {
  let i;
  const r = () => {
    a.clearTimeout(i), i = null;
  }, s = function() {
    const o = this, l = arguments;
    let c = function() {
      i = null, c = null, n || t.apply(o, l);
    };
    !i && n && t.apply(o, l), a.clearTimeout(i), i = a.setTimeout(c, e);
  };
  return s.cancel = r, s;
};
var Vte = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  UPDATE_REFRESH_INTERVAL: wa,
  bind_: Et,
  throttle: ii,
  debounce: C3
});
let Wo;
class fa {
  /**
   * Adds an `event listener` to an instance of an `EventTarget`. An `event listener` is a
   * function that will get called when an event with a certain name gets triggered.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} fn
   *        The function to call with `EventTarget`s
   */
  on(e, n) {
    const a = this.addEventListener;
    this.addEventListener = () => {
    }, ha(this, e, n), this.addEventListener = a;
  }
  /**
   * Removes an `event listener` for a specific event from an instance of `EventTarget`.
   * This makes it so that the `event listener` will no longer get called when the
   * named event happens.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} fn
   *        The function to remove.
   */
  off(e, n) {
    Ln(this, e, n);
  }
  /**
   * This function will add an `event listener` that gets triggered only once. After the
   * first trigger it will get removed. This is like adding an `event listener`
   * with {@link EventTarget#on} that calls {@link EventTarget#off} on itself.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} fn
   *        The function to be called once for each event name.
   */
  one(e, n) {
    const a = this.addEventListener;
    this.addEventListener = () => {
    }, Cd(this, e, n), this.addEventListener = a;
  }
  /**
   * This function will add an `event listener` that gets triggered only once and is
   * removed from all events. This is like adding an array of `event listener`s
   * with {@link EventTarget#on} that calls {@link EventTarget#off} on all events the
   * first time it is triggered.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} fn
   *        The function to be called once for each event name.
   */
  any(e, n) {
    const a = this.addEventListener;
    this.addEventListener = () => {
    }, lp(this, e, n), this.addEventListener = a;
  }
  /**
   * This function causes an event to happen. This will then cause any `event listeners`
   * that are waiting for that event, to get called. If there are no `event listeners`
   * for an event then nothing will happen.
   *
   * If the name of the `Event` that is being triggered is in `EventTarget.allowedEvents_`.
   * Trigger will also call the `on` + `uppercaseEventName` function.
   *
   * Example:
   * 'click' is in `EventTarget.allowedEvents_`, so, trigger will attempt to call
   * `onClick` if it exists.
   *
   * @param {string|EventTarget~Event|Object} event
   *        The name of the event, an `Event`, or an object with a key of type set to
   *        an event name.
   */
  trigger(e) {
    const n = e.type || e;
    typeof e == "string" && (e = {
      type: n
    }), e = kd(e), this.allowedEvents_[n] && this["on" + n] && this["on" + n](e), ho(this, e);
  }
  queueTrigger(e) {
    Wo || (Wo = /* @__PURE__ */ new Map());
    const n = e.type || e;
    let a = Wo.get(this);
    a || (a = /* @__PURE__ */ new Map(), Wo.set(this, a));
    const i = a.get(n);
    a.delete(n), j.clearTimeout(i);
    const r = j.setTimeout(() => {
      a.delete(n), a.size === 0 && (a = null, Wo.delete(this)), this.trigger(e);
    }, 0);
    a.set(n, r);
  }
}
fa.prototype.allowedEvents_ = {};
fa.prototype.addEventListener = fa.prototype.on;
fa.prototype.removeEventListener = fa.prototype.off;
fa.prototype.dispatchEvent = fa.prototype.trigger;
const Sd = (t) => typeof t.name == "function" ? t.name() : typeof t.name == "string" ? t.name : t.name_ ? t.name_ : t.constructor && t.constructor.name ? t.constructor.name : typeof t, xi = (t) => t instanceof fa || !!t.eventBusEl_ && ["on", "one", "off", "trigger"].every((e) => typeof t[e] == "function"), qte = (t, e) => {
  xi(t) ? e() : (t.eventedCallbacks || (t.eventedCallbacks = []), t.eventedCallbacks.push(e));
}, Sh = (t) => (
  // The regex here verifies that the `type` contains at least one non-
  // whitespace character.
  typeof t == "string" && /\S/.test(t) || Array.isArray(t) && !!t.length
), Cu = (t, e, n) => {
  if (!t || !t.nodeName && !xi(t))
    throw new Error(`Invalid target for ${Sd(e)}#${n}; must be a DOM node or evented object.`);
}, S3 = (t, e, n) => {
  if (!Sh(t))
    throw new Error(`Invalid event type for ${Sd(e)}#${n}; must be a non-empty string or array.`);
}, A3 = (t, e, n) => {
  if (typeof t != "function")
    throw new Error(`Invalid listener for ${Sd(e)}#${n}; must be a function.`);
}, E0 = (t, e, n) => {
  const a = e.length < 3 || e[0] === t || e[0] === t.eventBusEl_;
  let i, r, s;
  return a ? (i = t.eventBusEl_, e.length >= 3 && e.shift(), [r, s] = e) : (i = e[0], r = e[1], s = e[2]), Cu(i, t, n), S3(r, t, n), A3(s, t, n), s = Et(t, s), {
    isTargetingSelf: a,
    target: i,
    type: r,
    listener: s
  };
}, mr = (t, e, n, a) => {
  Cu(t, t, e), t.nodeName ? jte[e](t, n, a) : t[e](n, a);
}, Wte = {
  /**
   * Add a listener to an event (or events) on this object or another evented
   * object.
   *
   * @param  {string|Array|Element|Object} targetOrType
   *         If this is a string or array, it represents the event type(s)
   *         that will trigger the listener.
   *
   *         Another evented object can be passed here instead, which will
   *         cause the listener to listen for events on _that_ object.
   *
   *         In either case, the listener's `this` value will be bound to
   *         this object.
   *
   * @param  {string|Array|Function} typeOrListener
   *         If the first argument was a string or array, this should be the
   *         listener function. Otherwise, this is a string or array of event
   *         type(s).
   *
   * @param  {Function} [listener]
   *         If the first argument was another evented object, this will be
   *         the listener function.
   */
  on(...t) {
    const {
      isTargetingSelf: e,
      target: n,
      type: a,
      listener: i
    } = E0(this, t, "on");
    if (mr(n, "on", a, i), !e) {
      const r = () => this.off(n, a, i);
      r.guid = i.guid;
      const s = () => this.off("dispose", r);
      s.guid = i.guid, mr(this, "on", "dispose", r), mr(n, "on", "dispose", s);
    }
  },
  /**
   * Add a listener to an event (or events) on this object or another evented
   * object. The listener will be called once per event and then removed.
   *
   * @param  {string|Array|Element|Object} targetOrType
   *         If this is a string or array, it represents the event type(s)
   *         that will trigger the listener.
   *
   *         Another evented object can be passed here instead, which will
   *         cause the listener to listen for events on _that_ object.
   *
   *         In either case, the listener's `this` value will be bound to
   *         this object.
   *
   * @param  {string|Array|Function} typeOrListener
   *         If the first argument was a string or array, this should be the
   *         listener function. Otherwise, this is a string or array of event
   *         type(s).
   *
   * @param  {Function} [listener]
   *         If the first argument was another evented object, this will be
   *         the listener function.
   */
  one(...t) {
    const {
      isTargetingSelf: e,
      target: n,
      type: a,
      listener: i
    } = E0(this, t, "one");
    if (e)
      mr(n, "one", a, i);
    else {
      const r = (...s) => {
        this.off(n, a, r), i.apply(null, s);
      };
      r.guid = i.guid, mr(n, "one", a, r);
    }
  },
  /**
   * Add a listener to an event (or events) on this object or another evented
   * object. The listener will only be called once for the first event that is triggered
   * then removed.
   *
   * @param  {string|Array|Element|Object} targetOrType
   *         If this is a string or array, it represents the event type(s)
   *         that will trigger the listener.
   *
   *         Another evented object can be passed here instead, which will
   *         cause the listener to listen for events on _that_ object.
   *
   *         In either case, the listener's `this` value will be bound to
   *         this object.
   *
   * @param  {string|Array|Function} typeOrListener
   *         If the first argument was a string or array, this should be the
   *         listener function. Otherwise, this is a string or array of event
   *         type(s).
   *
   * @param  {Function} [listener]
   *         If the first argument was another evented object, this will be
   *         the listener function.
   */
  any(...t) {
    const {
      isTargetingSelf: e,
      target: n,
      type: a,
      listener: i
    } = E0(this, t, "any");
    if (e)
      mr(n, "any", a, i);
    else {
      const r = (...s) => {
        this.off(n, a, r), i.apply(null, s);
      };
      r.guid = i.guid, mr(n, "any", a, r);
    }
  },
  /**
   * Removes listener(s) from event(s) on an evented object.
   *
   * @param  {string|Array|Element|Object} [targetOrType]
   *         If this is a string or array, it represents the event type(s).
   *
   *         Another evented object can be passed here instead, in which case
   *         ALL 3 arguments are _required_.
   *
   * @param  {string|Array|Function} [typeOrListener]
   *         If the first argument was a string or array, this may be the
   *         listener function. Otherwise, this is a string or array of event
   *         type(s).
   *
   * @param  {Function} [listener]
   *         If the first argument was another evented object, this will be
   *         the listener function; otherwise, _all_ listeners bound to the
   *         event type(s) will be removed.
   */
  off(t, e, n) {
    if (!t || Sh(t))
      Ln(this.eventBusEl_, t, e);
    else {
      const a = t, i = e;
      Cu(a, this, "off"), S3(i, this, "off"), A3(n, this, "off"), n = Et(this, n), this.off("dispose", n), a.nodeName ? (Ln(a, i, n), Ln(a, "dispose", n)) : xi(a) && (a.off(i, n), a.off("dispose", n));
    }
  },
  /**
   * Fire an event on this evented object, causing its listeners to be called.
   *
   * @param   {string|Object} event
   *          An event type or an object with a type property.
   *
   * @param   {Object} [hash]
   *          An additional object to pass along to listeners.
   *
   * @return {boolean}
   *          Whether or not the default behavior was prevented.
   */
  trigger(t, e) {
    Cu(this.eventBusEl_, this, "trigger");
    const n = t && typeof t != "string" ? t.type : t;
    if (!Sh(n))
      throw new Error(`Invalid event type for ${Sd(this)}#trigger; must be a non-empty string or object with a type key that has a non-empty value.`);
    return ho(this.eventBusEl_, t, e);
  }
};
function cp(t, e = {}) {
  const {
    eventBusKey: n
  } = e;
  if (n) {
    if (!t[n].nodeName)
      throw new Error(`The eventBusKey "${n}" does not refer to an element.`);
    t.eventBusEl_ = t[n];
  } else
    t.eventBusEl_ = et("span", {
      className: "vjs-event-bus"
    });
  return Object.assign(t, Wte), t.eventedCallbacks && t.eventedCallbacks.forEach((a) => {
    a();
  }), t.on("dispose", () => {
    t.off(), [t, t.el_, t.eventBusEl_].forEach(function(a) {
      a && zn.has(a) && zn.delete(a);
    }), j.setTimeout(() => {
      t.eventBusEl_ = null;
    }, 0);
  }), t;
}
const Gte = {
  /**
   * A hash containing arbitrary keys and values representing the state of
   * the object.
   *
   * @type {Object}
   */
  state: {},
  /**
   * Set the state of an object by mutating its
   * {@link module:stateful~StatefulMixin.state|state} object in place.
   *
   * @fires   module:stateful~StatefulMixin#statechanged
   * @param   {Object|Function} stateUpdates
   *          A new set of properties to shallow-merge into the plugin state.
   *          Can be a plain object or a function returning a plain object.
   *
   * @return {Object|undefined}
   *          An object containing changes that occurred. If no changes
   *          occurred, returns `undefined`.
   */
  setState(t) {
    typeof t == "function" && (t = t());
    let e;
    return Ts(t, (n, a) => {
      this.state[a] !== n && (e = e || {}, e[a] = {
        from: this.state[a],
        to: n
      }), this.state[a] = n;
    }), e && xi(this) && this.trigger({
      changes: e,
      type: "statechanged"
    }), e;
  }
};
function E3(t, e) {
  return Object.assign(t, Gte), t.state = Object.assign({}, t.state, e), typeof t.handleStateChanged == "function" && xi(t) && t.on("statechanged", t.handleStateChanged), t;
}
const fl = function(t) {
  return typeof t != "string" ? t : t.replace(/./, (e) => e.toLowerCase());
}, qt = function(t) {
  return typeof t != "string" ? t : t.replace(/./, (e) => e.toUpperCase());
}, L3 = function(t, e) {
  return qt(t) === qt(e);
};
var Xte = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  toLowerCase: fl,
  toTitleCase: qt,
  titleCaseEquals: L3
});
class ye {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of component options.
   *
   * @param {Object[]} [options.children]
   *        An array of children objects to initialize this component with. Children objects have
   *        a name property that will be used if more than one component of the same type needs to be
   *        added.
   *
   * @param  {string} [options.className]
   *         A class or space separated list of classes to add the component
   *
   * @param {ReadyCallback} [ready]
   *        Function that gets called when the `Component` is ready.
   */
  constructor(e, n, a) {
    if (!e && this.play ? this.player_ = e = this : this.player_ = e, this.isDisposed_ = !1, this.parentComponent_ = null, this.options_ = wt({}, this.options_), n = this.options_ = wt(this.options_, n), this.id_ = n.id || n.el && n.el.id, !this.id_) {
      const i = e && e.id && e.id() || "no_player";
      this.id_ = `${i}_component_${xa()}`;
    }
    this.name_ = n.name || null, n.el ? this.el_ = n.el : n.createEl !== !1 && (this.el_ = this.createEl()), n.className && this.el_ && n.className.split(" ").forEach((i) => this.addClass(i)), ["on", "off", "one", "any", "trigger"].forEach((i) => {
      this[i] = void 0;
    }), n.evented !== !1 && (cp(this, {
      eventBusKey: this.el_ ? "el_" : null
    }), this.handleLanguagechange = this.handleLanguagechange.bind(this), this.on(this.player_, "languagechange", this.handleLanguagechange)), E3(this, this.constructor.defaultState), this.children_ = [], this.childIndex_ = {}, this.childNameIndex_ = {}, this.setTimeoutIds_ = /* @__PURE__ */ new Set(), this.setIntervalIds_ = /* @__PURE__ */ new Set(), this.rafIds_ = /* @__PURE__ */ new Set(), this.namedRafs_ = /* @__PURE__ */ new Map(), this.clearingTimersOnDispose_ = !1, n.initChildren !== !1 && this.initChildren(), this.ready(a), n.reportTouchActivity !== !1 && this.enableTouchActivity();
  }
  // `on`, `off`, `one`, `any` and `trigger` are here so tsc includes them in definitions.
  // They are replaced or removed in the constructor
  /**
   * Adds an `event listener` to an instance of an `EventTarget`. An `event listener` is a
   * function that will get called when an event with a certain name gets triggered.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} fn
   *        The function to call with `EventTarget`s
   */
  /**
   * Removes an `event listener` for a specific event from an instance of `EventTarget`.
   * This makes it so that the `event listener` will no longer get called when the
   * named event happens.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} [fn]
   *        The function to remove. If not specified, all listeners managed by Video.js will be removed.
   */
  /**
   * This function will add an `event listener` that gets triggered only once. After the
   * first trigger it will get removed. This is like adding an `event listener`
   * with {@link EventTarget#on} that calls {@link EventTarget#off} on itself.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} fn
   *        The function to be called once for each event name.
   */
  /**
   * This function will add an `event listener` that gets triggered only once and is
   * removed from all events. This is like adding an array of `event listener`s
   * with {@link EventTarget#on} that calls {@link EventTarget#off} on all events the
   * first time it is triggered.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} fn
   *        The function to be called once for each event name.
   */
  /**
   * This function causes an event to happen. This will then cause any `event listeners`
   * that are waiting for that event, to get called. If there are no `event listeners`
   * for an event then nothing will happen.
   *
   * If the name of the `Event` that is being triggered is in `EventTarget.allowedEvents_`.
   * Trigger will also call the `on` + `uppercaseEventName` function.
   *
   * Example:
   * 'click' is in `EventTarget.allowedEvents_`, so, trigger will attempt to call
   * `onClick` if it exists.
   *
   * @param {string|Event|Object} event
   *        The name of the event, an `Event`, or an object with a key of type set to
   *        an event name.
   *
   * @param {Object} [hash]
   *        Optionally extra argument to pass through to an event listener
   */
  /**
   * Dispose of the `Component` and all child components.
   *
   * @fires Component#dispose
   *
   * @param {Object} options
   * @param {Element} options.originalEl element with which to replace player element
   */
  dispose(e = {}) {
    if (!this.isDisposed_) {
      if (this.readyQueue_ && (this.readyQueue_.length = 0), this.trigger({
        type: "dispose",
        bubbles: !1
      }), this.isDisposed_ = !0, this.children_)
        for (let n = this.children_.length - 1; n >= 0; n--)
          this.children_[n].dispose && this.children_[n].dispose();
      this.children_ = null, this.childIndex_ = null, this.childNameIndex_ = null, this.parentComponent_ = null, this.el_ && (this.el_.parentNode && (e.restoreEl ? this.el_.parentNode.replaceChild(e.restoreEl, this.el_) : this.el_.parentNode.removeChild(this.el_)), this.el_ = null), this.player_ = null;
    }
  }
  /**
   * Determine whether or not this component has been disposed.
   *
   * @return {boolean}
   *         If the component has been disposed, will be `true`. Otherwise, `false`.
   */
  isDisposed() {
    return !!this.isDisposed_;
  }
  /**
   * Return the {@link Player} that the `Component` has attached to.
   *
   * @return {Player}
   *         The player that this `Component` has attached to.
   */
  player() {
    return this.player_;
  }
  /**
   * Deep merge of options objects with new options.
   * > Note: When both `obj` and `options` contain properties whose values are objects.
   *         The two properties get merged using {@link module:obj.merge}
   *
   * @param {Object} obj
   *        The object that contains new options.
   *
   * @return {Object}
   *         A new object of `this.options_` and `obj` merged together.
   */
  options(e) {
    return e ? (this.options_ = wt(this.options_, e), this.options_) : this.options_;
  }
  /**
   * Get the `Component`s DOM element
   *
   * @return {Element}
   *         The DOM element for this `Component`.
   */
  el() {
    return this.el_;
  }
  /**
   * Create the `Component`s DOM element.
   *
   * @param {string} [tagName]
   *        Element's DOM node type. e.g. 'div'
   *
   * @param {Object} [properties]
   *        An object of properties that should be set.
   *
   * @param {Object} [attributes]
   *        An object of attributes that should be set.
   *
   * @return {Element}
   *         The element that gets created.
   */
  createEl(e, n, a) {
    return et(e, n, a);
  }
  /**
   * Localize a string given the string in english.
   *
   * If tokens are provided, it'll try and run a simple token replacement on the provided string.
   * The tokens it looks for look like `{1}` with the index being 1-indexed into the tokens array.
   *
   * If a `defaultValue` is provided, it'll use that over `string`,
   * if a value isn't found in provided language files.
   * This is useful if you want to have a descriptive key for token replacement
   * but have a succinct localized string and not require `en.json` to be included.
   *
   * Currently, it is used for the progress bar timing.
   * ```js
   * {
   *   "progress bar timing: currentTime={1} duration={2}": "{1} of {2}"
   * }
   * ```
   * It is then used like so:
   * ```js
   * this.localize('progress bar timing: currentTime={1} duration{2}',
   *               [this.player_.currentTime(), this.player_.duration()],
   *               '{1} of {2}');
   * ```
   *
   * Which outputs something like: `01:23 of 24:56`.
   *
   *
   * @param {string} string
   *        The string to localize and the key to lookup in the language files.
   * @param {string[]} [tokens]
   *        If the current item has token replacements, provide the tokens here.
   * @param {string} [defaultValue]
   *        Defaults to `string`. Can be a default value to use for token replacement
   *        if the lookup key is needed to be separate.
   *
   * @return {string}
   *         The localized string or if no localization exists the english string.
   */
  localize(e, n, a = e) {
    const i = this.player_.language && this.player_.language(), r = this.player_.languages && this.player_.languages(), s = r && r[i], o = i && i.split("-")[0], l = r && r[o];
    let c = a;
    return s && s[e] ? c = s[e] : l && l[e] && (c = l[e]), n && (c = c.replace(/\{(\d+)\}/g, function(u, f) {
      const m = n[f - 1];
      let _ = m;
      return typeof m > "u" && (_ = u), _;
    })), c;
  }
  /**
   * Handles language change for the player in components. Should be overridden by sub-components.
   *
   * @abstract
   */
  handleLanguagechange() {
  }
  /**
   * Return the `Component`s DOM element. This is where children get inserted.
   * This will usually be the the same as the element returned in {@link Component#el}.
   *
   * @return {Element}
   *         The content element for this `Component`.
   */
  contentEl() {
    return this.contentEl_ || this.el_;
  }
  /**
   * Get this `Component`s ID
   *
   * @return {string}
   *         The id of this `Component`
   */
  id() {
    return this.id_;
  }
  /**
   * Get the `Component`s name. The name gets used to reference the `Component`
   * and is set during registration.
   *
   * @return {string}
   *         The name of this `Component`.
   */
  name() {
    return this.name_;
  }
  /**
   * Get an array of all child components
   *
   * @return {Array}
   *         The children
   */
  children() {
    return this.children_;
  }
  /**
   * Returns the child `Component` with the given `id`.
   *
   * @param {string} id
   *        The id of the child `Component` to get.
   *
   * @return {Component|undefined}
   *         The child `Component` with the given `id` or undefined.
   */
  getChildById(e) {
    return this.childIndex_[e];
  }
  /**
   * Returns the child `Component` with the given `name`.
   *
   * @param {string} name
   *        The name of the child `Component` to get.
   *
   * @return {Component|undefined}
   *         The child `Component` with the given `name` or undefined.
   */
  getChild(e) {
    if (e)
      return this.childNameIndex_[e];
  }
  /**
   * Returns the descendant `Component` following the givent
   * descendant `names`. For instance ['foo', 'bar', 'baz'] would
   * try to get 'foo' on the current component, 'bar' on the 'foo'
   * component and 'baz' on the 'bar' component and return undefined
   * if any of those don't exist.
   *
   * @param {...string[]|...string} names
   *        The name of the child `Component` to get.
   *
   * @return {Component|undefined}
   *         The descendant `Component` following the given descendant
   *         `names` or undefined.
   */
  getDescendant(...e) {
    e = e.reduce((a, i) => a.concat(i), []);
    let n = this;
    for (let a = 0; a < e.length; a++)
      if (n = n.getChild(e[a]), !n || !n.getChild)
        return;
    return n;
  }
  /**
   * Adds an SVG icon element to another element or component.
   *
   * @param {string} iconName
   *        The name of icon. A list of all the icon names can be found at 'sandbox/svg-icons.html'
   *
   * @param {Element} [el=this.el()]
   *        Element to set the title on. Defaults to the current Component's element.
   *
   * @return {Element}
   *        The newly created icon element.
   */
  setIcon(e, n = this.el()) {
    if (!this.player_.options_.experimentalSvgIcons)
      return;
    const a = "http://www.w3.org/2000/svg", i = et("span", {
      className: "vjs-icon-placeholder vjs-svg-icon"
    }, {
      "aria-hidden": "true"
    }), r = Me.createElementNS(a, "svg");
    r.setAttributeNS(null, "viewBox", "0 0 512 512");
    const s = Me.createElementNS(a, "use");
    return r.appendChild(s), s.setAttributeNS(null, "href", `#vjs-icon-${e}`), i.appendChild(r), this.iconIsSet_ ? n.replaceChild(i, n.querySelector(".vjs-icon-placeholder")) : n.appendChild(i), this.iconIsSet_ = !0, i;
  }
  /**
   * Add a child `Component` inside the current `Component`.
   *
   * @param {string|Component} child
   *        The name or instance of a child to add.
   *
   * @param {Object} [options={}]
   *        The key/value store of options that will get passed to children of
   *        the child.
   *
   * @param {number} [index=this.children_.length]
   *        The index to attempt to add a child into.
   *
   *
   * @return {Component}
   *         The `Component` that gets added as a child. When using a string the
   *         `Component` will get created by this process.
   */
  addChild(e, n = {}, a = this.children_.length) {
    let i, r;
    if (typeof e == "string") {
      r = qt(e);
      const s = n.componentClass || r;
      n.name = r;
      const o = ye.getComponent(s);
      if (!o)
        throw new Error(`Component ${s} does not exist`);
      if (typeof o != "function")
        return null;
      i = new o(this.player_ || this, n);
    } else
      i = e;
    if (i.parentComponent_ && i.parentComponent_.removeChild(i), this.children_.splice(a, 0, i), i.parentComponent_ = this, typeof i.id == "function" && (this.childIndex_[i.id()] = i), r = r || i.name && qt(i.name()), r && (this.childNameIndex_[r] = i, this.childNameIndex_[fl(r)] = i), typeof i.el == "function" && i.el()) {
      let s = null;
      this.children_[a + 1] && (this.children_[a + 1].el_ ? s = this.children_[a + 1].el_ : uo(this.children_[a + 1]) && (s = this.children_[a + 1])), this.contentEl().insertBefore(i.el(), s);
    }
    return i;
  }
  /**
   * Remove a child `Component` from this `Component`s list of children. Also removes
   * the child `Component`s element from this `Component`s element.
   *
   * @param {Component} component
   *        The child `Component` to remove.
   */
  removeChild(e) {
    if (typeof e == "string" && (e = this.getChild(e)), !e || !this.children_)
      return;
    let n = !1;
    for (let i = this.children_.length - 1; i >= 0; i--)
      if (this.children_[i] === e) {
        n = !0, this.children_.splice(i, 1);
        break;
      }
    if (!n)
      return;
    e.parentComponent_ = null, this.childIndex_[e.id()] = null, this.childNameIndex_[qt(e.name())] = null, this.childNameIndex_[fl(e.name())] = null;
    const a = e.el();
    a && a.parentNode === this.contentEl() && this.contentEl().removeChild(e.el());
  }
  /**
   * Add and initialize default child `Component`s based upon options.
   */
  initChildren() {
    const e = this.options_.children;
    if (e) {
      const n = this.options_, a = (s) => {
        const o = s.name;
        let l = s.opts;
        if (n[o] !== void 0 && (l = n[o]), l === !1)
          return;
        l === !0 && (l = {}), l.playerOptions = this.options_.playerOptions;
        const c = this.addChild(o, l);
        c && (this[o] = c);
      };
      let i;
      const r = ye.getComponent("Tech");
      Array.isArray(e) ? i = e : i = Object.keys(e), i.concat(Object.keys(this.options_).filter(function(s) {
        return !i.some(function(o) {
          return typeof o == "string" ? s === o : s === o.name;
        });
      })).map((s) => {
        let o, l;
        return typeof s == "string" ? (o = s, l = e[o] || this.options_[o] || {}) : (o = s.name, l = s), {
          name: o,
          opts: l
        };
      }).filter((s) => {
        const o = ye.getComponent(s.opts.componentClass || qt(s.name));
        return o && !r.isTech(o);
      }).forEach(a);
    }
  }
  /**
   * Builds the default DOM class name. Should be overridden by sub-components.
   *
   * @return {string}
   *         The DOM class name for this object.
   *
   * @abstract
   */
  buildCSSClass() {
    return "";
  }
  /**
   * Bind a listener to the component's ready state.
   * Different from event listeners in that if the ready event has already happened
   * it will trigger the function immediately.
   *
   * @param {ReadyCallback} fn
   *        Function that gets called when the `Component` is ready.
   */
  ready(e, n = !1) {
    if (e) {
      if (!this.isReady_) {
        this.readyQueue_ = this.readyQueue_ || [], this.readyQueue_.push(e);
        return;
      }
      n ? e.call(this) : this.setTimeout(e, 1);
    }
  }
  /**
   * Trigger all the ready listeners for this `Component`.
   *
   * @fires Component#ready
   */
  triggerReady() {
    this.isReady_ = !0, this.setTimeout(function() {
      const e = this.readyQueue_;
      this.readyQueue_ = [], e && e.length > 0 && e.forEach(function(n) {
        n.call(this);
      }, this), this.trigger("ready");
    }, 1);
  }
  /**
   * Find a single DOM element matching a `selector`. This can be within the `Component`s
   * `contentEl()` or another custom context.
   *
   * @param {string} selector
   *        A valid CSS selector, which will be passed to `querySelector`.
   *
   * @param {Element|string} [context=this.contentEl()]
   *        A DOM element within which to query. Can also be a selector string in
   *        which case the first matching element will get used as context. If
   *        missing `this.contentEl()` gets used. If  `this.contentEl()` returns
   *        nothing it falls back to `document`.
   *
   * @return {Element|null}
   *         the dom element that was found, or null
   *
   * @see [Information on CSS Selectors](https://developer.mozilla.org/en-US/docs/Web/Guide/CSS/Getting_Started/Selectors)
   */
  $(e, n) {
    return ir(e, n || this.contentEl());
  }
  /**
   * Finds all DOM element matching a `selector`. This can be within the `Component`s
   * `contentEl()` or another custom context.
   *
   * @param {string} selector
   *        A valid CSS selector, which will be passed to `querySelectorAll`.
   *
   * @param {Element|string} [context=this.contentEl()]
   *        A DOM element within which to query. Can also be a selector string in
   *        which case the first matching element will get used as context. If
   *        missing `this.contentEl()` gets used. If  `this.contentEl()` returns
   *        nothing it falls back to `document`.
   *
   * @return {NodeList}
   *         a list of dom elements that were found
   *
   * @see [Information on CSS Selectors](https://developer.mozilla.org/en-US/docs/Web/Guide/CSS/Getting_Started/Selectors)
   */
  $$(e, n) {
    return y3(e, n || this.contentEl());
  }
  /**
   * Check if a component's element has a CSS class name.
   *
   * @param {string} classToCheck
   *        CSS class name to check.
   *
   * @return {boolean}
   *         - True if the `Component` has the class.
   *         - False if the `Component` does not have the class`
   */
  hasClass(e) {
    return hl(this.el_, e);
  }
  /**
   * Add a CSS class name to the `Component`s element.
   *
   * @param {...string} classesToAdd
   *        One or more CSS class name to add.
   */
  addClass(...e) {
    Dr(this.el_, ...e);
  }
  /**
   * Remove a CSS class name from the `Component`s element.
   *
   * @param {...string} classesToRemove
   *        One or more CSS class name to remove.
   */
  removeClass(...e) {
    _d(this.el_, ...e);
  }
  /**
   * Add or remove a CSS class name from the component's element.
   * - `classToToggle` gets added when {@link Component#hasClass} would return false.
   * - `classToToggle` gets removed when {@link Component#hasClass} would return true.
   *
   * @param  {string} classToToggle
   *         The class to add or remove. Passed to DOMTokenList's toggle()
   *
   * @param  {boolean|Dom.PredicateCallback} [predicate]
   *         A boolean or function that returns a boolean. Passed to DOMTokenList's toggle().
   */
  toggleClass(e, n) {
    d3(this.el_, e, n);
  }
  /**
   * Show the `Component`s element if it is hidden by removing the
   * 'vjs-hidden' class name from it.
   */
  show() {
    this.removeClass("vjs-hidden");
  }
  /**
   * Hide the `Component`s element if it is currently showing by adding the
   * 'vjs-hidden` class name to it.
   */
  hide() {
    this.addClass("vjs-hidden");
  }
  /**
   * Lock a `Component`s element in its visible state by adding the 'vjs-lock-showing'
   * class name to it. Used during fadeIn/fadeOut.
   *
   * @private
   */
  lockShowing() {
    this.addClass("vjs-lock-showing");
  }
  /**
   * Unlock a `Component`s element from its visible state by removing the 'vjs-lock-showing'
   * class name from it. Used during fadeIn/fadeOut.
   *
   * @private
   */
  unlockShowing() {
    this.removeClass("vjs-lock-showing");
  }
  /**
   * Get the value of an attribute on the `Component`s element.
   *
   * @param {string} attribute
   *        Name of the attribute to get the value from.
   *
   * @return {string|null}
   *         - The value of the attribute that was asked for.
   *         - Can be an empty string on some browsers if the attribute does not exist
   *           or has no value
   *         - Most browsers will return null if the attribute does not exist or has
   *           no value.
   *
   * @see [DOM API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Element/getAttribute}
   */
  getAttribute(e) {
    return f3(this.el_, e);
  }
  /**
   * Set the value of an attribute on the `Component`'s element
   *
   * @param {string} attribute
   *        Name of the attribute to set.
   *
   * @param {string} value
   *        Value to set the attribute to.
   *
   * @see [DOM API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Element/setAttribute}
   */
  setAttribute(e, n) {
    Vs(this.el_, e, n);
  }
  /**
   * Remove an attribute from the `Component`s element.
   *
   * @param {string} attribute
   *        Name of the attribute to remove.
   *
   * @see [DOM API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Element/removeAttribute}
   */
  removeAttribute(e) {
    Td(this.el_, e);
  }
  /**
   * Get or set the width of the component based upon the CSS styles.
   * See {@link Component#dimension} for more detailed information.
   *
   * @param {number|string} [num]
   *        The width that you want to set postfixed with '%', 'px' or nothing.
   *
   * @param {boolean} [skipListeners]
   *        Skip the componentresize event trigger
   *
   * @return {number|undefined}
   *         The width when getting, zero if there is no width
   */
  width(e, n) {
    return this.dimension("width", e, n);
  }
  /**
   * Get or set the height of the component based upon the CSS styles.
   * See {@link Component#dimension} for more detailed information.
   *
   * @param {number|string} [num]
   *        The height that you want to set postfixed with '%', 'px' or nothing.
   *
   * @param {boolean} [skipListeners]
   *        Skip the componentresize event trigger
   *
   * @return {number|undefined}
   *         The height when getting, zero if there is no height
   */
  height(e, n) {
    return this.dimension("height", e, n);
  }
  /**
   * Set both the width and height of the `Component` element at the same time.
   *
   * @param  {number|string} width
   *         Width to set the `Component`s element to.
   *
   * @param  {number|string} height
   *         Height to set the `Component`s element to.
   */
  dimensions(e, n) {
    this.width(e, !0), this.height(n);
  }
  /**
   * Get or set width or height of the `Component` element. This is the shared code
   * for the {@link Component#width} and {@link Component#height}.
   *
   * Things to know:
   * - If the width or height in an number this will return the number postfixed with 'px'.
   * - If the width/height is a percent this will return the percent postfixed with '%'
   * - Hidden elements have a width of 0 with `window.getComputedStyle`. This function
   *   defaults to the `Component`s `style.width` and falls back to `window.getComputedStyle`.
   *   See [this]{@link http://www.foliotek.com/devblog/getting-the-width-of-a-hidden-element-with-jquery-using-width/}
   *   for more information
   * - If you want the computed style of the component, use {@link Component#currentWidth}
   *   and {@link {Component#currentHeight}
   *
   * @fires Component#componentresize
   *
   * @param {string} widthOrHeight
   8        'width' or 'height'
   *
   * @param  {number|string} [num]
   8         New dimension
   *
   * @param  {boolean} [skipListeners]
   *         Skip componentresize event trigger
   *
   * @return {number|undefined}
   *         The dimension when getting or 0 if unset
   */
  dimension(e, n, a) {
    if (n !== void 0) {
      (n === null || n !== n) && (n = 0), ("" + n).indexOf("%") !== -1 || ("" + n).indexOf("px") !== -1 ? this.el_.style[e] = n : n === "auto" ? this.el_.style[e] = "" : this.el_.style[e] = n + "px", a || this.trigger("componentresize");
      return;
    }
    if (!this.el_)
      return 0;
    const i = this.el_.style[e], r = i.indexOf("px");
    return parseInt(r !== -1 ? i.slice(0, r) : this.el_["offset" + qt(e)], 10);
  }
  /**
   * Get the computed width or the height of the component's element.
   *
   * Uses `window.getComputedStyle`.
   *
   * @param {string} widthOrHeight
   *        A string containing 'width' or 'height'. Whichever one you want to get.
   *
   * @return {number}
   *         The dimension that gets asked for or 0 if nothing was set
   *         for that dimension.
   */
  currentDimension(e) {
    let n = 0;
    if (e !== "width" && e !== "height")
      throw new Error("currentDimension only accepts width or height value");
    if (n = Ws(this.el_, e), n = parseFloat(n), n === 0 || isNaN(n)) {
      const a = `offset${qt(e)}`;
      n = this.el_[a];
    }
    return n;
  }
  /**
   * An object that contains width and height values of the `Component`s
   * computed style. Uses `window.getComputedStyle`.
   *
   * @typedef {Object} Component~DimensionObject
   *
   * @property {number} width
   *           The width of the `Component`s computed style.
   *
   * @property {number} height
   *           The height of the `Component`s computed style.
   */
  /**
   * Get an object that contains computed width and height values of the
   * component's element.
   *
   * Uses `window.getComputedStyle`.
   *
   * @return {Component~DimensionObject}
   *         The computed dimensions of the component's element.
   */
  currentDimensions() {
    return {
      width: this.currentDimension("width"),
      height: this.currentDimension("height")
    };
  }
  /**
   * Get the computed width of the component's element.
   *
   * Uses `window.getComputedStyle`.
   *
   * @return {number}
   *         The computed width of the component's element.
   */
  currentWidth() {
    return this.currentDimension("width");
  }
  /**
   * Get the computed height of the component's element.
   *
   * Uses `window.getComputedStyle`.
   *
   * @return {number}
   *         The computed height of the component's element.
   */
  currentHeight() {
    return this.currentDimension("height");
  }
  /**
   * Retrieves the position and size information of the component's element.
   *
   * @return {Object} An object with `boundingClientRect` and `center` properties.
   *         - `boundingClientRect`: An object with properties `x`, `y`, `width`,
   *           `height`, `top`, `right`, `bottom`, and `left`, representing
   *           the bounding rectangle of the element.
   *         - `center`: An object with properties `x` and `y`, representing
   *           the center point of the element. `width` and `height` are set to 0.
   */
  getPositions() {
    const e = this.el_.getBoundingClientRect(), n = {
      x: e.x,
      y: e.y,
      width: e.width,
      height: e.height,
      top: e.top,
      right: e.right,
      bottom: e.bottom,
      left: e.left
    }, a = {
      x: e.left + e.width / 2,
      y: e.top + e.height / 2,
      width: 0,
      height: 0,
      top: e.top + e.height / 2,
      right: e.left + e.width / 2,
      bottom: e.top + e.height / 2,
      left: e.left + e.width / 2
    };
    return {
      boundingClientRect: n,
      center: a
    };
  }
  /**
   * Set the focus to this component
   */
  focus() {
    this.el_.focus();
  }
  /**
   * Remove the focus from this component
   */
  blur() {
    this.el_.blur();
  }
  /**
   * When this Component receives a `keydown` event which it does not process,
   *  it passes the event to the Player for handling.
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called.
   */
  handleKeyDown(e) {
    this.player_ && (e.key !== "Tab" && !(this.player_.options_.playerOptions.spatialNavigation && this.player_.options_.playerOptions.spatialNavigation.enabled) && e.stopPropagation(), this.player_.handleKeyDown(e));
  }
  /**
   * Many components used to have a `handleKeyPress` method, which was poorly
   * named because it listened to a `keydown` event. This method name now
   * delegates to `handleKeyDown`. This means anyone calling `handleKeyPress`
   * will not see their method calls stop working.
   *
   * @param {KeyboardEvent} event
   *        The event that caused this function to be called.
   */
  handleKeyPress(e) {
    this.handleKeyDown(e);
  }
  /**
   * Emit a 'tap' events when touch event support gets detected. This gets used to
   * support toggling the controls through a tap on the video. They get enabled
   * because every sub-component would have extra overhead otherwise.
   *
   * @protected
   * @fires Component#tap
   * @listens Component#touchstart
   * @listens Component#touchmove
   * @listens Component#touchleave
   * @listens Component#touchcancel
   * @listens Component#touchend
    */
  emitTapEvents() {
    let e = 0, n = null;
    const a = 10, i = 200;
    let r;
    this.on("touchstart", function(o) {
      o.touches.length === 1 && (n = {
        pageX: o.touches[0].pageX,
        pageY: o.touches[0].pageY
      }, e = j.performance.now(), r = !0);
    }), this.on("touchmove", function(o) {
      if (o.touches.length > 1)
        r = !1;
      else if (n) {
        const l = o.touches[0].pageX - n.pageX, c = o.touches[0].pageY - n.pageY;
        Math.sqrt(l * l + c * c) > a && (r = !1);
      }
    });
    const s = function() {
      r = !1;
    };
    this.on("touchleave", s), this.on("touchcancel", s), this.on("touchend", function(o) {
      n = null, r === !0 && j.performance.now() - e < i && (o.preventDefault(), this.trigger("tap"));
    });
  }
  /**
   * This function reports user activity whenever touch events happen. This can get
   * turned off by any sub-components that wants touch events to act another way.
   *
   * Report user touch activity when touch events occur. User activity gets used to
   * determine when controls should show/hide. It is simple when it comes to mouse
   * events, because any mouse event should show the controls. So we capture mouse
   * events that bubble up to the player and report activity when that happens.
   * With touch events it isn't as easy as `touchstart` and `touchend` toggle player
   * controls. So touch events can't help us at the player level either.
   *
   * User activity gets checked asynchronously. So what could happen is a tap event
   * on the video turns the controls off. Then the `touchend` event bubbles up to
   * the player. Which, if it reported user activity, would turn the controls right
   * back on. We also don't want to completely block touch events from bubbling up.
   * Furthermore a `touchmove` event and anything other than a tap, should not turn
   * controls back on.
   *
   * @listens Component#touchstart
   * @listens Component#touchmove
   * @listens Component#touchend
   * @listens Component#touchcancel
   */
  enableTouchActivity() {
    if (!this.player() || !this.player().reportUserActivity)
      return;
    const e = Et(this.player(), this.player().reportUserActivity);
    let n;
    this.on("touchstart", function() {
      e(), this.clearInterval(n), n = this.setInterval(e, 250);
    });
    const a = function(i) {
      e(), this.clearInterval(n);
    };
    this.on("touchmove", e), this.on("touchend", a), this.on("touchcancel", a);
  }
  /**
   * A callback that has no parameters and is bound into `Component`s context.
   *
   * @callback Component~GenericCallback
   * @this Component
   */
  /**
   * Creates a function that runs after an `x` millisecond timeout. This function is a
   * wrapper around `window.setTimeout`. There are a few reasons to use this one
   * instead though:
   * 1. It gets cleared via  {@link Component#clearTimeout} when
   *    {@link Component#dispose} gets called.
   * 2. The function callback will gets turned into a {@link Component~GenericCallback}
   *
   * > Note: You can't use `window.clearTimeout` on the id returned by this function. This
   *         will cause its dispose listener not to get cleaned up! Please use
   *         {@link Component#clearTimeout} or {@link Component#dispose} instead.
   *
   * @param {Component~GenericCallback} fn
   *        The function that will be run after `timeout`.
   *
   * @param {number} timeout
   *        Timeout in milliseconds to delay before executing the specified function.
   *
   * @return {number}
   *         Returns a timeout ID that gets used to identify the timeout. It can also
   *         get used in {@link Component#clearTimeout} to clear the timeout that
   *         was set.
   *
   * @listens Component#dispose
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/setTimeout}
   */
  setTimeout(e, n) {
    var a;
    return e = Et(this, e), this.clearTimersOnDispose_(), a = j.setTimeout(() => {
      this.setTimeoutIds_.has(a) && this.setTimeoutIds_.delete(a), e();
    }, n), this.setTimeoutIds_.add(a), a;
  }
  /**
   * Clears a timeout that gets created via `window.setTimeout` or
   * {@link Component#setTimeout}. If you set a timeout via {@link Component#setTimeout}
   * use this function instead of `window.clearTimout`. If you don't your dispose
   * listener will not get cleaned up until {@link Component#dispose}!
   *
   * @param {number} timeoutId
   *        The id of the timeout to clear. The return value of
   *        {@link Component#setTimeout} or `window.setTimeout`.
   *
   * @return {number}
   *         Returns the timeout id that was cleared.
   *
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/clearTimeout}
   */
  clearTimeout(e) {
    return this.setTimeoutIds_.has(e) && (this.setTimeoutIds_.delete(e), j.clearTimeout(e)), e;
  }
  /**
   * Creates a function that gets run every `x` milliseconds. This function is a wrapper
   * around `window.setInterval`. There are a few reasons to use this one instead though.
   * 1. It gets cleared via  {@link Component#clearInterval} when
   *    {@link Component#dispose} gets called.
   * 2. The function callback will be a {@link Component~GenericCallback}
   *
   * @param {Component~GenericCallback} fn
   *        The function to run every `x` seconds.
   *
   * @param {number} interval
   *        Execute the specified function every `x` milliseconds.
   *
   * @return {number}
   *         Returns an id that can be used to identify the interval. It can also be be used in
   *         {@link Component#clearInterval} to clear the interval.
   *
   * @listens Component#dispose
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/setInterval}
   */
  setInterval(e, n) {
    e = Et(this, e), this.clearTimersOnDispose_();
    const a = j.setInterval(e, n);
    return this.setIntervalIds_.add(a), a;
  }
  /**
   * Clears an interval that gets created via `window.setInterval` or
   * {@link Component#setInterval}. If you set an interval via {@link Component#setInterval}
   * use this function instead of `window.clearInterval`. If you don't your dispose
   * listener will not get cleaned up until {@link Component#dispose}!
   *
   * @param {number} intervalId
   *        The id of the interval to clear. The return value of
   *        {@link Component#setInterval} or `window.setInterval`.
   *
   * @return {number}
   *         Returns the interval id that was cleared.
   *
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/clearInterval}
   */
  clearInterval(e) {
    return this.setIntervalIds_.has(e) && (this.setIntervalIds_.delete(e), j.clearInterval(e)), e;
  }
  /**
   * Queues up a callback to be passed to requestAnimationFrame (rAF), but
   * with a few extra bonuses:
   *
   * - Supports browsers that do not support rAF by falling back to
   *   {@link Component#setTimeout}.
   *
   * - The callback is turned into a {@link Component~GenericCallback} (i.e.
   *   bound to the component).
   *
   * - Automatic cancellation of the rAF callback is handled if the component
   *   is disposed before it is called.
   *
   * @param  {Component~GenericCallback} fn
   *         A function that will be bound to this component and executed just
   *         before the browser's next repaint.
   *
   * @return {number}
   *         Returns an rAF ID that gets used to identify the timeout. It can
   *         also be used in {@link Component#cancelAnimationFrame} to cancel
   *         the animation frame callback.
   *
   * @listens Component#dispose
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/window/requestAnimationFrame}
   */
  requestAnimationFrame(e) {
    this.clearTimersOnDispose_();
    var n;
    return e = Et(this, e), n = j.requestAnimationFrame(() => {
      this.rafIds_.has(n) && this.rafIds_.delete(n), e();
    }), this.rafIds_.add(n), n;
  }
  /**
   * Request an animation frame, but only one named animation
   * frame will be queued. Another will never be added until
   * the previous one finishes.
   *
   * @param {string} name
   *        The name to give this requestAnimationFrame
   *
   * @param  {Component~GenericCallback} fn
   *         A function that will be bound to this component and executed just
   *         before the browser's next repaint.
   */
  requestNamedAnimationFrame(e, n) {
    this.namedRafs_.has(e) && this.cancelNamedAnimationFrame(e), this.clearTimersOnDispose_(), n = Et(this, n);
    const a = this.requestAnimationFrame(() => {
      n(), this.namedRafs_.has(e) && this.namedRafs_.delete(e);
    });
    return this.namedRafs_.set(e, a), e;
  }
  /**
   * Cancels a current named animation frame if it exists.
   *
   * @param {string} name
   *        The name of the requestAnimationFrame to cancel.
   */
  cancelNamedAnimationFrame(e) {
    this.namedRafs_.has(e) && (this.cancelAnimationFrame(this.namedRafs_.get(e)), this.namedRafs_.delete(e));
  }
  /**
   * Cancels a queued callback passed to {@link Component#requestAnimationFrame}
   * (rAF).
   *
   * If you queue an rAF callback via {@link Component#requestAnimationFrame},
   * use this function instead of `window.cancelAnimationFrame`. If you don't,
   * your dispose listener will not get cleaned up until {@link Component#dispose}!
   *
   * @param {number} id
   *        The rAF ID to clear. The return value of {@link Component#requestAnimationFrame}.
   *
   * @return {number}
   *         Returns the rAF ID that was cleared.
   *
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/window/cancelAnimationFrame}
   */
  cancelAnimationFrame(e) {
    return this.rafIds_.has(e) && (this.rafIds_.delete(e), j.cancelAnimationFrame(e)), e;
  }
  /**
   * A function to setup `requestAnimationFrame`, `setTimeout`,
   * and `setInterval`, clearing on dispose.
   *
   * > Previously each timer added and removed dispose listeners on it's own.
   * For better performance it was decided to batch them all, and use `Set`s
   * to track outstanding timer ids.
   *
   * @private
   */
  clearTimersOnDispose_() {
    this.clearingTimersOnDispose_ || (this.clearingTimersOnDispose_ = !0, this.one("dispose", () => {
      [["namedRafs_", "cancelNamedAnimationFrame"], ["rafIds_", "cancelAnimationFrame"], ["setTimeoutIds_", "clearTimeout"], ["setIntervalIds_", "clearInterval"]].forEach(([e, n]) => {
        this[e].forEach((a, i) => this[n](i));
      }), this.clearingTimersOnDispose_ = !1;
    }));
  }
  /**
    * Decide whether an element is actually disabled or not.
    *
    * @function isActuallyDisabled
    * @param element {Node}
    * @return {boolean}
    *
    * @see {@link https://html.spec.whatwg.org/multipage/semantics-other.html#concept-element-disabled}
    */
  getIsDisabled() {
    return !!this.el_.disabled;
  }
  /**
    * Decide whether the element is expressly inert or not.
    *
    * @see {@link https://html.spec.whatwg.org/multipage/interaction.html#expressly-inert}
    * @function isExpresslyInert
    * @param element {Node}
    * @return {boolean}
    */
  getIsExpresslyInert() {
    return this.el_.inert && !this.el_.ownerDocument.documentElement.inert;
  }
  /**
   * Determine whether or not this component can be considered as focusable component.
   *
   * @param {HTMLElement} el - The HTML element representing the component.
   * @return {boolean}
   *         If the component can be focused, will be `true`. Otherwise, `false`.
   */
  getIsFocusable(e) {
    return (e || this.el_).tabIndex >= 0 && !(this.getIsDisabled() || this.getIsExpresslyInert());
  }
  /**
   * Determine whether or not this component is currently visible/enabled/etc...
   *
   * @param {HTMLElement} el - The HTML element representing the component.
   * @return {boolean}
   *         If the component can is currently visible & enabled, will be `true`. Otherwise, `false`.
   */
  getIsAvailableToBeFocused(e) {
    function n(r) {
      const s = j.getComputedStyle(r, null), o = s.getPropertyValue("visibility");
      return s.getPropertyValue("display") !== "none" && !["hidden", "collapse"].includes(o);
    }
    function a(r) {
      return !(!n(r.parentElement) || !n(r) || r.style.opacity === "0" || j.getComputedStyle(r).height === "0px" || j.getComputedStyle(r).width === "0px");
    }
    function i(r) {
      if (r.offsetWidth + r.offsetHeight + r.getBoundingClientRect().height + r.getBoundingClientRect().width === 0)
        return !1;
      const s = {
        x: r.getBoundingClientRect().left + r.offsetWidth / 2,
        y: r.getBoundingClientRect().top + r.offsetHeight / 2
      };
      if (s.x < 0 || s.x > (Me.documentElement.clientWidth || j.innerWidth) || s.y < 0 || s.y > (Me.documentElement.clientHeight || j.innerHeight))
        return !1;
      let o = Me.elementFromPoint(s.x, s.y);
      for (; o; ) {
        if (o === r)
          return !0;
        if (o.parentNode)
          o = o.parentNode;
        else
          return !1;
      }
    }
    return e || (e = this.el()), !!(i(e) && a(e) && (!e.parentElement || e.tabIndex >= 0));
  }
  /**
   * Register a `Component` with `videojs` given the name and the component.
   *
   * > NOTE: {@link Tech}s should not be registered as a `Component`. {@link Tech}s
   *         should be registered using {@link Tech.registerTech} or
   *         {@link videojs:videojs.registerTech}.
   *
   * > NOTE: This function can also be seen on videojs as
   *         {@link videojs:videojs.registerComponent}.
   *
   * @param {string} name
   *        The name of the `Component` to register.
   *
   * @param {Component} ComponentToRegister
   *        The `Component` class to register.
   *
   * @return {Component}
   *         The `Component` that was registered.
   */
  static registerComponent(e, n) {
    if (typeof e != "string" || !e)
      throw new Error(`Illegal component name, "${e}"; must be a non-empty string.`);
    const a = ye.getComponent("Tech"), i = a && a.isTech(n), r = ye === n || ye.prototype.isPrototypeOf(n.prototype);
    if (i || !r) {
      let o;
      throw i ? o = "techs must be registered using Tech.registerTech()" : o = "must be a Component subclass", new Error(`Illegal component, "${e}"; ${o}.`);
    }
    e = qt(e), ye.components_ || (ye.components_ = {});
    const s = ye.getComponent("Player");
    if (e === "Player" && s && s.players) {
      const o = s.players, l = Object.keys(o);
      if (o && l.length > 0 && l.map((c) => o[c]).every(Boolean))
        throw new Error("Can not register Player component after player has been created.");
    }
    return ye.components_[e] = n, ye.components_[fl(e)] = n, n;
  }
  /**
   * Get a `Component` based on the name it was registered with.
   *
   * @param {string} name
   *        The Name of the component to get.
   *
   * @return {typeof Component}
   *         The `Component` that got registered under the given name.
   */
  static getComponent(e) {
    if (!(!e || !ye.components_))
      return ye.components_[e];
  }
}
ye.registerComponent("Component", ye);
function Zte(t, e, n) {
  if (typeof e != "number" || e < 0 || e > n)
    throw new Error(`Failed to execute '${t}' on 'TimeRanges': The index provided (${e}) is non-numeric or out of bounds (0-${n}).`);
}
function nb(t, e, n, a) {
  return Zte(t, a, n.length - 1), n[a][e];
}
function L0(t) {
  let e;
  return t === void 0 || t.length === 0 ? e = {
    length: 0,
    start() {
      throw new Error("This TimeRanges object is empty");
    },
    end() {
      throw new Error("This TimeRanges object is empty");
    }
  } : e = {
    length: t.length,
    start: nb.bind(null, "start", 0, t),
    end: nb.bind(null, "end", 1, t)
  }, j.Symbol && j.Symbol.iterator && (e[j.Symbol.iterator] = () => (t || []).values()), e;
}
function Ra(t, e) {
  return Array.isArray(t) ? L0(t) : t === void 0 || e === void 0 ? L0() : L0([[t, e]]);
}
const D3 = function(t, e) {
  t = t < 0 ? 0 : t;
  let n = Math.floor(t % 60), a = Math.floor(t / 60 % 60), i = Math.floor(t / 3600);
  const r = Math.floor(e / 60 % 60), s = Math.floor(e / 3600);
  return (isNaN(t) || t === 1 / 0) && (i = a = n = "-"), i = i > 0 || s > 0 ? i + ":" : "", a = ((i || r >= 10) && a < 10 ? "0" + a : a) + ":", n = n < 10 ? "0" + n : n, i + a + n;
};
let up = D3;
function I3(t) {
  up = t;
}
function M3() {
  up = D3;
}
function $r(t, e = t) {
  return up(t, e);
}
var Kte = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  createTimeRanges: Ra,
  createTimeRange: Ra,
  setFormatTime: I3,
  resetFormatTime: M3,
  formatTime: $r
});
function O3(t, e) {
  let n = 0, a, i;
  if (!e)
    return 0;
  (!t || !t.length) && (t = Ra(0, 0));
  for (let r = 0; r < t.length; r++)
    a = t.start(r), i = t.end(r), i > e && (i = e), n += i - a;
  return n / e;
}
function Yt(t) {
  if (t instanceof Yt)
    return t;
  typeof t == "number" ? this.code = t : typeof t == "string" ? this.message = t : ni(t) && (typeof t.code == "number" && (this.code = t.code), Object.assign(this, t)), this.message || (this.message = Yt.defaultMessages[this.code] || "");
}
Yt.prototype.code = 0;
Yt.prototype.message = "";
Yt.prototype.status = null;
Yt.prototype.metadata = null;
Yt.errorTypes = ["MEDIA_ERR_CUSTOM", "MEDIA_ERR_ABORTED", "MEDIA_ERR_NETWORK", "MEDIA_ERR_DECODE", "MEDIA_ERR_SRC_NOT_SUPPORTED", "MEDIA_ERR_ENCRYPTED"];
Yt.defaultMessages = {
  1: "You aborted the media playback",
  2: "A network error caused the media download to fail part-way.",
  3: "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.",
  4: "The media could not be loaded, either because the server or network failed or because the format is not supported.",
  5: "The media is encrypted and we do not have the keys to decrypt it."
};
Yt.MEDIA_ERR_CUSTOM = 0;
Yt.prototype.MEDIA_ERR_CUSTOM = 0;
Yt.MEDIA_ERR_ABORTED = 1;
Yt.prototype.MEDIA_ERR_ABORTED = 1;
Yt.MEDIA_ERR_NETWORK = 2;
Yt.prototype.MEDIA_ERR_NETWORK = 2;
Yt.MEDIA_ERR_DECODE = 3;
Yt.prototype.MEDIA_ERR_DECODE = 3;
Yt.MEDIA_ERR_SRC_NOT_SUPPORTED = 4;
Yt.prototype.MEDIA_ERR_SRC_NOT_SUPPORTED = 4;
Yt.MEDIA_ERR_ENCRYPTED = 5;
Yt.prototype.MEDIA_ERR_ENCRYPTED = 5;
function pl(t) {
  return t != null && typeof t.then == "function";
}
function Xa(t) {
  pl(t) && t.then(null, (e) => {
  });
}
const Ah = function(t) {
  return ["kind", "label", "language", "id", "inBandMetadataTrackDispatchType", "mode", "src"].reduce((n, a, i) => (t[a] && (n[a] = t[a]), n), {
    cues: t.cues && Array.prototype.map.call(t.cues, function(n) {
      return {
        startTime: n.startTime,
        endTime: n.endTime,
        text: n.text,
        id: n.id
      };
    })
  });
}, Qte = function(t) {
  const e = t.$$("track"), n = Array.prototype.map.call(e, (i) => i.track);
  return Array.prototype.map.call(e, function(i) {
    const r = Ah(i.track);
    return i.src && (r.src = i.src), r;
  }).concat(Array.prototype.filter.call(t.textTracks(), function(i) {
    return n.indexOf(i) === -1;
  }).map(Ah));
}, Jte = function(t, e) {
  return t.forEach(function(n) {
    const a = e.addRemoteTextTrack(n).track;
    !n.src && n.cues && n.cues.forEach((i) => a.addCue(i));
  }), e.textTracks();
};
var ab = {
  textTracksToJson: Qte,
  jsonToTextTracks: Jte,
  trackToJson_: Ah
};
const D0 = "vjs-modal-dialog";
class fo extends ye {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {ContentDescriptor} [options.content=undefined]
   *        Provide customized content for this modal.
   *
   * @param {string} [options.description]
   *        A text description for the modal, primarily for accessibility.
   *
   * @param {boolean} [options.fillAlways=false]
   *        Normally, modals are automatically filled only the first time
   *        they open. This tells the modal to refresh its content
   *        every time it opens.
   *
   * @param {string} [options.label]
   *        A text label for the modal, primarily for accessibility.
   *
   * @param {boolean} [options.pauseOnOpen=true]
   *        If `true`, playback will will be paused if playing when
   *        the modal opens, and resumed when it closes.
   *
   * @param {boolean} [options.temporary=true]
   *        If `true`, the modal can only be opened once; it will be
   *        disposed as soon as it's closed.
   *
   * @param {boolean} [options.uncloseable=false]
   *        If `true`, the user will not be able to close the modal
   *        through the UI in the normal ways. Programmatic closing is
   *        still possible.
   */
  constructor(e, n) {
    super(e, n), this.handleKeyDown_ = (a) => this.handleKeyDown(a), this.close_ = (a) => this.close(a), this.opened_ = this.hasBeenOpened_ = this.hasBeenFilled_ = !1, this.closeable(!this.options_.uncloseable), this.content(this.options_.content), this.contentEl_ = et("div", {
      className: `${D0}-content`
    }, {
      role: "document"
    }), this.descEl_ = et("p", {
      className: `${D0}-description vjs-control-text`,
      id: this.el().getAttribute("aria-describedby")
    }), ur(this.descEl_, this.description()), this.el_.appendChild(this.descEl_), this.el_.appendChild(this.contentEl_);
  }
  /**
   * Create the `ModalDialog`'s DOM element
   *
   * @return {Element}
   *         The DOM element that gets created.
   */
  createEl() {
    return super.createEl("div", {
      className: this.buildCSSClass(),
      tabIndex: -1
    }, {
      "aria-describedby": `${this.id()}_description`,
      "aria-hidden": "true",
      "aria-label": this.label(),
      role: "dialog",
      "aria-live": "polite"
    });
  }
  dispose() {
    this.contentEl_ = null, this.descEl_ = null, this.previouslyActiveEl_ = null, super.dispose();
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `${D0} vjs-hidden ${super.buildCSSClass()}`;
  }
  /**
   * Returns the label string for this modal. Primarily used for accessibility.
   *
   * @return {string}
   *         the localized or raw label of this modal.
   */
  label() {
    return this.localize(this.options_.label || "Modal Window");
  }
  /**
   * Returns the description string for this modal. Primarily used for
   * accessibility.
   *
   * @return {string}
   *         The localized or raw description of this modal.
   */
  description() {
    let e = this.options_.description || this.localize("This is a modal window.");
    return this.closeable() && (e += " " + this.localize("This modal can be closed by pressing the Escape key or activating the close button.")), e;
  }
  /**
   * Opens the modal.
   *
   * @fires ModalDialog#beforemodalopen
   * @fires ModalDialog#modalopen
   */
  open() {
    if (this.opened_) {
      this.options_.fillAlways && this.fill();
      return;
    }
    const e = this.player();
    this.trigger("beforemodalopen"), this.opened_ = !0, (this.options_.fillAlways || !this.hasBeenOpened_ && !this.hasBeenFilled_) && this.fill(), this.wasPlaying_ = !e.paused(), this.options_.pauseOnOpen && this.wasPlaying_ && e.pause(), this.on("keydown", this.handleKeyDown_), this.hadControls_ = e.controls(), e.controls(!1), this.show(), this.conditionalFocus_(), this.el().setAttribute("aria-hidden", "false"), this.trigger("modalopen"), this.hasBeenOpened_ = !0;
  }
  /**
   * If the `ModalDialog` is currently open or closed.
   *
   * @param  {boolean} [value]
   *         If given, it will open (`true`) or close (`false`) the modal.
   *
   * @return {boolean}
   *         the current open state of the modaldialog
   */
  opened(e) {
    return typeof e == "boolean" && this[e ? "open" : "close"](), this.opened_;
  }
  /**
   * Closes the modal, does nothing if the `ModalDialog` is
   * not open.
   *
   * @fires ModalDialog#beforemodalclose
   * @fires ModalDialog#modalclose
   */
  close() {
    if (!this.opened_)
      return;
    const e = this.player();
    this.trigger("beforemodalclose"), this.opened_ = !1, this.wasPlaying_ && this.options_.pauseOnOpen && e.play(), this.off("keydown", this.handleKeyDown_), this.hadControls_ && e.controls(!0), this.hide(), this.el().setAttribute("aria-hidden", "true"), this.trigger({
      type: "modalclose",
      bubbles: !0
    }), this.conditionalBlur_(), this.options_.temporary && this.dispose();
  }
  /**
   * Check to see if the `ModalDialog` is closeable via the UI.
   *
   * @param  {boolean} [value]
   *         If given as a boolean, it will set the `closeable` option.
   *
   * @return {boolean}
   *         Returns the final value of the closable option.
   */
  closeable(e) {
    if (typeof e == "boolean") {
      const n = this.closeable_ = !!e;
      let a = this.getChild("closeButton");
      if (n && !a) {
        const i = this.contentEl_;
        this.contentEl_ = this.el_, a = this.addChild("closeButton", {
          controlText: "Close Modal Dialog"
        }), this.contentEl_ = i, this.on(a, "close", this.close_);
      }
      !n && a && (this.off(a, "close", this.close_), this.removeChild(a), a.dispose());
    }
    return this.closeable_;
  }
  /**
   * Fill the modal's content element with the modal's "content" option.
   * The content element will be emptied before this change takes place.
   */
  fill() {
    this.fillWith(this.content());
  }
  /**
   * Fill the modal's content element with arbitrary content.
   * The content element will be emptied before this change takes place.
   *
   * @fires ModalDialog#beforemodalfill
   * @fires ModalDialog#modalfill
   *
   * @param {ContentDescriptor} [content]
   *        The same rules apply to this as apply to the `content` option.
   */
  fillWith(e) {
    const n = this.contentEl(), a = n.parentNode, i = n.nextSibling;
    this.trigger("beforemodalfill"), this.hasBeenFilled_ = !0, a.removeChild(n), this.empty(), v3(n, e), this.trigger("modalfill"), i ? a.insertBefore(n, i) : a.appendChild(n);
    const r = this.getChild("closeButton");
    r && a.appendChild(r.el_), this.trigger("aftermodalfill");
  }
  /**
   * Empties the content element. This happens anytime the modal is filled.
   *
   * @fires ModalDialog#beforemodalempty
   * @fires ModalDialog#modalempty
   */
  empty() {
    this.trigger("beforemodalempty"), wd(this.contentEl()), this.trigger("modalempty");
  }
  /**
   * Gets or sets the modal content, which gets normalized before being
   * rendered into the DOM.
   *
   * This does not update the DOM or fill the modal, but it is called during
   * that process.
   *
   * @param  {ContentDescriptor} [value]
   *         If defined, sets the internal content value to be used on the
   *         next call(s) to `fill`. This value is normalized before being
   *         inserted. To "clear" the internal content value, pass `null`.
   *
   * @return {ContentDescriptor}
   *         The current content of the modal dialog
   */
  content(e) {
    return typeof e < "u" && (this.content_ = e), this.content_;
  }
  /**
   * conditionally focus the modal dialog if focus was previously on the player.
   *
   * @private
   */
  conditionalFocus_() {
    const e = Me.activeElement, n = this.player_.el_;
    this.previouslyActiveEl_ = null, (n.contains(e) || n === e) && (this.previouslyActiveEl_ = e, this.focus());
  }
  /**
   * conditionally blur the element and refocus the last focused element
   *
   * @private
   */
  conditionalBlur_() {
    this.previouslyActiveEl_ && (this.previouslyActiveEl_.focus(), this.previouslyActiveEl_ = null);
  }
  /**
   * Keydown handler. Attached when modal is focused.
   *
   * @listens keydown
   */
  handleKeyDown(e) {
    if (this.trigger({
      type: "modalKeydown",
      originalEvent: e,
      target: this,
      bubbles: !0
    }), e.stopPropagation(), e.key === "Escape" && this.closeable()) {
      e.preventDefault(), this.close();
      return;
    }
    if (e.key !== "Tab")
      return;
    const n = this.focusableEls_(), a = this.el_.querySelector(":focus");
    let i;
    for (let r = 0; r < n.length; r++)
      if (a === n[r]) {
        i = r;
        break;
      }
    Me.activeElement === this.el_ && (i = 0), e.shiftKey && i === 0 ? (n[n.length - 1].focus(), e.preventDefault()) : !e.shiftKey && i === n.length - 1 && (n[0].focus(), e.preventDefault());
  }
  /**
   * get all focusable elements
   *
   * @private
   */
  focusableEls_() {
    const e = this.el_.querySelectorAll("*");
    return Array.prototype.filter.call(e, (n) => (n instanceof j.HTMLAnchorElement || n instanceof j.HTMLAreaElement) && n.hasAttribute("href") || (n instanceof j.HTMLInputElement || n instanceof j.HTMLSelectElement || n instanceof j.HTMLTextAreaElement || n instanceof j.HTMLButtonElement) && !n.hasAttribute("disabled") || n instanceof j.HTMLIFrameElement || n instanceof j.HTMLObjectElement || n instanceof j.HTMLEmbedElement || n.hasAttribute("tabindex") && n.getAttribute("tabindex") !== -1 || n.hasAttribute("contenteditable"));
  }
}
fo.prototype.options_ = {
  pauseOnOpen: !0,
  temporary: !0
};
ye.registerComponent("ModalDialog", fo);
class Gs extends fa {
  /**
   * Create an instance of this class
   *
   * @param { Track[] } tracks
   *        A list of tracks to initialize the list with.
   *
   * @abstract
   */
  constructor(e = []) {
    super(), this.tracks_ = [], Object.defineProperty(this, "length", {
      get() {
        return this.tracks_.length;
      }
    });
    for (let n = 0; n < e.length; n++)
      this.addTrack(e[n]);
  }
  /**
   * Add a {@link Track} to the `TrackList`
   *
   * @param {Track} track
   *        The audio, video, or text track to add to the list.
   *
   * @fires TrackList#addtrack
   */
  addTrack(e) {
    const n = this.tracks_.length;
    "" + n in this || Object.defineProperty(this, n, {
      get() {
        return this.tracks_[n];
      }
    }), this.tracks_.indexOf(e) === -1 && (this.tracks_.push(e), this.trigger({
      track: e,
      type: "addtrack",
      target: this
    })), e.labelchange_ = () => {
      this.trigger({
        track: e,
        type: "labelchange",
        target: this
      });
    }, xi(e) && e.addEventListener("labelchange", e.labelchange_);
  }
  /**
   * Remove a {@link Track} from the `TrackList`
   *
   * @param {Track} rtrack
   *        The audio, video, or text track to remove from the list.
   *
   * @fires TrackList#removetrack
   */
  removeTrack(e) {
    let n;
    for (let a = 0, i = this.length; a < i; a++)
      if (this[a] === e) {
        n = this[a], n.off && n.off(), this.tracks_.splice(a, 1);
        break;
      }
    n && this.trigger({
      track: n,
      type: "removetrack",
      target: this
    });
  }
  /**
   * Get a Track from the TrackList by a tracks id
   *
   * @param {string} id - the id of the track to get
   * @method getTrackById
   * @return {Track}
   * @private
   */
  getTrackById(e) {
    let n = null;
    for (let a = 0, i = this.length; a < i; a++) {
      const r = this[a];
      if (r.id === e) {
        n = r;
        break;
      }
    }
    return n;
  }
}
Gs.prototype.allowedEvents_ = {
  change: "change",
  addtrack: "addtrack",
  removetrack: "removetrack",
  labelchange: "labelchange"
};
for (const t in Gs.prototype.allowedEvents_)
  Gs.prototype["on" + t] = null;
const I0 = function(t, e) {
  for (let n = 0; n < t.length; n++)
    !Object.keys(t[n]).length || e.id === t[n].id || (t[n].enabled = !1);
};
class ene extends Gs {
  /**
   * Create an instance of this class.
   *
   * @param {AudioTrack[]} [tracks=[]]
   *        A list of `AudioTrack` to instantiate the list with.
   */
  constructor(e = []) {
    for (let n = e.length - 1; n >= 0; n--)
      if (e[n].enabled) {
        I0(e, e[n]);
        break;
      }
    super(e), this.changing_ = !1;
  }
  /**
   * Add an {@link AudioTrack} to the `AudioTrackList`.
   *
   * @param {AudioTrack} track
   *        The AudioTrack to add to the list
   *
   * @fires TrackList#addtrack
   */
  addTrack(e) {
    e.enabled && I0(this, e), super.addTrack(e), e.addEventListener && (e.enabledChange_ = () => {
      this.changing_ || (this.changing_ = !0, I0(this, e), this.changing_ = !1, this.trigger("change"));
    }, e.addEventListener("enabledchange", e.enabledChange_));
  }
  removeTrack(e) {
    super.removeTrack(e), e.removeEventListener && e.enabledChange_ && (e.removeEventListener("enabledchange", e.enabledChange_), e.enabledChange_ = null);
  }
}
const M0 = function(t, e) {
  for (let n = 0; n < t.length; n++)
    !Object.keys(t[n]).length || e.id === t[n].id || (t[n].selected = !1);
};
class tne extends Gs {
  /**
   * Create an instance of this class.
   *
   * @param {VideoTrack[]} [tracks=[]]
   *        A list of `VideoTrack` to instantiate the list with.
   */
  constructor(e = []) {
    for (let n = e.length - 1; n >= 0; n--)
      if (e[n].selected) {
        M0(e, e[n]);
        break;
      }
    super(e), this.changing_ = !1, Object.defineProperty(this, "selectedIndex", {
      get() {
        for (let n = 0; n < this.length; n++)
          if (this[n].selected)
            return n;
        return -1;
      },
      set() {
      }
    });
  }
  /**
   * Add a {@link VideoTrack} to the `VideoTrackList`.
   *
   * @param {VideoTrack} track
   *        The VideoTrack to add to the list
   *
   * @fires TrackList#addtrack
   */
  addTrack(e) {
    e.selected && M0(this, e), super.addTrack(e), e.addEventListener && (e.selectedChange_ = () => {
      this.changing_ || (this.changing_ = !0, M0(this, e), this.changing_ = !1, this.trigger("change"));
    }, e.addEventListener("selectedchange", e.selectedChange_));
  }
  removeTrack(e) {
    super.removeTrack(e), e.removeEventListener && e.selectedChange_ && (e.removeEventListener("selectedchange", e.selectedChange_), e.selectedChange_ = null);
  }
}
class P3 extends Gs {
  /**
   * Add a {@link TextTrack} to the `TextTrackList`
   *
   * @param {TextTrack} track
   *        The text track to add to the list.
   *
   * @fires TrackList#addtrack
   */
  addTrack(e) {
    super.addTrack(e), this.queueChange_ || (this.queueChange_ = () => this.queueTrigger("change")), this.triggerSelectedlanguagechange || (this.triggerSelectedlanguagechange_ = () => this.trigger("selectedlanguagechange")), e.addEventListener("modechange", this.queueChange_), ["metadata", "chapters"].indexOf(e.kind) === -1 && e.addEventListener("modechange", this.triggerSelectedlanguagechange_);
  }
  removeTrack(e) {
    super.removeTrack(e), e.removeEventListener && (this.queueChange_ && e.removeEventListener("modechange", this.queueChange_), this.selectedlanguagechange_ && e.removeEventListener("modechange", this.triggerSelectedlanguagechange_));
  }
}
class nne {
  /**
   * Create an instance of this class.
   *
   * @param {HtmlTrackElement[]} [tracks=[]]
   *        A list of `HtmlTrackElement` to instantiate the list with.
   */
  constructor(e = []) {
    this.trackElements_ = [], Object.defineProperty(this, "length", {
      get() {
        return this.trackElements_.length;
      }
    });
    for (let n = 0, a = e.length; n < a; n++)
      this.addTrackElement_(e[n]);
  }
  /**
   * Add an {@link HtmlTrackElement} to the `HtmlTrackElementList`
   *
   * @param {HtmlTrackElement} trackElement
   *        The track element to add to the list.
   *
   * @private
   */
  addTrackElement_(e) {
    const n = this.trackElements_.length;
    "" + n in this || Object.defineProperty(this, n, {
      get() {
        return this.trackElements_[n];
      }
    }), this.trackElements_.indexOf(e) === -1 && this.trackElements_.push(e);
  }
  /**
   * Get an {@link HtmlTrackElement} from the `HtmlTrackElementList` given an
   * {@link TextTrack}.
   *
   * @param {TextTrack} track
   *        The track associated with a track element.
   *
   * @return {HtmlTrackElement|undefined}
   *         The track element that was found or undefined.
   *
   * @private
   */
  getTrackElementByTrack_(e) {
    let n;
    for (let a = 0, i = this.trackElements_.length; a < i; a++)
      if (e === this.trackElements_[a].track) {
        n = this.trackElements_[a];
        break;
      }
    return n;
  }
  /**
   * Remove a {@link HtmlTrackElement} from the `HtmlTrackElementList`
   *
   * @param {HtmlTrackElement} trackElement
   *        The track element to remove from the list.
   *
   * @private
   */
  removeTrackElement_(e) {
    for (let n = 0, a = this.trackElements_.length; n < a; n++)
      if (e === this.trackElements_[n]) {
        this.trackElements_[n].track && typeof this.trackElements_[n].track.off == "function" && this.trackElements_[n].track.off(), typeof this.trackElements_[n].off == "function" && this.trackElements_[n].off(), this.trackElements_.splice(n, 1);
        break;
      }
  }
}
class Su {
  /**
   * Create an instance of this class..
   *
   * @param {Array} cues
   *        A list of cues to be initialized with
   */
  constructor(e) {
    Su.prototype.setCues_.call(this, e), Object.defineProperty(this, "length", {
      get() {
        return this.length_;
      }
    });
  }
  /**
   * A setter for cues in this list. Creates getters
   * an an index for the cues.
   *
   * @param {Array} cues
   *        An array of cues to set
   *
   * @private
   */
  setCues_(e) {
    const n = this.length || 0;
    let a = 0;
    const i = e.length;
    this.cues_ = e, this.length_ = e.length;
    const r = function(s) {
      "" + s in this || Object.defineProperty(this, "" + s, {
        get() {
          return this.cues_[s];
        }
      });
    };
    if (n < i)
      for (a = n; a < i; a++)
        r.call(this, a);
  }
  /**
   * Get a `TextTrackCue` that is currently in the `TextTrackCueList` by id.
   *
   * @param {string} id
   *        The id of the cue that should be searched for.
   *
   * @return {TextTrackCueList~TextTrackCue|null}
   *         A single cue or null if none was found.
   */
  getCueById(e) {
    let n = null;
    for (let a = 0, i = this.length; a < i; a++) {
      const r = this[a];
      if (r.id === e) {
        n = r;
        break;
      }
    }
    return n;
  }
}
const ane = {
  alternative: "alternative",
  captions: "captions",
  main: "main",
  sign: "sign",
  subtitles: "subtitles",
  commentary: "commentary"
}, ine = {
  alternative: "alternative",
  descriptions: "descriptions",
  main: "main",
  "main-desc": "main-desc",
  translation: "translation",
  commentary: "commentary"
}, rne = {
  subtitles: "subtitles",
  captions: "captions",
  descriptions: "descriptions",
  chapters: "chapters",
  metadata: "metadata"
}, ib = {
  disabled: "disabled",
  hidden: "hidden",
  showing: "showing"
};
class dp extends fa {
  /**
   * Create an instance of this class.
   *
   * @param {Object} [options={}]
   *        Object of option names and values
   *
   * @param {string} [options.kind='']
   *        A valid kind for the track type you are creating.
   *
   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
   *        A unique id for this AudioTrack.
   *
   * @param {string} [options.label='']
   *        The menu label for this track.
   *
   * @param {string} [options.language='']
   *        A valid two character language code.
   *
   * @abstract
   */
  constructor(e = {}) {
    super();
    const n = {
      id: e.id || "vjs_track_" + xa(),
      kind: e.kind || "",
      language: e.language || ""
    };
    let a = e.label || "";
    for (const i in n)
      Object.defineProperty(this, i, {
        get() {
          return n[i];
        },
        set() {
        }
      });
    Object.defineProperty(this, "label", {
      get() {
        return a;
      },
      set(i) {
        i !== a && (a = i, this.trigger("labelchange"));
      }
    });
  }
}
const hp = function(t) {
  return new URL(t, Me.baseURI);
}, B3 = function(t) {
  return new URL(t, Me.baseURI).href;
}, fp = function(t) {
  if (typeof t == "string") {
    const n = /^(\/?)([\s\S]*?)((?:\.{1,2}|[^\/]+?)(\.([^\.\/\?]+)))(?:[\/]*|[\?].*)$/.exec(t);
    if (n)
      return n.pop().toLowerCase();
  }
  return "";
}, Ad = function(t, e = j.location) {
  return hp(t).origin !== e.origin;
};
var sne = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  parseUrl: hp,
  getAbsoluteURL: B3,
  getFileExtension: fp,
  isCrossOrigin: Ad
});
const rb = function(t, e) {
  const n = new j.WebVTT.Parser(j, j.vttjs, j.WebVTT.StringDecoder()), a = [];
  n.oncue = function(i) {
    e.addCue(i);
  }, n.onparsingerror = function(i) {
    a.push(i);
  }, n.onflush = function() {
    e.trigger({
      type: "loadeddata",
      target: e
    });
  }, n.parse(t), a.length > 0 && (j.console && j.console.groupCollapsed && j.console.groupCollapsed(`Text Track parsing errors for ${e.src}`), a.forEach((i) => ut.error(i)), j.console && j.console.groupEnd && j.console.groupEnd()), n.flush();
}, sb = function(t, e) {
  const n = {
    uri: t
  }, a = Ad(t);
  a && (n.cors = a);
  const i = e.tech_.crossOrigin() === "use-credentials";
  i && (n.withCredentials = i), o5(n, Et(this, function(r, s, o) {
    if (r)
      return ut.error(r, s);
    e.loaded_ = !0, typeof j.WebVTT != "function" ? e.tech_ && e.tech_.any(["vttjsloaded", "vttjserror"], (l) => {
      if (l.type === "vttjserror") {
        ut.error(`vttjs failed to load, stopping trying to process ${e.src}`);
        return;
      }
      return rb(o, e);
    }) : rb(o, e);
  }));
};
class Wl extends dp {
  /**
   * Create an instance of this class.
   *
   * @param {Object} options={}
   *        Object of option names and values
   *
   * @param {Tech} options.tech
   *        A reference to the tech that owns this TextTrack.
   *
   * @param {TextTrack~Kind} [options.kind='subtitles']
   *        A valid text track kind.
   *
   * @param {TextTrack~Mode} [options.mode='disabled']
   *        A valid text track mode.
   *
   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
   *        A unique id for this TextTrack.
   *
   * @param {string} [options.label='']
   *        The menu label for this track.
   *
   * @param {string} [options.language='']
   *        A valid two character language code.
   *
   * @param {string} [options.srclang='']
   *        A valid two character language code. An alternative, but deprioritized
   *        version of `options.language`
   *
   * @param {string} [options.src]
   *        A url to TextTrack cues.
   *
   * @param {boolean} [options.default]
   *        If this track should default to on or off.
   */
  constructor(e = {}) {
    if (!e.tech)
      throw new Error("A tech was not provided.");
    const n = wt(e, {
      kind: rne[e.kind] || "subtitles",
      language: e.language || e.srclang || ""
    });
    let a = ib[n.mode] || "disabled";
    const i = n.default;
    (n.kind === "metadata" || n.kind === "chapters") && (a = "hidden"), super(n), this.tech_ = n.tech, this.cues_ = [], this.activeCues_ = [], this.preload_ = this.tech_.preloadTextTracks !== !1;
    const r = new Su(this.cues_), s = new Su(this.activeCues_);
    let o = !1;
    this.timeupdateHandler = Et(this, function(c = {}) {
      if (!this.tech_.isDisposed()) {
        if (!this.tech_.isReady_) {
          c.type !== "timeupdate" && (this.rvf_ = this.tech_.requestVideoFrameCallback(this.timeupdateHandler));
          return;
        }
        this.activeCues = this.activeCues, o && (this.trigger("cuechange"), o = !1), c.type !== "timeupdate" && (this.rvf_ = this.tech_.requestVideoFrameCallback(this.timeupdateHandler));
      }
    });
    const l = () => {
      this.stopTracking();
    };
    this.tech_.one("dispose", l), a !== "disabled" && this.startTracking(), Object.defineProperties(this, {
      /**
       * @memberof TextTrack
       * @member {boolean} default
       *         If this track was set to be on or off by default. Cannot be changed after
       *         creation.
       * @instance
       *
       * @readonly
       */
      default: {
        get() {
          return i;
        },
        set() {
        }
      },
      /**
       * @memberof TextTrack
       * @member {string} mode
       *         Set the mode of this TextTrack to a valid {@link TextTrack~Mode}. Will
       *         not be set if setting to an invalid mode.
       * @instance
       *
       * @fires TextTrack#modechange
       */
      mode: {
        get() {
          return a;
        },
        set(c) {
          ib[c] && a !== c && (a = c, !this.preload_ && a !== "disabled" && this.cues.length === 0 && sb(this.src, this), this.stopTracking(), a !== "disabled" && this.startTracking(), this.trigger("modechange"));
        }
      },
      /**
       * @memberof TextTrack
       * @member {TextTrackCueList} cues
       *         The text track cue list for this TextTrack.
       * @instance
       */
      cues: {
        get() {
          return this.loaded_ ? r : null;
        },
        set() {
        }
      },
      /**
       * @memberof TextTrack
       * @member {TextTrackCueList} activeCues
       *         The list text track cues that are currently active for this TextTrack.
       * @instance
       */
      activeCues: {
        get() {
          if (!this.loaded_)
            return null;
          if (this.cues.length === 0)
            return s;
          const c = this.tech_.currentTime(), u = [];
          for (let f = 0, m = this.cues.length; f < m; f++) {
            const _ = this.cues[f];
            _.startTime <= c && _.endTime >= c && u.push(_);
          }
          if (o = !1, u.length !== this.activeCues_.length)
            o = !0;
          else
            for (let f = 0; f < u.length; f++)
              this.activeCues_.indexOf(u[f]) === -1 && (o = !0);
          return this.activeCues_ = u, s.setCues_(this.activeCues_), s;
        },
        // /!\ Keep this setter empty (see the timeupdate handler above)
        set() {
        }
      }
    }), n.src ? (this.src = n.src, this.preload_ || (this.loaded_ = !0), (this.preload_ || n.kind !== "subtitles" && n.kind !== "captions") && sb(this.src, this)) : this.loaded_ = !0;
  }
  startTracking() {
    this.rvf_ = this.tech_.requestVideoFrameCallback(this.timeupdateHandler), this.tech_.on("timeupdate", this.timeupdateHandler);
  }
  stopTracking() {
    this.rvf_ && (this.tech_.cancelVideoFrameCallback(this.rvf_), this.rvf_ = void 0), this.tech_.off("timeupdate", this.timeupdateHandler);
  }
  /**
   * Add a cue to the internal list of cues.
   *
   * @param {TextTrack~Cue} cue
   *        The cue to add to our internal list
   */
  addCue(e) {
    let n = e;
    if (!("getCueAsHTML" in n)) {
      n = new j.vttjs.VTTCue(e.startTime, e.endTime, e.text);
      for (const i in e)
        i in n || (n[i] = e[i]);
      n.id = e.id, n.originalCue_ = e;
    }
    const a = this.tech_.textTracks();
    for (let i = 0; i < a.length; i++)
      a[i] !== this && a[i].removeCue(n);
    this.cues_.push(n), this.cues.setCues_(this.cues_);
  }
  /**
   * Remove a cue from our internal list
   *
   * @param {TextTrack~Cue} removeCue
   *        The cue to remove from our internal list
   */
  removeCue(e) {
    let n = this.cues_.length;
    for (; n--; ) {
      const a = this.cues_[n];
      if (a === e || a.originalCue_ && a.originalCue_ === e) {
        this.cues_.splice(n, 1), this.cues.setCues_(this.cues_);
        break;
      }
    }
  }
}
Wl.prototype.allowedEvents_ = {
  cuechange: "cuechange"
};
class R3 extends dp {
  /**
   * Create an instance of this class.
   *
   * @param {Object} [options={}]
   *        Object of option names and values
   *
   * @param {AudioTrack~Kind} [options.kind='']
   *        A valid audio track kind
   *
   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
   *        A unique id for this AudioTrack.
   *
   * @param {string} [options.label='']
   *        The menu label for this track.
   *
   * @param {string} [options.language='']
   *        A valid two character language code.
   *
   * @param {boolean} [options.enabled]
   *        If this track is the one that is currently playing. If this track is part of
   *        an {@link AudioTrackList}, only one {@link AudioTrack} will be enabled.
   */
  constructor(e = {}) {
    const n = wt(e, {
      kind: ine[e.kind] || ""
    });
    super(n);
    let a = !1;
    Object.defineProperty(this, "enabled", {
      get() {
        return a;
      },
      set(i) {
        typeof i != "boolean" || i === a || (a = i, this.trigger("enabledchange"));
      }
    }), n.enabled && (this.enabled = n.enabled), this.loaded_ = !0;
  }
}
class N3 extends dp {
  /**
   * Create an instance of this class.
   *
   * @param {Object} [options={}]
   *        Object of option names and values
   *
   * @param {string} [options.kind='']
   *        A valid {@link VideoTrack~Kind}
   *
   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
   *        A unique id for this AudioTrack.
   *
   * @param {string} [options.label='']
   *        The menu label for this track.
   *
   * @param {string} [options.language='']
   *        A valid two character language code.
   *
   * @param {boolean} [options.selected]
   *        If this track is the one that is currently playing.
   */
  constructor(e = {}) {
    const n = wt(e, {
      kind: ane[e.kind] || ""
    });
    super(n);
    let a = !1;
    Object.defineProperty(this, "selected", {
      get() {
        return a;
      },
      set(i) {
        typeof i != "boolean" || i === a || (a = i, this.trigger("selectedchange"));
      }
    }), n.selected && (this.selected = n.selected);
  }
}
class Ei extends fa {
  /**
   * Create an instance of this class.
   *
   * @param {Object} options={}
   *        Object of option names and values
   *
   * @param {Tech} options.tech
   *        A reference to the tech that owns this HTMLTrackElement.
   *
   * @param {TextTrack~Kind} [options.kind='subtitles']
   *        A valid text track kind.
   *
   * @param {TextTrack~Mode} [options.mode='disabled']
   *        A valid text track mode.
   *
   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
   *        A unique id for this TextTrack.
   *
   * @param {string} [options.label='']
   *        The menu label for this track.
   *
   * @param {string} [options.language='']
   *        A valid two character language code.
   *
   * @param {string} [options.srclang='']
   *        A valid two character language code. An alternative, but deprioritized
   *        version of `options.language`
   *
   * @param {string} [options.src]
   *        A url to TextTrack cues.
   *
   * @param {boolean} [options.default]
   *        If this track should default to on or off.
   */
  constructor(e = {}) {
    super();
    let n;
    const a = new Wl(e);
    this.kind = a.kind, this.src = a.src, this.srclang = a.language, this.label = a.label, this.default = a.default, Object.defineProperties(this, {
      /**
       * @memberof HTMLTrackElement
       * @member {HTMLTrackElement~ReadyState} readyState
       *         The current ready state of the track element.
       * @instance
       */
      readyState: {
        get() {
          return n;
        }
      },
      /**
       * @memberof HTMLTrackElement
       * @member {TextTrack} track
       *         The underlying TextTrack object.
       * @instance
       *
       */
      track: {
        get() {
          return a;
        }
      }
    }), n = Ei.NONE, a.addEventListener("loadeddata", () => {
      n = Ei.LOADED, this.trigger({
        type: "load",
        target: this
      });
    });
  }
}
Ei.prototype.allowedEvents_ = {
  load: "load"
};
Ei.NONE = 0;
Ei.LOADING = 1;
Ei.LOADED = 2;
Ei.ERROR = 3;
const Ta = {
  audio: {
    ListClass: ene,
    TrackClass: R3,
    capitalName: "Audio"
  },
  video: {
    ListClass: tne,
    TrackClass: N3,
    capitalName: "Video"
  },
  text: {
    ListClass: P3,
    TrackClass: Wl,
    capitalName: "Text"
  }
};
Object.keys(Ta).forEach(function(t) {
  Ta[t].getterName = `${t}Tracks`, Ta[t].privateName = `${t}Tracks_`;
});
const Xs = {
  remoteText: {
    ListClass: P3,
    TrackClass: Wl,
    capitalName: "RemoteText",
    getterName: "remoteTextTracks",
    privateName: "remoteTextTracks_"
  },
  remoteTextEl: {
    ListClass: nne,
    TrackClass: Ei,
    capitalName: "RemoteTextTrackEls",
    getterName: "remoteTextTrackEls",
    privateName: "remoteTextTrackEls_"
  }
}, Rn = Object.assign({}, Ta, Xs);
Xs.names = Object.keys(Xs);
Ta.names = Object.keys(Ta);
Rn.names = [].concat(Xs.names).concat(Ta.names);
function one(t, e, n, a, i = {}) {
  const r = t.textTracks();
  i.kind = e, n && (i.label = n), a && (i.language = a), i.tech = t;
  const s = new Rn.text.TrackClass(i);
  return r.addTrack(s), s;
}
class rt extends ye {
  /**
  * Create an instance of this Tech.
  *
  * @param {Object} [options]
  *        The key/value store of player options.
  *
  * @param {Function} [ready]
  *        Callback function to call when the `HTML5` Tech is ready.
  */
  constructor(e = {}, n = function() {
  }) {
    e.reportTouchActivity = !1, super(null, e, n), this.onDurationChange_ = (a) => this.onDurationChange(a), this.trackProgress_ = (a) => this.trackProgress(a), this.trackCurrentTime_ = (a) => this.trackCurrentTime(a), this.stopTrackingCurrentTime_ = (a) => this.stopTrackingCurrentTime(a), this.disposeSourceHandler_ = (a) => this.disposeSourceHandler(a), this.queuedHanders_ = /* @__PURE__ */ new Set(), this.hasStarted_ = !1, this.on("playing", function() {
      this.hasStarted_ = !0;
    }), this.on("loadstart", function() {
      this.hasStarted_ = !1;
    }), Rn.names.forEach((a) => {
      const i = Rn[a];
      e && e[i.getterName] && (this[i.privateName] = e[i.getterName]);
    }), this.featuresProgressEvents || this.manualProgressOn(), this.featuresTimeupdateEvents || this.manualTimeUpdatesOn(), ["Text", "Audio", "Video"].forEach((a) => {
      e[`native${a}Tracks`] === !1 && (this[`featuresNative${a}Tracks`] = !1);
    }), e.nativeCaptions === !1 || e.nativeTextTracks === !1 ? this.featuresNativeTextTracks = !1 : (e.nativeCaptions === !0 || e.nativeTextTracks === !0) && (this.featuresNativeTextTracks = !0), this.featuresNativeTextTracks || this.emulateTextTracks(), this.preloadTextTracks = e.preloadTextTracks !== !1, this.autoRemoteTextTracks_ = new Rn.text.ListClass(), this.initTrackListeners(), e.nativeControlsForTouch || this.emitTapEvents(), this.constructor && (this.name_ = this.constructor.name || "Unknown Tech");
  }
  /**
   * A special function to trigger source set in a way that will allow player
   * to re-trigger if the player or tech are not ready yet.
   *
   * @fires Tech#sourceset
   * @param {string} src The source string at the time of the source changing.
   */
  triggerSourceset(e) {
    this.isReady_ || this.one("ready", () => this.setTimeout(() => this.triggerSourceset(e), 1)), this.trigger({
      src: e,
      type: "sourceset"
    });
  }
  /* Fallbacks for unsupported event types
  ================================================================================ */
  /**
   * Polyfill the `progress` event for browsers that don't support it natively.
   *
   * @see {@link Tech#trackProgress}
   */
  manualProgressOn() {
    this.on("durationchange", this.onDurationChange_), this.manualProgress = !0, this.one("ready", this.trackProgress_);
  }
  /**
   * Turn off the polyfill for `progress` events that was created in
   * {@link Tech#manualProgressOn}
   */
  manualProgressOff() {
    this.manualProgress = !1, this.stopTrackingProgress(), this.off("durationchange", this.onDurationChange_);
  }
  /**
   * This is used to trigger a `progress` event when the buffered percent changes. It
   * sets an interval function that will be called every 500 milliseconds to check if the
   * buffer end percent has changed.
   *
   * > This function is called by {@link Tech#manualProgressOn}
   *
   * @param {Event} event
   *        The `ready` event that caused this to run.
   *
   * @listens Tech#ready
   * @fires Tech#progress
   */
  trackProgress(e) {
    this.stopTrackingProgress(), this.progressInterval = this.setInterval(Et(this, function() {
      const n = this.bufferedPercent();
      this.bufferedPercent_ !== n && this.trigger("progress"), this.bufferedPercent_ = n, n === 1 && this.stopTrackingProgress();
    }), 500);
  }
  /**
   * Update our internal duration on a `durationchange` event by calling
   * {@link Tech#duration}.
   *
   * @param {Event} event
   *        The `durationchange` event that caused this to run.
   *
   * @listens Tech#durationchange
   */
  onDurationChange(e) {
    this.duration_ = this.duration();
  }
  /**
   * Get and create a `TimeRange` object for buffering.
   *
   * @return {TimeRange}
   *         The time range object that was created.
   */
  buffered() {
    return Ra(0, 0);
  }
  /**
   * Get the percentage of the current video that is currently buffered.
   *
   * @return {number}
   *         A number from 0 to 1 that represents the decimal percentage of the
   *         video that is buffered.
   *
   */
  bufferedPercent() {
    return O3(this.buffered(), this.duration_);
  }
  /**
   * Turn off the polyfill for `progress` events that was created in
   * {@link Tech#manualProgressOn}
   * Stop manually tracking progress events by clearing the interval that was set in
   * {@link Tech#trackProgress}.
   */
  stopTrackingProgress() {
    this.clearInterval(this.progressInterval);
  }
  /**
   * Polyfill the `timeupdate` event for browsers that don't support it.
   *
   * @see {@link Tech#trackCurrentTime}
   */
  manualTimeUpdatesOn() {
    this.manualTimeUpdates = !0, this.on("play", this.trackCurrentTime_), this.on("pause", this.stopTrackingCurrentTime_);
  }
  /**
   * Turn off the polyfill for `timeupdate` events that was created in
   * {@link Tech#manualTimeUpdatesOn}
   */
  manualTimeUpdatesOff() {
    this.manualTimeUpdates = !1, this.stopTrackingCurrentTime(), this.off("play", this.trackCurrentTime_), this.off("pause", this.stopTrackingCurrentTime_);
  }
  /**
   * Sets up an interval function to track current time and trigger `timeupdate` every
   * 250 milliseconds.
   *
   * @listens Tech#play
   * @triggers Tech#timeupdate
   */
  trackCurrentTime() {
    this.currentTimeInterval && this.stopTrackingCurrentTime(), this.currentTimeInterval = this.setInterval(function() {
      this.trigger({
        type: "timeupdate",
        target: this,
        manuallyTriggered: !0
      });
    }, 250);
  }
  /**
   * Stop the interval function created in {@link Tech#trackCurrentTime} so that the
   * `timeupdate` event is no longer triggered.
   *
   * @listens {Tech#pause}
   */
  stopTrackingCurrentTime() {
    this.clearInterval(this.currentTimeInterval), this.trigger({
      type: "timeupdate",
      target: this,
      manuallyTriggered: !0
    });
  }
  /**
   * Turn off all event polyfills, clear the `Tech`s {@link AudioTrackList},
   * {@link VideoTrackList}, and {@link TextTrackList}, and dispose of this Tech.
   *
   * @fires Component#dispose
   */
  dispose() {
    this.clearTracks(Ta.names), this.manualProgress && this.manualProgressOff(), this.manualTimeUpdates && this.manualTimeUpdatesOff(), super.dispose();
  }
  /**
   * Clear out a single `TrackList` or an array of `TrackLists` given their names.
   *
   * > Note: Techs without source handlers should call this between sources for `video`
   *         & `audio` tracks. You don't want to use them between tracks!
   *
   * @param {string[]|string} types
   *        TrackList names to clear, valid names are `video`, `audio`, and
   *        `text`.
   */
  clearTracks(e) {
    e = [].concat(e), e.forEach((n) => {
      const a = this[`${n}Tracks`]() || [];
      let i = a.length;
      for (; i--; ) {
        const r = a[i];
        n === "text" && this.removeRemoteTextTrack(r), a.removeTrack(r);
      }
    });
  }
  /**
   * Remove any TextTracks added via addRemoteTextTrack that are
   * flagged for automatic garbage collection
   */
  cleanupAutoTextTracks() {
    const e = this.autoRemoteTextTracks_ || [];
    let n = e.length;
    for (; n--; ) {
      const a = e[n];
      this.removeRemoteTextTrack(a);
    }
  }
  /**
   * Reset the tech, which will removes all sources and reset the internal readyState.
   *
   * @abstract
   */
  reset() {
  }
  /**
   * Get the value of `crossOrigin` from the tech.
   *
   * @abstract
   *
   * @see {Html5#crossOrigin}
   */
  crossOrigin() {
  }
  /**
   * Set the value of `crossOrigin` on the tech.
   *
   * @abstract
   *
   * @param {string} crossOrigin the crossOrigin value
   * @see {Html5#setCrossOrigin}
   */
  setCrossOrigin() {
  }
  /**
   * Get or set an error on the Tech.
   *
   * @param {MediaError} [err]
   *        Error to set on the Tech
   *
   * @return {MediaError|null}
   *         The current error object on the tech, or null if there isn't one.
   */
  error(e) {
    return e !== void 0 && (this.error_ = new Yt(e), this.trigger("error")), this.error_;
  }
  /**
   * Returns the `TimeRange`s that have been played through for the current source.
   *
   * > NOTE: This implementation is incomplete. It does not track the played `TimeRange`.
   *         It only checks whether the source has played at all or not.
   *
   * @return {TimeRange}
   *         - A single time range if this video has played
   *         - An empty set of ranges if not.
   */
  played() {
    return this.hasStarted_ ? Ra(0, 0) : Ra();
  }
  /**
   * Start playback
   *
   * @abstract
   *
   * @see {Html5#play}
   */
  play() {
  }
  /**
   * Set whether we are scrubbing or not
   *
   * @abstract
   * @param {boolean} _isScrubbing
   *                  - true for we are currently scrubbing
   *                  - false for we are no longer scrubbing
   *
   * @see {Html5#setScrubbing}
   */
  setScrubbing(e) {
  }
  /**
   * Get whether we are scrubbing or not
   *
   * @abstract
   *
   * @see {Html5#scrubbing}
   */
  scrubbing() {
  }
  /**
   * Causes a manual time update to occur if {@link Tech#manualTimeUpdatesOn} was
   * previously called.
   *
   * @param {number} _seconds
   *        Set the current time of the media to this.
   * @fires Tech#timeupdate
   */
  setCurrentTime(e) {
    this.manualTimeUpdates && this.trigger({
      type: "timeupdate",
      target: this,
      manuallyTriggered: !0
    });
  }
  /**
   * Turn on listeners for {@link VideoTrackList}, {@link {AudioTrackList}, and
   * {@link TextTrackList} events.
   *
   * This adds {@link EventTarget~EventListeners} for `addtrack`, and  `removetrack`.
   *
   * @fires Tech#audiotrackchange
   * @fires Tech#videotrackchange
   * @fires Tech#texttrackchange
   */
  initTrackListeners() {
    Ta.names.forEach((e) => {
      const n = Ta[e], a = () => {
        this.trigger(`${e}trackchange`);
      }, i = this[n.getterName]();
      i.addEventListener("removetrack", a), i.addEventListener("addtrack", a), this.on("dispose", () => {
        i.removeEventListener("removetrack", a), i.removeEventListener("addtrack", a);
      });
    });
  }
  /**
   * Emulate TextTracks using vtt.js if necessary
   *
   * @fires Tech#vttjsloaded
   * @fires Tech#vttjserror
   */
  addWebVttScript_() {
    if (!j.WebVTT)
      if (Me.body.contains(this.el())) {
        if (!this.options_["vtt.js"] && js(wg) && Object.keys(wg).length > 0) {
          this.trigger("vttjsloaded");
          return;
        }
        const e = Me.createElement("script");
        e.src = this.options_["vtt.js"] || "https://vjs.zencdn.net/vttjs/0.14.1/vtt.min.js", e.onload = () => {
          this.trigger("vttjsloaded");
        }, e.onerror = () => {
          this.trigger("vttjserror");
        }, this.on("dispose", () => {
          e.onload = null, e.onerror = null;
        }), j.WebVTT = !0, this.el().parentNode.appendChild(e);
      } else
        this.ready(this.addWebVttScript_);
  }
  /**
   * Emulate texttracks
   *
   */
  emulateTextTracks() {
    const e = this.textTracks(), n = this.remoteTextTracks(), a = (o) => e.addTrack(o.track), i = (o) => e.removeTrack(o.track);
    n.on("addtrack", a), n.on("removetrack", i), this.addWebVttScript_();
    const r = () => this.trigger("texttrackchange"), s = () => {
      r();
      for (let o = 0; o < e.length; o++) {
        const l = e[o];
        l.removeEventListener("cuechange", r), l.mode === "showing" && l.addEventListener("cuechange", r);
      }
    };
    s(), e.addEventListener("change", s), e.addEventListener("addtrack", s), e.addEventListener("removetrack", s), this.on("dispose", function() {
      n.off("addtrack", a), n.off("removetrack", i), e.removeEventListener("change", s), e.removeEventListener("addtrack", s), e.removeEventListener("removetrack", s);
      for (let o = 0; o < e.length; o++)
        e[o].removeEventListener("cuechange", r);
    });
  }
  /**
   * Create and returns a remote {@link TextTrack} object.
   *
   * @param {string} kind
   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata)
   *
   * @param {string} [label]
   *        Label to identify the text track
   *
   * @param {string} [language]
   *        Two letter language abbreviation
   *
   * @return {TextTrack}
   *         The TextTrack that gets created.
   */
  addTextTrack(e, n, a) {
    if (!e)
      throw new Error("TextTrack kind is required but was not provided");
    return one(this, e, n, a);
  }
  /**
   * Create an emulated TextTrack for use by addRemoteTextTrack
   *
   * This is intended to be overridden by classes that inherit from
   * Tech in order to create native or custom TextTracks.
   *
   * @param {Object} options
   *        The object should contain the options to initialize the TextTrack with.
   *
   * @param {string} [options.kind]
   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata).
   *
   * @param {string} [options.label].
   *        Label to identify the text track
   *
   * @param {string} [options.language]
   *        Two letter language abbreviation.
   *
   * @return {HTMLTrackElement}
   *         The track element that gets created.
   */
  createRemoteTextTrack(e) {
    const n = wt(e, {
      tech: this
    });
    return new Xs.remoteTextEl.TrackClass(n);
  }
  /**
   * Creates a remote text track object and returns an html track element.
   *
   * > Note: This can be an emulated {@link HTMLTrackElement} or a native one.
   *
   * @param {Object} options
   *        See {@link Tech#createRemoteTextTrack} for more detailed properties.
   *
   * @param {boolean} [manualCleanup=false]
   *        - When false: the TextTrack will be automatically removed from the video
   *          element whenever the source changes
   *        - When True: The TextTrack will have to be cleaned up manually
   *
   * @return {HTMLTrackElement}
   *         An Html Track Element.
   *
   */
  addRemoteTextTrack(e = {}, n) {
    const a = this.createRemoteTextTrack(e);
    return typeof n != "boolean" && (n = !1), this.remoteTextTrackEls().addTrackElement_(a), this.remoteTextTracks().addTrack(a.track), n === !1 && this.ready(() => this.autoRemoteTextTracks_.addTrack(a.track)), a;
  }
  /**
   * Remove a remote text track from the remote `TextTrackList`.
   *
   * @param {TextTrack} track
   *        `TextTrack` to remove from the `TextTrackList`
   */
  removeRemoteTextTrack(e) {
    const n = this.remoteTextTrackEls().getTrackElementByTrack_(e);
    this.remoteTextTrackEls().removeTrackElement_(n), this.remoteTextTracks().removeTrack(e), this.autoRemoteTextTracks_.removeTrack(e);
  }
  /**
   * Gets available media playback quality metrics as specified by the W3C's Media
   * Playback Quality API.
   *
   * @see [Spec]{@link https://wicg.github.io/media-playback-quality}
   *
   * @return {Object}
   *         An object with supported media playback quality metrics
   *
   * @abstract
   */
  getVideoPlaybackQuality() {
    return {};
  }
  /**
   * Attempt to create a floating video window always on top of other windows
   * so that users may continue consuming media while they interact with other
   * content sites, or applications on their device.
   *
   * @see [Spec]{@link https://wicg.github.io/picture-in-picture}
   *
   * @return {Promise|undefined}
   *         A promise with a Picture-in-Picture window if the browser supports
   *         Promises (or one was passed in as an option). It returns undefined
   *         otherwise.
   *
   * @abstract
   */
  requestPictureInPicture() {
    return Promise.reject();
  }
  /**
   * A method to check for the value of the 'disablePictureInPicture' <video> property.
   * Defaults to true, as it should be considered disabled if the tech does not support pip
   *
   * @abstract
   */
  disablePictureInPicture() {
    return !0;
  }
  /**
   * A method to set or unset the 'disablePictureInPicture' <video> property.
   *
   * @abstract
   */
  setDisablePictureInPicture() {
  }
  /**
   * A fallback implementation of requestVideoFrameCallback using requestAnimationFrame
   *
   * @param {function} cb
   * @return {number} request id
   */
  requestVideoFrameCallback(e) {
    const n = xa();
    return !this.isReady_ || this.paused() ? (this.queuedHanders_.add(n), this.one("playing", () => {
      this.queuedHanders_.has(n) && (this.queuedHanders_.delete(n), e());
    })) : this.requestNamedAnimationFrame(n, e), n;
  }
  /**
   * A fallback implementation of cancelVideoFrameCallback
   *
   * @param {number} id id of callback to be cancelled
   */
  cancelVideoFrameCallback(e) {
    this.queuedHanders_.has(e) ? this.queuedHanders_.delete(e) : this.cancelNamedAnimationFrame(e);
  }
  /**
   * A method to set a poster from a `Tech`.
   *
   * @abstract
   */
  setPoster() {
  }
  /**
   * A method to check for the presence of the 'playsinline' <video> attribute.
   *
   * @abstract
   */
  playsinline() {
  }
  /**
   * A method to set or unset the 'playsinline' <video> attribute.
   *
   * @abstract
   */
  setPlaysinline() {
  }
  /**
   * Attempt to force override of native audio tracks.
   *
   * @param {boolean} override - If set to true native audio will be overridden,
   * otherwise native audio will potentially be used.
   *
   * @abstract
   */
  overrideNativeAudioTracks(e) {
  }
  /**
   * Attempt to force override of native video tracks.
   *
   * @param {boolean} override - If set to true native video will be overridden,
   * otherwise native video will potentially be used.
   *
   * @abstract
   */
  overrideNativeVideoTracks(e) {
  }
  /**
   * Check if the tech can support the given mime-type.
   *
   * The base tech does not support any type, but source handlers might
   * overwrite this.
   *
   * @param  {string} _type
   *         The mimetype to check for support
   *
   * @return {string}
   *         'probably', 'maybe', or empty string
   *
   * @see [Spec]{@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/canPlayType}
   *
   * @abstract
   */
  canPlayType(e) {
    return "";
  }
  /**
   * Check if the type is supported by this tech.
   *
   * The base tech does not support any type, but source handlers might
   * overwrite this.
   *
   * @param {string} _type
   *        The media type to check
   * @return {string} Returns the native video element's response
   */
  static canPlayType(e) {
    return "";
  }
  /**
   * Check if the tech can support the given source
   *
   * @param {Object} srcObj
   *        The source object
   * @param {Object} options
   *        The options passed to the tech
   * @return {string} 'probably', 'maybe', or '' (empty string)
   */
  static canPlaySource(e, n) {
    return rt.canPlayType(e.type);
  }
  /*
   * Return whether the argument is a Tech or not.
   * Can be passed either a Class like `Html5` or a instance like `player.tech_`
   *
   * @param {Object} component
   *        The item to check
   *
   * @return {boolean}
   *         Whether it is a tech or not
   *         - True if it is a tech
   *         - False if it is not
   */
  static isTech(e) {
    return e.prototype instanceof rt || e instanceof rt || e === rt;
  }
  /**
   * Registers a `Tech` into a shared list for videojs.
   *
   * @param {string} name
   *        Name of the `Tech` to register.
   *
   * @param {Object} tech
   *        The `Tech` class to register.
   */
  static registerTech(e, n) {
    if (rt.techs_ || (rt.techs_ = {}), !rt.isTech(n))
      throw new Error(`Tech ${e} must be a Tech`);
    if (!rt.canPlayType)
      throw new Error("Techs must have a static canPlayType method on them");
    if (!rt.canPlaySource)
      throw new Error("Techs must have a static canPlaySource method on them");
    return e = qt(e), rt.techs_[e] = n, rt.techs_[fl(e)] = n, e !== "Tech" && rt.defaultTechOrder_.push(e), n;
  }
  /**
   * Get a `Tech` from the shared list by name.
   *
   * @param {string} name
   *        `camelCase` or `TitleCase` name of the Tech to get
   *
   * @return {Tech|undefined}
   *         The `Tech` or undefined if there was no tech with the name requested.
   */
  static getTech(e) {
    if (e) {
      if (rt.techs_ && rt.techs_[e])
        return rt.techs_[e];
      if (e = qt(e), j && j.videojs && j.videojs[e])
        return ut.warn(`The ${e} tech was added to the videojs object when it should be registered using videojs.registerTech(name, tech)`), j.videojs[e];
    }
  }
}
Rn.names.forEach(function(t) {
  const e = Rn[t];
  rt.prototype[e.getterName] = function() {
    return this[e.privateName] = this[e.privateName] || new e.ListClass(), this[e.privateName];
  };
});
rt.prototype.featuresVolumeControl = !0;
rt.prototype.featuresMuteControl = !0;
rt.prototype.featuresFullscreenResize = !1;
rt.prototype.featuresPlaybackRate = !1;
rt.prototype.featuresProgressEvents = !1;
rt.prototype.featuresSourceset = !1;
rt.prototype.featuresTimeupdateEvents = !1;
rt.prototype.featuresNativeTextTracks = !1;
rt.prototype.featuresVideoFrameCallback = !1;
rt.withSourceHandlers = function(t) {
  t.registerSourceHandler = function(n, a) {
    let i = t.sourceHandlers;
    i || (i = t.sourceHandlers = []), a === void 0 && (a = i.length), i.splice(a, 0, n);
  }, t.canPlayType = function(n) {
    const a = t.sourceHandlers || [];
    let i;
    for (let r = 0; r < a.length; r++)
      if (i = a[r].canPlayType(n), i)
        return i;
    return "";
  }, t.selectSourceHandler = function(n, a) {
    const i = t.sourceHandlers || [];
    let r;
    for (let s = 0; s < i.length; s++)
      if (r = i[s].canHandleSource(n, a), r)
        return i[s];
    return null;
  }, t.canPlaySource = function(n, a) {
    const i = t.selectSourceHandler(n, a);
    return i ? i.canHandleSource(n, a) : "";
  }, ["seekable", "seeking", "duration"].forEach(function(n) {
    const a = this[n];
    typeof a == "function" && (this[n] = function() {
      return this.sourceHandler_ && this.sourceHandler_[n] ? this.sourceHandler_[n].apply(this.sourceHandler_, arguments) : a.apply(this, arguments);
    });
  }, t.prototype), t.prototype.setSource = function(n) {
    let a = t.selectSourceHandler(n, this.options_);
    a || (t.nativeSourceHandler ? a = t.nativeSourceHandler : ut.error("No source handler found for the current source.")), this.disposeSourceHandler(), this.off("dispose", this.disposeSourceHandler_), a !== t.nativeSourceHandler && (this.currentSource_ = n), this.sourceHandler_ = a.handleSource(n, this, this.options_), this.one("dispose", this.disposeSourceHandler_);
  }, t.prototype.disposeSourceHandler = function() {
    this.currentSource_ && (this.clearTracks(["audio", "video"]), this.currentSource_ = null), this.cleanupAutoTextTracks(), this.sourceHandler_ && (this.sourceHandler_.dispose && this.sourceHandler_.dispose(), this.sourceHandler_ = null);
  };
};
ye.registerComponent("Tech", rt);
rt.registerTech("Tech", rt);
rt.defaultTechOrder_ = [];
const Ir = {}, Au = {}, Eu = {};
function lne(t, e) {
  Ir[t] = Ir[t] || [], Ir[t].push(e);
}
function cne(t, e, n) {
  t.setTimeout(() => _r(e, Ir[e.type], n, t), 1);
}
function une(t, e) {
  t.forEach((n) => n.setTech && n.setTech(e));
}
function dne(t, e, n) {
  return t.reduceRight(pp(n), e[n]());
}
function hne(t, e, n, a) {
  return e[n](t.reduce(pp(n), a));
}
function ob(t, e, n, a = null) {
  const i = "call" + qt(n), r = t.reduce(pp(i), a), s = r === Eu, o = s ? null : e[n](r);
  return mne(t, n, o, s), o;
}
const fne = {
  buffered: 1,
  currentTime: 1,
  duration: 1,
  muted: 1,
  played: 1,
  paused: 1,
  seekable: 1,
  volume: 1,
  ended: 1
}, pne = {
  setCurrentTime: 1,
  setMuted: 1,
  setVolume: 1
}, lb = {
  play: 1,
  pause: 1
};
function pp(t) {
  return (e, n) => e === Eu ? Eu : n[t] ? n[t](e) : e;
}
function mne(t, e, n, a) {
  for (let i = t.length - 1; i >= 0; i--) {
    const r = t[i];
    r[e] && r[e](a, n);
  }
}
function gne(t) {
  Au.hasOwnProperty(t.id()) && delete Au[t.id()];
}
function bne(t, e) {
  const n = Au[t.id()];
  let a = null;
  if (n == null)
    return a = e(t), Au[t.id()] = [[e, a]], a;
  for (let i = 0; i < n.length; i++) {
    const [r, s] = n[i];
    r === e && (a = s);
  }
  return a === null && (a = e(t), n.push([e, a])), a;
}
function _r(t = {}, e = [], n, a, i = [], r = !1) {
  const [s, ...o] = e;
  if (typeof s == "string")
    _r(t, Ir[s], n, a, i, r);
  else if (s) {
    const l = bne(a, s);
    if (!l.setSource)
      return i.push(l), _r(t, o, n, a, i, r);
    l.setSource(Object.assign({}, t), function(c, u) {
      if (c)
        return _r(t, o, n, a, i, r);
      i.push(l), _r(u, t.type === u.type ? o : Ir[u.type], n, a, i, r);
    });
  } else o.length ? _r(t, o, n, a, i, r) : r ? n(t, i) : _r(t, Ir["*"], n, a, i, !0);
}
const vne = {
  opus: "video/ogg",
  ogv: "video/ogg",
  mp4: "video/mp4",
  mov: "video/mp4",
  m4v: "video/mp4",
  mkv: "video/x-matroska",
  m4a: "audio/mp4",
  mp3: "audio/mpeg",
  aac: "audio/aac",
  caf: "audio/x-caf",
  flac: "audio/flac",
  oga: "audio/ogg",
  wav: "audio/wav",
  m3u8: "application/x-mpegURL",
  mpd: "application/dash+xml",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  gif: "image/gif",
  png: "image/png",
  svg: "image/svg+xml",
  webp: "image/webp"
}, Lu = function(t = "") {
  const e = fp(t);
  return vne[e.toLowerCase()] || "";
}, yne = (t, e) => {
  if (!e)
    return "";
  if (t.cache_.source.src === e && t.cache_.source.type)
    return t.cache_.source.type;
  const n = t.cache_.sources.filter((i) => i.src === e);
  if (n.length)
    return n[0].type;
  const a = t.$$("source");
  for (let i = 0; i < a.length; i++) {
    const r = a[i];
    if (r.type && r.src && r.src === e)
      return r.type;
  }
  return Lu(e);
}, $3 = function(t) {
  if (Array.isArray(t)) {
    let e = [];
    t.forEach(function(n) {
      n = $3(n), Array.isArray(n) ? e = e.concat(n) : ni(n) && e.push(n);
    }), t = e;
  } else typeof t == "string" && t.trim() ? t = [cb({
    src: t
  })] : ni(t) && typeof t.src == "string" && t.src && t.src.trim() ? t = [cb(t)] : t = [];
  return t;
};
function cb(t) {
  if (!t.type) {
    const e = Lu(t.src);
    e && (t.type = e);
  }
  return t;
}
var _ne = `<svg xmlns="http://www.w3.org/2000/svg">
  <defs>
    <symbol viewBox="0 0 48 48" id="vjs-icon-play">
      <path d="M16 10v28l22-14z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-pause">
      <path d="M12 38h8V10h-8v28zm16-28v28h8V10h-8z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-audio">
      <path d="M24 2C14.06 2 6 10.06 6 20v14c0 3.31 2.69 6 6 6h6V24h-8v-4c0-7.73 6.27-14 14-14s14 6.27 14 14v4h-8v16h6c3.31 0 6-2.69 6-6V20c0-9.94-8.06-18-18-18z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-captions">
      <path d="M38 8H10c-2.21 0-4 1.79-4 4v24c0 2.21 1.79 4 4 4h28c2.21 0 4-1.79 4-4V12c0-2.21-1.79-4-4-4zM22 22h-3v-1h-4v6h4v-1h3v2a2 2 0 0 1-2 2h-6a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2zm14 0h-3v-1h-4v6h4v-1h3v2a2 2 0 0 1-2 2h-6a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-subtitles">
      <path d="M40 8H8c-2.21 0-4 1.79-4 4v24c0 2.21 1.79 4 4 4h32c2.21 0 4-1.79 4-4V12c0-2.21-1.79-4-4-4zM8 24h8v4H8v-4zm20 12H8v-4h20v4zm12 0h-8v-4h8v4zm0-8H20v-4h20v4z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-fullscreen-enter">
      <path d="M14 28h-4v10h10v-4h-6v-6zm-4-8h4v-6h6v-4H10v10zm24 14h-6v4h10V28h-4v6zm-6-24v4h6v6h4V10H28z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-fullscreen-exit">
      <path d="M10 32h6v6h4V28H10v4zm6-16h-6v4h10V10h-4v6zm12 22h4v-6h6v-4H28v10zm4-22v-6h-4v10h10v-4h-6z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-play-circle">
      <path d="M20 33l12-9-12-9v18zm4-29C12.95 4 4 12.95 4 24s8.95 20 20 20 20-8.95 20-20S35.05 4 24 4zm0 36c-8.82 0-16-7.18-16-16S15.18 8 24 8s16 7.18 16 16-7.18 16-16 16z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-volume-mute">
      <path d="M33 24c0-3.53-2.04-6.58-5-8.05v4.42l4.91 4.91c.06-.42.09-.85.09-1.28zm5 0c0 1.88-.41 3.65-1.08 5.28l3.03 3.03C41.25 29.82 42 27 42 24c0-8.56-5.99-15.72-14-17.54v4.13c5.78 1.72 10 7.07 10 13.41zM8.55 6L6 8.55 15.45 18H6v12h8l10 10V26.55l8.51 8.51c-1.34 1.03-2.85 1.86-4.51 2.36v4.13a17.94 17.94 0 0 0 7.37-3.62L39.45 42 42 39.45l-18-18L8.55 6zM24 8l-4.18 4.18L24 16.36V8z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-volume-low">
      <path d="M14 18v12h8l10 10V8L22 18h-8z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-volume-medium">
      <path d="M37 24c0-3.53-2.04-6.58-5-8.05v16.11c2.96-1.48 5-4.53 5-8.06zm-27-6v12h8l10 10V8L18 18h-8z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-volume-high">
      <path d="M6 18v12h8l10 10V8L14 18H6zm27 6c0-3.53-2.04-6.58-5-8.05v16.11c2.96-1.48 5-4.53 5-8.06zM28 6.46v4.13c5.78 1.72 10 7.07 10 13.41s-4.22 11.69-10 13.41v4.13c8.01-1.82 14-8.97 14-17.54S36.01 8.28 28 6.46z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-spinner">
      <path d="M18.8 21l9.53-16.51C26.94 4.18 25.49 4 24 4c-4.8 0-9.19 1.69-12.64 4.51l7.33 12.69.11-.2zm24.28-3c-1.84-5.85-6.3-10.52-11.99-12.68L23.77 18h19.31zm.52 2H28.62l.58 1 9.53 16.5C41.99 33.94 44 29.21 44 24c0-1.37-.14-2.71-.4-4zm-26.53 4l-7.8-13.5C6.01 14.06 4 18.79 4 24c0 1.37.14 2.71.4 4h14.98l-2.31-4zM4.92 30c1.84 5.85 6.3 10.52 11.99 12.68L24.23 30H4.92zm22.54 0l-7.8 13.51c1.4.31 2.85.49 4.34.49 4.8 0 9.19-1.69 12.64-4.51L29.31 26.8 27.46 30z"></path>
    </symbol>
    <symbol viewBox="0 0 24 24" id="vjs-icon-hd">
      <path d="M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-8 12H9.5v-2h-2v2H6V9h1.5v2.5h2V9H11v6zm2-6h4c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1h-4V9zm1.5 4.5h2v-3h-2v3z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-chapters">
      <path d="M6 26h4v-4H6v4zm0 8h4v-4H6v4zm0-16h4v-4H6v4zm8 8h28v-4H14v4zm0 8h28v-4H14v4zm0-20v4h28v-4H14z"></path>
    </symbol>
    <symbol viewBox="0 0 40 40" id="vjs-icon-downloading">
      <path d="M18.208 36.875q-3.208-.292-5.979-1.729-2.771-1.438-4.812-3.729-2.042-2.292-3.188-5.229-1.146-2.938-1.146-6.23 0-6.583 4.334-11.416 4.333-4.834 10.833-5.5v3.166q-5.167.75-8.583 4.646Q6.25 14.75 6.25 19.958q0 5.209 3.396 9.104 3.396 3.896 8.562 4.646zM20 28.417L11.542 20l2.083-2.083 4.917 4.916v-11.25h2.916v11.25l4.875-4.916L28.417 20zm1.792 8.458v-3.167q1.833-.25 3.541-.958 1.709-.708 3.167-1.875l2.333 2.292q-1.958 1.583-4.25 2.541-2.291.959-4.791 1.167zm6.791-27.792q-1.541-1.125-3.25-1.854-1.708-.729-3.541-1.021V3.042q2.5.25 4.77 1.208 2.271.958 4.271 2.5zm4.584 21.584l-2.25-2.25q1.166-1.5 1.854-3.209.687-1.708.937-3.541h3.209q-.292 2.5-1.229 4.791-.938 2.292-2.521 4.209zm.541-12.417q-.291-1.833-.958-3.562-.667-1.73-1.833-3.188l2.375-2.208q1.541 1.916 2.458 4.208.917 2.292 1.167 4.75z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-file-download">
      <path d="M10.8 40.55q-1.35 0-2.375-1T7.4 37.15v-7.7h3.4v7.7h26.35v-7.7h3.4v7.7q0 1.4-1 2.4t-2.4 1zM24 32.1L13.9 22.05l2.45-2.45 5.95 5.95V7.15h3.4v18.4l5.95-5.95 2.45 2.45z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-file-download-done">
      <path d="M9.8 40.5v-3.45h28.4v3.45zm9.2-9.05L7.4 19.85l2.45-2.35L19 26.65l19.2-19.2 2.4 2.4z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-file-download-off">
      <path d="M4.9 4.75L43.25 43.1 41 45.3l-4.75-4.75q-.05.05-.075.025-.025-.025-.075-.025H10.8q-1.35 0-2.375-1T7.4 37.15v-7.7h3.4v7.7h22.05l-7-7-1.85 1.8L13.9 21.9l1.85-1.85L2.7 7zm26.75 14.7l2.45 2.45-3.75 3.8-2.45-2.5zM25.7 7.15V21.1l-3.4-3.45V7.15z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-share">
      <path d="M36 32.17c-1.52 0-2.89.59-3.93 1.54L17.82 25.4c.11-.45.18-.92.18-1.4s-.07-.95-.18-1.4l14.1-8.23c1.07 1 2.5 1.62 4.08 1.62 3.31 0 6-2.69 6-6s-2.69-6-6-6-6 2.69-6 6c0 .48.07.95.18 1.4l-14.1 8.23c-1.07-1-2.5-1.62-4.08-1.62-3.31 0-6 2.69-6 6s2.69 6 6 6c1.58 0 3.01-.62 4.08-1.62l14.25 8.31c-.1.42-.16.86-.16 1.31A5.83 5.83 0 1 0 36 32.17z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-cog">
      <path d="M38.86 25.95c.08-.64.14-1.29.14-1.95s-.06-1.31-.14-1.95l4.23-3.31c.38-.3.49-.84.24-1.28l-4-6.93c-.25-.43-.77-.61-1.22-.43l-4.98 2.01c-1.03-.79-2.16-1.46-3.38-1.97L29 4.84c-.09-.47-.5-.84-1-.84h-8c-.5 0-.91.37-.99.84l-.75 5.3a14.8 14.8 0 0 0-3.38 1.97L9.9 10.1a1 1 0 0 0-1.22.43l-4 6.93c-.25.43-.14.97.24 1.28l4.22 3.31C9.06 22.69 9 23.34 9 24s.06 1.31.14 1.95l-4.22 3.31c-.38.3-.49.84-.24 1.28l4 6.93c.25.43.77.61 1.22.43l4.98-2.01c1.03.79 2.16 1.46 3.38 1.97l.75 5.3c.08.47.49.84.99.84h8c.5 0 .91-.37.99-.84l.75-5.3a14.8 14.8 0 0 0 3.38-1.97l4.98 2.01a1 1 0 0 0 1.22-.43l4-6.93c.25-.43.14-.97-.24-1.28l-4.22-3.31zM24 31c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-square">
      <path d="M36 8H12c-2.21 0-4 1.79-4 4v24c0 2.21 1.79 4 4 4h24c2.21 0 4-1.79 4-4V12c0-2.21-1.79-4-4-4zm0 28H12V12h24v24z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-circle">
      <circle cx="24" cy="24" r="20"></circle>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-circle-outline">
      <path d="M24 4C12.95 4 4 12.95 4 24s8.95 20 20 20 20-8.95 20-20S35.05 4 24 4zm0 36c-8.82 0-16-7.18-16-16S15.18 8 24 8s16 7.18 16 16-7.18 16-16 16z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-circle-inner-circle">
      <path d="M24 4C12.97 4 4 12.97 4 24s8.97 20 20 20 20-8.97 20-20S35.03 4 24 4zm0 36c-8.82 0-16-7.18-16-16S15.18 8 24 8s16 7.18 16 16-7.18 16-16 16zm6-16c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6 6 2.69 6 6z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-cancel">
      <path d="M24 4C12.95 4 4 12.95 4 24s8.95 20 20 20 20-8.95 20-20S35.05 4 24 4zm10 27.17L31.17 34 24 26.83 16.83 34 14 31.17 21.17 24 14 16.83 16.83 14 24 21.17 31.17 14 34 16.83 26.83 24 34 31.17z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-replay">
      <path d="M24 10V2L14 12l10 10v-8c6.63 0 12 5.37 12 12s-5.37 12-12 12-12-5.37-12-12H8c0 8.84 7.16 16 16 16s16-7.16 16-16-7.16-16-16-16z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-repeat">
      <path d="M14 14h20v6l8-8-8-8v6H10v12h4v-8zm20 20H14v-6l-8 8 8 8v-6h24V26h-4v8z"></path>
    </symbol>
    <symbol viewBox="0 96 48 48" id="vjs-icon-replay-5">
      <path d="M17.689 98l-8.697 8.696 8.697 8.697 2.486-2.485-4.32-4.319h1.302c4.93 0 9.071 1.722 12.424 5.165 3.352 3.443 5.029 7.638 5.029 12.584h3.55c0-2.958-.553-5.73-1.658-8.313-1.104-2.583-2.622-4.841-4.555-6.774-1.932-1.932-4.19-3.45-6.773-4.555-2.584-1.104-5.355-1.657-8.313-1.657H15.5l4.615-4.615zm-8.08 21.659v13.861h11.357v5.008H9.609V143h12.7c.834 0 1.55-.298 2.146-.894.596-.597.895-1.31.895-2.145v-7.781c0-.835-.299-1.55-.895-2.147a2.929 2.929 0 0 0-2.147-.894h-8.227v-5.096H25.35v-4.384z"></path>
    </symbol>
    <symbol viewBox="0 96 48 48" id="vjs-icon-replay-10">
      <path d="M42.315 125.63c0-4.997-1.694-9.235-5.08-12.713-3.388-3.479-7.571-5.218-12.552-5.218h-1.315l4.363 4.363-2.51 2.51-8.787-8.786L25.221 97l2.45 2.45-4.662 4.663h1.375c2.988 0 5.788.557 8.397 1.673 2.61 1.116 4.892 2.65 6.844 4.602 1.953 1.953 3.487 4.234 4.602 6.844 1.116 2.61 1.674 5.41 1.674 8.398zM8.183 142v-19.657H3.176V117.8h9.643V142zm13.63 0c-1.156 0-2.127-.393-2.912-1.178-.778-.778-1.168-1.746-1.168-2.902v-16.04c0-1.156.393-2.127 1.178-2.912.779-.779 1.746-1.168 2.902-1.168h7.696c1.156 0 2.126.392 2.911 1.177.779.78 1.168 1.747 1.168 2.903v16.04c0 1.156-.392 2.127-1.177 2.912-.779.779-1.746 1.168-2.902 1.168zm.556-4.636h6.583v-15.02H22.37z"></path>
    </symbol>
    <symbol viewBox="0 96 48 48" id="vjs-icon-replay-30">
      <path d="M26.047 97l-8.733 8.732 8.733 8.733 2.496-2.494-4.336-4.338h1.307c4.95 0 9.108 1.73 12.474 5.187 3.367 3.458 5.051 7.668 5.051 12.635h3.565c0-2.97-.556-5.751-1.665-8.346-1.109-2.594-2.633-4.862-4.574-6.802-1.94-1.941-4.208-3.466-6.803-4.575-2.594-1.109-5.375-1.664-8.345-1.664H23.85l4.634-4.634zM2.555 117.531v4.688h10.297v5.25H5.873v4.687h6.979v5.156H2.555V142H13.36c1.061 0 1.95-.395 2.668-1.186.718-.79 1.076-1.772 1.076-2.94v-16.218c0-1.168-.358-2.149-1.076-2.94-.717-.79-1.607-1.185-2.668-1.185zm22.482.14c-1.149 0-2.11.39-2.885 1.165-.78.78-1.172 1.744-1.172 2.893v15.943c0 1.149.388 2.11 1.163 2.885.78.78 1.745 1.172 2.894 1.172h7.649c1.148 0 2.11-.388 2.884-1.163.78-.78 1.17-1.745 1.17-2.894v-15.943c0-1.15-.386-2.111-1.16-2.885-.78-.78-1.746-1.172-2.894-1.172zm.553 4.518h6.545v14.93H25.59z"></path>
    </symbol>
    <symbol viewBox="0 96 48 48" id="vjs-icon-forward-5">
      <path d="M29.508 97l-2.431 2.43 4.625 4.625h-1.364c-2.965 0-5.742.554-8.332 1.66-2.589 1.107-4.851 2.629-6.788 4.566-1.937 1.937-3.458 4.2-4.565 6.788-1.107 2.59-1.66 5.367-1.66 8.331h3.557c0-4.957 1.68-9.16 5.04-12.611 3.36-3.45 7.51-5.177 12.451-5.177h1.304l-4.326 4.33 2.49 2.49 8.715-8.716zm-9.783 21.61v13.89h11.382v5.018H19.725V142h12.727a2.93 2.93 0 0 0 2.15-.896 2.93 2.93 0 0 0 .896-2.15v-7.798c0-.837-.299-1.554-.896-2.152a2.93 2.93 0 0 0-2.15-.896h-8.245V123h11.29v-4.392z"></path>
    </symbol>
    <symbol viewBox="0 96 48 48" id="vjs-icon-forward-10">
      <path d="M23.119 97l-2.386 2.383 4.538 4.538h-1.339c-2.908 0-5.633.543-8.173 1.63-2.54 1.085-4.76 2.577-6.66 4.478-1.9 1.9-3.392 4.12-4.478 6.66-1.085 2.54-1.629 5.264-1.629 8.172h3.49c0-4.863 1.648-8.986 4.944-12.372 3.297-3.385 7.368-5.078 12.216-5.078h1.279l-4.245 4.247 2.443 2.442 8.55-8.55zm-9.52 21.45v4.42h4.871V142h4.513v-23.55zm18.136 0c-1.125 0-2.066.377-2.824 1.135-.764.764-1.148 1.709-1.148 2.834v15.612c0 1.124.38 2.066 1.139 2.824.764.764 1.708 1.145 2.833 1.145h7.489c1.125 0 2.066-.378 2.824-1.136.764-.764 1.145-1.709 1.145-2.833v-15.612c0-1.125-.378-2.067-1.136-2.825-.764-.764-1.708-1.145-2.833-1.145zm.54 4.42h6.408v14.617h-6.407z"></path>
    </symbol>
    <symbol viewBox="0 96 48 48" id="vjs-icon-forward-30">
      <path d="M25.549 97l-2.437 2.434 4.634 4.635H26.38c-2.97 0-5.753.555-8.347 1.664-2.594 1.109-4.861 2.633-6.802 4.574-1.94 1.94-3.465 4.207-4.574 6.802-1.109 2.594-1.664 5.377-1.664 8.347h3.565c0-4.967 1.683-9.178 5.05-12.636 3.366-3.458 7.525-5.187 12.475-5.187h1.307l-4.335 4.338 2.495 2.494 8.732-8.732zm-11.553 20.53v4.689h10.297v5.249h-6.978v4.688h6.978v5.156H13.996V142h10.808c1.06 0 1.948-.395 2.666-1.186.718-.79 1.077-1.771 1.077-2.94v-16.217c0-1.169-.36-2.15-1.077-2.94-.718-.79-1.605-1.186-2.666-1.186zm21.174.168c-1.149 0-2.11.389-2.884 1.163-.78.78-1.172 1.745-1.172 2.894v15.942c0 1.15.388 2.11 1.162 2.885.78.78 1.745 1.17 2.894 1.17h7.649c1.149 0 2.11-.386 2.885-1.16.78-.78 1.17-1.746 1.17-2.895v-15.942c0-1.15-.387-2.11-1.161-2.885-.78-.78-1.745-1.172-2.894-1.172zm.552 4.516h6.542v14.931h-6.542z"></path>
    </symbol>
    <symbol viewBox="0 0 512 512" id="vjs-icon-audio-description">
      <g fill-rule="evenodd"><path d="M227.29 381.351V162.993c50.38-1.017 89.108-3.028 117.631 17.126 27.374 19.342 48.734 56.965 44.89 105.325-4.067 51.155-41.335 94.139-89.776 98.475-24.085 2.155-71.972 0-71.972 0s-.84-1.352-.773-2.568m48.755-54.804c31.43 1.26 53.208-16.633 56.495-45.386 4.403-38.51-21.188-63.552-58.041-60.796v103.612c-.036 1.466.575 2.22 1.546 2.57"></path><path d="M383.78 381.328c13.336 3.71 17.387-11.06 23.215-21.408 12.722-22.571 22.294-51.594 22.445-84.774.221-47.594-18.343-82.517-35.6-106.182h-8.51c-.587 3.874 2.226 7.315 3.865 10.276 13.166 23.762 25.367 56.553 25.54 94.194.2 43.176-14.162 79.278-30.955 107.894"></path><path d="M425.154 381.328c13.336 3.71 17.384-11.061 23.215-21.408 12.721-22.571 22.291-51.594 22.445-84.774.221-47.594-18.343-82.517-35.6-106.182h-8.511c-.586 3.874 2.226 7.315 3.866 10.276 13.166 23.762 25.367 56.553 25.54 94.194.2 43.176-14.162 79.278-30.955 107.894"></path><path d="M466.26 381.328c13.337 3.71 17.385-11.061 23.216-21.408 12.722-22.571 22.292-51.594 22.445-84.774.221-47.594-18.343-82.517-35.6-106.182h-8.51c-.587 3.874 2.225 7.315 3.865 10.276 13.166 23.762 25.367 56.553 25.54 94.194.2 43.176-14.162 79.278-30.955 107.894M4.477 383.005H72.58l18.573-28.484 64.169-.135s.065 19.413.065 28.62h48.756V160.307h-58.816c-5.653 9.537-140.85 222.697-140.85 222.697zm152.667-145.282v71.158l-40.453-.27 40.453-70.888z"></path></g>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-next-item">
      <path d="M12 36l17-12-17-12v24zm20-24v24h4V12h-4z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-previous-item">
      <path d="M12 12h4v24h-4zm7 12l17 12V12z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-shuffle">
      <path d="M21.17 18.34L10.83 8 8 10.83l10.34 10.34 2.83-2.83zM29 8l4.09 4.09L8 37.17 10.83 40l25.09-25.09L40 19V8H29zm.66 18.83l-2.83 2.83 6.26 6.26L29 40h11V29l-4.09 4.09-6.25-6.26z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-cast">
      <path d="M42 6H6c-2.21 0-4 1.79-4 4v6h4v-6h36v28H28v4h14c2.21 0 4-1.79 4-4V10c0-2.21-1.79-4-4-4zM2 36v6h6c0-3.31-2.69-6-6-6zm0-8v4c5.52 0 10 4.48 10 10h4c0-7.73-6.27-14-14-14zm0-8v4c9.94 0 18 8.06 18 18h4c0-12.15-9.85-22-22-22z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-picture-in-picture-enter">
      <path d="M38 22H22v11.99h16V22zm8 16V9.96C46 7.76 44.2 6 42 6H6C3.8 6 2 7.76 2 9.96V38c0 2.2 1.8 4 4 4h36c2.2 0 4-1.8 4-4zm-4 .04H6V9.94h36v28.1z"></path>
    </symbol>
    <symbol viewBox="0 0 22 18" id="vjs-icon-picture-in-picture-exit">
      <path d="M18 4H4v10h14V4zm4 12V1.98C22 .88 21.1 0 20 0H2C.9 0 0 .88 0 1.98V16c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2zm-2 .02H2V1.97h18v14.05z"></path>
      <path fill="none" d="M-1-3h24v24H-1z"></path>
    </symbol>
    <symbol viewBox="0 0 1792 1792" id="vjs-icon-facebook">
      <path d="M1343 12v264h-157q-86 0-116 36t-30 108v189h293l-39 296h-254v759H734V905H479V609h255V391q0-186 104-288.5T1115 0q147 0 228 12z"></path>
    </symbol>
    <symbol viewBox="0 0 1792 1792" id="vjs-icon-linkedin">
      <path d="M477 625v991H147V625h330zm21-306q1 73-50.5 122T312 490h-2q-82 0-132-49t-50-122q0-74 51.5-122.5T314 148t133 48.5T498 319zm1166 729v568h-329v-530q0-105-40.5-164.5T1168 862q-63 0-105.5 34.5T999 982q-11 30-11 81v553H659q2-399 2-647t-1-296l-1-48h329v144h-2q20-32 41-56t56.5-52 87-43.5T1285 602q171 0 275 113.5t104 332.5z"></path>
    </symbol>
    <symbol viewBox="0 0 1200 1227" id="vjs-icon-twitter">
      <path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z"/>
    </symbol>
    <symbol viewBox="0 0 1792 1792" id="vjs-icon-tumblr">
      <path d="M1328 1329l80 237q-23 35-111 66t-177 32q-104 2-190.5-26T787 1564t-95-106-55.5-120-16.5-118V676H452V461q72-26 129-69.5t91-90 58-102 34-99T779 12q1-5 4.5-8.5T791 0h244v424h333v252h-334v518q0 30 6.5 56t22.5 52.5 49.5 41.5 81.5 14q78-2 134-29z"></path>
    </symbol>
    <symbol viewBox="0 0 1792 1792" id="vjs-icon-pinterest">
      <path d="M1664 896q0 209-103 385.5T1281.5 1561 896 1664q-111 0-218-32 59-93 78-164 9-34 54-211 20 39 73 67.5t114 28.5q121 0 216-68.5t147-188.5 52-270q0-114-59.5-214T1180 449t-255-63q-105 0-196 29t-154.5 77-109 110.5-67 129.5T377 866q0 104 40 183t117 111q30 12 38-20 2-7 8-31t8-30q6-23-11-43-51-61-51-151 0-151 104.5-259.5T904 517q151 0 235.5 82t84.5 213q0 170-68.5 289T980 1220q-61 0-98-43.5T859 1072q8-35 26.5-93.5t30-103T927 800q0-50-27-83t-77-33q-62 0-105 57t-43 142q0 73 25 122l-99 418q-17 70-13 177-206-91-333-281T128 896q0-209 103-385.5T510.5 231 896 128t385.5 103T1561 510.5 1664 896z"></path>
    </symbol>
  </defs>
</svg>`;
const ub = xu ? 10009 : wu ? 461 : 8, os = {
  codes: {
    play: 415,
    pause: 19,
    ff: 417,
    rw: 412,
    back: ub
  },
  names: {
    415: "play",
    19: "pause",
    417: "ff",
    412: "rw",
    [ub]: "back"
  },
  isEventKey(t, e) {
    return e = e.toLowerCase(), !!(this.names[t.keyCode] && this.names[t.keyCode] === e);
  },
  getEventName(t) {
    if (this.names[t.keyCode])
      return this.names[t.keyCode];
    if (this.codes[t.code]) {
      const e = this.codes[t.code];
      return this.names[e];
    }
    return null;
  }
}, db = 5;
class Tne extends fa {
  /**
   * Constructs a SpatialNavigation instance with initial settings.
   * Sets up the player instance, and prepares the spatial navigation system.
   *
   * @class
   * @param {Player} player - The Video.js player instance to which the spatial navigation is attached.
   */
  constructor(e) {
    super(), this.player_ = e, this.focusableComponents = [], this.isListening_ = !1, this.isPaused_ = !1, this.onKeyDown_ = this.onKeyDown_.bind(this), this.lastFocusedComponent_ = null;
  }
  /**
   * Starts the spatial navigation by adding a keydown event listener to the video container.
   * This method ensures that the event listener is added only once.
   */
  start() {
    this.isListening_ || (this.player_.on("keydown", this.onKeyDown_), this.player_.on("modalKeydown", this.onKeyDown_), this.player_.on("loadedmetadata", () => {
      this.focus(this.updateFocusableComponents()[0]);
    }), this.player_.on("modalclose", () => {
      this.refocusComponent();
    }), this.player_.on("focusin", this.handlePlayerFocus_.bind(this)), this.player_.on("focusout", this.handlePlayerBlur_.bind(this)), this.isListening_ = !0, this.player_.errorDisplay && this.player_.errorDisplay.on("aftermodalfill", () => {
      this.updateFocusableComponents(), this.focusableComponents.length && (this.focusableComponents.length > 1 ? this.focusableComponents[1].focus() : this.focusableComponents[0].focus());
    }));
  }
  /**
   * Stops the spatial navigation by removing the keydown event listener from the video container.
   * Also sets the `isListening_` flag to false.
   */
  stop() {
    this.player_.off("keydown", this.onKeyDown_), this.isListening_ = !1;
  }
  /**
   * Responds to keydown events for spatial navigation and media control.
   *
   * Determines if spatial navigation or media control is active and handles key inputs accordingly.
   *
   * @param {KeyboardEvent} event - The keydown event to be handled.
   */
  onKeyDown_(e) {
    const n = e.originalEvent ? e.originalEvent : e;
    if (["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown"].includes(n.key)) {
      if (this.isPaused_)
        return;
      n.preventDefault();
      const a = n.key.substring(5).toLowerCase();
      this.move(a);
    } else if (os.isEventKey(n, "play") || os.isEventKey(n, "pause") || os.isEventKey(n, "ff") || os.isEventKey(n, "rw")) {
      n.preventDefault();
      const a = os.getEventName(n);
      this.performMediaAction_(a);
    } else os.isEventKey(n, "Back") && e.target && typeof e.target.closeable == "function" && e.target.closeable() && (n.preventDefault(), e.target.close());
  }
  /**
   * Performs media control actions based on the given key input.
   *
   * Controls the playback and seeking functionalities of the media player.
   *
   * @param {string} key - The key representing the media action to be performed.
   *   Accepted keys: 'play', 'pause', 'ff' (fast-forward), 'rw' (rewind).
   */
  performMediaAction_(e) {
    if (this.player_)
      switch (e) {
        case "play":
          this.player_.paused() && this.player_.play();
          break;
        case "pause":
          this.player_.paused() || this.player_.pause();
          break;
        case "ff":
          this.userSeek_(this.player_.currentTime() + db);
          break;
        case "rw":
          this.userSeek_(this.player_.currentTime() - db);
          break;
      }
  }
  /**
   * Prevent liveThreshold from causing seeks to seem like they
   * are not happening from a user perspective.
   *
   * @param {number} ct
   *        current time to seek to
   */
  userSeek_(e) {
    this.player_.liveTracker && this.player_.liveTracker.isLive() && this.player_.liveTracker.nextSeekedFromUser(), this.player_.currentTime(e);
  }
  /**
   * Pauses the spatial navigation functionality.
   * This method sets a flag that can be used to temporarily disable the navigation logic.
   */
  pause() {
    this.isPaused_ = !0;
  }
  /**
   * Resumes the spatial navigation functionality if it has been paused.
   * This method resets the pause flag, re-enabling the navigation logic.
   */
  resume() {
    this.isPaused_ = !1;
  }
  /**
   * Handles Player Blur.
   *
   * @param {string|Event|Object} event
   *        The name of the event, an `Event`, or an object with a key of type set to
   *        an event name.
   *
   * Calls for handling of the Player Blur if:
   * *The next focused element is not a child of current focused element &
   * The next focused element is not a child of the Player.
   * *There is no next focused element
   */
  handlePlayerBlur_(e) {
    const n = e.relatedTarget;
    let a = null;
    const i = this.getCurrentComponent(e.target);
    n && (a = !!n.closest(".video-js"), n.classList.contains("vjs-text-track-settings") && !this.isPaused_ && this.searchForTrackSelect_()), (!e.currentTarget.contains(e.relatedTarget) && !a || !n) && (i && i.name() === "CloseButton" ? this.refocusComponent() : (this.pause(), i && i.el() && (this.lastFocusedComponent_ = i)));
  }
  /**
   * Handles the Player focus event.
   *
   * Calls for handling of the Player Focus if current element is focusable.
   */
  handlePlayerFocus_() {
    this.getCurrentComponent() && this.getCurrentComponent().getIsFocusable() && this.resume();
  }
  /**
   * Gets a set of focusable components.
   *
   * @return {Array}
   *         Returns an array of focusable components.
   */
  updateFocusableComponents() {
    const e = this.player_, n = [];
    function a(i) {
      for (const r of i)
        r.hasOwnProperty("el_") && r.getIsFocusable() && r.getIsAvailableToBeFocused(r.el()) && n.push(r), r.hasOwnProperty("children_") && r.children_.length > 0 && a(r.children_);
    }
    return e.children_.forEach((i) => {
      if (i.hasOwnProperty("el_"))
        if (i.getIsFocusable && i.getIsAvailableToBeFocused && i.getIsFocusable() && i.getIsAvailableToBeFocused(i.el())) {
          n.push(i);
          return;
        } else i.hasOwnProperty("children_") && i.children_.length > 0 ? a(i.children_) : i.hasOwnProperty("items") && i.items.length > 0 ? a(i.items) : this.findSuitableDOMChild(i) && n.push(i);
      if (i.name_ === "ErrorDisplay" && i.opened_) {
        const r = i.el_.querySelector(".vjs-errors-ok-button-container");
        r && r.querySelectorAll("button").forEach((o, l) => {
          n.push({
            name: () => "ModalButton" + (l + 1),
            el: () => o,
            getPositions: () => {
              const c = o.getBoundingClientRect(), u = {
                x: c.x,
                y: c.y,
                width: c.width,
                height: c.height,
                top: c.top,
                right: c.right,
                bottom: c.bottom,
                left: c.left
              }, f = {
                x: c.left + c.width / 2,
                y: c.top + c.height / 2,
                width: 0,
                height: 0,
                top: c.top + c.height / 2,
                right: c.left + c.width / 2,
                bottom: c.top + c.height / 2,
                left: c.left + c.width / 2
              };
              return {
                boundingClientRect: u,
                center: f
              };
            },
            // Asume that the following are always focusable
            getIsAvailableToBeFocused: () => !0,
            getIsFocusable: (c) => !0,
            focus: () => o.focus()
          });
        });
      }
    }), this.focusableComponents = n, this.focusableComponents;
  }
  /**
   * Finds a suitable child element within the provided component's DOM element.
   *
   * @param {Object} component - The component containing the DOM element to search within.
   * @return {HTMLElement|null} Returns the suitable child element if found, or null if not found.
   */
  findSuitableDOMChild(e) {
    function n(a) {
      if (e.getIsFocusable(a) && e.getIsAvailableToBeFocused(a))
        return a;
      for (let i = 0; i < a.children.length; i++) {
        const r = a.children[i], s = n(r);
        if (s)
          return s;
      }
      return null;
    }
    return e.el() ? n(e.el()) : null;
  }
  /**
   * Gets the currently focused component from the list of focusable components.
   * If a target element is provided, it uses that element to find the corresponding
   * component. If no target is provided, it defaults to using the document's currently
   * active element.
   *
   * @param {HTMLElement} [target] - The DOM element to check against the focusable components.
   *                                 If not provided, `document.activeElement` is used.
   * @return {Component|null} - Returns the focused component if found among the focusable components,
   *                            otherwise returns null if no matching component is found.
   */
  getCurrentComponent(e) {
    this.updateFocusableComponents();
    const n = e || document.activeElement;
    if (this.focusableComponents.length) {
      for (const a of this.focusableComponents)
        if (a.el() === n)
          return a;
    }
  }
  /**
   * Adds a component to the array of focusable components.
   *
   * @param {Component} component
   *        The `Component` to be added.
   */
  add(e) {
    const n = [...this.focusableComponents];
    e.hasOwnProperty("el_") && e.getIsFocusable() && e.getIsAvailableToBeFocused(e.el()) && n.push(e), this.focusableComponents = n, this.trigger({
      type: "focusableComponentsChanged",
      focusableComponents: this.focusableComponents
    });
  }
  /**
   * Removes component from the array of focusable components.
   *
   * @param {Component} component - The component to be removed from the focusable components array.
   */
  remove(e) {
    for (let n = 0; n < this.focusableComponents.length; n++)
      if (this.focusableComponents[n].name() === e.name()) {
        this.focusableComponents.splice(n, 1), this.trigger({
          type: "focusableComponentsChanged",
          focusableComponents: this.focusableComponents
        });
        return;
      }
  }
  /**
   * Clears array of focusable components.
   */
  clear() {
    this.focusableComponents.length > 0 && (this.focusableComponents = [], this.trigger({
      type: "focusableComponentsChanged",
      focusableComponents: this.focusableComponents
    }));
  }
  /**
   * Navigates to the next focusable component based on the specified direction.
   *
   * @param {string} direction 'up', 'down', 'left', 'right'
   */
  move(e) {
    const n = this.getCurrentComponent();
    if (!n)
      return;
    const a = n.getPositions(), i = this.focusableComponents.filter((s) => s !== n && this.isInDirection_(a.boundingClientRect, s.getPositions().boundingClientRect, e)), r = this.findBestCandidate_(a.center, i, e);
    r ? this.focus(r) : this.trigger({
      type: "endOfFocusableComponents",
      direction: e,
      focusedComponent: n
    });
  }
  /**
   * Finds the best candidate on the current center position,
   * the list of candidates, and the specified navigation direction.
   *
   * @param {Object} currentCenter The center position of the current focused component element.
   * @param {Array} candidates An array of candidate components to receive focus.
   * @param {string} direction The direction of navigation ('up', 'down', 'left', 'right').
   * @return {Object|null} The component that is the best candidate for receiving focus.
   */
  findBestCandidate_(e, n, a) {
    let i = 1 / 0, r = null;
    for (const s of n) {
      const o = s.getPositions().center, l = this.calculateDistance_(e, o, a);
      l < i && (i = l, r = s);
    }
    return r;
  }
  /**
   * Determines if a target rectangle is in the specified navigation direction
   * relative to a source rectangle.
   *
   * @param {Object} srcRect The bounding rectangle of the source element.
   * @param {Object} targetRect The bounding rectangle of the target element.
   * @param {string} direction The navigation direction ('up', 'down', 'left', 'right').
   * @return {boolean} True if the target is in the specified direction relative to the source.
   */
  isInDirection_(e, n, a) {
    switch (a) {
      case "right":
        return n.left >= e.right;
      case "left":
        return n.right <= e.left;
      case "down":
        return n.top >= e.bottom;
      case "up":
        return n.bottom <= e.top;
      default:
        return !1;
    }
  }
  /**
   * Focus the last focused component saved before blur on player.
   */
  refocusComponent() {
    if (this.lastFocusedComponent_) {
      this.player_.userActive() || this.player_.userActive(!0), this.updateFocusableComponents();
      for (let e = 0; e < this.focusableComponents.length; e++)
        if (this.focusableComponents[e].name() === this.lastFocusedComponent_.name()) {
          this.focus(this.focusableComponents[e]);
          return;
        }
    } else
      this.focus(this.updateFocusableComponents()[0]);
  }
  /**
   * Focuses on a given component.
   * If the component is available to be focused, it focuses on the component.
   * If not, it attempts to find a suitable DOM child within the component and focuses on it.
   *
   * @param {Component} component - The component to be focused.
   */
  focus(e) {
    typeof e == "object" && (e.getIsAvailableToBeFocused(e.el()) ? e.focus() : this.findSuitableDOMChild(e) && this.findSuitableDOMChild(e).focus());
  }
  /**
   * Calculates the distance between two points, adjusting the calculation based on
   * the specified navigation direction.
   *
   * @param {Object} center1 The center point of the first element.
   * @param {Object} center2 The center point of the second element.
   * @param {string} direction The direction of navigation ('up', 'down', 'left', 'right').
   * @return {number} The calculated distance between the two centers.
   */
  calculateDistance_(e, n, a) {
    const i = Math.abs(e.x - n.x), r = Math.abs(e.y - n.y);
    let s;
    switch (a) {
      case "right":
      case "left":
        s = i + r * 100;
        break;
      case "up":
        s = r * 2 + i * 0.5;
        break;
      case "down":
        s = r * 5 + i;
        break;
      default:
        s = i + r;
    }
    return s;
  }
  /**
   * This gets called by 'handlePlayerBlur_' if 'spatialNavigation' is enabled.
   * Searches for the first 'TextTrackSelect' inside of modal to focus.
   *
   * @private
   */
  searchForTrackSelect_() {
    const e = this;
    for (const n of e.updateFocusableComponents())
      if (n.constructor.name === "TextTrackSelect") {
        e.focus(n);
        break;
      }
  }
}
class xne extends ye {
  /**
   * Create an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should attach to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Function} [ready]
   *        The function that is run when this component is ready.
   */
  constructor(e, n, a) {
    const i = wt({
      createEl: !1
    }, n);
    if (super(e, i, a), !n.playerOptions.sources || n.playerOptions.sources.length === 0)
      for (let r = 0, s = n.playerOptions.techOrder; r < s.length; r++) {
        const o = qt(s[r]);
        let l = rt.getTech(o);
        if (o || (l = ye.getComponent(o)), l && l.isSupported()) {
          e.loadTech_(o);
          break;
        }
      }
    else
      e.src(n.playerOptions.sources);
  }
}
ye.registerComponent("MediaLoader", xne);
class Ed extends ye {
  /**
   * Creates an instance of this class.
   *
   * @param  {Player} player
   *         The `Player` that this class should be attached to.
   *
   * @param  {Object} [options]
   *         The key/value store of component options.
   *
   * @param  {function} [options.clickHandler]
   *         The function to call when the button is clicked / activated
   *
   * @param  {string} [options.controlText]
   *         The text to set on the button
   *
   * @param  {string} [options.className]
   *         A class or space separated list of classes to add the component
   *
   */
  constructor(e, n) {
    super(e, n), this.options_.controlText && this.controlText(this.options_.controlText), this.handleMouseOver_ = (a) => this.handleMouseOver(a), this.handleMouseOut_ = (a) => this.handleMouseOut(a), this.handleClick_ = (a) => this.handleClick(a), this.handleKeyDown_ = (a) => this.handleKeyDown(a), this.emitTapEvents(), this.enable();
  }
  /**
   * Create the `ClickableComponent`s DOM element.
   *
   * @param {string} [tag=div]
   *        The element's node type.
   *
   * @param {Object} [props={}]
   *        An object of properties that should be set on the element.
   *
   * @param {Object} [attributes={}]
   *        An object of attributes that should be set on the element.
   *
   * @return {Element}
   *         The element that gets created.
   */
  createEl(e = "div", n = {}, a = {}) {
    n = Object.assign({
      className: this.buildCSSClass(),
      tabIndex: 0
    }, n), e === "button" && ut.error(`Creating a ClickableComponent with an HTML element of ${e} is not supported; use a Button instead.`), a = Object.assign({
      role: "button"
    }, a), this.tabIndex_ = n.tabIndex;
    const i = et(e, n, a);
    return this.player_.options_.experimentalSvgIcons || i.appendChild(et("span", {
      className: "vjs-icon-placeholder"
    }, {
      "aria-hidden": !0
    })), this.createControlTextEl(i), i;
  }
  dispose() {
    this.controlTextEl_ = null, super.dispose();
  }
  /**
   * Create a control text element on this `ClickableComponent`
   *
   * @param {Element} [el]
   *        Parent element for the control text.
   *
   * @return {Element}
   *         The control text element that gets created.
   */
  createControlTextEl(e) {
    return this.controlTextEl_ = et("span", {
      className: "vjs-control-text"
    }, {
      // let the screen reader user know that the text of the element may change
      "aria-live": "polite"
    }), e && e.appendChild(this.controlTextEl_), this.controlText(this.controlText_, e), this.controlTextEl_;
  }
  /**
   * Get or set the localize text to use for the controls on the `ClickableComponent`.
   *
   * @param {string} [text]
   *        Control text for element.
   *
   * @param {Element} [el=this.el()]
   *        Element to set the title on.
   *
   * @return {string}
   *         - The control text when getting
   */
  controlText(e, n = this.el()) {
    if (e === void 0)
      return this.controlText_ || "Need Text";
    const a = this.localize(e);
    this.controlText_ = e, ur(this.controlTextEl_, a), !this.nonIconControl && !this.player_.options_.noUITitleAttributes && n.setAttribute("title", a);
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-control vjs-button ${super.buildCSSClass()}`;
  }
  /**
   * Enable this `ClickableComponent`
   */
  enable() {
    this.enabled_ || (this.enabled_ = !0, this.removeClass("vjs-disabled"), this.el_.setAttribute("aria-disabled", "false"), typeof this.tabIndex_ < "u" && this.el_.setAttribute("tabIndex", this.tabIndex_), this.on(["tap", "click"], this.handleClick_), this.on("keydown", this.handleKeyDown_));
  }
  /**
   * Disable this `ClickableComponent`
   */
  disable() {
    this.enabled_ = !1, this.addClass("vjs-disabled"), this.el_.setAttribute("aria-disabled", "true"), typeof this.tabIndex_ < "u" && this.el_.removeAttribute("tabIndex"), this.off("mouseover", this.handleMouseOver_), this.off("mouseout", this.handleMouseOut_), this.off(["tap", "click"], this.handleClick_), this.off("keydown", this.handleKeyDown_);
  }
  /**
   * Handles language change in ClickableComponent for the player in components
   *
   *
   */
  handleLanguagechange() {
    this.controlText(this.controlText_);
  }
  /**
   * Event handler that is called when a `ClickableComponent` receives a
   * `click` or `tap` event.
   *
   * @param {Event} event
   *        The `tap` or `click` event that caused this function to be called.
   *
   * @listens tap
   * @listens click
   * @abstract
   */
  handleClick(e) {
    this.options_.clickHandler && this.options_.clickHandler.call(this, arguments);
  }
  /**
   * Event handler that is called when a `ClickableComponent` receives a
   * `keydown` event.
   *
   * By default, if the key is Space or Enter, it will trigger a `click` event.
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */
  handleKeyDown(e) {
    e.key === " " || e.key === "Enter" ? (e.preventDefault(), e.stopPropagation(), this.trigger("click")) : super.handleKeyDown(e);
  }
}
ye.registerComponent("ClickableComponent", Ed);
class Eh extends Ed {
  /**
   * Create an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should attach to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, n) {
    super(e, n), this.update(), this.update_ = (a) => this.update(a), e.on("posterchange", this.update_);
  }
  /**
   * Clean up and dispose of the `PosterImage`.
   */
  dispose() {
    this.player().off("posterchange", this.update_), super.dispose();
  }
  /**
   * Create the `PosterImage`s DOM element.
   *
   * @return {Element}
   *         The element that gets created.
   */
  createEl() {
    return et("div", {
      className: "vjs-poster"
    });
  }
  /**
   * Get or set the `PosterImage`'s crossOrigin option.
   *
   * @param {string|null} [value]
   *        The value to set the crossOrigin to. If an argument is
   *        given, must be one of `'anonymous'` or `'use-credentials'`, or 'null'.
   *
   * @return {string|null}
   *         - The current crossOrigin value of the `Player` when getting.
   *         - undefined when setting
   */
  crossOrigin(e) {
    if (typeof e > "u")
      return this.$("img") ? this.$("img").crossOrigin : this.player_.tech_ && this.player_.tech_.isReady_ ? this.player_.crossOrigin() : this.player_.options_.crossOrigin || this.player_.options_.crossorigin || null;
    if (e !== null && e !== "anonymous" && e !== "use-credentials") {
      this.player_.log.warn(`crossOrigin must be null,  "anonymous" or "use-credentials", given "${e}"`);
      return;
    }
    this.$("img") && (this.$("img").crossOrigin = e);
  }
  /**
   * An {@link EventTarget~EventListener} for {@link Player#posterchange} events.
   *
   * @listens Player#posterchange
   *
   * @param {Event} [event]
   *        The `Player#posterchange` event that triggered this function.
   */
  update(e) {
    const n = this.player().poster();
    this.setSrc(n), n ? this.show() : this.hide();
  }
  /**
   * Set the source of the `PosterImage` depending on the display method. (Re)creates
   * the inner picture and img elementss when needed.
   *
   * @param {string} [url]
   *        The URL to the source for the `PosterImage`. If not specified or falsy,
   *        any source and ant inner picture/img are removed.
   */
  setSrc(e) {
    if (!e) {
      this.el_.textContent = "";
      return;
    }
    this.$("img") || this.el_.appendChild(et("picture", {
      className: "vjs-poster",
      // Don't want poster to be tabbable.
      tabIndex: -1
    }, {}, et("img", {
      loading: "lazy",
      crossOrigin: this.crossOrigin()
    }, {
      alt: ""
    }))), this.$("img").src = e;
  }
  /**
   * An {@link EventTarget~EventListener} for clicks on the `PosterImage`. See
   * {@link ClickableComponent#handleClick} for instances where this will be triggered.
   *
   * @listens tap
   * @listens click
   * @listens keydown
   *
   * @param {Event} event
   +        The `click`, `tap` or `keydown` event that caused this function to be called.
   */
  handleClick(e) {
    this.player_.controls() && (this.player_.tech(!0) && this.player_.tech(!0).focus(), this.player_.paused() ? Xa(this.player_.play()) : this.player_.pause());
  }
}
Eh.prototype.crossorigin = Eh.prototype.crossOrigin;
ye.registerComponent("PosterImage", Eh);
const ga = "#222", hb = "#ccc", wne = {
  monospace: "monospace",
  sansSerif: "sans-serif",
  serif: "serif",
  monospaceSansSerif: '"Andale Mono", "Lucida Console", monospace',
  monospaceSerif: '"Courier New", monospace',
  proportionalSansSerif: "sans-serif",
  proportionalSerif: "serif",
  casual: '"Comic Sans MS", Impact, fantasy',
  script: '"Monotype Corsiva", cursive',
  smallcaps: '"Andale Mono", "Lucida Console", monospace, sans-serif'
};
function O0(t, e) {
  let n;
  if (t.length === 4)
    n = t[1] + t[1] + t[2] + t[2] + t[3] + t[3];
  else if (t.length === 7)
    n = t.slice(1);
  else
    throw new Error("Invalid color code provided, " + t + "; must be formatted as e.g. #f0e or #f604e2.");
  return "rgba(" + parseInt(n.slice(0, 2), 16) + "," + parseInt(n.slice(2, 4), 16) + "," + parseInt(n.slice(4, 6), 16) + "," + e + ")";
}
function Ya(t, e, n) {
  try {
    t.style[e] = n;
  } catch {
    return;
  }
}
function fb(t) {
  return t ? `${t}px` : "";
}
class kne extends ye {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Function} [ready]
   *        The function to call when `TextTrackDisplay` is ready.
   */
  constructor(e, n, a) {
    super(e, n, a);
    const i = (s) => this.updateDisplay(s), r = (s) => {
      this.updateDisplayOverlay(), this.updateDisplay(s);
    };
    e.on("loadstart", (s) => this.toggleDisplay(s)), e.on("texttrackchange", i), e.on("loadedmetadata", (s) => {
      this.updateDisplayOverlay(), this.preselectTrack(s);
    }), e.ready(Et(this, function() {
      if (e.tech_ && e.tech_.featuresNativeTextTracks) {
        this.hide();
        return;
      }
      e.on("fullscreenchange", r), e.on("playerresize", r);
      const s = j.screen.orientation || j, o = j.screen.orientation ? "change" : "orientationchange";
      s.addEventListener(o, r), e.on("dispose", () => s.removeEventListener(o, r));
      const l = this.options_.playerOptions.tracks || [];
      for (let c = 0; c < l.length; c++)
        this.player_.addRemoteTextTrack(l[c], !0);
      this.preselectTrack();
    }));
  }
  /**
  * Preselect a track following this precedence:
  * - matches the previously selected {@link TextTrack}'s language and kind
  * - matches the previously selected {@link TextTrack}'s language only
  * - is the first default captions track
  * - is the first default descriptions track
  *
  * @listens Player#loadstart
  */
  preselectTrack() {
    const e = {
      captions: 1,
      subtitles: 1
    }, n = this.player_.textTracks(), a = this.player_.cache_.selectedLanguage;
    let i, r, s;
    for (let o = 0; o < n.length; o++) {
      const l = n[o];
      a && a.enabled && a.language && a.language === l.language && l.kind in e ? l.kind === a.kind ? s = l : s || (s = l) : a && !a.enabled ? (s = null, i = null, r = null) : l.default && (l.kind === "descriptions" && !i ? i = l : l.kind in e && !r && (r = l));
    }
    s ? s.mode = "showing" : r ? r.mode = "showing" : i && (i.mode = "showing");
  }
  /**
   * Turn display of {@link TextTrack}'s from the current state into the other state.
   * There are only two states:
   * - 'shown'
   * - 'hidden'
   *
   * @listens Player#loadstart
   */
  toggleDisplay() {
    this.player_.tech_ && this.player_.tech_.featuresNativeTextTracks ? this.hide() : this.show();
  }
  /**
   * Create the {@link Component}'s DOM element.
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    return super.createEl("div", {
      className: "vjs-text-track-display"
    }, {
      translate: "yes",
      "aria-live": "off",
      "aria-atomic": "true"
    });
  }
  /**
   * Clear all displayed {@link TextTrack}s.
   */
  clearDisplay() {
    typeof j.WebVTT == "function" && j.WebVTT.processCues(j, [], this.el_);
  }
  /**
   * Update the displayed TextTrack when a either a {@link Player#texttrackchange} or
   * a {@link Player#fullscreenchange} is fired.
   *
   * @listens Player#texttrackchange
   * @listens Player#fullscreenchange
   */
  updateDisplay() {
    const e = this.player_.textTracks(), n = this.options_.allowMultipleShowingTracks;
    if (this.clearDisplay(), n) {
      const s = [];
      for (let o = 0; o < e.length; ++o) {
        const l = e[o];
        l.mode === "showing" && s.push(l);
      }
      this.updateForTrack(s);
      return;
    }
    let a = null, i = null, r = e.length;
    for (; r--; ) {
      const s = e[r];
      s.mode === "showing" && (s.kind === "descriptions" ? a = s : i = s);
    }
    if (i ? (this.getAttribute("aria-live") !== "off" && this.setAttribute("aria-live", "off"), this.updateForTrack(i)) : a && (this.getAttribute("aria-live") !== "assertive" && this.setAttribute("aria-live", "assertive"), this.updateForTrack(a)), !j.CSS.supports("inset", "10px")) {
      const s = this.el_, o = s.querySelectorAll(".vjs-text-track-cue"), l = this.player_.controlBar.el_.getBoundingClientRect().height, c = this.player_.el_.getBoundingClientRect().height;
      s.style = "", Ya(s, "position", "relative"), Ya(s, "height", c - l + "px"), Ya(s, "top", "unset"), ku ? Ya(s, "bottom", c + "px") : Ya(s, "bottom", "0px"), o.length > 0 && o.forEach((u) => {
        if (u.style.inset) {
          const f = u.style.inset.split(" ");
          f.length === 3 && Object.assign(u.style, {
            top: f[0],
            right: f[1],
            bottom: f[2],
            left: "unset"
          });
        }
      });
    }
  }
  /**
   * Updates the displayed TextTrack to be sure it overlays the video when a either
   * a {@link Player#texttrackchange} or a {@link Player#fullscreenchange} is fired.
   */
  updateDisplayOverlay() {
    if (!this.player_.videoHeight() || !j.CSS.supports("inset-inline: 10px"))
      return;
    const e = this.player_.currentWidth(), n = this.player_.currentHeight(), a = e / n, i = this.player_.videoWidth() / this.player_.videoHeight();
    let r = 0, s = 0;
    Math.abs(a - i) > 0.1 && (a > i ? r = Math.round((e - n * i) / 2) : s = Math.round((n - e / i) / 2)), Ya(this.el_, "insetInline", fb(r)), Ya(this.el_, "insetBlock", fb(s));
  }
  /**
   * Style {@Link TextTrack} activeCues according to {@Link TextTrackSettings}.
   *
   * @param {TextTrack} track
   *        Text track object containing active cues to style.
   */
  updateDisplayState(e) {
    const n = this.player_.textTrackSettings.getValues(), a = e.activeCues;
    let i = a.length;
    for (; i--; ) {
      const r = a[i];
      if (!r)
        continue;
      const s = r.displayState;
      if (n.color && (s.firstChild.style.color = n.color), n.textOpacity && Ya(s.firstChild, "color", O0(n.color || "#fff", n.textOpacity)), n.backgroundColor && (s.firstChild.style.backgroundColor = n.backgroundColor), n.backgroundOpacity && Ya(s.firstChild, "backgroundColor", O0(n.backgroundColor || "#000", n.backgroundOpacity)), n.windowColor && (n.windowOpacity ? Ya(s, "backgroundColor", O0(n.windowColor, n.windowOpacity)) : s.style.backgroundColor = n.windowColor), n.edgeStyle && (n.edgeStyle === "dropshadow" ? s.firstChild.style.textShadow = `2px 2px 3px ${ga}, 2px 2px 4px ${ga}, 2px 2px 5px ${ga}` : n.edgeStyle === "raised" ? s.firstChild.style.textShadow = `1px 1px ${ga}, 2px 2px ${ga}, 3px 3px ${ga}` : n.edgeStyle === "depressed" ? s.firstChild.style.textShadow = `1px 1px ${hb}, 0 1px ${hb}, -1px -1px ${ga}, 0 -1px ${ga}` : n.edgeStyle === "uniform" && (s.firstChild.style.textShadow = `0 0 4px ${ga}, 0 0 4px ${ga}, 0 0 4px ${ga}, 0 0 4px ${ga}`)), n.fontPercent && n.fontPercent !== 1) {
        const o = j.parseFloat(s.style.fontSize);
        s.style.fontSize = o * n.fontPercent + "px", s.style.height = "auto", s.style.top = "auto";
      }
      n.fontFamily && n.fontFamily !== "default" && (n.fontFamily === "small-caps" ? s.firstChild.style.fontVariant = "small-caps" : s.firstChild.style.fontFamily = wne[n.fontFamily]);
    }
  }
  /**
   * Add an {@link TextTrack} to to the {@link Tech}s {@link TextTrackList}.
   *
   * @param {TextTrack|TextTrack[]} tracks
   *        Text track object or text track array to be added to the list.
   */
  updateForTrack(e) {
    if (Array.isArray(e) || (e = [e]), typeof j.WebVTT != "function" || e.every((a) => !a.activeCues))
      return;
    const n = [];
    for (let a = 0; a < e.length; ++a) {
      const i = e[a];
      for (let r = 0; r < i.activeCues.length; ++r)
        n.push(i.activeCues[r]);
    }
    j.WebVTT.processCues(j, n, this.el_);
    for (let a = 0; a < e.length; ++a) {
      const i = e[a];
      for (let r = 0; r < i.activeCues.length; ++r) {
        const s = i.activeCues[r].displayState;
        Dr(s, "vjs-text-track-cue", "vjs-text-track-cue-" + (i.language ? i.language : a)), i.language && Vs(s, "lang", i.language);
      }
      this.player_.textTrackSettings && this.updateDisplayState(i);
    }
  }
}
ye.registerComponent("TextTrackDisplay", kne);
class Cne extends ye {
  /**
   * Create the `LoadingSpinner`s DOM element.
   *
   * @return {Element}
   *         The dom element that gets created.
   */
  createEl() {
    const e = this.player_.isAudio(), n = this.localize(e ? "Audio Player" : "Video Player"), a = et("span", {
      className: "vjs-control-text",
      textContent: this.localize("{1} is loading.", [n])
    }), i = super.createEl("div", {
      className: "vjs-loading-spinner",
      dir: "ltr"
    });
    return i.appendChild(a), i;
  }
  /**
   * Update control text on languagechange
   */
  handleLanguagechange() {
    this.$(".vjs-control-text").textContent = this.localize("{1} is loading.", [this.player_.isAudio() ? "Audio Player" : "Video Player"]);
  }
}
ye.registerComponent("LoadingSpinner", Cne);
class Dn extends Ed {
  /**
   * Create the `Button`s DOM element.
   *
   * @param {string} [tag="button"]
   *        The element's node type. This argument is IGNORED: no matter what
   *        is passed, it will always create a `button` element.
   *
   * @param {Object} [props={}]
   *        An object of properties that should be set on the element.
   *
   * @param {Object} [attributes={}]
   *        An object of attributes that should be set on the element.
   *
   * @return {Element}
   *         The element that gets created.
   */
  createEl(e, n = {}, a = {}) {
    e = "button", n = Object.assign({
      className: this.buildCSSClass()
    }, n), a = Object.assign({
      // Necessary since the default button type is "submit"
      type: "button"
    }, a);
    const i = et(e, n, a);
    return this.player_.options_.experimentalSvgIcons || i.appendChild(et("span", {
      className: "vjs-icon-placeholder"
    }, {
      "aria-hidden": !0
    })), this.createControlTextEl(i), i;
  }
  /**
   * Add a child `Component` inside of this `Button`.
   *
   * @param {string|Component} child
   *        The name or instance of a child to add.
   *
   * @param {Object} [options={}]
   *        The key/value store of options that will get passed to children of
   *        the child.
   *
   * @return {Component}
   *         The `Component` that gets added as a child. When using a string the
   *         `Component` will get created by this process.
   *
   * @deprecated since version 5
   */
  addChild(e, n = {}) {
    const a = this.constructor.name;
    return ut.warn(`Adding an actionable (user controllable) child to a Button (${a}) is not supported; use a ClickableComponent instead.`), ye.prototype.addChild.call(this, e, n);
  }
  /**
   * Enable the `Button` element so that it can be activated or clicked. Use this with
   * {@link Button#disable}.
   */
  enable() {
    super.enable(), this.el_.removeAttribute("disabled");
  }
  /**
   * Disable the `Button` element so that it cannot be activated or clicked. Use this with
   * {@link Button#enable}.
   */
  disable() {
    super.disable(), this.el_.setAttribute("disabled", "disabled");
  }
  /**
   * This gets called when a `Button` has focus and `keydown` is triggered via a key
   * press.
   *
   * @param {KeyboardEvent} event
   *        The event that caused this function to get called.
   *
   * @listens keydown
   */
  handleKeyDown(e) {
    if (e.key === " " || e.key === "Enter") {
      e.stopPropagation();
      return;
    }
    super.handleKeyDown(e);
  }
}
ye.registerComponent("Button", Dn);
class F3 extends Dn {
  constructor(e, n) {
    super(e, n), this.mouseused_ = !1, this.setIcon("play"), this.on("mousedown", (a) => this.handleMouseDown(a));
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object. Always returns 'vjs-big-play-button'.
   */
  buildCSSClass() {
    return "vjs-big-play-button";
  }
  /**
   * This gets called when a `BigPlayButton` "clicked". See {@link ClickableComponent}
   * for more detailed information on what a click can be.
   *
   * @param {KeyboardEvent|MouseEvent|TouchEvent} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick(e) {
    const n = this.player_.play();
    if (this.mouseused_ && "clientX" in e && "clientY" in e) {
      Xa(n), this.player_.tech(!0) && this.player_.tech(!0).focus();
      return;
    }
    const a = this.player_.getChild("controlBar"), i = a && a.getChild("playToggle");
    if (!i) {
      this.player_.tech(!0).focus();
      return;
    }
    const r = () => i.focus();
    pl(n) ? n.then(r, () => {
    }) : this.setTimeout(r, 1);
  }
  /**
   * Event handler that is called when a `BigPlayButton` receives a
   * `keydown` event.
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */
  handleKeyDown(e) {
    this.mouseused_ = !1, super.handleKeyDown(e);
  }
  /**
   * Handle `mousedown` events on the `BigPlayButton`.
   *
   * @param {MouseEvent} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousedown
   */
  handleMouseDown(e) {
    this.mouseused_ = !0;
  }
}
F3.prototype.controlText_ = "Play Video";
ye.registerComponent("BigPlayButton", F3);
class Sne extends Dn {
  /**
  * Creates an instance of the this class.
  *
  * @param  {Player} player
  *         The `Player` that this class should be attached to.
  *
  * @param  {Object} [options]
  *         The key/value store of player options.
  */
  constructor(e, n) {
    super(e, n), this.setIcon("cancel"), this.controlText(n && n.controlText || this.localize("Close"));
  }
  /**
  * Builds the default DOM `className`.
  *
  * @return {string}
  *         The DOM `className` for this object.
  */
  buildCSSClass() {
    return `vjs-close-button ${super.buildCSSClass()}`;
  }
  /**
   * This gets called when a `CloseButton` gets clicked. See
   * {@link ClickableComponent#handleClick} for more information on when
   * this will be triggered
   *
   * @param {Event} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   * @fires CloseButton#close
   */
  handleClick(e) {
    this.trigger({
      type: "close",
      bubbles: !1
    });
  }
  /**
   * Event handler that is called when a `CloseButton` receives a
   * `keydown` event.
   *
   * By default, if the key is Esc, it will trigger a `click` event.
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */
  handleKeyDown(e) {
    e.key === "Escape" ? (e.preventDefault(), e.stopPropagation(), this.trigger("click")) : super.handleKeyDown(e);
  }
}
ye.registerComponent("CloseButton", Sne);
class z3 extends Dn {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */
  constructor(e, n = {}) {
    super(e, n), n.replay = n.replay === void 0 || n.replay, this.setIcon("play"), this.on(e, "play", (a) => this.handlePlay(a)), this.on(e, "pause", (a) => this.handlePause(a)), n.replay && this.on(e, "ended", (a) => this.handleEnded(a));
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-play-control ${super.buildCSSClass()}`;
  }
  /**
   * This gets called when an `PlayToggle` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick(e) {
    this.player_.paused() ? Xa(this.player_.play()) : this.player_.pause();
  }
  /**
   * This gets called once after the video has ended and the user seeks so that
   * we can change the replay button back to a play button.
   *
   * @param {Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#seeked
   */
  handleSeeked(e) {
    this.removeClass("vjs-ended"), this.player_.paused() ? this.handlePause(e) : this.handlePlay(e);
  }
  /**
   * Add the vjs-playing class to the element so it can change appearance.
   *
   * @param {Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#play
   */
  handlePlay(e) {
    this.removeClass("vjs-ended", "vjs-paused"), this.addClass("vjs-playing"), this.setIcon("pause"), this.controlText("Pause");
  }
  /**
   * Add the vjs-paused class to the element so it can change appearance.
   *
   * @param {Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#pause
   */
  handlePause(e) {
    this.removeClass("vjs-playing"), this.addClass("vjs-paused"), this.setIcon("play"), this.controlText("Play");
  }
  /**
   * Add the vjs-ended class to the element so it can change appearance
   *
   * @param {Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#ended
   */
  handleEnded(e) {
    this.removeClass("vjs-playing"), this.addClass("vjs-ended"), this.setIcon("replay"), this.controlText("Replay"), this.one(this.player_, "seeked", (n) => this.handleSeeked(n));
  }
}
z3.prototype.controlText_ = "Play";
ye.registerComponent("PlayToggle", z3);
class po extends ye {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, n) {
    super(e, n), this.on(e, ["timeupdate", "ended", "seeking"], (a) => this.update(a)), this.updateTextNode_();
  }
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    const e = this.buildCSSClass(), n = super.createEl("div", {
      className: `${e} vjs-time-control vjs-control`
    }), a = et("span", {
      className: "vjs-control-text",
      textContent: `${this.localize(this.labelText_)} `
    }, {
      role: "presentation"
    });
    return n.appendChild(a), this.contentEl_ = et("span", {
      className: `${e}-display`
    }, {
      // span elements have no implicit role, but some screen readers (notably VoiceOver)
      // treat them as a break between items in the DOM when using arrow keys
      // (or left-to-right swipes on iOS) to read contents of a page. Using
      // role='presentation' causes VoiceOver to NOT treat this span as a break.
      role: "presentation"
    }), n.appendChild(this.contentEl_), n;
  }
  dispose() {
    this.contentEl_ = null, this.textNode_ = null, super.dispose();
  }
  /**
   * Updates the displayed time according to the `updateContent` function which is defined in the child class.
   *
   * @param {Event} [event]
   *          The `timeupdate`, `ended` or `seeking` (if enableSmoothSeeking is true) event that caused this function to be called.
   */
  update(e) {
    !this.player_.options_.enableSmoothSeeking && e.type === "seeking" || this.updateContent(e);
  }
  /**
   * Updates the time display text node with a new time
   *
   * @param {number} [time=0] the time to update to
   *
   * @private
   */
  updateTextNode_(e = 0) {
    e = $r(e), this.formattedTime_ !== e && (this.formattedTime_ = e, this.requestNamedAnimationFrame("TimeDisplay#updateTextNode_", () => {
      if (!this.contentEl_)
        return;
      let n = this.textNode_;
      n && this.contentEl_.firstChild !== n && (n = null, ut.warn("TimeDisplay#updateTextnode_: Prevented replacement of text node element since it was no longer a child of this node. Appending a new node instead.")), this.textNode_ = Me.createTextNode(this.formattedTime_), this.textNode_ && (n ? this.contentEl_.replaceChild(this.textNode_, n) : this.contentEl_.appendChild(this.textNode_));
    }));
  }
  /**
   * To be filled out in the child class, should update the displayed time
   * in accordance with the fact that the current time has changed.
   *
   * @param {Event} [event]
   *        The `timeupdate`  event that caused this to run.
   *
   * @listens Player#timeupdate
   */
  updateContent(e) {
  }
}
po.prototype.labelText_ = "Time";
po.prototype.controlText_ = "Time";
ye.registerComponent("TimeDisplay", po);
class mp extends po {
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return "vjs-current-time";
  }
  /**
   * Update current time display
   *
   * @param {Event} [event]
   *        The `timeupdate` event that caused this function to run.
   *
   * @listens Player#timeupdate
   */
  updateContent(e) {
    let n;
    this.player_.ended() ? n = this.player_.duration() : n = this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime(), this.updateTextNode_(n);
  }
}
mp.prototype.labelText_ = "Current Time";
mp.prototype.controlText_ = "Current Time";
ye.registerComponent("CurrentTimeDisplay", mp);
class gp extends po {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, n) {
    super(e, n);
    const a = (i) => this.updateContent(i);
    this.on(e, "durationchange", a), this.on(e, "loadstart", a), this.on(e, "loadedmetadata", a);
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return "vjs-duration";
  }
  /**
   * Update duration time display.
   *
   * @param {Event} [event]
   *        The `durationchange`, `timeupdate`, or `loadedmetadata` event that caused
   *        this function to be called.
   *
   * @listens Player#durationchange
   * @listens Player#timeupdate
   * @listens Player#loadedmetadata
   */
  updateContent(e) {
    const n = this.player_.duration();
    this.updateTextNode_(n);
  }
}
gp.prototype.labelText_ = "Duration";
gp.prototype.controlText_ = "Duration";
ye.registerComponent("DurationDisplay", gp);
class Ane extends ye {
  /**
   * Create the component's DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    const e = super.createEl("div", {
      className: "vjs-time-control vjs-time-divider"
    }, {
      // this element and its contents can be hidden from assistive techs since
      // it is made extraneous by the announcement of the control text
      // for the current time and duration displays
      "aria-hidden": !0
    }), n = super.createEl("div"), a = super.createEl("span", {
      textContent: "/"
    });
    return n.appendChild(a), e.appendChild(n), e;
  }
}
ye.registerComponent("TimeDivider", Ane);
class bp extends po {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, n) {
    super(e, n), this.on(e, "durationchange", (a) => this.updateContent(a));
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return "vjs-remaining-time";
  }
  /**
   * Create the `Component`'s DOM element with the "minus" character prepend to the time
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    const e = super.createEl();
    return this.options_.displayNegative !== !1 && e.insertBefore(et("span", {}, {
      "aria-hidden": !0
    }, "-"), this.contentEl_), e;
  }
  /**
   * Update remaining time display.
   *
   * @param {Event} [event]
   *        The `timeupdate` or `durationchange` event that caused this to run.
   *
   * @listens Player#timeupdate
   * @listens Player#durationchange
   */
  updateContent(e) {
    if (typeof this.player_.duration() != "number")
      return;
    let n;
    this.player_.ended() ? n = 0 : this.player_.remainingTimeDisplay ? n = this.player_.remainingTimeDisplay() : n = this.player_.remainingTime(), this.updateTextNode_(n);
  }
}
bp.prototype.labelText_ = "Remaining Time";
bp.prototype.controlText_ = "Remaining Time";
ye.registerComponent("RemainingTimeDisplay", bp);
class Ene extends ye {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, n) {
    super(e, n), this.updateShowing(), this.on(this.player(), "durationchange", (a) => this.updateShowing(a));
  }
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    const e = super.createEl("div", {
      className: "vjs-live-control vjs-control"
    });
    return this.contentEl_ = et("div", {
      className: "vjs-live-display"
    }, {
      "aria-live": "off"
    }), this.contentEl_.appendChild(et("span", {
      className: "vjs-control-text",
      textContent: `${this.localize("Stream Type")} `
    })), this.contentEl_.appendChild(Me.createTextNode(this.localize("LIVE"))), e.appendChild(this.contentEl_), e;
  }
  dispose() {
    this.contentEl_ = null, super.dispose();
  }
  /**
   * Check the duration to see if the LiveDisplay should be showing or not. Then show/hide
   * it accordingly
   *
   * @param {Event} [event]
   *        The {@link Player#durationchange} event that caused this function to run.
   *
   * @listens Player#durationchange
   */
  updateShowing(e) {
    this.player().duration() === 1 / 0 ? this.show() : this.hide();
  }
}
ye.registerComponent("LiveDisplay", Ene);
class U3 extends Dn {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, n) {
    super(e, n), this.updateLiveEdgeStatus(), this.player_.liveTracker && (this.updateLiveEdgeStatusHandler_ = (a) => this.updateLiveEdgeStatus(a), this.on(this.player_.liveTracker, "liveedgechange", this.updateLiveEdgeStatusHandler_));
  }
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    const e = super.createEl("button", {
      className: "vjs-seek-to-live-control vjs-control"
    });
    return this.setIcon("circle", e), this.textEl_ = et("span", {
      className: "vjs-seek-to-live-text",
      textContent: this.localize("LIVE")
    }, {
      "aria-hidden": "true"
    }), e.appendChild(this.textEl_), e;
  }
  /**
   * Update the state of this button if we are at the live edge
   * or not
   */
  updateLiveEdgeStatus() {
    !this.player_.liveTracker || this.player_.liveTracker.atLiveEdge() ? (this.setAttribute("aria-disabled", !0), this.addClass("vjs-at-live-edge"), this.controlText("Seek to live, currently playing live")) : (this.setAttribute("aria-disabled", !1), this.removeClass("vjs-at-live-edge"), this.controlText("Seek to live, currently behind live"));
  }
  /**
   * On click bring us as near to the live point as possible.
   * This requires that we wait for the next `live-seekable-change`
   * event which will happen every segment length seconds.
   */
  handleClick() {
    this.player_.liveTracker.seekToLiveEdge();
  }
  /**
   * Dispose of the element and stop tracking
   */
  dispose() {
    this.player_.liveTracker && this.off(this.player_.liveTracker, "liveedgechange", this.updateLiveEdgeStatusHandler_), this.textEl_ = null, super.dispose();
  }
}
U3.prototype.controlText_ = "Seek to live, currently playing live";
ye.registerComponent("SeekToLive", U3);
function Gl(t, e, n) {
  return t = Number(t), Math.min(n, Math.max(e, isNaN(t) ? e : t));
}
var Lne = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  clamp: Gl
});
class vp extends ye {
  /**
  * Create an instance of this class
  *
  * @param {Player} player
  *        The `Player` that this class should be attached to.
  *
  * @param {Object} [options]
  *        The key/value store of player options.
  */
  constructor(e, n) {
    super(e, n), this.handleMouseDown_ = (a) => this.handleMouseDown(a), this.handleMouseUp_ = (a) => this.handleMouseUp(a), this.handleKeyDown_ = (a) => this.handleKeyDown(a), this.handleClick_ = (a) => this.handleClick(a), this.handleMouseMove_ = (a) => this.handleMouseMove(a), this.update_ = (a) => this.update(a), this.bar = this.getChild(this.options_.barName), this.vertical(!!this.options_.vertical), this.enable();
  }
  /**
   * Are controls are currently enabled for this slider or not.
   *
   * @return {boolean}
   *         true if controls are enabled, false otherwise
   */
  enabled() {
    return this.enabled_;
  }
  /**
   * Enable controls for this slider if they are disabled
   */
  enable() {
    this.enabled() || (this.on("mousedown", this.handleMouseDown_), this.on("touchstart", this.handleMouseDown_), this.on("keydown", this.handleKeyDown_), this.on("click", this.handleClick_), this.on(this.player_, "controlsvisible", this.update), this.playerEvent && this.on(this.player_, this.playerEvent, this.update), this.removeClass("disabled"), this.setAttribute("tabindex", 0), this.enabled_ = !0);
  }
  /**
   * Disable controls for this slider if they are enabled
   */
  disable() {
    if (!this.enabled())
      return;
    const e = this.bar.el_.ownerDocument;
    this.off("mousedown", this.handleMouseDown_), this.off("touchstart", this.handleMouseDown_), this.off("keydown", this.handleKeyDown_), this.off("click", this.handleClick_), this.off(this.player_, "controlsvisible", this.update_), this.off(e, "mousemove", this.handleMouseMove_), this.off(e, "mouseup", this.handleMouseUp_), this.off(e, "touchmove", this.handleMouseMove_), this.off(e, "touchend", this.handleMouseUp_), this.removeAttribute("tabindex"), this.addClass("disabled"), this.playerEvent && this.off(this.player_, this.playerEvent, this.update), this.enabled_ = !1;
  }
  /**
   * Create the `Slider`s DOM element.
   *
   * @param {string} type
   *        Type of element to create.
   *
   * @param {Object} [props={}]
   *        List of properties in Object form.
   *
   * @param {Object} [attributes={}]
   *        list of attributes in Object form.
   *
   * @return {Element}
   *         The element that gets created.
   */
  createEl(e, n = {}, a = {}) {
    return n.className = n.className + " vjs-slider", n = Object.assign({
      tabIndex: 0
    }, n), a = Object.assign({
      role: "slider",
      "aria-valuenow": 0,
      "aria-valuemin": 0,
      "aria-valuemax": 100
    }, a), super.createEl(e, n, a);
  }
  /**
   * Handle `mousedown` or `touchstart` events on the `Slider`.
   *
   * @param {MouseEvent} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousedown
   * @listens touchstart
   * @fires Slider#slideractive
   */
  handleMouseDown(e) {
    const n = this.bar.el_.ownerDocument;
    e.type === "mousedown" && e.preventDefault(), e.type === "touchstart" && !ai && e.preventDefault(), p3(), this.addClass("vjs-sliding"), this.trigger("slideractive"), this.on(n, "mousemove", this.handleMouseMove_), this.on(n, "mouseup", this.handleMouseUp_), this.on(n, "touchmove", this.handleMouseMove_), this.on(n, "touchend", this.handleMouseUp_), this.handleMouseMove(e, !0);
  }
  /**
   * Handle the `mousemove`, `touchmove`, and `mousedown` events on this `Slider`.
   * The `mousemove` and `touchmove` events will only only trigger this function during
   * `mousedown` and `touchstart`. This is due to {@link Slider#handleMouseDown} and
   * {@link Slider#handleMouseUp}.
   *
   * @param {MouseEvent} event
   *        `mousedown`, `mousemove`, `touchstart`, or `touchmove` event that triggered
   *        this function
   * @param {boolean} mouseDown this is a flag that should be set to true if `handleMouseMove` is called directly. It allows us to skip things that should not happen if coming from mouse down but should happen on regular mouse move handler. Defaults to false.
   *
   * @listens mousemove
   * @listens touchmove
   */
  handleMouseMove(e) {
  }
  /**
   * Handle `mouseup` or `touchend` events on the `Slider`.
   *
   * @param {MouseEvent} event
   *        `mouseup` or `touchend` event that triggered this function.
   *
   * @listens touchend
   * @listens mouseup
   * @fires Slider#sliderinactive
   */
  handleMouseUp(e) {
    const n = this.bar.el_.ownerDocument;
    m3(), this.removeClass("vjs-sliding"), this.trigger("sliderinactive"), this.off(n, "mousemove", this.handleMouseMove_), this.off(n, "mouseup", this.handleMouseUp_), this.off(n, "touchmove", this.handleMouseMove_), this.off(n, "touchend", this.handleMouseUp_), this.update();
  }
  /**
   * Update the progress bar of the `Slider`.
   *
   * @return {number}
   *          The percentage of progress the progress bar represents as a
   *          number from 0 to 1.
   */
  update() {
    if (!this.el_ || !this.bar)
      return;
    const e = this.getProgress();
    return e === this.progress_ || (this.progress_ = e, this.requestNamedAnimationFrame("Slider#update", () => {
      const n = this.vertical() ? "height" : "width";
      this.bar.el().style[n] = (e * 100).toFixed(2) + "%";
    })), e;
  }
  /**
   * Get the percentage of the bar that should be filled
   * but clamped and rounded.
   *
   * @return {number}
   *         percentage filled that the slider is
   */
  getProgress() {
    return Number(Gl(this.getPercent(), 0, 1).toFixed(4));
  }
  /**
   * Calculate distance for slider
   *
   * @param {Event} event
   *        The event that caused this function to run.
   *
   * @return {number}
   *         The current position of the Slider.
   *         - position.x for vertical `Slider`s
   *         - position.y for horizontal `Slider`s
   */
  calculateDistance(e) {
    const n = xd(this.el_, e);
    return this.vertical() ? n.y : n.x;
  }
  /**
   * Handle a `keydown` event on the `Slider`. Watches for left, right, up, and down
   * arrow keys. This function will only be called when the slider has focus. See
   * {@link Slider#handleFocus} and {@link Slider#handleBlur}.
   *
   * @param {KeyboardEvent} event
   *        the `keydown` event that caused this function to run.
   *
   * @listens keydown
   */
  handleKeyDown(e) {
    const n = this.options_.playerOptions.spatialNavigation, a = n && n.enabled, i = n && n.horizontalSeek;
    a ? i && e.key === "ArrowLeft" || !i && e.key === "ArrowDown" ? (e.preventDefault(), e.stopPropagation(), this.stepBack()) : i && e.key === "ArrowRight" || !i && e.key === "ArrowUp" ? (e.preventDefault(), e.stopPropagation(), this.stepForward()) : super.handleKeyDown(e) : e.key === "ArrowLeft" || e.key === "ArrowDown" ? (e.preventDefault(), e.stopPropagation(), this.stepBack()) : e.key === "ArrowUp" || e.key === "ArrowRight" ? (e.preventDefault(), e.stopPropagation(), this.stepForward()) : super.handleKeyDown(e);
  }
  /**
   * Listener for click events on slider, used to prevent clicks
   *   from bubbling up to parent elements like button menus.
   *
   * @param {Object} event
   *        Event that caused this object to run
   */
  handleClick(e) {
    e.stopPropagation(), e.preventDefault();
  }
  /**
   * Get/set if slider is horizontal for vertical
   *
   * @param {boolean} [bool]
   *        - true if slider is vertical,
   *        - false is horizontal
   *
   * @return {boolean}
   *         - true if slider is vertical, and getting
   *         - false if the slider is horizontal, and getting
   */
  vertical(e) {
    if (e === void 0)
      return this.vertical_ || !1;
    this.vertical_ = !!e, this.vertical_ ? this.addClass("vjs-slider-vertical") : this.addClass("vjs-slider-horizontal");
  }
}
ye.registerComponent("Slider", vp);
const P0 = (t, e) => Gl(t / e * 100, 0, 100).toFixed(2) + "%";
class Dne extends ye {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, n) {
    super(e, n), this.partEls_ = [], this.on(e, "progress", (a) => this.update(a));
  }
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    const e = super.createEl("div", {
      className: "vjs-load-progress"
    }), n = et("span", {
      className: "vjs-control-text"
    }), a = et("span", {
      textContent: this.localize("Loaded")
    }), i = Me.createTextNode(": ");
    return this.percentageEl_ = et("span", {
      className: "vjs-control-text-loaded-percentage",
      textContent: "0%"
    }), e.appendChild(n), n.appendChild(a), n.appendChild(i), n.appendChild(this.percentageEl_), e;
  }
  dispose() {
    this.partEls_ = null, this.percentageEl_ = null, super.dispose();
  }
  /**
   * Update progress bar
   *
   * @param {Event} [event]
   *        The `progress` event that caused this function to run.
   *
   * @listens Player#progress
   */
  update(e) {
    this.requestNamedAnimationFrame("LoadProgressBar#update", () => {
      const n = this.player_.liveTracker, a = this.player_.buffered(), i = n && n.isLive() ? n.seekableEnd() : this.player_.duration(), r = this.player_.bufferedEnd(), s = this.partEls_, o = P0(r, i);
      this.percent_ !== o && (this.el_.style.width = o, ur(this.percentageEl_, o), this.percent_ = o);
      for (let l = 0; l < a.length; l++) {
        const c = a.start(l), u = a.end(l);
        let f = s[l];
        f || (f = this.el_.appendChild(et()), s[l] = f), !(f.dataset.start === c && f.dataset.end === u) && (f.dataset.start = c, f.dataset.end = u, f.style.left = P0(c, r), f.style.width = P0(u - c, r));
      }
      for (let l = s.length; l > a.length; l--)
        this.el_.removeChild(s[l - 1]);
      s.length = a.length;
    });
  }
}
ye.registerComponent("LoadProgressBar", Dne);
class Ine extends ye {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The {@link Player} that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, n) {
    super(e, n), this.update = ii(Et(this, this.update), wa);
  }
  /**
   * Create the time tooltip DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    return super.createEl("div", {
      className: "vjs-time-tooltip"
    }, {
      "aria-hidden": "true"
    });
  }
  /**
   * Updates the position of the time tooltip relative to the `SeekBar`.
   *
   * @param {Object} seekBarRect
   *        The `ClientRect` for the {@link SeekBar} element.
   *
   * @param {number} seekBarPoint
   *        A number from 0 to 1, representing a horizontal reference point
   *        from the left edge of the {@link SeekBar}
   */
  update(e, n, a) {
    const i = Dl(this.el_), r = qs(this.player_.el()), s = e.width * n;
    if (!r || !i)
      return;
    let o = e.left - r.left + s, l = e.width - s + (r.right - e.right);
    l || (l = e.width - s, o = s);
    let c = i.width / 2;
    o < c ? c += c - o : l < c && (c = l), c < 0 ? c = 0 : c > i.width && (c = i.width), c = Math.round(c), this.el_.style.right = `-${c}px`, this.write(a);
  }
  /**
   * Write the time to the tooltip DOM element.
   *
   * @param {string} content
   *        The formatted time for the tooltip.
   */
  write(e) {
    ur(this.el_, e);
  }
  /**
   * Updates the position of the time tooltip relative to the `SeekBar`.
   *
   * @param {Object} seekBarRect
   *        The `ClientRect` for the {@link SeekBar} element.
   *
   * @param {number} seekBarPoint
   *        A number from 0 to 1, representing a horizontal reference point
   *        from the left edge of the {@link SeekBar}
   *
   * @param {number} time
   *        The time to update the tooltip to, not used during live playback
   *
   * @param {Function} cb
   *        A function that will be called during the request animation frame
   *        for tooltips that need to do additional animations from the default
   */
  updateTime(e, n, a, i) {
    this.requestNamedAnimationFrame("TimeTooltip#updateTime", () => {
      let r;
      const s = this.player_.duration();
      if (this.player_.liveTracker && this.player_.liveTracker.isLive()) {
        const o = this.player_.liveTracker.liveWindow(), l = o - n * o;
        r = (l < 1 ? "" : "-") + $r(l, o);
      } else
        r = $r(a, s);
      this.update(e, n, r), i && i();
    });
  }
}
ye.registerComponent("TimeTooltip", Ine);
class yp extends ye {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The {@link Player} that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, n) {
    super(e, n), this.setIcon("circle"), this.update = ii(Et(this, this.update), wa);
  }
  /**
   * Create the the DOM element for this class.
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    return super.createEl("div", {
      className: "vjs-play-progress vjs-slider-bar"
    }, {
      "aria-hidden": "true"
    });
  }
  /**
   * Enqueues updates to its own DOM as well as the DOM of its
   * {@link TimeTooltip} child.
   *
   * @param {Object} seekBarRect
   *        The `ClientRect` for the {@link SeekBar} element.
   *
   * @param {number} seekBarPoint
   *        A number from 0 to 1, representing a horizontal reference point
   *        from the left edge of the {@link SeekBar}
   */
  update(e, n) {
    const a = this.getChild("timeTooltip");
    if (!a)
      return;
    const i = this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime();
    a.updateTime(e, n, i);
  }
}
yp.prototype.options_ = {
  children: []
};
!En && !$a && yp.prototype.options_.children.push("timeTooltip");
ye.registerComponent("PlayProgressBar", yp);
class H3 extends ye {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The {@link Player} that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, n) {
    super(e, n), this.update = ii(Et(this, this.update), wa);
  }
  /**
   * Create the DOM element for this class.
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    return super.createEl("div", {
      className: "vjs-mouse-display"
    });
  }
  /**
   * Enqueues updates to its own DOM as well as the DOM of its
   * {@link TimeTooltip} child.
   *
   * @param {Object} seekBarRect
   *        The `ClientRect` for the {@link SeekBar} element.
   *
   * @param {number} seekBarPoint
   *        A number from 0 to 1, representing a horizontal reference point
   *        from the left edge of the {@link SeekBar}
   */
  update(e, n) {
    const a = n * this.player_.duration();
    this.getChild("timeTooltip").updateTime(e, n, a, () => {
      this.el_.style.left = `${e.width * n}px`;
    });
  }
}
H3.prototype.options_ = {
  children: ["timeTooltip"]
};
ye.registerComponent("MouseTimeDisplay", H3);
const Bc = 5, pb = 12;
class Ld extends vp {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, n) {
    n = wt(Ld.prototype.options_, n), n.children = [...n.children];
    const a = e.options_.disableSeekWhileScrubbingOnMobile && (En || $a);
    (!En && !$a || a) && n.children.splice(1, 0, "mouseTimeDisplay"), super(e, n), this.shouldDisableSeekWhileScrubbingOnMobile_ = a, this.pendingSeekTime_ = null, this.setEventHandlers_();
  }
  /**
   * Sets the event handlers
   *
   * @private
   */
  setEventHandlers_() {
    this.update_ = Et(this, this.update), this.update = ii(this.update_, wa), this.on(this.player_, ["durationchange", "timeupdate"], this.update), this.on(this.player_, ["ended"], this.update_), this.player_.liveTracker && this.on(this.player_.liveTracker, "liveedgechange", this.update), this.updateInterval = null, this.enableIntervalHandler_ = (e) => this.enableInterval_(e), this.disableIntervalHandler_ = (e) => this.disableInterval_(e), this.on(this.player_, ["playing"], this.enableIntervalHandler_), this.on(this.player_, ["ended", "pause", "waiting"], this.disableIntervalHandler_), "hidden" in Me && "visibilityState" in Me && this.on(Me, "visibilitychange", this.toggleVisibility_);
  }
  toggleVisibility_(e) {
    Me.visibilityState === "hidden" ? (this.cancelNamedAnimationFrame("SeekBar#update"), this.cancelNamedAnimationFrame("Slider#update"), this.disableInterval_(e)) : (!this.player_.ended() && !this.player_.paused() && this.enableInterval_(), this.update());
  }
  enableInterval_() {
    this.updateInterval || (this.updateInterval = this.setInterval(this.update, wa));
  }
  disableInterval_(e) {
    this.player_.liveTracker && this.player_.liveTracker.isLive() && e && e.type !== "ended" || this.updateInterval && (this.clearInterval(this.updateInterval), this.updateInterval = null);
  }
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    return super.createEl("div", {
      className: "vjs-progress-holder"
    }, {
      "aria-label": this.localize("Progress Bar")
    });
  }
  /**
   * This function updates the play progress bar and accessibility
   * attributes to whatever is passed in.
   *
   * @param {Event} [event]
   *        The `timeupdate` or `ended` event that caused this to run.
   *
   * @listens Player#timeupdate
   *
   * @return {number}
   *          The current percent at a number from 0-1
   */
  update(e) {
    if (Me.visibilityState === "hidden")
      return;
    const n = super.update();
    return this.requestNamedAnimationFrame("SeekBar#update", () => {
      const a = this.player_.ended() ? this.player_.duration() : this.getCurrentTime_(), i = this.player_.liveTracker;
      let r = this.player_.duration();
      i && i.isLive() && (r = this.player_.liveTracker.liveCurrentTime()), this.percent_ !== n && (this.el_.setAttribute("aria-valuenow", (n * 100).toFixed(2)), this.percent_ = n), (this.currentTime_ !== a || this.duration_ !== r) && (this.el_.setAttribute("aria-valuetext", this.localize("progress bar timing: currentTime={1} duration={2}", [$r(a, r), $r(r, r)], "{1} of {2}")), this.currentTime_ = a, this.duration_ = r), this.bar && this.bar.update(qs(this.el()), this.getProgress());
    }), n;
  }
  /**
   * Prevent liveThreshold from causing seeks to seem like they
   * are not happening from a user perspective.
   *
   * @param {number} ct
   *        current time to seek to
   */
  userSeek_(e) {
    this.player_.liveTracker && this.player_.liveTracker.isLive() && this.player_.liveTracker.nextSeekedFromUser(), this.player_.currentTime(e);
  }
  /**
   * Get the value of current time but allows for smooth scrubbing,
   * when player can't keep up.
   *
   * @return {number}
   *         The current time value to display
   *
   * @private
   */
  getCurrentTime_() {
    return this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime();
  }
  /**
   * Get the percentage of media played so far.
   *
   * @return {number}
   *         The percentage of media played so far (0 to 1).
   */
  getPercent() {
    if (this.pendingSeekTime_)
      return this.pendingSeekTime_ / this.player_.duration();
    const e = this.getCurrentTime_();
    let n;
    const a = this.player_.liveTracker;
    return a && a.isLive() ? (n = (e - a.seekableStart()) / a.liveWindow(), a.atLiveEdge() && (n = 1)) : n = e / this.player_.duration(), n;
  }
  /**
   * Handle mouse down on seek bar
   *
   * @param {MouseEvent} event
   *        The `mousedown` event that caused this to run.
   *
   * @listens mousedown
   */
  handleMouseDown(e) {
    Il(e) && (e.stopPropagation(), this.videoWasPlaying = !this.player_.paused(), this.shouldDisableSeekWhileScrubbingOnMobile_ || this.player_.pause(), super.handleMouseDown(e));
  }
  /**
   * Handle mouse move on seek bar
   *
   * @param {MouseEvent} event
   *        The `mousemove` event that caused this to run.
   * @param {boolean} mouseDown this is a flag that should be set to true if `handleMouseMove` is called directly. It allows us to skip things that should not happen if coming from mouse down but should happen on regular mouse move handler. Defaults to false
   *
   * @listens mousemove
   */
  handleMouseMove(e, n = !1) {
    if (!Il(e) || isNaN(this.player_.duration()))
      return;
    !n && !this.player_.scrubbing() && this.player_.scrubbing(!0);
    let a;
    const i = this.calculateDistance(e), r = this.player_.liveTracker;
    if (!r || !r.isLive())
      a = i * this.player_.duration(), a === this.player_.duration() && (a = a - 0.1);
    else {
      if (i >= 0.99) {
        r.seekToLiveEdge();
        return;
      }
      const s = r.seekableStart(), o = r.liveCurrentTime();
      if (a = s + i * r.liveWindow(), a >= o && (a = o), a <= s && (a = s + 0.1), a === 1 / 0)
        return;
    }
    this.shouldDisableSeekWhileScrubbingOnMobile_ ? this.pendingSeekTime_ = a : this.userSeek_(a), this.player_.options_.enableSmoothSeeking && this.update();
  }
  enable() {
    super.enable();
    const e = this.getChild("mouseTimeDisplay");
    e && e.show();
  }
  disable() {
    super.disable();
    const e = this.getChild("mouseTimeDisplay");
    e && e.hide();
  }
  /**
   * Handle mouse up on seek bar
   *
   * @param {MouseEvent} event
   *        The `mouseup` event that caused this to run.
   *
   * @listens mouseup
   */
  handleMouseUp(e) {
    super.handleMouseUp(e), e && e.stopPropagation(), this.player_.scrubbing(!1), this.pendingSeekTime_ && (this.userSeek_(this.pendingSeekTime_), this.pendingSeekTime_ = null), this.player_.trigger({
      type: "timeupdate",
      target: this,
      manuallyTriggered: !0
    }), this.videoWasPlaying ? Xa(this.player_.play()) : this.update_();
  }
  /**
   * Move more quickly fast forward for keyboard-only users
   */
  stepForward() {
    this.userSeek_(this.player_.currentTime() + Bc);
  }
  /**
   * Move more quickly rewind for keyboard-only users
   */
  stepBack() {
    this.userSeek_(this.player_.currentTime() - Bc);
  }
  /**
   * Toggles the playback state of the player
   * This gets called when enter or space is used on the seekbar
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called
   *
   */
  handleAction(e) {
    this.player_.paused() ? this.player_.play() : this.player_.pause();
  }
  /**
   * Called when this SeekBar has focus and a key gets pressed down.
   * Supports the following keys:
   *
   *   Space or Enter key fire a click event
   *   Home key moves to start of the timeline
   *   End key moves to end of the timeline
   *   Digit "0" through "9" keys move to 0%, 10% ... 80%, 90% of the timeline
   *   PageDown key moves back a larger step than ArrowDown
   *   PageUp key moves forward a large step
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */
  handleKeyDown(e) {
    const n = this.player_.liveTracker;
    if (e.key === " " || e.key === "Enter")
      e.preventDefault(), e.stopPropagation(), this.handleAction(e);
    else if (e.key === "Home")
      e.preventDefault(), e.stopPropagation(), this.userSeek_(0);
    else if (e.key === "End")
      e.preventDefault(), e.stopPropagation(), n && n.isLive() ? this.userSeek_(n.liveCurrentTime()) : this.userSeek_(this.player_.duration());
    else if (/^[0-9]$/.test(e.key)) {
      e.preventDefault(), e.stopPropagation();
      const a = parseInt(e.key, 10) * 0.1;
      n && n.isLive() ? this.userSeek_(n.seekableStart() + n.liveWindow() * a) : this.userSeek_(this.player_.duration() * a);
    } else e.key === "PageDown" ? (e.preventDefault(), e.stopPropagation(), this.userSeek_(this.player_.currentTime() - Bc * pb)) : e.key === "PageUp" ? (e.preventDefault(), e.stopPropagation(), this.userSeek_(this.player_.currentTime() + Bc * pb)) : super.handleKeyDown(e);
  }
  dispose() {
    this.disableInterval_(), this.off(this.player_, ["durationchange", "timeupdate"], this.update), this.off(this.player_, ["ended"], this.update_), this.player_.liveTracker && this.off(this.player_.liveTracker, "liveedgechange", this.update), this.off(this.player_, ["playing"], this.enableIntervalHandler_), this.off(this.player_, ["ended", "pause", "waiting"], this.disableIntervalHandler_), "hidden" in Me && "visibilityState" in Me && this.off(Me, "visibilitychange", this.toggleVisibility_), super.dispose();
  }
}
Ld.prototype.options_ = {
  children: ["loadProgressBar", "playProgressBar"],
  barName: "playProgressBar"
};
ye.registerComponent("SeekBar", Ld);
class Y3 extends ye {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, n) {
    super(e, n), this.handleMouseMove = ii(Et(this, this.handleMouseMove), wa), this.throttledHandleMouseSeek = ii(Et(this, this.handleMouseSeek), wa), this.handleMouseUpHandler_ = (a) => this.handleMouseUp(a), this.handleMouseDownHandler_ = (a) => this.handleMouseDown(a), this.enable();
  }
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    return super.createEl("div", {
      className: "vjs-progress-control vjs-control"
    });
  }
  /**
   * When the mouse moves over the `ProgressControl`, the pointer position
   * gets passed down to the `MouseTimeDisplay` component.
   *
   * @param {Event} event
   *        The `mousemove` event that caused this function to run.
   *
   * @listen mousemove
   */
  handleMouseMove(e) {
    const n = this.getChild("seekBar");
    if (!n)
      return;
    const a = n.getChild("playProgressBar"), i = n.getChild("mouseTimeDisplay");
    if (!a && !i)
      return;
    const r = n.el(), s = Dl(r);
    let o = xd(r, e).x;
    o = Gl(o, 0, 1), i && i.update(s, o), a && a.update(s, n.getProgress());
  }
  /**
   * A throttled version of the {@link ProgressControl#handleMouseSeek} listener.
   *
   * @method ProgressControl#throttledHandleMouseSeek
   * @param {Event} event
   *        The `mousemove` event that caused this function to run.
   *
   * @listen mousemove
   * @listen touchmove
   */
  /**
   * Handle `mousemove` or `touchmove` events on the `ProgressControl`.
   *
   * @param {Event} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousemove
   * @listens touchmove
   */
  handleMouseSeek(e) {
    const n = this.getChild("seekBar");
    n && n.handleMouseMove(e);
  }
  /**
   * Are controls are currently enabled for this progress control.
   *
   * @return {boolean}
   *         true if controls are enabled, false otherwise
   */
  enabled() {
    return this.enabled_;
  }
  /**
   * Disable all controls on the progress control and its children
   */
  disable() {
    if (this.children().forEach((e) => e.disable && e.disable()), !!this.enabled() && (this.off(["mousedown", "touchstart"], this.handleMouseDownHandler_), this.off(this.el_, ["mousemove", "touchmove"], this.handleMouseMove), this.removeListenersAddedOnMousedownAndTouchstart(), this.addClass("disabled"), this.enabled_ = !1, this.player_.scrubbing())) {
      const e = this.getChild("seekBar");
      this.player_.scrubbing(!1), e.videoWasPlaying && Xa(this.player_.play());
    }
  }
  /**
   * Enable all controls on the progress control and its children
   */
  enable() {
    this.children().forEach((e) => e.enable && e.enable()), !this.enabled() && (this.on(["mousedown", "touchstart"], this.handleMouseDownHandler_), this.on(this.el_, ["mousemove", "touchmove"], this.handleMouseMove), this.removeClass("disabled"), this.enabled_ = !0);
  }
  /**
   * Cleanup listeners after the user finishes interacting with the progress controls
   */
  removeListenersAddedOnMousedownAndTouchstart() {
    const e = this.el_.ownerDocument;
    this.off(e, "mousemove", this.throttledHandleMouseSeek), this.off(e, "touchmove", this.throttledHandleMouseSeek), this.off(e, "mouseup", this.handleMouseUpHandler_), this.off(e, "touchend", this.handleMouseUpHandler_);
  }
  /**
   * Handle `mousedown` or `touchstart` events on the `ProgressControl`.
   *
   * @param {Event} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousedown
   * @listens touchstart
   */
  handleMouseDown(e) {
    const n = this.el_.ownerDocument, a = this.getChild("seekBar");
    a && a.handleMouseDown(e), this.on(n, "mousemove", this.throttledHandleMouseSeek), this.on(n, "touchmove", this.throttledHandleMouseSeek), this.on(n, "mouseup", this.handleMouseUpHandler_), this.on(n, "touchend", this.handleMouseUpHandler_);
  }
  /**
   * Handle `mouseup` or `touchend` events on the `ProgressControl`.
   *
   * @param {Event} event
   *        `mouseup` or `touchend` event that triggered this function.
   *
   * @listens touchend
   * @listens mouseup
   */
  handleMouseUp(e) {
    const n = this.getChild("seekBar");
    n && n.handleMouseUp(e), this.removeListenersAddedOnMousedownAndTouchstart();
  }
}
Y3.prototype.options_ = {
  children: ["seekBar"]
};
ye.registerComponent("ProgressControl", Y3);
class j3 extends Dn {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @listens Player#enterpictureinpicture
   * @listens Player#leavepictureinpicture
   */
  constructor(e, n) {
    super(e, n), this.setIcon("picture-in-picture-enter"), this.on(e, ["enterpictureinpicture", "leavepictureinpicture"], (a) => this.handlePictureInPictureChange(a)), this.on(e, ["disablepictureinpicturechanged", "loadedmetadata"], (a) => this.handlePictureInPictureEnabledChange(a)), this.on(e, ["loadedmetadata", "audioonlymodechange", "audiopostermodechange"], () => this.handlePictureInPictureAudioModeChange()), this.disable();
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-picture-in-picture-control vjs-hidden ${super.buildCSSClass()}`;
  }
  /**
   * Displays or hides the button depending on the audio mode detection.
   * Exits picture-in-picture if it is enabled when switching to audio mode.
   */
  handlePictureInPictureAudioModeChange() {
    if (!(this.player_.currentType().substring(0, 5) === "audio" || this.player_.audioPosterMode() || this.player_.audioOnlyMode())) {
      this.show();
      return;
    }
    this.player_.isInPictureInPicture() && this.player_.exitPictureInPicture(), this.hide();
  }
  /**
   * Enables or disables button based on availability of a Picture-In-Picture mode.
   *
   * Enabled if
   * - `player.options().enableDocumentPictureInPicture` is true and
   *   window.documentPictureInPicture is available; or
   * - `player.disablePictureInPicture()` is false and
   *   element.requestPictureInPicture is available
   */
  handlePictureInPictureEnabledChange() {
    Me.pictureInPictureEnabled && this.player_.disablePictureInPicture() === !1 || this.player_.options_.enableDocumentPictureInPicture && "documentPictureInPicture" in j ? this.enable() : this.disable();
  }
  /**
   * Handles enterpictureinpicture and leavepictureinpicture on the player and change control text accordingly.
   *
   * @param {Event} [event]
   *        The {@link Player#enterpictureinpicture} or {@link Player#leavepictureinpicture} event that caused this function to be
   *        called.
   *
   * @listens Player#enterpictureinpicture
   * @listens Player#leavepictureinpicture
   */
  handlePictureInPictureChange(e) {
    this.player_.isInPictureInPicture() ? (this.setIcon("picture-in-picture-exit"), this.controlText("Exit Picture-in-Picture")) : (this.setIcon("picture-in-picture-enter"), this.controlText("Picture-in-Picture")), this.handlePictureInPictureEnabledChange();
  }
  /**
   * This gets called when an `PictureInPictureToggle` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick(e) {
    this.player_.isInPictureInPicture() ? this.player_.exitPictureInPicture() : this.player_.requestPictureInPicture();
  }
  /**
   * Show the `Component`s element if it is hidden by removing the
   * 'vjs-hidden' class name from it only in browsers that support the Picture-in-Picture API.
   */
  show() {
    typeof Me.exitPictureInPicture == "function" && super.show();
  }
}
j3.prototype.controlText_ = "Picture-in-Picture";
ye.registerComponent("PictureInPictureToggle", j3);
class V3 extends Dn {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, n) {
    super(e, n), this.setIcon("fullscreen-enter"), this.on(e, "fullscreenchange", (a) => this.handleFullscreenChange(a)), Me[e.fsApi_.fullscreenEnabled] === !1 && this.disable();
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-fullscreen-control ${super.buildCSSClass()}`;
  }
  /**
   * Handles fullscreenchange on the player and change control text accordingly.
   *
   * @param {Event} [event]
   *        The {@link Player#fullscreenchange} event that caused this function to be
   *        called.
   *
   * @listens Player#fullscreenchange
   */
  handleFullscreenChange(e) {
    this.player_.isFullscreen() ? (this.controlText("Exit Fullscreen"), this.setIcon("fullscreen-exit")) : (this.controlText("Fullscreen"), this.setIcon("fullscreen-enter"));
  }
  /**
   * This gets called when an `FullscreenToggle` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick(e) {
    this.player_.isFullscreen() ? this.player_.exitFullscreen() : this.player_.requestFullscreen();
  }
}
V3.prototype.controlText_ = "Fullscreen";
ye.registerComponent("FullscreenToggle", V3);
const Mne = function(t, e) {
  e.tech_ && !e.tech_.featuresVolumeControl && t.addClass("vjs-hidden"), t.on(e, "loadstart", function() {
    e.tech_.featuresVolumeControl ? t.removeClass("vjs-hidden") : t.addClass("vjs-hidden");
  });
};
class One extends ye {
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    const e = super.createEl("div", {
      className: "vjs-volume-level"
    });
    return this.setIcon("circle", e), e.appendChild(super.createEl("span", {
      className: "vjs-control-text"
    })), e;
  }
}
ye.registerComponent("VolumeLevel", One);
class Pne extends ye {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The {@link Player} that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, n) {
    super(e, n), this.update = ii(Et(this, this.update), wa);
  }
  /**
   * Create the volume tooltip DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    return super.createEl("div", {
      className: "vjs-volume-tooltip"
    }, {
      "aria-hidden": "true"
    });
  }
  /**
   * Updates the position of the tooltip relative to the `VolumeBar` and
   * its content text.
   *
   * @param {Object} rangeBarRect
   *        The `ClientRect` for the {@link VolumeBar} element.
   *
   * @param {number} rangeBarPoint
   *        A number from 0 to 1, representing a horizontal/vertical reference point
   *        from the left edge of the {@link VolumeBar}
   *
   * @param {boolean} vertical
   *        Referees to the Volume control position
   *        in the control bar{@link VolumeControl}
   *
   */
  update(e, n, a, i) {
    if (!a) {
      const r = qs(this.el_), s = qs(this.player_.el()), o = e.width * n;
      if (!s || !r)
        return;
      const l = e.left - s.left + o, c = e.width - o + (s.right - e.right);
      let u = r.width / 2;
      l < u ? u += u - l : c < u && (u = c), u < 0 ? u = 0 : u > r.width && (u = r.width), this.el_.style.right = `-${u}px`;
    }
    this.write(`${i}%`);
  }
  /**
   * Write the volume to the tooltip DOM element.
   *
   * @param {string} content
   *        The formatted volume for the tooltip.
   */
  write(e) {
    ur(this.el_, e);
  }
  /**
   * Updates the position of the volume tooltip relative to the `VolumeBar`.
   *
   * @param {Object} rangeBarRect
   *        The `ClientRect` for the {@link VolumeBar} element.
   *
   * @param {number} rangeBarPoint
   *        A number from 0 to 1, representing a horizontal/vertical reference point
   *        from the left edge of the {@link VolumeBar}
   *
   * @param {boolean} vertical
   *        Referees to the Volume control position
   *        in the control bar{@link VolumeControl}
   *
   * @param {number} volume
   *        The volume level to update the tooltip to
   *
   * @param {Function} cb
   *        A function that will be called during the request animation frame
   *        for tooltips that need to do additional animations from the default
   */
  updateVolume(e, n, a, i, r) {
    this.requestNamedAnimationFrame("VolumeLevelTooltip#updateVolume", () => {
      this.update(e, n, a, i.toFixed(0)), r && r();
    });
  }
}
ye.registerComponent("VolumeLevelTooltip", Pne);
class q3 extends ye {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The {@link Player} that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, n) {
    super(e, n), this.update = ii(Et(this, this.update), wa);
  }
  /**
   * Create the DOM element for this class.
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    return super.createEl("div", {
      className: "vjs-mouse-display"
    });
  }
  /**
   * Enquires updates to its own DOM as well as the DOM of its
   * {@link VolumeLevelTooltip} child.
   *
   * @param {Object} rangeBarRect
   *        The `ClientRect` for the {@link VolumeBar} element.
   *
   * @param {number} rangeBarPoint
   *        A number from 0 to 1, representing a horizontal/vertical reference point
   *        from the left edge of the {@link VolumeBar}
   *
   * @param {boolean} vertical
   *        Referees to the Volume control position
   *        in the control bar{@link VolumeControl}
   *
   */
  update(e, n, a) {
    const i = 100 * n;
    this.getChild("volumeLevelTooltip").updateVolume(e, n, a, i, () => {
      a ? this.el_.style.bottom = `${e.height * n}px` : this.el_.style.left = `${e.width * n}px`;
    });
  }
}
q3.prototype.options_ = {
  children: ["volumeLevelTooltip"]
};
ye.registerComponent("MouseVolumeLevelDisplay", q3);
class Dd extends vp {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, n) {
    super(e, n), this.on("slideractive", (a) => this.updateLastVolume_(a)), this.on(e, "volumechange", (a) => this.updateARIAAttributes(a)), e.ready(() => this.updateARIAAttributes());
  }
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    return super.createEl("div", {
      className: "vjs-volume-bar vjs-slider-bar"
    }, {
      "aria-label": this.localize("Volume Level"),
      "aria-live": "polite"
    });
  }
  /**
   * Handle mouse down on volume bar
   *
   * @param {Event} event
   *        The `mousedown` event that caused this to run.
   *
   * @listens mousedown
   */
  handleMouseDown(e) {
    Il(e) && super.handleMouseDown(e);
  }
  /**
   * Handle movement events on the {@link VolumeMenuButton}.
   *
   * @param {Event} event
   *        The event that caused this function to run.
   *
   * @listens mousemove
   */
  handleMouseMove(e) {
    const n = this.getChild("mouseVolumeLevelDisplay");
    if (n) {
      const a = this.el(), i = qs(a), r = this.vertical();
      let s = xd(a, e);
      s = r ? s.y : s.x, s = Gl(s, 0, 1), n.update(i, s, r);
    }
    Il(e) && (this.checkMuted(), this.player_.volume(this.calculateDistance(e)));
  }
  /**
   * If the player is muted unmute it.
   */
  checkMuted() {
    this.player_.muted() && this.player_.muted(!1);
  }
  /**
   * Get percent of volume level
   *
   * @return {number}
   *         Volume level percent as a decimal number.
   */
  getPercent() {
    return this.player_.muted() ? 0 : this.player_.volume();
  }
  /**
   * Increase volume level for keyboard users
   */
  stepForward() {
    this.checkMuted(), this.player_.volume(this.player_.volume() + 0.1);
  }
  /**
   * Decrease volume level for keyboard users
   */
  stepBack() {
    this.checkMuted(), this.player_.volume(this.player_.volume() - 0.1);
  }
  /**
   * Update ARIA accessibility attributes
   *
   * @param {Event} [event]
   *        The `volumechange` event that caused this function to run.
   *
   * @listens Player#volumechange
   */
  updateARIAAttributes(e) {
    const n = this.player_.muted() ? 0 : this.volumeAsPercentage_();
    this.el_.setAttribute("aria-valuenow", n), this.el_.setAttribute("aria-valuetext", n + "%");
  }
  /**
   * Returns the current value of the player volume as a percentage
   *
   * @private
   */
  volumeAsPercentage_() {
    return Math.round(this.player_.volume() * 100);
  }
  /**
   * When user starts dragging the VolumeBar, store the volume and listen for
   * the end of the drag. When the drag ends, if the volume was set to zero,
   * set lastVolume to the stored volume.
   *
   * @listens slideractive
   * @private
   */
  updateLastVolume_() {
    const e = this.player_.volume();
    this.one("sliderinactive", () => {
      this.player_.volume() === 0 && this.player_.lastVolume_(e);
    });
  }
}
Dd.prototype.options_ = {
  children: ["volumeLevel"],
  barName: "volumeLevel"
};
!En && !$a && Dd.prototype.options_.children.splice(0, 0, "mouseVolumeLevelDisplay");
Dd.prototype.playerEvent = "volumechange";
ye.registerComponent("VolumeBar", Dd);
class W3 extends ye {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */
  constructor(e, n = {}) {
    n.vertical = n.vertical || !1, (typeof n.volumeBar > "u" || js(n.volumeBar)) && (n.volumeBar = n.volumeBar || {}, n.volumeBar.vertical = n.vertical), super(e, n), Mne(this, e), this.throttledHandleMouseMove = ii(Et(this, this.handleMouseMove), wa), this.handleMouseUpHandler_ = (a) => this.handleMouseUp(a), this.on("mousedown", (a) => this.handleMouseDown(a)), this.on("touchstart", (a) => this.handleMouseDown(a)), this.on("mousemove", (a) => this.handleMouseMove(a)), this.on(this.volumeBar, ["focus", "slideractive"], () => {
      this.volumeBar.addClass("vjs-slider-active"), this.addClass("vjs-slider-active"), this.trigger("slideractive");
    }), this.on(this.volumeBar, ["blur", "sliderinactive"], () => {
      this.volumeBar.removeClass("vjs-slider-active"), this.removeClass("vjs-slider-active"), this.trigger("sliderinactive");
    });
  }
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    let e = "vjs-volume-horizontal";
    return this.options_.vertical && (e = "vjs-volume-vertical"), super.createEl("div", {
      className: `vjs-volume-control vjs-control ${e}`
    });
  }
  /**
   * Handle `mousedown` or `touchstart` events on the `VolumeControl`.
   *
   * @param {Event} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousedown
   * @listens touchstart
   */
  handleMouseDown(e) {
    const n = this.el_.ownerDocument;
    this.on(n, "mousemove", this.throttledHandleMouseMove), this.on(n, "touchmove", this.throttledHandleMouseMove), this.on(n, "mouseup", this.handleMouseUpHandler_), this.on(n, "touchend", this.handleMouseUpHandler_);
  }
  /**
   * Handle `mouseup` or `touchend` events on the `VolumeControl`.
   *
   * @param {Event} event
   *        `mouseup` or `touchend` event that triggered this function.
   *
   * @listens touchend
   * @listens mouseup
   */
  handleMouseUp(e) {
    const n = this.el_.ownerDocument;
    this.off(n, "mousemove", this.throttledHandleMouseMove), this.off(n, "touchmove", this.throttledHandleMouseMove), this.off(n, "mouseup", this.handleMouseUpHandler_), this.off(n, "touchend", this.handleMouseUpHandler_);
  }
  /**
   * Handle `mousedown` or `touchstart` events on the `VolumeControl`.
   *
   * @param {Event} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousedown
   * @listens touchstart
   */
  handleMouseMove(e) {
    this.volumeBar.handleMouseMove(e);
  }
}
W3.prototype.options_ = {
  children: ["volumeBar"]
};
ye.registerComponent("VolumeControl", W3);
const Bne = function(t, e) {
  e.tech_ && !e.tech_.featuresMuteControl && t.addClass("vjs-hidden"), t.on(e, "loadstart", function() {
    e.tech_.featuresMuteControl ? t.removeClass("vjs-hidden") : t.addClass("vjs-hidden");
  });
};
class G3 extends Dn {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, n) {
    super(e, n), Bne(this, e), this.on(e, ["loadstart", "volumechange"], (a) => this.update(a));
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-mute-control ${super.buildCSSClass()}`;
  }
  /**
   * This gets called when an `MuteToggle` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick(e) {
    const n = this.player_.volume(), a = this.player_.lastVolume_();
    if (n === 0) {
      const i = a < 0.1 ? 0.1 : a;
      this.player_.volume(i), this.player_.muted(!1);
    } else
      this.player_.muted(!this.player_.muted());
  }
  /**
   * Update the `MuteToggle` button based on the state of `volume` and `muted`
   * on the player.
   *
   * @param {Event} [event]
   *        The {@link Player#loadstart} event if this function was called
   *        through an event.
   *
   * @listens Player#loadstart
   * @listens Player#volumechange
   */
  update(e) {
    this.updateIcon_(), this.updateControlText_();
  }
  /**
   * Update the appearance of the `MuteToggle` icon.
   *
   * Possible states (given `level` variable below):
   * - 0: crossed out
   * - 1: zero bars of volume
   * - 2: one bar of volume
   * - 3: two bars of volume
   *
   * @private
   */
  updateIcon_() {
    const e = this.player_.volume();
    let n = 3;
    this.setIcon("volume-high"), En && this.player_.tech_ && this.player_.tech_.el_ && this.player_.muted(this.player_.tech_.el_.muted), e === 0 || this.player_.muted() ? (this.setIcon("volume-mute"), n = 0) : e < 0.33 ? (this.setIcon("volume-low"), n = 1) : e < 0.67 && (this.setIcon("volume-medium"), n = 2), _d(this.el_, [0, 1, 2, 3].reduce((a, i) => a + `${i ? " " : ""}vjs-vol-${i}`, "")), Dr(this.el_, `vjs-vol-${n}`);
  }
  /**
   * If `muted` has changed on the player, update the control text
   * (`title` attribute on `vjs-mute-control` element and content of
   * `vjs-control-text` element).
   *
   * @private
   */
  updateControlText_() {
    const n = this.player_.muted() || this.player_.volume() === 0 ? "Unmute" : "Mute";
    this.controlText() !== n && this.controlText(n);
  }
}
G3.prototype.controlText_ = "Mute";
ye.registerComponent("MuteToggle", G3);
class X3 extends ye {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */
  constructor(e, n = {}) {
    typeof n.inline < "u" ? n.inline = n.inline : n.inline = !0, (typeof n.volumeControl > "u" || js(n.volumeControl)) && (n.volumeControl = n.volumeControl || {}, n.volumeControl.vertical = !n.inline), super(e, n), this.handleKeyPressHandler_ = (a) => this.handleKeyPress(a), this.on(e, ["loadstart"], (a) => this.volumePanelState_(a)), this.on(this.muteToggle, "keyup", (a) => this.handleKeyPress(a)), this.on(this.volumeControl, "keyup", (a) => this.handleVolumeControlKeyUp(a)), this.on("keydown", (a) => this.handleKeyPress(a)), this.on("mouseover", (a) => this.handleMouseOver(a)), this.on("mouseout", (a) => this.handleMouseOut(a)), this.on(this.volumeControl, ["slideractive"], this.sliderActive_), this.on(this.volumeControl, ["sliderinactive"], this.sliderInactive_);
  }
  /**
   * Add vjs-slider-active class to the VolumePanel
   *
   * @listens VolumeControl#slideractive
   * @private
   */
  sliderActive_() {
    this.addClass("vjs-slider-active");
  }
  /**
   * Removes vjs-slider-active class to the VolumePanel
   *
   * @listens VolumeControl#sliderinactive
   * @private
   */
  sliderInactive_() {
    this.removeClass("vjs-slider-active");
  }
  /**
   * Adds vjs-hidden or vjs-mute-toggle-only to the VolumePanel
   * depending on MuteToggle and VolumeControl state
   *
   * @listens Player#loadstart
   * @private
   */
  volumePanelState_() {
    this.volumeControl.hasClass("vjs-hidden") && this.muteToggle.hasClass("vjs-hidden") && this.addClass("vjs-hidden"), this.volumeControl.hasClass("vjs-hidden") && !this.muteToggle.hasClass("vjs-hidden") && this.addClass("vjs-mute-toggle-only");
  }
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    let e = "vjs-volume-panel-horizontal";
    return this.options_.inline || (e = "vjs-volume-panel-vertical"), super.createEl("div", {
      className: `vjs-volume-panel vjs-control ${e}`
    });
  }
  /**
   * Dispose of the `volume-panel` and all child components.
   */
  dispose() {
    this.handleMouseOut(), super.dispose();
  }
  /**
   * Handles `keyup` events on the `VolumeControl`, looking for ESC, which closes
   * the volume panel and sets focus on `MuteToggle`.
   *
   * @param {Event} event
   *        The `keyup` event that caused this function to be called.
   *
   * @listens keyup
   */
  handleVolumeControlKeyUp(e) {
    e.key === "Escape" && this.muteToggle.focus();
  }
  /**
   * This gets called when a `VolumePanel` gains hover via a `mouseover` event.
   * Turns on listening for `mouseover` event. When they happen it
   * calls `this.handleMouseOver`.
   *
   * @param {Event} event
   *        The `mouseover` event that caused this function to be called.
   *
   * @listens mouseover
   */
  handleMouseOver(e) {
    this.addClass("vjs-hover"), ha(Me, "keyup", this.handleKeyPressHandler_);
  }
  /**
   * This gets called when a `VolumePanel` gains hover via a `mouseout` event.
   * Turns on listening for `mouseout` event. When they happen it
   * calls `this.handleMouseOut`.
   *
   * @param {Event} event
   *        The `mouseout` event that caused this function to be called.
   *
   * @listens mouseout
   */
  handleMouseOut(e) {
    this.removeClass("vjs-hover"), Ln(Me, "keyup", this.handleKeyPressHandler_);
  }
  /**
   * Handles `keyup` event on the document or `keydown` event on the `VolumePanel`,
   * looking for ESC, which hides the `VolumeControl`.
   *
   * @param {Event} event
   *        The keypress that triggered this event.
   *
   * @listens keydown | keyup
   */
  handleKeyPress(e) {
    e.key === "Escape" && this.handleMouseOut();
  }
}
X3.prototype.options_ = {
  children: ["muteToggle", "volumeControl"]
};
ye.registerComponent("VolumePanel", X3);
class Z3 extends Dn {
  constructor(e, n) {
    super(e, n), this.validOptions = [5, 10, 30], this.skipTime = this.getSkipForwardTime(), this.skipTime && this.validOptions.includes(this.skipTime) ? (this.setIcon(`forward-${this.skipTime}`), this.controlText(this.localize("Skip forward {1} seconds", [this.skipTime.toLocaleString(e.language())])), this.show()) : this.hide();
  }
  getSkipForwardTime() {
    const e = this.options_.playerOptions;
    return e.controlBar && e.controlBar.skipButtons && e.controlBar.skipButtons.forward;
  }
  buildCSSClass() {
    return `vjs-skip-forward-${this.getSkipForwardTime()} ${super.buildCSSClass()}`;
  }
  /**
   * On click, skips forward in the duration/seekable range by a configurable amount of seconds.
   * If the time left in the duration/seekable range is less than the configured 'skip forward' time,
   * skips to end of duration/seekable range.
   *
   * Handle a click on a `SkipForward` button
   *
   * @param {EventTarget~Event} event
   *        The `click` event that caused this function
   *        to be called
   */
  handleClick(e) {
    if (isNaN(this.player_.duration()))
      return;
    const n = this.player_.currentTime(), a = this.player_.liveTracker, i = a && a.isLive() ? a.seekableEnd() : this.player_.duration();
    let r;
    n + this.skipTime <= i ? r = n + this.skipTime : r = i, this.player_.currentTime(r);
  }
  /**
   * Update control text on languagechange
   */
  handleLanguagechange() {
    this.controlText(this.localize("Skip forward {1} seconds", [this.skipTime]));
  }
}
Z3.prototype.controlText_ = "Skip Forward";
ye.registerComponent("SkipForward", Z3);
class K3 extends Dn {
  constructor(e, n) {
    super(e, n), this.validOptions = [5, 10, 30], this.skipTime = this.getSkipBackwardTime(), this.skipTime && this.validOptions.includes(this.skipTime) ? (this.setIcon(`replay-${this.skipTime}`), this.controlText(this.localize("Skip backward {1} seconds", [this.skipTime.toLocaleString(e.language())])), this.show()) : this.hide();
  }
  getSkipBackwardTime() {
    const e = this.options_.playerOptions;
    return e.controlBar && e.controlBar.skipButtons && e.controlBar.skipButtons.backward;
  }
  buildCSSClass() {
    return `vjs-skip-backward-${this.getSkipBackwardTime()} ${super.buildCSSClass()}`;
  }
  /**
   * On click, skips backward in the video by a configurable amount of seconds.
   * If the current time in the video is less than the configured 'skip backward' time,
   * skips to beginning of video or seekable range.
   *
   * Handle a click on a `SkipBackward` button
   *
   * @param {EventTarget~Event} event
   *        The `click` event that caused this function
   *        to be called
   */
  handleClick(e) {
    const n = this.player_.currentTime(), a = this.player_.liveTracker, i = a && a.isLive() && a.seekableStart();
    let r;
    i && n - this.skipTime <= i ? r = i : n >= this.skipTime ? r = n - this.skipTime : r = 0, this.player_.currentTime(r);
  }
  /**
   * Update control text on languagechange
   */
  handleLanguagechange() {
    this.controlText(this.localize("Skip backward {1} seconds", [this.skipTime]));
  }
}
K3.prototype.controlText_ = "Skip Backward";
ye.registerComponent("SkipBackward", K3);
class Q3 extends ye {
  /**
   * Create an instance of this class.
   *
   * @param {Player} player
   *        the player that this component should attach to
   *
   * @param {Object} [options]
   *        Object of option names and values
   *
   */
  constructor(e, n) {
    super(e, n), n && (this.menuButton_ = n.menuButton), this.focusedChild_ = -1, this.on("keydown", (a) => this.handleKeyDown(a)), this.boundHandleBlur_ = (a) => this.handleBlur(a), this.boundHandleTapClick_ = (a) => this.handleTapClick(a);
  }
  /**
   * Add event listeners to the {@link MenuItem}.
   *
   * @param {Object} component
   *        The instance of the `MenuItem` to add listeners to.
   *
   */
  addEventListenerForItem(e) {
    e instanceof ye && (this.on(e, "blur", this.boundHandleBlur_), this.on(e, ["tap", "click"], this.boundHandleTapClick_));
  }
  /**
   * Remove event listeners from the {@link MenuItem}.
   *
   * @param {Object} component
   *        The instance of the `MenuItem` to remove listeners.
   *
   */
  removeEventListenerForItem(e) {
    e instanceof ye && (this.off(e, "blur", this.boundHandleBlur_), this.off(e, ["tap", "click"], this.boundHandleTapClick_));
  }
  /**
   * This method will be called indirectly when the component has been added
   * before the component adds to the new menu instance by `addItem`.
   * In this case, the original menu instance will remove the component
   * by calling `removeChild`.
   *
   * @param {Object} component
   *        The instance of the `MenuItem`
   */
  removeChild(e) {
    typeof e == "string" && (e = this.getChild(e)), this.removeEventListenerForItem(e), super.removeChild(e);
  }
  /**
   * Add a {@link MenuItem} to the menu.
   *
   * @param {Object|string} component
   *        The name or instance of the `MenuItem` to add.
   *
   */
  addItem(e) {
    const n = this.addChild(e);
    n && this.addEventListenerForItem(n);
  }
  /**
   * Create the `Menu`s DOM element.
   *
   * @return {Element}
   *         the element that was created
   */
  createEl() {
    const e = this.options_.contentElType || "ul";
    this.contentEl_ = et(e, {
      className: "vjs-menu-content"
    }), this.contentEl_.setAttribute("role", "menu");
    const n = super.createEl("div", {
      append: this.contentEl_,
      className: "vjs-menu"
    });
    return n.appendChild(this.contentEl_), ha(n, "click", function(a) {
      a.preventDefault(), a.stopImmediatePropagation();
    }), n;
  }
  dispose() {
    this.contentEl_ = null, this.boundHandleBlur_ = null, this.boundHandleTapClick_ = null, super.dispose();
  }
  /**
   * Called when a `MenuItem` loses focus.
   *
   * @param {Event} event
   *        The `blur` event that caused this function to be called.
   *
   * @listens blur
   */
  handleBlur(e) {
    const n = e.relatedTarget || Me.activeElement;
    if (!this.children().some((a) => a.el() === n)) {
      const a = this.menuButton_;
      a && a.buttonPressed_ && n !== a.el().firstChild && a.unpressButton();
    }
  }
  /**
   * Called when a `MenuItem` gets clicked or tapped.
   *
   * @param {Event} event
   *        The `click` or `tap` event that caused this function to be called.
   *
   * @listens click,tap
   */
  handleTapClick(e) {
    if (this.menuButton_) {
      this.menuButton_.unpressButton();
      const n = this.children();
      if (!Array.isArray(n))
        return;
      const a = n.filter((i) => i.el() === e.target)[0];
      if (!a)
        return;
      a.name() !== "CaptionSettingsMenuItem" && this.menuButton_.focus();
    }
  }
  /**
   * Handle a `keydown` event on this menu. This listener is added in the constructor.
   *
   * @param {KeyboardEvent} event
   *        A `keydown` event that happened on the menu.
   *
   * @listens keydown
   */
  handleKeyDown(e) {
    e.key === "ArrowLeft" || e.key === "ArrowDown" ? (e.preventDefault(), e.stopPropagation(), this.stepForward()) : (e.key === "ArrowRight" || e.key === "ArrowUp") && (e.preventDefault(), e.stopPropagation(), this.stepBack());
  }
  /**
   * Move to next (lower) menu item for keyboard users.
   */
  stepForward() {
    let e = 0;
    this.focusedChild_ !== void 0 && (e = this.focusedChild_ + 1), this.focus(e);
  }
  /**
   * Move to previous (higher) menu item for keyboard users.
   */
  stepBack() {
    let e = 0;
    this.focusedChild_ !== void 0 && (e = this.focusedChild_ - 1), this.focus(e);
  }
  /**
   * Set focus on a {@link MenuItem} in the `Menu`.
   *
   * @param {Object|string} [item=0]
   *        Index of child item set focus on.
   */
  focus(e = 0) {
    const n = this.children().slice();
    n.length && n[0].hasClass("vjs-menu-title") && n.shift(), n.length > 0 && (e < 0 ? e = 0 : e >= n.length && (e = n.length - 1), this.focusedChild_ = e, n[e].el_.focus());
  }
}
ye.registerComponent("Menu", Q3);
class _p extends ye {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */
  constructor(e, n = {}) {
    super(e, n), this.menuButton_ = new Dn(e, n), this.menuButton_.controlText(this.controlText_), this.menuButton_.el_.setAttribute("aria-haspopup", "true");
    const a = Dn.prototype.buildCSSClass();
    this.menuButton_.el_.className = this.buildCSSClass() + " " + a, this.menuButton_.removeClass("vjs-control"), this.addChild(this.menuButton_), this.update(), this.enabled_ = !0;
    const i = (r) => this.handleClick(r);
    this.handleMenuKeyUp_ = (r) => this.handleMenuKeyUp(r), this.on(this.menuButton_, "tap", i), this.on(this.menuButton_, "click", i), this.on(this.menuButton_, "keydown", (r) => this.handleKeyDown(r)), this.on(this.menuButton_, "mouseenter", () => {
      this.addClass("vjs-hover"), this.menu.show(), ha(Me, "keyup", this.handleMenuKeyUp_);
    }), this.on("mouseleave", (r) => this.handleMouseLeave(r)), this.on("keydown", (r) => this.handleSubmenuKeyDown(r));
  }
  /**
   * Update the menu based on the current state of its items.
   */
  update() {
    const e = this.createMenu();
    this.menu && (this.menu.dispose(), this.removeChild(this.menu)), this.menu = e, this.addChild(e), this.buttonPressed_ = !1, this.menuButton_.el_.setAttribute("aria-expanded", "false"), this.items && this.items.length <= this.hideThreshold_ ? (this.hide(), this.menu.contentEl_.removeAttribute("role")) : (this.show(), this.menu.contentEl_.setAttribute("role", "menu"));
  }
  /**
   * Create the menu and add all items to it.
   *
   * @return {Menu}
   *         The constructed menu
   */
  createMenu() {
    const e = new Q3(this.player_, {
      menuButton: this
    });
    if (this.hideThreshold_ = 0, this.options_.title) {
      const n = et("li", {
        className: "vjs-menu-title",
        textContent: qt(this.options_.title),
        tabIndex: -1
      }), a = new ye(this.player_, {
        el: n
      });
      e.addItem(a);
    }
    if (this.items = this.createItems(), this.items)
      for (let n = 0; n < this.items.length; n++)
        e.addItem(this.items[n]);
    return e;
  }
  /**
   * Create the list of menu items. Specific to each subclass.
   *
   * @abstract
   */
  createItems() {
  }
  /**
   * Create the `MenuButtons`s DOM element.
   *
   * @return {Element}
   *         The element that gets created.
   */
  createEl() {
    return super.createEl("div", {
      className: this.buildWrapperCSSClass()
    }, {});
  }
  /**
   * Overwrites the `setIcon` method from `Component`.
   * In this case, we want the icon to be appended to the menuButton.
   *
   * @param {string} name
   *         The icon name to be added.
   */
  setIcon(e) {
    super.setIcon(e, this.menuButton_.el_);
  }
  /**
   * Allow sub components to stack CSS class names for the wrapper element
   *
   * @return {string}
   *         The constructed wrapper DOM `className`
   */
  buildWrapperCSSClass() {
    let e = "vjs-menu-button";
    this.options_.inline === !0 ? e += "-inline" : e += "-popup";
    const n = Dn.prototype.buildCSSClass();
    return `vjs-menu-button ${e} ${n} ${super.buildCSSClass()}`;
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    let e = "vjs-menu-button";
    return this.options_.inline === !0 ? e += "-inline" : e += "-popup", `vjs-menu-button ${e} ${super.buildCSSClass()}`;
  }
  /**
   * Get or set the localized control text that will be used for accessibility.
   *
   * > NOTE: This will come from the internal `menuButton_` element.
   *
   * @param {string} [text]
   *        Control text for element.
   *
   * @param {Element} [el=this.menuButton_.el()]
   *        Element to set the title on.
   *
   * @return {string}
   *         - The control text when getting
   */
  controlText(e, n = this.menuButton_.el()) {
    return this.menuButton_.controlText(e, n);
  }
  /**
   * Dispose of the `menu-button` and all child components.
   */
  dispose() {
    this.handleMouseLeave(), super.dispose();
  }
  /**
   * Handle a click on a `MenuButton`.
   * See {@link ClickableComponent#handleClick} for instances where this is called.
   *
   * @param {Event} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick(e) {
    this.buttonPressed_ ? this.unpressButton() : this.pressButton();
  }
  /**
   * Handle `mouseleave` for `MenuButton`.
   *
   * @param {Event} event
   *        The `mouseleave` event that caused this function to be called.
   *
   * @listens mouseleave
   */
  handleMouseLeave(e) {
    this.removeClass("vjs-hover"), Ln(Me, "keyup", this.handleMenuKeyUp_);
  }
  /**
   * Set the focus to the actual button, not to this element
   */
  focus() {
    this.menuButton_.focus();
  }
  /**
   * Remove the focus from the actual button, not this element
   */
  blur() {
    this.menuButton_.blur();
  }
  /**
   * Handle tab, escape, down arrow, and up arrow keys for `MenuButton`. See
   * {@link ClickableComponent#handleKeyDown} for instances where this is called.
   *
   * @param {Event} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */
  handleKeyDown(e) {
    e.key === "Escape" || e.key === "Tab" ? (this.buttonPressed_ && this.unpressButton(), !e.key === "Tab" && (e.preventDefault(), this.menuButton_.focus())) : (e.key === "Up" || e.key === "Down" && !(this.player_.options_.playerOptions.spatialNavigation && this.player_.options_.playerOptions.spatialNavigation.enabled)) && (this.buttonPressed_ || (e.preventDefault(), this.pressButton()));
  }
  /**
   * Handle a `keyup` event on a `MenuButton`. The listener for this is added in
   * the constructor.
   *
   * @param {Event} event
   *        Key press event
   *
   * @listens keyup
   */
  handleMenuKeyUp(e) {
    (e.key === "Escape" || e.key === "Tab") && this.removeClass("vjs-hover");
  }
  /**
   * This method name now delegates to `handleSubmenuKeyDown`. This means
   * anyone calling `handleSubmenuKeyPress` will not see their method calls
   * stop working.
   *
   * @param {Event} event
   *        The event that caused this function to be called.
   */
  handleSubmenuKeyPress(e) {
    this.handleSubmenuKeyDown(e);
  }
  /**
   * Handle a `keydown` event on a sub-menu. The listener for this is added in
   * the constructor.
   *
   * @param {Event} event
   *        Key press event
   *
   * @listens keydown
   */
  handleSubmenuKeyDown(e) {
    (e.key === "Escape" || e.key === "Tab") && (this.buttonPressed_ && this.unpressButton(), !e.key === "Tab" && (e.preventDefault(), this.menuButton_.focus()));
  }
  /**
   * Put the current `MenuButton` into a pressed state.
   */
  pressButton() {
    if (this.enabled_) {
      if (this.buttonPressed_ = !0, this.menu.show(), this.menu.lockShowing(), this.menuButton_.el_.setAttribute("aria-expanded", "true"), En && c3())
        return;
      this.menu.focus();
    }
  }
  /**
   * Take the current `MenuButton` out of a pressed state.
   */
  unpressButton() {
    this.enabled_ && (this.buttonPressed_ = !1, this.menu.unlockShowing(), this.menu.hide(), this.menuButton_.el_.setAttribute("aria-expanded", "false"));
  }
  /**
   * Disable the `MenuButton`. Don't allow it to be clicked.
   */
  disable() {
    this.unpressButton(), this.enabled_ = !1, this.addClass("vjs-disabled"), this.menuButton_.disable();
  }
  /**
   * Enable the `MenuButton`. Allow it to be clicked.
   */
  enable() {
    this.enabled_ = !0, this.removeClass("vjs-disabled"), this.menuButton_.enable();
  }
}
ye.registerComponent("MenuButton", _p);
class Tp extends _p {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, n) {
    const a = n.tracks;
    if (super(e, n), this.items.length <= 1 && this.hide(), !a)
      return;
    const i = Et(this, this.update);
    a.addEventListener("removetrack", i), a.addEventListener("addtrack", i), a.addEventListener("labelchange", i), this.player_.on("ready", i), this.player_.on("dispose", function() {
      a.removeEventListener("removetrack", i), a.removeEventListener("addtrack", i), a.removeEventListener("labelchange", i);
    });
  }
}
ye.registerComponent("TrackButton", Tp);
class Xl extends Ed {
  /**
   * Creates an instance of the this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   *
   */
  constructor(e, n) {
    super(e, n), this.selectable = n.selectable, this.isSelected_ = n.selected || !1, this.multiSelectable = n.multiSelectable, this.selected(this.isSelected_), this.selectable ? this.multiSelectable ? this.el_.setAttribute("role", "menuitemcheckbox") : this.el_.setAttribute("role", "menuitemradio") : this.el_.setAttribute("role", "menuitem");
  }
  /**
   * Create the `MenuItem's DOM element
   *
   * @param {string} [type=li]
   *        Element's node type, not actually used, always set to `li`.
   *
   * @param {Object} [props={}]
   *        An object of properties that should be set on the element
   *
   * @param {Object} [attrs={}]
   *        An object of attributes that should be set on the element
   *
   * @return {Element}
   *         The element that gets created.
   */
  createEl(e, n, a) {
    this.nonIconControl = !0;
    const i = super.createEl("li", Object.assign({
      className: "vjs-menu-item",
      tabIndex: -1
    }, n), a), r = et("span", {
      className: "vjs-menu-item-text",
      textContent: this.localize(this.options_.label)
    });
    return this.player_.options_.experimentalSvgIcons ? i.appendChild(r) : i.replaceChild(r, i.querySelector(".vjs-icon-placeholder")), i;
  }
  /**
   * Ignore keys which are used by the menu, but pass any other ones up. See
   * {@link ClickableComponent#handleKeyDown} for instances where this is called.
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */
  handleKeyDown(e) {
    ["Tab", "Escape", "ArrowUp", "ArrowLeft", "ArrowRight", "ArrowDown"].includes(e.key) || super.handleKeyDown(e);
  }
  /**
   * Any click on a `MenuItem` puts it into the selected state.
   * See {@link ClickableComponent#handleClick} for instances where this is called.
   *
   * @param {Event} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick(e) {
    this.selected(!0);
  }
  /**
   * Set the state for this menu item as selected or not.
   *
   * @param {boolean} selected
   *        if the menu item is selected or not
   */
  selected(e) {
    this.selectable && (e ? (this.addClass("vjs-selected"), this.el_.setAttribute("aria-checked", "true"), this.controlText(", selected"), this.isSelected_ = !0) : (this.removeClass("vjs-selected"), this.el_.setAttribute("aria-checked", "false"), this.controlText(""), this.isSelected_ = !1));
  }
}
ye.registerComponent("MenuItem", Xl);
class Zl extends Xl {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, n) {
    const a = n.track, i = e.textTracks();
    n.label = a.label || a.language || "Unknown", n.selected = a.mode === "showing", super(e, n), this.track = a, this.kinds = (n.kinds || [n.kind || this.track.kind]).filter(Boolean);
    const r = (...o) => {
      this.handleTracksChange.apply(this, o);
    }, s = (...o) => {
      this.handleSelectedLanguageChange.apply(this, o);
    };
    if (e.on(["loadstart", "texttrackchange"], r), i.addEventListener("change", r), i.addEventListener("selectedlanguagechange", s), this.on("dispose", function() {
      e.off(["loadstart", "texttrackchange"], r), i.removeEventListener("change", r), i.removeEventListener("selectedlanguagechange", s);
    }), i.onchange === void 0) {
      let o;
      this.on(["tap", "click"], function() {
        if (typeof j.Event != "object")
          try {
            o = new j.Event("change");
          } catch {
          }
        o || (o = Me.createEvent("Event"), o.initEvent("change", !0, !0)), i.dispatchEvent(o);
      });
    }
    this.handleTracksChange();
  }
  /**
   * This gets called when an `TextTrackMenuItem` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick(e) {
    const n = this.track, a = this.player_.textTracks();
    if (super.handleClick(e), !!a)
      for (let i = 0; i < a.length; i++) {
        const r = a[i];
        this.kinds.indexOf(r.kind) !== -1 && (r === n ? r.mode !== "showing" && (r.mode = "showing") : r.mode !== "disabled" && (r.mode = "disabled"));
      }
  }
  /**
   * Handle text track list change
   *
   * @param {Event} event
   *        The `change` event that caused this function to be called.
   *
   * @listens TextTrackList#change
   */
  handleTracksChange(e) {
    const n = this.track.mode === "showing";
    n !== this.isSelected_ && this.selected(n);
  }
  handleSelectedLanguageChange(e) {
    if (this.track.mode === "showing") {
      const n = this.player_.cache_.selectedLanguage;
      if (n && n.enabled && n.language === this.track.language && n.kind !== this.track.kind)
        return;
      this.player_.cache_.selectedLanguage = {
        enabled: !0,
        language: this.track.language,
        kind: this.track.kind
      };
    }
  }
  dispose() {
    this.track = null, super.dispose();
  }
}
ye.registerComponent("TextTrackMenuItem", Zl);
class J3 extends Zl {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, n) {
    n.track = {
      player: e,
      // it is no longer necessary to store `kind` or `kinds` on the track itself
      // since they are now stored in the `kinds` property of all instances of
      // TextTrackMenuItem, but this will remain for backwards compatibility
      kind: n.kind,
      kinds: n.kinds,
      default: !1,
      mode: "disabled"
    }, n.kinds || (n.kinds = [n.kind]), n.label ? n.track.label = n.label : n.track.label = n.kinds.join(" and ") + " off", n.selectable = !0, n.multiSelectable = !1, super(e, n);
  }
  /**
   * Handle text track change
   *
   * @param {Event} event
   *        The event that caused this function to run
   */
  handleTracksChange(e) {
    const n = this.player().textTracks();
    let a = !0;
    for (let i = 0, r = n.length; i < r; i++) {
      const s = n[i];
      if (this.options_.kinds.indexOf(s.kind) > -1 && s.mode === "showing") {
        a = !1;
        break;
      }
    }
    a !== this.isSelected_ && this.selected(a);
  }
  handleSelectedLanguageChange(e) {
    const n = this.player().textTracks();
    let a = !0;
    for (let i = 0, r = n.length; i < r; i++) {
      const s = n[i];
      if (["captions", "descriptions", "subtitles"].indexOf(s.kind) > -1 && s.mode === "showing") {
        a = !1;
        break;
      }
    }
    a && (this.player_.cache_.selectedLanguage = {
      enabled: !1
    });
  }
  /**
   * Update control text and label on languagechange
   */
  handleLanguagechange() {
    this.$(".vjs-menu-item-text").textContent = this.player_.localize(this.options_.label), super.handleLanguagechange();
  }
}
ye.registerComponent("OffTextTrackMenuItem", J3);
class mo extends Tp {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */
  constructor(e, n = {}) {
    n.tracks = e.textTracks(), super(e, n);
  }
  /**
   * Create a menu item for each text track
   *
   * @param {TextTrackMenuItem[]} [items=[]]
   *        Existing array of items to use during creation
   *
   * @return {TextTrackMenuItem[]}
   *         Array of menu items that were created
   */
  createItems(e = [], n = Zl) {
    let a;
    this.label_ && (a = `${this.label_} off`), e.push(new J3(this.player_, {
      kinds: this.kinds_,
      kind: this.kind_,
      label: a
    })), this.hideThreshold_ += 1;
    const i = this.player_.textTracks();
    Array.isArray(this.kinds_) || (this.kinds_ = [this.kind_]);
    for (let r = 0; r < i.length; r++) {
      const s = i[r];
      if (this.kinds_.indexOf(s.kind) > -1) {
        const o = new n(this.player_, {
          track: s,
          kinds: this.kinds_,
          kind: this.kind_,
          // MenuItem is selectable
          selectable: !0,
          // MenuItem is NOT multiSelectable (i.e. only one can be marked "selected" at a time)
          multiSelectable: !1
        });
        o.addClass(`vjs-${s.kind}-menu-item`), e.push(o);
      }
    }
    return e;
  }
}
ye.registerComponent("TextTrackButton", mo);
class e_ extends Xl {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, n) {
    const a = n.track, i = n.cue, r = e.currentTime();
    n.selectable = !0, n.multiSelectable = !1, n.label = i.text, n.selected = i.startTime <= r && r < i.endTime, super(e, n), this.track = a, this.cue = i;
  }
  /**
   * This gets called when an `ChaptersTrackMenuItem` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick(e) {
    super.handleClick(), this.player_.currentTime(this.cue.startTime);
  }
}
ye.registerComponent("ChaptersTrackMenuItem", e_);
class xp extends mo {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Function} [ready]
   *        The function to call when this function is ready.
   */
  constructor(e, n, a) {
    super(e, n, a), this.setIcon("chapters"), this.selectCurrentItem_ = () => {
      this.items.forEach((i) => {
        i.selected(this.track_.activeCues[0] === i.cue);
      });
    };
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-chapters-button ${super.buildCSSClass()}`;
  }
  buildWrapperCSSClass() {
    return `vjs-chapters-button ${super.buildWrapperCSSClass()}`;
  }
  /**
   * Update the menu based on the current state of its items.
   *
   * @param {Event} [event]
   *        An event that triggered this function to run.
   *
   * @listens TextTrackList#addtrack
   * @listens TextTrackList#removetrack
   * @listens TextTrackList#change
   */
  update(e) {
    if (e && e.track && e.track.kind !== "chapters")
      return;
    const n = this.findChaptersTrack();
    n !== this.track_ ? (this.setTrack(n), super.update()) : (!this.items || n && n.cues && n.cues.length !== this.items.length) && super.update();
  }
  /**
   * Set the currently selected track for the chapters button.
   *
   * @param {TextTrack} track
   *        The new track to select. Nothing will change if this is the currently selected
   *        track.
   */
  setTrack(e) {
    if (this.track_ !== e) {
      if (this.updateHandler_ || (this.updateHandler_ = this.update.bind(this)), this.track_) {
        const n = this.player_.remoteTextTrackEls().getTrackElementByTrack_(this.track_);
        n && n.removeEventListener("load", this.updateHandler_), this.track_.removeEventListener("cuechange", this.selectCurrentItem_), this.track_ = null;
      }
      if (this.track_ = e, this.track_) {
        this.track_.mode = "hidden";
        const n = this.player_.remoteTextTrackEls().getTrackElementByTrack_(this.track_);
        n && n.addEventListener("load", this.updateHandler_), this.track_.addEventListener("cuechange", this.selectCurrentItem_);
      }
    }
  }
  /**
   * Find the track object that is currently in use by this ChaptersButton
   *
   * @return {TextTrack|undefined}
   *         The current track or undefined if none was found.
   */
  findChaptersTrack() {
    const e = this.player_.textTracks() || [];
    for (let n = e.length - 1; n >= 0; n--) {
      const a = e[n];
      if (a.kind === this.kind_)
        return a;
    }
  }
  /**
   * Get the caption for the ChaptersButton based on the track label. This will also
   * use the current tracks localized kind as a fallback if a label does not exist.
   *
   * @return {string}
   *         The tracks current label or the localized track kind.
   */
  getMenuCaption() {
    return this.track_ && this.track_.label ? this.track_.label : this.localize(qt(this.kind_));
  }
  /**
   * Create menu from chapter track
   *
   * @return {Menu}
   *         New menu for the chapter buttons
   */
  createMenu() {
    return this.options_.title = this.getMenuCaption(), super.createMenu();
  }
  /**
   * Create a menu item for each text track
   *
   * @return  {TextTrackMenuItem[]}
   *         Array of menu items
   */
  createItems() {
    const e = [];
    if (!this.track_)
      return e;
    const n = this.track_.cues;
    if (!n)
      return e;
    for (let a = 0, i = n.length; a < i; a++) {
      const r = n[a], s = new e_(this.player_, {
        track: this.track_,
        cue: r
      });
      e.push(s);
    }
    return e;
  }
}
xp.prototype.kind_ = "chapters";
xp.prototype.controlText_ = "Chapters";
ye.registerComponent("ChaptersButton", xp);
class wp extends mo {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Function} [ready]
   *        The function to call when this component is ready.
   */
  constructor(e, n, a) {
    super(e, n, a), this.setIcon("audio-description");
    const i = e.textTracks(), r = Et(this, this.handleTracksChange);
    i.addEventListener("change", r), this.on("dispose", function() {
      i.removeEventListener("change", r);
    });
  }
  /**
   * Handle text track change
   *
   * @param {Event} event
   *        The event that caused this function to run
   *
   * @listens TextTrackList#change
   */
  handleTracksChange(e) {
    const n = this.player().textTracks();
    let a = !1;
    for (let i = 0, r = n.length; i < r; i++) {
      const s = n[i];
      if (s.kind !== this.kind_ && s.mode === "showing") {
        a = !0;
        break;
      }
    }
    a ? this.disable() : this.enable();
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-descriptions-button ${super.buildCSSClass()}`;
  }
  buildWrapperCSSClass() {
    return `vjs-descriptions-button ${super.buildWrapperCSSClass()}`;
  }
}
wp.prototype.kind_ = "descriptions";
wp.prototype.controlText_ = "Descriptions";
ye.registerComponent("DescriptionsButton", wp);
class kp extends mo {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Function} [ready]
   *        The function to call when this component is ready.
   */
  constructor(e, n, a) {
    super(e, n, a), this.setIcon("subtitles");
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-subtitles-button ${super.buildCSSClass()}`;
  }
  buildWrapperCSSClass() {
    return `vjs-subtitles-button ${super.buildWrapperCSSClass()}`;
  }
}
kp.prototype.kind_ = "subtitles";
kp.prototype.controlText_ = "Subtitles";
ye.registerComponent("SubtitlesButton", kp);
class Cp extends Zl {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, n) {
    n.track = {
      player: e,
      kind: n.kind,
      label: n.kind + " settings",
      selectable: !1,
      default: !1,
      mode: "disabled"
    }, n.selectable = !1, n.name = "CaptionSettingsMenuItem", super(e, n), this.addClass("vjs-texttrack-settings"), this.controlText(", opens " + n.kind + " settings dialog");
  }
  /**
   * This gets called when an `CaptionSettingsMenuItem` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick(e) {
    this.player().getChild("textTrackSettings").open();
  }
  /**
   * Update control text and label on languagechange
   */
  handleLanguagechange() {
    this.$(".vjs-menu-item-text").textContent = this.player_.localize(this.options_.kind + " settings"), super.handleLanguagechange();
  }
}
ye.registerComponent("CaptionSettingsMenuItem", Cp);
class Sp extends mo {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Function} [ready]
   *        The function to call when this component is ready.
   */
  constructor(e, n, a) {
    super(e, n, a), this.setIcon("captions");
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-captions-button ${super.buildCSSClass()}`;
  }
  buildWrapperCSSClass() {
    return `vjs-captions-button ${super.buildWrapperCSSClass()}`;
  }
  /**
   * Create caption menu items
   *
   * @return {CaptionSettingsMenuItem[]}
   *         The array of current menu items.
   */
  createItems() {
    const e = [];
    return !(this.player().tech_ && this.player().tech_.featuresNativeTextTracks) && this.player().getChild("textTrackSettings") && (e.push(new Cp(this.player_, {
      kind: this.kind_
    })), this.hideThreshold_ += 1), super.createItems(e);
  }
}
Sp.prototype.kind_ = "captions";
Sp.prototype.controlText_ = "Captions";
ye.registerComponent("CaptionsButton", Sp);
class t_ extends Zl {
  createEl(e, n, a) {
    const i = super.createEl(e, n, a), r = i.querySelector(".vjs-menu-item-text");
    return this.options_.track.kind === "captions" && (this.player_.options_.experimentalSvgIcons ? this.setIcon("captions", i) : r.appendChild(et("span", {
      className: "vjs-icon-placeholder"
    }, {
      "aria-hidden": !0
    })), r.appendChild(et("span", {
      className: "vjs-control-text",
      // space added as the text will visually flow with the
      // label
      textContent: ` ${this.localize("Captions")}`
    }))), i;
  }
}
ye.registerComponent("SubsCapsMenuItem", t_);
class Ap extends mo {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Function} [ready]
   *        The function to call when this component is ready.
   */
  constructor(e, n = {}) {
    super(e, n), this.label_ = "subtitles", this.setIcon("subtitles"), ["en", "en-us", "en-ca", "fr-ca"].indexOf(this.player_.language_) > -1 && (this.label_ = "captions", this.setIcon("captions")), this.menuButton_.controlText(qt(this.label_));
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-subs-caps-button ${super.buildCSSClass()}`;
  }
  buildWrapperCSSClass() {
    return `vjs-subs-caps-button ${super.buildWrapperCSSClass()}`;
  }
  /**
   * Create caption/subtitles menu items
   *
   * @return {CaptionSettingsMenuItem[]}
   *         The array of current menu items.
   */
  createItems() {
    let e = [];
    return !(this.player().tech_ && this.player().tech_.featuresNativeTextTracks) && this.player().getChild("textTrackSettings") && (e.push(new Cp(this.player_, {
      kind: this.label_
    })), this.hideThreshold_ += 1), e = super.createItems(e, t_), e;
  }
}
Ap.prototype.kinds_ = ["captions", "subtitles"];
Ap.prototype.controlText_ = "Subtitles";
ye.registerComponent("SubsCapsButton", Ap);
class n_ extends Xl {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, n) {
    const a = n.track, i = e.audioTracks();
    n.label = a.label || a.language || "Unknown", n.selected = a.enabled, super(e, n), this.track = a, this.addClass(`vjs-${a.kind}-menu-item`);
    const r = (...s) => {
      this.handleTracksChange.apply(this, s);
    };
    i.addEventListener("change", r), this.on("dispose", () => {
      i.removeEventListener("change", r);
    });
  }
  createEl(e, n, a) {
    const i = super.createEl(e, n, a), r = i.querySelector(".vjs-menu-item-text");
    return ["main-desc", "descriptions"].indexOf(this.options_.track.kind) >= 0 && (r.appendChild(et("span", {
      className: "vjs-icon-placeholder"
    }, {
      "aria-hidden": !0
    })), r.appendChild(et("span", {
      className: "vjs-control-text",
      textContent: " " + this.localize("Descriptions")
    }))), i;
  }
  /**
   * This gets called when an `AudioTrackMenuItem is "clicked". See {@link ClickableComponent}
   * for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick(e) {
    if (super.handleClick(e), this.track.enabled = !0, this.player_.tech_.featuresNativeAudioTracks) {
      const n = this.player_.audioTracks();
      for (let a = 0; a < n.length; a++) {
        const i = n[a];
        i !== this.track && (i.enabled = i === this.track);
      }
    }
  }
  /**
   * Handle any {@link AudioTrack} change.
   *
   * @param {Event} [event]
   *        The {@link AudioTrackList#change} event that caused this to run.
   *
   * @listens AudioTrackList#change
   */
  handleTracksChange(e) {
    this.selected(this.track.enabled);
  }
}
ye.registerComponent("AudioTrackMenuItem", n_);
class a_ extends Tp {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */
  constructor(e, n = {}) {
    n.tracks = e.audioTracks(), super(e, n), this.setIcon("audio");
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-audio-button ${super.buildCSSClass()}`;
  }
  buildWrapperCSSClass() {
    return `vjs-audio-button ${super.buildWrapperCSSClass()}`;
  }
  /**
   * Create a menu item for each audio track
   *
   * @param {AudioTrackMenuItem[]} [items=[]]
   *        An array of existing menu items to use.
   *
   * @return {AudioTrackMenuItem[]}
   *         An array of menu items
   */
  createItems(e = []) {
    this.hideThreshold_ = 1;
    const n = this.player_.audioTracks();
    for (let a = 0; a < n.length; a++) {
      const i = n[a];
      e.push(new n_(this.player_, {
        track: i,
        // MenuItem is selectable
        selectable: !0,
        // MenuItem is NOT multiSelectable (i.e. only one can be marked "selected" at a time)
        multiSelectable: !1
      }));
    }
    return e;
  }
}
a_.prototype.controlText_ = "Audio Track";
ye.registerComponent("AudioTrackButton", a_);
class Ep extends Xl {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, n) {
    const a = n.rate, i = parseFloat(a, 10);
    n.label = a, n.selected = i === e.playbackRate(), n.selectable = !0, n.multiSelectable = !1, super(e, n), this.label = a, this.rate = i, this.on(e, "ratechange", (r) => this.update(r));
  }
  /**
   * This gets called when an `PlaybackRateMenuItem` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick(e) {
    super.handleClick(), this.player().playbackRate(this.rate);
  }
  /**
   * Update the PlaybackRateMenuItem when the playbackrate changes.
   *
   * @param {Event} [event]
   *        The `ratechange` event that caused this function to run.
   *
   * @listens Player#ratechange
   */
  update(e) {
    this.selected(this.player().playbackRate() === this.rate);
  }
}
Ep.prototype.contentElType = "button";
ye.registerComponent("PlaybackRateMenuItem", Ep);
class i_ extends _p {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, n) {
    super(e, n), this.menuButton_.el_.setAttribute("aria-describedby", this.labelElId_), this.updateVisibility(), this.updateLabel(), this.on(e, "loadstart", (a) => this.updateVisibility(a)), this.on(e, "ratechange", (a) => this.updateLabel(a)), this.on(e, "playbackrateschange", (a) => this.handlePlaybackRateschange(a));
  }
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    const e = super.createEl();
    return this.labelElId_ = "vjs-playback-rate-value-label-" + this.id_, this.labelEl_ = et("div", {
      className: "vjs-playback-rate-value",
      id: this.labelElId_,
      textContent: "1x"
    }), e.appendChild(this.labelEl_), e;
  }
  dispose() {
    this.labelEl_ = null, super.dispose();
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-playback-rate ${super.buildCSSClass()}`;
  }
  buildWrapperCSSClass() {
    return `vjs-playback-rate ${super.buildWrapperCSSClass()}`;
  }
  /**
   * Create the list of menu items. Specific to each subclass.
   *
   */
  createItems() {
    const e = this.playbackRates(), n = [];
    for (let a = e.length - 1; a >= 0; a--)
      n.push(new Ep(this.player(), {
        rate: e[a] + "x"
      }));
    return n;
  }
  /**
   * On playbackrateschange, update the menu to account for the new items.
   *
   * @listens Player#playbackrateschange
   */
  handlePlaybackRateschange(e) {
    this.update();
  }
  /**
   * Get possible playback rates
   *
   * @return {Array}
   *         All possible playback rates
   */
  playbackRates() {
    const e = this.player();
    return e.playbackRates && e.playbackRates() || [];
  }
  /**
   * Get whether playback rates is supported by the tech
   * and an array of playback rates exists
   *
   * @return {boolean}
   *         Whether changing playback rate is supported
   */
  playbackRateSupported() {
    return this.player().tech_ && this.player().tech_.featuresPlaybackRate && this.playbackRates() && this.playbackRates().length > 0;
  }
  /**
   * Hide playback rate controls when they're no playback rate options to select
   *
   * @param {Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#loadstart
   */
  updateVisibility(e) {
    this.playbackRateSupported() ? this.removeClass("vjs-hidden") : this.addClass("vjs-hidden");
  }
  /**
   * Update button label when rate changed
   *
   * @param {Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#ratechange
   */
  updateLabel(e) {
    this.playbackRateSupported() && (this.labelEl_.textContent = this.player().playbackRate() + "x");
  }
}
i_.prototype.controlText_ = "Playback Rate";
ye.registerComponent("PlaybackRateMenuButton", i_);
class r_ extends ye {
  /**
  * Builds the default DOM `className`.
  *
  * @return {string}
  *         The DOM `className` for this object.
  */
  buildCSSClass() {
    return `vjs-spacer ${super.buildCSSClass()}`;
  }
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl(e = "div", n = {}, a = {}) {
    return n.className || (n.className = this.buildCSSClass()), super.createEl(e, n, a);
  }
}
ye.registerComponent("Spacer", r_);
class Rne extends r_ {
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-custom-control-spacer ${super.buildCSSClass()}`;
  }
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    return super.createEl("div", {
      className: this.buildCSSClass(),
      // No-flex/table-cell mode requires there be some content
      // in the cell to fill the remaining space of the table.
      textContent: " "
    });
  }
}
ye.registerComponent("CustomControlSpacer", Rne);
class s_ extends ye {
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    return super.createEl("div", {
      className: "vjs-control-bar",
      dir: "ltr"
    });
  }
}
s_.prototype.options_ = {
  children: ["playToggle", "skipBackward", "skipForward", "volumePanel", "currentTimeDisplay", "timeDivider", "durationDisplay", "progressControl", "liveDisplay", "seekToLive", "remainingTimeDisplay", "customControlSpacer", "playbackRateMenuButton", "chaptersButton", "descriptionsButton", "subsCapsButton", "audioTrackButton", "pictureInPictureToggle", "fullscreenToggle"]
};
ye.registerComponent("ControlBar", s_);
class o_ extends fo {
  /**
   * Creates an instance of this class.
   *
   * @param  {Player} player
   *         The `Player` that this class should be attached to.
   *
   * @param  {Object} [options]
   *         The key/value store of player options.
   */
  constructor(e, n) {
    super(e, n), this.on(e, "error", (a) => {
      this.open(a);
    });
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   *
   * @deprecated Since version 5.
   */
  buildCSSClass() {
    return `vjs-error-display ${super.buildCSSClass()}`;
  }
  /**
   * Gets the localized error message based on the `Player`s error.
   *
   * @return {string}
   *         The `Player`s error message localized or an empty string.
   */
  content() {
    const e = this.player().error();
    return e ? this.localize(e.message) : "";
  }
}
o_.prototype.options_ = Object.assign({}, fo.prototype.options_, {
  pauseOnOpen: !1,
  fillAlways: !0,
  temporary: !1,
  uncloseable: !0
});
ye.registerComponent("ErrorDisplay", o_);
class l_ extends ye {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {ContentDescriptor} [options.content=undefined]
   *        Provide customized content for this modal.
   *
   * @param {string} [options.legendId]
   *        A text with part of an string to create atribute of aria-labelledby.
   *
   * @param {string} [options.id]
   *        A text with part of an string to create atribute of aria-labelledby.
   *
   * @param {Array} [options.SelectOptions]
   *        Array that contains the value & textContent of for each of the
   *        options elements.
   */
  constructor(e, n = {}) {
    super(e, n), this.el_.setAttribute("aria-labelledby", this.selectLabelledbyIds);
  }
  /**
   * Create the `TextTrackSelect`'s DOM element
   *
   * @return {Element}
   *         The DOM element that gets created.
   */
  createEl() {
    return this.selectLabelledbyIds = [this.options_.legendId, this.options_.labelId].join(" ").trim(), et("select", {
      id: this.options_.id
    }, {}, this.options_.SelectOptions.map((n) => {
      const a = (this.options_.labelId ? this.options_.labelId : `vjs-track-option-${xa()}`) + "-" + n[1].replace(/\W+/g, ""), i = et("option", {
        id: a,
        value: this.localize(n[0]),
        textContent: this.localize(n[1])
      });
      return i.setAttribute("aria-labelledby", `${this.selectLabelledbyIds} ${a}`), i;
    }));
  }
}
ye.registerComponent("TextTrackSelect", l_);
class Mr extends ye {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {ContentDescriptor} [options.content=undefined]
   *        Provide customized content for this modal.
   *
   * @param {string} [options.legendId]
   *        A text with part of an string to create atribute of aria-labelledby.
   *        It passes to 'TextTrackSelect'.
   *
   * @param {string} [options.id]
   *        A text with part of an string to create atribute of aria-labelledby.
   *        It passes to 'TextTrackSelect'.
   *
   * @param {string} [options.legendText]
   *        A text to use as the text content of the legend element.
   *
   * @param {Array} [options.selects]
   *        Array that contains the selects that are use to create 'selects'
   *        components.
   *
   * @param {Array} [options.SelectOptions]
   *        Array that contains the value & textContent of for each of the
   *        options elements, it passes to 'TextTrackSelect'.
   *
   * @param {string} [options.type]
   *        Conditions if some DOM elements will be added to the fieldset
   *        component.
   *
   * @param {Object} [options.selectConfigs]
   *        Object with the following properties that are the selects configurations:
   *        backgroundColor, backgroundOpacity, color, edgeStyle, fontFamily,
   *        fontPercent, textOpacity, windowColor, windowOpacity.
   *        These properties are use to configure the 'TextTrackSelect' Component.
   */
  constructor(e, n = {}) {
    super(e, n);
    const a = et("legend", {
      textContent: this.localize(this.options_.legendText),
      id: this.options_.legendId
    });
    this.el().appendChild(a);
    const i = this.options_.selects;
    for (const r of i) {
      const s = this.options_.selectConfigs[r], o = s.className, l = s.id.replace("%s", this.options_.id_);
      let c = null;
      const u = `vjs_select_${xa()}`;
      if (this.options_.type === "colors") {
        c = et("span", {
          className: o
        });
        const m = et("label", {
          id: l,
          className: "vjs-label",
          textContent: this.localize(s.label)
        });
        m.setAttribute("for", u), c.appendChild(m);
      }
      const f = new l_(e, {
        SelectOptions: s.options,
        legendId: this.options_.legendId,
        id: u,
        labelId: l
      });
      this.addChild(f), this.options_.type === "colors" && (c.appendChild(f.el()), this.el().appendChild(c));
    }
  }
  /**
   * Create the `TextTrackFieldset`'s DOM element
   *
   * @return {Element}
   *         The DOM element that gets created.
   */
  createEl() {
    return et("fieldset", {
      // Prefixing classes of elements within a player with "vjs-"
      // is a convention used in Video.js.
      className: this.options_.className
    });
  }
}
ye.registerComponent("TextTrackFieldset", Mr);
class c_ extends ye {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {ContentDescriptor} [options.content=undefined]
   *        Provide customized content for this modal.
   *
   * @param {Array} [options.fieldSets]
   *        Array that contains the configurations for the selects.
   *
   * @param {Object} [options.selectConfigs]
   *        Object with the following properties that are the select confugations:
   *        backgroundColor, backgroundOpacity, color, edgeStyle, fontFamily,
   *        fontPercent, textOpacity, windowColor, windowOpacity.
   *        it passes to 'TextTrackFieldset'.
   */
  constructor(e, n = {}) {
    super(e, n);
    const a = this.options_.textTrackComponentid, i = new Mr(e, {
      id_: a,
      legendId: `captions-text-legend-${a}`,
      legendText: this.localize("Text"),
      className: "vjs-fg vjs-track-setting",
      selects: this.options_.fieldSets[0],
      selectConfigs: this.options_.selectConfigs,
      type: "colors"
    });
    this.addChild(i);
    const r = new Mr(e, {
      id_: a,
      legendId: `captions-background-${a}`,
      legendText: this.localize("Text Background"),
      className: "vjs-bg vjs-track-setting",
      selects: this.options_.fieldSets[1],
      selectConfigs: this.options_.selectConfigs,
      type: "colors"
    });
    this.addChild(r);
    const s = new Mr(e, {
      id_: a,
      legendId: `captions-window-${a}`,
      legendText: this.localize("Caption Area Background"),
      className: "vjs-window vjs-track-setting",
      selects: this.options_.fieldSets[2],
      selectConfigs: this.options_.selectConfigs,
      type: "colors"
    });
    this.addChild(s);
  }
  /**
   * Create the `TextTrackSettingsColors`'s DOM element
   *
   * @return {Element}
   *         The DOM element that gets created.
   */
  createEl() {
    return et("div", {
      className: "vjs-track-settings-colors"
    });
  }
}
ye.registerComponent("TextTrackSettingsColors", c_);
class u_ extends ye {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {ContentDescriptor} [options.content=undefined]
   *        Provide customized content for this modal.
   *
   * @param {Array} [options.fieldSets]
   *        Array that contains the configurations for the selects.
   *
   * @param {Object} [options.selectConfigs]
   *        Object with the following properties that are the select confugations:
   *        backgroundColor, backgroundOpacity, color, edgeStyle, fontFamily,
   *        fontPercent, textOpacity, windowColor, windowOpacity.
   *        it passes to 'TextTrackFieldset'.
   */
  constructor(e, n = {}) {
    super(e, n);
    const a = this.options_.textTrackComponentid, i = new Mr(e, {
      id_: a,
      legendId: `captions-font-size-${a}`,
      legendText: "Font Size",
      className: "vjs-font-percent vjs-track-setting",
      selects: this.options_.fieldSets[0],
      selectConfigs: this.options_.selectConfigs,
      type: "font"
    });
    this.addChild(i);
    const r = new Mr(e, {
      id_: a,
      legendId: `captions-edge-style-${a}`,
      legendText: this.localize("Text Edge Style"),
      className: "vjs-edge-style vjs-track-setting",
      selects: this.options_.fieldSets[1],
      selectConfigs: this.options_.selectConfigs,
      type: "font"
    });
    this.addChild(r);
    const s = new Mr(e, {
      id_: a,
      legendId: `captions-font-family-${a}`,
      legendText: this.localize("Font Family"),
      className: "vjs-font-family vjs-track-setting",
      selects: this.options_.fieldSets[2],
      selectConfigs: this.options_.selectConfigs,
      type: "font"
    });
    this.addChild(s);
  }
  /**
   * Create the `TextTrackSettingsFont`'s DOM element
   *
   * @return {Element}
   *         The DOM element that gets created.
   */
  createEl() {
    return et("div", {
      className: "vjs-track-settings-font"
    });
  }
}
ye.registerComponent("TextTrackSettingsFont", u_);
class d_ extends ye {
  constructor(e, n = {}) {
    super(e, n);
    const a = this.localize("restore all settings to the default values"), i = new Dn(e, {
      controlText: a,
      className: "vjs-default-button"
    });
    i.el().classList.remove("vjs-control", "vjs-button"), i.el().textContent = this.localize("Reset"), this.addChild(i);
    const r = new Dn(e, {
      controlText: a,
      className: "vjs-done-button"
    });
    r.el().classList.remove("vjs-control", "vjs-button"), r.el().textContent = this.localize("Done"), this.addChild(r);
  }
  /**
   * Create the `TrackSettingsControls`'s DOM element
   *
   * @return {Element}
   *         The DOM element that gets created.
   */
  createEl() {
    return et("div", {
      className: "vjs-track-settings-controls"
    });
  }
}
ye.registerComponent("TrackSettingsControls", d_);
const B0 = "vjs-text-track-settings", mb = ["#000", "Black"], gb = ["#00F", "Blue"], bb = ["#0FF", "Cyan"], vb = ["#0F0", "Green"], yb = ["#F0F", "Magenta"], _b = ["#F00", "Red"], Tb = ["#FFF", "White"], xb = ["#FF0", "Yellow"], R0 = ["1", "Opaque"], N0 = ["0.5", "Semi-Transparent"], wb = ["0", "Transparent"], Wi = {
  backgroundColor: {
    selector: ".vjs-bg-color > select",
    id: "captions-background-color-%s",
    label: "Color",
    options: [mb, Tb, _b, vb, gb, xb, yb, bb],
    className: "vjs-bg-color"
  },
  backgroundOpacity: {
    selector: ".vjs-bg-opacity > select",
    id: "captions-background-opacity-%s",
    label: "Opacity",
    options: [R0, N0, wb],
    className: "vjs-bg-opacity vjs-opacity"
  },
  color: {
    selector: ".vjs-text-color > select",
    id: "captions-foreground-color-%s",
    label: "Color",
    options: [Tb, mb, _b, vb, gb, xb, yb, bb],
    className: "vjs-text-color"
  },
  edgeStyle: {
    selector: ".vjs-edge-style > select",
    id: "",
    label: "Text Edge Style",
    options: [["none", "None"], ["raised", "Raised"], ["depressed", "Depressed"], ["uniform", "Uniform"], ["dropshadow", "Drop shadow"]]
  },
  fontFamily: {
    selector: ".vjs-font-family > select",
    id: "",
    label: "Font Family",
    options: [["proportionalSansSerif", "Proportional Sans-Serif"], ["monospaceSansSerif", "Monospace Sans-Serif"], ["proportionalSerif", "Proportional Serif"], ["monospaceSerif", "Monospace Serif"], ["casual", "Casual"], ["script", "Script"], ["small-caps", "Small Caps"]]
  },
  fontPercent: {
    selector: ".vjs-font-percent > select",
    id: "",
    label: "Font Size",
    options: [["0.50", "50%"], ["0.75", "75%"], ["1.00", "100%"], ["1.25", "125%"], ["1.50", "150%"], ["1.75", "175%"], ["2.00", "200%"], ["3.00", "300%"], ["4.00", "400%"]],
    default: 2,
    parser: (t) => t === "1.00" ? null : Number(t)
  },
  textOpacity: {
    selector: ".vjs-text-opacity > select",
    id: "captions-foreground-opacity-%s",
    label: "Opacity",
    options: [R0, N0],
    className: "vjs-text-opacity vjs-opacity"
  },
  // Options for this object are defined below.
  windowColor: {
    selector: ".vjs-window-color > select",
    id: "captions-window-color-%s",
    label: "Color",
    className: "vjs-window-color"
  },
  // Options for this object are defined below.
  windowOpacity: {
    selector: ".vjs-window-opacity > select",
    id: "captions-window-opacity-%s",
    label: "Opacity",
    options: [wb, N0, R0],
    className: "vjs-window-opacity vjs-opacity"
  }
};
Wi.windowColor.options = Wi.backgroundColor.options;
function h_(t, e) {
  if (e && (t = e(t)), t && t !== "none")
    return t;
}
function Nne(t, e) {
  const n = t.options[t.options.selectedIndex].value;
  return h_(n, e);
}
function $ne(t, e, n) {
  if (e) {
    for (let a = 0; a < t.options.length; a++)
      if (h_(t.options[a].value, n) === e) {
        t.selectedIndex = a;
        break;
      }
  }
}
class Fne extends fo {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *         The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *         The key/value store of player options.
   */
  constructor(e, n) {
    n.temporary = !1, super(e, n), this.updateDisplay = this.updateDisplay.bind(this), this.fill(), this.hasBeenOpened_ = this.hasBeenFilled_ = !0, this.renderModalComponents(e), this.endDialog = et("p", {
      className: "vjs-control-text",
      textContent: this.localize("End of dialog window.")
    }), this.el().appendChild(this.endDialog), this.setDefaults(), n.persistTextTrackSettings === void 0 && (this.options_.persistTextTrackSettings = this.options_.playerOptions.persistTextTrackSettings), this.bindFunctionsToSelectsAndButtons(), this.options_.persistTextTrackSettings && this.restoreSettings();
  }
  renderModalComponents(e) {
    const n = new c_(e, {
      textTrackComponentid: this.id_,
      selectConfigs: Wi,
      fieldSets: [["color", "textOpacity"], ["backgroundColor", "backgroundOpacity"], ["windowColor", "windowOpacity"]]
    });
    this.addChild(n);
    const a = new u_(e, {
      textTrackComponentid: this.id_,
      selectConfigs: Wi,
      fieldSets: [["fontPercent"], ["edgeStyle"], ["fontFamily"]]
    });
    this.addChild(a);
    const i = new d_(e);
    this.addChild(i);
  }
  bindFunctionsToSelectsAndButtons() {
    this.on(this.$(".vjs-done-button"), ["click", "tap"], () => {
      this.saveSettings(), this.close();
    }), this.on(this.$(".vjs-default-button"), ["click", "tap"], () => {
      this.setDefaults(), this.updateDisplay();
    }), Ts(Wi, (e) => {
      this.on(this.$(e.selector), "change", this.updateDisplay);
    });
  }
  dispose() {
    this.endDialog = null, super.dispose();
  }
  label() {
    return this.localize("Caption Settings Dialog");
  }
  description() {
    return this.localize("Beginning of dialog window. Escape will cancel and close the window.");
  }
  buildCSSClass() {
    return super.buildCSSClass() + " vjs-text-track-settings";
  }
  /**
   * Gets an object of text track settings (or null).
   *
   * @return {Object}
   *         An object with config values parsed from the DOM or localStorage.
   */
  getValues() {
    return n3(Wi, (e, n, a) => {
      const i = Nne(this.$(n.selector), n.parser);
      return i !== void 0 && (e[a] = i), e;
    }, {});
  }
  /**
   * Sets text track settings from an object of values.
   *
   * @param {Object} values
   *        An object with config values parsed from the DOM or localStorage.
   */
  setValues(e) {
    Ts(Wi, (n, a) => {
      $ne(this.$(n.selector), e[a], n.parser);
    });
  }
  /**
   * Sets all `<select>` elements to their default values.
   */
  setDefaults() {
    Ts(Wi, (e) => {
      const n = e.hasOwnProperty("default") ? e.default : 0;
      this.$(e.selector).selectedIndex = n;
    });
  }
  /**
   * Restore texttrack settings from localStorage
   */
  restoreSettings() {
    let e;
    try {
      e = JSON.parse(j.localStorage.getItem(B0));
    } catch (n) {
      ut.warn(n);
    }
    e && this.setValues(e);
  }
  /**
   * Save text track settings to localStorage
   */
  saveSettings() {
    if (!this.options_.persistTextTrackSettings)
      return;
    const e = this.getValues();
    try {
      Object.keys(e).length ? j.localStorage.setItem(B0, JSON.stringify(e)) : j.localStorage.removeItem(B0);
    } catch (n) {
      ut.warn(n);
    }
  }
  /**
   * Update display of text track settings
   */
  updateDisplay() {
    const e = this.player_.getChild("textTrackDisplay");
    e && e.updateDisplay();
  }
  /**
   * Repopulate dialog with new localizations on languagechange
   */
  handleLanguagechange() {
    this.fill(), this.renderModalComponents(this.player_), this.bindFunctionsToSelectsAndButtons();
  }
}
ye.registerComponent("TextTrackSettings", Fne);
class zne extends ye {
  /**
   * Create the ResizeManager.
   *
   * @param {Object} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of ResizeManager options.
   *
   * @param {Object} [options.ResizeObserver]
   *        A polyfill for ResizeObserver can be passed in here.
   *        If this is set to null it will ignore the native ResizeObserver and fall back to the iframe fallback.
   */
  constructor(e, n) {
    let a = n.ResizeObserver || j.ResizeObserver;
    n.ResizeObserver === null && (a = !1);
    const i = wt({
      createEl: !a,
      reportTouchActivity: !1
    }, n);
    super(e, i), this.ResizeObserver = n.ResizeObserver || j.ResizeObserver, this.loadListener_ = null, this.resizeObserver_ = null, this.debouncedHandler_ = C3(() => {
      this.resizeHandler();
    }, 100, !1, this), a ? (this.resizeObserver_ = new this.ResizeObserver(this.debouncedHandler_), this.resizeObserver_.observe(e.el())) : (this.loadListener_ = () => {
      if (!this.el_ || !this.el_.contentWindow)
        return;
      const r = this.debouncedHandler_;
      let s = this.unloadListener_ = function() {
        Ln(this, "resize", r), Ln(this, "unload", s), s = null;
      };
      ha(this.el_.contentWindow, "unload", s), ha(this.el_.contentWindow, "resize", r);
    }, this.one("load", this.loadListener_));
  }
  createEl() {
    return super.createEl("iframe", {
      className: "vjs-resize-manager",
      tabIndex: -1,
      title: this.localize("No content")
    }, {
      "aria-hidden": "true"
    });
  }
  /**
   * Called when a resize is triggered on the iframe or a resize is observed via the ResizeObserver
   *
   * @fires Player#playerresize
   */
  resizeHandler() {
    !this.player_ || !this.player_.trigger || this.player_.trigger("playerresize");
  }
  dispose() {
    this.debouncedHandler_ && this.debouncedHandler_.cancel(), this.resizeObserver_ && (this.player_.el() && this.resizeObserver_.unobserve(this.player_.el()), this.resizeObserver_.disconnect()), this.loadListener_ && this.off("load", this.loadListener_), this.el_ && this.el_.contentWindow && this.unloadListener_ && this.unloadListener_.call(this.el_.contentWindow), this.ResizeObserver = null, this.resizeObserver = null, this.debouncedHandler_ = null, this.loadListener_ = null, super.dispose();
  }
}
ye.registerComponent("ResizeManager", zne);
const Une = {
  trackingThreshold: 20,
  liveTolerance: 15
};
class Hne extends ye {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {number} [options.trackingThreshold=20]
   *        Number of seconds of live window (seekableEnd - seekableStart) that
   *        media needs to have before the liveui will be shown.
   *
   * @param {number} [options.liveTolerance=15]
   *        Number of seconds behind live that we have to be
   *        before we will be considered non-live. Note that this will only
   *        be used when playing at the live edge. This allows large seekable end
   *        changes to not effect whether we are live or not.
   */
  constructor(e, n) {
    const a = wt(Une, n, {
      createEl: !1
    });
    super(e, a), this.trackLiveHandler_ = () => this.trackLive_(), this.handlePlay_ = (i) => this.handlePlay(i), this.handleFirstTimeupdate_ = (i) => this.handleFirstTimeupdate(i), this.handleSeeked_ = (i) => this.handleSeeked(i), this.seekToLiveEdge_ = (i) => this.seekToLiveEdge(i), this.reset_(), this.on(this.player_, "durationchange", (i) => this.handleDurationchange(i)), this.on(this.player_, "canplay", () => this.toggleTracking());
  }
  /**
   * all the functionality for tracking when seek end changes
   * and for tracking how far past seek end we should be
   */
  trackLive_() {
    const e = this.player_.seekable();
    if (!e || !e.length)
      return;
    const n = Number(j.performance.now().toFixed(4)), a = this.lastTime_ === -1 ? 0 : (n - this.lastTime_) / 1e3;
    this.lastTime_ = n, this.pastSeekEnd_ = this.pastSeekEnd() + a;
    const i = this.liveCurrentTime(), r = this.player_.currentTime();
    let s = this.player_.paused() || this.seekedBehindLive_ || Math.abs(i - r) > this.options_.liveTolerance;
    (!this.timeupdateSeen_ || i === 1 / 0) && (s = !1), s !== this.behindLiveEdge_ && (this.behindLiveEdge_ = s, this.trigger("liveedgechange"));
  }
  /**
   * handle a durationchange event on the player
   * and start/stop tracking accordingly.
   */
  handleDurationchange() {
    this.toggleTracking();
  }
  /**
   * start/stop tracking
   */
  toggleTracking() {
    this.player_.duration() === 1 / 0 && this.liveWindow() >= this.options_.trackingThreshold ? (this.player_.options_.liveui && this.player_.addClass("vjs-liveui"), this.startTracking()) : (this.player_.removeClass("vjs-liveui"), this.stopTracking());
  }
  /**
   * start tracking live playback
   */
  startTracking() {
    this.isTracking() || (this.timeupdateSeen_ || (this.timeupdateSeen_ = this.player_.hasStarted()), this.trackingInterval_ = this.setInterval(this.trackLiveHandler_, wa), this.trackLive_(), this.on(this.player_, ["play", "pause"], this.trackLiveHandler_), this.timeupdateSeen_ ? this.on(this.player_, "seeked", this.handleSeeked_) : (this.one(this.player_, "play", this.handlePlay_), this.one(this.player_, "timeupdate", this.handleFirstTimeupdate_)));
  }
  /**
   * handle the first timeupdate on the player if it wasn't already playing
   * when live tracker started tracking.
   */
  handleFirstTimeupdate() {
    this.timeupdateSeen_ = !0, this.on(this.player_, "seeked", this.handleSeeked_);
  }
  /**
   * Keep track of what time a seek starts, and listen for seeked
   * to find where a seek ends.
   */
  handleSeeked() {
    const e = Math.abs(this.liveCurrentTime() - this.player_.currentTime());
    this.seekedBehindLive_ = this.nextSeekedFromUser_ && e > 2, this.nextSeekedFromUser_ = !1, this.trackLive_();
  }
  /**
   * handle the first play on the player, and make sure that we seek
   * right to the live edge.
   */
  handlePlay() {
    this.one(this.player_, "timeupdate", this.seekToLiveEdge_);
  }
  /**
   * Stop tracking, and set all internal variables to
   * their initial value.
   */
  reset_() {
    this.lastTime_ = -1, this.pastSeekEnd_ = 0, this.lastSeekEnd_ = -1, this.behindLiveEdge_ = !0, this.timeupdateSeen_ = !1, this.seekedBehindLive_ = !1, this.nextSeekedFromUser_ = !1, this.clearInterval(this.trackingInterval_), this.trackingInterval_ = null, this.off(this.player_, ["play", "pause"], this.trackLiveHandler_), this.off(this.player_, "seeked", this.handleSeeked_), this.off(this.player_, "play", this.handlePlay_), this.off(this.player_, "timeupdate", this.handleFirstTimeupdate_), this.off(this.player_, "timeupdate", this.seekToLiveEdge_);
  }
  /**
   * The next seeked event is from the user. Meaning that any seek
   * > 2s behind live will be considered behind live for real and
   * liveTolerance will be ignored.
   */
  nextSeekedFromUser() {
    this.nextSeekedFromUser_ = !0;
  }
  /**
   * stop tracking live playback
   */
  stopTracking() {
    this.isTracking() && (this.reset_(), this.trigger("liveedgechange"));
  }
  /**
   * A helper to get the player seekable end
   * so that we don't have to null check everywhere
   *
   * @return {number}
   *         The furthest seekable end or Infinity.
   */
  seekableEnd() {
    const e = this.player_.seekable(), n = [];
    let a = e ? e.length : 0;
    for (; a--; )
      n.push(e.end(a));
    return n.length ? n.sort()[n.length - 1] : 1 / 0;
  }
  /**
   * A helper to get the player seekable start
   * so that we don't have to null check everywhere
   *
   * @return {number}
   *         The earliest seekable start or 0.
   */
  seekableStart() {
    const e = this.player_.seekable(), n = [];
    let a = e ? e.length : 0;
    for (; a--; )
      n.push(e.start(a));
    return n.length ? n.sort()[0] : 0;
  }
  /**
   * Get the live time window aka
   * the amount of time between seekable start and
   * live current time.
   *
   * @return {number}
   *         The amount of seconds that are seekable in
   *         the live video.
   */
  liveWindow() {
    const e = this.liveCurrentTime();
    return e === 1 / 0 ? 0 : e - this.seekableStart();
  }
  /**
   * Determines if the player is live, only checks if this component
   * is tracking live playback or not
   *
   * @return {boolean}
   *         Whether liveTracker is tracking
   */
  isLive() {
    return this.isTracking();
  }
  /**
   * Determines if currentTime is at the live edge and won't fall behind
   * on each seekableendchange
   *
   * @return {boolean}
   *         Whether playback is at the live edge
   */
  atLiveEdge() {
    return !this.behindLiveEdge();
  }
  /**
   * get what we expect the live current time to be
   *
   * @return {number}
   *         The expected live current time
   */
  liveCurrentTime() {
    return this.pastSeekEnd() + this.seekableEnd();
  }
  /**
   * The number of seconds that have occurred after seekable end
   * changed. This will be reset to 0 once seekable end changes.
   *
   * @return {number}
   *         Seconds past the current seekable end
   */
  pastSeekEnd() {
    const e = this.seekableEnd();
    return this.lastSeekEnd_ !== -1 && e !== this.lastSeekEnd_ && (this.pastSeekEnd_ = 0), this.lastSeekEnd_ = e, this.pastSeekEnd_;
  }
  /**
   * If we are currently behind the live edge, aka currentTime will be
   * behind on a seekableendchange
   *
   * @return {boolean}
   *         If we are behind the live edge
   */
  behindLiveEdge() {
    return this.behindLiveEdge_;
  }
  /**
   * Whether live tracker is currently tracking or not.
   */
  isTracking() {
    return typeof this.trackingInterval_ == "number";
  }
  /**
   * Seek to the live edge if we are behind the live edge
   */
  seekToLiveEdge() {
    this.seekedBehindLive_ = !1, !this.atLiveEdge() && (this.nextSeekedFromUser_ = !1, this.player_.currentTime(this.liveCurrentTime()));
  }
  /**
   * Dispose of liveTracker
   */
  dispose() {
    this.stopTracking(), super.dispose();
  }
}
ye.registerComponent("LiveTracker", Hne);
class Yne extends ye {
  constructor(e, n) {
    super(e, n), this.on("statechanged", (a) => this.updateDom_()), this.updateDom_();
  }
  /**
   * Create the `TitleBar`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    return this.els = {
      title: et("div", {
        className: "vjs-title-bar-title",
        id: `vjs-title-bar-title-${xa()}`
      }),
      description: et("div", {
        className: "vjs-title-bar-description",
        id: `vjs-title-bar-description-${xa()}`
      })
    }, et("div", {
      className: "vjs-title-bar"
    }, {}, a3(this.els));
  }
  /**
   * Updates the DOM based on the component's state object.
   */
  updateDom_() {
    const e = this.player_.tech_, n = e && e.el_, a = {
      title: "aria-labelledby",
      description: "aria-describedby"
    };
    ["title", "description"].forEach((i) => {
      const r = this.state[i], s = this.els[i], o = a[i];
      wd(s), r && ur(s, r), n && (n.removeAttribute(o), r && n.setAttribute(o, s.id));
    }), this.state.title || this.state.description ? this.show() : this.hide();
  }
  /**
   * Update the contents of the title bar component with new title and
   * description text.
   *
   * If both title and description are missing, the title bar will be hidden.
   *
   * If either title or description are present, the title bar will be visible.
   *
   * NOTE: Any previously set value will be preserved. To unset a previously
   * set value, you must pass an empty string or null.
   *
   * For example:
   *
   * ```
   * update({title: 'foo', description: 'bar'}) // title: 'foo', description: 'bar'
   * update({description: 'bar2'}) // title: 'foo', description: 'bar2'
   * update({title: ''}) // title: '', description: 'bar2'
   * update({title: 'foo', description: null}) // title: 'foo', description: null
   * ```
   *
   * @param  {Object} [options={}]
   *         An options object. When empty, the title bar will be hidden.
   *
   * @param  {string} [options.title]
   *         A title to display in the title bar.
   *
   * @param  {string} [options.description]
   *         A description to display in the title bar.
   */
  update(e) {
    this.setState(e);
  }
  /**
   * Dispose the component.
   */
  dispose() {
    const e = this.player_.tech_, n = e && e.el_;
    n && (n.removeAttribute("aria-labelledby"), n.removeAttribute("aria-describedby")), super.dispose(), this.els = null;
  }
}
ye.registerComponent("TitleBar", Yne);
const jne = {
  initialDisplay: 4e3,
  position: [],
  takeFocus: !1
};
class Vne extends Dn {
  /**
   * TransientButton constructor
   *
   * @param {Player} player The button's player
   * @param {TransientButtonOptions} options Options for the transient button
   */
  constructor(e, n) {
    n = wt(jne, n), super(e, n), this.controlText(n.controlText), this.hide(), this.on(this.player_, ["useractive", "userinactive"], (a) => {
      this.removeClass("force-display");
    });
  }
  /**
   * Return CSS class including position classes
   *
   * @return {string} CSS class list
   */
  buildCSSClass() {
    return `vjs-transient-button focus-visible ${this.options_.position.map((e) => `vjs-${e}`).join(" ")}`;
  }
  /**
   * Create the button element
   *
   * @return {HTMLButtonElement} The button element
   */
  createEl() {
    const e = et("button", {}, {
      type: "button",
      class: this.buildCSSClass()
    }, et("span"));
    return this.controlTextEl_ = e.querySelector("span"), e;
  }
  /**
   * Show the button. The button will remain visible for the `initialDisplay` time, default 4s,
   * and when there is user activity.
   */
  show() {
    super.show(), this.addClass("force-display"), this.options_.takeFocus && this.el().focus({
      preventScroll: !0
    }), this.forceDisplayTimeout = this.player_.setTimeout(() => {
      this.removeClass("force-display");
    }, this.options_.initialDisplay);
  }
  /**
   * Hide the display, even if during the `initialDisplay` time.
   */
  hide() {
    this.removeClass("force-display"), super.hide();
  }
  /**
   * Dispose the component
   */
  dispose() {
    this.player_.clearTimeout(this.forceDisplayTimeout), super.dispose();
  }
}
ye.registerComponent("TransientButton", Vne);
const Lh = (t) => {
  const e = t.el();
  if (e.hasAttribute("src"))
    return t.triggerSourceset(e.src), !0;
  const n = t.$$("source"), a = [];
  let i = "";
  if (!n.length)
    return !1;
  for (let r = 0; r < n.length; r++) {
    const s = n[r].src;
    s && a.indexOf(s) === -1 && a.push(s);
  }
  return a.length ? (a.length === 1 && (i = a[0]), t.triggerSourceset(i), !0) : !1;
}, qne = Object.defineProperty({}, "innerHTML", {
  get() {
    return this.cloneNode(!0).innerHTML;
  },
  set(t) {
    const e = Me.createElement(this.nodeName.toLowerCase());
    e.innerHTML = t;
    const n = Me.createDocumentFragment();
    for (; e.childNodes.length; )
      n.appendChild(e.childNodes[0]);
    return this.innerText = "", j.Element.prototype.appendChild.call(this, n), this.innerHTML;
  }
}), f_ = (t, e) => {
  let n = {};
  for (let a = 0; a < t.length && (n = Object.getOwnPropertyDescriptor(t[a], e), !(n && n.set && n.get)); a++)
    ;
  return n.enumerable = !0, n.configurable = !0, n;
}, Wne = (t) => f_([t.el(), j.HTMLMediaElement.prototype, j.Element.prototype, qne], "innerHTML"), kb = function(t) {
  const e = t.el();
  if (e.resetSourceWatch_)
    return;
  const n = {}, a = Wne(t), i = (r) => (...s) => {
    const o = r.apply(e, s);
    return Lh(t), o;
  };
  ["append", "appendChild", "insertAdjacentHTML"].forEach((r) => {
    e[r] && (n[r] = e[r], e[r] = i(n[r]));
  }), Object.defineProperty(e, "innerHTML", wt(a, {
    set: i(a.set)
  })), e.resetSourceWatch_ = () => {
    e.resetSourceWatch_ = null, Object.keys(n).forEach((r) => {
      e[r] = n[r];
    }), Object.defineProperty(e, "innerHTML", a);
  }, t.one("sourceset", e.resetSourceWatch_);
}, Gne = Object.defineProperty({}, "src", {
  get() {
    return this.hasAttribute("src") ? B3(j.Element.prototype.getAttribute.call(this, "src")) : "";
  },
  set(t) {
    return j.Element.prototype.setAttribute.call(this, "src", t), t;
  }
}), Xne = (t) => f_([t.el(), j.HTMLMediaElement.prototype, Gne], "src"), Zne = function(t) {
  if (!t.featuresSourceset)
    return;
  const e = t.el();
  if (e.resetSourceset_)
    return;
  const n = Xne(t), a = e.setAttribute, i = e.load;
  Object.defineProperty(e, "src", wt(n, {
    set: (r) => {
      const s = n.set.call(e, r);
      return t.triggerSourceset(e.src), s;
    }
  })), e.setAttribute = (r, s) => {
    const o = a.call(e, r, s);
    return /src/i.test(r) && t.triggerSourceset(e.src), o;
  }, e.load = () => {
    const r = i.call(e);
    return Lh(t) || (t.triggerSourceset(""), kb(t)), r;
  }, e.currentSrc ? t.triggerSourceset(e.currentSrc) : Lh(t) || kb(t), e.resetSourceset_ = () => {
    e.resetSourceset_ = null, e.load = i, e.setAttribute = a, Object.defineProperty(e, "src", n), e.resetSourceWatch_ && e.resetSourceWatch_();
  };
};
class je extends rt {
  /**
  * Create an instance of this Tech.
  *
  * @param {Object} [options]
  *        The key/value store of player options.
  *
  * @param {Function} [ready]
  *        Callback function to call when the `HTML5` Tech is ready.
  */
  constructor(e, n) {
    super(e, n);
    const a = e.source;
    let i = !1;
    if (this.featuresVideoFrameCallback = this.featuresVideoFrameCallback && this.el_.tagName === "VIDEO", a && (this.el_.currentSrc !== a.src || e.tag && e.tag.initNetworkState_ === 3) ? this.setSource(a) : this.handleLateInit_(this.el_), e.enableSourceset && this.setupSourcesetHandling_(), this.isScrubbing_ = !1, this.el_.hasChildNodes()) {
      const r = this.el_.childNodes;
      let s = r.length;
      const o = [];
      for (; s--; ) {
        const l = r[s];
        l.nodeName.toLowerCase() === "track" && (this.featuresNativeTextTracks ? (this.remoteTextTrackEls().addTrackElement_(l), this.remoteTextTracks().addTrack(l.track), this.textTracks().addTrack(l.track), !i && !this.el_.hasAttribute("crossorigin") && Ad(l.src) && (i = !0)) : o.push(l));
      }
      for (let l = 0; l < o.length; l++)
        this.el_.removeChild(o[l]);
    }
    this.proxyNativeTracks_(), this.featuresNativeTextTracks && i && ut.warn(`Text Tracks are being loaded from another origin but the crossorigin attribute isn't used.
This may prevent text tracks from loading.`), this.restoreMetadataTracksInIOSNativePlayer_(), (Ll || vd) && e.nativeControlsForTouch === !0 && this.setControls(!0), this.proxyWebkitFullscreen_(), this.triggerReady();
  }
  /**
   * Dispose of `HTML5` media element and remove all tracks.
   */
  dispose() {
    this.el_ && this.el_.resetSourceset_ && this.el_.resetSourceset_(), je.disposeMediaElement(this.el_), this.options_ = null, super.dispose();
  }
  /**
   * Modify the media element so that we can detect when
   * the source is changed. Fires `sourceset` just after the source has changed
   */
  setupSourcesetHandling_() {
    Zne(this);
  }
  /**
   * When a captions track is enabled in the iOS Safari native player, all other
   * tracks are disabled (including metadata tracks), which nulls all of their
   * associated cue points. This will restore metadata tracks to their pre-fullscreen
   * state in those cases so that cue points are not needlessly lost.
   *
   * @private
   */
  restoreMetadataTracksInIOSNativePlayer_() {
    const e = this.textTracks();
    let n;
    const a = () => {
      n = [];
      for (let r = 0; r < e.length; r++) {
        const s = e[r];
        s.kind === "metadata" && n.push({
          track: s,
          storedMode: s.mode
        });
      }
    };
    a(), e.addEventListener("change", a), this.on("dispose", () => e.removeEventListener("change", a));
    const i = () => {
      for (let r = 0; r < n.length; r++) {
        const s = n[r];
        s.track.mode === "disabled" && s.track.mode !== s.storedMode && (s.track.mode = s.storedMode);
      }
      e.removeEventListener("change", i);
    };
    this.on("webkitbeginfullscreen", () => {
      e.removeEventListener("change", a), e.removeEventListener("change", i), e.addEventListener("change", i);
    }), this.on("webkitendfullscreen", () => {
      e.removeEventListener("change", a), e.addEventListener("change", a), e.removeEventListener("change", i);
    });
  }
  /**
   * Attempt to force override of tracks for the given type
   *
   * @param {string} type - Track type to override, possible values include 'Audio',
   * 'Video', and 'Text'.
   * @param {boolean} override - If set to true native audio/video will be overridden,
   * otherwise native audio/video will potentially be used.
   * @private
   */
  overrideNative_(e, n) {
    if (n !== this[`featuresNative${e}Tracks`])
      return;
    const a = e.toLowerCase();
    this[`${a}TracksListeners_`] && Object.keys(this[`${a}TracksListeners_`]).forEach((i) => {
      this.el()[`${a}Tracks`].removeEventListener(i, this[`${a}TracksListeners_`][i]);
    }), this[`featuresNative${e}Tracks`] = !n, this[`${a}TracksListeners_`] = null, this.proxyNativeTracksForType_(a);
  }
  /**
   * Attempt to force override of native audio tracks.
   *
   * @param {boolean} override - If set to true native audio will be overridden,
   * otherwise native audio will potentially be used.
   */
  overrideNativeAudioTracks(e) {
    this.overrideNative_("Audio", e);
  }
  /**
   * Attempt to force override of native video tracks.
   *
   * @param {boolean} override - If set to true native video will be overridden,
   * otherwise native video will potentially be used.
   */
  overrideNativeVideoTracks(e) {
    this.overrideNative_("Video", e);
  }
  /**
   * Proxy native track list events for the given type to our track
   * lists if the browser we are playing in supports that type of track list.
   *
   * @param {string} name - Track type; values include 'audio', 'video', and 'text'
   * @private
   */
  proxyNativeTracksForType_(e) {
    const n = Ta[e], a = this.el()[n.getterName], i = this[n.getterName]();
    if (!this[`featuresNative${n.capitalName}Tracks`] || !a || !a.addEventListener)
      return;
    const r = {
      change: (o) => {
        const l = {
          type: "change",
          target: i,
          currentTarget: i,
          srcElement: i
        };
        i.trigger(l), e === "text" && this[Xs.remoteText.getterName]().trigger(l);
      },
      addtrack(o) {
        i.addTrack(o.track);
      },
      removetrack(o) {
        i.removeTrack(o.track);
      }
    }, s = function() {
      const o = [];
      for (let l = 0; l < i.length; l++) {
        let c = !1;
        for (let u = 0; u < a.length; u++)
          if (a[u] === i[l]) {
            c = !0;
            break;
          }
        c || o.push(i[l]);
      }
      for (; o.length; )
        i.removeTrack(o.shift());
    };
    this[n.getterName + "Listeners_"] = r, Object.keys(r).forEach((o) => {
      const l = r[o];
      a.addEventListener(o, l), this.on("dispose", (c) => a.removeEventListener(o, l));
    }), this.on("loadstart", s), this.on("dispose", (o) => this.off("loadstart", s));
  }
  /**
   * Proxy all native track list events to our track lists if the browser we are playing
   * in supports that type of track list.
   *
   * @private
   */
  proxyNativeTracks_() {
    Ta.names.forEach((e) => {
      this.proxyNativeTracksForType_(e);
    });
  }
  /**
   * Create the `Html5` Tech's DOM element.
   *
   * @return {Element}
   *         The element that gets created.
   */
  createEl() {
    let e = this.options_.tag;
    if (!e || !(this.options_.playerElIngest || this.movingMediaElementInDOM)) {
      if (e) {
        const a = e.cloneNode(!0);
        e.parentNode && e.parentNode.insertBefore(a, e), je.disposeMediaElement(e), e = a;
      } else {
        e = Me.createElement("video");
        const a = this.options_.tag && qi(this.options_.tag), i = wt({}, a);
        (!Ll || this.options_.nativeControlsForTouch !== !0) && delete i.controls, h3(e, Object.assign(i, {
          id: this.options_.techId,
          class: "vjs-tech"
        }));
      }
      e.playerId = this.options_.playerId;
    }
    typeof this.options_.preload < "u" && Vs(e, "preload", this.options_.preload), this.options_.disablePictureInPicture !== void 0 && (e.disablePictureInPicture = this.options_.disablePictureInPicture);
    const n = ["loop", "muted", "playsinline", "autoplay"];
    for (let a = 0; a < n.length; a++) {
      const i = n[a], r = this.options_[i];
      typeof r < "u" && (r ? Vs(e, i, i) : Td(e, i), e[i] = r);
    }
    return e;
  }
  /**
   * This will be triggered if the loadstart event has already fired, before videojs was
   * ready. Two known examples of when this can happen are:
   * 1. If we're loading the playback object after it has started loading
   * 2. The media is already playing the (often with autoplay on) then
   *
   * This function will fire another loadstart so that videojs can catchup.
   *
   * @fires Tech#loadstart
   *
   * @return {undefined}
   *         returns nothing.
   */
  handleLateInit_(e) {
    if (e.networkState === 0 || e.networkState === 3)
      return;
    if (e.readyState === 0) {
      let a = !1;
      const i = function() {
        a = !0;
      };
      this.on("loadstart", i);
      const r = function() {
        a || this.trigger("loadstart");
      };
      this.on("loadedmetadata", r), this.ready(function() {
        this.off("loadstart", i), this.off("loadedmetadata", r), a || this.trigger("loadstart");
      });
      return;
    }
    const n = ["loadstart"];
    n.push("loadedmetadata"), e.readyState >= 2 && n.push("loadeddata"), e.readyState >= 3 && n.push("canplay"), e.readyState >= 4 && n.push("canplaythrough"), this.ready(function() {
      n.forEach(function(a) {
        this.trigger(a);
      }, this);
    });
  }
  /**
   * Set whether we are scrubbing or not.
   * This is used to decide whether we should use `fastSeek` or not.
   * `fastSeek` is used to provide trick play on Safari browsers.
   *
   * @param {boolean} isScrubbing
   *                  - true for we are currently scrubbing
   *                  - false for we are no longer scrubbing
   */
  setScrubbing(e) {
    this.isScrubbing_ = e;
  }
  /**
   * Get whether we are scrubbing or not.
   *
   * @return {boolean} isScrubbing
   *                  - true for we are currently scrubbing
   *                  - false for we are no longer scrubbing
   */
  scrubbing() {
    return this.isScrubbing_;
  }
  /**
   * Set current time for the `HTML5` tech.
   *
   * @param {number} seconds
   *        Set the current time of the media to this.
   */
  setCurrentTime(e) {
    try {
      this.isScrubbing_ && this.el_.fastSeek && yd ? this.el_.fastSeek(e) : this.el_.currentTime = e;
    } catch (n) {
      ut(n, "Video is not ready. (Video.js)");
    }
  }
  /**
   * Get the current duration of the HTML5 media element.
   *
   * @return {number}
   *         The duration of the media or 0 if there is no duration.
   */
  duration() {
    if (this.el_.duration === 1 / 0 && $a && ai && this.el_.currentTime === 0) {
      const e = () => {
        this.el_.currentTime > 0 && (this.el_.duration === 1 / 0 && this.trigger("durationchange"), this.off("timeupdate", e));
      };
      return this.on("timeupdate", e), NaN;
    }
    return this.el_.duration || NaN;
  }
  /**
   * Get the current width of the HTML5 media element.
   *
   * @return {number}
   *         The width of the HTML5 media element.
   */
  width() {
    return this.el_.offsetWidth;
  }
  /**
   * Get the current height of the HTML5 media element.
   *
   * @return {number}
   *         The height of the HTML5 media element.
   */
  height() {
    return this.el_.offsetHeight;
  }
  /**
   * Proxy iOS `webkitbeginfullscreen` and `webkitendfullscreen` into
   * `fullscreenchange` event.
   *
   * @private
   * @fires fullscreenchange
   * @listens webkitendfullscreen
   * @listens webkitbeginfullscreen
   * @listens webkitbeginfullscreen
   */
  proxyWebkitFullscreen_() {
    if (!("webkitDisplayingFullscreen" in this.el_))
      return;
    const e = function() {
      this.trigger("fullscreenchange", {
        isFullscreen: !1
      }), this.el_.controls && !this.options_.nativeControlsForTouch && this.controls() && (this.el_.controls = !1);
    }, n = function() {
      "webkitPresentationMode" in this.el_ && this.el_.webkitPresentationMode !== "picture-in-picture" && (this.one("webkitendfullscreen", e), this.trigger("fullscreenchange", {
        isFullscreen: !0,
        // set a flag in case another tech triggers fullscreenchange
        nativeIOSFullscreen: !0
      }));
    };
    this.on("webkitbeginfullscreen", n), this.on("dispose", () => {
      this.off("webkitbeginfullscreen", n), this.off("webkitendfullscreen", e);
    });
  }
  /**
   * Check if fullscreen is supported on the video el.
   *
   * @return {boolean}
   *         - True if fullscreen is supported.
   *         - False if fullscreen is not supported.
   */
  supportsFullScreen() {
    return typeof this.el_.webkitEnterFullScreen == "function";
  }
  /**
   * Request that the `HTML5` Tech enter fullscreen.
   */
  enterFullScreen() {
    const e = this.el_;
    if (e.paused && e.networkState <= e.HAVE_METADATA)
      Xa(this.el_.play()), this.setTimeout(function() {
        e.pause();
        try {
          e.webkitEnterFullScreen();
        } catch (n) {
          this.trigger("fullscreenerror", n);
        }
      }, 0);
    else
      try {
        e.webkitEnterFullScreen();
      } catch (n) {
        this.trigger("fullscreenerror", n);
      }
  }
  /**
   * Request that the `HTML5` Tech exit fullscreen.
   */
  exitFullScreen() {
    if (!this.el_.webkitDisplayingFullscreen) {
      this.trigger("fullscreenerror", new Error("The video is not fullscreen"));
      return;
    }
    this.el_.webkitExitFullScreen();
  }
  /**
   * Create a floating video window always on top of other windows so that users may
   * continue consuming media while they interact with other content sites, or
   * applications on their device.
   *
   * @see [Spec]{@link https://wicg.github.io/picture-in-picture}
   *
   * @return {Promise}
   *         A promise with a Picture-in-Picture window.
   */
  requestPictureInPicture() {
    return this.el_.requestPictureInPicture();
  }
  /**
   * Native requestVideoFrameCallback if supported by browser/tech, or fallback
   * Don't use rVCF on Safari when DRM is playing, as it doesn't fire
   * Needs to be checked later than the constructor
   * This will be a false positive for clear sources loaded after a Fairplay source
   *
   * @param {function} cb function to call
   * @return {number} id of request
   */
  requestVideoFrameCallback(e) {
    return this.featuresVideoFrameCallback && !this.el_.webkitKeys ? this.el_.requestVideoFrameCallback(e) : super.requestVideoFrameCallback(e);
  }
  /**
   * Native or fallback requestVideoFrameCallback
   *
   * @param {number} id request id to cancel
   */
  cancelVideoFrameCallback(e) {
    this.featuresVideoFrameCallback && !this.el_.webkitKeys ? this.el_.cancelVideoFrameCallback(e) : super.cancelVideoFrameCallback(e);
  }
  /**
   * A getter/setter for the `Html5` Tech's source object.
   * > Note: Please use {@link Html5#setSource}
   *
   * @param {Tech~SourceObject} [src]
   *        The source object you want to set on the `HTML5` techs element.
   *
   * @return {Tech~SourceObject|undefined}
   *         - The current source object when a source is not passed in.
   *         - undefined when setting
   *
   * @deprecated Since version 5.
   */
  src(e) {
    if (e === void 0)
      return this.el_.src;
    this.setSrc(e);
  }
  /**
   * Add a <source> element to the <video> element.
   *
   * @param {string} srcUrl
   *        The URL of the video source.
   *
   * @param {string} [mimeType]
   *        The MIME type of the video source. Optional but recommended.
   *
   * @return {boolean}
   *         Returns true if the source element was successfully added, false otherwise.
   */
  addSourceElement(e, n) {
    if (!e)
      return ut.error("Invalid source URL."), !1;
    const a = {
      src: e
    };
    n && (a.type = n);
    const i = et("source", {}, a);
    return this.el_.appendChild(i), !0;
  }
  /**
   * Remove a <source> element from the <video> element by its URL.
   *
   * @param {string} srcUrl
   *        The URL of the source to remove.
   *
   * @return {boolean}
   *         Returns true if the source element was successfully removed, false otherwise.
   */
  removeSourceElement(e) {
    if (!e)
      return ut.error("Source URL is required to remove the source element."), !1;
    const n = this.el_.querySelectorAll("source");
    for (const a of n)
      if (a.src === e)
        return this.el_.removeChild(a), !0;
    return ut.warn(`No matching source element found with src: ${e}`), !1;
  }
  /**
   * Reset the tech by removing all sources and then calling
   * {@link Html5.resetMediaElement}.
   */
  reset() {
    je.resetMediaElement(this.el_);
  }
  /**
   * Get the current source on the `HTML5` Tech. Falls back to returning the source from
   * the HTML5 media element.
   *
   * @return {Tech~SourceObject}
   *         The current source object from the HTML5 tech. With a fallback to the
   *         elements source.
   */
  currentSrc() {
    return this.currentSource_ ? this.currentSource_.src : this.el_.currentSrc;
  }
  /**
   * Set controls attribute for the HTML5 media Element.
   *
   * @param {string} val
   *        Value to set the controls attribute to
   */
  setControls(e) {
    this.el_.controls = !!e;
  }
  /**
   * Create and returns a remote {@link TextTrack} object.
   *
   * @param {string} kind
   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata)
   *
   * @param {string} [label]
   *        Label to identify the text track
   *
   * @param {string} [language]
   *        Two letter language abbreviation
   *
   * @return {TextTrack}
   *         The TextTrack that gets created.
   */
  addTextTrack(e, n, a) {
    return this.featuresNativeTextTracks ? this.el_.addTextTrack(e, n, a) : super.addTextTrack(e, n, a);
  }
  /**
   * Creates either native TextTrack or an emulated TextTrack depending
   * on the value of `featuresNativeTextTracks`
   *
   * @param {Object} options
   *        The object should contain the options to initialize the TextTrack with.
   *
   * @param {string} [options.kind]
   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata).
   *
   * @param {string} [options.label]
   *        Label to identify the text track
   *
   * @param {string} [options.language]
   *        Two letter language abbreviation.
   *
   * @param {boolean} [options.default]
   *        Default this track to on.
   *
   * @param {string} [options.id]
   *        The internal id to assign this track.
   *
   * @param {string} [options.src]
   *        A source url for the track.
   *
   * @return {HTMLTrackElement}
   *         The track element that gets created.
   */
  createRemoteTextTrack(e) {
    if (!this.featuresNativeTextTracks)
      return super.createRemoteTextTrack(e);
    const n = Me.createElement("track");
    return e.kind && (n.kind = e.kind), e.label && (n.label = e.label), (e.language || e.srclang) && (n.srclang = e.language || e.srclang), e.default && (n.default = e.default), e.id && (n.id = e.id), e.src && (n.src = e.src), n;
  }
  /**
   * Creates a remote text track object and returns an html track element.
   *
   * @param {Object} options The object should contain values for
   * kind, language, label, and src (location of the WebVTT file)
   * @param {boolean} [manualCleanup=false] if set to true, the TextTrack
   * will not be removed from the TextTrackList and HtmlTrackElementList
   * after a source change
   * @return {HTMLTrackElement} An Html Track Element.
   * This can be an emulated {@link HTMLTrackElement} or a native one.
   *
   */
  addRemoteTextTrack(e, n) {
    const a = super.addRemoteTextTrack(e, n);
    return this.featuresNativeTextTracks && this.el().appendChild(a), a;
  }
  /**
   * Remove remote `TextTrack` from `TextTrackList` object
   *
   * @param {TextTrack} track
   *        `TextTrack` object to remove
   */
  removeRemoteTextTrack(e) {
    if (super.removeRemoteTextTrack(e), this.featuresNativeTextTracks) {
      const n = this.$$("track");
      let a = n.length;
      for (; a--; )
        (e === n[a] || e === n[a].track) && this.el().removeChild(n[a]);
    }
  }
  /**
   * Gets available media playback quality metrics as specified by the W3C's Media
   * Playback Quality API.
   *
   * @see [Spec]{@link https://wicg.github.io/media-playback-quality}
   *
   * @return {Object}
   *         An object with supported media playback quality metrics
   */
  getVideoPlaybackQuality() {
    if (typeof this.el().getVideoPlaybackQuality == "function")
      return this.el().getVideoPlaybackQuality();
    const e = {};
    return typeof this.el().webkitDroppedFrameCount < "u" && typeof this.el().webkitDecodedFrameCount < "u" && (e.droppedVideoFrames = this.el().webkitDroppedFrameCount, e.totalVideoFrames = this.el().webkitDecodedFrameCount), j.performance && (e.creationTime = j.performance.now()), e;
  }
}
md(je, "TEST_VID", function() {
  if (!co())
    return;
  const t = Me.createElement("video"), e = Me.createElement("track");
  return e.kind = "captions", e.srclang = "en", e.label = "English", t.appendChild(e), t;
});
je.isSupported = function() {
  try {
    je.TEST_VID.volume = 0.5;
  } catch {
    return !1;
  }
  return !!(je.TEST_VID && je.TEST_VID.canPlayType);
};
je.canPlayType = function(t) {
  return je.TEST_VID.canPlayType(t);
};
je.canPlaySource = function(t, e) {
  return je.canPlayType(t.type);
};
je.canControlVolume = function() {
  try {
    const t = je.TEST_VID.volume;
    je.TEST_VID.volume = t / 2 + 0.1;
    const e = t !== je.TEST_VID.volume;
    return e && En ? (j.setTimeout(() => {
      je && je.prototype && (je.prototype.featuresVolumeControl = t !== je.TEST_VID.volume);
    }), !1) : e;
  } catch {
    return !1;
  }
};
je.canMuteVolume = function() {
  try {
    const t = je.TEST_VID.muted;
    return je.TEST_VID.muted = !t, je.TEST_VID.muted ? Vs(je.TEST_VID, "muted", "muted") : Td(je.TEST_VID, "muted", "muted"), t !== je.TEST_VID.muted;
  } catch {
    return !1;
  }
};
je.canControlPlaybackRate = function() {
  if ($a && ai && gd < 58)
    return !1;
  try {
    const t = je.TEST_VID.playbackRate;
    return je.TEST_VID.playbackRate = t / 2 + 0.1, t !== je.TEST_VID.playbackRate;
  } catch {
    return !1;
  }
};
je.canOverrideAttributes = function() {
  try {
    const t = () => {
    };
    Object.defineProperty(Me.createElement("video"), "src", {
      get: t,
      set: t
    }), Object.defineProperty(Me.createElement("audio"), "src", {
      get: t,
      set: t
    }), Object.defineProperty(Me.createElement("video"), "innerHTML", {
      get: t,
      set: t
    }), Object.defineProperty(Me.createElement("audio"), "innerHTML", {
      get: t,
      set: t
    });
  } catch {
    return !1;
  }
  return !0;
};
je.supportsNativeTextTracks = function() {
  return yd || En && ai;
};
je.supportsNativeVideoTracks = function() {
  return !!(je.TEST_VID && je.TEST_VID.videoTracks);
};
je.supportsNativeAudioTracks = function() {
  return !!(je.TEST_VID && je.TEST_VID.audioTracks);
};
je.Events = ["loadstart", "suspend", "abort", "error", "emptied", "stalled", "loadedmetadata", "loadeddata", "canplay", "canplaythrough", "playing", "waiting", "seeking", "seeked", "ended", "durationchange", "timeupdate", "progress", "play", "pause", "ratechange", "resize", "volumechange"];
[["featuresMuteControl", "canMuteVolume"], ["featuresPlaybackRate", "canControlPlaybackRate"], ["featuresSourceset", "canOverrideAttributes"], ["featuresNativeTextTracks", "supportsNativeTextTracks"], ["featuresNativeVideoTracks", "supportsNativeVideoTracks"], ["featuresNativeAudioTracks", "supportsNativeAudioTracks"]].forEach(function([t, e]) {
  md(je.prototype, t, () => je[e](), !0);
});
je.prototype.featuresVolumeControl = je.canControlVolume();
je.prototype.movingMediaElementInDOM = !En;
je.prototype.featuresFullscreenResize = !0;
je.prototype.featuresProgressEvents = !0;
je.prototype.featuresTimeupdateEvents = !0;
je.prototype.featuresVideoFrameCallback = !!(je.TEST_VID && je.TEST_VID.requestVideoFrameCallback);
je.disposeMediaElement = function(t) {
  if (t) {
    for (t.parentNode && t.parentNode.removeChild(t); t.hasChildNodes(); )
      t.removeChild(t.firstChild);
    t.removeAttribute("src"), typeof t.load == "function" && function() {
      try {
        t.load();
      } catch {
      }
    }();
  }
};
je.resetMediaElement = function(t) {
  if (!t)
    return;
  const e = t.querySelectorAll("source");
  let n = e.length;
  for (; n--; )
    t.removeChild(e[n]);
  t.removeAttribute("src"), typeof t.load == "function" && function() {
    try {
      t.load();
    } catch {
    }
  }();
};
[
  /**
   * Get the value of `muted` from the media element. `muted` indicates
   * that the volume for the media should be set to silent. This does not actually change
   * the `volume` attribute.
   *
   * @method Html5#muted
   * @return {boolean}
   *         - True if the value of `volume` should be ignored and the audio set to silent.
   *         - False if the value of `volume` should be used.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-muted}
   */
  "muted",
  /**
   * Get the value of `defaultMuted` from the media element. `defaultMuted` indicates
   * whether the media should start muted or not. Only changes the default state of the
   * media. `muted` and `defaultMuted` can have different values. {@link Html5#muted} indicates the
   * current state.
   *
   * @method Html5#defaultMuted
   * @return {boolean}
   *         - The value of `defaultMuted` from the media element.
   *         - True indicates that the media should start muted.
   *         - False indicates that the media should not start muted
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-defaultmuted}
   */
  "defaultMuted",
  /**
   * Get the value of `autoplay` from the media element. `autoplay` indicates
   * that the media should start to play as soon as the page is ready.
   *
   * @method Html5#autoplay
   * @return {boolean}
   *         - The value of `autoplay` from the media element.
   *         - True indicates that the media should start as soon as the page loads.
   *         - False indicates that the media should not start as soon as the page loads.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-autoplay}
   */
  "autoplay",
  /**
   * Get the value of `controls` from the media element. `controls` indicates
   * whether the native media controls should be shown or hidden.
   *
   * @method Html5#controls
   * @return {boolean}
   *         - The value of `controls` from the media element.
   *         - True indicates that native controls should be showing.
   *         - False indicates that native controls should be hidden.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-controls}
   */
  "controls",
  /**
   * Get the value of `loop` from the media element. `loop` indicates
   * that the media should return to the start of the media and continue playing once
   * it reaches the end.
   *
   * @method Html5#loop
   * @return {boolean}
   *         - The value of `loop` from the media element.
   *         - True indicates that playback should seek back to start once
   *           the end of a media is reached.
   *         - False indicates that playback should not loop back to the start when the
   *           end of the media is reached.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-loop}
   */
  "loop",
  /**
   * Get the value of `playsinline` from the media element. `playsinline` indicates
   * to the browser that non-fullscreen playback is preferred when fullscreen
   * playback is the native default, such as in iOS Safari.
   *
   * @method Html5#playsinline
   * @return {boolean}
   *         - The value of `playsinline` from the media element.
   *         - True indicates that the media should play inline.
   *         - False indicates that the media should not play inline.
   *
   * @see [Spec]{@link https://html.spec.whatwg.org/#attr-video-playsinline}
   */
  "playsinline"
].forEach(function(t) {
  je.prototype[t] = function() {
    return this.el_[t] || this.el_.hasAttribute(t);
  };
});
[
  /**
   * Set the value of `muted` on the media element. `muted` indicates that the current
   * audio level should be silent.
   *
   * @method Html5#setMuted
   * @param {boolean} muted
   *        - True if the audio should be set to silent
   *        - False otherwise
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-muted}
   */
  "muted",
  /**
   * Set the value of `defaultMuted` on the media element. `defaultMuted` indicates that the current
   * audio level should be silent, but will only effect the muted level on initial playback..
   *
   * @method Html5.prototype.setDefaultMuted
   * @param {boolean} defaultMuted
   *        - True if the audio should be set to silent
   *        - False otherwise
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-defaultmuted}
   */
  "defaultMuted",
  /**
   * Set the value of `autoplay` on the media element. `autoplay` indicates
   * that the media should start to play as soon as the page is ready.
   *
   * @method Html5#setAutoplay
   * @param {boolean} autoplay
   *         - True indicates that the media should start as soon as the page loads.
   *         - False indicates that the media should not start as soon as the page loads.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-autoplay}
   */
  "autoplay",
  /**
   * Set the value of `loop` on the media element. `loop` indicates
   * that the media should return to the start of the media and continue playing once
   * it reaches the end.
   *
   * @method Html5#setLoop
   * @param {boolean} loop
   *         - True indicates that playback should seek back to start once
   *           the end of a media is reached.
   *         - False indicates that playback should not loop back to the start when the
   *           end of the media is reached.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-loop}
   */
  "loop",
  /**
   * Set the value of `playsinline` from the media element. `playsinline` indicates
   * to the browser that non-fullscreen playback is preferred when fullscreen
   * playback is the native default, such as in iOS Safari.
   *
   * @method Html5#setPlaysinline
   * @param {boolean} playsinline
   *         - True indicates that the media should play inline.
   *         - False indicates that the media should not play inline.
   *
   * @see [Spec]{@link https://html.spec.whatwg.org/#attr-video-playsinline}
   */
  "playsinline"
].forEach(function(t) {
  je.prototype["set" + qt(t)] = function(e) {
    this.el_[t] = e, e ? this.el_.setAttribute(t, t) : this.el_.removeAttribute(t);
  };
});
[
  /**
   * Get the value of `paused` from the media element. `paused` indicates whether the media element
   * is currently paused or not.
   *
   * @method Html5#paused
   * @return {boolean}
   *         The value of `paused` from the media element.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-paused}
   */
  "paused",
  /**
   * Get the value of `currentTime` from the media element. `currentTime` indicates
   * the current second that the media is at in playback.
   *
   * @method Html5#currentTime
   * @return {number}
   *         The value of `currentTime` from the media element.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-currenttime}
   */
  "currentTime",
  /**
   * Get the value of `buffered` from the media element. `buffered` is a `TimeRange`
   * object that represents the parts of the media that are already downloaded and
   * available for playback.
   *
   * @method Html5#buffered
   * @return {TimeRange}
   *         The value of `buffered` from the media element.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-buffered}
   */
  "buffered",
  /**
   * Get the value of `volume` from the media element. `volume` indicates
   * the current playback volume of audio for a media. `volume` will be a value from 0
   * (silent) to 1 (loudest and default).
   *
   * @method Html5#volume
   * @return {number}
   *         The value of `volume` from the media element. Value will be between 0-1.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-a-volume}
   */
  "volume",
  /**
   * Get the value of `poster` from the media element. `poster` indicates
   * that the url of an image file that can/will be shown when no media data is available.
   *
   * @method Html5#poster
   * @return {string}
   *         The value of `poster` from the media element. Value will be a url to an
   *         image.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-video-poster}
   */
  "poster",
  /**
   * Get the value of `preload` from the media element. `preload` indicates
   * what should download before the media is interacted with. It can have the following
   * values:
   * - none: nothing should be downloaded
   * - metadata: poster and the first few frames of the media may be downloaded to get
   *   media dimensions and other metadata
   * - auto: allow the media and metadata for the media to be downloaded before
   *    interaction
   *
   * @method Html5#preload
   * @return {string}
   *         The value of `preload` from the media element. Will be 'none', 'metadata',
   *         or 'auto'.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-preload}
   */
  "preload",
  /**
   * Get the value of the `error` from the media element. `error` indicates any
   * MediaError that may have occurred during playback. If error returns null there is no
   * current error.
   *
   * @method Html5#error
   * @return {MediaError|null}
   *         The value of `error` from the media element. Will be `MediaError` if there
   *         is a current error and null otherwise.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-error}
   */
  "error",
  /**
   * Get the value of `seeking` from the media element. `seeking` indicates whether the
   * media is currently seeking to a new position or not.
   *
   * @method Html5#seeking
   * @return {boolean}
   *         - The value of `seeking` from the media element.
   *         - True indicates that the media is currently seeking to a new position.
   *         - False indicates that the media is not seeking to a new position at this time.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-seeking}
   */
  "seeking",
  /**
   * Get the value of `seekable` from the media element. `seekable` returns a
   * `TimeRange` object indicating ranges of time that can currently be `seeked` to.
   *
   * @method Html5#seekable
   * @return {TimeRange}
   *         The value of `seekable` from the media element. A `TimeRange` object
   *         indicating the current ranges of time that can be seeked to.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-seekable}
   */
  "seekable",
  /**
   * Get the value of `ended` from the media element. `ended` indicates whether
   * the media has reached the end or not.
   *
   * @method Html5#ended
   * @return {boolean}
   *         - The value of `ended` from the media element.
   *         - True indicates that the media has ended.
   *         - False indicates that the media has not ended.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-ended}
   */
  "ended",
  /**
   * Get the value of `playbackRate` from the media element. `playbackRate` indicates
   * the rate at which the media is currently playing back. Examples:
   *   - if playbackRate is set to 2, media will play twice as fast.
   *   - if playbackRate is set to 0.5, media will play half as fast.
   *
   * @method Html5#playbackRate
   * @return {number}
   *         The value of `playbackRate` from the media element. A number indicating
   *         the current playback speed of the media, where 1 is normal speed.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-playbackrate}
   */
  "playbackRate",
  /**
   * Get the value of `defaultPlaybackRate` from the media element. `defaultPlaybackRate` indicates
   * the rate at which the media is currently playing back. This value will not indicate the current
   * `playbackRate` after playback has started, use {@link Html5#playbackRate} for that.
   *
   * Examples:
   *   - if defaultPlaybackRate is set to 2, media will play twice as fast.
   *   - if defaultPlaybackRate is set to 0.5, media will play half as fast.
   *
   * @method Html5.prototype.defaultPlaybackRate
   * @return {number}
   *         The value of `defaultPlaybackRate` from the media element. A number indicating
   *         the current playback speed of the media, where 1 is normal speed.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-playbackrate}
   */
  "defaultPlaybackRate",
  /**
   * Get the value of 'disablePictureInPicture' from the video element.
   *
   * @method Html5#disablePictureInPicture
   * @return {boolean} value
   *         - The value of `disablePictureInPicture` from the video element.
   *         - True indicates that the video can't be played in Picture-In-Picture mode
   *         - False indicates that the video can be played in Picture-In-Picture mode
   *
   * @see [Spec]{@link https://w3c.github.io/picture-in-picture/#disable-pip}
   */
  "disablePictureInPicture",
  /**
   * Get the value of `played` from the media element. `played` returns a `TimeRange`
   * object representing points in the media timeline that have been played.
   *
   * @method Html5#played
   * @return {TimeRange}
   *         The value of `played` from the media element. A `TimeRange` object indicating
   *         the ranges of time that have been played.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-played}
   */
  "played",
  /**
   * Get the value of `networkState` from the media element. `networkState` indicates
   * the current network state. It returns an enumeration from the following list:
   * - 0: NETWORK_EMPTY
   * - 1: NETWORK_IDLE
   * - 2: NETWORK_LOADING
   * - 3: NETWORK_NO_SOURCE
   *
   * @method Html5#networkState
   * @return {number}
   *         The value of `networkState` from the media element. This will be a number
   *         from the list in the description.
   *
   * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-networkstate}
   */
  "networkState",
  /**
   * Get the value of `readyState` from the media element. `readyState` indicates
   * the current state of the media element. It returns an enumeration from the
   * following list:
   * - 0: HAVE_NOTHING
   * - 1: HAVE_METADATA
   * - 2: HAVE_CURRENT_DATA
   * - 3: HAVE_FUTURE_DATA
   * - 4: HAVE_ENOUGH_DATA
   *
   * @method Html5#readyState
   * @return {number}
   *         The value of `readyState` from the media element. This will be a number
   *         from the list in the description.
   *
   * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#ready-states}
   */
  "readyState",
  /**
   * Get the value of `videoWidth` from the video element. `videoWidth` indicates
   * the current width of the video in css pixels.
   *
   * @method Html5#videoWidth
   * @return {number}
   *         The value of `videoWidth` from the video element. This will be a number
   *         in css pixels.
   *
   * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-video-videowidth}
   */
  "videoWidth",
  /**
   * Get the value of `videoHeight` from the video element. `videoHeight` indicates
   * the current height of the video in css pixels.
   *
   * @method Html5#videoHeight
   * @return {number}
   *         The value of `videoHeight` from the video element. This will be a number
   *         in css pixels.
   *
   * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-video-videowidth}
   */
  "videoHeight",
  /**
   * Get the value of `crossOrigin` from the media element. `crossOrigin` indicates
   * to the browser that should sent the cookies along with the requests for the
   * different assets/playlists
   *
   * @method Html5#crossOrigin
   * @return {string}
   *         - anonymous indicates that the media should not sent cookies.
   *         - use-credentials indicates that the media should sent cookies along the requests.
   *
   * @see [Spec]{@link https://html.spec.whatwg.org/#attr-media-crossorigin}
   */
  "crossOrigin"
].forEach(function(t) {
  je.prototype[t] = function() {
    return this.el_[t];
  };
});
[
  /**
   * Set the value of `volume` on the media element. `volume` indicates the current
   * audio level as a percentage in decimal form. This means that 1 is 100%, 0.5 is 50%, and
   * so on.
   *
   * @method Html5#setVolume
   * @param {number} percentAsDecimal
   *        The volume percent as a decimal. Valid range is from 0-1.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-a-volume}
   */
  "volume",
  /**
   * Set the value of `src` on the media element. `src` indicates the current
   * {@link Tech~SourceObject} for the media.
   *
   * @method Html5#setSrc
   * @param {Tech~SourceObject} src
   *        The source object to set as the current source.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-src}
   */
  "src",
  /**
   * Set the value of `poster` on the media element. `poster` is the url to
   * an image file that can/will be shown when no media data is available.
   *
   * @method Html5#setPoster
   * @param {string} poster
   *        The url to an image that should be used as the `poster` for the media
   *        element.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-poster}
   */
  "poster",
  /**
   * Set the value of `preload` on the media element. `preload` indicates
   * what should download before the media is interacted with. It can have the following
   * values:
   * - none: nothing should be downloaded
   * - metadata: poster and the first few frames of the media may be downloaded to get
   *   media dimensions and other metadata
   * - auto: allow the media and metadata for the media to be downloaded before
   *    interaction
   *
   * @method Html5#setPreload
   * @param {string} preload
   *         The value of `preload` to set on the media element. Must be 'none', 'metadata',
   *         or 'auto'.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-preload}
   */
  "preload",
  /**
   * Set the value of `playbackRate` on the media element. `playbackRate` indicates
   * the rate at which the media should play back. Examples:
   *   - if playbackRate is set to 2, media will play twice as fast.
   *   - if playbackRate is set to 0.5, media will play half as fast.
   *
   * @method Html5#setPlaybackRate
   * @return {number}
   *         The value of `playbackRate` from the media element. A number indicating
   *         the current playback speed of the media, where 1 is normal speed.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-playbackrate}
   */
  "playbackRate",
  /**
   * Set the value of `defaultPlaybackRate` on the media element. `defaultPlaybackRate` indicates
   * the rate at which the media should play back upon initial startup. Changing this value
   * after a video has started will do nothing. Instead you should used {@link Html5#setPlaybackRate}.
   *
   * Example Values:
   *   - if playbackRate is set to 2, media will play twice as fast.
   *   - if playbackRate is set to 0.5, media will play half as fast.
   *
   * @method Html5.prototype.setDefaultPlaybackRate
   * @return {number}
   *         The value of `defaultPlaybackRate` from the media element. A number indicating
   *         the current playback speed of the media, where 1 is normal speed.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-defaultplaybackrate}
   */
  "defaultPlaybackRate",
  /**
   * Prevents the browser from suggesting a Picture-in-Picture context menu
   * or to request Picture-in-Picture automatically in some cases.
   *
   * @method Html5#setDisablePictureInPicture
   * @param {boolean} value
   *         The true value will disable Picture-in-Picture mode.
   *
   * @see [Spec]{@link https://w3c.github.io/picture-in-picture/#disable-pip}
   */
  "disablePictureInPicture",
  /**
   * Set the value of `crossOrigin` from the media element. `crossOrigin` indicates
   * to the browser that should sent the cookies along with the requests for the
   * different assets/playlists
   *
   * @method Html5#setCrossOrigin
   * @param {string} crossOrigin
   *         - anonymous indicates that the media should not sent cookies.
   *         - use-credentials indicates that the media should sent cookies along the requests.
   *
   * @see [Spec]{@link https://html.spec.whatwg.org/#attr-media-crossorigin}
   */
  "crossOrigin"
].forEach(function(t) {
  je.prototype["set" + qt(t)] = function(e) {
    this.el_[t] = e;
  };
});
[
  /**
   * A wrapper around the media elements `pause` function. This will call the `HTML5`
   * media elements `pause` function.
   *
   * @method Html5#pause
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-pause}
   */
  "pause",
  /**
   * A wrapper around the media elements `load` function. This will call the `HTML5`s
   * media element `load` function.
   *
   * @method Html5#load
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-load}
   */
  "load",
  /**
   * A wrapper around the media elements `play` function. This will call the `HTML5`s
   * media element `play` function.
   *
   * @method Html5#play
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-play}
   */
  "play"
].forEach(function(t) {
  je.prototype[t] = function() {
    return this.el_[t]();
  };
});
rt.withSourceHandlers(je);
je.nativeSourceHandler = {};
je.nativeSourceHandler.canPlayType = function(t) {
  try {
    return je.TEST_VID.canPlayType(t);
  } catch {
    return "";
  }
};
je.nativeSourceHandler.canHandleSource = function(t, e) {
  if (t.type)
    return je.nativeSourceHandler.canPlayType(t.type);
  if (t.src) {
    const n = fp(t.src);
    return je.nativeSourceHandler.canPlayType(`video/${n}`);
  }
  return "";
};
je.nativeSourceHandler.handleSource = function(t, e, n) {
  e.setSrc(t.src);
};
je.nativeSourceHandler.dispose = function() {
};
je.registerSourceHandler(je.nativeSourceHandler);
rt.registerTech("Html5", je);
const p_ = [
  /**
   * Fired while the user agent is downloading media data.
   *
   * @event Player#progress
   * @type {Event}
   */
  /**
   * Retrigger the `progress` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechProgress_
   * @fires Player#progress
   * @listens Tech#progress
   */
  "progress",
  /**
   * Fires when the loading of an audio/video is aborted.
   *
   * @event Player#abort
   * @type {Event}
   */
  /**
   * Retrigger the `abort` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechAbort_
   * @fires Player#abort
   * @listens Tech#abort
   */
  "abort",
  /**
   * Fires when the browser is intentionally not getting media data.
   *
   * @event Player#suspend
   * @type {Event}
   */
  /**
   * Retrigger the `suspend` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechSuspend_
   * @fires Player#suspend
   * @listens Tech#suspend
   */
  "suspend",
  /**
   * Fires when the current playlist is empty.
   *
   * @event Player#emptied
   * @type {Event}
   */
  /**
   * Retrigger the `emptied` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechEmptied_
   * @fires Player#emptied
   * @listens Tech#emptied
   */
  "emptied",
  /**
   * Fires when the browser is trying to get media data, but data is not available.
   *
   * @event Player#stalled
   * @type {Event}
   */
  /**
   * Retrigger the `stalled` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechStalled_
   * @fires Player#stalled
   * @listens Tech#stalled
   */
  "stalled",
  /**
   * Fires when the browser has loaded meta data for the audio/video.
   *
   * @event Player#loadedmetadata
   * @type {Event}
   */
  /**
   * Retrigger the `loadedmetadata` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechLoadedmetadata_
   * @fires Player#loadedmetadata
   * @listens Tech#loadedmetadata
   */
  "loadedmetadata",
  /**
   * Fires when the browser has loaded the current frame of the audio/video.
   *
   * @event Player#loadeddata
   * @type {event}
   */
  /**
   * Retrigger the `loadeddata` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechLoaddeddata_
   * @fires Player#loadeddata
   * @listens Tech#loadeddata
   */
  "loadeddata",
  /**
   * Fires when the current playback position has changed.
   *
   * @event Player#timeupdate
   * @type {event}
   */
  /**
   * Retrigger the `timeupdate` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechTimeUpdate_
   * @fires Player#timeupdate
   * @listens Tech#timeupdate
   */
  "timeupdate",
  /**
   * Fires when the video's intrinsic dimensions change
   *
   * @event Player#resize
   * @type {event}
   */
  /**
   * Retrigger the `resize` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechResize_
   * @fires Player#resize
   * @listens Tech#resize
   */
  "resize",
  /**
   * Fires when the volume has been changed
   *
   * @event Player#volumechange
   * @type {event}
   */
  /**
   * Retrigger the `volumechange` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechVolumechange_
   * @fires Player#volumechange
   * @listens Tech#volumechange
   */
  "volumechange",
  /**
   * Fires when the text track has been changed
   *
   * @event Player#texttrackchange
   * @type {event}
   */
  /**
   * Retrigger the `texttrackchange` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechTexttrackchange_
   * @fires Player#texttrackchange
   * @listens Tech#texttrackchange
   */
  "texttrackchange"
], $0 = {
  canplay: "CanPlay",
  canplaythrough: "CanPlayThrough",
  playing: "Playing",
  seeked: "Seeked"
}, Dh = ["tiny", "xsmall", "small", "medium", "large", "xlarge", "huge"], Vc = {};
Dh.forEach((t) => {
  const e = t.charAt(0) === "x" ? `x-${t.substring(1)}` : t;
  Vc[t] = `vjs-layout-${e}`;
});
const Kne = {
  tiny: 210,
  xsmall: 320,
  small: 425,
  medium: 768,
  large: 1440,
  xlarge: 2560,
  huge: 1 / 0
};
class Mt extends ye {
  /**
   * Create an instance of this class.
   *
   * @param {Element} tag
   *        The original video DOM element used for configuring options.
   *
   * @param {Object} [options]
   *        Object of option names and values.
   *
   * @param {PlayerReadyCallback} [ready]
   *        Ready callback function.
   */
  constructor(e, n, a) {
    if (e.id = e.id || n.id || `vjs_video_${xa()}`, n = Object.assign(Mt.getTagSettings(e), n), n.initChildren = !1, n.createEl = !1, n.evented = !1, n.reportTouchActivity = !1, !n.language) {
      const s = e.closest("[lang]");
      s && (n.language = s.getAttribute("lang"));
    }
    if (super(null, n, a), this.boundDocumentFullscreenChange_ = (s) => this.documentFullscreenChange_(s), this.boundFullWindowOnEscKey_ = (s) => this.fullWindowOnEscKey(s), this.boundUpdateStyleEl_ = (s) => this.updateStyleEl_(s), this.boundApplyInitTime_ = (s) => this.applyInitTime_(s), this.boundUpdateCurrentBreakpoint_ = (s) => this.updateCurrentBreakpoint_(s), this.boundHandleTechClick_ = (s) => this.handleTechClick_(s), this.boundHandleTechDoubleClick_ = (s) => this.handleTechDoubleClick_(s), this.boundHandleTechTouchStart_ = (s) => this.handleTechTouchStart_(s), this.boundHandleTechTouchMove_ = (s) => this.handleTechTouchMove_(s), this.boundHandleTechTouchEnd_ = (s) => this.handleTechTouchEnd_(s), this.boundHandleTechTap_ = (s) => this.handleTechTap_(s), this.boundUpdatePlayerHeightOnAudioOnlyMode_ = (s) => this.updatePlayerHeightOnAudioOnlyMode_(s), this.isFullscreen_ = !1, this.log = e3(this.id_), this.fsApi_ = yu, this.isPosterFromTech_ = !1, this.queuedCallbacks_ = [], this.isReady_ = !1, this.hasStarted_ = !1, this.userActive_ = !1, this.debugEnabled_ = !1, this.audioOnlyMode_ = !1, this.audioPosterMode_ = !1, this.audioOnlyCache_ = {
      controlBarHeight: null,
      playerHeight: null,
      hiddenChildren: []
    }, !this.options_ || !this.options_.techOrder || !this.options_.techOrder.length)
      throw new Error("No techOrder specified. Did you overwrite videojs.options instead of just changing the properties you want to override?");
    if (this.tag = e, this.tagAttributes = e && qi(e), this.language(this.options_.language), n.languages) {
      const s = {};
      Object.getOwnPropertyNames(n.languages).forEach(function(o) {
        s[o.toLowerCase()] = n.languages[o];
      }), this.languages_ = s;
    } else
      this.languages_ = Mt.prototype.options_.languages;
    this.resetCache_(), this.poster_ = n.poster || "", this.controls_ = !!n.controls, e.controls = !1, e.removeAttribute("controls"), this.changingSrc_ = !1, this.playCallbacks_ = [], this.playTerminatedQueue_ = [], e.hasAttribute("autoplay") ? this.autoplay(!0) : this.autoplay(this.options_.autoplay), n.plugins && Object.keys(n.plugins).forEach((s) => {
      if (typeof this[s] != "function")
        throw new Error(`plugin "${s}" does not exist`);
    }), this.scrubbing_ = !1, this.el_ = this.createEl(), cp(this, {
      eventBusKey: "el_"
    }), this.fsApi_.requestFullscreen && (ha(Me, this.fsApi_.fullscreenchange, this.boundDocumentFullscreenChange_), this.on(this.fsApi_.fullscreenchange, this.boundDocumentFullscreenChange_)), this.fluid_ && this.on(["playerreset", "resize"], this.boundUpdateStyleEl_);
    const i = wt(this.options_);
    if (n.plugins && Object.keys(n.plugins).forEach((s) => {
      this[s](n.plugins[s]);
    }), n.debug && this.debug(!0), this.options_.playerOptions = i, this.middleware_ = [], this.playbackRates(n.playbackRates), n.experimentalSvgIcons) {
      const o = new j.DOMParser().parseFromString(_ne, "image/svg+xml");
      if (o.querySelector("parsererror"))
        ut.warn("Failed to load SVG Icons. Falling back to Font Icons."), this.options_.experimentalSvgIcons = null;
      else {
        const c = o.documentElement;
        c.style.display = "none", this.el_.appendChild(c), this.addClass("vjs-svg-icons-enabled");
      }
    }
    this.initChildren(), this.isAudio(e.nodeName.toLowerCase() === "audio"), this.controls() ? this.addClass("vjs-controls-enabled") : this.addClass("vjs-controls-disabled"), this.el_.setAttribute("role", "region"), this.isAudio() ? this.el_.setAttribute("aria-label", this.localize("Audio Player")) : this.el_.setAttribute("aria-label", this.localize("Video Player")), this.isAudio() && this.addClass("vjs-audio"), n.spatialNavigation && n.spatialNavigation.enabled && (this.spatialNavigation = new Tne(this), this.addClass("vjs-spatial-navigation-enabled")), Ll && this.addClass("vjs-touch-enabled"), En || this.addClass("vjs-workinghover"), Mt.players[this.id_] = this;
    const r = _h.split(".")[0];
    this.addClass(`vjs-v${r}`), this.userActive(!0), this.reportUserActivity(), this.one("play", (s) => this.listenForUserActivity_(s)), this.on("keydown", (s) => this.handleKeyDown(s)), this.on("languagechange", (s) => this.handleLanguagechange(s)), this.breakpoints(this.options_.breakpoints), this.responsive(this.options_.responsive), this.on("ready", () => {
      this.audioPosterMode(this.options_.audioPosterMode), this.audioOnlyMode(this.options_.audioOnlyMode);
    });
  }
  /**
   * Destroys the video player and does any necessary cleanup.
   *
   * This is especially helpful if you are dynamically adding and removing videos
   * to/from the DOM.
   *
   * @fires Player#dispose
   */
  dispose() {
    this.trigger("dispose"), this.off("dispose"), Ln(Me, this.fsApi_.fullscreenchange, this.boundDocumentFullscreenChange_), Ln(Me, "keydown", this.boundFullWindowOnEscKey_), this.styleEl_ && this.styleEl_.parentNode && (this.styleEl_.parentNode.removeChild(this.styleEl_), this.styleEl_ = null), Mt.players[this.id_] = null, this.tag && this.tag.player && (this.tag.player = null), this.el_ && this.el_.player && (this.el_.player = null), this.tech_ && (this.tech_.dispose(), this.isPosterFromTech_ = !1, this.poster_ = ""), this.playerElIngest_ && (this.playerElIngest_ = null), this.tag && (this.tag = null), gne(this), Rn.names.forEach((e) => {
      const n = Rn[e], a = this[n.getterName]();
      a && a.off && a.off();
    }), super.dispose({
      restoreEl: this.options_.restoreEl
    });
  }
  /**
   * Create the `Player`'s DOM element.
   *
   * @return {Element}
   *         The DOM element that gets created.
   */
  createEl() {
    let e = this.tag, n, a = this.playerElIngest_ = e.parentNode && e.parentNode.hasAttribute && e.parentNode.hasAttribute("data-vjs-player");
    const i = this.tag.tagName.toLowerCase() === "video-js";
    a ? n = this.el_ = e.parentNode : i || (n = this.el_ = super.createEl("div"));
    const r = qi(e);
    if (i) {
      for (n = this.el_ = e, e = this.tag = Me.createElement("video"); n.children.length; )
        e.appendChild(n.firstChild);
      hl(n, "video-js") || Dr(n, "video-js"), n.appendChild(e), a = this.playerElIngest_ = n, Object.keys(n).forEach((l) => {
        try {
          e[l] = n[l];
        } catch {
        }
      });
    }
    e.setAttribute("tabindex", "-1"), r.tabindex = "-1", ai && bd && (e.setAttribute("role", "application"), r.role = "application"), e.removeAttribute("width"), e.removeAttribute("height"), "width" in r && delete r.width, "height" in r && delete r.height, Object.getOwnPropertyNames(r).forEach(function(l) {
      i && l === "class" || n.setAttribute(l, r[l]), i && e.setAttribute(l, r[l]);
    }), e.playerId = e.id, e.id += "_html5_api", e.className = "vjs-tech", e.player = n.player = this, this.addClass("vjs-paused");
    const s = ["IS_SMART_TV", "IS_TIZEN", "IS_WEBOS", "IS_ANDROID", "IS_IPAD", "IS_IPHONE", "IS_CHROMECAST_RECEIVER"].filter((l) => l3[l]).map((l) => "vjs-device-" + l.substring(3).toLowerCase().replace(/\_/g, "-"));
    if (this.addClass(...s), j.VIDEOJS_NO_DYNAMIC_STYLE !== !0) {
      this.styleEl_ = w3("vjs-styles-dimensions");
      const l = ir(".vjs-styles-defaults"), c = ir("head");
      c.insertBefore(this.styleEl_, l ? l.nextSibling : c.firstChild);
    }
    this.fill_ = !1, this.fluid_ = !1, this.width(this.options_.width), this.height(this.options_.height), this.fill(this.options_.fill), this.fluid(this.options_.fluid), this.aspectRatio(this.options_.aspectRatio), this.crossOrigin(this.options_.crossOrigin || this.options_.crossorigin);
    const o = e.getElementsByTagName("a");
    for (let l = 0; l < o.length; l++) {
      const c = o.item(l);
      Dr(c, "vjs-hidden"), c.setAttribute("hidden", "hidden");
    }
    return e.initNetworkState_ = e.networkState, e.parentNode && !a && e.parentNode.insertBefore(n, e), xh(e, n), this.children_.unshift(e), this.el_.setAttribute("lang", this.language_), this.el_.setAttribute("translate", "no"), this.el_ = n, n;
  }
  /**
   * Get or set the `Player`'s crossOrigin option. For the HTML5 player, this
   * sets the `crossOrigin` property on the `<video>` tag to control the CORS
   * behavior.
   *
   * @see [Video Element Attributes]{@link https://developer.mozilla.org/en-US/docs/Web/HTML/Element/video#attr-crossorigin}
   *
   * @param {string|null} [value]
   *        The value to set the `Player`'s crossOrigin to. If an argument is
   *        given, must be one of `'anonymous'` or `'use-credentials'`, or 'null'.
   *
   * @return {string|null|undefined}
   *         - The current crossOrigin value of the `Player` when getting.
   *         - undefined when setting
   */
  crossOrigin(e) {
    if (typeof e > "u")
      return this.techGet_("crossOrigin");
    if (e !== null && e !== "anonymous" && e !== "use-credentials") {
      ut.warn(`crossOrigin must be null,  "anonymous" or "use-credentials", given "${e}"`);
      return;
    }
    this.techCall_("setCrossOrigin", e), this.posterImage && this.posterImage.crossOrigin(e);
  }
  /**
   * A getter/setter for the `Player`'s width. Returns the player's configured value.
   * To get the current width use `currentWidth()`.
   *
   * @param {number|string} [value]
   *        CSS value to set the `Player`'s width to.
   *
   * @return {number|undefined}
   *         - The current width of the `Player` when getting.
   *         - Nothing when setting
   */
  width(e) {
    return this.dimension("width", e);
  }
  /**
   * A getter/setter for the `Player`'s height. Returns the player's configured value.
   * To get the current height use `currentheight()`.
   *
   * @param {number|string} [value]
   *        CSS value to set the `Player`'s height to.
   *
   * @return {number|undefined}
   *         - The current height of the `Player` when getting.
   *         - Nothing when setting
   */
  height(e) {
    return this.dimension("height", e);
  }
  /**
   * A getter/setter for the `Player`'s width & height.
   *
   * @param {string} dimension
   *        This string can be:
   *        - 'width'
   *        - 'height'
   *
   * @param {number|string} [value]
   *        Value for dimension specified in the first argument.
   *
   * @return {number}
   *         The dimension arguments value when getting (width/height).
   */
  dimension(e, n) {
    const a = e + "_";
    if (n === void 0)
      return this[a] || 0;
    if (n === "" || n === "auto") {
      this[a] = void 0, this.updateStyleEl_();
      return;
    }
    const i = parseFloat(n);
    if (isNaN(i)) {
      ut.error(`Improper value "${n}" supplied for for ${e}`);
      return;
    }
    this[a] = i, this.updateStyleEl_();
  }
  /**
   * A getter/setter/toggler for the vjs-fluid `className` on the `Player`.
   *
   * Turning this on will turn off fill mode.
   *
   * @param {boolean} [bool]
   *        - A value of true adds the class.
   *        - A value of false removes the class.
   *        - No value will be a getter.
   *
   * @return {boolean|undefined}
   *         - The value of fluid when getting.
   *         - `undefined` when setting.
   */
  fluid(e) {
    if (e === void 0)
      return !!this.fluid_;
    this.fluid_ = !!e, xi(this) && this.off(["playerreset", "resize"], this.boundUpdateStyleEl_), e ? (this.addClass("vjs-fluid"), this.fill(!1), qte(this, () => {
      this.on(["playerreset", "resize"], this.boundUpdateStyleEl_);
    })) : this.removeClass("vjs-fluid"), this.updateStyleEl_();
  }
  /**
   * A getter/setter/toggler for the vjs-fill `className` on the `Player`.
   *
   * Turning this on will turn off fluid mode.
   *
   * @param {boolean} [bool]
   *        - A value of true adds the class.
   *        - A value of false removes the class.
   *        - No value will be a getter.
   *
   * @return {boolean|undefined}
   *         - The value of fluid when getting.
   *         - `undefined` when setting.
   */
  fill(e) {
    if (e === void 0)
      return !!this.fill_;
    this.fill_ = !!e, e ? (this.addClass("vjs-fill"), this.fluid(!1)) : this.removeClass("vjs-fill");
  }
  /**
   * Get/Set the aspect ratio
   *
   * @param {string} [ratio]
   *        Aspect ratio for player
   *
   * @return {string|undefined}
   *         returns the current aspect ratio when getting
   */
  /**
   * A getter/setter for the `Player`'s aspect ratio.
   *
   * @param {string} [ratio]
   *        The value to set the `Player`'s aspect ratio to.
   *
   * @return {string|undefined}
   *         - The current aspect ratio of the `Player` when getting.
   *         - undefined when setting
   */
  aspectRatio(e) {
    if (e === void 0)
      return this.aspectRatio_;
    if (!/^\d+\:\d+$/.test(e))
      throw new Error("Improper value supplied for aspect ratio. The format should be width:height, for example 16:9.");
    this.aspectRatio_ = e, this.fluid(!0), this.updateStyleEl_();
  }
  /**
   * Update styles of the `Player` element (height, width and aspect ratio).
   *
   * @private
   * @listens Tech#loadedmetadata
   */
  updateStyleEl_() {
    if (j.VIDEOJS_NO_DYNAMIC_STYLE === !0) {
      const o = typeof this.width_ == "number" ? this.width_ : this.options_.width, l = typeof this.height_ == "number" ? this.height_ : this.options_.height, c = this.tech_ && this.tech_.el();
      c && (o >= 0 && (c.width = o), l >= 0 && (c.height = l));
      return;
    }
    let e, n, a, i;
    this.aspectRatio_ !== void 0 && this.aspectRatio_ !== "auto" ? a = this.aspectRatio_ : this.videoWidth() > 0 ? a = this.videoWidth() + ":" + this.videoHeight() : a = "16:9";
    const r = a.split(":"), s = r[1] / r[0];
    this.width_ !== void 0 ? e = this.width_ : this.height_ !== void 0 ? e = this.height_ / s : e = this.videoWidth() || 300, this.height_ !== void 0 ? n = this.height_ : n = e * s, /^[^a-zA-Z]/.test(this.id()) ? i = "dimensions-" + this.id() : i = this.id() + "-dimensions", this.addClass(i), k3(this.styleEl_, `
      .${i} {
        width: ${e}px;
        height: ${n}px;
      }

      .${i}.vjs-fluid:not(.vjs-audio-only-mode) {
        padding-top: ${s * 100}%;
      }
    `);
  }
  /**
   * Load/Create an instance of playback {@link Tech} including element
   * and API methods. Then append the `Tech` element in `Player` as a child.
   *
   * @param {string} techName
   *        name of the playback technology
   *
   * @param {string} source
   *        video source
   *
   * @private
   */
  loadTech_(e, n) {
    this.tech_ && this.unloadTech_();
    const a = qt(e), i = e.charAt(0).toLowerCase() + e.slice(1);
    a !== "Html5" && this.tag && (rt.getTech("Html5").disposeMediaElement(this.tag), this.tag.player = null, this.tag = null), this.techName_ = a, this.isReady_ = !1;
    let r = this.autoplay();
    (typeof this.autoplay() == "string" || this.autoplay() === !0 && this.options_.normalizeAutoplay) && (r = !1);
    const s = {
      source: n,
      autoplay: r,
      nativeControlsForTouch: this.options_.nativeControlsForTouch,
      playerId: this.id(),
      techId: `${this.id()}_${i}_api`,
      playsinline: this.options_.playsinline,
      preload: this.options_.preload,
      loop: this.options_.loop,
      disablePictureInPicture: this.options_.disablePictureInPicture,
      muted: this.options_.muted,
      poster: this.poster(),
      language: this.language(),
      playerElIngest: this.playerElIngest_ || !1,
      "vtt.js": this.options_["vtt.js"],
      canOverridePoster: !!this.options_.techCanOverridePoster,
      enableSourceset: this.options_.enableSourceset
    };
    Rn.names.forEach((l) => {
      const c = Rn[l];
      s[c.getterName] = this[c.privateName];
    }), Object.assign(s, this.options_[a]), Object.assign(s, this.options_[i]), Object.assign(s, this.options_[e.toLowerCase()]), this.tag && (s.tag = this.tag), n && n.src === this.cache_.src && this.cache_.currentTime > 0 && (s.startTime = this.cache_.currentTime);
    const o = rt.getTech(e);
    if (!o)
      throw new Error(`No Tech named '${a}' exists! '${a}' should be registered using videojs.registerTech()'`);
    this.tech_ = new o(s), this.tech_.ready(Et(this, this.handleTechReady_), !0), ab.jsonToTextTracks(this.textTracksJson_ || [], this.tech_), p_.forEach((l) => {
      this.on(this.tech_, l, (c) => this[`handleTech${qt(l)}_`](c));
    }), Object.keys($0).forEach((l) => {
      this.on(this.tech_, l, (c) => {
        if (this.tech_.playbackRate() === 0 && this.tech_.seeking()) {
          this.queuedCallbacks_.push({
            callback: this[`handleTech${$0[l]}_`].bind(this),
            event: c
          });
          return;
        }
        this[`handleTech${$0[l]}_`](c);
      });
    }), this.on(this.tech_, "loadstart", (l) => this.handleTechLoadStart_(l)), this.on(this.tech_, "sourceset", (l) => this.handleTechSourceset_(l)), this.on(this.tech_, "waiting", (l) => this.handleTechWaiting_(l)), this.on(this.tech_, "ended", (l) => this.handleTechEnded_(l)), this.on(this.tech_, "seeking", (l) => this.handleTechSeeking_(l)), this.on(this.tech_, "play", (l) => this.handleTechPlay_(l)), this.on(this.tech_, "pause", (l) => this.handleTechPause_(l)), this.on(this.tech_, "durationchange", (l) => this.handleTechDurationChange_(l)), this.on(this.tech_, "fullscreenchange", (l, c) => this.handleTechFullscreenChange_(l, c)), this.on(this.tech_, "fullscreenerror", (l, c) => this.handleTechFullscreenError_(l, c)), this.on(this.tech_, "enterpictureinpicture", (l) => this.handleTechEnterPictureInPicture_(l)), this.on(this.tech_, "leavepictureinpicture", (l) => this.handleTechLeavePictureInPicture_(l)), this.on(this.tech_, "error", (l) => this.handleTechError_(l)), this.on(this.tech_, "posterchange", (l) => this.handleTechPosterChange_(l)), this.on(this.tech_, "textdata", (l) => this.handleTechTextData_(l)), this.on(this.tech_, "ratechange", (l) => this.handleTechRateChange_(l)), this.on(this.tech_, "loadedmetadata", this.boundUpdateStyleEl_), this.usingNativeControls(this.techGet_("controls")), this.controls() && !this.usingNativeControls() && this.addTechControlsListeners_(), this.tech_.el().parentNode !== this.el() && (a !== "Html5" || !this.tag) && xh(this.tech_.el(), this.el()), this.tag && (this.tag.player = null, this.tag = null);
  }
  /**
   * Unload and dispose of the current playback {@link Tech}.
   *
   * @private
   */
  unloadTech_() {
    Rn.names.forEach((e) => {
      const n = Rn[e];
      this[n.privateName] = this[n.getterName]();
    }), this.textTracksJson_ = ab.textTracksToJson(this.tech_), this.isReady_ = !1, this.tech_.dispose(), this.tech_ = !1, this.isPosterFromTech_ && (this.poster_ = "", this.trigger("posterchange")), this.isPosterFromTech_ = !1;
  }
  /**
   * Return a reference to the current {@link Tech}.
   * It will print a warning by default about the danger of using the tech directly
   * but any argument that is passed in will silence the warning.
   *
   * @param {*} [safety]
   *        Anything passed in to silence the warning
   *
   * @return {Tech}
   *         The Tech
   */
  tech(e) {
    return e === void 0 && ut.warn(`Using the tech directly can be dangerous. I hope you know what you're doing.
See https://github.com/videojs/video.js/issues/2617 for more info.
`), this.tech_;
  }
  /**
   * An object that contains Video.js version.
   *
   * @typedef {Object} PlayerVersion
   *
   * @property {string} 'video.js' - Video.js version
   */
  /**
   * Returns an object with Video.js version.
   *
   * @return {PlayerVersion}
   *          An object with Video.js version.
   */
  version() {
    return {
      "video.js": _h
    };
  }
  /**
   * Set up click and touch listeners for the playback element
   *
   * - On desktops: a click on the video itself will toggle playback
   * - On mobile devices: a click on the video toggles controls
   *   which is done by toggling the user state between active and
   *   inactive
   * - A tap can signal that a user has become active or has become inactive
   *   e.g. a quick tap on an iPhone movie should reveal the controls. Another
   *   quick tap should hide them again (signaling the user is in an inactive
   *   viewing state)
   * - In addition to this, we still want the user to be considered inactive after
   *   a few seconds of inactivity.
   *
   * > Note: the only part of iOS interaction we can't mimic with this setup
   * is a touch and hold on the video element counting as activity in order to
   * keep the controls showing, but that shouldn't be an issue. A touch and hold
   * on any controls will still keep the user active
   *
   * @private
   */
  addTechControlsListeners_() {
    this.removeTechControlsListeners_(), this.on(this.tech_, "click", this.boundHandleTechClick_), this.on(this.tech_, "dblclick", this.boundHandleTechDoubleClick_), this.on(this.tech_, "touchstart", this.boundHandleTechTouchStart_), this.on(this.tech_, "touchmove", this.boundHandleTechTouchMove_), this.on(this.tech_, "touchend", this.boundHandleTechTouchEnd_), this.on(this.tech_, "tap", this.boundHandleTechTap_);
  }
  /**
   * Remove the listeners used for click and tap controls. This is needed for
   * toggling to controls disabled, where a tap/touch should do nothing.
   *
   * @private
   */
  removeTechControlsListeners_() {
    this.off(this.tech_, "tap", this.boundHandleTechTap_), this.off(this.tech_, "touchstart", this.boundHandleTechTouchStart_), this.off(this.tech_, "touchmove", this.boundHandleTechTouchMove_), this.off(this.tech_, "touchend", this.boundHandleTechTouchEnd_), this.off(this.tech_, "click", this.boundHandleTechClick_), this.off(this.tech_, "dblclick", this.boundHandleTechDoubleClick_);
  }
  /**
   * Player waits for the tech to be ready
   *
   * @private
   */
  handleTechReady_() {
    this.triggerReady(), this.cache_.volume && this.techCall_("setVolume", this.cache_.volume), this.handleTechPosterChange_(), this.handleTechDurationChange_();
  }
  /**
   * Retrigger the `loadstart` event that was triggered by the {@link Tech}.
   *
   * @fires Player#loadstart
   * @listens Tech#loadstart
   * @private
   */
  handleTechLoadStart_() {
    this.removeClass("vjs-ended", "vjs-seeking"), this.error(null), this.handleTechDurationChange_(), this.paused() ? (this.hasStarted(!1), this.trigger("loadstart")) : this.trigger("loadstart"), this.manualAutoplay_(this.autoplay() === !0 && this.options_.normalizeAutoplay ? "play" : this.autoplay());
  }
  /**
   * Handle autoplay string values, rather than the typical boolean
   * values that should be handled by the tech. Note that this is not
   * part of any specification. Valid values and what they do can be
   * found on the autoplay getter at Player#autoplay()
   */
  manualAutoplay_(e) {
    if (!this.tech_ || typeof e != "string")
      return;
    const n = () => {
      const i = this.muted();
      this.muted(!0);
      const r = () => {
        this.muted(i);
      };
      this.playTerminatedQueue_.push(r);
      const s = this.play();
      if (pl(s))
        return s.catch((o) => {
          throw r(), new Error(`Rejection at manualAutoplay. Restoring muted value. ${o || ""}`);
        });
    };
    let a;
    if (e === "any" && !this.muted() ? (a = this.play(), pl(a) && (a = a.catch(n))) : e === "muted" && !this.muted() ? a = n() : a = this.play(), !!pl(a))
      return a.then(() => {
        this.trigger({
          type: "autoplay-success",
          autoplay: e
        });
      }).catch(() => {
        this.trigger({
          type: "autoplay-failure",
          autoplay: e
        });
      });
  }
  /**
   * Update the internal source caches so that we return the correct source from
   * `src()`, `currentSource()`, and `currentSources()`.
   *
   * > Note: `currentSources` will not be updated if the source that is passed in exists
   *         in the current `currentSources` cache.
   *
   *
   * @param {Tech~SourceObject} srcObj
   *        A string or object source to update our caches to.
   */
  updateSourceCaches_(e = "") {
    let n = e, a = "";
    typeof n != "string" && (n = e.src, a = e.type), this.cache_.source = this.cache_.source || {}, this.cache_.sources = this.cache_.sources || [], n && !a && (a = yne(this, n)), this.cache_.source = wt({}, e, {
      src: n,
      type: a
    });
    const i = this.cache_.sources.filter((l) => l.src && l.src === n), r = [], s = this.$$("source"), o = [];
    for (let l = 0; l < s.length; l++) {
      const c = qi(s[l]);
      r.push(c), c.src && c.src === n && o.push(c.src);
    }
    o.length && !i.length ? this.cache_.sources = r : i.length || (this.cache_.sources = [this.cache_.source]), this.cache_.src = n;
  }
  /**
   * *EXPERIMENTAL* Fired when the source is set or changed on the {@link Tech}
   * causing the media element to reload.
   *
   * It will fire for the initial source and each subsequent source.
   * This event is a custom event from Video.js and is triggered by the {@link Tech}.
   *
   * The event object for this event contains a `src` property that will contain the source
   * that was available when the event was triggered. This is generally only necessary if Video.js
   * is switching techs while the source was being changed.
   *
   * It is also fired when `load` is called on the player (or media element)
   * because the {@link https://html.spec.whatwg.org/multipage/media.html#dom-media-load|specification for `load`}
   * says that the resource selection algorithm needs to be aborted and restarted.
   * In this case, it is very likely that the `src` property will be set to the
   * empty string `""` to indicate we do not know what the source will be but
   * that it is changing.
   *
   * *This event is currently still experimental and may change in minor releases.*
   * __To use this, pass `enableSourceset` option to the player.__
   *
   * @event Player#sourceset
   * @type {Event}
   * @prop {string} src
   *                The source url available when the `sourceset` was triggered.
   *                It will be an empty string if we cannot know what the source is
   *                but know that the source will change.
   */
  /**
   * Retrigger the `sourceset` event that was triggered by the {@link Tech}.
   *
   * @fires Player#sourceset
   * @listens Tech#sourceset
   * @private
   */
  handleTechSourceset_(e) {
    if (!this.changingSrc_) {
      let n = (r) => this.updateSourceCaches_(r);
      const a = this.currentSource().src, i = e.src;
      a && !/^blob:/.test(a) && /^blob:/.test(i) && (!this.lastSource_ || this.lastSource_.tech !== i && this.lastSource_.player !== a) && (n = () => {
      }), n(i), e.src || this.tech_.any(["sourceset", "loadstart"], (r) => {
        if (r.type === "sourceset")
          return;
        const s = this.techGet_("currentSrc");
        this.lastSource_.tech = s, this.updateSourceCaches_(s);
      });
    }
    this.lastSource_ = {
      player: this.currentSource().src,
      tech: e.src
    }, this.trigger({
      src: e.src,
      type: "sourceset"
    });
  }
  /**
   * Add/remove the vjs-has-started class
   *
   *
   * @param {boolean} request
   *        - true: adds the class
   *        - false: remove the class
   *
   * @return {boolean}
   *         the boolean value of hasStarted_
   */
  hasStarted(e) {
    if (e === void 0)
      return this.hasStarted_;
    e !== this.hasStarted_ && (this.hasStarted_ = e, this.hasStarted_ ? this.addClass("vjs-has-started") : this.removeClass("vjs-has-started"));
  }
  /**
   * Fired whenever the media begins or resumes playback
   *
   * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-play}
   * @fires Player#play
   * @listens Tech#play
   * @private
   */
  handleTechPlay_() {
    this.removeClass("vjs-ended", "vjs-paused"), this.addClass("vjs-playing"), this.hasStarted(!0), this.trigger("play");
  }
  /**
   * Retrigger the `ratechange` event that was triggered by the {@link Tech}.
   *
   * If there were any events queued while the playback rate was zero, fire
   * those events now.
   *
   * @private
   * @method Player#handleTechRateChange_
   * @fires Player#ratechange
   * @listens Tech#ratechange
   */
  handleTechRateChange_() {
    this.tech_.playbackRate() > 0 && this.cache_.lastPlaybackRate === 0 && (this.queuedCallbacks_.forEach((e) => e.callback(e.event)), this.queuedCallbacks_ = []), this.cache_.lastPlaybackRate = this.tech_.playbackRate(), this.trigger("ratechange");
  }
  /**
   * Retrigger the `waiting` event that was triggered by the {@link Tech}.
   *
   * @fires Player#waiting
   * @listens Tech#waiting
   * @private
   */
  handleTechWaiting_() {
    this.addClass("vjs-waiting"), this.trigger("waiting");
    const e = this.currentTime(), n = () => {
      e !== this.currentTime() && (this.removeClass("vjs-waiting"), this.off("timeupdate", n));
    };
    this.on("timeupdate", n);
  }
  /**
   * Retrigger the `canplay` event that was triggered by the {@link Tech}.
   * > Note: This is not consistent between browsers. See #1351
   *
   * @fires Player#canplay
   * @listens Tech#canplay
   * @private
   */
  handleTechCanPlay_() {
    this.removeClass("vjs-waiting"), this.trigger("canplay");
  }
  /**
   * Retrigger the `canplaythrough` event that was triggered by the {@link Tech}.
   *
   * @fires Player#canplaythrough
   * @listens Tech#canplaythrough
   * @private
   */
  handleTechCanPlayThrough_() {
    this.removeClass("vjs-waiting"), this.trigger("canplaythrough");
  }
  /**
   * Retrigger the `playing` event that was triggered by the {@link Tech}.
   *
   * @fires Player#playing
   * @listens Tech#playing
   * @private
   */
  handleTechPlaying_() {
    this.removeClass("vjs-waiting"), this.trigger("playing");
  }
  /**
   * Retrigger the `seeking` event that was triggered by the {@link Tech}.
   *
   * @fires Player#seeking
   * @listens Tech#seeking
   * @private
   */
  handleTechSeeking_() {
    this.addClass("vjs-seeking"), this.trigger("seeking");
  }
  /**
   * Retrigger the `seeked` event that was triggered by the {@link Tech}.
   *
   * @fires Player#seeked
   * @listens Tech#seeked
   * @private
   */
  handleTechSeeked_() {
    this.removeClass("vjs-seeking", "vjs-ended"), this.trigger("seeked");
  }
  /**
   * Retrigger the `pause` event that was triggered by the {@link Tech}.
   *
   * @fires Player#pause
   * @listens Tech#pause
   * @private
   */
  handleTechPause_() {
    this.removeClass("vjs-playing"), this.addClass("vjs-paused"), this.trigger("pause");
  }
  /**
   * Retrigger the `ended` event that was triggered by the {@link Tech}.
   *
   * @fires Player#ended
   * @listens Tech#ended
   * @private
   */
  handleTechEnded_() {
    this.addClass("vjs-ended"), this.removeClass("vjs-waiting"), this.options_.loop ? (this.currentTime(0), this.play()) : this.paused() || this.pause(), this.trigger("ended");
  }
  /**
   * Fired when the duration of the media resource is first known or changed
   *
   * @listens Tech#durationchange
   * @private
   */
  handleTechDurationChange_() {
    this.duration(this.techGet_("duration"));
  }
  /**
   * Handle a click on the media element to play/pause
   *
   * @param {Event} event
   *        the event that caused this function to trigger
   *
   * @listens Tech#click
   * @private
   */
  handleTechClick_(e) {
    this.controls_ && (this.options_ === void 0 || this.options_.userActions === void 0 || this.options_.userActions.click === void 0 || this.options_.userActions.click !== !1) && (this.options_ !== void 0 && this.options_.userActions !== void 0 && typeof this.options_.userActions.click == "function" ? this.options_.userActions.click.call(this, e) : this.paused() ? Xa(this.play()) : this.pause());
  }
  /**
   * Handle a double-click on the media element to enter/exit fullscreen,
   * or exit documentPictureInPicture mode
   *
   * @param {Event} event
   *        the event that caused this function to trigger
   *
   * @listens Tech#dblclick
   * @private
   */
  handleTechDoubleClick_(e) {
    if (!this.controls_)
      return;
    Array.prototype.some.call(this.$$(".vjs-control-bar, .vjs-modal-dialog"), (a) => a.contains(e.target)) || (this.options_ === void 0 || this.options_.userActions === void 0 || this.options_.userActions.doubleClick === void 0 || this.options_.userActions.doubleClick !== !1) && (this.options_ !== void 0 && this.options_.userActions !== void 0 && typeof this.options_.userActions.doubleClick == "function" ? this.options_.userActions.doubleClick.call(this, e) : this.isInPictureInPicture() && !Me.pictureInPictureElement ? this.exitPictureInPicture() : this.isFullscreen() ? this.exitFullscreen() : this.requestFullscreen());
  }
  /**
   * Handle a tap on the media element. It will toggle the user
   * activity state, which hides and shows the controls.
   *
   * @listens Tech#tap
   * @private
   */
  handleTechTap_() {
    this.userActive(!this.userActive());
  }
  /**
   * Handle touch to start
   *
   * @listens Tech#touchstart
   * @private
   */
  handleTechTouchStart_() {
    this.userWasActive = this.userActive();
  }
  /**
   * Handle touch to move
   *
   * @listens Tech#touchmove
   * @private
   */
  handleTechTouchMove_() {
    this.userWasActive && this.reportUserActivity();
  }
  /**
   * Handle touch to end
   *
   * @param {Event} event
   *        the touchend event that triggered
   *        this function
   *
   * @listens Tech#touchend
   * @private
   */
  handleTechTouchEnd_(e) {
    e.cancelable && e.preventDefault();
  }
  /**
   * @private
   */
  toggleFullscreenClass_() {
    this.isFullscreen() ? this.addClass("vjs-fullscreen") : this.removeClass("vjs-fullscreen");
  }
  /**
   * when the document fschange event triggers it calls this
   */
  documentFullscreenChange_(e) {
    const n = e.target.player;
    if (n && n !== this)
      return;
    const a = this.el();
    let i = Me[this.fsApi_.fullscreenElement] === a;
    !i && a.matches && (i = a.matches(":" + this.fsApi_.fullscreen)), this.isFullscreen(i);
  }
  /**
   * Handle Tech Fullscreen Change
   *
   * @param {Event} event
   *        the fullscreenchange event that triggered this function
   *
   * @param {Object} data
   *        the data that was sent with the event
   *
   * @private
   * @listens Tech#fullscreenchange
   * @fires Player#fullscreenchange
   */
  handleTechFullscreenChange_(e, n) {
    n && (n.nativeIOSFullscreen && (this.addClass("vjs-ios-native-fs"), this.tech_.one("webkitendfullscreen", () => {
      this.removeClass("vjs-ios-native-fs");
    })), this.isFullscreen(n.isFullscreen));
  }
  handleTechFullscreenError_(e, n) {
    this.trigger("fullscreenerror", n);
  }
  /**
   * @private
   */
  togglePictureInPictureClass_() {
    this.isInPictureInPicture() ? this.addClass("vjs-picture-in-picture") : this.removeClass("vjs-picture-in-picture");
  }
  /**
   * Handle Tech Enter Picture-in-Picture.
   *
   * @param {Event} event
   *        the enterpictureinpicture event that triggered this function
   *
   * @private
   * @listens Tech#enterpictureinpicture
   */
  handleTechEnterPictureInPicture_(e) {
    this.isInPictureInPicture(!0);
  }
  /**
   * Handle Tech Leave Picture-in-Picture.
   *
   * @param {Event} event
   *        the leavepictureinpicture event that triggered this function
   *
   * @private
   * @listens Tech#leavepictureinpicture
   */
  handleTechLeavePictureInPicture_(e) {
    this.isInPictureInPicture(!1);
  }
  /**
   * Fires when an error occurred during the loading of an audio/video.
   *
   * @private
   * @listens Tech#error
   */
  handleTechError_() {
    const e = this.tech_.error();
    e && this.error(e);
  }
  /**
   * Retrigger the `textdata` event that was triggered by the {@link Tech}.
   *
   * @fires Player#textdata
   * @listens Tech#textdata
   * @private
   */
  handleTechTextData_() {
    let e = null;
    arguments.length > 1 && (e = arguments[1]), this.trigger("textdata", e);
  }
  /**
   * Get object for cached values.
   *
   * @return {Object}
   *         get the current object cache
   */
  getCache() {
    return this.cache_;
  }
  /**
   * Resets the internal cache object.
   *
   * Using this function outside the player constructor or reset method may
   * have unintended side-effects.
   *
   * @private
   */
  resetCache_() {
    this.cache_ = {
      // Right now, the currentTime is not _really_ cached because it is always
      // retrieved from the tech (see: currentTime). However, for completeness,
      // we set it to zero here to ensure that if we do start actually caching
      // it, we reset it along with everything else.
      currentTime: 0,
      initTime: 0,
      inactivityTimeout: this.options_.inactivityTimeout,
      duration: NaN,
      lastVolume: 1,
      lastPlaybackRate: this.defaultPlaybackRate(),
      media: null,
      src: "",
      source: {},
      sources: [],
      playbackRates: [],
      volume: 1
    };
  }
  /**
   * Pass values to the playback tech
   *
   * @param {string} [method]
   *        the method to call
   *
   * @param {Object} [arg]
   *        the argument to pass
   *
   * @private
   */
  techCall_(e, n) {
    this.ready(function() {
      if (e in pne)
        return hne(this.middleware_, this.tech_, e, n);
      if (e in lb)
        return ob(this.middleware_, this.tech_, e, n);
      try {
        this.tech_ && this.tech_[e](n);
      } catch (a) {
        throw ut(a), a;
      }
    }, !0);
  }
  /**
   * Mediate attempt to call playback tech method
   * and return the value of the method called.
   *
   * @param {string} method
   *        Tech method
   *
   * @return {*}
   *         Value returned by the tech method called, undefined if tech
   *         is not ready or tech method is not present
   *
   * @private
   */
  techGet_(e) {
    if (!(!this.tech_ || !this.tech_.isReady_)) {
      if (e in fne)
        return dne(this.middleware_, this.tech_, e);
      if (e in lb)
        return ob(this.middleware_, this.tech_, e);
      try {
        return this.tech_[e]();
      } catch (n) {
        throw this.tech_[e] === void 0 ? (ut(`Video.js: ${e} method not defined for ${this.techName_} playback technology.`, n), n) : n.name === "TypeError" ? (ut(`Video.js: ${e} unavailable on ${this.techName_} playback technology element.`, n), this.tech_.isReady_ = !1, n) : (ut(n), n);
      }
    }
  }
  /**
   * Attempt to begin playback at the first opportunity.
   *
   * @return {Promise|undefined}
   *         Returns a promise if the browser supports Promises (or one
   *         was passed in as an option). This promise will be resolved on
   *         the return value of play. If this is undefined it will fulfill the
   *         promise chain otherwise the promise chain will be fulfilled when
   *         the promise from play is fulfilled.
   */
  play() {
    return new Promise((e) => {
      this.play_(e);
    });
  }
  /**
   * The actual logic for play, takes a callback that will be resolved on the
   * return value of play. This allows us to resolve to the play promise if there
   * is one on modern browsers.
   *
   * @private
   * @param {Function} [callback]
   *        The callback that should be called when the techs play is actually called
   */
  play_(e = Xa) {
    this.playCallbacks_.push(e);
    const n = !!(!this.changingSrc_ && (this.src() || this.currentSrc())), a = !!(yd || En);
    if (this.waitToPlay_ && (this.off(["ready", "loadstart"], this.waitToPlay_), this.waitToPlay_ = null), !this.isReady_ || !n) {
      this.waitToPlay_ = (s) => {
        this.play_();
      }, this.one(["ready", "loadstart"], this.waitToPlay_), !n && a && this.load();
      return;
    }
    const i = this.techGet_("play");
    a && this.hasClass("vjs-ended") && this.resetProgressBar_(), i === null ? this.runPlayTerminatedQueue_() : this.runPlayCallbacks_(i);
  }
  /**
   * These functions will be run when if play is terminated. If play
   * runPlayCallbacks_ is run these function will not be run. This allows us
   * to differentiate between a terminated play and an actual call to play.
   */
  runPlayTerminatedQueue_() {
    const e = this.playTerminatedQueue_.slice(0);
    this.playTerminatedQueue_ = [], e.forEach(function(n) {
      n();
    });
  }
  /**
   * When a callback to play is delayed we have to run these
   * callbacks when play is actually called on the tech. This function
   * runs the callbacks that were delayed and accepts the return value
   * from the tech.
   *
   * @param {undefined|Promise} val
   *        The return value from the tech.
   */
  runPlayCallbacks_(e) {
    const n = this.playCallbacks_.slice(0);
    this.playCallbacks_ = [], this.playTerminatedQueue_ = [], n.forEach(function(a) {
      a(e);
    });
  }
  /**
   * Pause the video playback
   */
  pause() {
    this.techCall_("pause");
  }
  /**
   * Check if the player is paused or has yet to play
   *
   * @return {boolean}
   *         - false: if the media is currently playing
   *         - true: if media is not currently playing
   */
  paused() {
    return this.techGet_("paused") !== !1;
  }
  /**
   * Get a TimeRange object representing the current ranges of time that the user
   * has played.
   *
   * @return {TimeRange}
   *         A time range object that represents all the increments of time that have
   *         been played.
   */
  played() {
    return this.techGet_("played") || Ra(0, 0);
  }
  /**
   * Sets or returns whether or not the user is "scrubbing". Scrubbing is
   * when the user has clicked the progress bar handle and is
   * dragging it along the progress bar.
   *
   * @param {boolean} [isScrubbing]
   *        whether the user is or is not scrubbing
   *
   * @return {boolean|undefined}
   *         - The value of scrubbing when getting
   *         - Nothing when setting
   */
  scrubbing(e) {
    if (typeof e > "u")
      return this.scrubbing_;
    this.scrubbing_ = !!e, this.techCall_("setScrubbing", this.scrubbing_), e ? this.addClass("vjs-scrubbing") : this.removeClass("vjs-scrubbing");
  }
  /**
   * Get or set the current time (in seconds)
   *
   * @param {number|string} [seconds]
   *        The time to seek to in seconds
   *
   * @return {number|undefined}
   *         - the current time in seconds when getting
   *         - Nothing when setting
   */
  currentTime(e) {
    if (e === void 0)
      return this.cache_.currentTime = this.techGet_("currentTime") || 0, this.cache_.currentTime;
    if (e < 0 && (e = 0), !this.isReady_ || this.changingSrc_ || !this.tech_ || !this.tech_.isReady_) {
      this.cache_.initTime = e, this.off("canplay", this.boundApplyInitTime_), this.one("canplay", this.boundApplyInitTime_);
      return;
    }
    this.techCall_("setCurrentTime", e), this.cache_.initTime = 0, isFinite(e) && (this.cache_.currentTime = Number(e));
  }
  /**
   * Apply the value of initTime stored in cache as currentTime.
   *
   * @private
   */
  applyInitTime_() {
    this.currentTime(this.cache_.initTime);
  }
  /**
   * Normally gets the length in time of the video in seconds;
   * in all but the rarest use cases an argument will NOT be passed to the method
   *
   * > **NOTE**: The video must have started loading before the duration can be
   * known, and depending on preload behaviour may not be known until the video starts
   * playing.
   *
   * @fires Player#durationchange
   *
   * @param {number} [seconds]
   *        The duration of the video to set in seconds
   *
   * @return {number|undefined}
   *         - The duration of the video in seconds when getting
   *         - Nothing when setting
   */
  duration(e) {
    if (e === void 0)
      return this.cache_.duration !== void 0 ? this.cache_.duration : NaN;
    e = parseFloat(e), e < 0 && (e = 1 / 0), e !== this.cache_.duration && (this.cache_.duration = e, e === 1 / 0 ? this.addClass("vjs-live") : this.removeClass("vjs-live"), isNaN(e) || this.trigger("durationchange"));
  }
  /**
   * Calculates how much time is left in the video. Not part
   * of the native video API.
   *
   * @return {number}
   *         The time remaining in seconds
   */
  remainingTime() {
    return this.duration() - this.currentTime();
  }
  /**
   * A remaining time function that is intended to be used when
   * the time is to be displayed directly to the user.
   *
   * @return {number}
   *         The rounded time remaining in seconds
   */
  remainingTimeDisplay() {
    return Math.floor(this.duration()) - Math.floor(this.currentTime());
  }
  //
  // Kind of like an array of portions of the video that have been downloaded.
  /**
   * Get a TimeRange object with an array of the times of the video
   * that have been downloaded. If you just want the percent of the
   * video that's been downloaded, use bufferedPercent.
   *
   * @see [Buffered Spec]{@link http://dev.w3.org/html5/spec/video.html#dom-media-buffered}
   *
   * @return {TimeRange}
   *         A mock {@link TimeRanges} object (following HTML spec)
   */
  buffered() {
    let e = this.techGet_("buffered");
    return (!e || !e.length) && (e = Ra(0, 0)), e;
  }
  /**
   * Get the TimeRanges of the media that are currently available
   * for seeking to.
   *
   * @see [Seekable Spec]{@link https://html.spec.whatwg.org/multipage/media.html#dom-media-seekable}
   *
   * @return {TimeRange}
   *         A mock {@link TimeRanges} object (following HTML spec)
   */
  seekable() {
    let e = this.techGet_("seekable");
    return (!e || !e.length) && (e = Ra(0, 0)), e;
  }
  /**
   * Returns whether the player is in the "seeking" state.
   *
   * @return {boolean} True if the player is in the seeking state, false if not.
   */
  seeking() {
    return this.techGet_("seeking");
  }
  /**
   * Returns whether the player is in the "ended" state.
   *
   * @return {boolean} True if the player is in the ended state, false if not.
   */
  ended() {
    return this.techGet_("ended");
  }
  /**
   * Returns the current state of network activity for the element, from
   * the codes in the list below.
   * - NETWORK_EMPTY (numeric value 0)
   *   The element has not yet been initialised. All attributes are in
   *   their initial states.
   * - NETWORK_IDLE (numeric value 1)
   *   The element's resource selection algorithm is active and has
   *   selected a resource, but it is not actually using the network at
   *   this time.
   * - NETWORK_LOADING (numeric value 2)
   *   The user agent is actively trying to download data.
   * - NETWORK_NO_SOURCE (numeric value 3)
   *   The element's resource selection algorithm is active, but it has
   *   not yet found a resource to use.
   *
   * @see https://html.spec.whatwg.org/multipage/embedded-content.html#network-states
   * @return {number} the current network activity state
   */
  networkState() {
    return this.techGet_("networkState");
  }
  /**
   * Returns a value that expresses the current state of the element
   * with respect to rendering the current playback position, from the
   * codes in the list below.
   * - HAVE_NOTHING (numeric value 0)
   *   No information regarding the media resource is available.
   * - HAVE_METADATA (numeric value 1)
   *   Enough of the resource has been obtained that the duration of the
   *   resource is available.
   * - HAVE_CURRENT_DATA (numeric value 2)
   *   Data for the immediate current playback position is available.
   * - HAVE_FUTURE_DATA (numeric value 3)
   *   Data for the immediate current playback position is available, as
   *   well as enough data for the user agent to advance the current
   *   playback position in the direction of playback.
   * - HAVE_ENOUGH_DATA (numeric value 4)
   *   The user agent estimates that enough data is available for
   *   playback to proceed uninterrupted.
   *
   * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-readystate
   * @return {number} the current playback rendering state
   */
  readyState() {
    return this.techGet_("readyState");
  }
  /**
   * Get the percent (as a decimal) of the video that's been downloaded.
   * This method is not a part of the native HTML video API.
   *
   * @return {number}
   *         A decimal between 0 and 1 representing the percent
   *         that is buffered 0 being 0% and 1 being 100%
   */
  bufferedPercent() {
    return O3(this.buffered(), this.duration());
  }
  /**
   * Get the ending time of the last buffered time range
   * This is used in the progress bar to encapsulate all time ranges.
   *
   * @return {number}
   *         The end of the last buffered time range
   */
  bufferedEnd() {
    const e = this.buffered(), n = this.duration();
    let a = e.end(e.length - 1);
    return a > n && (a = n), a;
  }
  /**
   * Get or set the current volume of the media
   *
   * @param  {number} [percentAsDecimal]
   *         The new volume as a decimal percent:
   *         - 0 is muted/0%/off
   *         - 1.0 is 100%/full
   *         - 0.5 is half volume or 50%
   *
   * @return {number|undefined}
   *         The current volume as a percent when getting
   */
  volume(e) {
    let n;
    if (e !== void 0) {
      n = Math.max(0, Math.min(1, e)), this.cache_.volume = n, this.techCall_("setVolume", n), n > 0 && this.lastVolume_(n);
      return;
    }
    return n = parseFloat(this.techGet_("volume")), isNaN(n) ? 1 : n;
  }
  /**
   * Get the current muted state, or turn mute on or off
   *
   * @param {boolean} [muted]
   *        - true to mute
   *        - false to unmute
   *
   * @return {boolean|undefined}
   *         - true if mute is on and getting
   *         - false if mute is off and getting
   *         - nothing if setting
   */
  muted(e) {
    if (e !== void 0) {
      this.techCall_("setMuted", e);
      return;
    }
    return this.techGet_("muted") || !1;
  }
  /**
   * Get the current defaultMuted state, or turn defaultMuted on or off. defaultMuted
   * indicates the state of muted on initial playback.
   *
   * ```js
   *   var myPlayer = videojs('some-player-id');
   *
   *   myPlayer.src("http://www.example.com/path/to/video.mp4");
   *
   *   // get, should be false
   *   console.log(myPlayer.defaultMuted());
   *   // set to true
   *   myPlayer.defaultMuted(true);
   *   // get should be true
   *   console.log(myPlayer.defaultMuted());
   * ```
   *
   * @param {boolean} [defaultMuted]
   *        - true to mute
   *        - false to unmute
   *
   * @return {boolean|undefined}
   *         - true if defaultMuted is on and getting
   *         - false if defaultMuted is off and getting
   *         - Nothing when setting
   */
  defaultMuted(e) {
    return e !== void 0 && this.techCall_("setDefaultMuted", e), this.techGet_("defaultMuted") || !1;
  }
  /**
   * Get the last volume, or set it
   *
   * @param  {number} [percentAsDecimal]
   *         The new last volume as a decimal percent:
   *         - 0 is muted/0%/off
   *         - 1.0 is 100%/full
   *         - 0.5 is half volume or 50%
   *
   * @return {number|undefined}
   *         - The current value of lastVolume as a percent when getting
   *         - Nothing when setting
   *
   * @private
   */
  lastVolume_(e) {
    if (e !== void 0 && e !== 0) {
      this.cache_.lastVolume = e;
      return;
    }
    return this.cache_.lastVolume;
  }
  /**
   * Check if current tech can support native fullscreen
   * (e.g. with built in controls like iOS)
   *
   * @return {boolean}
   *         if native fullscreen is supported
   */
  supportsFullScreen() {
    return this.techGet_("supportsFullScreen") || !1;
  }
  /**
   * Check if the player is in fullscreen mode or tell the player that it
   * is or is not in fullscreen mode.
   *
   * > NOTE: As of the latest HTML5 spec, isFullscreen is no longer an official
   * property and instead document.fullscreenElement is used. But isFullscreen is
   * still a valuable property for internal player workings.
   *
   * @param  {boolean} [isFS]
   *         Set the players current fullscreen state
   *
   * @return {boolean|undefined}
   *         - true if fullscreen is on and getting
   *         - false if fullscreen is off and getting
   *         - Nothing when setting
   */
  isFullscreen(e) {
    if (e !== void 0) {
      const n = this.isFullscreen_;
      this.isFullscreen_ = !!e, this.isFullscreen_ !== n && this.fsApi_.prefixed && this.trigger("fullscreenchange"), this.toggleFullscreenClass_();
      return;
    }
    return this.isFullscreen_;
  }
  /**
   * Increase the size of the video to full screen
   * In some browsers, full screen is not supported natively, so it enters
   * "full window mode", where the video fills the browser window.
   * In browsers and devices that support native full screen, sometimes the
   * browser's default controls will be shown, and not the Video.js custom skin.
   * This includes most mobile devices (iOS, Android) and older versions of
   * Safari.
   *
   * @param  {Object} [fullscreenOptions]
   *         Override the player fullscreen options
   *
   * @fires Player#fullscreenchange
   */
  requestFullscreen(e) {
    this.isInPictureInPicture() && this.exitPictureInPicture();
    const n = this;
    return new Promise((a, i) => {
      function r() {
        n.off("fullscreenerror", o), n.off("fullscreenchange", s);
      }
      function s() {
        r(), a();
      }
      function o(c, u) {
        r(), i(u);
      }
      n.one("fullscreenchange", s), n.one("fullscreenerror", o);
      const l = n.requestFullscreenHelper_(e);
      l && (l.then(r, r), l.then(a, i));
    });
  }
  requestFullscreenHelper_(e) {
    let n;
    if (this.fsApi_.prefixed || (n = this.options_.fullscreen && this.options_.fullscreen.options || {}, e !== void 0 && (n = e)), this.fsApi_.requestFullscreen) {
      const a = this.el_[this.fsApi_.requestFullscreen](n);
      return a && a.then(() => this.isFullscreen(!0), () => this.isFullscreen(!1)), a;
    } else this.tech_.supportsFullScreen() && !this.options_.preferFullWindow ? this.techCall_("enterFullScreen") : this.enterFullWindow();
  }
  /**
   * Return the video to its normal size after having been in full screen mode
   *
   * @fires Player#fullscreenchange
   */
  exitFullscreen() {
    const e = this;
    return new Promise((n, a) => {
      function i() {
        e.off("fullscreenerror", s), e.off("fullscreenchange", r);
      }
      function r() {
        i(), n();
      }
      function s(l, c) {
        i(), a(c);
      }
      e.one("fullscreenchange", r), e.one("fullscreenerror", s);
      const o = e.exitFullscreenHelper_();
      o && (o.then(i, i), o.then(n, a));
    });
  }
  exitFullscreenHelper_() {
    if (this.fsApi_.requestFullscreen) {
      const e = Me[this.fsApi_.exitFullscreen]();
      return e && Xa(e.then(() => this.isFullscreen(!1))), e;
    } else this.tech_.supportsFullScreen() && !this.options_.preferFullWindow ? this.techCall_("exitFullScreen") : this.exitFullWindow();
  }
  /**
   * When fullscreen isn't supported we can stretch the
   * video container to as wide as the browser will let us.
   *
   * @fires Player#enterFullWindow
   */
  enterFullWindow() {
    this.isFullscreen(!0), this.isFullWindow = !0, this.docOrigOverflow = Me.documentElement.style.overflow, ha(Me, "keydown", this.boundFullWindowOnEscKey_), Me.documentElement.style.overflow = "hidden", Dr(Me.body, "vjs-full-window"), this.trigger("enterFullWindow");
  }
  /**
   * Check for call to either exit full window or
   * full screen on ESC key
   *
   * @param {string} event
   *        Event to check for key press
   */
  fullWindowOnEscKey(e) {
    e.key === "Escape" && this.isFullscreen() === !0 && (this.isFullWindow ? this.exitFullWindow() : this.exitFullscreen());
  }
  /**
   * Exit full window
   *
   * @fires Player#exitFullWindow
   */
  exitFullWindow() {
    this.isFullscreen(!1), this.isFullWindow = !1, Ln(Me, "keydown", this.boundFullWindowOnEscKey_), Me.documentElement.style.overflow = this.docOrigOverflow, _d(Me.body, "vjs-full-window"), this.trigger("exitFullWindow");
  }
  /**
   * Get or set disable Picture-in-Picture mode.
   *
   * @param {boolean} [value]
   *                  - true will disable Picture-in-Picture mode
   *                  - false will enable Picture-in-Picture mode
   */
  disablePictureInPicture(e) {
    if (e === void 0)
      return this.techGet_("disablePictureInPicture");
    this.techCall_("setDisablePictureInPicture", e), this.options_.disablePictureInPicture = e, this.trigger("disablepictureinpicturechanged");
  }
  /**
   * Check if the player is in Picture-in-Picture mode or tell the player that it
   * is or is not in Picture-in-Picture mode.
   *
   * @param  {boolean} [isPiP]
   *         Set the players current Picture-in-Picture state
   *
   * @return {boolean|undefined}
   *         - true if Picture-in-Picture is on and getting
   *         - false if Picture-in-Picture is off and getting
   *         - nothing if setting
   */
  isInPictureInPicture(e) {
    if (e !== void 0) {
      this.isInPictureInPicture_ = !!e, this.togglePictureInPictureClass_();
      return;
    }
    return !!this.isInPictureInPicture_;
  }
  /**
   * Create a floating video window always on top of other windows so that users may
   * continue consuming media while they interact with other content sites, or
   * applications on their device.
   *
   * This can use document picture-in-picture or element picture in picture
   *
   * Set `enableDocumentPictureInPicture` to `true` to use docPiP on a supported browser
   * Else set `disablePictureInPicture` to `false` to disable elPiP on a supported browser
   *
   *
   * @see [Spec]{@link https://w3c.github.io/picture-in-picture/}
   * @see [Spec]{@link https://wicg.github.io/document-picture-in-picture/}
   *
   * @fires Player#enterpictureinpicture
   *
   * @return {Promise}
   *         A promise with a Picture-in-Picture window.
   */
  requestPictureInPicture() {
    if (this.options_.enableDocumentPictureInPicture && j.documentPictureInPicture) {
      const e = Me.createElement(this.el().tagName);
      return e.classList = this.el().classList, e.classList.add("vjs-pip-container"), this.posterImage && e.appendChild(this.posterImage.el().cloneNode(!0)), this.titleBar && e.appendChild(this.titleBar.el().cloneNode(!0)), e.appendChild(et("p", {
        className: "vjs-pip-text"
      }, {}, this.localize("Playing in picture-in-picture"))), j.documentPictureInPicture.requestWindow({
        // The aspect ratio won't be correct, Chrome bug https://crbug.com/1407629
        width: this.videoWidth(),
        height: this.videoHeight()
      }).then((n) => (_3(n), this.el_.parentNode.insertBefore(e, this.el_), n.document.body.appendChild(this.el_), n.document.body.classList.add("vjs-pip-window"), this.player_.isInPictureInPicture(!0), this.player_.trigger({
        type: "enterpictureinpicture",
        pipWindow: n
      }), n.addEventListener("pagehide", (a) => {
        const i = a.target.querySelector(".video-js");
        e.parentNode.replaceChild(i, e), this.player_.isInPictureInPicture(!1), this.player_.trigger("leavepictureinpicture");
      }), n));
    }
    return "pictureInPictureEnabled" in Me && this.disablePictureInPicture() === !1 ? this.techGet_("requestPictureInPicture") : Promise.reject("No PiP mode is available");
  }
  /**
   * Exit Picture-in-Picture mode.
   *
   * @see [Spec]{@link https://wicg.github.io/picture-in-picture}
   *
   * @fires Player#leavepictureinpicture
   *
   * @return {Promise}
   *         A promise.
   */
  exitPictureInPicture() {
    if (j.documentPictureInPicture && j.documentPictureInPicture.window)
      return j.documentPictureInPicture.window.close(), Promise.resolve();
    if ("pictureInPictureEnabled" in Me)
      return Me.exitPictureInPicture();
  }
  /**
   * Called when this Player has focus and a key gets pressed down, or when
   * any Component of this player receives a key press that it doesn't handle.
   * This allows player-wide hotkeys (either as defined below, or optionally
   * by an external function).
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */
  handleKeyDown(e) {
    const {
      userActions: n
    } = this.options_;
    !n || !n.hotkeys || ((i) => {
      const r = i.tagName.toLowerCase();
      if (i.isContentEditable)
        return !0;
      const s = ["button", "checkbox", "hidden", "radio", "reset", "submit"];
      return r === "input" ? s.indexOf(i.type) === -1 : ["textarea"].indexOf(r) !== -1;
    })(this.el_.ownerDocument.activeElement) || (typeof n.hotkeys == "function" ? n.hotkeys.call(this, e) : this.handleHotkeys(e));
  }
  /**
   * Called when this Player receives a hotkey keydown event.
   * Supported player-wide hotkeys are:
   *
   *   f          - toggle fullscreen
   *   m          - toggle mute
   *   k or Space - toggle play/pause
   *
   * @param {Event} event
   *        The `keydown` event that caused this function to be called.
   */
  handleHotkeys(e) {
    const n = this.options_.userActions ? this.options_.userActions.hotkeys : {}, {
      fullscreenKey: a = (s) => e.key.toLowerCase() === "f",
      muteKey: i = (s) => e.key.toLowerCase() === "m",
      playPauseKey: r = (s) => e.key.toLowerCase() === "k" || e.key.toLowerCase() === " "
    } = n;
    if (a.call(this, e)) {
      e.preventDefault(), e.stopPropagation();
      const s = ye.getComponent("FullscreenToggle");
      Me[this.fsApi_.fullscreenEnabled] !== !1 && s.prototype.handleClick.call(this, e);
    } else i.call(this, e) ? (e.preventDefault(), e.stopPropagation(), ye.getComponent("MuteToggle").prototype.handleClick.call(this, e)) : r.call(this, e) && (e.preventDefault(), e.stopPropagation(), ye.getComponent("PlayToggle").prototype.handleClick.call(this, e));
  }
  /**
   * Check whether the player can play a given mimetype
   *
   * @see https://www.w3.org/TR/2011/WD-html5-20110113/video.html#dom-navigator-canplaytype
   *
   * @param {string} type
   *        The mimetype to check
   *
   * @return {string}
   *         'probably', 'maybe', or '' (empty string)
   */
  canPlayType(e) {
    let n;
    for (let a = 0, i = this.options_.techOrder; a < i.length; a++) {
      const r = i[a];
      let s = rt.getTech(r);
      if (s || (s = ye.getComponent(r)), !s) {
        ut.error(`The "${r}" tech is undefined. Skipped browser support check for that tech.`);
        continue;
      }
      if (s.isSupported() && (n = s.canPlayType(e), n))
        return n;
    }
    return "";
  }
  /**
   * Select source based on tech-order or source-order
   * Uses source-order selection if `options.sourceOrder` is truthy. Otherwise,
   * defaults to tech-order selection
   *
   * @param {Array} sources
   *        The sources for a media asset
   *
   * @return {Object|boolean}
   *         Object of source and tech order or false
   */
  selectSource(e) {
    const n = this.options_.techOrder.map((o) => [o, rt.getTech(o)]).filter(([o, l]) => l ? l.isSupported() : (ut.error(`The "${o}" tech is undefined. Skipped browser support check for that tech.`), !1)), a = function(o, l, c) {
      let u;
      return o.some((f) => l.some((m) => {
        if (u = c(f, m), u)
          return !0;
      })), u;
    };
    let i;
    const r = (o) => (l, c) => o(c, l), s = ([o, l], c) => {
      if (l.canPlaySource(c, this.options_[o.toLowerCase()]))
        return {
          source: c,
          tech: o
        };
    };
    return this.options_.sourceOrder ? i = a(e, n, r(s)) : i = a(n, e, s), i || !1;
  }
  /**
   * Executes source setting and getting logic
   *
   * @param {Tech~SourceObject|Tech~SourceObject[]|string} [source]
   *        A SourceObject, an array of SourceObjects, or a string referencing
   *        a URL to a media source. It is _highly recommended_ that an object
   *        or array of objects is used here, so that source selection
   *        algorithms can take the `type` into account.
   *
   *        If not provided, this method acts as a getter.
   * @param {boolean} [isRetry]
   *        Indicates whether this is being called internally as a result of a retry
   *
   * @return {string|undefined}
   *         If the `source` argument is missing, returns the current source
   *         URL. Otherwise, returns nothing/undefined.
   */
  handleSrc_(e, n) {
    if (typeof e > "u")
      return this.cache_.src || "";
    this.resetRetryOnError_ && this.resetRetryOnError_();
    const a = $3(e);
    if (!a.length) {
      this.setTimeout(function() {
        this.error({
          code: 4,
          message: this.options_.notSupportedMessage
        });
      }, 0);
      return;
    }
    if (this.changingSrc_ = !0, n || (this.cache_.sources = a), this.updateSourceCaches_(a[0]), cne(this, a[0], (i, r) => {
      if (this.middleware_ = r, n || (this.cache_.sources = a), this.updateSourceCaches_(i), this.src_(i)) {
        if (a.length > 1)
          return this.handleSrc_(a.slice(1));
        this.changingSrc_ = !1, this.setTimeout(function() {
          this.error({
            code: 4,
            message: this.options_.notSupportedMessage
          });
        }, 0), this.triggerReady();
        return;
      }
      une(r, this.tech_);
    }), a.length > 1) {
      const i = () => {
        this.error(null), this.handleSrc_(a.slice(1), !0);
      }, r = () => {
        this.off("error", i);
      };
      this.one("error", i), this.one("playing", r), this.resetRetryOnError_ = () => {
        this.off("error", i), this.off("playing", r);
      };
    }
  }
  /**
   * Get or set the video source.
   *
   * @param {Tech~SourceObject|Tech~SourceObject[]|string} [source]
   *        A SourceObject, an array of SourceObjects, or a string referencing
   *        a URL to a media source. It is _highly recommended_ that an object
   *        or array of objects is used here, so that source selection
   *        algorithms can take the `type` into account.
   *
   *        If not provided, this method acts as a getter.
   *
   * @return {string|undefined}
   *         If the `source` argument is missing, returns the current source
   *         URL. Otherwise, returns nothing/undefined.
   */
  src(e) {
    return this.handleSrc_(e, !1);
  }
  /**
   * Set the source object on the tech, returns a boolean that indicates whether
   * there is a tech that can play the source or not
   *
   * @param {Tech~SourceObject} source
   *        The source object to set on the Tech
   *
   * @return {boolean}
   *         - True if there is no Tech to playback this source
   *         - False otherwise
   *
   * @private
   */
  src_(e) {
    const n = this.selectSource([e]);
    return n ? L3(n.tech, this.techName_) ? (this.ready(function() {
      this.tech_.constructor.prototype.hasOwnProperty("setSource") ? this.techCall_("setSource", e) : this.techCall_("src", e.src), this.changingSrc_ = !1;
    }, !0), !1) : (this.changingSrc_ = !0, this.loadTech_(n.tech, n.source), this.tech_.ready(() => {
      this.changingSrc_ = !1;
    }), !1) : !0;
  }
  /**
   * Add a <source> element to the <video> element.
   *
   * @param {string} srcUrl
   *        The URL of the video source.
   *
   * @param {string} [mimeType]
   *        The MIME type of the video source. Optional but recommended.
   *
   * @return {boolean}
   *         Returns true if the source element was successfully added, false otherwise.
   */
  addSourceElement(e, n) {
    return this.tech_ ? this.tech_.addSourceElement(e, n) : !1;
  }
  /**
   * Remove a <source> element from the <video> element by its URL.
   *
   * @param {string} srcUrl
   *        The URL of the source to remove.
   *
   * @return {boolean}
   *         Returns true if the source element was successfully removed, false otherwise.
   */
  removeSourceElement(e) {
    return this.tech_ ? this.tech_.removeSourceElement(e) : !1;
  }
  /**
   * Begin loading the src data.
   */
  load() {
    if (this.tech_ && this.tech_.vhs) {
      this.src(this.currentSource());
      return;
    }
    this.techCall_("load");
  }
  /**
   * Reset the player. Loads the first tech in the techOrder,
   * removes all the text tracks in the existing `tech`,
   * and calls `reset` on the `tech`.
   */
  reset() {
    if (this.paused())
      this.doReset_();
    else {
      const e = this.play();
      Xa(e.then(() => this.doReset_()));
    }
  }
  doReset_() {
    this.tech_ && this.tech_.clearTracks("text"), this.removeClass("vjs-playing"), this.addClass("vjs-paused"), this.resetCache_(), this.poster(""), this.loadTech_(this.options_.techOrder[0], null), this.techCall_("reset"), this.resetControlBarUI_(), this.error(null), this.titleBar && this.titleBar.update({
      title: void 0,
      description: void 0
    }), xi(this) && this.trigger("playerreset");
  }
  /**
   * Reset Control Bar's UI by calling sub-methods that reset
   * all of Control Bar's components
   */
  resetControlBarUI_() {
    this.resetProgressBar_(), this.resetPlaybackRate_(), this.resetVolumeBar_();
  }
  /**
   * Reset tech's progress so progress bar is reset in the UI
   */
  resetProgressBar_() {
    this.currentTime(0);
    const {
      currentTimeDisplay: e,
      durationDisplay: n,
      progressControl: a,
      remainingTimeDisplay: i
    } = this.controlBar || {}, {
      seekBar: r
    } = a || {};
    e && e.updateContent(), n && n.updateContent(), i && i.updateContent(), r && (r.update(), r.loadProgressBar && r.loadProgressBar.update());
  }
  /**
   * Reset Playback ratio
   */
  resetPlaybackRate_() {
    this.playbackRate(this.defaultPlaybackRate()), this.handleTechRateChange_();
  }
  /**
   * Reset Volume bar
   */
  resetVolumeBar_() {
    this.volume(1), this.trigger("volumechange");
  }
  /**
   * Returns all of the current source objects.
   *
   * @return {Tech~SourceObject[]}
   *         The current source objects
   */
  currentSources() {
    const e = this.currentSource(), n = [];
    return Object.keys(e).length !== 0 && n.push(e), this.cache_.sources || n;
  }
  /**
   * Returns the current source object.
   *
   * @return {Tech~SourceObject}
   *         The current source object
   */
  currentSource() {
    return this.cache_.source || {};
  }
  /**
   * Returns the fully qualified URL of the current source value e.g. http://mysite.com/video.mp4
   * Can be used in conjunction with `currentType` to assist in rebuilding the current source object.
   *
   * @return {string}
   *         The current source
   */
  currentSrc() {
    return this.currentSource() && this.currentSource().src || "";
  }
  /**
   * Get the current source type e.g. video/mp4
   * This can allow you rebuild the current source object so that you could load the same
   * source and tech later
   *
   * @return {string}
   *         The source MIME type
   */
  currentType() {
    return this.currentSource() && this.currentSource().type || "";
  }
  /**
   * Get or set the preload attribute
   *
   * @param {'none'|'auto'|'metadata'} [value]
   *        Preload mode to pass to tech
   *
   * @return {string|undefined}
   *         - The preload attribute value when getting
   *         - Nothing when setting
   */
  preload(e) {
    if (e !== void 0) {
      this.techCall_("setPreload", e), this.options_.preload = e;
      return;
    }
    return this.techGet_("preload");
  }
  /**
   * Get or set the autoplay option. When this is a boolean it will
   * modify the attribute on the tech. When this is a string the attribute on
   * the tech will be removed and `Player` will handle autoplay on loadstarts.
   *
   * @param {boolean|'play'|'muted'|'any'} [value]
   *        - true: autoplay using the browser behavior
   *        - false: do not autoplay
   *        - 'play': call play() on every loadstart
   *        - 'muted': call muted() then play() on every loadstart
   *        - 'any': call play() on every loadstart. if that fails call muted() then play().
   *        - *: values other than those listed here will be set `autoplay` to true
   *
   * @return {boolean|string|undefined}
   *         - The current value of autoplay when getting
   *         - Nothing when setting
   */
  autoplay(e) {
    if (e === void 0)
      return this.options_.autoplay || !1;
    let n;
    typeof e == "string" && /(any|play|muted)/.test(e) || e === !0 && this.options_.normalizeAutoplay ? (this.options_.autoplay = e, this.manualAutoplay_(typeof e == "string" ? e : "play"), n = !1) : e ? this.options_.autoplay = !0 : this.options_.autoplay = !1, n = typeof n > "u" ? this.options_.autoplay : n, this.tech_ && this.techCall_("setAutoplay", n);
  }
  /**
   * Set or unset the playsinline attribute.
   * Playsinline tells the browser that non-fullscreen playback is preferred.
   *
   * @param {boolean} [value]
   *        - true means that we should try to play inline by default
   *        - false means that we should use the browser's default playback mode,
   *          which in most cases is inline. iOS Safari is a notable exception
   *          and plays fullscreen by default.
   *
   * @return {string|undefined}
   *         - the current value of playsinline
   *         - Nothing when setting
   *
   * @see [Spec]{@link https://html.spec.whatwg.org/#attr-video-playsinline}
   */
  playsinline(e) {
    return e !== void 0 && (this.techCall_("setPlaysinline", e), this.options_.playsinline = e), this.techGet_("playsinline");
  }
  /**
   * Get or set the loop attribute on the video element.
   *
   * @param {boolean} [value]
   *        - true means that we should loop the video
   *        - false means that we should not loop the video
   *
   * @return {boolean|undefined}
   *         - The current value of loop when getting
   *         - Nothing when setting
   */
  loop(e) {
    if (e !== void 0) {
      this.techCall_("setLoop", e), this.options_.loop = e;
      return;
    }
    return this.techGet_("loop");
  }
  /**
   * Get or set the poster image source url
   *
   * @fires Player#posterchange
   *
   * @param {string} [src]
   *        Poster image source URL
   *
   * @return {string|undefined}
   *         - The current value of poster when getting
   *         - Nothing when setting
   */
  poster(e) {
    if (e === void 0)
      return this.poster_;
    e || (e = ""), e !== this.poster_ && (this.poster_ = e, this.techCall_("setPoster", e), this.isPosterFromTech_ = !1, this.trigger("posterchange"));
  }
  /**
   * Some techs (e.g. YouTube) can provide a poster source in an
   * asynchronous way. We want the poster component to use this
   * poster source so that it covers up the tech's controls.
   * (YouTube's play button). However we only want to use this
   * source if the player user hasn't set a poster through
   * the normal APIs.
   *
   * @fires Player#posterchange
   * @listens Tech#posterchange
   * @private
   */
  handleTechPosterChange_() {
    if ((!this.poster_ || this.options_.techCanOverridePoster) && this.tech_ && this.tech_.poster) {
      const e = this.tech_.poster() || "";
      e !== this.poster_ && (this.poster_ = e, this.isPosterFromTech_ = !0, this.trigger("posterchange"));
    }
  }
  /**
   * Get or set whether or not the controls are showing.
   *
   * @fires Player#controlsenabled
   *
   * @param {boolean} [bool]
   *        - true to turn controls on
   *        - false to turn controls off
   *
   * @return {boolean|undefined}
   *         - The current value of controls when getting
   *         - Nothing when setting
   */
  controls(e) {
    if (e === void 0)
      return !!this.controls_;
    e = !!e, this.controls_ !== e && (this.controls_ = e, this.usingNativeControls() && this.techCall_("setControls", e), this.controls_ ? (this.removeClass("vjs-controls-disabled"), this.addClass("vjs-controls-enabled"), this.trigger("controlsenabled"), this.usingNativeControls() || this.addTechControlsListeners_()) : (this.removeClass("vjs-controls-enabled"), this.addClass("vjs-controls-disabled"), this.trigger("controlsdisabled"), this.usingNativeControls() || this.removeTechControlsListeners_()));
  }
  /**
   * Toggle native controls on/off. Native controls are the controls built into
   * devices (e.g. default iPhone controls) or other techs
   * (e.g. Vimeo Controls)
   * **This should only be set by the current tech, because only the tech knows
   * if it can support native controls**
   *
   * @fires Player#usingnativecontrols
   * @fires Player#usingcustomcontrols
   *
   * @param {boolean} [bool]
   *        - true to turn native controls on
   *        - false to turn native controls off
   *
   * @return {boolean|undefined}
   *         - The current value of native controls when getting
   *         - Nothing when setting
   */
  usingNativeControls(e) {
    if (e === void 0)
      return !!this.usingNativeControls_;
    e = !!e, this.usingNativeControls_ !== e && (this.usingNativeControls_ = e, this.usingNativeControls_ ? (this.addClass("vjs-using-native-controls"), this.trigger("usingnativecontrols")) : (this.removeClass("vjs-using-native-controls"), this.trigger("usingcustomcontrols")));
  }
  /**
   * Set or get the current MediaError
   *
   * @fires Player#error
   *
   * @param  {MediaError|string|number} [err]
   *         A MediaError or a string/number to be turned
   *         into a MediaError
   *
   * @return {MediaError|null|undefined}
   *         - The current MediaError when getting (or null)
   *         - Nothing when setting
   */
  error(e) {
    if (e === void 0)
      return this.error_ || null;
    if (ar("beforeerror").forEach((n) => {
      const a = n(this, e);
      if (!(ni(a) && !Array.isArray(a) || typeof a == "string" || typeof a == "number" || a === null)) {
        this.log.error("please return a value that MediaError expects in beforeerror hooks");
        return;
      }
      e = a;
    }), this.options_.suppressNotSupportedError && e && e.code === 4) {
      const n = function() {
        this.error(e);
      };
      this.options_.suppressNotSupportedError = !1, this.any(["click", "touchstart"], n), this.one("loadstart", function() {
        this.off(["click", "touchstart"], n);
      });
      return;
    }
    if (e === null) {
      this.error_ = null, this.removeClass("vjs-error"), this.errorDisplay && this.errorDisplay.close();
      return;
    }
    this.error_ = new Yt(e), this.addClass("vjs-error"), ut.error(`(CODE:${this.error_.code} ${Yt.errorTypes[this.error_.code]})`, this.error_.message, this.error_), this.trigger("error"), ar("error").forEach((n) => n(this, this.error_));
  }
  /**
   * Report user activity
   *
   * @param {Object} event
   *        Event object
   */
  reportUserActivity(e) {
    this.userActivity_ = !0;
  }
  /**
   * Get/set if user is active
   *
   * @fires Player#useractive
   * @fires Player#userinactive
   *
   * @param {boolean} [bool]
   *        - true if the user is active
   *        - false if the user is inactive
   *
   * @return {boolean|undefined}
   *         - The current value of userActive when getting
   *         - Nothing when setting
   */
  userActive(e) {
    if (e === void 0)
      return this.userActive_;
    if (e = !!e, e !== this.userActive_) {
      if (this.userActive_ = e, this.userActive_) {
        this.userActivity_ = !0, this.removeClass("vjs-user-inactive"), this.addClass("vjs-user-active"), this.trigger("useractive");
        return;
      }
      this.tech_ && this.tech_.one("mousemove", function(n) {
        n.stopPropagation(), n.preventDefault();
      }), this.userActivity_ = !1, this.removeClass("vjs-user-active"), this.addClass("vjs-user-inactive"), this.trigger("userinactive");
    }
  }
  /**
   * Listen for user activity based on timeout value
   *
   * @private
   */
  listenForUserActivity_() {
    let e, n, a;
    const i = Et(this, this.reportUserActivity), r = function(f) {
      (f.screenX !== n || f.screenY !== a) && (n = f.screenX, a = f.screenY, i());
    }, s = function() {
      i(), this.clearInterval(e), e = this.setInterval(i, 250);
    }, o = function(f) {
      i(), this.clearInterval(e);
    };
    this.on("mousedown", s), this.on("mousemove", r), this.on("mouseup", o), this.on("mouseleave", o);
    const l = this.getChild("controlBar");
    l && !En && !$a && (l.on("mouseenter", function(f) {
      this.player().options_.inactivityTimeout !== 0 && (this.player().cache_.inactivityTimeout = this.player().options_.inactivityTimeout), this.player().options_.inactivityTimeout = 0;
    }), l.on("mouseleave", function(f) {
      this.player().options_.inactivityTimeout = this.player().cache_.inactivityTimeout;
    })), this.on("keydown", i), this.on("keyup", i);
    let c;
    const u = function() {
      if (!this.userActivity_)
        return;
      this.userActivity_ = !1, this.userActive(!0), this.clearTimeout(c);
      const f = this.options_.inactivityTimeout;
      f <= 0 || (c = this.setTimeout(function() {
        this.userActivity_ || this.userActive(!1);
      }, f));
    };
    this.setInterval(u, 250);
  }
  /**
   * Gets or sets the current playback rate. A playback rate of
   * 1.0 represents normal speed and 0.5 would indicate half-speed
   * playback, for instance.
   *
   * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-playbackrate
   *
   * @param {number} [rate]
   *       New playback rate to set.
   *
   * @return {number|undefined}
   *         - The current playback rate when getting or 1.0
   *         - Nothing when setting
   */
  playbackRate(e) {
    if (e !== void 0) {
      this.techCall_("setPlaybackRate", e);
      return;
    }
    return this.tech_ && this.tech_.featuresPlaybackRate ? this.cache_.lastPlaybackRate || this.techGet_("playbackRate") : 1;
  }
  /**
   * Gets or sets the current default playback rate. A default playback rate of
   * 1.0 represents normal speed and 0.5 would indicate half-speed playback, for instance.
   * defaultPlaybackRate will only represent what the initial playbackRate of a video was, not
   * not the current playbackRate.
   *
   * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-defaultplaybackrate
   *
   * @param {number} [rate]
   *       New default playback rate to set.
   *
   * @return {number|undefined}
   *         - The default playback rate when getting or 1.0
   *         - Nothing when setting
   */
  defaultPlaybackRate(e) {
    return e !== void 0 ? this.techCall_("setDefaultPlaybackRate", e) : this.tech_ && this.tech_.featuresPlaybackRate ? this.techGet_("defaultPlaybackRate") : 1;
  }
  /**
   * Gets or sets the audio flag
   *
   * @param {boolean} [bool]
   *        - true signals that this is an audio player
   *        - false signals that this is not an audio player
   *
   * @return {boolean|undefined}
   *         - The current value of isAudio when getting
   *         - Nothing when setting
   */
  isAudio(e) {
    if (e !== void 0) {
      this.isAudio_ = !!e;
      return;
    }
    return !!this.isAudio_;
  }
  updatePlayerHeightOnAudioOnlyMode_() {
    const e = this.getChild("ControlBar");
    !e || this.audioOnlyCache_.controlBarHeight === e.currentHeight() || (this.audioOnlyCache_.controlBarHeight = e.currentHeight(), this.height(this.audioOnlyCache_.controlBarHeight));
  }
  enableAudioOnlyUI_() {
    this.addClass("vjs-audio-only-mode");
    const e = this.children(), n = this.getChild("ControlBar"), a = n && n.currentHeight();
    e.forEach((i) => {
      i !== n && i.el_ && !i.hasClass("vjs-hidden") && (i.hide(), this.audioOnlyCache_.hiddenChildren.push(i));
    }), this.audioOnlyCache_.playerHeight = this.currentHeight(), this.audioOnlyCache_.controlBarHeight = a, this.on("playerresize", this.boundUpdatePlayerHeightOnAudioOnlyMode_), this.height(a), this.trigger("audioonlymodechange");
  }
  disableAudioOnlyUI_() {
    this.removeClass("vjs-audio-only-mode"), this.off("playerresize", this.boundUpdatePlayerHeightOnAudioOnlyMode_), this.audioOnlyCache_.hiddenChildren.forEach((e) => e.show()), this.height(this.audioOnlyCache_.playerHeight), this.trigger("audioonlymodechange");
  }
  /**
   * Get the current audioOnlyMode state or set audioOnlyMode to true or false.
   *
   * Setting this to `true` will hide all player components except the control bar,
   * as well as control bar components needed only for video.
   *
   * @param {boolean} [value]
   *         The value to set audioOnlyMode to.
   *
   * @return {Promise|boolean}
   *        A Promise is returned when setting the state, and a boolean when getting
   *        the present state
   */
  audioOnlyMode(e) {
    if (typeof e != "boolean" || e === this.audioOnlyMode_)
      return this.audioOnlyMode_;
    if (this.audioOnlyMode_ = e, e) {
      const n = [];
      return this.isInPictureInPicture() && n.push(this.exitPictureInPicture()), this.isFullscreen() && n.push(this.exitFullscreen()), this.audioPosterMode() && n.push(this.audioPosterMode(!1)), Promise.all(n).then(() => this.enableAudioOnlyUI_());
    }
    return Promise.resolve().then(() => this.disableAudioOnlyUI_());
  }
  enablePosterModeUI_() {
    (this.tech_ && this.tech_).hide(), this.addClass("vjs-audio-poster-mode"), this.trigger("audiopostermodechange");
  }
  disablePosterModeUI_() {
    (this.tech_ && this.tech_).show(), this.removeClass("vjs-audio-poster-mode"), this.trigger("audiopostermodechange");
  }
  /**
   * Get the current audioPosterMode state or set audioPosterMode to true or false
   *
   * @param {boolean} [value]
   *         The value to set audioPosterMode to.
   *
   * @return {Promise|boolean}
   *         A Promise is returned when setting the state, and a boolean when getting
   *        the present state
   */
  audioPosterMode(e) {
    return typeof e != "boolean" || e === this.audioPosterMode_ ? this.audioPosterMode_ : (this.audioPosterMode_ = e, e ? this.audioOnlyMode() ? this.audioOnlyMode(!1).then(() => {
      this.enablePosterModeUI_();
    }) : Promise.resolve().then(() => {
      this.enablePosterModeUI_();
    }) : Promise.resolve().then(() => {
      this.disablePosterModeUI_();
    }));
  }
  /**
   * A helper method for adding a {@link TextTrack} to our
   * {@link TextTrackList}.
   *
   * In addition to the W3C settings we allow adding additional info through options.
   *
   * @see http://www.w3.org/html/wg/drafts/html/master/embedded-content-0.html#dom-media-addtexttrack
   *
   * @param {string} [kind]
   *        the kind of TextTrack you are adding
   *
   * @param {string} [label]
   *        the label to give the TextTrack label
   *
   * @param {string} [language]
   *        the language to set on the TextTrack
   *
   * @return {TextTrack|undefined}
   *         the TextTrack that was added or undefined
   *         if there is no tech
   */
  addTextTrack(e, n, a) {
    if (this.tech_)
      return this.tech_.addTextTrack(e, n, a);
  }
  /**
   * Create a remote {@link TextTrack} and an {@link HTMLTrackElement}.
   *
   * @param {Object} options
   *        Options to pass to {@link HTMLTrackElement} during creation. See
   *        {@link HTMLTrackElement} for object properties that you should use.
   *
   * @param {boolean} [manualCleanup=false] if set to true, the TextTrack will not be removed
   *                                        from the TextTrackList and HtmlTrackElementList
   *                                        after a source change
   *
   * @return {HtmlTrackElement}
   *         the HTMLTrackElement that was created and added
   *         to the HtmlTrackElementList and the remote
   *         TextTrackList
   *
   */
  addRemoteTextTrack(e, n) {
    if (this.tech_)
      return this.tech_.addRemoteTextTrack(e, n);
  }
  /**
   * Remove a remote {@link TextTrack} from the respective
   * {@link TextTrackList} and {@link HtmlTrackElementList}.
   *
   * @param {Object} track
   *        Remote {@link TextTrack} to remove
   *
   * @return {undefined}
   *         does not return anything
   */
  removeRemoteTextTrack(e = {}) {
    let {
      track: n
    } = e;
    if (n || (n = e), this.tech_)
      return this.tech_.removeRemoteTextTrack(n);
  }
  /**
   * Gets available media playback quality metrics as specified by the W3C's Media
   * Playback Quality API.
   *
   * @see [Spec]{@link https://wicg.github.io/media-playback-quality}
   *
   * @return {Object|undefined}
   *         An object with supported media playback quality metrics or undefined if there
   *         is no tech or the tech does not support it.
   */
  getVideoPlaybackQuality() {
    return this.techGet_("getVideoPlaybackQuality");
  }
  /**
   * Get video width
   *
   * @return {number}
   *         current video width
   */
  videoWidth() {
    return this.tech_ && this.tech_.videoWidth && this.tech_.videoWidth() || 0;
  }
  /**
   * Get video height
   *
   * @return {number}
   *         current video height
   */
  videoHeight() {
    return this.tech_ && this.tech_.videoHeight && this.tech_.videoHeight() || 0;
  }
  /**
   * Set or get the player's language code.
   *
   * Changing the language will trigger
   * [languagechange]{@link Player#event:languagechange}
   * which Components can use to update control text.
   * ClickableComponent will update its control text by default on
   * [languagechange]{@link Player#event:languagechange}.
   *
   * @fires Player#languagechange
   *
   * @param {string} [code]
   *        the language code to set the player to
   *
   * @return {string|undefined}
   *         - The current language code when getting
   *         - Nothing when setting
   */
  language(e) {
    if (e === void 0)
      return this.language_;
    this.language_ !== String(e).toLowerCase() && (this.language_ = String(e).toLowerCase(), xi(this) && this.trigger("languagechange"));
  }
  /**
   * Get the player's language dictionary
   * Merge every time, because a newly added plugin might call videojs.addLanguage() at any time
   * Languages specified directly in the player options have precedence
   *
   * @return {Array}
   *         An array of of supported languages
   */
  languages() {
    return wt(Mt.prototype.options_.languages, this.languages_);
  }
  /**
   * returns a JavaScript object representing the current track
   * information. **DOES not return it as JSON**
   *
   * @return {Object}
   *         Object representing the current of track info
   */
  toJSON() {
    const e = wt(this.options_), n = e.tracks;
    e.tracks = [];
    for (let a = 0; a < n.length; a++) {
      let i = n[a];
      i = wt(i), i.player = void 0, e.tracks[a] = i;
    }
    return e;
  }
  /**
   * Creates a simple modal dialog (an instance of the {@link ModalDialog}
   * component) that immediately overlays the player with arbitrary
   * content and removes itself when closed.
   *
   * @param {string|Function|Element|Array|null} content
   *        Same as {@link ModalDialog#content}'s param of the same name.
   *        The most straight-forward usage is to provide a string or DOM
   *        element.
   *
   * @param {Object} [options]
   *        Extra options which will be passed on to the {@link ModalDialog}.
   *
   * @return {ModalDialog}
   *         the {@link ModalDialog} that was created
   */
  createModal(e, n) {
    n = n || {}, n.content = e || "";
    const a = new fo(this, n);
    return this.addChild(a), a.on("dispose", () => {
      this.removeChild(a);
    }), a.open(), a;
  }
  /**
   * Change breakpoint classes when the player resizes.
   *
   * @private
   */
  updateCurrentBreakpoint_() {
    if (!this.responsive())
      return;
    const e = this.currentBreakpoint(), n = this.currentWidth();
    for (let a = 0; a < Dh.length; a++) {
      const i = Dh[a], r = this.breakpoints_[i];
      if (n <= r) {
        if (e === i)
          return;
        e && this.removeClass(Vc[e]), this.addClass(Vc[i]), this.breakpoint_ = i;
        break;
      }
    }
  }
  /**
   * Removes the current breakpoint.
   *
   * @private
   */
  removeCurrentBreakpoint_() {
    const e = this.currentBreakpointClass();
    this.breakpoint_ = "", e && this.removeClass(e);
  }
  /**
   * Get or set breakpoints on the player.
   *
   * Calling this method with an object or `true` will remove any previous
   * custom breakpoints and start from the defaults again.
   *
   * @param  {Object|boolean} [breakpoints]
   *         If an object is given, it can be used to provide custom
   *         breakpoints. If `true` is given, will set default breakpoints.
   *         If this argument is not given, will simply return the current
   *         breakpoints.
   *
   * @param  {number} [breakpoints.tiny]
   *         The maximum width for the "vjs-layout-tiny" class.
   *
   * @param  {number} [breakpoints.xsmall]
   *         The maximum width for the "vjs-layout-x-small" class.
   *
   * @param  {number} [breakpoints.small]
   *         The maximum width for the "vjs-layout-small" class.
   *
   * @param  {number} [breakpoints.medium]
   *         The maximum width for the "vjs-layout-medium" class.
   *
   * @param  {number} [breakpoints.large]
   *         The maximum width for the "vjs-layout-large" class.
   *
   * @param  {number} [breakpoints.xlarge]
   *         The maximum width for the "vjs-layout-x-large" class.
   *
   * @param  {number} [breakpoints.huge]
   *         The maximum width for the "vjs-layout-huge" class.
   *
   * @return {Object}
   *         An object mapping breakpoint names to maximum width values.
   */
  breakpoints(e) {
    return e === void 0 ? Object.assign(this.breakpoints_) : (this.breakpoint_ = "", this.breakpoints_ = Object.assign({}, Kne, e), this.updateCurrentBreakpoint_(), Object.assign(this.breakpoints_));
  }
  /**
   * Get or set a flag indicating whether or not this player should adjust
   * its UI based on its dimensions.
   *
   * @param  {boolean} [value]
   *         Should be `true` if the player should adjust its UI based on its
   *         dimensions; otherwise, should be `false`.
   *
   * @return {boolean|undefined}
   *         Will be `true` if this player should adjust its UI based on its
   *         dimensions; otherwise, will be `false`.
   *         Nothing if setting
   */
  responsive(e) {
    if (e === void 0)
      return this.responsive_;
    e = !!e;
    const n = this.responsive_;
    if (e !== n)
      return this.responsive_ = e, e ? (this.on("playerresize", this.boundUpdateCurrentBreakpoint_), this.updateCurrentBreakpoint_()) : (this.off("playerresize", this.boundUpdateCurrentBreakpoint_), this.removeCurrentBreakpoint_()), e;
  }
  /**
   * Get current breakpoint name, if any.
   *
   * @return {string}
   *         If there is currently a breakpoint set, returns a the key from the
   *         breakpoints object matching it. Otherwise, returns an empty string.
   */
  currentBreakpoint() {
    return this.breakpoint_;
  }
  /**
   * Get the current breakpoint class name.
   *
   * @return {string}
   *         The matching class name (e.g. `"vjs-layout-tiny"` or
   *         `"vjs-layout-large"`) for the current breakpoint. Empty string if
   *         there is no current breakpoint.
   */
  currentBreakpointClass() {
    return Vc[this.breakpoint_] || "";
  }
  /**
   * An object that describes a single piece of media.
   *
   * Properties that are not part of this type description will be retained; so,
   * this can be viewed as a generic metadata storage mechanism as well.
   *
   * @see      {@link https://wicg.github.io/mediasession/#the-mediametadata-interface}
   * @typedef  {Object} Player~MediaObject
   *
   * @property {string} [album]
   *           Unused, except if this object is passed to the `MediaSession`
   *           API.
   *
   * @property {string} [artist]
   *           Unused, except if this object is passed to the `MediaSession`
   *           API.
   *
   * @property {Object[]} [artwork]
   *           Unused, except if this object is passed to the `MediaSession`
   *           API. If not specified, will be populated via the `poster`, if
   *           available.
   *
   * @property {string} [poster]
   *           URL to an image that will display before playback.
   *
   * @property {Tech~SourceObject|Tech~SourceObject[]|string} [src]
   *           A single source object, an array of source objects, or a string
   *           referencing a URL to a media source. It is _highly recommended_
   *           that an object or array of objects is used here, so that source
   *           selection algorithms can take the `type` into account.
   *
   * @property {string} [title]
   *           Unused, except if this object is passed to the `MediaSession`
   *           API.
   *
   * @property {Object[]} [textTracks]
   *           An array of objects to be used to create text tracks, following
   *           the {@link https://www.w3.org/TR/html50/embedded-content-0.html#the-track-element|native track element format}.
   *           For ease of removal, these will be created as "remote" text
   *           tracks and set to automatically clean up on source changes.
   *
   *           These objects may have properties like `src`, `kind`, `label`,
   *           and `language`, see {@link Tech#createRemoteTextTrack}.
   */
  /**
   * Populate the player using a {@link Player~MediaObject|MediaObject}.
   *
   * @param  {Player~MediaObject} media
   *         A media object.
   *
   * @param  {Function} ready
   *         A callback to be called when the player is ready.
   */
  loadMedia(e, n) {
    if (!e || typeof e != "object")
      return;
    const a = this.crossOrigin();
    this.reset(), this.cache_.media = wt(e);
    const {
      artist: i,
      artwork: r,
      description: s,
      poster: o,
      src: l,
      textTracks: c,
      title: u
    } = this.cache_.media;
    !r && o && (this.cache_.media.artwork = [{
      src: o,
      type: Lu(o)
    }]), a && this.crossOrigin(a), l && this.src(l), o && this.poster(o), Array.isArray(c) && c.forEach((f) => this.addRemoteTextTrack(f, !1)), this.titleBar && this.titleBar.update({
      title: u,
      description: s || i || ""
    }), this.ready(n);
  }
  /**
   * Get a clone of the current {@link Player~MediaObject} for this player.
   *
   * If the `loadMedia` method has not been used, will attempt to return a
   * {@link Player~MediaObject} based on the current state of the player.
   *
   * @return {Player~MediaObject}
   */
  getMedia() {
    if (!this.cache_.media) {
      const e = this.poster(), n = this.currentSources(), a = Array.prototype.map.call(this.remoteTextTracks(), (r) => ({
        kind: r.kind,
        label: r.label,
        language: r.language,
        src: r.src
      })), i = {
        src: n,
        textTracks: a
      };
      return e && (i.poster = e, i.artwork = [{
        src: i.poster,
        type: Lu(i.poster)
      }]), i;
    }
    return wt(this.cache_.media);
  }
  /**
   * Gets tag settings
   *
   * @param {Element} tag
   *        The player tag
   *
   * @return {Object}
   *         An object containing all of the settings
   *         for a player tag
   */
  static getTagSettings(e) {
    const n = {
      sources: [],
      tracks: []
    }, a = qi(e), i = a["data-setup"];
    if (hl(e, "vjs-fill") && (a.fill = !0), hl(e, "vjs-fluid") && (a.fluid = !0), i !== null)
      try {
        Object.assign(a, JSON.parse(i || "{}"));
      } catch (r) {
        ut.error("data-setup", r);
      }
    if (Object.assign(n, a), e.hasChildNodes()) {
      const r = e.childNodes;
      for (let s = 0, o = r.length; s < o; s++) {
        const l = r[s], c = l.nodeName.toLowerCase();
        c === "source" ? n.sources.push(qi(l)) : c === "track" && n.tracks.push(qi(l));
      }
    }
    return n;
  }
  /**
   * Set debug mode to enable/disable logs at info level.
   *
   * @param {boolean} enabled
   * @fires Player#debugon
   * @fires Player#debugoff
   * @return {boolean|undefined}
   */
  debug(e) {
    if (e === void 0)
      return this.debugEnabled_;
    e ? (this.trigger("debugon"), this.previousLogLevel_ = this.log.level, this.log.level("debug"), this.debugEnabled_ = !0) : (this.trigger("debugoff"), this.log.level(this.previousLogLevel_), this.previousLogLevel_ = void 0, this.debugEnabled_ = !1);
  }
  /**
   * Set or get current playback rates.
   * Takes an array and updates the playback rates menu with the new items.
   * Pass in an empty array to hide the menu.
   * Values other than arrays are ignored.
   *
   * @fires Player#playbackrateschange
   * @param {number[]} [newRates]
   *                   The new rates that the playback rates menu should update to.
   *                   An empty array will hide the menu
   * @return {number[]} When used as a getter will return the current playback rates
   */
  playbackRates(e) {
    if (e === void 0)
      return this.cache_.playbackRates;
    Array.isArray(e) && e.every((n) => typeof n == "number") && (this.cache_.playbackRates = e, this.trigger("playbackrateschange"));
  }
  /**
   * Reports whether or not a player has a plugin available.
   *
   * This does not report whether or not the plugin has ever been initialized
   * on this player. For that, [usingPlugin]{@link Player#usingPlugin}.
   *
   * @method hasPlugin
   * @param  {string}  name
   *         The name of a plugin.
   *
   * @return {boolean}
   *         Whether or not this player has the requested plugin available.
   */
  /**
   * Reports whether or not a player is using a plugin by name.
   *
   * For basic plugins, this only reports whether the plugin has _ever_ been
   * initialized on this player.
   *
   * @method Player#usingPlugin
   * @param  {string} name
   *         The name of a plugin.
   *
   * @return {boolean}
   *         Whether or not this player is using the requested plugin.
   */
}
Rn.names.forEach(function(t) {
  const e = Rn[t];
  Mt.prototype[e.getterName] = function() {
    return this.tech_ ? this.tech_[e.getterName]() : (this[e.privateName] = this[e.privateName] || new e.ListClass(), this[e.privateName]);
  };
});
Mt.prototype.crossorigin = Mt.prototype.crossOrigin;
Mt.players = {};
const Go = j.navigator;
Mt.prototype.options_ = {
  // Default order of fallback technology
  techOrder: rt.defaultTechOrder_,
  html5: {},
  // enable sourceset by default
  enableSourceset: !0,
  // default inactivity timeout
  inactivityTimeout: 2e3,
  // default playback rates
  playbackRates: [],
  // Add playback rate selection by adding rates
  // 'playbackRates': [0.5, 1, 1.5, 2],
  liveui: !1,
  // Included control sets
  children: ["mediaLoader", "posterImage", "titleBar", "textTrackDisplay", "loadingSpinner", "bigPlayButton", "liveTracker", "controlBar", "errorDisplay", "textTrackSettings", "resizeManager"],
  language: Go && (Go.languages && Go.languages[0] || Go.userLanguage || Go.language) || "en",
  // locales and their language translations
  languages: {},
  // Default message to show when a video cannot be played.
  notSupportedMessage: "No compatible source was found for this media.",
  normalizeAutoplay: !1,
  fullscreen: {
    options: {
      navigationUI: "hide"
    }
  },
  breakpoints: {},
  responsive: !1,
  audioOnlyMode: !1,
  audioPosterMode: !1,
  spatialNavigation: {
    enabled: !1,
    horizontalSeek: !1
  },
  // Default smooth seeking to false
  enableSmoothSeeking: !1,
  disableSeekWhileScrubbingOnMobile: !1
};
p_.forEach(function(t) {
  Mt.prototype[`handleTech${qt(t)}_`] = function() {
    return this.trigger(t);
  };
});
ye.registerComponent("Player", Mt);
const Du = "plugin", ks = "activePlugins_", ps = {}, Iu = (t) => ps.hasOwnProperty(t), qc = (t) => Iu(t) ? ps[t] : void 0, m_ = (t, e) => {
  t[ks] = t[ks] || {}, t[ks][e] = !0;
}, Mu = (t, e, n) => {
  const a = (n ? "before" : "") + "pluginsetup";
  t.trigger(a, e), t.trigger(a + ":" + e.name, e);
}, Qne = function(t, e) {
  const n = function() {
    Mu(this, {
      name: t,
      plugin: e,
      instance: null
    }, !0);
    const a = e.apply(this, arguments);
    return m_(this, t), Mu(this, {
      name: t,
      plugin: e,
      instance: a
    }), a;
  };
  return Object.keys(e).forEach(function(a) {
    n[a] = e[a];
  }), n;
}, Cb = (t, e) => (e.prototype.name = t, function(...n) {
  Mu(this, {
    name: t,
    plugin: e,
    instance: null
  }, !0);
  const a = new e(this, ...n);
  return this[t] = () => a, Mu(this, a.getEventHash()), a;
});
class ta {
  /**
   * Creates an instance of this class.
   *
   * Sub-classes should call `super` to ensure plugins are properly initialized.
   *
   * @param {Player} player
   *        A Video.js player instance.
   */
  constructor(e) {
    if (this.constructor === ta)
      throw new Error("Plugin must be sub-classed; not directly instantiated.");
    this.player = e, this.log || (this.log = this.player.log.createLogger(this.name)), cp(this), delete this.trigger, E3(this, this.constructor.defaultState), m_(e, this.name), this.dispose = this.dispose.bind(this), e.on("dispose", this.dispose);
  }
  /**
   * Get the version of the plugin that was set on <pluginName>.VERSION
   */
  version() {
    return this.constructor.VERSION;
  }
  /**
   * Each event triggered by plugins includes a hash of additional data with
   * conventional properties.
   *
   * This returns that object or mutates an existing hash.
   *
   * @param   {Object} [hash={}]
   *          An object to be used as event an event hash.
   *
   * @return {PluginEventHash}
   *          An event hash object with provided properties mixed-in.
   */
  getEventHash(e = {}) {
    return e.name = this.name, e.plugin = this.constructor, e.instance = this, e;
  }
  /**
   * Triggers an event on the plugin object and overrides
   * {@link module:evented~EventedMixin.trigger|EventedMixin.trigger}.
   *
   * @param   {string|Object} event
   *          An event type or an object with a type property.
   *
   * @param   {Object} [hash={}]
   *          Additional data hash to merge with a
   *          {@link PluginEventHash|PluginEventHash}.
   *
   * @return {boolean}
   *          Whether or not default was prevented.
   */
  trigger(e, n = {}) {
    return ho(this.eventBusEl_, e, this.getEventHash(n));
  }
  /**
   * Handles "statechanged" events on the plugin. No-op by default, override by
   * subclassing.
   *
   * @abstract
   * @param    {Event} e
   *           An event object provided by a "statechanged" event.
   *
   * @param    {Object} e.changes
   *           An object describing changes that occurred with the "statechanged"
   *           event.
   */
  handleStateChanged(e) {
  }
  /**
   * Disposes a plugin.
   *
   * Subclasses can override this if they want, but for the sake of safety,
   * it's probably best to subscribe the "dispose" event.
   *
   * @fires Plugin#dispose
   */
  dispose() {
    const {
      name: e,
      player: n
    } = this;
    this.trigger("dispose"), this.off(), n.off("dispose", this.dispose), n[ks][e] = !1, this.player = this.state = null, n[e] = Cb(e, ps[e]);
  }
  /**
   * Determines if a plugin is a basic plugin (i.e. not a sub-class of `Plugin`).
   *
   * @param   {string|Function} plugin
   *          If a string, matches the name of a plugin. If a function, will be
   *          tested directly.
   *
   * @return {boolean}
   *          Whether or not a plugin is a basic plugin.
   */
  static isBasic(e) {
    const n = typeof e == "string" ? qc(e) : e;
    return typeof n == "function" && !ta.prototype.isPrototypeOf(n.prototype);
  }
  /**
   * Register a Video.js plugin.
   *
   * @param   {string} name
   *          The name of the plugin to be registered. Must be a string and
   *          must not match an existing plugin or a method on the `Player`
   *          prototype.
   *
   * @param   {typeof Plugin|Function} plugin
   *          A sub-class of `Plugin` or a function for basic plugins.
   *
   * @return {typeof Plugin|Function}
   *          For advanced plugins, a factory function for that plugin. For
   *          basic plugins, a wrapper function that initializes the plugin.
   */
  static registerPlugin(e, n) {
    if (typeof e != "string")
      throw new Error(`Illegal plugin name, "${e}", must be a string, was ${typeof e}.`);
    if (Iu(e))
      ut.warn(`A plugin named "${e}" already exists. You may want to avoid re-registering plugins!`);
    else if (Mt.prototype.hasOwnProperty(e))
      throw new Error(`Illegal plugin name, "${e}", cannot share a name with an existing player method!`);
    if (typeof n != "function")
      throw new Error(`Illegal plugin for "${e}", must be a function, was ${typeof n}.`);
    return ps[e] = n, e !== Du && (ta.isBasic(n) ? Mt.prototype[e] = Qne(e, n) : Mt.prototype[e] = Cb(e, n)), n;
  }
  /**
   * De-register a Video.js plugin.
   *
   * @param  {string} name
   *         The name of the plugin to be de-registered. Must be a string that
   *         matches an existing plugin.
   *
   * @throws {Error}
   *         If an attempt is made to de-register the base plugin.
   */
  static deregisterPlugin(e) {
    if (e === Du)
      throw new Error("Cannot de-register base plugin.");
    Iu(e) && (delete ps[e], delete Mt.prototype[e]);
  }
  /**
   * Gets an object containing multiple Video.js plugins.
   *
   * @param   {Array} [names]
   *          If provided, should be an array of plugin names. Defaults to _all_
   *          plugin names.
   *
   * @return {Object|undefined}
   *          An object containing plugin(s) associated with their name(s) or
   *          `undefined` if no matching plugins exist).
   */
  static getPlugins(e = Object.keys(ps)) {
    let n;
    return e.forEach((a) => {
      const i = qc(a);
      i && (n = n || {}, n[a] = i);
    }), n;
  }
  /**
   * Gets a plugin's version, if available
   *
   * @param   {string} name
   *          The name of a plugin.
   *
   * @return {string}
   *          The plugin's version or an empty string.
   */
  static getPluginVersion(e) {
    const n = qc(e);
    return n && n.VERSION || "";
  }
}
ta.getPlugin = qc;
ta.BASE_PLUGIN_NAME = Du;
ta.registerPlugin(Du, ta);
Mt.prototype.usingPlugin = function(t) {
  return !!this[ks] && this[ks][t] === !0;
};
Mt.prototype.hasPlugin = function(t) {
  return !!Iu(t);
};
function Jne(t, e) {
  let n = !1;
  return function(...a) {
    return n || ut.warn(t), n = !0, e.apply(this, a);
  };
}
function za(t, e, n, a) {
  return Jne(`${e} is deprecated and will be removed in ${t}.0; please use ${n} instead.`, a);
}
var eae = {
  NetworkBadStatus: "networkbadstatus",
  NetworkRequestFailed: "networkrequestfailed",
  NetworkRequestAborted: "networkrequestaborted",
  NetworkRequestTimeout: "networkrequesttimeout",
  NetworkBodyParserFailed: "networkbodyparserfailed",
  StreamingHlsPlaylistParserError: "streaminghlsplaylistparsererror",
  StreamingDashManifestParserError: "streamingdashmanifestparsererror",
  StreamingContentSteeringParserError: "streamingcontentsteeringparsererror",
  StreamingVttParserError: "streamingvttparsererror",
  StreamingFailedToSelectNextSegment: "streamingfailedtoselectnextsegment",
  StreamingFailedToDecryptSegment: "streamingfailedtodecryptsegment",
  StreamingFailedToTransmuxSegment: "streamingfailedtotransmuxsegment",
  StreamingFailedToAppendSegment: "streamingfailedtoappendsegment",
  StreamingCodecsChangeError: "streamingcodecschangeerror"
};
const g_ = (t) => t.indexOf("#") === 0 ? t.slice(1) : t;
function ce(t, e, n) {
  let a = ce.getPlayer(t);
  if (a)
    return e && ut.warn(`Player "${t}" is already initialised. Options will not be applied.`), n && a.ready(n), a;
  const i = typeof t == "string" ? ir("#" + g_(t)) : t;
  if (!uo(i))
    throw new TypeError("The element or ID supplied is not valid. (videojs)");
  const s = ("getRootNode" in i ? i.getRootNode() instanceof j.ShadowRoot : !1) ? i.getRootNode() : i.ownerDocument.body;
  (!i.ownerDocument.defaultView || !s.contains(i)) && ut.warn("The element supplied is not included in the DOM"), e = e || {}, e.restoreEl === !0 && (e.restoreEl = (i.parentNode && i.parentNode.hasAttribute && i.parentNode.hasAttribute("data-vjs-player") ? i.parentNode : i).cloneNode(!0)), ar("beforesetup").forEach((l) => {
    const c = l(i, wt(e));
    if (!ni(c) || Array.isArray(c)) {
      ut.error("please return an object in beforesetup hooks");
      return;
    }
    e = wt(e, c);
  });
  const o = ye.getComponent("Player");
  return a = new o(i, e, n), ar("setup").forEach((l) => l(a)), a;
}
ce.hooks_ = gi;
ce.hooks = ar;
ce.hook = Mte;
ce.hookOnce = Ote;
ce.removeHook = J5;
if (j.VIDEOJS_NO_DYNAMIC_STYLE !== !0 && co()) {
  let t = ir(".vjs-styles-defaults");
  if (!t) {
    t = w3("vjs-styles-defaults");
    const e = ir("head");
    e && e.insertBefore(t, e.firstChild), k3(t, `
      .video-js {
        width: 300px;
        height: 150px;
      }

      .vjs-fluid:not(.vjs-audio-only-mode) {
        padding-top: 56.25%
      }
    `);
  }
}
kh(1, ce);
ce.VERSION = _h;
ce.options = Mt.prototype.options_;
ce.getPlayers = () => Mt.players;
ce.getPlayer = (t) => {
  const e = Mt.players;
  let n;
  if (typeof t == "string") {
    const a = g_(t), i = e[a];
    if (i)
      return i;
    n = ir("#" + a);
  } else
    n = t;
  if (uo(n)) {
    const {
      player: a,
      playerId: i
    } = n;
    if (a || e[i])
      return a || e[i];
  }
};
ce.getAllPlayers = () => (
  // Disposed players leave a key with a `null` value, so we need to make sure
  // we filter those out.
  Object.keys(Mt.players).map((t) => Mt.players[t]).filter(Boolean)
);
ce.players = Mt.players;
ce.getComponent = ye.getComponent;
ce.registerComponent = (t, e) => (rt.isTech(e) && ut.warn(`The ${t} tech was registered as a component. It should instead be registered using videojs.registerTech(name, tech)`), ye.registerComponent.call(ye, t, e));
ce.getTech = rt.getTech;
ce.registerTech = rt.registerTech;
ce.use = lne;
Object.defineProperty(ce, "middleware", {
  value: {},
  writeable: !1,
  enumerable: !0
});
Object.defineProperty(ce.middleware, "TERMINATOR", {
  value: Eu,
  writeable: !1,
  enumerable: !0
});
ce.browser = l3;
ce.obj = Rte;
ce.mergeOptions = za(9, "videojs.mergeOptions", "videojs.obj.merge", wt);
ce.defineLazyProperty = za(9, "videojs.defineLazyProperty", "videojs.obj.defineLazyProperty", md);
ce.bind = za(9, "videojs.bind", "native Function.prototype.bind", Et);
ce.registerPlugin = ta.registerPlugin;
ce.deregisterPlugin = ta.deregisterPlugin;
ce.plugin = (t, e) => (ut.warn("videojs.plugin() is deprecated; use videojs.registerPlugin() instead"), ta.registerPlugin(t, e));
ce.getPlugins = ta.getPlugins;
ce.getPlugin = ta.getPlugin;
ce.getPluginVersion = ta.getPluginVersion;
ce.addLanguage = function(t, e) {
  return t = ("" + t).toLowerCase(), ce.options.languages = wt(ce.options.languages, {
    [t]: e
  }), ce.options.languages[t];
};
ce.log = ut;
ce.createLogger = e3;
ce.time = Kte;
ce.createTimeRange = za(9, "videojs.createTimeRange", "videojs.time.createTimeRanges", Ra);
ce.createTimeRanges = za(9, "videojs.createTimeRanges", "videojs.time.createTimeRanges", Ra);
ce.formatTime = za(9, "videojs.formatTime", "videojs.time.formatTime", $r);
ce.setFormatTime = za(9, "videojs.setFormatTime", "videojs.time.setFormatTime", I3);
ce.resetFormatTime = za(9, "videojs.resetFormatTime", "videojs.time.resetFormatTime", M3);
ce.parseUrl = za(9, "videojs.parseUrl", "videojs.url.parseUrl", hp);
ce.isCrossOrigin = za(9, "videojs.isCrossOrigin", "videojs.url.isCrossOrigin", Ad);
ce.EventTarget = fa;
ce.any = lp;
ce.on = ha;
ce.one = Cd;
ce.off = Ln;
ce.trigger = ho;
ce.xhr = o5;
ce.TextTrack = Wl;
ce.AudioTrack = R3;
ce.VideoTrack = N3;
["isEl", "isTextNode", "createEl", "hasClass", "addClass", "removeClass", "toggleClass", "setAttributes", "getAttributes", "emptyEl", "appendContent", "insertContent"].forEach((t) => {
  ce[t] = function() {
    return ut.warn(`videojs.${t}() is deprecated; use videojs.dom.${t}() instead`), T3[t].apply(null, arguments);
  };
});
ce.computedStyle = za(9, "videojs.computedStyle", "videojs.dom.computedStyle", Ws);
ce.dom = T3;
ce.fn = Vte;
ce.num = Lne;
ce.str = Xte;
ce.url = sne;
ce.Error = eae;
/*! @name videojs-contrib-quality-levels @version 4.1.0 @license Apache-2.0 */
class tae {
  /**
   * Creates a QualityLevel
   *
   * @param {Representation|Object} representation The representation of the quality level
   * @param {string}   representation.id        Unique id of the QualityLevel
   * @param {number=}  representation.width     Resolution width of the QualityLevel
   * @param {number=}  representation.height    Resolution height of the QualityLevel
   * @param {number}   representation.bandwidth Bitrate of the QualityLevel
   * @param {number=}  representation.frameRate Frame-rate of the QualityLevel
   * @param {Function} representation.enabled   Callback to enable/disable QualityLevel
   */
  constructor(e) {
    let n = this;
    return n.id = e.id, n.label = n.id, n.width = e.width, n.height = e.height, n.bitrate = e.bandwidth, n.frameRate = e.frameRate, n.enabled_ = e.enabled, Object.defineProperty(n, "enabled", {
      /**
       * Get whether the QualityLevel is enabled.
       *
       * @return {boolean} True if the QualityLevel is enabled.
       */
      get() {
        return n.enabled_();
      },
      /**
       * Enable or disable the QualityLevel.
       *
       * @param {boolean} enable true to enable QualityLevel, false to disable.
       */
      set(a) {
        n.enabled_(a);
      }
    }), n;
  }
}
class Ou extends ce.EventTarget {
  /**
   * Creates a QualityLevelList.
   */
  constructor() {
    super();
    let e = this;
    return e.levels_ = [], e.selectedIndex_ = -1, Object.defineProperty(e, "selectedIndex", {
      get() {
        return e.selectedIndex_;
      }
    }), Object.defineProperty(e, "length", {
      get() {
        return e.levels_.length;
      }
    }), e[Symbol.iterator] = () => e.levels_.values(), e;
  }
  /**
   * Adds a quality level to the list.
   *
   * @param {Representation|Object} representation The representation of the quality level
   * @param {string}   representation.id        Unique id of the QualityLevel
   * @param {number=}  representation.width     Resolution width of the QualityLevel
   * @param {number=}  representation.height    Resolution height of the QualityLevel
   * @param {number}   representation.bandwidth Bitrate of the QualityLevel
   * @param {number=}  representation.frameRate Frame-rate of the QualityLevel
   * @param {Function} representation.enabled   Callback to enable/disable QualityLevel
   * @return {QualityLevel} the QualityLevel added to the list
   * @method addQualityLevel
   */
  addQualityLevel(e) {
    let n = this.getQualityLevelById(e.id);
    if (n)
      return n;
    const a = this.levels_.length;
    return n = new tae(e), "" + a in this || Object.defineProperty(this, a, {
      get() {
        return this.levels_[a];
      }
    }), this.levels_.push(n), this.trigger({
      qualityLevel: n,
      type: "addqualitylevel"
    }), n;
  }
  /**
   * Removes a quality level from the list.
   *
   * @param {QualityLevel} qualityLevel The QualityLevel to remove from the list.
   * @return {QualityLevel|null} the QualityLevel removed or null if nothing removed
   * @method removeQualityLevel
   */
  removeQualityLevel(e) {
    let n = null;
    for (let a = 0, i = this.length; a < i; a++)
      if (this[a] === e) {
        n = this.levels_.splice(a, 1)[0], this.selectedIndex_ === a ? this.selectedIndex_ = -1 : this.selectedIndex_ > a && this.selectedIndex_--;
        break;
      }
    return n && this.trigger({
      qualityLevel: e,
      type: "removequalitylevel"
    }), n;
  }
  /**
   * Searches for a QualityLevel with the given id.
   *
   * @param {string} id The id of the QualityLevel to find.
   * @return {QualityLevel|null} The QualityLevel with id, or null if not found.
   * @method getQualityLevelById
   */
  getQualityLevelById(e) {
    for (let n = 0, a = this.length; n < a; n++) {
      const i = this[n];
      if (i.id === e)
        return i;
    }
    return null;
  }
  /**
   * Resets the list of QualityLevels to empty
   *
   * @method dispose
   */
  dispose() {
    this.selectedIndex_ = -1, this.levels_.length = 0;
  }
}
Ou.prototype.allowedEvents_ = {
  change: "change",
  addqualitylevel: "addqualitylevel",
  removequalitylevel: "removequalitylevel"
};
for (const t in Ou.prototype.allowedEvents_)
  Ou.prototype["on" + t] = null;
var b_ = "4.1.0";
const nae = function(t, e) {
  const n = t.qualityLevels, a = new Ou(), i = function() {
    a.dispose(), t.qualityLevels = n, t.off("dispose", i);
  };
  return t.on("dispose", i), t.qualityLevels = () => a, t.qualityLevels.VERSION = b_, a;
}, v_ = function(t) {
  return nae(this, ce.obj.merge({}, t));
};
ce.registerPlugin("qualityLevels", v_);
v_.VERSION = b_;
/*! @name @videojs/http-streaming @version 3.16.2 @license Apache-2.0 */
const Zn = cd, Pu = (t, e) => e && e.responseURL && t !== e.responseURL ? e.responseURL : t, Ca = (t) => ce.log.debug ? ce.log.debug.bind(ce, "VHS:", `${t} >`) : function() {
};
function gt(...t) {
  const e = ce.obj || ce;
  return (e.merge || e.mergeOptions).apply(e, t);
}
function vn(...t) {
  const e = ce.time || ce;
  return (e.createTimeRanges || e.createTimeRanges).apply(e, t);
}
function aae(t) {
  if (t.length === 0)
    return "Buffered Ranges are empty";
  let e = `Buffered Ranges: 
`;
  for (let n = 0; n < t.length; n++) {
    const a = t.start(n), i = t.end(n);
    e += `${a} --> ${i}. Duration (${i - a})
`;
  }
  return e;
}
const Za = 1 / 30, Ka = Za * 3, y_ = function(t, e) {
  const n = [];
  let a;
  if (t && t.length)
    for (a = 0; a < t.length; a++)
      e(t.start(a), t.end(a)) && n.push([t.start(a), t.end(a)]);
  return vn(n);
}, ms = function(t, e) {
  return y_(t, function(n, a) {
    return n - Ka <= e && a + Ka >= e;
  });
}, Rc = function(t, e) {
  return y_(t, function(n) {
    return n - Za >= e;
  });
}, iae = function(t) {
  if (t.length < 2)
    return vn();
  const e = [];
  for (let n = 1; n < t.length; n++) {
    const a = t.end(n - 1), i = t.start(n);
    e.push([a, i]);
  }
  return vn(e);
}, rae = function(t, e) {
  let n = null, a = null, i = 0;
  const r = [], s = [];
  if (!t || !t.length || !e || !e.length)
    return vn();
  let o = t.length;
  for (; o--; )
    r.push({
      time: t.start(o),
      type: "start"
    }), r.push({
      time: t.end(o),
      type: "end"
    });
  for (o = e.length; o--; )
    r.push({
      time: e.start(o),
      type: "start"
    }), r.push({
      time: e.end(o),
      type: "end"
    });
  for (r.sort(function(l, c) {
    return l.time - c.time;
  }), o = 0; o < r.length; o++)
    r[o].type === "start" ? (i++, i === 2 && (n = r[o].time)) : r[o].type === "end" && (i--, i === 1 && (a = r[o].time)), n !== null && a !== null && (s.push([n, a]), n = null, a = null);
  return vn(s);
}, __ = (t) => {
  const e = [];
  if (!t || !t.length)
    return "";
  for (let n = 0; n < t.length; n++)
    e.push(t.start(n) + " => " + t.end(n));
  return e.join(", ");
}, sae = function(t, e, n = 1) {
  return ((t.length ? t.end(t.length - 1) : 0) - e) / n;
}, Sr = (t) => {
  const e = [];
  for (let n = 0; n < t.length; n++)
    e.push({
      start: t.start(n),
      end: t.end(n)
    });
  return e;
}, oae = function(t, e) {
  if (t === e)
    return !1;
  if (!t && e || !e && t || t.length !== e.length)
    return !0;
  for (let n = 0; n < t.length; n++)
    if (t.start(n) !== e.start(n) || t.end(n) !== e.end(n))
      return !0;
  return !1;
}, F0 = function(t) {
  if (!(!t || !t.length || !t.end))
    return t.end(t.length - 1);
}, Lp = function(t, e) {
  let n = 0;
  if (!t || !t.length)
    return n;
  for (let a = 0; a < t.length; a++) {
    const i = t.start(a), r = t.end(a);
    if (!(e > r)) {
      if (e > i && e <= r) {
        n += r - e;
        continue;
      }
      n += r - i;
    }
  }
  return n;
}, Dp = (t, e) => {
  if (!e.preload)
    return e.duration;
  let n = 0;
  return (e.parts || []).forEach(function(a) {
    n += a.duration;
  }), (e.preloadHints || []).forEach(function(a) {
    a.type === "PART" && (n += t.partTargetDuration);
  }), n;
}, Ih = (t) => (t.segments || []).reduce((e, n, a) => (n.parts ? n.parts.forEach(function(i, r) {
  e.push({
    duration: i.duration,
    segmentIndex: a,
    partIndex: r,
    part: i,
    segment: n
  });
}) : e.push({
  duration: n.duration,
  segmentIndex: a,
  partIndex: null,
  segment: n,
  part: null
}), e), []), T_ = (t) => {
  const e = t.segments && t.segments.length && t.segments[t.segments.length - 1];
  return e && e.parts || [];
}, x_ = ({
  preloadSegment: t
}) => {
  if (!t)
    return;
  const {
    parts: e,
    preloadHints: n
  } = t;
  let a = (n || []).reduce((i, r) => i + (r.type === "PART" ? 1 : 0), 0);
  return a += e && e.length ? e.length : 0, a;
}, w_ = (t, e) => {
  if (e.endList)
    return 0;
  if (t && t.suggestedPresentationDelay)
    return t.suggestedPresentationDelay;
  const n = T_(e).length > 0;
  return n && e.serverControl && e.serverControl.partHoldBack ? e.serverControl.partHoldBack : n && e.partTargetDuration ? e.partTargetDuration * 3 : e.serverControl && e.serverControl.holdBack ? e.serverControl.holdBack : e.targetDuration ? e.targetDuration * 3 : 0;
}, lae = function(t, e) {
  let n = 0, a = e - t.mediaSequence, i = t.segments[a];
  if (i) {
    if (typeof i.start < "u")
      return {
        result: i.start,
        precise: !0
      };
    if (typeof i.end < "u")
      return {
        result: i.end - i.duration,
        precise: !0
      };
  }
  for (; a--; ) {
    if (i = t.segments[a], typeof i.end < "u")
      return {
        result: n + i.end,
        precise: !0
      };
    if (n += Dp(t, i), typeof i.start < "u")
      return {
        result: n + i.start,
        precise: !0
      };
  }
  return {
    result: n,
    precise: !1
  };
}, cae = function(t, e) {
  let n = 0, a, i = e - t.mediaSequence;
  for (; i < t.segments.length; i++) {
    if (a = t.segments[i], typeof a.start < "u")
      return {
        result: a.start - n,
        precise: !0
      };
    if (n += Dp(t, a), typeof a.end < "u")
      return {
        result: a.end - n,
        precise: !0
      };
  }
  return {
    result: -1,
    precise: !1
  };
}, k_ = function(t, e, n) {
  if (typeof e > "u" && (e = t.mediaSequence + t.segments.length), e < t.mediaSequence)
    return 0;
  const a = lae(t, e);
  if (a.precise)
    return a.result;
  const i = cae(t, e);
  return i.precise ? i.result : a.result + n;
}, C_ = function(t, e, n) {
  if (!t)
    return 0;
  if (typeof n != "number" && (n = 0), typeof e > "u") {
    if (t.totalDuration)
      return t.totalDuration;
    if (!t.endList)
      return j.Infinity;
  }
  return k_(t, e, n);
}, ml = function({
  defaultDuration: t,
  durationList: e,
  startIndex: n,
  endIndex: a
}) {
  let i = 0;
  if (n > a && ([n, a] = [a, n]), n < 0) {
    for (let r = n; r < Math.min(0, a); r++)
      i += t;
    n = 0;
  }
  for (let r = n; r < a; r++)
    i += e[r].duration;
  return i;
}, S_ = function(t, e, n, a) {
  if (!t || !t.segments)
    return null;
  if (t.endList)
    return C_(t);
  if (e === null)
    return null;
  e = e || 0;
  let i = k_(t, t.mediaSequence + t.segments.length, e);
  return n && (a = typeof a == "number" ? a : w_(null, t), i -= a), Math.max(0, i);
}, uae = function(t, e, n) {
  const i = e || 0;
  let r = S_(t, e, !0, n);
  return r === null ? vn() : (r < i && (r = i), vn(i, r));
}, dae = function({
  playlist: t,
  currentTime: e,
  startingSegmentIndex: n,
  startingPartIndex: a,
  startTime: i,
  exactManifestTimings: r
}) {
  let s = e - i;
  const o = Ih(t);
  let l = 0;
  for (let c = 0; c < o.length; c++) {
    const u = o[c];
    if (n === u.segmentIndex && !(typeof a == "number" && typeof u.partIndex == "number" && a !== u.partIndex)) {
      l = c;
      break;
    }
  }
  if (s < 0) {
    if (l > 0)
      for (let c = l - 1; c >= 0; c--) {
        const u = o[c];
        if (s += u.duration, r) {
          if (s < 0)
            continue;
        } else if (s + Za <= 0)
          continue;
        return {
          partIndex: u.partIndex,
          segmentIndex: u.segmentIndex,
          startTime: i - ml({
            defaultDuration: t.targetDuration,
            durationList: o,
            startIndex: l,
            endIndex: c
          })
        };
      }
    return {
      partIndex: o[0] && o[0].partIndex || null,
      segmentIndex: o[0] && o[0].segmentIndex || 0,
      startTime: e
    };
  }
  if (l < 0) {
    for (let c = l; c < 0; c++)
      if (s -= t.targetDuration, s < 0)
        return {
          partIndex: o[0] && o[0].partIndex || null,
          segmentIndex: o[0] && o[0].segmentIndex || 0,
          startTime: e
        };
    l = 0;
  }
  for (let c = l; c < o.length; c++) {
    const u = o[c];
    s -= u.duration;
    const f = u.duration > Za, m = s === 0, _ = f && s + Za >= 0;
    if (!((m || _) && c !== o.length - 1)) {
      if (r) {
        if (s > 0)
          continue;
      } else if (s - Za >= 0)
        continue;
      return {
        partIndex: u.partIndex,
        segmentIndex: u.segmentIndex,
        startTime: i + ml({
          defaultDuration: t.targetDuration,
          durationList: o,
          startIndex: l,
          endIndex: c
        })
      };
    }
  }
  return {
    segmentIndex: o[o.length - 1].segmentIndex,
    partIndex: o[o.length - 1].partIndex,
    startTime: e
  };
}, A_ = function(t) {
  return t.excludeUntil && t.excludeUntil > Date.now();
}, Ip = function(t) {
  return t.excludeUntil && t.excludeUntil === 1 / 0;
}, Id = function(t) {
  const e = A_(t);
  return !t.disabled && !e;
}, hae = function(t) {
  return t.disabled;
}, fae = function(t) {
  for (let e = 0; e < t.segments.length; e++)
    if (t.segments[e].key)
      return !0;
  return !1;
}, E_ = function(t, e) {
  return e.attributes && e.attributes[t];
}, pae = function(t, e, n, a = 0) {
  return E_("BANDWIDTH", n) ? (t * n.attributes.BANDWIDTH - a * 8) / e : NaN;
}, Mh = (t, e) => {
  if (t.playlists.length === 1)
    return !0;
  const n = e.attributes.BANDWIDTH || Number.MAX_VALUE;
  return t.playlists.filter((a) => Id(a) ? (a.attributes.BANDWIDTH || 0) < n : !1).length === 0;
}, Mp = (t, e) => !t && !e || !t && e || t && !e ? !1 : !!(t === e || t.id && e.id && t.id === e.id || t.resolvedUri && e.resolvedUri && t.resolvedUri === e.resolvedUri || t.uri && e.uri && t.uri === e.uri), Sb = function(t, e) {
  const n = t && t.mediaGroups && t.mediaGroups.AUDIO || {};
  let a = !1;
  for (const i in n) {
    for (const r in n[i])
      if (a = e(n[i][r]), a)
        break;
    if (a)
      break;
  }
  return !!a;
}, Kl = (t) => {
  if (!t || !t.playlists || !t.playlists.length)
    return Sb(t, (n) => n.playlists && n.playlists.length || n.uri);
  for (let e = 0; e < t.playlists.length; e++) {
    const n = t.playlists[e], a = n.attributes && n.attributes.CODECS;
    if (!(a && a.split(",").every((r) => f5(r)) || Sb(t, (r) => Mp(n, r))))
      return !1;
  }
  return !0;
};
var Kn = {
  liveEdgeDelay: w_,
  duration: C_,
  seekable: uae,
  getMediaInfoForTime: dae,
  isEnabled: Id,
  isDisabled: hae,
  isExcluded: A_,
  isIncompatible: Ip,
  playlistEnd: S_,
  isAes: fae,
  hasAttribute: E_,
  estimateSegmentRequestTime: pae,
  isLowestEnabledRendition: Mh,
  isAudioOnly: Kl,
  playlistMatch: Mp,
  segmentDurationWithParts: Dp
};
const {
  log: L_
} = ce, Cs = (t, e) => `${t}-${e}`, D_ = (t, e, n) => `placeholder-uri-${t}-${e}-${n}`, mae = ({
  onwarn: t,
  oninfo: e,
  manifestString: n,
  customTagParsers: a = [],
  customTagMappers: i = [],
  llhls: r
}) => {
  const s = new DJ();
  t && s.on("warn", t), e && s.on("info", e), a.forEach((c) => s.addParser(c)), i.forEach((c) => s.addTagMapper(c)), s.push(n), s.end();
  const o = s.manifest;
  if (r || (["preloadSegment", "skip", "serverControl", "renditionReports", "partInf", "partTargetDuration"].forEach(function(c) {
    o.hasOwnProperty(c) && delete o[c];
  }), o.segments && o.segments.forEach(function(c) {
    ["parts", "preloadHints"].forEach(function(u) {
      c.hasOwnProperty(u) && delete c[u];
    });
  })), !o.targetDuration) {
    let c = 10;
    o.segments && o.segments.length && (c = o.segments.reduce((u, f) => Math.max(u, f.duration), 0)), t && t({
      message: `manifest has no targetDuration defaulting to ${c}`
    }), o.targetDuration = c;
  }
  const l = T_(o);
  if (l.length && !o.partTargetDuration) {
    const c = l.reduce((u, f) => Math.max(u, f.duration), 0);
    t && (t({
      message: `manifest has no partTargetDuration defaulting to ${c}`
    }), L_.error("LL-HLS manifest has parts but lacks required #EXT-X-PART-INF:PART-TARGET value. See https://datatracker.ietf.org/doc/html/draft-pantos-hls-rfc8216bis-09#section-4.4.3.7. Playback is not guaranteed.")), o.partTargetDuration = c;
  }
  return o;
}, go = (t, e) => {
  t.mediaGroups && ["AUDIO", "SUBTITLES"].forEach((n) => {
    if (t.mediaGroups[n])
      for (const a in t.mediaGroups[n])
        for (const i in t.mediaGroups[n][a]) {
          const r = t.mediaGroups[n][a][i];
          e(r, n, a, i);
        }
  });
}, I_ = ({
  playlist: t,
  uri: e,
  id: n
}) => {
  t.id = n, t.playlistErrors_ = 0, e && (t.uri = e), t.attributes = t.attributes || {};
}, gae = (t) => {
  let e = t.playlists.length;
  for (; e--; ) {
    const n = t.playlists[e];
    I_({
      playlist: n,
      id: Cs(e, n.uri)
    }), n.resolvedUri = Zn(t.uri, n.uri), t.playlists[n.id] = n, t.playlists[n.uri] = n, n.attributes.BANDWIDTH || L_.warn("Invalid playlist STREAM-INF detected. Missing BANDWIDTH attribute.");
  }
}, bae = (t) => {
  go(t, (e) => {
    e.uri && (e.resolvedUri = Zn(t.uri, e.uri));
  });
}, vae = (t, e) => {
  const n = Cs(0, e), a = {
    mediaGroups: {
      AUDIO: {},
      VIDEO: {},
      "CLOSED-CAPTIONS": {},
      SUBTITLES: {}
    },
    uri: j.location.href,
    resolvedUri: j.location.href,
    playlists: [{
      uri: e,
      id: n,
      resolvedUri: e,
      // m3u8-parser does not attach an attributes property to media playlists so make
      // sure that the property is attached to avoid undefined reference errors
      attributes: {}
    }]
  };
  return a.playlists[n] = a.playlists[0], a.playlists[e] = a.playlists[0], a;
}, M_ = (t, e, n = D_) => {
  t.uri = e;
  for (let i = 0; i < t.playlists.length; i++)
    if (!t.playlists[i].uri) {
      const r = `placeholder-uri-${i}`;
      t.playlists[i].uri = r;
    }
  const a = Kl(t);
  go(t, (i, r, s, o) => {
    if (!i.playlists || !i.playlists.length) {
      if (a && r === "AUDIO" && !i.uri)
        for (let l = 0; l < t.playlists.length; l++) {
          const c = t.playlists[l];
          if (c.attributes && c.attributes.AUDIO && c.attributes.AUDIO === s)
            return;
        }
      i.playlists = [Jt({}, i)];
    }
    i.playlists.forEach(function(l, c) {
      const u = n(r, s, o, l), f = Cs(c, u);
      l.uri ? l.resolvedUri = l.resolvedUri || Zn(t.uri, l.uri) : (l.uri = c === 0 ? u : f, l.resolvedUri = l.uri), l.id = l.id || f, l.attributes = l.attributes || {}, t.playlists[l.id] = l, t.playlists[l.uri] = l;
    });
  }), gae(t), bae(t);
};
class Ab {
  constructor() {
    this.offset_ = null, this.pendingDateRanges_ = /* @__PURE__ */ new Map(), this.processedDateRanges_ = /* @__PURE__ */ new Map();
  }
  setOffset(e = []) {
    if (this.offset_ !== null || !e.length)
      return;
    const [n] = e;
    n.programDateTime !== void 0 && (this.offset_ = n.programDateTime / 1e3);
  }
  setPendingDateRanges(e = []) {
    if (!e.length)
      return;
    const [n] = e, a = n.startDate.getTime();
    this.trimProcessedDateRanges_(a), this.pendingDateRanges_ = e.reduce((i, r) => (i.set(r.id, r), i), /* @__PURE__ */ new Map());
  }
  processDateRange(e) {
    this.pendingDateRanges_.delete(e.id), this.processedDateRanges_.set(e.id, e);
  }
  getDateRangesToProcess() {
    if (this.offset_ === null)
      return [];
    const e = {}, n = [];
    this.pendingDateRanges_.forEach((a, i) => {
      if (!this.processedDateRanges_.has(i) && (a.startTime = a.startDate.getTime() / 1e3 - this.offset_, a.processDateRange = () => this.processDateRange(a), n.push(a), !!a.class))
        if (e[a.class]) {
          const r = e[a.class].push(a);
          a.classListIndex = r - 1;
        } else
          e[a.class] = [a], a.classListIndex = 0;
    });
    for (const a of n) {
      const i = e[a.class] || [];
      a.endDate ? a.endTime = a.endDate.getTime() / 1e3 - this.offset_ : a.endOnNext && i[a.classListIndex + 1] ? a.endTime = i[a.classListIndex + 1].startTime : a.duration ? a.endTime = a.startTime + a.duration : a.plannedDuration ? a.endTime = a.startTime + a.plannedDuration : a.endTime = a.startTime;
    }
    return n;
  }
  trimProcessedDateRanges_(e) {
    new Map(this.processedDateRanges_).forEach((a, i) => {
      a.startDate.getTime() < e && this.processedDateRanges_.delete(i);
    });
  }
}
const O_ = 22, Or = ({
  requestType: t,
  request: e,
  error: n,
  parseFailure: a
}) => {
  const i = e.status < 200 || e.status > 299, r = e.status >= 400 && e.status <= 499, s = {
    uri: e.uri,
    requestType: t
  }, o = i && !r || a;
  if (n && r)
    s.error = Jt({}, n), s.errorType = ce.Error.NetworkRequestFailed;
  else if (e.aborted)
    s.errorType = ce.Error.NetworkRequestAborted;
  else if (e.timedout)
    s.erroType = ce.Error.NetworkRequestTimeout;
  else if (o) {
    const l = a ? ce.Error.NetworkBodyParserFailed : ce.Error.NetworkBadStatus;
    s.errorType = l, s.status = e.status, s.headers = e.headers;
  }
  return s;
}, {
  EventTarget: yae
} = ce, _ae = (t, e) => {
  if (e.endList || !e.serverControl)
    return t;
  const n = {};
  if (e.serverControl.canBlockReload) {
    const {
      preloadSegment: a
    } = e;
    let i = e.mediaSequence + e.segments.length;
    if (a) {
      const r = a.parts || [], s = x_(e) - 1;
      s > -1 && s !== r.length - 1 && (n._HLS_part = s), (s > -1 || r.length) && i--;
    }
    n._HLS_msn = i;
  }
  if (e.serverControl && e.serverControl.canSkipUntil && (n._HLS_skip = e.serverControl.canSkipDateranges ? "v2" : "YES"), Object.keys(n).length) {
    const a = new j.URL(t);
    ["_HLS_skip", "_HLS_msn", "_HLS_part"].forEach(function(i) {
      n.hasOwnProperty(i) && a.searchParams.set(i, n[i]);
    }), t = a.toString();
  }
  return t;
}, Tae = (t, e) => {
  if (!t)
    return e;
  const n = gt(t, e);
  if (t.preloadHints && !e.preloadHints && delete n.preloadHints, t.parts && !e.parts)
    delete n.parts;
  else if (t.parts && e.parts)
    for (let a = 0; a < e.parts.length; a++)
      t.parts && t.parts[a] && (n.parts[a] = gt(t.parts[a], e.parts[a]));
  return !t.skipped && e.skipped && (n.skipped = !1), t.preload && !e.preload && (n.preload = !1), n;
}, xae = (t, e, n) => {
  const a = t.slice(), i = e.slice();
  n = n || 0;
  const r = [];
  let s;
  for (let o = 0; o < i.length; o++) {
    const l = a[o + n], c = i[o];
    l ? (s = l.map || s, r.push(Tae(l, c))) : (s && !c.map && (c.map = s), r.push(c));
  }
  return r;
}, P_ = (t, e) => {
  !t.resolvedUri && t.uri && (t.resolvedUri = Zn(e, t.uri)), t.key && !t.key.resolvedUri && (t.key.resolvedUri = Zn(e, t.key.uri)), t.map && !t.map.resolvedUri && (t.map.resolvedUri = Zn(e, t.map.uri)), t.map && t.map.key && !t.map.key.resolvedUri && (t.map.key.resolvedUri = Zn(e, t.map.key.uri)), t.parts && t.parts.length && t.parts.forEach((n) => {
    n.resolvedUri || (n.resolvedUri = Zn(e, n.uri));
  }), t.preloadHints && t.preloadHints.length && t.preloadHints.forEach((n) => {
    n.resolvedUri || (n.resolvedUri = Zn(e, n.uri));
  });
}, B_ = function(t) {
  const e = t.segments || [], n = t.preloadSegment;
  if (n && n.parts && n.parts.length) {
    if (n.preloadHints) {
      for (let a = 0; a < n.preloadHints.length; a++)
        if (n.preloadHints[a].type === "MAP")
          return e;
    }
    n.duration = t.targetDuration, n.preload = !0, e.push(n);
  }
  return e;
}, R_ = (t, e) => t === e || t.segments && e.segments && t.segments.length === e.segments.length && t.endList === e.endList && t.mediaSequence === e.mediaSequence && t.preloadSegment === e.preloadSegment, Oh = (t, e, n = R_) => {
  const a = gt(t, {}), i = a.playlists[e.id];
  if (!i || n(i, e))
    return null;
  e.segments = B_(e);
  const r = gt(i, e);
  if (r.preloadSegment && !e.preloadSegment && delete r.preloadSegment, i.segments) {
    if (e.skip) {
      e.segments = e.segments || [];
      for (let s = 0; s < e.skip.skippedSegments; s++)
        e.segments.unshift({
          skipped: !0
        });
    }
    r.segments = xae(i.segments, e.segments, e.mediaSequence - i.mediaSequence);
  }
  r.segments.forEach((s) => {
    P_(s, r.resolvedUri);
  });
  for (let s = 0; s < a.playlists.length; s++)
    a.playlists[s].id === e.id && (a.playlists[s] = r);
  return a.playlists[e.id] = r, a.playlists[e.uri] = r, go(t, (s, o, l, c) => {
    if (s.playlists)
      for (let u = 0; u < s.playlists.length; u++)
        e.id === s.playlists[u].id && (s.playlists[u] = r);
  }), a;
}, Ph = (t, e) => {
  const n = t.segments || [], a = n[n.length - 1], i = a && a.parts && a.parts[a.parts.length - 1], r = i && i.duration || a && a.duration;
  return e && r ? r * 1e3 : (t.partTargetDuration || t.targetDuration || 10) * 500;
}, Eb = (t, e, n) => {
  if (!t)
    return;
  const a = [];
  return t.forEach((i) => {
    if (!i.attributes)
      return;
    const {
      BANDWIDTH: r,
      RESOLUTION: s,
      CODECS: o
    } = i.attributes;
    a.push({
      id: i.id,
      bandwidth: r,
      resolution: s,
      codecs: o
    });
  }), {
    type: e,
    isLive: n,
    renditions: a
  };
};
class gs extends yae {
  constructor(e, n, a = {}) {
    if (super(), !e)
      throw new Error("A non-empty playlist URL or object is required");
    this.logger_ = Ca("PlaylistLoader");
    const {
      withCredentials: i = !1
    } = a;
    this.src = e, this.vhs_ = n, this.withCredentials = i, this.addDateRangesToTextTrack_ = a.addDateRangesToTextTrack;
    const r = n.options_;
    this.customTagParsers = r && r.customTagParsers || [], this.customTagMappers = r && r.customTagMappers || [], this.llhls = r && r.llhls, this.dateRangesStorage_ = new Ab(), this.state = "HAVE_NOTHING", this.handleMediaupdatetimeout_ = this.handleMediaupdatetimeout_.bind(this), this.on("mediaupdatetimeout", this.handleMediaupdatetimeout_), this.on("loadedplaylist", this.handleLoadedPlaylist_.bind(this));
  }
  handleLoadedPlaylist_() {
    const e = this.media();
    if (!e)
      return;
    this.dateRangesStorage_.setOffset(e.segments), this.dateRangesStorage_.setPendingDateRanges(e.dateRanges);
    const n = this.dateRangesStorage_.getDateRangesToProcess();
    !n.length || !this.addDateRangesToTextTrack_ || this.addDateRangesToTextTrack_(n);
  }
  handleMediaupdatetimeout_() {
    if (this.state !== "HAVE_METADATA")
      return;
    const e = this.media();
    let n = Zn(this.main.uri, e.uri);
    this.llhls && (n = _ae(n, e)), this.state = "HAVE_CURRENT_METADATA", this.request = this.vhs_.xhr({
      uri: n,
      withCredentials: this.withCredentials,
      requestType: "hls-playlist"
    }, (a, i) => {
      if (this.request) {
        if (a)
          return this.playlistRequestError(this.request, this.media(), "HAVE_METADATA");
        this.haveMetadata({
          playlistString: this.request.responseText,
          url: this.media().uri,
          id: this.media().id
        });
      }
    });
  }
  playlistRequestError(e, n, a) {
    const {
      uri: i,
      id: r
    } = n;
    this.request = null, a && (this.state = a), this.error = {
      playlist: this.main.playlists[r],
      status: e.status,
      message: `HLS playlist request error at URL: ${i}.`,
      responseText: e.responseText,
      code: e.status >= 500 ? 4 : 2,
      metadata: Or({
        requestType: e.requestType,
        request: e,
        error: e.error
      })
    }, this.trigger("error");
  }
  parseManifest_({
    url: e,
    manifestString: n
  }) {
    try {
      return mae({
        onwarn: ({
          message: a
        }) => this.logger_(`m3u8-parser warn for ${e}: ${a}`),
        oninfo: ({
          message: a
        }) => this.logger_(`m3u8-parser info for ${e}: ${a}`),
        manifestString: n,
        customTagParsers: this.customTagParsers,
        customTagMappers: this.customTagMappers,
        llhls: this.llhls
      });
    } catch (a) {
      this.error = a, this.error.metadata = {
        errorType: ce.Error.StreamingHlsPlaylistParserError,
        error: a
      };
    }
  }
  /**
   * Update the playlist loader's state in response to a new or updated playlist.
   *
   * @param {string} [playlistString]
   *        Playlist string (if playlistObject is not provided)
   * @param {Object} [playlistObject]
   *        Playlist object (if playlistString is not provided)
   * @param {string} url
   *        URL of playlist
   * @param {string} id
   *        ID to use for playlist
   */
  haveMetadata({
    playlistString: e,
    playlistObject: n,
    url: a,
    id: i
  }) {
    this.request = null, this.state = "HAVE_METADATA";
    const r = {
      playlistInfo: {
        type: "media",
        uri: a
      }
    };
    this.trigger({
      type: "playlistparsestart",
      metadata: r
    });
    const s = n || this.parseManifest_({
      url: a,
      manifestString: e
    });
    s.lastRequest = Date.now(), I_({
      playlist: s,
      uri: a,
      id: i
    });
    const o = Oh(this.main, s);
    this.targetDuration = s.partTargetDuration || s.targetDuration, this.pendingMedia_ = null, o ? (this.main = o, this.media_ = this.main.playlists[i]) : this.trigger("playlistunchanged"), this.updateMediaUpdateTimeout_(Ph(this.media(), !!o)), r.parsedPlaylist = Eb(this.main.playlists, r.playlistInfo.type, !this.media_.endList), this.trigger({
      type: "playlistparsecomplete",
      metadata: r
    }), this.trigger("loadedplaylist");
  }
  /**
    * Abort any outstanding work and clean up.
    */
  dispose() {
    this.trigger("dispose"), this.stopRequest(), j.clearTimeout(this.mediaUpdateTimeout), j.clearTimeout(this.finalRenditionTimeout), this.dateRangesStorage_ = new Ab(), this.off();
  }
  stopRequest() {
    if (this.request) {
      const e = this.request;
      this.request = null, e.onreadystatechange = null, e.abort();
    }
  }
  /**
    * When called without any arguments, returns the currently
    * active media playlist. When called with a single argument,
    * triggers the playlist loader to asynchronously switch to the
    * specified media playlist. Calling this method while the
    * loader is in the HAVE_NOTHING causes an error to be emitted
    * but otherwise has no effect.
    *
    * @param {Object=} playlist the parsed media playlist
    * object to switch to
    * @param {boolean=} shouldDelay whether we should delay the request by half target duration
    *
    * @return {Playlist} the current loaded media
    */
  media(e, n) {
    if (!e)
      return this.media_;
    if (this.state === "HAVE_NOTHING")
      throw new Error("Cannot switch media playlist from " + this.state);
    if (typeof e == "string") {
      if (!this.main.playlists[e])
        throw new Error("Unknown playlist URI: " + e);
      e = this.main.playlists[e];
    }
    if (j.clearTimeout(this.finalRenditionTimeout), n) {
      const o = (e.partTargetDuration || e.targetDuration) / 2 * 1e3 || 5e3;
      this.finalRenditionTimeout = j.setTimeout(this.media.bind(this, e, !1), o);
      return;
    }
    const a = this.state, i = !this.media_ || e.id !== this.media_.id, r = this.main.playlists[e.id];
    if (r && r.endList || // handle the case of a playlist object (e.g., if using vhs-json with a resolved
    // media playlist or, for the case of demuxed audio, a resolved audio media group)
    e.endList && e.segments.length) {
      this.request && (this.request.onreadystatechange = null, this.request.abort(), this.request = null), this.state = "HAVE_METADATA", this.media_ = e, i && (this.trigger("mediachanging"), a === "HAVE_MAIN_MANIFEST" ? this.trigger("loadedmetadata") : this.trigger("mediachange"));
      return;
    }
    if (this.updateMediaUpdateTimeout_(Ph(e, !0)), !i)
      return;
    if (this.state = "SWITCHING_MEDIA", this.request) {
      if (e.resolvedUri === this.request.url)
        return;
      this.request.onreadystatechange = null, this.request.abort(), this.request = null;
    }
    this.media_ && this.trigger("mediachanging"), this.pendingMedia_ = e;
    const s = {
      playlistInfo: {
        type: "media",
        uri: e.uri
      }
    };
    this.trigger({
      type: "playlistrequeststart",
      metadata: s
    }), this.request = this.vhs_.xhr({
      uri: e.resolvedUri,
      withCredentials: this.withCredentials,
      requestType: "hls-playlist"
    }, (o, l) => {
      if (this.request) {
        if (e.lastRequest = Date.now(), e.resolvedUri = Pu(e.resolvedUri, l), o)
          return this.playlistRequestError(this.request, e, a);
        this.trigger({
          type: "playlistrequestcomplete",
          metadata: s
        }), this.haveMetadata({
          playlistString: l.responseText,
          url: e.uri,
          id: e.id
        }), a === "HAVE_MAIN_MANIFEST" ? this.trigger("loadedmetadata") : this.trigger("mediachange");
      }
    });
  }
  /**
   * pause loading of the playlist
   */
  pause() {
    this.mediaUpdateTimeout && (j.clearTimeout(this.mediaUpdateTimeout), this.mediaUpdateTimeout = null), this.stopRequest(), this.state === "HAVE_NOTHING" && (this.started = !1), this.state === "SWITCHING_MEDIA" ? this.media_ ? this.state = "HAVE_METADATA" : this.state = "HAVE_MAIN_MANIFEST" : this.state === "HAVE_CURRENT_METADATA" && (this.state = "HAVE_METADATA");
  }
  /**
   * start loading of the playlist
   */
  load(e) {
    this.mediaUpdateTimeout && (j.clearTimeout(this.mediaUpdateTimeout), this.mediaUpdateTimeout = null);
    const n = this.media();
    if (e) {
      const a = n ? (n.partTargetDuration || n.targetDuration) / 2 * 1e3 : 5e3;
      this.mediaUpdateTimeout = j.setTimeout(() => {
        this.mediaUpdateTimeout = null, this.load();
      }, a);
      return;
    }
    if (!this.started) {
      this.start();
      return;
    }
    n && !n.endList ? this.trigger("mediaupdatetimeout") : this.trigger("loadedplaylist");
  }
  updateMediaUpdateTimeout_(e) {
    this.mediaUpdateTimeout && (j.clearTimeout(this.mediaUpdateTimeout), this.mediaUpdateTimeout = null), !(!this.media() || this.media().endList) && (this.mediaUpdateTimeout = j.setTimeout(() => {
      this.mediaUpdateTimeout = null, this.trigger("mediaupdatetimeout"), this.updateMediaUpdateTimeout_(e);
    }, e));
  }
  /**
   * start loading of the playlist
   */
  start() {
    if (this.started = !0, typeof this.src == "object") {
      this.src.uri || (this.src.uri = j.location.href), this.src.resolvedUri = this.src.uri, setTimeout(() => {
        this.setupInitialPlaylist(this.src);
      }, 0);
      return;
    }
    const e = {
      playlistInfo: {
        type: "multivariant",
        uri: this.src
      }
    };
    this.trigger({
      type: "playlistrequeststart",
      metadata: e
    }), this.request = this.vhs_.xhr({
      uri: this.src,
      withCredentials: this.withCredentials,
      requestType: "hls-playlist"
    }, (n, a) => {
      if (!this.request)
        return;
      if (this.request = null, n)
        return this.error = {
          status: a.status,
          message: `HLS playlist request error at URL: ${this.src}.`,
          responseText: a.responseText,
          // MEDIA_ERR_NETWORK
          code: 2,
          metadata: Or({
            requestType: a.requestType,
            request: a,
            error: n
          })
        }, this.state === "HAVE_NOTHING" && (this.started = !1), this.trigger("error");
      this.trigger({
        type: "playlistrequestcomplete",
        metadata: e
      }), this.src = Pu(this.src, a), this.trigger({
        type: "playlistparsestart",
        metadata: e
      });
      const i = this.parseManifest_({
        manifestString: a.responseText,
        url: this.src
      });
      e.parsedPlaylist = Eb(i.playlists, e.playlistInfo.type, !1), this.trigger({
        type: "playlistparsecomplete",
        metadata: e
      }), this.setupInitialPlaylist(i);
    });
  }
  srcUri() {
    return typeof this.src == "string" ? this.src : this.src.uri;
  }
  /**
   * Given a manifest object that's either a main or media playlist, trigger the proper
   * events and set the state of the playlist loader.
   *
   * If the manifest object represents a main playlist, `loadedplaylist` will be
   * triggered to allow listeners to select a playlist. If none is selected, the loader
   * will default to the first one in the playlists array.
   *
   * If the manifest object represents a media playlist, `loadedplaylist` will be
   * triggered followed by `loadedmetadata`, as the only available playlist is loaded.
   *
   * In the case of a media playlist, a main playlist object wrapper with one playlist
   * will be created so that all logic can handle playlists in the same fashion (as an
   * assumed manifest object schema).
   *
   * @param {Object} manifest
   *        The parsed manifest object
   */
  setupInitialPlaylist(e) {
    if (this.state = "HAVE_MAIN_MANIFEST", e.playlists) {
      this.main = e, M_(this.main, this.srcUri()), e.playlists.forEach((a) => {
        a.segments = B_(a), a.segments.forEach((i) => {
          P_(i, a.resolvedUri);
        });
      }), this.trigger("loadedplaylist"), this.request || this.media(this.main.playlists[0]);
      return;
    }
    const n = this.srcUri() || j.location.href;
    this.main = vae(e, n), this.haveMetadata({
      playlistObject: e,
      url: n,
      id: this.main.playlists[0].id
    }), this.trigger("loadedmetadata");
  }
  /**
   * Updates or deletes a preexisting pathway clone.
   * Ensures that all playlists related to the old pathway clone are
   * either updated or deleted.
   *
   * @param {Object} clone On update, the pathway clone object for the newly updated pathway clone.
   *        On delete, the old pathway clone object to be deleted.
   * @param {boolean} isUpdate True if the pathway is to be updated,
   *        false if it is meant to be deleted.
   */
  updateOrDeleteClone(e, n) {
    const a = this.main, i = e.ID;
    let r = a.playlists.length;
    for (; r--; ) {
      const s = a.playlists[r];
      if (s.attributes["PATHWAY-ID"] === i) {
        const o = s.resolvedUri, l = s.id;
        if (n) {
          const c = this.createCloneURI_(s.resolvedUri, e), u = Cs(i, c), f = this.createCloneAttributes_(i, s.attributes), m = this.createClonePlaylist_(s, u, e, f);
          a.playlists[r] = m, a.playlists[u] = m, a.playlists[c] = m;
        } else
          a.playlists.splice(r, 1);
        delete a.playlists[l], delete a.playlists[o];
      }
    }
    this.updateOrDeleteCloneMedia(e, n);
  }
  /**
   * Updates or deletes media data based on the pathway clone object.
   * Due to the complexity of the media groups and playlists, in all cases
   * we remove all of the old media groups and playlists.
   * On updates, we then create new media groups and playlists based on the
   * new pathway clone object.
   *
   * @param {Object} clone The pathway clone object for the newly updated pathway clone.
   * @param {boolean} isUpdate True if the pathway is to be updated,
   *        false if it is meant to be deleted.
   */
  updateOrDeleteCloneMedia(e, n) {
    const a = this.main, i = e.ID;
    ["AUDIO", "SUBTITLES", "CLOSED-CAPTIONS"].forEach((r) => {
      if (!(!a.mediaGroups[r] || !a.mediaGroups[r][i])) {
        for (const s in a.mediaGroups[r])
          if (s === i) {
            for (const o in a.mediaGroups[r][s])
              a.mediaGroups[r][s][o].playlists.forEach((c, u) => {
                const f = a.playlists[c.id], m = f.id, _ = f.resolvedUri;
                delete a.playlists[m], delete a.playlists[_];
              });
            delete a.mediaGroups[r][s];
          }
      }
    }), n && this.createClonedMediaGroups_(e);
  }
  /**
   * Given a pathway clone object, clones all necessary playlists.
   *
   * @param {Object} clone The pathway clone object.
   * @param {Object} basePlaylist The original playlist to clone from.
   */
  addClonePathway(e, n = {}) {
    const a = this.main, i = a.playlists.length, r = this.createCloneURI_(n.resolvedUri, e), s = Cs(e.ID, r), o = this.createCloneAttributes_(e.ID, n.attributes), l = this.createClonePlaylist_(n, s, e, o);
    a.playlists[i] = l, a.playlists[s] = l, a.playlists[r] = l, this.createClonedMediaGroups_(e);
  }
  /**
   * Given a pathway clone object we create clones of all media.
   * In this function, all necessary information and updated playlists
   * are added to the `mediaGroup` object.
   * Playlists are also added to the `playlists` array so the media groups
   * will be properly linked.
   *
   * @param {Object} clone The pathway clone object.
   */
  createClonedMediaGroups_(e) {
    const n = e.ID, a = e["BASE-ID"], i = this.main;
    ["AUDIO", "SUBTITLES", "CLOSED-CAPTIONS"].forEach((r) => {
      if (!(!i.mediaGroups[r] || i.mediaGroups[r][n]))
        for (const s in i.mediaGroups[r]) {
          if (s === a)
            i.mediaGroups[r][n] = {};
          else
            continue;
          for (const o in i.mediaGroups[r][s]) {
            const l = i.mediaGroups[r][s][o];
            i.mediaGroups[r][n][o] = Jt({}, l);
            const c = i.mediaGroups[r][n][o], u = this.createCloneURI_(l.resolvedUri, e);
            c.resolvedUri = u, c.uri = u, c.playlists = [], l.playlists.forEach((f, m) => {
              const _ = i.playlists[f.id], T = D_(r, n, o), g = Cs(n, T);
              if (_ && !i.playlists[g]) {
                const x = this.createClonePlaylist_(_, g, e), S = x.resolvedUri;
                i.playlists[g] = x, i.playlists[S] = x;
              }
              c.playlists[m] = this.createClonePlaylist_(f, g, e);
            });
          }
        }
    });
  }
  /**
   * Using the original playlist to be cloned, and the pathway clone object
   * information, we create a new playlist.
   *
   * @param {Object} basePlaylist  The original playlist to be cloned from.
   * @param {string} id The desired id of the newly cloned playlist.
   * @param {Object} clone The pathway clone object.
   * @param {Object} attributes An optional object to populate the `attributes` property in the playlist.
   *
   * @return {Object} The combined cloned playlist.
   */
  createClonePlaylist_(e, n, a, i) {
    const r = this.createCloneURI_(e.resolvedUri, a), s = {
      resolvedUri: r,
      uri: r,
      id: n
    };
    return e.segments && (s.segments = []), i && (s.attributes = i), gt(e, s);
  }
  /**
   * Generates an updated URI for a cloned pathway based on the original
   * pathway's URI and the paramaters from the pathway clone object in the
   * content steering server response.
   *
   * @param {string} baseUri URI to be updated in the cloned pathway.
   * @param {Object} clone The pathway clone object.
   *
   * @return {string} The updated URI for the cloned pathway.
   */
  createCloneURI_(e, n) {
    const a = new URL(e);
    a.hostname = n["URI-REPLACEMENT"].HOST;
    const i = n["URI-REPLACEMENT"].PARAMS;
    for (const r of Object.keys(i))
      a.searchParams.set(r, i[r]);
    return a.href;
  }
  /**
   * Helper function to create the attributes needed for the new clone.
   * This mainly adds the necessary media attributes.
   *
   * @param {string} id The pathway clone object ID.
   * @param {Object} oldAttributes The old attributes to compare to.
   * @return {Object} The new attributes to add to the playlist.
   */
  createCloneAttributes_(e, n) {
    const a = {
      "PATHWAY-ID": e
    };
    return ["AUDIO", "SUBTITLES", "CLOSED-CAPTIONS"].forEach((i) => {
      n[i] && (a[i] = e);
    }), a;
  }
  /**
   * Returns the key ID set from a playlist
   *
   * @param {playlist} playlist to fetch the key ID set from.
   * @return a Set of 32 digit hex strings that represent the unique keyIds for that playlist.
   */
  getKeyIdSet(e) {
    if (e.contentProtection) {
      const n = /* @__PURE__ */ new Set();
      for (const a in e.contentProtection) {
        const i = e.contentProtection[a].attributes.keyId;
        i && n.add(i.toLowerCase());
      }
      return n;
    }
  }
}
const Bh = function(t, e, n, a) {
  const i = t.responseType === "arraybuffer" ? t.response : t.responseText;
  !e && i && (t.responseTime = Date.now(), t.roundTripTime = t.responseTime - t.requestTime, t.bytesReceived = i.byteLength || i.length, t.bandwidth || (t.bandwidth = Math.floor(t.bytesReceived / t.roundTripTime * 8 * 1e3))), n.headers && (t.responseHeaders = n.headers), e && e.code === "ETIMEDOUT" && (t.timedout = !0), !e && !t.aborted && n.statusCode !== 200 && n.statusCode !== 206 && n.statusCode !== 0 && (e = new Error("XHR Failed with a response of: " + (t && (i || t.responseText)))), a(e, t);
}, wae = (t, e) => {
  if (!t || !t.size)
    return;
  let n = e;
  return t.forEach((a) => {
    n = a(n);
  }), n;
}, kae = (t, e, n, a) => {
  !t || !t.size || t.forEach((i) => {
    i(e, n, a);
  });
}, N_ = function() {
  const t = function e(n, a) {
    n = gt({
      timeout: 45e3
    }, n);
    const i = e.beforeRequest || ce.Vhs.xhr.beforeRequest, r = e._requestCallbackSet || ce.Vhs.xhr._requestCallbackSet || /* @__PURE__ */ new Set(), s = e._responseCallbackSet || ce.Vhs.xhr._responseCallbackSet;
    i && typeof i == "function" && (ce.log.warn("beforeRequest is deprecated, use onRequest instead."), r.add(i));
    const o = ce.Vhs.xhr.original === !0 ? ce.xhr : ce.Vhs.xhr, l = wae(r, n);
    r.delete(i);
    const c = o(l || n, function(f, m) {
      return kae(s, c, f, m), Bh(c, f, m, a);
    }), u = c.abort;
    return c.abort = function() {
      return c.aborted = !0, u.apply(c, arguments);
    }, c.uri = n.uri, c.requestType = n.requestType, c.requestTime = Date.now(), c;
  };
  return t.original = !0, t;
}, Cae = function(t) {
  let e;
  const n = t.offset;
  return typeof t.offset == "bigint" || typeof t.length == "bigint" ? e = j.BigInt(t.offset) + j.BigInt(t.length) - j.BigInt(1) : e = t.offset + t.length - 1, "bytes=" + n + "-" + e;
}, Rh = function(t) {
  const e = {};
  return t.byterange && (e.Range = Cae(t.byterange)), e;
}, Sae = function(t, e) {
  return t.start(e) + "-" + t.end(e);
}, Aae = function(t, e) {
  const n = t.toString(16);
  return "00".substring(0, 2 - n.length) + n + (e % 2 ? " " : "");
}, Eae = function(t) {
  return t >= 32 && t < 126 ? String.fromCharCode(t) : ".";
}, $_ = function(t) {
  const e = {};
  return Object.keys(t).forEach((n) => {
    const a = t[n];
    m5(a) ? e[n] = {
      bytes: a.buffer,
      byteOffset: a.byteOffset,
      byteLength: a.byteLength
    } : e[n] = a;
  }), e;
}, Bu = function(t) {
  const e = t.byterange || {
    length: 1 / 0,
    offset: 0
  };
  return [e.length, e.offset, t.resolvedUri].join(",");
}, F_ = function(t) {
  return t.resolvedUri;
}, z_ = (t) => {
  const e = Array.prototype.slice.call(t), n = 16;
  let a = "", i, r;
  for (let s = 0; s < e.length / n; s++)
    i = e.slice(s * n, s * n + n).map(Aae).join(""), r = e.slice(s * n, s * n + n).map(Eae).join(""), a += i + " " + r + `
`;
  return a;
}, Lae = ({
  bytes: t
}) => z_(t), Dae = (t) => {
  let e = "", n;
  for (n = 0; n < t.length; n++)
    e += Sae(t, n) + " ";
  return e;
};
var Iae = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  createTransferableMessage: $_,
  initSegmentId: Bu,
  segmentKeyId: F_,
  hexDump: z_,
  tagDump: Lae,
  textRanges: Dae
});
const U_ = 0.25, Mae = (t, e) => {
  if (!e.dateTimeObject)
    return null;
  const n = e.videoTimingInfo.transmuxerPrependedSeconds, i = e.videoTimingInfo.transmuxedPresentationStart + n, r = t - i;
  return new Date(e.dateTimeObject.getTime() + r * 1e3);
}, Oae = (t) => t.transmuxedPresentationEnd - t.transmuxedPresentationStart - t.transmuxerPrependedSeconds, Pae = (t, e) => {
  let n;
  try {
    n = new Date(t);
  } catch {
    return null;
  }
  if (!e || !e.segments || e.segments.length === 0)
    return null;
  let a = e.segments[0];
  if (n < new Date(a.dateTimeObject))
    return null;
  for (let l = 0; l < e.segments.length - 1; l++) {
    a = e.segments[l];
    const c = new Date(e.segments[l + 1].dateTimeObject);
    if (n < c)
      break;
  }
  const i = e.segments[e.segments.length - 1], r = i.dateTimeObject, s = i.videoTimingInfo ? Oae(i.videoTimingInfo) : i.duration + i.duration * U_, o = new Date(r.getTime() + s * 1e3);
  return n > o ? null : (n > new Date(r) && (a = i), {
    segment: a,
    estimatedStart: a.videoTimingInfo ? a.videoTimingInfo.transmuxedPresentationStart : Kn.duration(e, e.mediaSequence + e.segments.indexOf(a)),
    // Although, given that all segments have accurate date time objects, the segment
    // selected should be accurate, unless the video has been transmuxed at some point
    // (determined by the presence of the videoTimingInfo object), the segment's "player
    // time" (the start time in the player) can't be considered accurate.
    type: a.videoTimingInfo ? "accurate" : "estimate"
  });
}, Bae = (t, e) => {
  if (!e || !e.segments || e.segments.length === 0)
    return null;
  let n = 0, a;
  for (let r = 0; r < e.segments.length && (a = e.segments[r], n = a.videoTimingInfo ? a.videoTimingInfo.transmuxedPresentationEnd : n + a.duration, !(t <= n)); r++)
    ;
  const i = e.segments[e.segments.length - 1];
  if (i.videoTimingInfo && i.videoTimingInfo.transmuxedPresentationEnd < t)
    return null;
  if (t > n) {
    if (t > n + i.duration * U_)
      return null;
    a = i;
  }
  return {
    segment: a,
    estimatedStart: a.videoTimingInfo ? a.videoTimingInfo.transmuxedPresentationStart : n - a.duration,
    // Because videoTimingInfo is only set after transmux, it is the only way to get
    // accurate timing values.
    type: a.videoTimingInfo ? "accurate" : "estimate"
  };
}, Rae = (t, e) => {
  let n, a;
  try {
    n = new Date(t), a = new Date(e);
  } catch {
  }
  const i = n.getTime();
  return (a.getTime() - i) / 1e3;
}, Nae = (t) => {
  if (!t.segments || t.segments.length === 0)
    return !1;
  for (let e = 0; e < t.segments.length; e++)
    if (!t.segments[e].dateTimeObject)
      return !1;
  return !0;
}, $ae = ({
  playlist: t,
  time: e = void 0,
  callback: n
}) => {
  if (!n)
    throw new Error("getProgramTime: callback must be provided");
  if (!t || e === void 0)
    return n({
      message: "getProgramTime: playlist and time must be provided"
    });
  const a = Bae(e, t);
  if (!a)
    return n({
      message: "valid programTime was not found"
    });
  if (a.type === "estimate")
    return n({
      message: "Accurate programTime could not be determined. Please seek to e.seekTime and try again",
      seekTime: a.estimatedStart
    });
  const i = {
    mediaSeconds: e
  }, r = Mae(e, a.segment);
  return r && (i.programDateTime = r.toISOString()), n(null, i);
}, H_ = ({
  programTime: t,
  playlist: e,
  retryCount: n = 2,
  seekTo: a,
  pauseAfterSeek: i = !0,
  tech: r,
  callback: s
}) => {
  if (!s)
    throw new Error("seekToProgramTime: callback must be provided");
  if (typeof t > "u" || !e || !a)
    return s({
      message: "seekToProgramTime: programTime, seekTo and playlist must be provided"
    });
  if (!e.endList && !r.hasStarted_)
    return s({
      message: "player must be playing a live stream to start buffering"
    });
  if (!Nae(e))
    return s({
      message: "programDateTime tags must be provided in the manifest " + e.resolvedUri
    });
  const o = Pae(t, e);
  if (!o)
    return s({
      message: `${t} was not found in the stream`
    });
  const l = o.segment, c = Rae(l.dateTimeObject, t);
  if (o.type === "estimate") {
    if (n === 0)
      return s({
        message: `${t} is not buffered yet. Try again`
      });
    a(o.estimatedStart + c), r.one("seeked", () => {
      H_({
        programTime: t,
        playlist: e,
        retryCount: n - 1,
        seekTo: a,
        pauseAfterSeek: i,
        tech: r,
        callback: s
      });
    });
    return;
  }
  const u = l.start + c, f = () => s(null, r.currentTime());
  r.one("seeked", f), i && r.pause(), a(u);
}, z0 = (t, e) => {
  if (t.readyState === 4)
    return e();
}, Fae = (t, e, n, a) => {
  let i = [], r, s = !1;
  const o = function(f, m, _, T) {
    return m.abort(), s = !0, n(f, m, _, T);
  }, l = function(f, m) {
    if (s)
      return;
    if (f)
      return f.metadata = Or({
        requestType: a,
        request: m,
        error: f
      }), o(f, m, "", i);
    const _ = m.responseText.substring(i && i.byteLength || 0, m.responseText.length);
    if (i = HJ(i, g5(_, !0)), r = r || nl(i), i.length < 10 || r && i.length < r + 2)
      return z0(m, () => o(f, m, "", i));
    const T = ap(i);
    return T === "ts" && i.length < 188 ? z0(m, () => o(f, m, "", i)) : !T && i.length < 376 ? z0(m, () => o(f, m, "", i)) : o(null, m, T, i);
  }, u = e({
    uri: t,
    beforeSend(f) {
      f.overrideMimeType("text/plain; charset=x-user-defined"), f.addEventListener("progress", function({
        total: m,
        loaded: _
      }) {
        return Bh(f, null, {
          statusCode: f.status
        }, l);
      });
    }
  }, function(f, m) {
    return Bh(u, f, m, l);
  });
  return u;
}, {
  EventTarget: zae
} = ce, Lb = function(t, e) {
  if (!R_(t, e) || t.sidx && e.sidx && (t.sidx.offset !== e.sidx.offset || t.sidx.length !== e.sidx.length))
    return !1;
  if (!t.sidx && e.sidx || t.sidx && !e.sidx || t.segments && !e.segments || !t.segments && e.segments)
    return !1;
  if (!t.segments && !e.segments)
    return !0;
  for (let n = 0; n < t.segments.length; n++) {
    const a = t.segments[n], i = e.segments[n];
    if (a.uri !== i.uri)
      return !1;
    if (!a.byterange && !i.byterange)
      continue;
    const r = a.byterange, s = i.byterange;
    if (r && !s || !r && s || r.offset !== s.offset || r.length !== s.length)
      return !1;
  }
  return !0;
}, Uae = (t, e, n, a) => {
  const i = a.attributes.NAME || n;
  return `placeholder-uri-${t}-${e}-${i}`;
}, Hae = ({
  mainXml: t,
  srcUrl: e,
  clientOffset: n,
  sidxMapping: a,
  previousManifest: i
}) => {
  const r = cte(t, {
    manifestUri: e,
    clientOffset: n,
    sidxMapping: a,
    previousManifest: i
  });
  return M_(r, e, Uae), r;
}, Yae = (t, e) => {
  go(t, (n, a, i, r) => {
    (!e.mediaGroups[a][i] || !(r in e.mediaGroups[a][i])) && delete t.mediaGroups[a][i][r];
  });
}, jae = (t, e, n) => {
  let a = !0, i = gt(t, {
    // These are top level properties that can be updated
    duration: e.duration,
    minimumUpdatePeriod: e.minimumUpdatePeriod,
    timelineStarts: e.timelineStarts
  });
  for (let r = 0; r < e.playlists.length; r++) {
    const s = e.playlists[r];
    if (s.sidx) {
      const l = fd(s.sidx);
      n && n[l] && n[l].sidx && ep(s, n[l].sidx, s.sidx.resolvedUri);
    }
    const o = Oh(i, s, Lb);
    o && (i = o, a = !1);
  }
  return go(e, (r, s, o, l) => {
    if (r.playlists && r.playlists.length) {
      const c = r.playlists[0].id, u = Oh(i, r.playlists[0], Lb);
      u && (i = u, l in i.mediaGroups[s][o] || (i.mediaGroups[s][o][l] = r), i.mediaGroups[s][o][l].playlists[0] = i.playlists[c], a = !1);
    }
  }), Yae(i, e), e.minimumUpdatePeriod !== t.minimumUpdatePeriod && (a = !1), a ? null : i;
}, Vae = (t, e) => (!t.map && !e.map || !!(t.map && e.map && t.map.byterange.offset === e.map.byterange.offset && t.map.byterange.length === e.map.byterange.length)) && t.uri === e.uri && t.byterange.offset === e.byterange.offset && t.byterange.length === e.byterange.length, Db = (t, e) => {
  const n = {};
  for (const a in t) {
    const r = t[a].sidx;
    if (r) {
      const s = fd(r);
      if (!e[s])
        break;
      const o = e[s].sidxInfo;
      Vae(o, r) && (n[s] = e[s]);
    }
  }
  return n;
}, qae = (t, e) => {
  let a = Db(t.playlists, e);
  return go(t, (i, r, s, o) => {
    if (i.playlists && i.playlists.length) {
      const l = i.playlists;
      a = gt(a, Db(l, e));
    }
  }), a;
};
class Nh extends zae {
  // DashPlaylistLoader must accept either a src url or a playlist because subsequent
  // playlist loader setups from media groups will expect to be able to pass a playlist
  // (since there aren't external URLs to media playlists with DASH)
  constructor(e, n, a = {}, i) {
    super(), this.isPaused_ = !0, this.mainPlaylistLoader_ = i || this, i || (this.isMain_ = !0);
    const {
      withCredentials: r = !1
    } = a;
    if (this.vhs_ = n, this.withCredentials = r, this.addMetadataToTextTrack = a.addMetadataToTextTrack, !e)
      throw new Error("A non-empty playlist URL or object is required");
    this.on("minimumUpdatePeriod", () => {
      this.refreshXml_();
    }), this.on("mediaupdatetimeout", () => {
      this.refreshMedia_(this.media().id);
    }), this.state = "HAVE_NOTHING", this.loadedPlaylists_ = {}, this.logger_ = Ca("DashPlaylistLoader"), this.isMain_ ? (this.mainPlaylistLoader_.srcUrl = e, this.mainPlaylistLoader_.sidxMapping_ = {}) : this.childPlaylist_ = e;
  }
  get isPaused() {
    return this.isPaused_;
  }
  requestErrored_(e, n, a) {
    if (!this.request)
      return !0;
    if (this.request = null, e)
      return this.error = typeof e == "object" && !(e instanceof Error) ? e : {
        status: n.status,
        message: "DASH request error at URL: " + n.uri,
        response: n.response,
        // MEDIA_ERR_NETWORK
        code: 2,
        metadata: e.metadata
      }, a && (this.state = a), this.trigger("error"), !0;
  }
  /**
   * Verify that the container of the sidx segment can be parsed
   * and if it can, get and parse that segment.
   */
  addSidxSegments_(e, n, a) {
    const i = e.sidx && fd(e.sidx);
    if (!e.sidx || !i || this.mainPlaylistLoader_.sidxMapping_[i]) {
      j.clearTimeout(this.mediaRequest_), this.mediaRequest_ = j.setTimeout(() => a(!1), 0);
      return;
    }
    const r = Pu(e.sidx.resolvedUri), s = (l, c) => {
      if (this.requestErrored_(l, c, n))
        return;
      const u = this.mainPlaylistLoader_.sidxMapping_, {
        requestType: f
      } = c;
      let m;
      try {
        m = gte(Ke(c.response).subarray(8));
      } catch (_) {
        _.metadata = Or({
          requestType: f,
          request: c,
          parseFailure: !0
        }), this.requestErrored_(_, c, n);
        return;
      }
      return u[i] = {
        sidxInfo: e.sidx,
        sidx: m
      }, ep(e, m, e.sidx.resolvedUri), a(!0);
    }, o = "dash-sidx";
    this.request = Fae(r, this.vhs_.xhr, (l, c, u, f) => {
      if (l)
        return s(l, c);
      if (!u || u !== "mp4") {
        const T = u || "unknown";
        return s({
          status: c.status,
          message: `Unsupported ${T} container type for sidx segment at URL: ${r}`,
          // response is just bytes in this case
          // but we really don't want to return that.
          response: "",
          playlist: e,
          internal: !0,
          playlistExclusionDuration: 1 / 0,
          // MEDIA_ERR_NETWORK
          code: 2
        }, c);
      }
      const {
        offset: m,
        length: _
      } = e.sidx.byterange;
      if (f.length >= _ + m)
        return s(l, {
          response: f.subarray(m, m + _),
          status: c.status,
          uri: c.uri
        });
      this.request = this.vhs_.xhr({
        uri: r,
        responseType: "arraybuffer",
        requestType: "dash-sidx",
        headers: Rh({
          byterange: e.sidx.byterange
        })
      }, s);
    }, o);
  }
  dispose() {
    this.isPaused_ = !0, this.trigger("dispose"), this.stopRequest(), this.loadedPlaylists_ = {}, j.clearTimeout(this.minimumUpdatePeriodTimeout_), j.clearTimeout(this.mediaRequest_), j.clearTimeout(this.mediaUpdateTimeout), this.mediaUpdateTimeout = null, this.mediaRequest_ = null, this.minimumUpdatePeriodTimeout_ = null, this.mainPlaylistLoader_.createMupOnMedia_ && (this.off("loadedmetadata", this.mainPlaylistLoader_.createMupOnMedia_), this.mainPlaylistLoader_.createMupOnMedia_ = null), this.off();
  }
  hasPendingRequest() {
    return this.request || this.mediaRequest_;
  }
  stopRequest() {
    if (this.request) {
      const e = this.request;
      this.request = null, e.onreadystatechange = null, e.abort();
    }
  }
  media(e) {
    if (!e)
      return this.media_;
    if (this.state === "HAVE_NOTHING")
      throw new Error("Cannot switch media playlist from " + this.state);
    const n = this.state;
    if (typeof e == "string") {
      if (!this.mainPlaylistLoader_.main.playlists[e])
        throw new Error("Unknown playlist URI: " + e);
      e = this.mainPlaylistLoader_.main.playlists[e];
    }
    const a = !this.media_ || e.id !== this.media_.id;
    if (a && this.loadedPlaylists_[e.id] && this.loadedPlaylists_[e.id].endList) {
      this.state = "HAVE_METADATA", this.media_ = e, a && (this.trigger("mediachanging"), this.trigger("mediachange"));
      return;
    }
    a && (this.media_ && this.trigger("mediachanging"), this.addSidxSegments_(e, n, (i) => {
      this.haveMetadata({
        startingState: n,
        playlist: e
      });
    }));
  }
  haveMetadata({
    startingState: e,
    playlist: n
  }) {
    this.state = "HAVE_METADATA", this.loadedPlaylists_[n.id] = n, j.clearTimeout(this.mediaRequest_), this.mediaRequest_ = null, this.refreshMedia_(n.id), e === "HAVE_MAIN_MANIFEST" ? this.trigger("loadedmetadata") : this.trigger("mediachange");
  }
  pause() {
    this.isPaused_ = !0, this.mainPlaylistLoader_.createMupOnMedia_ && (this.off("loadedmetadata", this.mainPlaylistLoader_.createMupOnMedia_), this.mainPlaylistLoader_.createMupOnMedia_ = null), this.stopRequest(), j.clearTimeout(this.mediaUpdateTimeout), this.mediaUpdateTimeout = null, this.isMain_ && (j.clearTimeout(this.mainPlaylistLoader_.minimumUpdatePeriodTimeout_), this.mainPlaylistLoader_.minimumUpdatePeriodTimeout_ = null), this.state === "HAVE_NOTHING" && (this.started = !1);
  }
  load(e) {
    this.isPaused_ = !1, j.clearTimeout(this.mediaUpdateTimeout), this.mediaUpdateTimeout = null;
    const n = this.media();
    if (e) {
      const a = n ? n.targetDuration / 2 * 1e3 : 5e3;
      this.mediaUpdateTimeout = j.setTimeout(() => this.load(), a);
      return;
    }
    if (!this.started) {
      this.start();
      return;
    }
    n && !n.endList ? (this.isMain_ && !this.minimumUpdatePeriodTimeout_ && (this.trigger("minimumUpdatePeriod"), this.updateMinimumUpdatePeriodTimeout_()), this.trigger("mediaupdatetimeout")) : this.trigger("loadedplaylist");
  }
  start() {
    if (this.started = !0, !this.isMain_) {
      j.clearTimeout(this.mediaRequest_), this.mediaRequest_ = j.setTimeout(() => this.haveMain_(), 0);
      return;
    }
    this.requestMain_((e, n) => {
      this.haveMain_(), !this.hasPendingRequest() && !this.media_ && this.media(this.mainPlaylistLoader_.main.playlists[0]);
    });
  }
  requestMain_(e) {
    const n = {
      manifestInfo: {
        uri: this.mainPlaylistLoader_.srcUrl
      }
    };
    this.trigger({
      type: "manifestrequeststart",
      metadata: n
    }), this.request = this.vhs_.xhr({
      uri: this.mainPlaylistLoader_.srcUrl,
      withCredentials: this.withCredentials,
      requestType: "dash-manifest"
    }, (a, i) => {
      if (a) {
        const {
          requestType: s
        } = i;
        a.metadata = Or({
          requestType: s,
          request: i,
          error: a
        });
      }
      if (this.requestErrored_(a, i)) {
        this.state === "HAVE_NOTHING" && (this.started = !1);
        return;
      }
      this.trigger({
        type: "manifestrequestcomplete",
        metadata: n
      });
      const r = i.responseText !== this.mainPlaylistLoader_.mainXml_;
      if (this.mainPlaylistLoader_.mainXml_ = i.responseText, i.responseHeaders && i.responseHeaders.date ? this.mainLoaded_ = Date.parse(i.responseHeaders.date) : this.mainLoaded_ = Date.now(), this.mainPlaylistLoader_.srcUrl = Pu(this.mainPlaylistLoader_.srcUrl, i), r) {
        this.handleMain_(), this.syncClientServerClock_(() => e(i, r));
        return;
      }
      return e(i, r);
    });
  }
  /**
   * Parses the main xml for UTCTiming node to sync the client clock to the server
   * clock. If the UTCTiming node requires a HEAD or GET request, that request is made.
   *
   * @param {Function} done
   *        Function to call when clock sync has completed
   */
  syncClientServerClock_(e) {
    const n = ute(this.mainPlaylistLoader_.mainXml_);
    if (n === null)
      return this.mainPlaylistLoader_.clientOffset_ = this.mainLoaded_ - Date.now(), e();
    if (n.method === "DIRECT")
      return this.mainPlaylistLoader_.clientOffset_ = n.value - Date.now(), e();
    this.request = this.vhs_.xhr({
      uri: Zn(this.mainPlaylistLoader_.srcUrl, n.value),
      method: n.method,
      withCredentials: this.withCredentials,
      requestType: "dash-clock-sync"
    }, (a, i) => {
      if (!this.request)
        return;
      if (a) {
        const {
          requestType: s
        } = i;
        return this.error.metadata = Or({
          requestType: s,
          request: i,
          error: a
        }), this.mainPlaylistLoader_.clientOffset_ = this.mainLoaded_ - Date.now(), e();
      }
      let r;
      n.method === "HEAD" ? !i.responseHeaders || !i.responseHeaders.date ? r = this.mainLoaded_ : r = Date.parse(i.responseHeaders.date) : r = Date.parse(i.responseText), this.mainPlaylistLoader_.clientOffset_ = r - Date.now(), e();
    });
  }
  haveMain_() {
    this.state = "HAVE_MAIN_MANIFEST", this.isMain_ ? this.trigger("loadedplaylist") : this.media_ || this.media(this.childPlaylist_);
  }
  handleMain_() {
    j.clearTimeout(this.mediaRequest_), this.mediaRequest_ = null;
    const e = this.mainPlaylistLoader_.main, n = {
      manifestInfo: {
        uri: this.mainPlaylistLoader_.srcUrl
      }
    };
    this.trigger({
      type: "manifestparsestart",
      metadata: n
    });
    let a;
    try {
      a = Hae({
        mainXml: this.mainPlaylistLoader_.mainXml_,
        srcUrl: this.mainPlaylistLoader_.srcUrl,
        clientOffset: this.mainPlaylistLoader_.clientOffset_,
        sidxMapping: this.mainPlaylistLoader_.sidxMapping_,
        previousManifest: e
      });
    } catch (r) {
      this.error = r, this.error.metadata = {
        errorType: ce.Error.StreamingDashManifestParserError,
        error: r
      }, this.trigger("error");
    }
    e && (a = jae(e, a, this.mainPlaylistLoader_.sidxMapping_)), this.mainPlaylistLoader_.main = a || e;
    const i = this.mainPlaylistLoader_.main.locations && this.mainPlaylistLoader_.main.locations[0];
    if (i && i !== this.mainPlaylistLoader_.srcUrl && (this.mainPlaylistLoader_.srcUrl = i), (!e || a && a.minimumUpdatePeriod !== e.minimumUpdatePeriod) && this.updateMinimumUpdatePeriodTimeout_(), this.addEventStreamToMetadataTrack_(a), a) {
      const {
        duration: r,
        endList: s
      } = a, o = [];
      a.playlists.forEach((c) => {
        o.push({
          id: c.id,
          bandwidth: c.attributes.BANDWIDTH,
          resolution: c.attributes.RESOLUTION,
          codecs: c.attributes.CODECS
        });
      });
      const l = {
        duration: r,
        isLive: !s,
        renditions: o
      };
      n.parsedManifest = l, this.trigger({
        type: "manifestparsecomplete",
        metadata: n
      });
    }
    return !!a;
  }
  updateMinimumUpdatePeriodTimeout_() {
    const e = this.mainPlaylistLoader_;
    e.createMupOnMedia_ && (e.off("loadedmetadata", e.createMupOnMedia_), e.createMupOnMedia_ = null), e.minimumUpdatePeriodTimeout_ && (j.clearTimeout(e.minimumUpdatePeriodTimeout_), e.minimumUpdatePeriodTimeout_ = null);
    let n = e.main && e.main.minimumUpdatePeriod;
    if (n === 0 && (e.media() ? n = e.media().targetDuration * 1e3 : (e.createMupOnMedia_ = e.updateMinimumUpdatePeriodTimeout_, e.one("loadedmetadata", e.createMupOnMedia_))), typeof n != "number" || n <= 0) {
      n < 0 && this.logger_(`found invalid minimumUpdatePeriod of ${n}, not setting a timeout`);
      return;
    }
    this.createMUPTimeout_(n);
  }
  createMUPTimeout_(e) {
    const n = this.mainPlaylistLoader_;
    n.minimumUpdatePeriodTimeout_ = j.setTimeout(() => {
      n.minimumUpdatePeriodTimeout_ = null, n.trigger("minimumUpdatePeriod"), n.createMUPTimeout_(e);
    }, e);
  }
  /**
   * Sends request to refresh the main xml and updates the parsed main manifest
   */
  refreshXml_() {
    this.requestMain_((e, n) => {
      n && (this.media_ && (this.media_ = this.mainPlaylistLoader_.main.playlists[this.media_.id]), this.mainPlaylistLoader_.sidxMapping_ = qae(this.mainPlaylistLoader_.main, this.mainPlaylistLoader_.sidxMapping_), this.addSidxSegments_(this.media(), this.state, (a) => {
        this.refreshMedia_(this.media().id);
      }));
    });
  }
  /**
   * Refreshes the media playlist by re-parsing the main xml and updating playlist
   * references. If this is an alternate loader, the updated parsed manifest is retrieved
   * from the main loader.
   */
  refreshMedia_(e) {
    if (!e)
      throw new Error("refreshMedia_ must take a media id");
    this.media_ && this.isMain_ && this.handleMain_();
    const n = this.mainPlaylistLoader_.main.playlists, a = !this.media_ || this.media_ !== n[e];
    if (a ? this.media_ = n[e] : this.trigger("playlistunchanged"), !this.mediaUpdateTimeout) {
      const i = () => {
        this.media().endList || (this.mediaUpdateTimeout = j.setTimeout(() => {
          this.trigger("mediaupdatetimeout"), i();
        }, Ph(this.media(), !!a)));
      };
      i();
    }
    this.trigger("loadedplaylist");
  }
  /**
   * Takes eventstream data from a parsed DASH manifest and adds it to the metadata text track.
   *
   * @param {manifest} newMain the newly parsed manifest
   */
  addEventStreamToMetadataTrack_(e) {
    if (e && this.mainPlaylistLoader_.main.eventStream) {
      const n = this.mainPlaylistLoader_.main.eventStream.map((a) => ({
        cueTime: a.start,
        frames: [{
          data: a.messageData
        }]
      }));
      this.addMetadataToTextTrack("EventStream", n, this.mainPlaylistLoader_.main.duration);
    }
  }
  /**
   * Returns the key ID set from a playlist
   *
   * @param {playlist} playlist to fetch the key ID set from.
   * @return a Set of 32 digit hex strings that represent the unique keyIds for that playlist.
   */
  getKeyIdSet(e) {
    if (e.contentProtection) {
      const n = /* @__PURE__ */ new Set();
      for (const a in e.contentProtection) {
        const i = e.contentProtection[a].attributes["cenc:default_KID"];
        i && n.add(i.replace(/-/g, "").toLowerCase());
      }
      return n;
    }
  }
}
var mn = {
  GOAL_BUFFER_LENGTH: 30,
  MAX_GOAL_BUFFER_LENGTH: 60,
  BACK_BUFFER_LENGTH: 30,
  GOAL_BUFFER_LENGTH_RATE: 1,
  // 0.5 MB/s
  INITIAL_BANDWIDTH: 4194304,
  // A fudge factor to apply to advertised playlist bitrates to account for
  // temporary flucations in client bandwidth
  BANDWIDTH_VARIANCE: 1.2,
  // How much of the buffer must be filled before we consider upswitching
  BUFFER_LOW_WATER_LINE: 0,
  MAX_BUFFER_LOW_WATER_LINE: 30,
  // TODO: Remove this when experimentalBufferBasedABR is removed
  EXPERIMENTAL_MAX_BUFFER_LOW_WATER_LINE: 16,
  BUFFER_LOW_WATER_LINE_RATE: 1,
  // If the buffer is greater than the high water line, we won't switch down
  BUFFER_HIGH_WATER_LINE: 30
};
const Wae = (t) => {
  const e = new Uint8Array(new ArrayBuffer(t.length));
  for (let n = 0; n < t.length; n++)
    e[n] = t.charCodeAt(n);
  return e.buffer;
}, Y_ = function(t) {
  return t.on = t.addEventListener, t.off = t.removeEventListener, t;
}, Gae = function(t) {
  try {
    return URL.createObjectURL(new Blob([t], {
      type: "application/javascript"
    }));
  } catch {
    const n = new BlobBuilder();
    return n.append(t), URL.createObjectURL(n.getBlob());
  }
}, j_ = function(t) {
  return function() {
    const e = Gae(t), n = Y_(new Worker(e));
    n.objURL = e;
    const a = n.terminate;
    return n.on = n.addEventListener, n.off = n.removeEventListener, n.terminate = function() {
      return URL.revokeObjectURL(e), a.call(this);
    }, n;
  };
}, V_ = function(t) {
  return `var browserWorkerPolyFill = ${Y_.toString()};
browserWorkerPolyFill(self);
` + t;
}, q_ = function(t) {
  return t.toString().replace(/^function.+?{/, "").slice(0, -1);
}, Xae = V_(q_(function() {
  var t = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, e = function() {
    this.init = function() {
      var d = {};
      this.on = function(p, y) {
        d[p] || (d[p] = []), d[p] = d[p].concat(y);
      }, this.off = function(p, y) {
        var v;
        return d[p] ? (v = d[p].indexOf(y), d[p] = d[p].slice(), d[p].splice(v, 1), v > -1) : !1;
      }, this.trigger = function(p) {
        var y, v, w, C;
        if (y = d[p], !!y)
          if (arguments.length === 2)
            for (w = y.length, v = 0; v < w; ++v)
              y[v].call(this, arguments[1]);
          else {
            for (C = [], v = arguments.length, v = 1; v < arguments.length; ++v)
              C.push(arguments[v]);
            for (w = y.length, v = 0; v < w; ++v)
              y[v].apply(this, C);
          }
      }, this.dispose = function() {
        d = {};
      };
    };
  };
  e.prototype.pipe = function(d) {
    return this.on("data", function(p) {
      d.push(p);
    }), this.on("done", function(p) {
      d.flush(p);
    }), this.on("partialdone", function(p) {
      d.partialFlush(p);
    }), this.on("endedtimeline", function(p) {
      d.endTimeline(p);
    }), this.on("reset", function(p) {
      d.reset(p);
    }), d;
  }, e.prototype.push = function(d) {
    this.trigger("data", d);
  }, e.prototype.flush = function(d) {
    this.trigger("done", d);
  }, e.prototype.partialFlush = function(d) {
    this.trigger("partialdone", d);
  }, e.prototype.endTimeline = function(d) {
    this.trigger("endedtimeline", d);
  }, e.prototype.reset = function(d) {
    this.trigger("reset", d);
  };
  var n = e, a = Math.pow(2, 32), i = function(d) {
    var p = new DataView(d.buffer, d.byteOffset, d.byteLength), y;
    return p.getBigUint64 ? (y = p.getBigUint64(0), y < Number.MAX_SAFE_INTEGER ? Number(y) : y) : p.getUint32(0) * a + p.getUint32(4);
  }, r = {
    getUint64: i,
    MAX_UINT32: a
  }, s = r.MAX_UINT32, o, l, c, u, f, m, _, T, g, x, S, D, L, M, E, P, B, z, W, V, H, se, ie, Z, $, J, N, ue, xe, De, He, te, ke, Y, be, Ne;
  (function() {
    var d;
    if (ie = {
      avc1: [],
      // codingname
      avcC: [],
      btrt: [],
      dinf: [],
      dref: [],
      esds: [],
      ftyp: [],
      hdlr: [],
      mdat: [],
      mdhd: [],
      mdia: [],
      mfhd: [],
      minf: [],
      moof: [],
      moov: [],
      mp4a: [],
      // codingname
      mvex: [],
      mvhd: [],
      pasp: [],
      sdtp: [],
      smhd: [],
      stbl: [],
      stco: [],
      stsc: [],
      stsd: [],
      stsz: [],
      stts: [],
      styp: [],
      tfdt: [],
      tfhd: [],
      traf: [],
      trak: [],
      trun: [],
      trex: [],
      tkhd: [],
      vmhd: []
    }, !(typeof Uint8Array > "u")) {
      for (d in ie)
        ie.hasOwnProperty(d) && (ie[d] = [d.charCodeAt(0), d.charCodeAt(1), d.charCodeAt(2), d.charCodeAt(3)]);
      Z = new Uint8Array([105, 115, 111, 109]), J = new Uint8Array([97, 118, 99, 49]), $ = new Uint8Array([0, 0, 0, 1]), N = new Uint8Array([
        0,
        // version 0
        0,
        0,
        0,
        // flags
        0,
        0,
        0,
        0,
        // pre_defined
        118,
        105,
        100,
        101,
        // handler_type: 'vide'
        0,
        0,
        0,
        0,
        // reserved
        0,
        0,
        0,
        0,
        // reserved
        0,
        0,
        0,
        0,
        // reserved
        86,
        105,
        100,
        101,
        111,
        72,
        97,
        110,
        100,
        108,
        101,
        114,
        0
        // name: 'VideoHandler'
      ]), ue = new Uint8Array([
        0,
        // version 0
        0,
        0,
        0,
        // flags
        0,
        0,
        0,
        0,
        // pre_defined
        115,
        111,
        117,
        110,
        // handler_type: 'soun'
        0,
        0,
        0,
        0,
        // reserved
        0,
        0,
        0,
        0,
        // reserved
        0,
        0,
        0,
        0,
        // reserved
        83,
        111,
        117,
        110,
        100,
        72,
        97,
        110,
        100,
        108,
        101,
        114,
        0
        // name: 'SoundHandler'
      ]), xe = {
        video: N,
        audio: ue
      }, te = new Uint8Array([
        0,
        // version 0
        0,
        0,
        0,
        // flags
        0,
        0,
        0,
        1,
        // entry_count
        0,
        0,
        0,
        12,
        // entry_size
        117,
        114,
        108,
        32,
        // 'url' type
        0,
        // version 0
        0,
        0,
        1
        // entry_flags
      ]), He = new Uint8Array([
        0,
        // version
        0,
        0,
        0,
        // flags
        0,
        0,
        // balance, 0 means centered
        0,
        0
        // reserved
      ]), ke = new Uint8Array([
        0,
        // version
        0,
        0,
        0,
        // flags
        0,
        0,
        0,
        0
        // entry_count
      ]), Y = ke, be = new Uint8Array([
        0,
        // version
        0,
        0,
        0,
        // flags
        0,
        0,
        0,
        0,
        // sample_size
        0,
        0,
        0,
        0
        // sample_count
      ]), Ne = ke, De = new Uint8Array([
        0,
        // version
        0,
        0,
        1,
        // flags
        0,
        0,
        // graphicsmode
        0,
        0,
        0,
        0,
        0,
        0
        // opcolor
      ]);
    }
  })(), o = function(d) {
    var p = [], y = 0, v, w, C;
    for (v = 1; v < arguments.length; v++)
      p.push(arguments[v]);
    for (v = p.length; v--; )
      y += p[v].byteLength;
    for (w = new Uint8Array(y + 8), C = new DataView(w.buffer, w.byteOffset, w.byteLength), C.setUint32(0, w.byteLength), w.set(d, 4), v = 0, y = 8; v < p.length; v++)
      w.set(p[v], y), y += p[v].byteLength;
    return w;
  }, l = function() {
    return o(ie.dinf, o(ie.dref, te));
  }, c = function(d) {
    return o(ie.esds, new Uint8Array([
      0,
      // version
      0,
      0,
      0,
      // flags
      // ES_Descriptor
      3,
      // tag, ES_DescrTag
      25,
      // length
      0,
      0,
      // ES_ID
      0,
      // streamDependenceFlag, URL_flag, reserved, streamPriority
      // DecoderConfigDescriptor
      4,
      // tag, DecoderConfigDescrTag
      17,
      // length
      64,
      // object type
      21,
      // streamType
      0,
      6,
      0,
      // bufferSizeDB
      0,
      0,
      218,
      192,
      // maxBitrate
      0,
      0,
      218,
      192,
      // avgBitrate
      // DecoderSpecificInfo
      5,
      // tag, DecoderSpecificInfoTag
      2,
      // length
      // ISO/IEC 14496-3, AudioSpecificConfig
      // for samplingFrequencyIndex see ISO/IEC 13818-7:2006, 8.1.3.2.2, Table 35
      d.audioobjecttype << 3 | d.samplingfrequencyindex >>> 1,
      d.samplingfrequencyindex << 7 | d.channelcount << 3,
      6,
      1,
      2
      // GASpecificConfig
    ]));
  }, u = function() {
    return o(ie.ftyp, Z, $, Z, J);
  }, P = function(d) {
    return o(ie.hdlr, xe[d]);
  }, f = function(d) {
    return o(ie.mdat, d);
  }, E = function(d) {
    var p = new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      2,
      // creation_time
      0,
      0,
      0,
      3,
      // modification_time
      0,
      1,
      95,
      144,
      // timescale, 90,000 "ticks" per second
      d.duration >>> 24 & 255,
      d.duration >>> 16 & 255,
      d.duration >>> 8 & 255,
      d.duration & 255,
      // duration
      85,
      196,
      // 'und' language (undetermined)
      0,
      0
    ]);
    return d.samplerate && (p[12] = d.samplerate >>> 24 & 255, p[13] = d.samplerate >>> 16 & 255, p[14] = d.samplerate >>> 8 & 255, p[15] = d.samplerate & 255), o(ie.mdhd, p);
  }, M = function(d) {
    return o(ie.mdia, E(d), P(d.type), _(d));
  }, m = function(d) {
    return o(ie.mfhd, new Uint8Array([
      0,
      0,
      0,
      0,
      // flags
      (d & 4278190080) >> 24,
      (d & 16711680) >> 16,
      (d & 65280) >> 8,
      d & 255
      // sequence_number
    ]));
  }, _ = function(d) {
    return o(ie.minf, d.type === "video" ? o(ie.vmhd, De) : o(ie.smhd, He), l(), z(d));
  }, T = function(d, p) {
    for (var y = [], v = p.length; v--; )
      y[v] = V(p[v]);
    return o.apply(null, [ie.moof, m(d)].concat(y));
  }, g = function(d) {
    for (var p = d.length, y = []; p--; )
      y[p] = D(d[p]);
    return o.apply(null, [ie.moov, S(4294967295)].concat(y).concat(x(d)));
  }, x = function(d) {
    for (var p = d.length, y = []; p--; )
      y[p] = H(d[p]);
    return o.apply(null, [ie.mvex].concat(y));
  }, S = function(d) {
    var p = new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      1,
      // creation_time
      0,
      0,
      0,
      2,
      // modification_time
      0,
      1,
      95,
      144,
      // timescale, 90,000 "ticks" per second
      (d & 4278190080) >> 24,
      (d & 16711680) >> 16,
      (d & 65280) >> 8,
      d & 255,
      // duration
      0,
      1,
      0,
      0,
      // 1.0 rate
      1,
      0,
      // 1.0 volume
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      64,
      0,
      0,
      0,
      // transformation: unity matrix
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      // pre_defined
      255,
      255,
      255,
      255
      // next_track_ID
    ]);
    return o(ie.mvhd, p);
  }, B = function(d) {
    var p = d.samples || [], y = new Uint8Array(4 + p.length), v, w;
    for (w = 0; w < p.length; w++)
      v = p[w].flags, y[w + 4] = v.dependsOn << 4 | v.isDependedOn << 2 | v.hasRedundancy;
    return o(ie.sdtp, y);
  }, z = function(d) {
    return o(ie.stbl, W(d), o(ie.stts, Ne), o(ie.stsc, Y), o(ie.stsz, be), o(ie.stco, ke));
  }, function() {
    var d, p;
    W = function(y) {
      return o(ie.stsd, new Uint8Array([
        0,
        // version 0
        0,
        0,
        0,
        // flags
        0,
        0,
        0,
        1
      ]), y.type === "video" ? d(y) : p(y));
    }, d = function(y) {
      var v = y.sps || [], w = y.pps || [], C = [], R = [], F, U;
      for (F = 0; F < v.length; F++)
        C.push((v[F].byteLength & 65280) >>> 8), C.push(v[F].byteLength & 255), C = C.concat(Array.prototype.slice.call(v[F]));
      for (F = 0; F < w.length; F++)
        R.push((w[F].byteLength & 65280) >>> 8), R.push(w[F].byteLength & 255), R = R.concat(Array.prototype.slice.call(w[F]));
      if (U = [ie.avc1, new Uint8Array([
        0,
        0,
        0,
        0,
        0,
        0,
        // reserved
        0,
        1,
        // data_reference_index
        0,
        0,
        // pre_defined
        0,
        0,
        // reserved
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        // pre_defined
        (y.width & 65280) >> 8,
        y.width & 255,
        // width
        (y.height & 65280) >> 8,
        y.height & 255,
        // height
        0,
        72,
        0,
        0,
        // horizresolution
        0,
        72,
        0,
        0,
        // vertresolution
        0,
        0,
        0,
        0,
        // reserved
        0,
        1,
        // frame_count
        19,
        118,
        105,
        100,
        101,
        111,
        106,
        115,
        45,
        99,
        111,
        110,
        116,
        114,
        105,
        98,
        45,
        104,
        108,
        115,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        // compressorname
        0,
        24,
        // depth = 24
        17,
        17
        // pre_defined = -1
      ]), o(ie.avcC, new Uint8Array([
        1,
        // configurationVersion
        y.profileIdc,
        // AVCProfileIndication
        y.profileCompatibility,
        // profile_compatibility
        y.levelIdc,
        // AVCLevelIndication
        255
        // lengthSizeMinusOne, hard-coded to 4 bytes
      ].concat(
        [v.length],
        // numOfSequenceParameterSets
        C,
        // "SPS"
        [w.length],
        // numOfPictureParameterSets
        R
        // "PPS"
      ))), o(ie.btrt, new Uint8Array([
        0,
        28,
        156,
        128,
        // bufferSizeDB
        0,
        45,
        198,
        192,
        // maxBitrate
        0,
        45,
        198,
        192
        // avgBitrate
      ]))], y.sarRatio) {
        var q = y.sarRatio[0], ae = y.sarRatio[1];
        U.push(o(ie.pasp, new Uint8Array([(q & 4278190080) >> 24, (q & 16711680) >> 16, (q & 65280) >> 8, q & 255, (ae & 4278190080) >> 24, (ae & 16711680) >> 16, (ae & 65280) >> 8, ae & 255])));
      }
      return o.apply(null, U);
    }, p = function(y) {
      return o(ie.mp4a, new Uint8Array([
        // SampleEntry, ISO/IEC 14496-12
        0,
        0,
        0,
        0,
        0,
        0,
        // reserved
        0,
        1,
        // data_reference_index
        // AudioSampleEntry, ISO/IEC 14496-12
        0,
        0,
        0,
        0,
        // reserved
        0,
        0,
        0,
        0,
        // reserved
        (y.channelcount & 65280) >> 8,
        y.channelcount & 255,
        // channelcount
        (y.samplesize & 65280) >> 8,
        y.samplesize & 255,
        // samplesize
        0,
        0,
        // pre_defined
        0,
        0,
        // reserved
        (y.samplerate & 65280) >> 8,
        y.samplerate & 255,
        0,
        0
        // samplerate, 16.16
        // MP4AudioSampleEntry, ISO/IEC 14496-14
      ]), c(y));
    };
  }(), L = function(d) {
    var p = new Uint8Array([
      0,
      // version 0
      0,
      0,
      7,
      // flags
      0,
      0,
      0,
      0,
      // creation_time
      0,
      0,
      0,
      0,
      // modification_time
      (d.id & 4278190080) >> 24,
      (d.id & 16711680) >> 16,
      (d.id & 65280) >> 8,
      d.id & 255,
      // track_ID
      0,
      0,
      0,
      0,
      // reserved
      (d.duration & 4278190080) >> 24,
      (d.duration & 16711680) >> 16,
      (d.duration & 65280) >> 8,
      d.duration & 255,
      // duration
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      // layer
      0,
      0,
      // alternate_group
      1,
      0,
      // non-audio track volume
      0,
      0,
      // reserved
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      64,
      0,
      0,
      0,
      // transformation: unity matrix
      (d.width & 65280) >> 8,
      d.width & 255,
      0,
      0,
      // width
      (d.height & 65280) >> 8,
      d.height & 255,
      0,
      0
      // height
    ]);
    return o(ie.tkhd, p);
  }, V = function(d) {
    var p, y, v, w, C, R, F;
    return p = o(ie.tfhd, new Uint8Array([
      0,
      // version 0
      0,
      0,
      58,
      // flags
      (d.id & 4278190080) >> 24,
      (d.id & 16711680) >> 16,
      (d.id & 65280) >> 8,
      d.id & 255,
      // track_ID
      0,
      0,
      0,
      1,
      // sample_description_index
      0,
      0,
      0,
      0,
      // default_sample_duration
      0,
      0,
      0,
      0,
      // default_sample_size
      0,
      0,
      0,
      0
      // default_sample_flags
    ])), R = Math.floor(d.baseMediaDecodeTime / s), F = Math.floor(d.baseMediaDecodeTime % s), y = o(ie.tfdt, new Uint8Array([
      1,
      // version 1
      0,
      0,
      0,
      // flags
      // baseMediaDecodeTime
      R >>> 24 & 255,
      R >>> 16 & 255,
      R >>> 8 & 255,
      R & 255,
      F >>> 24 & 255,
      F >>> 16 & 255,
      F >>> 8 & 255,
      F & 255
    ])), C = 92, d.type === "audio" ? (v = se(d, C), o(ie.traf, p, y, v)) : (w = B(d), v = se(d, w.length + C), o(ie.traf, p, y, v, w));
  }, D = function(d) {
    return d.duration = d.duration || 4294967295, o(ie.trak, L(d), M(d));
  }, H = function(d) {
    var p = new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      (d.id & 4278190080) >> 24,
      (d.id & 16711680) >> 16,
      (d.id & 65280) >> 8,
      d.id & 255,
      // track_ID
      0,
      0,
      0,
      1,
      // default_sample_description_index
      0,
      0,
      0,
      0,
      // default_sample_duration
      0,
      0,
      0,
      0,
      // default_sample_size
      0,
      1,
      0,
      1
      // default_sample_flags
    ]);
    return d.type !== "video" && (p[p.length - 1] = 0), o(ie.trex, p);
  }, function() {
    var d, p, y;
    y = function(v, w) {
      var C = 0, R = 0, F = 0, U = 0;
      return v.length && (v[0].duration !== void 0 && (C = 1), v[0].size !== void 0 && (R = 2), v[0].flags !== void 0 && (F = 4), v[0].compositionTimeOffset !== void 0 && (U = 8)), [
        0,
        // version 0
        0,
        C | R | F | U,
        1,
        // flags
        (v.length & 4278190080) >>> 24,
        (v.length & 16711680) >>> 16,
        (v.length & 65280) >>> 8,
        v.length & 255,
        // sample_count
        (w & 4278190080) >>> 24,
        (w & 16711680) >>> 16,
        (w & 65280) >>> 8,
        w & 255
        // data_offset
      ];
    }, p = function(v, w) {
      var C, R, F, U, q, ae;
      for (U = v.samples || [], w += 20 + 16 * U.length, F = y(U, w), R = new Uint8Array(F.length + U.length * 16), R.set(F), C = F.length, ae = 0; ae < U.length; ae++)
        q = U[ae], R[C++] = (q.duration & 4278190080) >>> 24, R[C++] = (q.duration & 16711680) >>> 16, R[C++] = (q.duration & 65280) >>> 8, R[C++] = q.duration & 255, R[C++] = (q.size & 4278190080) >>> 24, R[C++] = (q.size & 16711680) >>> 16, R[C++] = (q.size & 65280) >>> 8, R[C++] = q.size & 255, R[C++] = q.flags.isLeading << 2 | q.flags.dependsOn, R[C++] = q.flags.isDependedOn << 6 | q.flags.hasRedundancy << 4 | q.flags.paddingValue << 1 | q.flags.isNonSyncSample, R[C++] = q.flags.degradationPriority & 61440, R[C++] = q.flags.degradationPriority & 15, R[C++] = (q.compositionTimeOffset & 4278190080) >>> 24, R[C++] = (q.compositionTimeOffset & 16711680) >>> 16, R[C++] = (q.compositionTimeOffset & 65280) >>> 8, R[C++] = q.compositionTimeOffset & 255;
      return o(ie.trun, R);
    }, d = function(v, w) {
      var C, R, F, U, q, ae;
      for (U = v.samples || [], w += 20 + 8 * U.length, F = y(U, w), C = new Uint8Array(F.length + U.length * 8), C.set(F), R = F.length, ae = 0; ae < U.length; ae++)
        q = U[ae], C[R++] = (q.duration & 4278190080) >>> 24, C[R++] = (q.duration & 16711680) >>> 16, C[R++] = (q.duration & 65280) >>> 8, C[R++] = q.duration & 255, C[R++] = (q.size & 4278190080) >>> 24, C[R++] = (q.size & 16711680) >>> 16, C[R++] = (q.size & 65280) >>> 8, C[R++] = q.size & 255;
      return o(ie.trun, C);
    }, se = function(v, w) {
      return v.type === "audio" ? d(v, w) : p(v, w);
    };
  }();
  var ee = {
    ftyp: u,
    mdat: f,
    moof: T,
    moov: g,
    initSegment: function(d) {
      var p = u(), y = g(d), v;
      return v = new Uint8Array(p.byteLength + y.byteLength), v.set(p), v.set(y, p.byteLength), v;
    }
  }, Ue = function(d) {
    var p, y, v = [], w = [];
    for (w.byteLength = 0, w.nalCount = 0, w.duration = 0, v.byteLength = 0, p = 0; p < d.length; p++)
      y = d[p], y.nalUnitType === "access_unit_delimiter_rbsp" ? (v.length && (v.duration = y.dts - v.dts, w.byteLength += v.byteLength, w.nalCount += v.length, w.duration += v.duration, w.push(v)), v = [y], v.byteLength = y.data.byteLength, v.pts = y.pts, v.dts = y.dts) : (y.nalUnitType === "slice_layer_without_partitioning_rbsp_idr" && (v.keyFrame = !0), v.duration = y.dts - v.dts, v.byteLength += y.data.byteLength, v.push(y));
    return w.length && (!v.duration || v.duration <= 0) && (v.duration = w[w.length - 1].duration), w.byteLength += v.byteLength, w.nalCount += v.length, w.duration += v.duration, w.push(v), w;
  }, tt = function(d) {
    var p, y, v = [], w = [];
    for (v.byteLength = 0, v.nalCount = 0, v.duration = 0, v.pts = d[0].pts, v.dts = d[0].dts, w.byteLength = 0, w.nalCount = 0, w.duration = 0, w.pts = d[0].pts, w.dts = d[0].dts, p = 0; p < d.length; p++)
      y = d[p], y.keyFrame ? (v.length && (w.push(v), w.byteLength += v.byteLength, w.nalCount += v.nalCount, w.duration += v.duration), v = [y], v.nalCount = y.length, v.byteLength = y.byteLength, v.pts = y.pts, v.dts = y.dts, v.duration = y.duration) : (v.duration += y.duration, v.nalCount += y.length, v.byteLength += y.byteLength, v.push(y));
    return w.length && v.duration <= 0 && (v.duration = w[w.length - 1].duration), w.byteLength += v.byteLength, w.nalCount += v.nalCount, w.duration += v.duration, w.push(v), w;
  }, we = function(d) {
    var p;
    return !d[0][0].keyFrame && d.length > 1 && (p = d.shift(), d.byteLength -= p.byteLength, d.nalCount -= p.nalCount, d[0][0].dts = p.dts, d[0][0].pts = p.pts, d[0][0].duration += p.duration), d;
  }, Je = function() {
    return {
      size: 0,
      flags: {
        isLeading: 0,
        dependsOn: 1,
        isDependedOn: 0,
        hasRedundancy: 0,
        degradationPriority: 0,
        isNonSyncSample: 1
      }
    };
  }, X = function(d, p) {
    var y = Je();
    return y.dataOffset = p, y.compositionTimeOffset = d.pts - d.dts, y.duration = d.duration, y.size = 4 * d.length, y.size += d.byteLength, d.keyFrame && (y.flags.dependsOn = 2, y.flags.isNonSyncSample = 0), y;
  }, Ae = function(d, p) {
    var y, v, w, C, R, F = p || 0, U = [];
    for (y = 0; y < d.length; y++)
      for (C = d[y], v = 0; v < C.length; v++)
        R = C[v], w = X(R, F), F += w.size, U.push(w);
    return U;
  }, fe = function(d) {
    var p, y, v, w, C, R, F = 0, U = d.byteLength, q = d.nalCount, ae = U + 4 * q, pe = new Uint8Array(ae), Fe = new DataView(pe.buffer);
    for (p = 0; p < d.length; p++)
      for (w = d[p], y = 0; y < w.length; y++)
        for (C = w[y], v = 0; v < C.length; v++)
          R = C[v], Fe.setUint32(F, R.data.byteLength), F += 4, pe.set(R.data, F), F += R.data.byteLength;
    return pe;
  }, Ee = function(d, p) {
    var y, v = p || 0, w = [];
    return y = X(d, v), w.push(y), w;
  }, Te = function(d) {
    var p, y, v = 0, w = d.byteLength, C = d.length, R = w + 4 * C, F = new Uint8Array(R), U = new DataView(F.buffer);
    for (p = 0; p < d.length; p++)
      y = d[p], U.setUint32(v, y.data.byteLength), v += 4, F.set(y.data, v), v += y.data.byteLength;
    return F;
  }, nt = {
    groupNalsIntoFrames: Ue,
    groupFramesIntoGops: tt,
    extendFirstKeyFrame: we,
    generateSampleTable: Ae,
    concatenateNalData: fe,
    generateSampleTableForFrame: Ee,
    concatenateNalDataForFrame: Te
  }, le = [33, 16, 5, 32, 164, 27], Oe = [33, 65, 108, 84, 1, 2, 4, 8, 168, 2, 4, 8, 17, 191, 252], Re = function(d) {
    for (var p = []; d--; )
      p.push(0);
    return p;
  }, ct = function(d) {
    return Object.keys(d).reduce(function(p, y) {
      return p[y] = new Uint8Array(d[y].reduce(function(v, w) {
        return v.concat(w);
      }, [])), p;
    }, {});
  }, Ot, Ge = function() {
    if (!Ot) {
      var d = {
        96e3: [le, [227, 64], Re(154), [56]],
        88200: [le, [231], Re(170), [56]],
        64e3: [le, [248, 192], Re(240), [56]],
        48e3: [le, [255, 192], Re(268), [55, 148, 128], Re(54), [112]],
        44100: [le, [255, 192], Re(268), [55, 163, 128], Re(84), [112]],
        32e3: [le, [255, 192], Re(268), [55, 234], Re(226), [112]],
        24e3: [le, [255, 192], Re(268), [55, 255, 128], Re(268), [111, 112], Re(126), [224]],
        16e3: [le, [255, 192], Re(268), [55, 255, 128], Re(268), [111, 255], Re(269), [223, 108], Re(195), [1, 192]],
        12e3: [Oe, Re(268), [3, 127, 248], Re(268), [6, 255, 240], Re(268), [13, 255, 224], Re(268), [27, 253, 128], Re(259), [56]],
        11025: [Oe, Re(268), [3, 127, 248], Re(268), [6, 255, 240], Re(268), [13, 255, 224], Re(268), [27, 255, 192], Re(268), [55, 175, 128], Re(108), [112]],
        8e3: [Oe, Re(268), [3, 121, 16], Re(47), [7]]
      };
      Ot = ct(d);
    }
    return Ot;
  }, ma = 9e4, Vn, ci, hn, ui, qr, dr, Wr;
  Vn = function(d) {
    return d * ma;
  }, ci = function(d, p) {
    return d * p;
  }, hn = function(d) {
    return d / ma;
  }, ui = function(d, p) {
    return d / p;
  }, qr = function(d, p) {
    return Vn(ui(d, p));
  }, dr = function(d, p) {
    return ci(hn(d), p);
  }, Wr = function(d, p, y) {
    return hn(y ? d : d - p);
  };
  var bt = {
    ONE_SECOND_IN_TS: ma,
    secondsToVideoTs: Vn,
    secondsToAudioTs: ci,
    videoTsToSeconds: hn,
    audioTsToSeconds: ui,
    audioTsToVideoTs: qr,
    videoTsToAudioTs: dr,
    metadataTsToSeconds: Wr
  }, bo = Ge, Oi = bt, vo = function(d) {
    var p, y, v = 0;
    for (p = 0; p < d.length; p++)
      y = d[p], v += y.data.byteLength;
    return v;
  }, yo = function(d, p, y, v) {
    var w, C = 0, R = 0, F = 0, U = 0, q, ae, pe;
    if (p.length && (w = Oi.audioTsToVideoTs(d.baseMediaDecodeTime, d.samplerate), C = Math.ceil(Oi.ONE_SECOND_IN_TS / (d.samplerate / 1024)), y && v && (R = w - Math.max(y, v), F = Math.floor(R / C), U = F * C), !(F < 1 || U > Oi.ONE_SECOND_IN_TS / 2))) {
      for (q = bo()[d.samplerate], q || (q = p[0].data), ae = 0; ae < F; ae++)
        pe = p[0], p.splice(0, 0, {
          data: q,
          dts: pe.dts - C,
          pts: pe.pts - C
        });
      return d.baseMediaDecodeTime -= Math.floor(Oi.videoTsToAudioTs(U, d.samplerate)), U;
    }
  }, de = function(d, p, y) {
    return p.minSegmentDts >= y ? d : (p.minSegmentDts = 1 / 0, d.filter(function(v) {
      return v.dts >= y ? (p.minSegmentDts = Math.min(p.minSegmentDts, v.dts), p.minSegmentPts = p.minSegmentDts, !0) : !1;
    }));
  }, Pe = function(d) {
    var p, y, v = [];
    for (p = 0; p < d.length; p++)
      y = d[p], v.push({
        size: y.data.byteLength,
        duration: 1024
        // For AAC audio, all samples contain 1024 samples
      });
    return v;
  }, _e = function(d) {
    var p, y, v = 0, w = new Uint8Array(vo(d));
    for (p = 0; p < d.length; p++)
      y = d[p], w.set(y.data, v), v += y.data.byteLength;
    return w;
  }, Be = {
    prefixWithSilence: yo,
    trimAdtsFramesByEarliestDts: de,
    generateSampleTable: Pe,
    concatenateFrameData: _e
  }, Ye = bt.ONE_SECOND_IN_TS, _n = function(d, p) {
    typeof p.pts == "number" && (d.timelineStartInfo.pts === void 0 && (d.timelineStartInfo.pts = p.pts), d.minSegmentPts === void 0 ? d.minSegmentPts = p.pts : d.minSegmentPts = Math.min(d.minSegmentPts, p.pts), d.maxSegmentPts === void 0 ? d.maxSegmentPts = p.pts : d.maxSegmentPts = Math.max(d.maxSegmentPts, p.pts)), typeof p.dts == "number" && (d.timelineStartInfo.dts === void 0 && (d.timelineStartInfo.dts = p.dts), d.minSegmentDts === void 0 ? d.minSegmentDts = p.dts : d.minSegmentDts = Math.min(d.minSegmentDts, p.dts), d.maxSegmentDts === void 0 ? d.maxSegmentDts = p.dts : d.maxSegmentDts = Math.max(d.maxSegmentDts, p.dts));
  }, qn = function(d) {
    delete d.minSegmentDts, delete d.maxSegmentDts, delete d.minSegmentPts, delete d.maxSegmentPts;
  }, di = function(d, p) {
    var y, v, w = d.minSegmentDts;
    return p || (w -= d.timelineStartInfo.dts), y = d.timelineStartInfo.baseMediaDecodeTime, y += w, y = Math.max(0, y), d.type === "audio" && (v = d.samplerate / Ye, y *= v, y = Math.floor(y)), y;
  }, Gr = {
    clearDtsInfo: qn,
    calculateTrackBaseMediaDecodeTime: di,
    collectDtsInfo: _n
  }, Pi = 4, Ua = 128, _o = function(d) {
    for (var p = 0, y = {
      payloadType: -1,
      payloadSize: 0
    }, v = 0, w = 0; p < d.byteLength && d[p] !== Ua; ) {
      for (; d[p] === 255; )
        v += 255, p++;
      for (v += d[p++]; d[p] === 255; )
        w += 255, p++;
      if (w += d[p++], !y.payload && v === Pi) {
        var C = String.fromCharCode(d[p + 3], d[p + 4], d[p + 5], d[p + 6]);
        if (C === "GA94") {
          y.payloadType = v, y.payloadSize = w, y.payload = d.subarray(p, p + w);
          break;
        } else
          y.payload = void 0;
      }
      p += w, v = 0, w = 0;
    }
    return y;
  }, Pd = function(d) {
    return d.payload[0] !== 181 || (d.payload[1] << 8 | d.payload[2]) !== 49 || String.fromCharCode(d.payload[3], d.payload[4], d.payload[5], d.payload[6]) !== "GA94" || d.payload[7] !== 3 ? null : d.payload.subarray(8, d.payload.length - 1);
  }, BT = function(d, p) {
    var y = [], v, w, C, R;
    if (!(p[0] & 64))
      return y;
    for (w = p[0] & 31, v = 0; v < w; v++)
      C = v * 3, R = {
        type: p[C + 2] & 3,
        pts: d
      }, p[C + 2] & 4 && (R.ccData = p[C + 3] << 8 | p[C + 4], y.push(R));
    return y;
  }, RT = function(d) {
    for (var p = d.byteLength, y = [], v = 1, w, C; v < p - 2; )
      d[v] === 0 && d[v + 1] === 0 && d[v + 2] === 3 ? (y.push(v + 2), v += 2) : v++;
    if (y.length === 0)
      return d;
    w = p - y.length, C = new Uint8Array(w);
    var R = 0;
    for (v = 0; v < w; R++, v++)
      R === y[0] && (R++, y.shift()), C[v] = d[R];
    return C;
  }, Rp = {
    parseSei: _o,
    parseUserData: Pd,
    parseCaptionPackets: BT,
    discardEmulationPreventionBytes: RT,
    USER_DATA_REGISTERED_ITU_T_T35: Pi
  }, Bd = n, Jl = Rp, Wn = function(d) {
    d = d || {}, Wn.prototype.init.call(this), this.parse708captions_ = typeof d.parse708captions == "boolean" ? d.parse708captions : !0, this.captionPackets_ = [], this.ccStreams_ = [
      new Pt(0, 0),
      // eslint-disable-line no-use-before-define
      new Pt(0, 1),
      // eslint-disable-line no-use-before-define
      new Pt(1, 0),
      // eslint-disable-line no-use-before-define
      new Pt(1, 1)
      // eslint-disable-line no-use-before-define
    ], this.parse708captions_ && (this.cc708Stream_ = new kt({
      captionServices: d.captionServices
    })), this.reset(), this.ccStreams_.forEach(function(p) {
      p.on("data", this.trigger.bind(this, "data")), p.on("partialdone", this.trigger.bind(this, "partialdone")), p.on("done", this.trigger.bind(this, "done"));
    }, this), this.parse708captions_ && (this.cc708Stream_.on("data", this.trigger.bind(this, "data")), this.cc708Stream_.on("partialdone", this.trigger.bind(this, "partialdone")), this.cc708Stream_.on("done", this.trigger.bind(this, "done")));
  };
  Wn.prototype = new Bd(), Wn.prototype.push = function(d) {
    var p, y, v;
    if (d.nalUnitType === "sei_rbsp" && (p = Jl.parseSei(d.escapedRBSP), !!p.payload && p.payloadType === Jl.USER_DATA_REGISTERED_ITU_T_T35 && (y = Jl.parseUserData(p), !!y))) {
      if (d.dts < this.latestDts_) {
        this.ignoreNextEqualDts_ = !0;
        return;
      } else if (d.dts === this.latestDts_ && this.ignoreNextEqualDts_) {
        this.numSameDts_--, this.numSameDts_ || (this.ignoreNextEqualDts_ = !1);
        return;
      }
      v = Jl.parseCaptionPackets(d.pts, y), this.captionPackets_ = this.captionPackets_.concat(v), this.latestDts_ !== d.dts && (this.numSameDts_ = 0), this.numSameDts_++, this.latestDts_ = d.dts;
    }
  }, Wn.prototype.flushCCStreams = function(d) {
    this.ccStreams_.forEach(function(p) {
      return d === "flush" ? p.flush() : p.partialFlush();
    }, this);
  }, Wn.prototype.flushStream = function(d) {
    if (!this.captionPackets_.length) {
      this.flushCCStreams(d);
      return;
    }
    this.captionPackets_.forEach(function(p, y) {
      p.presortIndex = y;
    }), this.captionPackets_.sort(function(p, y) {
      return p.pts === y.pts ? p.presortIndex - y.presortIndex : p.pts - y.pts;
    }), this.captionPackets_.forEach(function(p) {
      p.type < 2 ? this.dispatchCea608Packet(p) : this.dispatchCea708Packet(p);
    }, this), this.captionPackets_.length = 0, this.flushCCStreams(d);
  }, Wn.prototype.flush = function() {
    return this.flushStream("flush");
  }, Wn.prototype.partialFlush = function() {
    return this.flushStream("partialFlush");
  }, Wn.prototype.reset = function() {
    this.latestDts_ = null, this.ignoreNextEqualDts_ = !1, this.numSameDts_ = 0, this.activeCea608Channel_ = [null, null], this.ccStreams_.forEach(function(d) {
      d.reset();
    });
  }, Wn.prototype.dispatchCea608Packet = function(d) {
    this.setsTextOrXDSActive(d) ? this.activeCea608Channel_[d.type] = null : this.setsChannel1Active(d) ? this.activeCea608Channel_[d.type] = 0 : this.setsChannel2Active(d) && (this.activeCea608Channel_[d.type] = 1), this.activeCea608Channel_[d.type] !== null && this.ccStreams_[(d.type << 1) + this.activeCea608Channel_[d.type]].push(d);
  }, Wn.prototype.setsChannel1Active = function(d) {
    return (d.ccData & 30720) === 4096;
  }, Wn.prototype.setsChannel2Active = function(d) {
    return (d.ccData & 30720) === 6144;
  }, Wn.prototype.setsTextOrXDSActive = function(d) {
    return (d.ccData & 28928) === 256 || (d.ccData & 30974) === 4138 || (d.ccData & 30974) === 6186;
  }, Wn.prototype.dispatchCea708Packet = function(d) {
    this.parse708captions_ && this.cc708Stream_.push(d);
  };
  var NT = {
    127: 9834,
    // ♪
    4128: 32,
    // Transparent Space
    4129: 160,
    // Nob-breaking Transparent Space
    4133: 8230,
    // …
    4138: 352,
    // Š
    4140: 338,
    // Œ
    4144: 9608,
    // █
    4145: 8216,
    // ‘
    4146: 8217,
    // ’
    4147: 8220,
    // “
    4148: 8221,
    // ”
    4149: 8226,
    // •
    4153: 8482,
    // ™
    4154: 353,
    // š
    4156: 339,
    // œ
    4157: 8480,
    // ℠
    4159: 376,
    // Ÿ
    4214: 8539,
    // ⅛
    4215: 8540,
    // ⅜
    4216: 8541,
    // ⅝
    4217: 8542,
    // ⅞
    4218: 9168,
    // ⏐
    4219: 9124,
    // ⎤
    4220: 9123,
    // ⎣
    4221: 9135,
    // ⎯
    4222: 9126,
    // ⎦
    4223: 9121,
    // ⎡
    4256: 12600
    // ㄸ (CC char)
  }, $T = function(d) {
    var p = NT[d] || d;
    return d & 4096 && d === p ? "" : String.fromCharCode(p);
  }, ec = function(d) {
    return 32 <= d && d <= 127 || 160 <= d && d <= 255;
  }, hi = function(d) {
    this.windowNum = d, this.reset();
  };
  hi.prototype.reset = function() {
    this.clearText(), this.pendingNewLine = !1, this.winAttr = {}, this.penAttr = {}, this.penLoc = {}, this.penColor = {}, this.visible = 0, this.rowLock = 0, this.columnLock = 0, this.priority = 0, this.relativePositioning = 0, this.anchorVertical = 0, this.anchorHorizontal = 0, this.anchorPoint = 0, this.rowCount = 1, this.virtualRowCount = this.rowCount + 1, this.columnCount = 41, this.windowStyle = 0, this.penStyle = 0;
  }, hi.prototype.getText = function() {
    return this.rows.join(`
`);
  }, hi.prototype.clearText = function() {
    this.rows = [""], this.rowIdx = 0;
  }, hi.prototype.newLine = function(d) {
    for (this.rows.length >= this.virtualRowCount && typeof this.beforeRowOverflow == "function" && this.beforeRowOverflow(d), this.rows.length > 0 && (this.rows.push(""), this.rowIdx++); this.rows.length > this.virtualRowCount; )
      this.rows.shift(), this.rowIdx--;
  }, hi.prototype.isEmpty = function() {
    return this.rows.length === 0 ? !0 : this.rows.length === 1 ? this.rows[0] === "" : !1;
  }, hi.prototype.addText = function(d) {
    this.rows[this.rowIdx] += d;
  }, hi.prototype.backspace = function() {
    if (!this.isEmpty()) {
      var d = this.rows[this.rowIdx];
      this.rows[this.rowIdx] = d.substr(0, d.length - 1);
    }
  };
  var tc = function(d, p, y) {
    this.serviceNum = d, this.text = "", this.currentWindow = new hi(-1), this.windows = [], this.stream = y, typeof p == "string" && this.createTextDecoder(p);
  };
  tc.prototype.init = function(d, p) {
    this.startPts = d;
    for (var y = 0; y < 8; y++)
      this.windows[y] = new hi(y), typeof p == "function" && (this.windows[y].beforeRowOverflow = p);
  }, tc.prototype.setCurrentWindow = function(d) {
    this.currentWindow = this.windows[d];
  }, tc.prototype.createTextDecoder = function(d) {
    if (typeof TextDecoder > "u")
      this.stream.trigger("log", {
        level: "warn",
        message: "The `encoding` option is unsupported without TextDecoder support"
      });
    else
      try {
        this.textDecoder_ = new TextDecoder(d);
      } catch (p) {
        this.stream.trigger("log", {
          level: "warn",
          message: "TextDecoder could not be created with " + d + " encoding. " + p
        });
      }
  };
  var kt = function(d) {
    d = d || {}, kt.prototype.init.call(this);
    var p = this, y = d.captionServices || {}, v = {}, w;
    Object.keys(y).forEach((C) => {
      w = y[C], /^SERVICE/.test(C) && (v[C] = w.encoding);
    }), this.serviceEncodings = v, this.current708Packet = null, this.services = {}, this.push = function(C) {
      C.type === 3 ? (p.new708Packet(), p.add708Bytes(C)) : (p.current708Packet === null && p.new708Packet(), p.add708Bytes(C));
    };
  };
  kt.prototype = new Bd(), kt.prototype.new708Packet = function() {
    this.current708Packet !== null && this.push708Packet(), this.current708Packet = {
      data: [],
      ptsVals: []
    };
  }, kt.prototype.add708Bytes = function(d) {
    var p = d.ccData, y = p >>> 8, v = p & 255;
    this.current708Packet.ptsVals.push(d.pts), this.current708Packet.data.push(y), this.current708Packet.data.push(v);
  }, kt.prototype.push708Packet = function() {
    var d = this.current708Packet, p = d.data, y = null, v = null, w = 0, C = p[w++];
    for (d.seq = C >> 6, d.sizeCode = C & 63; w < p.length; w++)
      C = p[w++], y = C >> 5, v = C & 31, y === 7 && v > 0 && (C = p[w++], y = C), this.pushServiceBlock(y, w, v), v > 0 && (w += v - 1);
  }, kt.prototype.pushServiceBlock = function(d, p, y) {
    var v, w = p, C = this.current708Packet.data, R = this.services[d];
    for (R || (R = this.initService(d, w)); w < p + y && w < C.length; w++)
      v = C[w], ec(v) ? w = this.handleText(w, R) : v === 24 ? w = this.multiByteCharacter(w, R) : v === 16 ? w = this.extendedCommands(w, R) : 128 <= v && v <= 135 ? w = this.setCurrentWindow(w, R) : 152 <= v && v <= 159 ? w = this.defineWindow(w, R) : v === 136 ? w = this.clearWindows(w, R) : v === 140 ? w = this.deleteWindows(w, R) : v === 137 ? w = this.displayWindows(w, R) : v === 138 ? w = this.hideWindows(w, R) : v === 139 ? w = this.toggleWindows(w, R) : v === 151 ? w = this.setWindowAttributes(w, R) : v === 144 ? w = this.setPenAttributes(w, R) : v === 145 ? w = this.setPenColor(w, R) : v === 146 ? w = this.setPenLocation(w, R) : v === 143 ? R = this.reset(w, R) : v === 8 ? R.currentWindow.backspace() : v === 12 ? R.currentWindow.clearText() : v === 13 ? R.currentWindow.pendingNewLine = !0 : v === 14 ? R.currentWindow.clearText() : v === 141 && w++;
  }, kt.prototype.extendedCommands = function(d, p) {
    var y = this.current708Packet.data, v = y[++d];
    return ec(v) && (d = this.handleText(d, p, {
      isExtended: !0
    })), d;
  }, kt.prototype.getPts = function(d) {
    return this.current708Packet.ptsVals[Math.floor(d / 2)];
  }, kt.prototype.initService = function(d, p) {
    var v = "SERVICE" + d, y = this, v, w;
    return v in this.serviceEncodings && (w = this.serviceEncodings[v]), this.services[d] = new tc(d, w, y), this.services[d].init(this.getPts(p), function(C) {
      y.flushDisplayed(C, y.services[d]);
    }), this.services[d];
  }, kt.prototype.handleText = function(d, p, y) {
    var v = y && y.isExtended, w = y && y.isMultiByte, C = this.current708Packet.data, R = v ? 4096 : 0, F = C[d], U = C[d + 1], q = p.currentWindow, ae, pe;
    function Fe(Se) {
      return Se.map((Ze) => ("0" + (Ze & 255).toString(16)).slice(-2)).join("");
    }
    if (w ? (pe = [F, U], d++) : pe = [F], p.textDecoder_ && !v)
      ae = p.textDecoder_.decode(new Uint8Array(pe));
    else if (w) {
      const Se = Fe(pe);
      ae = String.fromCharCode(parseInt(Se, 16));
    } else
      ae = $T(R | F);
    return q.pendingNewLine && !q.isEmpty() && q.newLine(this.getPts(d)), q.pendingNewLine = !1, q.addText(ae), d;
  }, kt.prototype.multiByteCharacter = function(d, p) {
    var y = this.current708Packet.data, v = y[d + 1], w = y[d + 2];
    return ec(v) && ec(w) && (d = this.handleText(++d, p, {
      isMultiByte: !0
    })), d;
  }, kt.prototype.setCurrentWindow = function(d, p) {
    var y = this.current708Packet.data, v = y[d], w = v & 7;
    return p.setCurrentWindow(w), d;
  }, kt.prototype.defineWindow = function(d, p) {
    var y = this.current708Packet.data, v = y[d], w = v & 7;
    p.setCurrentWindow(w);
    var C = p.currentWindow;
    return v = y[++d], C.visible = (v & 32) >> 5, C.rowLock = (v & 16) >> 4, C.columnLock = (v & 8) >> 3, C.priority = v & 7, v = y[++d], C.relativePositioning = (v & 128) >> 7, C.anchorVertical = v & 127, v = y[++d], C.anchorHorizontal = v, v = y[++d], C.anchorPoint = (v & 240) >> 4, C.rowCount = v & 15, v = y[++d], C.columnCount = v & 63, v = y[++d], C.windowStyle = (v & 56) >> 3, C.penStyle = v & 7, C.virtualRowCount = C.rowCount + 1, d;
  }, kt.prototype.setWindowAttributes = function(d, p) {
    var y = this.current708Packet.data, v = y[d], w = p.currentWindow.winAttr;
    return v = y[++d], w.fillOpacity = (v & 192) >> 6, w.fillRed = (v & 48) >> 4, w.fillGreen = (v & 12) >> 2, w.fillBlue = v & 3, v = y[++d], w.borderType = (v & 192) >> 6, w.borderRed = (v & 48) >> 4, w.borderGreen = (v & 12) >> 2, w.borderBlue = v & 3, v = y[++d], w.borderType += (v & 128) >> 5, w.wordWrap = (v & 64) >> 6, w.printDirection = (v & 48) >> 4, w.scrollDirection = (v & 12) >> 2, w.justify = v & 3, v = y[++d], w.effectSpeed = (v & 240) >> 4, w.effectDirection = (v & 12) >> 2, w.displayEffect = v & 3, d;
  }, kt.prototype.flushDisplayed = function(d, p) {
    for (var y = [], v = 0; v < 8; v++)
      p.windows[v].visible && !p.windows[v].isEmpty() && y.push(p.windows[v].getText());
    p.endPts = d, p.text = y.join(`

`), this.pushCaption(p), p.startPts = d;
  }, kt.prototype.pushCaption = function(d) {
    d.text !== "" && (this.trigger("data", {
      startPts: d.startPts,
      endPts: d.endPts,
      text: d.text,
      stream: "cc708_" + d.serviceNum
    }), d.text = "", d.startPts = d.endPts);
  }, kt.prototype.displayWindows = function(d, p) {
    var y = this.current708Packet.data, v = y[++d], w = this.getPts(d);
    this.flushDisplayed(w, p);
    for (var C = 0; C < 8; C++)
      v & 1 << C && (p.windows[C].visible = 1);
    return d;
  }, kt.prototype.hideWindows = function(d, p) {
    var y = this.current708Packet.data, v = y[++d], w = this.getPts(d);
    this.flushDisplayed(w, p);
    for (var C = 0; C < 8; C++)
      v & 1 << C && (p.windows[C].visible = 0);
    return d;
  }, kt.prototype.toggleWindows = function(d, p) {
    var y = this.current708Packet.data, v = y[++d], w = this.getPts(d);
    this.flushDisplayed(w, p);
    for (var C = 0; C < 8; C++)
      v & 1 << C && (p.windows[C].visible ^= 1);
    return d;
  }, kt.prototype.clearWindows = function(d, p) {
    var y = this.current708Packet.data, v = y[++d], w = this.getPts(d);
    this.flushDisplayed(w, p);
    for (var C = 0; C < 8; C++)
      v & 1 << C && p.windows[C].clearText();
    return d;
  }, kt.prototype.deleteWindows = function(d, p) {
    var y = this.current708Packet.data, v = y[++d], w = this.getPts(d);
    this.flushDisplayed(w, p);
    for (var C = 0; C < 8; C++)
      v & 1 << C && p.windows[C].reset();
    return d;
  }, kt.prototype.setPenAttributes = function(d, p) {
    var y = this.current708Packet.data, v = y[d], w = p.currentWindow.penAttr;
    return v = y[++d], w.textTag = (v & 240) >> 4, w.offset = (v & 12) >> 2, w.penSize = v & 3, v = y[++d], w.italics = (v & 128) >> 7, w.underline = (v & 64) >> 6, w.edgeType = (v & 56) >> 3, w.fontStyle = v & 7, d;
  }, kt.prototype.setPenColor = function(d, p) {
    var y = this.current708Packet.data, v = y[d], w = p.currentWindow.penColor;
    return v = y[++d], w.fgOpacity = (v & 192) >> 6, w.fgRed = (v & 48) >> 4, w.fgGreen = (v & 12) >> 2, w.fgBlue = v & 3, v = y[++d], w.bgOpacity = (v & 192) >> 6, w.bgRed = (v & 48) >> 4, w.bgGreen = (v & 12) >> 2, w.bgBlue = v & 3, v = y[++d], w.edgeRed = (v & 48) >> 4, w.edgeGreen = (v & 12) >> 2, w.edgeBlue = v & 3, d;
  }, kt.prototype.setPenLocation = function(d, p) {
    var y = this.current708Packet.data, v = y[d], w = p.currentWindow.penLoc;
    return p.currentWindow.pendingNewLine = !0, v = y[++d], w.row = v & 15, v = y[++d], w.column = v & 63, d;
  }, kt.prototype.reset = function(d, p) {
    var y = this.getPts(d);
    return this.flushDisplayed(y, p), this.initService(p.serviceNum, d);
  };
  var FT = {
    42: 225,
    // á
    92: 233,
    // é
    94: 237,
    // í
    95: 243,
    // ó
    96: 250,
    // ú
    123: 231,
    // ç
    124: 247,
    // ÷
    125: 209,
    // Ñ
    126: 241,
    // ñ
    127: 9608,
    // █
    304: 174,
    // ®
    305: 176,
    // °
    306: 189,
    // ½
    307: 191,
    // ¿
    308: 8482,
    // ™
    309: 162,
    // ¢
    310: 163,
    // £
    311: 9834,
    // ♪
    312: 224,
    // à
    313: 160,
    //
    314: 232,
    // è
    315: 226,
    // â
    316: 234,
    // ê
    317: 238,
    // î
    318: 244,
    // ô
    319: 251,
    // û
    544: 193,
    // Á
    545: 201,
    // É
    546: 211,
    // Ó
    547: 218,
    // Ú
    548: 220,
    // Ü
    549: 252,
    // ü
    550: 8216,
    // ‘
    551: 161,
    // ¡
    552: 42,
    // *
    553: 39,
    // '
    554: 8212,
    // —
    555: 169,
    // ©
    556: 8480,
    // ℠
    557: 8226,
    // •
    558: 8220,
    // “
    559: 8221,
    // ”
    560: 192,
    // À
    561: 194,
    // Â
    562: 199,
    // Ç
    563: 200,
    // È
    564: 202,
    // Ê
    565: 203,
    // Ë
    566: 235,
    // ë
    567: 206,
    // Î
    568: 207,
    // Ï
    569: 239,
    // ï
    570: 212,
    // Ô
    571: 217,
    // Ù
    572: 249,
    // ù
    573: 219,
    // Û
    574: 171,
    // «
    575: 187,
    // »
    800: 195,
    // Ã
    801: 227,
    // ã
    802: 205,
    // Í
    803: 204,
    // Ì
    804: 236,
    // ì
    805: 210,
    // Ò
    806: 242,
    // ò
    807: 213,
    // Õ
    808: 245,
    // õ
    809: 123,
    // {
    810: 125,
    // }
    811: 92,
    // \
    812: 94,
    // ^
    813: 95,
    // _
    814: 124,
    // |
    815: 126,
    // ~
    816: 196,
    // Ä
    817: 228,
    // ä
    818: 214,
    // Ö
    819: 246,
    // ö
    820: 223,
    // ß
    821: 165,
    // ¥
    822: 164,
    // ¤
    823: 9474,
    // │
    824: 197,
    // Å
    825: 229,
    // å
    826: 216,
    // Ø
    827: 248,
    // ø
    828: 9484,
    // ┌
    829: 9488,
    // ┐
    830: 9492,
    // └
    831: 9496
    // ┘
  }, nc = function(d) {
    return d === null ? "" : (d = FT[d] || d, String.fromCharCode(d));
  }, ac = 14, zT = [4352, 4384, 4608, 4640, 5376, 5408, 5632, 5664, 5888, 5920, 4096, 4864, 4896, 5120, 5152], hr = function() {
    for (var d = [], p = ac + 1; p--; )
      d.push({
        text: "",
        indent: 0,
        offset: 0
      });
    return d;
  }, Pt = function(d, p) {
    Pt.prototype.init.call(this), this.field_ = d || 0, this.dataChannel_ = p || 0, this.name_ = "CC" + ((this.field_ << 1 | this.dataChannel_) + 1), this.setConstants(), this.reset(), this.push = function(y) {
      var v, w, C, R, F;
      if (v = y.ccData & 32639, v === this.lastControlCode_) {
        this.lastControlCode_ = null;
        return;
      }
      if ((v & 61440) === 4096 ? this.lastControlCode_ = v : v !== this.PADDING_ && (this.lastControlCode_ = null), C = v >>> 8, R = v & 255, v !== this.PADDING_)
        if (v === this.RESUME_CAPTION_LOADING_)
          this.mode_ = "popOn";
        else if (v === this.END_OF_CAPTION_)
          this.mode_ = "popOn", this.clearFormatting(y.pts), this.flushDisplayed(y.pts), w = this.displayed_, this.displayed_ = this.nonDisplayed_, this.nonDisplayed_ = w, this.startPts_ = y.pts;
        else if (v === this.ROLL_UP_2_ROWS_)
          this.rollUpRows_ = 2, this.setRollUp(y.pts);
        else if (v === this.ROLL_UP_3_ROWS_)
          this.rollUpRows_ = 3, this.setRollUp(y.pts);
        else if (v === this.ROLL_UP_4_ROWS_)
          this.rollUpRows_ = 4, this.setRollUp(y.pts);
        else if (v === this.CARRIAGE_RETURN_)
          this.clearFormatting(y.pts), this.flushDisplayed(y.pts), this.shiftRowsUp_(), this.startPts_ = y.pts;
        else if (v === this.BACKSPACE_)
          this.mode_ === "popOn" ? this.nonDisplayed_[this.row_].text = this.nonDisplayed_[this.row_].text.slice(0, -1) : this.displayed_[this.row_].text = this.displayed_[this.row_].text.slice(0, -1);
        else if (v === this.ERASE_DISPLAYED_MEMORY_)
          this.flushDisplayed(y.pts), this.displayed_ = hr();
        else if (v === this.ERASE_NON_DISPLAYED_MEMORY_)
          this.nonDisplayed_ = hr();
        else if (v === this.RESUME_DIRECT_CAPTIONING_)
          this.mode_ !== "paintOn" && (this.flushDisplayed(y.pts), this.displayed_ = hr()), this.mode_ = "paintOn", this.startPts_ = y.pts;
        else if (this.isSpecialCharacter(C, R))
          C = (C & 3) << 8, F = nc(C | R), this[this.mode_](y.pts, F), this.column_++;
        else if (this.isExtCharacter(C, R))
          this.mode_ === "popOn" ? this.nonDisplayed_[this.row_].text = this.nonDisplayed_[this.row_].text.slice(0, -1) : this.displayed_[this.row_].text = this.displayed_[this.row_].text.slice(0, -1), C = (C & 3) << 8, F = nc(C | R), this[this.mode_](y.pts, F), this.column_++;
        else if (this.isMidRowCode(C, R))
          this.clearFormatting(y.pts), this[this.mode_](y.pts, " "), this.column_++, (R & 14) === 14 && this.addFormatting(y.pts, ["i"]), (R & 1) === 1 && this.addFormatting(y.pts, ["u"]);
        else if (this.isOffsetControlCode(C, R)) {
          const q = R & 3;
          this.nonDisplayed_[this.row_].offset = q, this.column_ += q;
        } else if (this.isPAC(C, R)) {
          var U = zT.indexOf(v & 7968);
          if (this.mode_ === "rollUp" && (U - this.rollUpRows_ + 1 < 0 && (U = this.rollUpRows_ - 1), this.setRollUp(y.pts, U)), U !== this.row_ && U >= 0 && U <= 14 && (this.clearFormatting(y.pts), this.row_ = U), R & 1 && this.formatting_.indexOf("u") === -1 && this.addFormatting(y.pts, ["u"]), (v & 16) === 16) {
            const q = (v & 14) >> 1;
            this.column_ = q * 4, this.nonDisplayed_[this.row_].indent += q;
          }
          this.isColorPAC(R) && (R & 14) === 14 && this.addFormatting(y.pts, ["i"]);
        } else this.isNormalChar(C) && (R === 0 && (R = null), F = nc(C), F += nc(R), this[this.mode_](y.pts, F), this.column_ += F.length);
    };
  };
  Pt.prototype = new Bd(), Pt.prototype.flushDisplayed = function(d) {
    const p = (v) => {
      this.trigger("log", {
        level: "warn",
        message: "Skipping a malformed 608 caption at index " + v + "."
      });
    }, y = [];
    this.displayed_.forEach((v, w) => {
      if (v && v.text && v.text.length) {
        try {
          v.text = v.text.trim();
        } catch {
          p(w);
        }
        v.text.length && y.push({
          // The text to be displayed in the caption from this specific row, with whitespace removed.
          text: v.text,
          // Value between 1 and 15 representing the PAC row used to calculate line height.
          line: w + 1,
          // A number representing the indent position by percentage (CEA-608 PAC indent code).
          // The value will be a number between 10 and 80. Offset is used to add an aditional
          // value to the position if necessary.
          position: 10 + Math.min(70, v.indent * 10) + v.offset * 2.5
        });
      } else v == null && p(w);
    }), y.length && this.trigger("data", {
      startPts: this.startPts_,
      endPts: d,
      content: y,
      stream: this.name_
    });
  }, Pt.prototype.reset = function() {
    this.mode_ = "popOn", this.topRow_ = 0, this.startPts_ = 0, this.displayed_ = hr(), this.nonDisplayed_ = hr(), this.lastControlCode_ = null, this.column_ = 0, this.row_ = ac, this.rollUpRows_ = 2, this.formatting_ = [];
  }, Pt.prototype.setConstants = function() {
    this.dataChannel_ === 0 ? (this.BASE_ = 16, this.EXT_ = 17, this.CONTROL_ = (20 | this.field_) << 8, this.OFFSET_ = 23) : this.dataChannel_ === 1 && (this.BASE_ = 24, this.EXT_ = 25, this.CONTROL_ = (28 | this.field_) << 8, this.OFFSET_ = 31), this.PADDING_ = 0, this.RESUME_CAPTION_LOADING_ = this.CONTROL_ | 32, this.END_OF_CAPTION_ = this.CONTROL_ | 47, this.ROLL_UP_2_ROWS_ = this.CONTROL_ | 37, this.ROLL_UP_3_ROWS_ = this.CONTROL_ | 38, this.ROLL_UP_4_ROWS_ = this.CONTROL_ | 39, this.CARRIAGE_RETURN_ = this.CONTROL_ | 45, this.RESUME_DIRECT_CAPTIONING_ = this.CONTROL_ | 41, this.BACKSPACE_ = this.CONTROL_ | 33, this.ERASE_DISPLAYED_MEMORY_ = this.CONTROL_ | 44, this.ERASE_NON_DISPLAYED_MEMORY_ = this.CONTROL_ | 46;
  }, Pt.prototype.isSpecialCharacter = function(d, p) {
    return d === this.EXT_ && p >= 48 && p <= 63;
  }, Pt.prototype.isExtCharacter = function(d, p) {
    return (d === this.EXT_ + 1 || d === this.EXT_ + 2) && p >= 32 && p <= 63;
  }, Pt.prototype.isMidRowCode = function(d, p) {
    return d === this.EXT_ && p >= 32 && p <= 47;
  }, Pt.prototype.isOffsetControlCode = function(d, p) {
    return d === this.OFFSET_ && p >= 33 && p <= 35;
  }, Pt.prototype.isPAC = function(d, p) {
    return d >= this.BASE_ && d < this.BASE_ + 8 && p >= 64 && p <= 127;
  }, Pt.prototype.isColorPAC = function(d) {
    return d >= 64 && d <= 79 || d >= 96 && d <= 127;
  }, Pt.prototype.isNormalChar = function(d) {
    return d >= 32 && d <= 127;
  }, Pt.prototype.setRollUp = function(d, p) {
    if (this.mode_ !== "rollUp" && (this.row_ = ac, this.mode_ = "rollUp", this.flushDisplayed(d), this.nonDisplayed_ = hr(), this.displayed_ = hr()), p !== void 0 && p !== this.row_)
      for (var y = 0; y < this.rollUpRows_; y++)
        this.displayed_[p - y] = this.displayed_[this.row_ - y], this.displayed_[this.row_ - y] = {
          text: "",
          indent: 0,
          offset: 0
        };
    p === void 0 && (p = this.row_), this.topRow_ = p - this.rollUpRows_ + 1;
  }, Pt.prototype.addFormatting = function(d, p) {
    this.formatting_ = this.formatting_.concat(p);
    var y = p.reduce(function(v, w) {
      return v + "<" + w + ">";
    }, "");
    this[this.mode_](d, y);
  }, Pt.prototype.clearFormatting = function(d) {
    if (this.formatting_.length) {
      var p = this.formatting_.reverse().reduce(function(y, v) {
        return y + "</" + v + ">";
      }, "");
      this.formatting_ = [], this[this.mode_](d, p);
    }
  }, Pt.prototype.popOn = function(d, p) {
    var y = this.nonDisplayed_[this.row_].text;
    y += p, this.nonDisplayed_[this.row_].text = y;
  }, Pt.prototype.rollUp = function(d, p) {
    var y = this.displayed_[this.row_].text;
    y += p, this.displayed_[this.row_].text = y;
  }, Pt.prototype.shiftRowsUp_ = function() {
    var d;
    for (d = 0; d < this.topRow_; d++)
      this.displayed_[d] = {
        text: "",
        indent: 0,
        offset: 0
      };
    for (d = this.row_ + 1; d < ac + 1; d++)
      this.displayed_[d] = {
        text: "",
        indent: 0,
        offset: 0
      };
    for (d = this.topRow_; d < this.row_; d++)
      this.displayed_[d] = this.displayed_[d + 1];
    this.displayed_[this.row_] = {
      text: "",
      indent: 0,
      offset: 0
    };
  }, Pt.prototype.paintOn = function(d, p) {
    var y = this.displayed_[this.row_].text;
    y += p, this.displayed_[this.row_].text = y;
  };
  var Np = {
    CaptionStream: Wn,
    Cea608Stream: Pt,
    Cea708Stream: kt
  }, ic = {
    H264_STREAM_TYPE: 27,
    ADTS_STREAM_TYPE: 15,
    METADATA_STREAM_TYPE: 21
  }, UT = n, HT = 8589934592, YT = 4294967296, $p = "shared", Rd = function(d, p) {
    var y = 1;
    for (d > p && (y = -1); Math.abs(p - d) > YT; )
      d += y * HT;
    return d;
  }, Nd = function(d) {
    var p, y;
    Nd.prototype.init.call(this), this.type_ = d || $p, this.push = function(v) {
      if (v.type === "metadata") {
        this.trigger("data", v);
        return;
      }
      this.type_ !== $p && v.type !== this.type_ || (y === void 0 && (y = v.dts), v.dts = Rd(v.dts, y), v.pts = Rd(v.pts, y), p = v.dts, this.trigger("data", v));
    }, this.flush = function() {
      y = p, this.trigger("done");
    }, this.endTimeline = function() {
      this.flush(), this.trigger("endedtimeline");
    }, this.discontinuity = function() {
      y = void 0, p = void 0;
    }, this.reset = function() {
      this.discontinuity(), this.trigger("reset");
    };
  };
  Nd.prototype = new UT();
  var Fp = {
    TimestampRolloverStream: Nd,
    handleRollover: Rd
  }, jT = (d, p, y) => {
    if (!d)
      return -1;
    for (var v = y; v < d.length; v++)
      if (d[v] === p)
        return v;
    return -1;
  }, VT = {
    typedArrayIndexOf: jT
  }, rc = VT.typedArrayIndexOf, sc = {
    // UTF-16BE encoded Unicode, without BOM, terminated with \0\0
    Utf8: 3
    // UTF-8 encoded Unicode, terminated with \0
  }, zp = function(d, p, y) {
    var v, w = "";
    for (v = p; v < y; v++)
      w += "%" + ("00" + d[v].toString(16)).slice(-2);
    return w;
  }, To = function(d, p, y) {
    return decodeURIComponent(zp(d, p, y));
  }, xo = function(d, p, y) {
    return unescape(zp(d, p, y));
  }, wo = function(d) {
    return d[0] << 21 | d[1] << 14 | d[2] << 7 | d[3];
  }, ko = {
    APIC: function(d) {
      var p = 1, y, v, w = "-->";
      d.data[0] === sc.Utf8 && (y = rc(d.data, 0, p), !(y < 0) && (d.mimeType = xo(d.data, p, y), p = y + 1, d.pictureType = d.data[p], p++, v = rc(d.data, 0, p), !(v < 0) && (d.description = To(d.data, p, v), p = v + 1, d.mimeType === w ? d.url = xo(d.data, p, d.data.length) : d.pictureData = d.data.subarray(p, d.data.length))));
    },
    "T*": function(d) {
      d.data[0] === sc.Utf8 && (d.value = To(d.data, 1, d.data.length).replace(/\0*$/, ""), d.values = d.value.split("\0"));
    },
    TXXX: function(d) {
      var p;
      d.data[0] === sc.Utf8 && (p = rc(d.data, 0, 1), p !== -1 && (d.description = To(d.data, 1, p), d.value = To(d.data, p + 1, d.data.length).replace(/\0*$/, ""), d.data = d.value));
    },
    "W*": function(d) {
      d.url = xo(d.data, 0, d.data.length).replace(/\0.*$/, "");
    },
    WXXX: function(d) {
      var p;
      d.data[0] === sc.Utf8 && (p = rc(d.data, 0, 1), p !== -1 && (d.description = To(d.data, 1, p), d.url = xo(d.data, p + 1, d.data.length).replace(/\0.*$/, "")));
    },
    PRIV: function(d) {
      var p;
      for (p = 0; p < d.data.length; p++)
        if (d.data[p] === 0) {
          d.owner = xo(d.data, 0, p);
          break;
        }
      d.privateData = d.data.subarray(p + 1), d.data = d.privateData;
    }
  }, qT = function(d) {
    var p, y, v = 10, w = 0, C = [];
    if (!(d.length < 10 || d[0] !== 73 || d[1] !== 68 || d[2] !== 51)) {
      w = wo(d.subarray(6, 10)), w += 10;
      var R = d[5] & 64;
      R && (v += 4, v += wo(d.subarray(10, 14)), w -= wo(d.subarray(16, 20)));
      do {
        if (p = wo(d.subarray(v + 4, v + 8)), p < 1)
          break;
        y = String.fromCharCode(d[v], d[v + 1], d[v + 2], d[v + 3]);
        var F = {
          id: y,
          data: d.subarray(v + 10, v + p + 10)
        };
        F.key = F.id, ko[F.id] ? ko[F.id](F) : F.id[0] === "T" ? ko["T*"](F) : F.id[0] === "W" && ko["W*"](F), C.push(F), v += 10, v += p;
      } while (v < w);
      return C;
    }
  }, Up = {
    parseId3Frames: qT,
    parseSyncSafeInteger: wo,
    frameParsers: ko
  }, WT = n, GT = ic, Bi = Up, oc;
  oc = function(d) {
    var p = {
      // the bytes of the program-level descriptor field in MP2T
      // see ISO/IEC 13818-1:2013 (E), section 2.6 "Program and
      // program element descriptors"
      descriptor: d && d.descriptor
    }, y = 0, v = [], w = 0, C;
    if (oc.prototype.init.call(this), this.dispatchType = GT.METADATA_STREAM_TYPE.toString(16), p.descriptor)
      for (C = 0; C < p.descriptor.length; C++)
        this.dispatchType += ("00" + p.descriptor[C].toString(16)).slice(-2);
    this.push = function(R) {
      var F, U, q, ae, pe, Fe;
      if (R.type === "timed-metadata") {
        if (R.dataAlignmentIndicator && (w = 0, v.length = 0), v.length === 0 && (R.data.length < 10 || R.data[0] !== 73 || R.data[1] !== 68 || R.data[2] !== 51)) {
          this.trigger("log", {
            level: "warn",
            message: "Skipping unrecognized metadata packet"
          });
          return;
        }
        if (v.push(R), w += R.data.byteLength, v.length === 1 && (y = Bi.parseSyncSafeInteger(R.data.subarray(6, 10)), y += 10), !(w < y)) {
          for (F = {
            data: new Uint8Array(y),
            frames: [],
            pts: v[0].pts,
            dts: v[0].dts
          }, pe = 0; pe < y; )
            F.data.set(v[0].data.subarray(0, y - pe), pe), pe += v[0].data.byteLength, w -= v[0].data.byteLength, v.shift();
          U = 10, F.data[5] & 64 && (U += 4, U += Bi.parseSyncSafeInteger(F.data.subarray(10, 14)), y -= Bi.parseSyncSafeInteger(F.data.subarray(16, 20)));
          do {
            if (q = Bi.parseSyncSafeInteger(F.data.subarray(U + 4, U + 8)), q < 1) {
              this.trigger("log", {
                level: "warn",
                message: "Malformed ID3 frame encountered. Skipping remaining metadata parsing."
              });
              break;
            }
            if (Fe = String.fromCharCode(F.data[U], F.data[U + 1], F.data[U + 2], F.data[U + 3]), ae = {
              id: Fe,
              data: F.data.subarray(U + 10, U + q + 10)
            }, ae.key = ae.id, Bi.frameParsers[ae.id] ? Bi.frameParsers[ae.id](ae) : ae.id[0] === "T" ? Bi.frameParsers["T*"](ae) : ae.id[0] === "W" && Bi.frameParsers["W*"](ae), ae.owner === "com.apple.streaming.transportStreamTimestamp") {
              var Se = ae.data, Ze = (Se[3] & 1) << 30 | Se[4] << 22 | Se[5] << 14 | Se[6] << 6 | Se[7] >>> 2;
              Ze *= 4, Ze += Se[7] & 3, ae.timeStamp = Ze, F.pts === void 0 && F.dts === void 0 && (F.pts = ae.timeStamp, F.dts = ae.timeStamp), this.trigger("timestamp", ae);
            }
            F.frames.push(ae), U += 10, U += q;
          } while (U < y);
          this.trigger("data", F);
        }
      }
    };
  }, oc.prototype = new WT();
  var XT = oc, $d = n, Fd = Np, Sa = ic, ZT = Fp.TimestampRolloverStream, lc, Co, cc, Xr = 188, zd = 71;
  lc = function() {
    var d = new Uint8Array(Xr), p = 0;
    lc.prototype.init.call(this), this.push = function(y) {
      var v = 0, w = Xr, C;
      for (p ? (C = new Uint8Array(y.byteLength + p), C.set(d.subarray(0, p)), C.set(y, p), p = 0) : C = y; w < C.byteLength; ) {
        if (C[v] === zd && C[w] === zd) {
          this.trigger("data", C.subarray(v, w)), v += Xr, w += Xr;
          continue;
        }
        v++, w++;
      }
      v < C.byteLength && (d.set(C.subarray(v), 0), p = C.byteLength - v);
    }, this.flush = function() {
      p === Xr && d[0] === zd && (this.trigger("data", d), p = 0), this.trigger("done");
    }, this.endTimeline = function() {
      this.flush(), this.trigger("endedtimeline");
    }, this.reset = function() {
      p = 0, this.trigger("reset");
    };
  }, lc.prototype = new $d(), Co = function() {
    var d, p, y, v;
    Co.prototype.init.call(this), v = this, this.packetsWaitingForPmt = [], this.programMapTable = void 0, d = function(w, C) {
      var R = 0;
      C.payloadUnitStartIndicator && (R += w[R] + 1), C.type === "pat" ? p(w.subarray(R), C) : y(w.subarray(R), C);
    }, p = function(w, C) {
      C.section_number = w[7], C.last_section_number = w[8], v.pmtPid = (w[10] & 31) << 8 | w[11], C.pmtPid = v.pmtPid;
    }, y = function(w, C) {
      var R, F, U, q;
      if (w[5] & 1) {
        for (v.programMapTable = {
          video: null,
          audio: null,
          "timed-metadata": {}
        }, R = (w[1] & 15) << 8 | w[2], F = 3 + R - 4, U = (w[10] & 15) << 8 | w[11], q = 12 + U; q < F; ) {
          var ae = w[q], pe = (w[q + 1] & 31) << 8 | w[q + 2];
          ae === Sa.H264_STREAM_TYPE && v.programMapTable.video === null ? v.programMapTable.video = pe : ae === Sa.ADTS_STREAM_TYPE && v.programMapTable.audio === null ? v.programMapTable.audio = pe : ae === Sa.METADATA_STREAM_TYPE && (v.programMapTable["timed-metadata"][pe] = ae), q += ((w[q + 3] & 15) << 8 | w[q + 4]) + 5;
        }
        C.programMapTable = v.programMapTable;
      }
    }, this.push = function(w) {
      var C = {}, R = 4;
      if (C.payloadUnitStartIndicator = !!(w[1] & 64), C.pid = w[1] & 31, C.pid <<= 8, C.pid |= w[2], (w[3] & 48) >>> 4 > 1 && (R += w[R] + 1), C.pid === 0)
        C.type = "pat", d(w.subarray(R), C), this.trigger("data", C);
      else if (C.pid === this.pmtPid)
        for (C.type = "pmt", d(w.subarray(R), C), this.trigger("data", C); this.packetsWaitingForPmt.length; )
          this.processPes_.apply(this, this.packetsWaitingForPmt.shift());
      else this.programMapTable === void 0 ? this.packetsWaitingForPmt.push([w, R, C]) : this.processPes_(w, R, C);
    }, this.processPes_ = function(w, C, R) {
      R.pid === this.programMapTable.video ? R.streamType = Sa.H264_STREAM_TYPE : R.pid === this.programMapTable.audio ? R.streamType = Sa.ADTS_STREAM_TYPE : R.streamType = this.programMapTable["timed-metadata"][R.pid], R.type = "pes", R.data = w.subarray(C), this.trigger("data", R);
    };
  }, Co.prototype = new $d(), Co.STREAM_TYPES = {
    h264: 27,
    adts: 15
  }, cc = function() {
    var d = this, p = !1, y = {
      data: [],
      size: 0
    }, v = {
      data: [],
      size: 0
    }, w = {
      data: [],
      size: 0
    }, C, R = function(U, q) {
      var ae;
      const pe = U[0] << 16 | U[1] << 8 | U[2];
      q.data = new Uint8Array(), pe === 1 && (q.packetLength = 6 + (U[4] << 8 | U[5]), q.dataAlignmentIndicator = (U[6] & 4) !== 0, ae = U[7], ae & 192 && (q.pts = (U[9] & 14) << 27 | (U[10] & 255) << 20 | (U[11] & 254) << 12 | (U[12] & 255) << 5 | (U[13] & 254) >>> 3, q.pts *= 4, q.pts += (U[13] & 6) >>> 1, q.dts = q.pts, ae & 64 && (q.dts = (U[14] & 14) << 27 | (U[15] & 255) << 20 | (U[16] & 254) << 12 | (U[17] & 255) << 5 | (U[18] & 254) >>> 3, q.dts *= 4, q.dts += (U[18] & 6) >>> 1)), q.data = U.subarray(9 + U[8]));
    }, F = function(U, q, ae) {
      var pe = new Uint8Array(U.size), Fe = {
        type: q
      }, Se = 0, Ze = 0, ot = !1, fn;
      if (!(!U.data.length || U.size < 9)) {
        for (Fe.trackId = U.data[0].pid, Se = 0; Se < U.data.length; Se++)
          fn = U.data[Se], pe.set(fn.data, Ze), Ze += fn.data.byteLength;
        R(pe, Fe), ot = q === "video" || Fe.packetLength <= U.size, (ae || ot) && (U.size = 0, U.data.length = 0), ot && d.trigger("data", Fe);
      }
    };
    cc.prototype.init.call(this), this.push = function(U) {
      ({
        pat: function() {
        },
        pes: function() {
          var q, ae;
          switch (U.streamType) {
            case Sa.H264_STREAM_TYPE:
              q = y, ae = "video";
              break;
            case Sa.ADTS_STREAM_TYPE:
              q = v, ae = "audio";
              break;
            case Sa.METADATA_STREAM_TYPE:
              q = w, ae = "timed-metadata";
              break;
            default:
              return;
          }
          U.payloadUnitStartIndicator && F(q, ae, !0), q.data.push(U), q.size += U.data.byteLength;
        },
        pmt: function() {
          var q = {
            type: "metadata",
            tracks: []
          };
          C = U.programMapTable, C.video !== null && q.tracks.push({
            timelineStartInfo: {
              baseMediaDecodeTime: 0
            },
            id: +C.video,
            codec: "avc",
            type: "video"
          }), C.audio !== null && q.tracks.push({
            timelineStartInfo: {
              baseMediaDecodeTime: 0
            },
            id: +C.audio,
            codec: "adts",
            type: "audio"
          }), p = !0, d.trigger("data", q);
        }
      })[U.type]();
    }, this.reset = function() {
      y.size = 0, y.data.length = 0, v.size = 0, v.data.length = 0, this.trigger("reset");
    }, this.flushStreams_ = function() {
      F(y, "video"), F(v, "audio"), F(w, "timed-metadata");
    }, this.flush = function() {
      if (!p && C) {
        var U = {
          type: "metadata",
          tracks: []
        };
        C.video !== null && U.tracks.push({
          timelineStartInfo: {
            baseMediaDecodeTime: 0
          },
          id: +C.video,
          codec: "avc",
          type: "video"
        }), C.audio !== null && U.tracks.push({
          timelineStartInfo: {
            baseMediaDecodeTime: 0
          },
          id: +C.audio,
          codec: "adts",
          type: "audio"
        }), d.trigger("data", U);
      }
      p = !1, this.flushStreams_(), this.trigger("done");
    };
  }, cc.prototype = new $d();
  var Hp = {
    PAT_PID: 0,
    MP2T_PACKET_LENGTH: Xr,
    TransportPacketStream: lc,
    TransportParseStream: Co,
    ElementaryStream: cc,
    TimestampRolloverStream: ZT,
    CaptionStream: Fd.CaptionStream,
    Cea608Stream: Fd.Cea608Stream,
    Cea708Stream: Fd.Cea708Stream,
    MetadataStream: XT
  };
  for (var Ud in Sa)
    Sa.hasOwnProperty(Ud) && (Hp[Ud] = Sa[Ud]);
  var KT = Hp, QT = n, JT = bt.ONE_SECOND_IN_TS, uc, Yp = [96e3, 88200, 64e3, 48e3, 44100, 32e3, 24e3, 22050, 16e3, 12e3, 11025, 8e3, 7350];
  uc = function(d) {
    var p, y = 0;
    uc.prototype.init.call(this), this.skipWarn_ = function(v, w) {
      this.trigger("log", {
        level: "warn",
        message: `adts skiping bytes ${v} to ${w} in frame ${y} outside syncword`
      });
    }, this.push = function(v) {
      var w = 0, C, R, F, U, q;
      if (d || (y = 0), v.type === "audio") {
        p && p.length ? (F = p, p = new Uint8Array(F.byteLength + v.data.byteLength), p.set(F), p.set(v.data, F.byteLength)) : p = v.data;
        for (var ae; w + 7 < p.length; ) {
          if (p[w] !== 255 || (p[w + 1] & 246) !== 240) {
            typeof ae != "number" && (ae = w), w++;
            continue;
          }
          if (typeof ae == "number" && (this.skipWarn_(ae, w), ae = null), R = (~p[w + 1] & 1) * 2, C = (p[w + 3] & 3) << 11 | p[w + 4] << 3 | (p[w + 5] & 224) >> 5, U = ((p[w + 6] & 3) + 1) * 1024, q = U * JT / Yp[(p[w + 2] & 60) >>> 2], p.byteLength - w < C)
            break;
          this.trigger("data", {
            pts: v.pts + y * q,
            dts: v.dts + y * q,
            sampleCount: U,
            audioobjecttype: (p[w + 2] >>> 6 & 3) + 1,
            channelcount: (p[w + 2] & 1) << 2 | (p[w + 3] & 192) >>> 6,
            samplerate: Yp[(p[w + 2] & 60) >>> 2],
            samplingfrequencyindex: (p[w + 2] & 60) >>> 2,
            // assume ISO/IEC 14496-12 AudioSampleEntry default of 16
            samplesize: 16,
            // data is the frame without it's header
            data: p.subarray(w + 7 + R, w + C)
          }), y++, w += C;
        }
        typeof ae == "number" && (this.skipWarn_(ae, w), ae = null), p = p.subarray(w);
      }
    }, this.flush = function() {
      y = 0, this.trigger("done");
    }, this.reset = function() {
      p = void 0, this.trigger("reset");
    }, this.endTimeline = function() {
      p = void 0, this.trigger("endedtimeline");
    };
  }, uc.prototype = new QT();
  var ex = uc, jp;
  jp = function(d) {
    var p = d.byteLength, y = 0, v = 0;
    this.length = function() {
      return 8 * p;
    }, this.bitsAvailable = function() {
      return 8 * p + v;
    }, this.loadWord = function() {
      var w = d.byteLength - p, C = new Uint8Array(4), R = Math.min(4, p);
      if (R === 0)
        throw new Error("no bytes available");
      C.set(d.subarray(w, w + R)), y = new DataView(C.buffer).getUint32(0), v = R * 8, p -= R;
    }, this.skipBits = function(w) {
      var C;
      v > w ? (y <<= w, v -= w) : (w -= v, C = Math.floor(w / 8), w -= C * 8, p -= C, this.loadWord(), y <<= w, v -= w);
    }, this.readBits = function(w) {
      var C = Math.min(v, w), R = y >>> 32 - C;
      return v -= C, v > 0 ? y <<= C : p > 0 && this.loadWord(), C = w - C, C > 0 ? R << C | this.readBits(C) : R;
    }, this.skipLeadingZeros = function() {
      var w;
      for (w = 0; w < v; ++w)
        if (y & 2147483648 >>> w)
          return y <<= w, v -= w, w;
      return this.loadWord(), w + this.skipLeadingZeros();
    }, this.skipUnsignedExpGolomb = function() {
      this.skipBits(1 + this.skipLeadingZeros());
    }, this.skipExpGolomb = function() {
      this.skipBits(1 + this.skipLeadingZeros());
    }, this.readUnsignedExpGolomb = function() {
      var w = this.skipLeadingZeros();
      return this.readBits(w + 1) - 1;
    }, this.readExpGolomb = function() {
      var w = this.readUnsignedExpGolomb();
      return 1 & w ? 1 + w >>> 1 : -1 * (w >>> 1);
    }, this.readBoolean = function() {
      return this.readBits(1) === 1;
    }, this.readUnsignedByte = function() {
      return this.readBits(8);
    }, this.loadWord();
  };
  var tx = jp, Vp = n, nx = tx, dc, hc, qp;
  hc = function() {
    var d = 0, p, y;
    hc.prototype.init.call(this), this.push = function(v) {
      var w;
      y ? (w = new Uint8Array(y.byteLength + v.data.byteLength), w.set(y), w.set(v.data, y.byteLength), y = w) : y = v.data;
      for (var C = y.byteLength; d < C - 3; d++)
        if (y[d + 2] === 1) {
          p = d + 5;
          break;
        }
      for (; p < C; )
        switch (y[p]) {
          case 0:
            if (y[p - 1] !== 0) {
              p += 2;
              break;
            } else if (y[p - 2] !== 0) {
              p++;
              break;
            }
            d + 3 !== p - 2 && this.trigger("data", y.subarray(d + 3, p - 2));
            do
              p++;
            while (y[p] !== 1 && p < C);
            d = p - 2, p += 3;
            break;
          case 1:
            if (y[p - 1] !== 0 || y[p - 2] !== 0) {
              p += 3;
              break;
            }
            this.trigger("data", y.subarray(d + 3, p - 2)), d = p - 2, p += 3;
            break;
          default:
            p += 3;
            break;
        }
      y = y.subarray(d), p -= d, d = 0;
    }, this.reset = function() {
      y = null, d = 0, this.trigger("reset");
    }, this.flush = function() {
      y && y.byteLength > 3 && this.trigger("data", y.subarray(d + 3)), y = null, d = 0, this.trigger("done");
    }, this.endTimeline = function() {
      this.flush(), this.trigger("endedtimeline");
    };
  }, hc.prototype = new Vp(), qp = {
    100: !0,
    110: !0,
    122: !0,
    244: !0,
    44: !0,
    83: !0,
    86: !0,
    118: !0,
    128: !0,
    // TODO: the three profiles below don't
    // appear to have sps data in the specificiation anymore?
    138: !0,
    139: !0,
    134: !0
  }, dc = function() {
    var d = new hc(), p, y, v, w, C, R, F;
    dc.prototype.init.call(this), p = this, this.push = function(U) {
      U.type === "video" && (y = U.trackId, v = U.pts, w = U.dts, d.push(U));
    }, d.on("data", function(U) {
      var q = {
        trackId: y,
        pts: v,
        dts: w,
        data: U,
        nalUnitTypeCode: U[0] & 31
      };
      switch (q.nalUnitTypeCode) {
        case 5:
          q.nalUnitType = "slice_layer_without_partitioning_rbsp_idr";
          break;
        case 6:
          q.nalUnitType = "sei_rbsp", q.escapedRBSP = C(U.subarray(1));
          break;
        case 7:
          q.nalUnitType = "seq_parameter_set_rbsp", q.escapedRBSP = C(U.subarray(1)), q.config = R(q.escapedRBSP);
          break;
        case 8:
          q.nalUnitType = "pic_parameter_set_rbsp";
          break;
        case 9:
          q.nalUnitType = "access_unit_delimiter_rbsp";
          break;
      }
      p.trigger("data", q);
    }), d.on("done", function() {
      p.trigger("done");
    }), d.on("partialdone", function() {
      p.trigger("partialdone");
    }), d.on("reset", function() {
      p.trigger("reset");
    }), d.on("endedtimeline", function() {
      p.trigger("endedtimeline");
    }), this.flush = function() {
      d.flush();
    }, this.partialFlush = function() {
      d.partialFlush();
    }, this.reset = function() {
      d.reset();
    }, this.endTimeline = function() {
      d.endTimeline();
    }, F = function(U, q) {
      var ae = 8, pe = 8, Fe, Se;
      for (Fe = 0; Fe < U; Fe++)
        pe !== 0 && (Se = q.readExpGolomb(), pe = (ae + Se + 256) % 256), ae = pe === 0 ? ae : pe;
    }, C = function(U) {
      for (var q = U.byteLength, ae = [], pe = 1, Fe, Se; pe < q - 2; )
        U[pe] === 0 && U[pe + 1] === 0 && U[pe + 2] === 3 ? (ae.push(pe + 2), pe += 2) : pe++;
      if (ae.length === 0)
        return U;
      Fe = q - ae.length, Se = new Uint8Array(Fe);
      var Ze = 0;
      for (pe = 0; pe < Fe; Ze++, pe++)
        Ze === ae[0] && (Ze++, ae.shift()), Se[pe] = U[Ze];
      return Se;
    }, R = function(U) {
      var q = 0, ae = 0, pe = 0, Fe = 0, Se, Ze, ot, fn, ia, Ni, Mo, Oo, Po, Bo, kc, Lt = [1, 1], Ro, Ea;
      if (Se = new nx(U), Ze = Se.readUnsignedByte(), fn = Se.readUnsignedByte(), ot = Se.readUnsignedByte(), Se.skipUnsignedExpGolomb(), qp[Ze] && (ia = Se.readUnsignedExpGolomb(), ia === 3 && Se.skipBits(1), Se.skipUnsignedExpGolomb(), Se.skipUnsignedExpGolomb(), Se.skipBits(1), Se.readBoolean()))
        for (kc = ia !== 3 ? 8 : 12, Ea = 0; Ea < kc; Ea++)
          Se.readBoolean() && (Ea < 6 ? F(16, Se) : F(64, Se));
      if (Se.skipUnsignedExpGolomb(), Ni = Se.readUnsignedExpGolomb(), Ni === 0)
        Se.readUnsignedExpGolomb();
      else if (Ni === 1)
        for (Se.skipBits(1), Se.skipExpGolomb(), Se.skipExpGolomb(), Mo = Se.readUnsignedExpGolomb(), Ea = 0; Ea < Mo; Ea++)
          Se.skipExpGolomb();
      if (Se.skipUnsignedExpGolomb(), Se.skipBits(1), Oo = Se.readUnsignedExpGolomb(), Po = Se.readUnsignedExpGolomb(), Bo = Se.readBits(1), Bo === 0 && Se.skipBits(1), Se.skipBits(1), Se.readBoolean() && (q = Se.readUnsignedExpGolomb(), ae = Se.readUnsignedExpGolomb(), pe = Se.readUnsignedExpGolomb(), Fe = Se.readUnsignedExpGolomb()), Se.readBoolean() && Se.readBoolean()) {
        switch (Ro = Se.readUnsignedByte(), Ro) {
          case 1:
            Lt = [1, 1];
            break;
          case 2:
            Lt = [12, 11];
            break;
          case 3:
            Lt = [10, 11];
            break;
          case 4:
            Lt = [16, 11];
            break;
          case 5:
            Lt = [40, 33];
            break;
          case 6:
            Lt = [24, 11];
            break;
          case 7:
            Lt = [20, 11];
            break;
          case 8:
            Lt = [32, 11];
            break;
          case 9:
            Lt = [80, 33];
            break;
          case 10:
            Lt = [18, 11];
            break;
          case 11:
            Lt = [15, 11];
            break;
          case 12:
            Lt = [64, 33];
            break;
          case 13:
            Lt = [160, 99];
            break;
          case 14:
            Lt = [4, 3];
            break;
          case 15:
            Lt = [3, 2];
            break;
          case 16:
            Lt = [2, 1];
            break;
          case 255: {
            Lt = [Se.readUnsignedByte() << 8 | Se.readUnsignedByte(), Se.readUnsignedByte() << 8 | Se.readUnsignedByte()];
            break;
          }
        }
        Lt && Lt[0] / Lt[1];
      }
      return {
        profileIdc: Ze,
        levelIdc: ot,
        profileCompatibility: fn,
        width: (Oo + 1) * 16 - q * 2 - ae * 2,
        height: (2 - Bo) * (Po + 1) * 16 - pe * 2 - Fe * 2,
        // sar is sample aspect ratio
        sarRatio: Lt
      };
    };
  }, dc.prototype = new Vp();
  var ax = {
    H264Stream: dc
  }, ix = [96e3, 88200, 64e3, 48e3, 44100, 32e3, 24e3, 22050, 16e3, 12e3, 11025, 8e3, 7350], Wp = function(d, p) {
    var y = d[p + 6] << 21 | d[p + 7] << 14 | d[p + 8] << 7 | d[p + 9], v = d[p + 5], w = (v & 16) >> 4;
    return y = y >= 0 ? y : 0, w ? y + 20 : y + 10;
  }, Gp = function(d, p) {
    return d.length - p < 10 || d[p] !== 73 || d[p + 1] !== 68 || d[p + 2] !== 51 ? p : (p += Wp(d, p), Gp(d, p));
  }, rx = function(d) {
    var p = Gp(d, 0);
    return d.length >= p + 2 && (d[p] & 255) === 255 && (d[p + 1] & 240) === 240 && // verify that the 2 layer bits are 0, aka this
    // is not mp3 data but aac data.
    (d[p + 1] & 22) === 16;
  }, Xp = function(d) {
    return d[0] << 21 | d[1] << 14 | d[2] << 7 | d[3];
  }, sx = function(d, p, y) {
    var v, w = "";
    for (v = p; v < y; v++)
      w += "%" + ("00" + d[v].toString(16)).slice(-2);
    return w;
  }, ox = function(d, p, y) {
    return unescape(sx(d, p, y));
  }, lx = function(d, p) {
    var y = (d[p + 5] & 224) >> 5, v = d[p + 4] << 3, w = d[p + 3] & 6144;
    return w | v | y;
  }, cx = function(d, p) {
    return d[p] === 73 && d[p + 1] === 68 && d[p + 2] === 51 ? "timed-metadata" : d[p] & !0 && (d[p + 1] & 240) === 240 ? "audio" : null;
  }, ux = function(d) {
    for (var p = 0; p + 5 < d.length; ) {
      if (d[p] !== 255 || (d[p + 1] & 246) !== 240) {
        p++;
        continue;
      }
      return ix[(d[p + 2] & 60) >>> 2];
    }
    return null;
  }, dx = function(d) {
    var p, y, v, w;
    p = 10, d[5] & 64 && (p += 4, p += Xp(d.subarray(10, 14)));
    do {
      if (y = Xp(d.subarray(p + 4, p + 8)), y < 1)
        return null;
      if (w = String.fromCharCode(d[p], d[p + 1], d[p + 2], d[p + 3]), w === "PRIV") {
        v = d.subarray(p + 10, p + y + 10);
        for (var C = 0; C < v.byteLength; C++)
          if (v[C] === 0) {
            var R = ox(v, 0, C);
            if (R === "com.apple.streaming.transportStreamTimestamp") {
              var F = v.subarray(C + 1), U = (F[3] & 1) << 30 | F[4] << 22 | F[5] << 14 | F[6] << 6 | F[7] >>> 2;
              return U *= 4, U += F[7] & 3, U;
            }
            break;
          }
      }
      p += 10, p += y;
    } while (p < d.byteLength);
    return null;
  }, Hd = {
    isLikelyAacData: rx,
    parseId3TagSize: Wp,
    parseAdtsSize: lx,
    parseType: cx,
    parseSampleRate: ux,
    parseAacTimestamp: dx
  }, hx = n, Zp = Hd, fc;
  fc = function() {
    var d = new Uint8Array(), p = 0;
    fc.prototype.init.call(this), this.setTimestamp = function(y) {
      p = y;
    }, this.push = function(y) {
      var v = 0, w = 0, C, R, F, U;
      for (d.length ? (U = d.length, d = new Uint8Array(y.byteLength + U), d.set(d.subarray(0, U)), d.set(y, U)) : d = y; d.length - w >= 3; ) {
        if (d[w] === 73 && d[w + 1] === 68 && d[w + 2] === 51) {
          if (d.length - w < 10 || (v = Zp.parseId3TagSize(d, w), w + v > d.length))
            break;
          R = {
            type: "timed-metadata",
            data: d.subarray(w, w + v)
          }, this.trigger("data", R), w += v;
          continue;
        } else if ((d[w] & 255) === 255 && (d[w + 1] & 240) === 240) {
          if (d.length - w < 7 || (v = Zp.parseAdtsSize(d, w), w + v > d.length))
            break;
          F = {
            type: "audio",
            data: d.subarray(w, w + v),
            pts: p,
            dts: p
          }, this.trigger("data", F), w += v;
          continue;
        }
        w++;
      }
      C = d.length - w, C > 0 ? d = d.subarray(w) : d = new Uint8Array();
    }, this.reset = function() {
      d = new Uint8Array(), this.trigger("reset");
    }, this.endTimeline = function() {
      d = new Uint8Array(), this.trigger("endedtimeline");
    };
  }, fc.prototype = new hx();
  var fx = fc, px = ["audioobjecttype", "channelcount", "samplerate", "samplingfrequencyindex", "samplesize"], mx = px, gx = ["width", "height", "profileIdc", "levelIdc", "profileCompatibility", "sarRatio"], bx = gx, pc = n, So = ee, Ao = nt, mc = Be, Aa = Gr, fi = KT, gc = bt, Kp = ex, vx = ax.H264Stream, yx = fx, _x = Hd.isLikelyAacData, Tx = bt.ONE_SECOND_IN_TS, Qp = mx, Jp = bx, bc, Eo, vc, fr, xx = function(d, p) {
    p.stream = d, this.trigger("log", p);
  }, em = function(d, p) {
    for (var y = Object.keys(p), v = 0; v < y.length; v++) {
      var w = y[v];
      w === "headOfPipeline" || !p[w].on || p[w].on("log", xx.bind(d, w));
    }
  }, tm = function(d, p) {
    var y;
    if (d.length !== p.length)
      return !1;
    for (y = 0; y < d.length; y++)
      if (d[y] !== p[y])
        return !1;
    return !0;
  }, nm = function(d, p, y, v, w, C) {
    var R = y - p, F = v - p, U = w - y;
    return {
      start: {
        dts: d,
        pts: d + R
      },
      end: {
        dts: d + F,
        pts: d + U
      },
      prependedContentDuration: C,
      baseMediaDecodeTime: d
    };
  };
  Eo = function(d, p) {
    var y = [], v, w = 0, C = 0, R = 1 / 0;
    p = p || {}, v = p.firstSequenceNumber || 0, Eo.prototype.init.call(this), this.push = function(F) {
      Aa.collectDtsInfo(d, F), d && Qp.forEach(function(U) {
        d[U] = F[U];
      }), y.push(F);
    }, this.setEarliestDts = function(F) {
      w = F;
    }, this.setVideoBaseMediaDecodeTime = function(F) {
      R = F;
    }, this.setAudioAppendStart = function(F) {
      C = F;
    }, this.flush = function() {
      var F, U, q, ae, pe, Fe, Se;
      if (y.length === 0) {
        this.trigger("done", "AudioSegmentStream");
        return;
      }
      F = mc.trimAdtsFramesByEarliestDts(y, d, w), d.baseMediaDecodeTime = Aa.calculateTrackBaseMediaDecodeTime(d, p.keepOriginalTimestamps), Se = mc.prefixWithSilence(d, F, C, R), d.samples = mc.generateSampleTable(F), q = So.mdat(mc.concatenateFrameData(F)), y = [], U = So.moof(v, [d]), ae = new Uint8Array(U.byteLength + q.byteLength), v++, ae.set(U), ae.set(q, U.byteLength), Aa.clearDtsInfo(d), pe = Math.ceil(Tx * 1024 / d.samplerate), F.length && (Fe = F.length * pe, this.trigger("segmentTimingInfo", nm(
        // The audio track's baseMediaDecodeTime is in audio clock cycles, but the
        // frame info is in video clock cycles. Convert to match expectation of
        // listeners (that all timestamps will be based on video clock cycles).
        gc.audioTsToVideoTs(d.baseMediaDecodeTime, d.samplerate),
        // frame times are already in video clock, as is segment duration
        F[0].dts,
        F[0].pts,
        F[0].dts + Fe,
        F[0].pts + Fe,
        Se || 0
      )), this.trigger("timingInfo", {
        start: F[0].pts,
        end: F[0].pts + Fe
      })), this.trigger("data", {
        track: d,
        boxes: ae
      }), this.trigger("done", "AudioSegmentStream");
    }, this.reset = function() {
      Aa.clearDtsInfo(d), y = [], this.trigger("reset");
    };
  }, Eo.prototype = new pc(), bc = function(d, p) {
    var y, v = [], w = [], C, R;
    p = p || {}, y = p.firstSequenceNumber || 0, bc.prototype.init.call(this), delete d.minPTS, this.gopCache_ = [], this.push = function(F) {
      Aa.collectDtsInfo(d, F), F.nalUnitType === "seq_parameter_set_rbsp" && !C && (C = F.config, d.sps = [F.data], Jp.forEach(function(U) {
        d[U] = C[U];
      }, this)), F.nalUnitType === "pic_parameter_set_rbsp" && !R && (R = F.data, d.pps = [F.data]), v.push(F);
    }, this.flush = function() {
      for (var F, U, q, ae, pe, Fe, Se = 0, Ze, ot; v.length && v[0].nalUnitType !== "access_unit_delimiter_rbsp"; )
        v.shift();
      if (v.length === 0) {
        this.resetStream_(), this.trigger("done", "VideoSegmentStream");
        return;
      }
      if (F = Ao.groupNalsIntoFrames(v), q = Ao.groupFramesIntoGops(F), q[0][0].keyFrame || (U = this.getGopForFusion_(v[0], d), U ? (Se = U.duration, q.unshift(U), q.byteLength += U.byteLength, q.nalCount += U.nalCount, q.pts = U.pts, q.dts = U.dts, q.duration += U.duration) : q = Ao.extendFirstKeyFrame(q)), w.length) {
        var fn;
        if (p.alignGopsAtEnd ? fn = this.alignGopsAtEnd_(q) : fn = this.alignGopsAtStart_(q), !fn) {
          this.gopCache_.unshift({
            gop: q.pop(),
            pps: d.pps,
            sps: d.sps
          }), this.gopCache_.length = Math.min(6, this.gopCache_.length), v = [], this.resetStream_(), this.trigger("done", "VideoSegmentStream");
          return;
        }
        Aa.clearDtsInfo(d), q = fn;
      }
      Aa.collectDtsInfo(d, q), d.samples = Ao.generateSampleTable(q), pe = So.mdat(Ao.concatenateNalData(q)), d.baseMediaDecodeTime = Aa.calculateTrackBaseMediaDecodeTime(d, p.keepOriginalTimestamps), this.trigger("processedGopsInfo", q.map(function(ia) {
        return {
          pts: ia.pts,
          dts: ia.dts,
          byteLength: ia.byteLength
        };
      })), Ze = q[0], ot = q[q.length - 1], this.trigger("segmentTimingInfo", nm(d.baseMediaDecodeTime, Ze.dts, Ze.pts, ot.dts + ot.duration, ot.pts + ot.duration, Se)), this.trigger("timingInfo", {
        start: q[0].pts,
        end: q[q.length - 1].pts + q[q.length - 1].duration
      }), this.gopCache_.unshift({
        gop: q.pop(),
        pps: d.pps,
        sps: d.sps
      }), this.gopCache_.length = Math.min(6, this.gopCache_.length), v = [], this.trigger("baseMediaDecodeTime", d.baseMediaDecodeTime), this.trigger("timelineStartInfo", d.timelineStartInfo), ae = So.moof(y, [d]), Fe = new Uint8Array(ae.byteLength + pe.byteLength), y++, Fe.set(ae), Fe.set(pe, ae.byteLength), this.trigger("data", {
        track: d,
        boxes: Fe
      }), this.resetStream_(), this.trigger("done", "VideoSegmentStream");
    }, this.reset = function() {
      this.resetStream_(), v = [], this.gopCache_.length = 0, w.length = 0, this.trigger("reset");
    }, this.resetStream_ = function() {
      Aa.clearDtsInfo(d), C = void 0, R = void 0;
    }, this.getGopForFusion_ = function(F) {
      var U = 45e3, q = 1 / 0, ae, pe, Fe, Se, Ze;
      for (Ze = 0; Ze < this.gopCache_.length; Ze++)
        Se = this.gopCache_[Ze], Fe = Se.gop, !(!(d.pps && tm(d.pps[0], Se.pps[0])) || !(d.sps && tm(d.sps[0], Se.sps[0]))) && (Fe.dts < d.timelineStartInfo.dts || (ae = F.dts - Fe.dts - Fe.duration, ae >= -1e4 && ae <= U && (!pe || q > ae) && (pe = Se, q = ae)));
      return pe ? pe.gop : null;
    }, this.alignGopsAtStart_ = function(F) {
      var U, q, ae, pe, Fe, Se, Ze, ot;
      for (Fe = F.byteLength, Se = F.nalCount, Ze = F.duration, U = q = 0; U < w.length && q < F.length && (ae = w[U], pe = F[q], ae.pts !== pe.pts); ) {
        if (pe.pts > ae.pts) {
          U++;
          continue;
        }
        q++, Fe -= pe.byteLength, Se -= pe.nalCount, Ze -= pe.duration;
      }
      return q === 0 ? F : q === F.length ? null : (ot = F.slice(q), ot.byteLength = Fe, ot.duration = Ze, ot.nalCount = Se, ot.pts = ot[0].pts, ot.dts = ot[0].dts, ot);
    }, this.alignGopsAtEnd_ = function(F) {
      var U, q, ae, pe, Fe, Se;
      for (U = w.length - 1, q = F.length - 1, Fe = null, Se = !1; U >= 0 && q >= 0; ) {
        if (ae = w[U], pe = F[q], ae.pts === pe.pts) {
          Se = !0;
          break;
        }
        if (ae.pts > pe.pts) {
          U--;
          continue;
        }
        U === w.length - 1 && (Fe = q), q--;
      }
      if (!Se && Fe === null)
        return null;
      var Ze;
      if (Se ? Ze = q : Ze = Fe, Ze === 0)
        return F;
      var ot = F.slice(Ze), fn = ot.reduce(function(ia, Ni) {
        return ia.byteLength += Ni.byteLength, ia.duration += Ni.duration, ia.nalCount += Ni.nalCount, ia;
      }, {
        byteLength: 0,
        duration: 0,
        nalCount: 0
      });
      return ot.byteLength = fn.byteLength, ot.duration = fn.duration, ot.nalCount = fn.nalCount, ot.pts = ot[0].pts, ot.dts = ot[0].dts, ot;
    }, this.alignGopsWith = function(F) {
      w = F;
    };
  }, bc.prototype = new pc(), fr = function(d, p) {
    this.numberOfTracks = 0, this.metadataStream = p, d = d || {}, typeof d.remux < "u" ? this.remuxTracks = !!d.remux : this.remuxTracks = !0, typeof d.keepOriginalTimestamps == "boolean" ? this.keepOriginalTimestamps = d.keepOriginalTimestamps : this.keepOriginalTimestamps = !1, this.pendingTracks = [], this.videoTrack = null, this.pendingBoxes = [], this.pendingCaptions = [], this.pendingMetadata = [], this.pendingBytes = 0, this.emittedTracks = 0, fr.prototype.init.call(this), this.push = function(y) {
      if (y.content || y.text)
        return this.pendingCaptions.push(y);
      if (y.frames)
        return this.pendingMetadata.push(y);
      this.pendingTracks.push(y.track), this.pendingBytes += y.boxes.byteLength, y.track.type === "video" && (this.videoTrack = y.track, this.pendingBoxes.push(y.boxes)), y.track.type === "audio" && (this.audioTrack = y.track, this.pendingBoxes.unshift(y.boxes));
    };
  }, fr.prototype = new pc(), fr.prototype.flush = function(d) {
    var p = 0, y = {
      captions: [],
      captionStreams: {},
      metadata: [],
      info: {}
    }, v, w, C, R = 0, F;
    if (this.pendingTracks.length < this.numberOfTracks) {
      if (d !== "VideoSegmentStream" && d !== "AudioSegmentStream")
        return;
      if (this.remuxTracks)
        return;
      if (this.pendingTracks.length === 0) {
        this.emittedTracks++, this.emittedTracks >= this.numberOfTracks && (this.trigger("done"), this.emittedTracks = 0);
        return;
      }
    }
    if (this.videoTrack ? (R = this.videoTrack.timelineStartInfo.pts, Jp.forEach(function(U) {
      y.info[U] = this.videoTrack[U];
    }, this)) : this.audioTrack && (R = this.audioTrack.timelineStartInfo.pts, Qp.forEach(function(U) {
      y.info[U] = this.audioTrack[U];
    }, this)), this.videoTrack || this.audioTrack) {
      for (this.pendingTracks.length === 1 ? y.type = this.pendingTracks[0].type : y.type = "combined", this.emittedTracks += this.pendingTracks.length, C = So.initSegment(this.pendingTracks), y.initSegment = new Uint8Array(C.byteLength), y.initSegment.set(C), y.data = new Uint8Array(this.pendingBytes), F = 0; F < this.pendingBoxes.length; F++)
        y.data.set(this.pendingBoxes[F], p), p += this.pendingBoxes[F].byteLength;
      for (F = 0; F < this.pendingCaptions.length; F++)
        v = this.pendingCaptions[F], v.startTime = gc.metadataTsToSeconds(v.startPts, R, this.keepOriginalTimestamps), v.endTime = gc.metadataTsToSeconds(v.endPts, R, this.keepOriginalTimestamps), y.captionStreams[v.stream] = !0, y.captions.push(v);
      for (F = 0; F < this.pendingMetadata.length; F++)
        w = this.pendingMetadata[F], w.cueTime = gc.metadataTsToSeconds(w.pts, R, this.keepOriginalTimestamps), y.metadata.push(w);
      for (y.metadata.dispatchType = this.metadataStream.dispatchType, this.pendingTracks.length = 0, this.videoTrack = null, this.pendingBoxes.length = 0, this.pendingCaptions.length = 0, this.pendingBytes = 0, this.pendingMetadata.length = 0, this.trigger("data", y), F = 0; F < y.captions.length; F++)
        v = y.captions[F], this.trigger("caption", v);
      for (F = 0; F < y.metadata.length; F++)
        w = y.metadata[F], this.trigger("id3Frame", w);
    }
    this.emittedTracks >= this.numberOfTracks && (this.trigger("done"), this.emittedTracks = 0);
  }, fr.prototype.setRemux = function(d) {
    this.remuxTracks = d;
  }, vc = function(d) {
    var p = this, y = !0, v, w;
    vc.prototype.init.call(this), d = d || {}, this.baseMediaDecodeTime = d.baseMediaDecodeTime || 0, this.transmuxPipeline_ = {}, this.setupAacPipeline = function() {
      var C = {};
      this.transmuxPipeline_ = C, C.type = "aac", C.metadataStream = new fi.MetadataStream(), C.aacStream = new yx(), C.audioTimestampRolloverStream = new fi.TimestampRolloverStream("audio"), C.timedMetadataTimestampRolloverStream = new fi.TimestampRolloverStream("timed-metadata"), C.adtsStream = new Kp(), C.coalesceStream = new fr(d, C.metadataStream), C.headOfPipeline = C.aacStream, C.aacStream.pipe(C.audioTimestampRolloverStream).pipe(C.adtsStream), C.aacStream.pipe(C.timedMetadataTimestampRolloverStream).pipe(C.metadataStream).pipe(C.coalesceStream), C.metadataStream.on("timestamp", function(R) {
        C.aacStream.setTimestamp(R.timeStamp);
      }), C.aacStream.on("data", function(R) {
        R.type !== "timed-metadata" && R.type !== "audio" || C.audioSegmentStream || (w = w || {
          timelineStartInfo: {
            baseMediaDecodeTime: p.baseMediaDecodeTime
          },
          codec: "adts",
          type: "audio"
        }, C.coalesceStream.numberOfTracks++, C.audioSegmentStream = new Eo(w, d), C.audioSegmentStream.on("log", p.getLogTrigger_("audioSegmentStream")), C.audioSegmentStream.on("timingInfo", p.trigger.bind(p, "audioTimingInfo")), C.adtsStream.pipe(C.audioSegmentStream).pipe(C.coalesceStream), p.trigger("trackinfo", {
          hasAudio: !!w,
          hasVideo: !!v
        }));
      }), C.coalesceStream.on("data", this.trigger.bind(this, "data")), C.coalesceStream.on("done", this.trigger.bind(this, "done")), em(this, C);
    }, this.setupTsPipeline = function() {
      var C = {};
      this.transmuxPipeline_ = C, C.type = "ts", C.metadataStream = new fi.MetadataStream(), C.packetStream = new fi.TransportPacketStream(), C.parseStream = new fi.TransportParseStream(), C.elementaryStream = new fi.ElementaryStream(), C.timestampRolloverStream = new fi.TimestampRolloverStream(), C.adtsStream = new Kp(), C.h264Stream = new vx(), C.captionStream = new fi.CaptionStream(d), C.coalesceStream = new fr(d, C.metadataStream), C.headOfPipeline = C.packetStream, C.packetStream.pipe(C.parseStream).pipe(C.elementaryStream).pipe(C.timestampRolloverStream), C.timestampRolloverStream.pipe(C.h264Stream), C.timestampRolloverStream.pipe(C.adtsStream), C.timestampRolloverStream.pipe(C.metadataStream).pipe(C.coalesceStream), C.h264Stream.pipe(C.captionStream).pipe(C.coalesceStream), C.elementaryStream.on("data", function(R) {
        var F;
        if (R.type === "metadata") {
          for (F = R.tracks.length; F--; )
            !v && R.tracks[F].type === "video" ? (v = R.tracks[F], v.timelineStartInfo.baseMediaDecodeTime = p.baseMediaDecodeTime) : !w && R.tracks[F].type === "audio" && (w = R.tracks[F], w.timelineStartInfo.baseMediaDecodeTime = p.baseMediaDecodeTime);
          v && !C.videoSegmentStream && (C.coalesceStream.numberOfTracks++, C.videoSegmentStream = new bc(v, d), C.videoSegmentStream.on("log", p.getLogTrigger_("videoSegmentStream")), C.videoSegmentStream.on("timelineStartInfo", function(U) {
            w && !d.keepOriginalTimestamps && (w.timelineStartInfo = U, C.audioSegmentStream.setEarliestDts(U.dts - p.baseMediaDecodeTime));
          }), C.videoSegmentStream.on("processedGopsInfo", p.trigger.bind(p, "gopInfo")), C.videoSegmentStream.on("segmentTimingInfo", p.trigger.bind(p, "videoSegmentTimingInfo")), C.videoSegmentStream.on("baseMediaDecodeTime", function(U) {
            w && C.audioSegmentStream.setVideoBaseMediaDecodeTime(U);
          }), C.videoSegmentStream.on("timingInfo", p.trigger.bind(p, "videoTimingInfo")), C.h264Stream.pipe(C.videoSegmentStream).pipe(C.coalesceStream)), w && !C.audioSegmentStream && (C.coalesceStream.numberOfTracks++, C.audioSegmentStream = new Eo(w, d), C.audioSegmentStream.on("log", p.getLogTrigger_("audioSegmentStream")), C.audioSegmentStream.on("timingInfo", p.trigger.bind(p, "audioTimingInfo")), C.audioSegmentStream.on("segmentTimingInfo", p.trigger.bind(p, "audioSegmentTimingInfo")), C.adtsStream.pipe(C.audioSegmentStream).pipe(C.coalesceStream)), p.trigger("trackinfo", {
            hasAudio: !!w,
            hasVideo: !!v
          });
        }
      }), C.coalesceStream.on("data", this.trigger.bind(this, "data")), C.coalesceStream.on("id3Frame", function(R) {
        R.dispatchType = C.metadataStream.dispatchType, p.trigger("id3Frame", R);
      }), C.coalesceStream.on("caption", this.trigger.bind(this, "caption")), C.coalesceStream.on("done", this.trigger.bind(this, "done")), em(this, C);
    }, this.setBaseMediaDecodeTime = function(C) {
      var R = this.transmuxPipeline_;
      d.keepOriginalTimestamps || (this.baseMediaDecodeTime = C), w && (w.timelineStartInfo.dts = void 0, w.timelineStartInfo.pts = void 0, Aa.clearDtsInfo(w), R.audioTimestampRolloverStream && R.audioTimestampRolloverStream.discontinuity()), v && (R.videoSegmentStream && (R.videoSegmentStream.gopCache_ = []), v.timelineStartInfo.dts = void 0, v.timelineStartInfo.pts = void 0, Aa.clearDtsInfo(v), R.captionStream.reset()), R.timestampRolloverStream && R.timestampRolloverStream.discontinuity();
    }, this.setAudioAppendStart = function(C) {
      w && this.transmuxPipeline_.audioSegmentStream.setAudioAppendStart(C);
    }, this.setRemux = function(C) {
      var R = this.transmuxPipeline_;
      d.remux = C, R && R.coalesceStream && R.coalesceStream.setRemux(C);
    }, this.alignGopsWith = function(C) {
      v && this.transmuxPipeline_.videoSegmentStream && this.transmuxPipeline_.videoSegmentStream.alignGopsWith(C);
    }, this.getLogTrigger_ = function(C) {
      var R = this;
      return function(F) {
        F.stream = C, R.trigger("log", F);
      };
    }, this.push = function(C) {
      if (y) {
        var R = _x(C);
        R && this.transmuxPipeline_.type !== "aac" ? this.setupAacPipeline() : !R && this.transmuxPipeline_.type !== "ts" && this.setupTsPipeline(), y = !1;
      }
      this.transmuxPipeline_.headOfPipeline.push(C);
    }, this.flush = function() {
      y = !0, this.transmuxPipeline_.headOfPipeline.flush();
    }, this.endTimeline = function() {
      this.transmuxPipeline_.headOfPipeline.endTimeline();
    }, this.reset = function() {
      this.transmuxPipeline_.headOfPipeline && this.transmuxPipeline_.headOfPipeline.reset();
    }, this.resetCaptions = function() {
      this.transmuxPipeline_.captionStream && this.transmuxPipeline_.captionStream.reset();
    };
  }, vc.prototype = new pc();
  var wx = {
    Transmuxer: vc
  }, kx = function(d) {
    return d >>> 0;
  }, Cx = function(d) {
    return ("00" + d.toString(16)).slice(-2);
  }, yc = {
    toUnsigned: kx,
    toHexString: Cx
  }, Sx = function(d) {
    var p = "";
    return p += String.fromCharCode(d[0]), p += String.fromCharCode(d[1]), p += String.fromCharCode(d[2]), p += String.fromCharCode(d[3]), p;
  }, am = Sx, Ax = yc.toUnsigned, Ex = am, im = function(d, p) {
    var y = [], v, w, C, R, F;
    if (!p.length)
      return null;
    for (v = 0; v < d.byteLength; )
      w = Ax(d[v] << 24 | d[v + 1] << 16 | d[v + 2] << 8 | d[v + 3]), C = Ex(d.subarray(v + 4, v + 8)), R = w > 1 ? v + w : d.byteLength, C === p[0] && (p.length === 1 ? y.push(d.subarray(v + 8, R)) : (F = im(d.subarray(v + 8, R), p.slice(1)), F.length && (y = y.concat(F)))), v = R;
    return y;
  }, Yd = im, Lx = yc.toUnsigned, Dx = r.getUint64, Ix = function(d) {
    var p = {
      version: d[0],
      flags: new Uint8Array(d.subarray(1, 4))
    };
    return p.version === 1 ? p.baseMediaDecodeTime = Dx(d.subarray(4)) : p.baseMediaDecodeTime = Lx(d[4] << 24 | d[5] << 16 | d[6] << 8 | d[7]), p;
  }, jd = Ix, Mx = function(d) {
    var p = new DataView(d.buffer, d.byteOffset, d.byteLength), y = {
      version: d[0],
      flags: new Uint8Array(d.subarray(1, 4)),
      trackId: p.getUint32(4)
    }, v = y.flags[2] & 1, w = y.flags[2] & 2, C = y.flags[2] & 8, R = y.flags[2] & 16, F = y.flags[2] & 32, U = y.flags[0] & 65536, q = y.flags[0] & 131072, ae;
    return ae = 8, v && (ae += 4, y.baseDataOffset = p.getUint32(12), ae += 4), w && (y.sampleDescriptionIndex = p.getUint32(ae), ae += 4), C && (y.defaultSampleDuration = p.getUint32(ae), ae += 4), R && (y.defaultSampleSize = p.getUint32(ae), ae += 4), F && (y.defaultSampleFlags = p.getUint32(ae)), U && (y.durationIsEmpty = !0), !v && q && (y.baseDataOffsetIsMoof = !0), y;
  }, rm = Mx, Ox = function(d) {
    return {
      isLeading: (d[0] & 12) >>> 2,
      dependsOn: d[0] & 3,
      isDependedOn: (d[1] & 192) >>> 6,
      hasRedundancy: (d[1] & 48) >>> 4,
      paddingValue: (d[1] & 14) >>> 1,
      isNonSyncSample: d[1] & 1,
      degradationPriority: d[2] << 8 | d[3]
    };
  }, Px = Ox, sm = Px, Bx = function(d) {
    var p = {
      version: d[0],
      flags: new Uint8Array(d.subarray(1, 4)),
      samples: []
    }, y = new DataView(d.buffer, d.byteOffset, d.byteLength), v = p.flags[2] & 1, w = p.flags[2] & 4, C = p.flags[1] & 1, R = p.flags[1] & 2, F = p.flags[1] & 4, U = p.flags[1] & 8, q = y.getUint32(4), ae = 8, pe;
    for (v && (p.dataOffset = y.getInt32(ae), ae += 4), w && q && (pe = {
      flags: sm(d.subarray(ae, ae + 4))
    }, ae += 4, C && (pe.duration = y.getUint32(ae), ae += 4), R && (pe.size = y.getUint32(ae), ae += 4), U && (p.version === 1 ? pe.compositionTimeOffset = y.getInt32(ae) : pe.compositionTimeOffset = y.getUint32(ae), ae += 4), p.samples.push(pe), q--); q--; )
      pe = {}, C && (pe.duration = y.getUint32(ae), ae += 4), R && (pe.size = y.getUint32(ae), ae += 4), F && (pe.flags = sm(d.subarray(ae, ae + 4)), ae += 4), U && (p.version === 1 ? pe.compositionTimeOffset = y.getInt32(ae) : pe.compositionTimeOffset = y.getUint32(ae), ae += 4), p.samples.push(pe);
    return p;
  }, om = Bx, lm = {
    tfdt: jd,
    trun: om
  }, cm = {
    parseTfdt: lm.tfdt,
    parseTrun: lm.trun
  }, Rx = function(d) {
    for (var p = 0, y = String.fromCharCode(d[p]), v = ""; y !== "\0"; )
      v += y, p++, y = String.fromCharCode(d[p]);
    return v += y, v;
  }, Nx = {
    uint8ToCString: Rx
  }, _c = Nx.uint8ToCString, $x = r.getUint64, Fx = function(d) {
    var p = 4, y = d[0], v, w, C, R, F, U, q, ae;
    if (y === 0) {
      v = _c(d.subarray(p)), p += v.length, w = _c(d.subarray(p)), p += w.length;
      var pe = new DataView(d.buffer);
      C = pe.getUint32(p), p += 4, F = pe.getUint32(p), p += 4, U = pe.getUint32(p), p += 4, q = pe.getUint32(p), p += 4;
    } else if (y === 1) {
      var pe = new DataView(d.buffer);
      C = pe.getUint32(p), p += 4, R = $x(d.subarray(p)), p += 8, U = pe.getUint32(p), p += 4, q = pe.getUint32(p), p += 4, v = _c(d.subarray(p)), p += v.length, w = _c(d.subarray(p)), p += w.length;
    }
    ae = new Uint8Array(d.subarray(p, d.byteLength));
    var Fe = {
      scheme_id_uri: v,
      value: w,
      // if timescale is undefined or 0 set to 1 
      timescale: C || 1,
      presentation_time: R,
      presentation_time_delta: F,
      event_duration: U,
      id: q,
      message_data: ae
    };
    return Ux(y, Fe) ? Fe : void 0;
  }, zx = function(d, p, y, v) {
    return d || d === 0 ? d / p : v + y / p;
  }, Ux = function(d, p) {
    var y = p.scheme_id_uri !== "\0", v = d === 0 && um(p.presentation_time_delta) && y, w = d === 1 && um(p.presentation_time) && y;
    return !(d > 1) && v || w;
  }, um = function(d) {
    return d !== void 0 || d !== null;
  }, Hx = {
    parseEmsgBox: Fx,
    scaleTime: zx
  }, Lo;
  typeof window < "u" ? Lo = window : typeof t < "u" ? Lo = t : typeof self < "u" ? Lo = self : Lo = {};
  var dm = Lo, Tc = yc.toUnsigned, Do = yc.toHexString, Gt = Yd, Zr = am, Vd = Hx, Yx = rm, jx = om, Vx = jd, qx = r.getUint64, hm, fm, pm, mm, gm, qd, bm, Wd = dm, Wx = Up.parseId3Frames;
  hm = function(d) {
    var p = {}, y = Gt(d, ["moov", "trak"]);
    return y.reduce(function(v, w) {
      var C, R, F, U, q;
      return C = Gt(w, ["tkhd"])[0], !C || (R = C[0], F = R === 0 ? 12 : 20, U = Tc(C[F] << 24 | C[F + 1] << 16 | C[F + 2] << 8 | C[F + 3]), q = Gt(w, ["mdia", "mdhd"])[0], !q) ? null : (R = q[0], F = R === 0 ? 12 : 20, v[U] = Tc(q[F] << 24 | q[F + 1] << 16 | q[F + 2] << 8 | q[F + 3]), v);
    }, p);
  }, fm = function(d, p) {
    var y;
    y = Gt(p, ["moof", "traf"]);
    var v = y.reduce(function(w, C) {
      var R = Gt(C, ["tfhd"])[0], F = Tc(R[4] << 24 | R[5] << 16 | R[6] << 8 | R[7]), U = d[F] || 9e4, q = Gt(C, ["tfdt"])[0], ae = new DataView(q.buffer, q.byteOffset, q.byteLength), pe;
      q[0] === 1 ? pe = qx(q.subarray(4, 12)) : pe = ae.getUint32(4);
      let Fe;
      return typeof pe == "bigint" ? Fe = pe / Wd.BigInt(U) : typeof pe == "number" && !isNaN(pe) && (Fe = pe / U), Fe < Number.MAX_SAFE_INTEGER && (Fe = Number(Fe)), Fe < w && (w = Fe), w;
    }, 1 / 0);
    return typeof v == "bigint" || isFinite(v) ? v : 0;
  }, pm = function(d, p) {
    var y = Gt(p, ["moof", "traf"]), v = 0, w = 0, C;
    if (y && y.length) {
      var R = Gt(y[0], ["tfhd"])[0], F = Gt(y[0], ["trun"])[0], U = Gt(y[0], ["tfdt"])[0];
      if (R) {
        var q = Yx(R);
        C = q.trackId;
      }
      if (U) {
        var ae = Vx(U);
        v = ae.baseMediaDecodeTime;
      }
      if (F) {
        var pe = jx(F);
        pe.samples && pe.samples.length && (w = pe.samples[0].compositionTimeOffset || 0);
      }
    }
    var Fe = d[C] || 9e4;
    typeof v == "bigint" && (w = Wd.BigInt(w), Fe = Wd.BigInt(Fe));
    var Se = (v + w) / Fe;
    return typeof Se == "bigint" && Se < Number.MAX_SAFE_INTEGER && (Se = Number(Se)), Se;
  }, mm = function(d) {
    var p = Gt(d, ["moov", "trak"]), y = [];
    return p.forEach(function(v) {
      var w = Gt(v, ["mdia", "hdlr"]), C = Gt(v, ["tkhd"]);
      w.forEach(function(R, F) {
        var U = Zr(R.subarray(8, 12)), q = C[F], ae, pe, Fe;
        U === "vide" && (ae = new DataView(q.buffer, q.byteOffset, q.byteLength), pe = ae.getUint8(0), Fe = pe === 0 ? ae.getUint32(12) : ae.getUint32(20), y.push(Fe));
      });
    }), y;
  }, qd = function(d) {
    var p = d[0], y = p === 0 ? 12 : 20;
    return Tc(d[y] << 24 | d[y + 1] << 16 | d[y + 2] << 8 | d[y + 3]);
  }, gm = function(d) {
    var p = Gt(d, ["moov", "trak"]), y = [];
    return p.forEach(function(v) {
      var w = {}, C = Gt(v, ["tkhd"])[0], R, F;
      C && (R = new DataView(C.buffer, C.byteOffset, C.byteLength), F = R.getUint8(0), w.id = F === 0 ? R.getUint32(12) : R.getUint32(20));
      var U = Gt(v, ["mdia", "hdlr"])[0];
      if (U) {
        var q = Zr(U.subarray(8, 12));
        q === "vide" ? w.type = "video" : q === "soun" ? w.type = "audio" : w.type = q;
      }
      var ae = Gt(v, ["mdia", "minf", "stbl", "stsd"])[0];
      if (ae) {
        var pe = ae.subarray(8);
        w.codec = Zr(pe.subarray(4, 8));
        var Fe = Gt(pe, [w.codec])[0], Se, Ze;
        Fe && (/^[asm]vc[1-9]$/i.test(w.codec) ? (Se = Fe.subarray(78), Ze = Zr(Se.subarray(4, 8)), Ze === "avcC" && Se.length > 11 ? (w.codec += ".", w.codec += Do(Se[9]), w.codec += Do(Se[10]), w.codec += Do(Se[11])) : w.codec = "avc1.4d400d") : /^mp4[a,v]$/i.test(w.codec) ? (Se = Fe.subarray(28), Ze = Zr(Se.subarray(4, 8)), Ze === "esds" && Se.length > 20 && Se[19] !== 0 ? (w.codec += "." + Do(Se[19]), w.codec += "." + Do(Se[20] >>> 2 & 63).replace(/^0/, "")) : w.codec = "mp4a.40.2") : w.codec = w.codec.toLowerCase());
      }
      var ot = Gt(v, ["mdia", "mdhd"])[0];
      ot && (w.timescale = qd(ot)), y.push(w);
    }), y;
  }, bm = function(d, p = 0) {
    var y = Gt(d, ["emsg"]);
    return y.map((v) => {
      var w = Vd.parseEmsgBox(new Uint8Array(v)), C = Wx(w.message_data);
      return {
        cueTime: Vd.scaleTime(w.presentation_time, w.timescale, w.presentation_time_delta, p),
        duration: Vd.scaleTime(w.event_duration, w.timescale),
        frames: C
      };
    });
  };
  var Io = {
    // export mp4 inspector's findBox and parseType for backwards compatibility
    findBox: Gt,
    parseType: Zr,
    timescale: hm,
    startTime: fm,
    compositionStartTime: pm,
    videoTrackIds: mm,
    tracks: gm,
    getTimescaleFromMediaHeader: qd,
    getEmsgID3: bm
  };
  const {
    parseTrun: Gx
  } = cm, {
    findBox: vm
  } = Io;
  var ym = dm, Xx = function(d) {
    var p = vm(d, ["moof", "traf"]), y = vm(d, ["mdat"]), v = [];
    return y.forEach(function(w, C) {
      var R = p[C];
      v.push({
        mdat: w,
        traf: R
      });
    }), v;
  }, Zx = function(d, p, y) {
    var v = p, w = y.defaultSampleDuration || 0, C = y.defaultSampleSize || 0, R = y.trackId, F = [];
    return d.forEach(function(U) {
      var q = Gx(U), ae = q.samples;
      ae.forEach(function(pe) {
        pe.duration === void 0 && (pe.duration = w), pe.size === void 0 && (pe.size = C), pe.trackId = R, pe.dts = v, pe.compositionTimeOffset === void 0 && (pe.compositionTimeOffset = 0), typeof v == "bigint" ? (pe.pts = v + ym.BigInt(pe.compositionTimeOffset), v += ym.BigInt(pe.duration)) : (pe.pts = v + pe.compositionTimeOffset, v += pe.duration);
      }), F = F.concat(ae);
    }), F;
  }, _m = {
    getMdatTrafPairs: Xx,
    parseSamples: Zx
  }, Kx = Rp.discardEmulationPreventionBytes, Qx = Np.CaptionStream, Gd = Yd, Jx = jd, e4 = rm, {
    getMdatTrafPairs: t4,
    parseSamples: n4
  } = _m, a4 = function(d, p) {
    for (var y = d, v = 0; v < p.length; v++) {
      var w = p[v];
      if (y < w.size)
        return w;
      y -= w.size;
    }
    return null;
  }, i4 = function(d, p, y) {
    var v = new DataView(d.buffer, d.byteOffset, d.byteLength), w = {
      logs: [],
      seiNals: []
    }, C, R, F, U;
    for (R = 0; R + 4 < d.length; R += F)
      if (F = v.getUint32(R), R += 4, !(F <= 0))
        switch (d[R] & 31) {
          case 6:
            var q = d.subarray(R + 1, R + 1 + F), ae = a4(R, p);
            if (C = {
              nalUnitType: "sei_rbsp",
              size: F,
              data: q,
              escapedRBSP: Kx(q),
              trackId: y
            }, ae)
              C.pts = ae.pts, C.dts = ae.dts, U = ae;
            else if (U)
              C.pts = U.pts, C.dts = U.dts;
            else {
              w.logs.push({
                level: "warn",
                message: "We've encountered a nal unit without data at " + R + " for trackId " + y + ". See mux.js#223."
              });
              break;
            }
            w.seiNals.push(C);
            break;
        }
    return w;
  }, r4 = function(d, p) {
    var y = {}, v = t4(d);
    return v.forEach(function(w) {
      var C = w.mdat, R = w.traf, F = Gd(R, ["tfhd"]), U = e4(F[0]), q = U.trackId, ae = Gd(R, ["tfdt"]), pe = ae.length > 0 ? Jx(ae[0]).baseMediaDecodeTime : 0, Fe = Gd(R, ["trun"]), Se, Ze;
      p === q && Fe.length > 0 && (Se = n4(Fe, pe, U), Ze = i4(C, Se, q), y[q] || (y[q] = {
        seiNals: [],
        logs: []
      }), y[q].seiNals = y[q].seiNals.concat(Ze.seiNals), y[q].logs = y[q].logs.concat(Ze.logs));
    }), y;
  }, s4 = function(d, p, y) {
    var v;
    if (p === null)
      return null;
    v = r4(d, p);
    var w = v[p] || {};
    return {
      seiNals: w.seiNals,
      logs: w.logs,
      timescale: y
    };
  }, o4 = function() {
    var d = !1, p, y, v, w, C, R;
    this.isInitialized = function() {
      return d;
    }, this.init = function(F) {
      p = new Qx(), d = !0, R = F ? F.isPartial : !1, p.on("data", function(U) {
        U.startTime = U.startPts / w, U.endTime = U.endPts / w, C.captions.push(U), C.captionStreams[U.stream] = !0;
      }), p.on("log", function(U) {
        C.logs.push(U);
      });
    }, this.isNewInit = function(F, U) {
      return F && F.length === 0 || U && typeof U == "object" && Object.keys(U).length === 0 ? !1 : v !== F[0] || w !== U[v];
    }, this.parse = function(F, U, q) {
      var ae;
      if (this.isInitialized()) {
        if (!U || !q)
          return null;
        if (this.isNewInit(U, q))
          v = U[0], w = q[v];
        else if (v === null || !w)
          return y.push(F), null;
      } else return null;
      for (; y.length > 0; ) {
        var pe = y.shift();
        this.parse(pe, U, q);
      }
      return ae = s4(F, v, w), ae && ae.logs && (C.logs = C.logs.concat(ae.logs)), ae === null || !ae.seiNals ? C.logs.length ? {
        logs: C.logs,
        captions: [],
        captionStreams: []
      } : null : (this.pushNals(ae.seiNals), this.flushStream(), C);
    }, this.pushNals = function(F) {
      if (!this.isInitialized() || !F || F.length === 0)
        return null;
      F.forEach(function(U) {
        p.push(U);
      });
    }, this.flushStream = function() {
      if (!this.isInitialized())
        return null;
      R ? p.partialFlush() : p.flush();
    }, this.clearParsedCaptions = function() {
      C.captions = [], C.captionStreams = {}, C.logs = [];
    }, this.resetCaptionStream = function() {
      if (!this.isInitialized())
        return null;
      p.reset();
    }, this.clearAllCaptions = function() {
      this.clearParsedCaptions(), this.resetCaptionStream();
    }, this.reset = function() {
      y = [], v = null, w = null, C ? this.clearParsedCaptions() : C = {
        captions: [],
        // CC1, CC2, CC3, CC4
        captionStreams: {},
        logs: []
      }, this.resetCaptionStream();
    }, this.reset();
  }, l4 = o4;
  const {
    parseTfdt: c4
  } = cm, Ri = Yd, {
    getTimescaleFromMediaHeader: u4
  } = Io, {
    parseSamples: d4,
    getMdatTrafPairs: h4
  } = _m;
  var Tm = function() {
    let d = 9e4;
    this.init = function(p) {
      const y = Ri(p, ["moov", "trak", "mdia", "mdhd"])[0];
      y && (d = u4(y));
    }, this.parseSegment = function(p) {
      const y = [], v = h4(p);
      let w = 0;
      return v.forEach(function(C) {
        const R = C.mdat, F = C.traf, U = Ri(F, ["tfdt"])[0], q = Ri(F, ["tfhd"])[0], ae = Ri(F, ["trun"]);
        if (U && (w = c4(U).baseMediaDecodeTime), ae.length && q) {
          const pe = d4(ae, w, q);
          let Fe = 0;
          pe.forEach(function(Se) {
            const Ze = "utf-8", ot = new TextDecoder(Ze), fn = R.slice(Fe, Fe + Se.size);
            if (Ri(fn, ["vtte"])[0]) {
              Fe += Se.size;
              return;
            }
            Ri(fn, ["vttc"]).forEach(function(Mo) {
              const Oo = Ri(Mo, ["payl"])[0], Po = Ri(Mo, ["sttg"])[0], Bo = Se.pts / d, kc = (Se.pts + Se.duration) / d;
              let Lt, Ro;
              if (Oo)
                try {
                  Lt = ot.decode(Oo);
                } catch (Ea) {
                  console.error(Ea);
                }
              if (Po)
                try {
                  Ro = ot.decode(Po);
                } catch (Ea) {
                  console.error(Ea);
                }
              Se.duration && Lt && y.push({
                cueText: Lt,
                start: Bo,
                end: kc,
                settings: Ro
              });
            }), Fe += Se.size;
          });
        }
      }), y;
    };
  }, Xd = ic, xm = function(d) {
    var p = d[1] & 31;
    return p <<= 8, p |= d[2], p;
  }, xc = function(d) {
    return !!(d[1] & 64);
  }, wc = function(d) {
    var p = 0;
    return (d[3] & 48) >>> 4 > 1 && (p += d[4] + 1), p;
  }, f4 = function(d, p) {
    var y = xm(d);
    return y === 0 ? "pat" : y === p ? "pmt" : p ? "pes" : null;
  }, p4 = function(d) {
    var p = xc(d), y = 4 + wc(d);
    return p && (y += d[y] + 1), (d[y + 10] & 31) << 8 | d[y + 11];
  }, m4 = function(d) {
    var p = {}, y = xc(d), v = 4 + wc(d);
    if (y && (v += d[v] + 1), !!(d[v + 5] & 1)) {
      var w, C, R;
      w = (d[v + 1] & 15) << 8 | d[v + 2], C = 3 + w - 4, R = (d[v + 10] & 15) << 8 | d[v + 11];
      for (var F = 12 + R; F < C; ) {
        var U = v + F;
        p[(d[U + 1] & 31) << 8 | d[U + 2]] = d[U], F += ((d[U + 3] & 15) << 8 | d[U + 4]) + 5;
      }
      return p;
    }
  }, g4 = function(d, p) {
    var y = xm(d), v = p[y];
    switch (v) {
      case Xd.H264_STREAM_TYPE:
        return "video";
      case Xd.ADTS_STREAM_TYPE:
        return "audio";
      case Xd.METADATA_STREAM_TYPE:
        return "timed-metadata";
      default:
        return null;
    }
  }, b4 = function(d) {
    var p = xc(d);
    if (!p)
      return null;
    var y = 4 + wc(d);
    if (y >= d.byteLength)
      return null;
    var v = null, w;
    return w = d[y + 7], w & 192 && (v = {}, v.pts = (d[y + 9] & 14) << 27 | (d[y + 10] & 255) << 20 | (d[y + 11] & 254) << 12 | (d[y + 12] & 255) << 5 | (d[y + 13] & 254) >>> 3, v.pts *= 4, v.pts += (d[y + 13] & 6) >>> 1, v.dts = v.pts, w & 64 && (v.dts = (d[y + 14] & 14) << 27 | (d[y + 15] & 255) << 20 | (d[y + 16] & 254) << 12 | (d[y + 17] & 255) << 5 | (d[y + 18] & 254) >>> 3, v.dts *= 4, v.dts += (d[y + 18] & 6) >>> 1)), v;
  }, Zd = function(d) {
    switch (d) {
      case 5:
        return "slice_layer_without_partitioning_rbsp_idr";
      case 6:
        return "sei_rbsp";
      case 7:
        return "seq_parameter_set_rbsp";
      case 8:
        return "pic_parameter_set_rbsp";
      case 9:
        return "access_unit_delimiter_rbsp";
      default:
        return null;
    }
  }, v4 = function(d) {
    for (var p = 4 + wc(d), y = d.subarray(p), v = 0, w = 0, C = !1, R; w < y.byteLength - 3; w++)
      if (y[w + 2] === 1) {
        v = w + 5;
        break;
      }
    for (; v < y.byteLength; )
      switch (y[v]) {
        case 0:
          if (y[v - 1] !== 0) {
            v += 2;
            break;
          } else if (y[v - 2] !== 0) {
            v++;
            break;
          }
          w + 3 !== v - 2 && (R = Zd(y[w + 3] & 31), R === "slice_layer_without_partitioning_rbsp_idr" && (C = !0));
          do
            v++;
          while (y[v] !== 1 && v < y.length);
          w = v - 2, v += 3;
          break;
        case 1:
          if (y[v - 1] !== 0 || y[v - 2] !== 0) {
            v += 3;
            break;
          }
          R = Zd(y[w + 3] & 31), R === "slice_layer_without_partitioning_rbsp_idr" && (C = !0), w = v - 2, v += 3;
          break;
        default:
          v += 3;
          break;
      }
    return y = y.subarray(w), v -= w, w = 0, y && y.byteLength > 3 && (R = Zd(y[w + 3] & 31), R === "slice_layer_without_partitioning_rbsp_idr" && (C = !0)), C;
  }, y4 = {
    parseType: f4,
    parsePat: p4,
    parsePmt: m4,
    parsePayloadUnitStartIndicator: xc,
    parsePesType: g4,
    parsePesTime: b4,
    videoPacketContainsKeyFrame: v4
  }, wm = ic, Kr = Fp.handleRollover, vt = {};
  vt.ts = y4, vt.aac = Hd;
  var pr = bt.ONE_SECOND_IN_TS, Mn = 188, Ha = 71, _4 = function(d, p) {
    for (var y = 0, v = Mn, w, C; v < d.byteLength; ) {
      if (d[y] === Ha && d[v] === Ha) {
        switch (w = d.subarray(y, v), C = vt.ts.parseType(w, p.pid), C) {
          case "pat":
            p.pid = vt.ts.parsePat(w);
            break;
          case "pmt":
            var R = vt.ts.parsePmt(w);
            p.table = p.table || {}, Object.keys(R).forEach(function(F) {
              p.table[F] = R[F];
            });
            break;
        }
        y += Mn, v += Mn;
        continue;
      }
      y++, v++;
    }
  }, km = function(d, p, y) {
    for (var v = 0, w = Mn, C, R, F, U, q, ae = !1; w <= d.byteLength; ) {
      if (d[v] === Ha && (d[w] === Ha || w === d.byteLength)) {
        switch (C = d.subarray(v, w), R = vt.ts.parseType(C, p.pid), R) {
          case "pes":
            F = vt.ts.parsePesType(C, p.table), U = vt.ts.parsePayloadUnitStartIndicator(C), F === "audio" && U && (q = vt.ts.parsePesTime(C), q && (q.type = "audio", y.audio.push(q), ae = !0));
            break;
        }
        if (ae)
          break;
        v += Mn, w += Mn;
        continue;
      }
      v++, w++;
    }
    for (w = d.byteLength, v = w - Mn, ae = !1; v >= 0; ) {
      if (d[v] === Ha && (d[w] === Ha || w === d.byteLength)) {
        switch (C = d.subarray(v, w), R = vt.ts.parseType(C, p.pid), R) {
          case "pes":
            F = vt.ts.parsePesType(C, p.table), U = vt.ts.parsePayloadUnitStartIndicator(C), F === "audio" && U && (q = vt.ts.parsePesTime(C), q && (q.type = "audio", y.audio.push(q), ae = !0));
            break;
        }
        if (ae)
          break;
        v -= Mn, w -= Mn;
        continue;
      }
      v--, w--;
    }
  }, T4 = function(d, p, y) {
    for (var v = 0, w = Mn, C, R, F, U, q, ae, pe, Fe, Se = !1, Ze = {
      data: [],
      size: 0
    }; w < d.byteLength; ) {
      if (d[v] === Ha && d[w] === Ha) {
        switch (C = d.subarray(v, w), R = vt.ts.parseType(C, p.pid), R) {
          case "pes":
            if (F = vt.ts.parsePesType(C, p.table), U = vt.ts.parsePayloadUnitStartIndicator(C), F === "video" && (U && !Se && (q = vt.ts.parsePesTime(C), q && (q.type = "video", y.video.push(q), Se = !0)), !y.firstKeyFrame)) {
              if (U && Ze.size !== 0) {
                for (ae = new Uint8Array(Ze.size), pe = 0; Ze.data.length; )
                  Fe = Ze.data.shift(), ae.set(Fe, pe), pe += Fe.byteLength;
                if (vt.ts.videoPacketContainsKeyFrame(ae)) {
                  var ot = vt.ts.parsePesTime(ae);
                  ot ? (y.firstKeyFrame = ot, y.firstKeyFrame.type = "video") : console.warn("Failed to extract PTS/DTS from PES at first keyframe. This could be an unusual TS segment, or else mux.js did not parse your TS segment correctly. If you know your TS segments do contain PTS/DTS on keyframes please file a bug report! You can try ffprobe to double check for yourself.");
                }
                Ze.size = 0;
              }
              Ze.data.push(C), Ze.size += C.byteLength;
            }
            break;
        }
        if (Se && y.firstKeyFrame)
          break;
        v += Mn, w += Mn;
        continue;
      }
      v++, w++;
    }
    for (w = d.byteLength, v = w - Mn, Se = !1; v >= 0; ) {
      if (d[v] === Ha && d[w] === Ha) {
        switch (C = d.subarray(v, w), R = vt.ts.parseType(C, p.pid), R) {
          case "pes":
            F = vt.ts.parsePesType(C, p.table), U = vt.ts.parsePayloadUnitStartIndicator(C), F === "video" && U && (q = vt.ts.parsePesTime(C), q && (q.type = "video", y.video.push(q), Se = !0));
            break;
        }
        if (Se)
          break;
        v -= Mn, w -= Mn;
        continue;
      }
      v--, w--;
    }
  }, x4 = function(d, p) {
    if (d.audio && d.audio.length) {
      var y = p;
      (typeof y > "u" || isNaN(y)) && (y = d.audio[0].dts), d.audio.forEach(function(C) {
        C.dts = Kr(C.dts, y), C.pts = Kr(C.pts, y), C.dtsTime = C.dts / pr, C.ptsTime = C.pts / pr;
      });
    }
    if (d.video && d.video.length) {
      var v = p;
      if ((typeof v > "u" || isNaN(v)) && (v = d.video[0].dts), d.video.forEach(function(C) {
        C.dts = Kr(C.dts, v), C.pts = Kr(C.pts, v), C.dtsTime = C.dts / pr, C.ptsTime = C.pts / pr;
      }), d.firstKeyFrame) {
        var w = d.firstKeyFrame;
        w.dts = Kr(w.dts, v), w.pts = Kr(w.pts, v), w.dtsTime = w.dts / pr, w.ptsTime = w.pts / pr;
      }
    }
  }, w4 = function(d) {
    for (var p = !1, y = 0, v = null, w = null, C = 0, R = 0, F; d.length - R >= 3; ) {
      var U = vt.aac.parseType(d, R);
      switch (U) {
        case "timed-metadata":
          if (d.length - R < 10) {
            p = !0;
            break;
          }
          if (C = vt.aac.parseId3TagSize(d, R), C > d.length) {
            p = !0;
            break;
          }
          w === null && (F = d.subarray(R, R + C), w = vt.aac.parseAacTimestamp(F)), R += C;
          break;
        case "audio":
          if (d.length - R < 7) {
            p = !0;
            break;
          }
          if (C = vt.aac.parseAdtsSize(d, R), C > d.length) {
            p = !0;
            break;
          }
          v === null && (F = d.subarray(R, R + C), v = vt.aac.parseSampleRate(F)), y++, R += C;
          break;
        default:
          R++;
          break;
      }
      if (p)
        return null;
    }
    if (v === null || w === null)
      return null;
    var q = pr / v, ae = {
      audio: [{
        type: "audio",
        dts: w,
        pts: w
      }, {
        type: "audio",
        dts: w + y * 1024 * q,
        pts: w + y * 1024 * q
      }]
    };
    return ae;
  }, k4 = function(d) {
    var p = {
      pid: null,
      table: null
    }, y = {};
    _4(d, p);
    for (var v in p.table)
      if (p.table.hasOwnProperty(v)) {
        var w = p.table[v];
        switch (w) {
          case wm.H264_STREAM_TYPE:
            y.video = [], T4(d, p, y), y.video.length === 0 && delete y.video;
            break;
          case wm.ADTS_STREAM_TYPE:
            y.audio = [], km(d, p, y), y.audio.length === 0 && delete y.audio;
            break;
        }
      }
    return y;
  }, C4 = function(d, p) {
    var y = vt.aac.isLikelyAacData(d), v;
    return y ? v = w4(d) : v = k4(d), !v || !v.audio && !v.video ? null : (x4(v, p), v);
  }, S4 = {
    inspect: C4,
    parseAudioPes_: km
  };
  const A4 = function(d, p) {
    p.on("data", function(y) {
      const v = y.initSegment;
      y.initSegment = {
        data: v.buffer,
        byteOffset: v.byteOffset,
        byteLength: v.byteLength
      };
      const w = y.data;
      y.data = w.buffer, d.postMessage({
        action: "data",
        segment: y,
        byteOffset: w.byteOffset,
        byteLength: w.byteLength
      }, [y.data]);
    }), p.on("done", function(y) {
      d.postMessage({
        action: "done"
      });
    }), p.on("gopInfo", function(y) {
      d.postMessage({
        action: "gopInfo",
        gopInfo: y
      });
    }), p.on("videoSegmentTimingInfo", function(y) {
      const v = {
        start: {
          decode: bt.videoTsToSeconds(y.start.dts),
          presentation: bt.videoTsToSeconds(y.start.pts)
        },
        end: {
          decode: bt.videoTsToSeconds(y.end.dts),
          presentation: bt.videoTsToSeconds(y.end.pts)
        },
        baseMediaDecodeTime: bt.videoTsToSeconds(y.baseMediaDecodeTime)
      };
      y.prependedContentDuration && (v.prependedContentDuration = bt.videoTsToSeconds(y.prependedContentDuration)), d.postMessage({
        action: "videoSegmentTimingInfo",
        videoSegmentTimingInfo: v
      });
    }), p.on("audioSegmentTimingInfo", function(y) {
      const v = {
        start: {
          decode: bt.videoTsToSeconds(y.start.dts),
          presentation: bt.videoTsToSeconds(y.start.pts)
        },
        end: {
          decode: bt.videoTsToSeconds(y.end.dts),
          presentation: bt.videoTsToSeconds(y.end.pts)
        },
        baseMediaDecodeTime: bt.videoTsToSeconds(y.baseMediaDecodeTime)
      };
      y.prependedContentDuration && (v.prependedContentDuration = bt.videoTsToSeconds(y.prependedContentDuration)), d.postMessage({
        action: "audioSegmentTimingInfo",
        audioSegmentTimingInfo: v
      });
    }), p.on("id3Frame", function(y) {
      d.postMessage({
        action: "id3Frame",
        id3Frame: y
      });
    }), p.on("caption", function(y) {
      d.postMessage({
        action: "caption",
        caption: y
      });
    }), p.on("trackinfo", function(y) {
      d.postMessage({
        action: "trackinfo",
        trackInfo: y
      });
    }), p.on("audioTimingInfo", function(y) {
      d.postMessage({
        action: "audioTimingInfo",
        audioTimingInfo: {
          start: bt.videoTsToSeconds(y.start),
          end: bt.videoTsToSeconds(y.end)
        }
      });
    }), p.on("videoTimingInfo", function(y) {
      d.postMessage({
        action: "videoTimingInfo",
        videoTimingInfo: {
          start: bt.videoTsToSeconds(y.start),
          end: bt.videoTsToSeconds(y.end)
        }
      });
    }), p.on("log", function(y) {
      d.postMessage({
        action: "log",
        log: y
      });
    });
  };
  class Cm {
    constructor(p, y) {
      this.options = y || {}, this.self = p, this.init();
    }
    /**
     * initialize our web worker and wire all the events.
     */
    init() {
      this.transmuxer && this.transmuxer.dispose(), this.transmuxer = new wx.Transmuxer(this.options), A4(this.self, this.transmuxer);
    }
    pushMp4Captions(p) {
      this.captionParser || (this.captionParser = new l4(), this.captionParser.init());
      const y = new Uint8Array(p.data, p.byteOffset, p.byteLength), v = this.captionParser.parse(y, p.trackIds, p.timescales);
      this.self.postMessage({
        action: "mp4Captions",
        captions: v && v.captions || [],
        logs: v && v.logs || [],
        data: y.buffer
      }, [y.buffer]);
    }
    /**
     * Initializes the WebVttParser and passes the init segment.
     *
     * @param {Uint8Array} data mp4 boxed WebVTT init segment data
     */
    initMp4WebVttParser(p) {
      this.webVttParser || (this.webVttParser = new Tm());
      const y = new Uint8Array(p.data, p.byteOffset, p.byteLength);
      this.webVttParser.init(y);
    }
    /**
     * Parse an mp4 encapsulated WebVTT segment and return an array of cues.
     *
     * @param {Uint8Array} data a text/webvtt segment
     * @return {Object[]} an array of parsed cue objects
     */
    getMp4WebVttText(p) {
      this.webVttParser || (this.webVttParser = new Tm());
      const y = new Uint8Array(p.data, p.byteOffset, p.byteLength), v = this.webVttParser.parseSegment(y);
      this.self.postMessage({
        action: "getMp4WebVttText",
        mp4VttCues: v || [],
        data: y.buffer
      }, [y.buffer]);
    }
    probeMp4StartTime({
      timescales: p,
      data: y
    }) {
      const v = Io.startTime(p, y);
      this.self.postMessage({
        action: "probeMp4StartTime",
        startTime: v,
        data: y
      }, [y.buffer]);
    }
    probeMp4Tracks({
      data: p
    }) {
      const y = Io.tracks(p);
      this.self.postMessage({
        action: "probeMp4Tracks",
        tracks: y,
        data: p
      }, [p.buffer]);
    }
    /**
     * Probes an mp4 segment for EMSG boxes containing ID3 data.
     * https://aomediacodec.github.io/id3-emsg/
     *
     * @param {Uint8Array} data segment data
     * @param {number} offset segment start time
     * @return {Object[]} an array of ID3 frames
     */
    probeEmsgID3({
      data: p,
      offset: y
    }) {
      const v = Io.getEmsgID3(p, y);
      this.self.postMessage({
        action: "probeEmsgID3",
        id3Frames: v,
        emsgData: p
      }, [p.buffer]);
    }
    /**
     * Probe an mpeg2-ts segment to determine the start time of the segment in it's
     * internal "media time," as well as whether it contains video and/or audio.
     *
     * @private
     * @param {Uint8Array} bytes - segment bytes
     * @param {number} baseStartTime
     *        Relative reference timestamp used when adjusting frame timestamps for rollover.
     *        This value should be in seconds, as it's converted to a 90khz clock within the
     *        function body.
     * @return {Object} The start time of the current segment in "media time" as well as
     *                  whether it contains video and/or audio
     */
    probeTs({
      data: p,
      baseStartTime: y
    }) {
      const v = typeof y == "number" && !isNaN(y) ? y * bt.ONE_SECOND_IN_TS : void 0, w = S4.inspect(p, v);
      let C = null;
      w && (C = {
        // each type's time info comes back as an array of 2 times, start and end
        hasVideo: w.video && w.video.length === 2 || !1,
        hasAudio: w.audio && w.audio.length === 2 || !1
      }, C.hasVideo && (C.videoStart = w.video[0].ptsTime), C.hasAudio && (C.audioStart = w.audio[0].ptsTime)), this.self.postMessage({
        action: "probeTs",
        result: C,
        data: p
      }, [p.buffer]);
    }
    clearAllMp4Captions() {
      this.captionParser && this.captionParser.clearAllCaptions();
    }
    clearParsedMp4Captions() {
      this.captionParser && this.captionParser.clearParsedCaptions();
    }
    /**
     * Adds data (a ts segment) to the start of the transmuxer pipeline for
     * processing.
     *
     * @param {ArrayBuffer} data data to push into the muxer
     */
    push(p) {
      const y = new Uint8Array(p.data, p.byteOffset, p.byteLength);
      this.transmuxer.push(y);
    }
    /**
     * Recreate the transmuxer so that the next segment added via `push`
     * start with a fresh transmuxer.
     */
    reset() {
      this.transmuxer.reset();
    }
    /**
     * Set the value that will be used as the `baseMediaDecodeTime` time for the
     * next segment pushed in. Subsequent segments will have their `baseMediaDecodeTime`
     * set relative to the first based on the PTS values.
     *
     * @param {Object} data used to set the timestamp offset in the muxer
     */
    setTimestampOffset(p) {
      const y = p.timestampOffset || 0;
      this.transmuxer.setBaseMediaDecodeTime(Math.round(bt.secondsToVideoTs(y)));
    }
    setAudioAppendStart(p) {
      this.transmuxer.setAudioAppendStart(Math.ceil(bt.secondsToVideoTs(p.appendStart)));
    }
    setRemux(p) {
      this.transmuxer.setRemux(p.remux);
    }
    /**
     * Forces the pipeline to finish processing the last segment and emit it's
     * results.
     *
     * @param {Object} data event data, not really used
     */
    flush(p) {
      this.transmuxer.flush(), self.postMessage({
        action: "done",
        type: "transmuxed"
      });
    }
    endTimeline() {
      this.transmuxer.endTimeline(), self.postMessage({
        action: "endedtimeline",
        type: "transmuxed"
      });
    }
    alignGopsWith(p) {
      this.transmuxer.alignGopsWith(p.gopsToAlignWith.slice());
    }
  }
  self.onmessage = function(d) {
    if (d.data.action === "init" && d.data.options) {
      this.messageHandlers = new Cm(self, d.data.options);
      return;
    }
    this.messageHandlers || (this.messageHandlers = new Cm(self)), d.data && d.data.action && d.data.action !== "init" && this.messageHandlers[d.data.action] && this.messageHandlers[d.data.action](d.data);
  };
}));
var Zae = j_(Xae);
const Kae = (t, e, n) => {
  const {
    type: a,
    initSegment: i,
    captions: r,
    captionStreams: s,
    metadata: o,
    videoFrameDtsTime: l,
    videoFramePtsTime: c
  } = t.data.segment;
  e.buffer.push({
    captions: r,
    captionStreams: s,
    metadata: o
  });
  const u = t.data.segment.boxes || {
    data: t.data.segment.data
  }, f = {
    type: a,
    // cast ArrayBuffer to TypedArray
    data: new Uint8Array(u.data, u.data.byteOffset, u.data.byteLength),
    initSegment: new Uint8Array(i.data, i.byteOffset, i.byteLength)
  };
  typeof l < "u" && (f.videoFrameDtsTime = l), typeof c < "u" && (f.videoFramePtsTime = c), n(f);
}, Qae = ({
  transmuxedData: t,
  callback: e
}) => {
  t.buffer = [], e(t);
}, Jae = (t, e) => {
  e.gopInfo = t.data.gopInfo;
}, W_ = (t) => {
  const {
    transmuxer: e,
    bytes: n,
    audioAppendStart: a,
    gopsToAlignWith: i,
    remux: r,
    onData: s,
    onTrackInfo: o,
    onAudioTimingInfo: l,
    onVideoTimingInfo: c,
    onVideoSegmentTimingInfo: u,
    onAudioSegmentTimingInfo: f,
    onId3: m,
    onCaptions: _,
    onDone: T,
    onEndedTimeline: g,
    onTransmuxerLog: x,
    isEndOfTimeline: S,
    segment: D,
    triggerSegmentEventFn: L
  } = t, M = {
    buffer: []
  };
  let E = S;
  const P = (z) => {
    e.currentTransmux === t && (z.data.action === "data" && Kae(z, M, s), z.data.action === "trackinfo" && o(z.data.trackInfo), z.data.action === "gopInfo" && Jae(z, M), z.data.action === "audioTimingInfo" && l(z.data.audioTimingInfo), z.data.action === "videoTimingInfo" && c(z.data.videoTimingInfo), z.data.action === "videoSegmentTimingInfo" && u(z.data.videoSegmentTimingInfo), z.data.action === "audioSegmentTimingInfo" && f(z.data.audioSegmentTimingInfo), z.data.action === "id3Frame" && m([z.data.id3Frame], z.data.id3Frame.dispatchType), z.data.action === "caption" && _(z.data.caption), z.data.action === "endedtimeline" && (E = !1, g()), z.data.action === "log" && x(z.data.log), z.data.type === "transmuxed" && (E || (e.onmessage = null, Qae({
      transmuxedData: M,
      callback: T
    }), G_(e))));
  }, B = () => {
    const z = {
      message: "Received an error message from the transmuxer worker",
      metadata: {
        errorType: ce.Error.StreamingFailedToTransmuxSegment,
        segmentInfo: Tr({
          segment: D
        })
      }
    };
    T(null, z);
  };
  if (e.onmessage = P, e.onerror = B, a && e.postMessage({
    action: "setAudioAppendStart",
    appendStart: a
  }), Array.isArray(i) && e.postMessage({
    action: "alignGopsWith",
    gopsToAlignWith: i
  }), typeof r < "u" && e.postMessage({
    action: "setRemux",
    remux: r
  }), n.byteLength) {
    const z = n instanceof ArrayBuffer ? n : n.buffer, W = n instanceof ArrayBuffer ? 0 : n.byteOffset;
    L({
      type: "segmenttransmuxingstart",
      segment: D
    }), e.postMessage({
      action: "push",
      // Send the typed-array of data as an ArrayBuffer so that
      // it can be sent as a "Transferable" and avoid the costly
      // memory copy
      data: z,
      // To recreate the original typed-array, we need information
      // about what portion of the ArrayBuffer it was a view into
      byteOffset: W,
      byteLength: n.byteLength
    }, [z]);
  }
  S && e.postMessage({
    action: "endTimeline"
  }), e.postMessage({
    action: "flush"
  });
}, G_ = (t) => {
  t.currentTransmux = null, t.transmuxQueue.length && (t.currentTransmux = t.transmuxQueue.shift(), typeof t.currentTransmux == "function" ? t.currentTransmux() : W_(t.currentTransmux));
}, Ib = (t, e) => {
  t.postMessage({
    action: e
  }), G_(t);
}, X_ = (t, e) => {
  if (!e.currentTransmux) {
    e.currentTransmux = t, Ib(e, t);
    return;
  }
  e.transmuxQueue.push(Ib.bind(null, e, t));
}, eie = (t) => {
  X_("reset", t);
}, tie = (t) => {
  X_("endTimeline", t);
}, Z_ = (t) => {
  if (!t.transmuxer.currentTransmux) {
    t.transmuxer.currentTransmux = t, W_(t);
    return;
  }
  t.transmuxer.transmuxQueue.push(t);
}, nie = (t) => {
  const e = new Zae();
  e.currentTransmux = null, e.transmuxQueue = [];
  const n = e.terminate;
  return e.terminate = () => (e.currentTransmux = null, e.transmuxQueue.length = 0, n.call(e)), e.postMessage({
    action: "init",
    options: t
  }), e;
};
var U0 = {
  reset: eie,
  endTimeline: tie,
  transmux: Z_,
  createTransmuxer: nie
};
const Ss = function(t) {
  const e = t.transmuxer, n = t.endAction || t.action, a = t.callback, i = Jt({}, t, {
    endAction: null,
    transmuxer: null,
    callback: null
  }), r = (s) => {
    s.data.action === n && (e.removeEventListener("message", r), s.data.data && (s.data.data = new Uint8Array(s.data.data, t.byteOffset || 0, t.byteLength || s.data.data.byteLength), t.data && (t.data = s.data.data)), a(s.data));
  };
  if (e.addEventListener("message", r), t.data) {
    const s = t.data instanceof ArrayBuffer;
    i.byteOffset = s ? 0 : t.data.byteOffset, i.byteLength = t.data.byteLength;
    const o = [s ? t.data : t.data.buffer];
    e.postMessage(i, o);
  } else
    e.postMessage(i);
}, Qa = {
  FAILURE: 2,
  TIMEOUT: -101,
  ABORTED: -102
}, K_ = "wvtt", $h = (t) => {
  t.forEach((e) => {
    e.abort();
  });
}, aie = (t) => ({
  bandwidth: t.bandwidth,
  bytesReceived: t.bytesReceived || 0,
  roundTripTime: t.roundTripTime || 0
}), iie = (t) => {
  const e = t.target, a = {
    bandwidth: 1 / 0,
    bytesReceived: 0,
    roundTripTime: Date.now() - e.requestTime || 0
  };
  return a.bytesReceived = t.loaded, a.bandwidth = Math.floor(a.bytesReceived / a.roundTripTime * 8 * 1e3), a;
}, Op = (t, e) => {
  const {
    requestType: n
  } = e, a = Or({
    requestType: n,
    request: e,
    error: t
  });
  return e.timedout ? {
    status: e.status,
    message: "HLS request timed-out at URL: " + e.uri,
    code: Qa.TIMEOUT,
    xhr: e,
    metadata: a
  } : e.aborted ? {
    status: e.status,
    message: "HLS request aborted at URL: " + e.uri,
    code: Qa.ABORTED,
    xhr: e,
    metadata: a
  } : t ? {
    status: e.status,
    message: "HLS request errored at URL: " + e.uri,
    code: Qa.FAILURE,
    xhr: e,
    metadata: a
  } : e.responseType === "arraybuffer" && e.response.byteLength === 0 ? {
    status: e.status,
    message: "Empty HLS response at URL: " + e.uri,
    code: Qa.FAILURE,
    xhr: e,
    metadata: a
  } : null;
}, Mb = (t, e, n, a) => (i, r) => {
  const s = r.response, o = Op(i, r);
  if (o)
    return n(o, t);
  if (s.byteLength !== 16)
    return n({
      status: r.status,
      message: "Invalid HLS key at URL: " + r.uri,
      code: Qa.FAILURE,
      xhr: r
    }, t);
  const l = new DataView(s), c = new Uint32Array([l.getUint32(0), l.getUint32(4), l.getUint32(8), l.getUint32(12)]);
  for (let f = 0; f < e.length; f++)
    e[f].bytes = c;
  const u = {
    uri: r.uri
  };
  return a({
    type: "segmentkeyloadcomplete",
    segment: t,
    keyInfo: u
  }), n(null, t);
}, rie = (t, e) => {
  e === K_ && t.transmuxer.postMessage({
    action: "initMp4WebVttParser",
    data: t.map.bytes
  });
}, sie = (t, e, n) => {
  e === K_ && Ss({
    action: "getMp4WebVttText",
    data: t.bytes,
    transmuxer: t.transmuxer,
    callback: ({
      data: a,
      mp4VttCues: i
    }) => {
      t.bytes = a, n(null, t, {
        mp4VttCues: i
      });
    }
  });
}, Q_ = (t, e) => {
  const n = ap(t.map.bytes);
  if (n !== "mp4") {
    const a = t.map.resolvedUri || t.map.uri, i = n || "unknown";
    return e({
      internal: !0,
      message: `Found unsupported ${i} container for initialization segment at URL: ${a}`,
      code: Qa.FAILURE,
      metadata: {
        mediaType: i
      }
    });
  }
  Ss({
    action: "probeMp4Tracks",
    data: t.map.bytes,
    transmuxer: t.transmuxer,
    callback: ({
      tracks: a,
      data: i
    }) => (t.map.bytes = i, a.forEach(function(r) {
      t.map.tracks = t.map.tracks || {}, !t.map.tracks[r.type] && (t.map.tracks[r.type] = r, typeof r.id == "number" && r.timescale && (t.map.timescales = t.map.timescales || {}, t.map.timescales[r.id] = r.timescale), r.type === "text" && rie(t, r.codec));
    }), e(null))
  });
}, oie = ({
  segment: t,
  finishProcessingFn: e,
  triggerSegmentEventFn: n
}) => (a, i) => {
  const r = Op(a, i);
  if (r)
    return e(r, t);
  const s = new Uint8Array(i.response);
  if (n({
    type: "segmentloaded",
    segment: t
  }), t.map.key)
    return t.map.encryptedBytes = s, e(null, t);
  t.map.bytes = s, Q_(t, function(o) {
    if (o)
      return o.xhr = i, o.status = i.status, e(o, t);
    e(null, t);
  });
}, lie = ({
  segment: t,
  finishProcessingFn: e,
  responseType: n,
  triggerSegmentEventFn: a
}) => (i, r) => {
  const s = Op(i, r);
  if (s)
    return e(s, t);
  a({
    type: "segmentloaded",
    segment: t
  });
  const o = (
    // although responseText "should" exist, this guard serves to prevent an error being
    // thrown for two primary cases:
    // 1. the mime type override stops working, or is not implemented for a specific
    //    browser
    // 2. when using mock XHR libraries like sinon that do not allow the override behavior
    n === "arraybuffer" || !r.responseText ? r.response : Wae(r.responseText.substring(t.lastReachedChar || 0))
  );
  return t.stats = aie(r), t.key ? t.encryptedBytes = new Uint8Array(o) : t.bytes = new Uint8Array(o), e(null, t);
}, cie = ({
  segment: t,
  bytes: e,
  trackInfoFn: n,
  timingInfoFn: a,
  videoSegmentTimingInfoFn: i,
  audioSegmentTimingInfoFn: r,
  id3Fn: s,
  captionsFn: o,
  isEndOfTimeline: l,
  endedTimelineFn: c,
  dataFn: u,
  doneFn: f,
  onTransmuxerLog: m,
  triggerSegmentEventFn: _
}) => {
  const T = t.map && t.map.tracks || {}, g = !!(T.audio && T.video);
  let x = a.bind(null, t, "audio", "start");
  const S = a.bind(null, t, "audio", "end");
  let D = a.bind(null, t, "video", "start");
  const L = a.bind(null, t, "video", "end"), M = () => Z_({
    bytes: e,
    transmuxer: t.transmuxer,
    audioAppendStart: t.audioAppendStart,
    gopsToAlignWith: t.gopsToAlignWith,
    remux: g,
    onData: (E) => {
      E.type = E.type === "combined" ? "video" : E.type, u(t, E);
    },
    onTrackInfo: (E) => {
      n && (g && (E.isMuxed = !0), n(t, E));
    },
    onAudioTimingInfo: (E) => {
      x && typeof E.start < "u" && (x(E.start), x = null), S && typeof E.end < "u" && S(E.end);
    },
    onVideoTimingInfo: (E) => {
      D && typeof E.start < "u" && (D(E.start), D = null), L && typeof E.end < "u" && L(E.end);
    },
    onVideoSegmentTimingInfo: (E) => {
      const P = {
        pts: {
          start: E.start.presentation,
          end: E.end.presentation
        },
        dts: {
          start: E.start.decode,
          end: E.end.decode
        }
      };
      _({
        type: "segmenttransmuxingtiminginfoavailable",
        segment: t,
        timingInfo: P
      }), i(E);
    },
    onAudioSegmentTimingInfo: (E) => {
      const P = {
        pts: {
          start: E.start.pts,
          end: E.end.pts
        },
        dts: {
          start: E.start.dts,
          end: E.end.dts
        }
      };
      _({
        type: "segmenttransmuxingtiminginfoavailable",
        segment: t,
        timingInfo: P
      }), r(E);
    },
    onId3: (E, P) => {
      s(t, E, P);
    },
    onCaptions: (E) => {
      o(t, [E]);
    },
    isEndOfTimeline: l,
    onEndedTimeline: () => {
      c();
    },
    onTransmuxerLog: m,
    onDone: (E, P) => {
      f && (E.type = E.type === "combined" ? "video" : E.type, _({
        type: "segmenttransmuxingcomplete",
        segment: t
      }), f(P, t, E));
    },
    segment: t,
    triggerSegmentEventFn: _
  });
  Ss({
    action: "probeTs",
    transmuxer: t.transmuxer,
    data: e,
    baseStartTime: t.baseStartTime,
    callback: (E) => {
      t.bytes = e = E.data;
      const P = E.result;
      P && (n(t, {
        hasAudio: P.hasAudio,
        hasVideo: P.hasVideo,
        isMuxed: g
      }), n = null), M();
    }
  });
}, J_ = ({
  segment: t,
  bytes: e,
  trackInfoFn: n,
  timingInfoFn: a,
  videoSegmentTimingInfoFn: i,
  audioSegmentTimingInfoFn: r,
  id3Fn: s,
  captionsFn: o,
  isEndOfTimeline: l,
  endedTimelineFn: c,
  dataFn: u,
  doneFn: f,
  onTransmuxerLog: m,
  triggerSegmentEventFn: _
}) => {
  let T = new Uint8Array(e);
  if (Ite(T)) {
    t.isFmp4 = !0;
    const {
      tracks: g
    } = t.map;
    if (g.text && (!g.audio || !g.video)) {
      u(t, {
        data: T,
        type: "text"
      }), sie(t, g.text.codec, f);
      return;
    }
    const S = {
      isFmp4: !0,
      hasVideo: !!g.video,
      hasAudio: !!g.audio
    };
    g.audio && g.audio.codec && g.audio.codec !== "enca" && (S.audioCodec = g.audio.codec), g.video && g.video.codec && g.video.codec !== "encv" && (S.videoCodec = g.video.codec), g.video && g.audio && (S.isMuxed = !0), n(t, S);
    const D = (L, M) => {
      u(t, {
        data: T,
        type: S.hasAudio && !S.isMuxed ? "audio" : "video"
      }), M && M.length && s(t, M), L && L.length && o(t, L), f(null, t, {});
    };
    Ss({
      action: "probeMp4StartTime",
      timescales: t.map.timescales,
      data: T,
      transmuxer: t.transmuxer,
      callback: ({
        data: L,
        startTime: M
      }) => {
        e = L.buffer, t.bytes = T = L, S.hasAudio && !S.isMuxed && a(t, "audio", "start", M), S.hasVideo && a(t, "video", "start", M), Ss({
          action: "probeEmsgID3",
          data: T,
          transmuxer: t.transmuxer,
          offset: M,
          callback: ({
            emsgData: E,
            id3Frames: P
          }) => {
            if (e = E.buffer, t.bytes = T = E, !g.video || !E.byteLength || !t.transmuxer) {
              D(void 0, P);
              return;
            }
            Ss({
              action: "pushMp4Captions",
              endAction: "mp4Captions",
              transmuxer: t.transmuxer,
              data: T,
              timescales: t.map.timescales,
              trackIds: [g.video.id],
              callback: (B) => {
                e = B.data.buffer, t.bytes = T = B.data, B.logs.forEach(function(z) {
                  m(gt(z, {
                    stream: "mp4CaptionParser"
                  }));
                }), D(B.captions, P);
              }
            });
          }
        });
      }
    });
    return;
  }
  if (!t.transmuxer) {
    f(null, t, {});
    return;
  }
  if (typeof t.container > "u" && (t.container = ap(T)), t.container !== "ts" && t.container !== "aac") {
    n(t, {
      hasAudio: !1,
      hasVideo: !1
    }), f(null, t, {});
    return;
  }
  cie({
    segment: t,
    bytes: e,
    trackInfoFn: n,
    timingInfoFn: a,
    videoSegmentTimingInfoFn: i,
    audioSegmentTimingInfoFn: r,
    id3Fn: s,
    captionsFn: o,
    isEndOfTimeline: l,
    endedTimelineFn: c,
    dataFn: u,
    doneFn: f,
    onTransmuxerLog: m,
    triggerSegmentEventFn: _
  });
}, eT = function({
  id: t,
  key: e,
  encryptedBytes: n,
  decryptionWorker: a,
  segment: i,
  doneFn: r
}, s) {
  const o = (c) => {
    if (c.data.source === t) {
      a.removeEventListener("message", o);
      const u = c.data.decrypted;
      s(new Uint8Array(u.bytes, u.byteOffset, u.byteLength));
    }
  };
  a.onerror = () => {
    const c = "An error occurred in the decryption worker", u = Tr({
      segment: i
    }), f = {
      message: c,
      metadata: {
        error: new Error(c),
        errorType: ce.Error.StreamingFailedToDecryptSegment,
        segmentInfo: u,
        keyInfo: {
          uri: i.key.resolvedUri || i.map.key.resolvedUri
        }
      }
    };
    r(f, i);
  }, a.addEventListener("message", o);
  let l;
  e.bytes.slice ? l = e.bytes.slice() : l = new Uint32Array(Array.prototype.slice.call(e.bytes)), a.postMessage($_({
    source: t,
    encrypted: n,
    key: l,
    iv: e.iv
  }), [n.buffer, l.buffer]);
}, uie = ({
  decryptionWorker: t,
  segment: e,
  trackInfoFn: n,
  timingInfoFn: a,
  videoSegmentTimingInfoFn: i,
  audioSegmentTimingInfoFn: r,
  id3Fn: s,
  captionsFn: o,
  isEndOfTimeline: l,
  endedTimelineFn: c,
  dataFn: u,
  doneFn: f,
  onTransmuxerLog: m,
  triggerSegmentEventFn: _
}) => {
  _({
    type: "segmentdecryptionstart"
  }), eT({
    id: e.requestId,
    key: e.key,
    encryptedBytes: e.encryptedBytes,
    decryptionWorker: t,
    segment: e,
    doneFn: f
  }, (T) => {
    e.bytes = T, _({
      type: "segmentdecryptioncomplete",
      segment: e
    }), J_({
      segment: e,
      bytes: e.bytes,
      trackInfoFn: n,
      timingInfoFn: a,
      videoSegmentTimingInfoFn: i,
      audioSegmentTimingInfoFn: r,
      id3Fn: s,
      captionsFn: o,
      isEndOfTimeline: l,
      endedTimelineFn: c,
      dataFn: u,
      doneFn: f,
      onTransmuxerLog: m,
      triggerSegmentEventFn: _
    });
  });
}, die = ({
  activeXhrs: t,
  decryptionWorker: e,
  trackInfoFn: n,
  timingInfoFn: a,
  videoSegmentTimingInfoFn: i,
  audioSegmentTimingInfoFn: r,
  id3Fn: s,
  captionsFn: o,
  isEndOfTimeline: l,
  endedTimelineFn: c,
  dataFn: u,
  doneFn: f,
  onTransmuxerLog: m,
  triggerSegmentEventFn: _
}) => {
  let T = 0, g = !1;
  return (x, S) => {
    if (!g) {
      if (x)
        return g = !0, $h(t), f(x, S);
      if (T += 1, T === t.length) {
        const D = function() {
          if (S.encryptedBytes)
            return uie({
              decryptionWorker: e,
              segment: S,
              trackInfoFn: n,
              timingInfoFn: a,
              videoSegmentTimingInfoFn: i,
              audioSegmentTimingInfoFn: r,
              id3Fn: s,
              captionsFn: o,
              isEndOfTimeline: l,
              endedTimelineFn: c,
              dataFn: u,
              doneFn: f,
              onTransmuxerLog: m,
              triggerSegmentEventFn: _
            });
          J_({
            segment: S,
            bytes: S.bytes,
            trackInfoFn: n,
            timingInfoFn: a,
            videoSegmentTimingInfoFn: i,
            audioSegmentTimingInfoFn: r,
            id3Fn: s,
            captionsFn: o,
            isEndOfTimeline: l,
            endedTimelineFn: c,
            dataFn: u,
            doneFn: f,
            onTransmuxerLog: m,
            triggerSegmentEventFn: _
          });
        };
        if (S.endOfAllRequests = Date.now(), S.map && S.map.encryptedBytes && !S.map.bytes)
          return _({
            type: "segmentdecryptionstart",
            segment: S
          }), eT({
            decryptionWorker: e,
            // add -init to the "id" to differentiate between segment
            // and init segment decryption, just in case they happen
            // at the same time at some point in the future.
            id: S.requestId + "-init",
            encryptedBytes: S.map.encryptedBytes,
            key: S.map.key,
            segment: S,
            doneFn: f
          }, (L) => {
            S.map.bytes = L, _({
              type: "segmentdecryptioncomplete",
              segment: S
            }), Q_(S, (M) => {
              if (M)
                return $h(t), f(M, S);
              D();
            });
          });
        D();
      }
    }
  };
}, hie = ({
  loadendState: t,
  abortFn: e
}) => (n) => {
  n.target.aborted && e && !t.calledAbortFn && (e(), t.calledAbortFn = !0);
}, fie = ({
  segment: t,
  progressFn: e,
  trackInfoFn: n,
  timingInfoFn: a,
  videoSegmentTimingInfoFn: i,
  audioSegmentTimingInfoFn: r,
  id3Fn: s,
  captionsFn: o,
  isEndOfTimeline: l,
  endedTimelineFn: c,
  dataFn: u
}) => (f) => {
  if (!f.target.aborted)
    return t.stats = gt(t.stats, iie(f)), !t.stats.firstBytesReceivedAt && t.stats.bytesReceived && (t.stats.firstBytesReceivedAt = Date.now()), e(f, t);
}, pie = ({
  xhr: t,
  xhrOptions: e,
  decryptionWorker: n,
  segment: a,
  abortFn: i,
  progressFn: r,
  trackInfoFn: s,
  timingInfoFn: o,
  videoSegmentTimingInfoFn: l,
  audioSegmentTimingInfoFn: c,
  id3Fn: u,
  captionsFn: f,
  isEndOfTimeline: m,
  endedTimelineFn: _,
  dataFn: T,
  doneFn: g,
  onTransmuxerLog: x,
  triggerSegmentEventFn: S
}) => {
  const D = [], L = die({
    activeXhrs: D,
    decryptionWorker: n,
    trackInfoFn: s,
    timingInfoFn: o,
    videoSegmentTimingInfoFn: l,
    audioSegmentTimingInfoFn: c,
    id3Fn: u,
    captionsFn: f,
    isEndOfTimeline: m,
    endedTimelineFn: _,
    dataFn: T,
    doneFn: g,
    onTransmuxerLog: x,
    triggerSegmentEventFn: S
  });
  if (a.key && !a.key.bytes) {
    const z = [a.key];
    a.map && !a.map.bytes && a.map.key && a.map.key.resolvedUri === a.key.resolvedUri && z.push(a.map.key);
    const W = gt(e, {
      uri: a.key.resolvedUri,
      responseType: "arraybuffer",
      requestType: "segment-key"
    }), V = Mb(a, z, L, S), H = {
      uri: a.key.resolvedUri
    };
    S({
      type: "segmentkeyloadstart",
      segment: a,
      keyInfo: H
    });
    const se = t(W, V);
    D.push(se);
  }
  if (a.map && !a.map.bytes) {
    if (a.map.key && (!a.key || a.key.resolvedUri !== a.map.key.resolvedUri)) {
      const se = gt(e, {
        uri: a.map.key.resolvedUri,
        responseType: "arraybuffer",
        requestType: "segment-key"
      }), ie = Mb(a, [a.map.key], L, S), Z = {
        uri: a.map.key.resolvedUri
      };
      S({
        type: "segmentkeyloadstart",
        segment: a,
        keyInfo: Z
      });
      const $ = t(se, ie);
      D.push($);
    }
    const W = gt(e, {
      uri: a.map.resolvedUri,
      responseType: "arraybuffer",
      headers: Rh(a.map),
      requestType: "segment-media-initialization"
    }), V = oie({
      segment: a,
      finishProcessingFn: L,
      triggerSegmentEventFn: S
    });
    S({
      type: "segmentloadstart",
      segment: a
    });
    const H = t(W, V);
    D.push(H);
  }
  const M = gt(e, {
    uri: a.part && a.part.resolvedUri || a.resolvedUri,
    responseType: "arraybuffer",
    headers: Rh(a),
    requestType: "segment"
  }), E = lie({
    segment: a,
    finishProcessingFn: L,
    responseType: M.responseType,
    triggerSegmentEventFn: S
  });
  S({
    type: "segmentloadstart",
    segment: a
  });
  const P = t(M, E);
  P.addEventListener("progress", fie({
    segment: a,
    progressFn: r,
    trackInfoFn: s,
    timingInfoFn: o,
    videoSegmentTimingInfoFn: l,
    audioSegmentTimingInfoFn: c,
    id3Fn: u,
    captionsFn: f,
    isEndOfTimeline: m,
    endedTimelineFn: _,
    dataFn: T
  })), D.push(P);
  const B = {};
  return D.forEach((z) => {
    z.addEventListener("loadend", hie({
      loadendState: B,
      abortFn: i
    }));
  }), () => $h(D);
}, mie = Ca("CodecUtils"), gie = function(t) {
  const e = t.attributes || {};
  if (e.CODECS)
    return ja(e.CODECS);
}, tT = (t, e) => {
  const n = e.attributes || {};
  return t && t.mediaGroups && t.mediaGroups.AUDIO && n.AUDIO && t.mediaGroups.AUDIO[n.AUDIO];
}, bie = (t, e) => {
  if (!tT(t, e))
    return !0;
  const n = e.attributes || {}, a = t.mediaGroups.AUDIO[n.AUDIO];
  for (const i in a)
    if (!a[i].uri && !a[i].playlists)
      return !0;
  return !1;
}, Ru = function(t) {
  const e = {};
  return t.forEach(({
    mediaType: n,
    type: a,
    details: i
  }) => {
    e[n] = e[n] || [], e[n].push(h5(`${a}${i}`));
  }), Object.keys(e).forEach(function(n) {
    if (e[n].length > 1) {
      mie(`multiple ${n} codecs found as attributes: ${e[n].join(", ")}. Setting playlist codecs to null so that we wait for mux.js to probe segments for real codecs.`), e[n] = null;
      return;
    }
    e[n] = e[n][0];
  }), e;
}, Ob = function(t) {
  let e = 0;
  return t.audio && e++, t.video && e++, e;
}, gl = function(t, e) {
  const n = e.attributes || {}, a = Ru(gie(e) || []);
  if (tT(t, e) && !a.audio && !bie(t, e)) {
    const i = Ru(MJ(t, n.AUDIO) || []);
    i.audio && (a.audio = i.audio);
  }
  return a;
}, Nc = Ca("PlaylistSelector"), Pb = function(t) {
  if (!t || !t.playlist)
    return;
  const e = t.playlist;
  return JSON.stringify({
    id: e.id,
    bandwidth: t.bandwidth,
    width: t.width,
    height: t.height,
    codecs: e.attributes && e.attributes.CODECS || ""
  });
}, Nu = function(t, e) {
  if (!t)
    return "";
  const n = j.getComputedStyle(t);
  return n ? n[e] : "";
}, As = function(t, e) {
  const n = t.slice();
  t.sort(function(a, i) {
    const r = e(a, i);
    return r === 0 ? n.indexOf(a) - n.indexOf(i) : r;
  });
}, Pp = function(t, e) {
  let n, a;
  return t.attributes.BANDWIDTH && (n = t.attributes.BANDWIDTH), n = n || j.Number.MAX_VALUE, e.attributes.BANDWIDTH && (a = e.attributes.BANDWIDTH), a = a || j.Number.MAX_VALUE, n - a;
}, vie = function(t, e) {
  let n, a;
  return t.attributes.RESOLUTION && t.attributes.RESOLUTION.width && (n = t.attributes.RESOLUTION.width), n = n || j.Number.MAX_VALUE, e.attributes.RESOLUTION && e.attributes.RESOLUTION.width && (a = e.attributes.RESOLUTION.width), a = a || j.Number.MAX_VALUE, n === a && t.attributes.BANDWIDTH && e.attributes.BANDWIDTH ? t.attributes.BANDWIDTH - e.attributes.BANDWIDTH : n - a;
};
let nT = function(t, e, n, a, i, r) {
  if (!t)
    return;
  const s = {
    bandwidth: e,
    width: n,
    height: a,
    limitRenditionByPlayerDimensions: i
  };
  let o = t.playlists;
  Kn.isAudioOnly(t) && (o = r.getAudioTrackPlaylists_(), s.audioOnly = !0);
  let l = o.map((E) => {
    let P;
    const B = E.attributes && E.attributes.RESOLUTION && E.attributes.RESOLUTION.width, z = E.attributes && E.attributes.RESOLUTION && E.attributes.RESOLUTION.height;
    return P = E.attributes && E.attributes.BANDWIDTH, P = P || j.Number.MAX_VALUE, {
      bandwidth: P,
      width: B,
      height: z,
      playlist: E
    };
  });
  As(l, (E, P) => E.bandwidth - P.bandwidth), l = l.filter((E) => !Kn.isIncompatible(E.playlist));
  let c = l.filter((E) => Kn.isEnabled(E.playlist));
  c.length || (c = l.filter((E) => !Kn.isDisabled(E.playlist)));
  const u = c.filter((E) => E.bandwidth * mn.BANDWIDTH_VARIANCE < e);
  let f = u[u.length - 1];
  const m = u.filter((E) => E.bandwidth === f.bandwidth)[0];
  if (i === !1) {
    const E = m || c[0] || l[0];
    if (E && E.playlist) {
      let P = "sortedPlaylistReps";
      return m && (P = "bandwidthBestRep"), c[0] && (P = "enabledPlaylistReps"), Nc(`choosing ${Pb(E)} using ${P} with options`, s), E.playlist;
    }
    return Nc("could not choose a playlist with options", s), null;
  }
  const _ = u.filter((E) => E.width && E.height);
  As(_, (E, P) => E.width - P.width);
  const T = _.filter((E) => E.width === n && E.height === a);
  f = T[T.length - 1];
  const g = T.filter((E) => E.bandwidth === f.bandwidth)[0];
  let x, S, D;
  g || (x = _.filter((E) => E.width > n || E.height > a), S = x.filter((E) => E.width === x[0].width && E.height === x[0].height), f = S[S.length - 1], D = S.filter((E) => E.bandwidth === f.bandwidth)[0]);
  let L;
  if (r.leastPixelDiffSelector) {
    const E = _.map((P) => (P.pixelDiff = Math.abs(P.width - n) + Math.abs(P.height - a), P));
    As(E, (P, B) => P.pixelDiff === B.pixelDiff ? B.bandwidth - P.bandwidth : P.pixelDiff - B.pixelDiff), L = E[0];
  }
  const M = L || D || g || m || c[0] || l[0];
  if (M && M.playlist) {
    let E = "sortedPlaylistReps";
    return L ? E = "leastPixelDiffRep" : D ? E = "resolutionPlusOneRep" : g ? E = "resolutionBestRep" : m ? E = "bandwidthBestRep" : c[0] && (E = "enabledPlaylistReps"), Nc(`choosing ${Pb(M)} using ${E} with options`, s), M.playlist;
  }
  return Nc("could not choose a playlist with options", s), null;
};
const Bb = function() {
  let t = this.useDevicePixelRatio && j.devicePixelRatio || 1;
  return isNaN(this.customPixelRatio) || (t = this.customPixelRatio), nT(this.playlists.main, this.systemBandwidth, parseInt(Nu(this.tech_.el(), "width"), 10) * t, parseInt(Nu(this.tech_.el(), "height"), 10) * t, this.limitRenditionByPlayerDimensions, this.playlistController_);
}, yie = function(t) {
  let e = -1, n = -1;
  if (t < 0 || t > 1)
    throw new Error("Moving average bandwidth decay must be between 0 and 1.");
  return function() {
    let a = this.useDevicePixelRatio && j.devicePixelRatio || 1;
    return isNaN(this.customPixelRatio) || (a = this.customPixelRatio), e < 0 && (e = this.systemBandwidth, n = this.systemBandwidth), this.systemBandwidth > 0 && this.systemBandwidth !== n && (e = t * this.systemBandwidth + (1 - t) * e, n = this.systemBandwidth), nT(this.playlists.main, e, parseInt(Nu(this.tech_.el(), "width"), 10) * a, parseInt(Nu(this.tech_.el(), "height"), 10) * a, this.limitRenditionByPlayerDimensions, this.playlistController_);
  };
}, _ie = function(t) {
  const {
    main: e,
    currentTime: n,
    bandwidth: a,
    duration: i,
    segmentDuration: r,
    timeUntilRebuffer: s,
    currentTimeline: o,
    syncController: l
  } = t, c = e.playlists.filter((T) => !Kn.isIncompatible(T));
  let u = c.filter(Kn.isEnabled);
  u.length || (u = c.filter((T) => !Kn.isDisabled(T)));
  const m = u.filter(Kn.hasAttribute.bind(null, "BANDWIDTH")).map((T) => {
    const x = l.getSyncPoint(T, i, o, n) ? 1 : 2, D = Kn.estimateSegmentRequestTime(r, a, T) * x - s;
    return {
      playlist: T,
      rebufferingImpact: D
    };
  }), _ = m.filter((T) => T.rebufferingImpact <= 0);
  return As(_, (T, g) => Pp(g.playlist, T.playlist)), _.length ? _[0] : (As(m, (T, g) => T.rebufferingImpact - g.rebufferingImpact), m[0] || null);
}, Tie = function() {
  const t = this.playlists.main.playlists.filter(Kn.isEnabled);
  return As(t, (n, a) => Pp(n, a)), t.filter((n) => !!gl(this.playlists.main, n).video)[0] || null;
}, xie = (t) => {
  let e = 0, n;
  return t.bytes && (n = new Uint8Array(t.bytes), t.segments.forEach((a) => {
    n.set(a, e), e += a.byteLength;
  })), n;
};
function aT(t) {
  try {
    return new URL(t).pathname.split("/").slice(-2).join("/");
  } catch {
    return "";
  }
}
const wie = function(t, e, n) {
  if (!t[n]) {
    e.trigger({
      type: "usage",
      name: "vhs-608"
    });
    let a = n;
    /^cc708_/.test(n) && (a = "SERVICE" + n.split("_")[1]);
    const i = e.textTracks().getTrackById(a);
    if (i)
      t[n] = i;
    else {
      const r = e.options_.vhs && e.options_.vhs.captionServices || {};
      let s = n, o = n, l = !1;
      const c = r[a];
      c && (s = c.label, o = c.language, l = c.default), t[n] = e.addRemoteTextTrack({
        kind: "captions",
        id: a,
        // TODO: investigate why this doesn't seem to turn the caption on by default
        default: l,
        label: s,
        language: o
      }, !1).track;
    }
  }
}, kie = function({
  inbandTextTracks: t,
  captionArray: e,
  timestampOffset: n
}) {
  if (!e)
    return;
  const a = j.WebKitDataCue || j.VTTCue;
  e.forEach((i) => {
    const r = i.stream;
    i.content ? i.content.forEach((s) => {
      const o = new a(i.startTime + n, i.endTime + n, s.text);
      o.line = s.line, o.align = "left", o.position = s.position, o.positionAlign = "line-left", t[r].addCue(o);
    }) : t[r].addCue(new a(i.startTime + n, i.endTime + n, i.text));
  });
}, Cie = function(t) {
  Object.defineProperties(t.frame, {
    id: {
      get() {
        return ce.log.warn("cue.frame.id is deprecated. Use cue.value.key instead."), t.value.key;
      }
    },
    value: {
      get() {
        return ce.log.warn("cue.frame.value is deprecated. Use cue.value.data instead."), t.value.data;
      }
    },
    privateData: {
      get() {
        return ce.log.warn("cue.frame.privateData is deprecated. Use cue.value.data instead."), t.value.data;
      }
    }
  });
}, Sie = ({
  inbandTextTracks: t,
  metadataArray: e,
  timestampOffset: n,
  videoDuration: a
}) => {
  if (!e)
    return;
  const i = j.WebKitDataCue || j.VTTCue, r = t.metadataTrack_;
  if (!r || (e.forEach((u) => {
    const f = u.cueTime + n;
    typeof f != "number" || j.isNaN(f) || f < 0 || !(f < 1 / 0) || !u.frames || !u.frames.length || u.frames.forEach((m) => {
      const _ = new i(f, f, m.value || m.url || m.data || "");
      _.frame = m, _.value = m, Cie(_), r.addCue(_);
    });
  }), !r.cues || !r.cues.length))
    return;
  const s = r.cues, o = [];
  for (let u = 0; u < s.length; u++)
    s[u] && o.push(s[u]);
  const l = o.reduce((u, f) => {
    const m = u[f.startTime] || [];
    return m.push(f), u[f.startTime] = m, u;
  }, {}), c = Object.keys(l).sort((u, f) => Number(u) - Number(f));
  c.forEach((u, f) => {
    const m = l[u], _ = isFinite(a) ? a : u, T = Number(c[f + 1]) || _;
    m.forEach((g) => {
      g.endTime = T;
    });
  });
}, Aie = {
  id: "ID",
  class: "CLASS",
  startDate: "START-DATE",
  duration: "DURATION",
  endDate: "END-DATE",
  endOnNext: "END-ON-NEXT",
  plannedDuration: "PLANNED-DURATION",
  scte35Out: "SCTE35-OUT",
  scte35In: "SCTE35-IN"
}, Eie = /* @__PURE__ */ new Set(["id", "class", "startDate", "duration", "endDate", "endOnNext", "startTime", "endTime", "processDateRange"]), Lie = ({
  inbandTextTracks: t,
  dateRanges: e
}) => {
  const n = t.metadataTrack_;
  if (!n)
    return;
  const a = j.WebKitDataCue || j.VTTCue;
  e.forEach((i) => {
    for (const r of Object.keys(i)) {
      if (Eie.has(r))
        continue;
      const s = new a(i.startTime, i.endTime, "");
      s.id = i.id, s.type = "com.apple.quicktime.HLS", s.value = {
        key: Aie[r],
        data: i[r]
      }, (r === "scte35Out" || r === "scte35In") && (s.value.data = new Uint8Array(s.value.data.match(/[\da-f]{2}/gi)).buffer), n.addCue(s);
    }
    i.processDateRange();
  });
}, Rb = (t, e, n) => {
  t.metadataTrack_ || (t.metadataTrack_ = n.addRemoteTextTrack({
    kind: "metadata",
    label: "Timed Metadata"
  }, !1).track, ce.browser.IS_ANY_SAFARI || (t.metadataTrack_.inBandMetadataTrackDispatchType = e));
}, il = function(t, e, n) {
  let a, i;
  if (n && n.cues)
    for (a = n.cues.length; a--; )
      i = n.cues[a], i.startTime >= t && i.endTime <= e && n.removeCue(i);
}, Die = function(t) {
  const e = t.cues;
  if (!e)
    return;
  const n = {};
  for (let a = e.length - 1; a >= 0; a--) {
    const i = e[a], r = `${i.startTime}-${i.endTime}-${i.text}`;
    n[r] ? t.removeCue(i) : n[r] = i;
  }
}, Iie = (t, e, n) => {
  if (typeof e > "u" || e === null || !t.length)
    return [];
  const a = Math.ceil((e - n + 3) * Cr.ONE_SECOND_IN_TS);
  let i;
  for (i = 0; i < t.length && !(t[i].pts > a); i++)
    ;
  return t.slice(i);
}, Mie = (t, e, n) => {
  if (!e.length)
    return t;
  if (n)
    return e.slice();
  const a = e[0].pts;
  let i = 0;
  for (i; i < t.length && !(t[i].pts >= a); i++)
    ;
  return t.slice(0, i).concat(e);
}, Oie = (t, e, n, a) => {
  const i = Math.ceil((e - a) * Cr.ONE_SECOND_IN_TS), r = Math.ceil((n - a) * Cr.ONE_SECOND_IN_TS), s = t.slice();
  let o = t.length;
  for (; o-- && !(t[o].pts <= r); )
    ;
  if (o === -1)
    return s;
  let l = o + 1;
  for (; l-- && !(t[l].pts <= i); )
    ;
  return l = Math.max(l, 0), s.splice(l, o - l + 1), s;
}, Pie = function(t, e) {
  if (!t && !e || !t && e || t && !e)
    return !1;
  if (t === e)
    return !0;
  const n = Object.keys(t).sort(), a = Object.keys(e).sort();
  if (n.length !== a.length)
    return !1;
  for (let i = 0; i < n.length; i++) {
    const r = n[i];
    if (r !== a[i] || t[r] !== e[r])
      return !1;
  }
  return !0;
}, Bie = function(t, e, n) {
  e = e || [];
  const a = [];
  let i = 0;
  for (let r = 0; r < e.length; r++) {
    const s = e[r];
    if (t === s.timeline && (a.push(r), i += s.duration, i > n))
      return r;
  }
  return a.length === 0 ? 0 : a[a.length - 1];
}, Xo = 1, Rie = 500, Nb = (t) => typeof t == "number" && isFinite(t), $c = 1 / 60, Nie = (t, e, n) => t !== "main" || !e || !n ? null : !n.hasAudio && !n.hasVideo ? "Neither audio nor video found in segment." : e.hasVideo && !n.hasVideo ? "Only audio found in segment when we expected video. We can't switch to audio only from a stream that had video. To get rid of this message, please add codec information to the manifest." : !e.hasVideo && n.hasVideo ? "Video found in segment when we expected only audio. We can't switch to a stream with video from an audio only stream. To get rid of this message, please add codec information to the manifest." : null, $ie = (t, e, n) => {
  let a = e - mn.BACK_BUFFER_LENGTH;
  t.length && (a = Math.max(a, t.start(0)));
  const i = e - n;
  return Math.min(i, a);
}, ls = (t) => {
  const {
    startOfSegment: e,
    duration: n,
    segment: a,
    part: i,
    playlist: {
      mediaSequence: r,
      id: s,
      segments: o = []
    },
    mediaIndex: l,
    partIndex: c,
    timeline: u
  } = t, f = o.length - 1;
  let m = "mediaIndex/partIndex increment";
  t.getMediaInfoForTime ? m = `getMediaInfoForTime (${t.getMediaInfoForTime})` : t.isSyncRequest && (m = "getSyncSegmentCandidate (isSyncRequest)"), t.independent && (m += ` with independent ${t.independent}`);
  const _ = typeof c == "number", T = t.segment.uri ? "segment" : "pre-segment", g = _ ? x_({
    preloadSegment: a
  }) - 1 : 0;
  return `${T} [${r + l}/${r + f}]` + (_ ? ` part [${c}/${g}]` : "") + ` segment start/end [${a.start} => ${a.end}]` + (_ ? ` part start/end [${i.start} => ${i.end}]` : "") + ` startOfSegment [${e}] duration [${n}] timeline [${u}] selected by [${m}] playlist [${s}]`;
}, $b = (t) => `${t}TimingInfo`, Fie = ({
  segmentTimeline: t,
  currentTimeline: e,
  startOfSegment: n,
  buffered: a,
  overrideCheck: i
}) => !i && t === e ? null : t < e ? n : a.length ? a.end(a.length - 1) : n, Fh = ({
  timelineChangeController: t,
  currentTimeline: e,
  segmentTimeline: n,
  loaderType: a,
  audioDisabled: i
}) => {
  if (e === n)
    return !1;
  if (a === "audio") {
    const r = t.lastTimelineChange({
      type: "main"
    });
    return !r || r.to !== n;
  }
  if (a === "main" && i) {
    const r = t.pendingTimelineChange({
      type: "audio"
    });
    return !(r && r.to === n);
  }
  return !1;
}, zie = (t) => {
  if (!t)
    return !1;
  const e = t.pendingTimelineChange({
    type: "audio"
  }), n = t.pendingTimelineChange({
    type: "main"
  }), a = e && n, i = a && e.to !== n.to;
  return !!(a && e.from !== -1 && n.from !== -1 && i);
}, Uie = (t) => {
  const e = t.timelineChangeController_.pendingTimelineChange({
    type: "audio"
  }), n = t.timelineChangeController_.pendingTimelineChange({
    type: "main"
  });
  return e && n && e.to < n.to;
}, ji = (t) => {
  const e = t.pendingSegment_;
  if (!e)
    return;
  if (Fh({
    timelineChangeController: t.timelineChangeController_,
    currentTimeline: t.currentTimeline_,
    segmentTimeline: e.timeline,
    loaderType: t.loaderType_,
    audioDisabled: t.audioDisabled_
  }) && zie(t.timelineChangeController_)) {
    if (Uie(t)) {
      t.timelineChangeController_.trigger("audioTimelineBehind");
      return;
    }
    t.timelineChangeController_.trigger("fixBadTimelineChange");
  }
}, Hie = (t) => {
  let e = 0;
  return ["video", "audio"].forEach(function(n) {
    const a = t[`${n}TimingInfo`];
    if (!a)
      return;
    const {
      start: i,
      end: r
    } = a;
    let s;
    typeof i == "bigint" || typeof r == "bigint" ? s = j.BigInt(r) - j.BigInt(i) : typeof i == "number" && typeof r == "number" && (s = r - i), typeof s < "u" && s > e && (e = s);
  }), typeof e == "bigint" && e < Number.MAX_SAFE_INTEGER && (e = Number(e)), e;
}, Fb = ({
  segmentDuration: t,
  maxDuration: e
}) => t ? Math.round(t) > e + Za : !1, Yie = (t, e) => {
  if (e !== "hls")
    return null;
  const n = Hie({
    audioTimingInfo: t.audioTimingInfo,
    videoTimingInfo: t.videoTimingInfo
  });
  if (!n)
    return null;
  const a = t.playlist.targetDuration, i = Fb({
    segmentDuration: n,
    maxDuration: a * 2
  }), r = Fb({
    segmentDuration: n,
    maxDuration: a
  }), s = `Segment with index ${t.mediaIndex} from playlist ${t.playlist.id} has a duration of ${n} when the reported duration is ${t.duration} and the target duration is ${a}. For HLS content, a duration in excess of the target duration may result in playback issues. See the HLS specification section on EXT-X-TARGETDURATION for more details: https://tools.ietf.org/html/draft-pantos-http-live-streaming-23#section-4.3.3.1`;
  return i || r ? {
    severity: i ? "warn" : "info",
    message: s
  } : null;
}, Tr = ({
  type: t,
  segment: e
}) => {
  if (!e)
    return;
  const n = !!(e.key || e.map && e.map.ke), a = !!(e.map && !e.map.bytes), i = e.startOfSegment === void 0 ? e.start : e.startOfSegment;
  return {
    type: t || e.type,
    uri: e.resolvedUri || e.uri,
    start: i,
    duration: e.duration,
    isEncrypted: n,
    isMediaInitialization: a
  };
};
class zh extends ce.EventTarget {
  constructor(e, n = {}) {
    if (super(), !e)
      throw new TypeError("Initialization settings are required");
    if (typeof e.currentTime != "function")
      throw new TypeError("No currentTime getter specified");
    if (!e.mediaSource)
      throw new TypeError("No MediaSource specified");
    this.bandwidth = e.bandwidth, this.throughput = {
      rate: 0,
      count: 0
    }, this.roundTrip = NaN, this.resetStats_(), this.mediaIndex = null, this.partIndex = null, this.hasPlayed_ = e.hasPlayed, this.currentTime_ = e.currentTime, this.seekable_ = e.seekable, this.seeking_ = e.seeking, this.duration_ = e.duration, this.mediaSource_ = e.mediaSource, this.vhs_ = e.vhs, this.loaderType_ = e.loaderType, this.currentMediaInfo_ = void 0, this.startingMediaInfo_ = void 0, this.segmentMetadataTrack_ = e.segmentMetadataTrack, this.goalBufferLength_ = e.goalBufferLength, this.sourceType_ = e.sourceType, this.sourceUpdater_ = e.sourceUpdater, this.inbandTextTracks_ = e.inbandTextTracks, this.state_ = "INIT", this.timelineChangeController_ = e.timelineChangeController, this.shouldSaveSegmentTimingInfo_ = !0, this.parse708captions_ = e.parse708captions, this.useDtsForTimestampOffset_ = e.useDtsForTimestampOffset, this.captionServices_ = e.captionServices, this.exactManifestTimings = e.exactManifestTimings, this.addMetadataToTextTrack = e.addMetadataToTextTrack, this.checkBufferTimeout_ = null, this.error_ = void 0, this.currentTimeline_ = -1, this.shouldForceTimestampOffsetAfterResync_ = !1, this.pendingSegment_ = null, this.xhrOptions_ = null, this.pendingSegments_ = [], this.audioDisabled_ = !1, this.isPendingTimestampOffset_ = !1, this.gopBuffer_ = [], this.timeMapping_ = 0, this.safeAppend_ = !1, this.appendInitSegment_ = {
      audio: !0,
      video: !0
    }, this.playlistOfLastInitSegment_ = {
      audio: null,
      video: null
    }, this.callQueue_ = [], this.loadQueue_ = [], this.metadataQueue_ = {
      id3: [],
      caption: []
    }, this.waitingOnRemove_ = !1, this.quotaExceededErrorRetryTimeout_ = null, this.activeInitSegmentId_ = null, this.initSegments_ = {}, this.cacheEncryptionKeys_ = e.cacheEncryptionKeys, this.keyCache_ = {}, this.decrypter_ = e.decrypter, this.syncController_ = e.syncController, this.syncPoint_ = {
      segmentIndex: 0,
      time: 0
    }, this.transmuxer_ = this.createTransmuxer_(), this.triggerSyncInfoUpdate_ = () => this.trigger("syncinfoupdate"), this.syncController_.on("syncinfoupdate", this.triggerSyncInfoUpdate_), this.mediaSource_.addEventListener("sourceopen", () => {
      this.isEndOfStream_() || (this.ended_ = !1);
    }), this.fetchAtBuffer_ = !1, this.logger_ = Ca(`SegmentLoader[${this.loaderType_}]`), Object.defineProperty(this, "state", {
      get() {
        return this.state_;
      },
      set(a) {
        a !== this.state_ && (this.logger_(`${this.state_} -> ${a}`), this.state_ = a, this.trigger("statechange"));
      }
    }), this.sourceUpdater_.on("ready", () => {
      this.hasEnoughInfoToAppend_() ? this.processCallQueue_() : ji(this);
    }), this.sourceUpdater_.on("codecschange", (a) => {
      this.trigger(Jt({
        type: "codecschange"
      }, a));
    }), this.loaderType_ === "main" && this.timelineChangeController_.on("pendingtimelinechange", () => {
      this.hasEnoughInfoToAppend_() ? this.processCallQueue_() : ji(this);
    }), this.loaderType_ === "audio" && this.timelineChangeController_.on("timelinechange", (a) => {
      this.trigger(Jt({
        type: "timelinechange"
      }, a)), this.hasEnoughInfoToLoad_() ? this.processLoadQueue_() : ji(this), this.hasEnoughInfoToAppend_() ? this.processCallQueue_() : ji(this);
    });
  }
  /**
   * TODO: Current sync controller consists of many hls-specific strategies
   * media sequence sync is also hls-specific, and we would like to be protocol-agnostic on this level
   * this should be a part of the sync-controller and sync controller should expect different strategy list based on the protocol.
   *
   * @return {MediaSequenceSync|null}
   * @private
   */
  get mediaSequenceSync_() {
    return this.syncController_.getMediaSequenceSync(this.loaderType_);
  }
  createTransmuxer_() {
    return U0.createTransmuxer({
      remux: !1,
      alignGopsAtEnd: this.safeAppend_,
      keepOriginalTimestamps: !0,
      parse708captions: this.parse708captions_,
      captionServices: this.captionServices_
    });
  }
  /**
   * reset all of our media stats
   *
   * @private
   */
  resetStats_() {
    this.mediaBytesTransferred = 0, this.mediaRequests = 0, this.mediaRequestsAborted = 0, this.mediaRequestsTimedout = 0, this.mediaRequestsErrored = 0, this.mediaTransferDuration = 0, this.mediaSecondsLoaded = 0, this.mediaAppends = 0;
  }
  /**
   * dispose of the SegmentLoader and reset to the default state
   */
  dispose() {
    this.trigger("dispose"), this.state = "DISPOSED", this.pause(), this.abort_(), this.transmuxer_ && this.transmuxer_.terminate(), this.resetStats_(), this.checkBufferTimeout_ && j.clearTimeout(this.checkBufferTimeout_), this.syncController_ && this.triggerSyncInfoUpdate_ && this.syncController_.off("syncinfoupdate", this.triggerSyncInfoUpdate_), this.off();
  }
  setAudio(e) {
    this.audioDisabled_ = !e, e ? this.appendInitSegment_.audio = !0 : this.sourceUpdater_.removeAudio(0, this.duration_());
  }
  /**
   * abort anything that is currently doing on with the SegmentLoader
   * and reset to a default state
   */
  abort() {
    if (this.state !== "WAITING") {
      this.pendingSegment_ && (this.pendingSegment_ = null), this.timelineChangeController_.clearPendingTimelineChange(this.loaderType_);
      return;
    }
    this.abort_(), this.state = "READY", this.paused() || this.monitorBuffer_();
  }
  /**
   * abort all pending xhr requests and null any pending segements
   *
   * @private
   */
  abort_() {
    this.pendingSegment_ && this.pendingSegment_.abortRequests && this.pendingSegment_.abortRequests(), this.pendingSegment_ = null, this.callQueue_ = [], this.loadQueue_ = [], this.metadataQueue_.id3 = [], this.metadataQueue_.caption = [], this.timelineChangeController_.clearPendingTimelineChange(this.loaderType_), this.waitingOnRemove_ = !1, j.clearTimeout(this.quotaExceededErrorRetryTimeout_), this.quotaExceededErrorRetryTimeout_ = null;
  }
  checkForAbort_(e) {
    return this.state === "APPENDING" && !this.pendingSegment_ ? (this.state = "READY", !0) : !this.pendingSegment_ || this.pendingSegment_.requestId !== e;
  }
  /**
   * set an error on the segment loader and null out any pending segements
   *
   * @param {Error} error the error to set on the SegmentLoader
   * @return {Error} the error that was set or that is currently set
   */
  error(e) {
    return typeof e < "u" && (this.logger_("error occurred:", e), this.error_ = e), this.pendingSegment_ = null, this.error_;
  }
  endOfStream() {
    this.ended_ = !0, this.transmuxer_ && U0.reset(this.transmuxer_), this.gopBuffer_.length = 0, this.pause(), this.trigger("ended");
  }
  /**
   * Indicates which time ranges are buffered
   *
   * @return {TimeRange}
   *         TimeRange object representing the current buffered ranges
   */
  buffered_() {
    const e = this.getMediaInfo_();
    if (!this.sourceUpdater_ || !e)
      return vn();
    if (this.loaderType_ === "main") {
      const {
        hasAudio: n,
        hasVideo: a,
        isMuxed: i
      } = e;
      if (a && n && !this.audioDisabled_ && !i)
        return this.sourceUpdater_.buffered();
      if (a)
        return this.sourceUpdater_.videoBuffered();
    }
    return this.sourceUpdater_.audioBuffered();
  }
  /**
   * Gets and sets init segment for the provided map
   *
   * @param {Object} map
   *        The map object representing the init segment to get or set
   * @param {boolean=} set
   *        If true, the init segment for the provided map should be saved
   * @return {Object}
   *         map object for desired init segment
   */
  initSegmentForMap(e, n = !1) {
    if (!e)
      return null;
    const a = Bu(e);
    let i = this.initSegments_[a];
    return n && !i && e.bytes && (this.initSegments_[a] = i = {
      resolvedUri: e.resolvedUri,
      byterange: e.byterange,
      bytes: e.bytes,
      tracks: e.tracks,
      timescales: e.timescales
    }), i || e;
  }
  /**
   * Gets and sets key for the provided key
   *
   * @param {Object} key
   *        The key object representing the key to get or set
   * @param {boolean=} set
   *        If true, the key for the provided key should be saved
   * @return {Object}
   *         Key object for desired key
   */
  segmentKey(e, n = !1) {
    if (!e)
      return null;
    const a = F_(e);
    let i = this.keyCache_[a];
    this.cacheEncryptionKeys_ && n && !i && e.bytes && (this.keyCache_[a] = i = {
      resolvedUri: e.resolvedUri,
      bytes: e.bytes
    });
    const r = {
      resolvedUri: (i || e).resolvedUri
    };
    return i && (r.bytes = i.bytes), r;
  }
  /**
   * Returns true if all configuration required for loading is present, otherwise false.
   *
   * @return {boolean} True if the all configuration is ready for loading
   * @private
   */
  couldBeginLoading_() {
    return this.playlist_ && !this.paused();
  }
  /**
   * load a playlist and start to fill the buffer
   */
  load() {
    if (this.monitorBuffer_(), !!this.playlist_) {
      if (this.state === "INIT" && this.couldBeginLoading_())
        return this.init_();
      !this.couldBeginLoading_() || this.state !== "READY" && this.state !== "INIT" || (this.state = "READY");
    }
  }
  /**
   * Once all the starting parameters have been specified, begin
   * operation. This method should only be invoked from the INIT
   * state.
   *
   * @private
   */
  init_() {
    return this.state = "READY", this.resetEverything(), this.monitorBuffer_();
  }
  /**
   * set a playlist on the segment loader
   *
   * @param {PlaylistLoader} media the playlist to set on the segment loader
   */
  playlist(e, n = {}) {
    if (!e || this.playlist_ && this.playlist_.endList && e.endList && this.playlist_.uri === e.uri)
      return;
    const a = this.playlist_, i = this.pendingSegment_;
    this.playlist_ = e, this.xhrOptions_ = n, this.state === "INIT" && (e.syncInfo = {
      mediaSequence: e.mediaSequence,
      time: 0
    }, this.loaderType_ === "main" && this.syncController_.setDateTimeMappingForStart(e));
    let r = null;
    if (a && (a.id ? r = a.id : a.uri && (r = a.uri)), this.logger_(`playlist update [${r} => ${e.id || e.uri}]`), this.mediaSequenceSync_ && (this.mediaSequenceSync_.update(e, this.currentTime_()), this.logger_(`Playlist update:
currentTime: ${this.currentTime_()}
bufferedEnd: ${F0(this.buffered_())}
`, this.mediaSequenceSync_.diagnostics)), this.trigger("syncinfoupdate"), this.state === "INIT" && this.couldBeginLoading_())
      return this.init_();
    if (!a || a.uri !== e.uri) {
      this.mediaIndex !== null && (!e.endList && typeof e.partTargetDuration == "number" ? this.resetLoader() : this.resyncLoader()), this.currentMediaInfo_ = void 0, this.trigger("playlistupdate");
      return;
    }
    const s = e.mediaSequence - a.mediaSequence;
    if (this.logger_(`live window shift [${s}]`), this.mediaIndex !== null)
      if (this.mediaIndex -= s, this.mediaIndex < 0)
        this.mediaIndex = null, this.partIndex = null;
      else {
        const o = this.playlist_.segments[this.mediaIndex];
        if (this.partIndex && (!o.parts || !o.parts.length || !o.parts[this.partIndex])) {
          const l = this.mediaIndex;
          this.logger_(`currently processing part (index ${this.partIndex}) no longer exists.`), this.resetLoader(), this.mediaIndex = l;
        }
      }
    i && (i.mediaIndex -= s, i.mediaIndex < 0 ? (i.mediaIndex = null, i.partIndex = null) : (i.mediaIndex >= 0 && (i.segment = e.segments[i.mediaIndex]), i.partIndex >= 0 && i.segment.parts && (i.part = i.segment.parts[i.partIndex]))), this.syncController_.saveExpiredSegmentInfo(a, e);
  }
  /**
   * Prevent the loader from fetching additional segments. If there
   * is a segment request outstanding, it will finish processing
   * before the loader halts. A segment loader can be unpaused by
   * calling load().
   */
  pause() {
    this.checkBufferTimeout_ && (j.clearTimeout(this.checkBufferTimeout_), this.checkBufferTimeout_ = null);
  }
  /**
   * Returns whether the segment loader is fetching additional
   * segments when given the opportunity. This property can be
   * modified through calls to pause() and load().
   */
  paused() {
    return this.checkBufferTimeout_ === null;
  }
  /**
   * Delete all the buffered data and reset the SegmentLoader
   *
   * @param {Function} [done] an optional callback to be executed when the remove
   * operation is complete
   */
  resetEverything(e) {
    this.ended_ = !1, this.activeInitSegmentId_ = null, this.appendInitSegment_ = {
      audio: !0,
      video: !0
    }, this.resetLoader(), this.remove(0, 1 / 0, e), this.transmuxer_ && (this.transmuxer_.postMessage({
      action: "clearAllMp4Captions"
    }), this.transmuxer_.postMessage({
      action: "reset"
    }));
  }
  /**
   * Force the SegmentLoader to resync and start loading around the currentTime instead
   * of starting at the end of the buffer
   *
   * Useful for fast quality changes
   */
  resetLoader() {
    this.fetchAtBuffer_ = !1, this.mediaSequenceSync_ && this.mediaSequenceSync_.resetAppendedStatus(), this.resyncLoader();
  }
  /**
   * Force the SegmentLoader to restart synchronization and make a conservative guess
   * before returning to the simple walk-forward method
   */
  resyncLoader() {
    this.transmuxer_ && U0.reset(this.transmuxer_), this.mediaIndex = null, this.partIndex = null, this.syncPoint_ = null, this.isPendingTimestampOffset_ = !1;
    const e = this.currentMediaInfo_ && this.currentMediaInfo_.isFmp4;
    this.sourceType_ === "hls" && !e && (this.shouldForceTimestampOffsetAfterResync_ = !0), this.callQueue_ = [], this.loadQueue_ = [], this.metadataQueue_.id3 = [], this.metadataQueue_.caption = [], this.abort(), this.transmuxer_ && this.transmuxer_.postMessage({
      action: "clearParsedMp4Captions"
    });
  }
  /**
   * Remove any data in the source buffer between start and end times
   *
   * @param {number} start - the start time of the region to remove from the buffer
   * @param {number} end - the end time of the region to remove from the buffer
   * @param {Function} [done] - an optional callback to be executed when the remove
   * @param {boolean} force - force all remove operations to happen
   * operation is complete
   */
  remove(e, n, a = () => {
  }, i = !1) {
    if (n === 1 / 0 && (n = this.duration_()), n <= e) {
      this.logger_("skipping remove because end ${end} is <= start ${start}");
      return;
    }
    if (!this.sourceUpdater_ || !this.getMediaInfo_()) {
      this.logger_("skipping remove because no source updater or starting media info");
      return;
    }
    let r = 1;
    const s = () => {
      r--, r === 0 && a();
    };
    (i || !this.audioDisabled_) && (r++, this.sourceUpdater_.removeAudio(e, n, s)), (i || this.loaderType_ === "main") && (this.gopBuffer_ = Oie(this.gopBuffer_, e, n, this.timeMapping_), r++, this.sourceUpdater_.removeVideo(e, n, s));
    for (const o in this.inbandTextTracks_)
      il(e, n, this.inbandTextTracks_[o]);
    il(e, n, this.segmentMetadataTrack_), s();
  }
  /**
   * (re-)schedule monitorBufferTick_ to run as soon as possible
   *
   * @private
   */
  monitorBuffer_() {
    this.checkBufferTimeout_ && j.clearTimeout(this.checkBufferTimeout_), this.checkBufferTimeout_ = j.setTimeout(this.monitorBufferTick_.bind(this), 1);
  }
  /**
   * As long as the SegmentLoader is in the READY state, periodically
   * invoke fillBuffer_().
   *
   * @private
   */
  monitorBufferTick_() {
    this.state === "READY" && this.fillBuffer_(), this.checkBufferTimeout_ && j.clearTimeout(this.checkBufferTimeout_), this.checkBufferTimeout_ = j.setTimeout(this.monitorBufferTick_.bind(this), Rie);
  }
  /**
   * fill the buffer with segements unless the sourceBuffers are
   * currently updating
   *
   * Note: this function should only ever be called by monitorBuffer_
   * and never directly
   *
   * @private
   */
  fillBuffer_() {
    if (this.sourceUpdater_.updating())
      return;
    const e = this.chooseNextRequest_();
    if (!e)
      return;
    const n = {
      segmentInfo: Tr({
        type: this.loaderType_,
        segment: e
      })
    };
    this.trigger({
      type: "segmentselected",
      metadata: n
    }), typeof e.timestampOffset == "number" && (this.isPendingTimestampOffset_ = !1, this.timelineChangeController_.pendingTimelineChange({
      type: this.loaderType_,
      from: this.currentTimeline_,
      to: e.timeline
    })), this.loadSegment_(e);
  }
  /**
   * Determines if we should call endOfStream on the media source based
   * on the state of the buffer or if appened segment was the final
   * segment in the playlist.
   *
   * @param {number} [mediaIndex] the media index of segment we last appended
   * @param {Object} [playlist] a media playlist object
   * @return {boolean} do we need to call endOfStream on the MediaSource
   */
  isEndOfStream_(e = this.mediaIndex, n = this.playlist_, a = this.partIndex) {
    if (!n || !this.mediaSource_)
      return !1;
    const i = typeof e == "number" && n.segments[e], r = e + 1 === n.segments.length, s = !i || !i.parts || a + 1 === i.parts.length;
    return n.endList && this.mediaSource_.readyState === "open" && r && s;
  }
  /**
   * Determines what request should be made given current segment loader state.
   *
   * @return {Object} a request object that describes the segment/part to load
   */
  chooseNextRequest_() {
    const e = this.buffered_(), n = F0(e) || 0, a = Lp(e, this.currentTime_()), i = !this.hasPlayed_() && a >= 1, r = a >= this.goalBufferLength_(), s = this.playlist_.segments;
    if (!s.length || i || r)
      return null;
    this.syncPoint_ = this.syncPoint_ || this.syncController_.getSyncPoint(this.playlist_, this.duration_(), this.currentTimeline_, this.currentTime_(), this.loaderType_);
    const o = {
      partIndex: null,
      mediaIndex: null,
      startOfSegment: null,
      playlist: this.playlist_,
      isSyncRequest: !this.syncPoint_
    };
    if (o.isSyncRequest)
      o.mediaIndex = Bie(this.currentTimeline_, s, n), this.logger_(`choose next request. Can not find sync point. Fallback to media Index: ${o.mediaIndex}`);
    else if (this.mediaIndex !== null) {
      const m = s[this.mediaIndex], _ = typeof this.partIndex == "number" ? this.partIndex : -1;
      o.startOfSegment = m.end ? m.end : n, m.parts && m.parts[_ + 1] ? (o.mediaIndex = this.mediaIndex, o.partIndex = _ + 1) : o.mediaIndex = this.mediaIndex + 1;
    } else {
      let m, _, T;
      const g = this.fetchAtBuffer_ ? n : this.currentTime_();
      if (this.mediaSequenceSync_ && this.logger_(`chooseNextRequest_ request after Quality Switch:
For TargetTime: ${g}.
CurrentTime: ${this.currentTime_()}
BufferedEnd: ${n}
Fetch At Buffer: ${this.fetchAtBuffer_}
`, this.mediaSequenceSync_.diagnostics), this.mediaSequenceSync_ && this.mediaSequenceSync_.isReliable) {
        const x = this.getSyncInfoFromMediaSequenceSync_(g);
        if (!x) {
          const S = "No sync info found while using media sequence sync";
          return this.error({
            message: S,
            metadata: {
              errorType: ce.Error.StreamingFailedToSelectNextSegment,
              error: new Error(S)
            }
          }), this.logger_("chooseNextRequest_ - no sync info found using media sequence sync"), null;
        }
        this.logger_(`chooseNextRequest_ mediaSequence syncInfo (${x.start} --> ${x.end})`), m = x.segmentIndex, _ = x.partIndex, T = x.start;
      } else {
        this.logger_("chooseNextRequest_ - fallback to a regular segment selection algorithm, based on a syncPoint.");
        const x = Kn.getMediaInfoForTime({
          exactManifestTimings: this.exactManifestTimings,
          playlist: this.playlist_,
          currentTime: g,
          startingPartIndex: this.syncPoint_.partIndex,
          startingSegmentIndex: this.syncPoint_.segmentIndex,
          startTime: this.syncPoint_.time
        });
        m = x.segmentIndex, _ = x.partIndex, T = x.startTime;
      }
      o.getMediaInfoForTime = this.fetchAtBuffer_ ? `bufferedEnd ${g}` : `currentTime ${g}`, o.mediaIndex = m, o.startOfSegment = T, o.partIndex = _, this.logger_(`choose next request. Playlist switched and we have a sync point. Media Index: ${o.mediaIndex} `);
    }
    const l = s[o.mediaIndex];
    let c = l && typeof o.partIndex == "number" && l.parts && l.parts[o.partIndex];
    if (!l || typeof o.partIndex == "number" && !c)
      return null;
    typeof o.partIndex != "number" && l.parts && (o.partIndex = 0, c = l.parts[0]);
    const u = this.vhs_.playlists && this.vhs_.playlists.main && this.vhs_.playlists.main.independentSegments || this.playlist_.independentSegments;
    if (!a && c && !u && !c.independent)
      if (o.partIndex === 0) {
        const m = s[o.mediaIndex - 1], _ = m.parts && m.parts.length && m.parts[m.parts.length - 1];
        _ && _.independent && (o.mediaIndex -= 1, o.partIndex = m.parts.length - 1, o.independent = "previous segment");
      } else l.parts[o.partIndex - 1].independent && (o.partIndex -= 1, o.independent = "previous part");
    const f = this.mediaSource_ && this.mediaSource_.readyState === "ended";
    return o.mediaIndex >= s.length - 1 && f && !this.seeking_() ? null : (this.shouldForceTimestampOffsetAfterResync_ && (this.shouldForceTimestampOffsetAfterResync_ = !1, o.forceTimestampOffset = !0, this.logger_("choose next request. Force timestamp offset after loader resync")), this.generateSegmentInfo_(o));
  }
  getSyncInfoFromMediaSequenceSync_(e) {
    if (!this.mediaSequenceSync_)
      return null;
    const n = Math.max(e, this.mediaSequenceSync_.start);
    e !== n && this.logger_(`getSyncInfoFromMediaSequenceSync_. Pulled target time from ${e} to ${n}`);
    const a = this.mediaSequenceSync_.getSyncInfoForTime(n);
    if (!a)
      return null;
    if (!a.isAppended)
      return a;
    const i = this.mediaSequenceSync_.getSyncInfoForTime(a.end);
    return i ? (i.isAppended && this.logger_("getSyncInfoFromMediaSequenceSync_: We encounter unexpected scenario where next media sequence sync info is also appended!"), i) : null;
  }
  generateSegmentInfo_(e) {
    const {
      independent: n,
      playlist: a,
      mediaIndex: i,
      startOfSegment: r,
      isSyncRequest: s,
      partIndex: o,
      forceTimestampOffset: l,
      getMediaInfoForTime: c
    } = e, u = a.segments[i], f = typeof o == "number" && u.parts[o], m = {
      requestId: "segment-loader-" + Math.random(),
      // resolve the segment URL relative to the playlist
      uri: f && f.resolvedUri || u.resolvedUri,
      // the segment's mediaIndex at the time it was requested
      mediaIndex: i,
      partIndex: f ? o : null,
      // whether or not to update the SegmentLoader's state with this
      // segment's mediaIndex
      isSyncRequest: s,
      startOfSegment: r,
      // the segment's playlist
      playlist: a,
      // unencrypted bytes of the segment
      bytes: null,
      // when a key is defined for this segment, the encrypted bytes
      encryptedBytes: null,
      // The target timestampOffset for this segment when we append it
      // to the source buffer
      timestampOffset: null,
      // The timeline that the segment is in
      timeline: u.timeline,
      // The expected duration of the segment in seconds
      duration: f && f.duration || u.duration,
      // retain the segment in case the playlist updates while doing an async process
      segment: u,
      part: f,
      byteLength: 0,
      transmuxer: this.transmuxer_,
      // type of getMediaInfoForTime that was used to get this segment
      getMediaInfoForTime: c,
      independent: n
    }, _ = typeof l < "u" ? l : this.isPendingTimestampOffset_;
    m.timestampOffset = this.timestampOffsetForSegment_({
      segmentTimeline: u.timeline,
      currentTimeline: this.currentTimeline_,
      startOfSegment: r,
      buffered: this.buffered_(),
      overrideCheck: _
    });
    const T = F0(this.sourceUpdater_.audioBuffered());
    return typeof T == "number" && (m.audioAppendStart = T - this.sourceUpdater_.audioTimestampOffset()), this.sourceUpdater_.videoBuffered().length && (m.gopsToAlignWith = Iie(
      this.gopBuffer_,
      // since the transmuxer is using the actual timing values, but the time is
      // adjusted by the timestmap offset, we must adjust the value here
      this.currentTime_() - this.sourceUpdater_.videoTimestampOffset(),
      this.timeMapping_
    )), m;
  }
  // get the timestampoffset for a segment,
  // added so that vtt segment loader can override and prevent
  // adding timestamp offsets.
  timestampOffsetForSegment_(e) {
    return Fie(e);
  }
  /**
   * Determines if the network has enough bandwidth to complete the current segment
   * request in a timely manner. If not, the request will be aborted early and bandwidth
   * updated to trigger a playlist switch.
   *
   * @param {Object} stats
   *        Object containing stats about the request timing and size
   * @private
   */
  earlyAbortWhenNeeded_(e) {
    if (this.vhs_.tech_.paused() || // Don't abort if the current playlist is on the lowestEnabledRendition
    // TODO: Replace using timeout with a boolean indicating whether this playlist is
    //       the lowestEnabledRendition.
    !this.xhrOptions_.timeout || // Don't abort if we have no bandwidth information to estimate segment sizes
    !this.playlist_.attributes.BANDWIDTH || Date.now() - (e.firstBytesReceivedAt || Date.now()) < 1e3)
      return;
    const n = this.currentTime_(), a = e.bandwidth, i = this.pendingSegment_.duration, r = Kn.estimateSegmentRequestTime(i, a, this.playlist_, e.bytesReceived), s = sae(this.buffered_(), n, this.vhs_.tech_.playbackRate()) - 1;
    if (r <= s)
      return;
    const o = _ie({
      main: this.vhs_.playlists.main,
      currentTime: n,
      bandwidth: a,
      duration: this.duration_(),
      segmentDuration: i,
      timeUntilRebuffer: s,
      currentTimeline: this.currentTimeline_,
      syncController: this.syncController_
    });
    if (!o)
      return;
    const c = r - s - o.rebufferingImpact;
    let u = 0.5;
    s <= Za && (u = 1), !(!o.playlist || o.playlist.uri === this.playlist_.uri || c < u) && (this.bandwidth = o.playlist.attributes.BANDWIDTH * mn.BANDWIDTH_VARIANCE + 1, this.trigger("earlyabort"));
  }
  handleAbort_(e) {
    this.logger_(`Aborting ${ls(e)}`), this.mediaRequestsAborted += 1;
  }
  /**
   * XHR `progress` event handler
   *
   * @param {Event}
   *        The XHR `progress` event
   * @param {Object} simpleSegment
   *        A simplified segment object copy
   * @private
   */
  handleProgress_(e, n) {
    this.earlyAbortWhenNeeded_(n.stats), !this.checkForAbort_(n.requestId) && this.trigger("progress");
  }
  handleTrackInfo_(e, n) {
    const {
      hasAudio: a,
      hasVideo: i
    } = n, r = {
      segmentInfo: Tr({
        type: this.loaderType_,
        segment: e
      }),
      trackInfo: {
        hasAudio: a,
        hasVideo: i
      }
    };
    this.trigger({
      type: "segmenttransmuxingtrackinfoavailable",
      metadata: r
    }), this.earlyAbortWhenNeeded_(e.stats), !this.checkForAbort_(e.requestId) && (this.checkForIllegalMediaSwitch(n) || (n = n || {}, Pie(this.currentMediaInfo_, n) || (this.appendInitSegment_ = {
      audio: !0,
      video: !0
    }, this.startingMediaInfo_ = n, this.currentMediaInfo_ = n, this.logger_("trackinfo update", n), this.trigger("trackinfo")), !this.checkForAbort_(e.requestId) && (this.pendingSegment_.trackInfo = n, this.hasEnoughInfoToAppend_() ? this.processCallQueue_() : ji(this))));
  }
  handleTimingInfo_(e, n, a, i) {
    if (this.earlyAbortWhenNeeded_(e.stats), this.checkForAbort_(e.requestId))
      return;
    const r = this.pendingSegment_, s = $b(n);
    r[s] = r[s] || {}, r[s][a] = i, this.logger_(`timinginfo: ${n} - ${a} - ${i}`), this.hasEnoughInfoToAppend_() ? this.processCallQueue_() : ji(this);
  }
  handleCaptions_(e, n) {
    if (this.earlyAbortWhenNeeded_(e.stats), this.checkForAbort_(e.requestId))
      return;
    if (n.length === 0) {
      this.logger_("SegmentLoader received no captions from a caption event");
      return;
    }
    if (!this.pendingSegment_.hasAppendedData_) {
      this.metadataQueue_.caption.push(this.handleCaptions_.bind(this, e, n));
      return;
    }
    const i = this.sourceUpdater_.videoTimestampOffset() === null ? this.sourceUpdater_.audioTimestampOffset() : this.sourceUpdater_.videoTimestampOffset(), r = {};
    n.forEach((s) => {
      r[s.stream] = r[s.stream] || {
        // Infinity, as any other value will be less than this
        startTime: 1 / 0,
        captions: [],
        // 0 as an other value will be more than this
        endTime: 0
      };
      const o = r[s.stream];
      o.startTime = Math.min(o.startTime, s.startTime + i), o.endTime = Math.max(o.endTime, s.endTime + i), o.captions.push(s);
    }), Object.keys(r).forEach((s) => {
      const {
        startTime: o,
        endTime: l,
        captions: c
      } = r[s], u = this.inbandTextTracks_;
      this.logger_(`adding cues from ${o} -> ${l} for ${s}`), wie(u, this.vhs_.tech_, s), il(o, l, u[s]), kie({
        captionArray: c,
        inbandTextTracks: u,
        timestampOffset: i
      });
    }), this.transmuxer_ && this.transmuxer_.postMessage({
      action: "clearParsedMp4Captions"
    });
  }
  handleId3_(e, n, a) {
    if (this.earlyAbortWhenNeeded_(e.stats), this.checkForAbort_(e.requestId))
      return;
    if (!this.pendingSegment_.hasAppendedData_) {
      this.metadataQueue_.id3.push(this.handleId3_.bind(this, e, n, a));
      return;
    }
    this.addMetadataToTextTrack(a, n, this.duration_());
  }
  processMetadataQueue_() {
    this.metadataQueue_.id3.forEach((e) => e()), this.metadataQueue_.caption.forEach((e) => e()), this.metadataQueue_.id3 = [], this.metadataQueue_.caption = [];
  }
  processCallQueue_() {
    const e = this.callQueue_;
    this.callQueue_ = [], e.forEach((n) => n());
  }
  processLoadQueue_() {
    const e = this.loadQueue_;
    this.loadQueue_ = [], e.forEach((n) => n());
  }
  /**
   * Determines whether the loader has enough info to load the next segment.
   *
   * @return {boolean}
   *         Whether or not the loader has enough info to load the next segment
   */
  hasEnoughInfoToLoad_() {
    if (this.loaderType_ !== "audio")
      return !0;
    const e = this.pendingSegment_;
    return e ? this.getCurrentMediaInfo_() ? (
      // Technically, instead of waiting to load a segment on timeline changes, a segment
      // can be requested and downloaded and only wait before it is transmuxed or parsed.
      // But in practice, there are a few reasons why it is better to wait until a loader
      // is ready to append that segment before requesting and downloading:
      //
      // 1. Because audio and main loaders cross discontinuities together, if this loader
      //    is waiting for the other to catch up, then instead of requesting another
      //    segment and using up more bandwidth, by not yet loading, more bandwidth is
      //    allotted to the loader currently behind.
      // 2. media-segment-request doesn't have to have logic to consider whether a segment
      // is ready to be processed or not, isolating the queueing behavior to the loader.
      // 3. The audio loader bases some of its segment properties on timing information
      //    provided by the main loader, meaning that, if the logic for waiting on
      //    processing was in media-segment-request, then it would also need to know how
      //    to re-generate the segment information after the main loader caught up.
      !Fh({
        timelineChangeController: this.timelineChangeController_,
        currentTimeline: this.currentTimeline_,
        segmentTimeline: e.timeline,
        loaderType: this.loaderType_,
        audioDisabled: this.audioDisabled_
      })
    ) : !0 : !1;
  }
  getCurrentMediaInfo_(e = this.pendingSegment_) {
    return e && e.trackInfo || this.currentMediaInfo_;
  }
  getMediaInfo_(e = this.pendingSegment_) {
    return this.getCurrentMediaInfo_(e) || this.startingMediaInfo_;
  }
  getPendingSegmentPlaylist() {
    return this.pendingSegment_ ? this.pendingSegment_.playlist : null;
  }
  hasEnoughInfoToAppend_() {
    if (!this.sourceUpdater_.ready() || this.waitingOnRemove_ || this.quotaExceededErrorRetryTimeout_)
      return !1;
    const e = this.pendingSegment_, n = this.getCurrentMediaInfo_();
    if (!e || !n)
      return !1;
    const {
      hasAudio: a,
      hasVideo: i,
      isMuxed: r
    } = n;
    return !(i && !e.videoTimingInfo || a && !this.audioDisabled_ && !r && !e.audioTimingInfo || Fh({
      timelineChangeController: this.timelineChangeController_,
      currentTimeline: this.currentTimeline_,
      segmentTimeline: e.timeline,
      loaderType: this.loaderType_,
      audioDisabled: this.audioDisabled_
    }));
  }
  handleData_(e, n) {
    if (this.earlyAbortWhenNeeded_(e.stats), this.checkForAbort_(e.requestId))
      return;
    if (this.callQueue_.length || !this.hasEnoughInfoToAppend_()) {
      ji(this), this.callQueue_.push(this.handleData_.bind(this, e, n));
      return;
    }
    const a = this.pendingSegment_;
    if (this.setTimeMapping_(a.timeline), this.updateMediaSecondsLoaded_(a.part || a.segment), this.mediaSource_.readyState !== "closed") {
      if (e.map && (e.map = this.initSegmentForMap(e.map, !0), a.segment.map = e.map), e.key && this.segmentKey(e.key, !0), a.isFmp4 = e.isFmp4, a.timingInfo = a.timingInfo || {}, a.isFmp4)
        this.trigger("fmp4"), a.timingInfo.start = a[$b(n.type)].start;
      else {
        const i = this.getCurrentMediaInfo_(), r = this.loaderType_ === "main" && i && i.hasVideo;
        let s;
        r && (s = a.videoTimingInfo.start), a.timingInfo.start = this.trueSegmentStart_({
          currentStart: a.timingInfo.start,
          playlist: a.playlist,
          mediaIndex: a.mediaIndex,
          currentVideoTimestampOffset: this.sourceUpdater_.videoTimestampOffset(),
          useVideoTimingInfo: r,
          firstVideoFrameTimeForData: s,
          videoTimingInfo: a.videoTimingInfo,
          audioTimingInfo: a.audioTimingInfo
        });
      }
      if (this.updateAppendInitSegmentStatus(a, n.type), this.updateSourceBufferTimestampOffset_(a), a.isSyncRequest) {
        this.updateTimingInfoEnd_(a), this.syncController_.saveSegmentTimingInfo({
          segmentInfo: a,
          shouldSaveTimelineMapping: this.loaderType_ === "main"
        });
        const i = this.chooseNextRequest_();
        if (i.mediaIndex !== a.mediaIndex || i.partIndex !== a.partIndex) {
          this.logger_("sync segment was incorrect, not appending");
          return;
        }
        this.logger_("sync segment was correct, appending");
      }
      a.hasAppendedData_ = !0, this.processMetadataQueue_(), this.appendData_(a, n);
    }
  }
  updateAppendInitSegmentStatus(e, n) {
    this.loaderType_ === "main" && typeof e.timestampOffset == "number" && // in the case that we're handling partial data, we don't want to append an init
    // segment for each chunk
    !e.changedTimestampOffset && (this.appendInitSegment_ = {
      audio: !0,
      video: !0
    }), this.playlistOfLastInitSegment_[n] !== e.playlist && (this.appendInitSegment_[n] = !0);
  }
  getInitSegmentAndUpdateState_({
    type: e,
    initSegment: n,
    map: a,
    playlist: i
  }) {
    if (a) {
      const r = Bu(a);
      if (this.activeInitSegmentId_ === r)
        return null;
      n = this.initSegmentForMap(a, !0).bytes, this.activeInitSegmentId_ = r;
    }
    return n && this.appendInitSegment_[e] ? (this.playlistOfLastInitSegment_[e] = i, this.appendInitSegment_[e] = !1, this.activeInitSegmentId_ = null, n) : null;
  }
  handleQuotaExceededError_({
    segmentInfo: e,
    type: n,
    bytes: a
  }, i) {
    const r = this.sourceUpdater_.audioBuffered(), s = this.sourceUpdater_.videoBuffered();
    r.length > 1 && this.logger_("On QUOTA_EXCEEDED_ERR, found gaps in the audio buffer: " + Sr(r).join(", ")), s.length > 1 && this.logger_("On QUOTA_EXCEEDED_ERR, found gaps in the video buffer: " + Sr(s).join(", "));
    const o = r.length ? r.start(0) : 0, l = r.length ? r.end(r.length - 1) : 0, c = s.length ? s.start(0) : 0, u = s.length ? s.end(s.length - 1) : 0;
    if (l - o <= Xo && u - c <= Xo) {
      this.logger_(`On QUOTA_EXCEEDED_ERR, single segment too large to append to buffer, triggering an error. Appended byte length: ${a.byteLength}, audio buffer: ${Sr(r).join(", ")}, video buffer: ${Sr(s).join(", ")}, `), this.error({
        message: "Quota exceeded error with append of a single segment of content",
        excludeUntil: 1 / 0
      }), this.trigger("error");
      return;
    }
    this.waitingOnRemove_ = !0, this.callQueue_.push(this.appendToSourceBuffer_.bind(this, {
      segmentInfo: e,
      type: n,
      bytes: a
    }));
    const m = this.currentTime_() - Xo;
    this.logger_(`On QUOTA_EXCEEDED_ERR, removing audio/video from 0 to ${m}`), this.remove(0, m, () => {
      this.logger_(`On QUOTA_EXCEEDED_ERR, retrying append in ${Xo}s`), this.waitingOnRemove_ = !1, this.quotaExceededErrorRetryTimeout_ = j.setTimeout(() => {
        this.logger_("On QUOTA_EXCEEDED_ERR, re-processing call queue"), this.quotaExceededErrorRetryTimeout_ = null, this.processCallQueue_();
      }, Xo * 1e3);
    }, !0);
  }
  handleAppendError_({
    segmentInfo: e,
    type: n,
    bytes: a
  }, i) {
    if (i) {
      if (i.code === O_) {
        this.handleQuotaExceededError_({
          segmentInfo: e,
          type: n,
          bytes: a
        });
        return;
      }
      this.logger_("Received non QUOTA_EXCEEDED_ERR on append", i), this.error({
        message: `${n} append of ${a.length}b failed for segment #${e.mediaIndex} in playlist ${e.playlist.id}`,
        metadata: {
          errorType: ce.Error.StreamingFailedToAppendSegment
        }
      }), this.trigger("appenderror");
    }
  }
  appendToSourceBuffer_({
    segmentInfo: e,
    type: n,
    initSegment: a,
    data: i,
    bytes: r
  }) {
    if (!r) {
      const o = [i];
      let l = i.byteLength;
      a && (o.unshift(a), l += a.byteLength), r = xie({
        bytes: l,
        segments: o
      });
    }
    const s = {
      segmentInfo: Tr({
        type: this.loaderType_,
        segment: e
      })
    };
    this.trigger({
      type: "segmentappendstart",
      metadata: s
    }), this.sourceUpdater_.appendBuffer({
      segmentInfo: e,
      type: n,
      bytes: r
    }, this.handleAppendError_.bind(this, {
      segmentInfo: e,
      type: n,
      bytes: r
    }));
  }
  handleSegmentTimingInfo_(e, n, a) {
    if (!this.pendingSegment_ || n !== this.pendingSegment_.requestId)
      return;
    const i = this.pendingSegment_.segment, r = `${e}TimingInfo`;
    i[r] || (i[r] = {}), i[r].transmuxerPrependedSeconds = a.prependedContentDuration || 0, i[r].transmuxedPresentationStart = a.start.presentation, i[r].transmuxedDecodeStart = a.start.decode, i[r].transmuxedPresentationEnd = a.end.presentation, i[r].transmuxedDecodeEnd = a.end.decode, i[r].baseMediaDecodeTime = a.baseMediaDecodeTime;
  }
  appendData_(e, n) {
    const {
      type: a,
      data: i
    } = n;
    if (!i || !i.byteLength || a === "audio" && this.audioDisabled_)
      return;
    const r = this.getInitSegmentAndUpdateState_({
      type: a,
      initSegment: n.initSegment,
      playlist: e.playlist,
      map: e.isFmp4 ? e.segment.map : null
    });
    this.appendToSourceBuffer_({
      segmentInfo: e,
      type: a,
      initSegment: r,
      data: i
    });
  }
  /**
   * load a specific segment from a request into the buffer
   *
   * @private
   */
  loadSegment_(e) {
    if (this.state = "WAITING", this.pendingSegment_ = e, this.trimBackBuffer_(e), typeof e.timestampOffset == "number" && this.transmuxer_ && this.transmuxer_.postMessage({
      action: "clearAllMp4Captions"
    }), !this.hasEnoughInfoToLoad_()) {
      ji(this), this.loadQueue_.push(() => {
        const n = Jt({}, e, {
          forceTimestampOffset: !0
        });
        Jt(e, this.generateSegmentInfo_(n)), this.isPendingTimestampOffset_ = !1, this.updateTransmuxerAndRequestSegment_(e);
      });
      return;
    }
    this.updateTransmuxerAndRequestSegment_(e);
  }
  updateTransmuxerAndRequestSegment_(e) {
    this.shouldUpdateTransmuxerTimestampOffset_(e.timestampOffset) && (this.gopBuffer_.length = 0, e.gopsToAlignWith = [], this.timeMapping_ = 0, this.transmuxer_.postMessage({
      action: "reset"
    }), this.transmuxer_.postMessage({
      action: "setTimestampOffset",
      timestampOffset: e.timestampOffset
    }));
    const n = this.createSimplifiedSegmentObj_(e), a = this.isEndOfStream_(e.mediaIndex, e.playlist, e.partIndex), i = this.mediaIndex !== null, r = e.timeline !== this.currentTimeline_ && // currentTimeline starts at -1, so we shouldn't end the timeline switching to 0,
    // the first timeline
    e.timeline > 0, s = a || i && r;
    this.logger_(`Requesting
${aT(e.uri)}
${ls(e)}`), n.map && !n.map.bytes && (this.logger_("going to request init segment."), this.appendInitSegment_ = {
      video: !0,
      audio: !0
    }), e.abortRequests = pie({
      xhr: this.vhs_.xhr,
      xhrOptions: this.xhrOptions_,
      decryptionWorker: this.decrypter_,
      segment: n,
      abortFn: this.handleAbort_.bind(this, e),
      progressFn: this.handleProgress_.bind(this),
      trackInfoFn: this.handleTrackInfo_.bind(this),
      timingInfoFn: this.handleTimingInfo_.bind(this),
      videoSegmentTimingInfoFn: this.handleSegmentTimingInfo_.bind(this, "video", e.requestId),
      audioSegmentTimingInfoFn: this.handleSegmentTimingInfo_.bind(this, "audio", e.requestId),
      captionsFn: this.handleCaptions_.bind(this),
      isEndOfTimeline: s,
      endedTimelineFn: () => {
        this.logger_("received endedtimeline callback");
      },
      id3Fn: this.handleId3_.bind(this),
      dataFn: this.handleData_.bind(this),
      doneFn: this.segmentRequestFinished_.bind(this),
      onTransmuxerLog: ({
        message: o,
        level: l,
        stream: c
      }) => {
        this.logger_(`${ls(e)} logged from transmuxer stream ${c} as a ${l}: ${o}`);
      },
      triggerSegmentEventFn: ({
        type: o,
        segment: l,
        keyInfo: c,
        trackInfo: u,
        timingInfo: f
      }) => {
        const _ = {
          segmentInfo: Tr({
            segment: l
          })
        };
        c && (_.keyInfo = c), u && (_.trackInfo = u), f && (_.timingInfo = f), this.trigger({
          type: o,
          metadata: _
        });
      }
    });
  }
  /**
   * trim the back buffer so that we don't have too much data
   * in the source buffer
   *
   * @private
   *
   * @param {Object} segmentInfo - the current segment
   */
  trimBackBuffer_(e) {
    const n = $ie(this.seekable_(), this.currentTime_(), this.playlist_.targetDuration || 10);
    n > 0 && this.remove(0, n);
  }
  /**
   * created a simplified copy of the segment object with just the
   * information necessary to perform the XHR and decryption
   *
   * @private
   *
   * @param {Object} segmentInfo - the current segment
   * @return {Object} a simplified segment object copy
   */
  createSimplifiedSegmentObj_(e) {
    const n = e.segment, a = e.part, i = e.segment.key || e.segment.map && e.segment.map.key, r = e.segment.map && !e.segment.map.bytes, s = {
      resolvedUri: a ? a.resolvedUri : n.resolvedUri,
      byterange: a ? a.byterange : n.byterange,
      requestId: e.requestId,
      transmuxer: e.transmuxer,
      audioAppendStart: e.audioAppendStart,
      gopsToAlignWith: e.gopsToAlignWith,
      part: e.part,
      type: this.loaderType_,
      start: e.startOfSegment,
      duration: e.duration,
      isEncrypted: i,
      isMediaInitialization: r
    }, o = e.playlist.segments[e.mediaIndex - 1];
    if (o && o.timeline === n.timeline && (o.videoTimingInfo ? s.baseStartTime = o.videoTimingInfo.transmuxedDecodeEnd : o.audioTimingInfo && (s.baseStartTime = o.audioTimingInfo.transmuxedDecodeEnd)), n.key) {
      const l = n.key.iv || new Uint32Array([0, 0, 0, e.mediaIndex + e.playlist.mediaSequence]);
      s.key = this.segmentKey(n.key), s.key.iv = l;
    }
    return n.map && (s.map = this.initSegmentForMap(n.map)), s;
  }
  saveTransferStats_(e) {
    this.mediaRequests += 1, e && (this.mediaBytesTransferred += e.bytesReceived, this.mediaTransferDuration += e.roundTripTime);
  }
  saveBandwidthRelatedStats_(e, n) {
    if (this.pendingSegment_.byteLength = n.bytesReceived, e < $c) {
      this.logger_(`Ignoring segment's bandwidth because its duration of ${e} is less than the min to record ${$c}`);
      return;
    }
    const a = {
      bandwidthInfo: {
        from: this.bandwidth,
        to: n.bandwidth
      }
    };
    this.trigger({
      type: "bandwidthupdated",
      metadata: a
    }), this.bandwidth = n.bandwidth, this.roundTrip = n.roundTripTime;
  }
  handleTimeout_() {
    this.mediaRequestsTimedout += 1, this.bandwidth = 1, this.roundTrip = NaN, this.trigger("bandwidthupdate"), this.trigger("timeout");
  }
  /**
   * Handle the callback from the segmentRequest function and set the
   * associated SegmentLoader state and errors if necessary
   *
   * @private
   */
  segmentRequestFinished_(e, n, a) {
    if (this.callQueue_.length) {
      this.callQueue_.push(this.segmentRequestFinished_.bind(this, e, n, a));
      return;
    }
    if (this.saveTransferStats_(n.stats), !this.pendingSegment_ || n.requestId !== this.pendingSegment_.requestId)
      return;
    if (e) {
      if (this.pendingSegment_ = null, this.state = "READY", e.code === Qa.ABORTED)
        return;
      if (this.pause(), e.code === Qa.TIMEOUT) {
        this.handleTimeout_();
        return;
      }
      this.mediaRequestsErrored += 1, this.error(e), this.trigger("error");
      return;
    }
    const i = this.pendingSegment_;
    this.saveBandwidthRelatedStats_(i.duration, n.stats), i.endOfAllRequests = n.endOfAllRequests, a.gopInfo && (this.gopBuffer_ = Mie(this.gopBuffer_, a.gopInfo, this.safeAppend_)), this.state = "APPENDING", this.trigger("appending"), this.waitForAppendsToComplete_(i);
  }
  setTimeMapping_(e) {
    const n = this.syncController_.mappingForTimeline(e);
    n !== null && (this.timeMapping_ = n);
  }
  updateMediaSecondsLoaded_(e) {
    typeof e.start == "number" && typeof e.end == "number" ? this.mediaSecondsLoaded += e.end - e.start : this.mediaSecondsLoaded += e.duration;
  }
  shouldUpdateTransmuxerTimestampOffset_(e) {
    return e === null ? !1 : this.loaderType_ === "main" && e !== this.sourceUpdater_.videoTimestampOffset() || !this.audioDisabled_ && e !== this.sourceUpdater_.audioTimestampOffset();
  }
  trueSegmentStart_({
    currentStart: e,
    playlist: n,
    mediaIndex: a,
    firstVideoFrameTimeForData: i,
    currentVideoTimestampOffset: r,
    useVideoTimingInfo: s,
    videoTimingInfo: o,
    audioTimingInfo: l
  }) {
    if (typeof e < "u")
      return e;
    if (!s)
      return l.start;
    const c = n.segments[a - 1];
    return a === 0 || !c || typeof c.start > "u" || c.end !== i + r ? i : o.start;
  }
  waitForAppendsToComplete_(e) {
    const n = this.getCurrentMediaInfo_(e);
    if (!n) {
      this.error({
        message: "No starting media returned, likely due to an unsupported media format.",
        playlistExclusionDuration: 1 / 0
      }), this.trigger("error");
      return;
    }
    const {
      hasAudio: a,
      hasVideo: i,
      isMuxed: r
    } = n, s = this.loaderType_ === "main" && i, o = !this.audioDisabled_ && a && !r;
    if (e.waitingOnAppends = 0, !e.hasAppendedData_) {
      !e.timingInfo && typeof e.timestampOffset == "number" && (this.isPendingTimestampOffset_ = !0), e.timingInfo = {
        start: 0
      }, e.waitingOnAppends++, this.isPendingTimestampOffset_ || (this.updateSourceBufferTimestampOffset_(e), this.processMetadataQueue_()), this.checkAppendsDone_(e);
      return;
    }
    s && e.waitingOnAppends++, o && e.waitingOnAppends++, s && this.sourceUpdater_.videoQueueCallback(this.checkAppendsDone_.bind(this, e)), o && this.sourceUpdater_.audioQueueCallback(this.checkAppendsDone_.bind(this, e));
  }
  checkAppendsDone_(e) {
    this.checkForAbort_(e.requestId) || (e.waitingOnAppends--, e.waitingOnAppends === 0 && this.handleAppendsDone_());
  }
  checkForIllegalMediaSwitch(e) {
    const n = Nie(this.loaderType_, this.getCurrentMediaInfo_(), e);
    return n ? (this.error({
      message: n,
      playlistExclusionDuration: 1 / 0
    }), this.trigger("error"), !0) : !1;
  }
  updateSourceBufferTimestampOffset_(e) {
    if (e.timestampOffset === null || // we don't yet have the start for whatever media type (video or audio) has
    // priority, timing-wise, so we must wait
    typeof e.timingInfo.start != "number" || // already updated the timestamp offset for this segment
    e.changedTimestampOffset || // the alt audio loader should not be responsible for setting the timestamp offset
    this.loaderType_ !== "main")
      return;
    let n = !1;
    e.timestampOffset -= this.getSegmentStartTimeForTimestampOffsetCalculation_({
      videoTimingInfo: e.segment.videoTimingInfo,
      audioTimingInfo: e.segment.audioTimingInfo,
      timingInfo: e.timingInfo
    }), e.changedTimestampOffset = !0, e.timestampOffset !== this.sourceUpdater_.videoTimestampOffset() && (this.sourceUpdater_.videoTimestampOffset(e.timestampOffset), n = !0), e.timestampOffset !== this.sourceUpdater_.audioTimestampOffset() && (this.sourceUpdater_.audioTimestampOffset(e.timestampOffset), n = !0), n && this.trigger("timestampoffset");
  }
  getSegmentStartTimeForTimestampOffsetCalculation_({
    videoTimingInfo: e,
    audioTimingInfo: n,
    timingInfo: a
  }) {
    return this.useDtsForTimestampOffset_ ? e && typeof e.transmuxedDecodeStart == "number" ? e.transmuxedDecodeStart : n && typeof n.transmuxedDecodeStart == "number" ? n.transmuxedDecodeStart : a.start : a.start;
  }
  updateTimingInfoEnd_(e) {
    e.timingInfo = e.timingInfo || {};
    const n = this.getMediaInfo_(), i = this.loaderType_ === "main" && n && n.hasVideo && e.videoTimingInfo ? e.videoTimingInfo : e.audioTimingInfo;
    i && (e.timingInfo.end = typeof i.end == "number" ? (
      // End time may not exist in a case where we aren't parsing the full segment (one
      // current example is the case of fmp4), so use the rough duration to calculate an
      // end time.
      i.end
    ) : i.start + e.duration);
  }
  /**
   * callback to run when appendBuffer is finished. detects if we are
   * in a good state to do things with the data we got, or if we need
   * to wait for more
   *
   * @private
   */
  handleAppendsDone_() {
    if (this.pendingSegment_) {
      const l = {
        segmentInfo: Tr({
          type: this.loaderType_,
          segment: this.pendingSegment_
        })
      };
      this.trigger({
        type: "appendsdone",
        metadata: l
      });
    }
    if (!this.pendingSegment_) {
      this.state = "READY", this.paused() || this.monitorBuffer_();
      return;
    }
    const e = this.pendingSegment_;
    e.part && e.part.syncInfo ? e.part.syncInfo.markAppended() : e.segment.syncInfo && e.segment.syncInfo.markAppended(), this.updateTimingInfoEnd_(e), this.shouldSaveSegmentTimingInfo_ && this.syncController_.saveSegmentTimingInfo({
      segmentInfo: e,
      shouldSaveTimelineMapping: this.loaderType_ === "main"
    });
    const n = Yie(e, this.sourceType_);
    if (n && (n.severity === "warn" ? ce.log.warn(n.message) : this.logger_(n.message)), this.recordThroughput_(e), this.pendingSegment_ = null, this.state = "READY", e.isSyncRequest && (this.trigger("syncinfoupdate"), !e.hasAppendedData_)) {
      this.logger_(`Throwing away un-appended sync request ${ls(e)}`);
      return;
    }
    this.logger_(`Appended ${ls(e)}`), this.addSegmentMetadataCue_(e), this.fetchAtBuffer_ = !0, this.currentTimeline_ !== e.timeline && (this.timelineChangeController_.lastTimelineChange({
      type: this.loaderType_,
      from: this.currentTimeline_,
      to: e.timeline
    }), this.loaderType_ === "main" && !this.audioDisabled_ && this.timelineChangeController_.lastTimelineChange({
      type: "audio",
      from: this.currentTimeline_,
      to: e.timeline
    })), this.currentTimeline_ = e.timeline, this.trigger("syncinfoupdate");
    const a = e.segment, i = e.part, r = a.end && this.currentTime_() - a.end > e.playlist.targetDuration * 3, s = i && i.end && this.currentTime_() - i.end > e.playlist.partTargetDuration * 3;
    if (r || s) {
      this.logger_(`bad ${r ? "segment" : "part"} ${ls(e)}`), this.resetEverything();
      return;
    }
    this.mediaIndex !== null && this.trigger("bandwidthupdate"), this.trigger("progress"), this.mediaIndex = e.mediaIndex, this.partIndex = e.partIndex, this.isEndOfStream_(e.mediaIndex, e.playlist, e.partIndex) && this.endOfStream(), this.trigger("appended"), e.hasAppendedData_ && this.mediaAppends++, this.paused() || this.monitorBuffer_();
  }
  /**
   * Records the current throughput of the decrypt, transmux, and append
   * portion of the semgment pipeline. `throughput.rate` is a the cumulative
   * moving average of the throughput. `throughput.count` is the number of
   * data points in the average.
   *
   * @private
   * @param {Object} segmentInfo the object returned by loadSegment
   */
  recordThroughput_(e) {
    if (e.duration < $c) {
      this.logger_(`Ignoring segment's throughput because its duration of ${e.duration} is less than the min to record ${$c}`);
      return;
    }
    const n = this.throughput.rate, a = Date.now() - e.endOfAllRequests + 1, i = Math.floor(e.byteLength / a * 8 * 1e3);
    this.throughput.rate += (i - n) / ++this.throughput.count;
  }
  /**
   * Adds a cue to the segment-metadata track with some metadata information about the
   * segment
   *
   * @private
   * @param {Object} segmentInfo
   *        the object returned by loadSegment
   * @method addSegmentMetadataCue_
   */
  addSegmentMetadataCue_(e) {
    if (!this.segmentMetadataTrack_)
      return;
    const n = e.segment, a = n.start, i = n.end;
    if (!Nb(a) || !Nb(i))
      return;
    il(a, i, this.segmentMetadataTrack_);
    const r = j.WebKitDataCue || j.VTTCue, s = {
      custom: n.custom,
      dateTimeObject: n.dateTimeObject,
      dateTimeString: n.dateTimeString,
      programDateTime: n.programDateTime,
      bandwidth: e.playlist.attributes.BANDWIDTH,
      resolution: e.playlist.attributes.RESOLUTION,
      codecs: e.playlist.attributes.CODECS,
      byteLength: e.byteLength,
      uri: e.uri,
      timeline: e.timeline,
      playlist: e.playlist.id,
      start: a,
      end: i
    }, o = JSON.stringify(s), l = new r(a, i, o);
    l.value = s, this.segmentMetadataTrack_.addCue(l);
  }
}
function bi() {
}
const iT = function(t) {
  return typeof t != "string" ? t : t.replace(/./, (e) => e.toUpperCase());
}, jie = ["video", "audio"], Uh = (t, e) => {
  const n = e[`${t}Buffer`];
  return n && n.updating || e.queuePending[t];
}, Vie = (t, e) => {
  for (let n = 0; n < e.length; n++) {
    const a = e[n];
    if (a.type === "mediaSource")
      return null;
    if (a.type === t)
      return n;
  }
  return null;
}, Es = (t, e) => {
  if (e.queue.length === 0)
    return;
  let n = 0, a = e.queue[n];
  if (a.type === "mediaSource") {
    !e.updating() && e.mediaSource.readyState !== "closed" && (e.queue.shift(), a.action(e), a.doneFn && a.doneFn(), Es("audio", e), Es("video", e));
    return;
  }
  if (t !== "mediaSource" && !(!e.ready() || e.mediaSource.readyState === "closed" || Uh(t, e))) {
    if (a.type !== t) {
      if (n = Vie(t, e.queue), n === null)
        return;
      a = e.queue[n];
    }
    if (e.queue.splice(n, 1), e.queuePending[t] = a, a.action(t, e), !a.doneFn) {
      e.queuePending[t] = null, Es(t, e);
      return;
    }
  }
}, rT = (t, e) => {
  const n = e[`${t}Buffer`], a = iT(t);
  n && (n.removeEventListener("updateend", e[`on${a}UpdateEnd_`]), n.removeEventListener("error", e[`on${a}Error_`]), e.codecs[t] = null, e[`${t}Buffer`] = null);
}, Va = (t, e) => t && e && Array.prototype.indexOf.call(t.sourceBuffers, e) !== -1, ra = {
  appendBuffer: (t, e, n) => (a, i) => {
    const r = i[`${a}Buffer`];
    if (Va(i.mediaSource, r)) {
      i.logger_(`Appending segment ${e.mediaIndex}'s ${t.length} bytes to ${a}Buffer`);
      try {
        r.appendBuffer(t);
      } catch (s) {
        i.logger_(`Error with code ${s.code} ` + (s.code === O_ ? "(QUOTA_EXCEEDED_ERR) " : "") + `when appending segment ${e.mediaIndex} to ${a}Buffer`), i.queuePending[a] = null, n(s);
      }
    }
  },
  remove: (t, e) => (n, a) => {
    const i = a[`${n}Buffer`];
    if (Va(a.mediaSource, i)) {
      a.logger_(`Removing ${t} to ${e} from ${n}Buffer`);
      try {
        i.remove(t, e);
      } catch {
        a.logger_(`Remove ${t} to ${e} from ${n}Buffer failed`);
      }
    }
  },
  timestampOffset: (t) => (e, n) => {
    const a = n[`${e}Buffer`];
    Va(n.mediaSource, a) && (n.logger_(`Setting ${e}timestampOffset to ${t}`), a.timestampOffset = t);
  },
  callback: (t) => (e, n) => {
    t();
  },
  endOfStream: (t) => (e) => {
    if (e.mediaSource.readyState === "open") {
      e.logger_(`Calling mediaSource endOfStream(${t || ""})`);
      try {
        e.mediaSource.endOfStream(t);
      } catch (n) {
        ce.log.warn("Failed to call media source endOfStream", n);
      }
    }
  },
  duration: (t) => (e) => {
    e.logger_(`Setting mediaSource duration to ${t}`);
    try {
      e.mediaSource.duration = t;
    } catch (n) {
      ce.log.warn("Failed to set media source duration", n);
    }
  },
  abort: () => (t, e) => {
    if (e.mediaSource.readyState !== "open")
      return;
    const n = e[`${t}Buffer`];
    if (Va(e.mediaSource, n)) {
      e.logger_(`calling abort on ${t}Buffer`);
      try {
        n.abort();
      } catch (a) {
        ce.log.warn(`Failed to abort on ${t}Buffer`, a);
      }
    }
  },
  addSourceBuffer: (t, e) => (n) => {
    const a = iT(t), i = Ns(e);
    n.logger_(`Adding ${t}Buffer with codec ${e} to mediaSource`);
    const r = n.mediaSource.addSourceBuffer(i);
    r.addEventListener("updateend", n[`on${a}UpdateEnd_`]), r.addEventListener("error", n[`on${a}Error_`]), n.codecs[t] = e, n[`${t}Buffer`] = r;
  },
  removeSourceBuffer: (t) => (e) => {
    const n = e[`${t}Buffer`];
    if (rT(t, e), !!Va(e.mediaSource, n)) {
      e.logger_(`Removing ${t}Buffer with codec ${e.codecs[t]} from mediaSource`);
      try {
        e.mediaSource.removeSourceBuffer(n);
      } catch (a) {
        ce.log.warn(`Failed to removeSourceBuffer ${t}Buffer`, a);
      }
    }
  },
  changeType: (t) => (e, n) => {
    const a = n[`${e}Buffer`], i = Ns(t);
    if (!Va(n.mediaSource, a))
      return;
    const r = t.substring(0, t.indexOf(".")), s = n.codecs[e];
    if (s.substring(0, s.indexOf(".")) === r)
      return;
    const l = {
      codecsChangeInfo: {
        from: s,
        to: t
      }
    };
    n.trigger({
      type: "codecschange",
      metadata: l
    }), n.logger_(`changing ${e}Buffer codec from ${s} to ${t}`);
    try {
      a.changeType(i), n.codecs[e] = t;
    } catch (c) {
      l.errorType = ce.Error.StreamingCodecsChangeError, l.error = c, c.metadata = l, n.error_ = c, n.trigger("error"), ce.log.warn(`Failed to changeType on ${e}Buffer`, c);
    }
  }
}, sa = ({
  type: t,
  sourceUpdater: e,
  action: n,
  doneFn: a,
  name: i
}) => {
  e.queue.push({
    type: t,
    action: n,
    doneFn: a,
    name: i
  }), Es(t, e);
}, zb = (t, e) => (n) => {
  const a = e[`${t}Buffered`](), i = aae(a);
  if (e.logger_(`received "updateend" event for ${t} Source Buffer: `, i), e.queuePending[t]) {
    const r = e.queuePending[t].doneFn;
    e.queuePending[t] = null, r && r(e[`${t}Error_`]);
  }
  Es(t, e);
};
class sT extends ce.EventTarget {
  constructor(e) {
    super(), this.mediaSource = e, this.sourceopenListener_ = () => Es("mediaSource", this), this.mediaSource.addEventListener("sourceopen", this.sourceopenListener_), this.logger_ = Ca("SourceUpdater"), this.audioTimestampOffset_ = 0, this.videoTimestampOffset_ = 0, this.queue = [], this.queuePending = {
      audio: null,
      video: null
    }, this.delayedAudioAppendQueue_ = [], this.videoAppendQueued_ = !1, this.codecs = {}, this.onVideoUpdateEnd_ = zb("video", this), this.onAudioUpdateEnd_ = zb("audio", this), this.onVideoError_ = (n) => {
      this.videoError_ = n;
    }, this.onAudioError_ = (n) => {
      this.audioError_ = n;
    }, this.createdSourceBuffers_ = !1, this.initializedEme_ = !1, this.triggeredReady_ = !1;
  }
  initializedEme() {
    this.initializedEme_ = !0, this.triggerReady();
  }
  hasCreatedSourceBuffers() {
    return this.createdSourceBuffers_;
  }
  hasInitializedAnyEme() {
    return this.initializedEme_;
  }
  ready() {
    return this.hasCreatedSourceBuffers() && this.hasInitializedAnyEme();
  }
  createSourceBuffers(e) {
    this.hasCreatedSourceBuffers() || (this.addOrChangeSourceBuffers(e), this.createdSourceBuffers_ = !0, this.trigger("createdsourcebuffers"), this.triggerReady());
  }
  triggerReady() {
    this.ready() && !this.triggeredReady_ && (this.triggeredReady_ = !0, this.trigger("ready"));
  }
  /**
   * Add a type of source buffer to the media source.
   *
   * @param {string} type
   *        The type of source buffer to add.
   *
   * @param {string} codec
   *        The codec to add the source buffer with.
   */
  addSourceBuffer(e, n) {
    sa({
      type: "mediaSource",
      sourceUpdater: this,
      action: ra.addSourceBuffer(e, n),
      name: "addSourceBuffer"
    });
  }
  /**
   * call abort on a source buffer.
   *
   * @param {string} type
   *        The type of source buffer to call abort on.
   */
  abort(e) {
    sa({
      type: e,
      sourceUpdater: this,
      action: ra.abort(e),
      name: "abort"
    });
  }
  /**
   * Call removeSourceBuffer and remove a specific type
   * of source buffer on the mediaSource.
   *
   * @param {string} type
   *        The type of source buffer to remove.
   */
  removeSourceBuffer(e) {
    if (!this.canRemoveSourceBuffer()) {
      ce.log.error("removeSourceBuffer is not supported!");
      return;
    }
    sa({
      type: "mediaSource",
      sourceUpdater: this,
      action: ra.removeSourceBuffer(e),
      name: "removeSourceBuffer"
    });
  }
  /**
   * Whether or not the removeSourceBuffer function is supported
   * on the mediaSource.
   *
   * @return {boolean}
   *          if removeSourceBuffer can be called.
   */
  canRemoveSourceBuffer() {
    return !ce.browser.IS_FIREFOX && j.MediaSource && j.MediaSource.prototype && typeof j.MediaSource.prototype.removeSourceBuffer == "function";
  }
  /**
   * Whether or not the changeType function is supported
   * on our SourceBuffers.
   *
   * @return {boolean}
   *         if changeType can be called.
   */
  static canChangeType() {
    return j.SourceBuffer && j.SourceBuffer.prototype && typeof j.SourceBuffer.prototype.changeType == "function";
  }
  /**
   * Whether or not the changeType function is supported
   * on our SourceBuffers.
   *
   * @return {boolean}
   *         if changeType can be called.
   */
  canChangeType() {
    return this.constructor.canChangeType();
  }
  /**
   * Call the changeType function on a source buffer, given the code and type.
   *
   * @param {string} type
   *        The type of source buffer to call changeType on.
   *
   * @param {string} codec
   *        The codec string to change type with on the source buffer.
   */
  changeType(e, n) {
    if (!this.canChangeType()) {
      ce.log.error("changeType is not supported!");
      return;
    }
    sa({
      type: e,
      sourceUpdater: this,
      action: ra.changeType(n),
      name: "changeType"
    });
  }
  /**
   * Add source buffers with a codec or, if they are already created,
   * call changeType on source buffers using changeType.
   *
   * @param {Object} codecs
   *        Codecs to switch to
   */
  addOrChangeSourceBuffers(e) {
    if (!e || typeof e != "object" || Object.keys(e).length === 0)
      throw new Error("Cannot addOrChangeSourceBuffers to undefined codecs");
    Object.keys(e).forEach((n) => {
      const a = e[n];
      if (!this.hasCreatedSourceBuffers())
        return this.addSourceBuffer(n, a);
      this.canChangeType() && this.changeType(n, a);
    });
  }
  /**
   * Queue an update to append an ArrayBuffer.
   *
   * @param {MediaObject} object containing audioBytes and/or videoBytes
   * @param {Function} done the function to call when done
   * @see http://www.w3.org/TR/media-source/#widl-SourceBuffer-appendBuffer-void-ArrayBuffer-data
   */
  appendBuffer(e, n) {
    const {
      segmentInfo: a,
      type: i,
      bytes: r
    } = e;
    if (this.processedAppend_ = !0, i === "audio" && this.videoBuffer && !this.videoAppendQueued_) {
      this.delayedAudioAppendQueue_.push([e, n]), this.logger_(`delayed audio append of ${r.length} until video append`);
      return;
    }
    const s = n;
    if (sa({
      type: i,
      sourceUpdater: this,
      action: ra.appendBuffer(r, a || {
        mediaIndex: -1
      }, s),
      doneFn: n,
      name: "appendBuffer"
    }), i === "video") {
      if (this.videoAppendQueued_ = !0, !this.delayedAudioAppendQueue_.length)
        return;
      const o = this.delayedAudioAppendQueue_.slice();
      this.logger_(`queuing delayed audio ${o.length} appendBuffers`), this.delayedAudioAppendQueue_.length = 0, o.forEach((l) => {
        this.appendBuffer.apply(this, l);
      });
    }
  }
  /**
   * Get the audio buffer's buffered timerange.
   *
   * @return {TimeRange}
   *         The audio buffer's buffered time range
   */
  audioBuffered() {
    return Va(this.mediaSource, this.audioBuffer) && this.audioBuffer.buffered ? this.audioBuffer.buffered : vn();
  }
  /**
   * Get the video buffer's buffered timerange.
   *
   * @return {TimeRange}
   *         The video buffer's buffered time range
   */
  videoBuffered() {
    return Va(this.mediaSource, this.videoBuffer) && this.videoBuffer.buffered ? this.videoBuffer.buffered : vn();
  }
  /**
   * Get a combined video/audio buffer's buffered timerange.
   *
   * @return {TimeRange}
   *         the combined time range
   */
  buffered() {
    const e = Va(this.mediaSource, this.videoBuffer) ? this.videoBuffer : null, n = Va(this.mediaSource, this.audioBuffer) ? this.audioBuffer : null;
    return n && !e ? this.audioBuffered() : e && !n ? this.videoBuffered() : rae(this.audioBuffered(), this.videoBuffered());
  }
  /**
   * Add a callback to the queue that will set duration on the mediaSource.
   *
   * @param {number} duration
   *        The duration to set
   *
   * @param {Function} [doneFn]
   *        function to run after duration has been set.
   */
  setDuration(e, n = bi) {
    sa({
      type: "mediaSource",
      sourceUpdater: this,
      action: ra.duration(e),
      name: "duration",
      doneFn: n
    });
  }
  /**
   * Add a mediaSource endOfStream call to the queue
   *
   * @param {Error} [error]
   *        Call endOfStream with an error
   *
   * @param {Function} [doneFn]
   *        A function that should be called when the
   *        endOfStream call has finished.
   */
  endOfStream(e = null, n = bi) {
    typeof e != "string" && (e = void 0), sa({
      type: "mediaSource",
      sourceUpdater: this,
      action: ra.endOfStream(e),
      name: "endOfStream",
      doneFn: n
    });
  }
  /**
   * Queue an update to remove a time range from the buffer.
   *
   * @param {number} start where to start the removal
   * @param {number} end where to end the removal
   * @param {Function} [done=noop] optional callback to be executed when the remove
   * operation is complete
   * @see http://www.w3.org/TR/media-source/#widl-SourceBuffer-remove-void-double-start-unrestricted-double-end
   */
  removeAudio(e, n, a = bi) {
    if (!this.audioBuffered().length || this.audioBuffered().end(0) === 0) {
      a();
      return;
    }
    sa({
      type: "audio",
      sourceUpdater: this,
      action: ra.remove(e, n),
      doneFn: a,
      name: "remove"
    });
  }
  /**
   * Queue an update to remove a time range from the buffer.
   *
   * @param {number} start where to start the removal
   * @param {number} end where to end the removal
   * @param {Function} [done=noop] optional callback to be executed when the remove
   * operation is complete
   * @see http://www.w3.org/TR/media-source/#widl-SourceBuffer-remove-void-double-start-unrestricted-double-end
   */
  removeVideo(e, n, a = bi) {
    if (!this.videoBuffered().length || this.videoBuffered().end(0) === 0) {
      a();
      return;
    }
    sa({
      type: "video",
      sourceUpdater: this,
      action: ra.remove(e, n),
      doneFn: a,
      name: "remove"
    });
  }
  /**
   * Whether the underlying sourceBuffer is updating or not
   *
   * @return {boolean} the updating status of the SourceBuffer
   */
  updating() {
    return !!(Uh("audio", this) || Uh("video", this));
  }
  /**
   * Set/get the timestampoffset on the audio SourceBuffer
   *
   * @return {number} the timestamp offset
   */
  audioTimestampOffset(e) {
    return typeof e < "u" && this.audioBuffer && // no point in updating if it's the same
    this.audioTimestampOffset_ !== e && (sa({
      type: "audio",
      sourceUpdater: this,
      action: ra.timestampOffset(e),
      name: "timestampOffset"
    }), this.audioTimestampOffset_ = e), this.audioTimestampOffset_;
  }
  /**
   * Set/get the timestampoffset on the video SourceBuffer
   *
   * @return {number} the timestamp offset
   */
  videoTimestampOffset(e) {
    return typeof e < "u" && this.videoBuffer && // no point in updating if it's the same
    this.videoTimestampOffset_ !== e && (sa({
      type: "video",
      sourceUpdater: this,
      action: ra.timestampOffset(e),
      name: "timestampOffset"
    }), this.videoTimestampOffset_ = e), this.videoTimestampOffset_;
  }
  /**
   * Add a function to the queue that will be called
   * when it is its turn to run in the audio queue.
   *
   * @param {Function} callback
   *        The callback to queue.
   */
  audioQueueCallback(e) {
    this.audioBuffer && sa({
      type: "audio",
      sourceUpdater: this,
      action: ra.callback(e),
      name: "callback"
    });
  }
  /**
   * Add a function to the queue that will be called
   * when it is its turn to run in the video queue.
   *
   * @param {Function} callback
   *        The callback to queue.
   */
  videoQueueCallback(e) {
    this.videoBuffer && sa({
      type: "video",
      sourceUpdater: this,
      action: ra.callback(e),
      name: "callback"
    });
  }
  /**
   * dispose of the source updater and the underlying sourceBuffer
   */
  dispose() {
    this.trigger("dispose"), jie.forEach((e) => {
      this.abort(e), this.canRemoveSourceBuffer() ? this.removeSourceBuffer(e) : this[`${e}QueueCallback`](() => rT(e, this));
    }), this.videoAppendQueued_ = !1, this.delayedAudioAppendQueue_.length = 0, this.sourceopenListener_ && this.mediaSource.removeEventListener("sourceopen", this.sourceopenListener_), this.off();
  }
}
const Ub = (t) => decodeURIComponent(escape(String.fromCharCode.apply(null, t))), qie = (t) => {
  const e = new Uint8Array(t);
  return Array.from(e).map((n) => n.toString(16).padStart(2, "0")).join("");
}, Hb = new Uint8Array(`

`.split("").map((t) => t.charCodeAt(0)));
class Wie extends Error {
  constructor() {
    super("Trying to parse received VTT cues, but there is no WebVTT. Make sure vtt.js is loaded.");
  }
}
class Gie extends zh {
  constructor(e, n = {}) {
    super(e, n), this.mediaSource_ = null, this.subtitlesTrack_ = null, this.featuresNativeTextTracks_ = e.featuresNativeTextTracks, this.loadVttJs = e.loadVttJs, this.shouldSaveSegmentTimingInfo_ = !1;
  }
  /**
   * Indicates which time ranges are buffered
   *
   * @return {TimeRange}
   *         TimeRange object representing the current buffered ranges
   */
  buffered_() {
    if (!this.subtitlesTrack_ || !this.subtitlesTrack_.cues || !this.subtitlesTrack_.cues.length)
      return vn();
    const e = this.subtitlesTrack_.cues, n = e[0].startTime, a = e[e.length - 1].startTime;
    return vn([[n, a]]);
  }
  /**
   * Gets and sets init segment for the provided map
   *
   * @param {Object} map
   *        The map object representing the init segment to get or set
   * @param {boolean=} set
   *        If true, the init segment for the provided map should be saved
   * @return {Object}
   *         map object for desired init segment
   */
  initSegmentForMap(e, n = !1) {
    if (!e)
      return null;
    const a = Bu(e);
    let i = this.initSegments_[a];
    if (n && !i && e.bytes) {
      const r = Hb.byteLength + e.bytes.byteLength, s = new Uint8Array(r);
      s.set(e.bytes), s.set(Hb, e.bytes.byteLength), this.initSegments_[a] = i = {
        resolvedUri: e.resolvedUri,
        byterange: e.byterange,
        bytes: s
      };
    }
    return i || e;
  }
  /**
   * Returns true if all configuration required for loading is present, otherwise false.
   *
   * @return {boolean} True if the all configuration is ready for loading
   * @private
   */
  couldBeginLoading_() {
    return this.playlist_ && this.subtitlesTrack_ && !this.paused();
  }
  /**
   * Once all the starting parameters have been specified, begin
   * operation. This method should only be invoked from the INIT
   * state.
   *
   * @private
   */
  init_() {
    return this.state = "READY", this.resetEverything(), this.monitorBuffer_();
  }
  /**
   * Set a subtitle track on the segment loader to add subtitles to
   *
   * @param {TextTrack=} track
   *        The text track to add loaded subtitles to
   * @return {TextTrack}
   *        Returns the subtitles track
   */
  track(e) {
    return typeof e > "u" ? this.subtitlesTrack_ : (this.subtitlesTrack_ = e, this.state === "INIT" && this.couldBeginLoading_() && this.init_(), this.subtitlesTrack_);
  }
  /**
   * Remove any data in the source buffer between start and end times
   *
   * @param {number} start - the start time of the region to remove from the buffer
   * @param {number} end - the end time of the region to remove from the buffer
   */
  remove(e, n) {
    il(e, n, this.subtitlesTrack_);
  }
  /**
   * fill the buffer with segements unless the sourceBuffers are
   * currently updating
   *
   * Note: this function should only ever be called by monitorBuffer_
   * and never directly
   *
   * @private
   */
  fillBuffer_() {
    const e = this.chooseNextRequest_();
    if (e) {
      if (this.syncController_.timestampOffsetForTimeline(e.timeline) === null) {
        const n = () => {
          this.state = "READY", this.paused() || this.monitorBuffer_();
        };
        this.syncController_.one("timestampoffset", n), this.state = "WAITING_ON_TIMELINE";
        return;
      }
      this.loadSegment_(e);
    }
  }
  // never set a timestamp offset for vtt segments.
  timestampOffsetForSegment_() {
    return null;
  }
  chooseNextRequest_() {
    return this.skipEmptySegments_(super.chooseNextRequest_());
  }
  /**
   * Prevents the segment loader from requesting segments we know contain no subtitles
   * by walking forward until we find the next segment that we don't know whether it is
   * empty or not.
   *
   * @param {Object} segmentInfo
   *        a segment info object that describes the current segment
   * @return {Object}
   *         a segment info object that describes the current segment
   */
  skipEmptySegments_(e) {
    for (; e && e.segment.empty; ) {
      if (e.mediaIndex + 1 >= e.playlist.segments.length) {
        e = null;
        break;
      }
      e = this.generateSegmentInfo_({
        playlist: e.playlist,
        mediaIndex: e.mediaIndex + 1,
        startOfSegment: e.startOfSegment + e.duration,
        isSyncRequest: e.isSyncRequest
      });
    }
    return e;
  }
  stopForError(e) {
    this.error(e), this.state = "READY", this.pause(), this.trigger("error");
  }
  /**
   * append a decrypted segement to the SourceBuffer through a SourceUpdater
   *
   * @private
   */
  segmentRequestFinished_(e, n, a) {
    if (!this.subtitlesTrack_) {
      this.state = "READY";
      return;
    }
    if (this.saveTransferStats_(n.stats), !this.pendingSegment_) {
      this.state = "READY", this.mediaRequestsAborted += 1;
      return;
    }
    if (e) {
      e.code === Qa.TIMEOUT && this.handleTimeout_(), e.code === Qa.ABORTED ? this.mediaRequestsAborted += 1 : this.mediaRequestsErrored += 1, this.stopForError(e);
      return;
    }
    const i = this.pendingSegment_, r = a.mp4VttCues && a.mp4VttCues.length;
    r && (i.mp4VttCues = a.mp4VttCues), this.saveBandwidthRelatedStats_(i.duration, n.stats), n.key && this.segmentKey(n.key, !0), this.state = "APPENDING", this.trigger("appending");
    const s = i.segment;
    if (s.map && (s.map.bytes = n.map.bytes), i.bytes = n.bytes, typeof j.WebVTT != "function" && typeof this.loadVttJs == "function") {
      this.state = "WAITING_ON_VTTJS", this.loadVttJs().then(() => this.segmentRequestFinished_(e, n, a), () => this.stopForError({
        message: "Error loading vtt.js"
      }));
      return;
    }
    s.requested = !0;
    try {
      this.parseVTTCues_(i);
    } catch (o) {
      this.stopForError({
        message: o.message,
        metadata: {
          errorType: ce.Error.StreamingVttParserError,
          error: o
        }
      });
      return;
    }
    if (r || this.updateTimeMapping_(i, this.syncController_.timelines[i.timeline], this.playlist_), i.cues.length ? i.timingInfo = {
      start: i.cues[0].startTime,
      end: i.cues[i.cues.length - 1].endTime
    } : i.timingInfo = {
      start: i.startOfSegment,
      end: i.startOfSegment + i.duration
    }, i.isSyncRequest) {
      this.trigger("syncinfoupdate"), this.pendingSegment_ = null, this.state = "READY";
      return;
    }
    i.byteLength = i.bytes.byteLength, this.mediaSecondsLoaded += s.duration, i.cues.forEach((o) => {
      this.subtitlesTrack_.addCue(this.featuresNativeTextTracks_ ? new j.VTTCue(o.startTime, o.endTime, o.text) : o);
    }), Die(this.subtitlesTrack_), this.handleAppendsDone_();
  }
  handleData_(e, n) {
    const a = e && e.type === "vtt", i = n && n.type === "text";
    a && i && super.handleData_(e, n);
  }
  updateTimingInfoEnd_() {
  }
  /**
   * Utility function for converting mp4 webvtt cue objects into VTTCues.
   *
   * @param {Object} segmentInfo with mp4 webvtt cues for parsing into VTTCue objecs
   */
  parseMp4VttCues_(e) {
    const n = this.sourceUpdater_.videoTimestampOffset() === null ? this.sourceUpdater_.audioTimestampOffset() : this.sourceUpdater_.videoTimestampOffset();
    e.mp4VttCues.forEach((a) => {
      const i = a.start + n, r = a.end + n, s = new j.VTTCue(i, r, a.cueText);
      a.settings && a.settings.split(" ").forEach((o) => {
        const l = o.split(":"), c = l[0], u = l[1];
        s[c] = isNaN(u) ? u : Number(u);
      }), e.cues.push(s);
    });
  }
  /**
   * Uses the WebVTT parser to parse the segment response
   *
   * @throws NoVttJsError
   *
   * @param {Object} segmentInfo
   *        a segment info object that describes the current segment
   * @private
   */
  parseVTTCues_(e) {
    let n, a = !1;
    if (typeof j.WebVTT != "function")
      throw new Wie();
    if (e.cues = [], e.timestampmap = {
      MPEGTS: 0,
      LOCAL: 0
    }, e.mp4VttCues) {
      this.parseMp4VttCues_(e);
      return;
    }
    typeof j.TextDecoder == "function" ? n = new j.TextDecoder("utf8") : (n = j.WebVTT.StringDecoder(), a = !0);
    const i = new j.WebVTT.Parser(j, j.vttjs, n);
    if (i.oncue = e.cues.push.bind(e.cues), i.ontimestampmap = (s) => {
      e.timestampmap = s;
    }, i.onparsingerror = (s) => {
      ce.log.warn("Error encountered when parsing cues: " + s.message);
    }, e.segment.map) {
      let s = e.segment.map.bytes;
      a && (s = Ub(s)), i.parse(s);
    }
    let r = e.bytes;
    a && (r = Ub(r)), i.parse(r), i.flush();
  }
  /**
   * Updates the start and end times of any cues parsed by the WebVTT parser using
   * the information parsed from the X-TIMESTAMP-MAP header and a TS to media time mapping
   * from the SyncController
   *
   * @param {Object} segmentInfo
   *        a segment info object that describes the current segment
   * @param {Object} mappingObj
   *        object containing a mapping from TS to media time
   * @param {Object} playlist
   *        the playlist object containing the segment
   * @private
   */
  updateTimeMapping_(e, n, a) {
    const i = e.segment;
    if (!n)
      return;
    if (!e.cues.length) {
      i.empty = !0;
      return;
    }
    const {
      MPEGTS: r,
      LOCAL: s
    } = e.timestampmap, l = r / Cr.ONE_SECOND_IN_TS - s + n.mapping;
    if (e.cues.forEach((c) => {
      const u = c.endTime - c.startTime, f = this.handleRollover_(c.startTime + l, n.time);
      c.startTime = Math.max(f, 0), c.endTime = Math.max(f + u, 0);
    }), !a.syncInfo) {
      const c = e.cues[0].startTime, u = e.cues[e.cues.length - 1].startTime;
      a.syncInfo = {
        mediaSequence: a.mediaSequence + e.mediaIndex,
        time: Math.min(c, u - i.duration)
      };
    }
  }
  /**
   * MPEG-TS PES timestamps are limited to 2^33.
   * Once they reach 2^33, they roll over to 0.
   * mux.js handles PES timestamp rollover for the following scenarios:
   * [forward rollover(right)] ->
   *    PES timestamps monotonically increase, and once they reach 2^33, they roll over to 0
   * [backward rollover(left)] -->
   *    we seek back to position before rollover.
   *
   * According to the HLS SPEC:
   * When synchronizing WebVTT with PES timestamps, clients SHOULD account
   * for cases where the 33-bit PES timestamps have wrapped and the WebVTT
   * cue times have not.  When the PES timestamp wraps, the WebVTT Segment
   * SHOULD have a X-TIMESTAMP-MAP header that maps the current WebVTT
   * time to the new (low valued) PES timestamp.
   *
   * So we want to handle rollover here and align VTT Cue start/end time to the player's time.
   */
  handleRollover_(e, n) {
    if (n === null)
      return e;
    let a = e * Cr.ONE_SECOND_IN_TS;
    const i = n * Cr.ONE_SECOND_IN_TS;
    let r;
    for (i < a ? r = -8589934592 : r = 8589934592; Math.abs(a - i) > 4294967296; )
      a += r;
    return a / Cr.ONE_SECOND_IN_TS;
  }
}
const Xie = function(t, e) {
  const n = t.cues;
  for (let a = 0; a < n.length; a++) {
    const i = n[a];
    if (e >= i.adStartTime && e <= i.adEndTime)
      return i;
  }
  return null;
}, Zie = function(t, e, n = 0) {
  if (!t.segments)
    return;
  let a = n, i;
  for (let r = 0; r < t.segments.length; r++) {
    const s = t.segments[r];
    if (i || (i = Xie(e, a + s.duration / 2)), i) {
      if ("cueIn" in s) {
        i.endTime = a, i.adEndTime = a, a += s.duration, i = null;
        continue;
      }
      if (a < i.endTime) {
        a += s.duration;
        continue;
      }
      i.endTime += s.duration;
    } else if ("cueOut" in s && (i = new j.VTTCue(a, a + s.duration, s.cueOut), i.adStartTime = a, i.adEndTime = a + parseFloat(s.cueOut), e.addCue(i)), "cueOutCont" in s) {
      const [o, l] = s.cueOutCont.split("/").map(parseFloat);
      i = new j.VTTCue(a, a + s.duration, ""), i.adStartTime = a - o, i.adEndTime = i.adStartTime + l, e.addCue(i);
    }
    a += s.duration;
  }
};
class Yb {
  /**
   * @param {number} start - media sequence start
   * @param {number} end - media sequence end
   * @param {number} segmentIndex - index for associated segment
   * @param {number|null} [partIndex] - index for associated part
   * @param {boolean} [appended] - appended indicator
   *
   */
  constructor({
    start: e,
    end: n,
    segmentIndex: a,
    partIndex: i = null,
    appended: r = !1
  }) {
    this.start_ = e, this.end_ = n, this.segmentIndex_ = a, this.partIndex_ = i, this.appended_ = r;
  }
  isInRange(e) {
    return e >= this.start && e < this.end;
  }
  markAppended() {
    this.appended_ = !0;
  }
  resetAppendedStatus() {
    this.appended_ = !1;
  }
  get isAppended() {
    return this.appended_;
  }
  get start() {
    return this.start_;
  }
  get end() {
    return this.end_;
  }
  get segmentIndex() {
    return this.segmentIndex_;
  }
  get partIndex() {
    return this.partIndex_;
  }
}
class Kie {
  /**
   *
   * @param {SyncInfo} segmentSyncInfo - sync info for a given segment
   * @param {Array<SyncInfo>} [partsSyncInfo] - sync infos for a list of parts for a given segment
   */
  constructor(e, n = []) {
    this.segmentSyncInfo_ = e, this.partsSyncInfo_ = n;
  }
  get segmentSyncInfo() {
    return this.segmentSyncInfo_;
  }
  get partsSyncInfo() {
    return this.partsSyncInfo_;
  }
  get hasPartsSyncInfo() {
    return this.partsSyncInfo_.length > 0;
  }
  resetAppendStatus() {
    this.segmentSyncInfo_.resetAppendedStatus(), this.partsSyncInfo_.forEach((e) => e.resetAppendedStatus());
  }
}
class oT {
  constructor() {
    this.storage_ = /* @__PURE__ */ new Map(), this.diagnostics_ = "", this.isReliable_ = !1, this.start_ = -1 / 0, this.end_ = 1 / 0;
  }
  get start() {
    return this.start_;
  }
  get end() {
    return this.end_;
  }
  get diagnostics() {
    return this.diagnostics_;
  }
  get isReliable() {
    return this.isReliable_;
  }
  resetAppendedStatus() {
    this.storage_.forEach((e) => e.resetAppendStatus());
  }
  /**
   * update sync storage
   *
   * @param {Object} playlist
   * @param {number} currentTime
   *
   * @return {void}
   */
  update(e, n) {
    const {
      mediaSequence: a,
      segments: i
    } = e;
    if (this.isReliable_ = this.isReliablePlaylist_(a, i), !!this.isReliable_)
      return this.updateStorage_(i, a, this.calculateBaseTime_(a, i, n));
  }
  /**
   * @param {number} targetTime
   * @return {SyncInfo|null}
   */
  getSyncInfoForTime(e) {
    for (const {
      segmentSyncInfo: n,
      partsSyncInfo: a
    } of this.storage_.values())
      if (a.length) {
        for (const i of a)
          if (i.isInRange(e))
            return i;
      } else if (n.isInRange(e))
        return n;
    return null;
  }
  getSyncInfoForMediaSequence(e) {
    return this.storage_.get(e);
  }
  updateStorage_(e, n, a) {
    const i = /* @__PURE__ */ new Map();
    let r = `
`, s = a, o = n;
    this.start_ = s, e.forEach((l, c) => {
      const u = this.storage_.get(o), f = s, m = f + l.duration, _ = !!(u && u.segmentSyncInfo && u.segmentSyncInfo.isAppended), T = new Yb({
        start: f,
        end: m,
        appended: _,
        segmentIndex: c
      });
      l.syncInfo = T;
      let g = s;
      const x = (l.parts || []).map((S, D) => {
        const L = g, M = g + S.duration, E = !!(u && u.partsSyncInfo && u.partsSyncInfo[D] && u.partsSyncInfo[D].isAppended), P = new Yb({
          start: L,
          end: M,
          appended: E,
          segmentIndex: c,
          partIndex: D
        });
        return g = M, r += `Media Sequence: ${o}.${D} | Range: ${L} --> ${M} | Appended: ${E}
`, S.syncInfo = P, P;
      });
      i.set(o, new Kie(T, x)), r += `${aT(l.resolvedUri)} | Media Sequence: ${o} | Range: ${f} --> ${m} | Appended: ${_}
`, o++, s = m;
    }), this.end_ = s, this.storage_ = i, this.diagnostics_ = r;
  }
  calculateBaseTime_(e, n, a) {
    if (!this.storage_.size)
      return 0;
    if (this.storage_.has(e))
      return this.storage_.get(e).segmentSyncInfo.start;
    const i = Math.min(...this.storage_.keys());
    if (e < i) {
      const r = i - e;
      let s = this.storage_.get(i).segmentSyncInfo.start;
      for (let o = 0; o < r; o++) {
        const l = n[o];
        s -= l.duration;
      }
      return s;
    }
    return a;
  }
  isReliablePlaylist_(e, n) {
    return e != null && Array.isArray(n) && n.length;
  }
}
class jb extends oT {
  constructor(e) {
    super(), this.parent_ = e;
  }
  calculateBaseTime_(e, n, a) {
    if (!this.storage_.size) {
      const i = this.parent_.getSyncInfoForMediaSequence(e);
      return i ? i.segmentSyncInfo.start : 0;
    }
    return super.calculateBaseTime_(e, n, a);
  }
}
const Qie = 86400, H0 = [
  // Stategy "VOD": Handle the VOD-case where the sync-point is *always*
  //                the equivalence display-time 0 === segment-index 0
  {
    name: "VOD",
    run: (t, e, n, a, i) => n !== 1 / 0 ? {
      time: 0,
      segmentIndex: 0,
      partIndex: null
    } : null
  },
  {
    name: "MediaSequence",
    /**
     * run media sequence strategy
     *
     * @param {SyncController} syncController
     * @param {Object} playlist
     * @param {number} duration
     * @param {number} currentTimeline
     * @param {number} currentTime
     * @param {string} type
     */
    run: (t, e, n, a, i, r) => {
      const s = t.getMediaSequenceSync(r);
      if (!s || !s.isReliable)
        return null;
      const o = s.getSyncInfoForTime(i);
      return o ? {
        time: o.start,
        partIndex: o.partIndex,
        segmentIndex: o.segmentIndex
      } : null;
    }
  },
  // Stategy "ProgramDateTime": We have a program-date-time tag in this playlist
  {
    name: "ProgramDateTime",
    run: (t, e, n, a, i) => {
      if (!Object.keys(t.timelineToDatetimeMappings).length)
        return null;
      let r = null, s = null;
      const o = Ih(e);
      i = i || 0;
      for (let l = 0; l < o.length; l++) {
        const c = e.endList || i === 0 ? l : o.length - (l + 1), u = o[c], f = u.segment, m = t.timelineToDatetimeMappings[f.timeline];
        if (!m || !f.dateTimeObject)
          continue;
        let T = f.dateTimeObject.getTime() / 1e3 + m;
        if (f.parts && typeof u.partIndex == "number")
          for (let x = 0; x < u.partIndex; x++)
            T += f.parts[x].duration;
        const g = Math.abs(i - T);
        if (s !== null && (g === 0 || s < g))
          break;
        s = g, r = {
          time: T,
          segmentIndex: u.segmentIndex,
          partIndex: u.partIndex
        };
      }
      return r;
    }
  },
  // Stategy "Segment": We have a known time mapping for a timeline and a
  //                    segment in the current timeline with timing data
  {
    name: "Segment",
    run: (t, e, n, a, i) => {
      let r = null, s = null;
      i = i || 0;
      const o = Ih(e);
      for (let l = 0; l < o.length; l++) {
        const c = e.endList || i === 0 ? l : o.length - (l + 1), u = o[c], f = u.segment, m = u.part && u.part.start || f && f.start;
        if (f.timeline === a && typeof m < "u") {
          const _ = Math.abs(i - m);
          if (s !== null && s < _)
            break;
          (!r || s === null || s >= _) && (s = _, r = {
            time: m,
            segmentIndex: u.segmentIndex,
            partIndex: u.partIndex
          });
        }
      }
      return r;
    }
  },
  // Stategy "Discontinuity": We have a discontinuity with a known
  //                          display-time
  {
    name: "Discontinuity",
    run: (t, e, n, a, i) => {
      let r = null;
      if (i = i || 0, e.discontinuityStarts && e.discontinuityStarts.length) {
        let s = null;
        for (let o = 0; o < e.discontinuityStarts.length; o++) {
          const l = e.discontinuityStarts[o], c = e.discontinuitySequence + o + 1, u = t.discontinuities[c];
          if (u) {
            const f = Math.abs(i - u.time);
            if (s !== null && s < f)
              break;
            (!r || s === null || s >= f) && (s = f, r = {
              time: u.time,
              segmentIndex: l,
              partIndex: null
            });
          }
        }
      }
      return r;
    }
  },
  // Stategy "Playlist": We have a playlist with a known mapping of
  //                     segment index to display time
  {
    name: "Playlist",
    run: (t, e, n, a, i) => e.syncInfo ? {
      time: e.syncInfo.time,
      segmentIndex: e.syncInfo.mediaSequence - e.mediaSequence,
      partIndex: null
    } : null
  }
];
class Jie extends ce.EventTarget {
  constructor(e = {}) {
    super(), this.timelines = [], this.discontinuities = [], this.timelineToDatetimeMappings = {};
    const n = new oT(), a = new jb(n), i = new jb(n);
    this.mediaSequenceStorage_ = {
      main: n,
      audio: a,
      vtt: i
    }, this.logger_ = Ca("SyncController");
  }
  /**
   *
   * @param {string} loaderType
   * @return {MediaSequenceSync|null}
   */
  getMediaSequenceSync(e) {
    return this.mediaSequenceStorage_[e] || null;
  }
  /**
   * Find a sync-point for the playlist specified
   *
   * A sync-point is defined as a known mapping from display-time to
   * a segment-index in the current playlist.
   *
   * @param {Playlist} playlist
   *        The playlist that needs a sync-point
   * @param {number} duration
   *        Duration of the MediaSource (Infinite if playing a live source)
   * @param {number} currentTimeline
   *        The last timeline from which a segment was loaded
   * @param {number} currentTime
   *        Current player's time
   * @param {string} type
   *        Segment loader type
   * @return {Object}
   *          A sync-point object
   */
  getSyncPoint(e, n, a, i, r) {
    if (n !== 1 / 0)
      return H0.find(({
        name: l
      }) => l === "VOD").run(this, e, n);
    const s = this.runStrategies_(e, n, a, i, r);
    if (!s.length)
      return null;
    for (const o of s) {
      const {
        syncPoint: l,
        strategy: c
      } = o, {
        segmentIndex: u,
        time: f
      } = l;
      if (u < 0)
        continue;
      const m = e.segments[u], _ = f, T = _ + m.duration;
      if (this.logger_(`Strategy: ${c}. Current time: ${i}. selected segment: ${u}. Time: [${_} -> ${T}]}`), i >= _ && i < T)
        return this.logger_("Found sync point with exact match: ", l), l;
    }
    return this.selectSyncPoint_(s, {
      key: "time",
      value: i
    });
  }
  /**
   * Calculate the amount of time that has expired off the playlist during playback
   *
   * @param {Playlist} playlist
   *        Playlist object to calculate expired from
   * @param {number} duration
   *        Duration of the MediaSource (Infinity if playling a live source)
   * @return {number|null}
   *          The amount of time that has expired off the playlist during playback. Null
   *          if no sync-points for the playlist can be found.
   */
  getExpiredTime(e, n) {
    if (!e || !e.segments)
      return null;
    const a = this.runStrategies_(e, n, e.discontinuitySequence, 0);
    if (!a.length)
      return null;
    const i = this.selectSyncPoint_(a, {
      key: "segmentIndex",
      value: 0
    });
    return i.segmentIndex > 0 && (i.time *= -1), Math.abs(i.time + ml({
      defaultDuration: e.targetDuration,
      durationList: e.segments,
      startIndex: i.segmentIndex,
      endIndex: 0
    }));
  }
  /**
   * Runs each sync-point strategy and returns a list of sync-points returned by the
   * strategies
   *
   * @private
   * @param {Playlist} playlist
   *        The playlist that needs a sync-point
   * @param {number} duration
   *        Duration of the MediaSource (Infinity if playing a live source)
   * @param {number} currentTimeline
   *        The last timeline from which a segment was loaded
   * @param {number} currentTime
   *        Current player's time
   * @param {string} type
   *        Segment loader type
   * @return {Array}
   *          A list of sync-point objects
   */
  runStrategies_(e, n, a, i, r) {
    const s = [];
    for (let o = 0; o < H0.length; o++) {
      const l = H0[o], c = l.run(this, e, n, a, i, r);
      c && (c.strategy = l.name, s.push({
        strategy: l.name,
        syncPoint: c
      }));
    }
    return s;
  }
  /**
   * Selects the sync-point nearest the specified target
   *
   * @private
   * @param {Array} syncPoints
   *        List of sync-points to select from
   * @param {Object} target
   *        Object specifying the property and value we are targeting
   * @param {string} target.key
   *        Specifies the property to target. Must be either 'time' or 'segmentIndex'
   * @param {number} target.value
   *        The value to target for the specified key.
   * @return {Object}
   *          The sync-point nearest the target
   */
  selectSyncPoint_(e, n) {
    let a = e[0].syncPoint, i = Math.abs(e[0].syncPoint[n.key] - n.value), r = e[0].strategy;
    for (let s = 1; s < e.length; s++) {
      const o = Math.abs(e[s].syncPoint[n.key] - n.value);
      o < i && (i = o, a = e[s].syncPoint, r = e[s].strategy);
    }
    return this.logger_(`syncPoint for [${n.key}: ${n.value}] chosen with strategy [${r}]: [time:${a.time}, segmentIndex:${a.segmentIndex}` + (typeof a.partIndex == "number" ? `,partIndex:${a.partIndex}` : "") + "]"), a;
  }
  /**
   * Save any meta-data present on the segments when segments leave
   * the live window to the playlist to allow for synchronization at the
   * playlist level later.
   *
   * @param {Playlist} oldPlaylist - The previous active playlist
   * @param {Playlist} newPlaylist - The updated and most current playlist
   */
  saveExpiredSegmentInfo(e, n) {
    const a = n.mediaSequence - e.mediaSequence;
    if (a > Qie) {
      ce.log.warn(`Not saving expired segment info. Media sequence gap ${a} is too large.`);
      return;
    }
    for (let i = a - 1; i >= 0; i--) {
      const r = e.segments[i];
      if (r && typeof r.start < "u") {
        n.syncInfo = {
          mediaSequence: e.mediaSequence + i,
          time: r.start
        }, this.logger_(`playlist refresh sync: [time:${n.syncInfo.time}, mediaSequence: ${n.syncInfo.mediaSequence}]`), this.trigger("syncinfoupdate");
        break;
      }
    }
  }
  /**
   * Save the mapping from playlist's ProgramDateTime to display. This should only happen
   * before segments start to load.
   *
   * @param {Playlist} playlist - The currently active playlist
   */
  setDateTimeMappingForStart(e) {
    if (this.timelineToDatetimeMappings = {}, e.segments && e.segments.length && e.segments[0].dateTimeObject) {
      const n = e.segments[0], a = n.dateTimeObject.getTime() / 1e3;
      this.timelineToDatetimeMappings[n.timeline] = -a;
    }
  }
  /**
   * Calculates and saves timeline mappings, playlist sync info, and segment timing values
   * based on the latest timing information.
   *
   * @param {Object} options
   *        Options object
   * @param {SegmentInfo} options.segmentInfo
   *        The current active request information
   * @param {boolean} options.shouldSaveTimelineMapping
   *        If there's a timeline change, determines if the timeline mapping should be
   *        saved for timeline mapping and program date time mappings.
   */
  saveSegmentTimingInfo({
    segmentInfo: e,
    shouldSaveTimelineMapping: n
  }) {
    const a = this.calculateSegmentTimeMapping_(e, e.timingInfo, n), i = e.segment;
    a && (this.saveDiscontinuitySyncInfo_(e), e.playlist.syncInfo || (e.playlist.syncInfo = {
      mediaSequence: e.playlist.mediaSequence + e.mediaIndex,
      time: i.start
    }));
    const r = i.dateTimeObject;
    i.discontinuity && n && r && (this.timelineToDatetimeMappings[i.timeline] = -(r.getTime() / 1e3));
  }
  timestampOffsetForTimeline(e) {
    return typeof this.timelines[e] > "u" ? null : this.timelines[e].time;
  }
  mappingForTimeline(e) {
    return typeof this.timelines[e] > "u" ? null : this.timelines[e].mapping;
  }
  /**
   * Use the "media time" for a segment to generate a mapping to "display time" and
   * save that display time to the segment.
   *
   * @private
   * @param {SegmentInfo} segmentInfo
   *        The current active request information
   * @param {Object} timingInfo
   *        The start and end time of the current segment in "media time"
   * @param {boolean} shouldSaveTimelineMapping
   *        If there's a timeline change, determines if the timeline mapping should be
   *        saved in timelines.
   * @return {boolean}
   *          Returns false if segment time mapping could not be calculated
   */
  calculateSegmentTimeMapping_(e, n, a) {
    const i = e.segment, r = e.part;
    let s = this.timelines[e.timeline], o, l;
    if (typeof e.timestampOffset == "number")
      s = {
        time: e.startOfSegment,
        mapping: e.startOfSegment - n.start
      }, a && (this.timelines[e.timeline] = s, this.trigger("timestampoffset"), this.logger_(`time mapping for timeline ${e.timeline}: [time: ${s.time}] [mapping: ${s.mapping}]`)), o = e.startOfSegment, l = n.end + s.mapping;
    else if (s)
      o = n.start + s.mapping, l = n.end + s.mapping;
    else
      return !1;
    return r && (r.start = o, r.end = l), (!i.start || o < i.start) && (i.start = o), i.end = l, !0;
  }
  /**
   * Each time we have discontinuity in the playlist, attempt to calculate the location
   * in display of the start of the discontinuity and save that. We also save an accuracy
   * value so that we save values with the most accuracy (closest to 0.)
   *
   * @private
   * @param {SegmentInfo} segmentInfo - The current active request information
   */
  saveDiscontinuitySyncInfo_(e) {
    const n = e.playlist, a = e.segment;
    if (a.discontinuity)
      this.discontinuities[a.timeline] = {
        time: a.start,
        accuracy: 0
      };
    else if (n.discontinuityStarts && n.discontinuityStarts.length)
      for (let i = 0; i < n.discontinuityStarts.length; i++) {
        const r = n.discontinuityStarts[i], s = n.discontinuitySequence + i + 1, o = r - e.mediaIndex, l = Math.abs(o);
        if (!this.discontinuities[s] || this.discontinuities[s].accuracy > l) {
          let c;
          o < 0 ? c = a.start - ml({
            defaultDuration: n.targetDuration,
            durationList: n.segments,
            startIndex: e.mediaIndex,
            endIndex: r
          }) : c = a.end + ml({
            defaultDuration: n.targetDuration,
            durationList: n.segments,
            startIndex: e.mediaIndex + 1,
            endIndex: r
          }), this.discontinuities[s] = {
            time: c,
            accuracy: l
          };
        }
      }
  }
  dispose() {
    this.trigger("dispose"), this.off();
  }
}
class ere extends ce.EventTarget {
  constructor() {
    super(), this.pendingTimelineChanges_ = {}, this.lastTimelineChanges_ = {};
  }
  clearPendingTimelineChange(e) {
    this.pendingTimelineChanges_[e] = null, this.trigger("pendingtimelinechange");
  }
  pendingTimelineChange({
    type: e,
    from: n,
    to: a
  }) {
    return typeof n == "number" && typeof a == "number" && (this.pendingTimelineChanges_[e] = {
      type: e,
      from: n,
      to: a
    }, this.trigger("pendingtimelinechange")), this.pendingTimelineChanges_[e];
  }
  lastTimelineChange({
    type: e,
    from: n,
    to: a
  }) {
    if (typeof n == "number" && typeof a == "number") {
      this.lastTimelineChanges_[e] = {
        type: e,
        from: n,
        to: a
      }, delete this.pendingTimelineChanges_[e];
      const i = {
        timelineChangeInfo: {
          from: n,
          to: a
        }
      };
      this.trigger({
        type: "timelinechange",
        metadata: i
      });
    }
    return this.lastTimelineChanges_[e];
  }
  dispose() {
    this.trigger("dispose"), this.pendingTimelineChanges_ = {}, this.lastTimelineChanges_ = {}, this.off();
  }
}
const tre = V_(q_(function() {
  var t = /* @__PURE__ */ function() {
    function g() {
      this.listeners = {};
    }
    var x = g.prototype;
    return x.on = function(D, L) {
      this.listeners[D] || (this.listeners[D] = []), this.listeners[D].push(L);
    }, x.off = function(D, L) {
      if (!this.listeners[D])
        return !1;
      var M = this.listeners[D].indexOf(L);
      return this.listeners[D] = this.listeners[D].slice(0), this.listeners[D].splice(M, 1), M > -1;
    }, x.trigger = function(D) {
      var L = this.listeners[D];
      if (L)
        if (arguments.length === 2)
          for (var M = L.length, E = 0; E < M; ++E)
            L[E].call(this, arguments[1]);
        else
          for (var P = Array.prototype.slice.call(arguments, 1), B = L.length, z = 0; z < B; ++z)
            L[z].apply(this, P);
    }, x.dispose = function() {
      this.listeners = {};
    }, x.pipe = function(D) {
      this.on("data", function(L) {
        D.push(L);
      });
    }, g;
  }();
  /*! @name pkcs7 @version 1.0.4 @license Apache-2.0 */
  function e(g) {
    return g.subarray(0, g.byteLength - g[g.byteLength - 1]);
  }
  /*! @name aes-decrypter @version 4.0.2 @license Apache-2.0 */
  const n = function() {
    const g = [[[], [], [], [], []], [[], [], [], [], []]], x = g[0], S = g[1], D = x[4], L = S[4];
    let M, E, P;
    const B = [], z = [];
    let W, V, H, se, ie, Z;
    for (M = 0; M < 256; M++)
      z[(B[M] = M << 1 ^ (M >> 7) * 283) ^ M] = M;
    for (E = P = 0; !D[E]; E ^= W || 1, P = z[P] || 1)
      for (se = P ^ P << 1 ^ P << 2 ^ P << 3 ^ P << 4, se = se >> 8 ^ se & 255 ^ 99, D[E] = se, L[se] = E, H = B[V = B[W = B[E]]], Z = H * 16843009 ^ V * 65537 ^ W * 257 ^ E * 16843008, ie = B[se] * 257 ^ se * 16843008, M = 0; M < 4; M++)
        x[M][E] = ie = ie << 24 ^ ie >>> 8, S[M][se] = Z = Z << 24 ^ Z >>> 8;
    for (M = 0; M < 5; M++)
      x[M] = x[M].slice(0), S[M] = S[M].slice(0);
    return g;
  };
  let a = null;
  class i {
    constructor(x) {
      a || (a = n()), this._tables = [[a[0][0].slice(), a[0][1].slice(), a[0][2].slice(), a[0][3].slice(), a[0][4].slice()], [a[1][0].slice(), a[1][1].slice(), a[1][2].slice(), a[1][3].slice(), a[1][4].slice()]];
      let S, D, L;
      const M = this._tables[0][4], E = this._tables[1], P = x.length;
      let B = 1;
      if (P !== 4 && P !== 6 && P !== 8)
        throw new Error("Invalid aes key size");
      const z = x.slice(0), W = [];
      for (this._key = [z, W], S = P; S < 4 * P + 28; S++)
        L = z[S - 1], (S % P === 0 || P === 8 && S % P === 4) && (L = M[L >>> 24] << 24 ^ M[L >> 16 & 255] << 16 ^ M[L >> 8 & 255] << 8 ^ M[L & 255], S % P === 0 && (L = L << 8 ^ L >>> 24 ^ B << 24, B = B << 1 ^ (B >> 7) * 283)), z[S] = z[S - P] ^ L;
      for (D = 0; S; D++, S--)
        L = z[D & 3 ? S : S - 4], S <= 4 || D < 4 ? W[D] = L : W[D] = E[0][M[L >>> 24]] ^ E[1][M[L >> 16 & 255]] ^ E[2][M[L >> 8 & 255]] ^ E[3][M[L & 255]];
    }
    /**
     * Decrypt 16 bytes, specified as four 32-bit words.
     *
     * @param {number} encrypted0 the first word to decrypt
     * @param {number} encrypted1 the second word to decrypt
     * @param {number} encrypted2 the third word to decrypt
     * @param {number} encrypted3 the fourth word to decrypt
     * @param {Int32Array} out the array to write the decrypted words
     * into
     * @param {number} offset the offset into the output array to start
     * writing results
     * @return {Array} The plaintext.
     */
    decrypt(x, S, D, L, M, E) {
      const P = this._key[1];
      let B = x ^ P[0], z = L ^ P[1], W = D ^ P[2], V = S ^ P[3], H, se, ie;
      const Z = P.length / 4 - 2;
      let $, J = 4;
      const N = this._tables[1], ue = N[0], xe = N[1], De = N[2], He = N[3], te = N[4];
      for ($ = 0; $ < Z; $++)
        H = ue[B >>> 24] ^ xe[z >> 16 & 255] ^ De[W >> 8 & 255] ^ He[V & 255] ^ P[J], se = ue[z >>> 24] ^ xe[W >> 16 & 255] ^ De[V >> 8 & 255] ^ He[B & 255] ^ P[J + 1], ie = ue[W >>> 24] ^ xe[V >> 16 & 255] ^ De[B >> 8 & 255] ^ He[z & 255] ^ P[J + 2], V = ue[V >>> 24] ^ xe[B >> 16 & 255] ^ De[z >> 8 & 255] ^ He[W & 255] ^ P[J + 3], J += 4, B = H, z = se, W = ie;
      for ($ = 0; $ < 4; $++)
        M[(3 & -$) + E] = te[B >>> 24] << 24 ^ te[z >> 16 & 255] << 16 ^ te[W >> 8 & 255] << 8 ^ te[V & 255] ^ P[J++], H = B, B = z, z = W, W = V, V = H;
    }
  }
  class r extends t {
    constructor() {
      super(t), this.jobs = [], this.delay = 1, this.timeout_ = null;
    }
    /**
     * process an async job
     *
     * @private
     */
    processJob_() {
      this.jobs.shift()(), this.jobs.length ? this.timeout_ = setTimeout(this.processJob_.bind(this), this.delay) : this.timeout_ = null;
    }
    /**
     * push a job into the stream
     *
     * @param {Function} job the job to push into the stream
     */
    push(x) {
      this.jobs.push(x), this.timeout_ || (this.timeout_ = setTimeout(this.processJob_.bind(this), this.delay));
    }
  }
  const s = function(g) {
    return g << 24 | (g & 65280) << 8 | (g & 16711680) >> 8 | g >>> 24;
  }, o = function(g, x, S) {
    const D = new Int32Array(g.buffer, g.byteOffset, g.byteLength >> 2), L = new i(Array.prototype.slice.call(x)), M = new Uint8Array(g.byteLength), E = new Int32Array(M.buffer);
    let P, B, z, W, V, H, se, ie, Z;
    for (P = S[0], B = S[1], z = S[2], W = S[3], Z = 0; Z < D.length; Z += 4)
      V = s(D[Z]), H = s(D[Z + 1]), se = s(D[Z + 2]), ie = s(D[Z + 3]), L.decrypt(V, H, se, ie, E, Z), E[Z] = s(E[Z] ^ P), E[Z + 1] = s(E[Z + 1] ^ B), E[Z + 2] = s(E[Z + 2] ^ z), E[Z + 3] = s(E[Z + 3] ^ W), P = V, B = H, z = se, W = ie;
    return M;
  };
  class l {
    constructor(x, S, D, L) {
      const M = l.STEP, E = new Int32Array(x.buffer), P = new Uint8Array(x.byteLength);
      let B = 0;
      for (this.asyncStream_ = new r(), this.asyncStream_.push(this.decryptChunk_(E.subarray(B, B + M), S, D, P)), B = M; B < E.length; B += M)
        D = new Uint32Array([s(E[B - 4]), s(E[B - 3]), s(E[B - 2]), s(E[B - 1])]), this.asyncStream_.push(this.decryptChunk_(E.subarray(B, B + M), S, D, P));
      this.asyncStream_.push(function() {
        L(null, e(P));
      });
    }
    /**
     * a getter for step the maximum number of bytes to process at one time
     *
     * @return {number} the value of step 32000
     */
    static get STEP() {
      return 32e3;
    }
    /**
     * @private
     */
    decryptChunk_(x, S, D, L) {
      return function() {
        const M = o(x, S, D);
        L.set(M, x.byteOffset);
      };
    }
  }
  var c = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, u;
  typeof window < "u" ? u = window : typeof c < "u" ? u = c : typeof self < "u" ? u = self : u = {};
  var f = u, m = function(x) {
    return ArrayBuffer.isView === "function" ? ArrayBuffer.isView(x) : x && x.buffer instanceof ArrayBuffer;
  }, _ = f.BigInt || Number;
  _("0x1"), _("0x100"), _("0x10000"), _("0x1000000"), _("0x100000000"), _("0x10000000000"), _("0x1000000000000"), _("0x100000000000000"), _("0x10000000000000000"), function() {
    var g = new Uint16Array([65484]), x = new Uint8Array(g.buffer, g.byteOffset, g.byteLength);
    return x[0] === 255 ? "big" : x[0] === 204 ? "little" : "unknown";
  }();
  const T = function(g) {
    const x = {};
    return Object.keys(g).forEach((S) => {
      const D = g[S];
      m(D) ? x[S] = {
        bytes: D.buffer,
        byteOffset: D.byteOffset,
        byteLength: D.byteLength
      } : x[S] = D;
    }), x;
  };
  self.onmessage = function(g) {
    const x = g.data, S = new Uint8Array(x.encrypted.bytes, x.encrypted.byteOffset, x.encrypted.byteLength), D = new Uint32Array(x.key.bytes, x.key.byteOffset, x.key.byteLength / 4), L = new Uint32Array(x.iv.bytes, x.iv.byteOffset, x.iv.byteLength / 4);
    new l(S, D, L, function(M, E) {
      self.postMessage(T({
        source: x.source,
        decrypted: E
      }), [E.buffer]);
    });
  };
}));
var nre = j_(tre);
const are = (t) => {
  let e = t.default ? "main" : "alternative";
  return t.characteristics && t.characteristics.indexOf("public.accessibility.describes-video") >= 0 && (e = "main-desc"), e;
}, lT = (t, e) => {
  t.abort(), t.pause(), e && e.activePlaylistLoader && (e.activePlaylistLoader.pause(), e.activePlaylistLoader = null);
}, Hh = (t, e) => {
  e.activePlaylistLoader = t, t.load();
}, ire = (t, e) => () => {
  const {
    segmentLoaders: {
      [t]: n,
      main: a
    },
    mediaTypes: {
      [t]: i
    }
  } = e, r = i.activeTrack(), s = i.getActiveGroup(), o = i.activePlaylistLoader, l = i.lastGroup_;
  if (!(s && l && s.id === l.id) && (i.lastGroup_ = s, i.lastTrack_ = r, lT(n, i), !(!s || s.isMainPlaylist))) {
    if (!s.playlistLoader) {
      o && a.resetEverything();
      return;
    }
    n.resyncLoader(), Hh(s.playlistLoader, i);
  }
}, rre = (t, e) => () => {
  const {
    segmentLoaders: {
      [t]: n
    },
    mediaTypes: {
      [t]: a
    }
  } = e;
  a.lastGroup_ = null, n.abort(), n.pause();
}, sre = (t, e) => () => {
  const {
    mainPlaylistLoader: n,
    segmentLoaders: {
      [t]: a,
      main: i
    },
    mediaTypes: {
      [t]: r
    }
  } = e, s = r.activeTrack(), o = r.getActiveGroup(), l = r.activePlaylistLoader, c = r.lastTrack_;
  if (!(c && s && c.id === s.id) && (r.lastGroup_ = o, r.lastTrack_ = s, lT(a, r), !!o)) {
    if (o.isMainPlaylist) {
      if (!s || !c || s.id === c.id)
        return;
      const u = e.vhs.playlistController_, f = u.selectPlaylist();
      if (u.media() === f)
        return;
      r.logger_(`track change. Switching main audio from ${c.id} to ${s.id}`), n.pause(), i.resetEverything(), u.fastQualityChange_(f);
      return;
    }
    if (t === "AUDIO") {
      if (!o.playlistLoader) {
        i.setAudio(!0), i.resetEverything();
        return;
      }
      a.setAudio(!0), i.setAudio(!1);
    }
    if (l === o.playlistLoader) {
      Hh(o.playlistLoader, r);
      return;
    }
    a.track && a.track(s), a.resetEverything(), Hh(o.playlistLoader, r);
  }
}, $u = {
  /**
   * Returns a function to be called when a SegmentLoader or PlaylistLoader encounters
   * an error.
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @return {Function}
   *         Error handler. Logs warning (or error if the playlist is excluded) to
   *         console and switches back to default audio track.
   * @function onError.AUDIO
   */
  AUDIO: (t, e) => () => {
    const {
      mediaTypes: {
        [t]: n
      },
      excludePlaylist: a
    } = e, i = n.activeTrack(), r = n.activeGroup(), s = (r.filter((l) => l.default)[0] || r[0]).id, o = n.tracks[s];
    if (i === o) {
      a({
        error: {
          message: "Problem encountered loading the default audio track."
        }
      });
      return;
    }
    ce.log.warn("Problem encountered loading the alternate audio track.Switching back to default.");
    for (const l in n.tracks)
      n.tracks[l].enabled = n.tracks[l] === o;
    n.onTrackChanged();
  },
  /**
   * Returns a function to be called when a SegmentLoader or PlaylistLoader encounters
   * an error.
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @return {Function}
   *         Error handler. Logs warning to console and disables the active subtitle track
   * @function onError.SUBTITLES
   */
  SUBTITLES: (t, e) => () => {
    const {
      mediaTypes: {
        [t]: n
      }
    } = e;
    ce.log.warn("Problem encountered loading the subtitle track.Disabling subtitle track.");
    const a = n.activeTrack();
    a && (a.mode = "disabled"), n.onTrackChanged();
  }
}, Vb = {
  /**
   * Setup event listeners for audio playlist loader
   *
   * @param {string} type
   *        MediaGroup type
   * @param {PlaylistLoader|null} playlistLoader
   *        PlaylistLoader to register listeners on
   * @param {Object} settings
   *        Object containing required information for media groups
   * @function setupListeners.AUDIO
   */
  AUDIO: (t, e, n) => {
    if (!e)
      return;
    const {
      tech: a,
      requestOptions: i,
      segmentLoaders: {
        [t]: r
      }
    } = n;
    e.on("loadedmetadata", () => {
      const s = e.media();
      r.playlist(s, i), (!a.paused() || s.endList && a.preload() !== "none") && r.load();
    }), e.on("loadedplaylist", () => {
      r.playlist(e.media(), i), a.paused() || r.load();
    }), e.on("error", $u[t](t, n));
  },
  /**
   * Setup event listeners for subtitle playlist loader
   *
   * @param {string} type
   *        MediaGroup type
   * @param {PlaylistLoader|null} playlistLoader
   *        PlaylistLoader to register listeners on
   * @param {Object} settings
   *        Object containing required information for media groups
   * @function setupListeners.SUBTITLES
   */
  SUBTITLES: (t, e, n) => {
    const {
      tech: a,
      requestOptions: i,
      segmentLoaders: {
        [t]: r
      },
      mediaTypes: {
        [t]: s
      }
    } = n;
    e.on("loadedmetadata", () => {
      const o = e.media();
      r.playlist(o, i), r.track(s.activeTrack()), (!a.paused() || o.endList && a.preload() !== "none") && r.load();
    }), e.on("loadedplaylist", () => {
      r.playlist(e.media(), i), a.paused() || r.load();
    }), e.on("error", $u[t](t, n));
  }
}, ore = {
  /**
   * Setup PlaylistLoaders and AudioTracks for the audio groups
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @function initialize.AUDIO
   */
  AUDIO: (t, e) => {
    const {
      vhs: n,
      sourceType: a,
      segmentLoaders: {
        [t]: i
      },
      requestOptions: r,
      main: {
        mediaGroups: s
      },
      mediaTypes: {
        [t]: {
          groups: o,
          tracks: l,
          logger_: c
        }
      },
      mainPlaylistLoader: u
    } = e, f = Kl(u.main);
    (!s[t] || Object.keys(s[t]).length === 0) && (s[t] = {
      main: {
        default: {
          default: !0
        }
      }
    }, f && (s[t].main.default.playlists = u.main.playlists));
    for (const m in s[t]) {
      o[m] || (o[m] = []);
      for (const _ in s[t][m]) {
        let T = s[t][m][_], g;
        if (f ? (c(`AUDIO group '${m}' label '${_}' is a main playlist`), T.isMainPlaylist = !0, g = null) : a === "vhs-json" && T.playlists ? g = new gs(T.playlists[0], n, r) : T.resolvedUri ? g = new gs(T.resolvedUri, n, r) : T.playlists && a === "dash" ? g = new Nh(T.playlists[0], n, r, u) : g = null, T = gt({
          id: _,
          playlistLoader: g
        }, T), Vb[t](t, T.playlistLoader, e), o[m].push(T), typeof l[_] > "u") {
          const x = new ce.AudioTrack({
            id: _,
            kind: are(T),
            enabled: !1,
            language: T.language,
            default: T.default,
            label: _
          });
          l[_] = x;
        }
      }
    }
    i.on("error", $u[t](t, e));
  },
  /**
   * Setup PlaylistLoaders and TextTracks for the subtitle groups
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @function initialize.SUBTITLES
   */
  SUBTITLES: (t, e) => {
    const {
      tech: n,
      vhs: a,
      sourceType: i,
      segmentLoaders: {
        [t]: r
      },
      requestOptions: s,
      main: {
        mediaGroups: o
      },
      mediaTypes: {
        [t]: {
          groups: l,
          tracks: c
        }
      },
      mainPlaylistLoader: u
    } = e;
    for (const f in o[t]) {
      l[f] || (l[f] = []);
      for (const m in o[t][f]) {
        if (!a.options_.useForcedSubtitles && o[t][f][m].forced)
          continue;
        let _ = o[t][f][m], T;
        if (i === "hls")
          T = new gs(_.resolvedUri, a, s);
        else if (i === "dash") {
          if (!_.playlists.filter((x) => x.excludeUntil !== 1 / 0).length)
            return;
          T = new Nh(_.playlists[0], a, s, u);
        } else i === "vhs-json" && (T = new gs(
          // if the vhs-json object included the media playlist, use the media playlist
          // as provided, otherwise use the resolved URI to load the playlist
          _.playlists ? _.playlists[0] : _.resolvedUri,
          a,
          s
        ));
        if (_ = gt({
          id: m,
          playlistLoader: T
        }, _), Vb[t](t, _.playlistLoader, e), l[f].push(_), typeof c[m] > "u") {
          const g = n.addRemoteTextTrack({
            id: m,
            kind: "subtitles",
            default: _.default && _.autoselect,
            language: _.language,
            label: m
          }, !1).track;
          c[m] = g;
        }
      }
    }
    r.on("error", $u[t](t, e));
  },
  /**
   * Setup TextTracks for the closed-caption groups
   *
   * @param {String} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @function initialize['CLOSED-CAPTIONS']
   */
  "CLOSED-CAPTIONS": (t, e) => {
    const {
      tech: n,
      main: {
        mediaGroups: a
      },
      mediaTypes: {
        [t]: {
          groups: i,
          tracks: r
        }
      }
    } = e;
    for (const s in a[t]) {
      i[s] || (i[s] = []);
      for (const o in a[t][s]) {
        const l = a[t][s][o];
        if (!/^(?:CC|SERVICE)/.test(l.instreamId))
          continue;
        const c = n.options_.vhs && n.options_.vhs.captionServices || {};
        let u = {
          label: o,
          language: l.language,
          instreamId: l.instreamId,
          default: l.default && l.autoselect
        };
        if (c[u.instreamId] && (u = gt(u, c[u.instreamId])), u.default === void 0 && delete u.default, i[s].push(gt({
          id: o
        }, l)), typeof r[o] > "u") {
          const f = n.addRemoteTextTrack({
            id: u.instreamId,
            kind: "captions",
            default: u.default,
            language: u.language,
            label: u.label
          }, !1).track;
          r[o] = f;
        }
      }
    }
  }
}, cT = (t, e) => {
  for (let n = 0; n < t.length; n++)
    if (Mp(e, t[n]) || t[n].playlists && cT(t[n].playlists, e))
      return !0;
  return !1;
}, lre = (t, e) => (n) => {
  const {
    mainPlaylistLoader: a,
    mediaTypes: {
      [t]: {
        groups: i
      }
    }
  } = e, r = a.media();
  if (!r)
    return null;
  let s = null;
  r.attributes[t] && (s = i[r.attributes[t]]);
  const o = Object.keys(i);
  if (!s)
    if (t === "AUDIO" && o.length > 1 && Kl(e.main))
      for (let l = 0; l < o.length; l++) {
        const c = i[o[l]];
        if (cT(c, r)) {
          s = c;
          break;
        }
      }
    else i.main ? s = i.main : o.length === 1 && (s = i[o[0]]);
  return typeof n > "u" ? s : n === null || !s ? null : s.filter((l) => l.id === n.id)[0] || null;
}, cre = {
  /**
   * Returns a function used to get the active track of type provided
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @return {Function}
   *         Function that returns the active media track for the provided type. Returns
   *         null if no track is active
   * @function activeTrack.AUDIO
   */
  AUDIO: (t, e) => () => {
    const {
      mediaTypes: {
        [t]: {
          tracks: n
        }
      }
    } = e;
    for (const a in n)
      if (n[a].enabled)
        return n[a];
    return null;
  },
  /**
   * Returns a function used to get the active track of type provided
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @return {Function}
   *         Function that returns the active media track for the provided type. Returns
   *         null if no track is active
   * @function activeTrack.SUBTITLES
   */
  SUBTITLES: (t, e) => () => {
    const {
      mediaTypes: {
        [t]: {
          tracks: n
        }
      }
    } = e;
    for (const a in n)
      if (n[a].mode === "showing" || n[a].mode === "hidden")
        return n[a];
    return null;
  }
}, ure = (t, {
  mediaTypes: e
}) => () => {
  const n = e[t].activeTrack();
  return n ? e[t].activeGroup(n) : null;
}, dre = (t) => {
  ["AUDIO", "SUBTITLES", "CLOSED-CAPTIONS"].forEach((c) => {
    ore[c](c, t);
  });
  const {
    mediaTypes: e,
    mainPlaylistLoader: n,
    tech: a,
    vhs: i,
    segmentLoaders: {
      ["AUDIO"]: r,
      main: s
    }
  } = t;
  ["AUDIO", "SUBTITLES"].forEach((c) => {
    e[c].activeGroup = lre(c, t), e[c].activeTrack = cre[c](c, t), e[c].onGroupChanged = ire(c, t), e[c].onGroupChanging = rre(c, t), e[c].onTrackChanged = sre(c, t), e[c].getActiveGroup = ure(c, t);
  });
  const o = e.AUDIO.activeGroup();
  if (o) {
    const c = (o.filter((f) => f.default)[0] || o[0]).id;
    e.AUDIO.tracks[c].enabled = !0, e.AUDIO.onGroupChanged(), e.AUDIO.onTrackChanged(), e.AUDIO.getActiveGroup().playlistLoader ? (s.setAudio(!1), r.setAudio(!0)) : s.setAudio(!0);
  }
  n.on("mediachange", () => {
    ["AUDIO", "SUBTITLES"].forEach((c) => e[c].onGroupChanged());
  }), n.on("mediachanging", () => {
    ["AUDIO", "SUBTITLES"].forEach((c) => e[c].onGroupChanging());
  });
  const l = () => {
    e.AUDIO.onTrackChanged(), a.trigger({
      type: "usage",
      name: "vhs-audio-change"
    });
  };
  a.audioTracks().addEventListener("change", l), a.remoteTextTracks().addEventListener("change", e.SUBTITLES.onTrackChanged), i.on("dispose", () => {
    a.audioTracks().removeEventListener("change", l), a.remoteTextTracks().removeEventListener("change", e.SUBTITLES.onTrackChanged);
  }), a.clearTracks("audio");
  for (const c in e.AUDIO.tracks)
    a.audioTracks().addTrack(e.AUDIO.tracks[c]);
}, hre = () => {
  const t = {};
  return ["AUDIO", "SUBTITLES", "CLOSED-CAPTIONS"].forEach((e) => {
    t[e] = {
      groups: {},
      tracks: {},
      activePlaylistLoader: null,
      activeGroup: bi,
      activeTrack: bi,
      getActiveGroup: bi,
      onGroupChanged: bi,
      onTrackChanged: bi,
      lastTrack_: null,
      logger_: Ca(`MediaGroups[${e}]`)
    };
  }), t;
};
class qb {
  constructor() {
    this.priority_ = [], this.pathwayClones_ = /* @__PURE__ */ new Map();
  }
  set version(e) {
    e === 1 && (this.version_ = e);
  }
  set ttl(e) {
    this.ttl_ = e || 300;
  }
  set reloadUri(e) {
    e && (this.reloadUri_ = Zn(this.reloadUri_, e));
  }
  set priority(e) {
    e && e.length && (this.priority_ = e);
  }
  set pathwayClones(e) {
    e && e.length && (this.pathwayClones_ = new Map(e.map((n) => [n.ID, n])));
  }
  get version() {
    return this.version_;
  }
  get ttl() {
    return this.ttl_;
  }
  get reloadUri() {
    return this.reloadUri_;
  }
  get priority() {
    return this.priority_;
  }
  get pathwayClones() {
    return this.pathwayClones_;
  }
}
class fre extends ce.EventTarget {
  constructor(e, n) {
    super(), this.currentPathway = null, this.defaultPathway = null, this.queryBeforeStart = !1, this.availablePathways_ = /* @__PURE__ */ new Set(), this.steeringManifest = new qb(), this.proxyServerUrl_ = null, this.manifestType_ = null, this.ttlTimeout_ = null, this.request_ = null, this.currentPathwayClones = /* @__PURE__ */ new Map(), this.nextPathwayClones = /* @__PURE__ */ new Map(), this.excludedSteeringManifestURLs = /* @__PURE__ */ new Set(), this.logger_ = Ca("Content Steering"), this.xhr_ = e, this.getBandwidth_ = n;
  }
  /**
   * Assigns the content steering tag properties to the steering controller
   *
   * @param {string} baseUrl the baseURL from the main manifest for resolving the steering manifest url
   * @param {Object} steeringTag the content steering tag from the main manifest
   */
  assignTagProperties(e, n) {
    this.manifestType_ = n.serverUri ? "HLS" : "DASH";
    const a = n.serverUri || n.serverURL;
    if (!a) {
      this.logger_(`steering manifest URL is ${a}, cannot request steering manifest.`), this.trigger("error");
      return;
    }
    if (a.startsWith("data:")) {
      this.decodeDataUriManifest_(a.substring(a.indexOf(",") + 1));
      return;
    }
    this.steeringManifest.reloadUri = Zn(e, a), this.defaultPathway = n.pathwayId || n.defaultServiceLocation, this.queryBeforeStart = n.queryBeforeStart, this.proxyServerUrl_ = n.proxyServerURL, this.defaultPathway && !this.queryBeforeStart && this.trigger("content-steering");
  }
  /**
   * Requests the content steering manifest and parse the response. This should only be called after
   * assignTagProperties was called with a content steering tag.
   *
   * @param {string} initialUri The optional uri to make the request with.
   *    If set, the request should be made with exactly what is passed in this variable.
   *    This scenario should only happen once on initalization.
   */
  requestSteeringManifest(e) {
    const n = this.steeringManifest.reloadUri;
    if (!n)
      return;
    const a = e ? n : this.getRequestURI(n);
    if (!a) {
      this.logger_("No valid content steering manifest URIs. Stopping content steering."), this.trigger("error"), this.dispose();
      return;
    }
    const i = {
      contentSteeringInfo: {
        uri: a
      }
    };
    this.trigger({
      type: "contentsteeringloadstart",
      metadata: i
    }), this.request_ = this.xhr_({
      uri: a,
      requestType: "content-steering-manifest"
    }, (r, s) => {
      if (r) {
        if (s.status === 410) {
          this.logger_(`manifest request 410 ${r}.`), this.logger_(`There will be no more content steering requests to ${a} this session.`), this.excludedSteeringManifestURLs.add(a);
          return;
        }
        if (s.status === 429) {
          const c = s.responseHeaders["retry-after"];
          this.logger_(`manifest request 429 ${r}.`), this.logger_(`content steering will retry in ${c} seconds.`), this.startTTLTimeout_(parseInt(c, 10));
          return;
        }
        this.logger_(`manifest failed to load ${r}.`), this.startTTLTimeout_();
        return;
      }
      this.trigger({
        type: "contentsteeringloadcomplete",
        metadata: i
      });
      let o;
      try {
        o = JSON.parse(this.request_.responseText);
      } catch (c) {
        const u = {
          errorType: ce.Error.StreamingContentSteeringParserError,
          error: c
        };
        this.trigger({
          type: "error",
          metadata: u
        });
      }
      this.assignSteeringProperties_(o);
      const l = {
        contentSteeringInfo: i.contentSteeringInfo,
        contentSteeringManifest: {
          version: this.steeringManifest.version,
          reloadUri: this.steeringManifest.reloadUri,
          priority: this.steeringManifest.priority
        }
      };
      this.trigger({
        type: "contentsteeringparsed",
        metadata: l
      }), this.startTTLTimeout_();
    });
  }
  /**
   * Set the proxy server URL and add the steering manifest url as a URI encoded parameter.
   *
   * @param {string} steeringUrl the steering manifest url
   * @return the steering manifest url to a proxy server with all parameters set
   */
  setProxyServerUrl_(e) {
    const n = new j.URL(e), a = new j.URL(this.proxyServerUrl_);
    return a.searchParams.set("url", encodeURI(n.toString())), this.setSteeringParams_(a.toString());
  }
  /**
   * Decodes and parses the data uri encoded steering manifest
   *
   * @param {string} dataUri the data uri to be decoded and parsed.
   */
  decodeDataUriManifest_(e) {
    const n = JSON.parse(j.atob(e));
    this.assignSteeringProperties_(n);
  }
  /**
   * Set the HLS or DASH content steering manifest request query parameters. For example:
   * _HLS_pathway="<CURRENT-PATHWAY-ID>" and _HLS_throughput=<THROUGHPUT>
   * _DASH_pathway and _DASH_throughput
   *
   * @param {string} uri to add content steering server parameters to.
   * @return a new uri as a string with the added steering query parameters.
   */
  setSteeringParams_(e) {
    const n = new j.URL(e), a = this.getPathway(), i = this.getBandwidth_();
    if (a) {
      const r = `_${this.manifestType_}_pathway`;
      n.searchParams.set(r, a);
    }
    if (i) {
      const r = `_${this.manifestType_}_throughput`;
      n.searchParams.set(r, i);
    }
    return n.toString();
  }
  /**
   * Assigns the current steering manifest properties and to the SteeringManifest object
   *
   * @param {Object} steeringJson the raw JSON steering manifest
   */
  assignSteeringProperties_(e) {
    if (this.steeringManifest.version = e.VERSION, !this.steeringManifest.version) {
      this.logger_(`manifest version is ${e.VERSION}, which is not supported.`), this.trigger("error");
      return;
    }
    this.steeringManifest.ttl = e.TTL, this.steeringManifest.reloadUri = e["RELOAD-URI"], this.steeringManifest.priority = e["PATHWAY-PRIORITY"] || e["SERVICE-LOCATION-PRIORITY"], this.steeringManifest.pathwayClones = e["PATHWAY-CLONES"], this.nextPathwayClones = this.steeringManifest.pathwayClones, this.availablePathways_.size || (this.logger_("There are no available pathways for content steering. Ending content steering."), this.trigger("error"), this.dispose());
    const a = ((i) => {
      for (const r of i)
        if (this.availablePathways_.has(r))
          return r;
      return [...this.availablePathways_][0];
    })(this.steeringManifest.priority);
    this.currentPathway !== a && (this.currentPathway = a, this.trigger("content-steering"));
  }
  /**
   * Returns the pathway to use for steering decisions
   *
   * @return {string} returns the current pathway or the default
   */
  getPathway() {
    return this.currentPathway || this.defaultPathway;
  }
  /**
   * Chooses the manifest request URI based on proxy URIs and server URLs.
   * Also accounts for exclusion on certain manifest URIs.
   *
   * @param {string} reloadUri the base uri before parameters
   *
   * @return {string} the final URI for the request to the manifest server.
   */
  getRequestURI(e) {
    if (!e)
      return null;
    const n = (i) => this.excludedSteeringManifestURLs.has(i);
    if (this.proxyServerUrl_) {
      const i = this.setProxyServerUrl_(e);
      if (!n(i))
        return i;
    }
    const a = this.setSteeringParams_(e);
    return n(a) ? null : a;
  }
  /**
   * Start the timeout for re-requesting the steering manifest at the TTL interval.
   *
   * @param {number} ttl time in seconds of the timeout. Defaults to the
   *        ttl interval in the steering manifest
   */
  startTTLTimeout_(e = this.steeringManifest.ttl) {
    const n = e * 1e3;
    this.ttlTimeout_ = j.setTimeout(() => {
      this.requestSteeringManifest();
    }, n);
  }
  /**
   * Clear the TTL timeout if necessary.
   */
  clearTTLTimeout_() {
    j.clearTimeout(this.ttlTimeout_), this.ttlTimeout_ = null;
  }
  /**
   * aborts any current steering xhr and sets the current request object to null
   */
  abort() {
    this.request_ && this.request_.abort(), this.request_ = null;
  }
  /**
   * aborts steering requests clears the ttl timeout and resets all properties.
   */
  dispose() {
    this.off("content-steering"), this.off("error"), this.abort(), this.clearTTLTimeout_(), this.currentPathway = null, this.defaultPathway = null, this.queryBeforeStart = null, this.proxyServerUrl_ = null, this.manifestType_ = null, this.ttlTimeout_ = null, this.request_ = null, this.excludedSteeringManifestURLs = /* @__PURE__ */ new Set(), this.availablePathways_ = /* @__PURE__ */ new Set(), this.steeringManifest = new qb();
  }
  /**
   * adds a pathway to the available pathways set
   *
   * @param {string} pathway the pathway string to add
   */
  addAvailablePathway(e) {
    e && this.availablePathways_.add(e);
  }
  /**
   * Clears all pathways from the available pathways set
   */
  clearAvailablePathways() {
    this.availablePathways_.clear();
  }
  /**
   * Removes a pathway from the available pathways set.
   */
  excludePathway(e) {
    return this.availablePathways_.delete(e);
  }
  /**
   * Checks the refreshed DASH manifest content steering tag for changes.
   *
   * @param {string} baseURL new steering tag on DASH manifest refresh
   * @param {Object} newTag the new tag to check for changes
   * @return a true or false whether the new tag has different values
   */
  didDASHTagChange(e, n) {
    return !n && this.steeringManifest.reloadUri || n && (Zn(e, n.serverURL) !== this.steeringManifest.reloadUri || n.defaultServiceLocation !== this.defaultPathway || n.queryBeforeStart !== this.queryBeforeStart || n.proxyServerURL !== this.proxyServerUrl_);
  }
  getAvailablePathways() {
    return this.availablePathways_;
  }
}
const pre = (t, e) => {
  let n = null;
  return (...a) => {
    clearTimeout(n), n = setTimeout(() => {
      t.apply(null, a);
    }, e);
  };
}, mre = 10;
let Vi;
const gre = ["mediaRequests", "mediaRequestsAborted", "mediaRequestsTimedout", "mediaRequestsErrored", "mediaTransferDuration", "mediaBytesTransferred", "mediaAppends"], bre = function(t) {
  return this.audioSegmentLoader_[t] + this.mainSegmentLoader_[t];
}, vre = function({
  currentPlaylist: t,
  buffered: e,
  currentTime: n,
  nextPlaylist: a,
  bufferLowWaterLine: i,
  bufferHighWaterLine: r,
  duration: s,
  bufferBasedABR: o,
  log: l
}) {
  if (!a)
    return ce.log.warn("We received no playlist to switch to. Please check your stream."), !1;
  const c = `allowing switch ${t && t.id || "null"} -> ${a.id}`;
  if (!t)
    return l(`${c} as current playlist is not set`), !0;
  if (a.id === t.id)
    return !1;
  const u = !!ms(e, n).length;
  if (!t.endList)
    return !u && typeof t.partTargetDuration == "number" ? (l(`not ${c} as current playlist is live llhls, but currentTime isn't in buffered.`), !1) : (l(`${c} as current playlist is live`), !0);
  const f = Lp(e, n), m = o ? mn.EXPERIMENTAL_MAX_BUFFER_LOW_WATER_LINE : mn.MAX_BUFFER_LOW_WATER_LINE;
  if (s < m)
    return l(`${c} as duration < max low water line (${s} < ${m})`), !0;
  const _ = a.attributes.BANDWIDTH, T = t.attributes.BANDWIDTH;
  if (_ < T && (!o || f < r)) {
    let g = `${c} as next bandwidth < current bandwidth (${_} < ${T})`;
    return o && (g += ` and forwardBuffer < bufferHighWaterLine (${f} < ${r})`), l(g), !0;
  }
  if ((!o || _ > T) && f >= i) {
    let g = `${c} as forwardBuffer >= bufferLowWaterLine (${f} >= ${i})`;
    return o && (g += ` and next bandwidth > current bandwidth (${_} > ${T})`), l(g), !0;
  }
  return l(`not ${c} as no switching criteria met`), !1;
};
class yre extends ce.EventTarget {
  constructor(e) {
    super(), this.fastQualityChange_ = pre(this.fastQualityChange_.bind(this), 100);
    const {
      src: n,
      withCredentials: a,
      tech: i,
      bandwidth: r,
      externVhs: s,
      useCueTags: o,
      playlistExclusionDuration: l,
      enableLowInitialPlaylist: c,
      sourceType: u,
      cacheEncryptionKeys: f,
      bufferBasedABR: m,
      leastPixelDiffSelector: _,
      captionServices: T,
      experimentalUseMMS: g
    } = e;
    if (!n)
      throw new Error("A non-empty playlist URL or JSON manifest string is required");
    let {
      maxPlaylistRetries: x
    } = e;
    (x === null || typeof x > "u") && (x = 1 / 0), Vi = s, this.bufferBasedABR = !!m, this.leastPixelDiffSelector = !!_, this.withCredentials = a, this.tech_ = i, this.vhs_ = i.vhs, this.player_ = e.player_, this.sourceType_ = u, this.useCueTags_ = o, this.playlistExclusionDuration = l, this.maxPlaylistRetries = x, this.enableLowInitialPlaylist = c, this.usingManagedMediaSource_ = !1, this.useCueTags_ && (this.cueTagsTrack_ = this.tech_.addTextTrack("metadata", "ad-cues"), this.cueTagsTrack_.inBandMetadataTrackDispatchType = ""), this.requestOptions_ = {
      withCredentials: a,
      maxPlaylistRetries: x,
      timeout: null
    }, this.on("error", this.pauseLoading), this.mediaTypes_ = hre(), g && j.ManagedMediaSource ? (this.tech_.el_.disableRemotePlayback = !0, this.mediaSource = new j.ManagedMediaSource(), this.usingManagedMediaSource_ = !0, ce.log("Using ManagedMediaSource")) : j.MediaSource && (this.mediaSource = new j.MediaSource()), this.handleDurationChange_ = this.handleDurationChange_.bind(this), this.handleSourceOpen_ = this.handleSourceOpen_.bind(this), this.handleSourceEnded_ = this.handleSourceEnded_.bind(this), this.load = this.load.bind(this), this.pause = this.pause.bind(this), this.mediaSource.addEventListener("durationchange", this.handleDurationChange_), this.mediaSource.addEventListener("sourceopen", this.handleSourceOpen_), this.mediaSource.addEventListener("sourceended", this.handleSourceEnded_), this.mediaSource.addEventListener("startstreaming", this.load), this.mediaSource.addEventListener("endstreaming", this.pause), this.seekable_ = vn(), this.hasPlayed_ = !1, this.syncController_ = new Jie(e), this.segmentMetadataTrack_ = i.addRemoteTextTrack({
      kind: "metadata",
      label: "segment-metadata"
    }, !1).track, this.decrypter_ = new nre(), this.sourceUpdater_ = new sT(this.mediaSource), this.inbandTextTracks_ = {}, this.timelineChangeController_ = new ere(), this.keyStatusMap_ = /* @__PURE__ */ new Map();
    const S = {
      vhs: this.vhs_,
      parse708captions: e.parse708captions,
      useDtsForTimestampOffset: e.useDtsForTimestampOffset,
      captionServices: T,
      mediaSource: this.mediaSource,
      currentTime: this.tech_.currentTime.bind(this.tech_),
      seekable: () => this.seekable(),
      seeking: () => this.tech_.seeking(),
      duration: () => this.duration(),
      hasPlayed: () => this.hasPlayed_,
      goalBufferLength: () => this.goalBufferLength(),
      bandwidth: r,
      syncController: this.syncController_,
      decrypter: this.decrypter_,
      sourceType: this.sourceType_,
      inbandTextTracks: this.inbandTextTracks_,
      cacheEncryptionKeys: f,
      sourceUpdater: this.sourceUpdater_,
      timelineChangeController: this.timelineChangeController_,
      exactManifestTimings: e.exactManifestTimings,
      addMetadataToTextTrack: this.addMetadataToTextTrack.bind(this)
    };
    this.mainPlaylistLoader_ = this.sourceType_ === "dash" ? new Nh(n, this.vhs_, gt(this.requestOptions_, {
      addMetadataToTextTrack: this.addMetadataToTextTrack.bind(this)
    })) : new gs(n, this.vhs_, gt(this.requestOptions_, {
      addDateRangesToTextTrack: this.addDateRangesToTextTrack_.bind(this)
    })), this.setupMainPlaylistLoaderListeners_(), this.mainSegmentLoader_ = new zh(gt(S, {
      segmentMetadataTrack: this.segmentMetadataTrack_,
      loaderType: "main"
    }), e), this.audioSegmentLoader_ = new zh(gt(S, {
      loaderType: "audio"
    }), e), this.subtitleSegmentLoader_ = new Gie(gt(S, {
      loaderType: "vtt",
      featuresNativeTextTracks: this.tech_.featuresNativeTextTracks,
      loadVttJs: () => new Promise((M, E) => {
        function P() {
          i.off("vttjserror", B), M();
        }
        function B() {
          i.off("vttjsloaded", P), E();
        }
        i.one("vttjsloaded", P), i.one("vttjserror", B), i.addWebVttScript_();
      })
    }), e);
    const D = () => this.mainSegmentLoader_.bandwidth;
    this.contentSteeringController_ = new fre(this.vhs_.xhr, D), this.setupSegmentLoaderListeners_(), this.bufferBasedABR && (this.mainPlaylistLoader_.one("loadedplaylist", () => this.startABRTimer_()), this.tech_.on("pause", () => this.stopABRTimer_()), this.tech_.on("play", () => this.startABRTimer_())), gre.forEach((M) => {
      this[M + "_"] = bre.bind(this, M);
    }), this.logger_ = Ca("pc"), this.triggeredFmp4Usage = !1, this.tech_.preload() === "none" ? (this.loadOnPlay_ = () => {
      this.loadOnPlay_ = null, this.mainPlaylistLoader_.load();
    }, this.tech_.one("play", this.loadOnPlay_)) : this.mainPlaylistLoader_.load(), this.timeToLoadedData__ = -1, this.mainAppendsToLoadedData__ = -1, this.audioAppendsToLoadedData__ = -1;
    const L = this.tech_.preload() === "none" ? "play" : "loadstart";
    this.tech_.one(L, () => {
      const M = Date.now();
      this.tech_.one("loadeddata", () => {
        this.timeToLoadedData__ = Date.now() - M, this.mainAppendsToLoadedData__ = this.mainSegmentLoader_.mediaAppends, this.audioAppendsToLoadedData__ = this.audioSegmentLoader_.mediaAppends;
      });
    });
  }
  mainAppendsToLoadedData_() {
    return this.mainAppendsToLoadedData__;
  }
  audioAppendsToLoadedData_() {
    return this.audioAppendsToLoadedData__;
  }
  appendsToLoadedData_() {
    const e = this.mainAppendsToLoadedData_(), n = this.audioAppendsToLoadedData_();
    return e === -1 || n === -1 ? -1 : e + n;
  }
  timeToLoadedData_() {
    return this.timeToLoadedData__;
  }
  /**
   * Run selectPlaylist and switch to the new playlist if we should
   *
   * @param {string} [reason=abr] a reason for why the ABR check is made
   * @private
   */
  checkABR_(e = "abr") {
    const n = this.selectPlaylist();
    n && this.shouldSwitchToMedia_(n) && this.switchMedia_(n, e);
  }
  switchMedia_(e, n, a) {
    const i = this.media(), r = i && (i.id || i.uri), s = e && (e.id || e.uri);
    if (r && r !== s) {
      this.logger_(`switch media ${r} -> ${s} from ${n}`);
      const o = {
        renditionInfo: {
          id: s,
          bandwidth: e.attributes.BANDWIDTH,
          resolution: e.attributes.RESOLUTION,
          codecs: e.attributes.CODECS
        },
        cause: n
      };
      this.trigger({
        type: "renditionselected",
        metadata: o
      }), this.tech_.trigger({
        type: "usage",
        name: `vhs-rendition-change-${n}`
      });
    }
    this.mainPlaylistLoader_.media(e, a);
  }
  /**
   * A function that ensures we switch our playlists inside of `mediaTypes`
   * to match the current `serviceLocation` provided by the contentSteering controller.
   * We want to check media types of `AUDIO`, `SUBTITLES`, and `CLOSED-CAPTIONS`.
   *
   * This should only be called on a DASH playback scenario while using content steering.
   * This is necessary due to differences in how media in HLS manifests are generally tied to
   * a video playlist, where in DASH that is not always the case.
   */
  switchMediaForDASHContentSteering_() {
    ["AUDIO", "SUBTITLES", "CLOSED-CAPTIONS"].forEach((e) => {
      const n = this.mediaTypes_[e], a = n ? n.activeGroup() : null, i = this.contentSteeringController_.getPathway();
      if (a && i) {
        const s = (a.length ? a[0].playlists : a.playlists).filter((o) => o.attributes.serviceLocation === i);
        s.length && this.mediaTypes_[e].activePlaylistLoader.media(s[0]);
      }
    });
  }
  /**
   * Start a timer that periodically calls checkABR_
   *
   * @private
   */
  startABRTimer_() {
    this.stopABRTimer_(), this.abrTimer_ = j.setInterval(() => this.checkABR_(), 250);
  }
  /**
   * Stop the timer that periodically calls checkABR_
   *
   * @private
   */
  stopABRTimer_() {
    this.tech_.scrubbing && this.tech_.scrubbing() || (j.clearInterval(this.abrTimer_), this.abrTimer_ = null);
  }
  /**
   * Get a list of playlists for the currently selected audio playlist
   *
   * @return {Array} the array of audio playlists
   */
  getAudioTrackPlaylists_() {
    const e = this.main(), n = e && e.playlists || [];
    if (!e || !e.mediaGroups || !e.mediaGroups.AUDIO)
      return n;
    const a = e.mediaGroups.AUDIO, i = Object.keys(a);
    let r;
    if (Object.keys(this.mediaTypes_.AUDIO.groups).length)
      r = this.mediaTypes_.AUDIO.activeTrack();
    else {
      const o = a.main || i.length && a[i[0]];
      for (const l in o)
        if (o[l].default) {
          r = {
            label: l
          };
          break;
        }
    }
    if (!r)
      return n;
    const s = [];
    for (const o in a)
      if (a[o][r.label]) {
        const l = a[o][r.label];
        if (l.playlists && l.playlists.length)
          s.push.apply(s, l.playlists);
        else if (l.uri)
          s.push(l);
        else if (e.playlists.length)
          for (let c = 0; c < e.playlists.length; c++) {
            const u = e.playlists[c];
            u.attributes && u.attributes.AUDIO && u.attributes.AUDIO === o && s.push(u);
          }
      }
    return s.length ? s : n;
  }
  /**
   * Register event handlers on the main playlist loader. A helper
   * function for construction time.
   *
   * @private
   */
  setupMainPlaylistLoaderListeners_() {
    this.mainPlaylistLoader_.on("loadedmetadata", () => {
      const n = this.mainPlaylistLoader_.media(), a = n.targetDuration * 1.5 * 1e3;
      Mh(this.mainPlaylistLoader_.main, this.mainPlaylistLoader_.media()) ? this.requestOptions_.timeout = 0 : this.requestOptions_.timeout = a, n.endList && this.tech_.preload() !== "none" && (this.mainSegmentLoader_.playlist(n, this.requestOptions_), this.mainSegmentLoader_.load()), dre({
        sourceType: this.sourceType_,
        segmentLoaders: {
          AUDIO: this.audioSegmentLoader_,
          SUBTITLES: this.subtitleSegmentLoader_,
          main: this.mainSegmentLoader_
        },
        tech: this.tech_,
        requestOptions: this.requestOptions_,
        mainPlaylistLoader: this.mainPlaylistLoader_,
        vhs: this.vhs_,
        main: this.main(),
        mediaTypes: this.mediaTypes_,
        excludePlaylist: this.excludePlaylist.bind(this)
      }), this.triggerPresenceUsage_(this.main(), n), this.setupFirstPlay(), !this.mediaTypes_.AUDIO.activePlaylistLoader || this.mediaTypes_.AUDIO.activePlaylistLoader.media() ? this.trigger("selectedinitialmedia") : this.mediaTypes_.AUDIO.activePlaylistLoader.one("loadedmetadata", () => {
        this.trigger("selectedinitialmedia");
      });
    }), this.mainPlaylistLoader_.on("loadedplaylist", () => {
      this.loadOnPlay_ && this.tech_.off("play", this.loadOnPlay_);
      let n = this.mainPlaylistLoader_.media();
      if (!n) {
        this.attachContentSteeringListeners_(), this.initContentSteeringController_(), this.excludeUnsupportedVariants_();
        let a;
        if (this.enableLowInitialPlaylist && (a = this.selectInitialPlaylist()), a || (a = this.selectPlaylist()), !a || !this.shouldSwitchToMedia_(a) || (this.initialMedia_ = a, this.switchMedia_(this.initialMedia_, "initial"), !(this.sourceType_ === "vhs-json" && this.initialMedia_.segments)))
          return;
        n = this.initialMedia_;
      }
      this.handleUpdatedMediaPlaylist(n);
    }), this.mainPlaylistLoader_.on("error", () => {
      const n = this.mainPlaylistLoader_.error;
      this.excludePlaylist({
        playlistToExclude: n.playlist,
        error: n
      });
    }), this.mainPlaylistLoader_.on("mediachanging", () => {
      this.mainSegmentLoader_.abort(), this.mainSegmentLoader_.pause();
    }), this.mainPlaylistLoader_.on("mediachange", () => {
      const n = this.mainPlaylistLoader_.media(), a = n.targetDuration * 1.5 * 1e3;
      Mh(this.mainPlaylistLoader_.main, this.mainPlaylistLoader_.media()) ? this.requestOptions_.timeout = 0 : this.requestOptions_.timeout = a, this.sourceType_ === "dash" && this.mainPlaylistLoader_.isPaused && this.mainPlaylistLoader_.load(), this.mainSegmentLoader_.pause(), this.mainSegmentLoader_.playlist(n, this.requestOptions_), this.waitingForFastQualityPlaylistReceived_ ? this.runFastQualitySwitch_() : this.mainSegmentLoader_.load(), this.tech_.trigger({
        type: "mediachange",
        bubbles: !0
      });
    }), this.mainPlaylistLoader_.on("playlistunchanged", () => {
      const n = this.mainPlaylistLoader_.media();
      if (n.lastExcludeReason_ === "playlist-unchanged")
        return;
      this.stuckAtPlaylistEnd_(n) && (this.excludePlaylist({
        error: {
          message: "Playlist no longer updating.",
          reason: "playlist-unchanged"
        }
      }), this.tech_.trigger("playliststuck"));
    }), this.mainPlaylistLoader_.on("renditiondisabled", () => {
      this.tech_.trigger({
        type: "usage",
        name: "vhs-rendition-disabled"
      });
    }), this.mainPlaylistLoader_.on("renditionenabled", () => {
      this.tech_.trigger({
        type: "usage",
        name: "vhs-rendition-enabled"
      });
    }), ["manifestrequeststart", "manifestrequestcomplete", "manifestparsestart", "manifestparsecomplete", "playlistrequeststart", "playlistrequestcomplete", "playlistparsestart", "playlistparsecomplete", "renditiondisabled", "renditionenabled"].forEach((n) => {
      this.mainPlaylistLoader_.on(n, (a) => {
        this.player_.trigger(Jt({}, a));
      });
    });
  }
  /**
   * Given an updated media playlist (whether it was loaded for the first time, or
   * refreshed for live playlists), update any relevant properties and state to reflect
   * changes in the media that should be accounted for (e.g., cues and duration).
   *
   * @param {Object} updatedPlaylist the updated media playlist object
   *
   * @private
   */
  handleUpdatedMediaPlaylist(e) {
    this.useCueTags_ && this.updateAdCues_(e), this.mainSegmentLoader_.pause(), this.mainSegmentLoader_.playlist(e, this.requestOptions_), this.waitingForFastQualityPlaylistReceived_ && this.runFastQualitySwitch_(), this.updateDuration(!e.endList), this.tech_.paused() || (this.mainSegmentLoader_.load(), this.audioSegmentLoader_ && this.audioSegmentLoader_.load());
  }
  /**
   * A helper function for triggerring presence usage events once per source
   *
   * @private
   */
  triggerPresenceUsage_(e, n) {
    const a = e.mediaGroups || {};
    let i = !0;
    const r = Object.keys(a.AUDIO);
    for (const s in a.AUDIO)
      for (const o in a.AUDIO[s])
        a.AUDIO[s][o].uri || (i = !1);
    i && this.tech_.trigger({
      type: "usage",
      name: "vhs-demuxed"
    }), Object.keys(a.SUBTITLES).length && this.tech_.trigger({
      type: "usage",
      name: "vhs-webvtt"
    }), Vi.Playlist.isAes(n) && this.tech_.trigger({
      type: "usage",
      name: "vhs-aes"
    }), r.length && Object.keys(a.AUDIO[r[0]]).length > 1 && this.tech_.trigger({
      type: "usage",
      name: "vhs-alternate-audio"
    }), this.useCueTags_ && this.tech_.trigger({
      type: "usage",
      name: "vhs-playlist-cue-tags"
    });
  }
  shouldSwitchToMedia_(e) {
    const n = this.mainPlaylistLoader_.media() || this.mainPlaylistLoader_.pendingMedia_, a = this.tech_.currentTime(), i = this.bufferLowWaterLine(), r = this.bufferHighWaterLine(), s = this.tech_.buffered();
    return vre({
      buffered: s,
      currentTime: a,
      currentPlaylist: n,
      nextPlaylist: e,
      bufferLowWaterLine: i,
      bufferHighWaterLine: r,
      duration: this.duration(),
      bufferBasedABR: this.bufferBasedABR,
      log: this.logger_
    });
  }
  /**
   * Register event handlers on the segment loaders. A helper function
   * for construction time.
   *
   * @private
   */
  setupSegmentLoaderListeners_() {
    this.mainSegmentLoader_.on("bandwidthupdate", () => {
      this.checkABR_("bandwidthupdate"), this.tech_.trigger("bandwidthupdate");
    }), this.mainSegmentLoader_.on("timeout", () => {
      this.bufferBasedABR && this.mainSegmentLoader_.load();
    }), this.bufferBasedABR || this.mainSegmentLoader_.on("progress", () => {
      this.trigger("progress");
    }), this.mainSegmentLoader_.on("error", () => {
      const a = this.mainSegmentLoader_.error();
      this.excludePlaylist({
        playlistToExclude: a.playlist,
        error: a
      });
    }), this.mainSegmentLoader_.on("appenderror", () => {
      this.error = this.mainSegmentLoader_.error_, this.trigger("error");
    }), this.mainSegmentLoader_.on("syncinfoupdate", () => {
      this.onSyncInfoUpdate_();
    }), this.mainSegmentLoader_.on("timestampoffset", () => {
      this.tech_.trigger({
        type: "usage",
        name: "vhs-timestamp-offset"
      });
    }), this.audioSegmentLoader_.on("syncinfoupdate", () => {
      this.onSyncInfoUpdate_();
    }), this.audioSegmentLoader_.on("appenderror", () => {
      this.error = this.audioSegmentLoader_.error_, this.trigger("error");
    }), this.mainSegmentLoader_.on("ended", () => {
      this.logger_("main segment loader ended"), this.onEndOfStream();
    }), this.timelineChangeController_.on("audioTimelineBehind", () => {
      const a = this.audioSegmentLoader_.pendingSegment_;
      if (!a || !a.segment || !a.segment.syncInfo)
        return;
      const i = a.segment.syncInfo.end + 0.01;
      this.tech_.setCurrentTime(i);
    }), this.timelineChangeController_.on("fixBadTimelineChange", () => {
      this.logger_("Fix bad timeline change. Restarting al segment loaders..."), this.mainSegmentLoader_.pause(), this.mainSegmentLoader_.resetEverything(), this.mediaTypes_.AUDIO.activePlaylistLoader && (this.audioSegmentLoader_.pause(), this.audioSegmentLoader_.resetEverything()), this.mediaTypes_.SUBTITLES.activePlaylistLoader && (this.subtitleSegmentLoader_.pause(), this.subtitleSegmentLoader_.resetEverything()), this.load();
    }), this.mainSegmentLoader_.on("earlyabort", (a) => {
      this.bufferBasedABR || (this.delegateLoaders_("all", ["abort"]), this.excludePlaylist({
        error: {
          message: "Aborted early because there isn't enough bandwidth to complete the request without rebuffering."
        },
        playlistExclusionDuration: mre
      }));
    });
    const e = () => {
      if (!this.sourceUpdater_.hasCreatedSourceBuffers())
        return this.tryToCreateSourceBuffers_();
      const a = this.getCodecsOrExclude_();
      a && this.sourceUpdater_.addOrChangeSourceBuffers(a);
    };
    this.mainSegmentLoader_.on("trackinfo", e), this.audioSegmentLoader_.on("trackinfo", e), this.mainSegmentLoader_.on("fmp4", () => {
      this.triggeredFmp4Usage || (this.tech_.trigger({
        type: "usage",
        name: "vhs-fmp4"
      }), this.triggeredFmp4Usage = !0);
    }), this.audioSegmentLoader_.on("fmp4", () => {
      this.triggeredFmp4Usage || (this.tech_.trigger({
        type: "usage",
        name: "vhs-fmp4"
      }), this.triggeredFmp4Usage = !0);
    }), this.audioSegmentLoader_.on("ended", () => {
      this.logger_("audioSegmentLoader ended"), this.onEndOfStream();
    }), ["segmentselected", "segmentloadstart", "segmentloaded", "segmentkeyloadstart", "segmentkeyloadcomplete", "segmentdecryptionstart", "segmentdecryptioncomplete", "segmenttransmuxingstart", "segmenttransmuxingcomplete", "segmenttransmuxingtrackinfoavailable", "segmenttransmuxingtiminginfoavailable", "segmentappendstart", "appendsdone", "bandwidthupdated", "timelinechange", "codecschange"].forEach((a) => {
      this.mainSegmentLoader_.on(a, (i) => {
        this.player_.trigger(Jt({}, i));
      }), this.audioSegmentLoader_.on(a, (i) => {
        this.player_.trigger(Jt({}, i));
      }), this.subtitleSegmentLoader_.on(a, (i) => {
        this.player_.trigger(Jt({}, i));
      });
    });
  }
  mediaSecondsLoaded_() {
    return Math.max(this.audioSegmentLoader_.mediaSecondsLoaded + this.mainSegmentLoader_.mediaSecondsLoaded);
  }
  /**
   * Call load on our SegmentLoaders
   */
  load() {
    this.mainSegmentLoader_.load(), this.mediaTypes_.AUDIO.activePlaylistLoader && this.audioSegmentLoader_.load(), this.mediaTypes_.SUBTITLES.activePlaylistLoader && this.subtitleSegmentLoader_.load();
  }
  /**
   * Call pause on our SegmentLoaders
   */
  pause() {
    this.mainSegmentLoader_.pause(), this.mediaTypes_.AUDIO.activePlaylistLoader && this.audioSegmentLoader_.pause(), this.mediaTypes_.SUBTITLES.activePlaylistLoader && this.subtitleSegmentLoader_.pause();
  }
  /**
   * Re-tune playback quality level for the current player
   * conditions. This method will perform destructive actions like removing
   * already buffered content in order to readjust the currently active
   * playlist quickly. This is good for manual quality changes
   *
   * @private
   */
  fastQualityChange_(e = this.selectPlaylist()) {
    if (e && e === this.mainPlaylistLoader_.media()) {
      this.logger_("skipping fastQualityChange because new media is same as old");
      return;
    }
    this.switchMedia_(e, "fast-quality"), this.waitingForFastQualityPlaylistReceived_ = !0;
  }
  runFastQualitySwitch_() {
    this.waitingForFastQualityPlaylistReceived_ = !1, this.mainSegmentLoader_.pause(), this.mainSegmentLoader_.resetEverything(), this.mediaTypes_.AUDIO.activePlaylistLoader && (this.audioSegmentLoader_.pause(), this.audioSegmentLoader_.resetEverything()), this.mediaTypes_.SUBTITLES.activePlaylistLoader && (this.subtitleSegmentLoader_.pause(), this.subtitleSegmentLoader_.resetEverything()), this.load();
  }
  /**
   * Begin playback.
   */
  play() {
    if (this.setupFirstPlay())
      return;
    this.tech_.ended() && this.tech_.setCurrentTime(0), this.hasPlayed_ && this.load();
    const e = this.tech_.seekable();
    if (this.tech_.duration() === 1 / 0 && this.tech_.currentTime() < e.start(0))
      return this.tech_.setCurrentTime(e.end(e.length - 1));
  }
  /**
   * Seek to the latest media position if this is a live video and the
   * player and video are loaded and initialized.
   */
  setupFirstPlay() {
    const e = this.mainPlaylistLoader_.media();
    if (!e || this.tech_.paused() || this.hasPlayed_)
      return !1;
    if (!e.endList || e.start) {
      const n = this.seekable();
      if (!n.length)
        return !1;
      const a = n.end(0);
      let i = a;
      if (e.start) {
        const r = e.start.timeOffset;
        r < 0 ? i = Math.max(a + r, n.start(0)) : i = Math.min(a, r);
      }
      this.trigger("firstplay"), this.tech_.setCurrentTime(i);
    }
    return this.hasPlayed_ = !0, this.load(), !0;
  }
  /**
   * handle the sourceopen event on the MediaSource
   *
   * @private
   */
  handleSourceOpen_() {
    if (this.tryToCreateSourceBuffers_(), this.tech_.autoplay()) {
      const e = this.tech_.play();
      typeof e < "u" && typeof e.then == "function" && e.then(null, (n) => {
      });
    }
    this.trigger("sourceopen");
  }
  /**
   * handle the sourceended event on the MediaSource
   *
   * @private
   */
  handleSourceEnded_() {
    if (!this.inbandTextTracks_.metadataTrack_)
      return;
    const e = this.inbandTextTracks_.metadataTrack_.cues;
    if (!e || !e.length)
      return;
    const n = this.duration();
    e[e.length - 1].endTime = isNaN(n) || Math.abs(n) === 1 / 0 ? Number.MAX_VALUE : n;
  }
  /**
   * handle the durationchange event on the MediaSource
   *
   * @private
   */
  handleDurationChange_() {
    this.tech_.trigger("durationchange");
  }
  /**
   * Calls endOfStream on the media source when all active stream types have called
   * endOfStream
   *
   * @param {string} streamType
   *        Stream type of the segment loader that called endOfStream
   * @private
   */
  onEndOfStream() {
    let e = this.mainSegmentLoader_.ended_;
    if (this.mediaTypes_.AUDIO.activePlaylistLoader) {
      const n = this.mainSegmentLoader_.getCurrentMediaInfo_();
      !n || n.hasVideo ? e = e && this.audioSegmentLoader_.ended_ : e = this.audioSegmentLoader_.ended_;
    }
    e && (this.stopABRTimer_(), this.sourceUpdater_.endOfStream());
  }
  /**
   * Check if a playlist has stopped being updated
   *
   * @param {Object} playlist the media playlist object
   * @return {boolean} whether the playlist has stopped being updated or not
   */
  stuckAtPlaylistEnd_(e) {
    if (!this.seekable().length)
      return !1;
    const a = this.syncController_.getExpiredTime(e, this.duration());
    if (a === null)
      return !1;
    const i = Vi.Playlist.playlistEnd(e, a), r = this.tech_.currentTime(), s = this.tech_.buffered();
    if (!s.length)
      return i - r <= Ka;
    const o = s.end(s.length - 1);
    return o - r <= Ka && i - o <= Ka;
  }
  /**
   * Exclude a playlist for a set amount of time, making it unavailable for selection by
   * the rendition selection algorithm, then force a new playlist (rendition) selection.
   *
   * @param {Object=} playlistToExclude
   *                  the playlist to exclude, defaults to the currently selected playlist
   * @param {Object=} error
   *                  an optional error
   * @param {number=} playlistExclusionDuration
   *                  an optional number of seconds to exclude the playlist
   */
  excludePlaylist({
    playlistToExclude: e = this.mainPlaylistLoader_.media(),
    error: n = {},
    playlistExclusionDuration: a
  }) {
    if (e = e || this.mainPlaylistLoader_.media(), a = a || n.playlistExclusionDuration || this.playlistExclusionDuration, !e) {
      this.error = n, this.mediaSource.readyState !== "open" ? this.trigger("error") : this.sourceUpdater_.endOfStream("network");
      return;
    }
    e.playlistErrors_++;
    const i = this.mainPlaylistLoader_.main.playlists, r = i.filter(Id), s = r.length === 1 && r[0] === e;
    if (i.length === 1 && a !== 1 / 0)
      return ce.log.warn(`Problem encountered with playlist ${e.id}. Trying again since it is the only playlist.`), this.tech_.trigger("retryplaylist"), this.mainPlaylistLoader_.load(s);
    if (s) {
      if (this.main().contentSteering) {
        const T = this.pathwayAttribute_(e), g = this.contentSteeringController_.steeringManifest.ttl * 1e3;
        this.contentSteeringController_.excludePathway(T), this.excludeThenChangePathway_(), setTimeout(() => {
          this.contentSteeringController_.addAvailablePathway(T);
        }, g);
        return;
      }
      let _ = !1;
      i.forEach((T) => {
        if (T === e)
          return;
        const g = T.excludeUntil;
        typeof g < "u" && g !== 1 / 0 && (_ = !0, delete T.excludeUntil);
      }), _ && (ce.log.warn("Removing other playlists from the exclusion list because the last rendition is about to be excluded."), this.tech_.trigger("retryplaylist"));
    }
    let o;
    e.playlistErrors_ > this.maxPlaylistRetries ? o = 1 / 0 : o = Date.now() + a * 1e3, e.excludeUntil = o, n.reason && (e.lastExcludeReason_ = n.reason), this.tech_.trigger("excludeplaylist"), this.tech_.trigger({
      type: "usage",
      name: "vhs-rendition-excluded"
    });
    const l = this.selectPlaylist();
    if (!l) {
      this.error = "Playback cannot continue. No available working or supported playlists.", this.trigger("error");
      return;
    }
    const c = n.internal ? this.logger_ : ce.log.warn, u = n.message ? " " + n.message : "";
    c(`${n.internal ? "Internal problem" : "Problem"} encountered with playlist ${e.id}.${u} Switching to playlist ${l.id}.`), l.attributes.AUDIO !== e.attributes.AUDIO && this.delegateLoaders_("audio", ["abort", "pause"]), l.attributes.SUBTITLES !== e.attributes.SUBTITLES && this.delegateLoaders_("subtitle", ["abort", "pause"]), this.delegateLoaders_("main", ["abort", "pause"]);
    const f = l.targetDuration / 2 * 1e3 || 5 * 1e3, m = typeof l.lastRequest == "number" && Date.now() - l.lastRequest <= f;
    return this.switchMedia_(l, "exclude", s || m);
  }
  /**
   * Pause all segment/playlist loaders
   */
  pauseLoading() {
    this.delegateLoaders_("all", ["abort", "pause"]), this.stopABRTimer_();
  }
  /**
   * Call a set of functions in order on playlist loaders, segment loaders,
   * or both types of loaders.
   *
   * @param {string} filter
   *        Filter loaders that should call fnNames using a string. Can be:
   *        * all - run on all loaders
   *        * audio - run on all audio loaders
   *        * subtitle - run on all subtitle loaders
   *        * main - run on the main loaders
   *
   * @param {Array|string} fnNames
   *        A string or array of function names to call.
   */
  delegateLoaders_(e, n) {
    const a = [], i = e === "all";
    (i || e === "main") && a.push(this.mainPlaylistLoader_);
    const r = [];
    (i || e === "audio") && r.push("AUDIO"), (i || e === "subtitle") && (r.push("CLOSED-CAPTIONS"), r.push("SUBTITLES")), r.forEach((s) => {
      const o = this.mediaTypes_[s] && this.mediaTypes_[s].activePlaylistLoader;
      o && a.push(o);
    }), ["main", "audio", "subtitle"].forEach((s) => {
      const o = this[`${s}SegmentLoader_`];
      o && (e === s || e === "all") && a.push(o);
    }), a.forEach((s) => n.forEach((o) => {
      typeof s[o] == "function" && s[o]();
    }));
  }
  /**
   * set the current time on all segment loaders
   *
   * @param {TimeRange} currentTime the current time to set
   * @return {TimeRange} the current time
   */
  setCurrentTime(e) {
    const n = ms(this.tech_.buffered(), e);
    if (!(this.mainPlaylistLoader_ && this.mainPlaylistLoader_.media()) || !this.mainPlaylistLoader_.media().segments)
      return 0;
    if (n && n.length)
      return e;
    this.mainSegmentLoader_.pause(), this.mainSegmentLoader_.resetEverything(), this.mediaTypes_.AUDIO.activePlaylistLoader && (this.audioSegmentLoader_.pause(), this.audioSegmentLoader_.resetEverything()), this.mediaTypes_.SUBTITLES.activePlaylistLoader && (this.subtitleSegmentLoader_.pause(), this.subtitleSegmentLoader_.resetEverything()), this.load();
  }
  /**
   * get the current duration
   *
   * @return {TimeRange} the duration
   */
  duration() {
    if (!this.mainPlaylistLoader_)
      return 0;
    const e = this.mainPlaylistLoader_.media();
    return e ? e.endList ? this.mediaSource ? this.mediaSource.duration : Vi.Playlist.duration(e) : 1 / 0 : 0;
  }
  /**
   * check the seekable range
   *
   * @return {TimeRange} the seekable range
   */
  seekable() {
    return this.seekable_;
  }
  getSeekableRange_(e, n) {
    const a = e.media();
    if (!a)
      return null;
    const i = this.syncController_.getMediaSequenceSync(n);
    if (i && i.isReliable) {
      const o = i.start, l = i.end;
      if (!isFinite(o) || !isFinite(l))
        return null;
      const c = Vi.Playlist.liveEdgeDelay(this.mainPlaylistLoader_.main, a), u = Math.max(0, l - c);
      return u < o ? null : vn([[o, u]]);
    }
    const r = this.syncController_.getExpiredTime(a, this.duration());
    if (r === null)
      return null;
    const s = Vi.Playlist.seekable(a, r, Vi.Playlist.liveEdgeDelay(this.mainPlaylistLoader_.main, a));
    return s.length ? s : null;
  }
  computeFinalSeekable_(e, n) {
    if (!n)
      return e;
    const a = e.start(0), i = e.end(0), r = n.start(0), s = n.end(0);
    return r > i || a > s ? e : vn([[Math.max(a, r), Math.min(i, s)]]);
  }
  onSyncInfoUpdate_() {
    if (!this.mainPlaylistLoader_)
      return;
    const e = this.getSeekableRange_(this.mainPlaylistLoader_, "main");
    if (!e)
      return;
    let n;
    if (this.mediaTypes_.AUDIO.activePlaylistLoader && (n = this.getSeekableRange_(this.mediaTypes_.AUDIO.activePlaylistLoader, "audio"), !n))
      return;
    const a = this.seekable_;
    if (this.seekable_ = this.computeFinalSeekable_(e, n), !this.seekable_ || a && a.length && this.seekable_.length && a.start(0) === this.seekable_.start(0) && a.end(0) === this.seekable_.end(0))
      return;
    this.logger_(`seekable updated [${__(this.seekable_)}]`);
    const i = {
      seekableRanges: this.seekable_
    };
    this.trigger({
      type: "seekablerangeschanged",
      metadata: i
    }), this.tech_.trigger("seekablechanged");
  }
  /**
   * Update the player duration
   */
  updateDuration(e) {
    if (this.updateDuration_ && (this.mediaSource.removeEventListener("sourceopen", this.updateDuration_), this.updateDuration_ = null), this.mediaSource.readyState !== "open") {
      this.updateDuration_ = this.updateDuration.bind(this, e), this.mediaSource.addEventListener("sourceopen", this.updateDuration_);
      return;
    }
    if (e) {
      const i = this.seekable();
      if (!i.length)
        return;
      (isNaN(this.mediaSource.duration) || this.mediaSource.duration < i.end(i.length - 1)) && this.sourceUpdater_.setDuration(i.end(i.length - 1));
      return;
    }
    const n = this.tech_.buffered();
    let a = Vi.Playlist.duration(this.mainPlaylistLoader_.media());
    n.length > 0 && (a = Math.max(a, n.end(n.length - 1))), this.mediaSource.duration !== a && this.sourceUpdater_.setDuration(a);
  }
  /**
   * dispose of the PlaylistController and everything
   * that it controls
   */
  dispose() {
    this.trigger("dispose"), this.decrypter_.terminate(), this.mainPlaylistLoader_.dispose(), this.mainSegmentLoader_.dispose(), this.contentSteeringController_.dispose(), this.keyStatusMap_.clear(), this.loadOnPlay_ && this.tech_.off("play", this.loadOnPlay_), ["AUDIO", "SUBTITLES"].forEach((e) => {
      const n = this.mediaTypes_[e].groups;
      for (const a in n)
        n[a].forEach((i) => {
          i.playlistLoader && i.playlistLoader.dispose();
        });
    }), this.audioSegmentLoader_.dispose(), this.subtitleSegmentLoader_.dispose(), this.sourceUpdater_.dispose(), this.timelineChangeController_.dispose(), this.stopABRTimer_(), this.updateDuration_ && this.mediaSource.removeEventListener("sourceopen", this.updateDuration_), this.mediaSource.removeEventListener("durationchange", this.handleDurationChange_), this.mediaSource.removeEventListener("sourceopen", this.handleSourceOpen_), this.mediaSource.removeEventListener("sourceended", this.handleSourceEnded_), this.off();
  }
  /**
   * return the main playlist object if we have one
   *
   * @return {Object} the main playlist object that we parsed
   */
  main() {
    return this.mainPlaylistLoader_.main;
  }
  /**
   * return the currently selected playlist
   *
   * @return {Object} the currently selected playlist object that we parsed
   */
  media() {
    return this.mainPlaylistLoader_.media() || this.initialMedia_;
  }
  areMediaTypesKnown_() {
    const e = !!this.mediaTypes_.AUDIO.activePlaylistLoader, n = !!this.mainSegmentLoader_.getCurrentMediaInfo_(), a = e ? !!this.audioSegmentLoader_.getCurrentMediaInfo_() : !0;
    return !(!n || !a);
  }
  // find from and to for codec switch event
  getCodecsOrExclude_() {
    const e = {
      main: this.mainSegmentLoader_.getCurrentMediaInfo_() || {},
      audio: this.audioSegmentLoader_.getCurrentMediaInfo_() || {}
    }, n = this.mainSegmentLoader_.getPendingSegmentPlaylist() || this.media();
    e.video = e.main;
    const a = gl(this.main(), n), i = {}, r = !!this.mediaTypes_.AUDIO.activePlaylistLoader;
    if (e.main.hasVideo && (i.video = a.video || e.main.videoCodec || PJ), e.main.isMuxed && (i.video += `,${a.audio || e.main.audioCodec || Ag}`), (e.main.hasAudio && !e.main.isMuxed || e.audio.hasAudio || r) && (i.audio = a.audio || e.main.audioCodec || e.audio.audioCodec || Ag, e.audio.isFmp4 = e.main.hasAudio && !e.main.isMuxed ? e.main.isFmp4 : e.audio.isFmp4), !i.audio && !i.video) {
      this.excludePlaylist({
        playlistToExclude: n,
        error: {
          message: "Could not determine codecs for playlist."
        },
        playlistExclusionDuration: 1 / 0
      });
      return;
    }
    const s = (c, u) => c ? dl(u, this.usingManagedMediaSource_) : C0(u), o = {};
    let l;
    if (["video", "audio"].forEach(function(c) {
      if (i.hasOwnProperty(c) && !s(e[c].isFmp4, i[c])) {
        const u = e[c].isFmp4 ? "browser" : "muxer";
        o[u] = o[u] || [], o[u].push(i[c]), c === "audio" && (l = u);
      }
    }), r && l && n.attributes.AUDIO) {
      const c = n.attributes.AUDIO;
      this.main().playlists.forEach((u) => {
        (u.attributes && u.attributes.AUDIO) === c && u !== n && (u.excludeUntil = 1 / 0);
      }), this.logger_(`excluding audio group ${c} as ${l} does not support codec(s): "${i.audio}"`);
    }
    if (Object.keys(o).length) {
      const c = Object.keys(o).reduce((u, f) => (u && (u += ", "), u += `${f} does not support codec(s): "${o[f].join(",")}"`, u), "") + ".";
      this.excludePlaylist({
        playlistToExclude: n,
        error: {
          internal: !0,
          message: c
        },
        playlistExclusionDuration: 1 / 0
      });
      return;
    }
    if (this.sourceUpdater_.hasCreatedSourceBuffers() && !this.sourceUpdater_.canChangeType()) {
      const c = [];
      if (["video", "audio"].forEach((u) => {
        const f = (ja(this.sourceUpdater_.codecs[u] || "")[0] || {}).type, m = (ja(i[u] || "")[0] || {}).type;
        f && m && f.toLowerCase() !== m.toLowerCase() && c.push(`"${this.sourceUpdater_.codecs[u]}" -> "${i[u]}"`);
      }), c.length) {
        this.excludePlaylist({
          playlistToExclude: n,
          error: {
            message: `Codec switching not supported: ${c.join(", ")}.`,
            internal: !0
          },
          playlistExclusionDuration: 1 / 0
        });
        return;
      }
    }
    return i;
  }
  /**
   * Create source buffers and exlude any incompatible renditions.
   *
   * @private
   */
  tryToCreateSourceBuffers_() {
    if (this.mediaSource.readyState !== "open" || this.sourceUpdater_.hasCreatedSourceBuffers() || !this.areMediaTypesKnown_())
      return;
    const e = this.getCodecsOrExclude_();
    if (!e)
      return;
    this.sourceUpdater_.createSourceBuffers(e);
    const n = [e.video, e.audio].filter(Boolean).join(",");
    this.excludeIncompatibleVariants_(n);
  }
  /**
   * Excludes playlists with codecs that are unsupported by the muxer and browser.
   */
  excludeUnsupportedVariants_() {
    const e = this.main().playlists, n = [];
    Object.keys(e).forEach((a) => {
      const i = e[a];
      if (n.indexOf(i.id) !== -1)
        return;
      n.push(i.id);
      const r = gl(this.main, i), s = [];
      r.audio && !C0(r.audio) && !dl(r.audio, this.usingManagedMediaSource_) && s.push(`audio codec ${r.audio}`), r.video && !C0(r.video) && !dl(r.video, this.usingManagedMediaSource_) && s.push(`video codec ${r.video}`), r.text && r.text === "stpp.ttml.im1t" && s.push(`text codec ${r.text}`), s.length && (i.excludeUntil = 1 / 0, this.logger_(`excluding ${i.id} for unsupported: ${s.join(", ")}`));
    });
  }
  /**
   * Exclude playlists that are known to be codec or
   * stream-incompatible with the SourceBuffer configuration. For
   * instance, Media Source Extensions would cause the video element to
   * stall waiting for video data if you switched from a variant with
   * video and audio to an audio-only one.
   *
   * @param {Object} media a media playlist compatible with the current
   * set of SourceBuffers. Variants in the current main playlist that
   * do not appear to have compatible codec or stream configurations
   * will be excluded from the default playlist selection algorithm
   * indefinitely.
   * @private
   */
  excludeIncompatibleVariants_(e) {
    const n = [], a = this.main().playlists, i = Ru(ja(e)), r = Ob(i), s = i.video && ja(i.video)[0] || null, o = i.audio && ja(i.audio)[0] || null;
    Object.keys(a).forEach((l) => {
      const c = a[l];
      if (n.indexOf(c.id) !== -1 || c.excludeUntil === 1 / 0)
        return;
      n.push(c.id);
      const u = [], f = gl(this.mainPlaylistLoader_.main, c), m = Ob(f);
      if (!(!f.audio && !f.video)) {
        if (m !== r && u.push(`codec count "${m}" !== "${r}"`), !this.sourceUpdater_.canChangeType()) {
          const _ = f.video && ja(f.video)[0] || null, T = f.audio && ja(f.audio)[0] || null;
          _ && s && _.type.toLowerCase() !== s.type.toLowerCase() && u.push(`video codec "${_.type}" !== "${s.type}"`), T && o && T.type.toLowerCase() !== o.type.toLowerCase() && u.push(`audio codec "${T.type}" !== "${o.type}"`);
        }
        u.length && (c.excludeUntil = 1 / 0, this.logger_(`excluding ${c.id}: ${u.join(" && ")}`));
      }
    });
  }
  updateAdCues_(e) {
    let n = 0;
    const a = this.seekable();
    a.length && (n = a.start(0)), Zie(e, this.cueTagsTrack_, n);
  }
  /**
   * Calculates the desired forward buffer length based on current time
   *
   * @return {number} Desired forward buffer length in seconds
   */
  goalBufferLength() {
    const e = this.tech_.currentTime(), n = mn.GOAL_BUFFER_LENGTH, a = mn.GOAL_BUFFER_LENGTH_RATE, i = Math.max(n, mn.MAX_GOAL_BUFFER_LENGTH);
    return Math.min(n + e * a, i);
  }
  /**
   * Calculates the desired buffer low water line based on current time
   *
   * @return {number} Desired buffer low water line in seconds
   */
  bufferLowWaterLine() {
    const e = this.tech_.currentTime(), n = mn.BUFFER_LOW_WATER_LINE, a = mn.BUFFER_LOW_WATER_LINE_RATE, i = Math.max(n, mn.MAX_BUFFER_LOW_WATER_LINE), r = Math.max(n, mn.EXPERIMENTAL_MAX_BUFFER_LOW_WATER_LINE);
    return Math.min(n + e * a, this.bufferBasedABR ? r : i);
  }
  bufferHighWaterLine() {
    return mn.BUFFER_HIGH_WATER_LINE;
  }
  addDateRangesToTextTrack_(e) {
    Rb(this.inbandTextTracks_, "com.apple.streaming", this.tech_), Lie({
      inbandTextTracks: this.inbandTextTracks_,
      dateRanges: e
    });
  }
  addMetadataToTextTrack(e, n, a) {
    const i = this.sourceUpdater_.videoBuffer ? this.sourceUpdater_.videoTimestampOffset() : this.sourceUpdater_.audioTimestampOffset();
    Rb(this.inbandTextTracks_, e, this.tech_), Sie({
      inbandTextTracks: this.inbandTextTracks_,
      metadataArray: n,
      timestampOffset: i,
      videoDuration: a
    });
  }
  /**
   * Utility for getting the pathway or service location from an HLS or DASH playlist.
   *
   * @param {Object} playlist for getting pathway from.
   * @return the pathway attribute of a playlist
   */
  pathwayAttribute_(e) {
    return e.attributes["PATHWAY-ID"] || e.attributes.serviceLocation;
  }
  /**
   * Initialize available pathways and apply the tag properties.
   */
  initContentSteeringController_() {
    const e = this.main();
    if (e.contentSteering) {
      for (const n of e.playlists)
        this.contentSteeringController_.addAvailablePathway(this.pathwayAttribute_(n));
      if (this.contentSteeringController_.assignTagProperties(e.uri, e.contentSteering), this.contentSteeringController_.queryBeforeStart) {
        this.contentSteeringController_.requestSteeringManifest(!0);
        return;
      }
      this.tech_.one("canplay", () => {
        this.contentSteeringController_.requestSteeringManifest();
      });
    }
  }
  /**
   * Reset the content steering controller and re-init.
   */
  resetContentSteeringController_() {
    this.contentSteeringController_.clearAvailablePathways(), this.contentSteeringController_.dispose(), this.initContentSteeringController_();
  }
  /**
   * Attaches the listeners for content steering.
   */
  attachContentSteeringListeners_() {
    this.contentSteeringController_.on("content-steering", this.excludeThenChangePathway_.bind(this)), ["contentsteeringloadstart", "contentsteeringloadcomplete", "contentsteeringparsed"].forEach((n) => {
      this.contentSteeringController_.on(n, (a) => {
        this.trigger(Jt({}, a));
      });
    }), this.sourceType_ === "dash" && this.mainPlaylistLoader_.on("loadedplaylist", () => {
      const n = this.main();
      (this.contentSteeringController_.didDASHTagChange(n.uri, n.contentSteering) || (() => {
        const r = this.contentSteeringController_.getAvailablePathways(), s = [];
        for (const o of n.playlists) {
          const l = o.attributes.serviceLocation;
          if (l && (s.push(l), !r.has(l)))
            return !0;
        }
        return !!(!s.length && r.size);
      })()) && this.resetContentSteeringController_();
    });
  }
  /**
   * Simple exclude and change playlist logic for content steering.
   */
  excludeThenChangePathway_() {
    const e = this.contentSteeringController_.getPathway();
    if (!e)
      return;
    this.handlePathwayClones_();
    const a = this.main().playlists, i = /* @__PURE__ */ new Set();
    let r = !1;
    Object.keys(a).forEach((s) => {
      const o = a[s], l = this.pathwayAttribute_(o), c = l && e !== l;
      o.excludeUntil === 1 / 0 && o.lastExcludeReason_ === "content-steering" && !c && (delete o.excludeUntil, delete o.lastExcludeReason_, r = !0);
      const f = !o.excludeUntil && o.excludeUntil !== 1 / 0;
      !i.has(o.id) && c && f && (i.add(o.id), o.excludeUntil = 1 / 0, o.lastExcludeReason_ = "content-steering", this.logger_(`excluding ${o.id} for ${o.lastExcludeReason_}`));
    }), this.contentSteeringController_.manifestType_ === "DASH" && Object.keys(this.mediaTypes_).forEach((s) => {
      const o = this.mediaTypes_[s];
      if (o.activePlaylistLoader) {
        const l = o.activePlaylistLoader.media_;
        l && l.attributes.serviceLocation !== e && (r = !0);
      }
    }), r && this.changeSegmentPathway_();
  }
  /**
   * Add, update, or delete playlists and media groups for
   * the pathway clones for HLS Content Steering.
   *
   * See https://datatracker.ietf.org/doc/draft-pantos-hls-rfc8216bis/
   *
   * NOTE: Pathway cloning does not currently support the `PER_VARIANT_URIS` and
   * `PER_RENDITION_URIS` as we do not handle `STABLE-VARIANT-ID` or
   * `STABLE-RENDITION-ID` values.
   */
  handlePathwayClones_() {
    const n = this.main().playlists, a = this.contentSteeringController_.currentPathwayClones, i = this.contentSteeringController_.nextPathwayClones;
    if (a && a.size || i && i.size) {
      for (const [s, o] of a.entries())
        i.get(s) || (this.mainPlaylistLoader_.updateOrDeleteClone(o), this.contentSteeringController_.excludePathway(s));
      for (const [s, o] of i.entries()) {
        const l = a.get(s);
        if (!l) {
          n.filter((u) => u.attributes["PATHWAY-ID"] === o["BASE-ID"]).forEach((u) => {
            this.mainPlaylistLoader_.addClonePathway(o, u);
          }), this.contentSteeringController_.addAvailablePathway(s);
          continue;
        }
        this.equalPathwayClones_(l, o) || (this.mainPlaylistLoader_.updateOrDeleteClone(o, !0), this.contentSteeringController_.addAvailablePathway(s));
      }
      this.contentSteeringController_.currentPathwayClones = new Map(JSON.parse(JSON.stringify([...i])));
    }
  }
  /**
   * Determines whether two pathway clone objects are equivalent.
   *
   * @param {Object} a The first pathway clone object.
   * @param {Object} b The second pathway clone object.
   * @return {boolean} True if the pathway clone objects are equal, false otherwise.
   */
  equalPathwayClones_(e, n) {
    if (e["BASE-ID"] !== n["BASE-ID"] || e.ID !== n.ID || e["URI-REPLACEMENT"].HOST !== n["URI-REPLACEMENT"].HOST)
      return !1;
    const a = e["URI-REPLACEMENT"].PARAMS, i = n["URI-REPLACEMENT"].PARAMS;
    for (const r in a)
      if (a[r] !== i[r])
        return !1;
    for (const r in i)
      if (a[r] !== i[r])
        return !1;
    return !0;
  }
  /**
   * Changes the current playlists for audio, video and subtitles after a new pathway
   * is chosen from content steering.
   */
  changeSegmentPathway_() {
    const e = this.selectPlaylist();
    this.pauseLoading(), this.contentSteeringController_.manifestType_ === "DASH" && this.switchMediaForDASHContentSteering_(), this.switchMedia_(e, "content-steering");
  }
  /**
   * Iterates through playlists and check their keyId set and compare with the
   * keyStatusMap, only enable playlists that have a usable key. If the playlist
   * has no keyId leave it enabled by default.
   */
  excludeNonUsablePlaylistsByKeyId_() {
    if (!this.mainPlaylistLoader_ || !this.mainPlaylistLoader_.main)
      return;
    let e = 0;
    const n = "non-usable";
    this.mainPlaylistLoader_.main.playlists.forEach((a) => {
      const i = this.mainPlaylistLoader_.getKeyIdSet(a);
      !i || !i.size || i.forEach((r) => {
        const s = "usable", o = this.keyStatusMap_.has(r) && this.keyStatusMap_.get(r) === s, l = a.lastExcludeReason_ === n && a.excludeUntil === 1 / 0;
        o ? o && l && (delete a.excludeUntil, delete a.lastExcludeReason_, this.logger_(`enabling playlist ${a.id} because key ID ${r} is ${s}`)) : (a.excludeUntil !== 1 / 0 && a.lastExcludeReason_ !== n && (a.excludeUntil = 1 / 0, a.lastExcludeReason_ = n, this.logger_(`excluding playlist ${a.id} because the key ID ${r} doesn't exist in the keyStatusMap or is not ${s}`)), e++);
      });
    }), e >= this.mainPlaylistLoader_.main.playlists.length && this.mainPlaylistLoader_.main.playlists.forEach((a) => {
      const i = a && a.attributes && a.attributes.RESOLUTION && a.attributes.RESOLUTION.height < 720, r = a.excludeUntil === 1 / 0 && a.lastExcludeReason_ === n;
      i && r && (delete a.excludeUntil, ce.log.warn(`enabling non-HD playlist ${a.id} because all playlists were excluded due to ${n} key IDs`));
    });
  }
  /**
   * Adds a keystatus to the keystatus map, tries to convert to string if necessary.
   *
   * @param {any} keyId the keyId to add a status for
   * @param {string} status the status of the keyId
   */
  addKeyStatus_(e, n) {
    const r = (typeof e == "string" ? e : qie(e)).slice(0, 32).toLowerCase();
    this.logger_(`KeyStatus '${n}' with key ID ${r} added to the keyStatusMap`), this.keyStatusMap_.set(r, n);
  }
  /**
   * Utility function for adding key status to the keyStatusMap and filtering usable encrypted playlists.
   *
   * @param {any} keyId the keyId from the keystatuschange event
   * @param {string} status the key status string
   */
  updatePlaylistByKeyStatus(e, n) {
    this.addKeyStatus_(e, n), this.waitingForFastQualityPlaylistReceived_ || this.excludeNonUsableThenChangePlaylist_(), this.mainPlaylistLoader_.off("loadedplaylist", this.excludeNonUsableThenChangePlaylist_.bind(this)), this.mainPlaylistLoader_.on("loadedplaylist", this.excludeNonUsableThenChangePlaylist_.bind(this));
  }
  excludeNonUsableThenChangePlaylist_() {
    this.excludeNonUsablePlaylistsByKeyId_(), this.fastQualityChange_();
  }
}
const _re = (t, e, n) => (a) => {
  const i = t.main.playlists[e], r = Ip(i), s = Id(i);
  if (typeof a > "u")
    return s;
  a ? delete i.disabled : i.disabled = !0;
  const o = {
    renditionInfo: {
      id: e,
      bandwidth: i.attributes.BANDWIDTH,
      resolution: i.attributes.RESOLUTION,
      codecs: i.attributes.CODECS
    },
    cause: "fast-quality"
  };
  return a !== s && !r && (a ? (n(i), t.trigger({
    type: "renditionenabled",
    metadata: o
  })) : t.trigger({
    type: "renditiondisabled",
    metadata: o
  })), a;
};
class Tre {
  constructor(e, n, a) {
    const {
      playlistController_: i
    } = e, r = i.fastQualityChange_.bind(i);
    if (n.attributes) {
      const s = n.attributes.RESOLUTION;
      this.width = s && s.width, this.height = s && s.height, this.bandwidth = n.attributes.BANDWIDTH, this.frameRate = n.attributes["FRAME-RATE"];
    }
    this.codecs = gl(i.main(), n), this.playlist = n, this.id = a, this.enabled = _re(e.playlists, n.id, r);
  }
}
const xre = function(t) {
  t.representations = () => {
    const e = t.playlistController_.main(), n = Kl(e) ? t.playlistController_.getAudioTrackPlaylists_() : e.playlists;
    return n ? n.filter((a) => !Ip(a)).map((a, i) => new Tre(t, a, a.id)) : [];
  };
}, Wb = ["seeking", "seeked", "pause", "playing", "error"];
class wre extends ce.EventTarget {
  /**
   * Represents an PlaybackWatcher object.
   *
   * @class
   * @param {Object} options an object that includes the tech and settings
   */
  constructor(e) {
    super(), this.playlistController_ = e.playlistController, this.tech_ = e.tech, this.seekable = e.seekable, this.allowSeeksWithinUnsafeLiveWindow = e.allowSeeksWithinUnsafeLiveWindow, this.liveRangeSafeTimeDelta = e.liveRangeSafeTimeDelta, this.media = e.media, this.playedRanges_ = [], this.consecutiveUpdates = 0, this.lastRecordedTime = null, this.checkCurrentTimeTimeout_ = null, this.logger_ = Ca("PlaybackWatcher"), this.logger_("initialize");
    const n = () => this.monitorCurrentTime_(), a = () => this.monitorCurrentTime_(), i = () => this.techWaiting_(), r = () => this.resetTimeUpdate_(), s = this.playlistController_, o = ["main", "subtitle", "audio"], l = {};
    o.forEach((u) => {
      l[u] = {
        reset: () => this.resetSegmentDownloads_(u),
        updateend: () => this.checkSegmentDownloads_(u)
      }, s[`${u}SegmentLoader_`].on("appendsdone", l[u].updateend), s[`${u}SegmentLoader_`].on("playlistupdate", l[u].reset), this.tech_.on(["seeked", "seeking"], l[u].reset);
    });
    const c = (u) => {
      ["main", "audio"].forEach((f) => {
        s[`${f}SegmentLoader_`][u]("appended", this.seekingAppendCheck_);
      });
    };
    this.seekingAppendCheck_ = () => {
      this.fixesBadSeeks_() && (this.consecutiveUpdates = 0, this.lastRecordedTime = this.tech_.currentTime(), c("off"));
    }, this.clearSeekingAppendCheck_ = () => c("off"), this.watchForBadSeeking_ = () => {
      this.clearSeekingAppendCheck_(), c("on");
    }, this.tech_.on("seeked", this.clearSeekingAppendCheck_), this.tech_.on("seeking", this.watchForBadSeeking_), this.tech_.on("waiting", i), this.tech_.on(Wb, r), this.tech_.on("canplay", a), this.tech_.one("play", n), this.dispose = () => {
      this.clearSeekingAppendCheck_(), this.logger_("dispose"), this.tech_.off("waiting", i), this.tech_.off(Wb, r), this.tech_.off("canplay", a), this.tech_.off("play", n), this.tech_.off("seeking", this.watchForBadSeeking_), this.tech_.off("seeked", this.clearSeekingAppendCheck_), o.forEach((u) => {
        s[`${u}SegmentLoader_`].off("appendsdone", l[u].updateend), s[`${u}SegmentLoader_`].off("playlistupdate", l[u].reset), this.tech_.off(["seeked", "seeking"], l[u].reset);
      }), this.checkCurrentTimeTimeout_ && j.clearTimeout(this.checkCurrentTimeTimeout_), this.resetTimeUpdate_();
    };
  }
  /**
   * Periodically check current time to see if playback stopped
   *
   * @private
   */
  monitorCurrentTime_() {
    this.checkCurrentTime_(), this.checkCurrentTimeTimeout_ && j.clearTimeout(this.checkCurrentTimeTimeout_), this.checkCurrentTimeTimeout_ = j.setTimeout(this.monitorCurrentTime_.bind(this), 250);
  }
  /**
   * Reset stalled download stats for a specific type of loader
   *
   * @param {string} type
   *        The segment loader type to check.
   *
   * @listens SegmentLoader#playlistupdate
   * @listens Tech#seeking
   * @listens Tech#seeked
   */
  resetSegmentDownloads_(e) {
    const n = this.playlistController_[`${e}SegmentLoader_`];
    this[`${e}StalledDownloads_`] > 0 && this.logger_(`resetting possible stalled download count for ${e} loader`), this[`${e}StalledDownloads_`] = 0, this[`${e}Buffered_`] = n.buffered_();
  }
  /**
   * Checks on every segment `appendsdone` to see
   * if segment appends are making progress. If they are not
   * and we are still downloading bytes. We exclude the playlist.
   *
   * @param {string} type
   *        The segment loader type to check.
   *
   * @listens SegmentLoader#appendsdone
   */
  checkSegmentDownloads_(e) {
    const n = this.playlistController_, a = n[`${e}SegmentLoader_`], i = a.buffered_(), r = oae(this[`${e}Buffered_`], i);
    if (this[`${e}Buffered_`] = i, r) {
      const s = {
        bufferedRanges: i
      };
      n.trigger({
        type: "bufferedrangeschanged",
        metadata: s
      }), this.resetSegmentDownloads_(e);
      return;
    }
    this[`${e}StalledDownloads_`]++, this.logger_(`found #${this[`${e}StalledDownloads_`]} ${e} appends that did not increase buffer (possible stalled download)`, {
      playlistId: a.playlist_ && a.playlist_.id,
      buffered: Sr(i)
    }), !(this[`${e}StalledDownloads_`] < 10) && (this.logger_(`${e} loader stalled download exclusion`), this.resetSegmentDownloads_(e), this.tech_.trigger({
      type: "usage",
      name: `vhs-${e}-download-exclusion`
    }), e !== "subtitle" && n.excludePlaylist({
      error: {
        message: `Excessive ${e} segment downloading detected.`
      },
      playlistExclusionDuration: 1 / 0
    }));
  }
  /**
   * The purpose of this function is to emulate the "waiting" event on
   * browsers that do not emit it when they are waiting for more
   * data to continue playback
   *
   * @private
   */
  checkCurrentTime_() {
    if (this.tech_.paused() || this.tech_.seeking())
      return;
    const e = this.tech_.currentTime(), n = this.tech_.buffered();
    if (this.lastRecordedTime === e && (!n.length || e + Ka >= n.end(n.length - 1)))
      return this.techWaiting_();
    if (this.consecutiveUpdates >= 5 && e === this.lastRecordedTime)
      this.consecutiveUpdates++, this.waiting_();
    else if (e === this.lastRecordedTime)
      this.consecutiveUpdates++;
    else {
      this.playedRanges_.push(vn([this.lastRecordedTime, e]));
      const a = {
        playedRanges: this.playedRanges_
      };
      this.playlistController_.trigger({
        type: "playedrangeschanged",
        metadata: a
      }), this.consecutiveUpdates = 0, this.lastRecordedTime = e;
    }
  }
  /**
   * Resets the 'timeupdate' mechanism designed to detect that we are stalled
   *
   * @private
   */
  resetTimeUpdate_() {
    this.consecutiveUpdates = 0;
  }
  /**
   * Fixes situations where there's a bad seek
   *
   * @return {boolean} whether an action was taken to fix the seek
   * @private
   */
  fixesBadSeeks_() {
    if (!this.tech_.seeking())
      return !1;
    const n = this.seekable(), a = this.tech_.currentTime(), i = this.afterSeekableWindow_(n, a, this.media(), this.allowSeeksWithinUnsafeLiveWindow);
    let r;
    if (i && (r = n.end(n.length - 1)), this.beforeSeekableWindow_(n, a)) {
      const T = n.start(0);
      r = T + // if the playlist is too short and the seekable range is an exact time (can
      // happen in live with a 3 segment playlist), then don't use a time delta
      (T === n.end(0) ? 0 : Ka);
    }
    if (typeof r < "u")
      return this.logger_(`Trying to seek outside of seekable at time ${a} with seekable range ${__(n)}. Seeking to ${r}.`), this.tech_.setCurrentTime(r), !0;
    const s = this.playlistController_.sourceUpdater_, o = this.tech_.buffered(), l = s.audioBuffer ? s.audioBuffered() : null, c = s.videoBuffer ? s.videoBuffered() : null, u = this.media(), f = u.partTargetDuration ? u.partTargetDuration : (u.targetDuration - Za) * 2, m = [l, c];
    for (let T = 0; T < m.length; T++) {
      if (!m[T])
        continue;
      if (Lp(m[T], a) < f)
        return !1;
    }
    const _ = Rc(o, a);
    return _.length === 0 ? !1 : (r = _.start(0) + Ka, this.logger_(`Buffered region starts (${_.start(0)})  just beyond seek point (${a}). Seeking to ${r}.`), this.tech_.setCurrentTime(r), !0);
  }
  /**
   * Handler for situations when we determine the player is waiting.
   *
   * @private
   */
  waiting_() {
    if (this.techWaiting_())
      return;
    const e = this.tech_.currentTime(), n = this.tech_.buffered(), a = ms(n, e);
    if (a.length && e + 3 <= a.end(0)) {
      this.resetTimeUpdate_(), this.tech_.setCurrentTime(e), this.logger_(`Stopped at ${e} while inside a buffered region [${a.start(0)} -> ${a.end(0)}]. Attempting to resume playback by seeking to the current time.`), this.tech_.trigger({
        type: "usage",
        name: "vhs-unknown-waiting"
      });
      return;
    }
  }
  /**
   * Handler for situations when the tech fires a `waiting` event
   *
   * @return {boolean}
   *         True if an action (or none) was needed to correct the waiting. False if no
   *         checks passed
   * @private
   */
  techWaiting_() {
    const e = this.seekable(), n = this.tech_.currentTime();
    if (this.tech_.seeking())
      return !0;
    if (this.beforeSeekableWindow_(e, n)) {
      const o = e.end(e.length - 1);
      return this.logger_(`Fell out of live window at time ${n}. Seeking to live point (seekable end) ${o}`), this.resetTimeUpdate_(), this.tech_.setCurrentTime(o), this.tech_.trigger({
        type: "usage",
        name: "vhs-live-resync"
      }), !0;
    }
    const a = this.tech_.vhs.playlistController_.sourceUpdater_, i = this.tech_.buffered();
    if (this.videoUnderflow_({
      audioBuffered: a.audioBuffered(),
      videoBuffered: a.videoBuffered(),
      currentTime: n
    }))
      return this.resetTimeUpdate_(), this.tech_.setCurrentTime(n), this.tech_.trigger({
        type: "usage",
        name: "vhs-video-underflow"
      }), !0;
    const s = Rc(i, n);
    return s.length > 0 ? (this.logger_(`Stopped at ${n} and seeking to ${s.start(0)}`), this.resetTimeUpdate_(), this.skipTheGap_(n), !0) : !1;
  }
  afterSeekableWindow_(e, n, a, i = !1) {
    if (!e.length)
      return !1;
    let r = e.end(e.length - 1) + Ka;
    const s = !a.endList, o = typeof a.partTargetDuration == "number";
    return s && (o || i) && (r = e.end(e.length - 1) + a.targetDuration * 3), n > r;
  }
  beforeSeekableWindow_(e, n) {
    return !!(e.length && // can't fall before 0 and 0 seekable start identifies VOD stream
    e.start(0) > 0 && n < e.start(0) - this.liveRangeSafeTimeDelta);
  }
  videoUnderflow_({
    videoBuffered: e,
    audioBuffered: n,
    currentTime: a
  }) {
    if (!e)
      return;
    let i;
    if (e.length && n.length) {
      const r = ms(e, a - 3), s = ms(e, a), o = ms(n, a);
      o.length && !s.length && r.length && (i = {
        start: r.end(0),
        end: o.end(0)
      });
    } else
      Rc(e, a).length || (i = this.gapFromVideoUnderflow_(e, a));
    return i ? (this.logger_(`Encountered a gap in video from ${i.start} to ${i.end}. Seeking to current time ${a}`), !0) : !1;
  }
  /**
   * Timer callback. If playback still has not proceeded, then we seek
   * to the start of the next buffered region.
   *
   * @private
   */
  skipTheGap_(e) {
    const n = this.tech_.buffered(), a = this.tech_.currentTime(), i = Rc(n, a);
    if (this.resetTimeUpdate_(), i.length === 0 || a !== e)
      return;
    this.logger_("skipTheGap_:", "currentTime:", a, "scheduled currentTime:", e, "nextRange start:", i.start(0)), this.tech_.setCurrentTime(i.start(0) + Za);
    const r = {
      gapInfo: {
        from: a,
        to: i.start(0)
      }
    };
    this.playlistController_.trigger({
      type: "gapjumped",
      metadata: r
    }), this.tech_.trigger({
      type: "usage",
      name: "vhs-gap-skip"
    });
  }
  gapFromVideoUnderflow_(e, n) {
    const a = iae(e);
    for (let i = 0; i < a.length; i++) {
      const r = a.start(i), s = a.end(i);
      if (n - r < 4 && n - r > 2)
        return {
          start: r,
          end: s
        };
    }
    return null;
  }
}
const kre = {
  errorInterval: 30,
  getSource(t) {
    const n = this.tech({
      IWillNotUseThisInPlugins: !0
    }).currentSource_ || this.currentSource();
    return t(n);
  }
}, uT = function(t, e) {
  let n = 0, a = 0;
  const i = gt(kre, e);
  t.ready(() => {
    t.trigger({
      type: "usage",
      name: "vhs-error-reload-initialized"
    });
  });
  const r = function() {
    a && t.currentTime(a);
  }, s = function(u) {
    u != null && (a = t.duration() !== 1 / 0 && t.currentTime() || 0, t.one("loadedmetadata", r), t.src(u), t.trigger({
      type: "usage",
      name: "vhs-error-reload"
    }), t.play());
  }, o = function() {
    if (Date.now() - n < i.errorInterval * 1e3) {
      t.trigger({
        type: "usage",
        name: "vhs-error-reload-canceled"
      });
      return;
    }
    if (!i.getSource || typeof i.getSource != "function") {
      ce.log.error("ERROR: reloadSourceOnError - The option getSource must be a function!");
      return;
    }
    return n = Date.now(), i.getSource.call(t, s);
  }, l = function() {
    t.off("loadedmetadata", r), t.off("error", o), t.off("dispose", l);
  }, c = function(u) {
    l(), uT(t, u);
  };
  t.on("error", o), t.on("dispose", l), t.reloadSourceOnError = c;
}, Cre = function(t) {
  uT(this, t);
};
var dT = "3.16.2", Sre = "7.1.0", Are = "1.3.1", Ere = "7.2.0", Lre = "4.0.2";
const Ht = {
  PlaylistLoader: gs,
  Playlist: Kn,
  utils: Iae,
  STANDARD_PLAYLIST_SELECTOR: Bb,
  INITIAL_PLAYLIST_SELECTOR: Tie,
  lastBandwidthSelector: Bb,
  movingAverageBandwidthSelector: yie,
  comparePlaylistBandwidth: Pp,
  comparePlaylistResolution: vie,
  xhr: N_()
};
Object.keys(mn).forEach((t) => {
  Object.defineProperty(Ht, t, {
    get() {
      return ce.log.warn(`using Vhs.${t} is UNSAFE be sure you know what you are doing`), mn[t];
    },
    set(e) {
      if (ce.log.warn(`using Vhs.${t} is UNSAFE be sure you know what you are doing`), typeof e != "number" || e < 0) {
        ce.log.warn(`value of Vhs.${t} must be greater than or equal to 0`);
        return;
      }
      mn[t] = e;
    }
  });
});
const hT = "videojs-vhs", fT = function(t, e) {
  const n = e.media();
  let a = -1;
  for (let i = 0; i < t.length; i++)
    if (t[i].id === n.id) {
      a = i;
      break;
    }
  t.selectedIndex_ = a, t.trigger({
    selectedIndex: a,
    type: "change"
  });
}, Dre = function(t, e) {
  e.representations().forEach((n) => {
    t.addQualityLevel(n);
  }), fT(t, e.playlists);
};
Ht.canPlaySource = function() {
  return ce.log.warn("VHS is no longer a tech. Please remove it from your player's techOrder.");
};
const Ire = (t, e, n) => {
  if (!t)
    return t;
  let a = {};
  e && e.attributes && e.attributes.CODECS && (a = Ru(ja(e.attributes.CODECS))), n && n.attributes && n.attributes.CODECS && (a.audio = n.attributes.CODECS);
  const i = Ns(a.video), r = Ns(a.audio), s = {};
  for (const o in t)
    s[o] = {}, r && (s[o].audioContentType = r), i && (s[o].videoContentType = i), e.contentProtection && e.contentProtection[o] && e.contentProtection[o].pssh && (s[o].pssh = e.contentProtection[o].pssh), typeof t[o] == "string" && (s[o].url = t[o]);
  return gt(t, s);
}, Mre = (t, e) => t.reduce((n, a) => {
  if (!a.contentProtection)
    return n;
  const i = e.reduce((r, s) => {
    const o = a.contentProtection[s];
    return o && o.pssh && (r[s] = {
      pssh: o.pssh
    }), r;
  }, {});
  return Object.keys(i).length && n.push(i), n;
}, []), Ore = ({
  player: t,
  sourceKeySystems: e,
  audioMedia: n,
  mainPlaylists: a
}) => {
  if (!t.eme.initializeMediaKeys)
    return Promise.resolve();
  const i = n ? a.concat([n]) : a, r = Mre(i, Object.keys(e)), s = [], o = [];
  return r.forEach((l) => {
    o.push(new Promise((c, u) => {
      t.tech_.one("keysessioncreated", c);
    })), s.push(new Promise((c, u) => {
      t.eme.initializeMediaKeys({
        keySystems: l
      }, (f) => {
        if (f) {
          u(f);
          return;
        }
        c();
      });
    }));
  }), Promise.race([
    // If a session was previously created, these will all finish resolving without
    // creating a new session, otherwise it will take until the end of all license
    // requests, which is why the key session check is used (to make setup much faster).
    Promise.all(s),
    // Once a single session is created, the browser knows DRM will be used.
    Promise.race(o)
  ]);
}, Pre = ({
  player: t,
  sourceKeySystems: e,
  media: n,
  audioMedia: a
}) => {
  const i = Ire(e, n, a);
  return i ? (t.currentSource().keySystems = i, i && !t.eme ? (ce.log.warn("DRM encrypted source cannot be decrypted without a DRM plugin"), !1) : !0) : !1;
}, pT = () => {
  if (!j.localStorage)
    return null;
  const t = j.localStorage.getItem(hT);
  if (!t)
    return null;
  try {
    return JSON.parse(t);
  } catch {
    return null;
  }
}, Bre = (t) => {
  if (!j.localStorage)
    return !1;
  let e = pT();
  e = e ? gt(e, t) : t;
  try {
    j.localStorage.setItem(hT, JSON.stringify(e));
  } catch {
    return !1;
  }
  return e;
}, Rre = (t) => t.toLowerCase().indexOf("data:application/vnd.videojs.vhs+json,") === 0 ? JSON.parse(t.substring(t.indexOf(",") + 1)) : t, mT = (t, e) => {
  t._requestCallbackSet || (t._requestCallbackSet = /* @__PURE__ */ new Set()), t._requestCallbackSet.add(e);
}, gT = (t, e) => {
  t._responseCallbackSet || (t._responseCallbackSet = /* @__PURE__ */ new Set()), t._responseCallbackSet.add(e);
}, bT = (t, e) => {
  t._requestCallbackSet && (t._requestCallbackSet.delete(e), t._requestCallbackSet.size || delete t._requestCallbackSet);
}, vT = (t, e) => {
  t._responseCallbackSet && (t._responseCallbackSet.delete(e), t._responseCallbackSet.size || delete t._responseCallbackSet);
};
Ht.supportsNativeHls = function() {
  if (!Me || !Me.createElement)
    return !1;
  const t = Me.createElement("video");
  return ce.getTech("Html5").isSupported() ? [
    // Apple santioned
    "application/vnd.apple.mpegurl",
    // Apple sanctioned for backwards compatibility
    "audio/mpegurl",
    // Very common
    "audio/x-mpegurl",
    // Very common
    "application/x-mpegurl",
    // Included for completeness
    "video/x-mpegurl",
    "video/mpegurl",
    "application/mpegurl"
  ].some(function(n) {
    return /maybe|probably/i.test(t.canPlayType(n));
  }) : !1;
}();
Ht.supportsNativeDash = function() {
  return !Me || !Me.createElement || !ce.getTech("Html5").isSupported() ? !1 : /maybe|probably/i.test(Me.createElement("video").canPlayType("application/dash+xml"));
}();
Ht.supportsTypeNatively = (t) => t === "hls" ? Ht.supportsNativeHls : t === "dash" ? Ht.supportsNativeDash : !1;
Ht.isSupported = function() {
  return ce.log.warn("VHS is no longer a tech. Please remove it from your player's techOrder.");
};
Ht.xhr.onRequest = function(t) {
  mT(Ht.xhr, t);
};
Ht.xhr.onResponse = function(t) {
  gT(Ht.xhr, t);
};
Ht.xhr.offRequest = function(t) {
  bT(Ht.xhr, t);
};
Ht.xhr.offResponse = function(t) {
  vT(Ht.xhr, t);
};
const Nre = ce.getComponent("Component");
class yT extends Nre {
  constructor(e, n, a) {
    if (super(n, a.vhs), typeof a.initialBandwidth == "number" && (this.options_.bandwidth = a.initialBandwidth), this.logger_ = Ca("VhsHandler"), n.options_ && n.options_.playerId) {
      const i = ce.getPlayer(n.options_.playerId);
      this.player_ = i;
    }
    if (this.tech_ = n, this.source_ = e, this.stats = {}, this.ignoreNextSeekingEvent_ = !1, this.setOptions_(), this.options_.overrideNative && n.overrideNativeAudioTracks && n.overrideNativeVideoTracks)
      n.overrideNativeAudioTracks(!0), n.overrideNativeVideoTracks(!0);
    else if (this.options_.overrideNative && (n.featuresNativeVideoTracks || n.featuresNativeAudioTracks))
      throw new Error("Overriding native VHS requires emulated tracks. See https://git.io/vMpjB");
    this.on(Me, ["fullscreenchange", "webkitfullscreenchange", "mozfullscreenchange", "MSFullscreenChange"], (i) => {
      const r = Me.fullscreenElement || Me.webkitFullscreenElement || Me.mozFullScreenElement || Me.msFullscreenElement;
      r && r.contains(this.tech_.el()) ? this.playlistController_.fastQualityChange_() : this.playlistController_.checkABR_();
    }), this.on(this.tech_, "seeking", function() {
      if (this.ignoreNextSeekingEvent_) {
        this.ignoreNextSeekingEvent_ = !1;
        return;
      }
      this.setCurrentTime(this.tech_.currentTime());
    }), this.on(this.tech_, "error", function() {
      this.tech_.error() && this.playlistController_ && this.playlistController_.pauseLoading();
    }), this.on(this.tech_, "play", this.play);
  }
  /**
   * Set VHS options based on options from configuration, as well as partial
   * options to be passed at a later time.
   *
   * @param {Object} options A partial chunk of config options
   */
  setOptions_(e = {}) {
    if (this.options_ = gt(this.options_, e), this.options_.withCredentials = this.options_.withCredentials || !1, this.options_.limitRenditionByPlayerDimensions = this.options_.limitRenditionByPlayerDimensions !== !1, this.options_.useDevicePixelRatio = this.options_.useDevicePixelRatio || !1, this.options_.useBandwidthFromLocalStorage = typeof this.source_.useBandwidthFromLocalStorage < "u" ? this.source_.useBandwidthFromLocalStorage : this.options_.useBandwidthFromLocalStorage || !1, this.options_.useForcedSubtitles = this.options_.useForcedSubtitles || !1, this.options_.useNetworkInformationApi = this.options_.useNetworkInformationApi || !1, this.options_.useDtsForTimestampOffset = this.options_.useDtsForTimestampOffset || !1, this.options_.customTagParsers = this.options_.customTagParsers || [], this.options_.customTagMappers = this.options_.customTagMappers || [], this.options_.cacheEncryptionKeys = this.options_.cacheEncryptionKeys || !1, this.options_.llhls = this.options_.llhls !== !1, this.options_.bufferBasedABR = this.options_.bufferBasedABR || !1, typeof this.options_.playlistExclusionDuration != "number" && (this.options_.playlistExclusionDuration = 60), typeof this.options_.bandwidth != "number" && this.options_.useBandwidthFromLocalStorage) {
      const a = pT();
      a && a.bandwidth && (this.options_.bandwidth = a.bandwidth, this.tech_.trigger({
        type: "usage",
        name: "vhs-bandwidth-from-local-storage"
      })), a && a.throughput && (this.options_.throughput = a.throughput, this.tech_.trigger({
        type: "usage",
        name: "vhs-throughput-from-local-storage"
      }));
    }
    typeof this.options_.bandwidth != "number" && (this.options_.bandwidth = mn.INITIAL_BANDWIDTH), this.options_.enableLowInitialPlaylist = this.options_.enableLowInitialPlaylist && this.options_.bandwidth === mn.INITIAL_BANDWIDTH, ["withCredentials", "useDevicePixelRatio", "customPixelRatio", "limitRenditionByPlayerDimensions", "bandwidth", "customTagParsers", "customTagMappers", "cacheEncryptionKeys", "playlistSelector", "initialPlaylistSelector", "bufferBasedABR", "liveRangeSafeTimeDelta", "llhls", "useForcedSubtitles", "useNetworkInformationApi", "useDtsForTimestampOffset", "exactManifestTimings", "leastPixelDiffSelector"].forEach((a) => {
      typeof this.source_[a] < "u" && (this.options_[a] = this.source_[a]);
    }), this.limitRenditionByPlayerDimensions = this.options_.limitRenditionByPlayerDimensions, this.useDevicePixelRatio = this.options_.useDevicePixelRatio;
    const n = this.options_.customPixelRatio;
    typeof n == "number" && n >= 0 && (this.customPixelRatio = n);
  }
  // alias for public method to set options
  setOptions(e = {}) {
    this.setOptions_(e);
  }
  /**
   * called when player.src gets called, handle a new source
   *
   * @param {Object} src the source object to handle
   */
  src(e, n) {
    if (!e)
      return;
    this.setOptions_(), this.options_.src = Rre(this.source_.src), this.options_.tech = this.tech_, this.options_.externVhs = Ht, this.options_.sourceType = p5(n), this.options_.seekTo = (r) => {
      this.tech_.setCurrentTime(r);
    }, this.options_.player_ = this.player_, this.playlistController_ = new yre(this.options_);
    const a = gt({
      liveRangeSafeTimeDelta: Ka
    }, this.options_, {
      seekable: () => this.seekable(),
      media: () => this.playlistController_.media(),
      playlistController: this.playlistController_
    });
    this.playbackWatcher_ = new wre(a), this.attachStreamingEventListeners_(), this.playlistController_.on("error", () => {
      const r = ce.players[this.tech_.options_.playerId];
      let s = this.playlistController_.error;
      typeof s == "object" && !s.code ? s.code = 3 : typeof s == "string" && (s = {
        message: s,
        code: 3
      }), r.error(s);
    });
    const i = this.options_.bufferBasedABR ? Ht.movingAverageBandwidthSelector(0.55) : Ht.STANDARD_PLAYLIST_SELECTOR;
    this.playlistController_.selectPlaylist = this.selectPlaylist ? this.selectPlaylist.bind(this) : i.bind(this), this.playlistController_.selectInitialPlaylist = Ht.INITIAL_PLAYLIST_SELECTOR.bind(this), this.playlists = this.playlistController_.mainPlaylistLoader_, this.mediaSource = this.playlistController_.mediaSource, Object.defineProperties(this, {
      selectPlaylist: {
        get() {
          return this.playlistController_.selectPlaylist;
        },
        set(r) {
          this.playlistController_.selectPlaylist = r.bind(this);
        }
      },
      throughput: {
        get() {
          return this.playlistController_.mainSegmentLoader_.throughput.rate;
        },
        set(r) {
          this.playlistController_.mainSegmentLoader_.throughput.rate = r, this.playlistController_.mainSegmentLoader_.throughput.count = 1;
        }
      },
      bandwidth: {
        get() {
          let r = this.playlistController_.mainSegmentLoader_.bandwidth;
          const s = j.navigator.connection || j.navigator.mozConnection || j.navigator.webkitConnection, o = 1e7;
          if (this.options_.useNetworkInformationApi && s) {
            const l = s.downlink * 1e3 * 1e3;
            l >= o && r >= o ? r = Math.max(r, l) : r = l;
          }
          return r;
        },
        set(r) {
          this.playlistController_.mainSegmentLoader_.bandwidth = r, this.playlistController_.mainSegmentLoader_.throughput = {
            rate: 0,
            count: 0
          };
        }
      },
      /**
       * `systemBandwidth` is a combination of two serial processes bit-rates. The first
       * is the network bitrate provided by `bandwidth` and the second is the bitrate of
       * the entire process after that - decryption, transmuxing, and appending - provided
       * by `throughput`.
       *
       * Since the two process are serial, the overall system bandwidth is given by:
       *   sysBandwidth = 1 / (1 / bandwidth + 1 / throughput)
       */
      systemBandwidth: {
        get() {
          const r = 1 / (this.bandwidth || 1);
          let s;
          return this.throughput > 0 ? s = 1 / this.throughput : s = 0, Math.floor(1 / (r + s));
        },
        set() {
          ce.log.error('The "systemBandwidth" property is read-only');
        }
      }
    }), this.options_.bandwidth && (this.bandwidth = this.options_.bandwidth), this.options_.throughput && (this.throughput = this.options_.throughput), Object.defineProperties(this.stats, {
      bandwidth: {
        get: () => this.bandwidth || 0,
        enumerable: !0
      },
      mediaRequests: {
        get: () => this.playlistController_.mediaRequests_() || 0,
        enumerable: !0
      },
      mediaRequestsAborted: {
        get: () => this.playlistController_.mediaRequestsAborted_() || 0,
        enumerable: !0
      },
      mediaRequestsTimedout: {
        get: () => this.playlistController_.mediaRequestsTimedout_() || 0,
        enumerable: !0
      },
      mediaRequestsErrored: {
        get: () => this.playlistController_.mediaRequestsErrored_() || 0,
        enumerable: !0
      },
      mediaTransferDuration: {
        get: () => this.playlistController_.mediaTransferDuration_() || 0,
        enumerable: !0
      },
      mediaBytesTransferred: {
        get: () => this.playlistController_.mediaBytesTransferred_() || 0,
        enumerable: !0
      },
      mediaSecondsLoaded: {
        get: () => this.playlistController_.mediaSecondsLoaded_() || 0,
        enumerable: !0
      },
      mediaAppends: {
        get: () => this.playlistController_.mediaAppends_() || 0,
        enumerable: !0
      },
      mainAppendsToLoadedData: {
        get: () => this.playlistController_.mainAppendsToLoadedData_() || 0,
        enumerable: !0
      },
      audioAppendsToLoadedData: {
        get: () => this.playlistController_.audioAppendsToLoadedData_() || 0,
        enumerable: !0
      },
      appendsToLoadedData: {
        get: () => this.playlistController_.appendsToLoadedData_() || 0,
        enumerable: !0
      },
      timeToLoadedData: {
        get: () => this.playlistController_.timeToLoadedData_() || 0,
        enumerable: !0
      },
      buffered: {
        get: () => Sr(this.tech_.buffered()),
        enumerable: !0
      },
      currentTime: {
        get: () => this.tech_.currentTime(),
        enumerable: !0
      },
      currentSource: {
        get: () => this.tech_.currentSource_,
        enumerable: !0
      },
      currentTech: {
        get: () => this.tech_.name_,
        enumerable: !0
      },
      duration: {
        get: () => this.tech_.duration(),
        enumerable: !0
      },
      main: {
        get: () => this.playlists.main,
        enumerable: !0
      },
      playerDimensions: {
        get: () => this.tech_.currentDimensions(),
        enumerable: !0
      },
      seekable: {
        get: () => Sr(this.tech_.seekable()),
        enumerable: !0
      },
      timestamp: {
        get: () => Date.now(),
        enumerable: !0
      },
      videoPlaybackQuality: {
        get: () => this.tech_.getVideoPlaybackQuality(),
        enumerable: !0
      }
    }), this.tech_.one("canplay", this.playlistController_.setupFirstPlay.bind(this.playlistController_)), this.tech_.on("bandwidthupdate", () => {
      this.options_.useBandwidthFromLocalStorage && Bre({
        bandwidth: this.bandwidth,
        throughput: Math.round(this.throughput)
      });
    }), this.playlistController_.on("selectedinitialmedia", () => {
      xre(this);
    }), this.playlistController_.sourceUpdater_.on("createdsourcebuffers", () => {
      this.setupEme_();
    }), this.on(this.playlistController_, "progress", function() {
      this.tech_.trigger("progress");
    }), this.on(this.playlistController_, "firstplay", function() {
      this.ignoreNextSeekingEvent_ = !0;
    }), this.setupQualityLevels_(), this.tech_.el() && (this.mediaSourceUrl_ = j.URL.createObjectURL(this.playlistController_.mediaSource), (ce.browser.IS_ANY_SAFARI || ce.browser.IS_IOS) && this.options_.overrideNative && this.options_.sourceType === "hls" && typeof this.tech_.addSourceElement == "function" ? (this.tech_.addSourceElement(this.mediaSourceUrl_), this.tech_.addSourceElement(this.source_.src)) : this.tech_.src(this.mediaSourceUrl_));
  }
  createKeySessions_() {
    const e = this.playlistController_.mediaTypes_.AUDIO.activePlaylistLoader;
    this.logger_("waiting for EME key session creation"), Ore({
      player: this.player_,
      sourceKeySystems: this.source_.keySystems,
      audioMedia: e && e.media(),
      mainPlaylists: this.playlists.main.playlists
    }).then(() => {
      this.logger_("created EME key session"), this.playlistController_.sourceUpdater_.initializedEme();
    }).catch((n) => {
      this.logger_("error while creating EME key session", n), this.player_.error({
        message: "Failed to initialize media keys for EME",
        code: 3
      });
    });
  }
  handleWaitingForKey_() {
    this.logger_("waitingforkey fired, attempting to create any new key sessions"), this.createKeySessions_();
  }
  /**
   * If necessary and EME is available, sets up EME options and waits for key session
   * creation.
   *
   * This function also updates the source updater so taht it can be used, as for some
   * browsers, EME must be configured before content is appended (if appending unencrypted
   * content before encrypted content).
   */
  setupEme_() {
    const e = this.playlistController_.mediaTypes_.AUDIO.activePlaylistLoader, n = Pre({
      player: this.player_,
      sourceKeySystems: this.source_.keySystems,
      media: this.playlists.media(),
      audioMedia: e && e.media()
    });
    if (this.player_.tech_.on("keystatuschange", (a) => {
      this.playlistController_.updatePlaylistByKeyStatus(a.keyId, a.status);
    }), this.handleWaitingForKey_ = this.handleWaitingForKey_.bind(this), this.player_.tech_.on("waitingforkey", this.handleWaitingForKey_), !n) {
      this.playlistController_.sourceUpdater_.initializedEme();
      return;
    }
    this.createKeySessions_();
  }
  /**
   * Initializes the quality levels and sets listeners to update them.
   *
   * @method setupQualityLevels_
   * @private
   */
  setupQualityLevels_() {
    const e = ce.players[this.tech_.options_.playerId];
    !e || !e.qualityLevels || this.qualityLevels_ || (this.qualityLevels_ = e.qualityLevels(), this.playlistController_.on("selectedinitialmedia", () => {
      Dre(this.qualityLevels_, this);
    }), this.playlists.on("mediachange", () => {
      fT(this.qualityLevels_, this.playlists);
    }));
  }
  /**
   * return the version
   */
  static version() {
    return {
      "@videojs/http-streaming": dT,
      "mux.js": Sre,
      "mpd-parser": Are,
      "m3u8-parser": Ere,
      "aes-decrypter": Lre
    };
  }
  /**
   * return the version
   */
  version() {
    return this.constructor.version();
  }
  canChangeType() {
    return sT.canChangeType();
  }
  /**
   * Begin playing the video.
   */
  play() {
    this.playlistController_.play();
  }
  /**
   * a wrapper around the function in PlaylistController
   */
  setCurrentTime(e) {
    this.playlistController_.setCurrentTime(e);
  }
  /**
   * a wrapper around the function in PlaylistController
   */
  duration() {
    return this.playlistController_.duration();
  }
  /**
   * a wrapper around the function in PlaylistController
   */
  seekable() {
    return this.playlistController_.seekable();
  }
  /**
   * Abort all outstanding work and cleanup.
   */
  dispose() {
    this.playbackWatcher_ && this.playbackWatcher_.dispose(), this.playlistController_ && this.playlistController_.dispose(), this.qualityLevels_ && this.qualityLevels_.dispose(), this.tech_ && this.tech_.vhs && delete this.tech_.vhs, this.mediaSourceUrl_ && j.URL.revokeObjectURL && (j.URL.revokeObjectURL(this.mediaSourceUrl_), this.mediaSourceUrl_ = null), this.tech_ && this.tech_.off("waitingforkey", this.handleWaitingForKey_), super.dispose();
  }
  convertToProgramTime(e, n) {
    return $ae({
      playlist: this.playlistController_.media(),
      time: e,
      callback: n
    });
  }
  // the player must be playing before calling this
  seekToProgramTime(e, n, a = !0, i = 2) {
    return H_({
      programTime: e,
      playlist: this.playlistController_.media(),
      retryCount: i,
      pauseAfterSeek: a,
      seekTo: this.options_.seekTo,
      tech: this.options_.tech,
      callback: n
    });
  }
  /**
   * Adds the onRequest, onResponse, offRequest and offResponse functions
   * to the VhsHandler xhr Object.
   */
  setupXhrHooks_() {
    this.xhr.onRequest = (e) => {
      mT(this.xhr, e);
    }, this.xhr.onResponse = (e) => {
      gT(this.xhr, e);
    }, this.xhr.offRequest = (e) => {
      bT(this.xhr, e);
    }, this.xhr.offResponse = (e) => {
      vT(this.xhr, e);
    }, this.player_.trigger("xhr-hooks-ready");
  }
  attachStreamingEventListeners_() {
    const e = ["seekablerangeschanged", "bufferedrangeschanged", "contentsteeringloadstart", "contentsteeringloadcomplete", "contentsteeringparsed"], n = ["gapjumped", "playedrangeschanged"];
    e.forEach((a) => {
      this.playlistController_.on(a, (i) => {
        this.player_.trigger(Jt({}, i));
      });
    }), n.forEach((a) => {
      this.playbackWatcher_.on(a, (i) => {
        this.player_.trigger(Jt({}, i));
      });
    });
  }
}
const Fu = {
  name: "videojs-http-streaming",
  VERSION: dT,
  canHandleSource(t, e = {}) {
    const n = gt(ce.options, e);
    return !n.vhs.experimentalUseMMS && !dl("avc1.4d400d,mp4a.40.2", !1) ? !1 : Fu.canPlayType(t.type, n);
  },
  handleSource(t, e, n = {}) {
    const a = gt(ce.options, n);
    return e.vhs = new yT(t, e, a), e.vhs.xhr = N_(), e.vhs.setupXhrHooks_(), e.vhs.src(t.src, t.type), e.vhs;
  },
  canPlayType(t, e) {
    const n = p5(t);
    if (!n)
      return "";
    const a = Fu.getOverrideNative(e);
    return !Ht.supportsTypeNatively(n) || a ? "maybe" : "";
  },
  getOverrideNative(t = {}) {
    const {
      vhs: e = {}
    } = t, n = !(ce.browser.IS_ANY_SAFARI || ce.browser.IS_IOS), {
      overrideNative: a = n
    } = e;
    return a;
  }
}, $re = () => dl("avc1.4d400d,mp4a.40.2", !0);
$re() && ce.getTech("Html5").registerSourceHandler(Fu, 0);
ce.VhsHandler = yT;
ce.VhsSourceHandler = Fu;
ce.Vhs = Ht;
ce.use || ce.registerComponent("Vhs", Ht);
ce.options.vhs = ce.options.vhs || {};
(!ce.getPlugin || !ce.getPlugin("reloadSourceOnError")) && ce.registerPlugin("reloadSourceOnError", Cre);
const Fre = {
  name: "VideoJs",
  props: {
    sources: {
      type: Array,
      required: !0
    },
    poster: {
      type: String,
      default: ""
    },
    autoplay: {
      type: Boolean,
      default: !1
    },
    controls: {
      type: Boolean,
      default: !0
    },
    fill: {
      type: Boolean,
      default: !0
    },
    audioPosterMode: { type: Boolean, default: !0 },
    loop: { type: Boolean, default: !1 },
    muted: { type: Boolean, default: !1 },
    playsinline: { type: Boolean, default: !0 }
  },
  data() {
    return {
      player: null
    };
  },
  mounted() {
    this.player = ce(
      this.$refs.videoPlayer,
      this.$props,
      () => {
      }
    );
  },
  beforeUnmount() {
    this.player && this.player.dispose();
  }
}, zre = { class: "video-js-container" }, Ure = { class: "video-player" }, Hre = {
  ref: "videoPlayer",
  class: "video-js vjs-big-play-centered"
};
function Yre(t, e, n, a, i, r) {
  return h(), b("div", zre, [
    k("div", Ure, [
      k("video", Hre, null, 512)
    ])
  ]);
}
const jre = /* @__PURE__ */ ge(Fre, [["render", Yre]]), Vre = { class: "media-item" }, qre = ["innerHTML"], Wre = ["textContent"], Gre = /* @__PURE__ */ Ce({
  __name: "Item",
  props: {
    // the image / video / audio / embed
    item: { type: Array, default: () => [] },
    embedCode: { type: String, default: "" },
    coverImage: { type: Array, default: () => [] },
    coverOnly: { type: Boolean, default: !1 },
    // sizing for the container (not the media item itself)
    height: { type: Number, default: 0 },
    width: { type: Number, default: 0 },
    aspectRatio: { type: Number, default: 0 },
    // Layout options
    backgroundColor: { type: String, default: "" },
    focalPoint: { type: Array, default: () => [] },
    mode: { type: String, default: "intrinsic-ratio" },
    objectFit: { type: String, default: "contain" },
    // video options
    controls: { type: Boolean, default: !0 },
    autoplay: { type: Boolean, default: !1 },
    loop: { type: Boolean, default: !1 },
    muted: { type: Boolean, default: !1 },
    playsinline: { type: Boolean, default: !0 }
  },
  setup(t) {
    const e = t, n = I(() => e.item[0] && e.item[0].kind === "audio"), a = I(() => !!(e.embedCode && e.embedCode.length)), i = I(() => e.item[0] && e.item[0].kind === "image"), r = I(() => e.item[0] && e.item[0].kind === "video"), s = I(() => e.coverImage[0] && e.coverImage[0].src), o = I(() => [
      `objectFit: ${e.objectFit}`,
      `objectPosition:
        ${e.item[0] && e.item[0].focalPoint && e.item[0].focalPoint.map((u) => `${u * 100}%`).join(" ")}`
    ]), l = I(() => e.aspectRatio || e.height / e.width * 100 || !e.coverOnly && e.item[0] && e.item[0].height / e.item[0].width * 100 || (e.coverImage[0] && e.coverImage[0].height / e.coverImage[0].width) * 100 || 9 / 16 * 100), c = I(() => [
      `paddingBottom: ${l.value}%`
    ]);
    return (u, f) => (h(), b("div", Vre, [
      a.value ? (h(), b("div", {
        key: 0,
        class: "media media-embed",
        innerHTML: t.embedCode
      }, null, 8, qre)) : i.value ? (h(), b("img", $t({
        key: 1,
        class: "media media-image",
        style: o.value
      }, t.item[0]), null, 16)) : e.coverOnly ? (h(), b("img", $t({
        key: 2,
        class: "media media-image",
        style: o.value
      }, e.coverImage[0]), null, 16)) : r.value || n.value ? (h(), G(jre, {
        key: 3,
        class: "media media-video",
        style: bn(o.value),
        sources: e.item,
        poster: s.value,
        controls: e.controls,
        autoplay: e.autoplay,
        loop: e.loop,
        muted: e.muted,
        playsinline: e.playsinline,
        "audio-poster-mode": n.value
      }, null, 8, ["style", "sources", "poster", "controls", "autoplay", "loop", "muted", "playsinline", "audio-poster-mode"])) : (h(), b("p", {
        key: 4,
        class: "media",
        style: { "background-color": "white", padding: "10px" },
        textContent: ne(
          n.value ? "Audio uploads not supported yet" : "Could not identify media type"
        )
      }, null, 8, Wre)),
      k("div", {
        class: "sizer",
        style: bn(c.value)
      }, null, 4),
      me(u.$slots, "default", {}, void 0, !0)
    ]));
  }
}), Md = /* @__PURE__ */ ge(Gre, [["__scopeId", "data-v-7c537112"]]), Xre = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Md
}, Symbol.toStringTag, { value: "Module" })), Zre = {
  key: 0,
  class: "floating-highlight"
}, Kre = { class: "badge-content" }, Qre = {
  __name: "MediaBadge",
  setup(t) {
    const e = qe(), n = I(() => ["media-badge", (e == null ? void 0 : e.value) || ""]);
    return (a, i) => (h(), b("div", {
      class: re(n.value)
    }, [
      O(e) !== "ftva" ? (h(), b("div", Zre)) : A("", !0),
      k("div", Kre, [
        me(a.$slots, "default", { class: "badge-content-item" }, void 0, !0)
      ])
    ], 2));
  }
}, Jre = /* @__PURE__ */ ge(Qre, [["__scopeId", "data-v-5e631014"]]), ese = { key: 0 }, tse = {
  key: 0,
  class: "ftva-image-stack-bckgrd"
}, nse = { key: 0 }, ase = { key: 0 }, ise = { key: 1 }, rse = { key: 1 }, sse = {
  key: 3,
  class: "glyph-expand"
}, ose = {
  key: 0,
  y1: "20%",
  x1: "50%",
  y2: "80%",
  x2: "50%",
  "stroke-width": "1.5px"
}, lse = {
  key: 0,
  class: "text-wrapper"
}, cse = ["textContent"], use = /* @__PURE__ */ Ce({
  __name: "BannerImage",
  props: {
    item: {
      type: Array,
      default: () => []
    },
    coverImage: {
      type: Array,
      default: () => []
    },
    embedCode: {
      type: String,
      default: ""
    },
    nItems: {
      type: Number,
      required: !0
    },
    expanded: {
      type: Boolean,
      required: !0
    },
    isHalfWidth: {
      type: String,
      default: ""
    },
    sectionTitle: {
      type: String,
      default: ""
    },
    sectionSummary: {
      type: String,
      default: ""
    }
  },
  emits: ["toggleThumbnails"],
  setup(t, { emit: e }) {
    const n = t, a = e, i = qe(), r = I(() => [
      "banner-image",
      (i == null ? void 0 : i.value) || "",
      n.isHalfWidth === "halfWidth" ? "half-width-media-item" : ""
    ]);
    return (s, o) => (h(), b("div", {
      class: re(r.value)
    }, [
      Q(Md, {
        item: t.item,
        "embed-code": t.embedCode,
        "cover-image": t.coverImage,
        "aspect-ratio": 60,
        "object-fit": "cover",
        class: "media-item",
        onClick: o[0] || (o[0] = (l) => a("toggleThumbnails"))
      }, {
        default: oe(() => [
          t.nItems > 1 && !t.expanded ? (h(), b("div", ese, [
            o[1] || (o[1] = k("div", { class: "gradient" }, null, -1)),
            O(i) === "ftva" ? (h(), b("div", tse, [
              Q(O(t5), {
                class: "molecule-image-stack",
                "aria-hidden": "true"
              })
            ])) : (h(), G(O(xQ), {
              key: 1,
              class: "molecule-image-stack",
              "aria-hidden": "true"
            }))
          ])) : A("", !0),
          t.nItems > 1 ? (h(), G(Jre, {
            key: 1,
            "is-expanded": t.expanded
          }, {
            default: oe(() => [
              O(i) === "ftva" ? (h(), b("span", nse, [
                t.expanded ? (h(), b("span", ase, "Collapse Gallery")) : (h(), b("span", ise, "View all " + ne(t.nItems) + " images", 1))
              ])) : (h(), b("span", rse, ne(t.nItems) + " images ", 1)),
              O(i) === "ftva" ? (h(), G(O(of), {
                key: 2,
                class: re(["drop-triangle", { "is-expanded": t.expanded }])
              }, null, 8, ["class"])) : (h(), b("svg", sse, [
                o[2] || (o[2] = k("line", {
                  x1: "20%",
                  y1: "50%",
                  x2: "80%",
                  y2: "50%",
                  "stroke-width": "1.5px"
                }, null, -1)),
                t.expanded ? A("", !0) : (h(), b("line", ose))
              ]))
            ]),
            _: 1
          }, 8, ["is-expanded"])) : A("", !0)
        ]),
        _: 1
      }, 8, ["item", "embed-code", "cover-image"]),
      t.isHalfWidth ? (h(), b("div", lse, [
        t.sectionTitle ? (h(), b("h3", {
          key: 0,
          class: "title",
          textContent: ne(t.sectionTitle)
        }, null, 8, cse)) : A("", !0),
        t.sectionSummary ? (h(), G(un, {
          key: 1,
          class: "summary",
          innerHTML: t.sectionSummary
        }, null, 8, ["innerHTML"])) : A("", !0)
      ])) : A("", !0)
    ], 2));
  }
}), dse = /* @__PURE__ */ ge(use, [["__scopeId", "data-v-b4ac3f05"]]), hse = {
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-caret-circle-left"
};
function fse(t, e) {
  return h(), b("svg", hse, e[0] || (e[0] = [
    k("circle", {
      opacity: "0.2",
      cx: "24",
      cy: "24",
      r: "22",
      fill: "#EAF2FB",
      class: "svg__fill--primary-blue-01"
    }, null, -1),
    k("path", {
      d: "M17 24.1355L16.4697 24.6658C16.1768 24.3729 16.1768 23.8981 16.4697 23.6052L17 24.1355ZM16.4697 23.6052L30.4697 9.60517L31.5303 10.6658L17.5303 24.6658L16.4697 23.6052ZM17.5303 23.6052L31.5303 37.6052L30.4697 38.6658L16.4697 24.6658L17.5303 23.6052Z",
      fill: "#0B6AB7",
      class: "svg__fill--primary-blue-03"
    }, null, -1)
  ]));
}
const pse = { render: fse }, mse = {
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-caret-circle-right"
};
function gse(t, e) {
  return h(), b("svg", mse, e[0] || (e[0] = [
    k("circle", {
      opacity: "0.2",
      cx: "24",
      cy: "24",
      r: "22",
      fill: "#EAF2FB",
      class: "svg__fill--primary-blue-01"
    }, null, -1),
    k("path", {
      d: "M31 24.1355L31.5303 23.6052C31.8232 23.8981 31.8232 24.3729 31.5303 24.6658L31 24.1355ZM31.5303 24.6658L17.5303 38.6658L16.4697 37.6052L30.4697 23.6052L31.5303 24.6658ZM30.4697 24.6658L16.4697 10.6658L17.5303 9.60517L31.5303 23.6052L30.4697 24.6658Z",
      fill: "#0B6AB7",
      class: "svg__fill--primary-blue-03"
    }, null, -1)
  ]));
}
const bse = { render: gse }, vse = {
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-close-large"
};
function yse(t, e) {
  return h(), b("svg", vse, e[0] || (e[0] = [
    k("g", null, [
      k("circle", {
        opacity: "0.2",
        cx: "24",
        cy: "24",
        r: "24",
        fill: "#EAF2FB",
        class: "svg__fill--primary-blue-01"
      }),
      k("path", {
        d: "M36 35.8886L12 12.1099",
        stroke: "#5CD9FF",
        "stroke-width": "1.5",
        "stroke-linejoin": "round",
        class: "svg__stroke--default-cyan-02"
      }),
      k("path", {
        d: "M12.0989 36L35.9023 12",
        stroke: "#5CD9FF",
        "stroke-width": "1.5",
        "stroke-linejoin": "round",
        class: "svg__stroke--default-cyan-02"
      })
    ], -1)
  ]));
}
const _T = { render: yse }, _se = {
  key: 0,
  class: "credit-text"
}, Tse = ["textContent"], xse = ["disabled"], wse = ["disabled"], kse = { class: "caption-block" }, Cse = ["disabled", "onClick"], Sse = { class: "caption-content" }, Ase = { class: "media-object-caption-slot" }, Ese = {
  key: 0,
  class: "media-object-title"
}, Lse = ["textContent"], Dse = {
  key: 2,
  class: "media-object-credit"
}, Ise = /* @__PURE__ */ Ce({
  __name: "NewLightbox",
  props: {
    items: {
      type: Array,
      default: () => [],
      required: !0
    },
    selectedItem: {
      type: Number,
      default: 0
    },
    // Triggers Lightbox to be overlaid (default) or inline
    inline: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["closeModal"],
  setup(t, { emit: e }) {
    const n = e, a = qe(), i = ve(
      () => Promise.resolve().then(() => X2)
    ), r = K(t.selectedItem), s = I(() => t.items.map((S) => S.captionTitle)), o = I(() => t.items.map((S) => S.captionText)), l = I(() => ["lightbox", (a == null ? void 0 : a.value) || "", t.inline ? "inline" : ""]), c = I(() => (a == null ? void 0 : a.value) === "ftva" ? "cover" : "contain"), u = K(null), f = K(), m = K(), _ = K();
    st(() => {
      var S;
      (S = u.value) == null || S.focus(), T();
    });
    function T() {
      if (t.items.length < 2)
        return null;
      const S = _.value.getBoundingClientRect();
      f.value.style.setProperty("--counterWidth", `${S.width}px`), m.value.style.setProperty("--counterWidth", `${S.width}px`);
    }
    function g() {
      n("closeModal");
    }
    function x(S) {
      r.value = S;
    }
    return (S, D) => (h(), b("div", {
      ref_key: "lightbox",
      ref: u,
      class: re(l.value)
    }, [
      k("button", {
        class: "button-close",
        onClick: g
      }, [
        Q(O(_T), { "aria-label": "Close" })
      ]),
      Q(O(Ky), {
        modelValue: r.value,
        "onUpdate:modelValue": D[0] || (D[0] = (L) => r.value = L),
        class: "media-container"
      }, {
        default: oe(() => [
          (h(!0), b(he, null, Le(t.items, (L, M) => (h(), G(O(Qy), {
            key: `media-container-${M}`
          }, {
            default: oe(() => [
              (h(), G(Md, {
                key: `${L.captionTitle}-${M}`,
                "object-fit": c.value,
                item: L.item,
                "cover-image": L.coverImage,
                "embed-code": L.embedCode
              }, {
                default: oe(() => [
                  L.credit ? (h(), b("div", _se, [
                    k("span", {
                      textContent: ne(L.credit)
                    }, null, 8, Tse)
                  ])) : A("", !0)
                ]),
                _: 2
              }, 1032, ["object-fit", "item", "cover-image", "embed-code"]))
            ]),
            _: 2
          }, 1024))), 128))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      t.items.length > 1 ? (h(), b("button", {
        key: 0,
        ref_key: "prevBtnRef",
        ref: f,
        class: "button-prev",
        disabled: r.value <= 0,
        onClick: D[1] || (D[1] = (L) => r.value -= 1)
      }, [
        Q(O(pse), { "aria-label": "Show previous image" })
      ], 8, xse)) : A("", !0),
      t.items.length > 1 ? (h(), b("button", {
        key: 1,
        ref_key: "nextBtnRef",
        ref: m,
        class: "button-next",
        disabled: r.value >= t.items.length - 1,
        onClick: D[2] || (D[2] = (L) => r.value += 1)
      }, [
        Q(O(bse), { "aria-label": "Show next image" })
      ], 8, wse)) : A("", !0),
      k("div", kse, [
        t.items.length > 1 ? (h(), b("div", {
          key: 0,
          ref_key: "paginationCounterRef",
          ref: _,
          class: "media-counter",
          role: "tablist"
        }, [
          (h(!0), b(he, null, Le(t.items.length, (L) => (h(), b("button", {
            key: `caption-block-${L}`,
            disabled: L - 1 === r.value,
            class: "media-counter-item",
            onClick: (M) => x(L - 1)
          }, [
            Q(O(Jy))
          ], 8, Cse))), 128))
        ], 512)) : A("", !0),
        k("div", Sse, [
          k("div", Ase, [
            me(S.$slots, "default", { selectionIndex: r.value }, void 0, !0)
          ]),
          s.value[r.value] ? (h(), b("h4", Ese, [
            t.items && t.items[r.value] && t.items[r.value].linkUrl ? (h(), G(Xe, {
              key: 0,
              to: t.items[r.value].linkUrl
            }, {
              default: oe(() => [
                ze(ne(s.value[r.value]), 1)
              ]),
              _: 1
            }, 8, ["to"])) : (h(), b(he, { key: 1 }, [
              ze(ne(s.value[r.value]), 1)
            ], 64))
          ])) : A("", !0),
          o.value ? (h(), b("p", {
            key: 1,
            class: "media-object-caption",
            textContent: ne(o.value[r.value])
          }, null, 8, Lse)) : A("", !0),
          t.items && t.items[r.value] && t.items[r.value].credit ? (h(), b("p", Dse, ne(t.items[r.value].credit), 1)) : A("", !0),
          t.items && t.items[r.value] && t.items[r.value].linkUrl && t.items[r.value].linkText ? (h(), G(Xe, {
            key: 3,
            class: "media-object-caption-link",
            to: t.items[r.value].linkUrl
          }, {
            default: oe(() => [
              ze(ne(t.items[r.value].linkText) + " ", 1),
              Q(O(i))
            ]),
            _: 1
          }, 8, ["to"])) : A("", !0)
        ])
      ])
    ], 2));
  }
}), TT = /* @__PURE__ */ ge(Ise, [["__scopeId", "data-v-66533006"]]), Mse = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: TT
}, Symbol.toStringTag, { value: "Module" })), Ose = {
  key: 0,
  class: "caption-text"
}, Pse = /* @__PURE__ */ Ce({
  __name: "ThumbnailCard",
  props: {
    item: {
      type: Array,
      default: () => []
    },
    coverImage: {
      type: Array,
      default: () => []
    },
    embedCode: {
      type: String,
      default: ""
    },
    captionTitle: {
      type: String,
      default: ""
    },
    captionText: {
      type: String,
      default: ""
    },
    credit: {
      type: String,
      default: ""
    },
    linkUrl: {
      type: String,
      default: ""
    },
    linkText: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = t, n = I(() => (e.coverImage || []).concat(e.item || []).filter((s) => s.kind === "image")), a = I(() => wi(e.captionText || e.credit || "")), i = qe(), r = I(() => ["thumbnail-card", (i == null ? void 0 : i.value) || ""]);
    return (s, o) => (h(), G(cl, {
      class: re(r.value),
      "no-margins": !0
    }, {
      default: oe(() => [
        Q(Md, {
          item: n.value,
          "aspect-ratio": 60,
          class: "image",
          "object-fit": "cover"
        }, null, 8, ["item"]),
        Q(Nf, {
          class: "caption-title",
          textContent: ne(t.captionTitle)
        }, null, 8, ["textContent"]),
        a.value ? (h(), b("p", Ose, ne(a.value), 1)) : A("", !0),
        t.linkUrl && t.linkText ? (h(), G(Xe, {
          key: 1,
          to: t.linkUrl,
          class: "caption-link"
        }, {
          default: oe(() => [
            ze(ne(t.linkText) + " ", 1),
            Q(O(Xu))
          ]),
          _: 1
        }, 8, ["to"])) : A("", !0)
      ]),
      _: 1
    }, 8, ["class"]));
  }
}), Bse = /* @__PURE__ */ ge(Pse, [["__scopeId", "data-v-f59d1bfb"]]), Rse = {
  key: 1,
  class: "gallery-header"
}, Nse = { class: "gallery-title" }, $se = { class: "selected-image-title" }, Fse = { class: "selected-image-caption" }, zse = {
  key: 3,
  class: "thumbnails"
}, Use = /* @__PURE__ */ Ce({
  __name: "MediaGallery",
  props: {
    block: {
      type: Object,
      required: !0
    },
    // Triggers Lightbox to be overlaid (default) or inline
    inline: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    const e = K(!1), n = K(0), a = K(!1), i = I(() => t.block.mediaGallery.length), r = I(() => t.block.sectionTitle), s = I(() => t.block.mediaGalleryStyle === "fullWidth"), o = I(() => t.block.mediaGalleryStyle === "halfWidth"), l = I(() => o.value ? t.block.sectionTitle : ""), c = I(() => o.value ? t.block.richTextSimplified : ""), u = qe(), f = I(() => ["media-gallery", (u == null ? void 0 : u.value) || ""]);
    function m() {
      a.value = !1;
    }
    function _() {
      e.value = !e.value;
    }
    function T(g) {
      n.value = g, a.value = !0;
    }
    return (g, x) => t.block.mediaGallery && t.block.mediaGallery.length > 0 ? (h(), b("section", {
      key: 0,
      class: re(f.value)
    }, [
      a.value ? (h(), G(TT, {
        key: 0,
        items: t.block.mediaGallery,
        "selected-item": n.value,
        tabindex: "0",
        inline: t.inline,
        onCloseModal: m,
        onKeydown: Li(m, ["esc"])
      }, null, 8, ["items", "selected-item", "inline"])) : A("", !0),
      O(u) === "ftva" && s.value ? (h(), b("section", Rse, [
        k("h2", Nse, ne(r.value), 1),
        k("h3", $se, ne(t.block.mediaGallery[n.value].captionTitle), 1),
        k("p", Fse, ne(t.block.mediaGallery[n.value].captionText), 1)
      ])) : A("", !0),
      t.block.mediaGallery && t.block.mediaGallery[n.value].item ? (h(), G(dse, {
        key: 2,
        item: t.block.mediaGallery[n.value].item,
        "cover-image": t.block.mediaGallery[n.value].coverImage,
        "embed-code": t.block.mediaGallery[n.value].embedCode,
        "n-items": i.value,
        expanded: e.value,
        "is-half-width": t.block.mediaGalleryStyle,
        "section-title": l.value,
        "section-summary": c.value,
        onToggleThumbnails: _
      }, null, 8, ["item", "cover-image", "embed-code", "n-items", "expanded", "is-half-width", "section-title", "section-summary"])) : A("", !0),
      e.value ? (h(), b("div", zse, [
        (h(!0), b(he, null, Le(t.block.mediaGallery, (S, D) => (h(), G(Bse, $t({
          key: S.id,
          ref_for: !0
        }, S, {
          onClick: (L) => T(D)
        }), null, 16, ["onClick"]))), 128))
      ])) : A("", !0)
    ], 2)) : A("", !0);
  }
}), Hse = /* @__PURE__ */ ge(Use, [["__scopeId", "data-v-0e9277f2"]]), Yse = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Hse
}, Symbol.toStringTag, { value: "Module" })), jse = { class: "flexible-page-block-container" }, Vse = { class: "section-header" }, qse = ["innerHTML"], Wse = ["innerHTML"], Gse = /* @__PURE__ */ Ce({
  __name: "MediaWithText",
  props: {
    block: {
      type: Object,
      default: () => {
      }
    }
  },
  setup(t) {
    const e = I(() => t.block.mediaWithText.map((r) => {
      var s;
      return {
        ...r,
        // mediaWithText_mediaEmbed or mediaWithText_mediaUpload
        parsedTitle: r.titleLink ? r.titleLink : r.titleUpload,
        // item: upload
        // item[0].src & buttonUrl can return as null - neither are required
        parsedButtonUrl: r.item && r.typeMedia === "other" ? (s = r.item[0]) == null ? void 0 : s.src : r.buttonUrl
      };
    })), n = qe(), a = I(() => ["section-media-with-text", (n == null ? void 0 : n.value) || ""]);
    return (i, r) => (h(), b("div", {
      class: re(a.value)
    }, [
      k("div", jse, [
        r[0] || (r[0] = k("h2", { class: "visually-hidden" }, " Resources ", -1)),
        k("div", Vse, [
          t.block.sectionTitle ? (h(), b("h3", {
            key: 0,
            class: "section-title",
            innerHTML: t.block.sectionTitle
          }, null, 8, qse)) : A("", !0),
          t.block.sectionSummary ? (h(), b("div", {
            key: 1,
            class: "section-summary",
            innerHTML: t.block.sectionSummary
          }, null, 8, Wse)) : A("", !0)
        ]),
        (h(!0), b(he, null, Le(e.value, (s, o) => (h(), b("div", {
          key: `MediaWithTextKey${o}`,
          class: "meta"
        }, [
          Q(zI, {
            "section-header": s.parsedTitle,
            "short-description": s.description,
            item: s.item,
            "cover-image": s.coverImage,
            "button-text": s.buttonText,
            "button-url": s.parsedButtonUrl,
            "embed-code": s.embedCode,
            "type-media": s.typeMedia,
            class: "flexible-media-with-text"
          }, null, 8, ["section-header", "short-description", "item", "cover-image", "button-text", "button-url", "embed-code", "type-media"]),
          O(n) !== "ftva" ? (h(), G(sh, {
            key: 0,
            class: "divider"
          })) : A("", !0)
        ]))), 128))
      ])
    ], 2));
  }
}), Xse = /* @__PURE__ */ ge(Gse, [["__scopeId", "data-v-0647e6d2"]]), Zse = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Xse
}, Symbol.toStringTag, { value: "Module" })), Kse = {
  key: 1,
  class: "attribution-block"
}, Qse = ["innerHTML"], Jse = /* @__PURE__ */ Ce({
  __name: "PullQuote",
  props: {
    text: {
      type: String,
      default: ""
    },
    attribution: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = qe(), n = I(() => ["pull-quote", (e == null ? void 0 : e.value) || ""]);
    return (a, i) => (h(), b("div", {
      class: re(n.value)
    }, [
      t.text ? (h(), G(un, {
        key: 0,
        class: "quote",
        "rich-text-content": t.text
      }, null, 8, ["rich-text-content"])) : A("", !0),
      t.attribution ? (h(), b("div", Kse, [
        i[0] || (i[0] = k("span", { class: "dash" }, "—", -1)),
        t.attribution ? (h(), b("span", {
          key: 0,
          class: "attribution",
          innerHTML: t.attribution
        }, null, 8, Qse)) : A("", !0)
      ])) : A("", !0)
    ], 2));
  }
}), Wc = /* @__PURE__ */ ge(Jse, [["__scopeId", "data-v-6f731ff0"]]), eoe = /* @__PURE__ */ Ce({
  __name: "PullQuote",
  props: {
    block: {
      type: Object,
      default: () => {
      }
    }
  },
  setup(t) {
    return (e, n) => t.block.pullQuote ? (h(), G(Wc, {
      key: 0,
      text: t.block.pullQuote[0].text,
      attribution: t.block.pullQuote[0].attribution
    }, null, 8, ["text", "attribution"])) : A("", !0);
  }
}), toe = /* @__PURE__ */ ge(eoe, [["__scopeId", "data-v-b579df03"]]), noe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: toe
}, Symbol.toStringTag, { value: "Module" })), aoe = { class: "rich-text" }, ioe = ["innerHTML"], roe = /* @__PURE__ */ Ce({
  __name: "RichText",
  props: {
    block: {
      type: Object,
      default: () => {
      }
    }
  },
  setup(t) {
    return (e, n) => (h(), b("div", aoe, [
      t.block.sectionTitle ? (h(), b("h2", {
        key: 0,
        class: "section-title",
        innerHTML: t.block.sectionTitle
      }, null, 8, ioe)) : A("", !0),
      Q(un, {
        "rich-text-content": t.block.richText
      }, null, 8, ["rich-text-content"])
    ]));
  }
}), soe = /* @__PURE__ */ ge(roe, [["__scopeId", "data-v-7207e802"]]), ooe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: soe
}, Symbol.toStringTag, { value: "Module" })), loe = { class: "section-header" }, coe = ["textContent"], uoe = ["innerHTML"], doe = { class: "simple-cards-list" }, hoe = /* @__PURE__ */ Ce({
  __name: "SimpleCards",
  props: {
    items: {
      type: Array,
      default: () => []
    },
    sectionTitle: {
      type: String,
      default: ""
    },
    sectionSummary: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = I(() => {
      let i = ["card", "card-small"];
      switch (t.items.length) {
        case 1:
          i = ["card"];
          break;
        case 2:
        case 4:
          i = ["card", "card-large"];
          break;
        case 5:
          i = ["card", "card-five"];
          break;
      }
      return t.items.map((r) => ({
        ...r,
        classes: i
      }));
    }), n = qe(), a = I(() => ["simple-cards", (n == null ? void 0 : n.value) || ""]);
    return (i, r) => (h(), b("div", {
      class: re(a.value)
    }, [
      k("div", loe, [
        t.sectionTitle ? (h(), b("h2", {
          key: 0,
          class: "section-title",
          textContent: ne(t.sectionTitle)
        }, null, 8, coe)) : A("", !0),
        t.sectionSummary ? (h(), b("div", {
          key: 1,
          class: "section-summary",
          innerHTML: t.sectionSummary
        }, null, 8, uoe)) : A("", !0)
      ]),
      k("ul", doe, [
        (h(!0), b(he, null, Le(e.value, (s, o) => (h(), G(KM, {
          key: `SimpleCardsKey${o}`,
          class: re(s.classes),
          to: s.to,
          title: s.title,
          text: s.text
        }, null, 8, ["class", "to", "title", "text"]))), 128))
      ])
    ], 2));
  }
}), foe = /* @__PURE__ */ ge(hoe, [["__scopeId", "data-v-2fec9aa6"]]), Nhe = /* @__PURE__ */ Ce({
  __name: "SimpleCards",
  props: {
    block: {
      type: Object,
      default: () => {
      }
    }
  },
  setup(t) {
    const e = I(() => t.block.cards.map((i) => (i.typeHandle === "internalResource" || i.typeHandle === "internalServiceOrResource") && i.contentLink[0] ? {
      title: it(i, "contentLink[0].title", ""),
      text: it(i, "contentLink[0].summary", ""),
      to: i.contentLink[0].externalResourceUrl ? i.contentLink[0].externalResourceUrl : $n(
        i.contentLink[0].uri
      )
    } : i.typeHandle === "externalResource" || i.typeHandle === "externalServiceOrResource" ? {
      title: i.title,
      text: i.summary,
      to: i.externalLink
    } : {
      ...i
    })), n = qe(), a = I(() => ["flexible-simple-cards", (n == null ? void 0 : n.value) || ""]);
    return (i, r) => (h(), b("div", {
      class: re(a.value)
    }, [
      Q(foe, {
        "section-title": t.block.sectionTitle,
        "section-summary": t.block.sectionSummary,
        items: e.value
      }, null, 8, ["section-title", "section-summary", "items"])
    ], 2));
  }
}), poe = {
  name: "FooterSponsor",
  components: {
    BlockSponsor: cO
  },
  computed: {
    ...z4(io, ["footerSponsor"]),
    parsedFunders() {
      return Object.keys(this.footerSponsor).length !== 0 ? this.footerSponsor.funders : (console.log(
        "Pinia state data for footer sponsor not present if navigation is not setup for the website."
      ), []);
    }
  }
}, moe = { class: "footer-sponsor" }, goe = { class: "sponsor-logos" };
function boe(t, e, n, a, i, r) {
  const s = lt("BlockSponsor");
  return h(), b("div", moe, [
    e[0] || (e[0] = k("div", { class: "sponsor-text" }, " The UCLA Library Modern Endangered Archives Program is supported by Arcadia. ", -1)),
    k("div", goe, [
      (h(!0), b(he, null, Le(r.parsedFunders, (o) => (h(), G(s, {
        key: `footer-sponsor-${o.funderName}`,
        class: "sponsor-item",
        "funder-logo": o.funderLogo,
        "funder-name": o.funderName,
        "funder-url": o.funderUrl
      }, null, 8, ["funder-logo", "funder-name", "funder-url"]))), 128))
    ])
  ]);
}
const voe = /* @__PURE__ */ ge(poe, [["render", boe], ["__scopeId", "data-v-6c82596b"]]), yoe = {
  width: "115",
  height: "22",
  viewBox: "0 0 115 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__logo-library"
};
function _oe(t, e) {
  return h(), b("svg", yoe, e[0] || (e[0] = [
    ri('<path d="M64.2231 6.91406H66.6533V16.8684H72.2837V18.8963H64.2231V6.91406Z" fill="#0F0F0F" class="svg__fill--black"></path><path d="M73.1401 6.91406H75.421V8.95857H73.1401V6.91406ZM73.1401 10.3008H75.421V18.8957H73.1401V10.3008Z" fill="#0F0F0F" class="svg__fill--black"></path><path d="M79.0763 17.8236H79.0425V18.8963H76.8452V6.91406H79.1261V11.3376H79.1772C79.4275 10.9318 79.7814 10.5999 80.2024 10.3762C80.6234 10.1524 81.0965 10.0448 81.5729 10.0645C83.7349 10.0645 85.2769 11.9237 85.2769 14.6055C85.2769 17.3868 83.8019 19.1466 81.6406 19.1466C81.1342 19.1731 80.6299 19.0645 80.1793 18.832C79.7287 18.5994 79.348 18.2511 79.0763 17.8229V17.8236ZM82.9642 14.6055C82.9642 13.0158 82.327 11.9099 81.0538 11.9099C79.612 11.9099 79.0763 13.0663 79.0763 14.6573C79.0763 16.2332 79.8643 17.2389 81.1374 17.2389C82.3124 17.2389 82.9642 16.2664 82.9642 14.6076" fill="#0F0F0F" class="svg__fill--black"></path><path d="M88.5549 11.6745H88.6054C89.1245 10.7027 89.7113 10.1995 90.7169 10.1995C90.8982 10.1895 91.0798 10.2129 91.2526 10.2687V12.2627H91.2028C89.7113 12.112 88.6385 12.9 88.6385 14.7095V18.8987H86.3577V10.3005H88.5528L88.5549 11.6745Z" fill="#0F0F0F" class="svg__fill--black"></path><path d="M97.1455 17.9435H97.1124C96.6762 18.5967 96.0562 19.0998 94.582 19.0998C92.8222 19.0998 91.5815 18.1778 91.5815 16.4685C91.5815 14.5747 93.1236 13.972 95.0374 13.7038C96.4613 13.5027 97.1158 13.3859 97.1158 12.732C97.1158 12.11 96.632 11.7098 95.6747 11.7098C94.602 11.7098 94.085 12.0954 94.0159 12.9159H91.988C92.0571 11.4084 93.1775 10.082 95.6913 10.082C98.2729 10.082 99.3117 11.2391 99.3117 13.2497V17.6235C99.3117 18.2767 99.4119 18.6603 99.613 18.8137V18.8973H97.4179C97.2612 18.6018 97.1697 18.276 97.1497 17.9421L97.1455 17.9435ZM97.1663 15.8637V14.5747C96.6609 14.8117 96.1263 14.9807 95.5766 15.0772C94.387 15.3454 93.8002 15.6142 93.8002 16.4181C93.8002 17.2219 94.3359 17.5074 95.1404 17.5074C96.4481 17.5074 97.1683 16.7035 97.1683 15.8651" fill="#0F0F0F" class="svg__fill--black"></path><path d="M102.914 11.6745H102.965C103.484 10.7027 104.071 10.1995 105.076 10.1995C105.258 10.1895 105.439 10.2129 105.612 10.2687V12.2627H105.562C104.071 12.112 102.998 12.9 102.998 14.7095V18.8987H100.717V10.3005H102.912L102.914 11.6745Z" fill="#0F0F0F" class="svg__fill--black"></path><path d="M106.914 19.9198H107.719C108.624 19.9198 108.992 19.4498 108.992 18.7448C108.903 17.9377 108.683 17.1506 108.339 16.4148L106.026 10.2979H108.423L109.696 14.1685C109.964 14.9557 110.249 16.045 110.249 16.045H110.283C110.283 16.045 110.517 14.9557 110.786 14.1685L111.992 10.2979H114.288L111.288 19.1132C110.635 21.0236 109.998 21.7106 108.255 21.7106H106.914V19.9198Z" fill="#0F0F0F" class="svg__fill--black"></path><path d="M0.666559 13.818C0.614596 13.1713 0.600979 12.5221 0.625779 11.8738L1.55127 1.3623H4.99334L4.04919 11.9657C3.84667 14.2611 4.74659 15.8971 7.03785 15.8971C9.37887 15.8971 10.6168 14.2328 10.8207 12.1965L11.7973 1.3623H15.2366L14.2862 12.0611C13.902 16.1798 11.169 19.2652 6.75239 19.2652C3.30686 19.2652 1.08472 17.0383 0.670014 13.818" fill="#0B6AB7" class="svg__fill--primary-blue-03"></path><path d="M16.029 10.2578C16.4776 5.21216 19.8824 1.02914 25.7622 1.02914C27.3648 1.00627 28.9379 1.46155 30.2805 2.33685L29.8858 6.50466C29.3791 5.81083 28.7048 5.25673 27.926 4.89412C27.1471 4.53151 26.289 4.37222 25.4319 4.43113C21.7727 4.43113 19.7642 6.9719 19.4787 10.1893C19.2023 13.3218 20.8182 15.8681 24.3626 15.8681C25.2866 15.8725 26.2012 15.6822 27.0467 15.3095C27.8922 14.9369 28.6498 14.3903 29.27 13.7054L28.885 17.9858C27.4251 18.8272 25.7744 19.2814 24.0896 19.3053C18.2705 19.3053 15.606 14.9827 16.0242 10.2578" fill="#0B6AB7" class="svg__fill--primary-blue-03"></path><path d="M33.0275 1.3623H36.4592L35.2061 15.6352H40.1238C40.4694 15.6352 41.6444 15.6172 41.9596 15.5985C41.9416 15.7706 41.6472 18.8961 41.6472 18.8961H31.4709L33.0275 1.3623Z" fill="#0B6AB7" class="svg__fill--primary-blue-03"></path><path d="M50.9032 7.90896C51.0106 7.67206 51.0955 7.42561 51.1569 7.17286C51.1753 7.17151 51.1937 7.17151 51.2122 7.17286C51.2327 7.42362 51.2767 7.67191 51.3435 7.91449C51.5301 8.71419 52.8641 13.1529 52.8641 13.1529H48.5352C48.5352 13.1529 50.8569 8.02508 50.9032 7.91173V7.90896ZM51.7838 0.561035H51.546L42.1494 18.8966H45.7961L47.1169 16.1126H53.7363L54.5658 18.8939H58.2041L51.7838 0.561035Z" fill="#0B6AB7" class="svg__fill--primary-blue-03"></path>', 11)
  ]));
}
const Zs = { render: _oe }, Toe = {
  width: "300",
  height: "57",
  viewBox: "0 0 300 57",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  class: "svg__icon-ftva-footerlogo"
};
function xoe(t, e) {
  return h(), b("svg", Toe, e[0] || (e[0] = [
    k("rect", {
      y: "0.375",
      width: "300",
      height: "56.25",
      fill: "url(#pattern0_14159_65327)"
    }, null, -1),
    k("defs", null, [
      k("pattern", {
        id: "pattern0_14159_65327",
        patternContentUnits: "objectBoundingBox",
        width: "1",
        height: "1"
      }, [
        k("use", {
          "xlink:href": "#image0_14159_65327",
          transform: "matrix(0.00104167 0 0 0.00555556 0.00208333 0)"
        })
      ]),
      k("image", {
        id: "image0_14159_65327",
        width: "956",
        height: "180",
        "xlink:href": "data:image/png;base64,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"
      })
    ], -1)
  ]));
}
const woe = { render: xoe }, koe = {
  width: "225",
  height: "496",
  viewBox: "0 0 225 496",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__molecule-half"
};
function Coe(t, e) {
  return h(), b("svg", koe, e[0] || (e[0] = [
    k("g", null, [
      k("path", {
        d: "M244.852 445.001L106.511 387.698L71.9262 422.283L244.852 493.911L244.852 445.001Z",
        fill: "#0B6AB7",
        class: "svg__fill-bottom"
      }),
      k("path", {
        d: "M71.9261 76.4322L106.511 111.017L244.852 53.7149L244.851 4.80416L71.9261 76.4322Z",
        fill: "#0B6AB7",
        class: "svg__fill-top"
      }),
      k("path", {
        d: "M0.297249 249.357L71.9254 76.4319L106.511 111.017L49.2081 249.357L49.208 249.357L106.51 387.698L71.9254 422.283L0.297249 249.357Z",
        fill: "#9ECFFA",
        class: "svg__fill-accent"
      })
    ], -1)
  ]));
}
const Soe = { render: Coe }, Aoe = {
  width: "31",
  height: "32",
  viewBox: "0 0 31 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-ftva-footer_yt"
};
function Eoe(t, e) {
  return h(), b("svg", Aoe, e[0] || (e[0] = [
    k("rect", {
      y: "0.625",
      width: "31",
      height: "31",
      rx: "15.5",
      fill: "#115DAF"
    }, null, -1),
    k("path", {
      d: "M14.05 18.3L17.8128 16.125L14.05 13.95V18.3ZM22.431 12.6232C22.5253 12.964 22.5905 13.4207 22.634 14.0007C22.6848 14.5807 22.7065 15.081 22.7065 15.516L22.75 16.125C22.75 17.7127 22.634 18.88 22.431 19.6267C22.2498 20.2792 21.8293 20.6997 21.1768 20.881C20.836 20.9752 20.2125 21.0405 19.2555 21.084C18.313 21.1347 17.4503 21.1565 16.6528 21.1565L15.5 21.2C12.4623 21.2 10.57 21.084 9.82325 20.881C9.17075 20.6997 8.75025 20.2792 8.569 19.6267C8.47475 19.286 8.4095 18.8292 8.366 18.2492C8.31525 17.6692 8.2935 17.169 8.2935 16.734L8.25 16.125C8.25 14.5372 8.366 13.37 8.569 12.6232C8.75025 11.9707 9.17075 11.5502 9.82325 11.369C10.164 11.2747 10.7875 11.2095 11.7445 11.166C12.687 11.1152 13.5498 11.0935 14.3473 11.0935L15.5 11.05C18.5378 11.05 20.43 11.166 21.1768 11.369C21.8293 11.5502 22.2498 11.9707 22.431 12.6232Z",
      fill: "white"
    }, null, -1)
  ]));
}
const Y0 = { render: Eoe }, Loe = {
  width: "31",
  height: "32",
  viewBox: "0 0 31 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-ftva-footer_ig"
};
function Doe(t, e) {
  return h(), b("svg", Loe, e[0] || (e[0] = [
    k("rect", {
      y: "0.625",
      width: "31",
      height: "31",
      rx: "15.5",
      fill: "#115DAF"
    }, null, -1),
    k("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M15.5 9.125C13.5989 9.125 13.3605 9.13306 12.6139 9.16712C11.8688 9.20111 11.36 9.31945 10.9147 9.4925C10.4544 9.67136 10.0641 9.91072 9.67487 10.2999C9.28572 10.689 9.04636 11.0794 8.8675 11.5397C8.69445 11.985 8.57611 12.4938 8.54213 13.2389C8.50806 13.9855 8.5 14.2239 8.5 16.125C8.5 18.0261 8.50806 18.2645 8.54213 19.0111C8.57611 19.7562 8.69445 20.265 8.8675 20.7103C9.04636 21.1706 9.28572 21.561 9.67487 21.9501C10.0641 22.3393 10.4544 22.5786 10.9147 22.7575C11.36 22.9305 11.8688 23.0489 12.6139 23.0829C13.3605 23.1169 13.5989 23.125 15.5 23.125C17.4011 23.125 17.6395 23.1169 18.3861 23.0829C19.1312 23.0489 19.64 22.9305 20.0853 22.7575C20.5456 22.5786 20.9359 22.3393 21.3251 21.9501C21.7143 21.561 21.9536 21.1706 22.1325 20.7103C22.3055 20.265 22.4239 19.7562 22.4579 19.0111C22.4919 18.2645 22.5 18.0261 22.5 16.125C22.5 14.2239 22.4919 13.9855 22.4579 13.2389C22.4239 12.4938 22.3055 11.985 22.1325 11.5397C21.9536 11.0794 21.7143 10.689 21.3251 10.2999C20.9359 9.91072 20.5456 9.67136 20.0853 9.4925C19.64 9.31945 19.1312 9.20111 18.3861 9.16712C17.6395 9.13306 17.4011 9.125 15.5 9.125ZM15.5 10.3863C17.3691 10.3863 17.5905 10.3934 18.3286 10.4271C19.0111 10.4582 19.3817 10.5722 19.6284 10.6681C19.9551 10.7951 20.1883 10.9468 20.4333 11.1917C20.6782 11.4367 20.8299 11.6699 20.9569 11.9966C21.0528 12.2433 21.1668 12.6139 21.1979 13.2964C21.2316 14.0345 21.2387 14.2559 21.2387 16.125C21.2387 17.9941 21.2316 18.2155 21.1979 18.9536C21.1668 19.6361 21.0528 20.0067 20.9569 20.2534C20.8299 20.5801 20.6782 20.8133 20.4333 21.0583C20.1883 21.3032 19.9551 21.4549 19.6284 21.5819C19.3817 21.6778 19.0111 21.7918 18.3286 21.8229C17.5906 21.8566 17.3692 21.8637 15.5 21.8637C13.6308 21.8637 13.4094 21.8566 12.6714 21.8229C11.9889 21.7918 11.6183 21.6778 11.3716 21.5819C11.0449 21.4549 10.8117 21.3032 10.5667 21.0583C10.3218 20.8133 10.1701 20.5801 10.0431 20.2534C9.94723 20.0067 9.8332 19.6361 9.80208 18.9536C9.7684 18.2155 9.76126 17.9941 9.76126 16.125C9.76126 14.2559 9.7684 14.0345 9.80208 13.2964C9.8332 12.6139 9.94723 12.2433 10.0431 11.9966C10.1701 11.6699 10.3218 11.4367 10.5667 11.1917C10.8117 10.9468 11.0449 10.7951 11.3716 10.6681C11.6183 10.5722 11.9889 10.4582 12.6714 10.4271C13.4095 10.3934 13.6309 10.3863 15.5 10.3863ZM15.5 12.5304C13.5148 12.5304 11.9054 14.1397 11.9054 16.125C11.9054 18.1103 13.5148 19.7196 15.5 19.7196C17.4853 19.7196 19.0946 18.1103 19.0946 16.125C19.0946 14.1397 17.4853 12.5304 15.5 12.5304ZM15.5 18.4583C14.2113 18.4583 13.1667 17.4137 13.1667 16.125C13.1667 14.8363 14.2113 13.7917 15.5 13.7917C16.7887 13.7917 17.8333 14.8363 17.8333 16.125C17.8333 17.4137 16.7887 18.4583 15.5 18.4583ZM20.0766 12.3884C20.0766 12.8523 19.7005 13.2284 19.2366 13.2284C18.7727 13.2284 18.3966 12.8523 18.3966 12.3884C18.3966 11.9245 18.7727 11.5484 19.2366 11.5484C19.7005 11.5484 20.0766 11.9245 20.0766 12.3884Z",
      fill: "white"
    }, null, -1)
  ]));
}
const Gb = { render: Doe }, Ioe = {
  width: "31",
  height: "32",
  viewBox: "0 0 31 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-ftva-footer_x"
};
function Moe(t, e) {
  return h(), b("svg", Ioe, e[0] || (e[0] = [
    k("rect", {
      y: "0.625",
      width: "31",
      height: "31",
      rx: "15.5",
      fill: "#115DAF"
    }, null, -1),
    k("path", {
      d: "M16.7101 15.1296L21.4455 9.625H20.3234L16.2116 14.4046L12.9275 9.625H9.13965L14.1058 16.8526L9.13965 22.625H10.2619L14.6041 17.5776L18.0723 22.625H21.8601L16.7098 15.1296H16.7101ZM15.173 16.9162L14.6698 16.1965L10.6662 10.4698H12.3899L15.6209 15.0915L16.124 15.8112L20.3239 21.8186H18.6002L15.173 16.9165V16.9162Z",
      fill: "white"
    }, null, -1)
  ]));
}
const Fc = { render: Moe }, Ooe = {
  width: "31",
  height: "32",
  viewBox: "0 0 31 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-ftva-footer_fb"
};
function Poe(t, e) {
  return h(), b("svg", Ooe, e[0] || (e[0] = [
    k("rect", {
      y: "0.625",
      width: "31",
      height: "31",
      rx: "15.5",
      fill: "#115DAF"
    }, null, -1),
    k("path", {
      d: "M16.6526 16.7389V23.125H13.9194V16.7389H11.6338V14.2501H13.9194V12.4147C13.9194 10.2848 15.3028 9.125 17.3235 9.125C18.2914 9.125 19.1234 9.19275 19.3658 9.22307V11.4491L17.9641 11.4496C16.8654 11.4496 16.6526 11.9407 16.6526 12.6612V14.2501H19.2735L18.9323 16.7389H16.6526Z",
      fill: "white"
    }, null, -1)
  ]));
}
const Xb = { render: Poe }, Boe = { class: "footer-links" }, Roe = {
  key: 0,
  href: "https://www.library.ucla.edu",
  target: "_blank",
  class: "logo-ucla"
}, Noe = { class: "socials" }, $oe = ["href", "target"], Foe = {
  key: 2,
  class: "press-links"
}, zoe = {
  key: 0,
  id: "mc-embedded-subscribe-form",
  action: "https://ucla.us17.list-manage.com/subscribe/post?u=cb3f880892df52211b236bdee&id=ce2bece15c&f_id=00edc2e1f0",
  method: "post",
  name: "mc-embedded-subscribe-form",
  class: "validate form",
  target: "_blank",
  novalidate: ""
}, Uoe = {
  id: "mc_embed_signup_scroll",
  class: "form-header"
}, Hoe = { class: "statement" }, Yoe = { class: "input-block" }, joe = {
  id: "mc-embedded-subscribe",
  class: "button-submit",
  name: "subscribe",
  type: "submit"
}, Voe = /* @__PURE__ */ Ce({
  __name: "FooterPrimary",
  props: {
    form: {
      type: Boolean,
      default: !0
    },
    isMicrosite: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    const e = t, n = {
      arrowRight: vi,
      caretRight: uu
    }, a = {
      youtube: Y0,
      Youtube: Y0,
      YouTube: Y0,
      // handle edge case
      instagram: Gb,
      Instagram: Gb,
      twitter: Fc,
      Twitter: Fc,
      x: Fc,
      X: Fc,
      // handle either X or Twitter
      facebook: Xb,
      Facebook: Xb
    }, i = qe(), r = I(() => ["footer-primary", (i == null ? void 0 : i.value) || ""]), s = I(() => e.form ? ["container"] : ["container no-form"]), o = I(() => (i == null ? void 0 : i.value) === "ftva" ? {
      statement: "Subscribe to receive the latest updates on what's happening at the Film & Television Archive.",
      label: "Submit",
      icon: n.caretRight,
      socialMediaIcons: !0
    } : {
      statement: "Subscribe to get the latest updates on what's happening with UCLA Library.",
      label: "Subscribe",
      icon: n.arrowRight,
      socialMediaIcons: !1
    }), l = io(), c = I(() => Object.keys(l.footerPrimary).length !== 0 ? l.footerPrimary.nodes[0].children : (console.log(
      // @ts-expect-error
      `Pinia state data not present: is it client side:${process.client}`
    ), [])), u = I(() => Object.keys(l.footerPrimary).length !== 0 ? l.footerPrimary.nodes[1].children : (console.log(
      // @ts-expect-error
      `Pinia state data not present: is it client side:${process.client}`
    ), [])), f = I(() => (i == null ? void 0 : i.value) === "ftva" ? woe : Zs);
    function m(_) {
      return u2(_);
    }
    return (_, T) => (h(), b("div", {
      class: re(r.value)
    }, [
      O(i) ? A("", !0) : (h(), G(O(Soe), {
        key: 0,
        class: "molecule-half-svg",
        "aria-hidden": "true"
      })),
      k("div", {
        class: re(s.value)
      }, [
        k("div", Boe, [
          t.isMicrosite ? (h(), b("a", Roe, [
            (h(), G(dt(f.value), { class: "logo-svg" })),
            T[0] || (T[0] = k("span", { class: "visually-hidden" }, "UCLA Library Home", -1))
          ])) : (h(), G(Xe, {
            key: 1,
            to: "/",
            class: "logo-ucla"
          }, {
            default: oe(() => [
              (h(), G(dt(f.value), { class: "logo-svg" })),
              T[1] || (T[1] = k("span", { class: "visually-hidden" }, "UCLA Library Home", -1))
            ]),
            _: 1
          })),
          k("ul", Noe, [
            (h(!0), b(he, null, Le(c.value, (g) => {
              var x;
              return h(), b("li", {
                key: g.id,
                class: "social-item"
              }, [
                k("a", {
                  href: g.to,
                  target: m(g.target)
                }, [
                  (x = o.value) != null && x.socialMediaIcons ? (h(), G(dt(a[g.name]), { key: 0 })) : (h(), b(he, { key: 1 }, [
                    ze(ne(g.name), 1)
                  ], 64))
                ], 8, $oe)
              ]);
            }), 128))
          ]),
          u.value ? (h(), b("ul", Foe, [
            (h(!0), b(he, null, Le(u.value, (g) => (h(), b("li", {
              key: g.id,
              class: "press-item"
            }, [
              Q(Xe, {
                to: g.to,
                "link-target": g.target
              }, {
                default: oe(() => [
                  ze(ne(g.name), 1)
                ]),
                _: 2
              }, 1032, ["to", "link-target"])
            ]))), 128))
          ])) : A("", !0)
        ]),
        t.form ? (h(), b("form", zoe, [
          k("div", Uoe, [
            T[2] || (T[2] = k("h2", { class: "title" }, " Stay updated ", -1)),
            k("p", Hoe, ne(o.value.statement), 1)
          ]),
          k("div", Yoe, [
            T[3] || (T[3] = ri('<div class="field mc-field-group" data-v-37462b31><input id="mce-EMAIL" name="EMAIL" type="email" value="" placeholder="email@ucla.edu" class="input-email" required data-v-37462b31><label for="mce-EMAIL" class="label" data-v-37462b31> Email Address </label></div><div id="mce-responses" class="clear" data-v-37462b31><div id="mce-error-response" class="response" style="display:none;" data-v-37462b31></div><div id="mce-success-response" class="response" style="display:none;" data-v-37462b31></div></div><div style="position:absolute;left:-5000px;" aria-hidden="true" data-v-37462b31><input type="text" name="b_31248d1f341b8eede1b46cb33_40fdd1db46" tabindex="-1" value="" data-v-37462b31></div>', 3)),
            k("button", joe, [
              ze(ne(o.value.label) + " ", 1),
              (h(), G(dt(o.value.icon), { class: "arrow-svg" }))
            ])
          ])
        ])) : A("", !0)
      ], 2)
    ], 2));
  }
}), qoe = /* @__PURE__ */ ge(Voe, [["__scopeId", "data-v-37462b31"]]), Woe = { class: "container" }, Goe = { class: "regents" }, Xoe = { class: "links" }, Zoe = {
  __name: "FooterSock",
  setup(t) {
    const e = io(), n = I(() => Object.keys(e.footerSock).length !== 0 ? e.footerSock.nodes : (console.log(
      `Pinia state data for footer sock not present if navigation is not setup for the website: is it client side:${process.client}`
    ), [])), a = qe(), i = I(() => ["footer-sock", (a == null ? void 0 : a.value) || ""]), r = I(() => (/* @__PURE__ */ new Date()).getFullYear());
    return (s, o) => (h(), b("div", {
      class: re(i.value)
    }, [
      k("div", Woe, [
        k("div", Goe, " © " + ne(r.value) + " Regents of the University of California ", 1),
        k("ul", Xoe, [
          (h(!0), b(he, null, Le(n.value, (l) => (h(), b("li", {
            key: l.id,
            class: "item"
          }, [
            Q(Xe, {
              class: "link",
              to: l.to,
              "link-target": l.target
            }, {
              default: oe(() => [
                ze(ne(l.name), 1)
              ]),
              _: 2
            }, 1032, ["to", "link-target"])
          ]))), 128))
        ])
      ])
    ], 2));
  }
}, Koe = /* @__PURE__ */ ge(Zoe, [["__scopeId", "data-v-b34d5314"]]), Qoe = { class: "link-wrapper" }, Joe = { class: "link-list-label" }, ele = /* @__PURE__ */ Ce({
  __name: "FooterLinks",
  setup(t) {
    const e = io(), n = I(() => Object.keys(e.footerLinks).length !== 0 ? e.footerLinks.nodes : (console.log(
      "Pinia state data for footer links not present"
    ), [])), a = qe(), i = I(() => ["footer-links", (a == null ? void 0 : a.value) || ""]);
    return (r, s) => (h(), b("div", {
      class: re(i.value)
    }, [
      k("div", Qoe, [
        (h(!0), b(he, null, Le(n.value, (o, l) => (h(), b("div", {
          key: o.category,
          class: "link-list"
        }, [
          k("h4", Joe, ne(o.category), 1),
          k("ul", null, [
            (h(!0), b(he, null, Le(n.value[l].children, (c) => (h(), b("li", {
              key: c.name,
              class: "link-item"
            }, [
              Q(Xe, {
                id: "banner-featured",
                to: c.to,
                class: "title title-linked"
              }, {
                default: oe(() => [
                  ze(ne(c.name), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]))), 128))
          ])
        ]))), 128))
      ])
    ], 2));
  }
}), tle = /* @__PURE__ */ ge(ele, [["__scopeId", "data-v-f4091c1e"]]), nle = /* @__PURE__ */ Ce({
  __name: "FooterMain",
  setup(t) {
    const e = qe(), n = I(() => ["footer-main", (e == null ? void 0 : e.value) || ""]), a = I(() => (e == null ? void 0 : e.value) === void 0), i = I(() => (e == null ? void 0 : e.value) !== void 0), r = I(() => (e == null ? void 0 : e.value) === "ftva");
    return (s, o) => (h(), b("footer", {
      class: re(n.value)
    }, [
      a.value ? (h(), G(voe, {
        key: 0,
        class: "sponsor"
      })) : A("", !0),
      Q(qoe, {
        form: r.value,
        class: "primary",
        "is-microsite": !0
      }, null, 8, ["form"]),
      i.value ? (h(), G(tle, {
        key: 1,
        class: "links"
      })) : A("", !0),
      Q(Koe, { class: "sock" })
    ], 2));
  }
}), $he = /* @__PURE__ */ ge(nle, [["__scopeId", "data-v-88d30df1"]]), ale = {
  __name: "HeadingArrow",
  props: {
    text: {
      type: String,
      default: ""
    },
    to: {
      type: String,
      default: ""
    },
    section: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = I(() => t.section || pa(t.to)), n = I(() => ["heading-arrow", `color-${e.value}`]), a = I(() => {
      let r = "div";
      return t.to && (r = Xe), r;
    }), i = I(() => ["heading", `color-${a.value}`]);
    return (r, s) => (h(), G(dt(a.value), {
      to: t.to,
      class: re(n.value)
    }, {
      default: oe(() => [
        Q(O(Bl), {
          class: "svg",
          "aria-hidden": "true"
        }),
        k("h2", {
          class: re(i.value)
        }, ne(t.text), 3)
      ]),
      _: 1
    }, 8, ["to", "class"]));
  }
}, Fhe = /* @__PURE__ */ ge(ale, [["__scopeId", "data-v-57471d15"]]), ile = {
  width: "17",
  height: "17",
  viewBox: "0 0 17 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-ftva-search"
};
function rle(t, e) {
  return h(), b("svg", ile, e[0] || (e[0] = [
    k("path", {
      d: "M12.1498 10.6918H11.3819L11.1098 10.4294C12.0952 9.28636 12.6369 7.82709 12.6358 6.3179C12.6358 5.06834 12.2653 3.84684 11.571 2.80786C10.8768 1.76889 9.89009 0.95911 8.73565 0.480924C7.58121 0.00273745 6.31089 -0.122378 5.08534 0.121399C3.85979 0.365177 2.73404 0.966898 1.85047 1.85047C0.966898 2.73404 0.365177 3.85979 0.121399 5.08534C-0.122378 6.31089 0.00273745 7.58121 0.480924 8.73565C0.95911 9.89009 1.76889 10.8768 2.80786 11.571C3.84684 12.2653 5.06834 12.6358 6.3179 12.6358C7.88279 12.6358 9.32133 12.0623 10.4294 11.1098L10.6918 11.3819V12.1498L15.5517 17L17 15.5517L12.1498 10.6918ZM6.3179 10.6918C3.89766 10.6918 1.94397 8.73814 1.94397 6.3179C1.94397 3.89766 3.89766 1.94397 6.3179 1.94397C8.73814 1.94397 10.6918 3.89766 10.6918 6.3179C10.6918 8.73814 8.73814 10.6918 6.3179 10.6918Z",
      fill: "#132941",
      class: "svg__fill--dark-navy"
    }, null, -1)
  ]));
}
const Yh = { render: rle }, sle = {
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-menu"
};
function ole(t, e) {
  return h(), b("svg", sle, e[0] || (e[0] = [
    k("path", {
      d: "M11 15.3376h26",
      stroke: "#0B6AB7",
      "stroke-width": "1.5",
      class: "svg__stroke--primary-blue-03"
    }, null, -1),
    k("path", {
      d: "M11 24.1147h26",
      stroke: "#0B6AB7",
      "stroke-width": "1.5",
      class: "svg__stroke--primary-blue-03"
    }, null, -1),
    k("path", {
      d: "M11 32.8921h26",
      stroke: "#0B6AB7",
      "stroke-width": "1.5",
      class: "svg__stroke--primary-blue-03"
    }, null, -1)
  ]));
}
const xT = { render: ole }, lle = {
  width: "23",
  height: "23",
  viewBox: "0 0 23 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-ftva-circle-x"
};
function cle(t, e) {
  return h(), b("svg", lle, e[0] || (e[0] = [
    k("rect", {
      width: "23",
      height: "23",
      rx: "11.5",
      fill: "#41648C"
    }, null, -1),
    k("path", {
      d: "M15.5753 16.4242L15.5753 16.4242C15.631 16.4799 15.6972 16.5241 15.77 16.5543C15.8429 16.5845 15.9209 16.6 15.9997 16.6C16.0786 16.6 16.1566 16.5845 16.2295 16.5543C16.3023 16.5241 16.3685 16.4799 16.4242 16.4242C16.4799 16.3685 16.5241 16.3023 16.5543 16.2295C16.5845 16.1566 16.6 16.0786 16.6 15.9997C16.6 15.9209 16.5845 15.8429 16.5543 15.77C16.5241 15.6972 16.4799 15.631 16.4242 15.5753L16.4242 15.5753L12.3483 11.5L16.4242 7.4247L16.4242 7.42469C16.5368 7.31212 16.6 7.15945 16.6 7.00025C16.6 6.84105 16.5368 6.68838 16.4242 6.57581L16.3537 6.64632L16.4242 6.57581C16.3116 6.46324 16.1589 6.4 15.9997 6.4C15.8406 6.4 15.6879 6.46324 15.5753 6.57581L15.5753 6.57581L11.5 10.6517L7.4247 6.57581L7.42469 6.57581C7.31212 6.46324 7.15945 6.4 7.00025 6.4C6.84105 6.4 6.68838 6.46324 6.57581 6.57581C6.46324 6.68838 6.4 6.84105 6.4 7.00025C6.4 7.15945 6.46324 7.31212 6.57581 7.42469L6.57581 7.4247L10.6517 11.5L6.57581 15.5753L6.57581 15.5753C6.46324 15.6879 6.4 15.8406 6.4 15.9997C6.4 16.1589 6.46324 16.3116 6.57581 16.4242C6.68838 16.5368 6.84105 16.6 7.00025 16.6C7.15945 16.6 7.31212 16.5368 7.42469 16.4242L7.4247 16.4242L11.5 12.3483L15.5753 16.4242Z",
      fill: "#F1F1F1",
      stroke: "#F1F1F1",
      "stroke-width": "0.2"
    }, null, -1)
  ]));
}
const ule = { render: cle }, dle = {
  width: "32",
  height: "33",
  viewBox: "0 0 32 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-caret-down"
};
function hle(t, e) {
  return h(), b("svg", dle, e[0] || (e[0] = [
    k("path", {
      d: "m10 14.729 6 6 6-6",
      stroke: "#0B6AB7",
      "stroke-width": "1.5",
      "stroke-linecap": "square",
      "stroke-linejoin": "round",
      class: "svg__stroke--primary-blue-03"
    }, null, -1)
  ]));
}
const Od = { render: hle }, fle = {
  name: "NavMenuItem",
  components: {
    SmartLink: Xe
  },
  props: {
    item: {
      type: Object,
      default: () => {
      }
    },
    isActive: {
      type: Boolean,
      default: !1
    },
    isOpened: {
      type: Boolean,
      default: !0
    }
  },
  setup() {
    return {
      theme: qe()
    };
  },
  computed: {
    classes() {
      return [
        this.item.classes,
        "nav-menu-item",
        { "is-active": this.isActive },
        { "is-opened": this.isOpened },
        this.theme || ""
      ];
    },
    parsedChildren() {
      return this.item.children.map((t) => ({
        ...t,
        classes: `sub-menu-link ${t.classes || ""}`
      }));
    }
  }
}, ple = ["innerHTML"], mle = { class: "sub-menu" };
function gle(t, e, n, a, i, r) {
  const s = lt("SmartLink");
  return h(), b("li", {
    class: re(r.classes)
  }, [
    k("button", {
      class: "section-name",
      innerHTML: n.item.name
    }, null, 8, ple),
    me(t.$slots, "default", {}, void 0, !0),
    k("ul", mle, [
      (h(!0), b(he, null, Le(r.parsedChildren, (o) => (h(), b("li", {
        key: o.id,
        class: "sub-menu-item"
      }, [
        Q(s, {
          class: re(o.classes),
          to: o.to,
          "link-target": o.target
        }, {
          default: oe(() => [
            ze(ne(o.name), 1)
          ]),
          _: 2
        }, 1032, ["class", "to", "link-target"])
      ]))), 128))
    ])
  ], 2);
}
const ble = /* @__PURE__ */ ge(fle, [["render", gle], ["__scopeId", "data-v-8f090b1f"]]), vle = {
  key: 0,
  class: "item-top"
}, yle = {
  key: 0,
  class: "title"
}, _le = { class: "full-title" }, Tle = {
  key: 0,
  class: "acronym"
}, xle = ["aria-label"], wle = {
  key: 0,
  class: "title"
}, kle = { class: "full-title" }, Cle = {
  key: 0,
  class: "acronym"
}, Sle = {
  key: 1,
  class: "item-top-mobile"
}, Ale = {
  key: 2,
  class: "more-menu"
}, Ele = { class: "chevron" }, Lle = {
  key: 1,
  class: "mobile-menu-slot"
}, Dle = {
  key: 3,
  class: "support-links"
}, Ile = /* @__PURE__ */ Ce({
  __name: "NavPrimary",
  props: {
    items: {
      type: Array,
      default: () => []
    },
    currentPath: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    acronym: {
      type: String,
      default: ""
    }
  },
  setup(t, { expose: e }) {
    const n = t, { items: a, currentPath: i, title: r, acronym: s } = Vh(n), o = K(a.value || []), l = K(i.value), c = K(r.value), u = K(s.value), f = Yn(), m = K(!1), _ = K(!1), T = K(!1), g = K(-1), x = qe(), S = I(() => [
      "nav-primary",
      { "is-opened": m.value || _.value },
      { "slot-is-opened": _.value },
      // sometimes we need to style different depending on which menu is open
      { "not-hovered": g.value === -1 },
      { "has-title": c.value },
      { "has-acronym": u.value },
      { "is-opened-mobile": T.value },
      (x == null ? void 0 : x.value) || ""
    ]), D = I(() => {
      switch (x == null ? void 0 : x.value) {
        case "ftva":
          return {
            renderItemTop: !1,
            showSearch: !0,
            horizontalMobileMenu: !0,
            headerText: "UCLA Film & Television Archive"
          };
        default:
          return {
            renderItemTop: !0,
            showSearch: !1,
            horizontalMobileMenu: !1
          };
      }
    }), L = I(() => c.value || u.value), M = I(() => c.value ? o.value.filter((ue) => !ue.children || !ue.children.length) : []), E = I(() => o.value.filter((ue) => !ue.children || !ue.children.length)), P = I(() => {
      const ue = l.value || (f == null ? void 0 : f.path);
      return o.value.findIndex((xe) => xe.url && ue.includes(xe.url));
    }), B = I(
      () => o.value.filter((ue) => ue.children && ue.children.length).map((ue, xe) => ({
        ...ue,
        isActive: xe === g.value
      }))
    );
    function z() {
      _.value && (_.value = !1), m.value = !m.value, m.value || (document.body.setAttribute("tabindex", "-1"), document.body.focus(), document.body.removeAttribute("tabindex"));
    }
    function W() {
      H(), m.value ? (m.value = !1, setTimeout(() => {
        _.value = !_.value;
      }, 400)) : _.value = !_.value;
    }
    function V(ue) {
      g.value = ue;
    }
    function H() {
      g.value = P.value;
    }
    function se() {
      _.value = !1;
    }
    e({ closeSlot: se });
    const { width: ie } = li(), Z = I(() => ie.value <= 750);
    function $() {
      _.value = !1, m.value = !1, T.value = !T.value;
    }
    function J(ue) {
      var xe;
      (xe = D.value) != null && xe.horizontalMobileMenu && Z.value === !0 ? ue === g.value ? H() : (H(), V(ue)) : z();
    }
    Qe(Z, (ue, xe) => {
      xe !== ue && (m.value = !1, _.value = !1, T.value = !1);
    });
    function N() {
      Z.value === !0 ? $() : W();
    }
    return st(() => {
      Qe(
        [a, i, r, s],
        ([ue, xe, De, He]) => {
          console.log("NavPrimary data updated from nuxt layout or app.vue when working with craft draft previews", ue, xe, De, He), o.value = ue || [], l.value = xe, c.value = De, u.value = He;
        },
        { deep: !0 }
      ), g.value = P.value;
    }), (ue, xe) => (h(), b("nav", {
      "aria-label": "Primary Navigation",
      class: re(S.value)
    }, [
      D.value.renderItemTop ? (h(), b("div", vle, [
        L.value ? (h(), G(Xe, {
          key: 0,
          to: "/",
          "aria-label": c.value ? "" : "UCLA Library home page"
        }, {
          default: oe(() => [
            c.value ? (h(), b("div", yle, [
              k("span", _le, ne(c.value), 1),
              u.value ? (h(), b("span", Tle, ne(u.value), 1)) : A("", !0)
            ])) : (h(), G(O(Zs), {
              key: 1,
              class: "svg logo-ucla",
              alt: "UCLA Library logo blue"
            }))
          ]),
          _: 1
        }, 8, ["aria-label"])) : (h(), b("a", {
          key: 1,
          href: "/",
          "aria-label": c.value ? "" : "UCLA Library home page"
        }, [
          c.value ? (h(), b("div", wle, [
            k("span", kle, ne(c.value), 1),
            u.value ? (h(), b("span", Cle, ne(u.value), 1)) : A("", !0)
          ])) : (h(), G(O(Zs), {
            key: 1,
            class: "svg logo-ucla",
            alt: "UCLA Library logo blue"
          }))
        ], 8, xle))
      ])) : Z.value && D.value.headerText ? (h(), b("div", Sle, ne(D.value.headerText), 1)) : A("", !0),
      xe[1] || (xe[1] = k("div", { class: "nav-background-fill" }, null, -1)),
      D.value.showSearch ? (h(), b("div", Ale, [
        T.value ? A("", !0) : (h(), G(sn, {
          key: 0,
          class: "search-button",
          "icon-name": "none",
          "aria-label": "Search",
          onClick: N
        }, {
          default: oe(() => [
            Q(O(Yh), { class: "icon-search" })
          ]),
          _: 1
        })),
        !T.value || !Z.value ? (h(), G(sn, {
          key: 1,
          class: "more-menu-button mobile-only",
          "icon-name": "none",
          "aria-label": "open menu",
          onClick: $
        }, {
          default: oe(() => [
            Q(O(xT), { class: "icon-menu" })
          ]),
          _: 1
        })) : A("", !0),
        T.value ? (h(), G(sn, {
          key: 2,
          class: "close-button mobile-only",
          "icon-name": "none",
          "aria-label": "close menu",
          onClick: $
        }, {
          default: oe(() => [
            Q(O(ule), { class: "icon-menu-close" })
          ]),
          _: 1
        })) : A("", !0),
        k("div", {
          class: re(["slot-container", [{ "is-opened": _.value, "is-opened-mobile": T.value }]])
        }, [
          me(ue.$slots, "additional-menu", { closeSlot: se }, void 0, !0)
        ], 2)
      ])) : A("", !0),
      k("ul", {
        class: re(["menu", [{ "is-opened-mobile": T.value }]])
      }, [
        (h(!0), b(he, null, Le(B.value, (De, He) => (h(), G(ble, {
          key: `NavMenuItem-${De.name}`,
          item: De,
          "is-active": De.isActive,
          "is-opened": m.value,
          onClick: () => J(He),
          onMouseover: (te) => Z.value ? "" : V(He),
          onMouseleave: xe[0] || (xe[0] = (te) => Z.value ? "" : H)
        }, {
          default: oe(() => [
            D.value.horizontalMobileMenu && Z.value ? (h(), b("span", {
              key: 0,
              class: re(["caret", { "is-active": De.isActive }])
            }, [
              k("span", Ele, [
                Q(O(Od), { class: "caret-down-svg" })
              ])
            ], 2)) : A("", !0)
          ]),
          _: 2
        }, 1032, ["item", "is-active", "is-opened", "onClick", "onMouseover"]))), 128)),
        (h(!0), b(he, null, Le(M.value, (De) => (h(), b("li", {
          key: `nav-primary-${De.name}`,
          class: "nochildren-links"
        }, [
          Q(Xe, {
            class: "nochildren-link underline-hover",
            to: De.to,
            "link-target": De.target
          }, {
            default: oe(() => [
              ze(ne(De.name), 1)
            ]),
            _: 2
          }, 1032, ["to", "link-target"])
        ]))), 128)),
        !Z.value && O(x) === "ftva" ? (h(), G(sn, {
          key: 0,
          class: "search-button",
          "icon-name": "none",
          "aria-label": "Search",
          onClick: N
        }, {
          default: oe(() => [
            Q(O(Yh), { class: "icon-search" })
          ]),
          _: 1
        })) : A("", !0),
        Z.value && T.value ? (h(), b("div", Lle, [
          me(ue.$slots, "additional-mobile-menu-items", {}, void 0, !0)
        ])) : A("", !0)
      ], 2),
      c.value ? A("", !0) : (h(), b("div", Dle, [
        (h(!0), b(he, null, Le(E.value, (De) => (h(), b("div", {
          key: `nav-primary-support-${De.name}`,
          class: "item-top"
        }, [
          Q(Xe, {
            class: "support-link underline-hover",
            to: De.to
          }, {
            default: oe(() => [
              ze(ne(De.name), 1)
            ]),
            _: 2
          }, 1032, ["to"])
        ]))), 128))
      ])),
      xe[2] || (xe[2] = k("div", { class: "background-white" }, null, -1)),
      m.value || _.value ? (h(), b("div", {
        key: 4,
        class: "background-blue",
        onClick: z
      })) : A("", !0),
      m.value ? (h(), b("div", {
        key: 5,
        class: "click-blocker",
        onClick: z
      })) : A("", !0)
    ], 2));
  }
}), wT = /* @__PURE__ */ ge(Ile, [["__scopeId", "data-v-280169a2"]]), Mle = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-search"
};
function kT(t, e) {
  return h(), b("svg", Mle, e[0] || (e[0] = [
    k("path", {
      d: "M20.9713 19.7959L20.441 19.2655L19.3802 20.3261L19.9105 20.8565L20.9713 19.7959ZM25.9486 26.8954L26.4789 27.4258L27.5397 26.3652L27.0094 25.8349L25.9486 26.8954ZM17.9233 22.9143C22.827 20.8303 25.1128 15.1656 23.0288 10.2619L21.6483 10.8486C23.4083 14.9899 21.4779 19.7738 17.3366 21.5338L17.9233 22.9143ZM23.0288 10.2619C20.9448 5.35815 15.2801 3.07234 10.3764 5.15637L10.9631 6.53687C15.1044 4.77687 19.8883 6.70728 21.6483 10.8486L23.0288 10.2619ZM10.3764 5.15637C5.47265 7.2404 3.18684 12.9051 5.27087 17.8088L6.65137 17.2221C4.89137 13.0808 6.82178 8.29688 10.9631 6.53687L10.3764 5.15637ZM5.27087 17.8088C7.3549 22.7125 13.0196 24.9983 17.9233 22.9143L17.3366 21.5338C13.1953 23.2938 8.41138 21.3634 6.65137 17.2221L5.27087 17.8088ZM19.9105 20.8565L25.9486 26.8954L27.0094 25.8349L20.9713 19.7959L19.9105 20.8565Z",
      fill: "#0B6AB7",
      class: "svg__fill--primary-blue-03"
    }, null, -1)
  ]));
}
const Fr = { render: kT }, Ole = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Fr,
  render: kT
}, Symbol.toStringTag, { value: "Module" })), Ple = /* @__PURE__ */ Object.assign({
  inheritAttrs: !0
}, {
  __name: "SearchInput",
  props: {
    type: {
      type: String,
      default: "search"
    },
    modelValue: {
      type: String,
      default: ""
    },
    wrapperClass: {
      type: String,
      default: "search-input-wrapper"
    },
    clearIcon: {
      type: Boolean,
      default: !0
    },
    clearOnEsc: {
      type: Boolean,
      default: !0
    },
    blurOnEsc: {
      type: Boolean,
      default: !0
    },
    selectOnFocus: {
      type: Boolean,
      default: !0
    },
    shortcutKey: {
      type: String,
      default: "/"
    }
  },
  emits: ["update:modelValue", "clear"],
  setup(t, { emit: e }) {
    const n = t, a = e, i = N4(), r = K(!1), s = K(null), o = K(n.modelValue);
    function l(x, S, D = !0) {
      const L = {};
      return S && S.length > 0 && Object.keys(x).forEach((M) => {
        (D ? !S.includes(M) : S.includes(M)) && (L[M] = x[M]);
      }), L;
    }
    const c = I(() => l(i, ["class", "style"])), u = I(() => {
      const x = l(i, ["class", "style"]);
      return x.class || (x.class = n.wrapperClass), x;
    }), f = I(() => n.clearIcon && o.value.length > 0);
    st(() => {
      window.document.addEventListener("keydown", g);
    }), Qe(
      () => n.modelValue,
      (x) => {
        o.value = x;
      },
      { immediate: !0 }
    ), $4(() => {
      window.document.removeEventListener("keydown", g);
    });
    function m() {
      o.value = "", a("update:modelValue", ""), a("clear");
    }
    function _(x) {
      o.value = x.target.value, a("update:modelValue", x.target.value);
    }
    function T(x) {
      if (x.key === "Escape" && (n.clearOnEsc && m(), n.blurOnEsc)) {
        const S = s.value;
        S && S.blur();
      }
    }
    function g(x) {
      if (x.key === n.shortcutKey && x.target !== s.value && window.document.activeElement !== s.value && !(x.target instanceof HTMLInputElement) && !(x.target instanceof HTMLSelectElement) && !(x.target instanceof HTMLTextAreaElement)) {
        x.preventDefault();
        const S = [].slice.call(
          document.querySelectorAll(
            '[data-search-input="true"]:not([data-shortcut-enabled="false"])'
          )
        ).filter((L) => !!(L.offsetWidth || L.offsetHeight || L.getClientRects().length)), D = S.length > 1 ? S[0] : s.value;
        D && (D.focus(), n.selectOnFocus && D.select());
      }
    }
    return (x, S) => (h(), b("div", cn(Un(u.value)), [
      Tt(k("input", $t({
        ref_key: "inputRef",
        ref: s,
        "onUpdate:modelValue": S[0] || (S[0] = (D) => o.value = D),
        type: "search",
        "data-search-input": "true"
      }, c.value, {
        onInput: _,
        onFocus: S[1] || (S[1] = (D) => r.value = !0),
        onBlur: S[2] || (S[2] = (D) => r.value = !1),
        onKeydown: T
      }), null, 16), [
        [Zo, o.value]
      ]),
      Tt(k("button", {
        class: "clear-icon clear",
        "aria-label": "Clear",
        onMousedown: m,
        onKeydown: Li(m, ["space", "enter"])
      }, null, 544), [
        [va, f.value]
      ])
    ], 16));
  }
}), Ql = /* @__PURE__ */ ge(Ple, [["__scopeId", "data-v-44423933"]]), Ble = { class: "search-dropdown" }, Rle = {
  key: 0,
  class: "search-box"
}, Nle = { class: "input-container" }, $le = /* @__PURE__ */ Ce({
  __name: "SearchMenuItem",
  setup(t) {
    const e = K(!1), n = K(null), a = Yn(), i = K(""), r = qe();
    Qe(() => a.query.q, (f) => {
      console.log("searchWords", f), a.path.includes("search-site") && f && (i.value = Array.isArray(f) ? f[0] || "" : f || "");
    }, { immediate: !0 });
    const s = I(() => {
      switch (r == null ? void 0 : r.value) {
        case "ftva":
          return {
            url: "/search",
            queryParam: "q",
            placeholder: "Enter keywords to search this website"
          };
        case "meap":
          return {
            url: "/search-site",
            queryParam: "q",
            placeholder: "Enter keywords to search this website"
          };
        default:
          return {
            url: "/search-site",
            queryParam: "q",
            placeholder: "Search the library website"
          };
      }
    });
    async function o() {
      var f;
      e.value = !e.value, e.value && (await kn(), (f = n.value) == null || f.focus());
    }
    function l() {
      e.value = !1;
    }
    const c = Qs();
    function u() {
      l(), c.push({
        path: s.value.url,
        query: { [s.value.queryParam]: i.value }
      });
    }
    return (f, m) => (h(), b("div", Ble, [
      k("button", {
        class: "search-trigger",
        role: "button",
        "aria-label": "Search",
        onClick: o
      }, [
        Q(O(Fr), { class: "icon-search" })
      ]),
      e.value ? (h(), b("div", Rle, [
        k("button", {
          class: "close-btn",
          "aria-label": "Close search",
          onClick: l
        }, [
          Q(O(er), { class: "svg-glyph-close" })
        ]),
        k("form", {
          class: "input-container-wrapper",
          name: "searchHome",
          onSubmit: m[1] || (m[1] = da(() => {
          }, ["prevent"]))
        }, [
          k("div", Nle, [
            Q(Ql, {
              modelValue: i.value,
              "onUpdate:modelValue": m[0] || (m[0] = (_) => i.value = _),
              class: "search-input",
              placeholder: s.value.placeholder,
              onClear: u,
              onKeyup: Li(u, ["enter"])
            }, null, 8, ["modelValue", "placeholder"]),
            k("button", {
              class: "button-submit",
              type: "submit",
              onClick: u
            }, [
              Q(O(Fr), { class: "icon" })
            ])
          ]),
          m[2] || (m[2] = k("div", { class: "divider" }, null, -1))
        ], 32)
      ])) : A("", !0)
    ]));
  }
}), Fle = /* @__PURE__ */ ge($le, [["__scopeId", "data-v-d4ed377f"]]), zle = {
  "aria-label": "Secondary Navigation",
  class: "nav-secondary"
}, Ule = {
  key: 0,
  href: "https://www.library.ucla.edu",
  target: "_blank",
  "aria-label": "UCLA Library home page"
}, Hle = { class: "navigation-list" }, Yle = {
  key: 0,
  class: "list"
}, jle = {
  key: 2,
  class: "link-list"
}, Vle = /* @__PURE__ */ Ce({
  __name: "NavSecondary",
  props: {
    items: {
      type: Array,
      default: () => []
    },
    isMicrosite: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    const e = t, n = qe(), a = I(() => {
      switch (n == null ? void 0 : n.value) {
        case "meap":
          return {
            showSearch: !1
          };
        default:
          return {
            showSearch: !0
          };
      }
    }), { items: i, isMicrosite: r } = Vh(e), s = K(i.value || []), o = K(r.value);
    st(() => {
      Qe(
        [i, r],
        ([m, _]) => {
          console.log("NavSecondary updated from nuxt layout or nuxt app.vue", m, _), s.value = m || [], o.value = _;
        },
        { deep: !0 }
      );
    });
    const l = I(() => [
      "flex-container",
      { "flex-container-not-microsite": !o.value },
      { "flex-container-microsite": o.value }
    ]), c = I(() => (s.value || []).map((m) => {
      let _ = "list-item";
      return m != null && m.classes && (_ = `${_} ${m == null ? void 0 : m.classes}`), {
        ...m,
        classes: _
      };
    })), u = I(() => {
      var m;
      return (m = c == null ? void 0 : c.value) == null ? void 0 : m.slice(0, -1);
    }), f = I(() => {
      var m;
      return c.value && c.value.length > 0 ? c == null ? void 0 : c.value[((m = c == null ? void 0 : c.value) == null ? void 0 : m.length) - 1] : null;
    });
    return (m, _) => {
      var T, g, x;
      return h(), b("nav", zle, [
        k("div", {
          class: re(l.value)
        }, [
          o.value ? (h(), b("a", Ule, [
            Q(O(Zs), {
              class: "svg logo-ucla",
              alt: "UCLA Library logo blue"
            })
          ])) : A("", !0),
          k("div", Hle, [
            o.value ? A("", !0) : (h(), b("ul", Yle, [
              (h(!0), b(he, null, Le(u.value, (S) => (h(), b("li", {
                key: `nav-secondary-${S.name}`,
                class: re(S.classes)
              }, [
                Q(Xe, {
                  class: "link underline-hover",
                  to: S.to,
                  "link-target": S.target
                }, {
                  default: oe(() => [
                    ze(ne(S.name), 1)
                  ]),
                  _: 2
                }, 1032, ["to", "link-target"])
              ], 2))), 128))
            ])),
            !o.value && f.value ? (h(), G(sn, {
              key: 1,
              label: (T = f.value) == null ? void 0 : T.name,
              class: "account-button",
              "link-target": (g = f.value) == null ? void 0 : g.target,
              to: (x = f.value) == null ? void 0 : x.to,
              "is-secondary": !0
            }, null, 8, ["label", "link-target", "to"])) : A("", !0),
            o.value ? (h(), b("ul", jle, [
              (h(!0), b(he, null, Le(c.value, (S) => (h(), b("li", {
                key: `nav-secondary-${S.name}`,
                class: re(S.classes)
              }, [
                Q(Xe, {
                  class: "link underline-hover",
                  to: S.to,
                  "link-target": S.target
                }, {
                  default: oe(() => [
                    ze(ne(S.name), 1)
                  ]),
                  _: 2
                }, 1032, ["to", "link-target"])
              ], 2))), 128))
            ])) : A("", !0),
            a.value.showSearch ? (h(), G(Fle, {
              key: 3,
              class: "search-dropdown"
            })) : A("", !0)
          ])
        ], 2)
      ]);
    };
  }
}), CT = /* @__PURE__ */ ge(Vle, [["__scopeId", "data-v-cc96851f"]]), qle = { class: "header-main" }, Wle = /* @__PURE__ */ Ce({
  __name: "HeaderMain",
  props: {
    primaryNav: {
      type: Array,
      default: () => []
    },
    secondaryNav: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = t, { primaryNav: n, secondaryNav: a, title: i } = Vh(e), r = K(n.value), s = K(a.value), o = K(i.value);
    st(() => {
      Qe(
        [n, a, i],
        ([c, u, f]) => {
          r.value = c, s.value = u, o.value = f;
        },
        { deep: !0 }
      );
    });
    const l = I(() => !!o.value);
    return (c, u) => (h(), b("header", qle, [
      Q(CT, {
        items: s.value,
        "is-microsite": l.value
      }, null, 8, ["items", "is-microsite"]),
      Q(wT, {
        class: "primary",
        items: r.value,
        title: o.value
      }, null, 8, ["items", "title"])
    ]));
  }
}), Zb = /* @__PURE__ */ ge(Wle, [["__scopeId", "data-v-af0335ca"]]), Gle = {
  width: "249",
  height: "247",
  viewBox: "0 0 249 247",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__molecule-3d"
};
function Xle(t, e) {
  return h(), b("svg", Gle, e[0] || (e[0] = [
    k("path", {
      d: "M124.566 245.393L209.606 211.206L209.746 210.881M124.566 245.393L37.1772 211.206M124.566 245.393L190.343 191.802M124.566 245.393L57.38 191.802M247.193 123.89L209.606 40.2692M247.193 123.89L209.746 210.881M247.193 123.89L124.566 57.3629M247.193 123.89L190.343 191.802M209.606 40.2692L124.566 0.999955M209.606 40.2692L124.566 57.3629M124.566 0.999955L37.1772 40.2692M124.566 0.999955V57.3629M37.1772 40.2692L1 123.89M37.1772 40.2692L124.566 57.3629M1 123.89L37.1772 211.206M1 123.89L57.38 191.802M1 123.89L124.566 57.3629M37.1772 211.206L57.38 191.802M57.38 191.802H190.343M57.38 191.802L124.566 57.3629M190.343 191.802L209.746 210.881M190.343 191.802L124.566 57.3629",
      stroke: "#0AA5FF",
      "stroke-width": "1.5",
      class: "svg__stroke--default-cyan-03"
    }, null, -1)
  ]));
}
const Zle = { render: Xle }, Kle = { class: "nav-menu-item" }, Qle = ["data-sub-menu-title-id"], Jle = ["data-sub-menu-item-id"], ece = {
  __name: "NavMenuItemResponsive",
  props: {
    item: {
      type: Object,
      default: () => {
      }
    },
    index: {
      type: Number,
      default: 0
    },
    goBack: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["shouldOpen", "itemOpenedColor", "closeMainMenu"],
  setup(t, { emit: e }) {
    const n = e, a = I(() => t.item.children.map((l) => ({
      ...l,
      classes: `sub-menu-link ${l.classes || ""}`
    })));
    function i(l) {
      const c = document.querySelectorAll(
        `[data-sub-menu-item-id="${l}"]`
      )[0], u = document.querySelectorAll(
        `ul:not([data-sub-menu-item-id="${l}"])`
      ), f = document.querySelectorAll(
        `li span:not([data-sub-menu-title-id="${l}"])`
      );
      if (c.classList.contains("block")) {
        c.classList.remove("block"), c.classList.add("hidden");
        for (const m of f)
          m.classList.add("block");
      } else {
        c.classList.remove("hidden"), c.classList.add("block");
        for (const m of f)
          m.classList.remove("block");
        for (const m of u)
          m.classList.remove("block"), m.classList.add("hidden");
      }
      n("shouldOpen"), n("itemOpenedColor", l);
    }
    function r() {
      const l = document.querySelectorAll(
        "[data-sub-menu-title-id]"
      );
      for (const u of l)
        u.classList.remove("hidden"), u.classList.add("block");
      const c = document.querySelectorAll(
        "[data-sub-menu-item-id]"
      );
      for (const u of c)
        u.classList.remove("block"), u.classList.add("hidden");
    }
    function s() {
      n("closeMainMenu");
    }
    const o = K(t.goBack);
    return Qe(o, (l) => {
      l && r();
    }), (l, c) => (h(), b("li", Kle, [
      k("button", {
        class: "section-name block",
        "data-sub-menu-title-id": t.index,
        onClick: c[0] || (c[0] = (u) => i(t.index))
      }, ne(t.item.name), 9, Qle),
      k("ul", {
        "data-sub-menu-item-id": t.index,
        class: "sub-menu hidden"
      }, [
        (h(!0), b(he, null, Le(a.value, (u) => (h(), b("li", {
          key: u.id,
          class: "sub-menu-item",
          onClick: s
        }, [
          Q(Xe, {
            class: re(u.classes),
            to: u.to,
            "link-target": u.target
          }, {
            default: oe(() => [
              ze(ne(u.name), 1)
            ]),
            _: 2
          }, 1032, ["class", "to", "link-target"])
        ]))), 128))
      ], 8, Jle)
    ]));
  }
}, tce = /* @__PURE__ */ ge(ece, [["__scopeId", "data-v-21e4b46f"]]), nce = { class: "collapsed-menu" }, ace = {
  key: 0,
  class: "title"
}, ice = { class: "full-title" }, rce = {
  key: 0,
  class: "acronym"
}, sce = { class: "more-menu" }, oce = ["is-opened"], lce = { class: "expanded-menu-container" }, cce = { class: "expanded-menu" }, uce = {
  key: 0,
  class: "title opened-title"
}, dce = { class: "full-title" }, hce = {
  key: 0,
  class: "acronym"
}, fce = { class: "search-box" }, pce = { class: "input-container" }, mce = { class: "nav-menu-primary" }, gce = {
  key: 0,
  class: "nav-menu-secondary"
}, bce = { class: "list" }, vce = {
  key: 1,
  class: "support-us-container"
}, yce = /* @__PURE__ */ Ce({
  __name: "HeaderMainResponsive",
  props: {
    primaryNav: {
      // This is an array of objects, with each object shaped like {name, url, items:[{text, to, target}]}
      type: Array,
      default: () => []
    },
    secondaryNav: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ""
    },
    acronym: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = t, n = K(!1), a = K(!1), i = K(!1), r = K("cyan"), s = I(() => [
      "header-main-responsive",
      n.value ? "fullHeight" : "collapsedHeight",
      { "has-title": e.title },
      { "has-acronym": e.acronym }
    ]), o = I(() => e.title ? e.title : "UCLA Library home page"), l = I(() => _T), c = I(() => e.primaryNav.filter((E) => E.children && E.children.length)), u = I(() => e.secondaryNav), f = I(() => e.title ? e.primaryNav.filter((E) => !E.children || !E.children.length) : []), m = I(() => e.primaryNav.filter((E) => !E.children || !E.children.length));
    function _() {
      a.value = !a.value, i.value = !1;
    }
    function T() {
      i.value = !i.value, r.value = "cyan", n.value = !1;
    }
    function g(E) {
      E === 0 ? r.value = "green" : E === 1 ? r.value = "pink" : E === 2 && (r.value = "purple"), a.value === !1 && (r.value = "cyan");
    }
    function x() {
      n.value = !n.value, i.value = !i.value;
    }
    const S = Yn(), D = K(Array.isArray(S.query.q) ? S.query.q[0] || "" : S.query.q || ""), L = Qs();
    function M() {
      x(), L.push({
        path: "/search-site",
        query: { q: D.value }
      });
    }
    return (E, P) => (h(), b("nav", {
      role: "navigation",
      "aria-label": "Menu",
      class: re(s.value)
    }, [
      Tt(k("div", nce, [
        Q(Xe, {
          class: "clickable-parent",
          to: "/",
          "aria-label": o.value
        }, {
          default: oe(() => [
            t.title ? (h(), b("div", ace, [
              k("span", ice, ne(t.title), 1),
              t.acronym ? (h(), b("span", rce, ne(t.acronym), 1)) : A("", !0)
            ])) : (h(), G(dt(O(Zs)), {
              key: 1,
              width: "155",
              height: "55",
              class: "logo-ucla",
              role: "button"
            }))
          ]),
          _: 1
        }, 8, ["aria-label"]),
        k("div", sce, [
          k("button", {
            class: "search-button",
            role: "button",
            "aria-label": "Search button",
            onClick: x
          }, [
            Q(O(Fr), { class: "icon-search" })
          ]),
          k("button", {
            role: "button",
            class: "open-menu",
            "aria-label": "Open menu",
            "is-opened": n.value,
            onClick: x
          }, [
            (h(), G(dt(O(xT)), { class: "hamburguer" }))
          ], 8, oce)
        ])
      ], 512), [
        [va, !n.value]
      ]),
      Tt(k("div", lce, [
        k("div", cce, [
          Q(Xe, {
            class: "clickable-parent",
            to: "/",
            "aria-label": o.value,
            onClick: x
          }, {
            default: oe(() => [
              t.title ? (h(), b("div", uce, [
                k("span", dce, ne(t.title), 1),
                t.acronym ? (h(), b("span", hce, ne(t.acronym), 1)) : A("", !0)
              ])) : (h(), G(dt(O(Zs)), {
                key: 1,
                width: "155",
                height: "55",
                class: "expanded-logo",
                onClick: x
              }))
            ]),
            _: 1
          }, 8, ["aria-label"]),
          k("button", {
            role: "button",
            class: "close-menu",
            "aria-label": "Close menu",
            onClick: T
          }, [
            (h(), G(dt(l.value), { class: "close-svg" }))
          ])
        ]),
        k("div", fce, [
          k("form", {
            class: "input-container-wrapper",
            name: "searchHome",
            onSubmit: P[1] || (P[1] = da(() => {
            }, ["prevent"]))
          }, [
            k("div", pce, [
              Q(Ql, {
                modelValue: D.value,
                "onUpdate:modelValue": P[0] || (P[0] = (B) => D.value = B),
                class: "search-input",
                onClear: M,
                onKeyup: Li(M, ["enter"])
              }, null, 8, ["modelValue"]),
              k("button", {
                class: "button-submit",
                type: "submit",
                onClick: M
              }, [
                Q(O(Fr), { class: "icon" })
              ])
            ]),
            P[2] || (P[2] = k("div", { class: "divider" }, null, -1))
          ], 32)
        ]),
        k("ul", mce, [
          (h(!0), b(he, null, Le(c.value, (B, z) => (h(), G(tce, {
            key: B.name,
            item: B,
            index: z,
            "go-back": i.value,
            onShouldOpen: _,
            onItemOpenedColor: g,
            onCloseMainMenu: x
          }, null, 8, ["item", "index", "go-back"]))), 128)),
          (h(!0), b(he, null, Le(f.value, (B) => (h(), b("li", {
            key: `nochildren-${B.name}`,
            class: "nochildren-links"
          }, [
            Q(Xe, {
              class: "nochildren-link",
              to: B.to
            }, {
              default: oe(() => [
                ze(ne(B.name), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          ]))), 128))
        ]),
        n.value && !t.title ? (h(), b("div", gce, [
          k("ul", bce, [
            (h(!0), b(he, null, Le(u.value, (B) => (h(), b("li", {
              key: B.name,
              class: "list-item",
              onClick: x
            }, [
              Q(Xe, {
                class: "link underline-hover",
                to: B.to,
                "link-target": B.target
              }, {
                default: oe(() => [
                  ze(ne(B.name), 1)
                ]),
                _: 2
              }, 1032, ["to", "link-target"])
            ]))), 128))
          ])
        ])) : A("", !0),
        t.title ? A("", !0) : (h(), b("div", vce, [
          m.value.length ? (h(), G(sn, {
            key: 0,
            label: m.value[0].name,
            "is-secondary": !0,
            class: "button",
            to: m.value[0].to,
            "icon-name": "none",
            onClick: x
          }, null, 8, ["label", "to"])) : A("", !0)
        ])),
        (h(), G(dt(O(Zle)), {
          width: "150",
          height: "247",
          viewBox: "50 57 50 250",
          class: re(["molecule", r.value])
        }, null, 8, ["class"]))
      ], 512), [
        [va, n.value]
      ])
    ], 2));
  }
}), _ce = /* @__PURE__ */ ge(yce, [["__scopeId", "data-v-d378de10"]]), Tce = {
  width: "58",
  height: "20",
  viewBox: "0 0 58 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__logo-ucla"
};
function xce(t, e) {
  return h(), b("svg", Tce, e[0] || (e[0] = [
    k("path", {
      d: "M0.257623 13.8849C0.205661 13.2382 0.192044 12.589 0.216843 11.9407L1.14233 1.4292H4.58441L3.64025 12.0326C3.43774 14.328 4.33765 15.964 6.62891 15.964C8.96994 15.964 10.2078 14.2997 10.4117 12.2634L11.3884 1.4292H14.8277L13.8773 12.128C13.493 16.2467 10.7601 19.3321 6.34346 19.3321C2.89793 19.3321 0.675786 17.1051 0.261078 13.8849",
      fill: "#FFFFFF",
      class: "svg__fill--white"
    }, null, -1),
    k("path", {
      d: "M15.6201 10.3247C16.0687 5.27905 19.4734 1.09604 25.3533 1.09604C26.9559 1.07317 28.5289 1.52845 29.8715 2.40375L29.4769 6.57156C28.9702 5.87772 28.2959 5.32363 27.517 4.96102C26.7381 4.59841 25.88 4.43912 25.0229 4.49802C21.3638 4.49802 19.3552 7.0388 19.0698 10.2562C18.7933 13.3887 20.4093 15.935 23.9537 15.935C24.8777 15.9394 25.7922 15.7491 26.6378 15.3764C27.4833 15.0038 28.2408 14.4572 28.861 13.7723L28.4761 18.0527C27.0162 18.8941 25.3655 19.3483 23.6806 19.3722C17.8616 19.3722 15.1971 15.0496 15.6153 10.3247",
      fill: "#FFFFFF",
      class: "svg__fill--white"
    }, null, -1),
    k("path", {
      d: "M32.6185 1.4292H36.0503L34.7971 15.7021H39.7149C40.0605 15.7021 41.2355 15.6841 41.5507 15.6654C41.5327 15.8375 41.2382 18.963 41.2382 18.963H31.062L32.6185 1.4292Z",
      fill: "#FFFFFF",
      class: "svg__fill--white"
    }, null, -1),
    k("path", {
      d: "M50.4943 7.97586C50.6016 7.73895 50.6865 7.4925 50.7479 7.23975C50.7663 7.23841 50.7848 7.23841 50.8032 7.23975C50.8238 7.49051 50.8678 7.7388 50.9345 7.98139C51.1212 8.78108 52.4551 13.2198 52.4551 13.2198H48.1263C48.1263 13.2198 50.448 8.09198 50.4943 7.97862V7.97586ZM51.3748 0.62793H51.1371L41.7405 18.9635H45.3871L46.708 16.1795H53.3274L54.1568 18.9608H57.7952L51.3748 0.62793Z",
      fill: "#FFFFFF",
      class: "svg__fill--white"
    }, null, -1)
  ]));
}
const wce = { render: xce }, kce = ["href", "target"], Cce = {
  key: 0,
  class: "ucla-text"
}, Sce = {
  key: 0,
  class: "button-container"
}, Ace = /* @__PURE__ */ Ce({
  __name: "SiteBrandBar",
  setup(t) {
    const e = qe(), n = I(() => ["site-brand-bar", (e == null ? void 0 : e.value) || ""]), a = I(() => (e == null ? void 0 : e.value) === "ftva" ? {
      useLogo: !1,
      headerText: "UCLA Film & Television Archive",
      buttonText: "Donate",
      buttonLink: "/donate",
      homepage: "/",
      homepageLinkTarget: "_self"
    } : {});
    return (i, r) => {
      var s;
      return h(), b("div", {
        class: re(n.value)
      }, [
        k("a", {
          href: a.value.homepage || "https://www.ucla.edu",
          target: a.value.homepageLinkTarget || "_blank"
        }, [
          !((s = a.value) != null && s.useLogo) && a.value.headerText ? (h(), b("span", Cce, ne(a.value.headerText), 1)) : (h(), G(O(wce), {
            key: 1,
            class: "svg ucla-logo"
          })),
          r[0] || (r[0] = k("span", { class: "visually-hidden" }, "UCLA Home", -1))
        ], 8, kce),
        a.value.buttonLink && a.value.buttonText ? (h(), b("span", Sce, [
          Q(sn, {
            label: a.value.buttonText,
            "icon-name": "none",
            to: a.value.buttonLink,
            class: "button"
          }, null, 8, ["label", "to"])
        ])) : A("", !0)
      ], 2);
    };
  }
}), Ece = /* @__PURE__ */ ge(Ace, [["__scopeId", "data-v-81c04cb1"]]), Lce = { class: "header-smart" }, Dce = {
  __name: "HeaderSmart",
  props: {
    title: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = io(), { header: n } = U4(e), a = K(n.value.primary || []), i = K(n.value.secondary || []), r = K(Lm(Zb)), s = K(!1);
    return st(() => {
      const { width: o } = li();
      Qe(
        o,
        (l) => {
          s.value = l <= 1200, r.value = Lm(s.value ? _ce : Zb);
        },
        { immediate: !0 }
      ), Qe(
        n,
        (l, c) => {
          a.value = l.primary, i.value = l.secondary;
        },
        { deep: !0 }
      );
    }), (o, l) => (h(), b("header", Lce, [
      Q(O(Ece), { class: "brand-bar" }),
      (h(), G(dt(r.value), {
        class: re(s.value ? "mobile-header" : "desktop-header"),
        "primary-nav": a.value,
        "secondary-nav": i.value,
        title: t.title
      }, null, 8, ["class", "primary-nav", "secondary-nav", "title"]))
    ]));
  }
}, zhe = /* @__PURE__ */ ge(Dce, [["__scopeId", "data-v-918b4522"]]), Ice = { class: "top-row" }, Mce = { class: "bottom-row" }, Oce = "Looking for a specific collection item? Search the UCLA Film & Television Archive Catalog at ", Pce = /* @__PURE__ */ Ce({
  __name: "NavSearch",
  props: {
    placeholder: {
      type: String,
      default: "Enter keywords to search this website"
    }
  },
  emits: ["search-complete"],
  setup(t, { emit: e }) {
    const n = e, a = qe(), i = Qs(), r = Yn(), s = {
      label: "UC LIBRARY SEARCH >",
      to: "https://search.library.ucla.edu/discovery/search?vid=01UCS_LAL:UCLA&mode=advanced"
    }, o = I(() => ["nav-search", (a == null ? void 0 : a.value) || ""]), l = K(
      Array.isArray(r.query.q) ? r.query.q[0] || "" : r.query.q || ""
    );
    function c() {
      i.push({
        path: "/search",
        query: { q: l.value }
      }), n("search-complete");
    }
    return (u, f) => (h(), b("div", {
      class: re(o.value)
    }, [
      k("span", Ice, [
        Q(O(Yh), { class: "icon" }),
        Q(Ql, {
          modelValue: l.value,
          "onUpdate:modelValue": f[0] || (f[0] = (m) => l.value = m),
          class: "search-input",
          placeholder: t.placeholder,
          onClear: c,
          onKeyup: Li(c, ["enter"])
        }, null, 8, ["modelValue", "placeholder"]),
        Q(sn, {
          label: "Search Site",
          "icon-name": "none",
          class: "button-link",
          onClick: c
        })
      ]),
      k("span", Mce, [
        ze(ne(Oce) + " "),
        Q(Xe, {
          id: "search-link",
          to: s.to,
          class: "bottom-link"
        }, {
          default: oe(() => [
            ze(ne(s.label), 1)
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ], 2));
  }
}), Bce = /* @__PURE__ */ ge(Pce, [["__scopeId", "data-v-18473e46"]]), Rce = /* @__PURE__ */ Ce({
  __name: "HeaderSticky",
  props: {
    primaryItems: {
      type: Array,
      default: () => []
    },
    secondaryItems: {
      type: Array,
      default: () => []
    }
  },
  setup(t) {
    const e = qe(), n = I(() => ["header-sticky", (e == null ? void 0 : e.value) || ""]), a = I(() => {
      switch (e == null ? void 0 : e.value) {
        case "ftva":
          return {
            showSearch: !0,
            showDonate: !0
          };
        default:
          return {
            showSearch: !1,
            showDonate: !1
          };
      }
    });
    return (i, r) => (h(), b("header", {
      class: re(n.value)
    }, [
      Q(wT, {
        items: t.primaryItems,
        class: "primary"
      }, an({
        "additional-menu": oe(({ closeSlot: s }) => [
          a.value.showSearch ? (h(), G(Bce, {
            key: 0,
            onSearchComplete: s
          }, null, 8, ["onSearchComplete"])) : A("", !0)
        ]),
        _: 2
      }, [
        a.value.showDonate ? {
          name: "additional-mobile-menu-items",
          fn: oe(() => [
            Q(sn, {
              label: "DONATE",
              "icon-name": "none",
              to: "/donate",
              class: "donate-button"
            })
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["items"]),
      t.secondaryItems.length !== 0 ? (h(), G(CT, {
        key: 0,
        items: t.secondaryItems,
        class: "secondary"
      }, null, 8, ["items"])) : A("", !0)
    ], 2));
  }
}), Uhe = /* @__PURE__ */ ge(Rce, [["__scopeId", "data-v-789ab791"]]), Nce = { class: "image-container" }, $ce = ["src", "alt"], Fce = ["src", "alt"], zce = { class: "image-labels" }, Uce = { class: "before-label slider-label" }, Hce = { class: "after-label slider-label" }, Yce = {
  class: "slider-button",
  "aria-hidden": "true"
}, jce = { class: "button-text" }, Vce = { class: "caption" }, qce = /* @__PURE__ */ Ce({
  __name: "ImageSlider",
  props: {
    beforeImage: {
      type: Object,
      required: !0
    },
    afterImage: {
      type: Object,
      required: !0
    }
  },
  setup(t) {
    const e = K(null), n = K(null), a = K(null);
    function i(r) {
      const s = r.target;
      e.value && n.value && a.value && e.value.style.setProperty("--position", `${s.value}%`);
    }
    return (r, s) => (h(), b(he, null, [
      k("div", {
        ref_key: "sliderContainer",
        ref: e,
        class: "image-slider"
      }, [
        k("div", Nce, [
          k("img", {
            class: "after-image slider-image",
            src: t.afterImage.src,
            alt: t.afterImage.alt
          }, null, 8, $ce),
          k("img", {
            ref_key: "beforeImageElement",
            ref: a,
            class: "before-image slider-image",
            src: t.beforeImage.src,
            alt: t.beforeImage.alt
          }, null, 8, Fce),
          k("div", zce, [
            k("span", Uce, [
              me(r.$slots, "beforeLabel", {}, () => [
                s[1] || (s[1] = ze("Before"))
              ], !0)
            ]),
            k("span", Hce, [
              me(r.$slots, "afterLabel", {}, () => [
                s[2] || (s[2] = ze("After"))
              ], !0)
            ])
          ])
        ]),
        k("input", {
          ref_key: "slider",
          ref: n,
          type: "range",
          min: "0",
          max: "100",
          value: "50",
          "aria-label": "Percentage of before photo shown",
          class: "slider",
          onInput: s[0] || (s[0] = (o) => i(o))
        }, null, 544),
        s[3] || (s[3] = k("div", {
          class: "slider-line",
          "aria-hidden": "true"
        }, null, -1)),
        k("div", Yce, [
          k("span", jce, [
            Q(O(rh), { class: "button-icon" }),
            Q(O(uu), { class: "button-icon" })
          ])
        ])
      ], 512),
      k("div", Vce, [
        me(r.$slots, "captionText", {}, void 0, !0)
      ])
    ], 64));
  }
}), Hhe = /* @__PURE__ */ ge(qce, [["__scopeId", "data-v-e85387f4"]]), Wce = { class: "rich-text" }, Gce = ["innerHTML"], Xce = ["innerHTML"], Zce = {
  key: 3,
  class: "image-block"
}, Kce = ["innerHTML"], Qce = ["innerHTML"], Jce = ["innerHTML"], eue = {
  key: 7,
  class: "image-block"
}, tue = ["innerHTML"], nue = ["innerHTML"], aue = ["innerHTML"], iue = ["innerHTML"], rue = {
  key: 12,
  class: "image-block"
}, sue = ["innerHTML"], oue = ["innerHTML"], j0 = 60, lue = /* @__PURE__ */ Ce({
  __name: "ImpactRichText",
  props: {
    images: {
      type: Array,
      default: () => []
    },
    pullQuote: {
      type: Array,
      default: () => []
    },
    textBlocks: {
      type: Array,
      default: () => []
    }
  },
  setup(t) {
    return (e, n) => (h(), b("div", Wce, [
      t.textBlocks[0] ? (h(), b("div", {
        key: 0,
        class: "text",
        innerHTML: t.textBlocks[0]
      }, null, 8, Gce)) : A("", !0),
      t.pullQuote[0] ? (h(), G(Wc, {
        key: 1,
        class: "pull-quote",
        text: t.pullQuote[0].text,
        attribution: t.pullQuote[0].attribution
      }, null, 8, ["text", "attribution"])) : A("", !0),
      t.textBlocks[1] ? (h(), b("div", {
        key: 2,
        class: "text",
        innerHTML: t.textBlocks[1]
      }, null, 8, Xce)) : A("", !0),
      t.images[0] ? (h(), b("div", Zce, [
        t.images[0] ? (h(), G(dn, {
          key: 0,
          class: "image",
          media: t.images[0],
          "aspect-ratio": j0
        }, null, 8, ["media"])) : A("", !0),
        t.images[0].caption ? (h(), b("div", {
          key: 1,
          class: "caption",
          innerHTML: t.images[0].caption
        }, null, 8, Kce)) : A("", !0)
      ])) : A("", !0),
      t.textBlocks[2] ? (h(), b("div", {
        key: 4,
        class: "text",
        innerHTML: t.textBlocks[2]
      }, null, 8, Qce)) : A("", !0),
      t.pullQuote[1] ? (h(), G(Wc, {
        key: 5,
        class: "pull-quote",
        text: t.pullQuote[1].text,
        attribution: t.pullQuote[1].attribution
      }, null, 8, ["text", "attribution"])) : A("", !0),
      t.textBlocks[3] ? (h(), b("div", {
        key: 6,
        class: "text",
        innerHTML: t.textBlocks[3]
      }, null, 8, Jce)) : A("", !0),
      t.images[1] ? (h(), b("div", eue, [
        t.images[1] ? (h(), G(dn, {
          key: 0,
          class: "image",
          media: t.images[1],
          "aspect-ratio": j0
        }, null, 8, ["media"])) : A("", !0),
        t.images[1].caption ? (h(), b("div", {
          key: 1,
          class: "caption",
          innerHTML: t.images[1].caption
        }, null, 8, tue)) : A("", !0)
      ])) : A("", !0),
      t.textBlocks[4] ? (h(), b("div", {
        key: 8,
        class: "text",
        innerHTML: t.textBlocks[4]
      }, null, 8, nue)) : A("", !0),
      t.textBlocks[5] ? (h(), b("div", {
        key: 9,
        class: "text",
        innerHTML: t.textBlocks[5]
      }, null, 8, aue)) : A("", !0),
      t.pullQuote[2] ? (h(), G(Wc, {
        key: 10,
        class: "pull-quote",
        text: t.pullQuote[2].text,
        attribution: t.pullQuote[2].attribution
      }, null, 8, ["text", "attribution"])) : A("", !0),
      t.textBlocks[6] ? (h(), b("div", {
        key: 11,
        class: "text",
        innerHTML: t.textBlocks[6]
      }, null, 8, iue)) : A("", !0),
      t.images[2] ? (h(), b("div", rue, [
        t.images[2] ? (h(), G(dn, {
          key: 0,
          class: "image",
          media: t.images[2],
          "aspect-ratio": j0
        }, null, 8, ["media"])) : A("", !0),
        t.images[2].caption ? (h(), b("div", {
          key: 1,
          class: "caption",
          innerHTML: t.images[2].caption
        }, null, 8, sue)) : A("", !0)
      ])) : A("", !0),
      t.textBlocks[7] ? (h(), b("div", {
        key: 13,
        class: "text",
        innerHTML: t.textBlocks[7]
      }, null, 8, oue)) : A("", !0)
    ]));
  }
}), Yhe = /* @__PURE__ */ ge(lue, [["__scopeId", "data-v-684a366f"]]), cue = { class: "search-home" }, uue = {
  key: 0,
  class: "tabs"
}, due = ["onClick", "textContent"], hue = { class: "box" }, fue = ["action"], pue = { class: "input-container" }, mue = {
  key: 0,
  class: "links"
}, gue = {
  key: 0,
  class: "regular-links"
}, bue = {
  key: 1,
  class: "advanced-links"
}, vue = /* @__PURE__ */ Ce({
  __name: "SearchHome",
  props: {
    linkItems: {
      type: Array,
      default: () => []
    },
    advancedSearchLink: {
      type: Object,
      default: () => {
      }
    }
  },
  setup(t) {
    const e = [
      {
        title: "Site Search",
        actionURL: "/search-site",
        queryParam: "q",
        placeholder: "Search the library website"
      },
      {
        title: "UC Library Search",
        actionURL: "https://search.library.ucla.edu/discovery/search?vid=01UCS_LAL:UCLA&tab=Articles_books_more_slot&search_scope=ArticlesBooksMore&lang=en&query=any,contains,",
        placeholder: "Search articles, books and more"
      }
    ], n = Qs(), a = K(null), i = K(""), r = K(1), s = I(() => e.map((T, g) => {
      let x = "tab";
      return g === r.value && (x = "tab is-active"), {
        ...T,
        classes: x
      };
    })), o = I(() => r.value === 0), l = I(() => e[r.value].actionURL), c = I(() => e[r.value].placeholder), u = I(() => e[r.value].queryParam), f = I(() => i.value.split(" ").join("+"));
    function m() {
      o.value ? n.push({
        path: l.value,
        query: { [u.value]: i.value }
      }) : window.location.href = `${l.value}${f.value}`;
    }
    function _(T) {
      r.value = T;
    }
    return (T, g) => (h(), b("div", cue, [
      s.value.length ? (h(), b("div", uue, [
        (h(!0), b(he, null, Le(s.value, (x, S) => (h(), b("button", {
          key: x.title,
          ref_for: !0,
          ref_key: "searchtab",
          ref: a,
          class: re(x.classes),
          onClick: (D) => _(S),
          textContent: ne(x.title)
        }, null, 10, due))), 128))
      ])) : A("", !0),
      k("div", hue, [
        k("form", {
          name: "searchHome",
          action: l.value,
          onSubmit: g[1] || (g[1] = da(() => {
          }, ["prevent"]))
        }, [
          k("div", pue, [
            Q(Ql, {
              "model-value": i.value,
              "onUpdate:modelValue": g[0] || (g[0] = (x) => i.value = x),
              class: "search-input",
              placeholder: c.value,
              onKeyup: Li(m, ["enter"])
            }, null, 8, ["model-value", "placeholder"]),
            k("button", {
              class: "button-submit",
              onClick: m
            }, [
              Q(O(Fr), { class: "icon" })
            ])
          ])
        ], 40, fue),
        g[2] || (g[2] = k("div", { class: "divider" }, null, -1)),
        t.linkItems.length || t.advancedSearchLink ? (h(), b("nav", mue, [
          t.linkItems.length ? (h(), b("div", gue, [
            (h(!0), b(he, null, Le(t.linkItems, (x) => (h(), G(Xe, {
              key: x.url,
              class: "link",
              to: x.url,
              textContent: ne(x.text)
            }, null, 8, ["to", "textContent"]))), 128))
          ])) : A("", !0),
          t.advancedSearchLink ? (h(), b("div", bue, [
            Q(Xe, {
              to: t.advancedSearchLink.url,
              textContent: ne(t.advancedSearchLink.text)
            }, null, 8, ["to", "textContent"])
          ])) : A("", !0)
        ])) : A("", !0)
      ])
    ]));
  }
}), yue = /* @__PURE__ */ ge(vue, [["__scopeId", "data-v-5a386882"]]), _ue = { class: "masthead-primary" }, Tue = { class: "container" }, xue = { class: "logo" }, wue = /* @__PURE__ */ Ce({
  __name: "MastheadPrimary",
  props: {
    linkItems: {
      type: Array,
      default: () => []
    },
    advancedSearchLink: {
      type: Object,
      default: () => {
      }
    }
  },
  setup(t) {
    const e = ve(
      () => import("./logo-ucla-library-underline-CA5hKDhK.js")
    );
    return (n, a) => (h(), b("div", _ue, [
      k("div", Tue, [
        k("div", xue, [
          Q(O(e), { class: "svg" })
        ]),
        Q(yue, {
          "link-items": t.linkItems,
          "advanced-search-link": t.advancedSearchLink
        }, null, 8, ["link-items", "advanced-search-link"])
      ])
    ]));
  }
}), jhe = /* @__PURE__ */ ge(wue, [["__scopeId", "data-v-b63430f9"]]);
var kue = Ry, Cue = sd, Sue = Sf, Aue = rr, Eue = Ef, Lue = Af, Due = rd, Iue = Oy, Mue = "[object Map]", Oue = "[object Set]", Pue = Object.prototype, Bue = Pue.hasOwnProperty;
function Rue(t) {
  if (t == null)
    return !0;
  if (Eue(t) && (Aue(t) || typeof t == "string" || typeof t.splice == "function" || Lue(t) || Iue(t) || Sue(t)))
    return !t.length;
  var e = Cue(t);
  if (e == Mue || e == Oue)
    return !t.size;
  if (Due(t))
    return !kue(t).length;
  for (var n in t)
    if (Bue.call(t, n))
      return !1;
  return !0;
}
var Nue = Rue;
const $ue = /* @__PURE__ */ ka(Nue), Fue = { class: "container" }, zue = { class: "meta" }, Uue = ["innerHTML"], Hue = /* @__PURE__ */ Ce({
  __name: "MastheadSecondary",
  props: {
    hasMolecules: {
      type: Boolean,
      default: !0
    },
    title: {
      type: String,
      required: !0
    },
    text: {
      type: String,
      default: ""
    },
    theme: {
      type: String,
      default: ""
    },
    heroImage: {
      type: Object,
      default: () => {
      }
    }
  },
  setup(t) {
    const e = t, n = K(null), a = I(() => n.value !== null), i = I(() => !$ue(e.heroImage)), r = I(() => [
      "masthead-secondary",
      {
        "has-molecule": e.hasMolecules && !i.value
      },
      {
        "has-slot": a.value
      },
      {
        "theme-meap": e.theme.toLowerCase() === "meap"
      }
    ]);
    return (s, o) => (h(), b("div", {
      class: re(r.value)
    }, [
      i.value ? (h(), G(dn, {
        key: 0,
        class: "hero-image",
        media: t.heroImage
      }, null, 8, ["media"])) : A("", !0),
      k("div", Fue, [
        k("div", zue, [
          k("h1", {
            class: "title",
            innerHTML: t.title
          }, null, 8, Uue),
          t.text ? (h(), G(un, {
            key: 0,
            class: "text",
            "rich-text-content": t.text
          }, null, 8, ["rich-text-content"])) : A("", !0)
        ])
      ])
    ], 2));
  }
}), Vhe = /* @__PURE__ */ ge(Hue, [["__scopeId", "data-v-80b8e2a7"]]), Yue = ["textContent"], jue = ["textContent"], Vue = ["textContent"], que = ["textContent"], Wue = /* @__PURE__ */ Ce({
  __name: "NavBreadcrumb",
  props: {
    to: {
      type: String,
      default: ""
    },
    parentTitle: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    overrideTitleGroup: {
      type: Array,
      default: () => []
      // Array of objects:
      // { titleLevel: number, updatedTitle: string }
    }
  },
  setup(t) {
    const e = Yn(), n = K(!1), a = K(!1), i = K(!1), r = K(), s = K(!1);
    st(() => {
      const { width: x } = li();
      Qe(x, (S) => {
        a.value = S <= 1200;
      }, { immediate: !0 });
    });
    const o = I(() => {
      let x = e.path;
      x.indexOf("/") === 0 && (x = x.slice(1)), x.lastIndexOf("/") === x.length - 1 && (x = x.slice(0, x.length - 1));
      const S = decodeURI(x);
      return _(S).split("/");
    }), l = I(() => {
      const x = o.value;
      return x.length > 4 && !n.value && f(), a.value ? c(x).slice(-2).splice(0, 1) : c(x);
    });
    function c(x) {
      const S = [];
      return t.to && t.parentTitle && t.title ? (S.push({
        to: t.to,
        title: t.parentTitle,
        isLastItem: !1,
        isTruncated: !1
      }), S.push({
        to: "",
        title: t.title,
        isLastItem: !0,
        isTruncated: !1
      }), S) : (x.forEach((D, L) => {
        const M = D.length, E = e.path.indexOf(D), P = e.path.substring(0, M + E), B = /-/gi;
        let z = D.replace(B, " ");
        if (t.overrideTitleGroup.length > 0) {
          const H = L + 1, se = t.overrideTitleGroup.find((ie) => ie.titleLevel === H);
          se && (z = se.updatedTitle || z);
        }
        let W;
        L === x.length - 1 ? W = !0 : W = !1;
        let V = !1;
        x.length > 4 && i.value && (n.value === !1 && L === 1 ? V = !0 : V = !1), S.push({
          to: P,
          title: z,
          isTruncated: V,
          isLastItem: W
        });
      }), i.value ? [
        S[0],
        {
          title: "...",
          isTruncated: !0,
          isLastItem: !1
        },
        ...S.slice(-2)
      ] : S);
    }
    function u() {
      s.value = !0;
    }
    function f() {
      i.value = !0;
    }
    function m() {
      n.value = !0, i.value = !1, r.value[0].classList.remove("collapsed-url");
    }
    function _(x) {
      const S = /([0-9][0-9])-([0-9][0-9])-([0-9][0-9])(?!.\w)/;
      return S.test(x) ? x.replace(S, "").trim() : x;
    }
    const T = qe(), g = I(() => ["nav-breadcrumb", "subtitle", (T == null ? void 0 : T.value) || ""]);
    return (x, S) => (h(), b("div", {
      class: re(g.value),
      "aria-label": "breadcrumbs"
    }, [
      k("ol", null, [
        (h(!0), b(he, null, Le(l.value, (D) => (h(), b("li", {
          key: D.title,
          class: "breadcrumb-wrapper"
        }, [
          !D.isLastItem && !D.isTruncated ? (h(), G(Xe, {
            key: 0,
            to: D.to,
            class: "parent-page-url",
            onClick: S[0] || (S[0] = (L) => u()),
            textContent: ne(D.title)
          }, null, 8, ["to", "textContent"])) : !D.isLastItem && D.isTruncated ? (h(), b("button", {
            key: 1,
            ref_for: !0,
            ref_key: "collapsedBreadcrumbsBtn",
            ref: r,
            class: "parent-page-url collapsed-url",
            tabindex: "0",
            onClick: S[1] || (S[1] = (L) => m()),
            textContent: ne(D.title)
          }, null, 8, Yue)) : A("", !0),
          D.isLastItem && s.value ? (h(), b("span", {
            key: 2,
            class: "parent-page-url",
            textContent: ne(D.title)
          }, null, 8, jue)) : D.isLastItem && t.title ? (h(), b("span", {
            key: 3,
            class: "current-page-title",
            "aria-current": "page",
            textContent: ne(t.title)
          }, null, 8, Vue)) : D.isLastItem ? (h(), b("span", {
            key: 4,
            class: "current-page-title",
            "aria-current": "page",
            textContent: ne(D.title)
          }, null, 8, que)) : A("", !0)
        ]))), 128))
      ])
    ], 2));
  }
}), qhe = /* @__PURE__ */ ge(Wue, [["__scopeId", "data-v-7c81ed18"]]), Gue = { class: "page-anchor-content" }, Xue = { class: "chevron" }, Zue = {
  key: 0,
  class: "dropdown-menu page-anchor-list"
}, Kue = ["href"], Que = ["href"], Jue = /* @__PURE__ */ Ce({
  __name: "PageAnchor",
  props: {
    sectionTitles: {
      type: Array,
      required: !0
    },
    color: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = Yn(), n = K(!1), a = K(window.innerWidth), i = I(() => t.color || pa(e == null ? void 0 : e.path)), r = I(() => ["link", `color-${i.value}`]), s = I(() => t.sectionTitles.map((f) => f.replace("&", "").replace(/\s+/g, " ").trim().toLowerCase().replace(/ /g, "-"))), o = I(() => a.value > 1024);
    function l() {
      n.value = !n.value;
    }
    const c = qe(), u = I(() => ["page-anchor", (c == null ? void 0 : c.value) || ""]);
    return (f, m) => (h(), b("div", {
      class: re(u.value)
    }, [
      k("div", Gue, [
        k("button", {
          class: "dropdown-button",
          onClick: l
        }, [
          m[0] || (m[0] = ze(" On this page ")),
          k("span", {
            class: re(["caret", { "is-active": n.value }])
          }, [
            k("span", Xue, [
              Q(O(Od), { class: "caret-down-svg" })
            ])
          ], 2)
        ]),
        n.value && o.value ? (h(), b("ul", Zue, [
          (h(!0), b(he, null, Le(t.sectionTitles, (_, T) => (h(), b("li", {
            key: `${_}-${T}`,
            class: re(r.value)
          }, [
            k("a", {
              href: `#${s.value[T]}`
            }, ne(_), 9, Kue)
          ], 2))), 128)),
          k("li", {
            class: re(r.value)
          }, m[1] || (m[1] = [
            k("a", { href: "#" }, "Back to Top", -1)
          ]), 2)
        ])) : A("", !0),
        n.value && !o.value ? (h(), b("ul", {
          key: 1,
          class: "dropdown-menu page-anchor-list",
          onClick: l
        }, [
          (h(!0), b(he, null, Le(t.sectionTitles, (_, T) => (h(), b("li", {
            key: `${_}-${T}`,
            class: re(r.value)
          }, [
            k("a", {
              href: `#${s.value[T]}`
            }, ne(_), 9, Que)
          ], 2))), 128)),
          k("li", {
            class: re(r.value)
          }, m[2] || (m[2] = [
            k("a", { href: "#" }, "Back to Top", -1)
          ]), 2)
        ])) : A("", !0)
      ])
    ], 2));
  }
}), Whe = /* @__PURE__ */ ge(Jue, [["__scopeId", "data-v-74d033ab"]]), ede = /* @__PURE__ */ Ce({
  __name: "ScrollWrapper",
  props: {
    // display a single card in the carousel at a time instead of a continuous list of cards
    singleItem: {
      type: Boolean,
      default: !1
    },
    // used only for singleItem mode
    initialSlide: {
      type: Number,
      default: 1
    }
  },
  setup(t) {
    const e = Di(), n = K(0), a = K(1), i = qe(), r = I(() => ["scroll-wrapper", (i == null ? void 0 : i.value) || ""]);
    return st(() => {
      if (e && t.singleItem) {
        const s = Object.keys(e).length;
        s > 0 && (n.value = s);
      }
      a.value = t.initialSlide - 1;
    }), (s, o) => {
      const l = lt("v-card"), c = lt("v-window-item"), u = lt("v-window"), f = lt("v-slide-group-item"), m = lt("v-slide-group"), _ = lt("v-sheet");
      return h(), b("div", {
        class: re(r.value)
      }, [
        t.singleItem ? (h(), G(u, {
          key: 0,
          modelValue: a.value,
          "onUpdate:modelValue": o[0] || (o[0] = (T) => a.value = T),
          class: "v-window-container",
          "show-arrows": ""
        }, {
          default: oe(() => [
            (h(!0), b(he, null, Le(n.value, (T) => (h(), G(c, {
              key: `card-${T}`
            }, {
              default: oe(() => [
                Q(l, {
                  class: "padded-card",
                  elevation: "2"
                }, {
                  default: oe(() => [
                    me(s.$slots, `item-${T}`, {}, void 0, !0)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024))), 128))
          ]),
          _: 3
        }, 8, ["modelValue"])) : (h(), G(_, {
          key: 1,
          class: "mx-auto"
        }, {
          default: oe(() => [
            Q(m, { "show-arrows": !0 }, {
              default: oe(() => [
                Q(f, null, {
                  default: oe(() => [
                    me(s.$slots, "default", {}, void 0, !0)
                  ]),
                  _: 3
                })
              ]),
              _: 3
            })
          ]),
          _: 3
        }))
      ], 2);
    };
  }
}), tde = /* @__PURE__ */ ge(ede, [["__scopeId", "data-v-d9f480d2"]]), nde = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: tde
}, Symbol.toStringTag, { value: "Module" })), ade = { class: "single-checkbox" }, ide = {
  __name: "SingleCheckbox",
  props: {
    label: String,
    selected: Boolean
  },
  emits: ["update:selected", "input-selected"],
  setup(t, { emit: e }) {
    const n = t, a = e, i = K(n.selected);
    Qe(() => n.selected, (o) => {
      i.value = o;
    });
    const r = I(() => ["label", i.value ? "checked" : ""]);
    function s() {
      a("update:selected", i.value), a("input-selected");
    }
    return (o, l) => (h(), b("div", ade, [
      k("label", {
        class: re(r.value)
      }, [
        ze(ne(t.label) + " ", 1),
        Tt(k("input", {
          "onUpdate:modelValue": l[0] || (l[0] = (c) => i.value = c),
          type: "checkbox",
          class: "input",
          onChange: s
        }, null, 544), [
          [jh, i.value]
        ]),
        Q(O(w2), { class: "svg" })
      ], 2)
    ]));
  }
}, rde = /* @__PURE__ */ ge(ide, [["__scopeId", "data-v-32fe410c"]]), sde = { class: "search-generic-filter-buttons" }, ode = ["onClick"], lde = { class: "title" }, cde = { class: "chevron" }, ude = /* @__PURE__ */ Ce({
  __name: "SearchGenericFilterButtons",
  props: {
    items: {
      type: Array,
      default: () => []
    },
    singleCheckboxState: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["toggle", "update:single-checkbox-state", "single-checkbox-checked"],
  setup(t, { emit: e }) {
    const n = t, a = e, i = K(n.singleCheckboxState);
    Qe(() => n.singleCheckboxState, (f) => {
      i.value = f;
    });
    const r = I(() => {
      const f = n.items.find((m) => m.inputType === "single-checkbox");
      return f ? f.label : "";
    }), s = I(() => {
      const f = n.items.find((m) => m.inputType === "single-checkbox");
      return f ? f.esFieldName : "";
    }), o = I(() => {
      var f;
      return (f = n.items) == null ? void 0 : f.some((m) => m.inputType === "single-checkbox");
    });
    function l() {
      a("update:single-checkbox-state", i.value), a("single-checkbox-checked", s.value);
    }
    const c = I(() => n.items.map((f) => {
      if (f.inputType !== "single-checkbox") {
        const m = `button${f.isVisible ? " is-active" : ""}`;
        return {
          ...f,
          class: m
        };
      } else
        return null;
    }).filter((f) => f != null));
    function u(f) {
      a("toggle", f);
    }
    return (f, m) => (h(), b("div", sde, [
      (h(!0), b(he, null, Le(c.value, (_, T) => (h(), b("button", {
        key: _ == null ? void 0 : _.label,
        class: re(_ == null ? void 0 : _.class),
        type: "button",
        onClick: da((g) => u(T), ["prevent"])
      }, [
        k("span", lde, ne(_ == null ? void 0 : _.label), 1),
        k("div", cde, [
          Q(O(Od), { class: "caret-down-svg" })
        ])
      ], 10, ode))), 128)),
      o.value ? (h(), G(rde, {
        key: 0,
        selected: i.value,
        "onUpdate:selected": m[0] || (m[0] = (_) => i.value = _),
        label: r.value,
        onInputSelected: l
      }, null, 8, ["selected", "label"])) : A("", !0)
    ]));
  }
}), dde = /* @__PURE__ */ ge(ude, [["__scopeId", "data-v-98a6c18b"]]), hde = { class: "section-remove-search-filter" }, fde = /* @__PURE__ */ Ce({
  __name: "SectionRemoveSearchFilter",
  props: {
    filters: {
      type: Object,
      default: () => {
      }
    }
  },
  emits: ["update:filters", "remove-selected"],
  setup(t, { emit: e }) {
    const n = e, a = qe(), i = K({});
    Qe(() => t.filters, (l) => {
      (l == null || Object.keys(l).length === 0) && (i.value = {}), Object.entries(l).forEach(([c, u]) => {
        i.value[c] = u;
      });
    }, { deep: !0, immediate: !0 });
    const r = I(() => Object.entries(i.value).flatMap(([c, u]) => (Array.isArray(u) ? u : []).map((m) => ({ name: c, value: m }))));
    function s(l) {
      return l === "subjectLibrarian.keyword" ? "Subject Librarian" : "Past Events";
    }
    function o(l, c) {
      i.value[l] = i.value[l].filter((u) => u !== c), n("update:filters", i.value), n("remove-selected");
    }
    return (l, c) => Tt((h(), b("div", hde, [
      (h(!0), b(he, null, Le(r.value, (u) => (h(), b("div", {
        key: `filter-${u.value}`
      }, [
        Q(GI, {
          "is-selected": O(a) === "ftva",
          title: u.value === "yes" ? s(u.name) : u.value,
          onRemoveBlockFilter: (f) => o(
            u.name,
            u.value
          )
        }, null, 8, ["is-selected", "title", "onRemoveBlockFilter"])
      ]))), 128))
    ], 512)), [
      [va, i.value]
    ]);
  }
}), pde = /* @__PURE__ */ ge(fde, [["__scopeId", "data-v-f50fb70b"]]), mde = {
  key: 0,
  class: "container"
}, gde = /* @__PURE__ */ Ce({
  __name: "SearchGenericFilters",
  props: {
    filters: {
      type: Array,
      // array of objects that contain the filter objects
      default: () => []
    },
    queryFilters: {
      type: Object,
      // objects that contain the selected query filter from url [{name, value}]
      default: () => {
      }
    }
  },
  emits: ["update:queryFilters", "filters-selection-action"],
  setup(t, { emit: e }) {
    const n = t, a = e, i = K({});
    function r(T, g) {
      console.log("Search Generic Filters updateSelected: ", T, JSON.stringify(g)), i.value[T] = g;
    }
    const s = K(n.filters.some((T) => {
      var g;
      return T.inputType === "single-checkbox" && ((g = n.queryFilters[T.esFieldName]) == null ? void 0 : g.includes("yes"));
    })), o = K(-1);
    Qe(() => n.queryFilters, (T) => {
      console.log("In watch function props.queryFilters updated", JSON.stringify(T), JSON.stringify(n.filters)), (T == null || Object.keys(T).length === 0) && (i.value = {}), Object.entries(T).forEach(([g, x]) => {
        i.value[g] = x;
      }), console.log("queryFilterButtonDropDownStates.value", JSON.stringify(i.value)), console.log("In watch function props.queryFilters checkedState.value", s.value, JSON.stringify(n.filters));
    }, { deep: !0, immediate: !0 }), Qe(() => n.filters, (T) => {
      console.log("In watch function props.filters updated", JSON.stringify(n.filters), JSON.stringify(T)), console.log("In watch funciton props.filters heello query filters props.queryFilters", n.queryFilters), console.log("In watch fucntion props.filters queryFilterButtonDropDownStates", i.value), s.value = T == null ? void 0 : T.some((g) => {
        var x;
        return g.inputType === "single-checkbox" && ((x = i.value[g.esFieldName]) == null ? void 0 : x.includes("yes"));
      });
    }, { deep: !0, immediate: !0 });
    const l = I(() => n.filters.map((T, g) => {
      let x = Um;
      switch (T.inputType) {
        case "radio":
          x = QS;
          break;
        case "checkbox":
          x = Um;
          break;
      }
      return {
        ...T,
        componentName: x,
        isVisible: g === o.value
      };
    }));
    function c(T) {
      o.value = o.value === T ? -1 : T;
    }
    function u(T) {
      console.log("emit event to parent if checkbox is selected"), i.value[T] = s.value ? ["yes"] : [], a("update:queryFilters", i.value), a("filters-selection-action");
    }
    function f(T) {
      i.value = { ...T }, console.log("Updated Filters:", i.value);
    }
    function m() {
      console.log("doSearch function called to emit update:queryFilters and filters-selection-action events to the parent component", i.value), a("update:queryFilters", i.value), a("filters-selection-action");
    }
    Qe(i, () => {
      console.log("Update checked state"), s.value = n.filters.some((T) => {
        var g;
        return T.inputType === "single-checkbox" && ((g = i.value[T.esFieldName]) == null ? void 0 : g.includes("yes"));
      });
    });
    const _ = K(null);
    return OB(
      _,
      () => {
        o.value = -1;
      }
    ), (T, g) => (h(), b("div", {
      ref_key: "clickOutsideTarget",
      ref: _,
      class: "search-generic-filters"
    }, [
      t.filters.length > 0 ? (h(), b("div", mde, [
        Q(dde, {
          "single-checkbox-state": s.value,
          "onUpdate:singleCheckboxState": g[0] || (g[0] = (x) => s.value = x),
          items: l.value,
          class: "search-generic-filter-buttons",
          onToggle: c,
          onSingleCheckboxChecked: u
        }, null, 8, ["single-checkbox-state", "items"])
      ])) : A("", !0),
      (h(!0), b(he, null, Le(l.value, (x) => (h(), b("div", {
        key: x.esFieldName
      }, [
        Q(zr, {
          name: "slide-toggle",
          mode: "out-in"
        }, {
          default: oe(() => [
            x.isVisible ? (h(), G(dt(x.componentName), {
              key: 0,
              selected: i.value[x.esFieldName],
              "onUpdate:selected": [(S) => i.value[x.esFieldName] = S, (S) => r(x.esFieldName, S)],
              items: x.items,
              class: "filter-group",
              onInputSelected: m
            }, null, 40, ["selected", "onUpdate:selected", "items"])) : A("", !0)
          ]),
          _: 2
        }, 1024)
      ]))), 128)),
      Q(pde, {
        filters: i.value,
        class: "section-remove-container",
        "onUpdate:filters": f,
        onRemoveSelected: m
      }, null, 8, ["filters"])
    ], 512));
  }
}), bde = /* @__PURE__ */ ge(gde, [["__scopeId", "data-v-463ecc7c"]]), vde = { class: "search-generic" }, yde = { class: "input-container" }, _de = /* @__PURE__ */ Ce({
  __name: "SearchGeneric",
  props: {
    filters: {
      type: Array,
      // array of objects that contain the filter objects
      default: () => []
    },
    /* searchType: {
      type: String,
      default: '',
    }, */
    /* views: {
        type: Array,
        default: () => [],
    }, */
    searchGenericQuery: {
      type: Object,
      default: () => {
      }
    },
    placeholder: {
      type: String,
      default: ""
    }
    /* queryView: {
        type: String,
        default: "list",
    }, */
  },
  emits: ["search-ready"],
  setup(t, { emit: e }) {
    const n = e, a = Yn(), i = K(Array.isArray(a.query.q) ? a.query.q[0] || "" : a.query.q || ""), r = K(t.searchGenericQuery ? t.searchGenericQuery.queryFilters : {});
    st(() => {
      i.value = t.searchGenericQuery.queryText;
    }), Qe(() => t.searchGenericQuery, (l) => {
      r.value = l.queryFilters, i.value = l.queryText;
    }, { deep: !0, immediate: !0 }), Qe(() => a.query, () => {
      t.searchGenericQuery.queryText === a.query.q && (i.value = a.query.q);
    }, { deep: !0, immediate: !0 });
    function s(l) {
      console.log("In updateQueryFilters", l), r.value = l;
    }
    function o() {
      console.log("dosearch called"), console.log(
        `selected filters in component are: ${JSON.stringify(r.value)}`
      ), console.log(
        `search text in component are: ${JSON.stringify(i.value)}`
      ), n("search-ready", {
        filters: r.value,
        text: i.value
      });
    }
    return (l, c) => (h(), b("div", vde, [
      k("form", {
        name: "searchHome",
        onSubmit: c[1] || (c[1] = da(() => {
        }, ["prevent"]))
      }, [
        k("div", yde, [
          Q(Ql, {
            modelValue: i.value,
            "onUpdate:modelValue": c[0] || (c[0] = (u) => i.value = u),
            class: "search-input",
            placeholder: t.placeholder,
            onClear: o,
            onKeyup: Li(o, ["enter"])
          }, null, 8, ["modelValue", "placeholder"]),
          k("button", {
            class: "button-submit",
            type: "submit",
            onClick: o
          }, [
            Q(O(Fr), { class: "icon" })
          ])
        ])
      ], 32),
      c[2] || (c[2] = k("div", { class: "search-generic-filters-container" }, null, -1)),
      Q(bde, {
        filters: t.filters,
        "query-filters": r.value,
        "onUpdate:queryFilters": s,
        onFiltersSelectionAction: o
      }, null, 8, ["filters", "query-filters"])
    ]));
  }
}), Ghe = /* @__PURE__ */ ge(_de, [["__scopeId", "data-v-a2c640b5"]]), Tde = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-calendar"
};
function ST(t, e) {
  return h(), b("svg", Tde, e[0] || (e[0] = [
    k("path", {
      d: "M26.9902 25.9316C26.9902 26.2589 26.7248 26.5243 26.3975 26.5243C19.4626 26.5243 12.5277 26.5243 5.59274 26.5243C5.26538 26.5243 5 26.2589 5 25.9316V12.9113V8.26828C5 7.94092 5.26538 7.67554 5.59274 7.67554H26.3975C26.7248 7.67554 26.9902 7.94092 26.9902 8.26828V12.9113V25.9316Z",
      stroke: "#0B6AB7",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      class: "svg__stroke--primary-blue-03"
    }, null, -1),
    k("path", {
      d: "M11.8063 10.283L11.8063 4.00004",
      stroke: "#0B6AB7",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      class: "svg__stroke--primary-blue-03"
    }, null, -1),
    k("path", {
      d: "M20.1835 10.283L20.1835 4.00004",
      stroke: "#0B6AB7",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      class: "svg__stroke--primary-blue-03"
    }, null, -1),
    k("path", {
      d: "M7.8147 13.9585H15.9953H24.1759",
      stroke: "#0AA5FF",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      class: "svg__stroke--default-cyan-03"
    }, null, -1)
  ]));
}
const AT = { render: ST }, Bp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: AT,
  render: ST
}, Symbol.toStringTag, { value: "Module" })), xde = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-card"
};
function ET(t, e) {
  return h(), b("svg", xde, e[0] || (e[0] = [
    ri('<rect x="7.22302" y="7" width="7.0895" height="7.0737" rx="0.389099" stroke="#0B6AB7" stroke-width="1.5" class="svg__stroke--primary-blue-03"></rect><rect x="17.9305" y="7" width="7.0895" height="7.0737" rx="0.389099" stroke="#0B6AB7" stroke-width="1.5" class="svg__stroke--primary-blue-03"></rect><rect x="7.22302" y="17.6917" width="7.0895" height="7.0737" rx="0.389099" stroke="#0B6AB7" stroke-width="1.5" class="svg__stroke--primary-blue-03"></rect><rect x="17.9305" y="17.6917" width="7.0895" height="7.0737" rx="0.389099" stroke="#0B6AB7" stroke-width="1.5" class="svg__stroke--primary-blue-03"></rect><path d="M28 19.7427L28 24.7652" stroke="#0AA5FF" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" class="svg__stroke--default-cyan-03"></path><path d="M4 7L4 12.0225" stroke="#0AA5FF" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" class="svg__stroke--default-cyan-03"></path>', 6)
  ]));
}
const LT = { render: ET }, wde = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: LT,
  render: ET
}, Symbol.toStringTag, { value: "Module" })), kde = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-list"
};
function DT(t, e) {
  return h(), b("svg", kde, e[0] || (e[0] = [
    ri('<rect x="6" y="8" width="2.99937" height="2.99269" rx="0.371905" stroke="#0AA5FF" stroke-width="1.25" class="svg__stroke--default-cyan-03"></rect><path d="M12.4575 9.49634H26.2901" stroke="#0B6AB7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="svg__stroke--primary-blue-03"></path><rect x="6" y="14.4509" width="2.99937" height="2.99269" rx="0.371905" stroke="#0AA5FF" stroke-width="1.25"></rect><path d="M12.4575 15.9473H26.2901" stroke="#0B6AB7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="svg__stroke--primary-blue-03"></path><rect x="6" y="20.9016" width="2.99937" height="2.99269" rx="0.371905" stroke="#0AA5FF" stroke-width="1.25" class="svg__stroke--default-cyan-03"></rect><path d="M12.4575 22.3979H26.2901" stroke="#0B6AB7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="svg__stroke--primary-blue-03"></path>', 6)
  ]));
}
const IT = { render: DT }, MT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: IT,
  render: DT
}, Symbol.toStringTag, { value: "Module" })), Cde = { class: "view-btn" }, Sde = { class: "selected" }, Ade = { key: 0 }, Ede = { class: "chevron" }, Lde = { class: "view-list" }, Dde = ["onClick"], Ide = ["innerHTML"], Mde = {
  __name: "SearchGenericViewModes",
  props: {
    isOpened: {
      type: Boolean,
      default: !1
    },
    items: {
      type: Array,
      default: () => []
    },
    selected: {
      type: String,
      default: ""
    }
  },
  emits: ["update:isOpened", "update:selected", "view-changed"],
  setup(t, { emit: e }) {
    const n = t, a = e, i = K(n.isOpened), r = I(() => ["search-generic-view-modes", { "is-opened": i.value }]), s = I(() => n.items.find((m) => m.slug === n.selected) || {}), o = I(() => n.items.map((m) => {
      let _ = "list-item";
      return m.slug === n.selected && (_ += " is-active"), { ...m, classes: _ };
    })), l = /* @__PURE__ */ new Map([
      ["icon-calendar", AT],
      ["icon-list", IT],
      ["icon-card", LT]
    ]);
    function c(m) {
      return l.get(m);
    }
    function u() {
      i.value = !i.value, a("update:isOpened", i.value);
    }
    function f(m) {
      a("update:selected", m), a("view-changed", m);
    }
    return (m, _) => (h(), b("div", {
      class: re(r.value),
      onClick: u
    }, [
      k("button", Cde, [
        k("div", Sde, [
          t.selected ? A("", !0) : (h(), b("span", Ade, "View")),
          (h(), G(dt(c(s.value.iconName)), { class: "svg" }))
        ]),
        k("div", Ede, [
          Q(O(Od), { class: "svg" })
        ])
      ]),
      k("ul", Lde, [
        (h(!0), b(he, null, Le(o.value, (T) => (h(), b("li", {
          key: T.slug,
          class: re(T.classes),
          onClick: da((g) => f(T.slug), ["stop"])
        }, [
          (h(), G(dt(c(T.iconName)), { class: "svg" })),
          k("div", {
            innerHTML: T.title
          }, null, 8, Ide)
        ], 10, Dde))), 128))
      ])
    ], 2));
  }
}, Xhe = /* @__PURE__ */ ge(Mde, [["__scopeId", "data-v-cf30205d"]]), Ode = { class: "search-result-item" }, Pde = ["textContent"], Bde = {
  key: 0,
  class: "summary"
}, Rde = {
  __name: "SearchResult",
  props: {
    to: {
      type: String,
      default: ""
    },
    category: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    summary: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = I(() => t.summary ? wi(t.summary, 250) : "");
    return (n, a) => (h(), b("li", Ode, [
      me(n.$slots, "top", {}, () => [
        k("div", {
          class: "category",
          textContent: ne(t.category)
        }, null, 8, Pde),
        Q(Xe, {
          class: "title",
          to: t.to,
          innerHTML: t.title
        }, null, 8, ["to", "innerHTML"])
      ], !0),
      n.$slots.mid ? me(n.$slots, "mid", { key: 0 }, void 0, !0) : A("", !0),
      me(n.$slots, "bottom", {}, () => [
        t.summary ? (h(), b("div", Bde, ne(e.value), 1)) : A("", !0)
      ], !0)
    ]));
  }
}, Zhe = /* @__PURE__ */ ge(Rde, [["__scopeId", "data-v-a274858c"]]), Nde = { class: "section-dual-masonry" }, $de = { class: "masonry" }, Fde = /* @__PURE__ */ Ce({
  __name: "SectionDualMasonry",
  props: {
    items: {
      type: Array,
      default: () => []
    },
    to: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: "See More"
    }
  },
  setup(t) {
    return (e, n) => (h(), b("section", Nde, [
      k("div", $de, [
        (h(!0), b(he, null, Le(t.items, (a) => (h(), G(HD, {
          key: a.to,
          title: a.title,
          category: a.category,
          "start-date": a.startDate,
          "end-date": a.endDate,
          prompt: a.prompt,
          to: a.to,
          "section-handle": a.sectionHandle,
          class: "brick"
        }, null, 8, ["title", "category", "start-date", "end-date", "prompt", "to", "section-handle"]))), 128)),
        (h(!0), b(he, null, Le(t.items, (a) => (h(), G(Xe, {
          key: `image-${a.to}`,
          to: a.to,
          class: "brick brick-image"
        }, {
          default: oe(() => [
            Q(dn, {
              media: a.image,
              "aspect-ratio": 100
            }, null, 8, ["media"])
          ]),
          _: 2
        }, 1032, ["to"]))), 128))
      ]),
      Q(Xe, {
        class: "more",
        to: t.to
      }, {
        default: oe(() => [
          Q(kv, { text: t.text }, null, 8, ["text"])
        ]),
        _: 1
      }, 8, ["to"])
    ]));
  }
}), Khe = /* @__PURE__ */ ge(Fde, [["__scopeId", "data-v-5544244d"]]), zde = { class: "section-block-generic-list" }, Ude = { class: "block-generic-list" }, Hde = /* @__PURE__ */ Ce({
  __name: "SectionGenericList",
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  setup(t) {
    return (e, n) => (h(), b("section", zde, [
      k("ul", Ude, [
        (h(!0), b(he, null, Le(t.items, (a, i) => (h(), G(aI, {
          key: `${a.title}-${i}`,
          "section-title": "Academic Librarian Jobs",
          title: a.title,
          "alternative-full-name": a.alternativeFullName,
          language: a.language,
          text: a.summary,
          "job-requisition-number": a.jobRequisitionNumber,
          "job-posting-u-r-l": a.jobPostingURL,
          departments: a.department,
          "pay-rate": a.payRate,
          "associated-locations": a.associatedLocations
        }, null, 8, ["title", "alternative-full-name", "language", "text", "job-requisition-number", "job-posting-u-r-l", "departments", "pay-rate", "associated-locations"]))), 128))
      ])
    ]));
  }
}), Qhe = /* @__PURE__ */ ge(Hde, [["__scopeId", "data-v-b0a0dcc0"]]), Yde = { class: "section-location-list" }, jde = /* @__PURE__ */ Ce({
  __name: "SectionLocationList",
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  setup(t) {
    return (e, n) => (h(), b("ul", Yde, [
      (h(!0), b(he, null, Le(t.items, (a) => (h(), G(kI, {
        key: a.to,
        image: a.image,
        "location-type": a.locationType,
        title: a.title,
        to: a.to,
        "affiliate-library-url": a.affiliateLibraryUrl,
        address: a.address,
        "address-link": a.addressLink,
        amenities: a.amenities,
        "reserve-seat": a.reserveSeat,
        "is-ucla-library": a.isUclaLibrary,
        "libcal-location-id-for-hours": a.libcalLocationIdForHours,
        class: "block-location-list-item"
      }, null, 8, ["image", "location-type", "title", "to", "affiliate-library-url", "address", "address-link", "amenities", "reserve-seat", "is-ucla-library", "libcal-location-id-for-hours"]))), 128))
    ]));
  }
}), Jhe = /* @__PURE__ */ ge(jde, [["__scopeId", "data-v-bacb8491"]]), Vde = { class: "previous-wrapper" }, qde = { class: "pagination-wrapper" }, Wde = {
  key: 0,
  class: "pagination-numbers-container"
}, Gde = { class: "pagination-numbers" }, Xde = { class: "page-list-first" }, Zde = {
  key: 0,
  class: "page-list-truncate"
}, Kde = {
  key: 1,
  class: "page-list-truncate"
}, Qde = {
  key: 2,
  class: "page-list-last"
}, Jde = { class: "next-wrapper" }, e0e = /* @__PURE__ */ Ce({
  __name: "SectionPagination",
  props: {
    nextTo: {
      type: String,
      required: !1
    },
    previousTo: {
      type: String,
      required: !1
    },
    pages: {
      type: Number,
      required: !1
    },
    initialCurrentPage: {
      type: Number,
      required: !1
    },
    // Callback function to generate link for each page
    // If not provided, will generate a link based on FTVA Elastic Search pattern
    generateLinkCallback: {
      type: Function,
      required: !1
    },
    // Flag to generate a fixed amount of numbered buttons in the pagination container; when false, page numbers are generated dynamically
    fixedPageWidthMode: {
      type: Boolean,
      default: !1,
      required: !1
    },
    // Number of fixed page buttons to generate
    fixedPageWidthNum: {
      type: Number,
      default: 10,
      required: !1
    }
  },
  emits: ["changePage"],
  setup(t, { emit: e }) {
    const n = e, a = Yn(), i = I(() => ({ ...a.query })), r = K(10), s = K([]), o = K(1), l = K(null), c = qe();
    function u(M) {
      t.initialCurrentPage && t.pages && o.value !== M && (o.value = M, m(), n("changePage", M));
    }
    function f(M) {
      let E = new URLSearchParams({ ...i.value });
      return t.generateLinkCallback ? E ? t.generateLinkCallback(M, E) : t.generateLinkCallback(M) : (E = new URLSearchParams({ ...i.value, page: M.toString() }), `${a.path}?${E.toString()}`);
    }
    function m() {
      if (!t.pages)
        return null;
      let M;
      t.fixedPageWidthMode ? (M = t.fixedPageWidthNum, s.value = _(M, t.pages)) : (M = r.value, s.value = _(M, t.pages));
    }
    function _(M, E) {
      const P = [], B = M - 2;
      let z = Math.max(2, o.value - Math.floor(B / 2)), W = z + B - 1;
      W >= E && (W = E - 1, z = Math.max(2, W - B + 1));
      for (let V = z; V <= W; V++)
        P.push(V);
      return P;
    }
    function T(M) {
      if (!t.initialCurrentPage || !t.pages)
        return 10;
      const E = document.getElementsByClassName("pButton")[0];
      let P, B;
      E ? (P = Math.ceil(E.getBoundingClientRect().width), B = getComputedStyle(E).marginRight) : (P = 0, B = "0");
      const z = Math.ceil(P + Number.parseInt(B) * 2 + 1), W = document.getElementsByClassName("previous")[0], V = document.getElementsByClassName("next")[0];
      let H, se;
      return W ? H = Math.ceil(document.getElementsByClassName("previous")[0].getBoundingClientRect().width + 10) : H = 0, V ? se = Math.ceil(document.getElementsByClassName("next")[0].getBoundingClientRect().width + 10) : se = 0, Math.max(0, Math.floor(+((M - (H + se + z * 2)) / z).toFixed(2)));
    }
    const g = I(() => ["section-pagination", (c == null ? void 0 : c.value) || "", t.previousTo === "" ? "first-page" : "", t.nextTo === "" ? "last-page" : ""]), x = I(() => o.value - 1), S = I(() => o.value + 1), D = I(() => t.initialCurrentPage && t.pages && (o == null ? void 0 : o.value) !== 1), L = I(() => t.initialCurrentPage && t.pages && (o == null ? void 0 : o.value) !== t.pages);
    return Qe(() => t.pages, () => {
      m();
    }, { immediate: !0 }), Qe(() => t.initialCurrentPage, (M) => {
      o.value = M;
    }, { immediate: !0 }), st(() => {
      if (!t.initialCurrentPage || !t.pages)
        return;
      o.value = t.initialCurrentPage;
      const { width: M } = li();
      kn(() => {
        Qe([M], () => {
          const E = l.value.clientWidth;
          r.value = T(E), m();
        }, { immediate: !0 });
      });
    }), (M, E) => (h(), b("div", {
      ref_key: "pageButtons",
      ref: l,
      class: re(g.value),
      role: "navigation",
      "aria-label": "page list navigation"
    }, [
      k("div", Vde, [
        t.previousTo ? (h(), G(Xe, {
          key: 0,
          to: t.previousTo,
          class: "previous"
        }, {
          default: oe(() => [
            Q(O(vi), { class: "previous-svg" }),
            E[4] || (E[4] = k("div", { class: "underline-hover" }, " Previous ", -1))
          ]),
          _: 1
        }, 8, ["to"])) : D.value ? (h(), G(Xe, {
          key: 1,
          class: "previous",
          to: f(x.value),
          onClick: E[0] || (E[0] = (P) => u(x.value))
        }, {
          default: oe(() => [
            Q(O(vi), { class: "previous-svg" }),
            E[5] || (E[5] = k("div", { class: "underline-hover" }, " Previous ", -1))
          ]),
          _: 1
        }, 8, ["to"])) : A("", !0)
      ]),
      k("div", qde, [
        t.initialCurrentPage && t.pages ? (h(), b("div", Wde, [
          k("div", Gde, [
            k("span", Xde, [
              Q(Xe, {
                class: re(`pButton${o.value === 1 ? " pButton-selected" : ""}`),
                active: o.value === 1,
                to: f(1),
                onClick: E[1] || (E[1] = (P) => u(1))
              }, {
                default: oe(() => E[6] || (E[6] = [
                  ze(ne(1))
                ])),
                _: 1
              }, 8, ["class", "active", "to"])
            ]),
            s.value.indexOf(2) === -1 && t.pages > 2 ? (h(), b("span", Zde, "...")) : A("", !0),
            (h(!0), b(he, null, Le(s.value, (P) => (h(), G(Xe, {
              key: P,
              class: re(`pButton${P === o.value ? " pButton-selected" : ""}`),
              active: o.value === P,
              to: f(P),
              onClick: (B) => u(P)
            }, {
              default: oe(() => [
                ze(ne(P), 1)
              ]),
              _: 2
            }, 1032, ["class", "active", "to", "onClick"]))), 128)),
            s.value.indexOf(t.pages - 1) === -1 && t.pages > 2 ? (h(), b("span", Kde, "...")) : A("", !0),
            t.pages > 1 ? (h(), b("span", Qde, [
              Q(Xe, {
                class: re(`pButton${t.pages === o.value ? " pButton-selected" : ""}`),
                active: o.value === t.pages,
                to: f(t.pages),
                onClick: E[2] || (E[2] = (P) => u(t.pages))
              }, {
                default: oe(() => [
                  ze(ne(t.pages), 1)
                ]),
                _: 1
              }, 8, ["class", "active", "to"])
            ])) : A("", !0)
          ])
        ])) : A("", !0)
      ]),
      k("div", Jde, [
        t.nextTo ? (h(), G(Xe, {
          key: 0,
          to: t.nextTo,
          class: "next"
        }, {
          default: oe(() => [
            E[7] || (E[7] = k("div", { class: "underline-hover" }, " Next ", -1)),
            Q(O(vi), { class: "next-svg" })
          ]),
          _: 1
        }, 8, ["to"])) : L.value ? (h(), G(Xe, {
          key: 1,
          class: "next",
          to: f(S.value),
          onClick: E[3] || (E[3] = (P) => u(S.value))
        }, {
          default: oe(() => [
            E[8] || (E[8] = k("div", { class: "underline-hover" }, " Next ", -1)),
            Q(O(vi), { class: "next-svg" })
          ]),
          _: 1
        }, 8, ["to"])) : A("", !0)
      ])
    ], 2));
  }
}), efe = /* @__PURE__ */ ge(e0e, [["__scopeId", "data-v-287c194f"]]), t0e = {
  key: 0,
  class: "section-header"
}, n0e = ["innerHTML"], a0e = ["innerHTML"], i0e = { class: "grid-wrapper" }, r0e = { class: "category" }, s0e = { class: "author" }, o0e = /* @__PURE__ */ Ce({
  __name: "SectionPostSmall",
  props: {
    items: {
      type: Array,
      default: () => []
    },
    sectionTitle: {
      type: String,
      default: ""
    },
    sectionSummary: {
      type: String,
      default: ""
    },
    fullWidth: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    const e = qe(), n = I(() => [
      "section-post-small",
      { "full-width": t.fullWidth },
      (e == null ? void 0 : e.value) || ""
    ]);
    return (a, i) => (h(), b("section", {
      class: re(n.value)
    }, [
      t.sectionTitle || t.sectionSummary ? (h(), b("div", t0e, [
        t.sectionTitle ? (h(), b("h2", {
          key: 0,
          class: "section-title",
          innerHTML: t.sectionTitle
        }, null, 8, n0e)) : A("", !0),
        t.sectionSummary ? (h(), b("div", {
          key: 1,
          class: "section-summary",
          innerHTML: t.sectionSummary
        }, null, 8, a0e)) : A("", !0)
      ])) : A("", !0),
      k("div", i0e, [
        (h(!0), b(he, null, Le(t.items, (r) => (h(), G(qI, {
          key: `block-post-${r.title || r.to}`,
          image: r.image,
          to: r.to,
          class: "block"
        }, an({ _: 2 }, [
          r.categoryName ? {
            name: "category",
            fn: oe(() => [
              k("div", r0e, ne(r.categoryName), 1)
            ]),
            key: "0"
          } : void 0,
          r.title ? {
            name: "title",
            fn: oe(() => [
              ze(ne(r.title), 1)
            ]),
            key: "1"
          } : void 0,
          r.author ? {
            name: "author",
            fn: oe(() => [
              k("div", s0e, ne(r.author), 1)
            ]),
            key: "2"
          } : void 0
        ]), 1032, ["image", "to"]))), 128))
      ])
    ], 2));
  }
}), tfe = /* @__PURE__ */ ge(o0e, [["__scopeId", "data-v-892fa798"]]);
function l0e(t = "", e = "", n = "long") {
  const a = (c, u) => c ? Ct(new Date(c), u) : "", i = "MMMM d, Y", r = "MMM d", s = "MMM d, Y", o = a(t, i), l = e ? a(e, i) : "";
  if (!e || o === l)
    switch (n) {
      case "long":
        return a(t, i);
      case "short":
        return a(t, r);
      case "shortWithYear":
        return a(t, s);
    }
  if (n === "short") {
    const c = a(t, r), u = a(e, r);
    return `${c} - ${u}`;
  } else if (n === "shortWithYear") {
    const c = a(t, s), u = a(e, s);
    return `${c} - ${u}`;
  }
  return `${o} - ${l}`;
}
const c0e = { class: "container" }, u0e = ["innerHTML"], d0e = { class: "block-staff-article-list" }, h0e = /* @__PURE__ */ Ce({
  __name: "SectionStaffArticleList",
  props: {
    items: {
      type: Array,
      default: () => []
    },
    sectionTitle: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = qe(), n = I(() => ["section-staff-article-list", (e == null ? void 0 : e.value) || ""]);
    function a(o, l, c, u, f) {
      return (e == null ? void 0 : e.value) !== "ftva" ? null : u ? "Ongoing" : o === "ftvaEvent" ? ya(l, l, "shortWithYear") : o === "ftvaEventSeries" ? l0e(l, c, "shortWithYear") : f ? Ct(new Date(f), "MMMM d, Y") : null;
    }
    function i(o) {
      return o ? wi(o, 250) : "";
    }
    function r(o) {
      return console.log("theme", e == null ? void 0 : e.value), (e == null ? void 0 : e.value) === "ftva" ? "" : o;
    }
    function s(o) {
      return console.log("theme", e == null ? void 0 : e.value), (e == null ? void 0 : e.value) === "ftva" ? "" : o;
    }
    return (o, l) => (h(), b("section", {
      class: re(n.value)
    }, [
      k("div", c0e, [
        t.sectionTitle ? (h(), b("div", {
          key: 0,
          class: "section-title",
          innerHTML: t.sectionTitle
        }, null, 8, u0e)) : A("", !0),
        k("ul", d0e, [
          (h(!0), b(he, null, Le(t.items, (c, u) => (h(), G(xO, {
            key: u,
            class: "block-staff-article-item",
            image: c.image,
            to: c.to,
            category: c.category,
            title: c.title,
            date: s(c.date ?? ""),
            authors: c.authors,
            description: r(c.description ?? ""),
            "external-resource-url": c.externalResourceUrl
          }, an({ _: 2 }, [
            O(e) === "ftva" && c.description ? {
              name: "customFTVADescription",
              fn: oe(() => [
                ze(ne(i(c.description)), 1)
              ]),
              key: "0"
            } : void 0,
            O(e) === "ftva" && a(c.sectionHandle ?? "", c.startDate ?? "", c.endDate ?? "", c.ongoing ?? !1, c.date ?? "") ? {
              name: "customFTVADate",
              fn: oe(() => [
                ze(ne(a(
                  c.sectionHandle ?? "",
                  c.startDate ?? "",
                  c.endDate ?? "",
                  c.ongoing ?? !1,
                  c.date ?? ""
                )), 1)
              ]),
              key: "1"
            } : void 0
          ]), 1032, ["image", "to", "category", "title", "date", "authors", "description", "external-resource-url"]))), 128))
        ])
      ])
    ], 2));
  }
}), nfe = /* @__PURE__ */ ge(h0e, [["__scopeId", "data-v-d7f14810"]]), f0e = {
  name: "SectionStaffOrcidPublications",
  components: {
    RichText: un,
    SmartLink: Xe
  },
  props: {
    orcid: {
      type: String,
      default: ""
    },
    publications: {
      type: String,
      default: ""
    }
  }
}, p0e = {
  key: 0,
  class: "section-staff-orcid-publications"
}, m0e = {
  key: 0,
  class: "orcid-key"
};
function g0e(t, e, n, a, i, r) {
  const s = lt("SmartLink"), o = lt("RichText");
  return n.orcid || n.publications ? (h(), b("section", p0e, [
    e[1] || (e[1] = k("h2", { class: "secondary-header" }, " Publications ", -1)),
    n.orcid ? (h(), b("div", m0e, [
      e[0] || (e[0] = ze(" ORCID: ")),
      Q(s, {
        to: n.orcid,
        class: "orcid-value"
      }, {
        default: oe(() => [
          ze(ne(n.orcid), 1)
        ]),
        _: 1
      }, 8, ["to"])
    ])) : A("", !0),
    n.publications ? (h(), G(o, {
      key: 1,
      class: "publications",
      "rich-text-content": n.publications
    }, null, 8, ["rich-text-content"])) : A("", !0)
  ])) : A("", !0);
}
const afe = /* @__PURE__ */ ge(f0e, [["render", g0e], ["__scopeId", "data-v-5e4d5449"]]), b0e = { class: "section-screening-details" }, ife = /* @__PURE__ */ Ce({
  __name: "SectionScreeningDetails",
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  setup(t) {
    return (e, n) => (h(), b("section", b0e, [
      (h(!0), b(he, null, Le(t.items, (a, i) => (h(), b("div", {
        key: `block-screening-detail-${a.title}`
      }, [
        (h(), G(_M, {
          key: `block-screening-detail-${a.title}`,
          count: t.items.length,
          "screening-count": `Screening ${i + 1} of ${t.items.length}`,
          title: a.title,
          "alternate-title": a.alternateTitle,
          language: a.language,
          year: a.year,
          country: a.country,
          "language-info": a.languageInfo,
          runtime: a.runtime,
          "tag-labels": a.tagLabels,
          text: a.text,
          trailer: a.trailer,
          image: a.image,
          class: "block"
        }, null, 8, ["count", "screening-count", "title", "alternate-title", "language", "year", "country", "language-info", "runtime", "tag-labels", "text", "trailer", "image"])),
        i !== t.items.length - 1 ? (h(), G(bl, {
          key: 0,
          class: "divider"
        })) : A("", !0)
      ]))), 128))
    ]));
  }
}), v0e = { class: "section-spaces" }, y0e = { class: "section-spaces-list" }, _0e = /* @__PURE__ */ Ce({
  __name: "SectionSpacesList",
  props: {
    items: {
      type: Array,
      default: () => []
    },
    nShown: {
      type: String,
      default: "4"
    }
  },
  setup(t) {
    return (e, n) => (h(), b("div", v0e, [
      n[0] || (n[0] = k("h3", {
        id: "spaces",
        class: "spaces-title"
      }, " Spaces ", -1)),
      Q(W2, {
        disable: t.items.length <= Number(t.nShown)
      }, {
        default: oe(() => [
          k("ul", y0e, [
            (h(!0), b(he, null, Le(t.items, (a, i) => (h(), G(rO, {
              key: `BlockSpace${i}`,
              class: re([i >= Number(t.nShown) ? "show-hide-hideable" : null, "block"]),
              to: a.to,
              title: a.title,
              "is-online": a.isOnline,
              location: a.location,
              text: a.text,
              "button-text": a.buttonText,
              "button-url": a.buttonUrl
            }, null, 8, ["class", "to", "title", "is-online", "location", "text", "button-text", "button-url"]))), 128))
          ])
        ]),
        _: 1
      }, 8, ["disable"])
    ]));
  }
}), rfe = /* @__PURE__ */ ge(_0e, [["__scopeId", "data-v-41464f61"]]), T0e = { class: "section-staff-list" }, x0e = /* @__PURE__ */ Ce({
  __name: "SectionStaffList",
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  setup(t) {
    return (e, n) => (h(), b("div", null, [
      k("ul", T0e, [
        (h(!0), b(he, null, Le(t.items, (a) => (h(), G(oP, {
          key: `ucla-staff-${a.to}`,
          image: a.image,
          to: a.to,
          "staff-name": a.staffName,
          "alternative-full-name": a.alternativeFullName,
          language: a.language,
          "job-title": a.jobTitle,
          locations: a.locations,
          email: a.email,
          phone: a.phone,
          departments: a.departments,
          consultation: a.consultation,
          class: "block-staff-list-item"
        }, null, 8, ["image", "to", "staff-name", "alternative-full-name", "language", "job-title", "locations", "email", "phone", "departments", "consultation"]))), 128))
      ])
    ]));
  }
}), sfe = /* @__PURE__ */ ge(x0e, [["__scopeId", "data-v-7317bbb2"]]), w0e = {
  width: "90",
  height: "32",
  viewBox: "0 0 90 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-ftva-video"
};
function k0e(t, e) {
  return h(), b("svg", w0e, e[0] || (e[0] = [
    k("rect", {
      width: "90",
      height: "32",
      rx: "16",
      fill: "#115DAF"
    }, null, -1),
    k("path", {
      d: "M26.6279 14.3262L23.1663 11.9626C23.0794 11.9032 22.9784 11.8691 22.8741 11.8639C22.7697 11.8588 22.666 11.8827 22.5739 11.9332C22.4818 11.9837 22.4048 12.0589 22.3511 12.1507C22.2975 12.2425 22.2692 12.3475 22.2692 12.4545V17.1818C22.2692 17.2888 22.2975 17.3938 22.3511 17.4857C22.4048 17.5775 22.4818 17.6526 22.5739 17.7032C22.666 17.7537 22.7697 17.7776 22.8741 17.7724C22.9784 17.7672 23.0794 17.7331 23.1663 17.6737L26.6279 15.3101C26.707 15.2562 26.7719 15.183 26.8168 15.0972C26.8617 15.0114 26.8852 14.9155 26.8852 14.8182C26.8852 14.7208 26.8617 14.625 26.8168 14.5391C26.7719 14.4533 26.707 14.3802 26.6279 14.3262ZM23.4231 16.0776V13.5625L25.2678 14.8182L23.4231 16.0776ZM30.3462 9.5H17.6538C17.3478 9.5 17.0543 9.62451 16.838 9.84615C16.6216 10.0678 16.5 10.3684 16.5 10.6818V18.9545C16.5 19.268 16.6216 19.5686 16.838 19.7902C17.0543 20.0119 17.3478 20.1364 17.6538 20.1364H30.3462C30.6522 20.1364 30.9457 20.0119 31.162 19.7902C31.3784 19.5686 31.5 19.268 31.5 18.9545V10.6818C31.5 10.3684 31.3784 10.0678 31.162 9.84615C30.9457 9.62451 30.6522 9.5 30.3462 9.5ZM30.3462 18.9545H17.6538V10.6818H30.3462V18.9545ZM31.5 21.9091C31.5 22.0658 31.4392 22.2161 31.331 22.3269C31.2228 22.4377 31.0761 22.5 30.9231 22.5H17.0769C16.9239 22.5 16.7772 22.4377 16.669 22.3269C16.5608 22.2161 16.5 22.0658 16.5 21.9091C16.5 21.7524 16.5608 21.6021 16.669 21.4913C16.7772 21.3804 16.9239 21.3182 17.0769 21.3182H30.9231C31.0761 21.3182 31.2228 21.3804 31.331 21.4913C31.4392 21.6021 31.5 21.7524 31.5 21.9091Z",
      fill: "white"
    }, null, -1),
    k("path", {
      d: "M41.465 21L38.075 12.09H39.74L42.41 19.455L45.065 12.09H46.7L43.31 21H41.465ZM49.2794 21H47.7944V14.355H49.2794V21ZM48.5444 13.26C48.2844 13.26 48.0594 13.17 47.8694 12.99C47.6894 12.81 47.5994 12.59 47.5994 12.33C47.5994 12.07 47.6894 11.855 47.8694 11.685C48.0594 11.505 48.2844 11.415 48.5444 11.415C48.7944 11.415 49.0094 11.505 49.1894 11.685C49.3794 11.855 49.4744 12.07 49.4744 12.33C49.4744 12.59 49.3794 12.81 49.1894 12.99C49.0094 13.17 48.7944 13.26 48.5444 13.26ZM57.1747 20.865C56.7947 20.965 56.3847 21.035 55.9447 21.075C55.5147 21.125 55.0897 21.15 54.6697 21.15C54.0897 21.15 53.5647 21.075 53.0947 20.925C52.6247 20.775 52.2197 20.555 51.8797 20.265C51.5497 19.965 51.2897 19.6 51.0997 19.17C50.9197 18.74 50.8297 18.245 50.8297 17.685C50.8297 17.145 50.9197 16.66 51.0997 16.23C51.2797 15.8 51.5247 15.435 51.8347 15.135C52.1547 14.835 52.5297 14.605 52.9597 14.445C53.3997 14.285 53.8747 14.205 54.3847 14.205C54.6247 14.205 54.8647 14.23 55.1047 14.28C55.3447 14.32 55.5447 14.38 55.7047 14.46V10.8H57.1747V20.865ZM55.7047 15.765C55.3947 15.595 54.9847 15.51 54.4747 15.51C53.8447 15.51 53.3297 15.695 52.9297 16.065C52.5297 16.435 52.3297 16.965 52.3297 17.655C52.3297 18.375 52.5447 18.925 52.9747 19.305C53.4047 19.685 53.9797 19.875 54.6997 19.875C54.8497 19.875 55.0097 19.87 55.1797 19.86C55.3597 19.85 55.5347 19.835 55.7047 19.815V15.765ZM60.1652 18.015V18.045C60.1852 18.345 60.2602 18.61 60.3902 18.84C60.5202 19.06 60.6852 19.25 60.8852 19.41C61.0852 19.56 61.3052 19.675 61.5452 19.755C61.7952 19.835 62.0502 19.875 62.3102 19.875C62.7702 19.875 63.1752 19.825 63.5252 19.725C63.8752 19.615 64.2152 19.45 64.5452 19.23V20.535C64.2452 20.745 63.8852 20.9 63.4652 21C63.0552 21.1 62.6352 21.15 62.2052 21.15C61.6852 21.15 61.2102 21.07 60.7802 20.91C60.3602 20.75 59.9952 20.525 59.6852 20.235C59.3852 19.935 59.1502 19.575 58.9802 19.155C58.8102 18.735 58.7252 18.26 58.7252 17.73C58.7252 17.2 58.8052 16.72 58.9652 16.29C59.1352 15.85 59.3602 15.48 59.6402 15.18C59.9302 14.87 60.2702 14.63 60.6602 14.46C61.0502 14.29 61.4752 14.205 61.9352 14.205C62.4152 14.205 62.8352 14.28 63.1952 14.43C63.5552 14.58 63.8502 14.79 64.0802 15.06C64.3202 15.33 64.4952 15.655 64.6052 16.035C64.7252 16.405 64.7852 16.815 64.7852 17.265V18.015H60.1652ZM61.8902 15.45C61.4602 15.45 61.0952 15.59 60.7952 15.87C60.5052 16.15 60.3102 16.545 60.2102 17.055H63.3902C63.3702 16.535 63.2352 16.14 62.9852 15.87C62.7352 15.59 62.3702 15.45 61.8902 15.45ZM65.9469 17.685C65.9469 17.165 66.0319 16.695 66.2019 16.275C66.3719 15.845 66.6069 15.48 66.9069 15.18C67.2169 14.87 67.5769 14.63 67.9869 14.46C68.4069 14.29 68.8669 14.205 69.3669 14.205C69.8669 14.205 70.3269 14.29 70.7469 14.46C71.1669 14.63 71.5269 14.87 71.8269 15.18C72.1369 15.48 72.3769 15.845 72.5469 16.275C72.7169 16.695 72.8019 17.165 72.8019 17.685C72.8019 18.195 72.7169 18.665 72.5469 19.095C72.3769 19.515 72.1369 19.88 71.8269 20.19C71.5269 20.49 71.1669 20.725 70.7469 20.895C70.3269 21.065 69.8669 21.15 69.3669 21.15C68.8669 21.15 68.4069 21.065 67.9869 20.895C67.5769 20.725 67.2169 20.49 66.9069 20.19C66.6069 19.88 66.3719 19.515 66.2019 19.095C66.0319 18.665 65.9469 18.195 65.9469 17.685ZM71.3019 17.685C71.3019 17.005 71.1219 16.47 70.7619 16.08C70.4019 15.68 69.9369 15.48 69.3669 15.48C68.8069 15.48 68.3469 15.68 67.9869 16.08C67.6269 16.47 67.4469 17.005 67.4469 17.685C67.4469 18.355 67.6269 18.89 67.9869 19.29C68.3469 19.68 68.8069 19.875 69.3669 19.875C69.9369 19.875 70.4019 19.68 70.7619 19.29C71.1219 18.89 71.3019 18.355 71.3019 17.685Z",
      fill: "white"
    }, null, -1)
  ]));
}
const C0e = { render: k0e }, S0e = {
  width: "113",
  height: "33",
  viewBox: "0 0 113 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-ftva-watch_online"
};
function A0e(t, e) {
  return h(), b("svg", S0e, e[0] || (e[0] = [
    k("rect", {
      x: "0.5",
      y: "0.5",
      width: "112",
      height: "32",
      rx: "16",
      fill: "#115DAF"
    }, null, -1),
    k("rect", {
      x: "0.5",
      y: "0.5",
      width: "112",
      height: "32",
      rx: "16",
      stroke: "white"
    }, null, -1),
    k("path", {
      d: "M25.688 21H24.19L22.244 13.79L20.312 21H18.814L16.14 11.662H17.708L19.64 19.152L21.684 11.662H22.818L24.848 19.152L26.78 11.662H28.348L25.688 21ZM34.3755 21H33.1155V20.258C32.5835 20.846 31.8135 21.168 30.9035 21.168C29.7835 21.168 28.5515 20.412 28.5515 18.928C28.5515 17.388 29.7695 16.716 30.9035 16.716C31.8135 16.716 32.5975 17.01 33.1155 17.612V16.492C33.1155 15.652 32.4295 15.148 31.4635 15.148C30.6935 15.148 30.0355 15.442 29.4335 16.044L28.8875 15.176C29.6435 14.434 30.5675 14.07 31.6595 14.07C33.1295 14.07 34.3755 14.714 34.3755 16.436V21ZM33.1155 19.516V18.368C32.7375 17.864 32.0795 17.598 31.3795 17.598C30.4695 17.598 29.8255 18.144 29.8255 18.942C29.8255 19.74 30.4695 20.286 31.3795 20.286C32.0795 20.286 32.7375 20.02 33.1155 19.516ZM38.2567 21.168C37.1927 21.168 36.6467 20.566 36.6467 19.502V15.344H35.5267V14.238H36.6467V12.39H37.9067V14.238H39.2787V15.344H37.9067V19.222C37.9067 19.698 38.1307 20.048 38.5647 20.048C38.8587 20.048 39.1247 19.922 39.2507 19.782L39.5727 20.734C39.3067 20.986 38.9147 21.168 38.2567 21.168ZM40.254 17.612C40.254 15.582 41.654 14.07 43.698 14.07C44.972 14.07 45.742 14.602 46.232 15.26L45.392 16.03C44.986 15.456 44.44 15.19 43.754 15.19C42.424 15.19 41.57 16.212 41.57 17.612C41.57 19.012 42.424 20.048 43.754 20.048C44.44 20.048 44.986 19.768 45.392 19.208L46.232 19.978C45.742 20.636 44.972 21.168 43.698 21.168C41.654 21.168 40.254 19.642 40.254 17.612ZM53.4433 21H52.1833V16.646C52.1833 15.526 51.6093 15.19 50.7413 15.19C49.9573 15.19 49.2433 15.666 48.8793 16.17V21H47.6193V11.662H48.8793V15.19C49.3273 14.644 50.2373 14.07 51.2733 14.07C52.7153 14.07 53.4433 14.798 53.4433 16.226V21ZM62.0587 21.168C59.9587 21.168 58.6427 19.572 58.6427 17.612C58.6427 15.666 59.9587 14.07 62.0587 14.07C64.1727 14.07 65.4747 15.666 65.4747 17.612C65.4747 19.572 64.1727 21.168 62.0587 21.168ZM62.0587 20.048C63.4167 20.048 64.1587 18.9 64.1587 17.612C64.1587 16.338 63.4167 15.19 62.0587 15.19C60.7147 15.19 59.9587 16.338 59.9587 17.612C59.9587 18.9 60.7147 20.048 62.0587 20.048ZM72.8984 21H71.6384V16.674C71.6384 15.554 71.0644 15.19 70.1964 15.19C69.4124 15.19 68.6984 15.666 68.3344 16.17V21H67.0744V14.238H68.3344V15.19C68.7824 14.644 69.6784 14.07 70.7284 14.07C72.1564 14.07 72.8984 14.826 72.8984 16.254V21ZM76.1547 21H74.8947V11.662H76.1547V21ZM78.7783 13.104C78.3443 13.104 77.9663 12.754 77.9663 12.306C77.9663 11.858 78.3443 11.494 78.7783 11.494C79.2263 11.494 79.5903 11.858 79.5903 12.306C79.5903 12.754 79.2263 13.104 78.7783 13.104ZM79.4223 21H78.1623V14.238H79.4223V21ZM87.2539 21H85.9939V16.674C85.9939 15.554 85.4199 15.19 84.5519 15.19C83.7679 15.19 83.0539 15.666 82.6899 16.17V21H81.4299V14.238H82.6899V15.19C83.1379 14.644 84.0339 14.07 85.0839 14.07C86.5119 14.07 87.2539 14.826 87.2539 16.254V21ZM88.8302 17.612C88.8302 15.652 90.2442 14.07 92.2182 14.07C94.2482 14.07 95.5082 15.652 95.5082 17.724V18.032H90.1602C90.2582 19.18 91.0982 20.132 92.4562 20.132C93.1702 20.132 93.9542 19.852 94.4582 19.334L95.0462 20.16C94.3742 20.818 93.4222 21.168 92.3302 21.168C90.3142 21.168 88.8302 19.74 88.8302 17.612ZM92.2182 15.106C90.8602 15.106 90.2162 16.198 90.1462 17.122H94.2762C94.2482 16.226 93.6462 15.106 92.2182 15.106Z",
      fill: "white"
    }, null, -1)
  ]));
}
const E0e = { render: A0e }, L0e = ["data-header"], D0e = /* @__PURE__ */ Ce({
  __name: "SectionTeaserCard",
  props: {
    items: {
      type: Array,
      default: () => []
    },
    sectionTitle: {
      type: String,
      required: !1
    },
    gridLayout: {
      type: Boolean,
      default: !0
    }
  },
  setup(t) {
    const e = qe(), n = I(() => ["section-teaser-card", (e == null ? void 0 : e.value) || "", { "no-grid-layout": !t.gridLayout }]), a = I(() => t.items[0].sectionHandle === "ftvaItemInCollection" ? 75 : 60), i = I(() => (e == null ? void 0 : e.value) || "");
    return (r, s) => (h(), b("ul", {
      class: re(n.value),
      "data-header": t.sectionTitle ? t.sectionTitle : null
    }, [
      (h(!0), b(he, null, Le(t.items, (o, l) => (h(), G(Zh, {
        key: `Card${l}`,
        image: o.image,
        to: o.to,
        category: o.category,
        title: o.title,
        "alternative-full-name": o.alternativeFullName,
        language: o.language,
        "start-date": o.startDate,
        "end-date": o.endDate,
        text: o.text,
        "image-aspect-ratio": a.value,
        "is-vertical": !0,
        "byline-one": o.bylineOne,
        "byline-two": o.bylineTwo,
        "section-handle": o.sectionHandle,
        ongoing: o.ongoing,
        "date-created": i.value === "ftva" ? o.postDate : "",
        class: "card"
      }, {
        toptext: oe(() => [
          o.videoEmbed && o.videoEmbed !== null ? (h(), G(eo, { key: 0 }, {
            default: oe(() => [
              Q(O(C0e), { class: "white-icon" })
            ]),
            _: 1
          })) : A("", !0),
          o.ftvaCollectionType && o.ftvaCollectionType.includes("watchAndListenOnline") ? (h(), G(O(E0e), { key: 1 })) : A("", !0)
        ]),
        _: 2
      }, 1032, ["image", "to", "category", "title", "alternative-full-name", "language", "start-date", "end-date", "text", "image-aspect-ratio", "byline-one", "byline-two", "section-handle", "ongoing", "date-created"]))), 128))
    ], 10, L0e));
  }
}), ofe = /* @__PURE__ */ ge(D0e, [["__scopeId", "data-v-4adc9e43"]]), I0e = { class: "section-teaser-highlight" }, M0e = /* @__PURE__ */ Ce({
  __name: "SectionTeaserHighlight",
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  setup(t) {
    return (e, n) => (h(), b("ul", I0e, [
      (h(!0), b(he, null, Le(t.items, (a) => (h(), G(q2, {
        key: a.to,
        image: a.image,
        to: a.to,
        category: a.category,
        title: a.title,
        "start-date": a.startDate,
        "end-date": a.endDate,
        text: a.text,
        locations: a.locations,
        "alternative-full-name": a.alternativeFullName,
        language: a.language,
        "section-handle": a.sectionHandle,
        "byline-one": a.bylineOne,
        "byline-two": a.bylineTwo,
        "has-triangle": !0,
        "is-vertical": !0,
        ongoing: a.ongoing,
        class: "block"
      }, null, 8, ["image", "to", "category", "title", "start-date", "end-date", "text", "locations", "alternative-full-name", "language", "section-handle", "byline-one", "byline-two", "ongoing"]))), 128))
    ]));
  }
}), lfe = /* @__PURE__ */ ge(M0e, [["__scopeId", "data-v-9b37a033"]]), O0e = { class: "list" }, P0e = /* @__PURE__ */ Ce({
  __name: "SectionTeaserList",
  props: {
    items: {
      type: Array,
      default: () => []
    },
    nShown: {
      type: Number,
      default: 3
    },
    // TO SWITCH BETWEEN
    // BlockCardThreeColumn OR BlockClippedDate
    componentName: {
      type: String,
      default: "BlockClippedDate"
    }
  },
  setup(t) {
    const e = qe(), n = ve(
      () => Promise.resolve().then(() => FA)
    ), a = I(() => t.componentName === "BlockCardThreeColumn" ? n : SD), i = I(() => t.items.length <= t.nShown || (e == null ? void 0 : e.value) === "ftva" && t.componentName !== "BlockClippedDate"), r = I(() => ["section-teaser-list", (e == null ? void 0 : e.value) || ""]);
    return (s, o) => (h(), b("section", {
      class: re(r.value)
    }, [
      Q(W2, { disable: i.value }, {
        default: oe(() => [
          k("ul", O0e, [
            (h(!0), b(he, null, Le(t.items, (l, c) => (h(), G(dt(a.value), {
              key: c,
              class: re([c >= t.nShown ? "show-hide-hideable" : null, "list-item block"]),
              image: l.image,
              to: l.to,
              category: l.category,
              title: l.title,
              "start-date": l.startDate,
              "end-date": l.endDate,
              text: l.text,
              locations: l.locations,
              "section-handle": l.sectionHandle,
              ongoing: l.ongoing,
              "tag-labels": l.tagLabels
            }, null, 8, ["class", "image", "to", "category", "title", "start-date", "end-date", "text", "locations", "section-handle", "ongoing", "tag-labels"]))), 128))
          ])
        ]),
        _: 1
      }, 8, ["disable"])
    ], 2));
  }
}), cfe = /* @__PURE__ */ ge(P0e, [["__scopeId", "data-v-e2a20a34"]]), B0e = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-alert"
};
function OT(t, e) {
  return h(), b("svg", B0e, e[0] || (e[0] = [
    k("path", {
      d: "M16 25C20.9706 25 25 20.9706 25 16C25 11.0294 20.9706 7 16 7C11.0294 7 7 11.0294 7 16C7 20.9706 11.0294 25 16 25Z",
      stroke: "#0B6AB7",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      class: "svg__stroke--primary-blue-03"
    }, null, -1),
    k("path", {
      d: "M16 12V17",
      stroke: "#0B6AB7",
      "stroke-width": "1.5",
      "stroke-linecap": "square",
      "stroke-linejoin": "bevel",
      class: "svg__stroke--primary-blue-03"
    }, null, -1),
    k("path", {
      d: "M16 20H16.01",
      stroke: "#0B6AB7",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      class: "svg__stroke--primary-blue-03"
    }, null, -1)
  ]));
}
const PT = { render: OT }, R0e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: PT,
  render: OT
}, Symbol.toStringTag, { value: "Module" })), N0e = {
  name: "SiteNotificationAlert",
  components: {
    ButtonLink: sn,
    RichText: un,
    SvgAlertCircle: PT
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    time: {
      type: Number,
      default: 13500
    }
  },
  data() {
    return {
      isOpened: !0
    };
  },
  computed: {
    classes() {
      return [
        "site-notification-alert",
        this.isOpened ? "is-opened" : "is-closed"
      ];
    }
  },
  mounted() {
    this.delayedClose();
  },
  methods: {
    toggleAlert() {
      this.isOpened = !this.isOpened;
    },
    delayedClose() {
      setTimeout(() => {
        this.isOpened = !1;
      }, this.time);
    }
  }
}, $0e = { class: "alert-box-icon" }, F0e = ["innerHTML"], z0e = { class: "message" };
function U0e(t, e, n, a, i, r) {
  const s = lt("SvgAlertCircle"), o = lt("RichText"), l = lt("ButtonLink");
  return h(), b("section", {
    class: re(r.classes),
    role: "alert"
  }, [
    k("button", {
      class: "alert",
      onClick: e[0] || (e[0] = (c) => r.toggleAlert())
    }, [
      k("div", $0e, [
        Q(s, { class: "svg-alert-circle" })
      ]),
      k("div", {
        class: "alert-text",
        innerHTML: n.title
      }, null, 8, F0e)
    ]),
    k("div", z0e, [
      n.text ? (h(), G(o, {
        key: 0,
        class: "message-text",
        "rich-text-content": n.text
      }, null, 8, ["rich-text-content"])) : A("", !0),
      Q(l, {
        class: "button-dismiss",
        label: "Dismiss",
        "icon-name": "icon-close",
        "is-quaternary": "",
        onClick: r.toggleAlert
      }, null, 8, ["onClick"])
    ])
  ], 2);
}
const ufe = /* @__PURE__ */ ge(N0e, [["render", U0e], ["__scopeId", "data-v-e71e447b"]]), H0e = { class: "story-with-image" }, Y0e = {
  key: 0,
  class: "image-block"
}, j0e = ["textContent"], V0e = { class: "meta" }, q0e = {
  key: 0,
  class: "title"
}, W0e = ["innerHTML"], G0e = ["innerHTML"], X0e = { class: "calltoaction" }, Z0e = { key: 0 }, K0e = 60, Q0e = /* @__PURE__ */ Ce({
  __name: "StoryWithImage",
  props: {
    image: {
      type: Object,
      default: () => {
      }
    },
    caption: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    footnote: {
      type: String,
      default: ""
    },
    calltoaction: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    return (e, n) => (h(), b("div", H0e, [
      t.image ? (h(), b("div", Y0e, [
        Q(dn, {
          class: "image",
          media: t.image,
          "aspect-ratio": K0e
        }, {
          default: oe(() => n[0] || (n[0] = [
            k("div", { class: "gradient" }, null, -1)
          ])),
          _: 1
        }, 8, ["media"]),
        t.caption ? (h(), b("div", {
          key: 0,
          class: "caption",
          textContent: ne(t.caption)
        }, null, 8, j0e)) : A("", !0),
        k("div", V0e, [
          t.title ? (h(), b("h2", q0e, ne(t.title), 1)) : A("", !0),
          t.text ? (h(), b("div", {
            key: 1,
            class: "text",
            innerHTML: t.text
          }, null, 8, W0e)) : A("", !0),
          Q(sh, { class: "divider-general" }),
          t.footnote ? (h(), b("div", {
            key: 2,
            class: "footnote",
            innerHTML: t.footnote
          }, null, 8, G0e)) : A("", !0),
          Q(sh, { class: "divider-general" }),
          k("div", X0e, [
            t.calltoaction ? (h(), b("span", Z0e, ne(t.calltoaction), 1)) : A("", !0),
            Q(O(Xu), { class: "svg" })
          ])
        ])
      ])) : A("", !0)
    ]));
  }
}), dfe = /* @__PURE__ */ ge(Q0e, [["__scopeId", "data-v-f3974e51"]]), J0e = ["textContent"], ehe = {
  __name: "TabItem",
  props: {
    title: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: ""
    },
    content: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = wn("activeTabTitle"), n = qe(), a = I(() => ["tab-item", (n == null ? void 0 : n.value) || ""]);
    return (i, r) => Tt((h(), b("div", {
      class: re(a.value)
    }, [
      k("div", {
        textContent: ne(t.content)
      }, null, 8, J0e),
      me(i.$slots, "default", {}, void 0, !0)
    ], 2)), [
      [va, t.title === O(e)]
    ]);
  }
}, hfe = /* @__PURE__ */ ge(ehe, [["__scopeId", "data-v-786a4c59"]]), the = /* @__PURE__ */ Ce({
  __name: "TableComponent",
  props: {
    // Tableheaders will be used to infer the number of columns
    // Therefore, if you do not want header text in a column, pass an empty string instead
    tableHeaders: {
      type: Array,
      default: () => [""]
    },
    tableCaption: {
      type: String,
      default: "Table data"
    },
    // if a theme needs more than 1 style for tables,
    // use color-scheme prop to specify further
    colorScheme: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = qe(), n = I(() => ["table-component", (e == null ? void 0 : e.value) || "", t.colorScheme]), a = I(() => ["table-wrapper", (e == null ? void 0 : e.value) || "", t.colorScheme]);
    return (i, r) => (h(), b("div", {
      class: re(a.value)
    }, [
      k("table", {
        class: re(n.value)
      }, [
        k("caption", null, ne(t.tableCaption), 1),
        k("thead", null, [
          k("tr", null, [
            (h(!0), b(he, null, Le(t.tableHeaders, (s, o) => (h(), b("th", { key: o }, ne(s), 1))), 128))
          ])
        ]),
        k("tbody", null, [
          me(i.$slots, "default", {}, void 0, !0)
        ])
      ], 2)
    ], 2));
  }
}), ffe = /* @__PURE__ */ ge(the, [["__scopeId", "data-v-75b3fad3"]]), nhe = /* @__PURE__ */ Ce({
  __name: "TableRow",
  props: {
    // The number of columns to create for data
    // Each column has the structure:
    // <td class="column-#"><slot name="column#" /></td>
    numCells: {
      type: Number,
      default: 0
    }
  },
  setup(t) {
    const e = t, n = qe(), a = I(() => ["table-row", (n == null ? void 0 : n.value) || ""]);
    return (i, r) => (h(), b("tr", {
      class: re(a.value)
    }, [
      e.numCells !== 0 ? (h(!0), b(he, { key: 0 }, Le(e.numCells, (s) => (h(), b("td", {
        key: s,
        class: re(`column-${s}`)
      }, [
        me(i.$slots, `column${s}`, {}, void 0, !0)
      ], 2))), 128)) : A("", !0)
    ], 2));
  }
}), pfe = /* @__PURE__ */ ge(nhe, [["__scopeId", "data-v-4e8ecb6c"]]), ahe = {
  key: 0,
  class: "filters"
}, ihe = {
  class: "tab-list-header",
  role: "tablist"
}, rhe = ["id", "tabindex", "aria-controls", "aria-selected", "onClick"], she = ["id", "aria-labelledby", "hidden"], ohe = /* @__PURE__ */ Ce({
  __name: "TabList",
  props: {
    alignment: {
      type: String,
      default: "left"
    },
    initialTab: {
      type: Number,
      default: 0
    }
  },
  setup(t) {
    var P, B, z;
    const e = ve(
      () => Promise.resolve().then(() => Bp)
    ), n = ve(
      () => Promise.resolve().then(() => MT)
    ), i = ((B = (P = Di()) == null ? void 0 : P.default) == null ? void 0 : B.call(P)).map((W) => W.props), r = K(i), s = K([]), o = K(0), l = K((z = r.value[0]) == null ? void 0 : z.title), c = K(), u = Yn(), f = Qs();
    ba("activeTabTitle", l);
    const m = {
      "icon-calendar": {
        icon: e,
        label: "Calendar"
      },
      "icon-list": {
        icon: n,
        label: "List"
      }
    };
    st(() => {
      var ie, Z;
      const W = u.query.view, V = r.value.findIndex(
        ($) => ($ == null ? void 0 : $.title.toLowerCase()) === W
      );
      V !== -1 ? (o.value = V, l.value = (ie = r.value[V]) == null ? void 0 : ie.title) : (o.value = t.initialTab, l.value = (Z = r.value[t.initialTab]) == null ? void 0 : Z.title);
      const H = s.value[o.value];
      E(H, !1);
      const { width: se } = li();
      Qe(se, ($) => {
        const J = s.value[o.value];
        E(J, !0);
      });
    });
    const _ = I(() => `panel-${D(l.value)}`), T = qe(), g = I(() => ["tab-list", (T == null ? void 0 : T.value) || ""]);
    function x(W) {
      return `tab-${D(W)}`;
    }
    function S(W) {
      return `panel-${D(W)}`;
    }
    function D(W) {
      return W.toLowerCase().replace(/\s/g, "-");
    }
    function L(W) {
      const V = r.value.map((ie) => ie == null ? void 0 : ie.title), H = V.indexOf(l.value);
      let se;
      switch (W.key) {
        case "ArrowLeft":
          H - 1 < 0 ? se = V[V.length - 1] : se = V[H - 1], M(se);
          break;
        case "ArrowRight":
          H + 1 > V.length - 1 ? se = V[0] : se = V[H + 1], M(se);
          break;
      }
    }
    function M(W) {
      const V = r.value.findIndex((se) => (se == null ? void 0 : se.title) === W);
      l.value = W, o.value = V, f.push({
        query: {
          ...u.query,
          view: W.split(" ")[0].toLowerCase(),
          page: 1
        }
      });
      const H = s.value[V];
      H && H.focus(), H.classList.contains("active") || E(H, !0);
    }
    function E(W, V) {
      const H = c.value, se = W.getBoundingClientRect();
      H.style.height = `${se.height}px`, V ? (H.style.width = `${se.width}px`, W.style.background = "none") : H.style.width = "0", H.style.setProperty("--move_glider", `${W.offsetLeft}px`);
    }
    return (W, V) => (h(), b(he, null, [
      k("div", $t({
        class: [g.value, t.alignment],
        role: "tabs"
      }, W.$attrs), [
        W.$slots.filters ? (h(), b("div", ahe, [
          me(W.$slots, "filters", {}, void 0, !0)
        ])) : A("", !0),
        k("div", ihe, [
          k("span", {
            ref_key: "tabGliderRef",
            ref: c,
            class: "tab-glider"
          }, null, 512),
          (h(!0), b(he, null, Le(r.value, (H, se) => (h(), b("button", {
            id: x(H == null ? void 0 : H.title),
            ref_for: !0,
            ref: (ie) => s.value[se] = ie,
            key: H == null ? void 0 : H.title,
            class: re(["tab-list-item", { active: l.value === (H == null ? void 0 : H.title) }]),
            role: "tab",
            tabindex: l.value === (H == null ? void 0 : H.title) ? 0 : -1,
            "aria-controls": S(H == null ? void 0 : H.title),
            "aria-selected": l.value === (H == null ? void 0 : H.title),
            onKeydown: L,
            onClick: (ie) => M(H == null ? void 0 : H.title)
          }, [
            H != null && H.icon ? (h(), G(dt(m[H.icon].icon), {
              key: 0,
              class: "svg",
              "aria-hidden": "true"
            })) : A("", !0),
            ze(" " + ne(H == null ? void 0 : H.title), 1)
          ], 42, rhe))), 128))
        ])
      ], 16),
      k("div", {
        id: _.value,
        class: "tab-list-body",
        role: "tabpanel",
        "aria-labelledby": _.value,
        hidden: !l.value
      }, [
        me(W.$slots, "default", {}, void 0, !0)
      ], 8, she)
    ], 64));
  }
}), mfe = /* @__PURE__ */ ge(ohe, [["__scopeId", "data-v-0e3d7ee5"]]), lhe = { class: "two-column" }, che = {
  key: 0,
  class: "sidebar-mobile-top"
}, uhe = {
  key: 1,
  class: "sidebar-mobile-bottom"
}, dhe = { class: "sidebar-column" }, hhe = /* @__PURE__ */ Ce({
  __name: "TwoColLayoutWStickySideBar",
  setup(t) {
    const e = K(!1), n = K(null), a = K(null);
    function i() {
      a.value.style.minHeight = `${n.value.clientHeight + 125}px`;
    }
    return st(() => {
      const { width: r } = li();
      Qe([r, n], ([s]) => {
        e.value = s <= 899, e.value === !0 ? a.value.style.minHeight = "auto" : i();
      }, { immediate: !0 });
    }), (r, s) => (h(), b("div", lhe, [
      k("div", {
        ref_key: "primaryCol",
        ref: a,
        class: "primary-column top"
      }, [
        Q(cl, { class: "primary-section-wrapper" }, {
          default: oe(() => [
            me(r.$slots, "primaryTop", {}, void 0, !0),
            e.value ? (h(), b("div", che, [
              me(r.$slots, "sidebarTop", {}, void 0, !0)
            ])) : A("", !0),
            me(r.$slots, "primaryMid", {}, void 0, !0),
            e.value ? (h(), b("div", uhe, [
              me(r.$slots, "sidebarBottom", {}, void 0, !0)
            ])) : A("", !0),
            me(r.$slots, "primaryBottom", {}, void 0, !0)
          ]),
          _: 3
        })
      ], 512),
      k("div", dhe, [
        k("div", {
          ref_key: "sidebar",
          ref: n,
          class: "sidebar-content-wrapper"
        }, [
          e.value ? A("", !0) : me(r.$slots, "sidebarTop", { key: 0 }, void 0, !0),
          e.value ? A("", !0) : me(r.$slots, "sidebarBottom", { key: 1 }, void 0, !0)
        ], 512)
      ])
    ]));
  }
}), gfe = /* @__PURE__ */ ge(hhe, [["__scopeId", "data-v-bdefca4a"]]);
export {
  vhe as AlphabeticalBrowseBy,
  Pm as BannerFeatured,
  yhe as BannerHeader,
  _he as BannerText,
  The as BaseCalendar,
  Um as BaseCheckboxGroup,
  QS as BaseRadioGroup,
  xhe as BlockAmenities,
  Jh as BlockCallToAction,
  khe as BlockCallToActionTwoUp,
  whe as BlockCampusMap,
  $A as BlockCardThreeColumn,
  bD as BlockCardWithIllustration,
  Zh as BlockCardWithImage,
  SD as BlockClippedDate,
  Che as BlockDate,
  HD as BlockEvent,
  s6 as BlockEventDetail,
  q2 as BlockFloatingHighlight,
  Gh as BlockForm,
  aI as BlockGenericList,
  She as BlockHours,
  hI as BlockInfo,
  kI as BlockLocationListItem,
  zI as BlockMediaWithText,
  qI as BlockPostSmall,
  GI as BlockRemoveSearchFilter,
  _M as BlockScreeningDetail,
  W2 as BlockShowHide,
  KM as BlockSimpleCard,
  rO as BlockSpaces,
  cO as BlockSponsor,
  xO as BlockStaffArticleList,
  Ahe as BlockStaffDetail,
  oP as BlockStaffList,
  eo as BlockTag,
  Ehe as ButtonDropdown,
  IM as ButtonHide,
  sn as ButtonLink,
  kv as ButtonMore,
  zM as ButtonShow,
  Uu as CardMeta,
  Dhe as DateFilter,
  Ihe as DefinitionList,
  sh as DividerGeneral,
  bl as DividerWayFinder,
  Mhe as DropdownSingleSelect,
  Ohe as FiltersDropdown,
  $H as FlexibleAssociatedTopicCards,
  HH as FlexibleBannerFeatured,
  Phe as FlexibleBlocks,
  Bhe as FlexibleCallToAction,
  jZ as FlexibleCardWithImage,
  QZ as FlexibleForm,
  mK as FlexibleGridGalleryCards,
  wK as FlexibleHighlight,
  Rhe as FlexibleHorizontalDivider,
  RK as FlexibleImpactNumberCards,
  fQ as FlexibleImpactNumbersCarousel,
  vQ as FlexibleInfo,
  Hse as FlexibleMediaGallery,
  dse as FlexibleMediaGalleryBannerImage,
  TT as FlexibleMediaGalleryNewLightbox,
  Bse as FlexibleMediaGalleryThumbnailCard,
  Xse as FlexibleMediaWithText,
  toe as FlexiblePullQuote,
  soe as FlexibleRichText,
  Nhe as FlexibleSimpleCards,
  tle as FooterLinks,
  $he as FooterMain,
  qoe as FooterPrimary,
  Koe as FooterSock,
  voe as FooterSponsor,
  cK as GridGallery,
  Zb as HeaderMain,
  _ce as HeaderMainResponsive,
  zhe as HeaderSmart,
  Uhe as HeaderSticky,
  Fhe as HeadingArrow,
  en as IconWithLink,
  Hhe as ImageSlider,
  DK as ImpactNumberCard,
  oQ as ImpactNumbersCarousel,
  Yhe as ImpactRichText,
  jhe as MastheadPrimary,
  Vhe as MastheadSecondary,
  Jre as MediaBadge,
  Md as MediaItem,
  qhe as NavBreadcrumb,
  ble as NavMenuItem,
  tce as NavMenuItemResponsive,
  wT as NavPrimary,
  Bce as NavSearch,
  CT as NavSecondary,
  Whe as PageAnchor,
  Wc as PullQuote,
  dn as ResponsiveImage,
  Wh as ResponsiveVideo,
  un as RichText,
  tde as ScrollWrapper,
  Ghe as SearchGeneric,
  dde as SearchGenericFilterButtons,
  bde as SearchGenericFilters,
  Xhe as SearchGenericViewModes,
  yue as SearchHome,
  Ql as SearchInput,
  Fle as SearchMenuItem,
  Zhe as SearchResult,
  RH as SectionCardsWithIllustrations,
  Khe as SectionDualMasonry,
  Qhe as SectionGenericList,
  Nf as SectionHeader,
  Jhe as SectionLocationList,
  efe as SectionPagination,
  tfe as SectionPostSmall,
  pde as SectionRemoveSearchFilter,
  ife as SectionScreeningDetails,
  rfe as SectionSpacesList,
  nfe as SectionStaffArticleList,
  sfe as SectionStaffList,
  afe as SectionStaffOrcidPublications,
  ofe as SectionTeaserCard,
  lfe as SectionTeaserHighlight,
  cfe as SectionTeaserList,
  cl as SectionWrapper,
  foe as SimpleCards,
  rde as SingleCheckbox,
  Ece as SiteBrandBar,
  ufe as SiteNotificationAlert,
  Xe as SmartLink,
  dfe as StoryWithImage,
  hfe as TabItem,
  mfe as TabList,
  ffe as TableComponent,
  pfe as TableRow,
  gfe as TwoColLayoutWStickySideBar,
  aM as VideoEmbed
};
